webpackJsonp([8],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emktcommon_constant__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weui_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weui_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_weui_js__);






// 此文件仅保存淘基因小程序相关逻辑，常量定义保存在emktPublicConstants
function wxShare() {
  var link = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.sign.shareUrl;
  var imgUrl = __WEBPACK_IMPORTED_MODULE_1__emktcommon_constant__["a" /* default */].publicUrl + '/emktResources/resocurces/img/logo.jpg';
  var share = {};
  share.title = '吉凯基因网上商城这厢有礼了';
  share.desc = '科研资源共享平台,邀你和好友一起拿大礼!';
  share.link = link;
  share.imgUrl = imgUrl;
  if (link.indexOf('shareCartId') !== -1) {
    share.title = '您的好友帮您挑选好了产品快来看看吧！';
    share.desc = '一键查收即可购买，省时省力又优惠';
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_util__["a" /* wxShareConfig */])(share, function () {
    console.log(link);
  }, function () {
    console.log('fail');
  });
}

/**
 * 小程序下载合同文本
 * @param orderDetail
 */
function wxDownloadOrderText(orderDetail) {
  __WEBPACK_IMPORTED_MODULE_5_weui_js___default.a.loading('加载中');
  // window.gcapi('getOrderTextFiles', orderDetail.id).then((res) => {
  var fileName = '\u5408\u4F5C\u534F\u8BAE-' + orderDetail.orderNo + '.pdf';
  // const fileSize = res.body.result[0].fileSize
  __WEBPACK_IMPORTED_MODULE_5_weui_js___default.a.loading('加载中').hide();
  __WEBPACK_IMPORTED_MODULE_4_wx___default.a.miniProgram.navigateTo({
    url: '/pages/pdf/pdfPage?comeFrom=contract' + '&pdfName=' + fileName + '&orderId=' + orderDetail.id
  });
  console.log('/pages/pdf/pdfPage?comeFrom=contract' + '&pdfName=' + fileName + '&orderId=' + orderDetail.id);
  // })
}
/**
 * 小程序下载出货单word
 * @param contractNo
 */
function wxDownloadExpressSheet(contractNo) {
  var fileName = '\u51FA\u8D27\u5355-' + contractNo + '.docx';
  var expressUrl = '/pages/pdf/pdfPage?comeFrom=express' + '&pdfName=' + fileName + '&pdfSize=' + '&contractNo=' + contractNo;
  console.log(expressUrl);
  __WEBPACK_IMPORTED_MODULE_4_wx___default.a.miniProgram.navigateTo({
    url: expressUrl
  });
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__emktcommon_constant__["a" /* default */], {
  wxShare: wxShare,
  wxDownloadOrderText: wxDownloadOrderText,
  wxDownloadExpressSheet: wxDownloadExpressSheet
}));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = jQuery.noConflict();

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = jWeixin;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);




var _WAPP_LOGIN_TYPE_DICT, _ICON_TAG_IMAGE_MAP, _ADBERRATION_MESSAGE, _ADBERRATION_STATUS, _PRODUCT_TYPE_TAG_MAP;

var SDTString = 1;
var SDTInteger = 2;
var SDTEnumeration = 3;

var SDTDate = 4;
var SDTDateTime = 5;
var SDTGene = 6;
var SDTDecimal = 7;
var SDTToolVector = 8;
//
var KFTitle = 1;
var KFSubtitle = 2;
var KFAbstract = 3;
// var KFGene = 4
// var KFToolVector = 5
var KFNA = 100;
var KFSpecificat = 6;

var taxTypeId = 61033;
// var promoter1ID = 61034
// var tag2ID = 61035
// var euRID = 61036
// var proRID = 61037
// var promoter2ID = 61040
// var promoter3ID = 61041
// var tag1PUBID = 61042

var localStorege = {};
var emktMetaVersion = '0';
var isInit = false;
var isDebug = false;

var Rat = 'Rat';
var Mouse = 'Mouse';
var Human = 'Human';
var others = '其他';
var Gallusgallus = 'Gallus gallus';
var thalecress = 'thale cress';
var rice = 'rice';
var zebrafish = 'zebrafish';
var fruitfly = 'fruit fly';
var pig = 'pig';
var sheep = 'sheep';
var rabbit = 'rabbit';
var domesticsilkworm = 'domestic silkworm';
var Africanclawedfrog = 'African clawed frog';
var yeast = 'yeast';

var throttleLast, throttleDeferTimer;

var isDesktop = false;
var isResearchGroup = false;
var isWapp = false;
var isWappGuest = false;
var isSecPromotion = false;
var buyCartIsLocalStorage = true;
var publicUrl = 'http://gmall.taogene.com/';
var wxShareUrl = publicUrl + 'wxShare';
var CONST_MESSAGE_STATUS_NONE = 1; /** 客户留言状态- 无留言 */
var CONST_MESSAGE_STATUS_NEW_MESSAGE = 2; /** 客户留言状态- 有留言  */
var CONST_MESSAGE_STATUS_NEW_RESPONSE = 3; /** 客户留言状态- 有回答  */
var CONST_MESSAGE_STATUS_RESPONSE_READ = 4; /** 客户留言状态- 回答已读  */

var CONST_MESSAGE_TYPE_CUSTOMER_REQUEST = 1; /** 留言状态- 客户提问 */
var CONST_MESSAGE_TYPE_CUSTOMER_SERVICE_RESPONSE = 2; /** 留言状态- 客服回答 */

var lotteryStartDT = new Date('2019/11/28 0:0:0'); /** 感恩节首单抽奖有效日期 */
var lotteryEndDT = new Date('2019/12/31 23:59:59');
var christmasPreSalePeriod = ['2019/12/25 14:0:0', '2019/12/25 18:0:0', '2019/12/31 14:0:0', '2019/12/31 18:0:0', '2020/1/2 14:0:0', '2020/1/2 18:0:0'];
var extraBloodType = ['2/5/6/8/9/DJ', '1/2/5/6/8/9/DJ', '1/9/Retro/PHP.eB', '2/8/9/DJ', '1/6/8/9'];

var activityName = '三八女神节下单抽奖';
var promotionGuid = 'action-20201231-001';
var PRIZE_TYPE_OBJECT = 1; /** 实物奖品 **/
var PRIZE_TYPE_COUPON = 2; /** 优惠券奖品 **/
var AuthenticationID = 'action-authentication-001';
var customerBehaviours = {};
var behaviour = {};
var customerBehaviourType = {
  'click': 'click',
  'merchandise': 'merchandise',
  'search': 'search',
  'addCount': 'addCount',
  'minusCount': 'minusCount',
  'check': 'check',
  'deleteCart': 'deleteCart',
  'cancel': 'cancelDelete',
  'clickMer': 'clickMerchandiseAfterSearch'

  // 接口来源
};var FindSourceCrm = 'crm';

// 优惠券类别
var COUPON_TYPE_DISCOUNT = 5;
// 优惠券类别-筑研服务抵用券
var COUPON_TYPE_SPECIAL_FUND = 6;
var COUPON_TYPE = {
  prepaySpecialFundCoupon: 6 // 专享券

  // 代金券类别 新增折扣类型
};var COUPON_TYPE_NEW_DISCOUNT = 8;
var testCustomerNo = '00198019'; // leader '00198019'  member '00224747'
var testEnterpriseNo = '00000267';
var promotions618 = {};
var researchGroupStatusDictionary = {
  0: '未启用',
  1: '正常',
  2: '已冻结',
  3: '已过期'
};
var researchGroupApproveTypeDictionary = {
  0: '无需审批',
  1: '全部审批',
  2: '限额审批'
};
var WAPP_LOGIN_TYPE_CODE = 2;
var WAPP_LOGIN_TYPE_WX = 1;
var WAPP_LOGIN_TYPE_DICTIONARY = (_WAPP_LOGIN_TYPE_DICT = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_WAPP_LOGIN_TYPE_DICT, WAPP_LOGIN_TYPE_WX, '/pages/login/login'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_WAPP_LOGIN_TYPE_DICT, WAPP_LOGIN_TYPE_CODE, '/pages/login/loginByCode'), _WAPP_LOGIN_TYPE_DICT);
var CONSTANT_APPROVETYPE_NONE = 0;
var CONSTANT_APPROVETYPE_ALL = 1;
var CONSTANT_APPROVETYPE_THRESHOLD = 2;
var CONSTANT_SET_SINGLESTORKE_APPROVETYPE = 1;
var CONSTANT_SET_MOUNTH_APPROVETYPE = 2;
var CONSTANT_ALL_APPROVETYPE = 0;
// 课题组审批结果
var RESEARCH_GROUP_APPROVE_RESULT_NEED_NOT_APPROVE = 0; // 不需要审批
var RESEARCH_GROUP_APPROVE_RESULT_NOT_OPERATED = 1; // 未审批
var RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE = 2; // 待审批
var RESEARCH_GROUP_APPROVE_RESULT_APPROVED = 3; // 审批通过
var RESEARCH_GROUP_APPROVE_RESULT_NOT_APPROVED = 4; // 审批未通过
// 订单状态
var ORDER_STATUS_DRAFT = 1;
var ORDER_STATUS_SUBMITTED = 2;
var ORDER_STATUS_PAIED = 3;
var ORDER_STATUS_CONTRACT = 5;
var ORDER_STATUS_FINISHED = 11;
var ORDER_STATUS_ABORT = 12;
var ORDER_STATUS_CHECK = 14;
var ORDER_STATUS_SIGN_NEED = 15;
var ORDER_STATUS_CHECK_BAD = 16;
var ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE = 17;
var ORDER_STATUS_WAIT_PD_TECH_AUDIT = 18; // 产品类-待技术审核状态
var ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL = 19; // 产品类-技术审核未通过状态

// 结算方式
var BALANCE_TYPE_RESEARCH_GROUP = 1;
var BALANCE_TYPE_CUSTOMER = 0;
// 支付方式
var PAY_TYPE_REMAIN_MONEY = 1;
var PAY_TYPE_FAPIAO = 3;
// 课题组状态
var RESEARCH_GROUP_STATUS_DISABLE = 0; // 未启用
var RESEARCH_GROUP_STATUS_NORMAL = 1; // 正常
var RESEARCH_GROUP_STATUS_LOCKED = 2; // 已冻结
var RESEARCH_GROUP_STATUS_EXPIRED = 3; // 已过期
// 结算账户状态
var SETTLEMENT_ACCOUNT_STATUS_DISABLE = 0; // 禁用
var SETTLEMENT_ACCOUNT_STATUS_NORMAL = 1; // 启用
var SETTLEMENT_ACCOUNT_STATUS_LOCKED = 2; // 注销
var SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP = 3; // 课题组结算账户

// 订单状态
var ORDER_TYPE_SERVICE = 3;

// 产品类型
var PRODUCT_TYPE_TOOL = '产品类';
var CUSTOMIZE_IMAGE = 'Customize.jpg';
var PRODUCT_TYPE_SERVICE_CONSTANT = 99;
// 订单管理页面tab区订单状态对应的tab值
var MYORDER_TAB_WAITPAY = 1;
var MYORDER_TAB_EXECUTE = 2;
var MYORDER_TAB_FINISHED = 3;
var MYORDER_TAB_CANCELLED = 4;
var MYORDER_TAB_WAITAUDIT = 5;
// 判断是否是iphone全面屏
var isIphoneFullScreen = false;
// 是否需要适配全面屏，从小程序过了且当前为全面屏
var leaveSpaceForFullScreen = false;
var researchGroupDictionary = {
  '名称': 'researchGroupName',
  '编号': 'researchGroupNo',
  '单位': 'firstLevelEnterpriseName',
  '科室': 'secondLevelEnterpriseName',
  '负责人': 'leaderName',
  '审批人': 'approverName',
  '对账人': 'accountCustomerName',
  'A类折扣': 'discountA',
  'B类折扣': 'discountB',
  'C类折扣': 'discountC',
  '账期': 'creditPeriod',
  '课题组状态': 'status',
  '生效日期': 'startDT',
  '有效截止日期': 'endDT',
  '我的审批原则': 'approveType',
  '权益等级': 'vipLevel'
};
var researchGroupDetailDisplayOrder = ['名称', '编号', '单位', '科室', '负责人', '审批人', '对账人', 'A类折扣', 'B类折扣', 'C类折扣', '权益等级', '账期', '课题组状态', '生效日期', '有效截止日期', '我的审批原则'];
var researchGroupMemberDictionary = {
  'memberName': '姓名',
  'mobile': '手机',
  'email': '邮箱',
  'firstLevelEnterpriseName': '单位',
  'secondLevelEnterpriseName': '科室',
  'createDT': '加入日期',
  'approveType': '审批原则',
  'approveThreshold': '审批限额'
};
var researchServiceCategory = '30';
var benefitDiscount = [{ 'tool': 8, 'service': 9 }, { 'tool': 7.5, 'service': 8.8 }, { 'tool': 7.2, 'service': 8.6 }, { 'tool': 7, 'service': 8.5 }, { 'tool': 6.5, 'service': 8 }];
var HardGeneLevelNo1 = 1; // 困难基因级别-
var HardGeneLevelNo2 = 2; // 困难基因级别-二
var ENTERPRISE_TYPE_COMPANY = 7; // 单位类型-企业
var TOOLTYPE_LENTIVIRUS = '1';
var TOOLTYPE_PLASMID = '2';
var TOOLTYPE_ADENOVIRUS = '3';
var TOOLTYPE_RETROVIRUS = '6';
var TOOLTYPE_FLOATVIRUS = '7';
var TOOLTYPE_ADENOVIRUSABOUT = '4'; // 工具类型为腺病毒
var AAVBLOODTYPETWO = '2'; // 血清类型为2
var AAVBLOODTYPESIX = '6'; // 血清类型为6
var VIRUSTITER1E13 = '4'; // 病毒滴度为1E13
var VIRUSTITER5E12 = '9'; // 病毒滴度为5E12
var AMPLIFICATION = '3'; // 合同选择为扩增产品
var CUSTOMERPROVIDED = '1'; // 客户提供质粒
var ORDER_SOURCE = {
  EMKT: 1,
  SF: 2,
  OFFLINE: 3
  // 地址状态
};var ADDRESS_STATUS = {
  ADDRESS_STATUS_DRAFT: 1, // 草稿
  ADDRESS_STATUS_EFFECTIVE: 2, // 生效
  ADDRESS_STATUS_INVALID: 3 // 失效

  // 地址来源
};var ADDRESS_SOURCE = {
  ADDRESS_SOURCE_EMKT: 1, // 电商
  ADDRESS_SOURCE_SF: 2 // SF

  // 实物类型
};var MATERIAL_TYPE = {
  CELL: 1, // 目的细胞
  SAMPLE: 2, // 样本
  ANTIBODY: 3, // 抗体
  MEDICINE: 4, // 药物
  KIT: 6, // 试剂盒
  OTHER: 7, // 其他
  VIRUS: 8, // 病毒
  PLASMID: 9, // 质粒
  PRIMER: 10 // 引物

  // 实物文件类型
};var MATERIAL_FILETYPE = {
  SAMPLE_DELIVERY_GUIDE: 1, // 送样指南
  SAMPLE_INFO_SHEET: 2 // 实物信息表

  // 收货地址
};var DELIVERY_ADDRESS = {
  ADDRESS: '上海市浦东新区爱迪生路332号吉凯基因仓库',
  RECEIVER: '客供品管理员',
  PHONE: '021-61063988'
  // 样本图标及快递展示状态
};var SAMPLE_DISPLAY_TYPE = {
  DISPLAY_NMAE: 1, // 展示状态
  DISPLAY_ICON: 2 // 展示图标

  // 进入送样单时来源类型
};var SAMPLE_DELIVERY_FORM_TYPE = {
  fromAddSampleDelivery: 1, // 寄送实物
  fromModifySampleDelivery: 2 // 修改送样单

  // 实物管理静态文件
};var MATERIAL_STATIC_FILE_BASE_URL = '/emktResources/resocurces/img/material/';

// 商品图片静态文件
// const LOCATION_ORIGIN = 'https://www.genechemat.com:8443'
var LOCATION_ORIGIN = 'https://gmall.taogene.com';
var MERCHANDISE_IMG_BASE_URL = LOCATION_ORIGIN + '/emktResources/resocurces/img/merchandise/';

var MERCHANDISE_IMG_BASE_URL_RTMES = window.location.origin + '/rtmes-client/';
var MERCHANDISE_IMG_BASE_URL_SMART = window.location.origin + '/smart-center/gesource';
// 产品大类的角标iconTag
var PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION = 1;
var PRODUCT_CATEGORY_ICON_TAG_STOCK = 2;
var PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE = 3;
var ICON_TAG_IMAGE_MAP = (_ICON_TAG_IMAGE_MAP = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ICON_TAG_IMAGE_MAP, PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION, 'amplification.png'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ICON_TAG_IMAGE_MAP, PRODUCT_CATEGORY_ICON_TAG_STOCK, 'xianhuo.png'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ICON_TAG_IMAGE_MAP, PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE, 'dingzhi.png'), _ICON_TAG_IMAGE_MAP);
// 产品类型
var PRODUCT_TYPE_ID = {
  instantStock: 1,
  produceStock: 2,
  customMade: 3,
  reagent: 4,
  amplification: 5,
  control: 6
  // 载体图谱路径
};var TV_NO_PATH = LOCATION_ORIGIN + '/emktResources/resocurces/img/promotion/SKUIMG/';

// 服务类进展推送
var ADBERRATION_EXCHANGE = 1; // 1：实验异常需交流；
var ADBERRATION_RETROACTION = 2; // 2：实验信息需反馈；
var ADBERRATION_REPORT = 3; // 3：进展汇报
var ADBERRATION_MESSAGE = (_ADBERRATION_MESSAGE = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_MESSAGE, ADBERRATION_EXCHANGE, '实验服务出现异常，请点击异常实验查看详情'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_MESSAGE, ADBERRATION_RETROACTION, '实验暂停中，请您尽快查看并回复邮件以继续开展实验'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_MESSAGE, ADBERRATION_REPORT, '您的实验有进展，请点击有进展实验查看详情'), _ADBERRATION_MESSAGE);
var ADBERRATION_STATUS = (_ADBERRATION_STATUS = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_STATUS, ADBERRATION_EXCHANGE, '异常'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_STATUS, ADBERRATION_RETROACTION, '待确认'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ADBERRATION_STATUS, ADBERRATION_REPORT, '有进展'), _ADBERRATION_STATUS);
var EXPERIMENT_MODULES_STATUS_CANNOT_START = '无法开始';
var EXPERIMENT_MODULES_STATUS_READY_START = '准备开始';
var EXPERIMENT_MODULES_STATUS_ON_GOING = '进行中';
var EXPERIMENT_MODULES_STATUS_ENDING = '结束';
var EXPERIMENT_MODULES_STATUS_END_STOP = '终止';
var EXPERIMENT_MODULES_STATUS_NOT_START = '未开始';
var EXPERIMENT_MODULES_STATUS_STOP = '暂停中';
var EXPERIMENT_MODULES_STATUS_NAME_NOT_START = '未开始';
var EXPERIMENT_MODULES_STATUS_NAME__ON_GOING = '进行中';
var EXPERIMENT_MODULES_STATUS_NAME__ENDING = '已完成';
var EXPERIMENT_MODULES_STATUS_NAME__END_STOP = '终止';
var EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION = '待确认';

var QUERY_ORDER_TYPE = {
  RESEARCHGROUP: 1,
  CUSTOMER: 2,
  SETTLEMENT_ACCOUNT: 4

};
function initCustomerBehaviour() {
  customerBehaviours = {
    'home': {
      'goToDetail': {},
      'search': {},
      'clickBanner': {},
      'clickLike': {}
    },
    'category': {
      'search': {},
      'goToCategoryDetail': {}
    },
    'news': {
      // todo
    },
    'cart': {
      'addCount': [],
      'minusCount': [],
      'goToDetail': {},
      'check': [],
      'unCheck': [],
      'checkAll': [],
      'unCheckAll': [],
      'deleteCart': [],
      'goToPay': {}
    },
    'me': {
      // todo
    },
    'categoryDetail': {},
    'merchandises': {},
    'searchresults': {
      'click': {}
    },
    'login': {},
    'register': {},
    'mobileLogin': {},
    'activation': {},
    'orders': {},
    'userInfo': {},
    'addressModify': {},
    'address': {},
    'addAddress': {},
    'changeLoginId': {},
    'passwordChange': {},
    'orderContentConfirm': {},
    'orderPayConfirm': {},
    'orderContent': {},
    'addressDetail': {},
    'orderConfirmDetail': {},
    'payDetail': {},
    'invoiceDetail': {},
    'promotions': {},
    'orderContentDetail': {},
    'successPay': {},
    'invoiceTitle': {},
    'myCoupons': {},
    'addInvoiceTitle': {},
    'myOrders': {},
    'forgetPassword': {},
    'myOrderDetail': {},
    'evaluation': {},
    'custOrder': {},
    'custOrder2': {},
    'dataMeta': {},
    'myDiscount': {},
    'myComment': {},
    'getComments': {},
    'applyCreditPay': {},
    'invoiceAddress': {},
    'myInvoiceAddress': {},
    'addInvoiceAddress': {},
    'invoiceAddressModify': {},
    'myMessage': {},
    'contact': {},
    'myAgreement': {},
    'myRecommend': {},
    'publicNumber': {},
    'myOrderCoupons': {},
    'compositions': {},
    'custDetail': {}
  };
  behaviour = { 'time': '', 'target': '', 'type': '' };
}

// 优惠券活动类型：领取优惠券
var COUPON_ACTIVITY_TYPE_COUPON = 1;
// 优惠券活动类型：拼团活动
var COUPON_ACTIVITY_TYPE_GROUP_BUY = 2;
// 优惠券活动类型：20周年活动
var COUPON_ACTIVITY_TYPE_ANNIVERSARY = 3;
initCustomerBehaviour();

// 本地持久化存储
var getLocalStorage = function getLocalStorage(name) {
  if (!name) return;
  if (localStorege[name]) {
    return localStorege[name];
  } else {
    if (!window.localStorage) {
      return;
    }

    var content = window.localStorage.getItem(name);
    if (content) {
      localStorege[name] = JSON.parse(content);
      return localStorege[name];
    }
  }
};

var setLocalStorage = function setLocalStorage(name, content) {
  if (!name) return;
  localStorege[name] = content;

  if (!window.localStorage) {
    return;
  }

  content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content);
  try {
    window.localStorage.setItem(name, content);
  } catch (err) {
    // window.alert('local store :' + name + ',' + err)
    // 有可能是local storage quota 超出了， 尝试清除一下EmktAllKeywords，因为EmktAllKeywords比较大， 在空间不够的情况下，EmktAllKeywords会保存在内存里
    try {
      window.localStorage.removeItem('EmktAllKeywords');
      window.localStorage.setItem(name, content);
    } catch (error) {
      console.log('local store :' + name + ',' + error);
    }
  }
};
var setBuyCart = function setBuyCart(name, content) {
  if (buyCartIsLocalStorage) {
    setLocalStorage(name, content); // 非SF
  } else {
    setStoreItem(name, content); // SF
  }
};

// 仅放在内存里面，不持久化到window.localStorage
var setStoreItem = function setStoreItem(name, content) {
  if (!name) return;
  localStorege[name] = content;
};

var removeStoreItem = function removeStoreItem(name) {
  if (!name) return;
  localStorege[name] = '';
};

var getStoreItem = function getStoreItem(name) {
  if (!name) return;
  return localStorege[name];
};
function getEmktMetaVersion() {
  if (isInit === false) {
    init();
  }
  return emktMetaVersion;
}

function getEmktMetaData() {
  return getLocalStorage('EmktMetaData');
}
function setEmktMetaData(emktMetaData) {
  if (emktMetaData) {
    setLocalStorage('EmktMetaData', emktMetaData);
    emktMetaVersion = emktMetaData.version;
    window.document.cookie = 'EmktMetaVersion=' + emktMetaVersion;
  }
}

function merchandiseWithMeta(merchandise) {
  if (!merchandise) {
    return merchandise;
  }

  var attributes = merchandise.attributes;
  var categoryAttrGroupsMap = getEmktMetaData().categoryAttrGroupsMap;
  var BloodOptions = getLocalStorage('BloodOptions');
  var dictionariesMap = getEmktMetaData().dictionariesMap; // 字典
  var categoryAttrsMap = getEmktMetaData().categoryAttrsMap; // 属性的元数据
  var _attributes = {}; // 属性
  var _attributesList = []; // 属性列表
  var _customizableAttributes = {}; // 定制属性
  var _customizableAttrGroups = {}; // 定制属性组
  var _customizableAttrGroupsList = []; // 定制属性组列表

  merchandise._cycle = { label: '生产周期', value: merchandise.cycle, valueText: merchandise.cycle + '个工作日'
    // 处理属性
  };for (var attrName in attributes) {
    var attrVal = void 0;
    var options = {};
    var attrMeta = categoryAttrsMap[merchandise.categoryId][attrName];
    var sdType = attrMeta.semanticDT;
    var label = attrMeta.categoryAttrLabel;
    var groupId = attrMeta.attrGroupId;
    var sortOrder = attrMeta.sortOrder;
    var keyFeature = attrMeta.keyFeature;
    var displayable = attrMeta.displayable;
    var columnName = attrMeta.columnName;
    if (columnName === 'TVInfo.tag1PUBID' && merchandise.goodsNo === 'GTCL3481109223QA') {
      // 该产品载体无荧光但是基因有荧光，因此去电【无荧光】显示
      displayable = 0;
    }
    var sorteditAble = attrMeta.sorteditAble;
    var sectionId = attrMeta.sectionId;
    attrVal = {
      'label': label,
      'value': attributes[attrName],
      'sdType': sdType,
      'groupId': groupId,
      'sortOrder': sortOrder,
      'keyFeature': keyFeature,
      'displayable': displayable,
      'valueText': attributes[attrName],
      'columnName': columnName,
      'sorteditAble': sorteditAble,
      'sectionId': sectionId
      // 修改元数据配置信息获取
    };if (sdType === SDTEnumeration) {
      // 枚举类型
      var dicValue = void 0;
      var aName = null;
      if (attrMeta.extras) {
        // 血清型特殊处理
        if (attrMeta.extras.indexOf('^') !== -1) {
          aName = attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'));
        } else {
          aName = attrMeta.extras.substring(11, attrMeta.length);
        }
        if (aName === '61029') {
          attrVal.valueText = BloodOptions[attributes[attrName]];
          attrVal.options = BloodOptions;
        } else {
          if (attrMeta.extras.indexOf('^') !== -1) {
            dicValue = dictionariesMap[attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'))];
          } else {
            dicValue = dictionariesMap[attrMeta.extras.substring(11, attrMeta.length)];
          }
        }
      }
      if (aName !== '61029') {
        for (var k in dicValue) {
          var val = dicValue[k];
          options[val.dictKey] = val.dictValue;
        }
        attrVal.valueText = options[attributes[attrName]];
        attrVal.options = options;
      }
    }
    _attributes[attrName] = attrVal;
    _attributesList.push(attrVal);
  }
  // 结束本次修改
  // 属性列表排序
  var attributesSorter = function attributesSorter(a, b) {
    var sortOrderA = a.sortOrder;
    var sortOrderB = b.sortOrder;
    var keyFeatureA = a.keyFeature;
    var keyFeatureB = b.keyFeature;
    var r = keyFeatureA - keyFeatureB;
    if (merchandise.categoryId === 12) {
      return sortOrderA - sortOrderB;
    } else if (merchandise.categoryId === 20) {
      return a.sectionId - b.sectionId;
    } else {
      if (r === 0) {
        r = sortOrderA - sortOrderB;
      }
    }

    return r;
  };
  var custattributesSorter = function custattributesSorter(a, b) {
    var sortOrderA = a.sortOrder;
    var sortOrderB = b.sortOrder;
    if (merchandise.categoryId === 20) {
      return b.sectionId - a.sectionId;
    } else {
      return sortOrderA - sortOrderB;
    }
  };
  _attributesList.sort(attributesSorter);
  // 处理定制属性
  var customizableAttrNames = merchandise['customizableAttrNames'];
  for (var idx in customizableAttrNames) {
    var _attrName = customizableAttrNames[idx];
    if (_attrName !== 'GeneInfo.category') {
      var _attrVal = void 0;
      var _options = {};
      var _attrMeta = categoryAttrsMap[merchandise.categoryId][_attrName];
      var _sdType = _attrMeta.semanticDT;
      var _label = _attrMeta.categoryAttrLabel;
      var _groupId = _attrMeta.attrGroupId;
      var _sortOrder = _attrMeta.sortOrder;
      var _columnName = _attrMeta.columnName;
      var customizable = _attrMeta.customizable;
      var description = _attrMeta.description;
      _attrVal = {
        'label': _label,
        'value': '',
        'sdType': _sdType,
        'editAble': true,
        'sorteditAble': false,
        'customizable': customizable,
        'isNA': false,
        'groupId': _groupId,
        'sortOrder': _sortOrder,
        'error': '',
        'columnName': _columnName,
        'description': description
      };
      _attrVal.valueText = _attrVal.value;
      // if (attrName.indexOf('GeneInfo.') !== -1) {
      //   attrVal.editAble = false
      // }
      if (_sdType === SDTEnumeration) {
        // 枚举类型
        var _aName = null;
        var _dicValue = void 0;
        if (_attrMeta.extras) {
          // 血清型特殊处理
          if (_attrMeta.extras.indexOf('^') !== -1) {
            _aName = _attrMeta.extras.substring(_attrMeta.extras.indexOf('=') + 1, _attrMeta.extras.indexOf('^'));
          } else {
            _aName = _attrMeta.extras.substring(11, _attrMeta.length);
          }
          if (_aName === '61029') {
            _attrVal.valueText = '';
            _attrVal.options = BloodOptions;
          } else {
            if (_attrMeta.extras.indexOf('^') !== -1) {
              _dicValue = dictionariesMap[_attrMeta.extras.substring(_attrMeta.extras.indexOf('=') + 1, _attrMeta.extras.indexOf('^'))];
            } else {
              _dicValue = dictionariesMap[_attrMeta.extras.substring(11, _attrMeta.length)];
            }
          }
        }
        if (_aName !== '61029') {
          for (var key in _dicValue) {
            var _val = _dicValue[key];
            if (_val.valid) {
              // 只有有效的选项才可以加入options
              _options[_val.dictKey] = _val.dictValue;
            }
          }
          _attrVal.valueText = '';
          _attrVal.options = _options;
        }
      } else if (_sdType === SDTToolVector) {
        _attrVal.options = [];
      }
      /*
       if (sdType === SDTGene) { // 枚举类型
       var custGeneInfo1 = custGeneInfo(attrVal, groupId, dictionariesMap, sortOrder)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_tax', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_geneID', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_NMID', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       let tax = custGeneInfo1['GeneInfo_tax']
       tax.editAble = false
       tax.sortOrder = sortOrder + 1
       var Id = attrVal.groupId
       _customizableAttributes['GeneInfo_tax'] = tax
       if (!g) {
       g = categoryAttrGroupsMap[tax.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_tax')
       g.attrs.push(tax)
       let geneID = custGeneInfo1['GeneInfo_geneID']
       geneID.editAble = false
       geneID.sortOrder = sortOrder + 1
       _customizableAttributes['GeneInfo_geneID'] = geneID
       if (!g) {
       g = categoryAttrGroupsMap[geneID.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_geneID')
       g.attrs.push(geneID)
        let NMID = custGeneInfo1['GeneInfo_NMID']
       NMID.editAble = false
       NMID.sortOrder = sortOrder + 1
       _customizableAttributes['GeneInfo_NMID'] = NMID
       if (!g) {
       g = categoryAttrGroupsMap[NMID.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_NMID')
       g.attrs.push(NMID)
       }
       */
      // 处理定制属性组
      _customizableAttributes[_attrName] = _attrVal;
      var attrGroupId = _attrVal.groupId;
      var g = _customizableAttrGroups[attrGroupId];
      if (!g) {
        g = {};
        var gmeta = categoryAttrGroupsMap[_attrVal.groupId];
        g.attrGroupId = gmeta.attrGroupId;
        g.groupLabel = gmeta.groupLabel;
        g.sortOrder = gmeta.sortOrder;
        g.attrNames = [];
        g.attrs = [];
        _customizableAttrGroups[attrGroupId] = g;
        _customizableAttrGroupsList.push(g);
      }
      g.attrNames.push(_attrName);
      g.attrs.push(_attrVal);
    }
  }

  // // 定制组排序
  _customizableAttrGroupsList.sort(function (a, b) {
    return a.attrGroupId - b.attrGroupId;
  });

  // 定制属性排序
  for (var grpIdx in _customizableAttrGroupsList) {
    var grp = _customizableAttrGroupsList[grpIdx];
    grp.attrs.sort(custattributesSorter);
  }
  var _titleList = [];
  var _subTitleList = [];
  var _abstractList = [];
  var _specificatList = [];
  for (var attrIdx in _attributesList) {
    var attribute = _attributesList[attrIdx];
    if (merchandise.categoryId === 10) {
      var _label2 = attribute.label;
      if (_label2 === '基因名') {
        if (attribute.value !== '-1') {
          _titleList.push(attribute);
        }
      }
      if (_label2 === '调控目的') {
        if (attribute.value !== '-1') {
          _subTitleList.push(attribute);
        }
      }
      if (_label2 === '靶点提供方案') {
        if (attribute.value !== '-1') {
          _abstractList.push(attribute);
        }
      }
    } else if (merchandise.categoryId === 20) {
      var _label3 = attribute.label;
      if (_label3 === '基因' && attribute.value) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(attribute.value) === 'object') {
          var taxId = {};
          var dictionary = getEmktMetaData().dictionariesMap;
          taxId.columnName = 'GeneInfo.taxId';
          taxId.value = dictionary[61033][attribute.value.taxId].dictValue;
          taxId.valueText = taxId.value;
          var symbol = {};
          symbol.columnName = 'GeneInfo.symbol';
          symbol.value = attribute.value.symbol;
          symbol.valueText = attribute.value.symbol;
          _abstractList.push(taxId);
          _abstractList.push(symbol);
          // abstractTitles = abstractTitles + ' ' + taxId
          // abstractTitles = abstractTitles + ' ' + symbol
        } else if (attribute.value.toString().startsWith('{')) {
          attribute.value = JSON.parse(attribute.value);
          var _taxId = {};
          var _dictionary = getEmktMetaData().dictionariesMap;
          _taxId.columnName = 'GeneInfo.taxId';
          _taxId.value = _dictionary[61033][attribute.value.taxId].dictValue;
          _taxId.valueText = _taxId.value;
          var _symbol = {};
          _symbol.columnName = 'GeneInfo.symbol';
          _symbol.value = attribute.value.symbol;
          _symbol.valueText = attribute.value.symbol;
          _abstractList.push(_taxId);
          _abstractList.push(_symbol);
        }
      }
    } else {
      if (merchandise.categoryId !== 12 && merchandise.categoryId !== 20) {
        if (attribute.keyFeature >= KFNA) {
          break;
        }
      }
    }
    if (attribute.value !== '-1' && attribute.value !== undefined && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== -1) {
      if (attribute.keyFeature === KFTitle) {
        if (!(attribute.columnName === 'TVInfo.tag1PUBID' && merchandise.goodsNo === 'GTCL3481109223QA')) {
          // 该产品载体无荧光但是基因有荧光，因此去电【无荧光】显示
          _titleList.push(attribute);
        }
      } else if (attribute.keyFeature === KFSubtitle) {
        _subTitleList.push(attribute);
      } else if (attribute.keyFeature === KFAbstract) {
        _abstractList.push(attribute);
      } else if (attribute.keyFeature === KFSpecificat) {
        _specificatList.push(attribute);
      }
    }
  }
  var name = {};
  if (merchandise.categoryId !== 20) {
    name.valueText = merchandise.productName;
    _titleList.push(name);
  }
  merchandise['_attributes'] = _attributes;
  merchandise['_attributesList'] = _attributesList;
  if (merchandise.categoryId !== 10) {
    _titleList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    _subTitleList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    _abstractList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    _attributesList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
  }
  var i = 0;
  if (merchandise.bpromotions) {
    var promotions = [];
    for (i = 0; i < merchandise.bpromotions.length; i++) {
      if (merchandise.bpromotions[i].type === 3 && merchandise.bpromotions[i].emktIsShow === 1) {
        promotions.push(merchandise.bpromotions[i]);
      } else if (merchandise.bpromotions[i].type !== 3) {
        promotions.push(merchandise.bpromotions[i]);
      }
    }
    merchandise.bpromotions = promotions;
    merchandise.bpromotions.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }
  if (merchandise.promotions) {
    var dpromotions = [];
    for (i = 0; i < merchandise.promotions.length; i++) {
      if (merchandise.promotions[i].type === 3 && merchandise.promotions[i].emktIsShow === 1) {
        dpromotions.push(merchandise.promotions[i]);
      } else if (merchandise.promotions[i].type !== 3) {
        dpromotions.push(merchandise.promotions[i]);
      }
    }
    merchandise.promotions = dpromotions;
    merchandise.promotions.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }
  merchandise['_titleList'] = _titleList;
  merchandise['_subTitleList'] = _subTitleList;
  merchandise['_abstractList'] = _abstractList;
  merchandise['_specificatList'] = _specificatList;
  merchandise['_customizableAttrGroupsList'] = _customizableAttrGroupsList;
  merchandise['_customizableAttrGroups'] = _customizableAttrGroups;
  merchandise['_customizableAttributes'] = _customizableAttributes;
  return merchandise;
}
function init() {
  var emktMetaData = getLocalStorage('EmktMetaData');
  if (emktMetaData) {
    emktMetaVersion = emktMetaData.version;
  }
  window.document.cookie = 'EmktMetaVersion=' + emktMetaVersion;
  isInit = true;
}
// 获取订单中商品类型显示标签 deprecated
function getMerchandiseLabelPath(merchandise) {
  var route = '/static/img/';
  return getMerchandiseLabelImg(route, merchandise);
}
function getMerchandiseLabelImg(route, merchandise) {
  if (merchandise.categoryId === 20 || merchandise.categoryId === 10 || merchandise.isStock === 0) {
    return merchandise.fromEmkt && merchandise.name && merchandise.name.includes('扩增') ? route + '扩增标签.png' : route + '定制标签.png';
  } else {
    return route + '现货标签.png';
  }
}
function getOrderMerchandiseLabel(merchandise) {
  return getMerchandiseLabelImg(MERCHANDISE_IMG_BASE_URL, merchandise);
}
// 获取文件显示图标
function getOrderMaterialFileShowIcon(fileName) {
  var route = MATERIAL_STATIC_FILE_BASE_URL + 'other/';
  if (fileName !== undefined) {
    var suffix = getFileSuffix(fileName);
    if (suffix === 'pdf') {
      return route + 'pdf.svg';
    } else if (suffix === 'mp4') {
      return route + 'mp4.svg';
    } else if (suffix === 'doc' || suffix === 'docx') {
      return route + 'word.svg';
    } else if (suffix === 'xls' || suffix === 'xlsx') {
      return route + 'excel.svg';
    } else {
      return route + 'file_default.svg';
    }
  }
}
function reassembleOrderMaterialInfo(orderMaterialInfo) {
  var orderMaterial = [];
  var initFileList = [];
  orderMaterialInfo.forEach(function (material) {
    material.orderMaterial.isChecked = false;
    orderMaterial.push({ orderMaterial: material.orderMaterial, orderMaterialDetail: { infoReceived: false, orderMaterialId: material.orderMaterial.orderMaterialId } });
    if (material.initFileList) {
      material.initFileList.forEach(function (initFile) {
        initFileList.push(initFile);
      });
    }
  });
  return { orderMaterial: orderMaterial, initFileList: initFileList };
}
function getFileSuffix(fileName) {
  return fileName.substring(fileName.lastIndexOf('.') + 1);
}
// function custGene (attrVal, _attributes, _attributesList, groupId, dictionariesMap, sortOrder) {
//   attrVal.displayable = 0
//
//   let symbol = {}
//   symbol.label = '基因名'
//   if (attrVal.value) {
//     symbol.value = attrVal.value.symbol
//     symbol.valueText = symbol.value
//   } else {
//     symbol.value = ''
//     symbol.valueText = ''
//   }
//   symbol.sdType = SDTString
//   symbol.groupId = groupId
//   symbol.sortOrder = sortOrder
//   symbol.keyFeature = KFTitle
//   symbol.displayable = true
//   _attributes['GeneInfo_symbol'] = symbol
//   _attributesList.push(symbol)
//
//   let tax = {}
//   tax.label = '组织类型'
//   if (attrVal.value) {
//     tax.value = dictionariesMap[taxTypeId][attrVal.value.taxId].dictValue
//     tax.valueText = tax.value
//   } else {
//     tax.value = ''
//     tax.valueText = ''
//   }
//   tax.sdType = SDTEnumeration
//   tax.groupId = groupId
//   tax.sortOrder = sortOrder
//   tax.keyFeature = KFSubtitle
//   tax.displayable = true
//   _attributes['GeneInfo_tax'] = tax
//   _attributesList.push(tax)
//
//   let geneID = {}
//   geneID.label = '基因ID'
//   if (attrVal.value) {
//     geneID.value = attrVal.value.geneID
//     geneID.valueText = geneID.value
//   } else {
//     geneID.value = ''
//     geneID.valueText = ''
//   }
//   geneID.sdType = SDTString
//   geneID.groupId = groupId
//   geneID.sortOrder = sortOrder
//   geneID.keyFeature = KFNA
//   geneID.displayable = true
//   _attributes['GeneInfo_geneID'] = geneID
//   _attributesList.push(geneID)
//
//   let NMID = {}
//   NMID.label = 'bankid'
//   if (attrVal.value) {
//     NMID.value = attrVal.value.NMID
//     NMID.valueText = NMID.value
//   } else {
//     NMID.value = ''
//     NMID.valueText = ''
//   }
//   NMID.sdType = SDTString
//   NMID.groupId = groupId
//   NMID.sortOrder = sortOrder
//   NMID.keyFeature = KFNA
//   NMID.displayable = true
//   _attributes['GeneInfo_NMID'] = NMID
//   _attributesList.push(NMID)
// }
/*
function custGeneInfo (attrVal, groupId, dictionariesMap, sortOrder) {
  attrVal.displayable = 0
  let symbol = {}
  var custGeneInfo = {}
  symbol.label = '基因名'
  if (attrVal.value) {
    symbol.value = attrVal.value.symbol
    symbol.valueText = symbol.value
  } else {
    symbol.value = ''
    symbol.valueText = ''
  }
  symbol.sdType = SDTString
  symbol.groupId = groupId
  symbol.sortOrder = sortOrder
  symbol.keyFeature = KFTitle
  symbol.displayable = true
  custGeneInfo['GeneInfo_symbol'] = symbol
  let tax = {}
  tax.label = '组织类型'
  if (attrVal.value) {
    tax.value = dictionariesMap[taxTypeId][attrVal.value.taxId].dictValue
    tax.valueText = tax.value
  } else {
    tax.value = ''
    tax.valueText = ''
  }
  tax.sdType = SDTEnumeration
  tax.groupId = groupId
  tax.sortOrder = sortOrder
  tax.keyFeature = KFSubtitle
  tax.displayable = true
  custGeneInfo['GeneInfo_tax'] = tax
  let geneID = {}
  geneID.label = '基因ID'
  if (attrVal.value) {
    geneID.value = attrVal.value.geneID
    geneID.valueText = geneID.value
  } else {
    geneID.value = ''
    geneID.valueText = ''
  }
  geneID.sdType = SDTString
  geneID.groupId = groupId
  geneID.sortOrder = sortOrder
  geneID.keyFeature = KFNA
  geneID.displayable = true
  custGeneInfo['GeneInfo_geneID'] = geneID
  let NMID = {}
  NMID.label = 'bankid'
  if (attrVal.value) {
    NMID.value = attrVal.value.NMID
    NMID.valueText = NMID.value
  } else {
    NMID.value = ''
    NMID.valueText = ''
  }
  NMID.sdType = SDTString
  NMID.groupId = groupId
  NMID.sortOrder = sortOrder
  NMID.keyFeature = KFNA
  NMID.displayable = true
  custGeneInfo['GeneInfo_NMID'] = NMID
  return custGeneInfo
}
*/
// function geneedit (sortOrder, custGeneInfo1, _customizableAttributes, name, attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList) {
//   let tax = custGeneInfo1[name]
//   alert(name)
//   tax.editAble = false
//   tax.sortOrder = sortOrder + 1
//   var Id = attrVal.groupId
//   _customizableAttributes[name] = tax
//   if (!g) {
//     g = categoryAttrGroupsMap[tax.groupId]
//     g.attrNames = []
//     g.attrs = []
//     _customizableAttrGroups[Id] = g
//     _customizableAttrGroupsList.push(g)
//   }
//   g.attrNames.push(name)
//   g.attrs.push(tax)
// }
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);

  var context = scope || this;
  var now = new Date().getTime();
  var args = arguments;
  if (throttleLast && now < throttleLast + threshhold) {
    // hold on to it
    clearTimeout(throttleDeferTimer);
    throttleDeferTimer = setTimeout(function () {
      throttleLast = now;
      fn.apply(context, args);
    }, threshhold);
  } else {
    throttleLast = now;
    fn.apply(context, args);
  }
}
function openCustomerService() {
  window.open('https://imxcx1.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=082583ee-1b2d-4d17-bfa4-7a027eb0c4e5');
}
// 获取url中的参数
function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'); // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) return decodeURIComponent(r[2]);

  return null; // 返回参数值
}
// 获取参数全名
function getFullUrlParam(val) {
  var uri = window.location.href;
  var re = new RegExp('' + val + '=([^&?]*)', 'ig');
  return uri.match(re) ? uri.match(re)[0].substr(val.length + 1).substring(0) : null;
}
function getUrlParamHref(val) {
  var uri = window.location.href;
  var re = new RegExp('' + val + '=([^&?]*)', 'ig');
  return uri.match(re) ? uri.match(re)[0].substr(val.length + 1).substring(0, 1) : null;
}
function getUrlFullParamValue(val) {
  var queryString = window.location.search.substr(1);
  var queryparam = new URLSearchParams(queryString);
  var params = Object.fromEntries(queryparam);
  return params[val] || null;
}
function isNullOrBlankObject(obj) {
  return !obj || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) === '{}';
}
// 格式化价格 10,000，且保留两位小数
function formatPrice(moneyNumber) {
  if (moneyNumber === 0) {
    return '0.00';
  }
  if (!moneyNumber) {
    return '';
  }
  return String(moneyNumber.toFixed(2)).replace(/\B(?=(?:\d{3})+\b)/g, ',');
}

var RESEARCH_MEMBER_OP = {
  approval: 2,
  add: 1
};
function FormatterTime(date) {
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds;
  return newTime;
}

function getOrderStatusText(order) {
  var text = '';
  if (order.itemList) {
    for (var i = 0; i < order.itemList.length; i++) {
      var sfQuoteStatus = order.itemList[i].sfQuoteStatus;
      // 待审核
      if (sfQuoteStatus && sfQuoteStatus === 3) {
        text = '待审核';
        break;
      }
    }
  }
  if (!text) {
    switch (order.status) {
      case ORDER_STATUS_DRAFT:
      case ORDER_STATUS_SUBMITTED:
        text = order.approveResult === RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE ? '待审批' : '待提交';
        break;
      case ORDER_STATUS_FINISHED:
        text = '已完成';
        break;
      case ORDER_STATUS_ABORT:
        text = '已取消';
        break;
      case ORDER_STATUS_CHECK:
        text = '技术审核中';
        break;
      case ORDER_STATUS_CHECK_BAD:
        text = '审核不通过';
        break;
      case ORDER_STATUS_SIGN_NEED:
        text = '待签署';
        break;
      case ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE:
        text = '待重新提交';
        break;
      case ORDER_STATUS_WAIT_PD_TECH_AUDIT:
        text = '产品类技术审核中';
        break;
      case ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL:
        text = '产品类审核不通过';
        break;
      default:
        text = '执行中';
    }
  }
  return text;
}

function getStatusStyle(order) {
  var background = 'alert-background';
  switch (order.status) {
    case ORDER_STATUS_DRAFT:
    case ORDER_STATUS_SUBMITTED:
      background = 'alert-background';
      break;
    case ORDER_STATUS_FINISHED:
      background = 'green-background';
      break;
    case ORDER_STATUS_ABORT:
      background = 'alert-background';
      break;
    case ORDER_STATUS_SIGN_NEED:
      background = 'alert-background';
      break;
    case ORDER_STATUS_CHECK:
      background = 'alert-background';
      break;
    case ORDER_STATUS_CHECK_BAD:
      background = 'alert-background';
      break;
    case ORDER_STATUS_WAIT_PD_TECH_AUDIT:
      background = 'alert-background';
      break;
    case ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL:
      background = 'alert-background';
      break;
    default:
      background = 'orange-background';
  }
  return ['order-status', 'tiny-font', background];
}

function filterOrderListBySearchMap(orderList, searchMap) {
  var ignoreKeywordSearch = !searchMap.keyword;
  var ignoreMemberSearch = !searchMap.memberNames || searchMap.memberNames.length === 0;
  if (ignoreKeywordSearch && ignoreMemberSearch) return orderList;
  return orderList.filter(function (order) {
    var targetOrderNo = ignoreKeywordSearch || order.orderNo.toLowerCase().includes(searchMap.keyword.toLowerCase());
    var targetContract = ignoreKeywordSearch || order.itemList.map(function (item) {
      return item.contractNo && item.contractNo.toLowerCase();
    }).join(',').includes(searchMap.keyword.toLowerCase());
    var targetCustomer = ignoreMemberSearch || searchMap.memberNames.includes(order.orderPerson);
    return targetCustomer && (targetOrderNo || targetContract);
  });
}
function setOrderMerchandiseWithMeta(orders) {
  for (var i = 0; i < orders.length; i++) {
    var order = orders[i];
    if (order.merchandises[0]) {
      order.merchandises[0].productName = order.productName;
    }
    setMerchandiseDetailForClient(order.merchandises);
  }
}

function setMerchandiseDetailForClient(merchandises) {
  if (merchandises) {
    merchandises.forEach(function (item) {
      var mer = item.merchandiseDetailForClient;
      if (mer) {
        if (mer.categoryId === 10 || mer.categoryId === 20) {
          setMerchandiseDetailForClientCustom(item);
        }
        merchandiseWithMeta(mer);
        item._attributesList = mer._attributesList;
        item._titleList = mer._titleList;
        item._subTitleList = mer._subTitleList;
        item._attributes = mer._attributes;
        item._abstractList = mer._abstractList;
        item.priceMax = mer.priceMax;
      }
    });
  }
}

function setMerchandiseDetailForClientCustom(item) {
  var attributes = item.attributes;
  var obj = {};
  var mer = item.merchandiseDetailForClient;
  attributes.forEach(function (data) {
    var key = data.key;
    var val = data.value;
    obj[key] = val;
  });
  mer.productName = item.productName;
  mer.attributes = obj;
  mer.cycle = item.workdays;
  mer.priceMax = item.priceMax;
  mer.priceMin = item.priceMin;
  // mer.priceMax = item.price
  // mer.priceMin = item.price
  mer.productGuid = item.productGuid;
  return mer;
}

function dealMetaData(response) {
  if (response) {
    var merchandiseMeta = response;
    var detaillist;
    var categoryAttrsMap = {};
    // var dictionariesMapNew = {}
    var dictionariesMap = {};
    var tagsMap = {};
    var tagIdsMap = {};
    var tagNamesMap = {};
    var dictionaries;
    var categoryAttrGroups;
    var categoryAttrGroupsMap = {};
    var tags;
    var categories;
    var categoriesMap = {};
    // var val = []
    detaillist = merchandiseMeta.categoryAttrs;
    dictionaries = merchandiseMeta.dictionaries;
    categoryAttrGroups = merchandiseMeta.categoryAttrGroups;
    tags = merchandiseMeta.tags;
    categories = merchandiseMeta.categories;

    for (var j = 0; j < dictionaries.length; j++) {
      var dkey = dictionaries[j].typeID + '_' + dictionaries[j].dictKey;
      var dvalue = dictionaries[j];
      var keyNew = dictionaries[j].typeID;
      dictionariesMap[dkey] = dvalue;
      var dictionariesEntry = dictionariesMap[keyNew];
      if (!dictionariesEntry) {
        dictionariesMap[keyNew] = {};
        dictionariesEntry = dictionariesMap[keyNew];
      }
      dictionariesEntry[dictionaries[j].dictKey] = dvalue;
    }

    for (j = 0; j < categoryAttrGroups.length; j++) {
      var k = categoryAttrGroups[j].attrGroupId;
      var v = categoryAttrGroups[j];
      categoryAttrGroupsMap[k] = v;
    }

    for (var i = 0; i < detaillist.length; i++) {
      var attrsMap = categoryAttrsMap[detaillist[i].categoryId];
      if (!attrsMap) {
        attrsMap = {};
        categoryAttrsMap[detaillist[i].categoryId] = attrsMap;
      }

      // var key = detaillist[i].categoryId + '_' + detaillist[i].columnName
      var value = detaillist[i];
      // categoryAttrsMap[key] = value
      attrsMap[detaillist[i].columnName] = value;
    }
    for (var _k = 0; _k < tags.length; _k++) {
      var tkey = tags[_k].tagId;
      var tvalue = tags[_k];
      tagsMap[tkey] = tvalue;
    }
    for (var _k2 = 0; _k2 < tags.length; _k2++) {
      var tidkey = tags[_k2].tagId;
      var tidvalue = tags[_k2].tagLabel;
      tagIdsMap[tidkey] = tidvalue;
    }
    for (var _k3 = 0; _k3 < tags.length; _k3++) {
      var tnamekey = tags[_k3].tagLabel;
      var tnamevalue = tags[_k3].tagId;
      tagNamesMap[tnamekey] = tnamevalue;
    }
    for (var _i = 0; _i < categories.length; _i++) {
      var cate = categories[_i].categoryId;
      var cateValue = categories[_i];
      categoriesMap[cate] = cateValue;
    }

    merchandiseMeta.categoryAttrsMap = categoryAttrsMap;
    merchandiseMeta.dictionariesMap = dictionariesMap;
    merchandiseMeta.categoryAttrGroupsMap = categoryAttrGroupsMap;
    merchandiseMeta.tagsMap = tagsMap;
    merchandiseMeta.tagIdsMap = tagIdsMap;
    merchandiseMeta.tagNamesMap = tagNamesMap;
    merchandiseMeta.keywordMeanings = merchandiseMeta.keywordMeanings;
    merchandiseMeta.categoriesMap = categoriesMap;
    setLocalStorage('EmktAllKeywords', {}); // 同时要清空keyWords
    if (!window.localStorage) {
      // window.localStorage.clear()
    }
    if (isDebug) {
      window.alert('merchandiseMeta=' + merchandiseMeta);
    }
    setEmktMetaData(merchandiseMeta);
  }
}

function showDownloadOrderTextBtn(orderDetail) {
  if (!orderDetail) return false;
  var statusText = getOrderStatusText(orderDetail);
  var orderSourceQualified = orderDetail.orderSource !== ORDER_SOURCE.OFFLINE;
  var orderStatusQualified = statusText === '已完成' || statusText === '执行中';
  return orderSourceQualified && orderStatusQualified;
}

function showProgressBtn(orderDetail) {
  if (!orderDetail) return false;
  var statusText = getOrderStatusText(orderDetail);
  var orderStatusQualified = statusText === '已完成' || statusText === '执行中';
  return orderStatusQualified;
}

function isGVAPContract(orderDetail) {
  if (!orderDetail) return false;
  var orderItem = orderDetail.itemList && orderDetail.itemList[0];
  return orderItem && orderItem.contractNo && orderItem.contractNo.indexOf('GVAP') > -1;
}

/**
 * 复制: 拼装订单详细信息文本
 * @param orderDetail
 */
function assembleOrderDetailText(orderDetail, itemListLength, balanceTypeName, payTypeName, deliverMethod) {
  if (!orderDetail) return '';
  var productsDetail = orderDetail.itemList && orderDetail.itemList.map(function (item) {
    var getItemLabel = function getItemLabel(item) {
      return (item.TLNo || '') + ' ' + (item.tag1PUBID || '') + ' ' + (item.eu_RID || '') + ' ' + (item.tax || '') + ' ' + (item.symbol || '');
    };
    return item.name + ' ' + (item.orderType === 1 ? 'X' + item.quantity : '') + '  ' + formatPrice(item.price) + '\n' + ('' + (item.contractNo ? item.contractNo + '\n' : '')) + ('' + (getItemLabel(item) ? getItemLabel(item) + '\n' : ''));
  }).join('\n');
  return '\u8BA2\u5355\u7F16\u53F7\uFF1A' + orderDetail.orderNo + ' \n\n' + (productsDetail + ' \n') + ('\u5546\u54C1\u603B\u989D\uFF1A\xA5' + formatPrice(orderDetail.initPrice) + ' \n') + ('\u4F18\u60E0\u6298\u6263\uFF1A-\xA5' + formatPrice(orderDetail.discountPrice) + ' \n') + ('\u8FD0\u8D39\uFF1A\xA5' + formatPrice(orderDetail.expressPrice) + ' \n') + ('\u5171' + itemListLength + '\u4EF6\u5546\u54C1   \u5408\u8BA1: \xA5' + formatPrice(orderDetail.price) + ' \n\n') + ('\u7ED3\u7B97\u65B9\u5F0F: ' + balanceTypeName + ' \n') + ('\u652F\u4ED8\u65B9\u5F0F\uFF1A' + payTypeName + ' \n') + ('' + (orderDetail.sfQuoteNo ? '报价编号：' + orderDetail.sfQuoteNo + '\n' : '')) + ('\u914D\u9001\u65B9\u5F0F\uFF1A' + deliverMethod + ' \n') + ('\u4E0B\u5355\u65F6\u95F4\uFF1A' + orderDetail.orderTime + ' \n');
}

function convertProduct(data) {
  data.attributes = data.smartProductParameterSelection;
  var _attributesList = [];
  var _titleList = [];
  var _subTitleList = [];
  var _abstractList = [];
  data.smartAttributes.forEach(function (par) {
    var options = {};
    if (par.metaType === 1) {
      var p = data.productParameters.find(function (item) {
        return item.parameterGuid === par.parameterGuid;
      });
      if (p) {
        console.log(p);
        p.displayOptions && p.displayOptions.forEach(function (sys) {
          options[sys.dictKey] = sys.dictValue;
        });
      }
    }
    var attr = {
      label: par.keyLabel,
      value: par.value,
      sdType: par.dataType,
      groupId: 2,
      sortOrder: 1,
      keyFeature: 1,
      displayable: par.displayable,
      columnName: par.key,
      sectionId: 0,
      options: options
    };
    if (par.key.indexOf('GeneInfo') !== -1 && par.displayable === 1 && par.value) {
      _subTitleList.push({
        valueText: par.valueLabel
      });
    }
    if (par.key === 'TVInfo' && par.value) {
      _abstractList.push({
        valueText: par.valueLabel
      });
    }
    _attributesList.push(attr);
  });
  data._attributesList = _attributesList;
  data._subTitleList = _subTitleList;
  data._abstractList = _abstractList;
  var name = {};
  name.valueText = data.name;
  _titleList.push(name);
  data._titleList = _titleList;
  data.discountPrice = 0;
  data.productName = data.erpProductName;
  data.productGuid = data.erpProductGuid;
  data.workdays = data.workdays;
  data.price = data.price;
  data.expressPrice = 0;
  data.productQuantity = 1;
  data.merchandiseId = data.guid;
  data.muGuid = data.guid;
  data.SKUID = data.guid;
  return data;
}

var PRODUCT_TYPE_TAG_MAP = (_PRODUCT_TYPE_TAG_MAP = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PRODUCT_TYPE_TAG_MAP, PRODUCT_TYPE_ID.instantStock, {
  tagName: '现货',
  tagTheme: 'primary'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PRODUCT_TYPE_TAG_MAP, PRODUCT_TYPE_ID.produceStock, {
  tagName: '现货',
  tagTheme: 'primary'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PRODUCT_TYPE_TAG_MAP, PRODUCT_TYPE_ID.customMade, {
  tagName: '定制',
  tagTheme: 'danger'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PRODUCT_TYPE_TAG_MAP, PRODUCT_TYPE_ID.reagent, {
  tagName: '现货',
  tagTheme: 'primary'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PRODUCT_TYPE_TAG_MAP, PRODUCT_TYPE_ID.amplification, {
  tagName: '扩增',
  tagTheme: 'warning'
}), _PRODUCT_TYPE_TAG_MAP);
var PRODUCT_FILTER_RECORD_KEY_GENE = 'GeneInfo';
var PRODUCT_FILTER_RECORD_KEY_VECTOR = 'TVInfo';

// 基因、载体、转录本，展示信息定义
var GENE_DISPLAY_ATTRIBUTES = ['symbol', 'taxId'];
var TRANSCRIPT_DISPLAY_ATTRIBUTES = ['NMID', 'subtype'];
var VECTOR_DISPLAY_ATTRIBUTES = ['elementSeq', 'tlNo', 'promoterID', 'tag1ID', 'tag2ID', 'eu_RID'];
/**
 *
 * @param emktRoute 拼装跳转rtmes- h5页面的url
 * @returns
 */
function assembleSmartLink(samrtRoute) {
  var targetLocation = '' + MERCHANDISE_IMG_BASE_URL_RTMES + window.location.search + '#/' + samrtRoute;
  console.log('assembleSmartLink', targetLocation);
  return targetLocation;
}
function goCart(router) {
  if (getUrlParamHref('fromSmart') === '1') {
    window.location.href = assembleSmartLink('cart');
  } else {
    router.replace({ name: 'cart' });
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  assembleOrderDetailText: assembleOrderDetailText,
  goCart: goCart,
  isGVAPContract: isGVAPContract,
  showProgressBtn: showProgressBtn,
  showDownloadOrderTextBtn: showDownloadOrderTextBtn,
  filterOrderListBySearchMap: filterOrderListBySearchMap,
  dealMetaData: dealMetaData,
  setOrderMerchandiseWithMeta: setOrderMerchandiseWithMeta,
  getStatusStyle: getStatusStyle,
  getOrderStatusText: getOrderStatusText,
  SDTString: SDTString,
  SDTInteger: SDTInteger,
  SDTEnumeration: SDTEnumeration,
  SDTDate: SDTDate,
  SDTDateTime: SDTDateTime,
  SDTGene: SDTGene,
  SDTDecimal: SDTDecimal,
  SDTToolVector: SDTToolVector,
  Rat: Rat,
  Mouse: Mouse,
  Human: Human,
  others: others,
  Gallusgallus: Gallusgallus,
  thalecress: thalecress,
  rice: rice,
  zebrafish: zebrafish,
  fruitfly: fruitfly,
  pig: pig,
  sheep: sheep,
  rabbit: rabbit,
  domesticsilkworm: domesticsilkworm,
  Africanclawedfrog: Africanclawedfrog,
  yeast: yeast,
  taxTypeId: taxTypeId,
  CONST_MESSAGE_STATUS_NONE: CONST_MESSAGE_STATUS_NONE,
  CONST_MESSAGE_STATUS_NEW_MESSAGE: CONST_MESSAGE_STATUS_NEW_MESSAGE,
  CONST_MESSAGE_STATUS_NEW_RESPONSE: CONST_MESSAGE_STATUS_NEW_RESPONSE,
  CONST_MESSAGE_STATUS_RESPONSE_READ: CONST_MESSAGE_STATUS_RESPONSE_READ,

  CONST_MESSAGE_TYPE_CUSTOMER_REQUEST: CONST_MESSAGE_TYPE_CUSTOMER_REQUEST,
  CONST_MESSAGE_TYPE_CUSTOMER_SERVICE_RESPONSE: CONST_MESSAGE_TYPE_CUSTOMER_SERVICE_RESPONSE,

  throttle: throttle,
  setStoreItem: setStoreItem,
  getStoreItem: getStoreItem,
  removeStoreItem: removeStoreItem,
  setLocalStorage: setLocalStorage,
  getLocalStorage: getLocalStorage,
  getEmktMetaVersion: getEmktMetaVersion,
  getEmktMetaData: getEmktMetaData,
  setEmktMetaData: setEmktMetaData,
  merchandiseWithMeta: merchandiseWithMeta,
  getUrlParam: getUrlParam,
  getFullUrlParam: getFullUrlParam,
  getUrlFullParamValue: getUrlFullParamValue,
  publicUrl: publicUrl,
  wxShareUrl: wxShareUrl,
  // wxShare,
  isDebug: isDebug,
  isDesktop: isDesktop,
  isWapp: isWapp,
  isWappGuest: isWappGuest,
  isSecPromotion: isSecPromotion,
  isResearchGroup: isResearchGroup,
  getUrlParamHref: getUrlParamHref,
  isNullOrBlankObject: isNullOrBlankObject,
  formatPrice: formatPrice,
  buyCartIsLocalStorage: buyCartIsLocalStorage,
  setBuyCart: setBuyCart,
  customerBehaviours: customerBehaviours,
  QUERY_ORDER_TYPE: QUERY_ORDER_TYPE,
  initCustomerBehaviour: initCustomerBehaviour,
  getMerchandiseLabelPath: getMerchandiseLabelPath,
  getOrderMerchandiseLabel: getOrderMerchandiseLabel,
  getMerchandiseLabelImg: getMerchandiseLabelImg,
  behaviour: behaviour,
  customerBehaviourType: customerBehaviourType,
  researchServiceCategory: researchServiceCategory,
  lotteryStartDT: lotteryStartDT,
  lotteryEndDT: lotteryEndDT,
  christmasPreSalePeriod: christmasPreSalePeriod,
  researchGroupDictionary: researchGroupDictionary,
  researchGroupMemberDictionary: researchGroupMemberDictionary,
  researchGroupDetailDisplayOrder: researchGroupDetailDisplayOrder,
  researchGroupApproveTypeDictionary: researchGroupApproveTypeDictionary,
  researchGroupStatusDictionary: researchGroupStatusDictionary,
  testCustomerNo: testCustomerNo,
  testEnterpriseNo: testEnterpriseNo,
  promotions618: promotions618,
  COUPON_TYPE_DISCOUNT: COUPON_TYPE_DISCOUNT,
  COUPON_TYPE_NEW_DISCOUNT: COUPON_TYPE_NEW_DISCOUNT,
  COUPON_TYPE_SPECIAL_FUND: COUPON_TYPE_SPECIAL_FUND,
  COUPON_TYPE: COUPON_TYPE,
  CONSTANT_APPROVETYPE_THRESHOLD: CONSTANT_APPROVETYPE_THRESHOLD,
  CONSTANT_APPROVETYPE_ALL: CONSTANT_APPROVETYPE_ALL,
  CONSTANT_APPROVETYPE_NONE: CONSTANT_APPROVETYPE_NONE,
  RESEARCH_GROUP_APPROVE_RESULT_NEED_NOT_APPROVE: RESEARCH_GROUP_APPROVE_RESULT_NEED_NOT_APPROVE,
  RESEARCH_GROUP_APPROVE_RESULT_NOT_OPERATED: RESEARCH_GROUP_APPROVE_RESULT_NOT_OPERATED,
  RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE: RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE,
  RESEARCH_GROUP_APPROVE_RESULT_APPROVED: RESEARCH_GROUP_APPROVE_RESULT_APPROVED,
  RESEARCH_GROUP_APPROVE_RESULT_NOT_APPROVED: RESEARCH_GROUP_APPROVE_RESULT_NOT_APPROVED,
  ORDER_STATUS_DRAFT: ORDER_STATUS_DRAFT,
  ORDER_STATUS_SUBMITTED: ORDER_STATUS_SUBMITTED,
  ORDER_STATUS_PAIED: ORDER_STATUS_PAIED,
  ORDER_STATUS_FINISHED: ORDER_STATUS_FINISHED,
  ORDER_STATUS_CONTRACT: ORDER_STATUS_CONTRACT,
  ORDER_STATUS_ABORT: ORDER_STATUS_ABORT,
  ORDER_STATUS_CHECK: ORDER_STATUS_CHECK,
  ORDER_STATUS_CHECK_BAD: ORDER_STATUS_CHECK_BAD,
  ORDER_STATUS_SIGN_NEED: ORDER_STATUS_SIGN_NEED,
  ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE: ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE,
  ORDER_STATUS_WAIT_PD_TECH_AUDIT: ORDER_STATUS_WAIT_PD_TECH_AUDIT,
  ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL: ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL,
  BALANCE_TYPE_RESEARCH_GROUP: BALANCE_TYPE_RESEARCH_GROUP,
  BALANCE_TYPE_CUSTOMER: BALANCE_TYPE_CUSTOMER,
  PAY_TYPE_REMAIN_MONEY: PAY_TYPE_REMAIN_MONEY,
  PAY_TYPE_FAPIAO: PAY_TYPE_FAPIAO,
  RESEARCH_GROUP_STATUS_DISABLE: RESEARCH_GROUP_STATUS_DISABLE,
  RESEARCH_GROUP_STATUS_NORMAL: RESEARCH_GROUP_STATUS_NORMAL,
  RESEARCH_GROUP_STATUS_LOCKED: RESEARCH_GROUP_STATUS_LOCKED,
  RESEARCH_GROUP_STATUS_EXPIRED: RESEARCH_GROUP_STATUS_EXPIRED,
  PRODUCT_TYPE_TOOL: PRODUCT_TYPE_TOOL,
  CUSTOMIZE_IMAGE: CUSTOMIZE_IMAGE,
  MYORDER_TAB_WAITPAY: MYORDER_TAB_WAITPAY,
  MYORDER_TAB_EXECUTE: MYORDER_TAB_EXECUTE,
  MYORDER_TAB_FINISHED: MYORDER_TAB_FINISHED,
  MYORDER_TAB_CANCELLED: MYORDER_TAB_CANCELLED,
  isIphoneFullScreen: isIphoneFullScreen,
  leaveSpaceForFullScreen: leaveSpaceForFullScreen,
  benefitDiscount: benefitDiscount,
  CONSTANT_SET_MOUNTH_APPROVETYPE: CONSTANT_SET_MOUNTH_APPROVETYPE,
  CONSTANT_SET_SINGLESTORKE_APPROVETYPE: CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
  CONSTANT_ALL_APPROVETYPE: CONSTANT_ALL_APPROVETYPE,
  SETTLEMENT_ACCOUNT_STATUS_DISABLE: SETTLEMENT_ACCOUNT_STATUS_DISABLE,
  SETTLEMENT_ACCOUNT_STATUS_NORMAL: SETTLEMENT_ACCOUNT_STATUS_NORMAL,
  SETTLEMENT_ACCOUNT_STATUS_LOCKED: SETTLEMENT_ACCOUNT_STATUS_LOCKED,
  openCustomerService: openCustomerService,
  SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP: SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP,
  extraBloodType: extraBloodType,
  activityName: activityName,
  promotionGuid: promotionGuid,
  PRIZE_TYPE_OBJECT: PRIZE_TYPE_OBJECT,
  PRIZE_TYPE_COUPON: PRIZE_TYPE_COUPON,
  AuthenticationID: AuthenticationID,
  HardGeneLevelNo1: HardGeneLevelNo1,
  HardGeneLevelNo2: HardGeneLevelNo2,
  ENTERPRISE_TYPE_COMPANY: ENTERPRISE_TYPE_COMPANY,
  TOOLTYPE_LENTIVIRUS: TOOLTYPE_LENTIVIRUS,
  TOOLTYPE_PLASMID: TOOLTYPE_PLASMID,
  TOOLTYPE_ADENOVIRUS: TOOLTYPE_ADENOVIRUS,
  TOOLTYPE_RETROVIRUS: TOOLTYPE_RETROVIRUS,
  TOOLTYPE_FLOATVIRUS: TOOLTYPE_FLOATVIRUS,
  AAVBLOODTYPETWO: AAVBLOODTYPETWO,
  AAVBLOODTYPESIX: AAVBLOODTYPESIX,
  VIRUSTITER1E13: VIRUSTITER1E13,
  VIRUSTITER5E12: VIRUSTITER5E12,
  AMPLIFICATION: AMPLIFICATION,
  CUSTOMERPROVIDED: CUSTOMERPROVIDED,
  ORDER_SOURCE: ORDER_SOURCE,
  TOOLTYPE_ADENOVIRUSABOUT: TOOLTYPE_ADENOVIRUSABOUT,
  PRODUCT_TYPE_SERVICE_CONSTANT: PRODUCT_TYPE_SERVICE_CONSTANT,
  ADDRESS_STATUS: ADDRESS_STATUS,
  ADDRESS_SOURCE: ADDRESS_SOURCE,
  getFileSuffix: getFileSuffix,
  getOrderMaterialFileShowIcon: getOrderMaterialFileShowIcon,
  reassembleOrderMaterialInfo: reassembleOrderMaterialInfo,
  MATERIAL_TYPE: MATERIAL_TYPE,
  MATERIAL_FILETYPE: MATERIAL_FILETYPE,
  DELIVERY_ADDRESS: DELIVERY_ADDRESS,
  SAMPLE_DISPLAY_TYPE: SAMPLE_DISPLAY_TYPE,
  SAMPLE_DELIVERY_FORM_TYPE: SAMPLE_DELIVERY_FORM_TYPE,
  MATERIAL_STATIC_FILE_BASE_URL: MATERIAL_STATIC_FILE_BASE_URL,
  MERCHANDISE_IMG_BASE_URL: MERCHANDISE_IMG_BASE_URL,
  WAPP_LOGIN_TYPE_DICTIONARY: WAPP_LOGIN_TYPE_DICTIONARY,
  WAPP_LOGIN_TYPE_CODE: WAPP_LOGIN_TYPE_CODE,
  WAPP_LOGIN_TYPE_WX: WAPP_LOGIN_TYPE_WX,
  ORDER_TYPE_SERVICE: ORDER_TYPE_SERVICE,
  ADBERRATION_EXCHANGE: ADBERRATION_EXCHANGE,
  ADBERRATION_RETROACTION: ADBERRATION_RETROACTION,
  ADBERRATION_MESSAGE: ADBERRATION_MESSAGE,
  ADBERRATION_REPORT: ADBERRATION_REPORT,
  EXPERIMENT_MODULES_STATUS_NAME_NOT_START: EXPERIMENT_MODULES_STATUS_NAME_NOT_START,
  EXPERIMENT_MODULES_STATUS_NAME__ON_GOING: EXPERIMENT_MODULES_STATUS_NAME__ON_GOING,
  EXPERIMENT_MODULES_STATUS_NAME__ENDING: EXPERIMENT_MODULES_STATUS_NAME__ENDING,
  EXPERIMENT_MODULES_STATUS_NAME__END_STOP: EXPERIMENT_MODULES_STATUS_NAME__END_STOP,
  EXPERIMENT_MODULES_STATUS_CANNOT_START: EXPERIMENT_MODULES_STATUS_CANNOT_START,
  EXPERIMENT_MODULES_STATUS_NOT_START: EXPERIMENT_MODULES_STATUS_NOT_START,
  EXPERIMENT_MODULES_STATUS_ON_GOING: EXPERIMENT_MODULES_STATUS_ON_GOING,
  EXPERIMENT_MODULES_STATUS_ENDING: EXPERIMENT_MODULES_STATUS_ENDING,
  EXPERIMENT_MODULES_STATUS_END_STOP: EXPERIMENT_MODULES_STATUS_END_STOP,
  EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION: EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION,
  EXPERIMENT_MODULES_STATUS_READY_START: EXPERIMENT_MODULES_STATUS_READY_START,
  EXPERIMENT_MODULES_STATUS_STOP: EXPERIMENT_MODULES_STATUS_STOP,
  ADBERRATION_STATUS: ADBERRATION_STATUS,
  COUPON_ACTIVITY_TYPE_COUPON: COUPON_ACTIVITY_TYPE_COUPON,
  COUPON_ACTIVITY_TYPE_GROUP_BUY: COUPON_ACTIVITY_TYPE_GROUP_BUY,
  COUPON_ACTIVITY_TYPE_ANNIVERSARY: COUPON_ACTIVITY_TYPE_ANNIVERSARY,
  FindSourceCrm: FindSourceCrm,
  RESEARCH_MEMBER_OP: RESEARCH_MEMBER_OP,
  FormatterTime: FormatterTime,
  TV_NO_PATH: TV_NO_PATH,
  convertProduct: convertProduct,
  ICON_TAG_IMAGE_MAP: ICON_TAG_IMAGE_MAP,
  PRODUCT_TYPE_ID: PRODUCT_TYPE_ID,
  PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION: PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION,
  PRODUCT_CATEGORY_ICON_TAG_STOCK: PRODUCT_CATEGORY_ICON_TAG_STOCK,
  PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE: PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE,
  MERCHANDISE_IMG_BASE_URL_RTMES: MERCHANDISE_IMG_BASE_URL_RTMES,
  MERCHANDISE_IMG_BASE_URL_SMART: MERCHANDISE_IMG_BASE_URL_SMART,
  PRODUCT_TYPE_TAG_MAP: PRODUCT_TYPE_TAG_MAP,
  PRODUCT_FILTER_RECORD_KEY_GENE: PRODUCT_FILTER_RECORD_KEY_GENE,
  GENE_DISPLAY_ATTRIBUTES: GENE_DISPLAY_ATTRIBUTES,
  TRANSCRIPT_DISPLAY_ATTRIBUTES: TRANSCRIPT_DISPLAY_ATTRIBUTES,
  VECTOR_DISPLAY_ATTRIBUTES: VECTOR_DISPLAY_ATTRIBUTES,
  PRODUCT_FILTER_RECORD_KEY_VECTOR: PRODUCT_FILTER_RECORD_KEY_VECTOR,
  MYORDER_TAB_WAITAUDIT: MYORDER_TAB_WAITAUDIT
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c69b057c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-688d70f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1569),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23954744",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5be295a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f653ceb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeSureAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSolutionInfoByOrderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSolutionInfoByCartItemId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSolutionInfoByCartItemData; });
/* unused harmony export boSolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return specialEuTemplateNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return paraffinEuTemplateNo; });
/* unused harmony export getMeteDataSelfIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return filterMeteData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deDuplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return boSignalAnalysisTemplateNo; });
/* unused harmony export getCategorySuperId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(240);






/* eslint-disable */



var makeSureAsync = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(it, methods, param) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return it[methods].apply(it, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(param));

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function makeSureAsync(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 处理BoSolution为用户数据，在只拥有订单编号的情况下，这意味着数据已经是非常标准的solution的数据结构了
 * @param orderId 订单ID
 * @param euId 指定EU的Id
 * @return {userData}
 */
var getSolutionInfoByOrderId = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(orderId, euId) {
        var userData, sku, skus, solutionAll, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据');
                        console.log(orderId, euId);
                        userData = {};
                        sku = {};
                        skus = [];
                        solutionAll = null;
                        _context2.next = 8;
                        return gcapi('getWaitPayOrderInfoByOrderId', orderId).then(function (res) {
                            solutionAll = JSON.parse(res.body.result.solutionJson);
                        });

                    case 8:
                        userData = boSolution(solutionAll, euId);
                        _context2.next = 11;
                        return gcapi('getProteomicsBasicData', '').then(function (res) {
                            if (res.body.result) {
                                userData.euTemplates = JSON.parse(res.data.result.euTemplates);
                                userData.puTemplates = JSON.parse(res.data.result.puTemplates);
                                userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates);
                                skus = res.body.result.proteomicsSku.sort(function (a, b) {
                                    return a.sortOrder - b.sortOrder;
                                });
                                sku = skus.filter(function (v) {
                                    return v.id === userData.currSkuId;
                                })[0];
                                if (!sku || sku.length <= 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sku) === '{}') {
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading().hide();
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.dialog({
                                        title: '无法查看/购买!',
                                        content: '该商品无法查看/购买，请重新选购',
                                        buttons: [{
                                            label: '返回上一页',
                                            type: 'primary',
                                            onClick: function onClick() {
                                                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].back();
                                            }
                                        }]
                                    });
                                    // weui.alert("该商品已下架，不再支持购买")
                                }
                                console.log('userData', userData);
                                userData.currSku = sku;
                                console.log(sku, 'shjhsa', userData.currSku);
                                userData.singleMeteData = filterMeteData(sku, ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'], [71003, 71004, 71005, 71006, 71008]);
                                userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0];
                                userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007);
                                userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008);
                                userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004);
                                userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005);
                                userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006);
                                console.log(skus, 'sku');
                            } else {
                                $.toast('请求sku失败，请刷新页面或联系客服');
                            }
                            console.log(res.body.result.proteomicsSku, 'sku');
                        });

                    case 11:
                        // 获取当前EU的sku【0】参加的活动
                        data = skus.filter(function (v) {
                            return v.eu1 === userData.currEu;
                        })[0];

                        data = data.eu1_Pus.filter(function (v) {
                            return v.includes('SPEC') === false;
                        });
                        _context2.next = 15;
                        return gcapi('getServiceProductPromotions', data).then(function (res) {
                            if (res.data.code === 0) {
                                if (res.data.result.length > 0) {
                                    userData.promotion = res.data.result[0];
                                } else {
                                    userData.promotion = [];
                                }
                            }
                        });

                    case 15:
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据').hide();
                        return _context2.abrupt('return', userData);

                    case 17:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function getSolutionInfoByOrderId(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * 处理BoSolution为用户数据，在需要从购物车取数据的情况下
 * @param customerNo 客户信息
 * @param itemId 指定购物车里的某一服务类产品的Id
 * @return {userData}
 */
var getSolutionInfoByCartItemId = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(customerNo, itemId) {
        var userData, sku, skus, solutionAll, oldCartContent, cartData, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据');
                        console.log(itemId);
                        userData = {};
                        sku = {};
                        skus = [];
                        solutionAll = void 0;
                        oldCartContent = void 0;
                        cartData = void 0;
                        _context3.next = 10;
                        return gcapi('getNonSalesforceShoppingCart', customerNo).then(function (res) {
                            var cart = void 0;
                            // DB中无购物车记录或者记录为空{}
                            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
                                cart = '{}';
                            } else {
                                cart = res.body.result.cartContent;
                                oldCartContent = JSON.parse(cart);
                                cartData = JSON.parse(cart)[itemId];
                                solutionAll = cartData.allData.boSolution;
                                solutionAll.diseaseDirection = cartData.diseaseDirectionId;
                                solutionAll.diseaseName = cartData.diseaseDirectionName;
                                solutionAll.children[0].briefInfoDetail = cartData.userLabel;
                                solutionAll.children[0].skuId = cartData.allData.currSkuId;
                                console.log(solutionAll, '---------------------------------------------------------E><>>>>>>>>>>>>>>');
                            }
                        });

                    case 10:
                        userData = boSolution(solutionAll, solutionAll.children[0].id);
                        userData.deliveryTime = cartData.allData.deliveryTime;
                        _context3.next = 14;
                        return gcapi('getProteomicsBasicData', '').then(function (res) {
                            if (res.body.result) {
                                userData.euTemplates = JSON.parse(res.data.result.euTemplates);
                                userData.puTemplates = JSON.parse(res.data.result.puTemplates);
                                userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates);
                                skus = res.body.result.proteomicsSku.sort(function (a, b) {
                                    return a.sortOrder - b.sortOrder;
                                });
                                sku = skus.filter(function (v) {
                                    return v.id === userData.currSkuId;
                                })[0];
                                if (!sku || sku.length <= 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sku) === '{}') {
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading().hide();
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.dialog({
                                        title: '无法查看/购买!',
                                        content: '该商品无法查看/购买，请重新选购',
                                        buttons: [{
                                            label: '返回上一页',
                                            type: 'primary',
                                            onClick: function onClick() {
                                                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].back();
                                            }
                                        }]
                                    });
                                    // weui.alert("该商品已下架，不再支持购买")
                                }
                                userData.currSku = sku;
                                console.log(sku, 'shjhsa', userData.currSku);
                                userData.singleMeteData = filterMeteData(sku, ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'], [71003, 71004, 71005, 71006, 71008]);
                                userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0];
                                userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007);
                                userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008);
                                userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004);
                                userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005);
                                userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006);
                                console.log(skus, 'sku');
                            } else {
                                $.toast('请求sku失败，请刷新页面或联系客服');
                            }
                            console.log(res.body.result.proteomicsSku, 'sku');
                        });

                    case 14:
                        // 获取当前EU的sku【0】参加的活动
                        data = skus.filter(function (v) {
                            return v.eu1 === userData.currEu;
                        })[0];

                        data = data.eu1_Pus.filter(function (v) {
                            return v.includes('SPEC') === false;
                        });
                        _context3.next = 18;
                        return gcapi('getServiceProductPromotions', data).then(function (res) {
                            if (res.data.code === 0) {
                                if (res.data.result.length > 0) {
                                    userData.promotion = res.data.result[0];
                                } else {
                                    userData.promotion = [];
                                }
                            }
                        });

                    case 18:
                        userData.oldCartContent = oldCartContent;
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据').hide();
                        return _context3.abrupt('return', userData);

                    case 21:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function getSolutionInfoByCartItemId(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 处理BoSolution为用户数据，在已经拥有购物车中某一数据的情况下
 * @param cartData 在只拥有
 * @return {userData}
 */
var getSolutionInfoByCartItemData = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(cartData) {
        var userData, sku, skus, solutionAll, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据');
                        userData = {};
                        sku = {};
                        skus = [];
                        solutionAll = void 0;

                        solutionAll = cartData.allData.boSolution;
                        solutionAll.diseaseDirection = cartData.diseaseDirectionId;
                        solutionAll.diseaseName = cartData.diseaseDirectionName;
                        solutionAll.children[0].briefInfoDetail = cartData.userLabel;
                        solutionAll.children[0].skuId = cartData.allData.currSkuId;
                        userData = boSolution(solutionAll, solutionAll.children[0].id);
                        userData.deliveryTime = cartData.allData.deliveryTime;
                        _context4.next = 14;
                        return gcapi('getProteomicsBasicData', '').then(function (res) {
                            if (res.body.result) {
                                userData.euTemplates = JSON.parse(res.data.result.euTemplates);
                                userData.puTemplates = JSON.parse(res.data.result.puTemplates);
                                userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates);
                                skus = res.body.result.proteomicsSku.sort(function (a, b) {
                                    return a.sortOrder - b.sortOrder;
                                });
                                sku = skus.filter(function (v) {
                                    return v.id === userData.currSkuId;
                                })[0];
                                if (!sku || sku.length <= 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sku) === '{}') {
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading().hide();
                                    __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.dialog({
                                        title: '无法查看/购买!',
                                        content: '该商品无法查看/购买，请重新选购',
                                        buttons: [{
                                            label: '返回上一页',
                                            type: 'primary',
                                            onClick: function onClick() {
                                                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].back();
                                            }
                                        }]
                                    });
                                    // weui.alert("该商品已下架，不再支持购买")
                                }
                                userData.currSku = sku;
                                userData.singleMeteData = filterMeteData(sku, ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'], [71003, 71004, 71005, 71006, 71008]);
                                userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0];
                                userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007);
                                userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008);
                                userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004);
                                userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005);
                                userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006);
                                console.log(skus, 'sku');
                            } else {
                                $.toast('请求sku失败，请刷新页面或联系客服');
                            }
                            console.log(res.body.result.proteomicsSku, 'sku');
                        });

                    case 14:
                        // 获取当前EU的sku【0】参加的活动
                        data = skus.filter(function (v) {
                            return v.eu1 === userData.currEu;
                        })[0];

                        data = data.eu1_Pus.filter(function (v) {
                            return v.includes('SPEC') === false;
                        });
                        _context4.next = 18;
                        return gcapi('getServiceProductPromotions', data).then(function (res) {
                            if (res.data.code === 0) {
                                if (res.data.result.length > 0) {
                                    userData.promotion = res.data.result[0];
                                } else {
                                    userData.promotion = [];
                                }
                            }
                        });

                    case 18:
                        __WEBPACK_IMPORTED_MODULE_6_weui_js_dist_weui___default.a.loading('正在加载数据').hide();
                        return _context4.abrupt('return', userData);

                    case 20:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function getSolutionInfoByCartItemData(_x8) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * 处理BoSolution为用户数据
 * @param solutionAll 完整方案的（包含多个EU）
 * @param euId 指定EU的Id
 * @return {userData} 基础userData数据，所有其它数据必须在该基础上增加
 */
function boSolution(solutionAll, euId) {
    var userData = {};
    userData.returnMaterialChecked = deDuplicationArray(solutionAll.subLines, ['northId', 'southId']).indexOf(euId) !== -1;
    userData.diseaseDirection = {
        id: solutionAll.diseaseDirection,
        name: solutionAll.diseaseName
    };
    solutionAll.children.some(function (item) {
        if (item.id === euId) {
            userData.boSolution = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { children: [item] });
            userData.productInfo = { eu1: item.template.templateNo };
            userData.currEu = item.template.templateNo;
            userData.currSkuId = item.skuId;
            userData.tax = filterMeteData(undefined, [item.taxId], 61033)[0];
            userData.otherTaxName = item.otherTaxName;
            userData.groups = item.groups;
            userData.sampleType = item.briefInfoDetail.split('/')[1];
            userData.euTemplate = [item.template];
            if (item.parameterValues.length > 1) {
                userData.controlGroups = [];
                item.parameterValues.some(function (it) {
                    if (it.name === '数据比较分组' || it.name.includes('比较')) {
                        it.value.trim().split('\n').forEach(function (value) {
                            userData.controlGroups.push(value.split(' VS'));
                        });
                        return true;
                    }
                });
            } else {
                userData.controlGroups = [];
            }
            if (item.groups) {
                userData.geneSelectionGroup = [];
                item.groups[0].parameterValues.some(function (items) {
                    if (items.name === '基因' || items.values) {
                        items.values.forEach(function (gene) {
                            userData.geneSelectionGroup.push({
                                label: gene.outlineInfo,
                                geneGUID: gene.nativeId
                            });
                        });
                        return true;
                    }
                });
            }
            console.log(item, 'item');
            return true;
        }
    });
    return userData;
}
/**
 * @description 快捷获取PRM(046, 1)，shoutgun(048, 0)模板编号
 * @param index 拥有索引后会返回数组索引对应值
 * @return {boolean}
 */
var specialEuTemplateNo = function specialEuTemplateNo(index) {
    var arr = ['EU000048', 'EU000046'];
    if (index !== undefined && index !== null !== index !== '') {
        return arr[index];
    } else {
        return arr;
    }
};
/**
 * 石蜡样本EU编号
 * @return {string}
 */
var paraffinEuTemplateNo = function paraffinEuTemplateNo() {
    return 'EU000326';
};
var getMeteDataSelfIndex = function getMeteDataSelfIndex(meteDataDictKey, meteDataTypeId) {
    var dictionary = emkt.getEmktMetaData().dictionariesMap;
    var ins = void 0;
    var index = -1;
    for (var key in dictionary[meteDataTypeId]) {
        index += 1;
        if (meteDataDictKey === dictionary[meteDataTypeId][key].dictKey) {
            console.log(dictionary[meteDataTypeId][key]);
            ins = index;
        }
    }
    return ins;
};
/**
 * 过滤元数据
 * @param skus 如果有就是根据sku过滤元数据
 * @param conditional 过滤的条件是[]
 * @param meteDataTypeId 元数据的类型是 [] | Number
 * @param filterKey 过滤的关键字段是 ""
 * @return {{}|*[]|*}
 */
var filterMeteData = function filterMeteData(skus, conditional, meteDataTypeId, filterKey) {
    var dictionary = emkt.getEmktMetaData().dictionariesMap;
    // console.log(dictionary[71002])//产品分类
    // console.log(dictionary[71003])
    // console.log(dictionary[71004])
    // console.log(dictionary[71005])
    // console.log(dictionary[71006])
    var array = [];
    var singleMeteData = {};
    if (skus) {
        if (meteDataTypeId) {
            if (meteDataTypeId.length) {
                conditional.forEach(function (pro, index) {
                    for (var key in dictionary[meteDataTypeId[index]]) {
                        if (skus[pro] === dictionary[meteDataTypeId[index]][key].dictKey) {
                            singleMeteData[pro] = dictionary[meteDataTypeId[index]][key];
                        }
                    }
                });
                // console.log(singleMeteData, 'singleMeteData')
                return singleMeteData;
            }
        } else {
            var sku = skus.filter(function (v) {
                return v[filterKey] === conditional;
            });
            return sku;
        }
    } else {
        var _loop = function _loop(key) {
            conditional.forEach(function (item) {
                if (item === dictionary[meteDataTypeId][key].dictKey) {
                    array.push(dictionary[meteDataTypeId][key]);
                }
            });
        };

        for (var key in dictionary[meteDataTypeId]) {
            _loop(key);
        }
        // console.log(array, 'dictionary[meteDataTypeId]')
        return array;
    }
};
/**
 *
 * @param object 包含重复属性的对象
 * @param property 需要去重的属性
 * @return {*[]}
 */
var deDuplication = function deDuplication(object, property) {
    var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
    var array = [];
    for (var i = 0; i < object.length; i++) {
        set.add(object[i][property]);
    }
    set.forEach(function (item) {
        array.push(item);
    });
    console.log(array, '去重结果');
    return array;
};
/**
 *
 * @param array 包含重复属性的数组
 * @param property 需要去重的属性
 * @return {*[]}
 */
var deDuplicationArray = function deDuplicationArray(array, property) {
    var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
    var arr = [];
    property.forEach(function (pro) {
        array.forEach(function (item) {
            set.add(item[pro]);
        });
        set.forEach(function (item) {
            arr.push(item);
        });
    });
    return arr;
};
/**
 * 没啥特别的，但是不能改，如果生信分析的模板变了，这里也变一下
 * @return {string[]}
 */
var boSignalAnalysisTemplateNo = function boSignalAnalysisTemplateNo() {
    return ['PU000270', 'PU000908', 'PU000909'];
};

/**
 * @param {string} extraValue From SysDictionary Of Sample Category
 * @return Integer parentId
 */
var getCategorySuperId = function getCategorySuperId(extraValue) {
    return extraValue ? JSON.parse(extraValue).parentId : null;
};

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4074e541",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOrdersByCustomerOrResearchNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOrderProductInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return assembleOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOrderInvoiceInfos; });
/* unused harmony export getMerchandiseMeta */
/* unused harmony export downloadOrderTextFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getToolProgressInfoByContractNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceProgressInfoByOrderNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getExpressTrack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return downloadExpressOutFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCustomerGoodsByContractNos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOrderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getVectorMapFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(402);



var _this = this;



var getOrdersByCustomerOrResearchNo = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var type = _ref2.type,
        no = _ref2.no,
        afterSales = _ref2.afterSales;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getCustomerOrders', { params: { type: type, no: no, afterSales: String(afterSales) === '1' } }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getOrdersByCustomerOrResearchNo(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getOrderDetail = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(orderNo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getOrderDetail', { orderNo: orderNo }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getOrderDetail(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// 查询订单产品详情
var getOrderProductInfos = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getOrderProductInfos', { params: params }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getOrderProductInfos(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

// 组装订单信息（用于未生成合同订单）
var assembleOrders = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(orderId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/assembleOrders', { orderId: orderId }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function assembleOrders(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

// 查询订单开票信息
var getOrderInvoiceInfos = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(orderNo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getOrderInvoiceInfos', { orderNo: orderNo }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function getOrderInvoiceInfos(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

// 获取元数据信息
var getMerchandiseMeta = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getMerchandiseMeta', null, false));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function getMerchandiseMeta() {
    return _ref7.apply(this, arguments);
  };
}();

// 下载订单的合同文本
var downloadOrderTextFile = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(orderId, orderNo, orderSource) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            window.open('hub-api/downloadOrderText?orderNo=' + orderNo + '&orderId=' + orderId + '&orderSource=' + orderSource);

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function downloadOrderTextFile(_x6, _x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();

// 查询合同进展（工具类）
var getToolProgressInfoByContractNo = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(contractNo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getProgressInfoByContractNo', { contractNo: contractNo }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function getToolProgressInfoByContractNo(_x9) {
    return _ref9.apply(this, arguments);
  };
}();

// 查询进展（服务类）
var getServiceProgressInfoByOrderNo = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(orderNo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getProgressInfoByOrderNo', { orderNo: orderNo }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function getServiceProgressInfoByOrderNo(_x10) {
    return _ref10.apply(this, arguments);
  };
}();

// 获取物流信息
var getExpressTrack = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(contractNos) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getExpressTrack', { contractNos: contractNos }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function getExpressTrack(_x11) {
    return _ref11.apply(this, arguments);
  };
}();

// 下载出货单
var downloadExpressOutFile = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(contractNo) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            window.open('hub-api/GetExpressOutSheet?contractNo=' + contractNo);

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function downloadExpressOutFile(_x12) {
    return _ref12.apply(this, arguments);
  };
}();

// 获取订单实物信息
var getCustomerGoodsByContractNos = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(contractNos) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getCustomerGoodsByContractNos', { contractNos: contractNos }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function getCustomerGoodsByContractNos(_x13) {
    return _ref13.apply(this, arguments);
  };
}();
var getOrderItem = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getOrderItem?id=' + id));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this);
  }));

  return function getOrderItem(_x14) {
    return _ref14.apply(this, arguments);
  };
}();
var getVectorMapFile = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* postRequest */])('/hub-api/getVectorMapFile?id=' + id));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this);
  }));

  return function getVectorMapFile(_x15) {
    return _ref15.apply(this, arguments);
  };
}();

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7760fd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ade18fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1054)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7733f0e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae058e54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10bd0dc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-430bfe6b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd4c7510",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03f4f560",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Welcome__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ToWapp__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ToWapp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ToWapp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Home__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Category_Category__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Category_Category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Category_Category__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_search_SearchDetails__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_search_SearchDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_search_SearchDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Cart_Cart__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Cart_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Cart_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_User_Me__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_User_Me___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_User_Me__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_User_MyLogin_Login__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_User_MyLogin_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_User_MyLogin_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Detail_Merchandises__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Detail_Merchandises___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Detail_Merchandises__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_User_MyOrders_Orders__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_User_MyOrders_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_User_MyOrders_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_User_MyInfo_Userinfo__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_User_MyInfo_Userinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_User_MyInfo_Userinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_User_MyAddress_Address__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_User_MyAddress_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_User_MyAddress_Address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_User_MyAddress_AddressModify__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_User_MyAddress_AddressModify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_User_MyAddress_AddressModify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_User_MyLogin_ChangeLoginID__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_User_MyLogin_ChangeLoginID___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_User_MyLogin_ChangeLoginID__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_User_MyLogin_Register__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_User_MyLogin_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_User_MyLogin_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_User_MyLogin_PasswordChange__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_User_MyLogin_PasswordChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_User_MyLogin_PasswordChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_User_MyLogin_MobileLogin__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_User_MyLogin_MobileLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_User_MyLogin_MobileLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Category_CategoryDetail__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Category_CategoryDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_Category_CategoryDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_User_MyCredit_ApplyCreditPay__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_User_MyCredit_ApplyCreditPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_User_MyCredit_ApplyCreditPay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_User_MyInvoice_InvoiceAddress__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_User_MyInvoice_InvoiceAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_User_MyInvoice_InvoiceAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_User_MyInvoice_AddInvoiceAddress__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_User_MyInvoice_AddInvoiceAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_User_MyInvoice_AddInvoiceAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_User_MyInvoice_InvoiceAddressModify__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_User_MyInvoice_InvoiceAddressModify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_User_MyInvoice_InvoiceAddressModify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Order_OrderContentConfirm__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Order_OrderContentConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_Order_OrderContentConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Order_OrderContent__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Order_OrderContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_Order_OrderContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Order_Detail_OrderPayTypeConfirm__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Order_Detail_OrderPayTypeConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_Order_Detail_OrderPayTypeConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Order_Detail_OrderContentDetail__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Order_Detail_OrderContentDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_Order_Detail_OrderContentDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Order_Detail_AddressDetail__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Order_Detail_AddressDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_Order_Detail_AddressDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Order_Detail_OrderConfirmDetail__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Order_Detail_OrderConfirmDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_Order_Detail_OrderConfirmDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Order_Detail_PayDetail__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Order_Detail_PayDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_Order_Detail_PayDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Order_Detail_InvoiceDetail__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Order_Detail_InvoiceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_Order_Detail_InvoiceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Promotion_Promotions__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Promotion_Promotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_Promotion_Promotions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Order_Detail_successPay__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Order_Detail_successPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_Order_Detail_successPay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_User_MyAddress_AddAddress__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_User_MyAddress_AddAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_User_MyAddress_AddAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_User_MyLogin_Activation__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_User_MyLogin_Activation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__views_User_MyLogin_Activation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_User_MyInvoice_InvoiceTitle__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_User_MyInvoice_InvoiceTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__views_User_MyInvoice_InvoiceTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_User_MyCoupons_MyCoupons__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_User_MyCoupons_MyCoupons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__views_User_MyCoupons_MyCoupons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_User_MyInvoice_AddInvoiceTitle__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_User_MyInvoice_AddInvoiceTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__views_User_MyInvoice_AddInvoiceTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_MyOrder_order_AllOrder__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_MyOrder_order_AllOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__views_MyOrder_order_AllOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_User_MyLogin_ForgetPassword__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_User_MyLogin_ForgetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__views_User_MyLogin_ForgetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_MyOrder_order_detail_OrderDetail__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_MyOrder_order_detail_OrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__views_MyOrder_order_detail_OrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_MyOrder_comment_EvaluationOrder__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_MyOrder_comment_EvaluationOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__views_MyOrder_comment_EvaluationOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_DataMeta_DataMeta__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_DataMeta_DataMeta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__views_DataMeta_DataMeta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_Cust_CustOrder__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_Cust_CustOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__views_Cust_CustOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_Cust_DiyGoods__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_Cust_DiyGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__views_Cust_DiyGoods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_Order_Detail_MyDiscount__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_Order_Detail_MyDiscount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__views_Order_Detail_MyDiscount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_MyOrder_comment_detail_CommentForOrder__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_MyOrder_comment_detail_CommentForOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__views_MyOrder_comment_detail_CommentForOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_MyOrder_comment_detail_GetComments__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_MyOrder_comment_detail_GetComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__views_MyOrder_comment_detail_GetComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_Order_InvoiceAddress__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_Order_InvoiceAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__views_Order_InvoiceAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_Message_Message__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_Message_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__views_Message_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_Message_Contact__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_Message_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__views_Message_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_User_MyAgreement_MyAgreement__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_User_MyAgreement_MyAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__views_User_MyAgreement_MyAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_User_MyRecommend_MyRecommend__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_User_MyRecommend_MyRecommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__views_User_MyRecommend_MyRecommend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_User_MyRecommend_publicNumber__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_User_MyRecommend_publicNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__views_User_MyRecommend_publicNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_Order_Detail_MyOrderCoupons__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_Order_Detail_MyOrderCoupons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__views_Order_Detail_MyOrderCoupons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_Promotion_Compositions__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_Promotion_Compositions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__views_Promotion_Compositions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_Cust_Detail_CustDetail__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_Cust_Detail_CustDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__views_Cust_Detail_CustDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_Cust_Detail_CustPriceDetail__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_Cust_Detail_CustPriceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__views_Cust_Detail_CustPriceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_Message_MessageManagement__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_Message_MessageManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__views_Message_MessageManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_Channels_Channel__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_Channels_Channel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__views_Channels_Channel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_Channels_ChannelDetails__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_Channels_ChannelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__views_Channels_ChannelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_User_MyLogin_PointsDetails__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_User_MyLogin_PointsDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__views_User_MyLogin_PointsDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_finder_Finder__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_finder_Finder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__views_finder_Finder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_finder_detail_finderMerchandiseDeail__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_finder_detail_finderMerchandiseDeail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__views_finder_detail_finderMerchandiseDeail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_finder_detail_contactUs__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_finder_detail_contactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__views_finder_detail_contactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_finder_detail_finderOrderDeail__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_finder_detail_finderOrderDeail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__views_finder_detail_finderOrderDeail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_User_MyVipPlan_VipPlanDetails__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_User_MyVipPlan_VipPlanDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__views_User_MyVipPlan_VipPlanDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_User_MyVipPlan_VipPlanMemberDetails__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_User_MyVipPlan_VipPlanMemberDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__views_User_MyVipPlan_VipPlanMemberDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_User_MyVipPlan_memberDetails__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_User_MyVipPlan_memberDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__views_User_MyVipPlan_memberDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_User_MyLogin_PhoneNumberLogin__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_User_MyLogin_PhoneNumberLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__views_User_MyLogin_PhoneNumberLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_User_MyAccountChecked_AllBill_vue__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_User_MyAccountChecked_AllBill_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__views_User_MyAccountChecked_AllBill_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_User_MyAccountChecked_ChooseBillType_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_User_MyAccountChecked_ChooseBillType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__views_User_MyAccountChecked_ChooseBillType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_User_MyAccountChecked_AccountChecked_vue__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_User_MyAccountChecked_AccountChecked_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__views_User_MyAccountChecked_AccountChecked_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_User_MyAccountChecked_OldAccountChecked_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_User_MyAccountChecked_OldAccountChecked_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__views_User_MyAccountChecked_OldAccountChecked_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_Promotion_SecPromotion_vue__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_Promotion_SecPromotion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__views_Promotion_SecPromotion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberCharacterSetting__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberCharacterSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberCharacterSetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_User_MyResearchGroup_ResearchGroupHome__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_User_MyResearchGroup_ResearchGroupHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__views_User_MyResearchGroup_ResearchGroupHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_User_MyResearchGroup_researchGroupManagement_ResearchGroupDetail__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_User_MyResearchGroup_researchGroupManagement_ResearchGroupDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__views_User_MyResearchGroup_researchGroupManagement_ResearchGroupDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberManagement__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberDetail__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_User_MyResearchGroup_researchMemberManagement_AddResearchMember__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_User_MyResearchGroup_researchMemberManagement_AddResearchMember___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__views_User_MyResearchGroup_researchMemberManagement_AddResearchMember__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_User_MyResearchGroup_researchMemberManagement_RegisterContact__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_User_MyResearchGroup_researchMemberManagement_RegisterContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__views_User_MyResearchGroup_researchMemberManagement_RegisterContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_User_MyResearchGroup_researchGroupManagement_ApproveOrder__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_User_MyResearchGroup_researchGroupManagement_ApproveOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__views_User_MyResearchGroup_researchGroupManagement_ApproveOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_User_MyResearchGroup_researchGroupManagement_ApproveOrderDetail__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_User_MyResearchGroup_researchGroupManagement_ApproveOrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__views_User_MyResearchGroup_researchGroupManagement_ApproveOrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_User_MyResearchGroup_researchGroupBill_BillCheck__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_User_MyResearchGroup_researchGroupBill_BillCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__views_User_MyResearchGroup_researchGroupBill_BillCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_User_MyResearchGroup_researchGroupBenefit_Benefit__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_User_MyResearchGroup_researchGroupBenefit_Benefit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__views_User_MyResearchGroup_researchGroupBenefit_Benefit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_User_MyResearchGroup_researchGroupProgress_ResearchGroupOrder__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_User_MyResearchGroup_researchGroupProgress_ResearchGroupOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__views_User_MyResearchGroup_researchGroupProgress_ResearchGroupOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_User_MyResearchGroup_researchGroupProgress_OrderDetailInfo__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_User_MyResearchGroup_researchGroupProgress_OrderDetailInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__views_User_MyResearchGroup_researchGroupProgress_OrderDetailInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_User_MyResearchGroup_researchGroupProgress_ContractProgress__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_User_MyResearchGroup_researchGroupProgress_ContractProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__views_User_MyResearchGroup_researchGroupProgress_ContractProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_User_MyResearchGroup_researchGroupProgress_ServiceTaskProgress__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_User_MyResearchGroup_researchGroupProgress_ServiceTaskProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__views_User_MyResearchGroup_researchGroupProgress_ServiceTaskProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_serviceProgressRefactor_serviceProgress_index_vue__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_serviceProgressRefactor_serviceProgress_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__views_serviceProgressRefactor_serviceProgress_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_serviceProgressRefactor_historyProgressDetail_index_vue__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_serviceProgressRefactor_historyProgressDetail_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__views_serviceProgressRefactor_historyProgressDetail_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_serviceProgressRefactor_experimentDetail_index_vue__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_serviceProgressRefactor_experimentDetail_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__views_serviceProgressRefactor_experimentDetail_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_User_MyResearchGroup_researchGroupProgress_ExpressInfo__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_User_MyResearchGroup_researchGroupProgress_ExpressInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__views_User_MyResearchGroup_researchGroupProgress_ExpressInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_Activities_ActivityDoctor_vue__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_Activities_ActivityDoctor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__views_Activities_ActivityDoctor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_User_MyResearchGroup_researchGroupProgress_FinderMerchandiseDetailForGR__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_User_MyResearchGroup_researchGroupProgress_FinderMerchandiseDetailForGR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__views_User_MyResearchGroup_researchGroupProgress_FinderMerchandiseDetailForGR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_Activities_GetCoupon_OperationResult_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_Activities_GetCoupon_OperationResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__views_Activities_GetCoupon_OperationResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_Activities_GetCoupon_SearchContactWithoutDetail_vue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_Activities_GetCoupon_SearchContactWithoutDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__views_Activities_GetCoupon_SearchContactWithoutDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_v_2_6_Order_CouponSelection__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_v_2_6_Order_CouponSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__views_v_2_6_Order_CouponSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_v_2_6_Order_OrderConfirmation__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_v_2_6_Order_OrderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__views_v_2_6_Order_OrderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_v_2_6_MyAddress_AddAddress__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_v_2_6_MyAddress_AddAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__views_v_2_6_MyAddress_AddAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_v_2_6_MyAddress_Address__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_v_2_6_MyAddress_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__views_v_2_6_MyAddress_Address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_v_2_6_MyAddress_AddressModify__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_v_2_6_MyAddress_AddressModify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__views_v_2_6_MyAddress_AddressModify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_finder_detail_PdfPreview_vue__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_finder_detail_PdfPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__views_finder_detail_PdfPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_v_2_6_MyInvoice_updateInvoiceTitle__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_v_2_6_MyInvoice_updateInvoiceTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__views_v_2_6_MyInvoice_updateInvoiceTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_v_2_6_MyInvoice_InvoiceTitleModify__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_v_2_6_MyInvoice_InvoiceTitleModify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__views_v_2_6_MyInvoice_InvoiceTitleModify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_v_2_6_Order_OrderContentConfirmation__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_v_2_6_Order_OrderContentConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__views_v_2_6_Order_OrderContentConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_v_2_6_Order_SuccessPay__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_v_2_6_Order_SuccessPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__views_v_2_6_Order_SuccessPay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_v_2_6_Order_SuccessPay2__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_v_2_6_Order_SuccessPay2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__views_v_2_6_Order_SuccessPay2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_v_2_6_Order_SuccessPay3__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_v_2_6_Order_SuccessPay3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__views_v_2_6_Order_SuccessPay3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_v_2_6_Order_SuccessPay4__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_v_2_6_Order_SuccessPay4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__views_v_2_6_Order_SuccessPay4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_Authentication_authenticationHome_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_Authentication_authenticationHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__views_Authentication_authenticationHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_Authentication_sendAuthentication_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_Authentication_sendAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__views_Authentication_sendAuthentication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_Authentication_AuthenticationSuccess_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_Authentication_AuthenticationSuccess_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__views_Authentication_AuthenticationSuccess_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_fc_Proteomics_Purchase_vue__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_fc_Proteomics_Purchase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__views_fc_Proteomics_Purchase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_fc_BoSolution_BoSolution_vue__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_fc_BoSolution_BoSolution_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__views_fc_BoSolution_BoSolution_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_fc_centerController__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_fc_centerController___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__views_fc_centerController__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_fc_BoSolution_PdfList_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_fc_BoSolution_PdfList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__views_fc_BoSolution_PdfList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_fc_BoSolution_PdfPage_vue__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_fc_BoSolution_PdfPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__views_fc_BoSolution_PdfPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_fc_Order_SubmitChecked__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_fc_Order_SubmitChecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__views_fc_Order_SubmitChecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_fc_Order_PromotionSuccess__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_fc_Order_PromotionSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__views_fc_Order_PromotionSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_fc_Promotions_BuyPromotion__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_fc_Promotions_BuyPromotion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__views_fc_Promotions_BuyPromotion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_fc_BoSolution_BoSolutionDetail__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_fc_BoSolution_BoSolutionDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__views_fc_BoSolution_BoSolutionDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_v_2_6_Material_MaterialInquire__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_v_2_6_Material_MaterialInquire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__views_v_2_6_Material_MaterialInquire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_v_2_6_Material_SampleDeliveryList__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_v_2_6_Material_SampleDeliveryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__views_v_2_6_Material_SampleDeliveryList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_v_2_6_Material_MaterialDetail__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_v_2_6_Material_MaterialDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__views_v_2_6_Material_MaterialDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_v_2_6_Material_MaterialSendProcess__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_v_2_6_Material_MaterialSendProcess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__views_v_2_6_Material_MaterialSendProcess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_v_2_6_Material_AddSampleDeliverySheet__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_v_2_6_Material_AddSampleDeliverySheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__views_v_2_6_Material_AddSampleDeliverySheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_v_2_6_Material_MySampleDeliverySheet__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_v_2_6_Material_MySampleDeliverySheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__views_v_2_6_Material_MySampleDeliverySheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_v_2_6_Material_DownloadArticleInfoSheet__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_v_2_6_Material_DownloadArticleInfoSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__views_v_2_6_Material_DownloadArticleInfoSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_v_2_6_Material_ComputerSideUsage__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_v_2_6_Material_ComputerSideUsage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__views_v_2_6_Material_ComputerSideUsage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Activities_AnnivesaryCoupon_Anniversary__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Activities_AnnivesaryCoupon_Anniversary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__views_Activities_AnnivesaryCoupon_Anniversary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__emktcommon_router_index_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_v_2_6_User_myOrders_Orders__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_v_2_6_User_myOrders_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__views_v_2_6_User_myOrders_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_v_2_6_User_myOrders_OrderDetailPage__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_v_2_6_User_myOrders_OrderDetailPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__views_v_2_6_User_myOrders_OrderDetailPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_v_2_6_User_myOrders_OrderExpressPage__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_v_2_6_User_myOrders_OrderExpressPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__views_v_2_6_User_myOrders_OrderExpressPage__);

// import $ from 'jquery'
// top level




// import store from '@/store/index'
// second level














































































































// import WeappInvoiceAddress from '@/views_v_2.6/MyInvoice/InvoiceAddress'
// import WeappAddInvoiceAddress from '@/views_v_2.6/MyInvoice/AddInvoiceAddress'
// import WeappInvoiceAddressModify from '@/views_v_2.6/MyInvoice/InvoiceAddressModify'
// import WeappInvoiceTitle from '@/views_v_2.6/MyInvoice/InvoiceTitle'
// import WeappAddInvoiceTitle from '@/views_v_2.6/MyInvoice/AddInvoiceTitle'
// import WeappInvoiceTitleModify from '@/views_v_2.6/MyInvoice/InvoiceTitleModify'































__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

if (__WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].getUrlParam('ResearchGroup')) {
  __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].isResearchGroup = true;
}

var router;
if (__WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].isResearchGroup) {
  router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    routes: [{ path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_12__views_User_MyLogin_Login___default.a, meta: { title: '登录' } }, { path: '/order/forgetPassword', name: 'forgetPassword', component: __WEBPACK_IMPORTED_MODULE_44__views_User_MyLogin_ForgetPassword___default.a }, { path: '/PhoneNumberLogin', name: 'PhoneNumberLogin', component: __WEBPACK_IMPORTED_MODULE_74__views_User_MyLogin_PhoneNumberLogin___default.a }, { path: '/login/register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_19__views_User_MyLogin_Register___default.a }, { path: '/ResearchGroup/ResearchGroupDetail', name: 'ResearchGroupDetail', component: __WEBPACK_IMPORTED_MODULE_82__views_User_MyResearchGroup_researchGroupManagement_ResearchGroupDetail___default.a }, { path: '/ResearchGroup/ResearchMemberCharacterSetting', name: 'ResearchMemberCharacterSetting', component: __WEBPACK_IMPORTED_MODULE_80__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberCharacterSetting___default.a }, { path: '/ResearchGroup/ResearchMemberManagement', name: 'ResearchMemberManagement', component: __WEBPACK_IMPORTED_MODULE_83__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberManagement___default.a }, { path: '/ResearchGroup/ResearchMemberDetail', name: 'ResearchMemberDetail', component: __WEBPACK_IMPORTED_MODULE_84__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberDetail___default.a }, { path: '/ResearchGroup/AddResearchMember', name: 'AddResearchMember', component: __WEBPACK_IMPORTED_MODULE_85__views_User_MyResearchGroup_researchMemberManagement_AddResearchMember___default.a }, { path: '/ResearchGroup/RegisterContact', name: 'RegisterContact', component: __WEBPACK_IMPORTED_MODULE_86__views_User_MyResearchGroup_researchMemberManagement_RegisterContact___default.a }, { path: '/ResearchGroup/ApproveOrder', name: 'ApproveOrder', component: __WEBPACK_IMPORTED_MODULE_87__views_User_MyResearchGroup_researchGroupManagement_ApproveOrder___default.a }, { path: '/ResearchGroup/ApproveOrderDetail', name: 'ApproveOrderDetail', component: __WEBPACK_IMPORTED_MODULE_88__views_User_MyResearchGroup_researchGroupManagement_ApproveOrderDetail___default.a }, { path: '/ResearchGroup/BillCheck', name: 'BillCheck', component: __WEBPACK_IMPORTED_MODULE_89__views_User_MyResearchGroup_researchGroupBill_BillCheck___default.a }, { path: '/ResearchGroup/Benefit', name: 'Benefit', component: __WEBPACK_IMPORTED_MODULE_90__views_User_MyResearchGroup_researchGroupBenefit_Benefit___default.a }, { path: '*', name: 'ResearchGroupHome', component: __WEBPACK_IMPORTED_MODULE_81__views_User_MyResearchGroup_ResearchGroupHome___default.a }]
  });
} else {
  router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    routes: [{ path: '/', name: 'welcome', component: __WEBPACK_IMPORTED_MODULE_5__views_Welcome___default.a, redirect: '/me' }, { path: '/toWapp', name: 'ToWapp', component: __WEBPACK_IMPORTED_MODULE_6__views_ToWapp___default.a }, { path: '/home', name: 'home', component: __WEBPACK_IMPORTED_MODULE_7__views_Home___default.a, meta: { keepAlive: true, title: '吉凯淘基因' } }, { path: '/category', name: 'category', component: __WEBPACK_IMPORTED_MODULE_8__views_Category_Category___default.a, meta: { keepAlive: true, title: '商品分类' } }, { path: '/categoryDetail', name: 'categoryDetail', component: __WEBPACK_IMPORTED_MODULE_22__views_Category_CategoryDetail___default.a, meta: { keepAlive: false, title: '商品分类' } }, { path: '/cart', name: 'cart', component: __WEBPACK_IMPORTED_MODULE_10__views_Cart_Cart___default.a, meta: { keepAlive: true, title: '购物车' } }, { path: '/detail/merchandises', name: 'merchandises', component: __WEBPACK_IMPORTED_MODULE_13__views_Detail_Merchandises___default.a, meta: { title: '商品详情' } }, { path: '/search/results', name: 'searchresults', component: __WEBPACK_IMPORTED_MODULE_9__views_search_SearchDetails___default.a }, { path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_12__views_User_MyLogin_Login___default.a, meta: { title: '登录' } }, { path: '/login/register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_19__views_User_MyLogin_Register___default.a }, { path: '/login/mobileLogin', name: 'mobileLogin', component: __WEBPACK_IMPORTED_MODULE_21__views_User_MyLogin_MobileLogin___default.a }, { path: '/login/activation', name: 'activation', component: __WEBPACK_IMPORTED_MODULE_39__views_User_MyLogin_Activation___default.a }, { path: '/me', name: 'me', component: __WEBPACK_IMPORTED_MODULE_11__views_User_Me___default.a, meta: { requireAuth: true } }, { path: '/me/orders', name: 'orders', component: __WEBPACK_IMPORTED_MODULE_14__views_User_MyOrders_Orders___default.a, meta: { requireAuth: true } },
    // {path: '/me/orders/orderDetail', name: 'orderDetail', component: OrderDetail, meta: {requireAuth: true}},
    { path: '/me/userInfo', name: 'userInfo', component: __WEBPACK_IMPORTED_MODULE_15__views_User_MyInfo_Userinfo___default.a, meta: { requireAuth: true, title: '个人信息' } }, { path: '/me/userInfo/address/addressModify', name: 'addressModify', component: __WEBPACK_IMPORTED_MODULE_17__views_User_MyAddress_AddressModify___default.a, meta: { requireAuth: true } }, { path: '/me/userInfo/address', name: 'address', component: __WEBPACK_IMPORTED_MODULE_16__views_User_MyAddress_Address___default.a, meta: { requireAuth: true } }, { path: '/me/userInfo/address/addAddress', name: 'addAddress', component: __WEBPACK_IMPORTED_MODULE_38__views_User_MyAddress_AddAddress___default.a, meta: { requireAuth: true } }, { path: '/me/changeLoginId', name: 'changeLoginId', component: __WEBPACK_IMPORTED_MODULE_18__views_User_MyLogin_ChangeLoginID___default.a, meta: { requireAuth: true } }, { path: '/me/passwordChange', name: 'passwordChange', component: __WEBPACK_IMPORTED_MODULE_20__views_User_MyLogin_PasswordChange___default.a, meta: { requireAuth: true } }, { path: '/order/orderContentConfirm', name: 'orderContentConfirm', component: __WEBPACK_IMPORTED_MODULE_28__views_Order_OrderContentConfirm___default.a }, { path: '/order/orderPayConfirm', name: 'orderPayConfirm', component: __WEBPACK_IMPORTED_MODULE_30__views_Order_Detail_OrderPayTypeConfirm___default.a }, { path: '/order/orderContent', name: 'orderContent', component: __WEBPACK_IMPORTED_MODULE_29__views_Order_OrderContent___default.a }, { path: '/order/addressDetail', name: 'addressDetail', component: __WEBPACK_IMPORTED_MODULE_32__views_Order_Detail_AddressDetail___default.a }, { path: '/order/orderConfirmDetail', name: 'orderConfirmDetail', component: __WEBPACK_IMPORTED_MODULE_33__views_Order_Detail_OrderConfirmDetail___default.a }, { path: '/order/payDetail', name: 'payDetail', component: __WEBPACK_IMPORTED_MODULE_34__views_Order_Detail_PayDetail___default.a }, { path: '/order/invoiceDetail', name: 'invoiceDetail', component: __WEBPACK_IMPORTED_MODULE_35__views_Order_Detail_InvoiceDetail___default.a }, { path: '/promotion/promotions', name: 'promotions', component: __WEBPACK_IMPORTED_MODULE_36__views_Promotion_Promotions___default.a }, { path: '/order/orderContentDetail', name: 'orderContentDetail', component: __WEBPACK_IMPORTED_MODULE_31__views_Order_Detail_OrderContentDetail___default.a }, { path: '/detail/successPay', name: 'successPay', component: __WEBPACK_IMPORTED_MODULE_37__views_Order_Detail_successPay___default.a }, { path: '/user/invoiceTitle', name: 'invoiceTitle', component: __WEBPACK_IMPORTED_MODULE_40__views_User_MyInvoice_InvoiceTitle___default.a }, { path: '/user/myCoupons', name: 'myCoupons', component: __WEBPACK_IMPORTED_MODULE_41__views_User_MyCoupons_MyCoupons___default.a }, { path: '/user/addInvoiceTitle', name: 'addInvoiceTitle', component: __WEBPACK_IMPORTED_MODULE_42__views_User_MyInvoice_AddInvoiceTitle___default.a }, { path: '/order/myOrder', name: 'myOrders', component: __WEBPACK_IMPORTED_MODULE_43__views_MyOrder_order_AllOrder___default.a }, { path: '/order/forgetPassword', name: 'forgetPassword', component: __WEBPACK_IMPORTED_MODULE_44__views_User_MyLogin_ForgetPassword___default.a }, { path: '/order/myOrderDetail', name: 'myOrderDetail', component: __WEBPACK_IMPORTED_MODULE_45__views_MyOrder_order_detail_OrderDetail___default.a }, { path: '/order/orderEvaluation', name: 'evaluation', component: __WEBPACK_IMPORTED_MODULE_46__views_MyOrder_comment_EvaluationOrder___default.a }, { path: '/custOrder', name: 'custOrder', component: __WEBPACK_IMPORTED_MODULE_48__views_Cust_CustOrder___default.a, meta: { keepAlive: true, title: '定制我的基因产品' } }, { path: '/custOrder2', name: 'custOrder2', component: __WEBPACK_IMPORTED_MODULE_49__views_Cust_DiyGoods___default.a, meta: { title: '定制我的基因产品2' } }, { path: '/dataMeta/dataMeta', name: 'dataMeta', component: __WEBPACK_IMPORTED_MODULE_47__views_DataMeta_DataMeta___default.a }, { path: '/order/MyDiscount', name: 'myDiscount', component: __WEBPACK_IMPORTED_MODULE_50__views_Order_Detail_MyDiscount___default.a }, { path: '/order/MyComment', name: 'myComment', component: __WEBPACK_IMPORTED_MODULE_51__views_MyOrder_comment_detail_CommentForOrder___default.a }, { path: '/order/Comments', name: 'getComments', component: __WEBPACK_IMPORTED_MODULE_52__views_MyOrder_comment_detail_GetComments___default.a }, { path: '/order/applyCreditPay', name: 'applyCreditPay', component: __WEBPACK_IMPORTED_MODULE_23__views_User_MyCredit_ApplyCreditPay___default.a }, { path: '/order/invoiceAddress', name: 'invoiceAddress', component: __WEBPACK_IMPORTED_MODULE_53__views_Order_InvoiceAddress___default.a }, { path: '/user/myInvoice/invoiceAddress', name: 'myInvoiceAddress', component: __WEBPACK_IMPORTED_MODULE_24__views_User_MyInvoice_InvoiceAddress___default.a }, { path: '/user/myInvoice/addInvoiceAddress', name: 'addInvoiceAddress', component: __WEBPACK_IMPORTED_MODULE_25__views_User_MyInvoice_AddInvoiceAddress___default.a }, { path: '/user/myInvoice/updateInvoiceTitle', name: 'updateInvoiceTitle', component: __WEBPACK_IMPORTED_MODULE_109__views_v_2_6_MyInvoice_updateInvoiceTitle___default.a, meta: { title: '发票' } }, { path: '/user/myInvoice/InvoiceTitleModify', name: 'invoiceTitleModify', component: __WEBPACK_IMPORTED_MODULE_110__views_v_2_6_MyInvoice_InvoiceTitleModify___default.a, meta: { title: '开票信息' } }, { path: '/user/myInvoice/invoiceAddressModify', name: 'invoiceAddressModify', component: __WEBPACK_IMPORTED_MODULE_26__views_User_MyInvoice_InvoiceAddressModify___default.a }, { path: '/user/myMessage', name: 'myMessage', component: __WEBPACK_IMPORTED_MODULE_54__views_Message_Message___default.a, meta: { title: '留言中心' } }, { path: '/contact', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_55__views_Message_Contact___default.a }, { path: '/user/myAgreement/myAgreement', name: 'myAgreement', component: __WEBPACK_IMPORTED_MODULE_56__views_User_MyAgreement_MyAgreement___default.a }, { path: '/user/myRecommend/myRecommend', name: 'myRecommend', component: __WEBPACK_IMPORTED_MODULE_57__views_User_MyRecommend_MyRecommend___default.a }, { path: '/user/myRecommend/publicNumber', name: 'publicNumber', component: __WEBPACK_IMPORTED_MODULE_58__views_User_MyRecommend_publicNumber___default.a }, { path: '/order/detail/myOrderCoupons', name: 'myOrderCoupons', component: __WEBPACK_IMPORTED_MODULE_59__views_Order_Detail_MyOrderCoupons___default.a }, { path: '/promotion/Compositions', name: 'compositions', component: __WEBPACK_IMPORTED_MODULE_60__views_Promotion_Compositions___default.a }, { path: '/custDetail', name: 'custDetail', component: __WEBPACK_IMPORTED_MODULE_61__views_Cust_Detail_CustDetail___default.a }, { path: '/CustPriceDetail', name: 'custPriceDetail', component: __WEBPACK_IMPORTED_MODULE_62__views_Cust_Detail_CustPriceDetail___default.a }, { path: '/MessageManagement', name: 'MessageManagement', component: __WEBPACK_IMPORTED_MODULE_63__views_Message_MessageManagement___default.a, meta: { title: '消息管理' } }, { path: '/Channel', name: 'Channel', component: __WEBPACK_IMPORTED_MODULE_64__views_Channels_Channel___default.a }, { path: '/ChannelDetails', name: 'ChannelDetails', component: __WEBPACK_IMPORTED_MODULE_65__views_Channels_ChannelDetails___default.a }, { path: '/PointsDetails', name: 'PointsDetails', component: __WEBPACK_IMPORTED_MODULE_66__views_User_MyLogin_PointsDetails___default.a }, { path: '/finder/finderMerchandises', name: 'finderMerchandises', component: __WEBPACK_IMPORTED_MODULE_68__views_finder_detail_finderMerchandiseDeail___default.a }, { path: '/finer/FinderOrderDeail', name: 'FinderOrderDeail', component: __WEBPACK_IMPORTED_MODULE_70__views_finder_detail_finderOrderDeail___default.a, meta: { title: '订单详情' } }, { path: '/contactUs', name: 'contactUs', component: __WEBPACK_IMPORTED_MODULE_69__views_finder_detail_contactUs___default.a }, { path: '/finder/search', name: 'finder', component: __WEBPACK_IMPORTED_MODULE_67__views_finder_Finder___default.a, meta: { keepAlive: true, title: '吉凯基因产品发现助手' } }, { path: '/VipPlanDetails', name: 'VipPlanDetails', component: __WEBPACK_IMPORTED_MODULE_71__views_User_MyVipPlan_VipPlanDetails___default.a }, { path: '/VipPlanMemberDetails', name: 'VipPlanMemberDetails', component: __WEBPACK_IMPORTED_MODULE_72__views_User_MyVipPlan_VipPlanMemberDetails___default.a }, { path: '/MemberDetails', name: 'MemberDetails', component: __WEBPACK_IMPORTED_MODULE_73__views_User_MyVipPlan_memberDetails___default.a }, { path: '/PhoneNumberLogin', name: 'PhoneNumberLogin', component: __WEBPACK_IMPORTED_MODULE_74__views_User_MyLogin_PhoneNumberLogin___default.a }, { path: '/promotion/secpromotion', name: 'secpromotion', component: __WEBPACK_IMPORTED_MODULE_79__views_Promotion_SecPromotion_vue___default.a }, { path: '/user/myAccountChecked', name: 'MyAccountChecked', component: __WEBPACK_IMPORTED_MODULE_75__views_User_MyAccountChecked_AllBill_vue___default.a }, { path: '/activity/activityDoctor', name: 'ActivityDoctor', component: __WEBPACK_IMPORTED_MODULE_99__views_Activities_ActivityDoctor_vue___default.a }, { path: '/detail/operationResult', name: 'OperationResult', component: __WEBPACK_IMPORTED_MODULE_101__views_Activities_GetCoupon_OperationResult_vue___default.a }, { path: '/detail/SearchContactWithoutDetail', name: 'SearchContactWithoutDetail', component: __WEBPACK_IMPORTED_MODULE_102__views_Activities_GetCoupon_SearchContactWithoutDetail_vue___default.a }, { path: '/ResearchGroup/ResearchGroupDetail', name: 'ResearchGroupDetail', component: __WEBPACK_IMPORTED_MODULE_82__views_User_MyResearchGroup_researchGroupManagement_ResearchGroupDetail___default.a }, { path: '/ResearchGroup/ResearchGroupHome', name: 'ResearchGroupHome', component: __WEBPACK_IMPORTED_MODULE_81__views_User_MyResearchGroup_ResearchGroupHome___default.a, meta: { index: 1 } }, { path: '/ResearchGroup/ResearchMemberCharacterSetting', name: 'ResearchMemberCharacterSetting', component: __WEBPACK_IMPORTED_MODULE_80__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberCharacterSetting___default.a }, { path: '/ResearchGroup/ResearchMemberManagement', name: 'ResearchMemberManagement', component: __WEBPACK_IMPORTED_MODULE_83__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberManagement___default.a }, { path: '/ResearchGroup/ResearchMemberDetail', name: 'ResearchMemberDetail', component: __WEBPACK_IMPORTED_MODULE_84__views_User_MyResearchGroup_researchMemberManagement_ResearchMemberDetail___default.a }, { path: '/ResearchGroup/AddResearchMember', name: 'AddResearchMember', component: __WEBPACK_IMPORTED_MODULE_85__views_User_MyResearchGroup_researchMemberManagement_AddResearchMember___default.a }, { path: '/ResearchGroup/RegisterContact', name: 'RegisterContact', component: __WEBPACK_IMPORTED_MODULE_86__views_User_MyResearchGroup_researchMemberManagement_RegisterContact___default.a }, { path: '/ResearchGroup/ApproveOrder', name: 'ApproveOrder', component: __WEBPACK_IMPORTED_MODULE_87__views_User_MyResearchGroup_researchGroupManagement_ApproveOrder___default.a }, { path: '/ResearchGroup/ApproveOrderDetail', name: 'ApproveOrderDetail', component: __WEBPACK_IMPORTED_MODULE_88__views_User_MyResearchGroup_researchGroupManagement_ApproveOrderDetail___default.a }, { path: '/user/AccountChecked', name: 'AccountChecked', component: __WEBPACK_IMPORTED_MODULE_77__views_User_MyAccountChecked_AccountChecked_vue___default.a }, { path: '/user/OldAccountChecked', name: 'OldAccountChecked', component: __WEBPACK_IMPORTED_MODULE_78__views_User_MyAccountChecked_OldAccountChecked_vue___default.a, meta: { title: '我的对账单' } }, { path: '/user/ChooseBillType', name: 'ChooseBillType', component: __WEBPACK_IMPORTED_MODULE_76__views_User_MyAccountChecked_ChooseBillType_vue___default.a }, { path: '/ResearchGroup/BillCheck', name: 'BillCheck', component: __WEBPACK_IMPORTED_MODULE_89__views_User_MyResearchGroup_researchGroupBill_BillCheck___default.a }, { path: '/ResearchGroup/Benefit', name: 'Benefit', component: __WEBPACK_IMPORTED_MODULE_90__views_User_MyResearchGroup_researchGroupBenefit_Benefit___default.a }, { path: '/ResearchGroup/OrderDetailInfo', name: 'OrderDetailInfo', component: __WEBPACK_IMPORTED_MODULE_92__views_User_MyResearchGroup_researchGroupProgress_OrderDetailInfo___default.a }, { path: '/ResearchGroup/ResearchGroupOrder', name: 'ResearchGroupOrder', component: __WEBPACK_IMPORTED_MODULE_91__views_User_MyResearchGroup_researchGroupProgress_ResearchGroupOrder___default.a, meta: { keepAlive: true, index: 2 } }, { path: '/ResearchGroup/ServiceTaskProgress', name: 'ServiceTaskProgress', component: __WEBPACK_IMPORTED_MODULE_94__views_User_MyResearchGroup_researchGroupProgress_ServiceTaskProgress___default.a }, { path: '/ResearchGroup/ExpressInfo', name: 'ExpressInfo', component: __WEBPACK_IMPORTED_MODULE_98__views_User_MyResearchGroup_researchGroupProgress_ExpressInfo___default.a }, { path: '/ResearchGroup/Progress', name: 'Progress', component: __WEBPACK_IMPORTED_MODULE_93__views_User_MyResearchGroup_researchGroupProgress_ContractProgress___default.a }, { path: '/ResearchGroup/ServiceProgress', name: 'ServiceProgress', component: __WEBPACK_IMPORTED_MODULE_95__views_serviceProgressRefactor_serviceProgress_index_vue___default.a, meta: { title: '进展详情' } }, { path: '/ResearchGroup/HistoryProgressDetail', name: 'HistoryProgressDetail', component: __WEBPACK_IMPORTED_MODULE_96__views_serviceProgressRefactor_historyProgressDetail_index_vue___default.a, meta: { title: '历史进展' } }, { path: '/ResearchGroup/ExperimentDetail', name: 'ExperimentDetail', component: __WEBPACK_IMPORTED_MODULE_97__views_serviceProgressRefactor_experimentDetail_index_vue___default.a, meta: { title: '实验详情' } }, { path: '/ResearchGroup/FinderMerchandiseDetailForGR', name: 'FinderMerchandiseDetailForGR', component: __WEBPACK_IMPORTED_MODULE_100__views_User_MyResearchGroup_researchGroupProgress_FinderMerchandiseDetailForGR___default.a }, { path: '/Weapp/Order/CouponSelection', name: 'WeappCouponSelection', component: __WEBPACK_IMPORTED_MODULE_103__views_v_2_6_Order_CouponSelection___default.a, meta: { title: '选择优惠券' } }, { path: '/Weapp/Order/OrderConfirmation', name: 'WeappOrderConfirmation', component: __WEBPACK_IMPORTED_MODULE_104__views_v_2_6_Order_OrderConfirmation___default.a, meta: { title: '下单结算' } }, { path: '/Weapp/Order/OrderContentConfirmation', name: 'WeappOrderContentConfirmation', component: __WEBPACK_IMPORTED_MODULE_111__views_v_2_6_Order_OrderContentConfirmation___default.a, meta: { title: '订单详情' } }, { path: '/Weapp/Order/SuccessPay', name: 'WeappSuccessPay', component: __WEBPACK_IMPORTED_MODULE_112__views_v_2_6_Order_SuccessPay___default.a, meta: { title: '下单成功' } }, { path: '/Weapp/MyAddress/AddAddress', name: 'WeappAddAddress', component: __WEBPACK_IMPORTED_MODULE_105__views_v_2_6_MyAddress_AddAddress___default.a, meta: { title: '新增收货地址' } }, { path: '/Weapp/MyAddress/Address', name: 'WeappAddress', component: __WEBPACK_IMPORTED_MODULE_106__views_v_2_6_MyAddress_Address___default.a, meta: { title: '收货地址管理' } }, { path: '/Weapp/MyAddress/AddressModify', name: 'WeappAddressModify', component: __WEBPACK_IMPORTED_MODULE_107__views_v_2_6_MyAddress_AddressModify___default.a, meta: { title: '修改收货地址' } },
    // {path: '/Weapp/MyAddress/AddInvoiceAddress', name: 'WeappAddInvoiceAddress', component: WeappAddInvoiceAddress, meta: {title: '新增发票寄送地址'}},
    // {path: '/Weapp/MyInvoice/InvoiceAddress', name: 'WeappInvoiceAddress', component: WeappInvoiceAddress, meta: {title: '发票寄送地址管理'}},
    // {path: '/Weapp/MyInvoice/InvoiceAddressModify', name: 'WeappInvoiceAddressModify', component: WeappInvoiceAddressModify, meta: {title: '修改新增发票寄送地址'}},
    // {path: '/Weapp/MyInvoice/InvoiceTitle', name: 'WeappInvoiceTitle', component: WeappInvoiceTitle, meta: {title: '发票抬头管理'}},
    // {path: '/Weapp/MyInvoice/AddInvoiceTitle', name: 'WeappAddInvoiceTitle', component: WeappAddInvoiceTitle, meta: {title: '新增发票抬头'}},
    // {path: '/Weapp/MyInvoice/InvoiceTitleModify', name: 'WeappInvoiceTitleModify', component: WeappInvoiceTitleModify, meta: {title: '修改发票抬头'}},
    { path: '/Weapp/User/MyOrder/Orders', name: 'WeappMyOrders', component: __WEBPACK_IMPORTED_MODULE_138__views_v_2_6_User_myOrders_Orders___default.a, meta: { title: '我的订单', keepAlive: true } }, { path: '/Weapp/User/MyOrder/OrderDetail/:orderNo', name: 'WeappMyOrderDetail', component: __WEBPACK_IMPORTED_MODULE_139__views_v_2_6_User_myOrders_OrderDetailPage___default.a, meta: { title: '我的订单', keepAlive: true } }, {
      path: '/Weapp/User/MyOrder/OrderDetail/Express/:expressDetail',
      name: 'WeappMyOrderExpress',
      component: __WEBPACK_IMPORTED_MODULE_140__views_v_2_6_User_myOrders_OrderExpressPage___default.a,
      meta: { title: '物流信息' }
    }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_137__emktcommon_router_index_js__["a" /* default */]), [{ path: '/showPdf', name: 'showPdf', component: __WEBPACK_IMPORTED_MODULE_108__views_finder_detail_PdfPreview_vue___default.a }, { path: '/Weapp/Order/SuccessPay2', name: 'WeappSuccessPay2', component: __WEBPACK_IMPORTED_MODULE_113__views_v_2_6_Order_SuccessPay2___default.a, meta: { title: '领取优惠券' } }, { path: '/Weapp/Order/SuccessPay3', name: 'WeappSuccessPay3', component: __WEBPACK_IMPORTED_MODULE_114__views_v_2_6_Order_SuccessPay3___default.a, meta: { title: '领取优惠券' } }, { path: '/Weapp/Order/SuccessPay4', name: 'WeappSuccessPay4', component: __WEBPACK_IMPORTED_MODULE_115__views_v_2_6_Order_SuccessPay4___default.a, meta: { title: '下单抽奖' } }, { path: '/Weapp/authenticationHome', name: 'authenticationHome', component: __WEBPACK_IMPORTED_MODULE_116__views_Authentication_authenticationHome_vue___default.a, meta: { title: '发起合同签署' } }, { path: '/Weapp/sendAuthentication', name: 'sendAuthentication', component: __WEBPACK_IMPORTED_MODULE_117__views_Authentication_sendAuthentication_vue___default.a, meta: { title: '签署合同' } }, { path: '/Weapp/authenticationSuccess', name: 'authenticationSuccess', component: __WEBPACK_IMPORTED_MODULE_118__views_Authentication_AuthenticationSuccess_vue___default.a, meta: { title: '合同签署成功' } }, { path: '/centerController', name: 'centerController', component: __WEBPACK_IMPORTED_MODULE_121__views_fc_centerController___default.a }, { path: '/Weapp/Proteomics/Purchase', name: 'proteomicsPurchase', component: __WEBPACK_IMPORTED_MODULE_119__views_fc_Proteomics_Purchase_vue___default.a, meta: { title: '选购商品详情' } }, { path: '/Weapp/BoSolution', name: 'boSolution', component: __WEBPACK_IMPORTED_MODULE_120__views_fc_BoSolution_BoSolution_vue___default.a, meta: { title: '样本及实验方案' } }, { path: '/Weapp/PdfList', name: 'pdfList', component: __WEBPACK_IMPORTED_MODULE_122__views_fc_BoSolution_PdfList_vue___default.a, meta: { title: '查看报告' } }, { path: '/Weapp/PdfPage', name: 'pdfPage', component: __WEBPACK_IMPORTED_MODULE_123__views_fc_BoSolution_PdfPage_vue___default.a, meta: { title: '文件下载' } }, { path: '/success/submitSuccess', name: 'submitSuccess', component: __WEBPACK_IMPORTED_MODULE_124__views_fc_Order_SubmitChecked___default.a, meta: { title: '已提交' } }, { path: '/success/PromotionSuccess', name: 'PromotionSuccess', component: __WEBPACK_IMPORTED_MODULE_125__views_fc_Order_PromotionSuccess___default.a, meta: { title: '已提交' } }, { path: '/BuyPromotion', name: 'BuyPromotion', component: __WEBPACK_IMPORTED_MODULE_126__views_fc_Promotions_BuyPromotion___default.a, meta: { title: '订购协议' } }, { path: '/Weapp/BoSolutionDetail', name: 'boSolutionDetail', component: __WEBPACK_IMPORTED_MODULE_127__views_fc_BoSolution_BoSolutionDetail___default.a, meta: { title: '方案详情' } }, { path: '/user/Material/MaterialInquire', name: 'MaterialInquire', component: __WEBPACK_IMPORTED_MODULE_128__views_v_2_6_Material_MaterialInquire___default.a, meta: { title: '在库实物查询' } }, { path: '/user/Material/SampleDeliveryList', name: 'SampleDeliveryList', component: __WEBPACK_IMPORTED_MODULE_129__views_v_2_6_Material_SampleDeliveryList___default.a, meta: { title: '实物清单', keepAlive: true } }, { path: '/user/Material/MaterialDetail', name: 'MaterialDetail', component: __WEBPACK_IMPORTED_MODULE_130__views_v_2_6_Material_MaterialDetail___default.a, meta: { title: '实物详情', keepAlive: true } }, { path: '/user/Material/MaterialSendProcess', name: 'MaterialSendProcess', component: __WEBPACK_IMPORTED_MODULE_131__views_v_2_6_Material_MaterialSendProcess___default.a, meta: { title: '实物寄送流程' } }, { path: '/user/Material/AddSampleDeliverySheet', name: 'AddSampleDeliverySheet', component: __WEBPACK_IMPORTED_MODULE_132__views_v_2_6_Material_AddSampleDeliverySheet___default.a, meta: { title: '寄送实物', keepAlive: true } }, { path: '/user/Material/MySampleDeliverySheet', name: 'MySampleDeliverySheet', component: __WEBPACK_IMPORTED_MODULE_133__views_v_2_6_Material_MySampleDeliverySheet___default.a, meta: { title: '我的寄送记录', keepAlive: true } }, { path: '/user/Material/DownloadArticleInfoSheet', name: 'DownloadArticleInfoSheet', component: __WEBPACK_IMPORTED_MODULE_134__views_v_2_6_Material_DownloadArticleInfoSheet___default.a, meta: { title: '下载实物信息表' } }, { path: '/user/Material/ComputerSideUsage', name: 'ComputerSideUsage', component: __WEBPACK_IMPORTED_MODULE_135__views_v_2_6_Material_ComputerSideUsage___default.a, meta: { title: '电脑端使用方法' } }, { path: '/Weapp/activity/anniversary', name: 'anniversary', component: __WEBPACK_IMPORTED_MODULE_136__views_Activities_AnnivesaryCoupon_Anniversary___default.a, meta: { title: '吉凯22周年回忆录' } }])
  });
}

var params = {};
router.beforeEach(function (to, from, next) {
  var custInfo = __WEBPACK_IMPORTED_MODULE_4__store_index_js__["a" /* default */].state.sessionInfo.customerInfo;
  params['customerNo'] = custInfo ? custInfo.customerNo : 'GUEST';
  params['leaveTime'] = Date.parse(new Date());
  if (from.name && from.name !== null && from.name.indexOf('资讯') > -1) {
    // '资讯'需要转换成'news'
    params['pageName'] = 'news';
    params['news'] = __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].customerBehaviours['news'];
  } else {
    params['pageName'] = from.name;
    params[from.name] = __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].customerBehaviours[from.name];
  }
  // console.log(params)
  if (__WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].isWapp) {
    window.gcapi('customerBehaviourHandler', params).then(function (res) {});
  }
  __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].initCustomerBehaviour(); // 初始化
  params = {};
  params['enterTime'] = Date.parse(new Date());
  if (to === undefined) {
    router.app.store.dispatch('navTopLevel', false);
    return;
  }
  var toPath = to.path;
  // let fromPath = from.path
  // console.log(`to: ${toPath} from: ${fromPath}`)
  if (toPath === '/' || toPath.replace(/[^/]/g, '').length > 1 || __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].isResearchGroup) {
    router.app.store.commit('navTopLevel', false);
  } else {
    router.app.store.commit('navTopLevel', true);
  }

  if (to.meta.title) {
    window.document.title = to.meta.title;
  } else {
    window.document.title = '吉凯淘基因';
  }
  var toDepth = to.meta ? to.meta.index : 0;
  var fromDepth = from.meta ? from.meta.index : 0;
  if (toDepth < fromDepth && to.path.indexOf('ResearchGroup') > -1) {
    console.log('后退。。。');
    from.meta.keepAlive = false;
    to.meta.keepAlive = true;
  }
  // console.log(`navTopLevel: ${router.app.Emkt.navTopLevel}`)
  var enterprisePopupFlag = __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].getLocalStorage('enterprisePopupFlag');
  // let invoiceTitlePopupFlag = Emkt.getLocalStorage('invoiceTitlePopupFlag')
  var panelFilterFlag = __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].getLocalStorage('panelFilterFlag');
  var panelfinderFlag = __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].getLocalStorage('panelfinderFlag');
  if (__WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].getLocalStorage('isPopUpOpen')) {
    __WEBPACK_IMPORTED_MODULE_27__emkt__["a" /* default */].setStoreItem('isPopUpOpen', false);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.closeModal('.popup-goods');
    next(false);
  } else if (enterprisePopupFlag) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.closeModal('.popup-enterprise');
    next(false);
  } else if (panelFilterFlag) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.closePanel('#panel-right-demo');
    next(false);
  } else if (panelfinderFlag) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.closePanel('#panel-right-finder');
    next(false);
  } else {
    next();
  }
});
router.afterEach(function (route) {
  // console.log(`成功浏览到: ${route.path}`)
  // Emkt.customerBehaviours['router'] = route
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__ = __webpack_require__(253);









var _mutations;







__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* default */].Store({
  state: {
    navTopLevel: false,
    // isLogin: false,
    cartList: {
      cartContent: {}, // original cartList
      saveToDBOrLocalStorage: false // true -> DB  false -> localStorage
    },
    sessionInfo: {},
    findFilters: [],
    finderResultTotal: 0,
    finderFlag: false,
    enterpriseInfo: {},
    invoiceInfo: {},
    merchdiseGroup: [],
    messageSessions: [{
      id: 0,
      user: {
        name: '吉凯基因',
        img: 'dist/images/2.png'
      },
      messages: [],
      merchantMessages: {},
      messagesAmount: 0,
      unreadMessagesAmount: 0
    }],
    checkList: [],
    orderList: [],
    myOrder: {},
    geneSearchResult: {},
    remarkData: {},
    routerSrc: '',
    merchandiseQueryParams: {},
    queryTotal: {},
    finderSearchText: '',
    secInfo: '',
    showContractInfoBox: false,
    departmentInfo: {},
    showBillInfo: true,
    showProductImage: true,
    chosenResearchIndex: 0,
    chosenResearchMember: {},
    researchGroupSet: [],
    researchGroupMemberMap: {},
    chosenResearchGroupIndex: 0,
    secPromotionDetailObj: {},
    custRemark: '请填写具体靶点序列或靶点编号或合同号',
    custRemark1: '请避开以下靶点:',
    researchGroupOrderMap: {},
    chosenOrder: {},
    chosenMember: {},
    totalApproveAmount: 0,
    progressInfo: {},
    orderInfo: {},
    // 提交订单后，全局保存ordersubmit生成的订单
    currentWaitPayOrder: null,
    currentMyOrderTabIndex: -1,
    weappMyOrders: {},
    hardGeneInfo: [],
    gotoCart: false,
    orderMaterialInfo: [],
    reassembleOrderMaterialInfo: {},
    orderMaterialId: null,
    customerOpenId: '',
    hideCustomerService: false,
    researchApprovalGroupMember: null
  },
  mutations: (_mutations = {
    toggleCustomerService: function toggleCustomerService(state, status) {
      state.hideCustomerService = status;
    },
    navTopLevel: function navTopLevel(state, top) {
      state.navTopLevel = top;
    },
    gotoCart: function gotoCart(state, value) {
      state.gotoCart = value;
    }
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["f" /* UPDATE_WEAPP_MYORDERS */], function (state, orders) {
    state.weappMyOrders = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, orders);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["g" /* SET_CURRENT_MYORDER_TABINDEX */], function (state, tabindex) {
    state.currentMyOrderTabIndex = tabindex;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["h" /* SET_CURRENT_WAITPAY_ORDER */], function (state, order) {
    state.currentWaitPayOrder = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, order);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["c" /* ADD_CART_LIST */], function (state, goodInfo) {
    goodInfo.isChecked = true;
    __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].merchandiseWithMeta(goodInfo);
    var goods = state.cartList.cartContent;
    var goodId = void 0;
    if (goodInfo.categoryId === 20) {
      goodId = goodInfo.cartid;
    } else if (goodInfo.categoryId === 99) {
      goodId = goodInfo.itemId;
    } else {
      goodId = goodInfo.merchandiseId;
      // 更新商品的cartId为商品ID
      goodInfo.cartid = goodInfo.merchandiseId;
    }
    if (!goodId) {
      return;
    }
    if (goods[goodId]) {
      if (goods[goodId].categoryId !== 7) {
        goods[goodId].productQuantity = 1;
      } else {
        goods[goodId].productQuantity++;
      }
    } else {
      goodInfo.productQuantity = 1;
      goods[goodId] = goodInfo;
    }
    // var arr = []
    // for (let i in goods) {
    //   let object = {}
    //   object[i] = goods[i]
    //   arr.push(object)
    // }
    // if (arr.length > 0) {
    //   arr.unshift(arr[arr.length - 1])
    //   arr.pop()
    //   console.log(goods, 'sssssssnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
    //   console.log(arr, 'sssssssnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
    //   let finalObject = {}
    //   arr.forEach(item => {
    //     for (let key in item) {
    //       finalObject[key] = item[key]
    //     }
    //   })
    //   console.log(finalObject, 'vvvvvvvvvvvvvvvvv')
    // }
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["i" /* SETCONTRCTINfFOBOX */], function (state, data) {
    state.showContractInfoBox = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["j" /* UPDATE_CUST_REMARK */], function (state, data) {
    state.custRemark = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["k" /* UPDATE_CUST_REMARK1 */], function (state, data) {
    state.custRemark1 = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["b" /* DELETE_CART_LIST */], function (state, goodInfo) {
    var goods = state.cartList.cartContent;
    var goodId = void 0;
    if (goodInfo.categoryId === 20) {
      goodId = goodInfo.cartid;
    } else if (goodInfo.categoryId === 99) {
      goodId = goodInfo.itemId;
    } else {
      goodId = goodInfo.merchandiseId;
    }
    if (goods[goodId]) {
      if (goods[goodId].productQuantity === 1) {
        delete goods[goodId];
      } else {
        goods[goodId].productQuantity--;
      }
    }
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["a" /* REMOVE_FROM_CART_LIST */], function (state, merchandiseId) {
    var goods = state.cartList.cartContent;
    delete goods[merchandiseId];
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["e" /* REMOVE_ALL_CHECKLIST_FROM_CART_LIST */], function (state) {
    var goods = state.cartList.cartContent;
    console.log(state.checkList);
    for (var i = 0; i < state.checkList.length; i++) {
      if (state.checkList[i].categoryId === 20) {
        delete goods[state.checkList[i].cartid];
      } else if (state.checkList[i].categoryId === 99) {
        delete goods[state.checkList[i].itemId];
      } else {
        delete goods[state.checkList[i].cartid];
      }
    }
    // goods.forEach((item, index) => {
    //   if (item.categoryId)
    // })
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["l" /* REMOVE_ALL_FROM_CART_LIST */], function (state) {
    state.cartList = {
      cartContent: {}, // original cartList
      saveToDBOrLocalStorage: false // true -> DB  false -> localStorage
    };
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["d" /* ADD_CHECK_LIST */], function (state, items) {
    state.checkList = items;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["m" /* FINDER_FLAG */], function (state, items) {
    console.log(items);
    state.finderFlag = items;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["n" /* INIT_CART */], function (state) {
    // 从localStorage中取出记录
    var initCart = __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktBuyCart');
    // console.log('initCart', initCart)
    // 初始化购物车时，从小程序跳转过来，不读取本地购物车数据
    if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
      state.cartList.cartContent = {};
    } else if (initCart) {
      state.cartList.cartContent = initCart; // 前台监听不到此变化，因为初始化购物车无需保存到本地
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["o" /* SET_CART_LIST */], function (state, cart) {
    console.log('isWapp set cart list');
    if (cart) {
      state.cartList = {
        cartContent: cart,
        saveToDBOrLocalStorage: true // true -> DB  false -> localStorage
      };
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["p" /* ADD_ORDER */], function (state, order) {
    state.orderList.push(order);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["q" /* CLIENT_INFO */], function (state, clientInfo) {
    state.sessionInfo = clientInfo;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["r" /* LOGIN_STATE_UPDATE */], function (state, login) {
    state.hasLogin = login;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["s" /* CLIENT_INFO_UPDATE */], function (state, customerInfo) {
    state.sessionInfo = {
      'customerInfo': customerInfo
    };
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["t" /* ENTERPRISE_INFO_UPDATE */], function (state, enterprise) {
    state.enterpriseInfo = {
      'enterpriseName': enterprise.enterpriseName,
      'enterpriseNo': enterprise.enterpriseNo,
      'locationName': enterprise.locationName,
      'regionName': enterprise.regionName
    };
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["u" /* INVOICETITLE_INFO_UPDATE */], function (state, enterprise) {
    state.invoiceInfo = enterprise;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["v" /* MERCHDISEGROUP_UPDATE */], function (state, merchdiseGroup) {
    state.merchdiseGroup = merchdiseGroup;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["w" /* EXPRESSADDRESS_UPDATE */], function (state, expressInfo) {
    state.sessionInfo.expressAddress = expressInfo;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["x" /* INVOICE_TITLE */], function (state, invoiceInfo) {
    state.sessionInfo.invoiceTitle = invoiceInfo;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["y" /* MYORDER_UPDATE */], function (state, myOrder) {
    state.myOrder = myOrder;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["z" /* FINDER_RESULT_TOTAL */], function (state, finderResultTotal) {
    state.finderResultTotal = finderResultTotal;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["A" /* ADD_WAITPAID_ORDER */], function (state, waitPaidOrder) {
    if (state.myOrder.waitPaidOrders) {
      state.myOrder.waitPaidOrders.unshift(waitPaidOrder);
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["B" /* ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER */], function (state, waitPaidOrder) {
    var waitPaidOrders = state.myOrder.waitPaidOrders;
    var waitDeliverOrders = state.myOrder.waitDeliverOrders;
    if (waitPaidOrders) {
      var index = waitPaidOrders.indexOf(waitPaidOrder);
      if (index >= 0) {
        waitPaidOrders.splice(index, 1);
        waitDeliverOrders.unshift(waitPaidOrder);
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["C" /* CANCEL_ORDER_FROM_WAITPAID_ORDER */], function (state, waitPaidOrder) {
    var waitPaidOrders = state.myOrder.waitPaidOrders;
    var canceledOrders = state.myOrder.canceledOrders;
    var index = waitPaidOrders.indexOf(waitPaidOrder);
    if (index >= 0) {
      waitPaidOrders.splice(index, 1);
      canceledOrders.unshift(waitPaidOrder);
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["D" /* ADD_COMMENT_FROM_WAITCOMMENT */], function (state, comment) {
    var waitCommentMerchandise = state.myOrder.waitCommentMerchandise;
    var commentedMerchandise = state.myOrder.commentedMerchandise;
    for (var i = 0; i < waitCommentMerchandise.length; i++) {
      if (waitCommentMerchandise[i].orderGuid === comment.orderId && waitCommentMerchandise[i].merchandiseGuid === comment.merchandiseId) {
        commentedMerchandise.unshift(waitCommentMerchandise[i]);
        waitCommentMerchandise.splice(i, 1);
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["E" /* GENE_SEARCH_RESULT */], function (state, geneData) {
    state.geneSearchResult = geneData;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["F" /* HARD_GENE_INFO */], function (state, geneData) {
    state.hardGeneInfo = geneData;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["G" /* POPUP_TEXT_RESULT */], function (state, remarkData) {
    state.remarkData = remarkData;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["H" /* FINDER_SEARCH_TEXT */], function (state, finderSearchText) {
    state.finderSearchText = finderSearchText;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["I" /* FIND_FILTERS */], function (state, findFilters) {
    state.findFilters = findFilters;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["J" /* INIT_MESSAGE */], function (state) {
    // var self = store
    // window.gcapi('retrieveMyLeaveMessages').then((response) => {
    //   let data = response.body.result
    //   if (data) {
    //     self.getters.curMessageSession.leaveMessageStatus = data.leaveMessageStatus
    //     self.getters.curMessageSession.merchantMessages = data.merchantMessages
    //     self.getters.curMessageSession.messages = data.messages
    //     self.getters.curMessageSession.messagesAmount = data.messagesAmount
    //     self.getters.curMessageSession.unreadMessagesAmount = data.unreadMessagesAmount
    //   }
    // })
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["K" /* SEND_MESSAGE */], function (state, content) {
    // var merchandiseGuid = null
    // // var merchandise = null
    // var message = content
    // var merchantNo = null
    //
    // if (content.merchandise) {
    //   merchandiseGuid = content.merchandise.merchandiseId
    //   // merchandise = content.merchandise
    //   merchantNo = content.merchandise.MerchantNo
    // } else {
    //   merchantNo = content.merchantNo
    // }
    // if (content.message) {
    //   message = content.message
    // }
    // window.gcapi('submitLeaveMessage', {message: message, messageType: Emkt.CONST_MESSAGE_TYPE_CUSTOMER_REQUEST, merchandiseGuid: merchandiseGuid, merchantNo: merchantNo}).then(function () {
    //   // window.gcapi('retrieveMyLeaveMessages').then((response) => {
    //   //   let data = response.body.result.merchantMessages
    //   //   if (data) {
    //   //     state.messageSessions[0].merchantMessages = data
    //   //   }
    //   //   console.log(state.messageSessions[0].merchantMessages)
    //   // })
    // })
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["L" /* INVOICE_ADDRESS */], function (state, invoice) {
    state.sessionInfo.invoiceAddress = invoice;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["M" /* ROUTER_STORE */], function (state, data) {
    state.routerSrc = data;
    if (!data.query.des) {
      var id = data.query.id;
      if (id) {
        __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].setLocalStorage('EmktCategoryID', data.query.id);
      } else {
        __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].setLocalStorage('EmktCategoryID', '-1');
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["N" /* QUERY_PARAMS_STORE */], function (state, data) {
    state.merchandiseQueryParams = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["O" /* QUERY_TOTAL */], function (state, data) {
    state.queryTotal = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["P" /* SET_SECPROMOTION_INFO */], function (state, info) {
    state.secInfo = info;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["Q" /* UPDATE_SECPROMOTION_INFO */], function (state, updateInfo) {
    state.secInfo = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, state.secInfo, updateInfo);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["R" /* UPDATE_DEPARTMENT_INFO */], function (state, data) {
    state.departmentInfo = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["S" /* UPDATE_SHOWBILLINFO */], function (state, data) {
    state.showBillInfo = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["T" /* SET_SHOW_PRODUCT_IMAGE */], function (state, data) {
    state.showProductImage = false;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["U" /* COMBINE_CART_LIST */], function (state, data) {
    console.log('combine cart list');
    // DB中无购物车记录或者记录为空{} 更新'合并flag'，清空localStorage购物车
    if (data === '{}') {
      // console.log('no shopping cart result or content in DB')
      state.cartList.saveToDBOrLocalStorage = true;
      state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
      __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].setLocalStorage('EmktBuyCart', {});
      return;
    }
    var localCart = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktBuyCart'));
    var DBCart = JSON.parse(data);
    // 若localStorage购物车为空，数据库购物车更新cartList
    if (!localCart || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(localCart).length === 0) {
      state.cartList.cartContent = DBCart;
      state.cartList.saveToDBOrLocalStorage = true; // cartList得到初始化更新，由cartList生成的jsonString将保存到数据库
      state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList); // 前台将监听到cart List的变化
      // console.log('local cart is empty 数据库购物车更新cartList  state.cartList.saveToDBOrLocalStorage = true')
    } else {
      // 合并localStorage和数据库的购物车
      for (var id in DBCart) {
        // insert DBCart into localCart
        if (id in localCart) {
          if (localCart[id].categoryId !== 20) {
            localCart[id].productQuantity += DBCart[id].productQuantity;
          }
        } else {
          localCart[id] = DBCart[id];
        }
      }
      state.cartList.cartContent = localCart;
      state.cartList.saveToDBOrLocalStorage = true;
      state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList); // 前台将监听到cart List的变化
      __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].setLocalStorage('EmktBuyCart', {}); // 清空本地购物车
      // console.log('cartList is combined!')
    }
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["V" /* UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE */], function (state, flag) {
    var oldFlag = state.cartList.saveToDBOrLocalStorage;
    if (oldFlag === flag) {
      return;
    }
    state.cartList.saveToDBOrLocalStorage = flag;
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["W" /* UPDATE_CART_CONTENT */], function (state, data) {
    state.cartList.cartContent = JSON.parse(data);
    console.log('data', JSON.parse(data));
    state.cartList = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.cartList);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["X" /* UPDATE_CHOSEN_RESEARCH_INDEX */], function (state, data) {
    state.chosenResearchIndex = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["Y" /* UPDATE_CHOSEN_RESEARCH_MEMBER */], function (state, data) {
    state.chosenResearchMember = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["Z" /* UPDATE_RESEARCHGROUP_MEMBER_MAP */], function (state, data) {
    state.researchGroupMemberMap = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data);
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_0" /* UPDATE_RESEARCHGROUP_SET */], function (state, data) {
    state.researchGroupSet = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data));
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["X" /* UPDATE_CHOSEN_RESEARCH_INDEX */], function (state, data) {
    state.chosenResearchGroupIndex = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_1" /* UPDATE_RESEARCHGROUP_ORDER_MAP */], function (state, data) {
    state.researchGroupOrderMap = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_2" /* UPDATE_CHOSEN_ORDER */], function (state, data) {
    state.chosenOrder = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_3" /* UPDATE_CHOSEN_MEMBER */], function (state, data) {
    state.chosenMember = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_4" /* UPDATE_TOTAL_APPROVE_AMOUNT */], function (state, data) {
    state.totalApproveAmount = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_5" /* UPDATE_PROGRESSINFO */], function (state, data) {
    state.progressInfo = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_6" /* ORDER_MATERIAL_INFO */], function (state, data) {
    state.orderMaterialInfo = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_7" /* REASSEMBLE_ORDER_MATERIAL_INFO */], function (state, data) {
    state.reassembleOrderMaterialInfo = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_8" /* MATERIALDETAIL_ORDERMATERIALID */], function (state, data) {
    state.orderMaterialId = data;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_type_js__["_9" /* UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET */], function (state, data) {
    state.researchApprovalGroupMember = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data);
  }), _mutations),
  getters: {
    hideCustomerService: function hideCustomerService(state) {
      return state.hideCustomerService;
    },
    isSFFlag: function isSFFlag(state) {
      var flag = false;
      if (state.sessionInfo && state.sessionInfo.customerInfo && state.sessionInfo.customerInfo.ssoFlag === 1) {
        flag = true;
      }
      return flag;
    },
    hasLogin: function hasLogin(state) {
      var sessionInfo = state.sessionInfo;
      if (!sessionInfo) {
        return false;
      }
      if (!sessionInfo.customerInfo) {
        return false;
      }
      var customerInfo = state.sessionInfo.customerInfo;

      if (customerInfo.customerNo === 'GUEST' || customerInfo.customerNo === '') {
        return false;
      } else if (!customerInfo.customerNo && customerInfo.customerNo === '') {
        return false;
      }
      return true;
    },
    isWapp: function isWapp(state) {
      return __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp;
    },
    customerNo: function customerNo(state, getters) {
      if (!getters.hasLogin) {
        return '';
      }
      return state.sessionInfo.customerInfo.customerNo;
    },
    customerName: function customerName(state, getters) {
      if (!getters.hasLogin) {
        return 'GUEST';
      }
      return state.sessionInfo.customerInfo.customerName;
    },
    customerCreateDT: function customerCreateDT(state, getters) {
      if (!getters.hasLogin) {
        return 'GUEST';
      }
      var customerCreateDT = state.sessionInfo.customerInfo.createDT;
      return customerCreateDT && customerCreateDT.year + '\u5E74' + (customerCreateDT.month + 1) + '\u6708' + customerCreateDT.dayOfMonth + '\u65E5';
    },
    curMessageSession: function curMessageSession(state) {
      if (!state.messageSessions) {
        return null;
      }
      return state.messageSessions[0];
    },
    secFlag: function secFlag(state) {
      var pro = state.secInfo;
      // 初始化状态为 已结束
      if (!pro.startDT) {
        return 2;
      }
      var startDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second);
      var endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second);
      var now = pro.now;
      // 单数限制
      if (pro.limitNumber > 0) {
        if (now < startDT) {
          return 0;
        } else if (now < endDT && pro.usedNumber < pro.limitNumber) {
          return 1;
        } else {
          return 2;
        }
      } else {
        // 只有时间限制
        if (now < startDT) {
          return 0;
        } else if (now < endDT) {
          return 1;
        } else {
          return 2;
        }
      }
    },
    isNewCustomerWithoutHistoryOrders: function isNewCustomerWithoutHistoryOrders(state) {
      var orders = state.myOrder;
      if (!orders || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(orders) === '{}') {
        return null;
      }
      // 根据订单历史判断是否是新用户=无已完成订单且无待收货订单
      var ordersToEvaluate = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(orders.waitDeliverOrders), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(orders.finishedOrders));
      var orderTimeSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      if (ordersToEvaluate.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ordersToEvaluate), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var order = _step.value;

            orderTimeSet.add(order.payDT);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return orderTimeSet.size === 0;
    },
    researchGroupDetailList: function researchGroupDetailList(state, getters) {
      var detailList = [];
      if (getters.customerNo) {
        for (var i = 0; i < state.researchGroupSet.length; i++) {
          var group = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, state.researchGroupSet[i]);
          var memberList = state.researchGroupMemberMap[group.researchGroupNo];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(memberList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var member = _step2.value;

              if (member.memberNo === getters.customerNo) {
                group.approveType = member.approveType;
                group.approveThreshold = member.approveThreshold;
                group.monthlyLimit = member.monthlyLimit;
                break;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          detailList.push(group);
        }
      }
      return detailList;
    },
    displayChosenResearchGroup: function displayChosenResearchGroup(state, getters) {
      if (getters.researchGroupDetailList && getters.researchGroupDetailList.length > 0) {
        return getters.researchGroupDetailList[state.chosenResearchGroupIndex];
      }
      return null;
    },
    researchGroupCharacter: function researchGroupCharacter(state, getters) {
      if (!getters.customerNo || !getters.displayChosenResearchGroup) return '';
      if (getters.customerNo === getters.displayChosenResearchGroup.leaderNo) return 'leader';
      if (getters.customerNo === getters.displayChosenResearchGroup.approverNo) return 'approver';
    },
    researchGroupOrder: function researchGroupOrder(state, getters) {
      return state.researchGroupOrderMap;
    },
    chosenOrder: function chosenOrder(state, getters) {
      return state.chosenOrder;
    },
    // chooseMember: (state, getters) => {
    //   return state.chosenMember
    // },
    totalApproveAmount: function totalApproveAmount(state, getters) {
      return state.totalApproveAmount;
    },
    progressInfo: function progressInfo(state, getters) {
      return state.progressInfo;
    },
    cartList: function cartList(state, getters) {
      return state.cartList;
    },
    getOrderMaterialInfo: function getOrderMaterialInfo(state, getters) {
      return state.orderMaterialInfo;
    },
    getReassembleOrderMaterialInfo: function getReassembleOrderMaterialInfo(state, getters) {
      return state.reassembleOrderMaterialInfo;
    },
    getOrderMaterialId: function getOrderMaterialId(state, getters) {
      return state.orderMaterialId;
    }
  }
});

var messageTimer;
store.watch(function (state) {
  return state.messageSessions;
}, function (val) {
  var self = store;
  if (self.sessionInfo && self.sessionInfo.customerInfo) {
    clearInterval(messageTimer);
    messageTimer = setInterval(function () {
      window.gcapi('@retrieveMyResponeMessages').then(function (response) {
        var leaveMessageInfo = response.body.result;
        self.getters.curMessageSession.leaveMessageStatus = leaveMessageInfo.leaveMessageStatus;
        // self.getters.curMessageSession.merchantMessages = leaveMessageInfo.merchantMessages
        if (leaveMessageInfo.messagesAmount && leaveMessageInfo.messagesAmount.length > 0) {
          var len = leaveMessageInfo.messagesAmount;
          if (len > self.getters.curMessageSession.messagesAmount) {
            __WEBPACK_IMPORTED_MODULE_11_jquery___default.a.notification({
              title: '你有新消息',
              text: '请您查看新消息！',
              media: '<img src="/emktResources/resocurces/img/customerService.jpeg">',
              data: '请您查看新消息！',
              onClick: function onClick(data) {
                var router = window.app.$router;
                if (router) {
                  router.push({ name: 'MessageManagement' });
                }
              },
              onClose: function onClose(data) {
                // $.alert("Close "+data);
              }
            });
          }
          self.getters.curMessageSession.merchantMessages = leaveMessageInfo.merchantMessages;
          // var lastMessage = messages[len - 1]
        }
      });
    }, 60 * 1000);
  }
}, {
  deep: true
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6498ecec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOVE_FROM_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INIT_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_CHECK_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_ALL_CHECKLIST_FROM_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADD_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLIENT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LOGIN_STATE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLIENT_INFO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ENTERPRISE_INFO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return INVOICETITLE_INFO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EXPRESSADDRESS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return INVOICE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MYORDER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CANCEL_ORDER_FROM_WAITPAID_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ADD_WAITPAID_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ADD_COMMENT_FROM_WAITCOMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GENE_SEARCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return HARD_GENE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return POPUP_TEXT_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FIND_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FINDER_RESULT_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return INIT_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SEND_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return INVOICE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MERCHDISEGROUP_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ROUTER_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return QUERY_PARAMS_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return QUERY_TOTAL; });
/* unused harmony export CUST_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FINDER_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FINDER_SEARCH_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_SECPROMOTION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return UPDATE_SECPROMOTION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SETCONTRCTINfFOBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPDATE_DEPARTMENT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPDATE_SHOWBILLINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_SHOW_PRODUCT_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return COMBINE_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_CART_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_CHOSEN_RESEARCH_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_CHOSEN_RESEARCH_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_RESEARCHGROUP_MEMBER_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_RESEARCHGROUP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_ALL_FROM_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_CUST_REMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_CUST_REMARK1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UPDATE_RESEARCHGROUP_ORDER_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UPDATE_CHOSEN_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_CHOSEN_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_TOTAL_APPROVE_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_PROGRESSINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CURRENT_WAITPAY_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_CART_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_MYORDER_TABINDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_WEAPP_MYORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return ORDER_MATERIAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return REASSEMBLE_ORDER_MATERIAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return MATERIALDETAIL_ORDERMATERIALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET; });

var ADD_CART_LIST = 'ADD_CART_LIST';
var REMOVE_FROM_CART_LIST = 'REMOVE_FROM_CART_LIST';
var INIT_CART = 'INIT_CART';
var ADD_CHECK_LIST = 'ADD_CHECK_LIST';
var REMOVE_ALL_CHECKLIST_FROM_CART_LIST = 'REMOVE_ALL_CHECKLIST_FROM_CART_LIST';
var ADD_ORDER = 'ADD_ORDER';
var CLIENT_INFO = 'CLIENT_INFO';
var LOGIN_STATE_UPDATE = 'LOGIN_STATE_UPDATE';
var CLIENT_INFO_UPDATE = 'CLIENT_INFO_UPDATE';
var ENTERPRISE_INFO_UPDATE = 'ENTERPRISE_INFO_UPDATE';
var INVOICETITLE_INFO_UPDATE = 'INVOICETITLE_INFO_UPDATE';
var EXPRESSADDRESS_UPDATE = 'EXPRESSADDRESS_UPDATE';
var DELETE_CART_LIST = 'DELETE_CART_LIST';
var INVOICE_TITLE = 'INVOICE_TITLE';
var MYORDER_UPDATE = 'MYORDER_UPDATE';
var CANCEL_ORDER_FROM_WAITPAID_ORDER = 'CANCEL_ORDER_FROM_WAITPAID_ORDER';
var ADD_WAITPAID_ORDER = 'ADD_WAITPAID_ORDER';
var ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER = 'ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER';
var ADD_COMMENT_FROM_WAITCOMMENT = 'ADD_COMMENT_FROM_WAITCOMMENT';
var GENE_SEARCH_RESULT = 'GENE_SEARCH_RESULT';
var HARD_GENE_INFO = 'HARD_GENE_INFO';
var POPUP_TEXT_RESULT = 'POPUP_TEXT_RESULT';
var FIND_FILTERS = 'FIND_FILTERS';
var FINDER_RESULT_TOTAL = 'FINDER_RESULT_TOTAL';
var INIT_MESSAGE = 'INIT_MESSAGE';
var SEND_MESSAGE = 'SEND_MESSAGE';
var INVOICE_ADDRESS = 'INVOICE_ADDRESS';
var MERCHDISEGROUP_UPDATE = 'MERCHDISEGROUP_UPDATE';
var ROUTER_STORE = 'ROUTER_STORE';
var QUERY_PARAMS_STORE = 'QUERY_PARAMS_STORE';
var QUERY_TOTAL = 'QUERY_TOTAL';
var CUST_DATA = 'CUST_DATA';
var FINDER_FLAG = 'FINDER_FLAG';
var FINDER_SEARCH_TEXT = 'FINDER_SEARCH_TEXT';
var SET_SECPROMOTION_INFO = 'SET_SECPROMOTION_INFO';
var UPDATE_SECPROMOTION_INFO = 'UPDATE_SECPROMOTION_INFO';
var SETCONTRCTINfFOBOX = 'SETCONTRCTINfFOBOX';
var UPDATE_DEPARTMENT_INFO = 'UPDATE_DEPARTMENT_INFO';
var UPDATE_SHOWBILLINFO = 'UPDATE_SHOWBILLINFO';
var SET_SHOW_PRODUCT_IMAGE = 'SET_SHOW_PRODUCT_IMAGE';
var COMBINE_CART_LIST = 'COMBINE_CART_LIST';
var UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE = 'UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE';
var UPDATE_CART_CONTENT = 'UPDATE_CART_CONTENT';
var UPDATE_CHOSEN_RESEARCH_INDEX = 'UPDATE_CHOSEN_RESEARCH_INDEX';
var UPDATE_CHOSEN_RESEARCH_MEMBER = 'UPDATE_CHOSEN_RESEARCH_MEMBER';
var UPDATE_RESEARCHGROUP_MEMBER_MAP = 'UPDATE_RESEARCHGROUP_MEMBER_MAP';
var UPDATE_RESEARCHGROUP_SET = 'UPDATE_RESEARCHGROUP_SET';
var REMOVE_ALL_FROM_CART_LIST = 'REMOVE_ALL_FROM_CART_LIST';
var UPDATE_CUST_REMARK = 'UPDATE_CUST_REMARK';
var UPDATE_CUST_REMARK1 = 'UPDATE_CUST_REMARK1';
var UPDATE_RESEARCHGROUP_ORDER_MAP = 'UPDATE_RESEARCHGROUP_ORDER_MAP';
var UPDATE_CHOSEN_ORDER = 'UPDATE_CHOSEN_ORDER';
var UPDATE_CHOSEN_MEMBER = 'UPDATE_CHOSEN_MEMBER';
var UPDATE_TOTAL_APPROVE_AMOUNT = 'UPDATE_TOTAL_APPROVE_AMOUNT';
var UPDATE_PROGRESSINFO = 'UPDATE_PROGRESSINFO';
var SET_CURRENT_WAITPAY_ORDER = 'SET_CURRENT_WAITPAY_ORDER';
var SET_CART_LIST = 'SET_CART_LIST';
var SET_CURRENT_MYORDER_TABINDEX = 'SET_CURRENT_MYORDER_TABINDEX';
var UPDATE_WEAPP_MYORDERS = 'UPDATE_WEAPP_MYORDERS';
var ORDER_MATERIAL_INFO = 'ORDER_MATERIAL_INFO';
var REASSEMBLE_ORDER_MATERIAL_INFO = 'REASSEMBLE_ORDER_MATERIAL_INFO';
var MATERIALDETAIL_ORDERMATERIALID = 'MATERIALDETAIL_ORDERMATERIALID';

var UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET = 'UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET';

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    saveCartManually: function saveCartManually() {
      var _this = this;

      var cartJsonString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cartList.cartContent);
      // $.showPreloader('正在添加商品')
      this.$weui.loading('正在添加商品');
      if (__WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].isWappGuest) {
        // 小程序游客模式根据openID获取数据
        this.gcapi('saveWappGuestShoppingCart', {
          openId: this.customerOpenId,
          cartContent: cartJsonString
        }).then(function (response) {
          // $.hidePreloader()
          _this.$weui.loading().hide();
          if (response.body.code === 0) {
            _this.$weui.toast('添加成功', 1500);
            // $.toast('添加成功')
            console.log('手动保存购物车成功：save Shopping cart successfully');
          } else {
            _this.$weui.topTips('添加失败', 1000);
            // $.showPreloader('添加失败')
            // setTimeout(function () {
            //   $.hidePreloader()
            // }, 1000)
          }
        });
      } else {
        this.gcapi('saveShoppingCart', cartJsonString).then(function (response) {
          // $.hidePreloader()
          _this.$weui.loading().hide();
          if (response.body.code === 0) {
            _this.$weui.toast('添加成功', 1500);
            // $.toast('添加成功')
            console.log('手动保存购物车成功：save Shopping cart successfully');
          } else {
            _this.$weui.topTips('添加失败', 1000);
            // $.showPreloader('添加失败')
            // setTimeout(function () {
            //   $.hidePreloader()
            // }, 1000)
          }
        });
      }
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceProgressMixIn; });
var serviceProgressMixIn = {
  methods: {
    getStatusClass: function getStatusClass(statusName) {
      var className = '';
      switch (statusName) {
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__ON_GOING:
          className = 'mod1';
          break;
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME_NOT_START:
          className = 'layer5';
          break;
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__ENDING:
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__END_STOP:
          className = 'layer6';
          break;
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION:
          className = 'layer7';
          break;
        default:
          className = '';
      }
      console.log('className', className);
      return className;
    }
  }
};

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1519),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00a0ca2d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bf0ad2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1653),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bfec4ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1010bd11",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51af62fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1571),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-269d4cd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1561),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1db37a3d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1009)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-507fdc48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1670),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d6be9d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1111)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-df647602",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-358164f5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-440a0ddd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(968)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3200056c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31e3d66a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d424474",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ea11c9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76709f84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__);
/* eslint-disable */

 // svg组件

// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('svg-icon', __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon___default.a);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__(1754);
requireAll(req);

/***/ }),
/* 366 */,
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(958)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b71ce72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2242c872",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1573),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-275eb232",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1121)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1743),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7fdea44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(961)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1584),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2be266f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70bc91b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return postRequest; });
/* unused harmony export deleteRequest */
/* unused harmony export getRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weui_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weui_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_weui_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant_js__ = __webpack_require__(42);






// const UNAUTHORIZED = 401
// const FORBIDDEN = 403
// const ACTION_FAILED = 1
var SUCCESS_CODE = 0;

var FormUrlencodedContentType = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(err);
});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  return response;
});
var encodeRequestParams = function encodeRequestParams(data) {
  var ret = '';
  for (var it in data) {
    var processedData = it === 'SessionId' ? data[it] : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data[it]);
    ret += encodeURIComponent(it) + '=' + processedData + '&';
  }
  return ret;
};
var postRequest = function postRequest(url, body) {
  var showLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // 拼装业务员session
  var employeeSession = __WEBPACK_IMPORTED_MODULE_5__constant_js__["a" /* default */].getUrlParam('EmployeeSession') || '';
  body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, body, { SessionId: employeeSession });
  if (showLoading) __WEBPACK_IMPORTED_MODULE_4_weui_js___default.a.loading('加载中');
  return httpRequest({
    method: 'post',
    url: url,
    data: body,
    // data: qs.stringify(body),
    transformRequest: [encodeRequestParams],
    headers: FormUrlencodedContentType
  });
};

var deleteRequest = function deleteRequest(url) {
  return httpRequest({
    method: 'delete',
    url: '' + url
  });
};
var getRequest = function getRequest(url, param) {
  return httpRequest({
    method: 'get',
    url: '' + url,
    params: param,
    transformRequest: [encodeRequestParams]
  });
};

var httpRequest = function httpRequest(requestConfig) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default()(requestConfig).then(function (response) {
      if (__WEBPACK_IMPORTED_MODULE_4_weui_js___default.a.loading()) __WEBPACK_IMPORTED_MODULE_4_weui_js___default.a.loading().hide();
      if (response && response.data && response.data.code === SUCCESS_CODE) {
        resolve(response.data.result);
      } else {
        // 调用emkt getMerchandiseMeta直接返回
        if (requestConfig.url.indexOf('getMerchandiseMeta') > -1) {
          resolve(response.data.result);
        } else {
          alert(response.data.message);
        }
      }
    }).catch(function (e) {
      // (e: { response: { data: any; statusText: string }; message: any })
      console.log('api error: ', e);
      var m = '';
      // 下面是axios的出错处理机制
      if (e.response) {
        // 后台正常报错，如404错误
        var d = e.response.data;
        if (d) {
          m = d.status + ', ' + d.error + ', ' + d.message + ', ' + d.timestamp;
        } else {
          m = e.response.statusText;
        }
      } else {
        // 网络错误
        m = e.message;
      }

      alert(m);
    });
  });
};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders__ = __webpack_require__(404);



/* harmony default export */ __webpack_exports__["a"] = ([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__orders__["a" /* default */])));

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orderRoutes = [{
  path: '/Weapp/User/MyOrder/OrderDetail/GcOrderProductDetail/:orderItem/:order',
  name: 'WeappGcOrderProductDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1765));
  },
  meta: { title: '产品详情' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/GcOrderSmartProductDetail/:orderItem/:order',
  name: 'WeappGcOrderSmartProductDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1766));
  },
  meta: { title: '产品详情' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/Progress/:orderItem/:orderNo',
  name: 'WeappGcProgress',
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1767));
  },
  meta: { title: '进展详情' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/Task/:contractNo/:status/:taskModules',
  name: 'WeappGcServiceTaskProgress',
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1769));
  },
  meta: { title: '实验详情' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/GcOrderInvoiceDetail/:orderNo',
  name: 'WeappGcOrderInvoiceDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1764));
  },
  meta: { title: '开票回款金额信息' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/HistoryProgress/:contractProgressInfo',
  name: 'WeappGcContractHistoryProgress',
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1768));
  },
  meta: { title: '历史进展' }
}, {
  path: '/Weapp/User/MyOrder/OrderDetail/GcOrderGoodsDetail/:contractNos',
  name: 'WeappGcOrderGoodsDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1763));
  },
  meta: { title: '实物信息' }
}];

/* harmony default export */ __webpack_exports__["a"] = (orderRoutes);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EnterpriseBox__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EnterpriseBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_EnterpriseBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_User_MyResearchGroup_researchGroupComponents_ResearchGroupMemberBox__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_User_MyResearchGroup_researchGroupComponents_ResearchGroupMemberBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_User_MyResearchGroup_researchGroupComponents_ResearchGroupMemberBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_search_SearchBox__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_search_SearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_search_SearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_search_SearchGeneBox__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_search_SearchGeneBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_search_SearchGeneBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_search_PoPupTextBox__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_search_PoPupTextBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_search_PoPupTextBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_search_invoiceTitleBox__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_search_invoiceTitleBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_search_invoiceTitleBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Panel_SearchFilterPanel__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Panel_SearchFilterPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Panel_SearchFilterPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_index__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_resource__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_iconfont_iconfont_css__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_weui_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_weui_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_weui_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__icons__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vant_lib_index_css__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_animate_css__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_animate_css__);







var _this = this;
























__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_26_animate_css___default.a);

__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].prototype.$weui = __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a;
// console.log('weui', weui)
// $weui.dialog replace light7 $.modal & $.confirm
// $weui.alert replace light7 $.alert & alert
// $weui.toast replace light7 $.toast(successMessage)
// $weui.topTips replace light7 $.toast(errorMessage)
// $weui.loading replace light7 $.showPreloader()
// $weui.loading().hide() replace light7 $.hidePreloader()
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vant__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].prototype.store = __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].prototype.emkt = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_resource__["a" /* default */]);
window.emkt = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */];

if (false) {
  // Vue.http.options.root = 'static/test'
  Vue.http.options.root = 'gcapi';
} else if (false) {
  Vue.http.options.root = 'gcapi';
} else if (false) {
  Vue.http.options.root = 'gcapi';
} else if (false) {
  Vue.http.options.root = 'gcapi';
} else {
  __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.options.root = 'gcapi';
}
// redirect to smart
if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('toSmart') === '1') {
  var uri = window.location.href.split('#')[0];
  var uriItems = uri && uri.split('?');
  var processDomain = uriItems[0] && uriItems[0].includes('http://www.genechemat.com') && uriItems[0].replace('http', 'https') || uriItems[0];
  var newUri = uriItems && processDomain + '/rtmes-client/?' + uriItems[1];
  var replaceSmartUri = newUri && newUri.replace('&toSmart=1', '');
  console.log('toSmart', replaceSmartUri);
  window.location.href = replaceSmartUri;
}

if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParam('debug')) {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDebug = true;
}

if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('desktop') === '1') {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDesktop = true;
}
if (window) {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isIphoneFullScreen = /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
}

if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getFullUrlParam('wapp')) {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp = true;
}
if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getFullUrlParam('openid')) {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWappGuest = true; // 小程序Guest跳转
  __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.customerOpenId = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlFullParamValue('openid');
  if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].getters.hasLogin) {
    this.gcapi('gcwwwifc/userLogout').then(function (response) {
      if (response.body.code === 1) {
        _this.$weui.toast('同步登录状态失败！');
      }
    }, function (response) {
      _this.$weui.toast('同步登录状态失败！');
    });
  }
}
// 从小程序过来 且为全面屏 需要做适配
__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].leaveSpaceForFullScreen = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp && __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isIphoneFullScreen;
// if (Emkt.getFullUrlParam('session')) {
//   alert(window.location.href)
// }
__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getEmktMetaVersion(); // init

if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('sso_processed') === '1') {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].buyCartIsLocalStorage = false;
}
if (window.location.href.indexOf('secpromotion') !== -1) {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isSecPromotion = true;
}
if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getFullUrlParam('shareCartId')) {
  // 不存储在window.localstorage，每次进入应用时都重新获取并存储
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('shareCartId', __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getFullUrlParam('shareCartId'));
}
if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('QuoteStatus')) {
  if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('QuoteStatus') === '0' || __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('QuoteStatus') === '3') {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setLocalStorage('QuoteStatus', false);
  } else {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setLocalStorage('QuoteStatus', true);
  }
} else {
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setLocalStorage('QuoteStatus', false);
}

/*  Vue.http.options.root = process.env.NODE_ENV === 'development' ? 'static/test' : 'api' */
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  // request.headers.set('EmktMetaVersion', '' + Emkt.getEmktMetaVersion())
  // window.document.cookie = 'EmktMetaVersion=' + Emkt.getEmktMetaVersion()
  if (false) {
    // request.url = request.url + '.json'
  } else {
      // request.url = request.url + '.json'
    }

  next(function (response) {
    // 处理元数据
    dealMetaData(response);
  });
});
function dealMetaData(response) {
  if (response.body.attrs !== undefined) {
    if (response.body.attrs.EmktMetaData !== undefined) {
      var merchandiseMeta = response.body.attrs.EmktMetaData;
      var detaillist;
      var categoryAttrsMap = {};
      // var dictionariesMapNew = {}
      var dictionariesMap = {};
      var tagsMap = {};
      var tagIdsMap = {};
      var tagNamesMap = {};
      var dictionaries;
      var categoryAttrGroups;
      var categoryAttrGroupsMap = {};
      var tags;
      var categories;
      var categoriesMap = {};
      // var val = []
      detaillist = merchandiseMeta.categoryAttrs;
      dictionaries = merchandiseMeta.dictionaries;
      categoryAttrGroups = merchandiseMeta.categoryAttrGroups;
      tags = merchandiseMeta.tags;
      categories = merchandiseMeta.categories;

      for (var j = 0; j < dictionaries.length; j++) {
        var dkey = dictionaries[j].typeID + '_' + dictionaries[j].dictKey;
        var dvalue = dictionaries[j];
        var keyNew = dictionaries[j].typeID;
        dictionariesMap[dkey] = dvalue;
        var dictionariesEntry = dictionariesMap[keyNew];
        if (!dictionariesEntry) {
          dictionariesMap[keyNew] = {};
          dictionariesEntry = dictionariesMap[keyNew];
        }
        dictionariesEntry[dictionaries[j].dictKey] = dvalue;
      }

      for (j = 0; j < categoryAttrGroups.length; j++) {
        var k = categoryAttrGroups[j].attrGroupId;
        var v = categoryAttrGroups[j];
        categoryAttrGroupsMap[k] = v;
      }

      for (var i = 0; i < detaillist.length; i++) {
        var attrsMap = categoryAttrsMap[detaillist[i].categoryId];
        if (!attrsMap) {
          attrsMap = {};
          categoryAttrsMap[detaillist[i].categoryId] = attrsMap;
        }

        // var key = detaillist[i].categoryId + '_' + detaillist[i].columnName
        var value = detaillist[i];
        // categoryAttrsMap[key] = value
        attrsMap[detaillist[i].columnName] = value;
      }
      for (var _k = 0; _k < tags.length; _k++) {
        var tkey = tags[_k].tagId;
        var tvalue = tags[_k];
        tagsMap[tkey] = tvalue;
      }
      for (var _k2 = 0; _k2 < tags.length; _k2++) {
        var tidkey = tags[_k2].tagId;
        var tidvalue = tags[_k2].tagLabel;
        tagIdsMap[tidkey] = tidvalue;
      }
      for (var _k3 = 0; _k3 < tags.length; _k3++) {
        var tnamekey = tags[_k3].tagLabel;
        var tnamevalue = tags[_k3].tagId;
        tagNamesMap[tnamekey] = tnamevalue;
      }
      for (var _i = 0; _i < categories.length; _i++) {
        var cate = categories[_i].categoryId;
        var cateValue = categories[_i];
        categoriesMap[cate] = cateValue;
      }

      merchandiseMeta.categoryAttrsMap = categoryAttrsMap;
      merchandiseMeta.dictionariesMap = dictionariesMap;
      merchandiseMeta.categoryAttrGroupsMap = categoryAttrGroupsMap;
      merchandiseMeta.tagsMap = tagsMap;
      merchandiseMeta.tagIdsMap = tagIdsMap;
      merchandiseMeta.tagNamesMap = tagNamesMap;
      merchandiseMeta.keywordMeanings = merchandiseMeta.keywordMeanings;
      merchandiseMeta.categoriesMap = categoriesMap;
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setLocalStorage('EmktAllKeywords', {}); // 同时要清空keyWords
      if (!window.localStorage) {
        // window.localStorage.clear()
      }
      if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDebug) {
        window.alert('merchandiseMeta=' + merchandiseMeta);
      }
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setEmktMetaData(merchandiseMeta);
    }
  }
}

function setMerchandiseListWithMeta(merchandises) {
  merchandises.forEach(function (item) {
    if (item.compositions) {
      setMerchandiseListWithMeta(item.compositions);
    }
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].merchandiseWithMeta(item);
  });
}

function setOrderMerchandiseWithMeta(orders) {
  for (var i = 0; i < orders.length; i++) {
    var order = orders[i];
    if (order.merchandises[0]) {
      order.merchandises[0].productName = order.productName;
    }
    setMerchandiseDetailForClient(order.merchandises, order.isSmartOrder);
  }
}

function setMerchandiseDetailForClient(merchandises) {
  var isSmartOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (merchandises) {
    merchandises.forEach(function (item) {
      var mer = item.merchandiseDetailForClient;
      if (mer) {
        if (mer.categoryId === 10 || mer.categoryId === 20) {
          setMerchandiseDetailForClientCustom(item);
        }
        if (!isSmartOrder) {
          __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].merchandiseWithMeta(mer);
          item._attributesList = mer._attributesList;
          item._titleList = mer._titleList;
          item._subTitleList = mer._subTitleList;
          item._attributes = mer._attributes;
          item._abstractList = mer._abstractList;
          item.priceMax = mer.priceMax;
        }
      }
    });
  }
}

function setMerchandiseDetailForClientCustom(item) {
  var attributes = item.attributes;
  var obj = {};
  var mer = item.merchandiseDetailForClient;
  attributes.forEach(function (data) {
    var key = data.key;
    var val = data.value;
    obj[key] = val;
  });
  mer.productName = item.productName;
  mer.attributes = obj;
  mer.cycle = item.workdays;
  mer.priceMax = item.priceMax;
  mer.priceMin = item.priceMin;
  // mer.priceMax = item.price
  // mer.priceMin = item.price
  mer.productGuid = item.productGuid;
  return mer;
}
// || response.apiName === 'assambleOrders'
function retrieveMyOrder(response) {
  if (response.apiName === 'retrieveMyOrder') {
    var re = response.body.result;
    var canceledOrders = re.canceledOrders;
    var finishedOrders = re.finishedOrders;
    var waitDeliverOrders = re.waitDeliverOrders;
    var waitPaidOrders = re.waitPaidOrders;
    var waitSignOrders = re.waitSignOrders;
    var completeOrders = re.completeOrders;
    var quoteCompletedOrders = re.quoteCompletedOrders;
    var waitAuditOrders = re.waitAuditOrders;
    var failAuditOrders = re.failAuditOrders;
    waitSignOrders = getProductNum(waitSignOrders);
    completeOrders = getProductNum(completeOrders);
    quoteCompletedOrders = getProductNum(quoteCompletedOrders);
    waitAuditOrders = getProductNum(waitAuditOrders);
    failAuditOrders = getProductNum(failAuditOrders);

    canceledOrders = getProductNum(canceledOrders);
    finishedOrders = getProductNum(finishedOrders);
    waitDeliverOrders = getProductNum(waitDeliverOrders);
    waitPaidOrders = getProductNum(waitPaidOrders);

    setOrderMerchandiseWithMeta(waitSignOrders);
    setOrderMerchandiseWithMeta(completeOrders);
    setOrderMerchandiseWithMeta(quoteCompletedOrders);
    setOrderMerchandiseWithMeta(waitAuditOrders);
    setOrderMerchandiseWithMeta(failAuditOrders);

    changeorders(waitSignOrders);
    changeorders(completeOrders);
    changeorders(quoteCompletedOrders);
    changeorders(waitAuditOrders);
    changeorders(failAuditOrders);

    setOrderMerchandiseWithMeta(canceledOrders);
    setOrderMerchandiseWithMeta(finishedOrders);
    setOrderMerchandiseWithMeta(waitDeliverOrders);
    setOrderMerchandiseWithMeta(waitPaidOrders);
    changeorders(canceledOrders);
    changeorders(finishedOrders);
    changeorders(waitDeliverOrders);
    changeorders(waitPaidOrders);
    var commentedMerchandise = re.commentedMerchandise;
    var waitCommentMerchandise = re.waitCommentMerchandise;
    setMerchandiseDetailForClient(commentedMerchandise);
    setMerchandiseDetailForClient(waitCommentMerchandise);
    // console.log(commentedMerchandise)
  }
  if (response.apiName === 'assambleOrders') {
    setOrderMerchandiseWithMeta([response.body.result]);
  }
}
function orderSubmit(response) {
  if (response.apiName === 'orderSubmit') {
    var re = response.body.result;
    setMerchandiseDetailForClient(re.merchandises);
  }
}
function getWaitPayOrderInfoByOrderId(response) {
  if (response.apiName === 'getWaitPayOrderInfoByOrderId') {
    var re = [response.body.result];
    setOrderMerchandiseWithMeta(re);
    changeorders(re);
  }
}
function calculateOrderAmount(response) {
  if (response.apiName === 'calculateOrderAmount' && response.body.result) {
    var re = response.body.result;
    setMerchandiseDetailForClient(re.merchandises);
  }
}

function getAllOrdersByCustomerNoOrResearchGroupNo(response) {
  if (response.apiName === 'getAllOrdersByCustomerNoOrResearchGroupNo' && response.body.result) {
    var re = response.body.result;

    var _loop = function _loop(key) {
      re[key].forEach(function (order) {
        order.fromEmkt && order.itemList && order.itemList.forEach(function (item) {
          item.fromEmkt = order.fromEmkt;
          var convertedAttributes = {};
          if (!item.attrs) console.log('empty attrs: key', key, order, item);
          item.attrs && item.attrs.forEach(function (attr) {
            convertedAttributes[attr.attribute] = attr.value;
          });
          item.attributes = convertedAttributes;
          __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].merchandiseWithMeta(item);
        });
      });
    };

    for (var key in re) {
      _loop(key);
    }
  }
}

function changeorders(orders) {
  for (var j = 0; j < orders.length; j++) {
    if (orders[j].subOrders && orders[j].subOrders.length > 0) {
      setOrderMerchandiseWithMeta(orders[j].subOrders);
    }
  }
}
function getProductNum(productList) {
  if (productList) {
    var i = 0;
    var j = 0;
    for (i = 0; i < productList.length; i++) {
      if (productList[i].merchandises && productList[i].merchandises.length > 0) {
        var l = 0;
        if (productList[i].isStock === false) {
          l = productList[i].merchandises.length;
        } else {
          for (j = 0; j < productList[i].merchandises.length; j++) {
            l = l + productList[i].merchandises[j].quantity;
          }
        }
        productList[i].productNum = l;
      } else if (productList[i].subOrders && productList[i].subOrders.length > 0) {
        var k = 0;
        for (j = 0; j < productList[i].subOrders.length; j++) {
          k = k + productList[i].subOrders[j].merchandises.length;
        }
        productList[i].productNum = k;
      }
    }
  }
  return productList;
}
function getAllCustomizedMerchandise(response) {
  if (response.apiName === 'getAllCustomizedMerchandise') {
    setMerchandiseListWithMeta(response.body.result);
  }
}
function getMerchandiseDetails(response) {
  if (response.apiName === 'getMerchandiseDetails') {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].merchandiseWithMeta(response.body.result);
  }
}
function findMerchandiseDetails(response) {
  if (response.apiName === 'findMerchandiseDetails') {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].merchandiseWithMeta(response.body.result);
  }
}
function queryMerchandise(response) {
  if (response.apiName === 'queryMerchandise') {
    setMerchandiseListWithMeta(response.body.result.merchandiseList);
  }
}
function find(response) {
  if (response.apiName === 'find') {
    if (response.body.result.merchandiseList) {
      setMerchandiseListWithMeta(response.body.result.merchandiseList);
    }
  }
}
function getRecommended(response) {
  if (response.apiName === 'getRecommended') {
    setMerchandiseListWithMeta(response.body.result);
  }
}
function EmktPromotions(response) {
  if (response.apiName === 'EmktPromotions') {
    setMerchandiseListWithMeta(response.body.result);
  }
}
function procApplicableMerchandiseLiteList(response) {
  if (response.apiName === 'getApplicableMerchandiseLiteList') {
    setMerchandiseListWithMeta(response.body.result);
  }
}
function getRecommendation(response) {
  if (response.apiName === 'getRecommendation') {
    setMerchandiseListWithMeta(response.body.result);
  }
}
function productDetectCustom(response) {
  if (response.apiName === 'productDetect') {
    setMerchandiseDetailForClientCustom(response.body.result);
  }
}
function apiPostProc(response) {
  retrieveMyOrder(response);
  getAllCustomizedMerchandise(response);
  orderSubmit(response);
  getWaitPayOrderInfoByOrderId(response);
  getMerchandiseDetails(response);
  findMerchandiseDetails(response);
  procApplicableMerchandiseLiteList(response);
  getRecommended(response);
  queryMerchandise(response);
  find(response);
  EmktPromotions(response);
  getRecommendation(response);
  productDetectCustom(response);
  calculateOrderAmount(response);
  getAllOrdersByCustomerNoOrResearchGroupNo(response);
}
function gcapi(api, para, option) {
  var apiName = api;
  var suppress = false;
  if (apiName.startsWith('@')) {
    // 加@前缀的调用，启用错误抑制
    apiName = apiName.substring(1); // 去掉错误抑制前缀，取得API名字
    suppress = true;
  }
  var apiDisplayName = apiName;
  var idx = apiDisplayName.lastIndexOf('/');
  if (idx !== -1) {
    apiDisplayName = apiDisplayName.substring(idx);
  }
  return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    apiCall(apiName, para, option).then(function (response) {
      response.apiName = apiName;
      response.apiDisplayName = apiDisplayName;
      if (response.body.code !== 0) {
        if (response.body.code === 101 && response.body.message === '') {
          // $.toast('啊哦～登录失败了')
          __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.topTips('啊哦～登录失败了', 1000);
          __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.loading().hide();
          return;
        } else {
          // 发生了错误，处理错误信息
          response.code = response.body.code;
          response.message = response.body.message;

          if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDebug) {
            response.message = response.message + ': ' + apiDisplayName;
            __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.topTips(response.message === '' ? '出错啦' : response.message);
            __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.loading().hide();
            // $.toast(response.message === '' ? '出错啦' : response.message)
          }

          response.statusText = response.message;
          // 若联系人不存在，通知SF删除成员失败，验证余额账户时，验证结算账户可用信用额度， 前台需监测到此结果
          if (response.code === 1) {
            if (response.message === '该联系人不存在' || response.message.includes('通知SF删除成员失败') || response.message === '缺少必要信息' || response.message.includes('可用信用额度')) {
              suppress = true;
            }
          }
          if (suppress === false) {
            // 如果没有启用了错误消息抑制， 这里显示错误消息， 然后停止下游处理
            __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.topTips(response.message === '' ? '出错啦' : response.message);
            __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.loading().hide();
            // $.toast(response.message === '' ? '出错啦' : response.message)
            return;
          }
        }
      }
      apiPostProc(response); // api结果预处理
      resolve(response);
    }, function (response) {
      response.apiName = apiName;
      response.apiDisplayName = apiDisplayName;
      response.message = response.statusText;

      if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDebug) {
        response.message = response.message + ': ' + apiDisplayName;
        __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.topTips(response.message === '' ? '出错啦' : response.message);
        __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.loading().hide();
        // $.toast(response.message === '' ? '出错啦' : response.message)
      }

      if (suppress === false) {
        // 如果没有启用了错误消息抑制， 这里显示错误消息
        __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.topTips(response.message === '' ? '出错啦' : response.message);
        __WEBPACK_IMPORTED_MODULE_22_weui_js___default.a.loading().hide();
        // $.toast(response.message === '' ? '出错啦' : response.message)
      }
      reject(response);
    });
  });
}

function apiCall(api, para, option) {
  var apiName = api;
  if (apiName.startsWith('gcwwwifc/')) {
    // console.log(api, store.state.sessionInfo)
    if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo) {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(api, __WEBPACK_IMPORTED_MODULE_20_jquery___default.a.extend({ params: para, SessionId: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.session }, option));
    } else if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.session) {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(api, __WEBPACK_IMPORTED_MODULE_20_jquery___default.a.extend({ params: para, SessionId: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.session }, option));
    } else {
      // if (Emkt.isWapp) {
      //   if (Emkt.getUrlParamHref('session')) {
      //     console.log(window.location.href)
      //     var sessionId = Emkt.getUrlFullParamValue('session')
      //     return Vue.http.get(api, $.extend({params: para, SessionId: sessionId}, option))
      //   }
      // } else {
      //   return Vue.http.get(api, $.extend({params: para}, option))
      // }
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(api, __WEBPACK_IMPORTED_MODULE_20_jquery___default.a.extend({ params: para }, option));
    }
  }
  if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo) {
    return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(api, { Json: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(para), SessionId: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.session }, option);
  } else if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.session) {
    return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(api, { Json: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(para), SessionId: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.session }, option);
  } else {
    // if (Emkt.isWapp) {
    //   if (Emkt.getUrlParamHref('session')) {
    //     console.log(window.location.href)
    //     sessionId = Emkt.getUrlFullParamValue('session')
    //     return Vue.http.post(api, {Json: JSON.stringify(para), SessionId: sessionId}, option)
    //   }
    // } else {
    //   return Vue.http.post(api, {Json: JSON.stringify(para)}, option)
    // }
    return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(api, { Json: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(para) }, option);
  }
  // return Vue.http.get(api, $.extend({params: {Json: JSON.stringify(para)}}, option))
}

__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].prototype.gcapi = gcapi;
/* eslint-disable no-new */
// 初始化客户端数据
var Curl = '@gcwwwifc/getCustomerInfo';
if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp && __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getFullUrlParam('session')) {
  Curl = Curl + window.location.search;
}
gcapi(Curl).then(function (response) {
  var data = response.body;
  if (data.code === 0) {
    __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo = data.result;
    // console.log('getCustomerInfo', store.state.sessionInfo)
    // console.log(Emkt.buyCartIsLocalStorage)
    var shoppingCart = __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart;
    if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].buyCartIsLocalStorage === false && shoppingCart && shoppingCart !== 'null' && JSON.parse(shoppingCart).cartContent) {
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktBuyCart', JSON.parse(JSON.parse(shoppingCart).cartContent));
      // console.log(Emkt.getLocalStorage('EmktBuyCart'))
    }
  } else {
    return gcapi('@gcwwwifc/login', {
      'LoginId': 'guest',
      'Password': 'guest'
    });
  }
}).then(function (response) {
  if (response !== undefined) {
    var res = response.body;
    // console.log('response.body', res)
    if (res.code === 101) {
      // guest account
      __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo = res.result;
    } else if (res.code === 0) {
      // console.log('store.state.sessionInfo', store.state.sessionInfo)
      if (res.result) {
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo = res.result;
        // 更新sessionInfo以更新getters hasLogin
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo);
      }
      return gcapi('@gcwwwifc/getCustomerInfo');
    }
  }
}).then(function (response) {
  if (response !== undefined) {
    var res = response.body;
    if (res.code === 0) {
      __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo = res.result;
    }
  }
}).then(function () {
  __WEBPACK_IMPORTED_MODULE_20_jquery___default.a.sign = {
    shareUrl: '',
    appId: '',
    timestamp: 0,
    nonceStr: '',
    signature: ''
    // return gcapi('@gcwwwifc/getWechatTicket', {Url: location.origin + location.pathname + location.search})
  };
})
// .then(function (res) {
//   if (res) {
//     let data = res.body
//     if (data.code === 0) {
//       let shareUrl = Emkt.wxShareUrl
//       let sign = data.result
//       if (store.getters.hasLogin && store.state.sessionInfo.customerInfo.customerNo) {
//         let customerNo = store.state.sessionInfo.customerInfo.customerNo
//         shareUrl += '?introducer=' + customerNo
//       }
//       $.sign = {
//         shareUrl: shareUrl,
//         appId: sign.appId,
//         timestamp: +sign.timestamp,
//         nonceStr: sign.nonceStr,
//         signature: sign.signature
//       }
//     } else {
//       $.sign = {
//         shareUrl: '',
//         appId: '',
//         timestamp: 0,
//         nonceStr: '',
//         signature: ''
//       }
//     }
//   }
// })
// .then(function () {
//   // return gcapi('getBuyCart')
// })
// .then(function (res) {
//   if (Emkt.buyCartIsLocalStorage === false) {
//     // Emkt.setBuyCart('EmktBuyCart', store.state.sessionInfo.customerInfo)
//   }
// }
// .then(function () {
//   return gcapi('getSysParametersForAVVBlood')
// })
// .then(function (res) {
//   var BloodOptions = []
//   var BloodData = res.body.result
//   var BloodOptionsChoose = []
//   var specialBloodOptions = []
//   let BloodMaps = []
//   for (var i in BloodData) {
//     BloodOptions[BloodData[i].value] = BloodData[i].key
//     if (Emkt.extraBloodType.indexOf(BloodData[i].key) === -1) {
//       BloodOptionsChoose[BloodData[i].value] = BloodData[i].key
//     }
//     console.log(BloodData[i])
//     if (BloodData[i].wappCanUse === '1') {
//       specialBloodOptions[BloodData[i].value] = BloodData[i].key
//     }
//     BloodMaps[BloodData[i].key] = BloodData[i].organization
//   }
//   // console.log('BloodOptions', BloodOptions)
//   Emkt.setLocalStorage('BloodOptions', BloodOptions)
//   Emkt.setLocalStorage('BloodData', BloodData)
//   Emkt.setLocalStorage('BloodMaps', BloodMaps)
//   // console.log('BloodOptionsChoose', BloodOptionsChoose)
//   Emkt.setLocalStorage('BloodOptionsChoose', BloodOptionsChoose)
//   Emkt.setLocalStorage('SpecialBloodOptions', specialBloodOptions)
//   // console.log('SpecialBloodOptions---->', specialBloodOptions)
// })
.then(function () {
  // if (!Emkt.isWapp || Emkt.isSecPromotion) {
  return gcapi('getHotPromotions');
  // }
}).then(function (res) {
  // if (!Emkt.isWapp || Emkt.isSecPromotion) {
  if (res.body.result.length > 0) {
    getHotPromotions(res);
    getSecPromotion();
  } else {
    var promotions = [];
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktDiscounts', null);
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktShowPromotions', promotions);
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktPromotions', promotions);
  }
  // }
}).then(function (response) {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    var ShowPromotions = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getLocalStorage('EmktShowPromotions');
    if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].getters.hasLogin && __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerNo) {
      if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
        var showPromotionParam = {};
        showPromotionParam.bPromotions = ShowPromotions;
        showPromotionParam.customerNo = __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerNo;
        gcapi('ShowPromotions', showPromotionParam).then(function (res) {
          if (res.body.result === true) {
            var isshowPromotion = {};
            isshowPromotion.showPromotionParam = showPromotionParam;
            isshowPromotion.show = true;
            __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setLocalStorage('isshowPromotion', isshowPromotion);
          }
        });
      }
    }
  }
}).then(function (response) {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].getters.hasLogin && __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerNo) {
      gcapi('getRecommendation', __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerNo).then(function (res) {
        if (res.body.result.length > 0) {
          var i = 0;
          var list = [];
          var newlist = res.body.result;
          // console.log(res.body.result)
          if (newlist.length > 15) {
            for (i = 0; i < 15; i++) {
              list.push(newlist[i]);
            }
            __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktRecommendations', list);
          } else {
            __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktRecommendations', newlist);
          }
        }
      });
    }
  }
}).then(function () {
  console.log(__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlFullParamValue('QuoteId'));
  if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('fromSmart') === '1' && __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlFullParamValue('QuoteId')) {
    gcapi('getQuoteShoppingCart', __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlFullParamValue('QuoteId')).then(function (res) {
      if (res && res.body.code === 0 && res.body.result) {
        // if (store.state.sessionInfo.customerInfo.customerProperties && store.state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart) {
        //   let shoppingCart = store.state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart
        var list = JSON.parse(res.body.result.cartContent);
        console.log('cartContent', list);
        var ar = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(list).forEach(function (l) {
          console.log('isChecked', list[l].isChecked);
          if (list[l].isChecked) {
            ar.push(__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].convertProduct(list[l]));
          }
        });
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.checkList = ar;
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.cartList.cartContent = list;
        // }
      }
    });
  }
}).then(function () {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    return gcapi('getChannel');
  }
}).then(function (res) {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    if (res.body.result.length > 0) {
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktChannels', res.body.result);
    }
  }
})
// .then(function () {
//   if (!Emkt.isWapp) {
//     return gcapi('getAllToolVectors')
//   }
// })
// .then(function (res) {
//   if (!Emkt.isWapp) {
//     // console.log(res)
//     let toolVectors = res.body.result
//     console.log(toolVectors)
//     Emkt.setStoreItem('toolVectors', toolVectors)
//   }
// })
.then(function () {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    return gcapi('getCustData');
  }
}).then(function (res) {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    // console.log(res)
    var custdata = JSON.parse(res.body.result).custdata;
    // console.log(custdata)
    // let newData = initCustData(JSON.parse(JSON.stringify(custdata)), Emkt.getStoreItem('toolVectors'))
    // console.log('data', custdata, 'newData', newData)
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('custdata', custdata);
  }
}).then(function () {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    return gcapi('getBillInfoBlacklist');
  }
}).then(function (res) {
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktBillInfoBlacklist', res.body.result);
    // if (res.body.result !== null && store.state.sessionInfo.customerInfo.customerNo) {
    //   if (res.body.result.indexOf(store.state.sessionInfo.customerInfo.customerNo) !== -1) {
    //     store.state.showBillInfo = false
    //   } else {
    //     store.state.showBillInfo = true
    //   }
    // }
    // console.log(res)
  }
}).then(function () {
  if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('sso_processed') === '1') {
    return gcapi('getAllCustomizedMerchandise');
  }
}).then(function (res) {
  if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getUrlParamHref('sso_processed') === '1') {
    var merch = res.body.result[0];
    merch._curStep = 0;
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktCustomizedMerchandise', merch);
  }
})
// .then(function () {
//   var param = {}
//   param.text = ''
//   param.fromIndex = 0
//   param.findFilters = []
//   return gcapi('find', param)
// })
// .then(function (res) {
//   store.state.findFilters =
// })
// .then(function () {
//   $.getJSON('/static/dingz1.json', function (res) {
//     $.each(res, function (infoIndex, info) {
//       console.log(info)
//       Emkt.setStoreItem('dingzhi', info)
//     })
//   })
// })
// .then(function () {
//   return gcapi('getRecommendation', 'GUEST')
// })
// .then(function (res) {
//   if (res.body.result.length > 0) {
//     var mlist = []
//     mlist = res.body.result
//     var merchList = []
//     for (var n = 0; n < mlist.length; n = n + 3) {
//       var swaperlist = []
//       swaperlist.push(mlist[n])
//       swaperlist.push(mlist[n + 1])
//       swaperlist.push(mlist[n + 2])
//       merchList.push(swaperlist)
//     }
//     Emkt.setStoreItem('EmktRecommendations', merchList)
//   } else {
//     var recommendations = []
//     Emkt.setStoreItem('EmktRecommendations', recommendations)
//   }
// })
// .then(function () {
//   return gcapi('getApplicableMerchandiseLiteList', 'plain-1')
// })
// .then(function (res) {
//   if (res.body.result.length > 0) {
//     getApplicableMerchandiseLiteList(res)
//   } else {
//     var merchList = []
//     Emkt.setStoreItem('EmktPlain', merchList)
//   }
// })
.then(function () {
  var app = new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_8__App___default.a);
    }
  });
  window.app = app;
}).then(function () {
  if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].getters.hasLogin && __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo) {
    var customerNo = __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo.customerNo;
    // let customerNo = Emkt.testCustomerNo   // member '00224747'   leader '00198019'
    // 获取所有的课题组信息
    gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(function (res) {
      if (res && res.body.result) {
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.researchGroupMemberMap = res.body.result.bResearchGroupMemberMap;
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.researchGroupSet = res.body.result.bResearchGroupList;
        // console.log('researchGroupMemberMap', store.state.researchGroupMemberMap, store.state.researchGroupSet)
      }
    });

    // 过滤掉无效的任职关系
    gcapi('getWorkExperienceList', customerNo).then(function (res) {
      if (res && res.body.result) {
        var workList = res.body.result.filter(function (work) {
          return work.enable === true;
        });
        __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktWorkExperienceList', workList);
      } else {
        __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktWorkExperienceList', []);
      }
      // console.log('EmktWorkExperienceList', Emkt.getLocalStorage('EmktWorkExperienceList'))
    });
  }
  if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isWapp) {
    gcapi('getRecommended').then(function (response) {
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktAllRecommends', response.body.result);
    });
    if (__WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.sessionInfo.customerInfo) {
      gcapi('retrieveMyOrder').then(function (response) {
        var res = response.body;
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.myOrder = res.result;
      });
    }
  }
  // 课题组成员选择框
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#ResearchGroupMemberBox',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_10__views_User_MyResearchGroup_researchGroupComponents_ResearchGroupMemberBox___default.a);
    }
  });
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#SearxhBox',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_11__views_search_SearchBox___default.a);
    }
  });
  gcapi('gcwwwifc/listEnterprise').then(function (response) {
    if (response.body.result) {
      // 过滤出所有的一级单位信息
      var firstLevelEnterpriseList = response.body.result.filter(function (enterprise) {
        return enterprise.enterpriseLevel === 1;
      });
      var firstLevelInvoiceTitleMap = {};
      var enterpriseInvoiceTitleList = [];
      var enterpriseNoMap = {};
      firstLevelEnterpriseList.forEach(function (enterprise) {
        if (enterprise.enterpriseInvoiceTitle !== '' && enterprise.enterpriseInvoiceTitle !== undefined) {
          var firstLevelEnterprise = firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle];
          if (firstLevelEnterprise === undefined) {
            var invoiceTitleList = [];
            var invoice = {
              'enterpriseInvoiceTitle': enterprise.enterpriseInvoiceTitle
            };
            invoiceTitleList.push(enterprise);
            invoice.enterpriseList = invoiceTitleList;
            firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle] = invoice;
          } else {
            var _invoiceTitleList = firstLevelEnterprise.enterpriseList;
            _invoiceTitleList.push(enterprise);
            firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle] = firstLevelEnterprise;
          }
          var invoiceTitle = {
            'enterpriseInvoiceTitle': enterprise.enterpriseInvoiceTitle
          };
          if (!enterpriseInvoiceTitleList.includes(invoiceTitle) && enterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
            enterpriseInvoiceTitleList.push(invoiceTitle);
          }
          enterpriseNoMap[enterprise.enterpriseNo] = enterprise;
        }
      });
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktFirstLevelEnterpriseNoMap', enterpriseNoMap);
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktEnterpriseInvoiceTitleList', enterpriseInvoiceTitleList);
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktFirstLevelInvoiceTitleMap', firstLevelInvoiceTitleMap);
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktFirstLevelEnterpriseList', firstLevelEnterpriseList);
      // console.log('firstLevelEnterpriseMap', firstLevelInvoiceTitleMap)
      // console.log('EmktEnterpriseInvoiceTitleList', enterpriseInvoiceTitleList)
      new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
        el: '#EnterpriseBox',
        store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
        router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
        render: function render(h) {
          return h(__WEBPACK_IMPORTED_MODULE_9__components_EnterpriseBox___default.a);
        }
      });
      new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
        el: '#invoiceTitleBox',
        store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
        router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
        render: function render(h) {
          return h(__WEBPACK_IMPORTED_MODULE_14__views_search_invoiceTitleBox___default.a);
        }
      });
    }
  });
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#searchGeneBox',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_12__views_search_SearchGeneBox___default.a);
    }
  });
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#popuptextbox',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_13__views_search_PoPupTextBox___default.a);
    }
  });
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#searchFilterPanel',
    store: __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_15__views_Panel_SearchFilterPanel___default.a);
    }
  });

  __WEBPACK_IMPORTED_MODULE_20_jquery___default()(document).on('click', '.open-goods', function () {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('isPopUpOpen', true);
  });
  __WEBPACK_IMPORTED_MODULE_20_jquery___default()(document).on('click', '.close-popup', function () {
    __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('isPopUpOpen', false);
  });
  /*
  if (router.currentRoute !== undefined && router.currentRoute.name === 'welcome') {
    // console.log(router.currentRoute)
    router.replace('home')
  }
  */
}).catch(function (error) {
  // console.log('Initialization failed.')
  // console.log(error)
  var msg = error.message;
  __WEBPACK_IMPORTED_MODULE_20_jquery___default.a.toast(msg);
});

// function initCustData (custData, toolVectors) {
//   custData.forEach(data => {
//     if (data.name.indexOf('扩增') === -1 && data.name.indexOf('质粒抽提') === -1) {
//       data.TVInfo = toolVectors.filter(tv => {
//         let result = tv.contractType && tv.contractType.split(',').filter(item => item === data.name) || []
//           // console.log(tv.contractType && tv.contractType.split(','), result)
//         return result.length > 0
//       }
//       ).map(tv => ({value: tv.TLNo})) || []
//     }
//   })
//   return custData
// }
function getHotPromotions(res) {
  var discounts = [];
  var promotions = [];
  var showpromotions = [];
  var specialcouponpromotions = [];
  discounts = res.body.result;
  if (res.body.code !== 0) {
    return;
  }
  for (var i = 0; i < discounts.length; i++) {
    if (discounts[i].type !== 0) {
      promotions.push(discounts[i]);
    }
    if (discounts[i].type === 0) {
      __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktDiscounts', discounts[i]);
    }
    if (discounts[i].acknowledge === 1) {
      showpromotions.push(discounts[i]);
    }
    if (discounts[i].requiredCustomers === 1) {
      specialcouponpromotions.push(discounts[i]);
    }
  }
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktShowPromotions', showpromotions);
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktPromotions', promotions);
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktSpecialcouponpromotions', specialcouponpromotions);
}
function getSecPromotion() {
  var promotions = __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getLocalStorage('EmktPromotions');
  __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktSecPromotion', ''); // 全局唯一 监测秒杀是否结束
  var secInfoList = {};

  var _loop2 = function _loop2(promotion) {
    if (promotion.type === 6 || promotion.type === '6') {
      if (!__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].getLocalStorage('EmktSecPromotion')) {
        __WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].setStoreItem('EmktSecPromotion', promotion);
      }
      gcapi('getSeckillPromotion', promotion.promotionGuid).then(function (response) {
        var result = response.body.result;
        secInfoList[promotion.promotionGuid] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, promotion, result);
        __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */].state.secPromotionDetailObj = secInfoList; // 同一时刻所有的秒杀详情集合
        // console.log('store.state.secPromotionDetailObj', store.state.secPromotionDetailObj)
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(promotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var promotion = _step.value;

      _loop2(promotion);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
// function getApplicableMerchandiseLiteList (res) {
//   var mlist = []
//   mlist = res.body.result
//   var merchList = []
//   for (var n = 0; n < 9; n = n + 3) {
//     var swaperlist = []
//     swaperlist.push(mlist[n])
//     swaperlist.push(mlist[n + 1])
//     swaperlist.push(mlist[n + 2])
//     for (var i = 0; i < swaperlist.length; i++) {
//       var tags = []
//       var merchandiseMeta = Emkt.getEmktMetaData()
//       var tagsmap = merchandiseMeta.tagsMap
//       for (var j = 0; j < swaperlist[i].tagIds.length; j++) {
//         tags.push(tagsmap[swaperlist[i].tagIds[j]].tagLabel)
//       }
//       swaperlist.tags = tags
//       swaperlist[i].attrs = swaperlist[i]._attributesList
//     }
//     merchList.push(swaperlist)
//   }
//   Emkt.setStoreItem('EmktPlain', merchList)
// }
// for debug
function capi(func, para) {
  gcapi(func, para).then(function (response) {
    // return response
    // console.log(response.body)
  });
}
window.gcapi = gcapi;
window.capi = capi;
// console.log('Vue App created')
window.$ = __WEBPACK_IMPORTED_MODULE_20_jquery___default.a;
window.store = __WEBPACK_IMPORTED_MODULE_17__store_index__["a" /* default */];
// console.log('Emkt App created')

if (__WEBPACK_IMPORTED_MODULE_19__emkt__["a" /* default */].isDebug) {
  // 加载控制台
  var loadScript = function loadScript(url, callback) {
    var script = document.createElement('script');
    script.onload = function () {
      return callback();
    };
    script.src = url;
    document.body.appendChild(script);
  };

  loadScript('https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js', function () {
    var VConsole = window.VConsole;
    new VConsole();
  });
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = swiperAnimateCache;
/* harmony export (immutable) */ __webpack_exports__["b"] = swiperAnimate;
/* unused harmony export clearSwiperAnimate */
// animate.js
// https://www.its404.com/article/qq_41725450/112601375
function swiperAnimateCache() {
  var allBoxes = window.document.documentElement.querySelectorAll('.ani');
  for (var i = 0; i < allBoxes.length; i++) {
    allBoxes[i].attributes['style'] ? allBoxes[i].setAttribute('swiper-animate-style-cache', allBoxes[i].attributes['style'].value) : allBoxes[i].setAttribute('swiper-animate-style-cache', ' ');
    allBoxes[i].style.visibility = 'hidden';
  }
}

function swiperAnimate(swiper) {
  clearSwiperAnimate();
  var b = swiper.slides[swiper.activeIndex].querySelectorAll('.ani');
  for (var i = 0; i < b.length; i++) {
    b[i].style.visibility = 'visible';
    var effect = b[i].attributes['swiper-animate-effect'] ? b[i].attributes['swiper-animate-effect'].value : '';
    b[i].className = b[i].className + ' ' + effect + ' animate__animated';
    var duration = b[i].attributes['swiper-animate-duration'] ? b[i].attributes['swiper-animate-duration'].value : '';
    // duration && style
    var delay = b[i].attributes['swiper-animate-delay'] ? b[i].attributes['swiper-animate-delay'].value : '';
    var style = b[i].attributes['style'].value + 'animation-duration:' + duration + ';-webkit-animation-duration:' + duration + ';' + 'animation-delay:' + delay + ';-webkit-animation-delay:' + delay + ';';
    // delay && (style = style )
    b[i].setAttribute('style', style);
  }
}

function clearSwiperAnimate() {
  var allBoxes = window.document.documentElement.querySelectorAll('.ani');
  for (var i = 0; i < allBoxes.length; i++) {
    allBoxes[i].attributes['swiper-animate-style-cache'] && allBoxes[i].setAttribute('style', allBoxes[i].attributes['swiper-animate-style-cache'].value);
    allBoxes[i].style.visibility = 'hidden';
    allBoxes[i].className = allBoxes[i].className.replace('animated', ' ');
    var effectValue = allBoxes[i].attributes['swiper-animate-effect'].value;
    /* eslint-disable-next-line */
    allBoxes[i].attributes['swiper-animate-effect'] && (effectValue, allBoxes[i].className = allBoxes[i].className.replace(effectValue, ' '));
  }
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hookTime */
/* unused harmony export loader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wxShareConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);



// 打印钩子函数运行的时间
var hookTime = function hookTime(component, hookFnName) {
  var date = new Date();
  var m = date.getMinutes();
  var s = date.getSeconds();
  var ms = date.getMilliseconds();
  console.log(component + ' ' + hookFnName + ' ' + m + '-' + s + '-' + ms);
};

// 加载动画
var loader = {
  show: function show() {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ball-beat')[0]) {
      return;
    }
    var modalContainer = document.body;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(modalContainer).append('<div class="loader-inner ball-beat"><div></div><div></div><div></div></div>');
  },
  hide: function hide() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ball-beat').remove();
  }
};

// 微信分享配置
var wxShareConfig = function wxShareConfig(_ref, success, fail) {
  var title = _ref.title,
      desc = _ref.desc,
      link = _ref.link,
      imgUrl = _ref.imgUrl;

  console.log('wxShare Config:', link);
  __WEBPACK_IMPORTED_MODULE_1_wx___default.a.ready(function () {
    // “分享给朋友” 及“分享到QQ”
    __WEBPACK_IMPORTED_MODULE_1_wx___default.a.updateAppMessageShareData({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
    // “分享到朋友圈”及“分享到QQ空间”
    __WEBPACK_IMPORTED_MODULE_1_wx___default.a.updateTimelineShareData({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
    // 分享到腾讯微博
    __WEBPACK_IMPORTED_MODULE_1_wx___default.a.onMenuShareWeibo({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
  });
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {
      checkedData: '',
      questionUrl: '/emktResources/resocurces/img/question.png',
      blood: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('BloodOptionsChoose')
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'attrGroups'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['hardGeneInfo']), {
    options: function options() {
      var opt = this.attribute.options;
      var resArr = [];
      if (opt) {
        for (var data in opt) {
          resArr.push(parseInt(data));
        }
        return resArr;
      }
      return resArr;
    }
  }),
  methods: {
    getAfterText: function getAfterText(attribute) {
      var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' + '<input type="radio" class="radio-input-attr" name="attr" value="';
      var ret2 = '';
      var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var attr = this.attribute.options;
      var height = '';
      var length = 0;
      var tips = '';
      var BloodMaps = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('BloodMaps');
      for (var key in attr) {
        if (attribute.columnName === 'AAVBloodType') {
          tips = BloodMaps[attr[key]] && '<div class="blood-tips" style="font-size: 12px">' + BloodMaps[attr[key]] + '</div>' || '';
        }
        if (attribute.valueText === attr[key]) {
          ret2 += ret1 + key + ret4 + attr[key] + +tips + '</div></div></label></li>';
        } else {
          ret2 += ret1 + key + ret3 + attr[key] + tips + '</div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      return ret;
    },
    fetchData: function fetchData() {
      console.log(this.attribute);
      if (this.attribute.columnName === 'CustRemark_Required' && this.attribute.value === '1' || this.attribute.columnName === 'CustTlnoRemark_Required' && this.attribute.value === '1') {
        this.curAttrsInGroup[24].isNA = false;
      }
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.alert(val);
    },
    getTitle: function getTitle(attribute) {
      return attribute.label;
    },
    showOptionList: function showOptionList(attribute) {
      var _this = this;
      var chooseText = _this.getAfterText(attribute);
      if (this.attribute.label === "病毒滴度要求") {
        chooseText += "<div style='font-size:8px'>1E13不可选血清2、6 </div>";
      }
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: chooseText,
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
            }
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.radio-input-attr').on('click', function () {
        var val = void 0;
        var radio = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.radio-input-attr');
        for (var i = 0; i < radio.length; i++) {
          if (radio[i].checked) {
            val = radio[i].value;
          }
        }
        if (_this.attribute.value !== val) {
          _this.attribute.value = val;
          _this.checkedData = val;
          _this.valueChanged(attribute);
        }
        // 来源选择=非前合同，清空前合同的载体号
        if (_this.attribute.columnName === 'Source' && ['1', '2'].includes(_this.attribute.value)) {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('TLNo', null);
        }
        if (_this.curAttrsInGroup && _this.curAttrsInGroup.length === 26 && _this.index <= 4) {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('TLNo', null);
        }
        if (_this.attrGroups[0].attrs[2].value === '4') {
          _this.attrGroups[2].attrs[2].options = _this.blood;
          _this.attrGroups[2].attrs[2].isNA = false;
        }
        if (_this.attribute.columnName === 'Type' && _this.curAttrsInGroup[6].value.category === 3 && _this.curAttrsInGroup[6].value.ttttflag !== undefined && _this.curAttrsInGroup[6].value.ttttflag === 1) {
          alert('microRNA序列中存在连续4个T，需要更换海绵体方法进行构建，不可以继续进行下一步选择，详细邮件询问售前技术支持。');
        }
        if (_this.attribute.columnName === 'Tech' && _this.attribute.value === '1') {
          // 慢病毒>6000 || 腺病毒>6500 || 逆转录>4000 ||悬浮病毒6000 || 质粒>10000
          if (_this.curAttrsInGroup[2].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].TOOLTYPE_LENTIVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6000 || _this.curAttrsInGroup[2].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].TOOLTYPE_PLASMID && _this.curAttrsInGroup[6].value.CDSSize > 10000 || _this.curAttrsInGroup[2].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].TOOLTYPE_ADENOVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6500 || _this.curAttrsInGroup[2].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].TOOLTYPE_RETROVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 4000 || _this.curAttrsInGroup[2].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].TOOLTYPE_FLOATVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6000) {
            _this.$weui.alert('您所选择的基因，超出该合同类型的构建或包装极限，公司无法接入，请咨询售前如何实现客户需求，无法加入购物车，或重新选择基因');
          }
        }
        if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0 && _this.attribute.sortOrder > 70) {
          //选完调控技术后开始判断拦截
          var hardHeneGo = true;
          var hardGenecontent = {};
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.hardGeneInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var hardGene = _step.value;

              if (hardGene.level === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].HardGeneLevelNo1) {
                // 合同大类检查调控技术 和靶点设计方案
                if (hardGene.contractType !== undefined && hardGene.contractType) {
                  //有hardGene
                  if (_this.curAttrsInGroup[12].value && hardGene.tech.includes(_this.curAttrsInGroup[12].value)) {
                    if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                      if (_this.curAttrsInGroup[13].value && hardGene.targetSupplier.includes(_this.curAttrsInGroup[13].value)) {
                        hardGenecontent = hardGene;
                        hardHeneGo = false;
                      }
                    } else {
                      hardHeneGo = false;
                      hardGenecontent = hardGene;
                      break;
                    }
                  }
                  // if(_this.attribute.columnName === 'TemplateSource') {
                  //   //有hardGene
                  //   if (_this.curAttrsInGroup[12].value && hardGene.tech.includes(_this.curAttrsInGroup[12].value )) {
                  //     if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                  //       if (_this.curAttrsInGroup[13].value  && hardGene.targetSupplier.includes(_this.curAttrsInGroup[13].value)) {
                  //         hardHeneGo = false
                  //       }
                  //     } else {
                  //       hardHeneGo = false
                  //     }
                  //   }
                  // }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!hardHeneGo) {
            _this.$weui.alert(hardGenecontent.infeasibilityStatement + '，' + hardGenecontent.solution);
          }
        }
        if (_this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '0') {
          alert('请告知由客户寄送实物，或者来源于客户其他合同号');
        }
        if (_this.attribute.columnName === 'CustRemark_Required' && _this.attribute.value === '1' || _this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '1') {
          _this.curAttrsInGroup[24].isNA = false;
        }
        if (_this.attribute.columnName === 'CustRemark_Required' && _this.attribute.value === '0' || _this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '0') {
          _this.curAttrsInGroup[24].isNA = true;
        }
        console.log('attrGroups', _this.attrGroups);
        //工具类型为腺相关病毒
        if (_this.attrGroups[0].attrs[26].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].VIRUSTITER1E13 && _this.attribute.columnName === 'AAVBloodType' && (_this.attribute.value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].AAVBLOODTYPESIX || _this.attribute.value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].AAVBLOODTYPETWO)) {
          _this.$weui.alert("该血清型无法做到1E13的滴度，请重新按要求选择");
          _this.attribute.value = '-1';
        }
        //DR20231019001
        // if(_this.attrGroups[0].attrs[26].value === Emkt.VIRUSTITER5E12 && _this.attribute.columnName === 'AAVBloodType'){
        //   if(!( _this.attribute.value === Emkt.AAVBLOODTYPESIX || _this.attribute.value === Emkt.AAVBLOODTYPETWO) && _this.attribute.value != '-1'){
        //     _this.$weui.alert("5E12的滴度只允许选择2、6血清型，请重新按要求选择")
        //   _this.attribute.value = '-1'
        //   }
        // }
        var VIRUSTITER1E12 = '3'; // 病毒滴度为1E12
        var LVAMOUNT1E12 = '25'; // 目的病毒总量为1E12
        var LVAMOUNT5E12 = '26'; // 目的病毒总量为5E12
        var LVAMOUNT1E11 = '23'; // 目的病毒总量为5E12
        var LVAMOUNT5E11 = '24'; // 目的病毒总量为5E12
        if (_this.attrGroups[0].attrs[26].value === VIRUSTITER1E12 && _this.attribute.columnName === 'LVAmount') {
          if (![LVAMOUNT1E12, LVAMOUNT5E12, LVAMOUNT1E11, LVAMOUNT5E11].includes(_this.attribute.value)) {
            _this.$weui.alert("1E12的滴度只能选择1E12、5E12、1E11、5E11的目的病毒总量，请重新按要求选择");
            _this.attribute.value = '-1';
          }
        }
        if (_this.attribute.columnName === 'LVAmount' && [LVAMOUNT1E11, LVAMOUNT5E11].includes(_this.attribute.value)) {
          if (_this.attrGroups[0].attrs[26].value !== VIRUSTITER1E12) {
            _this.$weui.alert("1E11、5E11的目的病毒总量只能选择1E12的滴度，请重新按要求选择");
            _this.attribute.value = '-1';
          }
        }
        var CONTRACTTYPENC = '2'; // 合同类型为对照产品
        var NCLVAMOUNTNONE = '6'; // 无需对照
        var NCLVAMOUNT1E12 = '25'; // 对照病毒总量为1E12
        var NCLVAMOUNT5E12 = '26'; // 对照病毒总量为5E12
        if (_this.attrGroups[0].attrs[26].value === VIRUSTITER1E12 && _this.attribute.columnName === 'NC_LV_Amount') {
          if (![NCLVAMOUNT1E12, NCLVAMOUNT5E12, NCLVAMOUNTNONE, LVAMOUNT1E11, LVAMOUNT5E11].includes(_this.attribute.value)) {
            _this.$weui.alert("1E12的滴度只能选择无需对照、1E12、5E12、1E11、5E11的对照病毒总量，请重新按要求选择");
            _this.attribute.value = '-1';
          }
        }
        if (_this.attrGroups[0].attrs[0].value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].AMPLIFICATION && _this.attribute.columnName === 'Source' && _this.attribute.value === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CUSTOMERPROVIDED) {
          _this.$weui.alert("客户提供质粒用于病毒包装，公司不承诺滴度及出毒总量，仅提供实际出毒，请知悉风险");
        }
        if (_this.attribute.columnName === 'ContractType' && (_this.curAttrsInGroup[0].value === '3' || _this.curAttrsInGroup[0].value === '4')) {
          _this.gcapi('searchContractNo', null).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('contractNO', null);
            __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('target', null);
            __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('contractNO', response.body.result);
          });
        } else if (_this.attribute.columnName === 'ContractType' && (_this.curAttrsInGroup[0].value !== '3' || _this.curAttrsInGroup[0].value !== '4')) {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('TLNo', null);
        }
        if (_this.attribute.columnName === 'ToolType' && _this.curAttrsInGroup[0].value === '3') {
          var newContractNos = [];
          setTimeout(function () {}, 2000);
          var contractNos = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('contractNO');
          //            console.log(contractNos)
          if (contractNos) {
            if (_this.attribute.value === '3') {
              newContractNos = [];
              for (var no1 in contractNos) {
                if ((contractNos[no1].split(':')[0].indexOf('A') !== -1 || contractNos[no1].split(':')[0].indexOf('GCI') !== -1) && contractNos[no1].split(':')[0].indexOf('GVAP') === -1) {
                  newContractNos.push(contractNos[no1]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
              //                _this.gcapi('searchPreContract', 'GIDL0119920').then(function (response) {
              //                  if (response.body.result.labelNames !== undefined) {
              //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
              //                  }
              //                })
            } else if (_this.attribute.value === '4') {
              newContractNos = [];
              for (var no in contractNos) {
                if ((contractNos[no].split(':')[0].indexOf('V') !== -1 || contractNos[no].split(':')[0].indexOf('GCI') !== -1) && contractNos[no].split(':')[0].indexOf('GVAP') === -1) {
                  newContractNos.push(contractNos[no]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
            } else if (_this.attribute.value === '2') {
              newContractNos = [];
              for (var no4 in contractNos) {
                if (contractNos[no4].indexOf('病毒') !== -1 || contractNos[no4].indexOf('质粒') !== -1 || contractNos[no4].indexOf('shRNA') !== -1 || contractNos[no4].split(':')[0].indexOf('GCI') !== -1) {
                  newContractNos.push(contractNos[no4]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
            } else if (_this.attribute.value === '1') {
              newContractNos = [];
              for (var no2 in contractNos) {
                if (contractNos[no2].split(':')[0].indexOf('L') !== -1 || contractNos[no2].split(':')[0].indexOf('GCI') !== -1) {
                  newContractNos.push(contractNos[no2]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
              //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
              //                  if (response.body.result.labelNames !== undefined) {
              //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
              //                  }
              //                })
            } else if (_this.attribute.value === '6') {
              newContractNos = [];
              for (var no5 in contractNos) {
                if (contractNos[no5].split(':')[0].indexOf('R') !== -1) {
                  newContractNos.push(contractNos[no5]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
              //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
              //                  if (response.body.result.labelNames !== undefined) {
              //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
              //                  }
              //                })
            } else if (_this.attribute.value === '7') {
              newContractNos = [];
              for (var no6 in contractNos) {
                if (contractNos[no6].split(':')[0].indexOf('GOSL') !== -1 || contractNos[no6].indexOf('慢病毒') !== -1 || contractNos[no6].indexOf('悬浮专用') !== -1 || contractNos[no6].indexOf('悬浮细胞专用') !== -1) {
                  newContractNos.push(contractNos[no6]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos);
              //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
              //                  if (response.body.result.labelNames !== undefined) {
              //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
              //                  }
              //                })
            } else {
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', contractNos);
            }
          }
        }
        if (_this.attribute.columnName === 'RequiredGoods' && _this.curAttrsInGroup[0].value === '4') {
          var newContractNos1 = [];
          var contractNos1 = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('contractNO');
          if (contractNos1) {
            if (_this.attribute.value === '3' || _this.attribute.value === '4' || _this.attribute.value === '5') {
              newContractNos1 = [];
              for (var no3 in contractNos1) {
                if (contractNos1[no3].split(':')[0].indexOf('GCEL') !== -1 || contractNos1[no3].split(':')[0].indexOf('GCZL') !== -1) {
                  newContractNos1.push(contractNos1[no3]);
                }
              }
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', null);
              __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('newContractNos', newContractNos1);
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.closeModal();
        if (_this.attribute.columnName === 'AAVBloodType') {
          if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('xueQingXing') !== null && __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('xueQingXing') !== undefined && _this.attribute.value !== undefined) {
            if (_this.attribute.value.toString() !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('xueQingXing').toString()) {
              __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
                title: '请核对',
                afterText: '<div>订单选择的血清型与前合同' + _this.attribute.options[__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('xueQingXing')] + '不同，如果确定更换血清型，请点确认,否则请重新选择！</div>',
                buttons: [{
                  text: '重新选择',
                  bold: true,
                  onClick: function onClick() {}
                }, {
                  text: '确认',
                  bold: true,
                  onClick: function onClick() {
                    __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('xueQingXing', null);
                  }
                }]
              });
            }
          }
        }
      });
    },
    valueChanged: function valueChanged(attribute) {
      this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute);
      //        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
    }
    //      ,
    //      getKeyByValue (value) {
    //        let obj = this.attribute.options
    //        for (var prop in obj) {
    //          if (obj.hasOwnProperty(prop)) {
    //            if (obj[prop] === value) {
    //              return prop
    //            }
    //          }
    //        }
    //      }

  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = this.attribute.options[val];
      if (!this.$route.query.cust) {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute);
      }
    }
    //      ,
    //      attribute: {
    //        handler: function (val) {
    //          this.attribute.value = this.getKeyByValue(val)
    //        },
    //        deep: true
    //      }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-gene-box',
  data: function data() {
    return {
      attributevalueText: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'customAttrs'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    options: function options() {
      if (this.attribute.options) {
        return this.attribute.options;
      }
      return {};
    },
    attrOptions: function attrOptions() {
      var attr = this.curAttrsInGroup;
      var resList = [];
      for (var i in attr) {
        if (attr[i].customizable === 0 && attr[i].columnName.indexOf('TVInfo.') < 0) {
          resList.push(attr[i]);
        }
      }

      return resList;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['geneSearchResult'])),
  methods: {
    fetchData: function fetchData() {
      /*
      if (this.geneSearchResult['/custOrder']) {
        this.attributevalueText = this.geneSearchResult['/custOrder'].data.symbol
      } else {
        this.attributevalueText = this.attribute.value.symbol
      }
      */
    }
  },
  watch: {
    'geneSearchResult': function geneSearchResult(val) {
      var data = val['/custOrder'].data;
      var dictionary = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      data['taxName'] = dictionary[61033][data.taxId].dictValue;
      if (data.CDSSize === 0 || data.CDSSize === null) {
        this.$weui.alert('您所选择的基因大小为0，请联系售前修改！');
        return;
      }
      this.attribute.value = data;
      this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
      this.customAttrs['GeneInfo.NMID'].value = data.NMID;
      this.customAttrs['GeneInfo.NMID'].valueText = data.NMID;
      this.customAttrs['GeneInfo.CDSSize'].value = data.CDSSize;
      this.customAttrs['GeneInfo.CDSSize'].valueText = data.CDSSize;
      this.customAttrs['GeneInfo.symbol'].value = data.symbol === undefined ? data.microNo : data.symbol;
      this.customAttrs['GeneInfo.symbol'].valueText = data.symbol === undefined ? data.microNo : data.symbol;
      this.customAttrs['GeneInfo.taxId'].value = data.taxId;
      this.customAttrs['GeneInfo.taxId'].valueText = dictionary[61033][data.taxId].dictValue;
      //        if (this.curAttrsInGroup[7].value === '') {
      //          this.curAttrsInGroup[7].value = this.customAttrs['GeneInfo.symbol'].value
      //          this.curAttrsInGroup[7].valueText = this.customAttrs['GeneInfo.symbol'].valueText
      //        }
      //        if (this.curAttrsInGroup[8].value === '') {
      //          this.curAttrsInGroup[8].value = this.customAttrs['GeneInfo.NMID'].value
      //          this.curAttrsInGroup[8].valueText = this.customAttrs['GeneInfo.NMID'].valueText
      //        }
      //        if (this.curAttrsInGroup[9].value === '') {
      //          this.curAttrsInGroup[9].value = this.customAttrs['GeneInfo.taxId'].value
      //          this.curAttrsInGroup[9].valueText = this.customAttrs['GeneInfo.symbol'].valueText
      //        }
      //        if (this.curAttrsInGroup[10].value === '') {
      //          this.curAttrsInGroup[10].value = this.customAttrs['GeneInfo.CDSSize'].value
      //          this.curAttrsInGroup[10].valueText = this.customAttrs['GeneInfo.CDSSize'].valueText
      //        }
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-gene-box',
  data: function data() {
    return {};
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {
    options: function options() {
      if (this.attribute.options) {
        return this.attribute.options;
      }
      return {};
    }
  },
  methods: {},
  watch: {}
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-number-box',
  data: function data() {
    return {};
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {},
  watch: {
    'attribute.value': function attributeValue(val) {
      if (val !== '') {
        if (val.replace(/[^\d]/g, '') === '') {
          alert('请您填写数字');
        }
      }
      if (this.attribute.columnName === 'PlasmidNumber' && val > 1) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          title: '请核对',
          afterText: '<div>请确认客户所提供的质粒抗性都相同，否则不同抗性的质粒请单独录入订单合同。</div>',
          buttons: [{
            text: '不确定',
            bold: true,
            onClick: function onClick() {
              alert('请您重新选择！');
            }
          }, {
            text: '确定',
            bold: true,
            onClick: function onClick() {
              _this.attribute.valueText = val;
              _this.$emit('controlForm', _this.index, _this.curAttrsInGroup, _this.attribute);
            }
          }]
        });
      } else {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute);
      }
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-tv-box',
  data: function data() {
    return {
      tvOptions: [],
      searchdata: '',
      serarchOptions: [],
      // 当查询不到载体时，此变量为true，表示只显示空的筛选结果
      onlyShowSearchOptions: false,
      blood: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('BloodOptionsChoose'),
      TVInfoFilters: {
        selectedWQFlag: -1,
        selectedTag1ID: -1,
        selectedEuRID: -1,
        selectedTag2ID: -1,
        selectedTag5ID: -1
      },
      filterOptionAttributes: [{ attribute: 'WQFlag', name: '级别', data: 'selectedWQFlag' }, { attribute: 'tag1ID', name: '荧光蛋白', data: 'selectedTag1ID' }, { attribute: 'eu_RID', name: '真核抗性', data: 'selectedEuRID' }, { attribute: 'tag2ID', name: '融合标签', data: 'selectedTag2ID' }, { attribute: 'tag5ID', name: '启动子类型', data: 'selectedTag5ID' }],
      // erp-typeID： WQFlag=1694  tag1ID，tag2ID=1647   eu_RID=1645  tag5ID=1985
      filterOptions: {
        'WQFlag': [{ text: '请选择', value: -1 }, { text: '推荐', value: 1 }, { text: '常用', value: '2,4' }, { text: '不常用', value: 3 }],
        'tag1ID': [{ text: '请选择', value: -1 }, { text: '无荧光', value: -999 }, { text: 'GFP（绿色）', value: '0,5,7,24' }, { text: 'RFP（红色）', value: 1 }, { text: 'dsRED（红色）', value: 6 }, { text: 'cherry（红色）', value: 4 }, { text: 'firefly_Luciferase（荧光素酶）', value: 8 }, { text: 'Renilla _Luciferase（海肾荧光素酶）', value: 13 }, { text: 'firefly_Luciferase+Renilla_Luciferase（双荧光素酶）', value: 23 }, { text: '其他', value: 999 }],
        'eu_RID': [{ text: '请选择', value: -1 }, { text: 'Puromycin(嘌呤)', value: 2 }, { text: 'Neomycin(新霉素)', value: 0 }, { text: 'Hygromycin(潮霉素)', value: 1 }, { text: 'Blasticidin(杀稻瘟菌素)', value: 5 }],
        'tag2ID': [{ text: '请选择', value: -1 }, { text: '独立表达', value: -999 }, { text: '融合荧光', value: '1,6,7,20' }, { text: '融合标签', value: '14,15,16,21' }],
        'tag5ID': [{ text: '请选择', value: -1 }, { text: '广谱启动子', value: 0 }, { text: '特异性启动子', value: 1 }]
      }
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'attrGroups'],
  mounted: function mounted() {
    this.tvOptionsHandler();
  },
  created: function created() {},

  computed: {
    tvInfo: function tvInfo() {
      var opt = [];
      this.serarchOptions = [];
      this.tvOptions.forEach(function (data) {
        var obj = {};
        for (var i in data) {
          obj[i] = data[i];
        }
        opt.push(obj);
      });
      // let group = this.curAttrsInGroup
      // for (var j in opt) {
      //   for (var i in group) {
      //     let colName = group[i].columnName
      //     let name = colName.substring(7, colName.length)
      //     let info = opt[j][name]
      //     if (info) {
      //       let val = group[i].options
      //       if (val) {
      //         opt[j][name] = val[info]
      //       }
      //     }
      //   }
      // }
      //        if (opt && opt.length < 1) {
      //          Emkt.setLocalStorage('TLNo', null)
      //        }
      var data = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('TLNo');
      if (data !== undefined && data !== null && opt.length > 0) {
        var newopt = [];
        //          for (var k in opt) {
        //            if (opt[k].TLNo.indexOf(data) !== -1) {
        //              newopt.push(opt[k])
        //              Emkt.setLocalStorage('TLNo', null)
        //            }
        //          }
        var d = {};
        d.TLNo = data;
        newopt.push(d);
        //          Emkt.setLocalStorage('TLNo', null)
        return newopt;
      } else {
        return opt;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_CUST_REMARK', 'UPDATE_CUST_REMARK1']), {
    control: function control(val) {
      if (this.attrGroups && val.RNAiEffect && val.RNAiEffect !== '0') {
        if (this.attrGroups[0].attrs[10].value > parseInt(val.RNAiEffect)) {
          if (this.attrGroups[0].attrs[12].value === '1') {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出载体包装容量，请咨询售前解决方案!');
          } else if (this.attrGroups[0].attrs[13].value === '2' || this.attrGroups[0].attrs[13].value === '3') {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出合同承诺有效靶点大小范围，请确认风险!');
          } else if (this.attrGroups[0].attrs[12].value === '2' || this.attrGroups[0].attrs[12].valueText !== undefined && this.attrGroups[0].attrs[13].valueText.indexOf('Cas9') !== -1) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出承诺，请咨询售前解决方案!');
          }
          //            alert('基因的CDS大小' + this.attrGroups[0].attrs[9].value + '超过载体的包装容量!请选择其他载体或重新选择基因!')
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('isnext', true);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('isnext', true);
        }
      }
      if (this.attrGroups && (this.attrGroups[0].attrs[6].value.category === 3 || this.attrGroups[0].attrs[6].value.category === 2) && this.attrGroups[0].attrs[6].value.ttttflag !== undefined && this.attrGroups[0].attrs[6].value.ttttflag === 1 && val.TTTTFlag !== undefined && val.TTTTFlag === 0) {
        this.$weui.alert('您选择的miRNA存在4个连续的T，使用U6启动子构建有提前转录终止的可能，建议您返回上一步重新选择启动子为Ubi，CMV等二型启动子的载体');
        __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('isnext', false);
      }
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
      console.log(this.attrGroups);
      if (this.attribute.value === 'GV127' || this.attribute.value === 'GV311' || this.attribute.value === 'CV032' || this.attribute.value === 'CV253' || this.attribute.value === 'CV033' || this.attribute.value === 'CV271' || this.attribute.value === 'CV604' || this.attribute.value === 'CV232' || this.attribute.value === 'CV627' || this.attribute.value === 'CV627' || this.attribute.value === 'CV252' || this.attribute.value === 'CV104') {
        this.attrGroups[2].attrs[23].isNA = false;
        this.UPDATE_CUST_REMARK('请提供改造合同号');
        this.UPDATE_CUST_REMARK1('');
      } else {
        this.attrGroups[2].attrs[23].isNA = true;
        this.UPDATE_CUST_REMARK('请填写具体靶点序列或靶点编号或合同号');
        this.UPDATE_CUST_REMARK1('请避开以下靶点:');
      }
      if (this.attrGroups[0].attrs[13].value === '2' || this.attrGroups[0].attrs[13].value === '7') {
        if (this.attrGroups[0].attrs[0].value === '1' && this.attrGroups[0].attrs[10].value === '2' && this.attrGroups[0].attrs[11].value === '2') {
          this.attrGroups[2].attrs[22].isNA = true;
        } else {
          this.attrGroups[2].attrs[22].isNA = false;
        }
      }
      if (this.attrGroups[0].attrs[2].value === '4') {
        this.attrGroups[2].attrs[2].options = this.blood;
        this.attrGroups[2].attrs[2].isNA = false;
      }
    },
    searchTVByKeyword: function searchTVByKeyword() {
      var data = this.searchdata;
      var updateSerarchOptions = [];
      for (var i = 0; i < this.serarchOptions.length; i++) {
        if (this.serarchOptions[i].TLNo && this.serarchOptions[i].TLNo.indexOf(data.toUpperCase()) !== -1 || this.serarchOptions[i].elementSeq && this.serarchOptions[i].elementSeq.toLowerCase().indexOf(data.toLowerCase()) !== -1 || this.serarchOptions[i].promoterAAV && this.serarchOptions[i].promoterAAV.indexOf(data) !== -1) {
          updateSerarchOptions.push(this.serarchOptions[i]);
        }
      }
      this.serarchOptions = updateSerarchOptions;
    },
    tvOptionsHandler: function tvOptionsHandler() {
      // debugger
      var param = this.attribute.options;
      console.log(this.attrGroups);
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showIndicator();
      this.gcapi('getToolVectorsByTLNos', param).then(function (res) {
        var body = res.body;
        _this.tvOptions = body.result;
        _this.tvOptions.sort(function (a, b) {
          return a.WQFlag - b.WQFlag;
        });
        _this.tvOptions = _this.tvOptions.filter(function (tv) {
          var gene = _this.attrGroups[0].attrs[6].value;
          var canUse = true;
          if (gene) {
            var geneCategory = gene.geneCategory;
            if (geneCategory) {
              var recommendGeneTypeUse = true;
              var availableGeneType = true;
              if (tv.recommendGeneType !== undefined) {
                if (!tv.recommendGeneType.includes(geneCategory)) {
                  recommendGeneTypeUse = false;
                }
              } else {
                recommendGeneTypeUse = undefined;
              }
              if (tv.availableGeneType !== undefined) {
                if (!tv.availableGeneType.includes(geneCategory)) {
                  availableGeneType = false;
                }
              } else {
                availableGeneType = undefined;
              }
              if (recommendGeneTypeUse === false && availableGeneType === false || recommendGeneTypeUse === undefined && availableGeneType === false || availableGeneType === undefined && recommendGeneTypeUse === false) {
                canUse = false;
              }
            }
          }
          if (canUse) {
            var expresstionTest = tv.expresstionTest;
            if (expresstionTest !== '' && expresstionTest !== undefined && _this.attrGroups[0].attrs[19].value.toString() !== '-1') {
              if (!expresstionTest.includes(_this.attrGroups[0].attrs[19].value)) {
                canUse = false;
              }
            }
            if (_this.attrGroups[0].attrs[19].value.toString() !== '-1' && (expresstionTest === '' || expresstionTest === undefined)) {
              canUse = false;
            }
          }
          if (canUse) {
            var inducingTest = tv.inducingTest;
            if (inducingTest !== '' && inducingTest !== undefined && _this.attrGroups[0].attrs[20].value.toString() !== '-1') {
              if (!inducingTest.includes(_this.attrGroups[0].attrs[20].value)) {
                canUse = false;
              }
            }
            if (_this.attrGroups[0].attrs[20].value.toString() !== '-1' && (inducingTest === '' || inducingTest === undefined)) {
              canUse = false;
            }
          }
          return canUse;
        });
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hideIndicator();
        }, 300);
      });
    },
    changePeriod: function changePeriod() {
      if (this.attribute.value === '' && __WEBPACK_IMPORTED_MODULE_1_jquery___default()("input[type='radio']:checked").val() !== undefined && __WEBPACK_IMPORTED_MODULE_1_jquery___default()("input[type='radio']:checked").val() !== '') {
        this.attribute.value = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("input[type='radio']:checked").val();
        this.GoNext(__WEBPACK_IMPORTED_MODULE_1_jquery___default()("input[type='radio']:checked").val());
      }
    },
    GoNext: function GoNext(val) {
      __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('isnext', true);
      this.attribute.valueText = val;
      var group = this.curAttrsInGroup;
      var tvInfo = this.tvOptions;
      var checkedTvInfo = {};
      for (var j in tvInfo) {
        if (tvInfo[j].TLNo === val) {
          checkedTvInfo = tvInfo[j];
        }
      }
      for (var i in group) {
        var colName = group[i].columnName;
        var info = checkedTvInfo[colName.substring(7, colName.length)];
        if (info !== undefined) {
          group[i].value = info;
          var opt = group[i].options;
          if (opt) {
            group[i].valueText = opt[info];
          } else {
            group[i].valueText = info;
          }
        } else if (colName !== 'TVInfo') {
          group[i].value = -1;
          group[i].valueText = 'NA';
        }
      }
      //        Emkt.setLocalStorage('TLNo', null)
      this.control(checkedTvInfo);
      //        if (!this.$route.query.cust) {
      //          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
      //        }
    },

    /* eslint-disable */
    filterTVOptions: function filterTVOptions(val) {
      var _this2 = this;

      console.log('watch TVInfoFilters', val, this.tvInfo);
      var validFilters = {};

      var _loop = function _loop(key) {
        if (val[key] !== -1) {
          var targetOptionAttribute = _this2.filterOptionAttributes.find(function (option) {
            return option.data === key;
          });
          var targetAttribute = targetOptionAttribute && targetOptionAttribute.attribute;
          validFilters[targetAttribute] = val[key];
        }
      };

      for (var key in val) {
        _loop(key);
      }
      console.log('validFilters', validFilters);
      this.serarchOptions = this.tvInfo.filter(function (tv) {
        for (var attr in validFilters) {
          var selectedValue = validFilters[attr];
          var tvAttrValue = tv[attr];
          // 判断属性值是否为空  为空：value !== 0 && value === null/undefined
          if (selectedValue === -999) {
            if (tvAttrValue === 0 || !!tvAttrValue) {
              return false;
            }
          }
          // 判断"其他"类型，即非选项中包含的其他枚举值
          else if (selectedValue === 999) {
              var inValidOptions = _this2.filterOptions[attr].filter(function (option) {
                return ![999, -999, -1].includes(option.value);
              }).map(function (op) {
                return op.value;
              });
              console.log('inValidOptions', inValidOptions);
              if (inValidOptions.includes(tvAttrValue)) {
                return false;
              }
            } else {
              var selectedValues = String(validFilters[attr]).split(",");
              if (!selectedValues.includes(String(tvAttrValue))) {
                return false;
              }
            }
        }
        return true;
      });
      // 根据输入的关键字搜索载体信息
      if (this.searchdata !== '') {
        this.searchTVByKeyword();
      }
      if (this.serarchOptions.length === 0) {
        this.onlyShowSearchOptions = true;
        alert('查询结果无此载体！');
      }
      console.log('filterTVOptions serarchOptions：', this.serarchOptions);
    },
    showCustomMade: function showCustomMade(WQFlag) {
      console.log('WQFlag:', WQFlag);
      console.log('attrs:', this.attrGroups[0].attrs[0]);
      console.log('value:', this.attrGroups[0].attrs[0].value);
      console.log('showCustomMade:', WQFlag === 3 && this.attrGroups && (this.attrGroups[0].attrs[0].value !== '1' || this.attrGroups[0].attrs[0].value !== '4'));
      return !(WQFlag === 3 && this.attrGroups && (this.attrGroups[0].attrs[0].value === '1' || this.attrGroups[0].attrs[0].value === '4'));
    }
  }),
  watch: {
    'attribute.value': function attributeValue(val) {
      this.GoNext(val);
    },
    'TVInfoFilters': {
      handler: 'filterTVOptions',
      deep: true
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-textarea-box',
  data: function data() {
    return {
      textareaData: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['remarkData'])),
  methods: {
    getAfterText: function getAfterText(attribute) {
      var ret = '<div class="modal-class" style="overflow-y: scroll; display: flex">' + ' <div style="margin: auto;">' + ' <textarea placeholder="请输入..." id="textarea-input-attr" style="height: 8rem;width: 12rem;background-color: #FFFFFF;border: 1px solid #E9E9E9;"></textarea>' + ' </div>' + ' </div>';
      return ret;
    },
    getTitle: function getTitle(attribute) {
      return attribute.label;
    },
    control: function control(attribute) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.textareaData) {
              _this.attribute.value = _this.textareaData;
              //                  _this.attribute.valuetext = _this.textareaData
            }
          }
        }, {
          text: '确定',
          bold: true,
          onClick: function onClick() {
            var textarea = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#textarea-input-attr');
            var val = textarea.val();
            _this.attribute.value = val;
            //                _this.attribute.valuetext = val
            _this.textareaData = val;
          }
        }]
      });
      if (attribute.value) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#textarea-input-attr').val(attribute.value);
      }
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    },
    'remarkData': function remarkData(val) {
      var data = val['/custOrder'].data;
      //        let dictionary = Emkt.getEmktMetaData().dictionariesMap
      //        data['taxName'] = dictionary[61033][data.taxId].dictValue
      this.attribute.value = data;
      this.attribute.valueText = data;
      //        this.$emit('controlForm', this.index, this.curAttrsInGroup)
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {
      textareaData: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {
    getAfterText: function getAfterText(attribute) {
      var ret = '<div class="modal-class" style="overflow-y: scroll; display: flex">' + ' <div style="margin: auto;">' + ' <textarea placeholder="请输入..." id="textarea-input-attr" style="height: 8rem;width: 12rem;background-color: #FFFFFF;border: 1px solid #E9E9E9;"></textarea>' + ' </div>' + ' </div>';
      return ret;
    },
    getTitle: function getTitle(attribute) {
      return attribute.label;
    },
    control: function control(attribute) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.textareaData) {
              _this.attribute.value = _this.textareaData;
              //                  _this.attribute.valuetext = _this.textareaData
            }
          }
        }, {
          text: '确定',
          bold: true,
          onClick: function onClick() {
            var textarea = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#textarea-input-attr');
            var val = textarea.val();
            _this.attribute.value = val;
            //                _this.attribute.valuetext = val
            _this.textareaData = val;
          }
        }]
      });
      if (attribute.value) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#textarea-input-attr').val(attribute.value);
      }
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {};
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {
    control: function control() {
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {
      checkedData: '',
      questionUrl: '/emktResources/resocurces/img/question.png',
      serarchOptions: [],
      serarchcustomerOptions: [],
      searchdata: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'attrGroups'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: {},
  methods: {
    fetchData: function fetchData() {},
    getAfterText: function getAfterText(attribute) {
      this.attribute.options = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos');
      var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' + '<input type="radio" class="radio-input-attr"  name="attr" value="';
      var ret2 = '';
      var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret5 = '<div style="font-size: small">';
      var ret6 = '  <div class="searchbar row" id="showsearch"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput" placeholder="合同号／合同名称" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="searchContract"><span class="icon icon-search"></span></a> </div>';
      var ret7 = '  <div class="searchbar row" id="showsearchcushomer"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput1" placeholder="客户编号" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="searchcustomerContract"><span class="icon icon-search"></span></a> </div>';
      var ret8 = '  <div class="searchbar row" id="customerinput"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="yuancontract" placeholder="常规试剂合同号(原合同说明)" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="customerContract" style="width: 15%"><span class="icon icon-button" >确定</span></a> </div>';
      var attr = void 0;
      if (this.serarchOptions.length > 0 && this.searchdata !== '') {
        attr = this.serarchOptions;
      } else if (this.serarchcustomerOptions.length > 0) {
        attr = this.serarchcustomerOptions;
      } else {
        attr = this.attribute.options;
      }
      var height = '';
      var length = 0;
      for (var key in attr) {
        if (attribute.value === attr[key]) {
          ret2 += ret1 + key + ret4 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>';
        } else {
          ret2 += ret1 + key + ret3 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        if (this.curAttrsInGroup[2].value === '2') {
          ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
        } else {
          ret = ret7 + ret6 + '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
        }
      } else {
        if (this.curAttrsInGroup[2].value === '2') {
          ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
        } else {
          ret = ret7 + ret6 + '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
        }
      }
      ret = ret + ret2 + '</ul></div></div>';
      if (this.getTitle(attribute) === '您没有过历史定制合同，请全新定制!') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#showsearch').hide();
        return ret;
      } else {
        return ret;
      }
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert(val);
    },
    getTitle: function getTitle(attribute) {
      if (__WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos') && __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos').length < 1 || __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos') === undefined) {
        return '您没有过历史定制合同，请全新定制';
        //          alert('您没有过历史定制合同，请全新定制！')
      } else {
        return attribute.label;
      }
    },
    showOptionList: function showOptionList(attribute) {
      var _this = this;
      _this.attribute.options = [];
      //        $.showPreloader('正在查询')
      //        setTimeout(function () {
      //        }, 500)
      //         $.hidePreloader()
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
              _this.attribute.valueText = _this.checkedData;
            }
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr').on('click', function () {
        var val = void 0;
        var radio = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr');
        if (_this.serarchOptions.length > 0 && _this.searchdata !== '') {
          for (var j = 0; j < radio.length; j++) {
            if (radio[j].checked) {
              val = _this.serarchOptions[radio[j].value];
            }
          }
        } else if (_this.serarchcustomerOptions.length > 0) {
          for (var k = 0; k < radio.length; k++) {
            if (radio[k].checked) {
              val = _this.serarchcustomerOptions[radio[k].value];
            }
          }
        } else {
          for (var i = 0; i < radio.length; i++) {
            if (radio[i].checked) {
              val = _this.attribute.options[radio[i].value];
            }
          }
        }
        if (_this.attribute.value !== val) {
          _this.attribute.value = val;
          _this.attribute.valueText = val;
          if (_this.attribute.value !== undefined) {
            var contractNo = _this.attribute.value.split(':')[0];
            console.log(_this.attribute.value);
            _this.$weui.loading('正在查询合同信息，请稍等...');
            _this.gcapi('searchPreContract', contractNo).then(function (response) {
              //                console.log(_this.attribute.value)
              _this.$weui.loading().hide();
              __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].setLocalStorage('TLNo', null);
              __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].setLocalStorage('xueQingXing', null);
              __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].setLocalStorage('TLNo', response.body.result.TLNo);
              if (_this.curAttrsInGroup[3].value === '4' && response.body.result.finshDT) {
                var date = response.body.result.finshDT;
                console.log(response.body.result.finshDT);
                var time = 0;
                var now = new Date();
                time = (now.getFullYear() - date.year) * 12 + (now.getMonth() - date.month);
                if (time >= 12) {
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                    title: '请核对',
                    afterText: '<div>该合同生产完结已超过1年，请您先与平台确认是否仍有毒种！</div>',
                    buttons: [{
                      text: '取消',
                      bold: true,
                      onClick: function onClick() {
                        _this.attribute.value = '';
                        alert('请您重新选择【来源】或者【选择原合同】选项！');
                      }
                    }, {
                      text: '继续',
                      bold: true,
                      onClick: function onClick() {
                        _this.nextFlow(response);
                      }
                    }]
                  });
                } else {
                  _this.nextFlow(response);
                }
              } else {
                _this.nextFlow(response);
              }
            });
          }
          _this.checkedData = val;
          if (_this.serarchcustomerOptions.length < 1) {
            _this.valueChanged(attribute);
          }
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.closeModal();
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcustomerContract').on('click', function () {
        _this.serarchcustomerOptions = [];
        _this.serarchOptions = [];
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchinput1').val();
        console.log(data);
        _this.$weui.loading('正在查询合同信息，请稍等...');
        _this.gcapi('searchContractNo', data).then(function (response) {
          _this.serarchcustomerOptions = response.body.result;
          _this.$weui.loading().hide();
          var contractNos = [];
          var newContractNos = [];
          contractNos = response.body.result;
          if (_this.curAttrsInGroup[2].value === '3') {
            newContractNos = [];
            for (var no1 in contractNos) {
              if ((contractNos[no1].split(':')[0].indexOf('A') !== -1 || contractNos[no1].split(':')[0].indexOf('GCI') !== -1) && contractNos[no1].split(':')[0].indexOf('GVAP') === -1) {
                newContractNos.push(contractNos[no1]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '4') {
            newContractNos = [];
            for (var no in contractNos) {
              if ((contractNos[no].split(':')[0].indexOf('V') !== -1 || contractNos[no].split(':')[0].indexOf('GCI') !== -1) && contractNos[no].split(':')[0].indexOf('GVAP') === -1) {
                newContractNos.push(contractNos[no]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '2') {
            newContractNos = [];
            for (var no4 in contractNos) {
              if (contractNos[no4].indexOf('病毒') !== -1 || contractNos[no4].indexOf('质粒') !== -1 || contractNos[no4].indexOf('shRNA') !== -1 || contractNos[no4].split(':')[0].indexOf('GCI') !== -1) {
                newContractNos.push(contractNos[no4]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '1') {
            newContractNos = [];
            for (var no2 in contractNos) {
              if (contractNos[no2].split(':')[0].indexOf('L') !== -1 || contractNos[no2].split(':')[0].indexOf('GCI') !== -1) {
                newContractNos.push(contractNos[no2]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '6') {
            newContractNos = [];
            for (var no5 in contractNos) {
              if (contractNos[no5].split(':')[0].indexOf('R') !== -1) {
                newContractNos.push(contractNos[no5]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
            //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
            //                  if (response.body.result.labelNames !== undefined) {
            //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
            //                  }
            //                })
          } else if (_this.curAttrsInGroup[2].value === '7') {
            newContractNos = [];
            for (var no6 in contractNos) {
              if (contractNos[no6].split(':')[0].indexOf('GOSL') !== -1 || contractNos[no6].indexOf('慢病毒') !== -1 || contractNos[no6].indexOf('悬浮专用') !== -1 || contractNos[no6].indexOf('悬浮细胞专用') !== -1) {
                newContractNos.push(contractNos[no6]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
            //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
            //                  if (response.body.result.labelNames !== undefined) {
            //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
            //                  }
            //                })
          } else {
            _this.serarchcustomerOptions = contractNos;
          }
          if (_this.serarchcustomerOptions.length < 1) {
            alert('此用户没有符合条件的合同，请您全新定制！');
          }
          _this.showOptionList(_this.attribute);
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchContract').on('click', function () {
        _this.serarchcustomerOptions = [];
        _this.serarchOptions = [];
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchinput').val();
        _this.searchdata = data;
        for (var i = 0; i < _this.attribute.options.length; i++) {
          if (_this.attribute.options[i].indexOf(data) !== -1) {
            _this.serarchOptions.push(_this.attribute.options[i]);
          }
        }
        if (_this.serarchOptions.length < 1 && data !== '') {
          alert('查询结果无此合同号！');
        } else {
          _this.showOptionList(_this.attribute);
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#customerContract').on('click', function () {
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#yuancontract').val().toString();
        console.log(data.valueOf('GCD'));
        if (data.indexOf('GCD') !== -1 || data.indexOf('gcd') !== -1) {
          console.log(data);
          _this.attribute.value = data;
          _this.attribute.valueText = data;
          _this.curAttrsInGroup[5].value = -1;
          _this.curAttrsInGroup[5].sorteditAble = false;
          _this.curAttrsInGroup[5].valueText = -1;
          console.log(_this.attribute);
          //            _this.$emit('controlForm', 4, _this.curAttrsInGroup, _this.attribute)
          //             $.hidePreloader()
        } else {
          alert('请您确定输入的是GCD合同！');
          _this.attribute.value = '';
          _this.attribute.valueText = '';
          // $.hidePreloader()
        }
      });
    },
    nextFlow: function nextFlow(response) {
      var _this = this;
      if (response.body.result.xueQingXing) {
        __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].setLocalStorage('xueQingXing', response.body.result.xueQingXing);
      }
      if (response.body.result.labelNames !== undefined && response.body.result.labelNames !== null && _this.curAttrsInGroup[1].value === -1) {
        __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].setLocalStorage('target', response.body.result.labelNames);
        _this.curAttrsInGroup[5].options = response.body.result.labelNames;
        _this.curAttrsInGroup[5].value = '';
        _this.curAttrsInGroup[5].sorteditAble = true;
        _this.curAttrsInGroup[5].valueText = '';
        _this.curAttrsInGroup[5].isNA = false;
      } else {
        _this.curAttrsInGroup[5].value = -1;
        _this.curAttrsInGroup[5].sorteditAble = false;
        _this.curAttrsInGroup[5].isNA = true;
        _this.curAttrsInGroup[5].valueText = -1;
        _this.$emit('controlForm', 5, _this.curAttrsInGroup, _this.attribute);
      }
    },
    valueChanged: function valueChanged(attribute) {
      this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute);
      //        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
    }
    //      ,
    //      getKeyByValue (value) {
    //        let obj = this.attribute.options
    //        for (var prop in obj) {
    //          if (obj.hasOwnProperty(prop)) {
    //            if (obj[prop] === value) {
    //              return prop
    //            }
    //          }
    //        }
    //      }

  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.options = [];
      this.attribute.options.push(val);
      //        this.attribute.valueText = this.attribute.options[val]
    }
    //      ,
    //      attribute: {
    //        handler: function (val) {
    //          this.attribute.value = this.getKeyByValue(val)
    //        },
    //        deep: true
    //      }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AttrEnumBox2__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AttrEnumBox2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AttrEnumBox2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttrGeneBox__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttrGeneBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AttrGeneBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttrGeneInfoBox__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttrGeneInfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AttrGeneInfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AttrTextBox__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AttrTextBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AttrTextBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AttrTextAreaBox__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AttrTextAreaBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AttrTextAreaBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AttrTextArea2Box__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AttrTextArea2Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AttrTextArea2Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AttrNumberBox__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AttrNumberBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AttrNumberBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AttrTVBox__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AttrTVBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AttrTVBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContractChoose_vue__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContractChoose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ContractChoose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TargetChoose_vue__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TargetChoose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__TargetChoose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TemContractChoose_vue__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TemContractChoose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__TemContractChoose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'















/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    //      this.fetchData()
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    steps: function steps() {
      if (this.merchandise) {
        return this.merchandise._customizableAttrGroupsList.length;
      }

      return 0;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["a" /* mapState */])([
  //        'geneSearchResult', 'cartList', 'custdata'
  'geneSearchResult', 'cartList', 'hardGeneInfo']), {
    attrGroups: function attrGroups() {
      if (this.merchandise === undefined) {
        this.merchandise = __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('EmktCustomizedMerchandise');
      } else if (this.merchandise) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.$route.query.cust) === 'object') {
          if (this.$route.query.cust._attributes.PreContract.value !== '-1' && this.$route.query.cust._attributes.TVInfo.value !== '-1') {
            __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].setLocalStorage('TLNo', this.$route.query.cust._attributes.TVInfo.value);
          } else {
            __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].setLocalStorage('TLNo', null);
          }
          var custAttr = this.$route.query.cust._attributes;
          var merAttr = this.merchandise._customizableAttributes;
          this.merchandise._customizableAttrGroups = {};
          this.merchandise._customizableAttrGroupsList = [];
          var geneObj = void 0;
          for (var i in merAttr) {
            if (i === 'GeneInfo') {
              var val = custAttr[i].value;
              var text = void 0;
              if (typeof val === 'string' && val.indexOf(',') !== -1) {
                var obj = JSON.parse(val);
                //                  let obj = val
                geneObj = obj;
                text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol;
              } else if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) === 'object') {
                text = val.symbol === undefined ? val.microNo : val.symbol;
              } else if (typeof val === 'string' && val.indexOf(',') === -1) {
                var _obj = val;
                geneObj = _obj;
                text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol;
              }
              merAttr[i].value = geneObj === undefined ? val : geneObj;
              merAttr[i].valueText = text;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.NMID' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.NMID;
              merAttr[i].valueText = geneObj.NMID;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.symbol' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.symbol;
              merAttr[i].valueText = geneObj.symbol;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.CDSSize' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.CDSSize;
              merAttr[i].valueText = geneObj.CDSSize;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.taxId' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.taxId;
              merAttr[i].valueText = geneObj.taxId;
              merAttr[i].isNA = false;
            } else if (custAttr[i] && custAttr[i].value && custAttr[i].value !== undefined) {
              if (custAttr[i].value.toString() === '-1') {
                merAttr[i].value = -1;
                merAttr[i].valueText = -1;
                merAttr[i].isNA = true;
              } else {
                merAttr[i].value = custAttr[i].value;
                merAttr[i].valueText = custAttr[i].valueText;
              }
            } else {
              merAttr[i].value = -1;
              merAttr[i].valueText = -1;
              merAttr[i].isNA = true;
            }
            merAttr[i]['sorteditAble'] = true;
            // 处理定制属性组
            this.attrGroupHandler(merAttr, i);
          }
          this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
            return a.attrGroupId - b.attrGroupId;
          });
        }
        this.iscontrol = false;
        return this.merchandise._customizableAttrGroupsList;
      }
    },
    curAttrsInGroup: function curAttrsInGroup() {
      var curGroup = this.attrGroups[this.curStep];
      if (curGroup) {
        if (this.curStep === 2) {
          for (var i = 0; i < curGroup.attrs.length; i++) {
            curGroup.attrs[i].sorteditAble = true;
          }
        } else {
          // 设置第一个可以edit
          curGroup.attrs[0].sorteditAble = true;
        }
        return curGroup.attrs;
      }
      return [];
    },
    curGroup: function curGroup() {
      var curGroup = this.attrGroups[this.curStep];
      return curGroup;
    },

    curStep: {
      get: function get() {
        if (!this.merchandise) {
          return 0;
        }
        return this.merchandise._curStep;
      },
      // setter
      set: function set(newValue) {
        this.merchandise._curStep = newValue;
      }
    },
    error: function error() {
      // 检查当前组是否有错
      return null;
    },
    validate: function validate() {
      // 检查当前组是否有错, 是否属性值都填写了
      return null;
    }
  }),
  components: {
    'attr-enum-box': __WEBPACK_IMPORTED_MODULE_3__AttrEnumBox2___default.a,
    'attr-gene-box': __WEBPACK_IMPORTED_MODULE_4__AttrGeneBox___default.a,
    'attr-geneInfo-box': __WEBPACK_IMPORTED_MODULE_5__AttrGeneInfoBox___default.a,
    'attr-text-box': __WEBPACK_IMPORTED_MODULE_6__AttrTextBox___default.a,
    'attr-number-box': __WEBPACK_IMPORTED_MODULE_9__AttrNumberBox___default.a,
    'attr-tv-box': __WEBPACK_IMPORTED_MODULE_10__AttrTVBox___default.a,
    'attr-text-area-box': __WEBPACK_IMPORTED_MODULE_7__AttrTextAreaBox___default.a,
    'attr-text-area2-box': __WEBPACK_IMPORTED_MODULE_8__AttrTextArea2Box___default.a,
    'attr-contract-box': __WEBPACK_IMPORTED_MODULE_11__ContractChoose_vue___default.a,
    'attr-target-box': __WEBPACK_IMPORTED_MODULE_12__TargetChoose_vue___default.a,
    'attr-temcontract-box': __WEBPACK_IMPORTED_MODULE_13__TemContractChoose_vue___default.a

  },
  data: function data() {
    return {
      merchandise: __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('EmktCustomizedMerchandise'),
      EmktMetaData: __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('EmktMetaData'),
      bMerchandise: {},
      geneObject: {},
      muGuid: '',
      QuoteStatus: __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('QuoteStatus'),
      ToolNo: ['CV004', 'CV005', 'CV011', 'CV015', 'CV016', 'CV017', 'CV020', 'CV021', 'CV023', 'CV027', 'CV028', 'CV029', 'CV030', 'CV031', 'CV034', 'CV035', 'CV036', 'CV037', 'CV038', 'CV047', 'CV048', 'CV054', 'CV059', 'CV062', 'CV071', 'CV074', 'CV088', 'CV092', 'CV093', 'CV101', 'CV103', 'CV107', 'CV108', 'CV109', 'CV111', 'CV113', 'CV115', 'CV117', 'CV118', 'CV119', 'CV121', 'CV122', 'CV124', 'CV125', 'CV126', 'CV127', 'CV131', 'CV132', 'CV133', 'CV134', 'CV135', 'CV136', 'CV137', 'CV138', 'CV139', 'CV142', 'CV144', 'CV148', 'CV151', 'CV152', 'CV153', 'CV156', 'CV158', 'CV159', 'CV160', 'CV161', 'CV162', 'CV163', 'CV164', 'CV168', 'CV170', 'CV172', 'CV173', 'CV174', 'CV175', 'CV177', 'CV179', 'CV180', 'CV181', 'CV189', 'CV191', 'CV194', 'CV195', 'CV197', 'CV198', 'CV199', 'CV200', 'CV201', 'CV202', 'CV204', 'CV207', 'CV208', 'CV209', 'CV210', 'CV211', 'CV212', 'CV213', 'CV214', 'CV215', 'CV216', 'CV217', 'CV218', 'CV219', 'CV220', 'CV222', 'CV223', 'CV225', 'CV226', 'CV228', 'CV230', 'CV231', 'CV238', 'CV239', 'CV240', 'CV241', 'CV243', 'CV244', 'CV246', 'CV247', 'CV248', 'CV251', 'CV260', 'CV261', 'CV262', 'CV267', 'CV270', 'CV275', 'CV276', 'CV277', 'CV280', 'CV281', 'CV284', 'CV286', 'CV290', 'CV292', 'CV319', 'CV373', 'CV476', 'GV105', 'GV111', 'GV114', 'GV131', 'GV132', 'GV133', 'GV156', 'GV157', 'GV158', 'GV162', 'GV169', 'GV171', 'GV174', 'GV179', 'GV180', 'GV187', 'GV190', 'GV193', 'GV196', 'GV200', 'GV203', 'GV212', 'GV221', 'GV222', 'GV224', 'GV226', 'GV227', 'GV231', 'GV241', 'GV243', 'GV244', 'GV245', 'GV246', 'GV247', 'GV255', 'GV318', 'GV322', 'GV323', 'GV324', 'GV325', 'GV339', 'GV346', 'GV353', 'GV368', 'GV379', 'GV382', 'GV400', 'GV401', 'GV402', 'GV403', 'GV404', 'GV405', 'GV421', 'GV422', 'GV423', 'GV424', 'GV426', 'GV427', 'GV428', 'GV429', 'GV430', 'GV431', 'GV433', 'GV436', 'GV437', 'GV438', 'GV439', 'GV440', 'GV441', 'GV442', 'GV443', 'GV444', 'GV445', 'GV446', 'GV447', 'GV448', 'GV449', 'GV450', 'GV451', 'GV452', 'GV453', 'GV454', 'GV455', 'GV456', 'GV457', 'GV459', 'GV471', 'GV472', 'GV474', 'GV477', 'GV482', 'GV484', 'GV499', 'GV510', 'GV516', 'GV523', 'GV528', 'GV533', 'GV560', 'GV561', 'GV562', 'GV608', 'GV609', 'GV635', 'GV637', 'GV653', 'GV669', 'CV032', 'CV033', 'CV066', 'CV104', 'CV232', 'CV252', 'CV253', 'CV271', 'CV604', 'CV627', 'GV127', 'GV311', 'GV312', 'GV313', 'CV701']
    };
  },

  props: [],
  watch: {
    'curGroup': {
      deep: true,
      handler: function handler(val, oldVal) {
        console.log(val);
        // 当前步骤有任何属性的改动， 必须清除下一步界面里面的属性值
      }
    },
    //      '$route': 'getContract',
    $route: function $route() {
      this.getContract();
      if (this.$route.query.cust) {
        //          this.clearCust()
        this.initoptions();
      } else {
        this.attrHandler();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'DELETE_CART_LIST', 'REMOVE_FROM_CART_LIST']), {
    getEditor: function getEditor(attribute) {
      if (attribute.customizable === 1) {
        if (attribute.columnName === 'PreContract') {
          return 'attr-contract-box';
        } else if (attribute.columnName === 'CloneNrSelect') {
          return 'attr-target-box';
        } else if (attribute.columnName === 'TemsPreContract') {
          return 'attr-temcontract-box';
        } else if (attribute.columnName === 'CustRemark') {
          return 'attr-text-area2-box';
        } else {
          if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].SDTGene) {
            return 'attr-gene-box';
          } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].SDTToolVector) {
            return 'attr-tv-box';
          } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].SDTEnumeration) {
            return 'attr-enum-box';
          } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].SDTInteger) {
            return 'attr-number-box';
          } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].SDTDecimal) {
            return 'attr-number-box';
          } else {
            return 'attr-text-area-box';
          }
        }
      }
    },
    getContract: function getContract() {
      //        if (this.$route.name === 'custOrder') {
      //          this.gcapi('searchContractNo').then(function (response) {
      //            Emkt.setLocalStorage('contractNO', null)
      //            Emkt.setLocalStorage('contractNO', response.body.result)
      //          })
      //        }
    },
    initoptions: function initoptions() {
      if (this.$route.query.cust) {
        var k = 0;
        var j = 0;
        var custarray = [];
        if (this.merchandise._customizableAttrGroupsList[0].attrs[0].value === '') {
          if (this.$route.query.cust._attributes.PreContract.value !== '-1' && this.$route.query.cust._attributes.TVInfo.value !== '-1') {
            __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].setLocalStorage('TLNo', this.$route.query.cust._attributes.TVInfo.value);
          }
          var custAttr = this.$route.query.cust._attributes;
          var merAttr = this.merchandise._customizableAttributes;
          this.merchandise._customizableAttrGroups = {};
          this.merchandise._customizableAttrGroupsList = [];
          var geneObj = void 0;
          for (var i in merAttr) {
            if (i === 'GeneInfo') {
              var val = custAttr[i].value;
              var text = void 0;
              if (typeof val === 'string' && val.indexOf(',') !== -1) {
                var obj = JSON.parse(val);
                //                  let obj = val
                geneObj = obj;
                text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol;
              } else if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) === 'object') {
                text = val.symbol === undefined ? val.microNo : val.symbol;
              } else if (typeof val === 'string' && val.indexOf(',') === -1) {
                var _obj2 = val;
                geneObj = _obj2;
                text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol;
              }
              merAttr[i].value = geneObj === undefined ? val : geneObj;
              merAttr[i].valueText = text;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.NMID' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.NMID;
              merAttr[i].valueText = geneObj.NMID;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.symbol' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.symbol;
              merAttr[i].valueText = geneObj.symbol;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.CDSSize' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.CDSSize;
              merAttr[i].valueText = geneObj.CDSSize;
              merAttr[i].isNA = false;
            } else if (i === 'GeneInfo.taxId' && custAttr[i] === undefined) {
              merAttr[i].value = geneObj.taxId;
              merAttr[i].valueText = geneObj.taxId;
              merAttr[i].isNA = false;
            } else if (custAttr[i] && custAttr[i].value && custAttr[i].value !== undefined) {
              if (custAttr[i].value.toString() === '-1') {
                merAttr[i].value = -1;
                merAttr[i].valueText = -1;
                merAttr[i].isNA = true;
              } else {
                merAttr[i].value = custAttr[i].value;
                merAttr[i].valueText = custAttr[i].valueText;
              }
            } else {
              merAttr[i].value = -1;
              merAttr[i].valueText = -1;
              merAttr[i].isNA = true;
            }
            merAttr[i]['sorteditAble'] = true;
            // 处理定制属性组
            this.attrGroupHandler(merAttr, i);
          }
          this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
            return a.attrGroupId - b.attrGroupId;
          });
        }
        custarray = this.madearray(this.merchandise._customizableAttrGroupsList[0].attrs, this.merchandise._customizableAttrGroupsList[0].attrs.length - 1, custarray);
        custarray = this.madearray(this.merchandise._customizableAttrGroupsList[1].attrs, 0, custarray);
        var newarry = [];
        for (k = 0; k < custarray.length - 2; k++) {
          newarry.push(custarray[k]);
          this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k);
          if (k === 0 || k === 1 || k === 2 || k === 3 || k === 4 || k === 5) {
            this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k);
          } else if (k > 5 && k < 8) {
            this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k + 4);
          } else {
            this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k + 3);
          }
        }
        this.changeValue(custarray, this.merchandise._customizableAttrGroupsList[1].attrs, 0);
        for (j = 0; j < 3; j++) {
          for (k = 0; k < this.merchandise._customizableAttrGroupsList[j].attrs.length; k++) {
            if (this.merchandise._customizableAttrGroupsList[j].attrs[k].value === '-1') {
              this.merchandise._customizableAttrGroupsList[j].attrs[k].isNA = true;
              this.merchandise._customizableAttrGroupsList[j].attrs[k].value = -1;
              this.merchandise._customizableAttrGroupsList[j].attrs[k].valueText = '';
            }
          }
        }
      } else {
        //          this.attrHandler()
      }
    },
    modifyProduct: function modifyProduct() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.confirm('您确定修改此商品信息吗？', function () {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.showIndicator();
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.hideIndicator();
        }, 300);
        _this.REMOVE_FROM_CART_LIST(_this.$route.query.cust.merchandiseId);
        _this.calculatePrice();
      }, function () {
        console.log('cancel');
      });
    },
    controlForm: function controlForm(index, curAttrsInGroup) {
      if (this.curStep !== 2) {
        this.judgeValue(curAttrsInGroup, index, this.curStep);
        for (i = 0; i < curAttrsInGroup.length; i++) {
          if (curAttrsInGroup[i].options && curAttrsInGroup[i].options.length < 1 || curAttrsInGroup[i].columnName === 'CloneNrSelect' && curAttrsInGroup[i].options[1] === '全新定制') {
            curAttrsInGroup[i].isNA = true;
            curAttrsInGroup[i].value = -1;
            curAttrsInGroup[i].sorteditAble = false;
            curAttrsInGroup[i].valueText = 'NA';
          }
        }
        if (index === 0 && this.curStep === 0) {
          for (var m = 0; m < curAttrsInGroup.length; m++) {
            if (m !== 0) {
              curAttrsInGroup[m].value = '';
              curAttrsInGroup[m].valueText = '';
              curAttrsInGroup[m].sorteditAble = false;
              curAttrsInGroup[m].isNA = false;
            }
          }
        }
        var i;
        for (i = this.curStep + 1; i <= 2; i++) {
          for (var j = 0; j < this.attrGroups[i].attrs.length; j++) {
            if (i === 1) {
              if (j === 0) {
                this.attrGroups[i].attrs[j].sorteditAble = true;
              } else {
                this.attrGroups[i].attrs[j].sorteditAble = false;
              }
            }
            this.attrGroups[i].attrs[j].value = '';
            this.attrGroups[i].attrs[j].valueText = '';
            this.attrGroups[i].attrs[j].isNA = false;
          }
        }
        if (curAttrsInGroup[6] && curAttrsInGroup[6].columnName === 'GeneInfo') {
          for (i = index; i < curAttrsInGroup.length; i++) {
            if (index === 6) {
              if (i === 6) {
                curAttrsInGroup[i].sorteditAble = true;
                curAttrsInGroup[i + 5].sorteditAble = true;
                curAttrsInGroup[i + 5].value = '';
                curAttrsInGroup[i + 5].valueText = '';
                curAttrsInGroup[i + 5].isNA = false;
              } else if (i !== 7 && i !== 8 && i !== 9 && i !== 10 && i !== 11) {
                curAttrsInGroup[i].sorteditAble = false;
                curAttrsInGroup[i].value = '';
                curAttrsInGroup[i].valueText = '';
                curAttrsInGroup[i].isNA = false;
              }
            } else {
              //                for (var q = 0; q < curAttrsInGroup.length; q++) {
              //                  if (curAttrsInGroup[q].options && curAttrsInGroup[q].options.length < 1) {
              //                    curAttrsInGroup[q].isNA = true
              //                    curAttrsInGroup[q].value = -1
              //                    curAttrsInGroup[q].valueText = 'NA'
              //                  }
              //                }
              if (index < curAttrsInGroup.length - 1) {
                var k = index;
                while (curAttrsInGroup[1 + k].isNA === true && k < curAttrsInGroup.length - 2) {
                  k++;
                }
              }
              for (i = index; i < curAttrsInGroup.length - 1; i++) {
                if (index === i) {
                  curAttrsInGroup[i].sorteditAble = true;
                  curAttrsInGroup[1 + k].sorteditAble = true;
                  //                    curAttrsInGroup[i].value = ''
                  curAttrsInGroup[1 + k].value = '';
                  curAttrsInGroup[1 + k].valueText = '';
                  curAttrsInGroup[1 + k].isNA = false;
                } else {
                  if (i !== k + 1) {
                    curAttrsInGroup[i].sorteditAble = false;
                    curAttrsInGroup[i].value = '';
                    curAttrsInGroup[i].valueText = '';
                    curAttrsInGroup[i].isNA = false;
                  }
                }
              }
              if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '1') {
                curAttrsInGroup[2].sorteditAble = true;
                curAttrsInGroup[2].value = '';
                curAttrsInGroup[2].valueText = '';
                curAttrsInGroup[2].isNA = false;
              } else if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '2') {
                curAttrsInGroup[2].sorteditAble = true;
                curAttrsInGroup[2].value = '';
                curAttrsInGroup[2].valueText = '';
                curAttrsInGroup[2].isNA = false;
              } else if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '3') {
                curAttrsInGroup[2].sorteditAble = true;
                curAttrsInGroup[2].value = '';
                curAttrsInGroup[2].valueText = '';
                curAttrsInGroup[2].isNA = false;
              }
              if (curAttrsInGroup[index].columnName === 'RequiredGoods' && (curAttrsInGroup[index].value === '3' || curAttrsInGroup[index].value === '4' || curAttrsInGroup[index].value === '5')) {
                curAttrsInGroup[4].sorteditAble = true;
                curAttrsInGroup[4].value = '';
                curAttrsInGroup[4].valueText = '';
                curAttrsInGroup[4].isNA = false;
              }
            }
          }
        }
        this.judgeValue(curAttrsInGroup, index, this.curStep);
        for (i = 0; i < curAttrsInGroup.length; i++) {
          if (curAttrsInGroup[i].options && curAttrsInGroup[i].options.length < 1) {
            curAttrsInGroup[i].isNA = true;
            curAttrsInGroup[i].sorteditAble = false;
            curAttrsInGroup[i].value = -1;
            curAttrsInGroup[i].valueText = '';
          }
        }
      }
      //        else if (this.curStep === 1) {
      //          this.judgeValue(curAttrsInGroup, index, this.curStep)
      //        }
    },
    arr: function arr(_arr) {
      var result = [];
      for (var i = 0; i < _arr.length; i++) {
        if (result.indexOf(_arr[i]) === -1) {
          result.push(_arr[i]);
        }
      }
      return result;
    },
    changeValue: function changeValue(custarray, group, index) {
      console.log('changeValue start----', new Date().getTime());
      if (custarray.length >= 7 && index === custarray.length - 1) {
        if (custarray.length >= 9) {
          index = index + 4;
        } else {
          index = index + 3;
        }
      }
      var i;
      var dictionariesMap = this.EmktMetaData.dictionariesMap;
      var datas = [];
      datas = __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('custdata');
      for (i = 0; i < custarray.length; i++) {
        var temarr = [];
        for (var j = 0; j < datas.length; j++) {
          if (datas[j][custarray[i].columnName]) {
            for (var n = 0; n < datas[j][custarray[i].columnName].length; n++) {
              if (custarray[i]['value']) {
                if (custarray[i].columnName === 'TVInfo') {
                  if (datas[j][custarray[i].columnName][n].value.toString().indexOf(custarray[i]['value'].toString()) !== -1) {
                    temarr.push(datas[j]);
                  }
                } else {
                  if (datas[j][custarray[i].columnName][n].value.toString() === custarray[i]['value'].toString()) {
                    temarr.push(datas[j]);
                  }
                }
              }
            }
          }
        }
        if (temarr.length > 0) {
          datas = temarr;
        }
      }
      var karry = [];
      var mapKarry = {};
      for (i = 0; i < datas.length; i++) {
        var k;
        for (k = index + 1; k < group.length; k++) {
          if (datas[i]['GeneInfo.category'][0].value === -1) {
            if (group[k].columnName === 'GeneInfo' || group[k].columnName === 'GeneInfo.CDSSize' || group[k].columnName === 'GeneInfo.symbol' || group[k].columnName === 'GeneInfo.NMID' || group[k].columnName === 'GeneInfo.taxId') {
              group[k].isNA = true;
              group[k].value = -1;
              group[k].valueText = 'NA';
            }
          } else if (datas[i]['GeneInfo.category'][0].value === '') {
            if (group[k].columnName === 'GeneInfo' || group[k].columnName === 'GeneInfo.CDSSize' || group[k].columnName === 'GeneInfo.symbol' || group[k].columnName === 'GeneInfo.NMID' || group[k].columnName === 'GeneInfo.taxId') {
              group[k].isNA = false;
              group[k].value = '';
              group[k].valueText = '';
            }
          }
          if (datas[i][group[k].columnName]) {
            var m;
            for (m = 0; m < datas[i][group[k].columnName].length; m++) {
              if (datas[i][group[k].columnName][m].value === -1) {
                group[k].options = [];
              } else {
                var kvalue2 = {};
                kvalue2['key'] = group[k].columnName;
                var da = {};
                var sysData = dictionariesMap[datas[i][group[k].columnName][m].typeID + '_' + datas[i][group[k].columnName][m].value];
                da.key = datas[i][group[k].columnName][m].value;
                da.value = sysData.dictValue;
                if (sysData.valid) {
                  kvalue2['value'] = da;
                  if (mapKarry[da.key]) {
                    var arrayKarry = mapKarry[da.key];
                    if (!arrayKarry.includes(da.value)) {
                      arrayKarry.push(da.value);
                      karry.push(kvalue2);
                    }
                  } else {
                    mapKarry[da.key] = [da.value];
                    karry.push(kvalue2);
                  }
                }
                group[k].options = [];
              }
            }
          }
        }
      }
      if (group.length !== 6) {
        for (i = 0; i < datas.length; i++) {
          if (datas[i][this.attrGroups[1].attrs[0].columnName]) {
            for (m = 0; m < datas[i][this.attrGroups[1].attrs[0].columnName].length; m++) {
              if (datas[i][this.attrGroups[1].attrs[0].columnName][m].value === -1) {
                this.attrGroups[1].attrs[0].options = [];
              } else {
                kvalue2 = {};
                kvalue2['key'] = this.attrGroups[1].attrs[0].columnName;
                kvalue2['value'] = datas[i][this.attrGroups[1].attrs[0].columnName][m].value;
                this.attrGroups[1].attrs[0].options = [];
                // karry.push(kvalue2)
                if (mapKarry[kvalue2.key]) {
                  var _arrayKarry = mapKarry[kvalue2.key];
                  if (!_arrayKarry.includes(kvalue2.value)) {
                    _arrayKarry.push(kvalue2.value);
                    karry.push(kvalue2);
                  }
                } else {
                  mapKarry[kvalue2.key] = [kvalue2.value];
                  karry.push(kvalue2);
                }
              }
            }
          }
        }
        if (mapKarry[this.attrGroups[1].attrs[0].columnName]) {
          this.attrGroups[1].attrs[0].options = mapKarry[this.attrGroups[1].attrs[0].columnName];
        }
        // for (i = 0; i < karry.length; i++) {
        //   if (this.attrGroups[1].attrs[0].columnName === karry[i].key && karry[i]['value'] !== '-1') {
        //     this.attrGroups[1].attrs[0].options.push(karry[i]['value'])
        //   }
        //   if (this.attrGroups[1].attrs[0].options) {
        //     this.attrGroups[1].attrs[0].options = this.arr(this.attrGroups[1].attrs[0].options)
        //   }
        // }
      }
      for (j = 0; j < this.attrGroups[2].attrs.length; j++) {
        this.attrGroups[2].attrs[j].isNA = true;
      }

      for (i = 0; i < datas.length; i++) {
        if (datas[i]['otherAttrs']) {
          for (k = 0; k < datas[i]['otherAttrs'].length; k++) {
            for (j = 0; j < this.attrGroups[2].attrs.length; j++) {
              if (datas[i]['otherAttrs'][k] === this.attrGroups[2].attrs[j].columnName.toString()) {
                //                  if (datas[i]['TargetNum'].length === 1 && datas[i]['TargetNum'][0] === 1) {
                //                    if (this.attrGroups[2].attrs[j].columnName === 'TargetNum') {
                //                      this.attrGroups[2].attrs[j].value = 1
                //                      this.attrGroups[2].attrs[j].valueText = 1
                //                    }
                //                  }
                if (this.attrGroups[2].attrs[j].columnName.toString() === 'LVAmount') {
                  this.attrGroups[2].attrs[j].options = [];
                  for (m = 0; m < datas[i]['otherAttrsOptions'].length; m++) {
                    this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsOptions'][m].typeID + '_' + datas[i]['otherAttrsOptions'][m].value].dictValue;
                  }
                }
                if (this.attrGroups[2].attrs[j].columnName.toString() === 'NC_LV_Amount' || this.attrGroups[2].attrs[j].columnName.toString() === 'NC_Plasmid_Amount') {
                  this.attrGroups[2].attrs[j].options = [];
                  for (m = 0; m < datas[i]['otherAttrsNCOptions'].length; m++) {
                    this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsNCOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsNCOptions'][m].typeID + '_' + datas[i]['otherAttrsNCOptions'][m].value].dictValue;
                  }
                }
                if (this.attrGroups[2].attrs[j].columnName.toString() === 'AAVBloodType') {
                  this.attrGroups[2].attrs[j].options = [];
                  for (m = 0; m < datas[i]['AAVBloodTypeOptions'].length; m++) {
                    this.attrGroups[2].attrs[j].options[datas[i]['AAVBloodTypeOptions'][m].value] = dictionariesMap[datas[i]['AAVBloodTypeOptions'][m].typeID + '_' + datas[i]['AAVBloodTypeOptions'][m].value].dictValue;
                  }
                }
                if (this.attrGroups[2].attrs[j].columnName.toString() === 'Plasmid_Amount') {
                  if (datas[i]['otherAttrsOptions'] && datas[i]['otherAttrsOptions'].length >= 1) {
                    this.attrGroups[2].attrs[j].options = [];
                    for (m = 0; m < datas[i]['otherAttrsOptions'].length; m++) {
                      this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsOptions'][m].typeID + '_' + datas[i]['otherAttrsOptions'][m].value].dictValue;
                    }
                  }
                }
                this.attrGroups[2].attrs[j].isNA = false;
              }
            }
          }
        }
      }
      //        console.log(this.attrGroups[2].attrs)
      for (i = 0; i < karry.length; i++) {
        for (k = index + 1; k < group.length; k++) {
          if (group[k].columnName === karry[i].key) {
            group[k].options[karry[i]['value'].key] = karry[i]['value'].value;
          }
        }
      }
      if (datas[0].MuGuid) {
        this.muGuid = datas[0].MuGuid;
      }
      //        console.log(this.attrGroups[1].attrs)
      console.log('changeValue end----', new Date().getTime());
      return group;
    },
    madearray: function madearray(curAttrsInGroup, index, custarray) {
      console.log('madearray start----', new Date().getTime());
      var i;
      for (i = 0; i < index + 1; i++) {
        if (curAttrsInGroup[i].value !== '') {
          if (curAttrsInGroup[i].columnName !== 'GeneInfo.NMID' && curAttrsInGroup[i].columnName !== 'GeneInfo.CDSSize' && curAttrsInGroup[i].columnName !== 'GeneInfo.symbol' && curAttrsInGroup[i].columnName !== 'GeneInfo.taxId') {
            var data = {};
            if (curAttrsInGroup[i].columnName === 'GeneInfo') {
              if (curAttrsInGroup[i].value === -1 || !curAttrsInGroup[i].value) {
                data['columnName'] = 'GeneInfo.category';
                data['value'] = -1;
                custarray.push(data);
                var data2 = {};
                data2['columnName'] = 'GeneInfo.ttttflag';
                data2['value'] = -1;
                custarray.push(data2);
              } else if (curAttrsInGroup[i].value) {
                data['columnName'] = 'GeneInfo.category';
                data['value'] = curAttrsInGroup[i].value.category;
                custarray.push(data);
                var data1 = {};
                data1['columnName'] = 'GeneInfo.ttttflag';
                if (curAttrsInGroup[i].value.ttttflag !== undefined) {
                  data1['value'] = curAttrsInGroup[i].value.ttttflag;
                  custarray.push(data1);
                } else {
                  data1['value'] = -1;
                  custarray.push(data1);
                }
              }
            } else if (curAttrsInGroup[i].columnName === 'TemsPreContract') {
              if (curAttrsInGroup[i].value !== -1 && curAttrsInGroup[i].value) {
                data['columnName'] = curAttrsInGroup[i].columnName;
                data['value'] = 1;
                custarray.push(data);
              }
            } else {
              data['columnName'] = curAttrsInGroup[i].columnName;
              data['value'] = curAttrsInGroup[i].value;
              custarray.push(data);
            }
          }
        }
      }
      console.log('madearray end----', new Date().getTime());
      return custarray;
    },
    judgeValue: function judgeValue(curAttrsInGroup, index, curStep) {
      //        $('.multiselect__input').attr('disabled', true)
      console.log('judgeValue start----', new Date().getTime());
      var custarray = [];
      console.log(this.merchandise);
      if (curStep === 0) {
        custarray = this.madearray(this.attrGroups[0].attrs, index, custarray);
      } else if (curStep === 1) {
        custarray = this.madearray(this.attrGroups[0].attrs, this.attrGroups[0].attrs.length - 1, custarray);
        custarray = this.madearray(this.attrGroups[1].attrs, index, custarray);
      }
      curAttrsInGroup = this.changeValue(custarray, curAttrsInGroup, index);
      console.log('judgeValue end----', new Date().getTime());
    },
    getCss: function getCss(attribute) {
      return {
        // 'item-link': attribute.sdType === Emkt.SDTGene | attribute.sdType === Emkt.SDTToolVector
      };
    },
    judgeError: function judgeError(val) {
      this.isError = val;
    },
    receiveData: function receiveData(data) {},
    pageUp: function pageUp() {
      if (this.curStep <= 0) {
        return;
      }

      if (this.error) {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast(this.error);
        return;
      }

      this.curStep--;
    },
    pageDown: function pageDown() {
      var isachieve = true;
      var _this = this;
      if (_this.attrGroups[0].attrs[3].value === '2' && _this.curStep === 0) {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.modal({
          title: '请核对',
          afterText: '<div>您确定客户提供的腺病毒类型为Ad5亚型，且能在HEK293细胞中扩增。腺病毒毒种滴度>10^7 PFU/mL，毒种体积>50µL?</div>',
          buttons: [{
            text: '不确定',
            bold: true,
            onClick: function onClick() {
              isachieve === false;
              __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('请您先与客户确认以上信息！');
              return;
            }
          }, {
            text: '确定',
            bold: true,
            onClick: function onClick() {
              if (isachieve === true) {
                if (_this.curStep >= _this.steps - 1) {
                  return;
                }
                if (_this.error) {
                  __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast(_this.error);
                  return;
                }
                _this.curStep++;
              }
            }
          }]
        });
        //          $.confirm('您确定客户提供的腺病毒类型为Ad5亚型，且能在HEK293细胞中扩增。腺病毒毒种滴度>10^7 PFU/mL，毒种体积>50µL?',
        //            function () {
        //              if (isachieve === true) {
        //                if (_this.curStep >= _this.steps - 1) {
        //                  return
        //                }
        //                if (_this.error) {
        //                  $.toast(_this.error)
        //                  return
        //                }
        //                _this.curStep++
        //              }
        //            },
        //            function () {
        //              isachieve === false
        //              $.alert('请您先与客户确认以上信息！')
        //              return
        //            })
      }
      if (_this.curStep === 1) {
        if (_this.attrGroups[_this.curStep].attrs[0].options.length < 1) {
          _this.attrGroups[_this.curStep].attrs[0].value = '-1';
          _this.attrGroups[_this.curStep].attrs[0].valueText = '-1';
        }
        if (_this.attrGroups[_this.curStep].attrs[0].value === '') {
          isachieve = false;
          __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('请您将信息填写完整！');
        }
        if (_this.attrGroups[0].attrs[4].value !== '-1' && _this.attrGroups[0].attrs[4].value !== -1 && _this.attrGroups[0].attrs[2].value !== '2') {
          _this.$weui.loading('正在查询中...');
          _this.gcapi('searchPreContract', _this.attrGroups[0].attrs[4].value.split(':')[0]).then(function (response) {
            _this.$weui.loading().hide();
            var data = response.body.result.TLNo;
            if (_this.attrGroups[1].attrs[0].value !== data) {
              _this.attrGroups[1].attrs[0].value = data;
            }
          }).catch(function (err) {
            _this.$weui.loading().hide();
            console.log(err);
          });
        }
        if (__WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('isnext') !== undefined && __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getLocalStorage('isnext') === false) {
          isachieve = false;
          //            Emkt.setLocalStorage('isnext', true)
          __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('请您重新选择基因或载体！');
          return;
        }
      }
      if (_this.curStep !== 1) {
        if (_this.attrGroups[0].attrs[12].value === '1') {
          // 慢病毒>6000 || 腺病毒>6500 || 逆转录>4000 ||悬浮病毒6000 || 质粒>10000
          if (_this.attrGroups[0].attrs[2].value === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].TOOLTYPE_LENTIVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6000 || _this.attrGroups[0].attrs[2].value === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].TOOLTYPE_PLASMID && _this.attrGroups[0].attrs[6].value.CDSSize > 10000 || _this.attrGroups[0].attrs[2].value === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].TOOLTYPE_ADENOVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6500 || _this.attrGroups[0].attrs[2].value === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].TOOLTYPE_RETROVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 4000 || _this.attrGroups[0].attrs[2].value === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].TOOLTYPE_FLOATVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6000) {
            isachieve = false;
            _this.$weui.alert('您所选择的基因，超出该合同类型的构建或包装极限，公司无法接入，请咨询售前如何实现客户需求，无法加入购物车，重新选择基因');
          }
        }
        if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0) {
          var hardHeneGo = true;
          var hardGenecontent = {};
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.hardGeneInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var hardGene = _step.value;

              if (hardGene.level === __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].HardGeneLevelNo1) {
                if (hardGene.contractType !== undefined && hardGene.contractType) {
                  //有hardGene
                  if (_this.attrGroups[0].attrs[12].value && hardGene.tech.includes(_this.attrGroups[0].attrs[12].value)) {
                    if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                      if (_this.attrGroups[0].attrs[13].value && hardGene.targetSupplier.includes(_this.attrGroups[0].attrs[13].value)) {
                        hardHeneGo = false;
                        hardGenecontent = hardGene;
                        break;
                      }
                    } else {
                      hardHeneGo = false;
                      hardGenecontent = hardGene;
                      break;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!hardHeneGo) {
            _this.$weui.alert(hardGenecontent.infeasibilityStatement + '，' + hardGenecontent.solution);
            isachieve = false;
          }
        }
        if (_this.attrGroups[0].attrs[6].value.category === 3 && _this.attrGroups[0].attrs[6].value.ttttflag !== undefined && _this.attrGroups[0].attrs[6].value.ttttflag === 1) {
          isachieve = false;
          __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('microRNA序列中存在连续4个T，需要更换海绵体方法进行构建，不可以继续进行下一步选择，详细邮件询问售前技术支持。');
        }
        for (var j = 0; j < _this.curAttrsInGroup.length; j++) {
          if (_this.curAttrsInGroup[j].value === '') {
            isachieve = false;
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('请您将信息填写完整！');
            break;
          }
        }
      }
      if (isachieve === true && (_this.attrGroups[0].attrs[3].value !== '2' || _this.curStep !== 0)) {
        if (_this.curStep >= _this.steps - 1) {
          return;
        }
        if (_this.error) {
          __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast(_this.error);
          return;
        }
        _this.curStep++;
      }
    },
    fetchData: function fetchData() {
      var self = this;
      self.initoptions();
      //        this.gcapi('getAllCustomizedMerchandise').then(function (response) {
      //          var merch = response.body.result[0]
      //          merch._curStep = 0
      //          self.merchandise = merch
      //          self.initoptions()
      //          Emkt.setStoreItem('EmktCustomizedMerchandise', self.merchandise)
      //        })
    },
    addCartList: function addCartList(bMerchandise) {
      var id = bMerchandise.merchandiseId;
      id = id + new Date().getTime();
      bMerchandise.merchandiseId = id;
      bMerchandise.attributes['GeneInfo'] = this.geneObject;
      this.ADD_CART_LIST(bMerchandise);
    },
    calculatePrice: function calculatePrice() {
      // 阴性载体
      if (this.attrGroups[1].attrs[0].value === 'GV127' || this.attrGroups[1].attrs[0].value === 'GV311' || this.attrGroups[1].attrs[0].value === 'CV032' || this.attrGroups[1].attrs[0].value === 'CV253' || this.attrGroups[1].attrs[0].value === 'CV033' || this.attrGroups[1].attrs[0].value === 'CV271' || this.attrGroups[1].attrs[0].value === 'CV604' || this.attrGroups[1].attrs[0].value === 'CV232' || this.attrGroups[1].attrs[0].value === 'CV627' || this.attrGroups[1].attrs[0].value === 'CV627' || this.attrGroups[1].attrs[0].value === 'CV252' || this.attrGroups[1].attrs[0].value === 'CV104' || this.attrGroups[1].attrs[0].value === 'GV312' || this.attrGroups[1].attrs[0].value === 'GV313' || this.attrGroups[1].attrs[0].value === 'CV207' || this.attrGroups[1].attrs[0].value === 'CV275') {
        if (this.attrGroups[2].attrs[23].value === '1') {
          if (this.attrGroups[2].attrs[24].value === '') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast('【吉凯载体改造】必须填写【备注信息】！');
            return;
          }
        }
      }
      // 慢病毒扩增(Cas9单载体，sgRNA) 不能选择对照
      if (this.attrGroups[0].attrs[0].value === '3' && this.attrGroups[0].attrs[2].value === '1' && this.attrGroups[1].attrs[5].value.toString().indexOf('cas') !== -1 && this.attrGroups[1].attrs[5].value.indexOf('sgRNA') !== -1) {
        if (this.attrGroups[2].attrs[6].value !== '' && this.attrGroups[2].attrs[6].value !== -1) {
          if (this.attrGroups[2].attrs[6].value !== '6') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast('此载体【无对照】,如需对照,请咨询售前！');
            return;
          }
        }
      }
      if (this.ToolNo.indexOf(this.attrGroups[1].attrs[0].value) !== -1) {
        if (this.attrGroups[2].attrs[12].value !== '' && this.attrGroups[2].attrs[12].value !== -1) {
          if (this.attrGroups[2].attrs[12].value !== '9') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast('此载体【无对照】,如需对照,请咨询售前！');
            return;
          }
        }
        if (this.attrGroups[2].attrs[6].value !== '' && this.attrGroups[2].attrs[6].value !== -1) {
          if (this.attrGroups[2].attrs[6].value !== '6') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast('此载体【无对照】,如需对照,请咨询售前！');
            return;
          }
        }
        if (this.attrGroups[2].attrs[16].value !== '' && this.attrGroups[2].attrs[16].value !== -1) {
          if (this.attrGroups[2].attrs[16].value !== '0') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.toast('此载体【无对照】,如需对照,请咨询售前！');
            return;
          }
        }
      }
      for (var a in this.curAttrsInGroup) {
        if (this.curAttrsInGroup[a].columnName !== 'TvNoName' && this.curAttrsInGroup[a].columnName !== 'TvNoNumber') {
          if (this.curAttrsInGroup[a].isNA === false && this.curAttrsInGroup[a].value === '') {
            __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.alert('请将信息填写完整！');
            return;
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].setLocalStorage('TLNo', null);
      var bMerchandise = this.merchandiseHandler();
      var _this = this;
      _this.$weui.loading('正在处理...');
      this.gcapi('productDetect', bMerchandise).then(function (res) {
        var body = res.body;
        _this.$weui.loading().hide();
        if (body.code === 0) {
          var merchandise = {};
          merchandise = body.result.merchandiseDetailForClient;
          merchandise.productName = body.result.productName;
          merchandise.workdays = body.result.workdays;
          merchandise.expressPrice = body.result.expressPrice;
          if (body.result.templateSource) {
            merchandise.templateSource = body.result.templateSource;
          }
          if (_this.$route.query.cust && _this.$route.query.cust.id) {
            merchandise.id = _this.$route.query.cust.id;
          }
          merchandise.newMerch = 1;
          if (body.result.hardGeneDescription) {
            _this.$weui.confirm(body.result.hardGeneDescription, function () {
              merchandise.hardGeneDescription = body.result.hardGeneDescription;
              _this.addCartList(merchandise);
              _this.attrHandler();
              _this.$router.push({ name: 'cart' });
            }, function () {});
          } else {
            _this.addCartList(merchandise);
            _this.attrHandler();
            _this.$router.push({ name: 'cart' });
          }
        } else {
          _this.$weui.toast(body.result, 1500);
        }
      });
    },
    merchandiseHandler: function merchandiseHandler() {
      var md = this.merchandise;
      var bMerchandise = {};
      var attribute = [];
      var attr = md._customizableAttributes;
      var categoryId = void 0;
      for (var akey in attr) {
        if (akey === 'GeneInfo') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
        } else if (akey === 'AAVBloodType]') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
        } else if (akey === 'MuGuid') {
          attribute.push({
            key: akey,
            value: this.muGuid
          });
        } else {
          var obj = {};
          obj['key'] = akey;
          var val = attr[akey].value;
          if (val) {
            if (val.value !== undefined) {
              obj['value'] = val.value;
            } else {
              obj['value'] = val;
            }
          }
          attribute.push(obj);
        }
      }
      console.log(this.attrGroups);
      var cate = {};
      cate['key'] = 'GeneInfo.category';
      cate['value'] = categoryId;
      attribute.push(cate);
      bMerchandise.unitPrice = md.priceMax;
      bMerchandise.initPrice = bMerchandise.unitPrice;
      bMerchandise.merchandiseGuid = md.merchandiseId;
      bMerchandise.attributes = attribute;
      bMerchandise.newMerch = 1;
      //        bMerchandise.geneObject = geneObject
      return bMerchandise;
    },
    clearCust: function clearCust() {
      var attrs = this.merchandise._customizableAttrGroupsList;
      for (var i in attrs) {
        for (var j in attrs[i].attrs) {
          attrs[i].attrs[j].value = '';
          attrs[i].attrs[j].valueText = '';
          attrs[i].attrs[j].sorteditAble = false;
          attrs[i].attrs[j].isNA = false;
        }
      }
      this.curStep = 0;
      //        console.log(this.merchandise._customizableAttributes)
    },
    attrHandler: function attrHandler() {
      var merAttr = this.merchandise._customizableAttributes;
      this.merchandise._customizableAttrGroups = {};
      this.merchandise._customizableAttrGroupsList = [];
      for (var i in merAttr) {
        merAttr[i].value = '';
        merAttr[i].valueText = '';
        merAttr[i]['sorteditAble'] = false;
        merAttr[i]['isNA'] = false;
        // 处理定制属性组
        this.attrGroupHandler(merAttr, i);
      }
      this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
        return a.attrGroupId - b.attrGroupId;
      });
      this.curStep = 0;
    },
    attrGroupHandler: function attrGroupHandler(merAttr, i) {
      var attrGroupId = merAttr[i].groupId;
      var g = this.merchandise._customizableAttrGroups[attrGroupId];
      if (!g) {
        g = __WEBPACK_IMPORTED_MODULE_14__emkt__["a" /* default */].getEmktMetaData().categoryAttrGroupsMap[merAttr[i].groupId];
        g.attrNames = [];
        g.attrs = [];
        this.merchandise._customizableAttrGroups[attrGroupId] = g;
        this.merchandise._customizableAttrGroupsList.push(g);
      }
      g.attrNames.push(i);
      g.attrs.push(merAttr[i]);
    }
  })
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      //        goodList: []
      workdays: '0',
      templateSource: '',
      productName: ''
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['cartList']), {
    attributeList: function attributeList() {
      var merchandise = this.$route.query.custom;
      if (typeof merchandise === 'string') {
        var cartList = this.cartList.cartContent;
        for (var i in cartList) {
          if (i === merchandise) {
            this.workdays = cartList[i].workdays;
            this.productName = cartList[i].productName;
            if (cartList[i].templateSource) {
              this.templateSource = cartList[i].templateSource;
            }
            var attr = cartList[i]._attributesList;
            for (var j in attr) {
              if (attr[j].columnName === 'GeneInfo' && attr[j].value) {
                var symbol = attr[j].value.symbol === undefined ? attr[j].value.microNo : attr[j].value.symbol;
                attr[j].value = symbol;
                attr[j].valueText = symbol;
              }
            }
            return attr;
          }
        }
      } else {
        var res = [];
        merchandise.forEach(function (data) {
          if (data.columnName === 'GeneInfo' && data.value !== undefined) {
            if (JSON.parse(data.value) !== null) {
              var data1 = JSON.parse(data.value);
              console.log(data1);
              var _symbol = data1.symbol === undefined ? data1.microNo : data1.symbol;
              data.valueText = _symbol;
            } else {
              data.value = -1;
              data.valueText = '-1';
            }
          }
          res.push(data);
        });
        if (this.$route.query.workdays) {
          this.workdays = this.$route.query.workdays;
        }
        return res;
      }
    }
  }),
  methods: {
    fetchData: function fetchData() {}
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      priceDetail: []
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  computed: {},
  methods: {
    fetchData: function fetchData() {
      this.priceDetail = this.$route.query.priceDetails;
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.init();
    //      console.log('mounted')
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.products = this.cartList.cartContent;
  },
  data: function data() {
    return {
      products: [],
      isCheckedAll: false,
      result: 0,
      confirmDelete: false,
      readyToDelIndex: -1,
      value: '',
      options: ['Select option', 'options', 'selected', 'mulitple', 'label', 'searchable', 'clearOnSelect', 'hideSelected', 'maxHeight', 'allowEmpty', 'showLabels', 'onChange', 'touched']
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['REMOVE_FROM_CART_LIST']), {
    getChecked: function getChecked(item) {
      if (item.isChecked === void 0) {
        this.$set(item, 'isChecked', true);
      } else {
        item.isChecked = !item.isChecked;
      }
      //        this.isSelectedAll()
      console.log(item);
    },
    changeQuantity: function changeQuantity(good, val) {
      if (good.productQuantity === void 0) {
        this.$set(good, 'productQuantity', 1);
      }
      if (good.productQuantity === 1 && val === -1) {
        this.confirmDelete = true;
        //          this.readyToDelIndex = _index
      } else {
        good.productQuantity += val;
      }
    },
    checkedAll: function checkedAll() {
      var _this2 = this;

      if (this.isCheckedAll === false) {
        this.isCheckedAll = true;
        this.products.forEach(function (item) {
          if (item.isChecked === void 0) {
            _this2.$set(item, 'isChecked', true);
          } else {
            item.isChecked = true;
          }
          console.log(item.isChecked);
        });
      } else {
        this.isCheckedAll = false;
        this.products.forEach(function (item) {
          item.isChecked = false;
          console.log(item.isChecked);
        });
      }
    },
    isSelectedAll: function isSelectedAll() {
      var _this3 = this;

      var flag = true;
      this.products.forEach(function (item) {
        if (!item.isChecked) {
          flag = false;
        }
        if (!flag) {
          _this3.isCheckedAll = false;
        } else {
          _this3.isCheckedAll = true;
        }
      });
    },
    removeProduct: function removeProduct(item, index) {
      var _this = this;
      console.log('index  ' + index);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.confirm('您确定删除此商品吗？', function () {
        console.log('ok');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showIndicator();
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hideIndicator();
        }, 300);
        //          _this.products.splice(index, 1)
        _this.REMOVE_FROM_CART_LIST(item, index);
      }, function () {
        console.log('cancel');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['cartList']), {
    totalPrice: function totalPrice() {
      var t = 0;
      this.products.forEach(function (item) {
        if (item.isChecked) {
          t += item.price * item.productQuantity;
        }
      });
      return t;
    }
  }),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {
      checkedData: '',
      questionUrl: '/emktResources/resocurces/img/question.png'
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {
    attrValueDisplay: function attrValueDisplay() {
      if (this.attribute.value !== '') {
        var valArr = this.attribute.value.split('|$|');
        console.log('attrValueDisplay----->', valArr);
        if (valArr.length > 1) {
          return valArr;
        }
        return this.attribute.value.split('|$');
      }
      return undefined;
    }
  },
  methods: {
    getAfterText: function getAfterText(attribute) {
      this.attribute.options = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('target');
      var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' + '<input type="checkbox" class="checkbox-input-attr" style="font-size: smaller"  name="attr" value="';
      var ret2 = '';
      var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret4 = '"checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var attr = this.attribute.options;
      var height = '';
      var length = 0;
      var data = [];
      for (var k = 0; k < attribute.valueText.split('|$').length; k++) {
        if (attribute.valueText.split('|$')[k] !== '') {
          data.push(attribute.valueText.split('|$')[k]);
        }
      }
      for (var key in attr) {
        console.log(data);
        if (data[key] === attr[key]) {
          ret2 += ret1 + key + ret4 + attr[key] + '</div></div></label></li>';
        } else {
          ret2 += ret1 + key + ret3 + attr[key] + '</div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      return ret;
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert(val);
    },
    getTitle: function getTitle(attribute) {
      return attribute.label;
    },
    showOptionList: function showOptionList(attribute) {
      console.log(attribute);
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
            }
          }
        }, {
          text: '完成',
          bold: true,
          onClick: function onClick() {
            var val = '';
            var radio = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.checkbox-input-attr');
            for (var i = 0; i < radio.length; i++) {
              if (radio[i].checked) {
                var selectedVal = _this.attribute.options[radio[i].value];
                val = val === '' ? selectedVal : val + '|$' + selectedVal;
                console.log('selected value --------');
              }
            }
            if (_this.attribute.value !== val) {
              _this.attribute.value = val;
              //                  let data = []
              //                  data = val.split(' ')
              //                  let l = data[0]
              //                  for (var j = 1; j < data.length; j++) {
              //                    if (data[j] !== ' ') {
              //                      l = l + ' ' + _this.attribute.options[data[j]]
              //                    }
              //                  }
              _this.attribute.valueText = val;
              _this.checkedData = val;
              //                  _this.valueChanged(attribute)
            }
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.closeModal();
          }
        }]
      });
    },
    valueChanged: function valueChanged(attribute) {
      this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute);
      //        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
    }
    //      ,
    //      getKeyByValue (value) {
    //        let obj = this.attribute.options
    //        for (var prop in obj) {
    //          if (obj.hasOwnProperty(prop)) {
    //            if (obj[prop] === value) {
    //              return prop
    //            }
    //          }
    //        }
    //      }

  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.$emit('controlForm', this.index, this.curAttrsInGroup, val);
    }
    //      ,
    //      attribute: {
    //        handler: function (val) {
    //          this.attribute.value = this.getKeyByValue(val)
    //        },
    //        deep: true
    //      }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attr-text-box',
  data: function data() {
    return {
      checkedData: '',
      questionUrl: '/emktResources/resocurces/img/question.png',
      serarchOptions: [],
      serarchcustomerOptions: [],
      searchdata: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'attrGroups'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: {},
  methods: {
    fetchData: function fetchData() {},
    getAfterText: function getAfterText(attribute) {
      this.attribute.options = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos');
      var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' + '<input type="radio" class="radio-input-attr"  name="attr" value="';
      var ret2 = '';
      var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret5 = '<div style="font-size: small">';
      var ret6 = '  <div class="searchbar row" id="showsearch"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput" placeholder="合同号／合同名称" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="searchContract"><span class="icon icon-search"></span></a> </div>';
      var ret7 = '  <div class="searchbar row" id="showsearchcushomer"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput1" placeholder="客户编号" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="searchcustomerContract"><span class="icon icon-search"></span></a> </div>';
      var ret8 = '  <div class="searchbar row" id="customerinput"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="yuancontract" placeholder="直接填写合同号" /> </div> ' + '<a  class="button button-fill button-primary col-15" id="customerContract" style="width: 15%"><span class="icon icon-button" >确定</span></a> </div>';
      var attr = void 0;
      if (this.serarchOptions.length > 0 && this.searchdata !== '') {
        attr = this.serarchOptions;
      } else if (this.serarchcustomerOptions.length > 0) {
        attr = this.serarchcustomerOptions;
      } else {
        attr = this.attribute.options;
      }
      var height = '';
      var length = 0;
      for (var key in attr) {
        if (attribute.value === attr[key]) {
          ret2 += ret1 + key + ret4 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>';
        } else {
          ret2 += ret1 + key + ret3 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      if (this.getTitle(attribute) === '您没有过历史定制合同，请全新定制!') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#showsearch').hide();
        return ret;
      } else {
        return ret;
      }
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert(val);
    },
    getTitle: function getTitle(attribute) {
      if (__WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos') && __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos').length < 1 || __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('newContractNos') === undefined) {
        return '您没有过历史定制合同，请全新定制';
        //          alert('您没有过历史定制合同，请全新定制！')
      } else {
        return attribute.label;
      }
    },
    showOptionList: function showOptionList(attribute) {
      var _this = this;
      _this.attribute.options = [];
      //        $.showPreloader('正在查询')
      //        setTimeout(function () {
      //        }, 500)
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.hidePreloader();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
              _this.attribute.valueText = _this.checkedData;
            }
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr').on('click', function () {
        var val = void 0;
        var radio = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr');
        if (_this.serarchOptions.length > 0 && _this.searchdata !== '') {
          for (var j = 0; j < radio.length; j++) {
            if (radio[j].checked) {
              val = _this.serarchOptions[radio[j].value];
            }
          }
        } else if (_this.serarchcustomerOptions.length > 0) {
          for (var k = 0; k < radio.length; k++) {
            if (radio[k].checked) {
              val = _this.serarchcustomerOptions[radio[k].value];
            }
          }
        } else {
          for (var i = 0; i < radio.length; i++) {
            if (radio[i].checked) {
              val = _this.attribute.options[radio[i].value];
            }
          }
        }
        if (_this.attribute.value !== val) {
          _this.attribute.value = val;
          _this.attribute.valueText = val;
          _this.checkedData = val;
          if (_this.serarchcustomerOptions.length < 1) {
            _this.valueChanged(attribute);
          }
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.closeModal();
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcustomerContract').on('click', function () {
        _this.serarchcustomerOptions = [];
        _this.serarchOptions = [];
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchinput1').val();
        console.log(data);
        _this.gcapi('searchContractNo', data).then(function (response) {
          _this.serarchcustomerOptions = response.body.result;
          var contractNos = [];
          var newContractNos = [];
          contractNos = response.body.result;
          if (_this.curAttrsInGroup[2].value === '3') {
            newContractNos = [];
            for (var no1 in contractNos) {
              if (contractNos[no1].split(':')[0].indexOf('A') !== -1 && contractNos[no1].split(':')[0].indexOf('GVAP') === -1) {
                newContractNos.push(contractNos[no1]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '4') {
            newContractNos = [];
            for (var no in contractNos) {
              if (contractNos[no].split(':')[0].indexOf('V') !== -1 && contractNos[no].split(':')[0].indexOf('GVAP') === -1) {
                newContractNos.push(contractNos[no]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '2') {
            newContractNos = [];
            for (var no4 in contractNos) {
              if (contractNos[no4].indexOf('病毒') !== -1 || contractNos[no4].indexOf('质粒') !== -1 || contractNos[no4].indexOf('shRNA') !== -1 || contractNos[no4].split(':')[0].indexOf('GCI') !== -1) {
                newContractNos.push(contractNos[no4]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '1') {
            newContractNos = [];
            for (var no2 in contractNos) {
              if (contractNos[no2].split(':')[0].indexOf('L') !== -1 || contractNos[no2].split(':')[0].indexOf('GCI') !== -1) {
                newContractNos.push(contractNos[no2]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
          } else if (_this.curAttrsInGroup[2].value === '6') {
            newContractNos = [];
            for (var no5 in contractNos) {
              if (contractNos[no5].split(':')[0].indexOf('R') !== -1) {
                newContractNos.push(contractNos[no5]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
            //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
            //                  if (response.body.result.labelNames !== undefined) {
            //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
            //                  }
            //                })
          } else if (_this.curAttrsInGroup[2].value === '7') {
            newContractNos = [];
            for (var no6 in contractNos) {
              if (contractNos[no6].split(':')[0].indexOf('GOSL') !== -1 || contractNos[no6].split(':')[0].indexOf('慢病毒') !== -1 && contractNos[no6].split(':')[0].indexOf('悬浮专用') !== -1) {
                newContractNos.push(contractNos[no6]);
              }
            }
            _this.serarchcustomerOptions = newContractNos;
            //                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
            //                  if (response.body.result.labelNames !== undefined) {
            //                    Emkt.setLocalStorage('target', response.body.result.labelNames)
            //                  }
            //                })
          } else {
            _this.serarchcustomerOptions = contractNos;
          }
          if (_this.serarchcustomerOptions.length < 1) {
            alert('此用户没有符合条件的合同，请您全新定制！');
          }
          _this.showOptionList(_this.attribute);
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchContract').on('click', function () {
        _this.serarchcustomerOptions = [];
        _this.serarchOptions = [];
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchinput').val();
        _this.searchdata = data;
        for (var i = 0; i < _this.attribute.options.length; i++) {
          if (_this.attribute.options[i].indexOf(data) !== -1) {
            _this.serarchOptions.push(_this.attribute.options[i]);
          }
        }
        if (_this.serarchOptions.length < 1 && data !== '') {
          alert('查询结果无此合同号！');
        } else {
          _this.showOptionList(_this.attribute);
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#customerContract').on('click', function () {
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#yuancontract').val().toString();
        if (!(data.replace(/^[a-zA-Z0-9]+$/g, '') === '')) {
          _this.attribute.value = '';
          _this.attribute.valueText = '';
          alert('请您填写数字和英文');
        } else {
          _this.attribute.value = data;
          _this.attribute.valueText = data;
        }
        //            _this.$emit('controlForm', 4, _this.curAttrsInGroup, _this.attribute)
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.hidePreloader();
      });
    },
    valueChanged: function valueChanged(attribute) {}
    //        this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute)
    //        this.$emit('judgeValue', this.curAttrsInGroup, this.index)

    //      ,
    //      getKeyByValue (value) {
    //        let obj = this.attribute.options
    //        for (var prop in obj) {
    //          if (obj.hasOwnProperty(prop)) {
    //            if (obj[prop] === value) {
    //              return prop
    //            }
    //          }
    //        }
    //      }

  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.options = [];
      this.attribute.options.push(val);
      this.$emit('controlForm', this.index, this.curAttrsInGroup, val);
      //        this.attribute.valueText = this.attribute.options[val]
    }
    //      ,
    //      attribute: {
    //        handler: function (val) {
    //          this.attribute.value = this.getKeyByValue(val)
    //        },
    //        deep: true
    //      }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {}
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {}
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      myCoupons: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'count': function count() {
      return this.sessionInfo.expressAddress.length;
    }
  }),
  watch: {},
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var customerNo = this.sessionInfo.customerInfo.customerNo;
      this.gcapi('getMyCoupons', customerNo).then(function (res) {
        _this.myCoupons = res.body.result;
      });
    }
  },
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      myCoupons: []
    };
  },

  computed: {},
  watch: {},
  methods: {
    fetchData: function fetchData() {
      var myOrderCoupons = JSON.parse(this.$route.query.myOrderCoupons);
      if (myOrderCoupons) {
        this.myCoupons = myOrderCoupons;
      }
    },
    getCoupon: function getCoupon(index) {
      __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].setStoreItem('myCoupons', this.myCoupons[index]);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('ul li')[index].style.background = 'grey';
      this.$router.go(-1);
    }
  },
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.orderList = this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      return this.$route.query.orderList;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']))
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      merchandises: this.$route.query.order.merchandises,
      order: this.$route.query.order
    };
  },

  methods: {}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      orderList: [],
      limitNum: 1
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('getOrderContent').then(function (res) {
        _this.orderList = res.data.OrderList;
      });
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {}
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emkt__ = __webpack_require__(5);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//  import Clipboard from 'clipboard'
/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$nextTick(function () {
      //        if (this.order.lotteryURL) {
      this.getActivity();
      //        }
    });
  },
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('正在查询活动信息');
    _this.gcapi('retrieveMyOrder').then(function (response) {
      console.log('retrieveMyOrder', response);
      _this.MYORDER_UPDATE(response.body.result);
      _this.showLottery();
    });
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_7__components_MerchandiseList_vue___default.a
  },
  data: function data() {
    return {
      order: this.$route.query.BOrders[0],
      recomPproducts: this.emkt.getLocalStorage('EmktAllRecommends'),
      description: '为你推荐',
      ifShowInstruction: false,
      promotions618Used: [],
      ifIsMonthlyFirstOrder: false
    };
  },

  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])(['sessionInfo', 'myOrder', 'showLotteryAlready']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName']), {
    mobile: function mobile() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile;
    },
    enterpriseName: function enterpriseName() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName;
    },
    customerNo: function customerNo() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'MYORDER_UPDATE']), {
    getActivity: function getActivity() {
      // let _this = this
      // _this.gcapi('getSuccessPayData').then(function (response) {
      //   var successdata = JSON.parse(response.body.result)
      //   var order = _this.$route.query.order.merchandises
      //   var isshowbox = false
      //   var num = 0
      //   if (successdata.availableFlag === 1) {
      //     if (successdata.total === 0) {
      //       if (successdata.category.length > 0) {
      //         for (var n = 0; n < successdata.category.length; n++) {
      //           num = 0
      //           for (var m = 0; m < order.length; m++) {
      //             if (order[m].discountPrice === 0 && order[m].merchandiseDetailForClient.categoryId === successdata.category[n]) {
      //               num = num + order[m].quantity
      //             }
      //           }
      //           if (num >= successdata.num) {
      //             isshowbox = true
      //             break
      //           }
      //         }
      //       } else {
      //         num = 0
      //         for (var i = 0; i < order.length; i++) {
      //           if (order[i].discountPrice === 0) {
      //             num = num + order[i].quantity
      //           }
      //         }
      //         if (num >= successdata.num) {
      //           isshowbox = true
      //         }
      //       }
      //     } else {
      //       if (successdata.category.length > 0) {
      //         num = 0
      //         for (var o = 0; o < successdata.category.length; o++) {
      //           for (var p = 0; p < order.length; p++) {
      //             if (order[p].discountPrice === 0 && order[p].merchandiseDetailForClient.categoryId === successdata.category[0]) {
      //               num = num + order[p].quantity
      //             }
      //           }
      //         }
      //         if (num >= successdata.num) {
      //           isshowbox = true
      //         }
      //       } else {
      //         num = 0
      //         for (var r = 0; r < order.length; r++) {
      //           if (order[r].discountPrice === 0) {
      //             num = num + order[r].quantity
      //           }
      //         }
      //         if (num >= successdata.num) {
      //           isshowbox = true
      //         }
      //       }
      //     }
      //   }
      //   if (isshowbox) {
      //     let url = successdata.url
      //     $.modal({
      //       text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/successshow.jpg"></div>',
      //       buttons: [{
      //         text: '关闭'
      //       }],
      //       onClick: function () {
      //         $.modal({
      //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
      //           buttons: [{
      //             text: '确定放弃',
      //             onClick: function () {
      //               _this.getLotteryChance()
      //             }
      //           }, {
      //             text: '返回抽奖',
      //             onClick: function () {
      //               _this.getLotteryChance()
      //             }
      //           }]
      //         })
      //       }
      //     })
      //     $('#lottery').click(function () {
      //       window.open(url)
      //       $.closeModal()
      //     })
      //   }
      // })
      //        this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
      //          if (res.body.result) {
      //            let url = res.body.result
      //            $.modal({
      //              text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
      //              buttons: [{
      //                text: '关闭'
      //              }],
      //              onClick: function () {
      //                $.modal({
      //                  text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
      //                  buttons: [{
      //                    text: '确定放弃',
      //                    onClick: function () {
      //                      _this.getLotteryChance()
      //                    }
      //                  }, {
      //                    text: '返回抽奖',
      //                    onClick: function () {
      //                      _this.getLotteryChance()
      //                    }
      //                  }]
      //                })
      //              }
      //            })
      //            $('#lottery').click(function () {
      //              window.open(url)
      //              $.closeModal()
      //            })
      //          }
      //        })
      //         if (_this.$route.query.order.totalPrice > 3000) {
      //           this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
      //             if (res.body.result) {
      //               let url = res.body.result
      //               $.modal({
      //                 text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
      //                 buttons: [{
      //                   text: '关闭'
      //                 }],
      //                 onClick: function () {
      //                   $.modal({
      //                     text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
      //                     buttons: [{
      //                       text: '确定放弃',
      //                       onClick: function () {
      //                         _this.getLotteryChance()
      //                       }
      //                     }, {
      //                       text: '返回抽奖',
      //                       onClick: function () {
      //                         _this.getLotteryChance()
      //                       }
      //                     }]
      //                   })
      //                 }
      //               })
      //               $('#lottery').click(function () {
      //                 window.open(url)
      //                 $.closeModal()
      //               })
      //             }
      //           })
      //         }
      //        if (this.myOrder && ((this.myOrder.completeOrders.length + this.myOrder.waitDeliverOrders.length + this.myOrder.finishedOrders.length) === 0)) {
      //          this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
      //            if (res.body.result) {
      //              let url = res.body.result
      //              $.modal({
      //                text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
      //                buttons: [{
      //                  text: '关闭'
      //                }],
      //                onClick: function () {
      //                  $.modal({
      //                    text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
      //                    buttons: [{
      //                      text: '确定放弃',
      //                      onClick: function () {
      //                        _this.getLotteryChance()
      //                      }
      //                    }, {
      //                      text: '返回抽奖',
      //                      onClick: function () {
      //                        _this.getLotteryChance()
      //                      }
      //                    }]
      //                  })
      //                }
      //              })
      //              $('#lottery').click(function () {
      //                window.open(url)
      //                $.closeModal()
      //              })
      //            }
      //          })
      //        }
      //        if (this.myOrder && ((this.myOrder.completeOrders.length + this.myOrder.waitDeliverOrders.length + this.myOrder.finishedOrders.length) === 0)) {
      //          $.modal({
      //            text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/static/desc/img/song_register.jpg"></div>',
      //            buttons: [{
      //              text: '关闭'
      //            }],
      //            onClick: function () {
      //              $.modal({
      //                text: '首单奖励',
      //                buttons: [{
      //                  text: '已查看'
      //                }]
      //              })
      //            }
      //          })
      //          $('#lottery').click(function () {
      //            $.closeModal()
      //          })
      //        }
    },
    showLottery: function showLottery() {
      var _this2 = this;

      // 是否参与抽奖，刷新后不获取抽奖信息
      var paidOrder = this.$route.query.order;
      if (!paidOrder || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(paidOrder) === '{}' || !paidOrder.merchandises) {
        return __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('暂无抽奖信息');
      }
      // 先判断是不是首单，此值需要传到优惠券领取页面
      this.ifIsMonthlyFirstOrder = this.isMonthlyFirstOrder();
      // 获取此订单中使用的618活动促销
      this.getPromotions618();
      if (this.promotions618Used && this.promotions618Used.length > 0) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
        this.ifShowInstruction = true;
      } else {
        this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then(function (res) {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
          if (res.body.result && res.body.result.length > 0) {
            var lotteryInfo = res.body.result[0];
            var url = lotteryInfo.url;
            // 享受520促销，判断是否有抽奖记录
            // if (this.has520Promotion()) {
            //   const lotteryRecord = {
            //     guid: lotteryInfo.guid,
            //     customerNo: this.sessionInfo.customerInfo.customerNo
            //   }
            //   this.gcapi('checkedLotteryrecords', lotteryRecord).then(res => {
            //     if (!res.body.result) {
            //       $.toast('您已经抽过奖了')
            //       return
            //     }
            //     let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/a-178-show.png"></a></div>'
            //     const self = this
            //     $.modal({
            //       text: domText,
            //       buttons: [{
            //         text: '关闭'
            //       }],
            //       onClick: function () {
            //         $.modal({
            //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
            //           buttons: [{
            //             text: '确定放弃',
            //             onClick: function () {
            //             }
            //           }, {
            //             text: '<a href="' + url + '">返回抽奖</a>',
            //             onClick: () => {
            //               // 防止iphone手机报错，加@抑制报错信息
            //               self.gcapi('@submitLotteryrecords', lotteryRecord)
            //             }
            //           }]
            //         })
            //       }
            //     })
            //     $('#lottery').click(() => {
            //       self.gcapi('@submitLotteryrecords', lotteryRecord).then(res => {})
            //       $.closeModal()
            //     })
            //   })
            // } else {
            // 每个月首单抽奖，无需判断是否有抽奖记录
            if (!_this2.ifIsMonthlyFirstOrder) return __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('暂无抽奖信息');
            var domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></a></div>';
            // const self = this
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
              text: domText,
              buttons: [{
                text: '关闭'
              }],
              onClick: function onClick() {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
                  text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                  buttons: [{
                    text: '确定放弃',
                    onClick: function onClick() {}
                  }, {
                    text: '<a href="' + url + '">返回抽奖</a>',
                    onClick: function onClick() {}
                  }]
                });
              }
            });
            // }
          }
        });
      }
    },
    isMonthlyFirstOrder: function isMonthlyFirstOrder() {
      if (!this.myOrder) return true;
      var currentMonth = new Date().getMonth() + 1;
      var currentYear = 2020;
      if (![4, 5, 6].includes(currentMonth)) return true;
      var waitDeliverAndFinishedOrders = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.myOrder.waitDeliverOrders), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.myOrder.finishedOrders));
      var orderSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      waitDeliverAndFinishedOrders.filter(function (order) {
        return new Date(order.payDT.replace(/-/g, '/')).getFullYear() === currentYear;
      }).forEach(function (order) {
        if (new Date(order.payDT.replace(/-/g, '/')).getMonth() + 1 === currentMonth) {
          orderSet.add(order.payDT.replace(/-/g, '/'));
        }
      });
      console.log('orderSet', orderSet);
      return orderSet.size === 1;
    },

    // has520Promotion () {
    //   const paidOrder = this.$route.query.order
    //   if (!paidOrder || JSON.stringify(paidOrder) === '{}' || !paidOrder.merchandises) {
    //     return false
    //   }
    //   return paidOrder.merchandises.some(merchandise => {
    //     return merchandise && merchandise.perferPromotions && merchandise.perferPromotions.find(promotion => promotion && (promotion.promotionGuid.includes('-178') || promotion.promotionGuid.includes('-179')))
    //   })
    // },
    getPromotions618: function getPromotions618() {
      var paidOrder = this.$route.query.order;
      if (!paidOrder || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(paidOrder) === '{}' || !paidOrder.merchandises) {
        this.promotions618Used = [];
      }
      var promotionGuids618 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].promotions618);
      var promotionsSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      paidOrder.merchandises.forEach(function (merchandise) {
        merchandise && merchandise.perferPromotions && merchandise.perferPromotions.forEach(function (promotion) {
          if (promotion && promotionGuids618.includes(promotion.promotionGuid)) {
            promotionsSet.add(promotion.promotionGuid);
          }
        });
      });
      this.promotions618Used = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(promotionsSet)).sort().map(function (guid) {
        return __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].promotions618[guid];
      });
      var guids = this.promotions618Used.map(function (pro) {
        return pro.guid;
      }).join(',');
      __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].setStoreItem('promotionGuids618Used', guids);
      console.log('promotions618Used', this.promotions618Used);
    },
    currentDayIs618: function currentDayIs618() {
      var promotions = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getLocalStorage('EmktPromotions');
      var pro = promotions && promotions.find(function (pro) {
        return pro.promotionGuid === 'promotion-20200602-186';
      });
      var startDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second);
      var endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second);
      var now = new Date();
      console.log('currentDayIs618', now >= startDT && now <= endDT);
      return now >= startDT && now <= endDT;
    },
    getCouponForSelf: function getCouponForSelf() {
      var _this3 = this;

      this.ifShowInstruction = false;
      if (!this.hasLogin) {
        return alert('请先登录');
      }
      if (!this.promotions618Used || this.promotions618Used.length === 0) {
        return alert('无可领优惠券');
      }
      if (!this.customerNo || !this.mobile || !this.customerName || !this.enterpriseName) {
        return alert('个人信息不完整，请联系业务员');
      }
      var formCollectionActivity = {
        'customerNo': this.customerNo,
        'customerMobile': this.mobile,
        'customerName': this.customerName,
        'customerEnterpriseName': this.enterpriseName,
        'activityName': '618领取优惠券',
        'attachmentName': __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getLocalStorage('promotionGuids618Used'),
        'additionalinfos': []
      };
      formCollectionActivity['additionalinfos'].push({
        'columnName': '券是否自用',
        'columnValue': '券自用'
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者电话号码',
        'columnValue': this.mobile
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者姓名',
        'columnValue': this.customerName
      });
      var formCollectionActivityList = [];
      formCollectionActivityList.push(formCollectionActivity);
      this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then(function (response) {
        if (response.body.result === false) {
          return __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('提交失败');
        } else {
          // 领取优惠券后，清空订单中使用的618促销guids
          __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].setStoreItem('promotionGuids618Used', '');
          var result = void 0,
              text = void 0;
          result = '领取成功';
          text = '折扣券将在3-5个工作日发放完毕';
          _this3.$router.replace({ name: 'OperationResult', query: { result: result, text: text, 'showLottery': _this3.ifIsMonthlyFirstOrder } });
        }
      });
    },
    getCouponForFriend: function getCouponForFriend() {
      this.$router.replace({ name: 'SearchContactWithoutDetail', query: { 'showLottery': this.ifIsMonthlyFirstOrder } });
    }
  }),
  addCartListForRecom: function addCartListForRecom(item, index) {
    //        let pl = index
    var pl = '五周年';
    var pr = [];
    pr.push(item);
    this.ADD_CART_LIST({ pl: pl, pr: pr });
    __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('加入购物车成功！');
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {
    this.sessionInfo.invoiceAddress.forEach(function (item) {
      item.isSelected = false;
    });
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  watch: {},
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    selectInvoicAddress: function selectInvoicAddress(index) {
      this.sessionInfo.invoiceAddress[index].isSelected = true;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('ul li')[index].style.background = 'grey';
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child_Order_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__child_Order_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var self = this;
    var invoiceTitle = this.sessionInfo.invoiceTitle;
    if (invoiceTitle) {
      var defTitle = invoiceTitle.filter(function (item) {
        return item.isDefault === 1;
      });
      if (defTitle.length > 0) {
        this.defaultTitle = defTitle[0].enterpriseName;
        this.taxpayerIdentificationNo = defTitle[0].invoiceTaxRegNo;
      }
    }
    this.sessionInfo.invoiceAddress.forEach(function (item) {
      if (item.isDefault) {
        self.invoiceAddress.push(item);
        self.defaultInvoiceAddress = false;
      }
    });
    // // 获取所有有效的任职关系列表，选择任职关系初始默认值
    // this.workExperienceList = emkt.getLocalStorage('EmktWorkExperienceList')
    // if (this.workExperienceList && this.workExperienceList.length > 0) {
    //   this.workExperienceNameList = this.workExperienceList.map(work => {
    //     return work.firstLevelEnterpriseName + (work.secondLevelEnterpriseName ? work.secondLevelEnterpriseName : '')
    //   })
    // } else {
    //   // 如果该客户无任职关系信息，取客户的个人信息中的单位信息
    //   const customerInfo = this.sessionInfo.customerInfo
    //   if (customerInfo && customerInfo.enterpriseNo) {
    //     const enterprise = {
    //       firstLevelEnterpriseNo: customerInfo.enterpriseNo,
    //       firstLevelEnterpriseName: customerInfo.enterpriseName
    //     }
    //     this.workExperienceList = [enterprise]
    //     this.workExperienceNameList = [customerInfo.enterpriseName]
    //   }
    // }
    // if (this.workExperienceNameList.length > 1) {
    //   this.ifNeedChooseWorkExperience = true
    // } else {
    //   this.ifNeedChooseWorkExperience = false
    // }
    // this.chosenWorkExperienceName = this.workExperienceNameList[0]
    // this.chosenWorkExperience = this.workExperienceList[0]
    // console.log('nameList', this.researchGroupSet, this.researchGroupNameList, this.workExperienceList, this.workExperienceNameList)
    // if (this.payType === 3 && this.ifNeedChooseWorkExperience) {
    //   this.showOptionList('workExperience', 0)
    // }
  },
  created: function created() {
    if (this.sessionInfo.customerInfo && (this.sessionInfo.customerInfo.payTypeID === 1 || this.sessionInfo.customerInfo.payTypeID === 3)) {
      this.isCredit = true;
    }
    this.storedchoosedisplay = false;
    this.customerNo = this.sessionInfo.customerInfo.customerNo;
    this.getResearchGroupAndWorkExperience(this.customerNo);
  },

  components: {
    orderContent: __WEBPACK_IMPORTED_MODULE_4__child_Order_vue___default.a
  },
  data: function data() {
    return {
      orderList: [],
      limitNum: 1,
      totalMoney: 0,
      order: this.$route.params.order,
      oldorder: {},
      payType: '3',
      defaultTitle: '',
      invoiceAddress: [],
      defaultInvoiceAddress: true,
      isCredit: false,
      taxpayerIdentificationNo: '',
      questionUrl: '/emktResources/resocurces/img/question.png',
      productInfo: { value: {} },
      showButton: true,
      veriCode: '',
      customerNo: '',
      coolDown: false,
      mobile: '',
      vipyanzheng: false,
      storedchoosedisplay: false,
      ifcanUseVipPlan: false,
      customerStoredPlanNo: '',
      planCustomerNo: '',
      vipPLan: [{
        vipguid: '1',
        checked: true
      }, {
        vipguid: '2',
        checked: false
      }],
      newgoodsMoney: 0,
      yueyanzheng: false,
      researchGroupNameList: [],
      chosenResearchGroupName: '',
      workExperienceNameList: [],
      chosenWorkExperienceName: '',
      workExperienceList: [],
      chosenWorkExperience: {},
      ifNeedChooseWorkExperience: false,
      saveItemInOrder: {
        0: 'workExperience',
        1: 'researchGroup'
      },
      yfukuanmoney: false,
      selectedBalanceType: __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER,
      selectedPayType: __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PAY_TYPE_FAPIAO,
      chosenSettlementAccount: null,
      settlementAccountList: [],
      payTypeOptionMapping: {
        '1': 2,
        '3': 0,
        '6': 3,
        '7': 4
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['sessionInfo'])),
  watch: {
    'selectedPayType': {
      handler: 'handlePayTypeChange'
    },
    'selectedBalanceType': {
      handler: 'handleBalanceTypeChange'
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['MYORDER_UPDATE']), {
    fetchData: function fetchData() {},
    getResearchGroupAndWorkExperience: function getResearchGroupAndWorkExperience(customerNo) {
      var _this2 = this;

      // 获取所有的课题组信息
      this.gcapi('getSettlementAccountListInfo', customerNo).then(function (res) {
        if (res.body.result) {
          _this2.settlementAccountList = res.body.result;
          if (!_this2.settlementAccountList || _this2.settlementAccountList.length === 0) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
            return;
          }
          // 选择第一个正常的课题组为默认课题组
          for (var i = 0; i < _this2.settlementAccountList.length; i++) {
            if (_this2.settlementAccountList[i].settlementAccountStatus === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
              _this2.chosenSettlementAccount = _this2.settlementAccountList[i];
              _this2.selectedBalanceType = _this2.chosenSettlementAccount;
              break;
            }
          }
          if (_this2.chosenSettlementAccount == null) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
          }
        }
        _this2.calculatePriceByAccountDiscountRatio(_this2.customerNo);
      });
    },
    getOptionListHtml: function getOptionListHtml(optionList, optionName) {
      var className = 'radio-input-attr';
      var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' + '<input type="radio"  class="' + className + '" name="attr" value="';
      var ret2 = '';
      var ret3 = '" ><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">';
      var height = '';
      var length = 0;
      var chosenValue = optionName === 'research' ? this.chosenResearchGroupName : this.chosenWorkExperienceName;
      for (var i = 0; i < optionList.length; i++) {
        var name = optionList[i];
        if (chosenValue === name) {
          ret2 += ret1 + name + '" id="' + i + ret4 + name + '</div></div></label></li>';
        } else {
          ret2 += ret1 + name + '" id="' + i + ret3 + name + '</div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      return ret;
    },
    showOptionList: function showOptionList(optionName, chooseIndex) {
      if (optionName !== 'research' && this.ifNeedChooseWorkExperience === false) {
        console.log('不需要选择任职关系');
        if (chooseIndex === 2) {
          this.payByRestMoney(true);
        }
        return;
      }
      var optionList = optionName === 'research' ? this.researchGroupNameList : this.workExperienceNameList;
      var title = optionName === 'research' ? '请选择课题组' : '请选择您目前的任职信息';
      var error = optionName === 'research' ? '您尚未添加过课题组' : '';
      if (optionList.length === 0) {
        if (error) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.alert(error);
        }
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
        title: title,
        afterText: this.getOptionListHtml(optionList, optionName),
        buttons: [{
          text: '关闭',
          bold: true,
          onClick: function onClick() {}
        }]
      });
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.radio-input-attr').on('click', function (e) {
        e.preventDefault();
        if (optionName === 'research') {
          // debugger
          var id = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).attr('id');
          var chosenName = self.researchGroupNameList[id];
          console.log('radio id', id);
          if (self.researchGroupSet[id].status === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_DISABLE) {
            return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.alert(chosenName + '未启用，请选择其他课题组');
          }
          if (self.researchGroupSet[id].status === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_LOCKED) {
            return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.alert(chosenName + '已被冻结，请联系业务员解锁');
          }
          if (self.researchGroupSet[id].status === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_EXPIRED) {
            return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.alert(chosenName + '已过期，请选择其他课题组');
          }
          var val = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).val();
          console.log('click', val);
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal();
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('您已选择' + val);
          self.chosenResearchGroupName = val;
          self.updateChoice(optionName);
          if (chooseIndex === 4) {
            var _val = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).val();
            // debugger
            console.log('click', _val);
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal();
            if (chooseIndex === 2 || chooseIndex === 4) {
              self.payByRestMoney(false);
            }
          }
          self.calculatePriceByAccountDiscountRatio(self.customerNo);
        } else {
          var _val2 = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).val();
          // debugger
          console.log('click', _val2);
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal();
          self.chosenWorkExperienceName = _val2;
          self.updateChoice(optionName);
          if (chooseIndex === 2) {
            self.payByRestMoney(true);
          }
        }
      });
    },
    updateChoice: function updateChoice(optionName) {
      if (optionName === 'research' && this.chosenResearchGroupName) {
        var index = this.researchGroupNameList.indexOf(this.chosenResearchGroupName);
        if (index !== -1) {
          console.log('chosenReseachGroup', this.chosenResearchGroupName, this.researchGroupSet[index]);
          this.chosenResearchGroup = this.researchGroupSet[index];
        }
      }
      if (optionName !== 'research' && this.chosenWorkExperienceName) {
        var _index = this.workExperienceNameList.indexOf(this.chosenWorkExperienceName);
        if (_index !== -1) {
          console.log('chosenWorkExperience', this.workExperienceList[_index]);
          this.chosenWorkExperience = this.workExperienceList[_index];
        }
      }
    },
    selectAddress: function selectAddress() {
      if (!this.defaultInvoiceAddress) {
        this.$router.push({ name: 'myInvoiceAddress', params: { order: this.order } });
      }
    },
    yanzheng: function yanzheng(optionIndex) {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(this.vipPLan, function (index, item) {
        item.checked = false;
      });
      this.vipyanzheng = false;
      this.vipPLan[optionIndex].checked = true;
      var _this = this;
      var radio = document.getElementsByName('my-radio');
      for (var i = 0; i < radio.length; i++) {
        if (radio[i].checked) {
          _this.payType = radio[i].value;
        }
      }
      var div = ' <div class="item-content"> ' + ' <div class="item-inner"> ' + ' <div class="item-title label" style="margin-bottom: 10px">向管理员发送短信验证码</div> ' + ' <div class="item-input" style="display: inline-block"> ' + ' <input  id="veriCode" style="width:6rem;display: inline;" type="text" pattern="[0-9]*" v-model.trim="veriCode" placeholder="验证码"> ' + ' <div style="display: inline;width: 2.5rem"> ' + ' <a   id="sendcode" >发送</a> </div> </div> </div> </div> ';
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
        afterText: div,
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {}
        }, {
          text: '确定',
          bold: true,
          onClick: function onClick() {
            var param = {
              'LoginId': _this.mobile,
              'VerifyCode': __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#veriCode').val()
            };
            _this.gcapi('gcwwwifc/verifyCustomerCode', param).then(function (response) {
              if (response.body.code === 0) {
                alert(response.body.message);
                _this.customerStoredPlanNo = _this.vipPLan[optionIndex].GUID;
                _this.vipyanzheng = true;
                _this.gcapi('retrieveCustomerPlanMemberInformation', _this.vipPLan[optionIndex].GUID).then(function (response) {
                  var data = response.body.result;
                  for (var i in data) {
                    if (data[i].role === 1) {
                      _this.mobile = data[i].mobile;
                      var bOrders = [];
                      var invoiceAddress = void 0;
                      var invoiceExpressContactor = void 0;
                      var invoiceExpressAddress = void 0;
                      var invoiceExpressPhone = void 0;
                      if (!_this.defaultInvoiceAddress) {
                        invoiceAddress = _this.invoiceAddress;
                      } else {
                        invoiceAddress = _this.sessionInfo.expressAddress.filter(function (item) {
                          return item.isDefault === 1;
                        });
                      }
                      if (invoiceAddress && invoiceAddress.length > 0) {
                        var invoice = invoiceAddress[0];
                        invoiceExpressContactor = invoice.consignee;
                        invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress;
                        invoiceExpressPhone = invoice.expressMobile;
                      }
                      console.log(_this.customerStoredPlanNo);
                      var bOrder = {
                        payType: _this.payType,
                        id: _this.order.id,
                        invoiceTitle: _this.defaultTitle,
                        taxpayerIdentificationNo: _this.taxpayerIdentificationNo,
                        invoiceExpressContactor: invoiceExpressContactor,
                        invoiceExpressAddress: invoiceExpressAddress,
                        invoiceExpressPhone: invoiceExpressPhone,
                        prepayCustomerNo: _this.customerNo,
                        customerStoredPlanNo: _this.vipPLan[optionIndex].GUID
                      };
                      if (bOrder.payType === '5') {
                        bOrder.prepayCustomerNo = data[i].customerPlanMemberNo;
                        _this.customerNo = data[i].customerPlanMemberNo;
                      }
                      bOrder.amplification = _this.order.amplification;
                      bOrders.push(bOrder);
                      var obj = {};
                      obj.bOrders = bOrders;
                      obj.customerNo = data[i].customerPlanMemberNo;
                      _this.gcapi('calculatePriceByAccountDiscountRatio', obj).then(function (response) {
                        if (response.body.result !== null && response.body.result.length > 0) {
                          if (_this.order.merchandises.length === 1) {
                            _this.order.merchandises[0].price = response.body.result[0].price;
                            _this.order.merchandises[0].discountPrice = response.body.result[0].discountPrice;
                            _this.order.price = response.body.result[0].price;
                            _this.order.totalPrice = response.body.result[0].totalPrice;
                            _this.order.discountPrice = response.body.result[0].discountPrice;
                          } else {
                            var price = 0;
                            var totalPrice = 0;
                            var discountPrice = 0;
                            var initPrice = 0;
                            if (_this.order.subOrders.length > 0) {
                              for (var i = 0; i < response.body.result[0].subOrders.length; i++) {
                                for (var j = 0; j < _this.order.subOrders.length; j++) {
                                  if (response.body.result[0].subOrders[i].id === _this.order.subOrders[j].id) {
                                    price = price + response.body.result[0].subOrders[i].price;
                                    initPrice = initPrice + response.body.result[0].subOrders[i].initPrice;
                                    totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice;
                                    discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice;
                                    if (!_this.order.subOrders[j].isStock) {
                                      _this.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price;
                                      _this.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice;
                                      _this.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice;
                                    }
                                  }
                                }
                              }
                            } else {
                              for (var m = 0; m < response.body.result[0].subOrders.length; m++) {
                                for (var n = 0; n < _this.order.merchandises.length; n++) {
                                  if (response.body.result[0].subOrders[m].id === _this.order.merchandises[n].orderGuid) {
                                    if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                                      for (var o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                                        if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === _this.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                                          price = price + response.body.result[0].subOrders[m].stocks[o].price;
                                          initPrice = initPrice + response.body.result[0].subOrders[m].stocks[o].initPrice;
                                          totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[o].totalPrice;
                                          discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[o].discountPrice;
                                        }
                                      }
                                    } else {
                                      if (_this.order.merchandises[n].presentQuantity === 0) {
                                        price = price + response.body.result[0].subOrders[m].price;
                                        initPrice = initPrice + response.body.result[0].subOrders[m].initPrice;
                                        totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice;
                                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice;
                                      }
                                    }
                                    if (_this.order.merchandises[n].categoryId === 20) {
                                      _this.order.merchandises[n].price = response.body.result[0].subOrders[m].price;
                                      _this.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].initPrice;
                                      _this.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].discountPrice;
                                    }
                                  }
                                }
                              }
                            }
                            _this.order.price = price;
                            _this.order.totalPrice = totalPrice;
                            _this.order.initPrice = initPrice;
                            _this.order.discountPrice = discountPrice;
                          }
                        }
                      });
                    }
                  }
                });
              } else {
                alert(response.body.message);
              }
            });
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#sendcode').on('click', function () {
        _this.sendVeriCode(optionIndex);
      });
    },
    choosevip: function choosevip(index) {
      this.customerNo = this.sessionInfo.customerInfo.customerNo;
      console.log(this.payType);
      switch (index) {
        case 1:
          this.storedchoosedisplay = true;
          break;
        case 0:
          if (this.ifNeedChooseWorkExperience) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.all-pop-bg').show().find('.choose-workexperience').show(); // 发票付款
          } else {
            console.log('unneccessary to choose work experience');
          }
          this.storedchoosedisplay = false;
          this.calculatePriceByAccountDiscountRatio(this.customerNo);
          break;
        case 2:
          if (this.ifNeedChooseWorkExperience) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.all-pop-bg').show().find('.choose-workexperience').show(); // 余额付款 更新选择的任职经历后，调用payByRestMoney
          } else {
            console.log('unneccessary to choose work experience');
            this.payByRestMoney(true);
          }
          this.storedchoosedisplay = false;
          this.yueyanzheng = false;
          break;
        case 4:
          this.payByRestMoney(true);
          this.storedchoosedisplay = false;
          this.yueyanzheng = false; // 课题组余额
          break;
        case 3:
          // 选择课题组结算发票报账
          this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo);
          break;
      }
    },
    getOrderpayType: function getOrderpayType() {
      console.log('selectedBalanceType', this.selectedBalanceType);
      // 个人发票支付
      if (this.selectedBalanceType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PAY_TYPE_FAPIAO) {
        return '3';
      }
      // 个人余额支付
      if (this.selectedBalanceType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        return '1';
      }
      // 课题组结算（发票报账）
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PAY_TYPE_FAPIAO) {
        return this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '6' : '3';
      }
      // 课题组结算（余额支付）
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        return this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '7' : '1';
      }
    },
    handlePayTypeChange: function handlePayTypeChange() {
      this.updateBalanceAccount();
      console.log('handlePayTypeChange', this.selectedPayType);
      // if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
      //   this.payByRestMoney()
      // } else {
      //   $('.all-pop-bg').show().find('.authCode').hide()
      //   $('.all-pop-bg').show().find('.vip-plan').hide()
      //   $('.all-pop-bg').show().find('.paid-over').show()
      // }
    },
    updateBalanceAccount: function updateBalanceAccount() {
      this.payType = this.getOrderpayType();
      this.choosevip(this.payTypeOptionMapping[this.payType]);
    },
    handleBalanceTypeChange: function handleBalanceTypeChange() {
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER) {
        var chosenName = this.selectedBalanceType.settlementAccountName;
        if (this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          var status = this.selectedBalanceType.settlementAccountStatus;
          if (status !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
            this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
            this.$weui.alert(chosenName + '已冻结，请联系业务员解锁');
            return;
            // return alert(chosenName + '未启用，请选择其他课题组')
          }
          var researchGroupStatus = this.selectedBalanceType.researchGroupStatus;
          if (!this.checkResearchGroup(researchGroupStatus, chosenName)) {
            return;
          }
          this.chosenSettlementAccount = this.selectedBalanceType;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('您已选择' + chosenName, 1500);
        } else {
          this.chosenSettlementAccount = this.selectedBalanceType;
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('您已选择' + chosenName, 1500);
        }
      } else {
        this.chosenSettlementAccount = null;
      }
      this.updateBalanceAccount();
    },
    checkResearchGroup: function checkResearchGroup(researchGroupStatus, chosenName) {
      if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_DISABLE) {
        this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        this.$weui.alert(chosenName + '课题组未启用，请选择其他结算账户');
        return false;
        // return alert(chosenName + '未启用，请选择其他课题组')
      }
      if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_LOCKED) {
        this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        this.$weui.alert(chosenName + '课题组已冻结，请联系业务员解锁');
        return false;
        // return alert(chosenName + '未启用，请选择其他课题组')
      }
      if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_EXPIRED) {
        this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        this.$weui.alert(chosenName + '课题组已过期，请选择其他结算账户');
        return false; // return alert(chosenName + '未启用，请选择其他课题组')
      }
      return true;
    },
    payByRestMoney: function payByRestMoney(calculateprice) {
      console.log('prepay');
      this.storedchoosedisplay = false;
      this.yueyanzheng = false;
      var self = this;
      if (self.sessionInfo.customerInfo.restPayCustomerNo === undefined || self.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
          text: '<div style="margin-top: .5rem">余额客户名称</div><input id="customername" type="text" style="margin: .5rem 0 .7rem 0"></input></br>' + '余额客户手机号<input id="phoneNum" type="text" style="margin: .5rem 0 .5rem 0"></input><div id="appender"></div>',
          buttons: [{
            text: '提交',
            close: true,
            onClick: function onClick() {
              var myreg = /^(1[34578]\d{9})$/;
              var mobile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#phoneNum').val().match(/\d+(.\d+)?/g) + '';
              if (!myreg.test(mobile)) {
                var colors = ['2px solid #f00', ''];
                // 设置闪烁间隔
                var frequency = 100;
                var duration = 800;
                var i = 0;
                var timer = setInterval(function () {
                  __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#phoneNum').css('border', colors[i % colors.length]);
                  if (i++ > colors.length) i = 0;
                }, frequency);
                setTimeout(function () {
                  clearInterval(timer);
                }, duration);
                return false;
              } else {
                self.gcapi('gcwwwifc/verifyPrepayCustomer', {
                  'CustomerName': __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#customername').val()),
                  'Mobile': mobile
                }).then(function (response) {
                  var customerNo = response.body.result;
                  if (customerNo) {
                    self.customerNo = customerNo;
                    if (calculateprice) {
                      self.calculatePriceByAccountDiscountRatio(customerNo);
                    }
                  } else {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
                      title: '绑定余额账号',
                      text: '<div style="margin: 1rem 0 0 -1.4rem">手机号<input id="phone" type="text" ' + 'style="width: 6rem;background-color: gainsboro; margin-left: .5rem"  disabled /></div></br>' + '验证码<input id="verifyNum" type="text" style="width: 5rem;margin: .3rem .3rem 0 .7rem"></input> ' + '<a id="enterBtn">发送</a><br/>' + '<div id="appender" style="padding-top:.5rem;text-align: center;color: #999; font-size:smaller"></div>',
                      close: false,
                      buttons: [{
                        text: '提交',
                        close: false,
                        onClick: function onClick() {
                          self.gcapi('gcwwwifc/confirmPrepayCustomer', {
                            'Mobile': mobile,
                            'VerifyCode': __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#verifyNum').val()
                          }).then(function (response) {
                            if (response.body.code !== 0) {
                              __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#appender')[0].innerHTML = '验证码错误~';
                              return;
                            }
                            var customerNo = response.body.result;
                            if (customerNo) {
                              self.customerNo = customerNo;
                            }
                            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('提交成功');
                            if (calculateprice) {
                              self.calculatePriceByAccountDiscountRatio(customerNo);
                            }
                          });
                        }
                      }, {
                        text: '关闭'
                      }]
                    });
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#phone').val(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#phoneNum').val());

                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#enterBtn').click(function () {
                      self.gcapi('gcwwwifc/applyPrepayCustomer', {
                        'Mobile': mobile
                      });
                      var wait = 60;
                      function time(o) {
                        if (wait === 0) {
                          o.innerHTML = '发送';
                          o.style.color = '';
                          wait = 60;
                        } else {
                          o.innerHTML = wait + 's';
                          o.style.color = '#C8C8C8';
                          wait--;
                          setTimeout(function () {
                            time(o);
                          }, 1000);
                        }
                      }
                      time(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#enterBtn')[0]);
                    });
                  }
                });
              }
            }
          }, {
            text: '关闭'
          }]
        });
      } else {
        self.customerNo = self.sessionInfo.customerInfo.customerNo;
        if (calculateprice) {
          self.calculatePriceByAccountDiscountRatio(self.customerNo);
        }
      }
    },
    sendVeriCode: function sendVeriCode(optionIndex) {
      var _this = this;
      _this.customerStoredPlanNo = '';
      if (!_this.coolDown) {
        _this.gcapi('retrieveCustomerPlanMemberInformation', _this.vipPLan[optionIndex].GUID).then(function (response) {
          var data = response.body.result;
          for (var i in data) {
            if (data[i].role === 3) {
              _this.mobile = data[i].mobile;
              break;
            }
          }
        }).then(function (reponse) {
          if (_this.mobile === '' || _this.mobile === undefined) {
            alert('请配置管理联系人联系方式，否则无法进行验证！');
            return;
          }
          console.log(_this.mobile);
          _this.gcapi('gcwwwifc/requestPasswordChange', { 'LoginId': _this.mobile.replace(/\s+/g, '') }).then(function (response) {
            _this.coolDown = true;
            time(document.getElementById('sendcode'));
            alert(response.body.message);
          }, function (response) {
            alert(response.body.message);
          });
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    goToGoodsDetail: function goToGoodsDetail() {
      this.$router.push({ name: 'orderContentDetail', query: { order: this.order } });
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      var message = void 0;
      switch (val) {
        case 1:
          message = '订单提交后，将使用您的账户余额支付订单货款。余额不足时，请选择其他支付方式。' + '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。';
          break;
        case 3:
          message = '订单提交后，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。' + '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。';
          break;
        case 4:
          message = '该订单包含【第三方】商品，此商品不支持余额付款。' + '请您使用线下付款或者将【第三方】商品与【自营】商品分开购买！';
          break;
        case 5:
          message = '订单提交后，将使用您的蓝V储值账户余额支付订单货款。余额不足时，' + '请选择其他支付方式。为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人蓝V储值账户余额，' + '请准确填写储值帐号的姓名和手机号码进行授权。';
          break;
        case 2:
          message = '订单提交后，将使用您的信用支付额度支付订单货款。信用支付额度不足时，请选择其他支付方式。' + '同时，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。货款到位后，您的账户将恢复相应信用支付额度。' + '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。';
          break;
        case 6:
          message = '订单提交后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。';
          break;
        case 7:
          message = '订单提交后，将计入您所在课题组的消费。同时订单货款将使用您的账户余额支付。余额不足时，请选择其他支付方式。' + '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。';
      }
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.alert(message);
    },
    orderPay: function orderPay() {
      var saveItemInOrderKey = 0;
      var convertedPayType = this.payType;
      if (this.chosenSettlementAccount === null) {
        this.$weui.alert('请选择结算账户');
        return;
      }
      // 其余结算方式需要保存任职关系
      if (this.payType !== '6' && this.payType !== '7') {
        saveItemInOrderKey = 0;
        console.log('this chosenwork', this.chosenWorkExperience);
      }
      // 课题组结算需要保存课题组信息
      if (this.payType === '6') {
        this.payType = '3'; // 课题组结算属于发票付款
        saveItemInOrderKey = 1;
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
      }
      if (this.payType === '7') {
        this.payType = '1'; // 课题组结算属于发票付款
        saveItemInOrderKey = 1;
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
        if (!this.yfukuanmoney) {
          return;
        }
      }
      if (this.payType !== '5') {
        this.customerStoredPlanNo = '';
      }
      if (this.payType === '5' && this.vipyanzheng === false) {
        alert('使用大客户储值计划账户必须先验证，请您先验证！');
        return;
      }
      if (this.payType === '1') {
        //  if (this.order.merchandises.length > 0) {
        //    for (let i in this.order.merchandises) {
        //      if (this.order.merchandises[i].selfOperated === 0) {
        //        this.displayMessage(4)
        //        return
        //      }
        //    }
        //  } else {
        //    for (let i in this.order.subOrders) {
        //      for (let j in this.order.subOrders[i].merchandises) {
        //        if (this.order.subOrders[i].merchandises[j].selfOperated === 0) {
        //          this.displayMessage(4)
        //          return
        //        }
        //      }
        //    }
        //  }
        if (this.checkInfo()) {
          // this.remainPay( )
          if (!this.yueyanzheng && (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0)) {
            alert('使用余额付款必须先验证，请您先验证！');
            return;
          } else {
            this.successPay(saveItemInOrderKey, convertedPayType);
          }
        }
      } else {
        if (this.checkInfo()) {
          this.successPay(saveItemInOrderKey, convertedPayType);
        }
      }
    },
    successPay: function successPay(saveItemInOrderKey, convertedPayType) {
      console.log('saveItemInOrderKey', convertedPayType, saveItemInOrderKey);
      var saveItem = {};
      if (this.chosenSettlementAccount === null) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
        return;
      }
      saveItem.settlementAccountNo = this.chosenSettlementAccount.settlementAccountNo;
      if (saveItemInOrderKey === 1 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chosenSettlementAccount) !== '{}') {
        saveItem.balanceType = 1; // 课题组结算
        saveItem.researchGroupApproveResult = 0; // 审批状态 不需要审批
        saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo;
        saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName;
        saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo;
        saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName;
        saveItem.researchGroupNo = this.chosenSettlementAccount.researchGroupNo;
        saveItem.researchGroupName = this.chosenSettlementAccount.researchGroupName;
      } else if (saveItemInOrderKey === 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chosenSettlementAccount) !== '{}') {
        saveItem.balanceType = 0; // 个人结算
        saveItem.researchGroupApproveResult = 0; // 审批状态 不需要审批
        saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo;
        saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName;
        saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo;
        saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName;
      }
      console.log('saveItem', saveItem);
      // return
      var self = this;
      var bOrders = [];
      var invoiceAddress = void 0;
      var invoiceExpressContactor = void 0;
      var invoiceExpressAddress = void 0;
      var invoiceExpressPhone = void 0;
      if (!this.defaultInvoiceAddress) {
        invoiceAddress = this.invoiceAddress;
      } else {
        invoiceAddress = this.sessionInfo.expressAddress.filter(function (item) {
          return item.isDefault === 1;
        });
      }
      if (invoiceAddress && invoiceAddress.length > 0) {
        var invoice = invoiceAddress[0];
        invoiceExpressContactor = invoice.consignee;
        invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress;
        invoiceExpressPhone = invoice.expressMobile;
      }
      console.log(this.customerStoredPlanNo);
      var bOrder = {
        payType: this.payType,
        id: this.order.id,
        invoiceTitle: this.defaultTitle,
        taxpayerIdentificationNo: this.taxpayerIdentificationNo,
        invoiceExpressContactor: invoiceExpressContactor,
        invoiceExpressAddress: invoiceExpressAddress,
        invoiceExpressPhone: invoiceExpressPhone,
        prepayCustomerNo: this.customerNo,
        customerStoredPlanNo: this.customerStoredPlanNo
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(bOrder, saveItem);
      console.log('border', bOrder);
      bOrder.amplification = self.order.amplification;
      bOrders.push(bOrder);
      this.$weui.loading('正在生成合同，请稍等');
      this.showButton = false;
      var BOrders = {};
      this.gcapi('orderPay', bOrders).then(function (response) {
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast(response.body.message);
          return;
        }
        BOrders = response.body.result;
      }).then(function () {
        // $.hidePreloader()
        self.$weui.loading().hide();
        var failed = false;
        for (var order in BOrders) {
          if (BOrders[order].status === 12) {
            failed = true;
            continue;
          }
        }
        if (failed) {
          alert('您参与的秒杀促销活动已经结束，此订单已自动取消，请您重新下单！');
          self.gcapi('retrieveMyOrder').then(function (response) {
            self.MYORDER_UPDATE(response.body.result);
          });
          self.$router.replace({ name: 'cart' });
        } else {
          if (BOrders[0].researchGroupApproveResult === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE) {
            alert('您的订单正在审批中，审批结果会通过吉凯公众号消息告知您');
          }
          self.$router.replace({ name: 'successPay', query: { BOrders: BOrders, order: self.$route.params.order } });
        }
      });
    },
    remainPay: function remainPay() {
      //        var self = this
      if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
        // 他人付款
        //          $.modal({
        //            text: '<div style="margin-top: .5rem">余额客户名称</div><input id="customername" type="text" style="margin: .5rem 0 .7rem 0"></input></br>' +
        //            '余额客户手机号<input id="phoneNum" type="text" style="margin: .5rem 0 .5rem 0"></input><div id="appender"></div>',
        //            buttons: [{
        //              text: '提交',
        //              close: false,
        //              onClick: function () {
        //                let myreg = /^(1[34578]\d{9})$/
        //                let mobile = $('#phoneNum').val().match(/\d+(.\d+)?/g) + ''
        //                if (!myreg.test(mobile)) {
        //                  var colors = ['2px solid #f00', '']
        //                  // 设置闪烁间隔
        //                  var frequency = 100
        //                  var duration = 800
        //
        //                  var i = 0
        //                  var timer = setInterval(function () {
        //                    $('#phoneNum').css('border', colors[i % colors.length])
        //                    if (i++ > colors.length) i = 0
        //                  }, frequency)
        //                  setTimeout(function () {
        //                    clearInterval(timer)
        //                  }, duration)
        //                  return false
        //                } else {
        //                  self.gcapi('gcwwwifc/verifyPrepayCustomer', {
        //                    'CustomerName': $.trim($('#customername').val()),
        //                    'Mobile': mobile
        //                  }).then((response) => {
        //                    let customerNo = response.body.result
        //                    if (customerNo) {
        //                      self.customerNo = customerNo
        //                      self.successPay()
        //                    } else {
        //                      $.modal({
        //                        title: '绑定余额账号',
        //                        text: '<div style="margin: 1rem 0 0 -1.4rem">手机号<input id="phone" type="text" ' +
        //                        'style="width: 6rem;background-color: gainsboro; margin-left: .5rem"  disabled /></div></br>' +
        //                        '验证码<input id="verifyNum" type="text" style="width: 5rem;margin: .3rem .3rem 0 .7rem"></input> ' +
        //                        '<a id="enterBtn">发送</a><br/>' +
        //                        '<div id="appender" style="padding-top:.5rem;text-align: center;color: #999; font-size:smaller"></div>',
        //                        close: false,
        //                        buttons: [{
        //                          text: '提交',
        //                          close: false,
        //                          onClick: function () {
        //                            self.gcapi('gcwwwifc/confirmPrepayCustomer', {
        //                              'Mobile': mobile,
        //                              'VerifyCode': $('#verifyNum').val()
        //                            }).then((response) => {
        //                              if (response.body.code !== 0) {
        //                                $('#appender')[0].innerHTML = '验证码错误~'
        //                                return
        //                              }
        //                              let customerNo = response.body.result
        //                              if (customerNo) {
        //                                self.customerNo = customerNo
        //                              }
        //                              $.toast('提交成功')
        //                              self.successPay()
        //                            })
        //                          }
        //                        }, {
        //                          text: '关闭'
        //                        }]
        //                      })
        //                      $('#phone').val($('#phoneNum').val())
        //
        //                      $('#enterBtn').click(function () {
        //                        self.gcapi('gcwwwifc/applyPrepayCustomer', {
        //                          'Mobile': mobile
        //                        })
        //                        let wait = 60
        //                        function time (o) {
        //                          if (wait === 0) {
        //                            o.innerHTML = '发送'
        //                            o.style.color = ''
        //                            wait = 60
        //                          } else {
        //                            o.innerHTML = wait + 's'
        //                            o.style.color = '#C8C8C8'
        //                            wait--
        //                            setTimeout(function () {
        //                              time(o)
        //                            }, 1000)
        //                          }
        //                        }
        //                        time($('#enterBtn')[0])
        //                      })
        //                    }
        //                  })
        //                }
        //              }
        //            }, {
        //              text: '关闭'
        //            }]
        //          })
      } else {
        this.customerNo = this.sessionInfo.customerInfo.customerNo;
        this.successPay();
      }
    },
    checkInfo: function checkInfo() {
      if (this.defaultTitle === '') {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择发票抬头');
        return false;
      } else {
        return true;
      }
    },
    calculatePriceByAccountDiscountRatio: function calculatePriceByAccountDiscountRatio(customerNo) {
      var self = this;
      self.yueyanzheng = true;
      var bOrders = [];
      var invoiceAddress = void 0;
      var invoiceExpressContactor = void 0;
      var invoiceExpressAddress = void 0;
      var invoiceExpressPhone = void 0;
      if (self.chosenSettlementAccount === null) {
        return;
      }
      if (!self.defaultInvoiceAddress) {
        invoiceAddress = self.invoiceAddress;
      } else {
        invoiceAddress = self.sessionInfo.expressAddress.filter(function (item) {
          return item.isDefault === 1;
        });
      }
      if (invoiceAddress && invoiceAddress.length > 0) {
        var invoice = invoiceAddress[0];
        invoiceExpressContactor = invoice.consignee;
        invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress;
        invoiceExpressPhone = invoice.expressMobile;
      }
      var bOrder = {
        payType: self.payType,
        id: self.order.id,
        invoiceTitle: self.defaultTitle,
        taxpayerIdentificationNo: self.taxpayerIdentificationNo,
        invoiceExpressContactor: invoiceExpressContactor,
        invoiceExpressAddress: invoiceExpressAddress,
        invoiceExpressPhone: invoiceExpressPhone,
        prepayCustomerNo: self.customerNo,
        customerStoredPlanNo: self.customerStoredPlanNo
      };
      bOrder.amplification = self.order.amplification;
      bOrders.push(bOrder);
      var obj = {};
      obj.settlementAccountNo = self.chosenSettlementAccount.settlementAccountNo;
      obj.bOrders = bOrders;
      obj.customerNo = customerNo;
      // 计算折扣率时，传入结算方式和课题组编号
      if (self.payType === '6') {
        bOrder.payType = '3';
        if (self.chosenSettlementAccount.settlementAccountType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_RESEARCH_GROUP;
          obj.researchGroupNo = self.chosenSettlementAccount.researchGroupNo;
        } else {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        }
      } else if (self.payType === '7') {
        bOrder.payType = '1';
        if (self.chosenSettlementAccount.settlementAccountType === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_RESEARCH_GROUP;
        } else {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        }
      } else {
        bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
      }
      console.log('order', self.order);
      self.gcapi('calculatePriceByAccountDiscountRatio', obj).then(function (response) {
        if (response.body.result !== null && response.body.result.length > 0) {
          if (bOrder.balanceType === 1 && bOrder.payType === '1') {
            var obj = { 'customerNo': self.customerNo, 'price': response.body.result[0].price };
            self.gcapi('hasPrepayRemain', obj).then(function (response) {
              if (!response.body.result) {
                self.yfukuanmoney = false;
                alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式');
              } else {
                self.yfukuanmoney = true;
              }
            });
          }
          if (self.order.merchandises.length === 1) {
            self.order.merchandises[0].price = response.body.result[0].price;
            self.order.merchandises[0].discountPrice = response.body.result[0].discountPrice;
            self.order.price = response.body.result[0].price;
            self.order.initPrice = response.body.result[0].initPrice;
            self.order.totalPrice = response.body.result[0].totalPrice;
            self.order.discountPrice = response.body.result[0].discountPrice;
          } else {
            var price = 0;
            var totalPrice = 0;
            var initPrice = 0;
            var discountPrice = 0;
            if (self.order.subOrders.length > 0) {
              for (var i = 0; i < response.body.result[0].subOrders.length; i++) {
                for (var j = 0; j < self.order.subOrders.length; j++) {
                  if (response.body.result[0].subOrders[i].id === self.order.subOrders[j].id) {
                    price = price + response.body.result[0].subOrders[i].price;
                    initPrice = initPrice + response.body.result[0].subOrders[i].initPrice;
                    totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice;
                    discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice;
                    if (!self.order.subOrders[j].isStock) {
                      self.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price;
                      self.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice;
                      self.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice;
                    } else {
                      // 增加现货折扣后价格
                      for (var n = 0; n < self.order.merchandises.length; n++) {
                        for (var o = 0; o < response.body.result[0].subOrders[i].stocks.length; o++) {
                          if (response.body.result[0].subOrders[i].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                            self.order.merchandises[n].price = response.body.result[0].subOrders[i].stocks[o].price;
                            self.order.merchandises[n].initPrice = response.body.result[0].subOrders[i].stocks[o].initPrice;
                            self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[i].stocks[o].discountPrice;
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else if (response.body.result[0].subOrders.length > 0) {
              for (var m = 0; m < response.body.result[0].subOrders.length; m++) {
                for (var _n = 0; _n < self.order.merchandises.length; _n++) {
                  if (response.body.result[0].subOrders[m].id === self.order.merchandises[_n].orderGuid) {
                    if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                      for (var _o = 0; _o < response.body.result[0].subOrders[m].stocks.length; _o++) {
                        if (response.body.result[0].subOrders[m].stocks[_o].merchandiseGuid === self.order.merchandises[_n].merchandiseGuid && self.order.merchandises[_n].presentQuantity === 0) {
                          price = price + response.body.result[0].subOrders[m].stocks[_o].price;
                          initPrice = initPrice + response.body.result[0].subOrders[m].stocks[_o].initPrice;
                          totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[_o].totalPrice;
                          discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[_o].discountPrice;
                        }
                      }
                    } else {
                      if (self.order.merchandises[_n].presentQuantity === 0) {
                        price = price + response.body.result[0].subOrders[m].price;
                        initPrice = initPrice + response.body.result[0].subOrders[m].initPrice;
                        totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice;
                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice;
                      }
                    }
                    //                      if (self.order.merchandises[n].isStock) {
                    //                        discountPrice = discountPrice + self.order.merchandises[n].discountPrice
                    //                      } else {
                    //                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
                    //                      }
                    if (self.order.merchandises[_n].categoryId === 20) {
                      self.order.merchandises[_n].price = response.body.result[0].subOrders[m].price;
                      self.order.merchandises[_n].initPrice = response.body.result[0].subOrders[m].initPrice;
                      self.order.merchandises[_n].discountPrice = response.body.result[0].subOrders[m].discountPrice;
                    } else if (self.order.merchandises[_n].presentQuantity === 0) {
                      // 现货更新商品价格
                      for (var _o2 = 0; _o2 < response.body.result[0].subOrders[m].stocks.length; _o2++) {
                        if (response.body.result[0].subOrders[m].stocks[_o2].merchandiseGuid === self.order.merchandises[_n].merchandiseGuid && self.order.merchandises[_n].presentQuantity === 0) {
                          self.order.merchandises[_n].price = response.body.result[0].subOrders[m].stocks[_o2].price;
                          self.order.merchandises[_n].initPrice = response.body.result[0].subOrders[m].stocks[_o2].initPrice;
                          self.order.merchandises[_n].discountPrice = response.body.result[0].subOrders[m].stocks[_o2].discountPrice;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              // 更新现货折扣后价格
              if (response.body.result[0].isStock && response.body.result[0].stocks.length > 0) {
                for (var _n2 = 0; _n2 < self.order.merchandises.length; _n2++) {
                  for (var _o3 = 0; _o3 < response.body.result[0].stocks.length; _o3++) {
                    if (response.body.result[0].stocks[_o3].merchandiseGuid === self.order.merchandises[_n2].merchandiseGuid && self.order.merchandises[_n2].presentQuantity === 0) {
                      price = price + response.body.result[0].stocks[_o3].price;
                      initPrice = initPrice + response.body.result[0].stocks[_o3].initPrice;
                      totalPrice = totalPrice + response.body.result[0].stocks[_o3].totalPrice;
                      discountPrice = discountPrice + response.body.result[0].stocks[_o3].discountPrice;

                      self.order.merchandises[_n2].price = response.body.result[0].stocks[_o3].price;
                      self.order.merchandises[_n2].initPrice = response.body.result[0].stocks[_o3].initPrice;
                      self.order.merchandises[_n2].discountPrice = response.body.result[0].stocks[_o3].discountPrice;
                    }
                  }
                }
              }
            }
            self.order.price = price;
            self.order.totalPrice = totalPrice;
            self.order.initPrice = initPrice;
            self.order.discountPrice = discountPrice;
          }
        }
      });
    },
    showResearchGroupIntro: function showResearchGroupIntro() {
      var info = '<div>为您的科研课题组创建专属账户，您可享受专属科研服务、更优的折扣活动、账户月结便捷跟踪管理。如果还未加入课题组计划，请联系我们的业务人员或致电<a href="tel:400-621-0302">400-621-0302</a></div>';
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
        afterText: info,
        buttons: [{
          text: 'ok',
          bold: true,
          onClick: function onClick() {}
        }]
      });
    }
  })
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__child_Order_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__child_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__child_Order_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      address: [],
      distinct: 'myDiscount',
      coupons: { value: [] },
      selectCoupon: __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getLocalStorage('myCoupons'),
      productInfo: { value: {} },
      showButton: true,
      isSsoFlag: this.emkt.buyCartIsLocalStorage
    };
  },

  components: {
    orderContent: __WEBPACK_IMPORTED_MODULE_5__child_Order_vue___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['REMOVE_ALL_CHECKLIST_FROM_CART_LIST', 'ADD_ORDER', 'ADD_WAITPAID_ORDER', 'MYORDER_UPDATE']), {
    fetchData: function fetchData() {
      this.address = this.sessionInfo.expressAddress;
    },
    goToMyCoupons: function goToMyCoupons() {
      // coupon type = 6 筑研服务抵用券
      if (this.selectCoupon && this.selectCoupon.type && this.selectCoupon.type === 6) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('不支持更换抵用券');
        return;
      }
      if (this.coupons.value.length > 0) {
        this.$router.push({ name: 'myOrderCoupons', query: { myOrderCoupons: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.coupons.value) } });
      }
    },
    orderSubmit: function orderSubmit() {
      var _this = this;

      //        let cName = this.address.userName
      //        let aName = this.address.streetName
      //        let tel = this.address.tel
      var self = this;
      //        console.log(this.productInfo)
      var bMerchandises = this.productInfo.value;
      if (!bMerchandises) {
        return;
      }
      var order = void 0;
      bMerchandises.orderType = '1';
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.showPreloader('正在进入结算方式页面，请稍等');
      this.showButton = false;
      this.gcapi('orderSubmit', bMerchandises).then(function (response) {
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast(response.body.message);
          return;
        }
        order = response.body.result;
        order.expressFree = _this.productInfo.value.expressFree;
        _this.ADD_WAITPAID_ORDER(order);
        _this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST();
        _this.ADD_ORDER(order);
        __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setStoreItem('myCoupons', undefined);
      }).then(function () {
        return self.gcapi('retrieveMyOrder');
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.hidePreloader();
        if (response !== undefined) {
          self.MYORDER_UPDATE(response.body.result);
          self.$router.replace({ name: 'orderContent', params: { order: order } });
        }
      });
    },
    checkSubmit: function checkSubmit() {
      var _this2 = this;

      //        let cName = this.address.userName
      //        let aName = this.address.streetName
      //        let tel = this.address.tel
      // 将sf跳转链接的参数传给后台
      var paymentInfo = {};
      // paymentInfo.balanceType = emkt.getUrlParam('BalanceType') === '' ? 0 : emkt.getUrlParam('BalanceType')
      paymentInfo.payType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('PayType');
      paymentInfo.firstLevelEnterpriseNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('FirstLevelEnterpriseNo');
      paymentInfo.firstLevelEnterpriseName = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('FirstLevelEnterpriseName');
      paymentInfo.secondLevelEnterpriseNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SecondLevelEnterpriseNo');
      paymentInfo.secondLevelEnterpriseName = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SecondLevelEnterpriseName');
      paymentInfo.settlementAccountNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SettlementAccountNo');
      // paymentInfo.researchGroupNo = emkt.getUrlParam('ResearchGroupNo')
      // paymentInfo.researchGroupName = emkt.getUrlParam('ResearchGroupName')
      var self = this;
      var bMerchandises = this.productInfo.value;
      if (!bMerchandises) {
        return;
      }
      var order = void 0;
      this.showButton = false;
      var currentQuoteNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('QuoteNo');
      var sessionQuoteNo = self.sessionInfo.customerInfo.customerProperties['QuoteNo'];
      if (currentQuoteNo !== sessionQuoteNo) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast("当前报价登陆态失效，请重新打开产品录入页面");
        return;
      }

      bMerchandises.sfQuoteNo = sessionQuoteNo;
      bMerchandises.sfQuoteId = self.sessionInfo.customerInfo.customerProperties['QuoteId'];
      bMerchandises.employeeNo = self.sessionInfo.customerInfo.employeeOnBehalf;
      bMerchandises.orderSource = '2';
      bMerchandises.clientSource = '1';
      bMerchandises.orderType = '1';
      bMerchandises.expressAddress = '';
      bMerchandises.expressContactor = '';
      bMerchandises.expressPhone = '';
      bMerchandises.merchantNo = '101';
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(bMerchandises, paymentInfo);
      this.$weui.loading('正在提交审核 请耐心等待。');
      console.log(bMerchandises);
      this.gcapi('orderSubmit', bMerchandises).then(function (response) {
        if (response.body.code === 1) {
          _this2.$weui.loading().hide();
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast(response.body.message);
          return;
        }
        _this2.$weui.loading().hide();
        order = response.body.result;
        order.expressFree = _this2.productInfo.value.expressFree;
        //          this.gcapi('orderSubmit', bMerchandises).then(response => {
        //          })
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.showPreloader('已生成报价，请在管理界面中进行商务、技术审核。');
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.hidePreloader();
        }, 1000);
        _this2.REMOVE_ALL_CHECKLIST_FROM_CART_LIST();
        // 更新数据库购物车信息
        var cartContent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.cartList.cartContent) === '{}' ? null : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.cartList.cartContent);
        _this2.gcapi('saveShoppingCart', cartContent).then(function (response) {
          if (response.body.code === 0) {
            console.log('数据库购物车已更新');
          } else {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.showPreloader('保存失败！');
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.hidePreloader();
            }, 1000);
          }
          __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].goCart(self.$router);
        });
        __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setStoreItem('myCoupons', undefined);
        // self.$router.replace({name: 'cart'})
      }).then(function () {
        return self.gcapi('retrieveMyOrder');
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.hidePreloader();
        if (response !== undefined) {
          self.MYORDER_UPDATE(response.body.result);
        }
      });
    },
    updateSelectCoupon: function updateSelectCoupon(coupon) {
      this.selectCoupon = coupon;
      __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setStoreItem('myCoupons', coupon);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['checkList', 'sessionInfo', 'cartList'])),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.order) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#express')[0].disabled = true;
    }
    var _this = this;
    _this.fetchTotalMoney();
    // if (emkt.getLocalStorage('VipPlanList') !== null) {
    //   var list = emkt.getLocalStorage('VipPlanList')
    //   for (var i in list) {
    //     if (list[i].type === 1) {
    //       _this.VipPlanList.push(list[i])
    //       _this.ifcanUseVipPlanBouns = true
    //     }
    //   }
    //   if (_this.VipPlanList.length === 1) {
    //     _this.isUseVipPlanBouns = true
    //     _this.customerVipPlanNo = _this.VipPlanList[0].GUID
    //   //  _this.fetchTotalMoney()
    //   }
    //   // if (list[i].applicationNumber > 0 && list[i].type === 1) {
    //   //   _this.gcapi('presentVirusNum', list[i].GUID).then(function (response) {
    //   //     if (response.body.result) {
    //   //       _this.VipPlanList.push(list[i])
    //   //       _this.ifcanUseVipPlanBouns = true
    //   //     }
    //   //   })
    //   // }
    //   _this.fetchTotalMoney()
    // } else {
    //   _this.fetchTotalMoney()
    // }
  },
  created: function created() {
    this.address = this.sessionInfo.expressAddress;
    if (this.checkList.length === 0) {
      if (this.order.merchandises.length === 0) {
        for (var i in this.order.subOrders) {
          for (var j in this.order.subOrders[i].merchandises) {
            this.orderList.push(this.order.subOrders[i].merchandises[j]);
          }
        }
        //          this.orderList = this.order.subOrders.merchandises
      } else {
        this.orderList = this.order.merchandises;
      }
    } else {
      this.orderList = this.checkList;
    }
    //      this.orderList = this.checkList.length === 0 ? this.order.merchandises : this.checkList
    this.orderNum = this.orderList.length;
    if (this.address === undefined) {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('请登录');
      return;
    }
    //      this.fetchTotalMoney()
    //      this.orderList.push(this.cartList[this.goodId])
  },


  props: ['buttonName', 'order', 'coupons', 'selectCoupon', 'productInfo', 'showButton', 'showpromotion'],

  data: function data() {
    return {
      orderList: [],
      limitNum: 1,
      goodId: null,
      address: [],
      goodsMoney: 0,
      totalMoney: 0,
      orderNum: 0,
      expressPrice: 0,
      isUseVipPlanBouns: false,
      ifcanUseVipPlanBouns: false,
      baseurl: '/emktResources/resocurces/img/merchandise/',
      questionUrl: '/emktResources/resocurces/img/question.png',
      discountPrice: 0,
      isExpress: false,
      VipPlanList: [],
      customerVipPlanNo: '',
      getAllAvailableCouponsAlready: false,
      couponRefused: false,
      specialFundCouponUsed: false,
      showBtn: true
    };
  },

  watch: {
    'order.price': function orderPrice(val) {
      this.discountPrice = this.order.discountPrice.toFixed(1);
      this.totalMoney = parseFloat(this.order.totalPrice);
      this.goodsMoney = this.order.initPrice;
    },
    'order.initPrice': function orderInitPrice(val) {
      this.totalMoney = parseFloat(this.order.totalPrice);
      this.discountPrice = this.order.discountPrice.toFixed(1);
      this.goodsMoney = this.order.initPrice;
    },
    selectCoupon: function selectCoupon(val) {
      // 选择免邮券后，重新计算价格
      if (val.type !== 0) {
        this.fetchTotalMoney();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['REMOVE_ALL_CHECKLIST_FROM_CART_LIST']), {
    // changeUseIfVipPlanBouns () {  //蓝v计划
    //   this.customerVipPlanNo = ''
    //   if (this.isUseVipPlanBouns === false) {
    //     this.fetchTotalMoney()
    //   } else {
    //     if (this.VipPlanList.length === 1) {
    //       this.customerVipPlanNo = this.VipPlanList[0].GUID
    //       this.fetchTotalMoney()
    //     }
    //   }
    // },
    // yanzheng (optionIndex) {       //蓝v计划
    //   $.each(this.VipPlanList, function (index, item) {
    //     item.checked = false
    //   })
    //   this.VipPlanList[optionIndex].checked = true
    //   this.customerVipPlanNo = this.VipPlanList[optionIndex].GUID
    //   this.fetchTotalMoney()
    // },
    displayMessage: function displayMessage() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert('如果选择发货，商品将直接寄送给您；如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。');
    },
    displayMessage1: function displayMessage1() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert('1、您订单中的所有商品会一起运出，因此需要等待最后一份商品生产完成后统一发货。如果您急需其中的某个产品，您可以分批下单。<br>' + '2、订单提交后，系统将自动开具发票，发票抬头内容即为您实际采购的产品明细。<br>' + '3、当您下了多个订单时，不能进行合并订单操作。如有特殊情况，请与我们的工作人员联系处理（400-621-0302）。');
    },
    displayMessage2: function displayMessage2() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert('配送病毒或者冻存细胞等产品时，需要用到大量的干冰来保持产品的稳定性和活性，配送质粒和支原体试剂盒时，' + '需要用冰袋保持产品活性。我们将选择最佳的产品包装和最有保障的物流配送，' + '将优质产品快速送到您手中。当订单含多个产品时我们仅收取一次费用。');
    },
    displayMessage3: function displayMessage3() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert('订单提交后，该订单将享受相应蓝V会员账户权益。！');
    },
    changeCouponRefused: function changeCouponRefused() {
      this.fetchTotalMoney();
    },
    changeExpressFree: function changeExpressFree() {
      var self = this;
      if (self.isExpress === false) {
        self.fetchTotalMoney();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.confirm('如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。', function () {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.showIndicator();
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hideIndicator();
          }, 300);
          self.fetchTotalMoney();
        }, function () {
          self.isExpress = false;
        });
      }
    },
    response: function response() {
      var _this = this;
      if (this.buttonName === '确认下单') {
        console.log('isNewCustomerWithoutHistoryOrders', this.isNewCustomerWithoutHistoryOrders);
        var preSaleText = '';
        if (this.isPreSaleOrder()) {
          preSaleText = '本产品为预售产品，3月初发货，请知悉! 如有疑问可联系在线客服或业务员！<br>';
        }
        var showText = '<div><span style="color: #ff0000">' + preSaleText + '</span> \u8BF7\u60A8\u4ED4\u7EC6\u6838\u5BF9\u8BA2\u5355\u4FE1\u606F\uFF08\u5305\u62EC\u7269\u54C1\uFF0C\u53D1\u7968\uFF0C\u53D1\u8D27\u5730\u5740\uFF0C\u53D1\u8D27\u65B9\u5F0F\u548C\u7ED3\u7B97\u65B9\u5F0F\uFF09\n           \u786E\u8BA4\u8BA2\u5355\u540E\u5409\u51EF\u5C06\u5C3D\u5FEB\u5BF9\u60A8\u7684\u8BA2\u5355\u8FDB\u884C\u5BA1\u6838\uFF0C\u5BA1\u6838\u901A\u8FC7\u4E4B\u524D\uFF0C\u60A8\u4ECD\u65E7\u53EF\u4EE5\u5728\u201C\u6211\u7684\u201D\u754C\u9762\u4E2D\u7684\u201C\u5F85\u6536\u8D27\u201D\u6A21\u5757\u4E0B\u627E\u5230\u60A8\u7684\u8BA2\u5355\u3002</div>';
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.modal({
          text: showText,
          buttons: [{
            text: 'Cancel',
            onClick: function onClick() {}
          }, {
            text: 'OK',
            onClick: function onClick() {
              __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.showIndicator();
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hideIndicator();
              }, 300);
              _this.$emit('response');
            }
          }]
        });
      } else {
        _this.$emit('response');
      }
    },
    isPreSaleOrder: function isPreSaleOrder() {
      var preSalePeriod = [];
      __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].christmasPreSalePeriod.forEach(function (timeString) {
        preSalePeriod.push(new Date(timeString));
      });
      console.log('presaleperiod', preSalePeriod);
      var now = new Date();
      var isPreSale = false;
      if (now > preSalePeriod[0] && now < preSalePeriod[1]) {
        isPreSale = true;
        console.log('first day, all orders are pre sale orders');
      } else if (now > preSalePeriod[2] && now < preSalePeriod[3] || now > preSalePeriod[4] && now < preSalePeriod[5]) {
        console.log('second/third day, new customers\' orders are pre sale orders');
        isPreSale = this.isNewCustomerWithoutHistoryOrders;
      }
      console.log('is pre sale', isPreSale);
      return isPreSale;
    },
    getProductInfo: function getProductInfo() {
      var _this2 = this;

      var self = this;
      var border = {};
      if (this.address === undefined) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('请登录');
        return;
      } else {
        var addr = this.filterAddress[0];
        if (!addr && this.isSFFlag === false) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.modal({
            title: '请先添加收货地址',
            buttons: [{
              text: '确定',
              onClick: function onClick() {
                self.$router.push({ name: 'address', params: { order: self.order } });
              }
            }]
          });
          return;
        }
        if (this.isSFFlag === false) {
          border.expressAddress = addr.city + addr.district + addr.expressAddress;
          border.expressPhone = addr.expressMobile;
          border.expressContactor = addr.consignee;
          border.isSingleExpress = true;
        } else {
          border.expressAddress = '';
          border.expressPhone = '';
          border.expressContactor = '';
          border.isSingleExpress = true;
        }
      }
      var coupons = [];
      var coupon = this.selectCoupon;
      if (coupon) {
        if (this.selectCoupon.type !== 0) {
          coupons.push(coupon);
        }
      }
      border.coupons = coupons;

      var bMerchandises = [];
      if (this.orderList === undefined) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('读取数据失败');
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParamHref('fromSmart') === '1') {
        border.isSmartOrder = true;
        border.bsmartProducts = [];
        this.orderList.forEach(function (item) {
          var pro = {
            guid: item.guid,
            smartProductParameterSelection: item.smartProductParameterSelection
          };
          var bMerchandise = {};
          bMerchandise.price = item.price;
          bMerchandise.expressPrice = item.expressPrice;
          bMerchandise.merchandiseGuid = item.guid;
          bMerchandise.workdays = item.workdays;
          bMerchandise.priceMax = item.price;
          bMerchandise.priceMin = item.price;
          bMerchandise.unitPrice = item.price;
          bMerchandise.initPrice = item.price;
          bMerchandise.SKUID = item.SKUID;
          bMerchandise.productName = item.productName;
          bMerchandise.productGuid = item.productGuid;
          bMerchandise.muGuid = item.muGuid;
          bMerchandise.isSmartMerchandise = true;
          bMerchandise.attributes = item.smartAttributes;
          bMerchandises.push(bMerchandise);
          border.bsmartProducts.push(pro);
        });
      } else {
        var _loop = function _loop(i) {
          var bMerchandise = {};
          var order = _this2.orderList[i];

          if (order.categoryId !== 10) {
            bMerchandise.merchandiseGuid = order.merchandiseId;
          } else {
            if (order.merchandiseId.toString().indexOf('Customized01') === -1) {
              alert('提交商品中包含审核失败的报价，请您修改商品再提交审核');
              _this2.$router.push({ name: 'cart' });
              return {
                v: void 0
              };
            }
            bMerchandise.merchandiseGuid = order.goodsNo;
            bMerchandise.merchandiseId = order.goodsNo;
          }
          if (order.id) {
            bMerchandise.orderGuid = order.id;
          }
          if (_this2.isSFFlag) {
            bMerchandise.unitPrice = order.priceMax;
          } else {
            bMerchandise.unitPrice = order.priceMin;
          }
          if (order.hardGeneDescription) {
            bMerchandise.hardGeneDescription = order.hardGeneDescription;
          }
          bMerchandise.selfOperated = order.selfOperated;
          bMerchandise.customerGuid = _this2.sessionInfo.customerInfo.customerGuid;
          bMerchandise.quantity = order.productQuantity;
          bMerchandise.merchantNo = order.MerchantNo;
          bMerchandise.amplification = order.amplification;
          bMerchandise.categoryId = order.categoryId;
          bMerchandise.priceMax = order.priceMax;
          bMerchandise.priceMin = order.priceMin;
          bMerchandise.initPrice = bMerchandise.quantity * bMerchandise.unitPrice;
          var productGuid = order.productGuid;
          if (productGuid) {
            bMerchandise.productGuid = productGuid;
          }
          var cusGuid = order.expressPrice;
          if (cusGuid) {
            bMerchandise.expressPrice = cusGuid;
          }
          var attributes = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(order.attributes).forEach(function (key) {
            if (order.attributes[key] instanceof Object) {
              if (key === 'GeneInfo') {
                attributes.push({ key: key, value: order.attributes[key].geneGUID });
                //                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
              }
              if (key === 'TVInfo') {
                attributes.push({ key: key, value: order.attributes[key].TLNo });
              }
            } else {
              attributes.push({ key: key, value: order.attributes[key] });
            }
          });
          bMerchandise.attributes = attributes;

          bMerchandises[i] = bMerchandise;
        };

        for (var i = 0; i < this.orderList.length; i++) {
          var _ret = _loop(i);

          if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
        }
      }

      border.merchandises = bMerchandises;
      border.expressFree = this.isExpress;
      border.usedBonus = false;
      border.customerVipPlanNo = this.customerVipPlanNo;
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp) {
        border.clientSource = '3';
      } else {
        border.clientSource = '1';
      }
      self.productInfo.value = border;
      return border;
    },
    fetchTotalMoney: function fetchTotalMoney() {
      var _this3 = this;

      this.showBtn = false;
      var self = this;

      var bMerchandises = this.getProductInfo();
      if (!bMerchandises) {
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp) {
        bMerchandises.clientSource = '3';
      } else {
        bMerchandises.clientSource = '1';
      }
      if (this.$route.query && this.$route.params.order) {
        var result = this.$route.params.order;
        this.goodsMoney = result.price;
        this.expressPrice = result.expressPrice;
        this.totalMoney = result.totalPrice;
        this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : 0;
        this.isExpress = result.expressFree;
        this.isUseVipPlanBouns = false;
      } else {
        if (this.isSFFlag) {
          // 将sf跳转链接的参数传给后台
          var paymentInfo = {};
          paymentInfo.balanceType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('BalanceType') === '' ? 0 : __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('BalanceType');
          paymentInfo.payType = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('PayType');
          paymentInfo.firstLevelEnterpriseNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('FirstLevelEnterpriseNo');
          paymentInfo.firstLevelEnterpriseName = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('FirstLevelEnterpriseName');
          paymentInfo.secondLevelEnterpriseNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SecondLevelEnterpriseNo');
          paymentInfo.secondLevelEnterpriseName = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SecondLevelEnterpriseName');
          paymentInfo.researchGroupNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('ResearchGroupNo');
          paymentInfo.researchGroupName = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('ResearchGroupName');
          paymentInfo.settlementAccountNo = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParam('SettlementAccountNo');
          bMerchandises.sfQuoteId = this.sessionInfo.customerInfo.customerProperties['QuoteId'];
          bMerchandises.employeeNo = this.sessionInfo.customerInfo.employeeOnBehalf;
          bMerchandises.orderSource = '2';
          bMerchandises.clientSource = '1';
          bMerchandises.orderType = '1';
          bMerchandises.merchantNo = '101';
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(bMerchandises, paymentInfo);
          if (this.couponRefused) {
            bMerchandises.coupons = [];
          }
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.showPreloader('正在计算中');
        this.gcapi('calculateOrderAmount', bMerchandises).then(function (data) {

          var result = data.body.result;
          var useSpecialCoupon = false;
          var notShare = false;
          for (var i = 0; i < result.merchandises.length; i++) {
            for (var j = 0; j < _this3.productInfo.value.merchandises.length; j++) {
              if (result.merchandises[i].merchandiseGuid === _this3.productInfo.value.merchandises[j].merchandiseGuid) {
                _this3.productInfo.value.merchandises[j].remark = result.merchandises[i].remark;
              }
            }
            if (result.merchandises[i].perferPromotions) {
              for (var k = 0; k < result.merchandises[i].perferPromotions.length; k++) {
                if (result.merchandises[i].perferPromotions[k].requiredCustomers === 1) {
                  var pro = result.merchandises[i].perferPromotions[k];
                  var endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second);
                  var statrDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second);
                  var startDT1 = _this3.FormatterTime(statrDT).replace(/-/g, '/');
                  var endDT1 = _this3.FormatterTime(endDT).replace(/-/g, '/');
                  var newcoupon = {
                    'promotionGuid': pro.promotionGuid,
                    'code': _this3.sessionInfo.customerInfo.customerNo + pro.promotionGuid,
                    'customerNo': _this3.sessionInfo.customerInfo.customerNo,
                    'type': 0,
                    'label': pro.name,
                    'startDT': startDT1,
                    'endDT': endDT1,
                    'description': pro.description
                  };
                  if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                    notShare = true;
                  }
                  useSpecialCoupon = true;
                  result.coupons.push(newcoupon);
                  break;
                } else {
                  if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                    result.coupons = result.coupons.filter(function (coupon) {
                      // 一旦有免单券则不过滤
                      return coupon.type === 4;
                    });
                    break;
                  }
                }
              }
            }
            // SF跳转下单，折扣券和代金券可以一起使用
            if (useSpecialCoupon && _this3.isSFFlag === false || notShare) {
              result.coupons = result.coupons.filter(function (coupon) {
                // 非SF下单，一旦有折扣券则其他全券不可使用
                return coupon.type === 0;
              });
            }
          }
          if (!_this3.selectCoupon) {
            _this3.filterCoupons(result);
          }
          // console.log(this.productInfo)
          _this3.totalMoney = 0;
          _this3.goodsMoney = 0;
          _this3.expressPrice = 0;
          _this3.specialFundCouponUsed = result.specialFundCouponUsed;
          var isedit = false;
          for (var n in bMerchandises.merchandises) {
            if (bMerchandises.merchandises[n].orderGuid) {
              isedit = true;
            }
          }
          if (isedit) {
            if (_this3.isSFFlag) {
              for (var m in bMerchandises.merchandises) {
                _this3.goodsMoney = _this3.goodsMoney + bMerchandises.merchandises[m].initPrice;
                if (bMerchandises.merchandises[m].expressPrice) {
                  _this3.expressPrice = _this3.expressPrice + bMerchandises.merchandises[m].expressPrice;
                }
              }
              if (bMerchandises.expressFree) {
                _this3.expressPrice = 0;
              }
              _this3.totalMoney = _this3.expressPrice + _this3.goodsMoney;
            } else {
              _this3.goodsMoney = result.price;
              _this3.totalMoney = result.totalPrice;
              _this3.expressPrice = result.expressPrice;
            }
          } else {
            _this3.goodsMoney = result.price;
            _this3.totalMoney = result.totalPrice;
            _this3.expressPrice = result.expressPrice;
          }
          var couponlist = [];

          var _loop2 = function _loop2(_j) {
            flag = true;

            couponlist.forEach(function (item) {
              if (result.coupons[_j].code === item.code) {
                flag = false;
              }
            });
            if (flag) {
              couponlist.push(result.coupons[_j]);
            }
          };

          for (var _j = 0; _j < result.coupons.length; _j++) {
            var flag;

            _loop2(_j);
          }
          // 首次可选择优惠券
          if (!_this3.getAllAvailableCouponsAlready) {
            _this3.coupons.value = couponlist;
            _this3.getAllAvailableCouponsAlready = true;
          }
          // 计算特殊的打折券的折扣金额
          var specialcouponpromotions = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getLocalStorage('EmktSpecialcouponpromotions');
          var specialDiscountPrice = 0;
          if (specialcouponpromotions && specialcouponpromotions.length > 0) {
            var specialCouponPromotionGuids = specialcouponpromotions.map(function (pro) {
              return pro.promotionGuid;
            });
            result.merchandises.forEach(function (merchandise) {
              var preferPromitionGuid = merchandise.perferPromotions && merchandise.perferPromotions.length > 0 && merchandise.perferPromotions[0].promotionGuid;
              specialDiscountPrice += preferPromitionGuid && specialCouponPromotionGuids.includes(preferPromitionGuid) ? merchandise.discountPrice : 0;
            });
          }
          console.log('specialDiscountPrice', specialDiscountPrice);
          _this3.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) + Math.abs(+specialDiscountPrice) : specialDiscountPrice ? Math.abs(+specialDiscountPrice) : 0;
          //            if (this.discountPrice < 1 && this.isUseVipPlanBouns) {
          //              alert('您好，此订单中的商品不符合赠送条件，请勿使用赠送名额！')
          //              this.isUseVipPlanBouns = false
          //              $.each(this.VipPlanList, function (index, item) {
          //                item.checked = false
          //              })
          //              this.customerVipPlanNo = ''
          //              this.fetchTotalMoney()
          //            }
          if (+_this3.totalMoney < 0) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.modal({
              title: '订单出现异常，请联系客服',
              buttons: [{
                text: '确定',
                onClick: function onClick() {
                  self.$router.go(-1);
                }
              }]
            });
          }
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hidePreloader();
          _this3.showBtn = true;
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hidePreloader();
        });
      }
    },
    goToDetail: function goToDetail(product) {
      var id = product.categoryId;
      var cId = void 0;
      if (product.merchandiseDetailForClient) {
        cId = product.merchandiseDetailForClient.categoryId;
      }
      var mId = product.merchandiseId;
      if (id !== 10 && cId !== 10) {
        if (id === 20 || cId === 20) {
          this.$router.push({ name: 'FinderOrderDeail', params: { merchandises: product, id: 1, order: this.order } });
        } else {
          this.$router.push({ name: 'finderMerchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId }, params: { order: this.order } });
        }
        //          this.$router.push({name: 'merchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId }})
      } else {
        if (mId) {
          this.$router.push({ name: 'custDetail', query: { custom: mId }, params: { order: this.order } });
        } else {
          this.$router.push({ name: 'custDetail', query: { custom: product.merchandiseDetailForClient._attributesList }, params: { order: this.order } });
        }
      }
    },
    gotolast: function gotolast() {
      this.$router.push({ name: 'cart' });
    },
    containExpressCoupon: function containExpressCoupon(coupons) {
      return coupons.some(function (coupon) {
        return coupon.label.indexOf('免邮券') !== -1 || coupon.label.indexOf('折券') !== -1;
      });
    },
    setAvailableCoupons: function setAvailableCoupons(result) {
      if (!result.coupons || result.coupons.length === 0) return;
      // 折扣券
      if (this.containExpressCoupon(result.coupons)) {
        if (result.coupons.length === 1) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('已为您选择折扣券！');
          this.$emit('updateSelectCoupon', result.coupons[0]);
        }
      }
      // 优惠券和促销不同享时，使用免邮券来抵消运费
      if (this.containExpressCoupon(result.coupons)) {
        result.coupons = result.coupons.filter(function (coupon) {
          // 过滤出金额比订单运费少的免邮券
          return coupon.label.includes('免邮券') && coupon.value <= result.expressPrice;
        });
        result.coupons.sort(function (a, b) {
          return b.value - a.value;
        });
        console.log('sorted coupons', result.coupons);
        if (result.coupons[0]) {
          // 默认选择第一个免邮券后，更新selectCoupon以重新计算价格
          if (!this.selectCoupon || this.selectCoupon.label !== result.coupons[0].label) {
            console.log('需计算最新价格');
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('已为您选择免邮券，正在重新计算价格');
            this.$emit('updateSelectCoupon', result.coupons[0]);
          }
        }
      } else {
        result.coupons = [];
      }
    },
    filterCoupons: function filterCoupons(result) {
      if (!result.coupons || result.coupons.length === 0) return;
      if (this.couponRefused) {
        return;
      }
      // 需过滤掉大于邮费的免邮券, 并选择最优的优惠券
      // const expressPrice = result.expressPrice
      // result.coupons = result.coupons.filter(coupon => {  // 过滤掉大于邮费的免邮券
      //   return !(coupon.label.includes('免邮券') && coupon.value > expressPrice)
      // })
      // 按优惠券金额倒序排列
      result.coupons.sort(function (a, b) {
        return b.value - a.value;
      });
      if (result.coupons[0]) {
        // 默认选择最优优惠券后，更新selectCoupon以重新计算价格
        if (!this.selectCoupon || this.selectCoupon.label !== result.coupons[0].label) {
          console.log('需计算最新价格');
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('已为您选择优惠券，正在重新计算价格');
          this.$emit('updateSelectCoupon', result.coupons[0]);
        }
      }
    },
    FormatterTime: function FormatterTime(date) {
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds;
      return newTime;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['checkList', 'sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['isNewCustomerWithoutHistoryOrders', 'isSFFlag']), {
    //    过滤
    filterAddress: function filterAddress() {
      var self = this;
      if (this.address === undefined) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.modal({
          title: '请先登录',
          buttons: [{
            text: '确定',
            onClick: function onClick() {
              self.$router.push({ name: 'login' });
            }
          }]
        });
        return [];
      }
      var add = [];
      this.address.forEach(function (item) {
        if (item.isDefault && add.length < self.limitNum) {
          add.push(item);
        }
      });
      if (add.length < self.limitNum) {
        this.address.forEach(function (item) {
          if (!item.isDefault && add.length < self.limitNum) {
            add.push(item);
          }
        });
      }
      if (add.length === 0 && this.isSFFlag === false) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.modal({
          title: '请先添加收货地址',
          buttons: [{
            text: '确定',
            onClick: function onClick() {
              self.$router.push({ name: 'address', params: { order: self.order } });
            }
          }]
        });
        return [];
      }
      __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setStoreItem('filterAddress', add);
      return add;
    },
    isUseSpecialFundCoupon: function isUseSpecialFundCoupon() {
      console.log('this.selectCoupon');
      return this.selectCoupon && this.selectCoupon.type && this.selectCoupon.type === 6;
    },
    showGo: function showGo() {
      return !(__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParamHref('fromSmart') === '1');
    }
  })
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContractInfoBox_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContractInfoBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContractInfoBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.fetchData();
  },

  components: { contractInfoBox: __WEBPACK_IMPORTED_MODULE_3__ContractInfoBox_vue___default.a },
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo', 'showContractInfoBox'])),
  data: function data() {
    return {
      sumdata: {},
      contractInfo: {},
      questionUrl: '/emktResources/resocurces/img/question.png',
      timeList1: [],
      timeList2: [],
      selected: '',
      chooseDate: '',
      billInfo: {},
      summary: {},
      consumeContractList: [],
      deliverContractList: [],
      invoiceList: [],
      type: '',
      statementGuid: ''
    };
  },

  watch: {
    '$route.query.type': function $routeQueryType(val) {
      this.selected = this.$route.query.type;
    },
    '$route.query.chooseDate': function $routeQueryChooseDate(val) {
      this.chooseDate = this.$route.query.chooseDate;
    },
    '$route.query.groupName': function $routeQueryGroupName(val) {
      this.groupName = this.$route.query.groupName;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['SETCONTRCTINfFOBOX']), {
    fetchData: function fetchData() {
      this.selected = this.$route.query.type;
      this.chooseDate = this.$route.query.chooseDate;
      this.groupName = this.$route.query.groupName;
      this.billInfo = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('billInfo');
      if (this.billInfo) {
        console.log('billInfo->', __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('billInfo'));
        // 账户总览
        this.summary = this.billInfo.summary;
        // 流水号
        this.statementGuid = this.billInfo.statementGuid;
        // 账户消费明细
        this.consumeContractList = this.billInfo.consumeContractList;
        // 账户交付明细
        this.deliverContractList = this.billInfo.deliverContractList;
        // 发票明细
        this.invoiceList = this.billInfo.invoiceList;
        if (this.selected === '累计') {
          var _this = this;
          var list1 = _this.billInfo.consumeContractList;
          var list2 = _this.billInfo.deliverContractList;
          _this.timeList1 = [];
          _this.timeList2 = [];
          var newtimeList1 = [];
          var newtimeList2 = [];
          for (var i in list1) {
            console.log(list1[i].contractStartDT.substring(0, 4));
            if (newtimeList1.indexOf(list1[i].contractStartDT.substring(0, 4)) === -1) {
              newtimeList1.push(list1[i].contractStartDT.substring(0, 4));
              var showdata1 = {};
              showdata1.isshow = false;
              showdata1.data = list1[i].contractStartDT.substring(0, 4);
              _this.timeList1.push(showdata1);
            }
          }
          for (var j in list2) {
            console.log(list2[j].deliveryDT.substring(0, 4));
            if (newtimeList2.indexOf(list2[i].deliveryDT.substring(0, 4)) === -1) {
              newtimeList2.push(list2[i].deliveryDT.substring(0, 4));
              var showdata2 = {};
              showdata2.isshow = false;
              showdata2.data = list2[i].deliveryDT.substring(0, 4);
              _this.timeList2.push(showdata2);
            }
          }
        }
      }
    },
    tolast: function tolast() {
      this.$router.push('/user/myAccountChecked');
    },
    showcontractInfo: function showcontractInfo(contract, type) {
      this.contractInfo = contract;
      this.type = type;
      console.log(this.showContractInfoBox);
      console.log('contract->', this.contractInfo);
      this.SETCONTRCTINfFOBOX(true);
    },
    senEmail: function senEmail() {
      var _this = this;
      _this.gcapi('contactUsForBill', _this.statementGuid).then(function (response) {
        alert('您的反馈已收到，我们将会尽快联系您，感谢您对吉凯基因的支持。');
      });
    },
    submit: function submit() {
      var _this = this;
      _this.gcapi('confirmBill', _this.statementGuid).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('感谢您对吉凯基因的支持!');
        }
      });
    },
    showcontract: function showcontract(showdata) {
      if (showdata.isshow) {
        showdata.isshow = false;
      } else {
        showdata.isshow = true;
      }
    }
  })
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChooseBillType__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChooseBillType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChooseBillType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OldAccountChecked__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OldAccountChecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OldAccountChecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emkt_js__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AllBill',
  components: {
    ChooseBillType: __WEBPACK_IMPORTED_MODULE_2__ChooseBillType___default.a,
    OldAccountChecked: __WEBPACK_IMPORTED_MODULE_3__OldAccountChecked___default.a
  },
  mounted: function mounted() {
    console.log('this.researchGroupSet', this.researchGroupSet);
    console.log('this.researchGroupAsLeaderList', this.researchGroupAsLeaderList);
  },
  data: function data() {
    return {
      researchGroupList: [],
      isWapp: __WEBPACK_IMPORTED_MODULE_5__emkt_js__["a" /* default */].isWapp
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['sessionInfo', 'researchGroupSet']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['hasLogin', 'researchGroupAsLeaderList']), {
    canWatch: function canWatch() {
      if (!this.researchGroupSet || this.researchGroupSet.length === 0) {
        this.researchGroupList = [];
        return false;
      }
      if (!this.hasLogin || !this.sessionInfo.customerInfo.customerNo) {
        this.researchGroupList = [];
        return false;
      }
      var customerNo = this.sessionInfo.customerInfo.customerNo;
      // const customerNo = '00004380'
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.researchGroupSet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var researchGroup = _step.value;

          if (customerNo === researchGroup.leaderNo || customerNo === researchGroup.accountCustomerNo) {
            this.researchGroupList.push(researchGroup);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.researchGroupList.length > 0) {
        return true;
      }
      return false;
    },
    showComp: function showComp() {
      if (this.canWatch) {
        if (this.researchGroupList.length > 1) {
          return true;
        } else {
          return false;
        }
      }
    }
  }),
  methods: {
    tolast: function tolast() {
      this.$router.push({ name: 'me' });
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyResearchGroup_researchGroupComponents_ChooseResearchGroup__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyResearchGroup_researchGroupComponents_ChooseResearchGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MyResearchGroup_researchGroupComponents_ChooseResearchGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import $
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChooseBillType',
  props: {
    showComp: Boolean,
    researchGroupList: {}
  },
  components: {
    ChooseResearchGroup: __WEBPACK_IMPORTED_MODULE_1__MyResearchGroup_researchGroupComponents_ChooseResearchGroup___default.a
  },
  data: function data() {
    return {
      selected: '月度',
      chooseDate: '2020-01',
      year: '2020',
      month: '01',
      billInfo: {},
      defaultIndex: 0
    };
  },
  mounted: function mounted() {
    console.log('课题组列表:', this.researchGroupList);
  },

  watch: {
    'selected': function selected(val) {
      if (val === '累计') {
        this.year = '';
        this.month = '';
      } else if (val === '年度') {
        this.month = '';
      }
    }
  },
  methods: {
    toBillChecked: function toBillChecked() {
      var _this2 = this;

      this.changeChooseDate();
      // 获取账单数据
      if (this.researchGroupList.length > 0) {
        var params = this.researchGroupList[this.defaultIndex].researchGroupNo + ',' + this.chooseDate;
        // var params = '00000004,2020-02'
        console.log('params->' + params);
        this.gcapi('loadResearchGroupBillInfo', params).then(function (res) {
          console.log('res.body.result：', JSON.parse(res.body.result));
          var mes = JSON.parse(res.body.result);
          if (!mes.result) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('课题组编号不存在');
            return;
          }
          var obj = JSON.parse(JSON.parse(res.body.result).json);
          console.log('账单对象：', obj);
          _this2.billInfo = obj;
          __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].setStoreItem('billInfo', obj);
          var _this = _this2;
          if (_this.selected === '累计') {
            _this.$router.push({ name: 'AccountChecked', query: { type: _this.selected, groupName: _this2.researchGroupList[_this2.defaultIndex].researchGroupName } });
          } else {
            _this.$router.push({ name: 'AccountChecked', query: { type: _this.selected, chooseDate: _this.chooseDate, groupName: _this2.researchGroupList[_this2.defaultIndex].researchGroupName } });
          }
        });
      }
    },
    updateDefaultIndex: function updateDefaultIndex(index) {
      console.log('update', index);
      this.defaultIndex = index;
    },
    tolast: function tolast() {
      this.$router.push({ name: 'me' });
    },
    changeChooseDate: function changeChooseDate() {
      if (this.selected === '月度') {
        this.chooseDate = this.year + '-' + this.month;
      } else if (this.selected === '年度') {
        this.chooseDate = this.year;
      } else {
        this.chooseDate = '';
      }
    }
  }

});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contractInfoBox',
  props: ['contractInfo', 'type', 'selected'],
  data: function data() {
    return {
      payType: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['showContractInfoBox'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['SETCONTRCTINfFOBOX']), {
    actionHandler: function actionHandler(action) {
      if (action === 'cancel') {
        // this.resetWindow()
        this.SETCONTRCTINfFOBOX(false);
        return;
      }
      if (action === 'ok') {}
    }
  })
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContractInfoBox_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContractInfoBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ContractInfoBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_v_2_6_components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_v_2_6_components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_v_2_6_components_FooterPlaceholder__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},

  components: { contractInfoBox: __WEBPACK_IMPORTED_MODULE_2__ContractInfoBox_vue___default.a, FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__views_v_2_6_components_FooterPlaceholder___default.a },
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo', 'showContractInfoBox'])),
  data: function data() {
    return {
      sumdata: {},
      contractInfo: {},
      questionUrl: '/emktResources/resocurces/img/question.png',
      timeList: [],
      asBillInfos: [],
      selected: '个人',
      type: '消费明细',
      isWapp: __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isWapp
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['SETCONTRCTINfFOBOX']), {
    fetchData: function fetchData() {
      var _this = this;
      // '00289663'
      _this.gcapi('loadCustomerBillInfo', _this.sessionInfo.customerInfo.customerNo).then(function (response) {
        console.log('response::', response);
        var data = {};
        data = JSON.parse(response.body.result);
        console.log(data);
        if (!data.result) {
          // $.toast(data.message)
        } else {
          _this.sumdata = JSON.parse(JSON.parse(response.body.result).json);
          _this.asBillInfos = _this.sumdata.asBillInfos;
          for (var billInfoKey in _this.asBillInfos) {
            var list = _this.asBillInfos[billInfoKey].consumeContractList;
            _this.timeList = [];
            var newtimeList = [];
            for (var i in list) {
              console.log(list[i].contractStartDT.substring(0, 4));
              if (newtimeList.indexOf(list[i].contractStartDT.substring(0, 4)) === -1) {
                newtimeList.push(list[i].contractStartDT.substring(0, 4));
                var showdata = {};
                showdata.isshow = false;
                showdata.data = list[i].contractStartDT.substring(0, 4);
                _this.timeList.push(showdata);
              }
            }
            console.log('timeList:', _this.timeList);
            console.log('sumdata:', _this.sumdata);
            console.log('asBillInfos:', _this.asBillInfos);
          }
        }
      });
    },
    tolast: function tolast() {
      this.$router.push({ name: 'me' });
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      var message = void 0;
      message = '注:发票超期级别，异常为超过平均回款 周期，一级为超过2个，二级为超过1个。 正常是指还未超过平均回款周期。' + '您的历史平均回款周期：' + val.customerReceivePeriodAvg + '天' + '您单位历史平均回款周期：' + val.enterpriseReceivePeriodAvg + '天';
      this.$weui.alert(message);
      // $.alert(message)
    },
    showcontractInfo: function showcontractInfo(contract) {
      this.contractInfo = contract;
      console.log(this.showContractInfoBox);
      this.SETCONTRCTINfFOBOX(true);
    },
    senEmail: function senEmail() {
      var _this2 = this;

      var _this = this;
      var customerNo = _this.sessionInfo.customerInfo.customerNo;
      _this.gcapi('billInfoSendEmail', customerNo).then(function (response) {
        _this2.$weui.alert(response.body.result);
        // alert(response.body.result)
      });
    },
    submit: function submit() {
      var _this3 = this;

      var _this = this;
      _this.gcapi('checkCustomerBillInfo', _this.sessionInfo.customerInfo.customerNo).then(function (response) {
        _this3.$weui.toast('感谢您对吉凯基因的支持!', 1500);
        // $.toast('感谢您对吉凯基因的支持!')
      });
    },
    showcontract: function showcontract(showdata) {
      if (showdata.isshow) {
        showdata.isshow = false;
      } else {
        showdata.isshow = true;
      }
    }
  })
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseResearchGroup__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseResearchGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseResearchGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      researchGroupApproveTypeDictionary: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].researchGroupApproveTypeDictionary,
      approveTypeThreshold: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].CONSTANT_APPROVETYPE_NONE,
      waitApproveOrderNum: 0,
      showChooseResearchGroup: false,
      billInfo: {},
      isResearchGroup: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isResearchGroup,
      orderList: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp,
      approvalMemberList: []
    };
  },
  mounted: function mounted() {
    console.log('haslogin', this.hasLogin);
    if (this.isResearchGroup && this.hasLogin && __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isNullOrBlankObject(this.displayChosenResearchGroup)) {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('加载中');
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
      }, 3000);
    }
  },

  components: {
    ChooseResearchGroup: __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseResearchGroup___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_ORDER_MAP']), {
    goBack: function goBack() {
      if (this.isResearchGroup) return;
      this.$router.push({ name: 'me' });
    },
    isJson: function isJson(str) {
      try {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(JSON.parse(str)) === 'object') {
          return true;
        }
      } catch (e) {
        console.log('is not Json', e);
      }
      return false;
    },
    getWaitApproveOrderNumAndBill: function getWaitApproveOrderNumAndBill() {
      var _this = this;

      if (!this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('请登录');
        this.$router.push({ name: 'login' });
      }
      if (!this.customerNo || !this.displayChosenResearchGroup) {
        return;
      }
      // 00000056
      var queryParam = {};
      queryParam.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      if (this.displayChosenResearchGroup) {
        this.gcapi('getAllRequestLogByResearchGroupNo', queryParam.researchGroupNo).then(function (res) {
          _this.approvalMemberList = res.data.result.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { createDT: item.createDT || __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FormatterTime(new Date()) });
          }).filter(function (item) {
            return item.status === 0;
          });
        });
      }
      this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(function (res) {
        console.log('课题组订单订单信息列表：', res.data.result);
        if (res.data.code === 0) {
          _this.orderList = res.data.result;
          __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setLocalStorage('ResearchGroupOrderList', _this.orderList);
        } else {
          console.log('获取课题组订单信息列表失败');
        }
      });
      console.log('displayChosenResearchGroup', this.displayChosenResearchGroup);
      if (this.customerNo === this.displayChosenResearchGroup.approverNo || this.customerNo === this.displayChosenResearchGroup.leaderNo) {
        this.gcapi('loadWaitingApprovedOrderList', this.displayChosenResearchGroup.researchGroupNo).then(function (res) {
          if (res && res.body.result) {
            _this.waitApproveOrderNum = res.body.result.length;
          }
        });
      }
      if (this.customerNo === this.displayChosenResearchGroup.accountCustomerNo || this.customerNo === this.displayChosenResearchGroup.leaderNo) {
        var parameter = this.displayChosenResearchGroup.researchGroupNo + ',' + new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth());
        this.gcapi('loadResearchGroupBillInfo', parameter).then(function (res) {
          if (res && res.body.result && _this.isJson(res.body.result) && JSON.parse(res.body.result).json) {
            var obj = JSON.parse(JSON.parse(res.body.result).json);
            console.log('账单对象：', obj);
            _this.billInfo = obj;
            __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setStoreItem('billInfo', obj);
          } else {
            console.log('获取账单失败');
          }
        });
      }
    },
    toggleShowChooseBox: function toggleShowChooseBox() {
      this.showChooseResearchGroup = !this.showChooseResearchGroup;
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    checkBill: function checkBill() {
      this.$router.push({ name: 'BillCheck' });
    },
    toOrder: function toOrder(index) {
      // 1:全部订单 2：待审批 3：执行中 4：已完成
      this.$router.push({ name: 'ResearchGroupOrder', query: { tabIndex: index } });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['hasLogin', 'customerNo', 'displayChosenResearchGroup', 'customerName', 'researchGroupCharacter']), {
    currentDiscount: function currentDiscount() {
      if (this.displayChosenResearchGroup && this.displayChosenResearchGroup.level) {
        return __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].benefitDiscount[this.displayChosenResearchGroup.level - 1];
      }
      return {};
    },
    approvalMemberListLength: function approvalMemberListLength() {
      return this.approvalMemberList.length;
    }
  }),
  watch: {
    'displayChosenResearchGroup': {
      handler: 'getWaitApproveOrderNumAndBill',
      immediate: true
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin', 'customerNo', 'displayChosenResearchGroup', 'isWapp']), {
    vipBenefitSvg: function vipBenefitSvg() {
      var index = this.currentIndex + 1;
      return 'static/img/svg/VIP' + index + '\u6743\u76CA.svg';
    }
  }),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    vipImg: function vipImg(item) {
      return 'static/img/VIP' + item + '.png';
    },
    changeVip: function changeVip(newVal, oldVal) {
      console.log('val', newVal, oldVal);
      this.currentIndex = newVal;
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillList__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BillList__);
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      deliverIsOpen: false,
      consumeIsOpen: false,
      contractInfo: {},
      selected: '累计',
      type: '',
      showBillDetail: false
    };
  },

  components: {
    BillList: __WEBPACK_IMPORTED_MODULE_0__BillList___default.a
  },
  props: ['billInfo'],
  computed: {
    deliverContractList: function deliverContractList() {
      if (this.billInfo && this.billInfo.deliverContractList) return this.billInfo.deliverContractList;
      return {};
    },
    consumeContractList: function consumeContractList() {
      if (this.billInfo && this.billInfo.consumeContractList) return this.billInfo.consumeContractList;
      return {};
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    showBillInfo: function showBillInfo(detail, type) {
      this.contractInfo = detail;
      this.type = type;
      this.showBillDetail = !this.showBillDetail;
      console.log('detail', detail);
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BillList__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BillList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BillList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AnnualBillDetail__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AnnualBillDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AnnualBillDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChooseBillPeriod__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChooseBillPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChooseBillPeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__researchGroupComponents_ResearchGroupRemindBox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__researchGroupComponents_ResearchGroupRemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__researchGroupComponents_ResearchGroupRemindBox__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import BillDetail from './BillDetail'





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      billInfo: __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getLocalStorage('billInfo'),
      deliverIsOpen: false,
      consumeIsOpen: false,
      showBillDetail: false,
      showChooseBillPeriod: false,
      contractInfo: {},
      type: '',
      monthOrYear: 'month',
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      showResearchGroupRemindBox: false,
      yearList: [],
      annualContractObj: {},
      showAnnualBillDetail: false,
      annualBillInfo: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()
    };
  },
  mounted: function mounted() {},

  components: {
    BillList: __WEBPACK_IMPORTED_MODULE_6__BillList___default.a, ChooseBillPeriod: __WEBPACK_IMPORTED_MODULE_8__ChooseBillPeriod___default.a, ResearchGroupRemindBox: __WEBPACK_IMPORTED_MODULE_9__researchGroupComponents_ResearchGroupRemindBox___default.a, AnnualBillDetail: __WEBPACK_IMPORTED_MODULE_7__AnnualBillDetail___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter', 'customerNo', 'isWapp']), {
    summary: function summary() {
      if (!this.billInfo) return {};
      return this.billInfo.summary;
    },
    consumeContractList: function consumeContractList() {
      if (!this.billInfo) return {};
      return this.billInfo.consumeContractList;
    },
    deliverContractList: function deliverContractList() {
      if (!this.billInfo) return {};
      return this.billInfo.deliverContractList;
    },
    invoiceList: function invoiceList() {
      if (!this.billInfo) return {};
      return this.billInfo.invoiceList;
    },
    showBillConfirmButton: function showBillConfirmButton() {
      return this.billInfo && this.billInfo.statementGuid && this.monthOrYear === 'month';
    },
    displayDate: function displayDate() {
      if (this.monthOrYear === 'month') {
        return this.year + '年' + this.month + '月';
      }
      if (this.monthOrYear === 'year') {
        return this.year + '年';
      }
      if (this.monthOrYear === 'all') return '历史累计';
    }
  }),
  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'ResearchGroupHome' });
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    showBillInfo: function showBillInfo(detail, type) {
      this.contractInfo = detail;
      this.type = type;
      this.showBillDetail = !this.showBillDetail;
      console.log('detail', detail);
    },
    getBillInfo: function getBillInfo(params) {
      var _this = this;

      if (String(params).includes('-')) {
        this.year = String(params).split('-')[0];
        this.month = String(params).split('-')[1];
      } else if (params) {
        this.year = String(params);
      }
      // let parameter = '00000013,' + params // '00000026,2018-11'
      var parameter = this.displayChosenResearchGroup.researchGroupNo + ',' + params;
      console.log('params->' + parameter);
      this.gcapi('loadResearchGroupBillInfo', parameter).then(function (res) {
        // console.log('res.body.result：', JSON.parse(res.body.result))
        var mes = JSON.parse(res.body.result);
        if (!mes.result) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('课题组编号不存在');
          return;
        }
        var obj = JSON.parse(JSON.parse(res.body.result).json);
        console.log('账单对象：', obj);
        _this.billInfo = obj;
        if (_this.monthOrYear === 'all') {
          _this.classifyBillByYear();
          __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].setStoreItem('allBillInfo', obj);
        } else {
          __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].setStoreItem('billInfo', obj);
        }
      });
    },
    classifyBillByYear: function classifyBillByYear() {
      var list1 = this.billInfo.consumeContractList;
      var list2 = this.billInfo.deliverContractList;
      var annualContractObj = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(list1), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          var year = i.contractStartDT.substring(0, 4);
          if (!annualContractObj[year]) {
            annualContractObj[year] = {};
            // annualContractObj[year].isSelected = false
            annualContractObj[year].year = year;
            annualContractObj[year].consumeContractList = [];
            annualContractObj[year].consumeContractList.push(i);
          } else if (!annualContractObj[year].consumeContractList) {
            annualContractObj[year].consumeContractList = [];
            annualContractObj[year].consumeContractList.push(i);
          } else {
            annualContractObj[year].consumeContractList.push(i);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(list2), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var j = _step2.value;

          var year = j.deliveryDT.substring(0, 4);
          if (!annualContractObj[year]) {
            annualContractObj[year] = {};
            // annualContractObj[year].isSelected = false
            annualContractObj[year].year = year;
            annualContractObj[year].deliverContractList = [];
            annualContractObj[year].deliverContractList.push(j);
          } else if (!annualContractObj[year].deliverContractList) {
            annualContractObj[year].deliverContractList = [];
            annualContractObj[year].deliverContractList.push(j);
          } else {
            annualContractObj[year].deliverContractList.push(j);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.yearList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(annualContractObj);
      this.annualContractObj = annualContractObj;
    },
    chooseBillType: function chooseBillType(type) {
      if (type === 'all') {
        this.monthOrYear = 'all';
        if (!__WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getLocalStorage('allBillInfo')) return this.getBillInfo('');
        this.billInfo = __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getLocalStorage('allBillInfo');
        this.classifyBillByYear();
        return;
      }
      if (type === 'month') {
        this.showChooseBillPeriod = !this.showChooseBillPeriod;
        this.monthOrYear = 'month';
        return;
      }
      if (type === 'year') {
        this.showChooseBillPeriod = !this.showChooseBillPeriod;
        this.monthOrYear = 'year';
        return;
      }
    },
    sendEmail: function sendEmail() {
      var _this2 = this;

      this.gcapi('contactUsForBill', this.billInfo.statementGuid).then(function (response) {
        _this2.billInfo.status = 2;
        _this2.remindParams.firstline = '您的反馈已收到';
        _this2.remindParams.secondline = '我们将会尽快联系您。';
        _this2.toggleResearchGroupRemindBox();
        // $.alert('您的反馈已收到，我们将会尽快联系您，感谢您对吉凯基因的支持。')
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.gcapi('confirmBill', this.billInfo.statementGuid).then(function (response) {
        if (response.body.code === 0) {
          _this3.billInfo.status = 1;
          _this3.remindParams.firstline = '感谢您对吉凯基因的支持';
          _this3.remindParams.secondline = '';
          _this3.toggleResearchGroupRemindBox();
          // $.toast('感谢您对吉凯基因的支持!')
        }
      });
    },
    toggleResearchGroupRemindBox: function toggleResearchGroupRemindBox() {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox;
    },
    showAnnualBill: function showAnnualBill(year) {
      this.annualBillInfo = this.annualContractObj[year];
      console.log('annualBillInfo', this.annualBillInfo);
      this.showAnnualBillDetail = !this.showAnnualBillDetail;
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['contractInfo', 'type', 'selected'],
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillDetail__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BillDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      deliverIsOpen: false,
      consumeIsOpen: false,
      contractInfo: {},
      selected: '累计',
      type: '',
      showBillDetail: false
    };
  },

  components: {
    BillDetail: __WEBPACK_IMPORTED_MODULE_0__BillDetail___default.a
  },
  props: ['billInfo', 'top'],
  computed: {
    deliverContractList: function deliverContractList() {
      if (this.billInfo && this.billInfo.deliverContractList) return this.billInfo.deliverContractList;
      return {};
    },
    consumeContractList: function consumeContractList() {
      if (this.billInfo && this.billInfo.consumeContractList) return this.billInfo.consumeContractList;
      return {};
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    showBillInfo: function showBillInfo(detail, type) {
      this.contractInfo = detail;
      this.type = type;
      this.showBillDetail = !this.showBillDetail;
      console.log('detail', detail);
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      monthList: [],
      yearList: [2018, 2019, 2020, 2021],
      isSelectedYear: {},
      isSelectedMonth: {},
      month: '',
      year: ''

    };
  },
  mounted: function mounted() {
    var list = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(12).keys()));
    this.monthList = list.map(function (mon) {
      return mon + 1;
    });
    this.initIsSelectedYear();
    this.initIsSelectedMonth();
    this.updateMonth(Number(this.defaultMonth));
    this.updateYear(Number(this.defaultYear));
  },

  props: ['monthOrYear', 'defaultYear', 'defaultMonth'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup'])),
  methods: {
    initIsSelectedMonth: function initIsSelectedMonth() {
      var selectedObj = {};
      this.monthList.forEach(function (mon) {
        selectedObj[mon] = false;
      });
      this.isSelectedMonth = selectedObj;
    },
    initIsSelectedYear: function initIsSelectedYear() {
      var selectedObj = {};
      this.yearList.forEach(function (year) {
        selectedObj[year] = false;
      });
      this.isSelectedYear = selectedObj;
    },
    updateYear: function updateYear(year) {
      var isTrue = this.isSelectedYear[year];
      this.initIsSelectedYear();
      this.isSelectedYear[year] = !isTrue;
      this.year = this.isSelectedYear[year] ? year : '';
    },
    updateMonth: function updateMonth(month) {
      var isTrue = this.isSelectedMonth[month];
      this.initIsSelectedMonth();
      this.isSelectedMonth[month] = !isTrue;
      this.month = this.isSelectedMonth[month] ? month : '';
    },
    confirm: function confirm() {
      if (this.monthOrYear === 'month') {
        if (!this.year || !this.month) return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择日期');
        var params = this.year + '-' + (this.month < 10 ? '0' + this.month : this.month);
        this.$emit('getBillInfo', params);
        this.$emit('toggleShow');
      } else if (this.monthOrYear === 'year') {
        if (!this.year) return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请选择日期');
        var _params = this.year;
        this.$emit('getBillInfo', _params);
        this.$emit('toggleShow');
      }
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      approve: {
        approveType: this.memberDetail && this.memberDetail.approveType
        // approveThreshold: this.memberDetail && this.memberDetail.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.approveThreshold : '',
        // monthlyLimit: this.memberDetail && this.memberDetail.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.monthlyLimit : ''
      }
    };
  },

  props: ['memberDetail', 'setApproveType'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['researchGroupDetailList', 'displayChosenResearchGroup'])),
  methods: {
    updateApproveType: function updateApproveType(approveType) {
      this.approve.approveType = approveType;
      console.log('approveType', approveType);
    },
    updateMemberApproveType: function updateMemberApproveType() {
      if (this.validateInfo()) {
        this.$emit('updateMemberApproveType', this.approve, this.setApproveType);
        this.$emit('toggleShow');
      }
    },
    validateInfo: function validateInfo() {
      if (this.approve.approveType === undefined) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请设置审批原则');
        return false;
      }
      return true;
    },
    resetWindow: function resetWindow() {
      // ios 兼容，键盘收起后界面下移恢复
      setTimeout(function () {
        window.scrollTo(0, 0);
        console.log('reset invoked');
      }, 300);
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      approve: {
        approveType: this.memberDetail && this.memberDetail.approveType,
        approveThreshold: this.memberDetail && this.memberDetail.approveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.approveThreshold : '',
        monthlyLimit: this.memberDetail && this.memberDetail.approveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD ? this.memberDetail.monthlyLimit : ''
      },
      setSinglestrokeApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_ALL_APPROVETYPE,
      settype: 0
    };
  },

  props: ['memberDetail', 'setApproveType'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['researchGroupDetailList', 'displayChosenResearchGroup'])),
  methods: {
    updateApproveType: function updateApproveType(data) {
      this.settype = data;
      this.approve.approveType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD;
      this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE ? data === 0 ? this.approve.approveThreshold = '' : '' : data === 0 ? this.approve.monthlyLimit = '' : '';
    },
    updateMemberApproveType: function updateMemberApproveType() {
      if (this.validateInfo()) {
        console.log('setApproveType:' + this.setApproveType);
        this.$emit('updateMemberApproveType', this.approve, this.setApproveType);
        this.$emit('toggleShow');
      }
    },
    validateInfo: function validateInfo() {
      console.log(this.approve);
      if (this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE) {
        this.approve.monthlyLimit = undefined;
      }
      if (this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE) {
        this.approve.approveThreshold = undefined;
      }
      if (this.approve.approveType === undefined) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请设置审批原则');
        return false;
      }
      if (this.approve.approveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD && this.settype === 1 && (!this.approve.approveThreshold && this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE || !this.approve.monthlyLimit && this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入审批限额');
        return false;
      }
      if (this.approve.approveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD && this.settype === 1 && (this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE && !/^[0-9]*$/.test(this.approve.approveThreshold) || this.setApproveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE && !/^[0-9]*$/.test(this.approve.monthlyLimit))) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入正确的审批限额');
        return false;
      }
      return true;
    },
    resetWindow: function resetWindow() {
      // ios 兼容，键盘收起后界面下移恢复
      setTimeout(function () {
        window.scrollTo(0, 0);
        console.log('reset invoked');
      }, 300);
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      constants: {},
      index: 0
    };
  },
  mounted: function mounted() {
    this.index = this.chosenResearchGroupIndex;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['researchGroupDetailList', 'displayChosenResearchGroup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['chosenResearchGroupIndex'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_RESEARCH_INDEX']), {
    updateResearchGroup: function updateResearchGroup(index) {
      this.index = index;
    },
    updateChosenResearchGroup: function updateChosenResearchGroup() {
      this.UPDATE_CHOSEN_RESEARCH_INDEX(this.index);
      this.$emit('toggleShow');
    }
  })
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters, mapState, mapMutations} from 'vuex'

// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      query: '',
      data: [],
      filteredData: []
    };
  },

  props: ['enterpriseNo'],
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    // listening to input
    'query': function query(_query) {
      this.initialize();
      var data = this.data;
      var filteredData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var enterprise = _step.value;

          if (enterprise.enterpriseName.match(_query.toLowerCase())) {
            filteredData.push(enterprise);
            if (filteredData.length > 19) {
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.filteredData = filteredData;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    updateEnterprise: function updateEnterprise(enterprise) {
      this.$emit('toggleShow');
      this.$emit('update', enterprise);
    },
    fetchData: function fetchData() {
      var _this = this;

      // 获取科室列表
      if (!this.enterpriseNo) return;
      this.gcapi('getSecondEnterpriseInfoByFirstEnterpriseNo', this.enterpriseNo).then(function (res) {
        if (res && res.body.result) {
          _this.data = res.body.result.filter(function (enterprise) {
            return enterprise.parentEnterpriseName && enterprise.enterpriseName && enterprise.enterpriseName.includes(enterprise.parentEnterpriseName);
          });
          _this.initialize();
        }
      });
    },
    initialize: function initialize() {
      this.filteredData = this.data;
    },
    autofocus: function autofocus() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#search-department').focus();
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters, mapState, mapMutations} from 'vuex'


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      query: '',
      data: [],
      filteredData: []
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    // listening to input
    'query': function query(_query) {
      this.initialize();
      var data = this.data;
      var filteredData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var enterprise = _step.value;

          if (enterprise.enterpriseName.match(_query.toLowerCase())) {
            filteredData.push(enterprise);
            if (filteredData.length > 19) {
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.filteredData = filteredData;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    updateEnterprise: function updateEnterprise(enterprise) {
      this.$emit('toggleShow');
      this.$emit('update', enterprise);
    },
    fetchData: function fetchData() {
      // 获取课题组成员列表
      this.data = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelEnterpriseList');
      this.initialize();
    },
    initialize: function initialize() {
      this.filteredData = [];
    },
    autofocus: function autofocus() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#search-enterprise').focus();
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reason: ''
    };
  },

  methods: {
    resetWindow: function resetWindow() {
      // ios 兼容，键盘收起后界面下移恢复
      setTimeout(function () {
        window.scrollTo(0, 0);
        console.log('reset invoked');
      }, 300);
    },
    autofocus: function autofocus() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('textarea').focus();
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      query: '',
      data: [],
      filteredData: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var researchGroupMember = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.popup-researchGroupMember');
    researchGroupMember.on('open', function () {
      console.log('popup is opening');
      _this.query = '';
      _this.fetchData();
    });
    researchGroupMember.on('closed', function () {
      console.log('popup closed');
    });
  },

  watch: {
    // listening to input
    'query': function query(_query) {
      console.log('in query');
      this.initialize();
      var data = this.data;
      var filteredData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var member = _step.value;

          if (member.memberName.match(_query.toLowerCase())) {
            filteredData.push(member);
            if (filteredData.length > 19) {
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.filteredData = filteredData;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['researchGroupMemberMap']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_RESEARCH_MEMBER']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    updateChosenResearchMember: function updateChosenResearchMember(member) {
      this.UPDATE_CHOSEN_RESEARCH_MEMBER(member);
    },
    fetchData: function fetchData() {
      // 获取课题组成员列表
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return;
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return;
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      this.data = this.researchGroupMemberMap[researchGroupNo];
      this.initialize();
    },
    initialize: function initialize() {
      this.filteredData = this.data;
    },
    autofocus: function autofocus() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#search').focus();
    }
  })
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['remindParams'],
  methods: {
    cancel: function cancel() {
      this.$emit('toggleShow');
    },
    confirm: function confirm() {
      this.$emit('toggleShow');
      this.$emit('confirm');
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      waitApproveOrderList: [],
      researchGroupNo: this.$route.query.researchGroupNo
    };
  },

  watch: {
    'researchGroupDetailList': {
      handler: 'setResearchGroupByGroupNo',
      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter', 'researchGroupDetailList', 'isWapp'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_RESEARCH_INDEX']), {
    setResearchGroupByGroupNo: function setResearchGroupByGroupNo() {
      if (!this.researchGroupNo) return;
      var researchGroupIndex = 0;
      for (var i = 0; i < this.researchGroupDetailList.length; i++) {
        if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
          researchGroupIndex = i;
          continue;
        }
      }
      this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex);
      if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
        this.fetchWaitApproveOrderList();
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'ResearchGroupHome' });
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    fetchWaitApproveOrderList: function fetchWaitApproveOrderList() {
      var _this = this;

      var researchGroup = this.displayChosenResearchGroup;
      if (researchGroup && researchGroup.researchGroupNo) {
        this.$weui.loading('查询中');
        this.gcapi('loadWaitingApprovedOrderList', researchGroup.researchGroupNo).then(function (res) {
          _this.$weui.loading().hide();
          if (res && res.body.result) {
            _this.waitApproveOrderList = res.body.result;
            console.log('waitApproveOrderList', _this.waitApproveOrderList);
            if (_this.waitApproveOrderList.length === 0) __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('您当前没有待审批的订单');
          }
        });
      }
    }
  })
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupDisagreeBox__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupDisagreeBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupDisagreeBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderNo: this.$route.query.orderNo || __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getFullUrlParam('orderNo'),
      reason: '',
      orderDetail: {},
      showResearchGroupDisagreeBox: false,
      researchGroupNo: this.$route.query.researchGroupNo || __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getFullUrlParam('researchGroupNo')
    };
  },

  watch: {
    'researchGroupDetailList': {
      handler: 'setResearchGroupByGroupNo',
      immediate: true,
      isWapp: __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWapp
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin', 'displayChosenResearchGroup', 'researchGroupCharacter', 'researchGroupDetailList', 'isWapp']), {
    hasDisplayData: function hasDisplayData() {
      if (!this.orderDetail || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.orderDetail) === '{}') {
        return false;
      } else {
        return true;
      }
    }
  }),
  components: {
    ResearchGroupDisagreeBox: __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupDisagreeBox___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_RESEARCH_INDEX']), {
    setResearchGroupByGroupNo: function setResearchGroupByGroupNo() {
      if (!this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请登录');
        this.$router.push({ name: 'login' });
      }
      if (!this.researchGroupNo) return;
      var researchGroupIndex = 0;
      for (var i = 0; i < this.researchGroupDetailList.length; i++) {
        if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
          researchGroupIndex = i;
          continue;
        }
      }
      this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex);
      if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
        this.fetchWaitApproveOrderDetail();
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'ApproveOrder', query: { researchGroupNo: this.researchGroupNo } });
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    fetchWaitApproveOrderDetail: function fetchWaitApproveOrderDetail() {
      var _this = this;

      if (this.researchGroupNo && this.orderNo) {
        this.$weui.loading('查询中');
        this.gcapi('loadWaitingApprovedOrderList', this.researchGroupNo).then(function (res) {
          if (res && res.body.result) {
            var waitApproveOrderList = res.body.result;
            var specificWaitApproveOrderList = waitApproveOrderList.filter(function (order) {
              return order.orderNo === _this.orderNo;
            });
            if (specificWaitApproveOrderList.length === 0) {
              _this.$weui.loading().hide();
              _this.orderDetail = {};
              return _this.$weui.toast('此订单已完成审批');
            } else {
              _this.gcapi('loadWaitingApprovedOrderDetail', _this.orderDetail.id).then(function (res) {
                _this.$weui.loading().hide();
                if (res && res.body.result) {
                  _this.orderDetail = res.body.result;
                }
              });
            }
          }
        });
      }
    },
    agree: function agree() {
      var _this2 = this;

      var approveParams = {
        orderNo: this.orderNo,
        orderId: this.orderDetail.id,
        isApproved: true
      };
      this.$weui.loading('保存中');
      this.gcapi('approveResearchGroupOrder', approveParams).then(function (res) {
        _this2.$weui.loading().hide();
        if (res && res.body.code === 0) {
          _this2.goBack();
        } else {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('保存失败');
        }
      });
    },
    disagree: function disagree(reason) {
      var _this3 = this;

      console.log('reason', reason);
      if (!reason) return __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请填写原因');
      var approveParams = {
        orderNo: this.orderNo,
        orderId: this.orderDetail.id,
        isApproved: false,
        remark: reason
      };
      this.$weui.loading('保存中');
      this.gcapi('approveResearchGroupOrder', approveParams).then(function (res) {
        _this3.$weui.loading().hide();
        if (res && res.body.code === 0) {
          _this3.goBack();
        } else {
          _this3.$weui.toast('保存失败');
        }
      });
    },
    toggleResearchGroupDisagreeBox: function toggleResearchGroupDisagreeBox() {
      this.showResearchGroupDisagreeBox = !this.showResearchGroupDisagreeBox;
    }
  })
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      researchGroupDictionary: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].researchGroupDictionary,
      researchGroupDetailDisplayOrder: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].researchGroupDetailDisplayOrder,
      researchGroupStatusDictionary: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].researchGroupStatusDictionary,
      researchGroupApproveTypeDictionary: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].researchGroupApproveTypeDictionary
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'isWapp']), {
    researchGroupDetail: function researchGroupDetail() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return undefined;
      var info = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.researchGroupDetailDisplayOrder), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var attr = _step.value;

          // 一级单位非医院，不显示科室信息
          if (this.researchGroupDictionary[attr] === 'secondLevelEnterpriseName') {
            if (!this.displayChosenResearchGroup.firstLevelEnterpriseName.includes('医院')) continue;
          }
          if (this.researchGroupDictionary[attr]) {
            // 课题组状态转换为文字
            if (this.researchGroupDictionary[attr] === 'status') {
              info.push({ name: attr, value: this.researchGroupStatusDictionary[this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]] });
            } else if (this.researchGroupDictionary[attr] === 'approveType') {
              info.push({ name: attr, value: this.researchGroupApproveTypeDictionary[this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]] });
            } else if (this.researchGroupDictionary[attr] === 'vipLevel') {
              // info.push({name: attr, value: 'VIP ' + this.displayChosenResearchGroup[this.researchGroupDictionary[attr]]})
            } else {
              info.push({ name: attr, value: this.displayChosenResearchGroup[this.researchGroupDictionary[attr]] });
            }
          }
          // 审批原则为限额审批时，需显示审批限额
          if (this.researchGroupDictionary[attr] === 'approveType' && this.displayChosenResearchGroup.approveType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD) {
            info.push({ name: '审批限额', value: '¥' + this.splitMoney(this.displayChosenResearchGroup.approveThreshold) });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return info;
    }
  }),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolProgress__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ToolProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContractProgress',
  components: {
    ToolProgress: __WEBPACK_IMPORTED_MODULE_1__ToolProgress___default.a
  },
  data: function data() {
    return {
      type: 'Service',
      subType: false,
      item: null,
      progressInfo: {},
      sfQuoteNo: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([
  // 'progressInfo'
  'isWapp'])),
  // activated () {
  //   this.progressInfo = EMKT.getLocalStorage('progressInfo')
  // },
  mounted: function mounted() {
    var _this = this;

    var item = JSON.parse(this.$route.query.item);
    this.sfQuoteNo = this.$route.query.sfQuoteNo;
    this.item = item;
    console.log('item：', item);
    var progressParam = { id: item.contractNo, type: 1, contractType: item.productType, contractSubType: item.contractType
      // let progressParam = {}
      // if (item.productType === '产品类') {
      //   progressParam = {id: 'GOSL0158678', type: 1, contractType: '产品类', contractSubType: '非大综合'}
      // } else if (item.productType === '服务类') {
      //   if (item.contractType !== '非大综合') {
      //     progressParam = {id: 'GSZE0219508', type: 1, contractType: '服务类', contractSubType: '非大综合'}
      //   } else {
      //     progressParam = {id: 'GSGC0157106', type: 1, contractType: '服务类', contractSubType: '大综合'}
      //   }
      // }
      // progressParam = {id: 'GOSL0158678', type: 1, contractType: '产品类', contractSubType: '非大综合'}
      // progressParam = {id: 'GSZE0219508', type: 1, contractType: '服务类', contractSubType: '非大综合'}
      // progressParam = {id: 'GSGC0157106', type: 1, contractType: '服务类', contractSubType: '大综合'}
    };console.log('progressParam：', progressParam);
    this.gcapi('getContractProgressInfoByContractNo', progressParam).then(function (res) {
      console.log('进展信息：', res.data.result);
      var result = res.data.result;
      var type = 'Tool';
      var subType = false;
      if (item.productType === '服务类') {
        type = 'Service';
        if (item.contractType === '大综合') {
          subType = true;
        } else {
          subType = false;
        }
      } else {
        type = 'Tool';
      }
      _this.type = type;
      _this.subType = subType;
      _this.progressInfo = result;
      console.log('type：', _this.type);
      console.log('subType：', _this.subType);
      __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setLocalStorage('progressInfo', result);
      // this.UPDATE_PROGRESSINFO(result)
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'OrderDetailInfo', query: { status: 2, routeType: 1 } });
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExpressInfo',
  data: function data() {
    return {
      expressInfo: this.$route.query.expressOutList[0],
      order: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp
    };
  },
  mounted: function mounted() {
    this.order = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('ResearchGroupOrder');
  },

  methods: {
    goBack: function goBack() {
      var item = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('chosenItem');
      // if (this.type === 'Tool' || (this.type === 'Service' && !this.subType)) {
      this.$router.push({ name: 'Progress', query: { item: item } });
      // } else {
      //
      // }

      // this.$router.go(-1)
    },
    copy: function copy() {
      console.log(111);
      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast('复制成功');
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast('该浏览器不支持自动复制');
        clipboard.destroy();
      });
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__finder_FinderBox_FinderAttrEnumBox_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__finder_FinderBox_FinderAttrEnumBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__finder_FinderBox_FinderAttrEnumBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finder_FinderBox_FinderAttrNumberBox_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finder_FinderBox_FinderAttrNumberBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__finder_FinderBox_FinderAttrNumberBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__finder_FinderBox_FinderAttrTextAreaBox_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__finder_FinderBox_FinderAttrTextAreaBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__finder_FinderBox_FinderAttrTextAreaBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__finder_FinderBox_FinderAttrTextBox_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__finder_FinderBox_FinderAttrTextBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__finder_FinderBox_FinderAttrTextBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__finder_FinderBox_FinderAttrGeneBox_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__finder_FinderBox_FinderAttrGeneBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__finder_FinderBox_FinderAttrGeneBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__finder_FinderBox_FinderAttrTVBox_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__finder_FinderBox_FinderAttrTVBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__finder_FinderBox_FinderAttrTVBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// webmobile/src/views/finder/FinderBox/FinderAttrNumberBox.vue










/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: [],
  components: {
    'finder-attr-enum-box': __WEBPACK_IMPORTED_MODULE_4__finder_FinderBox_FinderAttrEnumBox_vue___default.a,
    'finder-attr-text-box': __WEBPACK_IMPORTED_MODULE_7__finder_FinderBox_FinderAttrTextBox_vue___default.a,
    'finder-attr-number-box': __WEBPACK_IMPORTED_MODULE_5__finder_FinderBox_FinderAttrNumberBox_vue___default.a,
    'finder-attr-text-area-box': __WEBPACK_IMPORTED_MODULE_6__finder_FinderBox_FinderAttrTextAreaBox_vue___default.a,
    'finder-attr-gene-box': __WEBPACK_IMPORTED_MODULE_8__finder_FinderBox_FinderAttrGeneBox_vue___default.a,
    'finder-attr-tv-box': __WEBPACK_IMPORTED_MODULE_9__finder_FinderBox_FinderAttrTVBox_vue___default.a
  },
  data: function data() {
    return {
      attrGroups: [],
      curAttrsInGroup: [],
      promotions: [],
      merchandises: [],
      baseurl: '/emktResources/resocurces/img/merchandise/',
      manualurl: '/emktResources/resocurces/manual/',
      merchandiseurl: '/emktResources/resocurces/merchandiseInfo',
      attrurl: '../../../static/filters/',
      attr: '?go=true',
      questionUrl: '../../../static/img/',
      Comments: [],
      QuoteStatus: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('QuoteStatus'),
      qualityCommitment: '',
      introduces: '',
      tlnoimgurl: '',
      discountedPrice: 0,
      numRequiredForSecPromotion: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktSecPromotion') && __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktSecPromotion').requiredQuantity,
      from: this.$route.query.from,
      orderStatus: this.$route.query.status,
      routeType: this.$route.query.routeType,
      secPromotionDetail: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp,
      Tvnopath: '/emktResources/resocurces/img/promotion/SKUIMG/'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    //      'merchandises': function (merch) {
    //        for (var i in this.merchandises._attributesList) {
    //          if (this.merchandises._attributesList[i].sectionId === 4 || this.merchandises._attributesList[i].sectionId === 2) {
    //            if (this.merchandises._attributesList[i].value === '' || this.merchandises._attributesList[i].value === -1) {
    //              return
    //            }
    //          }
    //        }
    //      }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['cartList', 'leaveMessageStatus', 'sessionInfo', 'curMessageSession', 'secPromotionDetailObj']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['hasLogin', 'curMessageSession', 'secFlag'
  // ...
  ]), {
    getTotalGoodsNum: function getTotalGoodsNum() {
      var self = this;
      var sum = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).forEach(function (item) {
        sum += self.cartList.cartContent[item].productQuantity;
      });
      return sum;
    },
    secPromotionRatio: function secPromotionRatio() {
      var ratio = String(100 - this.secPromotionDetail.seckilltRatio * 100);
      ratio = ratio[1] === '0' ? ratio[0] : ratio;
      return ratio;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE', 'FINDER_SEARCH_TEXT']), {
    getSecPromotionDetail: function getSecPromotionDetail() {
      if (!this.merchandises.promotions) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.merchandises.promotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var promotion = _step.value;

          if (promotion.type !== 6) continue;
          this.secPromotionDetail = this.secPromotionDetailObj[promotion.promotionGuid];
          this.numRequiredForSecPromotion = this.secPromotionDetail && this.secPromotionDetail.requiredQuantity;
          break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    tokefuMessage: function tokefuMessage() {
      var _this2 = this;

      if (this.hasLogin) {
        var merch = {};
        this.gcapi('retrieveMyLeaveMessages').then(function (response) {
          var data = response.body.result.merchantMessages;
          for (var i in data) {
            if (data[i].merchantNo === '101') {
              merch.messages = data[i].messages;
              merch.merchantName = data[i].merchantName;
              merch.merchantNo = data[i].merchantNo;
              _this2.$router.push({ name: 'myMessage', query: { Messages: merch } });
            }
          }
        });
      } else {
        alert('请您先去登录！');
      }
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    addCartList: function addCartList() {
      var _this = this;
      if (_this.merchandises.selfOperated === 0 && _this.sessionInfo.customerInfo.ssoFlag === 1) {
        __WEBPACK_IMPORTED_MODULE_12_jquery___default.a.toast('第三方商品不支持此操作！');
        return;
      }
      if (_this.merchandises.categoryId === 20) {
        for (var i in _this.merchandises._attributesList) {
          if (_this.merchandises._attributesList[i].groupId === 2 || _this.merchandises._attributesList[i].groupId === 3) {
            if (_this.merchandises._attributesList[i].value === '' || _this.merchandises._attributesList[i].valueText === '' && _this.merchandises._attributesList[i].value !== -1) {
              alert('请将' + _this.merchandises._attributesList[i].label + '信息填写完整！');
              return;
            }
          }
        }
        //          $.modal({
        //            title: '确认订单',
        //            afterText: '<div>为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此中情况为您进行免费售后服务</div>',
        //            buttons: [
        //              {
        //                text: '在线联系',
        //                bold: true,
        //                onClick: function () {
        //                  alert('如有问题，请致电02151320189-8012')
        //                }
        //              },
        //              {
        //                text: '确定',
        //                bold: true,
        //                onClick: function () {
        //                }
        //              }
        //            ]
        //          })
        _this.$router.replace({ name: 'FinderOrderDeail', params: { merchandises: _this.merchandises } });
      } else {
        var pl = _this.plan;
        var pr = _this.merchandises;
        if (_this.merchandises.salesLimit !== -1) {
          if (_this.merchandises.totalSales >= _this.merchandises.salesLimit) {
            __WEBPACK_IMPORTED_MODULE_12_jquery___default.a.confirm('此商品已经售罄！');
          } else {
            console.log(pl, pr);
            _this.ADD_CART_LIST(pr);
          }
        } else {
          if (pr.specialAnnouncement) {
            __WEBPACK_IMPORTED_MODULE_12_jquery___default.a.modal({
              title: '请确认',
              afterText: '<div>我司cDNA克隆产品只作为cDNA模板使用，不承诺过表达。且该产品只提供质粒，不提供菌液。如有疑问，请咨询在线客服。</div>',
              buttons: [{
                text: '取消',
                bold: true,
                onClick: function onClick() {
                  console.log('cancel');
                }
              }, {
                text: '确定购买',
                bold: true,
                onClick: function onClick() {
                  _this.ADD_CART_LIST(pr);
                }
              }]
            });
          } else {
            _this.ADD_CART_LIST(pr);
          }
        }
      }
    },
    checkTlNoImg: function checkTlNoImg() {
      //        $('#home_keleyi_com').attr('href','http://keleyi.com');
    },
    merchandiseHandler: function merchandiseHandler() {
      var md = this.merchandises;
      var bMerchandise = {};
      var attribute = [];
      // md._customizableAttributes['GeneInfo'] = md._attributesList[md._attributesList.length - 1]
      var attr = md._attributes;
      var categoryId = void 0;
      for (var akey in attr) {
        if (akey === 'GeneInfo') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
          this.geneObject = attr[akey].value;
          if (this.geneObject !== null) {
            var taxId = {};
            taxId.columnName = 'GeneInfo.taxId';
            taxId.value = this.geneObject.taxId;
            taxId.valueText = this.geneObject.taxId;
            var symbol = {};
            symbol.columnName = 'GeneInfo.symbol';
            symbol.value = this.geneObject.symbol;
            symbol.valueText = this.geneObject.symbol;
            this.merchandises._abstractList.push(taxId);
            this.merchandises._abstractList.push(symbol);
          }
        } else if (akey === 'AAVBloodType]') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
        } else {
          var obj = {};
          obj['key'] = akey;
          var val = attr[akey].value;
          if (val === '') {
            obj['value'] = -1;
          } else if (val) {
            if (val.value !== undefined) {
              obj['value'] = val.value;
            } else {
              obj['value'] = val;
            }
          } else if (val === 0) {
            obj['value'] = val;
          }
          if (obj['key'] === 'TVInfo') {
            obj['value'] = obj['value'].TLNo;
          }
          //            if (obj['key'] === 'InducingTest' || obj['key'] === 'ExpressionTest' === 0) {
          //              obj['value'] = 0
          //            }
          //            if (obj['key'] === 'ProductGuid') {
          //              bMerchandise.productGuid = obj['value']
          //            }
          attribute.push(obj);
        }
      }
      var cate = {};
      cate['key'] = 'GeneInfo.category';
      cate['value'] = categoryId;
      attribute.push(cate);
      bMerchandise.unitPrice = md.priceMax;
      bMerchandise.initPrice = bMerchandise.unitPrice;
      bMerchandise.merchandiseGuid = md.merchandiseId;
      bMerchandise.amplification = md.amplification;
      bMerchandise.attributes = attribute;
      bMerchandise.MerchantNo = '101';
      //        bMerchandise.productGuid = attribute['ProductGuid'].value
      //        bMerchandise.geneObject = geneObject
      return bMerchandise;
    },
    gotolast: function gotolast() {
      if (this.from === 'OrderDetailInfo') {
        // this.$router.push({name: 'OrderDetailInfo', query: {status: this.status}})
        this.$router.push({ name: 'OrderDetailInfo', query: { status: this.orderStatus, routeType: this.routeType } });
      } else {
        if (this.$route.params.order) {
          this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
        } else {
          this.$router.go(-1);
        }
        //        this.$router.push({name: 'finder'})
      }
    },
    controlForm: function controlForm(index, attribute) {
      var _this3 = this;

      if (attribute.value === '' || attribute.value === undefined) {
        return;
      }
      if (attribute.columnName === 'VirusTiter' && this.merchandises._attributes.LVAmount.value === '') {
        alert('此类合同需要先选择目的病毒总量');
        this.merchandises._attributes.VirusTiter.value = '';
        this.merchandises._attributes.VirusTiter.valueText = '';
        return;
      }
      if ((this.merchandises._attributes.ProductGuid.value === 'C20B666F-8896-4AA7-BF1E-5233ED7EECC9' || this.merchandises._attributes.ProductGuid.value === '5640779C-68F8-47DE-92FF-944ED087C951' || this.merchandises._attributes.ProductGuid.value === 'B80D3CEF-618B-49C1-9A13-852A3F0DA146' || this.merchandises._attributes.ProductGuid.value === '3AAA49FE-3576-4589-A382-84AC8286CA63') && attribute.columnName === 'LVAmount') {
        if (attribute.value === '26') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
        }
        if (attribute.value === '25') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
          this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL';
        }
        if (attribute.value === '27') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL';
        }
      } else if (this.merchandises._attributes.ProductGuid.value === '195FC008-F234-4D06-8B61-650EA583D506' && attribute.columnName === 'LVAmount') {
        if (attribute.value === '27' || attribute.value === '26' || attribute.value === '25') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
        }
      }
      console.log(this.merchandises);
      for (var i in this.merchandises._attributesList) {
        if (this.merchandises._attributesList[i].groupId === 2 || this.merchandises._attributesList[i].groupId === 3) {
          if (this.merchandises._attributes.ReguTech && this.merchandises._attributes.ReguTech.value === 5 && this.merchandises._attributesList[i].columnName === 'GeneInfo') {
            this.merchandises._attributesList[i].value = -1;
          }
          if (this.merchandises._attributesList[i].value === '') {
            return;
          }
        }
      }
      var param = {};
      for (var j in this.merchandises._attributesList) {
        if (this.merchandises._attributesList[j].value !== '') {
          var value = '';
          var key = this.merchandises._attributesList[j].columnName;
          if (key === 'TVInfo') {
            value = this.merchandises._attributesList[j].value.TLNo;
          } else if (key === 'GeneInfo') {
            value = this.merchandises._attributesList[j].value.geneGUID;
          } else {
            value = this.merchandises._attributesList[j].value;
          }
          param[this.merchandises._attributesList[j].columnName] = value;
        }
      }
      var _this = this;
      if (this.merchandises.amplification === 1) {
        var bMerchandise = this.merchandiseHandler();
        _this.gcapi('productDetect', bMerchandise).then(function (res) {
          var body = res.body;
          if (body.code === 0) {
            _this.merchandises.productName = body.result.productName;
            _this.merchandises.workdays = body.result.workdays;
            _this.merchandises.expressPrice = body.result.expressPrice;
            _this.merchandises.amplification = body.result.amplification;
            if (_this.merchandises.amplification === 1) {
              _this.merchandises.priceMin = body.result.priceMax;
            } else {
              _this.merchandises.priceMin = body.result.priceMin;
            }
            _this.merchandises.priceMax = body.result.priceMax;
          } else {
            alert(body.result);
          }
        });
      } else {
        param['muGuid'] = _this.merchandises.merchandiseId;
        console.log('param', param);
        this.gcapi('calculatePrice', param).then(function (response) {
          console.log(response);
          _this3.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount);
          _this3.merchandises.cycle = response.body.result.workDays;
          //            this.merchandises.workDays = response.body.result.workDays
          _this3.merchandises.priceMin = response.body.result.priceMin;
        });
      }
    },
    getEditor: function getEditor(attribute) {
      //        if (attribute.customizable === 1) {
      //          if (attribute.columnName === 'PreContract') {
      //            return 'attr-contract-box'
      //          } else if (attribute.columnName === 'CloneNrSelect') {
      //            return 'attr-target-box'
      //          } else if (attribute.columnName === 'TemsPreContract') {
      //            return 'attr-temcontract-box'
      //          } else {
      //            if (attribute.sdType === Emkt.SDTGene) {
      //              return 'attr-gene-box'
      //            } else if (attribute.sdType === Emkt.SDTToolVector) {
      //              return 'attr-tv-box'
      //            } else if (attribute.sdType === Emkt.SDTEnumeration) {
      //              return 'finder-attr-enum-box'
      //            } else if (attribute.sdType === Emkt.SDTInteger) {
      //              return 'finder-attr-number-box'
      //            } else if (attribute.sdType === Emkt.SDTDecimal) {
      //              return 'finder-attr-number-box'
      //            } else {
      //              return 'finder-attr-text-area-box'
      //            }
      //          }
      //        }
      if (attribute.sdType !== undefined) {
        if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTGene) {
          return 'finder-attr-gene-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTEnumeration) {
          return 'finder-attr-enum-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTInteger) {
          return 'finder-attr-number-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTToolVector) {
          return 'finder-attr-tv-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTDecimal) {
          return 'finder-attr-number-box';
        } else {
          return 'finder-attr-text-box';
        }
      }
    },
    fetchData: function fetchData() {
      var _this4 = this;

      var _this = this;
      if (_this.$route.params.merchandises) {
        _this.merchandises = _this.$route.params.merchandises;
        if (_this.merchandises.amplification === 1) {
          var bMerchandise = this.merchandiseHandler();
          _this.gcapi('productDetect', bMerchandise).then(function (res) {
            var body = res.body;
            if (body.code === 0) {
              _this.merchandises.productName = body.result.productName;
              _this.merchandises.workdays = body.result.workdays;
              _this.merchandises.expressPrice = body.result.expressPrice;
              _this.merchandises.priceMin = body.result.priceMax;
              _this.merchandises.priceMax = body.result.priceMax;
            } else {
              alert(body.result);
            }
          });
        }
        if (_this.merchandises.H5FileName) {
          _this.$http.get(this.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, { emulateHTTP: true }).then(function (response) {
            _this.introduces = response.bodyText;
          });
        }
        if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
          _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg';
        }
        if (_this.merchandises.categoryId === 20) {
          _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, { emulateHTTP: true }).then(function (response) {
            _this.qualityCommitment = response.bodyText;
          });
        } else {
          if (_this.merchandises.QualityPromisesH5FileName) {
            var dictionariesMap = __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktMetaData').dictionariesMap;
            var name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue;
            _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + name, { emulateHTTP: true }).then(function (response) {
              _this.qualityCommitment = response.bodyText;
            });
          }
        }
        if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
          _this.merchandises._attributes.GeneInfo.displayable = 0;
          _this.merchandises._attributes.GeneInfo.value = -1;
        }
      } else {
        var method = '';
        if (_this.$route.query.categoryId === 20 || _this.$route.query.categoryId === '20') {
          if (_this.$route.query.cid === 20 || _this.$route.query.cid === '20') {
            method = 'getMerchandiseDetails';
          } else {
            method = 'findMerchandiseDetails';
          }
        } else {
          method = 'getMerchandiseDetails';
        }
        this.gcapi(method, _this.$route.query.id).then(function (response) {
          _this.merchandises = response.body.result;
          if (_this.$route.query.categoryId === 20) {
            if (!(_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5)) {
              _this.merchandises.priceMin = 0;
              _this.merchandises.priceMax = 0;
            }
          }
          _this.merchandises._titleList.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          });
          if (_this.merchandises.geneWord !== '') {
            _this4.FINDER_SEARCH_TEXT(_this.merchandises.geneWord);
          }
          //            _this.merchandises._attributesList.forEach(function (item) {
          //              if (item.groupId === 3 && item.displayable !== 0 && item.value !== 214 && item.value !== '214' && item.value !== -1 && item.value !== '-1') {
          //                item.value = ''
          //                item.valueText = ''
          //              }
          //            })
          if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
            _this.merchandises._attributes.GeneInfo.displayable = 0;
            _this.merchandises._attributes.GeneInfo.value = -1;
            var param = {};
            for (var j in _this.merchandises._attributesList) {
              //                if (_this.merchandises.categoryId === 20 && _this.merchandises._attributesList[j].groupId === 3) {
              //                  _this.merchandises._attributesList[j].value !== ''
              //                }
              if (_this.merchandises._attributesList[j].value !== '') {
                var value = '';
                var key = _this.merchandises._attributesList[j].columnName;
                if (key === 'TVInfo') {
                  value = _this.merchandises._attributesList[j].value.TLNo;
                } else if (key === 'GeneInfo') {
                  value = _this.merchandises._attributesList[j].value.geneGUID;
                } else {
                  value = _this.merchandises._attributesList[j].value;
                }
                param[_this.merchandises._attributesList[j].columnName] = value;
              }
            }
            param['muGuid'] = _this.merchandises.merchandiseId;
            console.log('param', param);
            _this.gcapi('calculatePrice', param).then(function (response) {
              _this.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount);
              _this.merchandises.cycle = response.body.result.workDays;
              _this.merchandises.priceMin = response.body.result.priceMin;
            });
          }
          var showpromotion = [];
          for (var i in _this.merchandises.promotions) {
            if (_this.merchandises.promotions[i].type === 1 || _this.merchandises.promotions[i].type === 6) {
              showpromotion.push(_this.merchandises.promotions[i]);
              //              if (self.cartList[item].promotions[i].type === 3) {
              //                var allCoupons = Emkt.getLocalStorage('allCoupons')
              //                if (allCoupons.length > 0) {
              //                  for (var j in allCoupons) {
              //                    if (allCoupons[j].promotionGuid === self.cartList[item].promotions[i].promotionGuid) {
              //                      showpromotion.push(self.cartList[item].promotions[i])
              //                    }
              //                  }
              //                }
              //              } else {
              //                showpromotion.push(self.cartList[item].promotions[i])
              //              }
            }
          }
          _this.merchandises.showpromotion = showpromotion;
          if (_this.merchandises.H5FileName) {
            _this.$http.get(_this4.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, { emulateHTTP: true }).then(function (response) {
              _this.introduces = response.bodyText;
            });
          }
          if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
            _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg';
          }
          if (_this.merchandises.categoryId === 20) {
            _this.$http.get(_this4.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, { emulateHTTP: true }).then(function (response) {
              _this.qualityCommitment = response.bodyText;
            });
          } else {
            if (_this.merchandises.QualityPromisesH5FileName) {
              var dictionariesMap = __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktMetaData').dictionariesMap;
              var _name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue;
              _this.$http.get(_this4.merchandiseurl + '/static/desc/qualitypromises/' + _name, { emulateHTTP: true }).then(function (response) {
                _this.qualityCommitment = response.bodyText;
              });
            }
          }
          console.log('merchandises', _this.merchandises);
          _this4.getSecPromotionDetail();
        });
      }
      _this.gcapi('getMerchandiseComments', _this.$route.query.id).then(function (response) {
        _this.Comments = response.body.result;
      });
    },
    addcss: function addcss(data) {
      var obj1 = document.getElementById('detail');
      var obj2 = document.getElementById('introduce');
      var obj3 = document.getElementById('qualityCommitment');
      var obj4 = document.getElementById('comments');
      var obj5 = document.getElementById('tlnoImg');
      if (data === 1) {
        obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;background-color: transparent';
        obj2.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 2) {
        obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 3) {
        obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 4) {
        obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 5 && this.merchandises.categoryId === 20) {
        obj5.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
      }
    },
    toMessage: function toMessage(merchandiseLabel) {
      var _this5 = this;

      var _this = this;
      this.SEND_MESSAGE({ message: '咨询', merchandise: _this.merchandises });
      var merch = {};
      this.gcapi('retrieveMyLeaveMessages').then(function (response) {
        var data = response.body.result.merchantMessages;
        _this5.curMessageSession.leaveMessageStatus = data.leaveMessageStatus;
        _this5.curMessageSession.merchantMessages = data.merchantMessages;
        _this5.curMessageSession.messages = data.messages;
        _this5.curMessageSession.messagesAmount = data.messagesAmount;
        _this5.curMessageSession.unreadMessagesAmount = data.unreadMessagesAmount;
        console.log(_this.merchandises);
        for (var i in data) {
          if (data[i].merchantNo === _this.merchandises.MerchantNo) {
            merch.messages = data[i].messages;
            merch.merchantName = data[i].merchantName;
            merch.merchantNo = data[i].merchantNo;
            console.log(merch);
            _this5.$router.replace({ name: 'myMessage', params: { merchandiseurl: _this5.$route.fullPath, merchandises: _this.merchandises }, query: { Messages: merch } });
          }
        }
      });
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    showSecPromotionInfo: function showSecPromotionInfo() {
      if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
        return false;
      }
      if (this.merchandises.promotions) {
        return this.merchandises.promotions[0] && this.merchandises.promotions[0].type === 6 && this.secFlag !== 2;
      } else {
        return this.merchandises.bpromotions && this.merchandises.bpromotions[0] && this.merchandises.bpromotions[0].type === 6 && this.secFlag !== 2;
      }
    },
    gotomanual: function gotomanual(manualFileName) {
      var url = this.manualurl + manualFileName;
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_11_wx___default.a.miniProgram.navigateTo({
          url: '/pages/pdf/pdfPage?comeFrom=merchandise&pdfName=' + manualFileName + '&pdfType=1'
        });
      } else {
        window.open(url);
      }
    }
  })

});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupDisagreeBox__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupDisagreeBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupDisagreeBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderDetailInfo',
  data: function data() {
    return {
      status: 2,
      memberInfo: {},
      order: {},
      showResearchGroupDisagreeBox: false,
      monthlyTotalApprovedAmount: 0,
      orderList: {},
      baseurl: '/emktResources/resocurces/img/merchandise/',
      serviceUrl: '/emktResources/resocurces/img/merchandise/service.png',
      orderNo: this.$route.query.orderNo || __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getFullUrlParam('orderNo'),
      researchGroupNo: this.$route.query.researchGroupNo || __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getFullUrlParam('researchGroupNo'),
      routeType: this.$route.query.routeType - 0,
      isWapp: __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp,
      isService: null
    };
  },
  created: function created() {
    if (this.chosenOrder.itemList[0].serviceItemDetail) {
      this.isService = true;
    } else {
      this.isService = false;
    }
  },

  watch: {
    'researchGroupDetailList': {
      handler: 'setResearchGroupByGroupNo',
      immediate: true
    }
  },
  components: {
    ResearchGroupDisagreeBox: __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupDisagreeBox___default.a, FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder___default.a
  },
  mounted: function mounted() {
    if (this.routeType === 1) {
      this.fetchWaitApproveOrderDetail();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'chosenOrder', 'totalApproveAmount', 'chosenMember', 'hasLogin', 'researchGroupCharacter', 'researchGroupDetailList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['researchGroupMemberMap', 'chosenMember']), {
    // 计算属性的 getter
    boxHeight: function boxHeight() {
      if (this.status === 1) {
        return '90vh';
      } else {
        return '97vh';
      }
    },
    itemListLength: function itemListLength() {
      var num = 0;
      if (this.order.itemList) {
        for (var i = 0; i < this.order.itemList.length; i++) {
          var item = this.order.itemList[i];
          if (item.productType === '服务类') {
            if (item.contractNoSrc === '') {
              num++;
            }
          } else {
            num++;
          }
        }
      }
      return num;
    },

    // 混合服务类合同名称位置
    namePos: function namePos() {
      if (this.orderType !== 2) {
        return '-20vw';
      } else {
        return '-6.73vw';
      }
    },
    // 订单地址位置
    orderAddress: function orderAddress() {
      if (this.status === 1) {
        return '20vw';
      } else {
        return '2.67vw';
      }
    },
    // 商品总额
    discountPrice: function discountPrice() {
      if (this.order) {
        var discountPrice = (this.order.discountPrice + '').replace('-', '') - 0;
        return discountPrice;
      } else {
        return 0;
      }
    },
    memberList: function memberList() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return;
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return;
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      return this.researchGroupMemberMap[researchGroupNo];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_ORDER_MAP', 'UPDATE_CHOSEN_ORDER', 'UPDATE_CHOSEN_MEMBER', 'UPDATE_TOTAL_APPROVE_AMOUNT', 'UPDATE_CHOSEN_RESEARCH_INDEX']), {
    setResearchGroupByGroupNo: function setResearchGroupByGroupNo() {
      console.log('researchGroupDetailList', this.researchGroupDetailList);
      if (!this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请登录');
        this.$router.push({ name: 'login' });
      }
      if (!this.researchGroupNo) return;
      var researchGroupIndex = 0;
      for (var i = 0; i < this.researchGroupDetailList.length; i++) {
        if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
          researchGroupIndex = i;
          continue;
        }
      }
      this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex);
      if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
        this.fetchWaitApproveOrderDetail();
      }
    },

    fetchWaitApproveOrderDetail: function fetchWaitApproveOrderDetail() {
      var _this = this;

      if (this.routeType === 1) {
        // 订单列表跳转
        this.order = this.chosenOrder;
        this.orderList = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getLocalStorage('ResearchGroupOrderList');
        this.status = this.$route.query.status - 0;
        this.memberInfo = this.chosenMember;
        this.monthlyTotalApprovedAmount = this.totalApproveAmount;
      } else {
        if (this.researchGroupNo && this.orderNo) {
          this.$weui.loading('查询中');
          // 获取订单详情
          this.gcapi('getWaitApprovedOrderInfoByOrderNo', this.order.id).then(function (res) {
            if (res.data.code === 0) {
              _this.order = res.data.result;
              _this.UPDATE_CHOSEN_ORDER(res.data.result);
              console.log('审批提醒查到的订单信息', res.data);
              __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setLocalStorage('ResearchGroupOrder', _this.order);
              if (_this.order.status === 13) {
                _this.status = 1;
                var memberInfo = {};
                for (var i = 0; i < _this.memberList.length; i++) {
                  if (res.data.result.orderPerson === _this.memberList[i].memberName) {
                    memberInfo = _this.memberList[i];
                    break;
                  }
                }
                _this.memberInfo = memberInfo;
                _this.UPDATE_CHOSEN_MEMBER(memberInfo);
                console.log('下单成员信息', memberInfo);
                _this.gcapi('getMonthlyTotalApprovedAmount', _this.order.id).then(function (res) {
                  console.log('月度累计限额：', res.data);
                  if (res.data.code === 0) {
                    _this.monthlyTotalApprovedAmount = res.data.result;
                    _this.UPDATE_TOTAL_APPROVE_AMOUNT(_this.monthlyTotalApprovedAmount);
                  } else {
                    console.log('获取月度累计限额失败');
                  }
                });
                _this.$weui.loading().hide();
              } else {
                _this.status = 2;
                _this.$weui.loading().hide();
                return _this.$weui.toast('此订单已完成审批');
              }
            } else {
              _this.$weui.loading().hide();
              console.log('获取课题组订单信息失败');
            }
          });
        }

        // 微信审批提醒跳转
        var queryParam = {};
        queryParam.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
        this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(function (res) {
          console.log('课题组订单信息：', res.data.result);
          if (res.data.code === 0) {
            _this.orderList = res.data.result;
            __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setLocalStorage('ResearchGroupOrderList', _this.orderList);
          } else {
            console.log('获取课题组订单列表信息失败');
          }
        });
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'ResearchGroupOrder', query: { index: this.tabIndex } });
    },
    toProgress: function toProgress(item) {
      __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].setLocalStorage('chosenItem', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      this.$router.push({ name: 'Progress', query: { item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item) } });
    },
    toProductInfo: function toProductInfo(orderId, euId) {
      var _this2 = this;

      if (this.isService) {
        if (orderId && euId) {
          this.$router.push({
            name: 'boSolutionDetail',
            params: { orderId: orderId, euId: euId }
          });
        } else {
          alert('产品数据错误，请刷新页面后重试！');
        }
      } else {
        if (orderId) {
          this.gcapi('assambleOrders', orderId).then(function (res) {
            console.log('产品详情', res.data);
            _this2.$router.push({ name: 'FinderMerchandiseDetailForGR', params: { merchandises: res.body.result.merchandises[0] }, query: { orderStatus: _this2.status, routeType: _this2.routeType } });
          });
        }
      }
    },
    toggleResearchGroupDisagreeBox: function toggleResearchGroupDisagreeBox() {
      this.showResearchGroupDisagreeBox = !this.showResearchGroupDisagreeBox;
    },
    agree: function agree() {
      var _this3 = this;

      console.log('order->', this.order);
      var approveParams = {
        orderNo: this.order.orderNo,
        orderId: this.order.id,
        isApproved: true
      };
      this.$weui.loading('保存中');
      this.gcapi('approveResearchGroupOrder', approveParams).then(function (res) {
        _this3.$weui.loading().hide();
        if (res && res.body.code === 0) {
          _this3.removeOrder(_this3.order.orderNo);
          _this3.goBack();
        } else {
          _this3.$weui.toast('保存失败');
        }
      });
    },
    disagree: function disagree(reason) {
      var _this4 = this;

      console.log('reason', reason);
      if (!reason) return this.$weui.toast('请填写原因');
      var approveParams = {
        orderNo: this.order.orderNo,
        orderId: this.order.id,
        isApproved: false,
        remark: reason
      };
      this.$weui.loading('保存中');
      this.gcapi('approveResearchGroupOrder', approveParams).then(function (res) {
        _this4.$weui.loading().hide();
        if (res && res.body.code === 0) {
          _this4.removeOrder(_this4.orderNo);
          _this4.goBack();
        } else {
          _this4.$weui.toast('保存失败');
        }
      });
    },
    removeOrder: function removeOrder(orderNo) {
      console.log('开始去除订单。。');
      for (var i = 0; i < this.orderList.waitApprovedOrderList.length; i++) {
        var worder = this.orderList.waitApprovedOrderList;
        if (worder[i].orderNo === orderNo) {
          this.orderList.waitApprovedOrderList.splice(i, 1);
        }
      }
      console.log('审批后订单', this.orderList);
    },
    copy: function copy() {
      var clipboard = new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('复制成功');
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('该浏览器不支持自动复制');
        clipboard.destroy();
      });
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    goMessage: function goMessage() {
      __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].openCustomerService();
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    },
    stringSet: function stringSet(str) {
      if (str) {
        var temp = str.replace(/&nbsp;/gi, ' ');
        return temp;
      } else {
        return '';
      }
    },
    showProductDetailBtn: function showProductDetailBtn(item) {
      if (!item) return false;
      return item.fromEmkt;
    }
  })
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderInfoList',
  props: {
    orderStatus: Number,
    orderListOrigin: Object,
    chooseMemberName: String,
    chooseStatus: Number
  },
  data: function data() {
    return {
      monthlyTotalApprovedAmount: 0,
      orderList: [],
      baseurl: '/emktResources/resocurces/img/merchandise/',
      serviceUrl: '/emktResources/resocurces/img/merchandise/service.png'
    };
  },
  mounted: function mounted() {
    this.orderList = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('ResearchGroupOrderList');
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['researchGroupMemberMap']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter']), {
    memberList: function memberList() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return;
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return;
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      var totalMemberList = this.researchGroupMemberMap[researchGroupNo];
      var doubleList = [[]];
      var num = 0; // 已经循环的成员总数
      for (var i = 0; i <= (totalMemberList.length + 1) / 3; i++) {
        doubleList[i] = [];
        var k = 0; // 每行的成员总数
        for (var j = num; j < totalMemberList.length; j++) {
          if (i === 0 && k < 2 || i !== 0 && k < 3) {
            doubleList[i][k] = totalMemberList[j];
            num++;
            k++;
          } else {
            break;
          }
        }
      }
      console.log('课题组成员二维数组', doubleList);
      // return this.researchGroupMemberMap[researchGroupNo]
      return doubleList;
    },
    memberList1: function memberList1() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return;
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return;
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      return this.researchGroupMemberMap[researchGroupNo];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_ORDER', 'UPDATE_CHOSEN_MEMBER', 'UPDATE_TOTAL_APPROVE_AMOUNT']), {
    toDetailInfo: function toDetailInfo(status, order) {
      var _this = this;

      this.UPDATE_CHOSEN_ORDER(order);
      __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('ResearchGroupOrder', order);
      console.log('订单信息', order);
      var memberInfo = {};
      for (var i = 0; i < this.memberList1.length; i++) {
        if (order.orderPerson === this.memberList1[i].memberName) {
          memberInfo = this.memberList1[i];
          break;
        }
      }
      this.UPDATE_CHOSEN_MEMBER(memberInfo);
      console.log('下单成员信息', memberInfo);
      if (status === 1) {
        this.gcapi('getMonthlyTotalApprovedAmount', order.id).then(function (res) {
          console.log('月度累计限额：', res.data);
          if (res.data.code === 0) {
            _this.monthlyTotalApprovedAmount = res.data.result;
            _this.UPDATE_TOTAL_APPROVE_AMOUNT(_this.monthlyTotalApprovedAmount);
          } else {
            console.log('获取月度累计限额失败');
          }
        });
      }

      this.$router.push({ name: 'OrderDetailInfo', query: { status: status, routeType: 1, orderNo: order.orderNo } });
      // this.$router.push({name: 'OrderDetailInfo', query: {routeType: 2, orderNo: order.orderNo, researchGroupNo: this.displayChosenResearchGroup.researchGroupNo}})
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).split('.')[0].replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    stringSet: function stringSet(str) {
      if (str) {
        var s = str.replace(/&nbsp;/ig, ' ');
        return s;
      } else {
        return '';
      }
    }
  })
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderInfoList__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderInfoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderInfoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResearchGroupOrder',
  components: {
    orderInfoList: __WEBPACK_IMPORTED_MODULE_2__OrderInfoList___default.a
  },
  data: function data() {
    return {
      isDefaultStatus: 1,
      open: false,
      openAll: false,
      tabIndex: 1,
      m_column: -1,
      m_row: 0,
      orderList: {},
      chooseMemberName: '全部成员',
      chooseStatus: 1,
      isWapp: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].isWapp
    };
  },
  mounted: function mounted() {
    this.fetchOrderData();
  },
  activated: function activated() {
    console.log('researchGroupOrder activated');
    this.fetchOrderData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    tabMarginLeft: function tabMarginLeft() {
      return (this.tabIndex - 1) * 22.8 + 6;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['researchGroupMemberMap']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup']), {
    memberList: function memberList() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return [[]];
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return [[]];
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      var totalMemberList = this.researchGroupMemberMap[researchGroupNo];
      var doubleList = [[]];
      var num = 0; // 已经循环的成员总数
      for (var i = 0; i <= (totalMemberList.length + 1) / 3; i++) {
        doubleList[i] = [];
        var k = 0; // 每行的成员总数
        for (var j = num; j < totalMemberList.length; j++) {
          if (i === 0 && k < 2 || i !== 0 && k < 3) {
            doubleList[i][k] = totalMemberList[j];
            num++;
            k++;
          } else {
            break;
          }
        }
      }
      console.log('课题组成员二维数组', doubleList);
      // return this.researchGroupMemberMap[researchGroupNo]
      return doubleList;
    }
  }),
  methods: {
    fetchOrderData: function fetchOrderData() {
      if (this.$route.query.tabIndex) {
        this.tabIndex = this.$route.query.tabIndex - 0;
      } else {
        this.tabIndex = 1;
      }
      this.orderList = __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].getLocalStorage('ResearchGroupOrderList');
      console.log('researchGroupOrderList', this.orderList);
    },
    goBack: function goBack() {
      this.$router.push({ name: 'ResearchGroupHome' });
    },
    changeOpenAll: function changeOpenAll() {
      this.openAll = !this.openAll;
      this.open = this.openAll;
      if (this.openAll) {
        this.isDefaultStatus = 1;
        this.chooseStatus = 1;
      } else {
        if (this.m_row === 0 && this.m_column === -1) {
          // 显示选中全部成员的布局
          this.isDefaultStatus = 1;
          this.chooseStatus = 1;
        } else {
          // 显示选中单个成员的布局
          this.isDefaultStatus = 2;
          this.chooseStatus = 2;
        }
      }
    },
    changeOpen: function changeOpen() {
      this.open = !this.open;
      this.openAll = this.open;
      if (!this.open) {
        if (this.m_row === 0 && this.m_column === -1) {
          // 显示选中全部成员的布局
          this.isDefaultStatus = 1;
          this.chooseStatus = 1;
        } else {
          // 显示选中单个成员的布局
          this.isDefaultStatus = 2;
          this.chooseStatus = 2;
        }
      }
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    chooseMember: function chooseMember(mrow, mcolumn) {
      this.openAll = true;
      this.m_column = mcolumn;
      this.m_row = mrow;
      if (mcolumn !== -1) {
        this.chooseMemberName = this.memberList[this.m_row][this.m_column].memberName;
        this.chooseStatus = 2;
      } else {
        this.chooseStatus = 1;
      }
    },
    toDefineStatus: function toDefineStatus() {
      this.isDefaultStatus = 1;
      this.open = false;
      this.openAll = false;
      this.memberNo = 0;
      this.m_column = -1;
      this.m_row = 0;
      this.chooseMemberName = '全部成员';
      this.chooseStatus = 1;
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskProgress__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TaskProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ServiceTaskProgress',
  data: function data() {
    return {
      isShow: false,
      stage: {},
      project: {},
      type: 'Service',
      subType: true,
      expressOutList: [],
      isWapp: __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].isWapp
    };
  },

  components: {
    TaskProgress: __WEBPACK_IMPORTED_MODULE_0__TaskProgress___default.a
  },
  mounted: function mounted() {
    this.stage = this.$route.query.stage;
    this.project = this.$route.query.project;
    this.expressOutList = JSON.parse(this.$route.query.expressOutList);
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'Progress', query: { item: __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('chosenItem') } });
      // this.$router.go(-1)
    },

    changeShow: function changeShow(status) {
      this.isShow = status;
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TaskProgress',
  props: {
    type: String,
    subType: Boolean,
    taskModules: Array,
    expressOutList: Array
  },
  data: function data() {
    return {
      isShow: false
    };
  },

  computed: {
    taskList: function taskList() {
      if (this.taskModules !== undefined) {
        var tasks = this.taskModules;
        var _this = this;
        tasks.sort(function (a, b) {
          var aTimeString = '';
          var bTimeString = '';
          if (_this.type === 'Service') {
            if (a.taskStatus === '结束' || a.taskStatus === '终止') {
              aTimeString = a.actualEnd;
            } else {
              aTimeString = a.expectedEnd;
            }
            if (b.taskStatus === '结束' || b.taskStatus === '终止') {
              bTimeString = b.actualEnd;
            } else {
              bTimeString = b.expectedEnd;
            }
          } else {
            if (a.statusId === 4 || a.statusId === 5) {
              aTimeString = a.realEndDate;
            } else {
              aTimeString = a.planEndDate;
            }
            if (b.statusId === 4 || b.statusId === 5) {
              bTimeString = b.realEndDate;
            } else {
              bTimeString = b.planEndDate;
            }
          }
          var aTime = new Date(aTimeString).getTime();
          var bTime = new Date(bTimeString).getTime();
          if (_this.type === 'Tool') {
            aTime = new Date(aTimeString.replace('.', '-')).getTime();
            bTime = new Date(bTimeString.replace('.', '-')).getTime();
          }
          return aTime - bTime;
        });
        console.log('taskList', tasks);
        return tasks;
      } else {
        return [];
      }
    },
    expressOutListLength: function expressOutListLength() {
      var len = this.expressOutList ? this.expressOutList.length : 0;
      return len;
    }
  },
  methods: {
    changeShow: function changeShow(status) {
      this.isShow = status;
    },
    toExpress: function toExpress() {
      this.$router.push({ name: 'ExpressInfo', query: { expressOutList: this.expressOutList } });
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskProgress__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TaskProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToolProgress',
  components: {
    TaskProgress: __WEBPACK_IMPORTED_MODULE_0__TaskProgress___default.a
  },
  props: {
    type: String,
    progressInfo: Object,
    item: Object,
    sfQuoteNo: null
  },
  data: function data() {
    return {
      isShow: false,
      baseurl: '/emktResources/resocurces/img/merchandise/'
    };
  },

  computed: {
    showDefaultImage: function showDefaultImage() {
      if (!this.progressInfo || !this.progressInfo.contractInfo) {
        return true;
      } else if (!this.taskModules || this.taskModules === []) {
        return true;
      } else {
        return false;
      }
    },
    gtvInfo: function gtvInfo() {
      if (this.progressInfo.contractInfo.gtvInfo) {
        return this.progressInfo.contractInfo.gtvInfo[0];
      } else {
        return [];
      }
    },
    taskModules: function taskModules() {
      if (this.progressInfo.contractInfo.taskModules) {
        return this.progressInfo.contractInfo.taskModules[0];
      } else {
        return [];
      }
    },
    expressOutList: function expressOutList() {
      if (this.progressInfo.contractInfo.expressOutList) {
        return this.progressInfo.contractInfo.expressOutList;
      } else {
        return [];
      }
    }
  },
  methods: {
    copy: function copy() {
      var _this = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        _this.$weui.toast('复制成功', 1500);
        // $.toast('复制成功')
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this.$weui.topTips('该浏览器不支持自动复制');
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    },
    copysfQuoteNo: function copysfQuoteNo() {
      var _this2 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#tag-copy1');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        _this2.$weui.toast('复制成功', 1500);
        // $.toast('复制成功')
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this2.$weui.topTips('该浏览器不支持自动复制');
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseApproveType1__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseApproveType1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseApproveType1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType2__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ResearchGroupRemindBox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ResearchGroupRemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ResearchGroupRemindBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// eslint-disable-next-line no-unused-vars




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      researchGroupApproveTypeDictionary: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].researchGroupApproveTypeDictionary,
      approveTypeThreshold: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_APPROVETYPE_ALL,
      mobileQuery: '',
      nameQuery: '',
      contactDetail: {},
      showChooseApproveType: false,
      showResearchGroupRemindBox: false,
      approve: {},
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      newContact: this.$route.query.newContact,
      // startChooseBox: true,
      showChooSinglestrokeApproveType: false,
      showChooSinglemouthApproveType: false,
      setSinglestrokeApproveType: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_ALL_APPROVETYPE,
      isWapp: __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].isWapp
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['researchGroupMemberMap', 'sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'customerNo', 'hasLogin', 'researchGroupCharacter'])),
  mounted: function mounted() {
    console.log('newContact', this.newContact);
    if (this.newContact) this.contactDetail = this.$route.query.newContact;
  },

  components: {
    ChooseApproveType1: __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ChooseApproveType1___default.a, ResearchGroupRemindBox: __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ResearchGroupRemindBox___default.a, ChooseApproveType2: __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType2___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },

    // changeapprove () {
    //   this.startChooseBox === false ? this.approve.approveType = this.approveTypeNone : this.approve.approveType = undefined
    //   console.log(this.approveType)
    // },
    toggleShowChooseBox: function toggleShowChooseBox(data) {
      console.log(data);
      switch (data) {
        case 0:
          this.showChooseApproveType = !this.showChooseApproveType;
          break;
        case 2:
          this.showChooSinglemouthApproveType = !this.showChooSinglemouthApproveType;
          break;
        case 1:
          this.showChooSinglestrokeApproveType = !this.showChooSinglestrokeApproveType;
      }
    },
    saveApproveType: function saveApproveType(approve, setApproveType) {
      this.approve.approveType === approve.approveType;
      setApproveType === this.setallApproveType ? this.approve = approve : setApproveType === this.setSinglestrokeApproveType ? this.approve.approveThreshold = approve.approveThreshold : this.approve.monthlyLimit = approve.monthlyLimit;
      console.log('approve', this.approve);
    },
    validatemobile: function validatemobile(mobile) {
      if (mobile.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('手机号码不能为空');
        return false;
      }
      var myreg = /^1[3-9]{1}[0-9]{9}$/;
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请输入有效的手机号码');
        return false;
      }
      return true;
    },
    searchContact: function searchContact() {
      var _this = this;

      console.log('Query', this.mobileQuery, this.nameQuery);
      this.contactDetail = {};
      if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请输入姓名和正确的手机号');
        return;
      }
      // 根据联系人手机号、姓名、一级单位编号搜索联系人个人信息
      if (this.customerNo) {
        var queryParam = {};
        queryParam.customerName = this.nameQuery;
        queryParam.mobile = this.mobileQuery;
        // queryParam.enterpriseNo = EMKT.testEnterpriseNo // 测试用复旦大学附属中山医院.  00000267
        queryParam.enterpriseNo = this.sessionInfo.customerInfo.enterpriseNo;
        this.$weui.loading('查询中');
        this.gcapi('searchContact', queryParam).then(function (response) {
          _this.$weui.loading().hide();
          console.log('rsponse', response);
          if (response && response.body.code === 1) {
            _this.remindParams.firstline = '该联系人未注册';
            _this.remindParams.secondline = '是否注册新联系人？';
            _this.remindParams.singleOrDouble = 2;
            _this.toggleResearchGroupRemindBox();
            return;
            // $.toast('无此联系人，请新建联系人')
            // return this.$router.push({name: 'RegisterContact', query: {defaultIndex: this.defaultIndex}})
          }
          if (response && response.body.result) {
            _this.contactDetail = response.body.result;
          } else {
            _this.remindParams.firstline = '该联系人与您不在同一单位';
            _this.remindParams.secondline = '请联系业务员添加';
            _this.remindParams.singleOrDouble = 1;
            _this.toggleResearchGroupRemindBox();
            // $.alert('未查到同一单位的联系人信息，请联系业务员添加')
          }
        }).catch(function (e) {
          console.log('e', e);
        });
      }
    },
    convertContactToNewMember: function convertContactToNewMember(contact) {
      // debugger
      var newMember = {};
      // 来自data
      newMember.researchGroupName = this.displayChosenResearchGroup.researchGroupName;
      newMember.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      newMember.approveType = this.approve.approveType;
      if (this.approve.approveType === __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD) {
        newMember.approveThreshold = this.approve.approveThreshold === '' ? null : this.approve.approveThreshold;
        newMember.monthlyLimit = this.approve.monthlyLimit === '' ? null : this.approve.monthlyLimit;
      } else {
        newMember.approveThreshold = null;
        newMember.monthlyLimit = null;
      }
      // 来自联系人信息
      newMember.memberGuid = contact.customerGuid; // 成员GUID
      newMember.memberNo = contact.customerNo; // 成员编号（客户编号）
      newMember.memberName = contact.customerName;
      newMember.email = contact.email;
      newMember.mobile = contact.mobile;
      newMember.firstLevelEnterpriseNo = contact.enterpriseNo;
      newMember.firstLevelEnterpriseName = contact.enterpriseName;
      newMember.secondLevelEnterpriseNo = contact.secondLevelEnterpriseNo;
      newMember.secondLevelEnterpriseName = contact.secondLevelEnterpriseName;
      // 创建时间、创建人
      newMember.createDT = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();
      newMember.creator = this.sessionInfo.customerInfo.customerNo + '/' + this.sessionInfo.customerInfo.customerName; // 创建人 员工编号/姓名
      newMember.startDT = newMember.createDT;
      newMember.enable = true;
      return newMember;
    },
    addMember: function addMember() {
      console.log(this.hasLogin);
      if (!this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请先去登录');
        this.$router.push({ name: 'login' });
        return;
      }
      if (this.newMemberAlreadyExist(this.contactDetail)) {
        this.remindParams.firstline = '此人已加入课题组';
        this.remindParams.secondline = '无需添加';
        this.remindParams.singleOrDouble = 1;
        this.toggleResearchGroupRemindBox();
        // $.alert('此人已加入课题组，无需添加')
        return;
      }
      if (this.approve.approveType === undefined) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请设置审批原则');
        return false;
      }
      var newMember = this.convertContactToNewMember(this.contactDetail);
      console.log('newMember', newMember);
      var self = this;
      this.$weui.loading('保存中');
      setTimeout(function () {
        self.gcapi('saveOrUpdateResearchGroupMember', newMember).then(function (res) {
          self.$weui.loading().hide();
          if (res && res.body.result) {
            var newMemberMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, self.researchGroupMemberMap);
            newMemberMap[newMember.researchGroupNo].push(res.body.result);
            self.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap);
            self.$weui.toast('添加成功');
            self.$router.replace({ name: 'ResearchMemberManagement' });
          } else {
            self.$weui.toast('添加失败，请重试');
          }
        });
      }, 3000);
    },
    newMemberAlreadyExist: function newMemberAlreadyExist(contact) {
      var members = this.researchGroupMemberMap[this.displayChosenResearchGroup.researchGroupNo];
      if (!members) {
        return false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(members), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var member = _step.value;

          if (member.memberNo === contact.customerNo) {
            // 需改为验证新添加成员的编号是否已经存在
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    toggleResearchGroupRemindBox: function toggleResearchGroupRemindBox() {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox;
    },
    registerContact: function registerContact() {
      this.$router.push({ name: 'RegisterContact', query: { name: this.nameQuery, mobile: this.mobileQuery } });
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).focus();
    }
  })
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupRemindBox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupRemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupRemindBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_FirstLevelEnterpriseBox__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_FirstLevelEnterpriseBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_FirstLevelEnterpriseBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_DepartmentBox__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_DepartmentBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_DepartmentBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      registerMobile: this.$route.query.mobile,
      registerName: this.$route.query.name,
      registerEmail: '',
      showFirstLevelEnterpriseBox: false,
      showDepartmentBox: false,
      showResearchGroupRemindBox: false,
      remindParams: {
        register: true
      },
      agreeStatus: true,
      enterprise: {},
      department: {},
      error: '',
      isWapp: __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp
    };
  },
  mounted: function mounted() {
    if (this.hasLogin && this.displayChosenResearchGroup) {
      this.enterprise = {
        'enterpriseName': this.displayChosenResearchGroup.firstLevelEnterpriseName,
        'enterpriseNo': this.displayChosenResearchGroup.firstLevelEnterpriseNo
      };
      this.department = {
        'enterpriseName': this.displayChosenResearchGroup.secondLevelEnterpriseName,
        'enterpriseNo': this.displayChosenResearchGroup.secondLevelEnterpriseNo
      };
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'customerNo', 'hasLogin', 'researchGroupCharacter'])),
  components: {
    ResearchGroupRemindBox: __WEBPACK_IMPORTED_MODULE_3__researchGroupComponents_ResearchGroupRemindBox___default.a, FirstLevelEnterpriseBox: __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_FirstLevelEnterpriseBox___default.a, DepartmentBox: __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_DepartmentBox___default.a
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    validatemobile: function validatemobile(mobile) {
      if (mobile.length === 0) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('手机号码不能为空');
        return false;
      }
      var myreg = /^1[3-9]{1}[0-9]{9}$/;
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入有效的手机号码');
        return false;
      }
      return true;
    },
    toggleShowFirstLevelEnterpriseBox: function toggleShowFirstLevelEnterpriseBox() {
      this.showFirstLevelEnterpriseBox = !this.showFirstLevelEnterpriseBox;
    },
    toggleShowDepartmentBox: function toggleShowDepartmentBox() {
      this.showDepartmentBox = !this.showDepartmentBox;
    },
    toggleResearchGroupRemindBox: function toggleResearchGroupRemindBox() {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox;
    },
    updateFirstLevelEnterprise: function updateFirstLevelEnterprise(enterprise) {
      console.log('enterprise', enterprise);
      this.enterprise = enterprise;
      this.department = {};
    },
    updateDepartment: function updateDepartment(department) {
      console.log('department', department);
      this.department = department;
    },
    checkInfo: function checkInfo() {
      var _this = this;
      if (!_this.registerName) {
        _this.error = '请填写姓名';
        return false;
      }
      var mobile = _this.registerMobile.replace(/\s+/g, '');
      if (!mobile) {
        _this.error = '请填写手机号';
        return false;
      }
      if (!/^1[3-9]{1}[0-9]{9}$/.test(mobile)) {
        _this.error = '手机号有误';
        return false;
      }
      var email = _this.registerEmail.replace(/\s+/g, '');

      if (!email) {
        _this.error = '请填写邮箱';
        return false;
      }
      if (!/^\w+([._-]\w+)*@(\w+\.)+\w+$/.test(email)) {
        _this.error = '邮箱有误';
        return false;
      }

      if (!_this.enterprise.enterpriseName) {
        _this.error = '请选择单位';
        return false;
      }
      // if (_this.ifShowDepartment && !_this.department.enterpriseName) {
      //   _this.error = '请选择科室'
      //   return false
      // }
      if (!_this.agreeStatus) {
        _this.error = '请阅读并同意用户注册协议';
        return false;
      }
      return true;
    },
    register: function register() {
      var _this2 = this;

      var _this = this;
      if (!_this.checkInfo()) return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(_this.error);
      this.$weui.loading('正在添加联系人');
      var newContact = {
        'customerName': _this.registerName.replace(/\s/g, ''),
        'mobile': _this.registerMobile.replace(/\s+/g, ''),
        'enterpriseNo': _this.enterprise.enterpriseNo,
        'email': _this.registerEmail.replace(/\s+/g, ''),
        'enterpriseName': _this.enterprise.enterpriseName
      };
      _this.gcapi('registCustomer', newContact).then(function (response) {
        _this2.$weui.loading().hide();
        if (response.body.code === 0 && response.body.result) {
          newContact.customerNo = response.body.result.customerInfo && response.body.result.customerInfo.customerNo;
          _this2.$router.replace({ name: 'AddResearchMember', query: { newContact: newContact } });
          _this2.$weui.toast('联系人添加成功，请选择签约审批原则');
        }
      }, function (response) {
        _this2.$weui.loading().hide();
        _this2.$weui.toast(response.body['message']);
      });
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupRemindBox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupRemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupRemindBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      character: this.$route.query.character,
      showResearchGroupRemindBox: false,
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      isWapp: __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWapp
    };
  },

  components: {
    ResearchGroupRemindBox: __WEBPACK_IMPORTED_MODULE_4__researchGroupComponents_ResearchGroupRemindBox___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['researchGroupMemberMap', 'researchGroupSet', 'chosenResearchMember']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter']), {
    characterToDisplay: function characterToDisplay() {
      // 显示审批人/对账人
      if (this.character === 'approver') return '审批人';
      if (this.character === 'accountCustomer') return '对账人';
      if (this.character === 'horMember') return '科研者之家会员';
      return '';
    },
    characterNameToDisplay: function characterNameToDisplay() {
      if (this.character === 'approver') return this.displayChosenResearchGroup.approverName;
      if (this.character === 'accountCustomer') return this.displayChosenResearchGroup.accountCustomerName;
      if (this.character === 'horMember') return this.displayChosenResearchGroup.horMemberName;
      return '';
    }
  }),
  watch: {
    chosenResearchMember: function chosenResearchMember(val) {
      console.log('chosenResearchMember', val);
      if (val && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(val) !== '{}') this.ifEmailExist(val);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_SET']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    ifEmailExist: function ifEmailExist(member) {
      var _this = this;

      if (this.character === 'accountCustomer' && !member.email) {
        // 查询此成员邮箱是否已更新
        var queryParam = {
          researchGroupNo: member.researchGroupNo,
          memberNo: member.memberNo
        };
        this.gcapi('getResearchGroupMemberInfo', queryParam).then(function (res) {
          if (res && res.body.result) {
            var newEmail = res.body.result.email;
            if (!newEmail) {
              _this.remindParams.firstline = '对账联系人邮箱不能为空';
              _this.remindParams.secondline = '请提醒此成员添加邮箱（添加方式：淘基因-我的个人中心-修改个人信息-修改邮箱）';
              _this.remindParams.singleOrDouble = 1;
              _this.toggleResearchGroupRemindBox();
              return;
              // $.alert('对账联系人邮箱不能为空，请提醒此成员添加邮箱（添加方式：电商平台-我的个人中心-修改个人信息-修改邮箱）')
            } else {
              _this.saveResearchGroup(member);
            }
          }
        });
      } else {
        this.saveResearchGroup(member);
      }
    },
    saveResearchGroup: function saveResearchGroup(val) {
      var _this2 = this;

      var name = this.character === 'approver' ? 'approverName' : this.character === 'accountCustomer' ? 'accountCustomerName' : 'horMemberName';
      var no = this.character === 'approver' ? 'approverNo' : this.character === 'accountCustomer' ? 'accountCustomerNo' : 'horMemberNo';
      var researchGroupToUpdate = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.displayChosenResearchGroup);
      researchGroupToUpdate[name] = val.memberName;
      researchGroupToUpdate[no] = val.memberNo;
      console.log('researchGroupToUpdate', researchGroupToUpdate);
      // 更新课题组审批人/对账人
      __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.showPreloader('保存中');
      this.gcapi('updateResearchGroup', researchGroupToUpdate).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.hidePreloader();
        if (res && res.body.result) {
          var updatedResearchGroup = res.body.result;
          // 更新内存中课题组的信息，this.$set()可以监测数组的变化
          var researchGroupSetToUpdate = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.researchGroupSet));
          for (var i = 0; i < researchGroupSetToUpdate.length; i++) {
            var group = researchGroupSetToUpdate[i];
            if (group.researchGroupNo === updatedResearchGroup.researchGroupNo) {
              // this.$set(researchGroupSetToUpdate, i, Object.assign(group, updatedResearchGroup))
              researchGroupSetToUpdate[i] = updatedResearchGroup;
              _this2.UPDATE_RESEARCHGROUP_SET(researchGroupSetToUpdate);
            }
          }
          console.log('课题组保存成功', _this2.researchGroupSet);
          __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.toast('课题组保存成功');
        } else {
          __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.toast('课题组保存失败，请重试');
        }
      });
    },
    toggleResearchGroupRemindBox: function toggleResearchGroupRemindBox() {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox;
    }
  })
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType1__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ChooseApproveType2__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ChooseApproveType2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ChooseApproveType2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__researchGroupComponents_ResearchGroupRemindBox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__researchGroupComponents_ResearchGroupRemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__researchGroupComponents_ResearchGroupRemindBox__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      researchGroupApproveTypeDictionary: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].researchGroupApproveTypeDictionary,
      memberIndex: this.$route.query.memberIndex,
      approveTypeThreshold: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD,
      showChooseApproveType: false,
      showResearchGroupRemindBox: false,
      remindParams: {
        firstline: '该操作不可撤销',
        secondline: '确认删除该课题组成员？',
        singleOrDouble: 2
      },
      type: this.$route.query.type || __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_MEMBER_OP.add,
      showChooSinglestrokeApproveType: false,
      showChooSinglemouthApproveType: false,
      setSinglestrokeApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_ALL_APPROVETYPE,
      approveTypeNone: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_ALL,
      // startChooseBox: true,
      approve: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp
    };
  },
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['researchGroupMemberMap', 'researchApprovalGroupMember']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter']), {
    memberDetail: function memberDetail() {
      if (this.type === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_MEMBER_OP.add) {
        if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return {};
        if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return {};
        var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
        console.log(this.researchGroupMemberMap[researchGroupNo][this.memberIndex]);
        return this.researchGroupMemberMap[researchGroupNo][this.memberIndex];
      } else {
        return this.researchApprovalGroupMember;
      }
    }
  }),
  components: {
    ChooseApproveType1: __WEBPACK_IMPORTED_MODULE_5__researchGroupComponents_ChooseApproveType1___default.a, ResearchGroupRemindBox: __WEBPACK_IMPORTED_MODULE_7__researchGroupComponents_ResearchGroupRemindBox___default.a, ChooseApproveType2: __WEBPACK_IMPORTED_MODULE_6__researchGroupComponents_ChooseApproveType2___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },

    // changeapprove () {
    //       // this.memberDetail.approveType !== EMKT.CONSTANT_APPROVETYPE_NONE ? this.startChooseBox = true : false
    //   this.startChooseBox === false ? this.approve.approveType = this.approveTypeNone : this.approve.approveType = undefined
    // },
    checkMember: function checkMember() {
      var deletedMember = this.memberDetail;
      var leaderNo = this.displayChosenResearchGroup.leaderNo;
      var approverNo = this.displayChosenResearchGroup.approverNo;
      var accountCustomerNo = this.displayChosenResearchGroup.accountCustomerNo;
      if (leaderNo === deletedMember.memberNo) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('删除组长请联系业务员');
        return;
      }
      if (approverNo === deletedMember.memberNo) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('删除前请先移除审批人身份');
        return;
      }
      if (accountCustomerNo === deletedMember.memberNo) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('删除前请先移除对账联系人身份');
        return;
      }
      this.toggleResearchGroupRemindBox();
    },
    deleteMember: function deleteMember() {
      // 删除成员接口, 将课题组的一级客户和二级客户信息传到后台
      var waitDeleteMember = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.memberDetail);
      waitDeleteMember.firstLevelEnterpriseNo = this.displayChosenResearchGroup.firstLevelEnterpriseNo;
      waitDeleteMember.firstLevelEnterpriseName = this.displayChosenResearchGroup.firstLevelEnterpriseName;
      waitDeleteMember.secondLevelEnterpriseNo = this.displayChosenResearchGroup.secondLevelEnterpriseNo;
      waitDeleteMember.secondLevelEnterpriseName = this.displayChosenResearchGroup.secondLevelEnterpriseName;
      this.gcapi('deleteResearchGroupMember', waitDeleteMember).then(function (res) {
        if (res && res.body.code === 1) __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('信息同步失败，请联系业务员删除成员');
      });
      var newMemberMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.researchGroupMemberMap);
      newMemberMap[this.memberDetail.researchGroupNo].splice(this.memberIndex, 1);
      this.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap);
      this.goBack();
    },
    toggleShowChooseBox: function toggleShowChooseBox(data) {
      console.log(data);
      switch (data) {
        case 0:
          this.showChooseApproveType = !this.showChooseApproveType;
          break;
        case 2:
          this.showChooSinglemouthApproveType = !this.showChooSinglemouthApproveType;
          break;
        case 1:
          this.showChooSinglestrokeApproveType = !this.showChooSinglestrokeApproveType;
      }
    },
    saveMember: function saveMember(approve) {
      var _this2 = this;

      console.log('updateMemberApproveType', approve);
      if (approve.approveType === undefined) {
        return;
      }
      console.log(this.approve);
      var memberToUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.memberDetail);
      memberToUpdate.approveType = approve.approveType;
      if (approve.approveType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD) {
        memberToUpdate.approveThreshold = approve.approveThreshold === '' ? null : approve.approveThreshold;
        memberToUpdate.monthlyLimit = approve.monthlyLimit === '' ? null : approve.monthlyLimit;
      } else {
        memberToUpdate.approveThreshold = null;
        memberToUpdate.monthlyLimit = null;
      }
      console.log('memberToUpdate', memberToUpdate);
      if (this.type === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_MEMBER_OP.add) {
        this.$weui.loading('保存中');
        // 保存到数据库
        this.gcapi('saveOrUpdateResearchGroupMember', memberToUpdate).then(function (res) {
          _this2.$weui.loading().hide();
          if (res && res.body.result) {
            var newMemberMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.researchGroupMemberMap);
            newMemberMap[memberToUpdate.researchGroupNo][_this2.memberIndex] = res.body.result;
            _this2.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap);
            _this2.$weui.toast('保存成功');
          } else {
            _this2.$weui.toast('保存失败');
          }
        });
      } else {
        this.UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET(memberToUpdate);
        console.log(memberToUpdate);
      }
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    toggleResearchGroupRemindBox: function toggleResearchGroupRemindBox() {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox;
    },
    fetchData: function fetchData() {
      this.approve.approveType = this.memberDetail.approveType;
      this.approve.approveThreshold = this.memberDetail.approveThreshold === undefined ? '' : this.memberDetail.approveThreshold;
      this.approve.monthlyLimit = this.memberDetail.monthlyLimit === undefined ? '' : this.memberDetail.monthlyLimit;
      console.log(this.memberDetail.approveType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_NONE);
    },
    saveApproveType: function saveApproveType(approve, setApproveType) {
      this.approve.approveType === approve.approveType;
      setApproveType === this.setallApproveType ? this.approve = approve : setApproveType === this.setSinglestrokeApproveType ? this.approve.approveThreshold = approve.approveThreshold : this.approve.monthlyLimit = approve.monthlyLimit;
      if (this.checkApproval()) {
        this.saveMember(this.approve);
      }
      // if (this.approve.approveType === this.approveTypeThreshold) {
      //   if (this.approve.approveThreshold === '' && this.approve.monthlyLimit === '') {
      //     $.toast('单笔订单限额和单月累积限额不可同时为无限额！')
      //     return
      //   } else if (this.approve.approveThreshold === undefined) {
      //     return
      //   } else if (this.approve.monthlyLimit === undefined) {
      //     return
      //   } else {
      //     this.saveMember(this.approve)
      //   }
      // } else {
      //   this.saveMember(this.approve)
      // }
    },
    checkApproval: function checkApproval() {
      if (this.approve.approveType === this.approveTypeThreshold) {
        if (this.approve.approveThreshold === '' && this.approve.monthlyLimit === '') {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('单笔订单限额和单月累积限额不可同时为无限额！');
          return false;
        } else if (this.approve.approveThreshold === undefined) {
          return false;
        } else if (this.approve.monthlyLimit === undefined) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    submitAddMember: function submitAddMember() {
      var _this3 = this;

      var _this = this;
      if (_this.approve.approveType === undefined) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('请设置审批规则！');
        return;
      }
      if (_this.checkApproval()) {
        console.log(_this.memberDetail);
        var researchGroupNo = _this.displayChosenResearchGroup.researchGroupNo;
        var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.memberDetail, { researchGroupNo: researchGroupNo });
        _this.$weui.loading('保存中');
        _this.gcapi('approvalRequestAndSaveMember', params).then(function (res) {
          _this.$weui.loading().hide();
          var newMemberMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.researchGroupMemberMap);
          newMemberMap[params.researchGroupNo].push(res.body.result);
          _this3.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap);
          _this.$router.push({ name: 'ResearchMemberManagement' });
        });
      }
    }
  })
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      researchGroupApproveTypeDictionary: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].researchGroupApproveTypeDictionary,
      memberIndex: 1,
      approveTypeThreshold: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].CONSTANT_APPROVETYPE_ALL,
      isWapp: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp,
      tabType: 1,
      approvalMemberList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    _this.$weui.loading('数据加载中...');
    _this.gcapi('getAllRequestLogByResearchGroupNo', _this.displayChosenResearchGroup.researchGroupNo).then(function (res) {
      _this.$weui.loading().hide();
      _this.approvalMemberList = res.data.result.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { createDT: item.createDT || __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].FormatterTime(new Date()) });
      });
      if (_this.approvalMemberList.findIndex(function (item) {
        return item.status === 0;
      }) !== -1) {
        _this.tabType = 2;
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['researchGroupMemberMap']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['displayChosenResearchGroup', 'researchGroupCharacter']), {
    memberList: function memberList() {
      if (!this.displayChosenResearchGroup || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.displayChosenResearchGroup) === '{}') return;
      if (!this.researchGroupMemberMap || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.researchGroupMemberMap) === '{}') return;
      var researchGroupNo = this.displayChosenResearchGroup.researchGroupNo;
      return this.researchGroupMemberMap[researchGroupNo];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET']), {
    goBack: function goBack() {
      this.$router.push({ name: 'ResearchGroupHome' });
    },
    splitMoney: function splitMoney(moneyNumber) {
      if (moneyNumber === undefined) {
        return '';
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',');
    },
    addMember: function addMember() {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('EMKT.isWapp', __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp);
      if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp) {
        var _displayChosenResearc = this.displayChosenResearchGroup,
            researchGroupNo = _displayChosenResearc.researchGroupNo,
            researchGroupName = _displayChosenResearc.researchGroupName;

        __WEBPACK_IMPORTED_MODULE_4_wx___default.a.miniProgram.navigateTo({
          url: '/pages/researchGroupMember/share?researchGroupNo=' + researchGroupNo + '&researchGroupName=' + researchGroupName
        });
      } else {
        this.$router.push({ name: 'AddResearchMember' });
      }
    },
    goDetailOrApproval: function goDetailOrApproval(member, index) {
      if (member.status === 0) {
        this.UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET(member);
        this.$router.push({ name: 'ResearchMemberDetail', query: { memberIndex: index, type: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_MEMBER_OP.approval } });
      } else {
        var index1 = this.memberList.findIndex(function (item) {
          return item.memberNo === member.memberNo;
        });
        if (index1 === -1) {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('该成员已经不存在！');
          return;
        }
        this.$router.push({ name: 'ResearchMemberDetail', query: { memberIndex: index1 } });
      }
    }
  })
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var PDFJS = __webpack_require__(1130);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      scale: 0.9
    };
  },
  created: function created() {
    this.showPDF(this.$route.params.url);
  },

  methods: {
    showPDF: function showPDF(url) {
      var _this = this;
      PDFJS.getDocument(url).then(function (pdf) {
        _this.pdfDoc = pdf;
        _this.renderPage(1);
      });
    },
    renderPage: function renderPage(num) {
      this.pageRendering = true;
      var _this = this;
      this.pdfDoc.getPage(num).then(function (page) {
        var viewport = page.getViewport(4);
        var canvas = document.getElementById('the-canvas');
        canvas.height = viewport.height * 1.5;
        canvas.width = viewport.width;
        canvas.style.height = viewport.height * 0.3 + 'px';
        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: canvas.getContext('2d'),
          viewport: viewport
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(function () {
          _this.pageRendering = false;
          if (_this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(_this.pageNumPending);
            _this.pageNumPending = null;
          }
        });
      });
    },
    queueRenderPage: function queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    onPrevPage: function onPrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },
    onNextPage: function onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import EMKT from '../../../emkt'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('close', function () {
      _this.addEnterprise = _this.enterpriseInfo.enterpriseName;
    });
  },
  created: function created() {},
  data: function data() {
    return {
      customerName: '',
      Mobile: '',
      message: '',
      addEnterprise: '',
      isReceivePromotion: true,
      error: '出错了'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['enterpriseInfo'])),
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'MYORDER_UPDATE']), {
    submit: function submit() {
      var _this = this;
      var leaveComment = {};
      leaveComment.mobile = _this.Mobile;
      leaveComment.message = _this.message;
      leaveComment.customerName = _this.customerName;
      leaveComment.enterpriseName = _this.addEnterprise;
      if (_this.Mobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.Mobile)) {
        alert('手机号码有误');
        return;
      }
      _this.gcapi('submitLeaveComment', leaveComment).then(function (res) {
        console.log(res);
        if (res.body.message === '') {
          _this.Mobile = '';
          _this.message = '';
          _this.customerName = '';
          _this.addEnterprise = '';
          alert('您的留言已提交');
        } else {
          alert(res.body.message);
        }
      });
    },
    goback: function goback() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_v_2_6_PrivateMixins_MerchandisesMixin__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_wx__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import $ from 'jquery'


/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: [],
  components: {
    'finder-attr-enum-box': __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue___default.a,
    'finder-attr-text-box': __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue___default.a,
    'finder-attr-number-box': __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue___default.a,
    'finder-attr-text-area-box': __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue___default.a,
    'finder-attr-gene-box': __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue___default.a,
    'finder-attr-tv-box': __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__views_v_2_6_PrivateMixins_MerchandisesMixin__["a" /* default */]],
  data: function data() {
    return {
      attrGroups: [],
      curAttrsInGroup: [],
      promotions: [],
      merchandises: [],
      baseurl: '/emktResources/resocurces/img/merchandise/',
      manualurl: '/emktResources/resocurces/manual/',
      merchandiseurl: '/emktResources/resocurces/merchandiseInfo',
      attr: '?go=true',
      attrurl: '../../../static/filters/',
      questionUrl: '../../../static/img/',
      Comments: [],
      QuoteStatus: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('QuoteStatus'),
      qualityCommitment: '',
      introduces: '',
      tlnoimgurl: '',
      discountedPrice: 0,
      numRequiredForSecPromotion: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktSecPromotion') && __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktSecPromotion').requiredQuantity,
      secPromotionDetail: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp,
      Tvnopath: '/emktResources/resocurces/img/promotion/SKUIMG/',
      soldOut: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    //      'merchandises': function (merch) {
    //        for (var i in this.merchandises._attributesList) {
    //          if (this.merchandises._attributesList[i].sectionId === 4 || this.merchandises._attributesList[i].sectionId === 2) {
    //            if (this.merchandises._attributesList[i].value === '' || this.merchandises._attributesList[i].value === -1) {
    //              return
    //            }
    //          }
    //        }
    //      }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['cartList', 'leaveMessageStatus', 'sessionInfo', 'curMessageSession', 'secPromotionDetailObj', 'customerOpenId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['hasLogin', 'curMessageSession', 'secFlag'
  // ...
  ]), {
    getTotalGoodsNum: function getTotalGoodsNum() {
      var self = this;
      var sum = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).forEach(function (item) {
        sum += self.cartList.cartContent[item].productQuantity;
      });
      return sum;
    },
    secPromotionRatio: function secPromotionRatio() {
      if (!this.secPromotionDetail) return 1;
      var ratio = String(100 - this.secPromotionDetail.seckilltRatio * 100);
      ratio = ratio[1] === '0' ? ratio[0] : ratio;
      return ratio;
    },
    filteredShowPromotions: function filteredShowPromotions() {
      if (this.merchandises.showpromotion && this.merchandises.showpromotion.length > 0) {
        return this.merchandises.showpromotion.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6);
        });
      }
      if (this.merchandises.bpromotions && this.merchandises.bpromotions.length > 0) {
        return this.merchandises.bpromotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6);
        });
      }
      return [];
    },
    showExtraMessage: function showExtraMessage() {
      var ids = ['13d3354c-d853-4af4-a432-77d31630ce43', 'deaf9877-ee3f-4f55-951f-94a0a1c3d4a8'];
      return this.merchandises.selfOperated === 0 || ids.includes(this.merchandises.merchandiseId);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE', 'FINDER_SEARCH_TEXT']), {
    getSecPromotionDetail: function getSecPromotionDetail() {
      if (!this.merchandises.promotions) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.merchandises.promotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var promotion = _step.value;

          if (promotion.type !== 6) continue;
          this.secPromotionDetail = this.secPromotionDetailObj[promotion.promotionGuid];
          this.numRequiredForSecPromotion = this.secPromotionDetail && this.secPromotionDetail.requiredQuantity;
          break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    tokefuMessage: function tokefuMessage() {
      if (this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].openCustomerService();
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      } else {
        alert('请您先去登录！');
      }
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    addCartList: function addCartList() {
      var _this = this;
      var sum = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.cartList.cartContent).forEach(function (item) {
        if (_this.cartList.cartContent[item]) {
          sum += _this.cartList.cartContent[item].productQuantity;
        }
      });
      if (sum > 55) {
        _this.$weui.topTips('购物车商品太多啦！购物车商品上限是55个哦！');
        return;
      }
      if (_this.merchandises.selfOperated === 0 && _this.sessionInfo.customerInfo.ssoFlag === 1) {
        _this.$weui.topTips('第三方商品不支持此操作！');
        // $.toast('第三方商品不支持此操作！')
        return;
      }
      _this.merchandises.newMerch = 1;
      if (_this.merchandises.categoryId === 20) {
        for (var i in _this.merchandises._attributesList) {
          if (_this.merchandises._attributesList[i].groupId === 2 || _this.merchandises._attributesList[i].groupId === 3) {
            if (_this.merchandises._attributesList[i].value === '' || _this.merchandises._attributesList[i].valueText === '' && _this.merchandises._attributesList[i].value !== -1) {
              alert('请将' + _this.merchandises._attributesList[i].label + '信息填写完整！');
              return;
            }
          }
        }
        //          $.modal({
        //            title: '确认订单',
        //            afterText: '<div>为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此中情况为您进行免费售后服务</div>',
        //            buttons: [
        //              {
        //                text: '在线联系',
        //                bold: true,
        //                onClick: function () {
        //                  alert('如有问题，请致电02151320189-8012')
        //                }
        //              },
        //              {
        //                text: '确定',
        //                bold: true,
        //                onClick: function () {
        //                }
        //              }
        //            ]
        //          })
        _this.$router.replace({ name: 'FinderOrderDeail', params: { merchandises: _this.merchandises } });
      } else {
        var pl = _this.plan;
        var pr = _this.merchandises;
        if (_this.merchandises.salesLimit !== -1) {
          if (_this.merchandises.totalSales >= _this.merchandises.salesLimit) {
            _this.$weui.alert('此商品已经售罄！');
            // $.confirm('此商品已经售罄！')
          } else {
            console.log(pl, pr);
            _this.ADD_CART_LIST(pr);
            _this.checkFromWapp();
          }
        } else {
          if (pr.specialAnnouncement) {
            _this.$weui.dialog({
              title: '请确认',
              content: '<div>我司cDNA克隆产品只作为cDNA模板使用，不承诺过表达。且该产品只提供质粒，不提供菌液。如有疑问，请咨询在线客服。</div>',
              buttons: [{
                label: '取消',
                type: 'default',
                onClick: function onClick() {
                  console.log('cancel');
                }
              }, {
                label: '确定',
                type: 'primary',
                onClick: function onClick() {
                  _this.ADD_CART_LIST(pr);
                  _this.checkFromWapp();
                }
              }]
            });
            // $.modal({
            //   title: '请确认',
            //   afterText: '<div>我司cDNA克隆产品只作为cDNA模板使用，不承诺过表达。且该产品只提供质粒，不提供菌液。如有疑问，请咨询在线客服。</div>',
            //   buttons: [
            //     {
            //       text: '取消',
            //       bold: true,
            //       onClick: function () {
            //         console.log('cancel')
            //       }
            //     },
            //     {
            //       text: '确定购买',
            //       bold: true,
            //       onClick: function () {
            //         _this.ADD_CART_LIST(pr)
            //         _this.checkFromWapp()
            //       }
            //     }
            //   ]
            // })
          } else {
            _this.ADD_CART_LIST(pr);
            _this.checkFromWapp();
          }
        }
      }
    },
    checkFromWapp: function checkFromWapp() {
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        // 游客状态 跳转会小程序登录页面
        if (this.cartList.saveToDBOrLocalStorage === false) {
          console.log('游客登录状态 需要先登录');
          __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.switchTab({
            url: '/pages/login/login'
          });
          return;
        } else {
          this.saveCartManually();
        }
      }
    },
    gotoCart: function gotoCart() {
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.switchTab({
          url: '/pages/cart/cart'
        });
      } else {
        this.$router.replace({ name: 'cart' });
      }
    },
    checkTlNoImg: function checkTlNoImg() {
      //        $('#home_keleyi_com').attr('href','http://keleyi.com');
    },
    merchandiseHandler: function merchandiseHandler() {
      var md = this.merchandises;
      var bMerchandise = {};
      var attribute = [];
      // md._customizableAttributes['GeneInfo'] = md._attributesList[md._attributesList.length - 1]
      var attr = md._attributes;
      var categoryId = void 0;
      for (var akey in attr) {
        if (akey === 'GeneInfo') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
          this.geneObject = attr[akey].value;
          if (this.geneObject !== null) {
            var taxId = {};
            taxId.columnName = 'GeneInfo.taxId';
            taxId.value = this.geneObject.taxId;
            taxId.valueText = this.geneObject.taxId;
            var symbol = {};
            symbol.columnName = 'GeneInfo.symbol';
            symbol.value = this.geneObject.symbol;
            symbol.valueText = this.geneObject.symbol;
            this.merchandises._abstractList.push(taxId);
            this.merchandises._abstractList.push(symbol);
          }
        } else if (akey === 'AAVBloodType]') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
        } else {
          var obj = {};
          obj['key'] = akey;
          var val = attr[akey].value;
          if (val === '') {
            obj['value'] = -1;
          } else if (val) {
            if (val.value !== undefined) {
              obj['value'] = val.value;
            } else {
              obj['value'] = val;
            }
          } else if (val === 0) {
            obj['value'] = val;
          }
          if (obj['key'] === 'TVInfo') {
            if (obj['value'].TLNo === undefined) {
              obj['value'] = obj['value'];
            } else {
              obj['value'] = obj['value'].TLNo;
            }
          }
          //            if (obj['key'] === 'InducingTest' || obj['key'] === 'ExpressionTest' === 0) {
          //              obj['value'] = 0
          //            }
          //            if (obj['key'] === 'ProductGuid') {
          //              bMerchandise.productGuid = obj['value']
          //            }
          attribute.push(obj);
        }
      }
      var cate = {};
      cate['key'] = 'GeneInfo.category';
      cate['value'] = categoryId;
      attribute.push(cate);
      bMerchandise.unitPrice = md.priceMax;
      bMerchandise.initPrice = bMerchandise.unitPrice;
      bMerchandise.merchandiseGuid = md.merchandiseId;
      bMerchandise.amplification = md.amplification;
      bMerchandise.attributes = attribute;
      bMerchandise.MerchantNo = '101';
      bMerchandise.newMerch = 1;
      //        bMerchandise.productGuid = attribute['ProductGuid'].value
      //        bMerchandise.geneObject = geneObject
      return bMerchandise;
    },
    gotolast: function gotolast() {
      if (this.$route.params.order) {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else {
        this.$router.go(-1);
      }
      //        this.$router.push({name: 'finder'})
    },
    controlForm: function controlForm(index, attribute) {
      var _this2 = this;

      if (attribute.value === '' || attribute.value === undefined) {
        return;
      }
      if (attribute.columnName === 'VirusTiter' && this.merchandises._attributes.LVAmount.value === '') {
        alert('此类合同需要先选择目的病毒总量');
        this.merchandises._attributes.VirusTiter.value = '';
        this.merchandises._attributes.VirusTiter.valueText = '';
        return;
      }
      if ((this.merchandises._attributes.ProductGuid.value === 'C20B666F-8896-4AA7-BF1E-5233ED7EECC9' || this.merchandises._attributes.ProductGuid.value === '5640779C-68F8-47DE-92FF-944ED087C951' || this.merchandises._attributes.ProductGuid.value === 'B80D3CEF-618B-49C1-9A13-852A3F0DA146' || this.merchandises._attributes.ProductGuid.value === '3AAA49FE-3576-4589-A382-84AC8286CA63') && attribute.columnName === 'LVAmount') {
        if (attribute.value === '26') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
        }
        if (attribute.value === '25') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
          this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL';
        }
        if (attribute.value === '27') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL';
        }
      } else if (this.merchandises._attributes.ProductGuid.value === '195FC008-F234-4D06-8B61-650EA583D506' && attribute.columnName === 'LVAmount') {
        if (attribute.value === '27' || attribute.value === '26' || attribute.value === '25') {
          this.merchandises._attributes.VirusTiter.value = '';
          this.merchandises._attributes.VirusTiter.valueText = '';
          this.merchandises._attributes.VirusTiter.options = {};
          this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL';
        }
      }
      console.log(this.merchandises);
      for (var i in this.merchandises._attributesList) {
        if (this.merchandises._attributesList[i].groupId === 2 || this.merchandises._attributesList[i].groupId === 3) {
          if (this.merchandises._attributes.ReguTech && this.merchandises._attributes.ReguTech.value === 5 && this.merchandises._attributesList[i].columnName === 'GeneInfo') {
            this.merchandises._attributesList[i].value = -1;
          }
          if (this.merchandises._attributesList[i].value === '') {
            return;
          }
        }
      }
      var param = {};
      for (var j in this.merchandises._attributesList) {
        if (this.merchandises._attributesList[j].value !== '') {
          var value = '';
          var key = this.merchandises._attributesList[j].columnName;
          if (key === 'TVInfo') {
            value = this.merchandises._attributesList[j].value.TLNo;
          } else if (key === 'GeneInfo') {
            value = this.merchandises._attributesList[j].value.geneGUID;
          } else {
            value = this.merchandises._attributesList[j].value;
          }
          param[this.merchandises._attributesList[j].columnName] = value;
        }
      }
      var _this = this;
      if (this.merchandises.amplification === 1) {
        var bMerchandise = this.merchandiseHandler();
        _this.gcapi('productDetect', bMerchandise).then(function (res) {
          var body = res.body;
          if (body.code === 0) {
            _this.merchandises.productName = body.result.productName;
            _this.merchandises.workdays = body.result.workdays;
            _this.merchandises.expressPrice = body.result.expressPrice;
            _this.merchandises.amplification = body.result.amplification;
            if (_this.merchandises.amplification === 1) {
              _this.merchandises.priceMin = body.result.priceMax;
            } else {
              _this.merchandises.priceMin = body.result.priceMin;
            }
            _this.merchandises.priceMax = body.result.priceMax;
          } else {
            alert(body.result);
          }
        });
      } else {
        param['MuGuid'] = _this.merchandises.merchandiseId;
        console.log('param', param);
        this.$weui.loading('正在计算..');
        this.gcapi('calculatePrice', param).then(function (response) {
          console.log(response);
          _this2.$weui.loading().hide();
          _this2.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount);
          _this2.merchandises.cycle = response.body.result.workDays;
          //            this.merchandises.workDays = response.body.result.workDays
          _this2.merchandises.priceMin = response.body.result.priceMin;
        });
      }
    },
    getEditor: function getEditor(attribute) {
      //        if (attribute.customizable === 1) {
      //          if (attribute.columnName === 'PreContract') {
      //            return 'attr-contract-box'
      //          } else if (attribute.columnName === 'CloneNrSelect') {
      //            return 'attr-target-box'
      //          } else if (attribute.columnName === 'TemsPreContract') {
      //            return 'attr-temcontract-box'
      //          } else {
      //            if (attribute.sdType === Emkt.SDTGene) {
      //              return 'attr-gene-box'
      //            } else if (attribute.sdType === Emkt.SDTToolVector) {
      //              return 'attr-tv-box'
      //            } else if (attribute.sdType === Emkt.SDTEnumeration) {
      //              return 'finder-attr-enum-box'
      //            } else if (attribute.sdType === Emkt.SDTInteger) {
      //              return 'finder-attr-number-box'
      //            } else if (attribute.sdType === Emkt.SDTDecimal) {
      //              return 'finder-attr-number-box'
      //            } else {
      //              return 'finder-attr-text-area-box'
      //            }
      //          }
      //        }
      if (attribute.sdType !== undefined) {
        if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTGene) {
          return 'finder-attr-gene-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTEnumeration) {
          return 'finder-attr-enum-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTInteger) {
          return 'finder-attr-number-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTToolVector) {
          return 'finder-attr-tv-box';
        } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTDecimal) {
          return 'finder-attr-number-box';
        } else {
          return 'finder-attr-text-box';
        }
      }
    },
    fetchData: function fetchData() {
      var _this3 = this;

      var _this = this;
      if (_this.$route.params.merchandises) {
        _this.merchandises = _this.$route.params.merchandises;
        _this.getSecPromotionDetail();
        if (_this.merchandises.amplification === 1 || _this.merchandises.categoryId === 20) {
          var bMerchandise = this.merchandiseHandler();
          _this.gcapi('productDetect', bMerchandise).then(function (res) {
            var body = res.body;
            if (body.code === 0) {
              _this.merchandises.productName = body.result.productName;
              _this.merchandises.workdays = body.result.workdays;
              _this.merchandises.expressPrice = body.result.expressPrice;
              _this.merchandises.priceMin = body.result.priceMax;
              _this.merchandises.priceMax = body.result.priceMax;
            } else {
              alert(body.result);
            }
          });
        }
        if (_this.merchandises.H5FileName) {
          _this.$http.get(this.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, { emulateHTTP: true }).then(function (response) {
            _this.introduces = response.bodyText;
          });
        }
        if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
          _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg';
        }
        if (_this.merchandises.categoryId === 20) {
          _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, { emulateHTTP: true }).then(function (response) {
            _this.qualityCommitment = response.bodyText;
          });
        } else {
          if (_this.merchandises.QualityPromisesH5FileName) {
            var dictionariesMap = __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktMetaData').dictionariesMap;
            var name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue;
            _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + name, { emulateHTTP: true }).then(function (response) {
              _this.qualityCommitment = response.bodyText;
            });
          }
        }
        if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
          _this.merchandises._attributes.GeneInfo.displayable = 0;
          _this.merchandises._attributes.GeneInfo.value = -1;
        }
        _this.soldOut = _this.merchandises.totalSales === _this.merchandises.salesLimit && _this.merchandises.salesLimit !== -1;
      } else {
        var method = '';
        if (_this.$route.query.categoryId === 20 || _this.$route.query.categoryId === '20') {
          if (_this.$route.query.cid === 20 || _this.$route.query.cid === '20') {
            method = 'getMerchandiseDetails';
          } else {
            method = 'findMerchandiseDetails';
          }
        } else {
          method = 'getMerchandiseDetails';
        }
        _this.$weui.loading('正在加载中');
        this.gcapi(method, _this.$route.query.id).then(function (response) {
          _this.merchandises = response.body.result;
          _this.soldOut = _this.merchandises.totalSales === _this.merchandises.salesLimit && _this.merchandises.salesLimit !== -1;
          _this3.$weui.loading().hide();
          if (_this.$route.query.categoryId === 20) {
            if (!(_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5)) {
              _this.merchandises.priceMin = 0;
              _this.merchandises.priceMax = 0;
            }
          }
          _this.merchandises._titleList.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          });
          if (_this.merchandises.geneWord !== '') {
            _this3.FINDER_SEARCH_TEXT(_this.merchandises.geneWord);
          }
          //            _this.merchandises._attributesList.forEach(function (item) {
          //              if (item.groupId === 3 && item.displayable !== 0 && item.value !== 214 && item.value !== '214' && item.value !== -1 && item.value !== '-1') {
          //                item.value = ''
          //                item.valueText = ''
          //              }
          //            })
          if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
            _this.merchandises._attributes.GeneInfo.displayable = 0;
            _this.merchandises._attributes.GeneInfo.value = -1;
            var param = {};
            for (var j in _this.merchandises._attributesList) {
              //                if (_this.merchandises.categoryId === 20 && _this.merchandises._attributesList[j].groupId === 3) {
              //                  _this.merchandises._attributesList[j].value !== ''
              //                }
              if (_this.merchandises._attributesList[j].value !== '') {
                var value = '';
                var key = _this.merchandises._attributesList[j].columnName;
                if (key === 'TVInfo') {
                  value = _this.merchandises._attributesList[j].value.TLNo;
                } else if (key === 'GeneInfo') {
                  value = _this.merchandises._attributesList[j].value.geneGUID;
                } else {
                  value = _this.merchandises._attributesList[j].value;
                }
                param[_this.merchandises._attributesList[j].columnName] = value;
              }
            }
            param['muGuid'] = _this.merchandises.merchandiseId;
            console.log('param', param);
            _this.gcapi('calculatePrice', param).then(function (response) {
              _this.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount);
              _this.merchandises.cycle = response.body.result.workDays;
              _this.merchandises.priceMin = response.body.result.priceMin;
            });
          }
          var showpromotion = [];
          for (var i in _this.merchandises.promotions) {
            if (_this.merchandises.promotions[i].type === 1 || _this.merchandises.promotions[i].type === 6) {
              if (_this3.merchandises.promotions[i].type === 1) {
                var samePromotionName = showpromotion.find(function (item) {
                  return item.name === _this3.merchandises.promotions[i].name;
                });
                if (!samePromotionName) {
                  showpromotion.push(_this3.merchandises.promotions[i]);
                }
              }
            }
          }
          _this.merchandises.showpromotion = showpromotion;
          if (_this.merchandises.H5FileName) {
            _this.$http.get(_this3.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, { emulateHTTP: true }).then(function (response) {
              _this.introduces = response.bodyText;
            });
          }
          if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
            _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg';
          }
          if (_this.merchandises.categoryId === 20) {
            _this.$http.get(_this3.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, { emulateHTTP: true }).then(function (response) {
              _this.qualityCommitment = response.bodyText;
            });
          } else {
            if (_this.merchandises.QualityPromisesH5FileName) {
              var dictionariesMap = __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('EmktMetaData').dictionariesMap;
              var _name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue;
              _this.$http.get(_this3.merchandiseurl + '/static/desc/qualitypromises/' + _name, { emulateHTTP: true }).then(function (response) {
                _this.qualityCommitment = response.bodyText;
              });
            }
          }
          console.log('merchandises', _this.merchandises);
          _this3.getSecPromotionDetail();
        });
      }
      _this.gcapi('getMerchandiseComments', _this.$route.query.id).then(function (response) {
        _this.Comments = response.body.result;
      });
    },
    addcss: function addcss(data) {
      var obj1 = document.getElementById('detail');
      var obj2 = document.getElementById('introduce');
      var obj3 = document.getElementById('qualityCommitment');
      var obj4 = document.getElementById('comments');
      var obj5 = document.getElementById('tlnoImg');
      if (data === 1) {
        obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;background-color: transparent';
        obj2.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 2) {
        obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 3) {
        obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 4) {
        obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;';
        }
      } else if (data === 5 && this.merchandises.categoryId === 20) {
        obj5.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
      }
    },
    wappaddcss: function wappaddcss(data) {
      var obj1 = document.getElementById('detail');
      var obj2 = document.getElementById('introduce');
      var obj3 = document.getElementById('qualityCommitment');
      var obj4 = document.getElementById('comments');
      var obj5 = document.getElementById('tlnoImg');
      if (data === 1) {
        obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;background-color: transparent;margin-top: -40px;';
        obj2.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj3.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj4.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        }
      } else if (data === 2) {
        obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;background-color: transparent;margin-top: -40px;';
        obj1.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj3.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj4.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        }
      } else if (data === 3) {
        obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent;margin-top: -40px;';
        obj1.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj2.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj4.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        }
      } else if (data === 4) {
        obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent;margin-top: -40px;';
        obj1.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj3.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj2.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        if (this.merchandises.categoryId === 20) {
          obj5.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        }
      } else if (data === 5 && this.merchandises.categoryId === 20) {
        obj5.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent;margin-top: -40px;';
        obj1.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj3.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj2.style.cssText = 'border: 0px solid black;margin-top: -40px;';
        obj4.style.cssText = 'border: 0px solid black;margin-top: -40px;';
      }
    },
    toMessage: function toMessage(merchandiseLabel) {
      __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].openCustomerService();
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    },
    showSecPromotionInfo: function showSecPromotionInfo() {
      if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
        return false;
      }
      if (this.merchandises.promotions) {
        return this.merchandises.promotions[0] && this.merchandises.promotions[0].type === 6 && this.secFlag !== 2;
      } else {
        return this.merchandises.bpromotions && this.merchandises.bpromotions[0] && this.merchandises.bpromotions[0].type === 6 && this.secFlag !== 2;
      }
    },
    gotomanual: function gotomanual(manualFileName) {
      var url = this.manualurl + manualFileName;
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.navigateTo({
          url: '/pages/pdf/pdfPage?comeFrom=merchandise&pdfName=' + manualFileName + '&pdfType=1'
        });
      } else {
        window.open(url);
      }
    }
  })

});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_v_2_6_PrivateMixins_MerchandisesMixin__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_wx__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: [],
  components: {
    'finder-attr-enum-box': __WEBPACK_IMPORTED_MODULE_4__FinderBox_FinderAttrEnumBox_vue___default.a,
    'finder-attr-text-box': __WEBPACK_IMPORTED_MODULE_7__FinderBox_FinderAttrTextBox_vue___default.a,
    'finder-attr-number-box': __WEBPACK_IMPORTED_MODULE_5__FinderBox_FinderAttrNumberBox_vue___default.a,
    'finder-attr-text-area-box': __WEBPACK_IMPORTED_MODULE_6__FinderBox_FinderAttrTextAreaBox_vue___default.a,
    'finder-attr-gene-box': __WEBPACK_IMPORTED_MODULE_8__FinderBox_FinderAttrGeneBox_vue___default.a,
    'finder-attr-tv-box': __WEBPACK_IMPORTED_MODULE_9__FinderBox_FinderAttrTVBox_vue___default.a
  },
  data: function data() {
    return {
      attrGroups: [],
      curAttrsInGroup: [],
      promotions: [],
      merchandises: [],
      baseurl: '/emktResources/resocurces/img/merchandise/',
      manualurl: '/emktResources/resocurces/manual/',
      Comments: [],
      QuoteStatus: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].getLocalStorage('QuoteStatus'),
      qualityCommitment: '',
      introduces: '',
      geneObject: {},
      seckilltRatio: 0,
      numRequiredForSecPromotion: 0,
      secPromotionDetail: {},
      isWapp: __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp
    };
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__views_v_2_6_PrivateMixins_MerchandisesMixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['cartList', 'sessionInfo', 'secPromotionDetailObj', 'customerOpenId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['secFlag', 'hasLogin'
  // ...
  ]), {
    filteredShowPromotions: function filteredShowPromotions() {
      if (this.merchandises.showpromotion && this.merchandises.showpromotion.length > 0) {
        return this.merchandises.showpromotion.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6);
        });
      }
      if (this.merchandises.bpromotions && this.merchandises.bpromotions.length > 0) {
        return this.merchandises.bpromotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6);
        });
      }
      return [];
    },

    //      title () {
    //        if (this.merchandiseAttributes === []) {
    //          return ''
    //        } else {
    //          return this.merchandiseAttributes[0].valueText
    //        }
    //      },
    //      merchandiseAttributes () {
    //        if (this.merchandise._attributesList === []) {
    //          return []
    //        } else {
    //          return this.merchandise._attributesList
    //        }
    //      },
    getTotalGoodsNum: function getTotalGoodsNum() {
      var self = this;
      var sum = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).forEach(function (item) {
        sum += self.cartList.cartContent[item].productQuantity;
      });
      return sum;
    },
    secPromotionRatio: function secPromotionRatio() {
      var ratio = String(100 - this.secPromotionDetail.seckilltRatio * 100);
      ratio = ratio[1] === '0' ? ratio[0] : ratio;
      return ratio;
    }
    //      merchandiseList: function () {
    //        this.gcapi('getMerchandiseDetails', this.$route.query.id).then((response) => {
    //          this.merchandises = response.body.result
    //          this.merchandises.tags = this.$route.query.tags
    //          this.merchandises.attrs = this.$route.query.attrs
    //          this.merchandises.attributesList = response.body.result._attributesList
    //        })
    //        return this.merchandises
    //      }

  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE']), {
    addCartList: function addCartList(bMerchandise) {
      console.log(this.merchandises.expressPrice);
      if (this.merchandises.priceMin) {
        bMerchandise.priceMin = this.merchandises.priceMin;
        bMerchandise.priceMax = this.merchandises.priceMax;
      } else {
        bMerchandise.priceMin = this.merchandises.price;
        bMerchandise.priceMax = this.merchandises.price;
      }
      bMerchandise.attributes['GeneInfo'] = this.geneObject;
      var id = bMerchandise.merchandiseId;
      id = id + new Date().getTime();
      bMerchandise.cartid = id;
      if (bMerchandise.promotions) {
        bMerchandise.promotions.sort(function (a, b) {
          return a.priority - b.priority;
        });
      }
      bMerchandise.newMerch = 1;
      this.ADD_CART_LIST(bMerchandise);
      this.checkFromWeapp();
    },
    checkFromWeapp: function checkFromWeapp() {
      // 小程序添加商品，游客状态需先登录，登录状态需手动保存购物车，且不自动跳转到购物车
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        // 游客保存在本地
        if (this.cartList.saveToDBOrLocalStorage === false) {
          console.log('游客登录状态 需要先登录');
          __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.switchTab({
            url: '/pages/login/login'
          });
          this.$weui.loading().hide();
          return;
        } else {
          this.saveCartManually();
        }
      } else {
        this.$weui.loading().hide();
        this.$router.push({ name: 'cart' });
      }
    },
    gotofindermerchdisesdetail: function gotofindermerchdisesdetail() {
      for (var i in this.merchandises._attributes) {
        if (this.merchandises._attributes[i].groupId === 2 || this.merchandises._attributes[i].groupId === 3) {
          this.merchandises._attributes[i].sorteditAble = true;
        }
      }
      this.$router.replace({ name: 'finderMerchandises', params: { merchandises: this.merchandises } });
    },
    calculatePrice: function calculatePrice() {
      for (var a in this.curAttrsInGroup) {
        if (this.curAttrsInGroup[a].columnName !== 'TvNoName' && this.curAttrsInGroup[a].columnName !== 'TvNoNumber') {
          if (this.curAttrsInGroup[a].isNA === false && this.curAttrsInGroup[a].value === '') {
            this.$weui.alert('请将信息填写完整！');
            return;
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].setLocalStorage('TLNo', null);
      var bMerchandise = this.merchandiseHandler();
      var _this = this;
      // $.showIndicator()
      this.$weui.loading('查询商品中');
      this.gcapi('productDetect', bMerchandise).then(function (res) {
        var body = res.body;
        if (body.code === 0) {
          var merchandise = {};
          merchandise = body.result.merchandiseDetailForClient;
          merchandise.productName = body.result.productName;
          merchandise.workdays = body.result.workdays;
          merchandise.expressPrice = body.result.expressPrice;
          merchandise.amplification = body.result.amplification;
          if (merchandise.amplification === 1) {
            merchandise.priceMin = body.result.priceMax;
          } else {
            merchandise.priceMin = body.result.priceMin;
          }
          merchandise.priceMax = body.result.priceMax;
          if (body.result.templateSource) {
            merchandise.templateSource = body.result.templateSource;
          }
          if (_this.$route.query.cust && _this.$route.query.cust.id) {
            merchandise.id = _this.$route.query.cust.id;
          }
          //            _this.merchandises.priceMin = body.result.price
          _this.addCartList(merchandise);
          //            this.attrHandler()
          // if (merchandise.amplification === 1) {
          //   window.location.reload()
          // }
        } else {
          _this.$weui.topTips(body.result, 1000);
          // $.toast(body.result)
        }
      });
    },
    merchandiseHandler: function merchandiseHandler() {
      var md = this.merchandises;
      var bMerchandise = {};
      var attribute = [];
      // md._customizableAttributes['GeneInfo'] = md._attributesList[md._attributesList.length - 1]
      var attr = md._attributes;
      var categoryId = void 0;
      for (var akey in attr) {
        if (akey === 'GeneInfo') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
          this.geneObject = attr[akey].value;
          if (this.geneObject !== null) {
            var taxId = {};
            taxId.columnName = 'GeneInfo.taxId';
            taxId.value = this.geneObject.taxId;
            taxId.valueText = this.geneObject.taxId;
            var symbol = {};
            symbol.columnName = 'GeneInfo.symbol';
            symbol.value = this.geneObject.symbol;
            symbol.valueText = this.geneObject.symbol;
            this.merchandises._abstractList.push(taxId);
            this.merchandises._abstractList.push(symbol);
          }
        } else if (akey === 'AAVBloodType]') {
          attribute.push({ key: akey, value: attr[akey].value.geneGUID });
          categoryId = attr[akey].value.category;
          this.geneObject = attr[akey].value;
        } else {
          var obj = {};
          obj['key'] = akey;
          var val = attr[akey].value;
          if (val === '') {
            obj['value'] = -1;
          } else if (val) {
            if (val.value !== undefined) {
              obj['value'] = val.value;
            } else {
              obj['value'] = val;
            }
          } else if (val === 0) {
            obj['value'] = val;
          }
          if (obj['key'] === 'TVInfo') {
            if (obj['value'].TLNo === undefined) {
              obj['value'] = obj['value'];
            } else {
              obj['value'] = obj['value'].TLNo;
            }
          }
          //            if (obj['key'] === 'InducingTest' || obj['key'] === 'ExpressionTest' === 0) {
          //              obj['value'] = 0
          //            }
          //            if (obj['key'] === 'ProductGuid') {
          //              bMerchandise.productGuid = obj['value']
          //            }
          attribute.push(obj);
        }
      }
      var cate = {};
      cate['key'] = 'GeneInfo.category';
      cate['value'] = categoryId;
      attribute.push(cate);
      bMerchandise.unitPrice = md.priceMax;
      bMerchandise.initPrice = bMerchandise.unitPrice;
      bMerchandise.merchandiseGuid = md.merchandiseId;
      bMerchandise.amplification = md.amplification;
      bMerchandise.attributes = attribute;
      bMerchandise.MerchantNo = '101';
      bMerchandise.newMerch = 1;
      //        bMerchandise.productGuid = attribute['ProductGuid'].value
      //        bMerchandise.geneObject = geneObject
      return bMerchandise;
    },
    gotolast: function gotolast() {
      if (this.$route.params.order) {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else if (this.$route.query.id) {
        this.$router.replace({ name: 'cart' });
      } else if (this.$route.params.type) {
        this.$router.go(-1);
      } else {
        for (var i in this.merchandises._attributes) {
          if (this.merchandises._attributes[i].groupId === 2 || this.merchandises._attributes[i].groupId === 3) {
            this.merchandises._attributes[i].sorteditAble = true;
          }
        }
        this.$router.replace({ name: 'finderMerchandises', params: { merchandises: this.merchandises } });
      }
      //        this.$router.go(-1)
    },
    controlForm: function controlForm(index) {},
    getEditor: function getEditor(attribute) {
      //        if (attribute.customizable === 1) {
      //          if (attribute.columnName === 'PreContract') {
      //            return 'attr-contract-box'
      //          } else if (attribute.columnName === 'CloneNrSelect') {
      //            return 'attr-target-box'
      //          } else if (attribute.columnName === 'TemsPreContract') {
      //            return 'attr-temcontract-box'
      //          } else {
      //            if (attribute.sdType === Emkt.SDTGene) {
      //              return 'attr-gene-box'
      //            } else if (attribute.sdType === Emkt.SDTToolVector) {
      //              return 'attr-tv-box'
      //            } else if (attribute.sdType === Emkt.SDTEnumeration) {
      //              return 'finder-attr-enum-box'
      //            } else if (attribute.sdType === Emkt.SDTInteger) {
      //              return 'finder-attr-number-box'
      //            } else if (attribute.sdType === Emkt.SDTDecimal) {
      //              return 'finder-attr-number-box'
      //            } else {
      //              return 'finder-attr-text-area-box'
      //            }
      //          }
      //        }
      if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTGene) {
        return 'finder-attr-gene-box';
      } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTEnumeration) {
        return 'finder-attr-enum-box';
      } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTInteger) {
        return 'finder-attr-number-box';
      } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTToolVector) {
        return 'finder-attr-tv-box';
      } else if (attribute.sdType === __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].SDTDecimal) {
        return 'finder-attr-number-box';
      } else {
        return 'finder-attr-text-box';
      }
    },
    getSecPromotionDetail: function getSecPromotionDetail() {
      if (!this.merchandises.promotions) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.merchandises.promotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var promotion = _step.value;

          if (promotion.type !== 6) continue;
          this.secPromotionDetail = this.secPromotionDetailObj[promotion.promotionGuid];
          this.numRequiredForSecPromotion = this.secPromotionDetail && this.secPromotionDetail.requiredQuantity;
          break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    fetchData: function fetchData() {
      var _this2 = this;

      console.log(this.$route.query.id);
      if (this.$route.query.merchandises) {
        if (this.isWapp) {
          this.gcapi('getWappMerchandiseDetail', this.$route.query.merchandises).then(function (response) {
            var result = response.body.result;
            _this2.merchandises = JSON.parse(result);
            for (var j in _this2.merchandises._attributesList) {
              _this2.merchandises._attributesList[j].sorteditAble = false;
            }
          });
        } else {
          this.merchandises = JSON.parse(this.$route.query.merchandises);
          for (var j in this.merchandises._attributesList) {
            this.merchandises._attributesList[j].sorteditAble = false;
          }
        }
      } else {
        this.merchandises = this.$route.params.merchandises;
      }

      //        this.merchandises._attributes.forEach(item => {
      //          item.sorteditAble = false
      //        })
      console.log('finderOrderDeail merchandises', this.merchandises);
      this.getSecPromotionDetail();
      for (var i in this.merchandises._attributes) {
        this.merchandises._attributes[i].sorteditAble = false;
      }
      this.gcapi('getMerchandiseComments', this.$route.query.id).then(function (response) {
        _this2.Comments = response.body.result;
      });
    },
    addcss: function addcss(data) {
      var obj1 = document.getElementById('detail');
      var obj2 = document.getElementById('introduce');
      var obj3 = document.getElementById('qualityCommitment');
      var obj4 = document.getElementById('comments');
      if (data === 1) {
        obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
      } else if (data === 2) {
        obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
      } else if (data === 3) {
        obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;';
        obj1.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
        obj4.style.cssText = 'border: 0px solid black;';
      } else if (data === 4) {
        obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;';
        obj1.style.cssText = 'border: 0px solid black;';
        obj3.style.cssText = 'border: 0px solid black;';
        obj2.style.cssText = 'border: 0px solid black;';
      }
    },
    toMessage: function toMessage() {
      __WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].openCustomerService();
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    showSecPromotionInfo: function showSecPromotionInfo() {
      console.log('detail session', this.sessionInfo.customerInfo);
      if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
        return false;
      }
      console.log('detail merchandises.promotions', this.merchandises.promotions);
      if (this.merchandises.promotions) {
        return this.merchandises.promotions[0] && this.merchandises.promotions[0].type === 6 && this.secFlag !== 2;
      } else {
        return this.merchandises.bpromotions && this.merchandises.bpromotions[0] && this.merchandises.bpromotions[0].type === 6 && this.secFlag !== 2;
      }
    },
    gotoCart: function gotoCart() {
      if (__WEBPACK_IMPORTED_MODULE_10__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.switchTab({
          url: '/pages/cart/cart'
        });
      } else {
        this.$router.replace({ name: 'cart' });
      }
    }
  })

});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_v_2_6_components_CustomerService__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_v_2_6_components_CustomerService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_v_2_6_components_CustomerService__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CustomerService: __WEBPACK_IMPORTED_MODULE_6__views_v_2_6_components_CustomerService___default.a
  },
  name: 'app',
  data: function data() {
    return {
      isWapp: __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWapp,
      preventTouchMoveFlag: false,
      isPcUser: null,
      backUrl: '/static/img/svg/返回上一页面.svg',
      showBack: false
    };
  },

  created: function created() {
    // 微信配置
    __WEBPACK_IMPORTED_MODULE_2_wx___default.a.config({
      debug: false,
      appId: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.sign.appId,
      timestamp: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.sign.timestamp,
      nonceStr: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.sign.nonceStr,
      signature: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.sign.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo']
    });
    __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].wxShare();
    this.INIT_CART();
    console.log('Emkt.isWapp', this.isWapp);
    // 在需要配置分享内容的时候调用
    // wxShareConfig()
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])([
  // 映射 this.navTopLevel 为 store.state.navTopLevel
  'navTopLevel', 'cartList', 'sessionInfo', 'myOrder', 'researchGroupSet', 'gotoCart', 'customerOpenId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])([
  // 映射 this.navTopLevel 为 store.state.navTopLevel
  'hasLogin', 'isSFFlag', 'customerNo', 'hideCustomerService']), {
    getTotalGoodsNum: function getTotalGoodsNum() {
      var self = this;
      var number = 0;
      for (var key in self.cartList.cartContent) {
        if (self.cartList.cartContent[key].productQuantity) {
          number = number + self.cartList.cartContent[key].productQuantity;
        } else {
          number = number + 1;
        }
      }
      return number;
    },
    isSalesFlag: function isSalesFlag() {
      var flag = false;
      var cInfo = this.sessionInfo.customerInfo;
      if (cInfo) {
        if (cInfo.onBehalfOfCustomer === 1) {
          flag = true;
        }
      }
      return flag;
    },
    isDeskFlag: function isDeskFlag() {
      return __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isDesktop;
    },
    isHomepage: function isHomepage() {
      return this.$route.name === 'home';
    },
    waitPaidAndDeliver: function waitPaidAndDeliver() {
      var orders = this.myOrder;
      if (!orders) {
        return 0;
      }
      if (!orders.waitDeliverOrders && orders.waitPaidOrders) {
        return orders.waitPaidOrders.length;
      }
      if (orders.waitDeliverOrders && !orders.waitPaidOrders) {
        return orders.waitDeliverOrders.length;
      }
      if (orders.waitDeliverOrders && orders.waitPaidOrders) {
        return orders.waitDeliverOrders.length + orders.waitPaidOrders.length;
      }
      return 0;
    }
  }),
  mounted: function mounted() {
    this.isPcUser = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    // if (this.isPcUser) {
    //   alert('手机用户')
    // } else {
    //   alert('PC用户')
    // }
    // new DragUtil(hottarget, target)
    // this.getSessionID()
  },

  watch: {
    // TODO 初始化购物车逻辑
    'hasLogin': {
      handler: 'getNonSalesforceShoppingCart',
      immediate: true
    },
    'cartList': 'saveCartList',
    'researchGroupSet': {
      handler: 'remindOverdueBill'
    },
    $route: function $route(to, from) {
      if (window.history.length < 2) {
        this.showBack = false;
      } else {
        this.showBack = true;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['INIT_CART', 'COMBINE_CART_LIST', 'UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE', 'SET_CART_LIST']), {
    handlePreventTouchMove: function handlePreventTouchMove() {
      this.preventTouchMoveFlag = true;
    },
    handleActivateTouchMove: function handleActivateTouchMove() {
      this.preventTouchMoveFlag = false;
    },
    goBack: function goBack() {
      window.history.back();
      console.log(this.$router.history, window.history, 'siaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
    },
    getNonSalesforceShoppingCart: function getNonSalesforceShoppingCart(val) {
      var _this = this;

      if (val === undefined) {
        console.log('hasLogin has not been initialized');
        return;
      }
      if (this.isSFFlag === true) {
        return;
      }
      if (val === false && !__WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWappGuest) {
        this.UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE(false);
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWappGuest) {
        this.gcapi('getWappGuestShoppingCart', this.customerOpenId).then(function (res) {
          if (res && res.body.code === 0) {
            var cart = void 0;
            // DB中无购物车记录或者记录为空{}
            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
              cart = '{}';
            } else {
              cart = res.body.result.cartContent;
            }
            _this.SET_CART_LIST(JSON.parse(cart));
          }
        });
      } else {
        this.gcapi('getNonSalesforceShoppingCart', this.sessionInfo.customerInfo.customerNo).then(function (res) {
          if (res && res.body.code === 0) {
            var cart = void 0;
            // DB中无购物车记录或者记录为空{}
            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
              cart = '{}';
            } else {
              cart = res.body.result.cartContent;
            }
            // 从小程序跳转过来，仅读取数据库购物车数据
            if (_this.isWapp) {
              _this.SET_CART_LIST(JSON.parse(cart));
            } else if (__WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getUrlParamHref('fromSmart') === '1') {
              _this.SET_CART_LIST(JSON.parse(cart));
            } else {
              _this.COMBINE_CART_LIST(cart);
            }
          }
        });
      }
    },
    saveCartList: function saveCartList(val) {
      var that = this;
      // 防止cartList为null时，清空购物车
      if (!val || !val.cartContent) return;
      // SF需手动保存购物车
      if (this.isSFFlag === true) {
        console.log('isSFFlag is true');
        return;
      }
      // TODO 购物车保存逻辑
      // 游客保存在本地
      if (val.saveToDBOrLocalStorage === false) {
        console.log('游客登录状态 购物车存储在本地');
        __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].setLocalStorage('EmktBuyCart', val.cartContent);
        return;
      }
      console.log(val.cartContent, '购物数据AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
      // 顾客保存在数据库
      var cartJsonString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val.cartContent);
      // $.showPreloader('正在处理数据')
      if (localStorage.getItem('saveToCart')) {
        this.$weui.loading('正在处理数据~');
      }
      if (__WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].isWappGuest) {
        // 小程序游客模式根据openID获取数据
        this.gcapi('saveWappGuestShoppingCart', { openId: this.customerOpenId, cartContent: cartJsonString }).then(function (response) {
          if (response.body.code === 0) {
            if (localStorage.getItem('saveToCart')) {
              that.$weui.loading().hide();
              localStorage.removeItem('saveToCart');
              that.$weui.toast('商品加入成功！', 500);
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.showPreloader('保存失败！');
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hidePreloader();
            }, 1000);
          }
        });
      } else {
        this.gcapi('saveShoppingCart', cartJsonString).then(function (response) {
          if (response.body.code === 0) {
            if (localStorage.getItem('saveToCart')) {
              that.$weui.loading().hide();
              localStorage.removeItem('saveToCart');
              that.$weui.toast('商品加入成功！', 500);
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.showPreloader('保存失败！');
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.hidePreloader();
            }, 1000);
          }
        });
      }
    },
    remindOverdueBill: function remindOverdueBill(val) {
      var _this2 = this;

      if (!this.hasLogin) {
        return;
      }
      if (!val || val.length === 0) {
        console.log('researchGroupSet is empty');
        return;
      }
      var remindOverdueBillAlready = __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].getLocalStorage('remindOverdueBillAlready');
      if (remindOverdueBillAlready) {
        console.log('remind overdue bill already');
        return;
      }
      var freezedResearchGroup = val.filter(function (group) {
        return _this2.customerNo === group.leaderNo && group.status === __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_LOCKED;
      });
      if (freezedResearchGroup.length === 0) {
        return;
      }
      var name = this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerName;
      var remindText = name + '老师，您好，您的某月账单已逾期尚未结清，目前课题组账户已冻结，请您尽快结清账款。如有疑问，请联系业务人员或致电客服热线400-621-0302';
      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.alert(remindText);
      __WEBPACK_IMPORTED_MODULE_5__emkt__["a" /* default */].setStoreItem('remindOverdueBillAlready', true);
    }
    //      ,
    //      getSessionID () {
    //        // obtaining guest sessinid by an anonymous request
    //        var _this = this
    //        _this.gcapi('gcwwwifc/login', {
    //          'LoginId': 'XX',
    //          'Password': 'XX',
    //          'Access_Token': 'XX'
    //        })
    //        if (!EMKT.getLocalStorage('EmktFirstLevelEnterpriseList')) {
    //          _this.gcapi('gcwwwifc/listEnterprise').then((response) => {
    //            EMKT.setLocalStorage('EmktFirstLevelEnterpriseList', response.body['result'])
    //          })
    //        }
    //      }

  })
  /*
  data () {
    return {
      isIndex: this.Emkt.navTopLevel
    }
  }
  */
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper', 'data'],
  computed: {
    activities: function activities() {
      return this.data.campaignNameBefore ? this.data.campaignNameBefore.split(',') : [];
    },
    activitiesThisYear: function activitiesThisYear() {
      return this.data.campaignName ? this.data.campaignName.split(',') : [];
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper', 'data']
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper', 'data']
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper', 'data']
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper', 'data']
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue___default.a },
  data: function data() {
    return {
      hide: false,
      modalShow: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['customerName', 'customerCreateDT']), {
    showLogo: function showLogo() {
      console.log('window.innerHeight', window.innerHeight);
      return window.innerHeight > 720;
    }
  }),
  methods: {
    handleHide: function handleHide(i) {
      this.hide = i;
    },
    getText: function getText(text) {
      return this.hide ? '****' : text;
    },
    handleOpenModal: function handleOpenModal() {
      this.modalShow = !this.modalShow;
    }
  },
  props: ['swiper', 'data']
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_1__PageWrapper_vue___default.a },
  methods: {
    handleButtonClick: function handleButtonClick() {
      this.swiper.slideNext();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['customerName'])),
  props: ['swiper'],
  data: function data() {
    return {
      texts: ['未来可期', '差异显著', '文章见刊', '经费充足', '文章接收', '科研大吉', '逢投必中', '数据分析好到爆', '科研人 科研魂', '好运爆表100%', '沉迷学术 无法自拔', '论文一稿过', '多发paper 少掉头发'],
      text: ''
    };
  },
  created: function created() {
    this.text = this.texts[Math.floor(Math.random() * 3)];
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  methods: {
    handleButtonClick: function handleButtonClick() {
      this.swiper.slideNext();
    }
  },
  props: ['swiper']
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PageWrapper_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_2__PageWrapper_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['customerName', 'customerCreateDT']), {
    dataInfo: function dataInfo() {
      return this.data;
    }
  }),
  props: ['swiper', 'data']
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  props: ['swiper']
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageWrapper: __WEBPACK_IMPORTED_MODULE_0__PageWrapper_vue___default.a },
  methods: {
    handleButtonClick: function handleButtonClick() {
      this.swiper.slideNext();
    }
  },
  props: ['swiper']
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['background', 'hasDownBtn', 'swiper'],
  methods: {
    handleButtonClick: function handleButtonClick() {
      this.swiper.slideNext();
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['startDT', 'endDT'],
  data: function data() {
    return {
      day: '00',
      hr: '00',
      min: '00',
      sec: '00',
      daysOnly: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['secFlag']), {
    // 无时间限制, 假定一周
    timeNotLimited: function timeNotLimited() {
      var self = this;
      if (self.startDT) {
        var start = Date.parse(new Date(self.startDT.year, self.startDT.month, self.startDT.dayOfMonth, self.startDT.hourOfDay, self.startDT.minute, self.startDT.second));
        var end = Date.parse(new Date(self.endDT.year, self.endDT.month, self.endDT.dayOfMonth, self.endDT.hourOfDay, self.endDT.minute, self.endDT.second));
        return end - start > 7 * 24 * 60 * 60 * 1000;
      }
    }
  }),
  watch: {
    'startDT': {
      handler: 'countdown',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['UPDATE_SECPROMOTION_INFO']), {
    countdown: function countdown() {
      var self = this;
      this.timeInterval = setInterval(function () {
        var start = Date.parse(new Date(self.startDT.year, self.startDT.month, self.startDT.dayOfMonth, self.startDT.hourOfDay, self.startDT.minute, self.startDT.second));
        var end = Date.parse(new Date(self.endDT.year, self.endDT.month, self.endDT.dayOfMonth, self.endDT.hourOfDay, self.endDT.minute, self.endDT.second));
        var now = Date.parse(new Date());
        self.UPDATE_SECPROMOTION_INFO({ now: now });
        var diff = void 0;
        if (self.secFlag === 0) {
          diff = start - now;
          self.daysOnly = diff > 24 * 60 * 60 * 1000;
        } else if (self.secFlag === 1) {
          diff = end - now;
        } else {
          clearInterval(self.timeInterval);
          self.day = '00';
          self.hr = '00';
          self.min = '00';
          self.sec = '00';
          console.log('end secflag', self.secFlag);
          return;
        }
        var day = parseInt(diff / 1000 / 60 / 60 / 24);
        var hr = parseInt(diff / 1000 / 60 / 60 % 24);
        var min = parseInt(diff / 1000 / 60 % 60);
        var sec = parseInt(diff / 1000 % 60);
        self.day = day > 9 ? day.toString() : '0' + day;
        self.hr = hr > 9 ? hr.toString() : '0' + hr;
        self.min = min > 9 ? min.toString() : '0' + min;
        self.sec = sec > 9 ? sec.toString() : '0' + sec;
      }, 1000);
    }
  })
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.removeChoose();
    var enterprise = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup-enterprise');
    enterprise.on('open', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setStoreItem('enterprisePopupFlag', true);
      console.log('popup is opening');
    });
    enterprise.on('closed', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setStoreItem('enterprisePopupFlag', false);
      console.log('popup closed');
    });
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  data: function data() {
    return {
      query: '',
      data: {},
      filteredData: {},
      enterpriseNo: ''
    };
  },

  watch: {
    // listening to input
    'query': function query(_query) {
      console.log('in query');
      var _this = this;
      _this.initialize();
      var data = _this.data;
      var filteredData = _this.filteredData;
      for (var i = 0; i < data.length; i++) {
        if (data[i]['enterpriseName'].match(_query.toLowerCase())) {
          var item = {
            'enterpriseName': data[i].enterpriseName,
            'enterpriseNo': data[i].enterpriseNo,
            'locationName': data[i].locationName,
            'regionName': data[i].regionName
          };
          filteredData.push(item);
          if (filteredData.length > 19) {
            break;
          }
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['ENTERPRISE_INFO_UPDATE', 'UPDATE_DEPARTMENT_INFO']), {
    fetchData: function fetchData() {
      // fetching data from localstorage
      this.data = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelEnterpriseList');
    },
    initialize: function initialize() {
      this.filteredData = [];
    },
    removeChoose: function removeChoose() {
      this.ENTERPRISE_INFO_UPDATE('');
    },
    valueConvey: function valueConvey(index) {
      var _this = this;
      var choice = {
        'enterpriseName': _this.filteredData[index].enterpriseName,
        'enterpriseNo': _this.filteredData[index].enterpriseNo,
        'locationName': _this.filteredData[index].locationName,
        'regionName': _this.filteredData[index].regionName
      };
      _this.ENTERPRISE_INFO_UPDATE(choice);
      _this.UPDATE_DEPARTMENT_INFO({});
      _this.query = '';
    },
    valueConvey2: function valueConvey2() {
      var _this = this;
      var choice = {
        'enterpriseName': _this.query,
        'enterpriseNo': ''
      };
      _this.ENTERPRISE_INFO_UPDATE(choice);
    }
  })
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      total: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE']), {
    addCartListForRecom: function addCartListForRecom(pro) {
      this.ADD_CART_LIST(pro);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('加入购物车成功！');
    },
    setdatas: function setdatas(pro) {
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].customerBehaviourType.clickMer };
      }
      var _self = this;
      _self.MERCHDISEGROUP_UPDATE(pro.compositions);
      this.$router.push({ path: '/promotion/Compositions' });
    },
    openshaxuan: function openshaxuan() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.openPanel('#panel-right-demo');
    },
    getbpromotions: function getbpromotions(merchdise) {
      if (merchdise.bpromotions) {
        var bpromotions = merchdise.bpromotions;
        var r = [];
        var t = [];
        for (var m = 0; m < bpromotions.length; m++) {
          if (t.indexOf(bpromotions[m].type) === -1) {
            r.push(bpromotions[m]);
            t.push(bpromotions[m].type);
            // console.log(m + ' ' + bpromotions[m].type)
          }
        }
        return r;
      }
    },
    clickMerchandise: function clickMerchandise(pro) {
      var id = '';
      var cid = 0;
      if (pro.categoryId === 20 && pro.findId) {
        id = pro.findId;
      } else if (pro.categoryId === 20 && !pro.findId) {
        cid = 20;
        id = pro.merchandiseId;
      } else {
        id = pro.merchandiseId;
      }
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].customerBehaviourType.clickMer };
      }
      if (this.proo) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { pro: this.proo } });
      } else if (this.channel) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { channel: this.channel } });
      } else {
        if (cid === 20) {
          this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId, cid: 20 } });
        } else {
          this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId } });
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['queryTotal', 'sessionInfo']), {
    merchs: function merchs() {
      var newmerchList = [];
      if (!this.merchList) {
        return newmerchList;
      }
      newmerchList = this.merchList;
      //        for (var i = 0; i < newmerchList.length; i++) {
      //          var tags = []
      //          var merchandiseMeta = emkt.getEmktMetaData()
      //          var tagsmap = merchandiseMeta.tagsMap
      //          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
      //            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
      //          }
      //          newmerchList.tags = tags
      //          var bpromotions = newmerchList[i].bpromotions
      //          var r = []
      //          var t = []
      //          for (var m = 0; m < bpromotions.length; m++) {
      //            if (t.indexOf(bpromotions[m].type) === -1) {
      //              r.push(bpromotions[m])
      //              t.push(bpromotions[m].type)
      //              console.log(m + ' ' + bpromotions[m].type)
      //            }
      //          }
      //          newmerchList[i].bpromotions = r
      //        }
      this.total = newmerchList.length;
      return newmerchList;
    },
    showFilterBarFlag: function showFilterBarFlag() {
      var flag = true;
      var src = this.$route.name;
      if (src === 'home') {
        flag = false;
      }
      if (!this.showFilterBar) {
        flag = false;
      }
      return flag;
    }
  })
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentPage: this.$router.history.current.fullPath,
      isWapp: __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].isWapp
    };
  },
  mounted: function mounted() {},

  props: ['show', 'defaultIndex'],
  //    props: {
  //      show: {
  //        type: Boolean,
  //        required: true, // 必需且是bool类型的
  //        twoWay: true   // 双向绑定
  //      }
  //    },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(42);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FooterPlaceholder',
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */]
    };
  },

  props: {
    showPlaceHolder: Boolean
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcSearchInput',
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */],
      keyword: ''
    };
  },

  props: {
    displayInBrowser: Boolean
  },
  emits: ['updateSearchKeyword'],
  methods: {
    handleChange: function handleChange() {
      this.$emit('updateSearchKeyword', this.keyword);
    },
    clearKeyword: function clearKeyword() {
      this.keyword = '';
      this.handleChange();
    }
  },
  mounted: function mounted() {
    this.$weui.searchBar('#searchBar');
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */],
      m_column: -1,
      currentSelectionName: []
    };
  },

  props: {
    memberList: {
      type: Array,
      default: []
    }
  },
  emits: ['updateSelection'],
  methods: {
    chooseMember: function chooseMember(mcolumn) {
      this.m_column = mcolumn;
      if (mcolumn !== -1) {
        this.currentSelectionName = [this.memberList[this.m_column]];
      } else {
        this.currentSelectionName = [];
      }
      this.$emit('updateSelection', this.currentSelectionName);
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcOrderExpressBase_vue__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcOrderExpressBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GcOrderExpressBase_vue__);


//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcOrderExpress',
  components: { GcOrderExpressBase: __WEBPACK_IMPORTED_MODULE_2__components_GcOrderExpressBase_vue___default.a },
  data: function data() {
    return {
      expressDetail: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.expressDetail = JSON.parse(_this.$route.params.expressDetail);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    downloadExpressOutFile1: function downloadExpressOutFile1(contractNo) {
      this.$emit('downloadExpressFile', contractNo);
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_clipboard__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcOrderExpress',
  props: {
    expressDetail: Array
  },
  emits: ['downloadExpressOutFile'],
  data: function data() {
    return {
      expressList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var i, express;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.expressDetail) {
                for (i = 0; i < _this.expressDetail.length; i++) {
                  express = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    showAll: false
                  }, _this.expressDetail[i]);

                  _this.expressList.push(express);
                }
              }
              console.log('expressList===============>', _this.expressList);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    changeOpen: function changeOpen(express) {
      express.showAll = !express.showAll;
    },
    copy: function copy() {
      var _this2 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_3_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        _this2.$weui.toast('复制成功', 1500);
        // $.toast('复制成功')
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this2.$weui.topTips('该浏览器不支持自动复制');
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    },

    downloadExpressOutFile: function downloadExpressOutFile(contractNo) {
      console.log('downloadExpressOutFile');
      this.$emit('downloadExpressOutFile', contractNo);
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GcOrderDetailButtonsBase_vue__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GcOrderDetailButtonsBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_GcOrderDetailButtonsBase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcOrderCommonButtons',
  components: { GcOrderDetailButtonsBase: __WEBPACK_IMPORTED_MODULE_0__components_GcOrderDetailButtonsBase_vue___default.a },
  props: {
    orderDetail: Object
  },
  computed: {
    showCustomerGoodsBtn: function showCustomerGoodsBtn() {
      return __WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].showProgressBtn(this.orderDetail) && !__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].isGVAPContract(this.orderDetail);
    },
    showInvoiceBtn: function showInvoiceBtn() {
      return __WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].showProgressBtn(this.orderDetail);
    }
  },
  methods: {
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].getOrderStatusText,
    // 处理路由跳转逻辑
    goToInvoice: function goToInvoice() {
      this.$router.push({ name: 'WeappGcOrderInvoiceDetail', params: { orderNo: this.orderDetail.orderNo } });
    },
    goToCustomerGoods: function goToCustomerGoods() {
      console.log('goToCustomerGoods======>', this.orderDetail.itemList);
      var contractNos = this.orderDetail.itemList.map(function (obj) {
        return obj.contractNo;
      }).join(',');
      this.$router.push({ name: 'WeappGcOrderGoodsDetail', params: { contractNos: contractNos } });
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GcOrderDetailBase_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GcOrderDetailBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GcOrderDetailBase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GcOrderDetailButtonsWithActions_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GcOrderDetailButtonsWithActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__GcOrderDetailButtonsWithActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emktcommon_api_orderApi_js__ = __webpack_require__(166);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// 封装了路由跳转, 调用API获取数据




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderDetail: {},
      expressTrack: {}
    };
  },

  props: {
    showProductContractNo: Boolean,
    showPlaceHolder: Boolean
  },
  watch: {
    // '$route.params.orderNo': {
    //   handler: 'queryOrderDetail',
    //   immediate: true
    // }
  },
  components: { GcOrderDetailBase: __WEBPACK_IMPORTED_MODULE_5__components_GcOrderDetailBase_vue___default.a, GcOrderDetailButtonsWithActions: __WEBPACK_IMPORTED_MODULE_6__GcOrderDetailButtonsWithActions_vue___default.a },
  methods: {
    queryOrderDetail: function queryOrderDetail() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__emktcommon_api_orderApi_js__["b" /* getOrderDetail */])(_this.$route.params.orderNo);

              case 2:
                _this.orderDetail = _context.sent;

                console.log('queryOrderDetail', _this.orderDetail);
                _this.queryExpressTrack();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    queryExpressTrack: function queryExpressTrack() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var itemList, contractNos, expressTrackList;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.orderDetail) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                itemList = [];
                contractNos = [];

                itemList = _this2.orderDetail.itemList;
                itemList.forEach(function (i) {
                  contractNos.push(i.contractNo);
                });
                _context2.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__emktcommon_api_orderApi_js__["k" /* getExpressTrack */])(contractNos.join(","));

              case 8:
                expressTrackList = _context2.sent;

                _this2.expressTrack = _this2.processExpressTrack(expressTrackList);
                console.log('expressTrack', expressTrackList, _this2.expressTrack);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    processExpressTrack: function processExpressTrack(expressList) {
      var expressNoMap = {}; // expressNo: list
      expressList.forEach(function (express) {
        var expressList = expressNoMap[express.mailNo] || [];
        expressList.push(express);
        expressNoMap[express.mailNo] = expressList;
      });
      var combinedExpressList = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(expressNoMap).forEach(function (expressNo) {
        var contractNos = expressNoMap[expressNo].map(function (express) {
          return express.contractNo;
        });
        var combinedExpress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, expressNoMap[expressNo][0], { contractNoList: contractNos });
        combinedExpressList.push(combinedExpress);
      });
      return combinedExpressList;
    },
    handleGoToProductInfo: function handleGoToProductInfo(item) {
      console.log('orderItem=================>', item);
      if (item.smartProductGuid) {
        this.$router.push({ name: 'WeappGcOrderSmartProductDetail', params: { orderItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item), order: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ fromEmkt: this.orderDetail.fromEmkt }) } });
      } else {
        this.$router.push({ name: 'WeappGcOrderProductDetail', params: { orderItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item), order: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ fromEmkt: this.orderDetail.fromEmkt }) } });
      }
    },
    handleGoToProgressInfo: function handleGoToProgressInfo(item) {
      console.log('orderItem=================>', item);
      this.$router.push({ name: 'WeappGcProgress', params: { orderItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item), orderNo: this.$route.params.orderNo } });
    },
    handleGoToExpressInfo: function handleGoToExpressInfo() {
      this.$router.push({ name: 'WeappMyOrderExpress', params: { expressDetail: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.expressTrack) } });
    },
    handleGetExpressSheet: function handleGetExpressSheet(item) {
      var contractNo = item.contractNo;
      if (contractNo && contractNo !== '') {
        if (item.contractNo.includes(',')) {
          this.$router.push({ name: 'WeappMyOrderExpress', params: { expressDetail: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.expressTrack) } });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__emktcommon_api_orderApi_js__["j" /* downloadExpressOutFile */])(item.contractNo);
        }
      } else {
        alert('无合同编号,无法下载出货单!');
      }
    }
  },
  activated: function activated() {
    this.queryOrderDetail();
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GcOrderListBase_vue__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GcOrderListBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GcOrderListBase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcOrderListButtonsBase_vue__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcOrderListButtonsBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GcOrderListButtonsBase_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    orderList: Array,
    showProductContractNo: Boolean
  },
  emits: ['goToOrderDetail', 'downloadOrderText'],
  components: { GcOrderListBase: __WEBPACK_IMPORTED_MODULE_1__components_GcOrderListBase_vue___default.a, GcOrderListButtonsBase: __WEBPACK_IMPORTED_MODULE_2__components_GcOrderListButtonsBase_vue___default.a },
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */]
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    handleGoToOrderDetail: function handleGoToOrderDetail(orderDetail) {
      this.$emit('goToOrderDetail', orderDetail);
    },
    handleDownloadOrderText: function handleDownloadOrderText(orderDetail) {
      this.$emit('downloadOrderText', orderDetail);
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GcFooterPlaceholder_vue__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GcFooterPlaceholder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_GcFooterPlaceholder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_components_GcOrderProductBase_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_components_GcOrderProductBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__product_components_GcOrderProductBase_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import $ from 'jquery'





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    orderDetail: Object,
    expressTrack: Array,
    showProductContractNo: Boolean,
    showPlaceHolder: Boolean
  },
  emits: ['goToProductInfo', 'goToProgressInfo', 'goToExpressInfo'],
  data: function data() {
    return {
      status: 2,
      routeType: 1,
      showSampleDeliveryGuide: true,
      emkt: __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('this.orderDetail===============>', _this.orderDetail);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: { GcFooterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__components_GcFooterPlaceholder_vue___default.a, GcOrderProduct: __WEBPACK_IMPORTED_MODULE_5__product_components_GcOrderProductBase_vue___default.a },
  computed: {
    lastExpressInfo: function lastExpressInfo() {
      console.log('this.expressTrack===============>', this.expressTrack);
      var lastExpressInfo = {
        acceptTime: "1900-01-01 00:00:00",
        opcode: "",
        remark: "快递信息已经超过三个月"
      };
      if (this.expressTrack) {
        for (var i = 0; i < this.expressTrack.length; i++) {
          var routes = this.expressTrack[i].routes;
          if (routes) {
            for (var j = 0; j < routes.length; j++) {
              var maxDateTime = new Date(lastExpressInfo.acceptTime);
              var currentDateTime = new Date(routes[j].acceptTime);
              if (currentDateTime.getTime() > maxDateTime.getTime()) {
                lastExpressInfo = routes[j];
              }
            }
          }
        }
      }
      console.log('lastExpressInfo===============>', lastExpressInfo);
      return lastExpressInfo;
    },
    itemListLength: function itemListLength() {
      var num = 0;
      if (this.orderDetail.itemList) {
        for (var i = 0; i < this.orderDetail.itemList.length; i++) {
          var item = this.orderDetail.itemList[i];
          if (item.productType === '服务类') {
            if (item.contractNoSrc === '') {
              num++;
            }
          } else {
            num++;
          }
        }
      }
      return num;
    },

    // 商品总额
    discountPrice: function discountPrice() {
      if (this.orderDetail) {
        var discountPrice = (this.orderDetail.discountPrice + '').replace('-', '') - 0;
        return discountPrice;
      } else {
        return 0;
      }
    },
    isWaitApproveOrder: function isWaitApproveOrder() {
      if (!this.orderDetail) return false;
      return this.orderDetail.status === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].ORDER_STATUS_SUBMITTED && this.orderDetail.approveResult === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE;
    },
    showPdf: function showPdf() {
      if (!this.orderDetail) return false;
      return __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].ORDER_STATUS_FINISHED !== this.orderDetail.status;
    }
  },
  methods: {
    stringSet: function stringSet(str) {
      if (str) {
        var temp = str.replace(/&nbsp;/gi, ' ');
        return temp;
      } else {
        return '';
      }
    },
    copy: function copy() {
      var _this2 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        _this2.$weui.toast('复制成功', 1500);
        // $.toast('复制成功')
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this2.$weui.topTips('该浏览器不支持自动复制');
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    },

    // goMessage () {
    //   window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    // },
    getStatusStyle: __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].getStatusStyle,
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].getOrderStatusText,
    getBalanceTypeName: function getBalanceTypeName() {
      if (!this.orderDetail) return '';
      return this.orderDetail.balanceType === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].BALANCE_TYPE_CUSTOMER ? '个人结算' : this.orderDetail.researchGroupName;
    },
    getPayTypeName: function getPayTypeName() {
      if (!this.orderDetail) return '';
      return this.orderDetail.payType === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */].PAY_TYPE_FAPIAO ? '发票支付' : '余额支付';
    },
    getDeliverMethod: function getDeliverMethod() {
      if (!this.orderDetail) return '';
      return this.orderDetail.expressFree ? '不发货' : '顺丰快递';
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

// import EMKT from '../../constant'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcOrderDetailButtonsBase',
  emits: ['goToInvoice', 'goToCustomerGoods'],
  props: {
    orderDetail: Object,
    showCustomerGoodsBtn: Boolean,
    showInvoiceBtn: Boolean
  },
  methods: {}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_components_GcOrderProductBase_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_components_GcOrderProductBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__product_components_GcOrderProductBase_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    orderList: Array,
    showProductContractNo: Boolean
  },
  emits: ['goToOrderDetail'],
  components: { GcOrderProduct: __WEBPACK_IMPORTED_MODULE_1__product_components_GcOrderProductBase_vue___default.a },
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */]
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].getOrderStatusText,
    getStatusStyle: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].getStatusStyle,
    stringSet: function stringSet(str) {
      if (str) {
        var s = str.replace(/&nbsp;/ig, ' ');
        return s;
      } else {
        return '';
      }
    },

    goToOrderDetail: function goToOrderDetail(order) {
      __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].setLocalStorage('currentOrderDetail', order);
      this.$emit('goToOrderDetail', order);
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(42);
//
//
//
//
//
//
//

// import EMKT from '../../constant'



/* harmony default export */ __webpack_exports__["default"] = ({
  emits: ['goToProgress', 'downloadOrderText'],
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    showProgressBtn: function showProgressBtn() {
      return __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].showProgressBtn(this.orderDetail) && !__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].isGVAPContract(this.orderDetail);
    },
    showDownloadContractBtn: function showDownloadContractBtn() {
      // 线下订单不支持下载合同文本
      return __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].showDownloadOrderTextBtn(this.orderDetail);
    }
  },
  methods: {
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].getOrderStatusText
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GcSingleSelection_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GcSingleSelection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GcSingleSelection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcSearchInput_vue__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GcSearchInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GcSearchInput_vue__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GcOrderSearchBox',
  components: { GcSingleSelection: __WEBPACK_IMPORTED_MODULE_1__components_GcSingleSelection_vue___default.a, GcSearchInput: __WEBPACK_IMPORTED_MODULE_2__components_GcSearchInput_vue___default.a },
  data: function data() {
    return {
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */],
      keyword: '',
      memberNames: []
    };
  },

  props: {
    memberList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    displayInBrowser: Boolean
  },
  computed: {
    searchConditionMap: function searchConditionMap() {
      return {
        keyword: this.keyword || '',
        memberNames: this.memberNames || []
      };
    }
  },
  emits: ['updateSearchMap'],
  methods: {
    handleFilter: function handleFilter(keyword) {
      this.keyword = keyword;
      this.$emit('updateSearchMap', this.searchConditionMap);
    },
    handleUpdateSelection: function handleUpdateSelection(memberNames) {
      this.memberNames = memberNames;
      this.$emit('updateSearchMap', this.searchConditionMap);
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EMKT from '../constant'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    item: Object,
    order: Object,
    showProductContractNo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      baseurl: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].MERCHANDISE_IMG_BASE_URL,
      serviceUrl: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].MERCHANDISE_IMG_BASE_URL + 'service.png',
      emkt: __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */]
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    stringSet: function stringSet(str) {
      if (str) {
        var s = str.replace(/&nbsp;/ig, ' ');
        return s;
      } else {
        return '';
      }
    },
    calTagName: function calTagName(item) {
      var iconTag = void 0;
      var type = item.iconTag;
      console.log('type:', type);
      if (type === __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].PRODUCT_TYPE_ID.customMade) {
        iconTag = __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE;
      } else if (type === __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].PRODUCT_TYPE_ID.amplification) {
        iconTag = __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION;
      } else {
        iconTag = __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].PRODUCT_CATEGORY_ICON_TAG_STOCK;
      }
      return __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].MERCHANDISE_IMG_BASE_URL_RTMES + '/imgs/toolVector/' + __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].ICON_TAG_IMAGE_MAP[iconTag];
    },
    getSmartFileSrc: function getSmartFileSrc(iconGuid) {
      return __WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */].MERCHANDISE_IMG_BASE_URL_SMART + '/smart-files/preview/' + iconGuid;
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchContact__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchContact__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import EMKT from '../../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      stage: 1,
      url: '',
      showSearchContact: false
    };
  },
  mounted: function mounted() {
    if (!this.hasLogin) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请登录');
      return this.$router.push({ name: 'login' });
    }
    this.checkIfUploadAlready();
  },

  components: {
    SearchContact: __WEBPACK_IMPORTED_MODULE_3__SearchContact___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName']), {
    ifShowIcon: function ifShowIcon() {
      return 'visibility:' + (this.url ? 'hidden;' : 'visible;');
    },
    mobile: function mobile() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile;
    },
    enterpriseName: function enterpriseName() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName;
    },
    customerNo: function customerNo() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo;
    }
  }),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    changeImagePositive: function changeImagePositive(e) {
      var file = e.target.files && e.target.files[0];
      if (!file) return;
      var isAllowedUpdate = this.checkImage(file);
      if (!isAllowedUpdate) {
        return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('上传图片过大');
      }
      this.imgFile = file;
      var reader = new FileReader();
      var _this = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        _this.url = this.result;
        console.log(file);
      };
    },
    checkImage: function checkImage(file) {
      var maxSize = 5 * 1024; // 5mb
      var size = file.size;
      var isAllow = false;
      maxSize = maxSize * 1024; // 转化为字节数
      isAllow = size <= maxSize;
      return isAllow;
    },
    goToNextStep: function goToNextStep() {
      if (this.stage === 2 && !this.url) return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请上传您的工牌');
      this.stage += 1;
    },
    goToLastStep: function goToLastStep() {
      this.stage -= 1;
    },
    toggleShowSearchContact: function toggleShowSearchContact() {
      this.showSearchContact = !this.showSearchContact;
    },
    checkIfUploadAlready: function checkIfUploadAlready() {
      var _this2 = this;

      var formData = new FormData();
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      var url = '/gcapi/formDataCollect/applyCustomerAdditionalinfos?customerNo=' + this.customerNo + '&activityName=\u63F4\u9102\u6D3B\u52A8';
      this.$http.post(url, formData, config).then(function (res) {
        if (res.body.code === 0) {
          _this2.stage = 1; // 未上传过文件
        } else {
          _this2.stage = 4; // 已上传过文献
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('已完成认证');
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    uploadIdentification: function uploadIdentification(queryName, queryMobile) {
      var _this3 = this;

      if (!this.imgFile) return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请上传身份证明');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.showPreloader('上传中');
      console.log('uploadIdentification');
      var formData = new FormData();
      formData.append('positive', this.imgFile);
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      var url = '/gcapi/formDataCollect/applyCustomerAdditionalinfos?customerNo=' + this.customerNo + '&activityName=\u63F4\u9102\u6D3B\u52A8';
      this.$http.post(url, formData, config).then(function (res) {
        if (res.body.code === 0) {
          _this3.saveInfoCollectionIntoDB(queryName, queryMobile);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(res.body.message);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    saveInfoCollectionIntoDB: function saveInfoCollectionIntoDB(queryName, queryMobile) {
      var _this4 = this;

      var formCollectionActivity = {
        'customerNo': this.customerNo,
        'customerMobile': this.mobile,
        'customerName': this.customerName,
        'customerEnterpriseName': this.enterpriseName,
        'activityName': '援鄂活动',
        'additionalinfos': []
      };
      formCollectionActivity['additionalinfos'].push({
        'columnName': '券是否自用',
        'columnValue': queryMobile === this.mobile ? '券自用' : '券赠送'
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者电话号码',
        'columnValue': queryMobile
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者姓名',
        'columnValue': queryName
      });
      var formCollectionActivityList = [];
      formCollectionActivityList.push(formCollectionActivity);
      this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.hidePreloader();
        // 如果转赠，发送注册短信
        if (queryMobile !== _this4.mobile) {
          _this4.sendRegistrationText(queryName, queryMobile);
        }
        _this4.goToNextStep();
      });
    },
    sendRegistrationText: function sendRegistrationText(name, mobile) {
      var textString = name + '\u8001\u5E08\uFF0C\u60A8\u597D\uFF01\u60A8\u7684\u597D\u53CB' + this.customerName + '\u8001\u5E08\u56E0\u4E3A\u53C2\u4E0E\u63F4\u9102\u6D3B\u52A8\uFF0C\u4EAB\u53D7\u5409\u51EF\u57FA\u56E0\u63D0\u4F9B\u7684\u4E13\u5C5E\u300C\u5B9A\u5236\u4EA7\u54C16\u6298\u5238\u300D\uFF0C\u4ED6\u5DF2\u7ECF\u5C06\u8BE5\u798F\u5229\u8D60\u4E0E\u60A8\u4F7F\u7528\uFF0C\u60A8\u53EF\u4EE5\u767B\u5F55\u5409\u51EF\u6DD8\u57FA\u56E0\u5546\u57CEwww.taogene.com\u67E5\u770B\u798F\u5229\u5E76\u4F7F\u7528';
      var queryParam = {};
      queryParam.mobile = mobile;
      queryParam.message = textString;
      this.gcapi('@gcwwwifc/requestRegiserInvitation', queryParam).then(function (res) {
        if (res && res.body.code === 0) return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('发送成功');
        return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('发送失败');
      });
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_swiper_swiper_min_css__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_swiper_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_swiper_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Anniversary_PageStart_index__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Anniversary_PageStart_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Anniversary_PageStart_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Anniversary_PageRoadmap_index__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Anniversary_PageRoadmap_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Anniversary_PageRoadmap_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Anniversary_PageMeet_index__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Anniversary_PageMeet_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Anniversary_PageMeet_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Anniversary_PageContract_index__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Anniversary_PageContract_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Anniversary_PageContract_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Anniversary_PageContractFirst_index__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Anniversary_PageContractFirst_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Anniversary_PageContractFirst_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Anniversary_PageContractLast_index__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Anniversary_PageContractLast_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Anniversary_PageContractLast_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Anniversary_PageActivities_index__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Anniversary_PageActivities_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Anniversary_PageActivities_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Anniversary_PageCoupon_index__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Anniversary_PageCoupon_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Anniversary_PageCoupon_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Anniversary_PageFinal_index__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Anniversary_PageFinal_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Anniversary_PageFinal_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Anniversary_PageKeyWords_index_vue__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Anniversary_PageKeyWords_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Anniversary_PageKeyWords_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Anniversary_PageKeyWordsReslut_index_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Anniversary_PageKeyWordsReslut_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Anniversary_PageKeyWordsReslut_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_animate__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      swiper: null,
      isWapp: true,
      data: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])(['hasLogin'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vuex__["b" /* mapMutations */])(['toggleCustomerService']), {
    getAnniversaryDetail: function getAnniversaryDetail() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.hasLogin) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return _this.gcapi('getAnniversaryEventInfo');

              case 3:
                return _context.abrupt('return', _context.sent);

              case 6:
                _this.$weui.topTips('请您先登录~', 1000);
                __WEBPACK_IMPORTED_MODULE_16_wx___default.a.miniProgram.navigateTo({
                  url: '/pages/login/login?redirectH5PathName=anniversary'
                });
                return _context.abrupt('return', false);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  components: { PageStart: __WEBPACK_IMPORTED_MODULE_5__components_Anniversary_PageStart_index___default.a, PageRoadmap: __WEBPACK_IMPORTED_MODULE_6__components_Anniversary_PageRoadmap_index___default.a, PageMeet: __WEBPACK_IMPORTED_MODULE_7__components_Anniversary_PageMeet_index___default.a, PageContract: __WEBPACK_IMPORTED_MODULE_8__components_Anniversary_PageContract_index___default.a, PageContractFirst: __WEBPACK_IMPORTED_MODULE_9__components_Anniversary_PageContractFirst_index___default.a, PageContractLast: __WEBPACK_IMPORTED_MODULE_10__components_Anniversary_PageContractLast_index___default.a, PageActivities: __WEBPACK_IMPORTED_MODULE_11__components_Anniversary_PageActivities_index___default.a, PageCoupon: __WEBPACK_IMPORTED_MODULE_12__components_Anniversary_PageCoupon_index___default.a, PageContent: __WEBPACK_IMPORTED_MODULE_13__components_Anniversary_PageFinal_index___default.a, PageKeyWords: __WEBPACK_IMPORTED_MODULE_14__components_Anniversary_PageKeyWords_index_vue___default.a, PageKeyWordsReslut: __WEBPACK_IMPORTED_MODULE_15__components_Anniversary_PageKeyWordsReslut_index_vue___default.a },
  beforeMount: function beforeMount() {
    this.toggleCustomerService(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.toggleCustomerService(false);
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res, showRes;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return _this2.getAnniversaryDetail();

            case 3:
              res = _context2.sent;

              if (!(res === false)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return');

            case 6:
              _this2.data = res.data.result || {};
              _context2.next = 9;
              return _this2.gcapi('getIfShowAnniversaryPrize');

            case 9:
              showRes = _context2.sent;

              _this2.data.showPrize = showRes.data.result;
              console.log('res:', res.data.result, showRes.data.result);

              _this2.$nextTick(function () {
                var swiper = new __WEBPACK_IMPORTED_MODULE_3_swiper__["a" /* default */]('.swiper', {
                  direction: 'vertical',
                  pagination: false,
                  on: {
                    init: function init(swiper) {
                      __WEBPACK_IMPORTED_MODULE_17__util_animate__["a" /* swiperAnimateCache */](swiper); // 隐藏动画元素
                      __WEBPACK_IMPORTED_MODULE_17__util_animate__["b" /* swiperAnimate */](swiper); // 初始化完成开始动画
                    },
                    slideChangeTransitionEnd: function slideChangeTransitionEnd() {
                      __WEBPACK_IMPORTED_MODULE_17__util_animate__["b" /* swiperAnimate */](swiper); // 每个slide开始切换时也运行当前slide动画
                    }
                  }
                });

                _this2.swiper = swiper;
              });
              _this2.loading = false;

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    if (this.ifShowLottery) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.showPreloader('正在查询活动信息');
      this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then(function (res) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.hidePreloader();
        if (res.body.result && res.body.result.length > 0) {
          var lotteryInfo = res.body.result[0];
          _this.lotteryUrl = lotteryInfo.url;
        }
      });
    }
  },
  data: function data() {
    return {
      constants: {},
      result: this.$route.query.result,
      text: this.$route.query.text,
      ifShowLottery: this.$route.query.showLottery,
      lotteryUrl: ''
    };
  },

  methods: {
    goHome: function goHome() {
      this.$router.replace({ name: 'home' });
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      constants: {},
      nameQuery: '',
      mobileQuery: '',
      waitRegister: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName']), {
    mobile: function mobile() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile;
    },
    enterpriseName: function enterpriseName() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName;
    },
    customerNo: function customerNo() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo;
    }
  }),
  methods: {
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).focus();
    },
    resetWindow: function resetWindow() {
      setTimeout(function () {
        window.scrollTo(0, 0);
        console.log('reset invoked');
      }, 300);
    },
    validatemobile: function validatemobile(mobile) {
      if (mobile.length === 0) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('手机号码不能为空');
        return false;
      }
      var myreg = /^1[3-9]{1}[0-9]{9}$/;
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('请输入有效的手机号码');
        return false;
      }
      return true;
    },
    searchContact: function searchContact() {
      var _this = this;

      this.resetWindow();
      if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('请输入姓名和正确的手机号');
        return;
      }
      // 根据联系人手机号、姓名搜索联系人个人信息
      if (this.hasLogin) {
        var queryParam = {};
        queryParam.customerName = this.nameQuery;
        queryParam.mobile = this.mobileQuery;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showPreloader('查询中');
        this.gcapi('@gcwwwifc/queryCustomerInfoByMobileAndName', queryParam).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hidePreloader();
          if (response && response.body === 'null') {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
              title: '该用户未注册',
              text: '邀请用户注册后，发放折扣券。若该用户已经注册，请重新核对您填写的信息是否正确',
              buttons: [{
                text: '核对信息',
                onClick: function onClick() {}
              }, {
                text: '邀请注册',
                onClick: function onClick() {
                  _this.waitRegister = true;
                  _this.saveInfoCollectionIntoDB(_this.nameQuery, _this.mobileQuery);
                }
              }]
            });
            return;
          } else if (response && response.body.length > 0) {
            _this.waitRegister = false;
            _this.saveInfoCollectionIntoDB(_this.nameQuery, _this.mobileQuery);
          }
        }).catch(function (e) {
          console.log('e', e);
        });
      }
    },
    sendRegistrationText: function sendRegistrationText(name, mobile) {
      var textString = name + '\u8001\u5E08\uFF0C\u60A8\u597D\uFF01\u60A8\u7684\u597D\u53CB' + this.customerName + '\u8001\u5E08\u56E0\u4E3A\u53C2\u4E0E\u63F4\u9102\u6D3B\u52A8\uFF0C\u4EAB\u53D7\u5409\u51EF\u57FA\u56E0\u63D0\u4F9B\u7684\u4E13\u5C5E\u300C\u5B9A\u5236\u4EA7\u54C16\u6298\u5238\u300D\uFF0C\u4ED6\u5DF2\u7ECF\u5C06\u8BE5\u798F\u5229\u8D60\u4E0E\u60A8\u4F7F\u7528\uFF0C\u60A8\u53EF\u4EE5\u767B\u5F55\u5409\u51EF\u6DD8\u57FA\u56E0\u5546\u57CEwww.taogene.com\u67E5\u770B\u798F\u5229\u5E76\u4F7F\u7528';
      var queryParam = {};
      queryParam.mobile = mobile;
      queryParam.message = textString;
      this.gcapi('@gcwwwifc/requestRegiserInvitation', queryParam).then(function (res) {
        if (res && res.body.code === 0) return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('发送成功');
        return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('发送失败');
      });
    },
    saveInfoCollectionIntoDB: function saveInfoCollectionIntoDB(queryName, queryMobile) {
      var _this2 = this;

      var formCollectionActivity = {
        'customerNo': this.customerNo,
        'customerMobile': this.mobile,
        'customerName': this.customerName,
        'customerEnterpriseName': this.enterpriseName,
        'activityName': '618领取优惠券',
        'attachmentName': __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('promotionGuids618Used'),
        'additionalinfos': []
      };
      formCollectionActivity['additionalinfos'].push({
        'columnName': '券是否自用',
        'columnValue': queryMobile === this.mobile ? '券自用' : '券赠送'
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者电话号码',
        'columnValue': queryMobile
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者姓名',
        'columnValue': queryName
      });
      var formCollectionActivityList = [];
      formCollectionActivityList.push(formCollectionActivity);
      this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then(function (response) {
        // 领取优惠券后，清空订单中使用的618促销guids
        __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setStoreItem('promotionGuids618Used', '');
        var result = void 0,
            text = void 0;
        // 如果转赠，发送注册短信
        if (queryMobile !== _this2.mobile) {
          _this2.sendRegistrationText(queryName, queryMobile);
          result = _this2.waitRegister ? '邀请成功' : '转赠成功';
          text = _this2.waitRegister ? '已向该用户发送注册短信邀请，折扣券将在用户完成注册后的3-5个工作日发放完毕' : '折扣券将在3-5个工作日发放完毕';
        } else {
          result = '领取成功';
          text = '折扣券将在3-5个工作日发放完毕';
        }
        _this2.$router.replace({ name: 'OperationResult', query: { result: result, text: text, 'showLottery': _this2.$route.query.showLottery } });
      });
    },
    changeMind: function changeMind() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        title: '您确认要放弃领券？',
        buttons: [{
          text: '放弃',
          onClick: function onClick() {
            _this3.$router.replace({ name: 'home' });
          }
        }, {
          text: '转赠自己',
          onClick: function onClick() {
            _this3.waitRegister = false;
            _this3.saveInfoCollectionIntoDB(_this3.customerName, _this3.mobile);
          }
        }, {
          text: '取消',
          onClick: function onClick() {}
        }]
      });
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['remindParams'],
  methods: {
    cancel: function cancel() {
      this.$emit('toggleShow');
    },
    confirm: function confirm() {
      this.$emit('toggleShow');
      this.$emit('confirm');
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemindBox__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemindBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RemindBox__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import EMKT from '../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mobileQuery: '',
      nameQuery: '',
      contactDetail: {},
      showRemindBox: false,
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin'])),
  components: {
    RemindBox: __WEBPACK_IMPORTED_MODULE_3__RemindBox___default.a
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    toggleShowRemindBox: function toggleShowRemindBox() {
      this.showRemindBox = !this.showRemindBox;
    },
    validatemobile: function validatemobile(mobile) {
      if (mobile.length === 0) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('手机号码不能为空');
        return false;
      }
      var myreg = /^1[3-9]{1}[0-9]{9}$/;
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入有效的手机号码');
        return false;
      }
      return true;
    },
    resetWindow: function resetWindow() {
      setTimeout(function () {
        window.scrollTo(0, 0);
        console.log('reset invoked');
      }, 300);
    },
    searchContact: function searchContact() {
      var _this = this;

      this.resetWindow();
      this.contactDetail = {};
      if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入姓名和正确的手机号');
        return;
      }
      // 根据联系人手机号、姓名搜索联系人个人信息
      if (this.hasLogin) {
        var queryParam = {};
        queryParam.customerName = this.nameQuery;
        queryParam.mobile = this.mobileQuery;
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.showPreloader('查询中');
        this.gcapi('@gcwwwifc/queryCustomerInfoByMobileAndName', queryParam).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.hidePreloader();
          if (response && response.body === 'null') {
            _this.remindParams.firstline = '该用户未注册';
            _this.remindParams.secondline = '是否发送注册邀请？';
            _this.remindParams.singleOrDouble = 2;
            _this.toggleShowRemindBox();
            return;
          } else if (response && response.body.length > 0) {
            _this.contactDetail = response.body[0];
          }
        }).catch(function (e) {
          console.log('e', e);
        });
      }
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).focus();
    },
    infoCollectionTransfer: function infoCollectionTransfer() {
      this.$emit('finish', this.nameQuery, this.mobileQuery);
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      coolDown: false
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin', 'isWapp'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: {
    fetchData: function fetchData() {},
    returnCart: function returnCart() {
      if (__WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({
          url: '/pages/cart/cart'
        });
      } else {
        this.$router.replace({ name: 'cart' });
      }
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_components_FooterPlaceholder_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_components_FooterPlaceholder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_v_2_6_components_FooterPlaceholder_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import emkt from '../../emkt.js'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (this.$route.query.customerNo !== this.sessionInfo.customerInfo.customerNo) {
      this.disabled = true;
    }
  },
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      disabled: false,
      orderId: this.$route.query.orderId,
      customerName: '',
      mobile: '',
      canEdit: true,
      showConfirmedButton: false
    };
  },

  components: {
    FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_components_FooterPlaceholder_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin', 'isWapp'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      if (this.sessionInfo.customerInfo) {
        // 获取最新的客户信息
        this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(function (response) {
          if (response.body.result) {
            _this2.customerName = response.body.result.customerName;
            _this2.mobile = response.body.result.mobile;
          } else {
            _this2.customerName = _this2.sessionInfo.customerInfo.customerName;
            _this2.mobile = _this2.sessionInfo.customerInfo.mobile;
          }
        });
      }
    },
    goShowConfirmedButton: function goShowConfirmedButton() {
      var title = '姓名: ' + this.customerName + '</br>' + '手机：' + this.mobile;
      var _this = this;
      _this.$weui.confirm(title, {
        title: '确认实名信息',
        buttons: [{
          label: '返回修改',
          type: 'default',
          onClick: function onClick() {
            console.log('no');
          }
        }, {
          label: '确认发起',
          type: 'primary',
          onClick: function onClick() {
            _this.sendAuthentication();
          }
        }]
      });
      // this.showConfirmedButton = true
    },
    sendAuthentication: function sendAuthentication() {
      var _this3 = this;

      var _this = this;
      var authenticationInfo = {
        customerName: this.customerName,
        mobile: this.mobile,
        orderId: this.orderId
      };
      _this.$weui.loading('正在发送短信');
      _this.gcapi('startEmktSignFlowByCustomer', authenticationInfo).then(function (response) {
        _this.$weui.loading().hide();
        if (response.body.message !== '') {
          _this.$weui.toast(response.body.message, 3000);
        } else {
          _this.$weui.toast('短信已经发送！', 3000);
          _this.$router.push({ name: 'sendAuthentication', params: { authenticationInfo: authenticationInfo }, query: { orderId: _this3.orderId, canShow: true, time: 60 } });
        }
      }, function (response) {
        console.log(response.body.message);
        _this.$weui.toast(response.body.message, 2500);
      });
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).focus();
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      coolDown: false,
      resendTime: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin', 'isWapp'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  mounted: function mounted() {
    console.log(this.$route, 'sssssssssssssssss');
    this.$route.query.time ? this.counterWithoutSend() : '';
  },

  methods: {
    fetchData: function fetchData() {
      if (this.$route.params.authenticationInfo) {
        this.sendAuthenticationMesage();
      }
    },
    sendAuthenticationMesage: function sendAuthenticationMesage() {
      var _this = this;

      this.$weui.loading('正在发送短信');
      this.gcapi('startEmktSignFlowByCustomer', this.$route.params.authenticationInfo).then(function (response) {
        _this.$weui.loading().hide();
        if (response.body.message !== '') {
          _this.$weui.toast(response.body.message, 3000);
        } else {
          _this.$weui.toast('短信已经发送！', 3000);
        }
      }, function (response) {
        _this.$weui.toast(response.body.message, 2500);
      });
    },
    revert: function revert() {
      __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setLocalStorage('authenticationSource', null);
      if (__WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    returnAuthenticationHome: function returnAuthenticationHome() {
      this.$router.back();
    },
    counterWithoutSend: function counterWithoutSend() {
      var _this2 = this;

      clearInterval(countTime);
      this.resendTime = 60;
      var countTime = setInterval(function () {
        if (_this2.resendTime > 0) {
          _this2.resendTime--;
        } else {
          clearInterval(countTime);
        }
      }, 1000);
    },
    counter: function counter() {
      var _this3 = this;

      clearInterval(countTime);
      this.sendAuthenticationMesage(true);
      this.resendTime = 60;
      var countTime = setInterval(function () {
        if (_this3.resendTime > 0) {
          _this3.resendTime--;
        } else {
          clearInterval(countTime);
        }
      }, 1000);
    },
    checkOrderStatus: function checkOrderStatus() {
      var _this4 = this;

      this.gcapi('getWaitPayOrderInfoByOrderId', parseInt(this.$route.query.orderId)).then(function (res) {
        if (res.body.code === 0) {
          var signStatus = res.body.result.signStatus;
          if (signStatus === 2) {
            _this4.$router.replace({ name: 'WeappSuccessPay', params: { orderId: _this4.orderId } });
          } else {
            _this4.$weui.dialog({
              content: '您还未完成签署',
              buttons: [{
                label: '我知道了'
              }]
            });
          }
        } else {
          alert('获取电签状态失败，请检查你的网络或联系客服！');
        }
      });
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__finder_components_NewMerchandiseListC_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__finder_components_NewMerchandiseListC_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__finder_components_NewMerchandiseListC_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_js_md5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_js_md5__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    console.log('this.cartList', this.cartList);
    this.getAllChecked();
    this.getSecPromotionInfo();
    this.initNumForSecPromtion();
    if (this.shareCartId) {
      console.log('shareCartId', __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].getLocalStorage('shareCartId'));
      this.ifShowBox = true;
    }
  },
  created: function created() {
    var _this2 = this;

    // this.initVipPLan()
    // 下拉刷新
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()(document).ready(function () {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.initPullToRefresh('.pull-to-refresh-content');
    });
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()(document).on('refresh', '.pull-to-refresh-content', function () {
      _this2.getNonSalesforceShoppingCart();
    });
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_8__components_MerchandiseList_vue___default.a, newMerchandiseListC: __WEBPACK_IMPORTED_MODULE_9__finder_components_NewMerchandiseListC_vue___default.a
  },
  data: function data() {
    return {
      recomPproducts: this.emkt.getLocalStorage('EmktAllRecommends'),
      isCheckedAll: false,
      result: 0,
      confirmDelete: false,
      QuoteStatus: this.emkt.getLocalStorage('QuoteStatus'),
      readyToDelIndex: -1,
      isActivity: false,
      totalGoodsNum: 0,
      baseurl: '/emktResources/resocurces/img/merchandise/',
      description: '为你推荐',
      totalPrice: 0,
      isSsoFlag: this.emkt.buyCartIsLocalStorage,
      isCustomFlag: false, // 是否来自定制
      IShints: false,
      baseUrl: '/emktResources/resocurces/img/pay/',
      numOfSecPromotionProducts: {},
      numRequiredForSecPromotion: {},
      secPromotion: __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].getLocalStorage('EmktSecPromotion'),
      ifShowShareInstruction: false,
      shareCartId: __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].getLocalStorage('shareCartId'),
      ifShowBox: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapMutations */])([__WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__["a" /* REMOVE_FROM_CART_LIST */], __WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__["b" /* DELETE_CART_LIST */], __WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__["c" /* ADD_CART_LIST */], __WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__["d" /* ADD_CHECK_LIST */], __WEBPACK_IMPORTED_MODULE_7__store_mutation_type_js__["e" /* REMOVE_ALL_CHECKLIST_FROM_CART_LIST */], 'SET_SECPROMOTION_INFO', 'COMBINE_CART_LIST', 'UPDATE_CART_CONTENT']), {
    shareBuyCartContent: function shareBuyCartContent() {
      var _this3 = this;

      if (!this.checkList || this.checkList.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('请勾选分享商品');
        return;
      }
      var shareCartContent = {};
      for (var i = 0; i < this.checkList.length; i++) {
        var cartIdName = this.checkList[i].categoryId === 20 ? 'cartid' : 'merchandiseId';
        var shareKey = this.checkList[i][cartIdName];
        shareCartContent[shareKey] = this.cartList.cartContent[shareKey];
      }
      var cartJsonString = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(shareCartContent);
      var cartMD5 = __WEBPACK_IMPORTED_MODULE_11_js_md5___default()(cartJsonString).toUpperCase();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('正在生成分享链接');
      this.gcapi('saveShareShoppingCart', { 'cartContent': cartJsonString, 'cartMD5': cartMD5 }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
        if (response.body.code === 0) {
          console.log('create shareCartId successfully');
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
            afterText: '<div>分享链接生成成功!<br>点击分享给好友</div>',
            buttons: [{
              text: '取消',
              bold: true,
              onClick: function onClick() {
                console.log('cancel');
              }
            }, {
              text: '分享',
              bold: true,
              onClick: function onClick() {
                var shareUrl = __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].wxShareUrl;
                shareUrl += '?shareCartId=' + response.body.result;
                __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.sign.shareUrl = shareUrl;
                __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].wxShare();
                _this3.ifShowShareInstruction = true;
              }
            }]
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('保存失败！');
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
          }, 1000);
        }
      });
    },
    getShareCartContent: function getShareCartContent() {
      var _this4 = this;

      this.ifShowBox = false;
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('查询中');
      this.gcapi('getShareShoppingCart', this.shareCartId).then(function (res) {
        if (res && res.body.code === 0) {
          var cart = void 0;
          // DB中无购物车记录或者记录为空{}
          if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('分享内容不存在');
          } else {
            cart = res.body.result.cartContent;
            var shareCartContent = JSON.parse(cart);
            var currentCartContent = _this4.cartList.cartContent;
            var shareMerchandiseCount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(shareCartContent).length;
            var existedMerchdiseCount = 0;
            // 合并购物车,分享内容置前，若购物车内已存在分享商品，不再重复添加。
            for (var id in currentCartContent) {
              // insert cartList.cartContent into shareCartContent
              if (id in shareCartContent) {
                existedMerchdiseCount++;
                if (shareCartContent[id].categoryId !== 20) {
                  shareCartContent[id].productQuantity = currentCartContent[id].productQuantity;
                }
              } else {
                shareCartContent[id] = currentCartContent[id];
              }
            }
            shareMerchandiseCount -= existedMerchdiseCount;
            var remindText = '';
            if (shareMerchandiseCount === 0) {
              remindText = '已有商品不再重复添加';
            } else if (existedMerchdiseCount === 0) {
              remindText = '\u6210\u529F\u6DFB\u52A0' + shareMerchandiseCount + '\u4E2A\u5546\u54C1';
            } else {
              remindText = '\u6210\u529F\u6DFB\u52A0' + shareMerchandiseCount + '\u4E2A\u5546\u54C1\uFF0C\u5DF2\u6709\u5546\u54C1\u4E0D\u518D\u91CD\u590D\u6DFB\u52A0';
            }
            _this4.UPDATE_CART_CONTENT(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(shareCartContent));
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast(remindText);
          }
        }
      });
    },
    initNumForSecPromtion: function initNumForSecPromtion() {
      var numForSecPromtion = {};
      var numRequired = {};
      for (var promotionGuid in this.secPromotionDetailObj) {
        numForSecPromtion[promotionGuid] = 0;
        numRequired[promotionGuid] = this.secPromotionDetailObj[promotionGuid].requiredQuantity;
      }
      this.numRequiredForSecPromotion = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, numRequired);
      this.numOfSecPromotionProducts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, numForSecPromtion);
      console.log('numForSecPromtion', this.numRequiredForSecPromotion, this.numOfSecPromotionProducts);
    },
    gotoOrderContentConfirm: function gotoOrderContentConfirm() {
      if (this.hasLogin === false) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('请登录');
        this.$router.push({ name: 'login' });
        return;
      }
      this.checkNotAvailableMerchandises();
    },
    checkNotAvailableMerchandises: function checkNotAvailableMerchandises() {
      var _this5 = this;

      // 只检查工具类商品的有效性
      var merchandiseIdList = this.checkList.filter(function (mer) {
        return mer.categoryId !== __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT;
      }).map(function (merchandise) {
        return merchandise.merchandiseId;
      });
      var serviceProductList = this.checkList.filter(function (mer) {
        return mer.categoryId === __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT;
      });
      if (this.checkList.length !== serviceProductList.length && this.checkList.length !== merchandiseIdList.length) {
        this.$weui.alert('工具类和服务类产品不可一起下单');
        return;
      }
      this.gcapi('getNotAvailableMerchandiseId', merchandiseIdList).then(function (res) {
        if (res.body.code === 0) {
          var notAvailableIds = res.body.result;
          if (notAvailableIds.length === 0) {
            _this5.ifCanGoCheck();
          } else {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(notAvailableIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var notAvailableId = _step.value;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.checkList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var merchandise = _step2.value;

                    if (notAvailableId === merchandise.merchandiseId) {
                      merchandise.availableFlag = 0;
                      merchandise.isChecked = false;
                      console.log('find merchandise not availble', merchandise);
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('部分商品已下架，请重新选择');
            return;
          }
        }
      });
    },
    ifCanGoCheck: function ifCanGoCheck() {
      this.IShints = false;
      this.transporthints();
      var _this = this;
      console.log(this.checkList);
      var cangocheck = true;
      var stock = [];
      var cust = [];
      for (var i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].categoryId === __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT) {
          continue;
        }
        if (this.checkList[i].stockOrCustomized === 1) {
          cust.push(this.checkList[i].priceMax);
        } else {
          stock.push(this.checkList[i].priceMax * this.checkList[i].productQuantity);
        }
        if (this.checkList[i].salesLimit > 0) {
          if (this.checkList[i].productQuantity > this.checkList[i].salesLimit - this.checkList[i].totalSales) {
            alert('您所购买的商品' + this.checkList[i].merchandiseLabel + '为限购商品，此商品还剩余' + (this.checkList[i].salesLimit - this.checkList[i].totalSales) + '个，请您重新选择');
            cangocheck = false;
            break;
          }
        }
        if (this.checkList[i].newMerch === undefined && (this.checkList[i].manualFileName.indexOf('腺相关') !== -1 || this.checkList[i].manualFileName.indexOf('神经环路标记病毒') !== -1)) {
          this.$weui.alert('老师：您好！\n' + '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' + '感谢您的支持！');
          cangocheck = false;
          break;
        }
      }
      var stockprice = 0;
      for (var pi in stock) {
        stockprice = stockprice + stock[pi];
      }
      var custprice = 0;
      for (var pe in cust) {
        custprice = custprice + cust[pe];
      }
      var now = Date.parse(new Date());
      var lotteryStartDT = new Date('2020/6/24 0:0:0');
      var lotteryEndDT = new Date('2020/6/24 23:59:59');
      var promotiontime = false;
      if (now >= Date.parse(lotteryStartDT) && now <= Date.parse(lotteryEndDT)) {
        promotiontime = true;
      }
      if (custprice >= 3000 && stockprice >= 2000 && promotiontime) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
          title: '小提示',
          afterText: '<div>老师，将【现货】与【定制】产品分开下单可以享受更低优惠价哦</div>',
          buttons: [{
            text: '继续结算',
            bold: true,
            onClick: function onClick() {
              if (cangocheck) {
                if (_this.IShints) {
                  __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
                    title: '小提示',
                    afterText: '<div>当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?</div>',
                    buttons: [{
                      text: '取消',
                      bold: true,
                      onClick: function onClick() {
                        console.log('cancel');
                      }
                    }, {
                      text: '确定',
                      bold: true,
                      onClick: function onClick() {
                        _this.checkPromotion();
                      }
                    }]
                  });
                  //          $.confirm('当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?',
                  //            function () {
                  //              Emkt.setStoreItem('myCoupons', undefined)
                  //              _this.$router.push({name: 'orderContentConfirm'})
                  //            },
                  //            function () {
                  //              console.log('cancel')
                  //            })
                } else {
                  _this.checkPromotion();
                  //          Emkt.setStoreItem('myCoupons', undefined)
                  //          _this.$router.push({name: 'orderContentConfirm'})
                }
              }
            }
          }, {
            text: '重新选择',
            bold: true,
            onClick: function onClick() {
              return;
            }
          }]
        });
      } else {
        if (cangocheck) {
          if (_this.IShints) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
              title: '小提示',
              afterText: '<div>当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?</div>',
              buttons: [{
                text: '取消',
                bold: true,
                onClick: function onClick() {
                  console.log('cancel');
                }
              }, {
                text: '确定',
                bold: true,
                onClick: function onClick() {
                  _this.checkPromotion();
                }
              }]
            });
            //          $.confirm('当收货地气温低于10℃或高于35℃，或所需运输时间超过48小时，会导致细胞状态较差，不建议您选择常温运输细胞，为节省您宝贵的科研时间，请选择干冰运输细胞！您是否继续进行结算?',
            //            function () {
            //              Emkt.setStoreItem('myCoupons', undefined)
            //              _this.$router.push({name: 'orderContentConfirm'})
            //            },
            //            function () {
            //              console.log('cancel')
            //            })
          } else {
            _this.checkPromotion();
            //          Emkt.setStoreItem('myCoupons', undefined)
            //          _this.$router.push({name: 'orderContentConfirm'})
          }
        }
      }
    },

    //      getbpromotions (merchdise) {
    //        if (merchdise.bpromotions) {
    //          var bpromotions = merchdise.bpromotions
    //          var r = []
    //          var t = []
    //          for (var m = 0; m < bpromotions.length; m++) {
    //            if (t.indexOf(bpromotions[m].type) === -1) {
    //              r.push(bpromotions[m])
    //              t.push(bpromotions[m].type)
    //              // console.log(m + ' ' + bpromotions[m].type)
    //            }
    //          }
    //          console.log(1)
    //          console.log(r)
    //          return r
    //        }
    //      },
    gotoOrderQuotedPriceConfirm: function gotoOrderQuotedPriceConfirm() {
      // if (this.sessionInfo.customerInfo) {
      //   var CustomerPlanParams = {
      //     'CustomerNo': this.sessionInfo.customerInfo.customerNo
      //   }
      //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
      //     var VipPlanList = response.body.result
      //     Emkt.setLocalStorage('VipPlanList', VipPlanList)
      //   })
      // }
      var cango = true;
      for (var i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].newMerch === undefined && (this.checkList[i].manualFileName.indexOf('腺相关') !== -1 || this.checkList[i].productName.indexOf('神经环路标记病毒') !== -1)) {
          this.$weui.alert('老师：您好！\n' + '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' + '感谢您的支持！');
          cango = false;
          break;
        }
      }
      if (cango) {
        __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].setStoreItem('myCoupons', undefined);
        this.$router.push({ name: 'orderContentConfirm' });
      }
    },
    getChecked: function getChecked(product) {
      // if (product.isChecked) {
      //   product.isChecked = false
      // } else {
      //   product.isChecked = true
      // }
      console.log('getChecked' + product.isChecked);
      this.getAllChecked();
    },
    saveBuyCart: function saveBuyCart() {
      var list = this.checkList;
      var savelist = {};
      var i = void 0;
      for (i = 0; i < list.length; i++) {
        for (var item in this.cartList.cartContent) {
          if (item === list[i].merchandiseId) {
            savelist[list[i].merchandiseId] = list[i];
          }
        }
      }
      var saveContent = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(savelist) === '{}' ? null : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(savelist);
      this.gcapi('saveShoppingCart', saveContent).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('保存成功！');
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
          }, 1000);
        } else {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showPreloader('保存失败！');
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hidePreloader();
          }, 1000);
        }
      });
      // this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
    },
    changeQuantity: function changeQuantity(good, val) {
      if (good.productQuantity === void 0) {
        this.$set(good, 'productQuantity', 1);
      }
      if (val === 1) {
        __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviours.cart.addCount.push({ 'time': Date.parse(new Date()), 'target': good.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviourType.addCount });
        this.ADD_CART_LIST(good);
      } else if (val === -1) {
        __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviours.cart.minusCount.push({ 'time': Date.parse(new Date()), 'target': good.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviourType.minusCount });
        if (good.productQuantity === 1 && val === -1) {
          this.removeProduct(good, good.merchandiseId);
        } else {
          this.DELETE_CART_LIST(good);
        }
      }
      this.getAllChecked();
    },
    initVipPLan: function initVipPLan() {
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].setLocalStorage('VipPlanList', null);
      if (this.sessionInfo.customerInfo) {
        var CustomerPlanParams = {
          'CustomerNo': this.sessionInfo.customerInfo.customerNo
        };
        this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then(function (response) {
          var VipPlanList = response.body.result;
          __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].setLocalStorage('VipPlanList', VipPlanList);
        });
      }
    },
    checkedAll: function checkedAll() {
      var self = this;
      if (self.isCheckedAll) {
        self.isCheckedAll = false;
      } else {
        self.isCheckedAll = true;
      }
      console.log('isCheckedAll ' + self.isCheckedAll);
      this.products.forEach(function (item) {
        item.isChecked = self.isCheckedAll;
      });
      this.getAllChecked();
    },
    removeProduct: function removeProduct(product, merchandiseId) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.confirm('您确定删除此商品吗？', function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.showIndicator();
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.hideIndicator();
        }, 300);
        //          _this.products.splice(index, 1)
        if (product.categoryId === 20) {
          var id = product.cartid;
          _this.REMOVE_FROM_CART_LIST(id);
        } else if (product.categoryId === __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT) {
          _this.REMOVE_FROM_CART_LIST(product.cartid);
        } else {
          _this.REMOVE_FROM_CART_LIST(merchandiseId);
        }
        _this.getAllChecked();
        _this.remindSaveBuyCart();
        __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviours.cart.delete.push({ 'time': Date.parse(new Date()), 'target': merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviourType.delete });
      }, function () {
        console.log('cancel');
        __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviours.cart.delete.push({ 'time': Date.parse(new Date()), 'target': merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviourType.cancel });
      });
    },
    getAllChecked: function getAllChecked() {
      var _this6 = this;

      var sum = 0;
      var checks = [];
      var isAllCheckeds = true;
      // 初始化参与秒杀的商品总数
      var initObj = {};
      for (var guid in this.numOfSecPromotionProducts) {
        initObj[guid] = 0;
      }
      this.numOfSecPromotionProducts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, initObj);
      // 统计参与秒杀的商品总数
      this.products.forEach(function (item) {
        if (item.isChecked) {
          if (item.promotions && item.promotions[0] && item.promotions[0].type === 6 && _this6.secFlag === 1) {
            _this6.numOfSecPromotionProducts[item.promotions[0].promotionGuid] += item.productQuantity;
          }
        }
      });
      this.products.forEach(function (item) {
        if (item.isChecked) {
          if (_this6.sessionInfo.customerInfo && _this6.sessionInfo.customerInfo.ssoFlag === 1) {
            sum += item.priceMax * item.productQuantity;
            //  n件享受秒杀折扣
          } else if (item.promotions && item.promotions[0] && item.promotions[0].type === 6 && _this6.secFlag === 1 && _this6.numOfSecPromotionProducts[item.promotions[0].promotionGuid] >= _this6.numRequiredForSecPromotion[item.promotions[0].promotionGuid]) {
            sum += item.priceMax * item.productQuantity * (1 - _this6.secPromotionDetailObj[item.promotions[0].promotionGuid].seckilltRatio);
          } else {
            sum += item.priceMin * item.productQuantity;
          }
          checks.push(item);
        } else {
          isAllCheckeds = false;
        }
      });
      this.isCheckedAll = isAllCheckeds;
      this.ADD_CHECK_LIST(checks);
      sum = sum.toFixed(2);
      this.totalPrice = sum;
    },
    remindSaveBuyCart: function remindSaveBuyCart() {
      var _this7 = this;

      // 当购物车为空时，提醒sf业务员保存购物车
      if (this.isSFFlag === false) {
        return;
      }
      if (this.products && this.products.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.confirm('您是否需要清空数据库购物车？', function () {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('保存中');
          _this7.saveBuyCart();
        }, function () {});
      }
    },
    checkCust: function checkCust() {
      // 定制商品不支持添加数量
      var flag = false;
      var cart = this.cartList.cartContent;
      if (cart) {
        var cur = cart.Customized01;
        if (cur) {
          flag = true;
          __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.toast('定制商品不支持修改数量');
        }
      }
      //        this.isCustomFlag = flag
      return flag;
    },
    goToDetail: function goToDetail(product) {
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].behaviour.time = Date.parse(new Date());
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].behaviour.target = product.merchandiseId;
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].behaviour.type = __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviourType.click;
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].customerBehaviours.cart.goToDetail = __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].behaviour;
      var id = product.categoryId;
      if (id === 10) {
        this.$router.push({ name: 'custDetail', query: { custom: product.merchandiseId } });
      } else {
        //          this.$router.push({name: 'merchandises', query: { id: product.merchandiseId }})
        this.$router.replace({ name: 'FinderOrderDeail', query: { merchandises: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(product), id: 1 } });
        //          this.$router.push({name: 'finderMerchandises', params: {merchandises: product}})
      }
    },
    transporthints: function transporthints() {
      for (var i in this.checkList) {
        for (var j in this.checkList[i]._attributesList) {
          if (this.checkList[i]._attributesList[j].columnName === 'TransportCondition' && this.checkList[i]._attributesList[j].value === 0) {
            this.IShints = true;
            break;
          }
        }
      }
    },
    checkPromotion: function checkPromotion() {
      var allpromotion = [];
      //        if (this.sessionInfo.customerInfo) {
      //          var CustomerPlanParams = {
      //            'CustomerNo': this.sessionInfo.customerInfo.customerNo
      //          }
      //          this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
      //            var VipPlanList = response.body.result
      //            Emkt.setLocalStorage('VipPlanList', VipPlanList)
      //          })
      //        }

      for (var i in this.checkList) {
        for (var j in this.checkList[i]._attributesList) {
          if (this.checkList[i]._attributesList[j].columnName === 'TransportCondition' && this.checkList[i]._attributesList[j].value === 0) {
            this.IShints = true;
            break;
          }
        }
        var promotion = [];
        for (var m in this.checkList[i].showpromotion) {
          if (this.checkList[i].showpromotion[m].type === 1 && this.checkList[i].showpromotion[m].requiredMoney > 0) {
            allpromotion.push(this.checkList[i].showpromotion[m]);
            promotion.push(this.checkList[i].showpromotion[m]);
          }
        }
        this.checkList[i].allpromotion = promotion;
      }
      // var obj = {}
      // allpromotion = allpromotion.reduce(function (item, next) {
      //   obj[next.promotionGuid] ? '' : obj[next.promotionGuid] = true && item.push(next)
      //   return item
      // }, [])
      var _this = this;
      // if (allpromotion.length > 0) {
      //   for (var n in allpromotion) {
      //     var lackmoney = allpromotion[n].requiredMoney
      //     for (var k in _this.checkList) {
      //       for (var l in _this.checkList[k].allpromotion) {
      //         if (_this.checkList[k].allpromotion[l].promotionGuid === allpromotion[n].promotionGuid) {
      //           lackmoney = lackmoney - _this.checkList[k].priceMin * _this.checkList[k].productQuantity
      //         }
      //       }
      //     }
      //     allpromotion[n].lackmoney = lackmoney
      //   }
      //   allpromotion.sort(function (a, b) {
      //     return a.lackmoney - b.lackmoney
      //   })
      // for (var p in allpromotion) {
      // if (allpromotion[p].lackmoney > 0 && allpromotion[p].lackmoney < allpromotion[p].requiredMoney) {
      // $.modal({
      //   title: '小提示',
      //   afterText: '<div>您还差' + allpromotion[p].lackmoney + '元即可参与' + allpromotion[p].name + '活动</div>',
      //   buttons: [
      //     {
      //       text: '暂不结算',
      //       bold: true,
      //       onClick: function () {
      //       }
      //     },
      //     {
      //       text: '继续结算',
      //       bold: true,
      //       onClick: function () {
      //         Emkt.setStoreItem('myCoupons', undefined)
      //         _this.$router.push({name: 'orderContentConfirm'})
      //       }
      //     }
      //   ]
      // })
      //   break
      // } else {
      //   Emkt.setStoreItem('myCoupons', undefined)
      //   _this.$router.push({name: 'orderContentConfirm'})
      // }
      // }
      __WEBPACK_IMPORTED_MODULE_10__emkt_js__["a" /* default */].setStoreItem('myCoupons', undefined);
      // _this.$router.push({name: 'orderContentConfirm'})
      if (_this.sessionInfo.customerInfo.ssoFlag === 1) {
        _this.$router.push({ name: 'orderContentConfirm' });
      } else {
        _this.$router.push({ name: 'WeappOrderContentConfirmation' });
      }
    },
    showSecPromotionInfo: function showSecPromotionInfo(product) {
      if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
        return false;
      }
      // n 件参加秒杀
      if (product.promotions) {
        var guid = product.promotions[0] && product.promotions[0].promotionGuid;
        return product.isChecked && product.promotions[0] && product.promotions[0].type === 6 && this.secFlag === 1 && this.numOfSecPromotionProducts[guid] >= this.numRequiredForSecPromotion[guid];
      }
      return false;
    },
    secPromotionProductIncluded: function secPromotionProductIncluded() {
      if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
        return false;
      }
      // n 件参加秒杀
      for (var guid in this.secPromotionDetailObj) {
        if (this.numOfSecPromotionProducts[guid] && this.numOfSecPromotionProducts[guid] >= this.numRequiredForSecPromotion[guid]) return true;
      }
      return false;
    },
    getSecPromotionInfo: function getSecPromotionInfo() {
      var _this8 = this;

      var info = {};
      if (this.secPromotion === '' || this.secPromotion === undefined) {
        return;
      }
      info.startDT = this.secPromotion.startDT;
      info.endDT = this.secPromotion.endDT;
      info.promotionGuid = this.secPromotion.promotionGuid;
      info.now = Date.parse(new Date());
      this.gcapi('getSeckillPromotion', info.promotionGuid).then(function (response) {
        var result = response.body.result;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(info, result);
        _this8.SET_SECPROMOTION_INFO(info);
        console.log('secinfo', _this8.secInfo);
        console.log('secflag', _this8.secFlag);
      });
    },
    getNonSalesforceShoppingCart: function getNonSalesforceShoppingCart() {
      var _this9 = this;

      if (this.isSFFlag === true || this.hasLogin === false) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.pullToRefreshDone('.pull-to-refresh-content'); // done
        return;
      }
      var customerNo = this.sessionInfo.customerInfo.customerNo;
      console.log('getNonSalesforceShoppingCart', customerNo);
      this.gcapi('getNonSalesforceShoppingCart', customerNo).then(function (res) {
        if (res && res.body.code === 0) {
          var cart = void 0;
          // DB中无购物车记录或者记录为空{}
          if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
            cart = '{}';
          } else {
            cart = res.body.result.cartContent;
          }
          _this9.UPDATE_CART_CONTENT(cart);
        }
        // alert('refresh finish')
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.pullToRefreshDone('.pull-to-refresh-content'); // done
      });
    },
    secPromotionPrice: function secPromotionPrice(product) {
      var guid = product.promotions[0].promotionGuid;
      var seckilltRatio = this.secPromotionDetailObj[guid].seckilltRatio;
      return (1 - seckilltRatio) * product.priceMax && ((1 - seckilltRatio) * product.priceMax).toFixed(2);
    },
    secPromotionType: function secPromotionType(product) {
      var guid = product.promotions[0].promotionGuid;
      return this.secPromotionDetailObj[guid].seckillType;
    },
    filteredShowPromotions: function filteredShowPromotions(merchandise) {
      if (merchandise.promotions && merchandise.promotions.length > 0 && merchandise.amplification === 0) {
        return merchandise.promotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.name && pro.type !== 0;
        });
      }
      if (merchandise.bpromotions && merchandise.bpromotions.length > 0 && merchandise.amplification === 0) {
        return merchandise.bpromotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.name && pro.type !== 0;
        });
      }
      return [];
    }
  }),
  watch: {
    //      'isCustomFlag': 'checkCust'
    'isCheckedAll': function isCheckedAll(val) {
      console.log('watch ischeckedALl', val);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])(['cartList', 'sessionInfo', 'checkList', 'secInfo', 'secPromotionDetailObj']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['secFlag', 'hasLogin', 'isSFFlag']), {
    products: function products() {
      var products = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).forEach(function (item) {
        products.push(self.cartList.cartContent[item]);
      });
      return products;
    },
    getTotalGoodsNum: function getTotalGoodsNum() {
      //        this.checkCust()
      var self = this;
      var sum = 0;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).forEach(function (item) {
        sum += self.cartList.cartContent[item].productQuantity;
      });
      this.getAllChecked();
      return sum;
    },
    hasSharePermission: function hasSharePermission() {
      // sf不显示分享链接
      return this.hasLogin && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag !== 1;
    }
  }),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
    // 默认页面 获取秒杀活动信息和促销弹框信息
    this.getSecPromotionInfo();
    this.getShowPromotion();
  },
  data: function data() {
    return {
      tabs1: [],
      tabs2: [],
      catagoryList: [],
      description: '',
      ssoFlag: 0,
      baseurl: '/emktResources/resocurces/img/merchandise/',
      secPromotion: __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktSecPromotion'),
      attrurl: '/emktResources/resocurces/img/promotion/',
      newList: []
    };
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['sessionInfo', 'secInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['curMessageSession', 'hasLogin', 'secFlag'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['SET_SECPROMOTION_INFO']), {
    fetchData: function fetchData() {
      var _this2 = this;

      if (this.sessionInfo.ssoFlag !== undefined) {
        this.ssoFlag = this.sessionInfo.ssoFlag;
      } else {
        this.ssoFlag = this.sessionInfo.customerInfo.ssoFlag;
      }
      this.gcapi('getNewCategories').then(function (res) {
        var result = res.data.result;
        var cates = JSON.parse(result);
        _this2.newList = cates.newCategories || [];
      });
      var tab = __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getEmktMetaData().categories;
      var newtab = [];
      var newtab1 = [];
      for (var j = 0; j < tab.length; j++) {
        if (tab[j].available && tab[j].categoryId !== 10 && tab[j].categoryId !== 20 && tab[j].categoryId !== 11) {
          newtab.push(tab[j]);
        }
      }
      for (var l = 0; l < tab.length; l++) {
        if (tab[l].available && tab[l].categoryId === 20) {
          newtab1.push(tab[l]);
        }
      }
      //        for (var i = 0; i < newtab.length; i = i + 2) {
      //          var tabs2 = []
      //          tabs2.push(newtab[i])
      //          tabs2.push(newtab[i + 1])
      //          this.tabs1.push(tabs2)
      //        }
      for (var m = 0; m < newtab1.length; m = m + 4) {
        var tabs3 = [];
        tabs3.push(newtab1[m]);
        tabs3.push(newtab1[m + 1]);
        tabs3.push(newtab1[m + 2]);
        tabs3.push(newtab1[m + 3]);
        this.tabs2.push(tabs3);
      }
      for (var i = 0; i < newtab.length; i = i + 4) {
        var tabs2 = [];
        tabs2.push(newtab[i]);
        tabs2.push(newtab[i + 1]);
        tabs2.push(newtab[i + 2]);
        tabs2.push(newtab[i + 3]);
        this.tabs1.push(tabs2);
      }
    },
    gotoMymessage: function gotoMymessage() {
      __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].openCustomerService();
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    },
    todCategoryDetail: function todCategoryDetail(id, label) {
      __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].customerBehaviours.category.goToCategoryDetail = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].customerBehaviourType.click };
      this.$router.push({ path: 'categoryDetail', query: { id: id, label: label } });
    },
    todCategoryDetailnew: function todCategoryDetailnew(obj) {
      if (obj.filterName) {
        this.$router.push({ path: 'categoryDetail', query: { id: obj.categoryId, label: obj.categoryLabel, filterName: obj.filterName, filterValue: obj.filterValue } });
      } else {
        this.$router.push({ path: 'categoryDetail', query: { id: obj.categoryId, label: obj.categoryLabel } });
      }
    },
    onSearchClicked: function onSearchClicked() {
      __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].customerBehaviours.category.search = { 'time': Date.parse(new Date()), 'target': '', 'type': __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].customerBehaviourType.search };
    },
    getSecPromotionInfo: function getSecPromotionInfo() {
      var _this3 = this;

      var info = {};
      if (this.secPromotion === '' || this.secPromotion === undefined) {
        return;
      }
      info.startDT = this.secPromotion.startDT;
      info.endDT = this.secPromotion.endDT;
      info.promotionGuid = this.secPromotion.promotionGuid;
      info.now = Date.parse(new Date());
      this.gcapi('getSeckillPromotion', info.promotionGuid).then(function (response) {
        var result = response.body.result;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(info, result);
        _this3.SET_SECPROMOTION_INFO(info);
        console.log('secinfo', _this3.secInfo);
        console.log('secflag', _this3.secFlag);
      });
    },
    getShowPromotion: function getShowPromotion() {
      var _this = this;
      if (_this.hasLogin) {
        var customerInfo = _this.sessionInfo.customerInfo;
        if (customerInfo && customerInfo.ssoFlag === 0) {
          var ShowPromotions = __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('isshowPromotion');
          if (ShowPromotions && ShowPromotions !== undefined && ShowPromotions !== null && ShowPromotions.show === true) {
            var attr = ShowPromotions.showPromotionParam.bPromotions[0];
            var content = '<div id="lottery"><img style="width: 12rem;height: 20rem;"' + 'src=' + _this.attrurl + attr.showimage + '></div>';
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
              text: content,
              buttons: [{
                text: '我知道了',
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setLocalStorage('isshowPromotion', null);
                  _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam).then(function (response) {});
                }
              }]
            });
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#lottery').click(function () {
              __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setLocalStorage('isshowPromotion', null);
              _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam).then(function (response) {});
              //                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
              //              _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
              //                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
              _this.$router.push({ path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl } });
              __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.closeModal();
            });
          }
          // var specialcouponpromotions = emkt.getLocalStorage('EmktSpecialcouponpromotions')
          // if (specialcouponpromotions.length === 1) {
          //   var pro = specialcouponpromotions[0]
          //   let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
          //   let now = new Date()
          //   if (now < endDT) {
          //     _this.gcapi('getMySpecialPromotionCoupon', pro.promotionGuid).then((res) => {
          //       var showspecialcoupon = false
          //       if (res.body.result != null) {
          //         var MySpecialPromotionCoupon = res.body.result
          //         MySpecialPromotionCoupon.quantity < pro.promotionCustomer.quantity ? showspecialcoupon = true : showspecialcoupon = false
          //         if (showspecialcoupon) {
          //           var content1 = '<div id="lottery">援鄂英雄您好，您的定制产品6折券/万元免单券已经到账，您可以下单使用！</div>'
          //           $.modal({
          //             text: content1,
          //             buttons: [ {
          //               text: '了解详情',
          //               onClick: function () {
          //                 _this.$router.push('/user/myCoupons')
          //               }
          //             },
          //             {
          //               text: '直接下单',
          //               onClick: function () {
          //                 _this.$router.push('/finder/search')
          //               }
          //             }]
          //           })
          //         }
          //       }
          //     })
          //   }
          // }
        }
      }
    }
  })
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__finder_components_NewMerchandiseListA_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__finder_components_NewMerchandiseListA_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__finder_components_NewMerchandiseListA_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_wx__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
  },
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      Merchandises: [],
      tabs1: [],
      //        tabs2: [],
      catagoryList: [],
      description: '',
      id: this.$route.query.id,
      total: 0
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
    'merchandiseQueryParams': function merchandiseQueryParams() {
      var _this2 = this;

      var _this = this;
      var params = this.merchandiseQueryParams;
      var id = params.categoryId;
      if (id) {
        if (id === 6) {
          if (__WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].isWapp) {
            __WEBPACK_IMPORTED_MODULE_6_wx___default.a.miniProgram.switchTab({
              url: '/pages/cart/cart'
            });
          } else {
            this.$router.replace({ name: 'cart' });
          }
        } else {
          var query = this.$route.query;
          if (query.filterName && query.filterName === 'promotionGuid') {
            params = { 'promotionGuid': query.filterValue, 'fromIndex': 0 };
          } else {
            params = { 'categoryId': params.categoryId, 'filterConditions': params.filterConditions };
          }
          console.log('params', params);
          console.log('query', query);
          this.gcapi('queryMerchandise', params).then(function (res) {
            if (res.body.code === 0) {
              _this.catagoryList = res.body.result.merchandiseList;
              _this.catagoryList.sort(function (o1, o2) {
                return o1.selfOperated - o2.selfOperated;
              });
              _this.total = res.body.result.total;
              var data = {};
              data['total'] = _this2.total;
              data['category'] = res.body.result.categoryIdToCount;
              _this2.QUERY_TOTAL(data);
            }
          });
        }
      }
    }
  },
  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue___default.a, newMerchandiseListA: __WEBPACK_IMPORTED_MODULE_4__finder_components_NewMerchandiseListA_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['merchandiseQueryParams']), {
    showSearchBar: function showSearchBar() {
      var flag = false;
      var id = parseInt(this.id);
      /*
        以下产品大类暂不显示查询bar
        5 ===》 aav ；7 ===》 支原体 ；8 ===》 cas9文库 ；9 ===》 工具类病毒 ；
       */
      if (id === 5 || id === 8 || id === 9 || id === 7 || id === 14) {
        flag = true;
      }
      return flag;
    },
    showFilterBarForKit: function showFilterBarForKit() {
      // let id = parseInt(this.id)
      var flag = false;
      // if (id && id === 7) {
      //   flag = true
      // }
      return flag;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['QUERY_TOTAL']), {
    fetchData: function fetchData() {
      var _this3 = this;

      if (this.$route.query.id === 20) {
        this.$router.replace({ name: 'finder' });
        return;
      }
      if (this.$route.query.id === 6) {
        this.$weui.topTips('细胞相关产品已经下架！', 3000);
        if (__WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].isWapp) {
          __WEBPACK_IMPORTED_MODULE_6_wx___default.a.miniProgram.switchTab({
            url: '/pages/cart/cart'
          });
        } else {
          this.$router.replace({ name: 'cart' });
        }
      }
      var params = { categoryId: this.$route.query.id };
      var query = this.$route.query;
      if (query.filterName && query.filterName === 'promotionGuid') {
        params = { 'promotionGuid': query.filterValue, 'fromIndex': 0 };
      }
      console.log('params', params);
      console.log('query', query);
      this.gcapi('queryMerchandise', params).then(function (response) {
        _this3.id = _this3.$route.query.id;
        _this3.catagoryList = response.body.result.merchandiseList;
        _this3.total = response.body.result.total;
        for (var i = 0; i < _this3.catagoryList.length; i++) {
          var tags = [];
          var merchandiseMeta = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getEmktMetaData();
          var tagsmap = merchandiseMeta.tagsMap;
          for (var j = 0; j < _this3.catagoryList[i].tagIds.length; j++) {
            tags.push(tagsmap[_this3.catagoryList[i].tagIds[j]].tagLabel);
          }
          _this3.catagoryList[i].tags = tags;
        }
        _this3.catagoryList.sort(function (o1, o2) {
          return o1.selfOperated - o2.selfOperated;
        });
        if (_this3.catagoryList.length < 20) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.button').remove();
        }
        var data = {};
        data['total'] = _this3.total;
        data['category'] = response.body.result.categoryIdToCount;
        _this3.QUERY_TOTAL(data);
      });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      var fromindex = this.catagoryList.length;
      if (fromindex >= this.total) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.button').remove();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#over').append('已经到底啦！');
        return;
      } else {
        var addlist = [];
        var params = { categoryId: this.id, fromIndex: fromindex };
        var query = this.$route.query;
        if (query.filterName && query.filterName === 'promotionGuid') {
          params = { 'promotionGuid': query.filterValue, 'fromIndex': 0 };
        }
        this.gcapi('queryMerchandise', params).then(function (response) {
          addlist = response.body.result.merchandiseList;
          for (var i = 0; i < addlist.length; i++) {
            var tags = [];
            var merchandiseMeta = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getEmktMetaData();
            var tagsmap = merchandiseMeta.tagsMap;
            for (var j = 0; j < addlist[i].tagIds.length; j++) {
              tags.push(tagsmap[addlist[i].tagIds[j]].tagLabel);
            }
            addlist[i].tags = tags;
            _this4.catagoryList.push(addlist[i]);
          }
          var data = {};
          data['total'] = _this4.total;
          data['category'] = response.body.result.categoryIdToCount;
          _this4.QUERY_TOTAL(data);
        });
      }
    }
  })
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
  },
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/promotion/',
      channels: []
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([
    // ...
  ])),
  methods: {
    fetchData: function fetchData() {
      var channelList = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getLocalStorage('EmktChannels');
      for (var i = 0; i < channelList.length; i++) {
        if (this.$route.query.promotionGroupGuid === channelList[i].promotionGroupGuid) {
          this.channels = channelList[i];
        }
      }
    },
    tolast: function tolast() {
      this.$router.go(-1);
    },
    gotoPro: function gotoPro(pro) {
      this.$router.push({ name: 'ChannelDetails', query: { promotionGuid: pro.promotionGuid, imageUrl: pro.imageUrl } });
    },
    gotolast: function gotolast() {
      this.$router.push({ name: 'home' });
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import emkt from '../../emkt.js'
/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      merchandise: [],
      total: 0,
      baseurl: '/emktResources/resocurces/img/promotion/',
      pro: {}
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['hasLogin'
  // ...
  ])),
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.pro.promotionGuid = this.$route.query.promotionGuid;
      this.pro.imageUrl = this.$route.query.imageUrl;
      this.gcapi('queryMerchandise', { promotionGuid: this.pro.promotionGuid, fromIndex: 0 }).then(function (response) {
        _this.merchandise = response.body.result.merchandiseList;
        console.log(response.body.result.merchandiseList);
        _this.total = response.body.result.total;
      });
    },
    loadmore: function loadmore() {
      var _this2 = this;

      var fromindex = this.merchandise.length;
      if (fromindex >= this.total) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.button').remove();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#over').append('已经到底啦！');
        return;
      } else {
        var addlist = [];
        this.gcapi('queryMerchandise', { promotionGuid: this.pro.promotionGuid, fromIndex: fromindex }).then(function (response) {
          addlist = response.body.result.merchandiseList;
          for (var i = 0; i < addlist.length; i++) {
            _this2.merchandise.push(addlist[i]);
          }
        });
      }
    },
    tolast: function tolast() {
      this.$router.go(-1);
    },
    gotolast: function gotolast() {
      //        if (this.$route.params.channels) {
      //          this.$router.push({name: 'Channel', params: {channel: this.$route.params.channels}})
      //        } else {
      //          this.$router.push({name: 'home'})
      //        }
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      merchandises: ''
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.gcapi('getMerchandiseDetails', '040616fe-68a0-4dec-998b-eaa8f632ebef').then(function (response) {
        _this.merchandises = response.body.result;
      });
    }
  },
  computed: {
    merchandisesMeta: function merchandisesMeta() {
      var data = this.merchandises;
      var attr = data.attributes;
      var dicMeta = __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].getEmktMetaData().dictionariesMap;
      var attrMeta = __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].getEmktMetaData().categoryAttrsMap;
      if (data.attributesMeta === undefined) {
        var id = data.categoryId;
        var typeTar = void 0;
        var attributesMeta = {};
        // get
        for (var i in data.attributes) {
          var attrName = i;
          var attrVal = void 0;
          var optTar = {};
          var attrValTar = attrMeta[id + '_' + attrName];
          typeTar = attrMeta[data.categoryId + '_' + attrName].semanticDT;
          if (typeTar === 3) {
            var dicValue = dicMeta[attrValTar.extras.substring(11, attrValTar.length)];
            for (var a in dicValue) {
              var val = dicValue[a];
              optTar[val.dictKey] = val.dictValue;
            }
            attrVal = {
              'value': attr[attrName],
              'sdType': typeTar,
              'options': optTar
            };
          } else {
            attrVal = {
              'value': attr[attrName],
              'sdType': typeTar
            };
          }
          attributesMeta[attrName] = attrVal;
          //            console.log(attributesMeta)
        }
        data['attributesMeta'] = attributesMeta;
      }
      return data;
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wx__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import $ from 'jquery'

//  import emkt from '../../emkt.js'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
    //      this.fetchData()
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  data: function data() {
    return {
      merchandises: [],
      baseurl: '/emktResources/resocurces/img/merchandise/',
      manualurl: '/emktResources/resocurces/manual/',
      merchandiseurl: '/emktResources/resocurces/merchandiseInfo',
      attr: '?go=true',
      Comments: [],
      QuoteStatus: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('QuoteStatus'),
      qualityCommitment: '',
      introduces: ''
      //        goodList: []
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['cartList', 'leaveMessageStatus', 'sessionInfo', 'curMessageSession']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin', 'curMessageSession', 'isWapp'
  // ...
  ]), {
    //      title () {
    //        if (this.merchandiseAttributes === []) {
    //          return ''
    //        } else {
    //          return this.merchandiseAttributes[0].valueText
    //        }
    //      },
    //      merchandiseAttributes () {
    //        if (this.merchandise._attributesList === []) {
    //          return []
    //        } else {
    //          return this.merchandise._attributesList
    //        }
    //      },
    getTotalGoodsNum: function getTotalGoodsNum() {
      var self = this;
      var number = 0;
      for (var key in self.cartList.cartContent) {
        if (self.cartList.cartContent[key].productQuantity) {
          number = number + self.cartList.cartContent[key].productQuantity;
        } else {
          number = number + 1;
        }
      }
      return number;
    }
    //      merchandiseList: function () {
    //        this.gcapi('getMerchandiseDetails', this.$route.query.id).then((response) => {
    //          this.merchandises = response.body.result
    //          this.merchandises.tags = this.$route.query.tags
    //          this.merchandises.attrs = this.$route.query.attrs
    //          this.merchandises.attributesList = response.body.result._attributesList
    //        })
    //        return this.merchandises
    //      }

  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE']), {
    addCartList: function addCartList() {
      if (this.merchandises.selfOperated === 0 && this.sessionInfo.customerInfo.ssoFlag === 1) {
        this.$weui.topTips('第三方商品不支持此操作！');
        // $.toast('第三方商品不支持此操作！')
        return;
      }
      //        if (this.merchandises.stockOrCustomized === 0 && emkt.buyCartIsLocalStorage === false) {
      //          alert('只能对定制产品进行报价！')
      //        } else {
      //          let pl = this.plan
      //          let pr = this.merchandises
      //          console.log(pl, pr)
      //          this.ADD_CART_LIST(pr)
      //        }
      var pl = this.plan;
      var pr = this.merchandises;
      if (this.merchandises.salesLimit !== -1) {
        if (this.merchandises.totalSales >= this.merchandises.salesLimit) {
          this.$weui.alert('此商品已经售罄！');
          // $.confirm('此商品已经售罄！')
        } else {
          console.log(pl, pr);
          this.ADD_CART_LIST(pr);
        }
      } else {
        this.ADD_CART_LIST(pr);
      }
    },
    tolast: function tolast() {
      this.$router.go(-1);
    },
    gotoCart: function gotoCart() {
      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_3_wx___default.a.miniProgram.switchTab({
          url: '/pages/cart/cart'
        });
      } else {
        this.$router.replace({ name: 'cart' });
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.gcapi('getMerchandiseDetails', this.$route.query.id).then(function (response) {
        _this.merchandises = response.body.result;
        var showpromotion = [];
        for (var i in _this.merchandises.promotions) {
          if (_this.merchandises.promotions[i].type === 1) {
            var samePromotionName = showpromotion.find(function (item) {
              return item.name === _this.merchandises.promotions[i].name;
            });
            if (!samePromotionName) {
              showpromotion.push(_this.merchandises.promotions[i]);
            }
          }
        }
        _this.merchandises.showpromotion = showpromotion;
        if (_this.merchandises.H5FileName) {
          _this.$http.get(_this.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, { emulateHTTP: true }).then(function (response) {
            _this.introduces = response.bodyText;
          });
        }
        if (_this.merchandises.QualityPromisesH5FileName) {
          var dictionariesMap = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktMetaData').dictionariesMap;
          var name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue;
          _this.$http.get(_this.merchandiseurl + '/static/desc/qualitypromises/' + name, { emulateHTTP: true }).then(function (response) {
            _this.qualityCommitment = response.bodyText;
          });
        }
        console.log(_this.merchandises);
      });
      this.gcapi('getMerchandiseComments', this.$route.query.id).then(function (response) {
        _this.Comments = response.body.result;
      });
    },
    toMessage: function toMessage(merchandiseLabel) {
      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_3_wx___default.a.miniProgram.navigateTo({
          url: '/pages/consult/consult'
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].openCustomerService();
      }
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    gotolast: function gotolast() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__finder_components_NewMerchandiseListB__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__finder_components_NewMerchandiseListB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__finder_components_NewMerchandiseListB__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // this.gcapi('getEndPrice', {'quoteId': '701334ba-0f03-4199-b203-ca86d3e6330a', 'discountA': 0.7, 'discountType': 0, 'discountB': 0.700, 'discountC': 1, 'calculatePromotion': false, 'toolUsePromotion': 1, 'serviceUsePromotion': 1, 'settlementAccountNo': 'A00229481', 'startDtLtRgDeadline': false})
    this.fetchData();
    this.init();
    this.getReco();
    this.getSecPromotionInfo();
    console.log('secflag', this.secFlag);
    console.log('promotions', this.promotions);
  },
  created: function created() {},
  data: function data() {
    return {
      promotions: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktPromotions'),
      channels: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktChannels'),
      // merchList: emkt.getLocalStorage('EmktPlain'),
      baseurl: '/emktResources/resocurces/img/promotion/',
      merchandisebaseurl: '/emktResources/resocurces/img/merchandise/',
      attrurl: '/emktResources/resocurces/img/promotion/',
      hotMerch: [],
      description: '',
      promotionGuid: '',
      recommendsList: [],
      recommends: [],
      ssoFlag: 0,
      secPromotion: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktSecPromotion')
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'getReco'
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['hasLogin', 'secFlag', 'curMessageSession'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['sessionInfo', 'secInfo'])),
  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_6__components_MerchandiseList_vue___default.a, newMerchandiseListB: __WEBPACK_IMPORTED_MODULE_7__finder_components_NewMerchandiseListB___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SET_SECPROMOTION_INFO']), {
    getDoctorPromotion: function getDoctorPromotion() {
      if (!this.promotions) return null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.promotions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var promotion = _step.value;

          if (promotion.promotionGuid.includes('-169')) return promotion;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    },
    addCartListForRecom: function addCartListForRecom(pro) {
      this.ADD_CART_LIST(pro);
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('加入购物车成功！');
    },
    openen: function openen() {
      this.$router.push({ name: 'finder' });
    },
    gotoMymessage: function gotoMymessage() {
      __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].openCustomerService();
      // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    },
    gotochannel: function gotochannel(channel) {
      if (channel === 'doctor') {
        var activityPromotion = this.getDoctorPromotion();
        activityPromotion ? this.todiscount(activityPromotion) : null;
        return;
      }
      if (channel.type === 6) {
        this.$router.push({ path: 'promotion/secpromotion', query: { id: this.secInfo.promotionGuid, des: channel.description, detailImageUrl: channel.detailImageUrl, activityId: channel.activityId } });
      } else if (channel.type === 0) {
        this.$router.push({ name: 'Channel', query: { promotionGroupGuid: channel.promotionGroupGuid } });
      } else {
        this.$router.push({ name: 'promotions', query: { des: channel.description, promotionGroupGuid: channel.promotionGroupGuid, activityId: channel.activityId } });
      }
    },
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.swiper-container').swiper({
        autoplay: 3000,
        autoplayDisableOnInteraction: false
      });

      //        $('#sw').swiper({
      //          direction: 'vertical',
      //          autoplay: 3000,
      //          autoplayDisableOnInteraction: false
      //        })
      //        $('.swiper-container').slideTo(0, 3000, false)
    },
    getReco: function getReco() {
      if (this.$route.name === 'home') {
        var _this = this;
        _this.recommendsList = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations');
        //          console.log(emkt.getLocalStorage('EmktRecommendations'))
        //        if (!self.recommendsList) {
        //          this.gcapi('getRecommended').then(function (response) {
        //            emkt.setStoreItem('EmktAllRecommends', response.body.result)
        //            self.recommendsList = emkt.getLocalStorage('EmktAllRecommends')
        //          })
        //        }
        if (!_this.recommendsList || _this.recommendsList.length < 4) {
          _this.gcapi('getRecommendation', 'GUEST').then(function (response) {
            var i = 0;
            var list = [];
            var newlist = response.body.result;
            //              console.log(newlist)
            if (newlist.length > 15) {
              for (i = 0; i < 15; i++) {
                list.push(newlist[i]);
              }
              __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setStoreItem('EmktRecommendations', list);
            } else {
              __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setStoreItem('EmktRecommendations', newlist);
            }
            //              emkt.setStoreItem('EmktRecommendations', newlist)
            _this.recommendsList = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations');
          });
        }
        if (_this.hasLogin) {
          var customerInfo = _this.sessionInfo.customerInfo;
          if (customerInfo && customerInfo.ssoFlag === 0) {
            var ShowPromotions = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('isshowPromotion');
            if (ShowPromotions && ShowPromotions !== undefined && ShowPromotions !== null && ShowPromotions.show === true) {
              var attr = ShowPromotions.showPromotionParam.bPromotions[0];
              var content = '<div id="lottery"><img style="width: 12rem;height: 20rem;"' + 'src=' + _this.attrurl + attr.showimage + '></div>';
              __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.modal({
                text: content,
                buttons: [{
                  text: '我知道了',
                  onClick: function onClick() {
                    __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setLocalStorage('isshowPromotion', null);
                    _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam).then(function (response) {});
                  }
                }]
              });
              __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#lottery').click(function () {
                __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setLocalStorage('isshowPromotion', null);
                _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam).then(function (response) {});
                //                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
                //              _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
                //                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
                if (attr.type === 6 && attr.promotionGuid.indexOf('161') !== -1) {
                  // document.getElementById('fakelink').click()
                  window.location.href = 'https://jinshuju.net/f/nrxuBV';
                } else if (attr.type === 6) {
                  // 秒杀活动
                  _this.$router.push({ path: 'promotion/secpromotion', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl } });
                } else {
                  _this.$router.push({ path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: attr.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl } });
                }
                __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal();
              });
            } else {
              //                _this.gcapi('getMyCoupons', customerNo).then((res) => {
              //                  emkt.setLocalStorage('allCoupons', res.body.result)
              //                  _this.myCoupons = res.body.result
              //                  if (_this.myCoupons.length > 0) {
              //                    var isread = true
              //                    for (var i in _this.myCoupons) {
              //                      if (_this.myCoupons[i].acknowledge === 0) {
              //                        isread = false
              //                      }
              //                    }
              //                    if (!isread) {
              //                      $.modal({
              //                        text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
              //                        buttons: [{
              //                          text: '查看全部优惠券',
              //                          onClick: function () {
              //                            _this.gcapi('acknowledge', customerNo)
              //                              .then((response) => {
              //                              })
              //                            _this.$router.push({name: 'myCoupons'})
              //                          }
              //                        }, {
              //                          text: '我知道了',
              //                          onClick: function () {
              //                            _this.gcapi('acknowledge', customerNo)
              //                              .then((response) => {
              //                              })
              //                          }
              //                        }]
              //                      })
              //                    }
              //                  }
              //                })
            }
          }
        }
      }
    },
    fetchData: function fetchData() {
      var _this = this;
      if (_this.sessionInfo.ssoFlag !== undefined) {
        _this.ssoFlag = _this.sessionInfo.ssoFlag;
      } else {
        _this.ssoFlag = _this.sessionInfo.customerInfo.ssoFlag;
      }
      _this.recommends = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktAllRecommends');
      if (!_this.recommends) {
        this.gcapi('getRecommended').then(function (response) {
          __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setStoreItem('EmktAllRecommends', response.body.result);
          _this.recommends = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktAllRecommends');
        });
      }
      var discounts = [];
      discounts = __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getLocalStorage('EmktDiscounts');
      if (discounts !== null && discounts !== undefined) {
        _this.description = discounts.description;
        _this.promotionGuid = discounts.promotionGuid;
      }
      // var data = {'customerNo': '00294934', 'type': 6, 'id': 1, 'name': '高君国自然方案', 'templateNo': 'RSEX0001', 'initPrice': 26460.00, 'children': [{'type': 7, 'id': 1, 'name': '体外建立内皮细胞不完全消融模型', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 1, 'name': '模型建立', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 2, 'name': '线粒体氧化应激', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 2, 'name': 'DCF线粒体氧化应激', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 3, 'name': '线粒体提取', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 3, 'name': '线粒体提取', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 4, 'name': ' 抑制线粒体氧化应激', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 4, 'name': '抗氧化剂NAC', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 5, 'name': '抑制线粒体自噬', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 5, 'name': '线粒体自噬抑制剂mdivi', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 6, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 6, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 7, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 7, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 8, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 8, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 9, 'name': 'PI/Hoechst双荧光显微镜观察焦亡', 'templateNo': 'EU000149', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 9, 'name': '免疫荧光', 'templateNo': 'PU000097', 'number': 0, 'unitPrice': 250.00, 'initPrice': 0.00, 'children': []}]}, {'type': 7, 'id': 10, 'name': 'PI/Hoechst双荧光显微镜观察焦亡', 'templateNo': 'EU000149', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 10, 'name': '免疫荧光', 'templateNo': 'PU000097', 'number': 0, 'unitPrice': 250.00, 'initPrice': 0.00, 'children': []}]}, {'type': 7, 'id': 11, 'name': 'SYTOX Green流式细胞检测细胞焦亡实验', 'templateNo': 'EU000139', 'initPrice': 1980.00, 'children': [{'type': 8, 'id': 11, 'name': '流式细胞表面分子检测实验（直标抗体）', 'templateNo': 'PU000087', 'number': 6, 'unitPrice': 330.00, 'initPrice': 1980.00, 'children': []}]}, {'type': 7, 'id': 12, 'name': 'SYTOX Green流式细胞检测细胞焦亡实验', 'templateNo': 'EU000139', 'initPrice': 1980.00, 'children': [{'type': 8, 'id': 12, 'name': '流式细胞表面分子检测实验（直标抗体）', 'templateNo': 'PU000087', 'number': 6, 'unitPrice': 330.00, 'initPrice': 1980.00, 'children': []}]}]}
      // var data = {
      //   'type': 6,
      //   'id': 19,
      //   'name': '刘清老师实验方案',
      //   'templateNo': 'RS000018',
      //   'initPrice': 162500.00,
      //   'canMultiDiscount': true,
      //   'children': [
      //     {
      //       'type': 7,
      //       'id': 88,
      //       'name': '肿瘤关键基因筛选及验证',
      //       'templateNo': 'EU000052',
      //       'initPrice': 162500.00,
      //       'canMultiDiscount': true,
      //       'children': [
      //         {
      //           'type': 8,
      //           'id': 186,
      //           'name': '肿瘤关键基因筛选及验证',
      //           'templateNo': 'PU000294',
      //           'unitPrice': 162500.00,
      //           'initPrice': 162500.00,
      //           'canMultiDiscount': true,
      //           'children': []
      //         }
      //       ]
      //     }
      //   ]
      // }
      // var data = {'customerNo': '00382330', 'type': 5, 'id': 7147, 'name': '测试', 'templateNo': 'RSEX0001', 'initPrice': 165200, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 6, 'id': 24640, 'name': 'TMT蛋白组学', 'templateNo': 'EU000039', 'initPrice': 68000, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 7, 'id': 54930, 'name': 'TMT蛋白组学6标及以上', 'templateNo': 'PU000264', 'number': 10, 'unitPrice': 4600.00, 'initPrice': 46000, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54931, 'name': '蛋白组学生信分析（A套系）', 'templateNo': 'PU000270', 'number': 1, 'unitPrice': 0.00, 'initPrice': 0, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54932, 'name': '蛋白组学去高丰度蛋白', 'templateNo': 'PU000271', 'number': 10, 'unitPrice': 2200.00, 'initPrice': 22000, 'canMultiDiscount': true, 'persist': false, 'children': []}]}, {'type': 6, 'id': 24641, 'name': '磷酸化TMT蛋白组学', 'templateNo': 'EU000040', 'initPrice': 97200, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 7, 'id': 54933, 'name': '蛋白组学生信分析（A套系）', 'templateNo': 'PU000270', 'number': 1, 'unitPrice': 0.00, 'initPrice': 0, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54934, 'name': '蛋白组学去高丰度蛋白', 'templateNo': 'PU000271', 'number': 10, 'unitPrice': 2200.00, 'initPrice': 22000, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54935, 'name': '磷酸化TMT蛋白组学4标及以上', 'templateNo': 'PU000274', 'number': 10, 'unitPrice': 7520.00, 'initPrice': 75200, 'canMultiDiscount': true, 'persist': false, 'children': []}]}]}
      // this.gcapi('calculateServiceOrderPrice', data).then(function (response) {
      // })
    },
    openLink: function openLink(attr) {
      var promotionId = attr.promotionGuid;
      if (promotionId.endsWith('-251') || promotionId.endsWith('-252') || promotionId.endsWith('-253')) {
        return true;
      }
      return false;
    },
    getOuterLink: function getOuterLink(attr) {
      var promotionId = attr.promotionGuid;
      if (promotionId.endsWith('-251')) {
        return 'https://jinshuju.net/f/PepHEL';
      } else if (promotionId.endsWith('-252')) {
        return 'https://jinshuju.net/f/BXHWwz';
      } else if (promotionId.endsWith('-253')) {
        return 'https://jinshuju.net/f/QPLea0';
      }
    },
    todiscount: function todiscount(attr) {
      console.log(attr);
      __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviours.home.clickBanner = { 'time': Date.parse(new Date()), 'target': attr.name, 'type': __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviourType.click };
      if (attr.type === 4) {
        if (attr.action) {
          this.$router.push({ path: attr.action });
        } else {
          // eslint-disable-next-line standard/object-curly-even-spacing
          this.$router.push({ path: 'promotion/promotions', query: { id: attr.promotionGuid, isadvertising: true, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId } });
        }
      } else if (attr.type === 6) {
        // 秒杀活动
        this.$router.push({ path: 'promotion/secpromotion', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId } });
      } else {
        this.$router.push({ path: 'promotion/promotions', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId } });
      }
    },
    topromotion: function topromotion(id, des) {
      __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviours.home.clickLike = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviourType.click };
      this.$router.push({ path: 'promotion/promotions', query: { id: id, des: des } });
    },
    goToMerchandises: function goToMerchandises(pro) {
      __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviours.home.goToDetail = { 'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].customerBehaviourType.click };
      this.$router.push({
        name: 'merchandises',
        query: {
          id: pro.merchandiseId,
          typename: pro.bpromotions[0].typeName,
          name: pro.bpromotions[0].name,
          tags: pro.tags
        }
      });
    },
    getSecPromotionInfo: function getSecPromotionInfo() {
      var _this2 = this;

      var info = {};
      if (this.secPromotion === '' || this.secPromotion === undefined) {
        return;
      }
      info.startDT = this.secPromotion.startDT;
      info.endDT = this.secPromotion.endDT;
      info.promotionGuid = this.secPromotion.promotionGuid;
      info.now = Date.parse(new Date());
      this.gcapi('getSeckillPromotion', info.promotionGuid).then(function (response) {
        var result = response.body.result;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(info, result);
        _this2.SET_SECPROMOTION_INFO(info);
        console.log('secinfo', _this2.secInfo);
        console.log('secflag', _this2.secFlag);
      });
    }
  })
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageText__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MessageText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageContent__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { textcontent: __WEBPACK_IMPORTED_MODULE_1__MessageText___default.a, dialoguecontent: __WEBPACK_IMPORTED_MODULE_2__MessageContent___default.a },
  data: function data() {
    return {
      Messages: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['INIT_MESSAGE', 'SEND_MESSAGE']), {
    //      ...mapState([
    //        'leaveMessageStatus'
    //        // ...
    //      ]),
    readdata: function readdata() {
      if (this.curMessageSession.leaveMessageStatus === 3) {
        this.gcapi('readLeaveMessageResponse', this.Messages.merchantNo);
      }
    },
    fetchData: function fetchData() {
      if (this.$route.query.merchandiseurl) {
        // var content = 'this.$route.query.merchandiseLabel + ' ' + this.$route.query.merchandiseurl
        var content = '<a href=' + this.$route.query.merchandiseurl + '>' + this.$route.query.merchandiseLabel + '</a>';
        var data = {};
        data.message = content;
        data.merchandise = this.$route.params.merchandises;
        this.SEND_MESSAGE(data, 1);
      }
    },
    create: function create() {
      //        console.log(this.Messages)
      if (this.$route.query.Messages) {
        this.Messages = this.$route.query.Messages;
      }
    },
    toMessageManagement: function toMessageManagement() {
      this.INIT_MESSAGE('INIT_MESSAGE');
      this.$router.push({ name: 'MessageManagement' });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['curMessageSession'])),
  mounted: function mounted() {
    this.create();
    this.readdata();
  },
  created: function created() {
    //      this.readdata()

  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['messages'],
  mounted: function mounted() {
    //      clearInterval(messageTimer)
    var _this = this;
    //      messageTimer = setInterval(function () {
    //          _this.gcapi('retrieveMyLeaveMessages').then((response) => {
    //
    //          })
    //      }, 6 * 1000)
    _this.realmessages = _this.messages;
    var retrieveMessage = function retrieveMessage() {
      console.log('invoked');
      _this.gcapi('retrieveMyLeaveMessages').then(function (response) {
        var data = response.body.result.merchantMessages;
        for (var i in data) {
          if (data[i].merchantNo === _this.messages[0].merchantNo) {
            _this.realmessages = data[i].messages;

            var len = _this.realmessages.length;

            if (len > 0 && _this.messages[0].merchantNo === '101') {
              var lastMsg = _this.realmessages[len - 1];
              var now = new Date().getTime();
              var lastMsgDate = lastMsg.createDT;

              if (lastMsgDate) {
                var lastMsgTime = Date.parse(lastMsgDate);
                var offset = now - lastMsgTime;
                if (offset < 3600 * 1000 && offset > 10) {
                  var autoMsg = {};
                  autoMsg.message = '如果信息长时间未回复，您可以选择添加技术支持微信：15000205412（电话同号）';
                  autoMsg.messageType = 2;
                  _this.realmessages[len] = autoMsg;
                }
              }
            }

            if (data[i].unreadMessagesAmount > 0) {
              _this.gcapi('readLeaveMessageResponse', _this.messages[0].merchantNo);
            }
          }
        }
      });
    };
    retrieveMessage();
    _this.messageTimer = setInterval(retrieveMessage, 8 * 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.messageTimer);
  },

  methods: {},
  data: function data() {
    return {
      realmessages: [],
      messageTimer: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['customerName', 'curMessageSession'
  // ...
  ])),
  filters: {
    // 将日期过滤为 hour:minutes
    time: function time(date) {
      if (typeof date === 'string') {
        date = new Date(date);
      }
      return date.getHours() + ':' + date.getMinutes();
    }
  },
  directives: {
    // 发送消息后滚动到底部
    'scroll-bottom': function scrollBottom(el) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        el.scrollTop = el.scrollHeight - el.clientHeight;
      });
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      merchantMessages: [],
      responseMessages: [],
      date1: '',
      url: '/emktResources/resocurces/img/customerService.jpeg'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['INIT_MESSAGE']), {
    fetchData: function fetchData() {
      //        var responsemerchantMessages = this.curMessageSession.merchantMessages
      //        for (var i in responsemerchantMessages) {
      //          var merch = {}
      //          merch.messages = responsemerchantMessages[i]
      //          merch.merchantNo = responsemerchantMessages[i][0].merchantNo
      //          for (var j = responsemerchantMessages[i].length - 1; j >= 0; j--) {
      //            if (responsemerchantMessages[i][j].messageType === 2) {
      //              merch.responseMessage = responsemerchantMessages[i][j].message
      //              break
      //            }
      //          }
      //        this.INIT_MESSAGE('INIT_MESSAGE')
      this.merchantMessages = this.curMessageSession.merchantMessages;
      var date = new Date();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      this.date1 = date.getFullYear() + '-' + month + '-' + strDate;
    },
    goto: function goto(merch) {
      this.$router.push({ name: 'myMessage', query: { Messages: merch } });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['curMessageSession'])),
  mounted: function mounted() {
    this.fetchData();
  },
  created: function created() {
    this.fetchData();
  },

  watch: {}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['merchantNo', 'messages'],
  data: function data() {
    return {
      content: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['curMessageSession'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['SEND_MESSAGE', 'INIT_MESSAGE']), {
    onKeyup: function onKeyup(e) {
      if (e.keyCode === 13 && this.content.length > 1 && this.content.trim() !== '') {
        var data = {};
        data.message = this.content;
        data.merchandise = this.$route.params.merchandises;
        data.merchantNo = this.merchantNo;
        this.SEND_MESSAGE(data);
        this.INIT_MESSAGE('INIT_MESSAGE');
        var newdata = {};
        newdata.message = this.content;
        newdata.messageType = 1;
        this.messages.push(newdata);

        //        this.messageSessions[0].messages.push({
        //          message: this.content,
        //          createDT: new Date(),
        //          messageType: 1
        //        })
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#prompt').css('display', 'block');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#prompt').fadeIn('fast', function () {
          window.setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#prompt').fadeOut('fast', function () {
              __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#prompt').css('display', 'none');
            });
          }, 3000);
        });
        this.content = '';
      }
    }
  })
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comment_child_MyCommentOrder_vue__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comment_child_MyCommentOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__comment_child_MyCommentOrder_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      waitCommentMerchandise: this.$store.state.myOrder.waitCommentMerchandise,
      commentedMerchandise: this.$store.state.myOrder.commentedMerchandise
    };
  },

  components: {
    myCommentOrder: __WEBPACK_IMPORTED_MODULE_4__comment_child_MyCommentOrder_vue___default.a
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['myOrder'])),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getMerchandiseComments: function getMerchandiseComments(merch) {
      var self = this;
      this.gcapi('getMerchandiseComments', merch.merchandiseId).then(function (response) {
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body.message);
          return;
        }
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.hidePreloader();
        self.$router.push({ name: 'getComments', query: { BOrderComments: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.body.result), merch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(merch) } });
      });
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MerchandiseList_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      merchList: []
    };
  },
  mounted: function mounted() {
    var self = this;
    if (this.commentMerchandise) {
      for (var i = 0; i < this.commentMerchandise.length; i++) {
        var merchandise = this.commentMerchandise[i];
        merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid;
        merchandise.merchandiseDetailForClient.orderId = merchandise.orderGuid;
        self.merchList.push(merchandise.merchandiseDetailForClient);
      }
    }
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_1__components_MerchandiseList_vue___default.a
  },
  props: ['commentMerchandise', 'buttonName1', 'buttonName2'],
  methods: {
    goToComment: function goToComment(merchandise) {
      this.$router.push({ name: 'myComment', query: { merchandise: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(merchandise) } });
    },
    response: function response(merch) {
      this.$emit('response', merch);
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      merch: JSON.parse(this.$route.query.merchandise),
      level: 5
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
      var s = document.getElementById('starts');
      var n = s.getElementsByTagName('span');

      for (var i = 0; i < n.length; i++) {
        n[i].onclick = function () {
          var q = +this.getAttribute('rel');
          self.level = q;
          for (var _i = q; _i < n.length; _i++) {
            n[_i].style = '';
          }
          for (var _i2 = 0; _i2 < q; _i2++) {
            n[_i2].style = 'background-color: yellow';
          }
        };
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['ADD_COMMENT_FROM_WAITCOMMENT']), {
    commitComment: function commitComment() {
      var _this = this;

      var self = this;
      var BOrderComment = {};
      BOrderComment.orderId = this.merch.orderId;
      BOrderComment.MerchandiseGuid = this.merch.merchandiseId;
      BOrderComment.comments = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#text').val();
      BOrderComment.commentLevel = this.level;

      this.gcapi('merchandiseComment', BOrderComment).then(function (response) {
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body.message);
          return;
        }
        self.ADD_COMMENT_FROM_WAITCOMMENT(_this.merch);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('评价成功');
        self.$router.go(-1);
      });
    }
  })
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      BOrderComments: JSON.parse(this.$route.query.BOrderComments),
      merch: JSON.parse(this.$route.query.merch)
    };
  },
  mounted: function mounted() {
    //      var self = this
    //      $(function () {
    //        var s = document.getElementById('starts')
    //        var n = s.getElementsByTagName('span')
    //
    //        for (var i = 0; i < n.length; i++) {
    //          n[i].onclick = function () {
    //            var q = +this.getAttribute('rel')
    //            self.level = q
    //            for (let i = q; i < n.length; i++) {
    //              n[i].style = ''
    //            }
    //            for (let i = 0; i < q; i++) {
    //              n[i].style = 'background-color: yellow'
    //            }
    //          }
    //        }
    //      })
  },

  methods: {}
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__child_MyOrder_vue__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__child_MyOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__child_MyOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      waitPaidOrders: [],
      waitDeliverOrders: [],
      finishedOrders: [],
      canceledOrders: [],
      waitSignOrders: [],
      completeOrders: [],
      quoteCompletedOrders: [],
      waitAuditOrders: [],
      failAuditOrders: [],
      baseUrl: '/emktResources/resocurces/img/pay/'
    };
  },

  components: {
    myOrder: __WEBPACK_IMPORTED_MODULE_2__child_MyOrder_vue___default.a
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#t' + this.$route.query.id).addClass('active');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#tab' + this.$route.query.id).addClass('active');
    if (this.myOrder) {
      this.waitPaidOrders = this.myOrder.waitPaidOrders;
      this.waitDeliverOrders = this.myOrder.waitDeliverOrders;
      this.myOrder.finishedOrders.forEach(function (item) {
        item.isFinished = true;
      });
      this.finishedOrders = this.myOrder.finishedOrders;
      this.canceledOrders = this.myOrder.canceledOrders;

      this.waitSignOrders = this.myOrder.waitSignOrders;
      this.completeOrders = this.myOrder.completeOrders;
      this.quoteCompletedOrders = this.myOrder.quoteCompletedOrders;
      this.waitAuditOrders = this.myOrder.waitAuditOrders;
      this.failAuditOrders = this.myOrder.failAuditOrders;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['myOrder', 'sessionInfo'])),
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['SET_CURRENT_WAITPAY_ORDER', 'SET_CURRENT_WAITPAY_ORDER']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    cancelOrderFromWaitPaid: function cancelOrderFromWaitPaid(order) {
      var self = this;
      this.gcapi('orderCancel', { id: order.id }).then(function (data) {
        var index = self.waitPaidOrders.indexOf(order);
        if (index >= 0) {
          self.waitPaidOrders.splice(index, 1);
        } else {
          index = self.waitDeliverOrders.indexOf(order);
          if (index >= 0) {
            self.waitDeliverOrders.splice(index, 1);
          }
        }
        self.canceledOrders.unshift(order);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('取消成功');
      });
    },
    orderPay: function orderPay(order) {
      // this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then(res => {
      //   if (res && res.body.result) {
      //     const waitPayOrder = res.body.result
      //     this.SET_CURRENT_WAITPAY_ORDER(waitPayOrder)
      //     this.$router.push({name: 'WeappOrderConfirmation'})
      //   }
      // })
      var clientOrder = order;
      this.SET_CURRENT_WAITPAY_ORDER(clientOrder);
      this.$router.replace({ name: 'WeappOrderConfirmation' });
      // this.$router.push({name: 'orderContent', params: {order: clientOrder}})
    },
    gotolast: function gotolast() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      ordernum: [],
      waitApproveStatus: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showPreloader('加载中');
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hidePreloader();
    }, 2000);
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  props: ['orderList', 'description', 'button1Name', 'button2Name', 'button3Name', 'button4Name', 'button5Name', 'payFlag'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'REMOVE_FROM_CART_LIST']), {
    buyAgain1: function buyAgain1(order) {
      var order1 = {};
      order1 = order.merchandises[0].merchandiseDetailForClient;
      order1.amplification = 1;
      //        order.merchandises[0].amplification = 1
      order1.amplification = 1;
      if (typeof order1._attributes.TVInfo.value === 'string') {
        var obj = {};
        obj.TLNo = order1._attributes.TVInfo.value;
        if (order1._attributesList[0].columnName === 'TVInfo') {
          order1._attributesList[0].value = obj;
          order1._attributesList[0].valueText = obj;
        }
      }
      for (var i in order1._attributesList) {
        if (order1._attributesList[i].value !== '214' && (order1._attributesList[i].columnName === 'AAVBloodType' || order1._attributesList[i].columnName === 'VirusTiter' || order1._attributesList[i].columnName === 'LVAmount' || order1._attributesList[i].columnName === 'NC_LV_Amount' || order1._attributesList[i].columnName === 'NC_LV_Amount' || order1._attributesList[i].columnName === 'NC_Lentivirus_Required' || order1._attributesList[i].columnName === 'NC_Plasmid_Amount' || order1._attributesList[i].columnName === 'NC_Plasmid_CultureRequired' || order1._attributesList[i].columnName === 'NC_Plasmid_Required' || order1._attributesList[i].columnName === 'PlasmidNumber' || order1._attributesList[i].columnName === 'Plasmid_Required' || order1._attributesList[i].columnName === 'Plasmid_Amount' || order1._attributesList[i].columnName === 'Plasmid_CultureRequired')) {} else {
          if ((order1._attributesList[i].groupId === 2 || order1._attributesList[i].groupId === 3) && order1._attributesList[i].columnName !== 'GeneInfo') {
            order1._attributesList[i].displayable = 0;
          }
          order1._attributesList[i].sorteditAble = false;
        }
        if (order1._attributesList[i].columnName === 'ContractType') {
          order1._attributesList[i].value = 3;
          order1._attributesList[i].valueText = 3;
        }
        if (order1._attributesList[i].columnName === 'Type' || order1._attributesList[i].columnName === 'Tech') {
          order1._attributesList[i].value = '-1';
          order1._attributesList[i].valueText = '-1';
          order1._attributes.Type.value = '-1';
          order1._attributes.Type.valueText = '-1';
        }
        if (order1._attributesList[i].columnName === 'PreContract') {
          order1._attributesList[i].value = order.contractNo + ':' + order.productName;
          order1._attributesList[i].valueText = order.contractNo + ':' + order.productName;
        }
        if (order1._attributesList[i].columnName === 'Source') {
          if (order1._attributes.ToolType.value === '3' || order1._attributes.ToolType.value === 3) {
            order1._attributesList[i].value = 4;
            order1._attributesList[i].valueText = 4;
          } else {
            order1._attributesList[i].value = 3;
            order1._attributesList[i].valueText = 3;
          }
        }
        if (order1._attributesList[i].columnName === 'PlasmidNumber') {
          if (order1._attributes.ToolType.value === '2' || order1._attributes.ToolType.value === 2) {
            if (order1._attributes.TargetNum.value === '-1' || order1._attributes.TargetNum.value === -1) {
              order1._attributesList[i].value = 1;
              order1._attributesList[i].valueText = 1;
            } else {
              order1._attributesList[i].value = order1._attributes.TargetNum.value;
              order1._attributesList[i].valueText = order1._attributes.TargetNum.valueText;
            }
          }
          if (order1._attributes.ToolType.value === '3' || order1._attributes.ToolType.value === 3) {
            order1._attributesList[i].value = 1;
            order1._attributesList[i].valueText = 1;
          }
        }
        if (order1._attributesList[i].columnName === 'VirusTiter') {
          if (order1._attributes.ProductName.value === 'RNAi综合－腺相关病毒外筛') {
            order1._attributesList[i].value = 3;
            order1._attributesList[i].valueText = 3;
          }
        }
        if (order1._attributesList[i].columnName === 'Plasmid_Amount') {
          if (order1._attributes.ProductName.value === '过表达慢病毒（Tet-on）' || order1._attributes.ProductName.value === '过表达慢病毒' || order1._attributes.ProductName.value === '过表达慢病毒（悬浮细胞专用）') {
            order1._attributesList[i].value = '-1';
            order1._attributesList[i].valueText = '-1';
          }
        }
        if (order1._attributesList[i].columnName === 'NC_LV_Amount') {
          if (order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(SAM)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(双载体)') {
            order1._attributesList[i].value = '-1';
            order1._attributesList[i].valueText = '-1';
          }
        }
        if (order1._attributesList[i].columnName === 'GeneInfo.category') {
          if (order1._attributes.ProductName.value === 'miRNA-down-腺相关病毒' || order1._attributes.ProductName.value === 'miRNA-up-腺相关病毒') {
            order1._attributesList[i].value = '-1';
            order1._attributesList[i].valueText = '-1';
          }
        }
      }
      if (order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(SAM)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(SAM,sgRNA)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体,sgRNA)' || order1._attributes.ProductName.value === 'RNAi-Easy(三保一)-慢病毒' || order1._attributes.ProductName.value === 'RNAi-Easy(三保一)-腺病毒' || order1._attributes.ProductName.value === 'RNAi-Easy-慢病毒（悬浮细胞专用）' || order1._attributes.ProductName.value === 'RNAi-Easy-逆转录病毒（悬浮细胞专用）') {
        alert('原订单为三个靶点，本次扩增产品只扩增其中您验证有效的靶点，且需要您提供有效靶点信息。如有疑问，请联系在线客服。');
      }
      this.$router.push({ name: 'finderMerchandises', query: { categoryId: order1.categoryId }, params: { merchandises: order1 } });
    },
    response1: function response1(order) {
      this.$emit('response1', order);
    },
    response2: function response2(order) {
      this.$emit('response2', order);
    },
    response3: function response3(merchandise) {
      if (merchandise.merchandiseDetailForClient.categoryId !== 10) {
        this.$router.push({ name: 'merchandises', query: { id: merchandise.merchandiseGuid } });
      } else {
        this.$router.push({ name: 'custDetail', query: { custom: merchandise._attributesList, workdays: merchandise.workdays } });
      }
    },
    response4: function response4(priceDetails) {
      this.$router.push({ name: 'custPriceDetail', query: { priceDetails: priceDetails } });
    },
    response6: function response6(merchandises) {
      for (var m in merchandises) {
        merchandises[m].merchandiseDetailForClient.id = merchandises[m].orderGuid;
        merchandises[m].merchandiseDetailForClient.merchandiseId = merchandises[m].orderGuid;
        this.REMOVE_FROM_CART_LIST(merchandises[m].merchandiseDetailForClient.merchandiseId);
        this.ADD_CART_LIST(merchandises[m].merchandiseDetailForClient);
      }
      this.$router.push({ name: 'cart' });
    },
    response5: function response5(comments) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        title: '审核意见',
        afterText: '<div style="margin-top: 10px">' + comments + '</div>',
        buttons: [{
          text: '确定',
          bold: true,
          onClick: function onClick() {}
        }]
      });
    }
  }),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      BOrder: JSON.parse(this.$route.query.BOrder),
      merchandises: []
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo']), {
      balanceTypeResearch: __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].BALANCE_TYPE_RESEARCH_GROUP
    });
  },
  created: function created() {
    var self = this;
    if (this.BOrder.merchandises.length > 0) {
      this.BOrder.merchandises.forEach(function (merchandise) {
        if (merchandise.merchandiseDetailForClient) {
          merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid;
          self.merchandises.push(merchandise.merchandiseDetailForClient);
        }
      });
    } else if (this.BOrder.subOrders.length > 0) {
      for (var i = 0; i < this.BOrder.subOrders.length; i++) {
        this.BOrder.subOrders[i].merchandises.forEach(function (merchandise) {
          if (merchandise.merchandiseDetailForClient) {
            merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid;
            self.merchandises.push(merchandise.merchandiseDetailForClient);
          }
        });
      }
    }
    console.log(self.BOrder);
    if (this.BOrder.balanceType === this.balanceTypeResearch) {
      this.BOrder.payTypeName = '课题组结算';
    }
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_3__components_MerchandiseList_vue___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['ADD_CART_LIST']), {
    addCartList: function addCartList(merchandises) {
      var self = this;
      merchandises.forEach(function (item, index) {
        if (item.categoryId === 10) {
          var mId = item.merchandiseId;
          mId = mId + new Date().getTime();
          item.merchandiseId = mId;
          if (self.BOrder.productGuid === '') {
            item.productGuid = self.BOrder.subOrders[index].productGuid;
          } else {
            item.productGuid = self.BOrder.productGuid;
          }
          if (self.BOrder.workdays) {
            item.workdays = self.BOrder.workdays;
          }
        }
        if (item.categoryId === 6) {
          self.$weui.topTips('细胞相关产品已经下架！不可再次购买！', 2000);
          return;
        }
        if (item.categoryId === 20) {
          item.productGuid = self.BOrder.productGuid;
        }
        item.newMerch = 1;
        self.ADD_CART_LIST(item);
      });
      this.$router.push({ name: 'cart' });
    },
    buyAgain1: function buyAgain1(order) {
      order.merchandises[0].amplification = 1;
      order.merchandises[0].merchandiseDetailForClient.amplification = 1;
      if (typeof order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value === 'string') {
        var obj = {};
        obj.TLNo = order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value;
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[0].columnName === 'TVInfo') {
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].value = obj;
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].valueText = obj;
          //          order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value = obj
          //          order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.valueText = obj
        }
      }
      for (var i in order.merchandises[0].merchandiseDetailForClient._attributesList) {
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].value !== '214' && (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'AAVBloodType' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'LVAmount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Lentivirus_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_CultureRequired' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_CultureRequired')) {} else {
          if ((order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 2 || order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 3) && order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName !== 'GeneInfo') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].displayable = 0;
          }
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].sorteditAble = false;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'ContractType') {
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributes.ContractType.value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Type' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Tech') {
          order.merchandises[0].merchandiseDetailForClient._attributes.Type.value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributes.Tech.value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = '-1';
        }
        //          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PreContract') {
        //            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = order.contractNo
        //            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = order.contractNo
        //          }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Source') {
          order.merchandises[0].merchandiseDetailForClient._attributes.Source.value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber') {
          if (order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === '2' || order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === 2) {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.value;
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.valueText;
          }
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter') {
          if (order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'RNAi综合－腺相关病毒外筛') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
          }
        }
        //          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Tech') {
        //            if (order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'RNAi综合－腺病毒外筛' || order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'CAS9-KO-腺相关病毒') {
        //              order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = '-1'
        //              order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = '-1'
        //            }
        //          }
      }
      this.$router.push({ name: 'finderMerchandises', query: { categoryId: order.merchandises[0].merchandiseDetailForClient.categoryId }, params: { merchandises: order.merchandises[0].merchandiseDetailForClient } });
    },
    sendEMail: function sendEMail() {
      var self = this;
      if (this.sessionInfo().customerInfo && this.sessionInfo().customerInfo.email) {
        this.callSendEmailMethod(this.sessionInfo().customerInfo.email);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.alert('请填写正确的邮箱:<input id = "ema" type="text"></input>', function () {
          if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#ema').val()) {
            self.callSendEmailMethod(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#ema').val());
          } else {
            self.sendEMail();
          }
        });
      }
    },
    isEamil: function isEamil(str) {
      var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      return reg.test(str);
    },
    callSendEmailMethod: function callSendEmailMethod(email) {
      if (!this.isEamil(email)) {
        this.sendEMail();
        return;
      }
      var obj = { 'orderId': this.BOrder.id, 'email': email
        //        obj.push({'orderId': this.BOrder.id})
        //        obj.push({'email': email})
      };this.gcapi('sendOrderExperimentReport', obj).then(function (response) {
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body.message);
          return;
        }
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('已发送到您的邮箱');
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    goToDetail: function goToDetail(product) {
      if (product.merchandiseDetailForClient.categoryId !== 10) {
        if (product.merchandiseDetailForClient.categoryId === 20) {
          this.$router.push({ name: 'FinderOrderDeail', params: { merchandises: product, type: 1 } });
        } else {
          this.$router.push({ name: 'finderMerchandises', query: { id: product.merchandiseGuid } });
        }
        //          this.$router.push({name: 'merchandises', query: { id: product.merchandiseGuid }})
      } else {
        this.$router.push({ name: 'custDetail', query: { custom: product._attributesList, workdays: product.workdays } });
      }
    }
  })
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.matchData();
    this.reset();
  },
  mounted: function mounted() {
    var enterprise = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#panel-right-demo');
    enterprise.on('open', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('panelFilterFlag', true);
    });
    enterprise.on('closed', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('panelFilterFlag', false);
    });
    this.init();
  },
  data: function data() {
    return {
      categorySelected: '',
      itemSel: [],
      categoryOptions: [],
      currSelection: [],
      search: {},
      currentCategory: '',
      tempOption: [],
      categoriesOptions: [],
      categoryId: '',
      queryParams: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['routerSrc', 'queryTotal']), {
    selection: function selection() {
      var options = this.categoryOptions;
      if (this.categorySelected === '') {
        this.categorySelected = this.$route.query.label;
        this.currentCategory = this.$route.query.id;
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.openPanel('#panel-right-demo');
      }
      console.log('tempOption', this.tempOption);
      console.log(options);
      for (var i in options) {
        if (this.categorySelected === options[i].text) {
          this.currSelection = options[i].children;
          this.categoryId = options[i].id;
          this.tempOption = options[i];
          return options[i].children;
        }
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['QUERY_PARAMS_STORE']), {
    reset: function reset() {
      var src = this.routerSrc.name;
      if (src === 'home' || src === 'category') {
        this.categoryId = '';
        this.categorySelected = '';
      }
      this.itemSel = [];
      this.queryParams = '';
    },
    matchData: function matchData() {
      var _this = this;

      var meta = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getEmktMetaData();
      var categories = meta.categoriesMap;
      var match = meta.categoryIdToFilterAttributes;
      var attr = meta.categoryAttrsMap;

      var _loop = function _loop() {
        var val = match[k];
        if (val) {
          var key = categories[k].categoryLabel;
          var valAttr = [];
          //            let rows = ''
          var rowsCount = 0;
          for (i in val) {
            var objAttr = {};
            objAttr['attributeName'] = attr[k][val[i].attributeName].categoryAttrLabel;
            var temp = val[i].filterItems;
            temp.forEach(function (data) {
              data['attributeNameSrc'] = val[i].attributeName;
            });
            objAttr['filterItems'] = temp;
            valAttr.push(objAttr);
            rowsCount = Math.ceil(valAttr.length / 3);
          }
          var obj = { 'id': categories[k].categoryId, 'text': key, 'value': key, 'children': valAttr, 'rowsCount': rowsCount };
          _this.categoryOptions.push(obj);
        }
      };

      for (var k in categories) {
        var i;

        _loop();
      }
      if (this.$route.query.search) {
        this.search = JSON.parse(this.$route.query.search);
      }
    },
    queryHandler: function queryHandler() {
      var items = this.itemSel;
      //        let options = this.categoryOptions
      //        for (var k in options) {
      //          if (this.categorySelected === options[k].text) {
      //            this.currSelection = options[k].children
      //            this.categoryId = options[k].id
      //          }
      //        }
      var obj = {};
      for (var i in items) {
        var arr = [];
        for (var j in items) {
          if (items[i].attributeNameSrc === items[j].attributeNameSrc) {
            arr.push(items[j].dictKey);
            obj[items[i].attributeNameSrc] = arr;
          }
        }
      }
      var queryParam = {};
      if (this.categoryId !== '') {
        queryParam.filterConditions = obj;
        this.queryParams = obj;
        queryParam.categoryId = this.categoryId;
      }
      if (this.search.categoryId) {
        this.categoryId = this.search.categoryId;
      }
      queryParam.keywordChosen = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#searchGoods').val();
      queryParam.tagIds = this.search.tagIds;
      queryParam.fromIndex = 0;
      queryParam.promotionGuid = this.search.promotionGuid;
      this.QUERY_PARAMS_STORE(queryParam);
    },
    clickConfirm: function clickConfirm() {
      this.queryHandler();
    },
    selectChanged: function selectChanged(val) {
      var queryParam = {};
      var id = 0;
      var sel = this.categorySelected;
      this.categoryOptions.forEach(function (data) {
        if (data.value === sel) {
          id = data.id;
        }
      });
      if (this.categoryId !== '') {
        queryParam.categoryId = this.categoryId;
      }
      if (id) {
        this.categoryId = id;
        queryParam.categoryId = id;
      }
      queryParam.keywordChosen = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#searchGoods').val();
      queryParam.tagIds = this.search.tagIds;
      queryParam.fromIndex = 0;
      queryParam.promotionGuid = this.search.promotionGuid;
      this.QUERY_PARAMS_STORE(queryParam);
      // this.itemSel = []
    },
    init: function init() {
      this.categoryId = '';
      this.itemSel = [];
      var query = this.$route.query;
      var id = '';
      if (query) {
        if (query.categoryId) {
          id = parseInt(query.categoryId);
        } else {
          id = parseInt(query.id);
        }
        if (id) {
          this.categoryId = id;
        }
        if (id === 5 || id === 8 || id === 14 || id === 7 || id === 9) {
          var ret = {};
          var cs = '';
          var cc = '';
          var ci = '';
          this.categoryOptions.filter(function (e, index, self) {
            if (e.id === id) {
              ret = e;
              cs = e.text;
              cc = e.text;
              ci = e.id;
              return ret;
            }
          });
          this.categorySelected = cs;
          this.currentCategory = cc;
          this.categoryId = ci;
          this.tempOption = ret;
          if (query.filterName && query.filterName !== 'promotionGuid') {
            for (var _i in ret.children) {
              for (var j in ret.children[_i].filterItems) {
                if (ret.children[_i].filterItems[j].attributeNameSrc === query.filterName && ret.children[_i].filterItems[j].dictKey === parseInt(query.filterValue)) {
                  this.itemSel.push(ret.children[_i].filterItems[j]);
                }
              }
            }
          }
          __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.openPanel('#panel-right-demo');
        }
      }
      var src = this.routerSrc.name;
      var i = this.categoryId;
      if (i !== 5 && i !== 8 && i !== 14 && i !== 7 && i !== 9 && (src === 'home' || src === 'category')) {
        this.categorySelected = '';
        this.currentCategory = '';
      }
    }
  }),
  watch: {
    itemSel: {
      handler: 'queryHandler',
      deep: true
    },
    'routerSrc': function routerSrc() {
      var _this2 = this;

      /*
        if the route comes from category detail,
        checks category default on the base of the query params of router
       */
      var cur = this.routerSrc.query;
      var currentCategory = void 0;
      if (cur) {
        currentCategory = cur.label;
        if (currentCategory) {
          this.currentCategory = currentCategory;
          this.categorySelected = this.currentCategory;
          this.categoryId = cur.id;
          var options = this.categoryOptions;
          if (options) {
            options.forEach(function (data) {
              if (data.text === currentCategory) {
                var obj = { 'text': data.text, 'value': data.text, 'children': data.children };
                _this2.tempOption = obj;
              }
            });
          }
        } else {
          this.reset();
        }
        //          if (this.routerSrc.name !== 'home' && (this.routerSrc.query.id !== 'undefined' && this.routerSrc.query.id !== 2 && this.routerSrc.query.id !== 3 && this.routerSrc.query.id !== 12 && this.routerSrc.query.id !== 1 && this.routerSrc.query.id !== 6 && this.routerSrc.query.id !== 7)) {
        //            $.openPanel('#panel-right-demo')
        //          }
      }
    },
    '$route': function $route() {
      //        this.reset()
      if (this.$route.name === 'categoryDetail') {
        this.init();
      }
    },
    'queryTotal': function queryTotal() {
      var _this3 = this;

      if (!this.categorySelected) {
        /*
         进一步过滤this.categoryOptions，仅获取查询结果中的类别
         */
        var searchCategories = this.queryTotal.category;
        var options = this.categoryOptions;
        var ret = [];
        options.forEach(function (data) {
          var val = searchCategories[data.id];
          if (val) {
            _this3.categoryOptions.filter(function (e, index, self) {
              if (e.id === data.id) {
                ret.push(e);
                return ret;
              }
            });
          }
        });
        this.categoriesOptions = ret;
      }
    },
    'categorySelected': 'selectChanged'
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
  },
  created: function created() {
    //      this.fetchData()
  },
  data: function data() {
    return {
      compositions: [],
      isWapp: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].isWapp
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'fetchData'
  },
  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_2__components_MerchandiseList_vue___default.a, newMerchandiseListA: __WEBPACK_IMPORTED_MODULE_3__finder_components_NewMerchandiseListA_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['merchdiseGroup'
  // ...
  ])),
  methods: {
    fetchData: function fetchData() {},
    tolast: function tolast() {
      this.$router.go(-1);
    },
    gotolast: function gotolast() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__finder_components_NewMerchandiseListA__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__finder_components_NewMerchandiseListA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__finder_components_NewMerchandiseListA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_wx__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderId: this.$route.query.orderId,
      merchandise: [],
      total: 0,
      baseurl: 'emktResources/resocurces/img/promotion/',
      coupons: [],
      bcoupons: [],
      channel: {},
      showPage: false,
      CanStartAuthentication: false,
      authenticationDetail: null,
      activityRedirectPath: '',
      activityType: null
    };
  },
  created: function created() {
    if (this.$route.query.cc) {
      this.checkOrderStatus();
    }
    this.fetchData();
    if (this.$route.query.activityId) {
      this.getActivityPath();
    }
    console.log('isSpecialPromotion', this.isSpecialPromotion);
  },

  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_5__components_MerchandiseList_vue___default.a, newMerchandiseListA: __WEBPACK_IMPORTED_MODULE_6__finder_components_NewMerchandiseListA___default.a, FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_7__views_v_2_6_components_FooterPlaceholder_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['hasLogin', 'isWapp'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['sessionInfo']), {
    isSpecialPromotion: function isSpecialPromotion() {
      return this.$route.query.id === 'promotion-C-275';
    }
  }),
  methods: {
    goToSpecialPromotion: function goToSpecialPromotion() {
      var customerInfo = this.sessionInfo && this.sessionInfo.customerInfo;
      if (!customerInfo) {
        this.$weui.toast('未获取到用户信息，请先登录后重试', 2500);
        return;
      }
      var params = new URLSearchParams({
        customerNo: customerInfo.customerNo || '',
        customerName: customerInfo.customerName || '',
        customerMobile: customerInfo.mobile || '',
        customerSession: customerInfo.session || ''
      });
      window.location.href = 'https://www.genechemat.com/worldcup/?' + params.toString();
    },
    checkOrderStatus: function checkOrderStatus() {
      var _this2 = this;

      if (!this.sessionInfo.customerInfo) {
        return;
      }
      this.authenticationDetail = {
        'customerName': this.sessionInfo.customerInfo.customerName,
        'orderId': this.orderId
        // 获取最新的客户信息
      };this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(function (response) {
        if (response.body.result) {
          _this2.authenticationDetail = {
            'customerName': response.body.result.customerName,
            'orderId': _this2.orderId
          };
        }
        _this2.gcapi('getWaitPayOrderInfoByOrderId', parseInt(_this2.$route.query.orderId)).then(function (res) {
          if (res.body.code === 0) {
            var signStatus = res.body.result.signStatus;
            if (signStatus === 2) {
              _this2.$router.replace({ name: 'PromotionSuccess', query: { orderId: _this2.orderId } });
            } else if (signStatus === 1) {
              _this2.$router.replace({ name: 'sendAuthentication', params: { authenticationInfo: _this2.authenticationDetail }, query: { orderId: _this2.orderId, time: 60 } });
            } else {
              _this2.fetchData();
              _this2.showPage = true;
            }
          } else {
            alert('获取电签状态失败，请检查你的网络或联系客服！');
          }
        });
      });
    },
    goStartAuthentication: function goStartAuthentication(customerNo) {
      if (!this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast('请先登录');
        this.$router.push({ name: 'login' });
      } else {
        this.$router.replace({ name: 'authenticationHome', query: { orderId: this.orderId, customerNo: customerNo } });
      }
    },
    sendAuthentication: function sendAuthentication() {
      var _this3 = this;

      var _this = this;
      _this.$weui.loading('正在发送短信');
      _this.gcapi('startEmktSignFlowByCustomer', this.authenticationDetail).then(function (response) {
        _this.$weui.loading().hide();
        if (response.body.message !== '') {
          _this.$weui.toast(response.body.message, 3000);
        } else {
          _this.$weui.toast('短信已经发送！', 3000);
          _this.$router.replace({ name: 'sendAuthentication', params: { authenticationInfo: _this3.authenticationDetail }, query: { orderId: _this3.orderId, time: 60 } });
        }
      }, function (response) {
        console.log(response.body.message);
        _this.$weui.toast(response.body.message, 2500);
      });
    },
    go: function go() {
      var _this4 = this;

      console.log(this.sessionInfo);
      this.$weui.loading('正在获取信息');
      this.gcapi('getSignCustomerInfo', this.orderId).then(function (res) {
        console.log(res.body);
        var result = res.body.result;
        if (result) {
          if (result.authenticationInfo && result.authenticationInfo.length > 0) {
            _this4.sendAuthentication();
          } else {
            _this4.$weui.loading().hide();
            _this4.goStartAuthentication(result.customerNo);
          }
        }
      });
    },
    fetchData: function fetchData() {
      var _this5 = this;

      if (this.$route.query.id === '') {
        if (__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations') && __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations').length > 0) {
          this.merchandise = __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations');
        } else {
          this.merchandise = __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktAllRecommends');
        }
      } else if (this.$route.query.promotionGroupGuid) {
        var channel = {};
        var channelList = __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktChannels');
        for (var m = 0; m < channelList.length; m++) {
          if (this.$route.query.promotionGroupGuid === channelList[m].promotionGroupGuid) {
            channel = channelList[m];
          }
        }
        this.channel = channel;
        if (channel.promotionList.length === 1) {
          this.gcapi('queryMerchandise', { promotionGuid: channel.promotionList[0].promotionGuid, fromIndex: 0 }).then(function (response) {
            _this5.merchandise = response.body.result.merchandiseList;
            _this5.total = response.body.result.total;
          });
        }
      } else {
        this.gcapi('queryMerchandise', { promotionGuid: this.$route.query.id, fromIndex: 0 }).then(function (response) {
          _this5.merchandise = response.body.result.merchandiseList;
          _this5.total = response.body.result.total;
        });
        if (this.$route.query.type === 6) {
          this.gcapi('getSeckillPromotion', this.$route.query.id).then(function (response) {
            console.log(response.body.result);
          });
        }
        /*
        this.gcapi('getApplicableMerchandiseLiteList', this.$route.query.id).then((response) => {
          this.merchandise = response.body.result
        })
        */
      }
      var Promotions = [];
      Promotions = __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getLocalStorage('EmktPromotions');
      for (var i = 0; i < Promotions.length; i++) {
        if (Promotions[i].promotionGuid === this.$route.query.id) {
          // var newcoupons = []
          // var oldcoupons = []
          // oldcoupons = Promotions[i].couponTemplateList
          // if (oldcoupons) {
          //   for (var k = 0; k < oldcoupons.length; k++) {
          //     if (oldcoupons[k].type === 0) {
          //       this.bcoupons.push(oldcoupons[k])
          //     } else {
          //       newcoupons.push(oldcoupons[k])
          //     }
          //   }
          // }
          // for (var j = 0; j < newcoupons.length; j = j + 3) {
          //   var tabs2 = []
          //   tabs2.push(newcoupons[j])
          //   tabs2.push(newcoupons[j + 1])
          //   tabs2.push(newcoupons[j + 2])
          //   this.coupons.push(tabs2)
          // }
          this.coupons = Promotions[i].couponTemplateList;
        }
      }
      // if (this.$route.query.id === emkt.AuthenticationID && this.hasLogin) {
      //   this.gcapi('gcwwwifc/getCustomerWithoutLogin?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(response => {
      //     if (response.body.result) {
      //       if (!response.body.result.authenticationInfo) {
      //         this.CanStartAuthentication = false
      //       } else {
      //         this.CanStartAuthentication = true
      //         // self.$weui.toast('您已实名认证过！', 2500)
      //       }
      //     } else {
      //       this.$weui.toast(response.body.message, 1500)
      //     }
      //   })
      // }
    },
    getcoupon: function getcoupon(data) {
      var self = this;
      if (!self.hasLogin) {
        if (__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].isWapp) {
          self.$weui.confirm('请先登录再来领取优惠！', {
            title: '提示',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: function onClick() {
                console.log('no');
              }
            }, {
              label: '去登录',
              type: 'primary',
              onClick: function onClick() {
                var wappLoginType = __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].getFullUrlParam('LoginType');
                var pages = wappLoginType === __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].WAPP_LOGIN_TYPE_CODE ? __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].WAPP_LOGIN_TYPE_DICTIONARY[__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].WAPP_LOGIN_TYPE_CODE] : __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].WAPP_LOGIN_TYPE_DICTIONARY[__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].WAPP_LOGIN_TYPE_WX];
                __WEBPACK_IMPORTED_MODULE_9_wx___default.a.miniProgram.navigateTo({
                  url: pages
                });
              }
            }]
          });
        } else {
          self.$weui.alert('请您先登录~');
          this.$router.push({ name: 'login' });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.confirm('您确定领取此优惠券吗？', function () {
          self.gcapi('requestCoupon', { promotionGuid: data.promotionGuid, code: data.code }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.toast(response.body.result);
            console.log(response.body.result);
          });
          //            requestCoupon(data)
        }, function () {
          console.log('cancel');
        });
      }
    },
    loadmore: function loadmore() {
      var _this6 = this;

      var fromindex = this.merchandise.length;
      if (fromindex >= this.total) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.button').remove();
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#over').append('已经到底啦！');
        return;
      } else {
        var addlist = [];
        if (this.channel.promotionList && this.channel.promotionList.length === 1) {
          this.gcapi('queryMerchandise', { promotionGuid: this.channel.promotionList[0].promotionGuid, fromIndex: fromindex }).then(function (response) {
            addlist = response.body.result.merchandiseList;
            for (var i = 0; i < addlist.length; i++) {
              _this6.merchandise.push(addlist[i]);
            }
          });
        } else {
          this.gcapi('queryMerchandise', { promotionGuid: this.$route.query.id, fromIndex: fromindex }).then(function (response) {
            addlist = response.body.result.merchandiseList;
            for (var i = 0; i < addlist.length; i++) {
              _this6.merchandise.push(addlist[i]);
            }
          });
        }
      }
    },
    tolast: function tolast() {
      this.$router.go(-1);
    },
    gotolast: function gotolast() {
      this.$router.push({ name: 'home' });
    },
    openLink: function openLink() {
      var promotionId = this.$route.query.id;
      if (promotionId.includes('20210318-004')) {
        return true;
      }
      return false;
    },
    openLink2: function openLink2() {
      var promotionId = this.$route.query.id;
      if (promotionId.includes('-154')) {
        return true;
      }
      return false;
    },
    openLink3: function openLink3() {
      var promotionId = this.$route.query.id;
      if (promotionId.includes('-161')) {
        return true;
      }
      return false;
    },
    goToActivity: function goToActivity() {
      var promotionId = this.$route.query.id;
      if (promotionId.includes('-169')) {
        return this.$router.push({ name: 'ActivityDoctor' });
      }
      return;
    },
    getActivityPath: function getActivityPath() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var activityTypeRes, activityPath;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this7.gcapi('couponActivityById', parseInt(_this7.$route.query.activityId));

              case 2:
                activityTypeRes = _context.sent;

                console.log('activityTypeRes', activityTypeRes);
                _this7.activityType = activityTypeRes && activityTypeRes.body.result && activityTypeRes.body.result.activityType;
                activityPath = void 0;
                _context.t0 = _this7.activityType;
                _context.next = _context.t0 === __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].COUPON_ACTIVITY_TYPE_COUPON ? 9 : _context.t0 === __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].COUPON_ACTIVITY_TYPE_GROUP_BUY ? 11 : _context.t0 === __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].COUPON_ACTIVITY_TYPE_ANNIVERSARY ? 13 : 15;
                break;

              case 9:
                activityPath = '/pages/coupon/index';
                return _context.abrupt('break', 16);

              case 11:
                activityPath = '/pages/coupon/group-coupon/index';
                return _context.abrupt('break', 16);

              case 13:
                activityPath = '/Weapp/activity/anniversary';
                return _context.abrupt('break', 16);

              case 15:
                activityPath = '/pages/coupon/index';

              case 16:
                _this7.activityRedirectPath = activityPath + '?activityId=' + _this7.$route.query.activityId;
                console.log('activityPath:', _this7.activityRedirectPath);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    goToActivityDetailPage: function goToActivityDetailPage() {
      if (this.activityType === __WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].COUPON_ACTIVITY_TYPE_ANNIVERSARY) {
        this.$router.push(this.activityRedirectPath);
      } else if (__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_9_wx___default.a.miniProgram.navigateTo({
          url: self.activityRedirectPath
        });
      }
    },
    checkForCouponActivity: function checkForCouponActivity() {
      var self = this;
      console.log('self.$route', self.$route);
      if (self.$route.query.activityId) {
        if (!self.hasLogin) {
          if (__WEBPACK_IMPORTED_MODULE_8__emkt_js__["a" /* default */].isWapp) {
            this.goToActivityDetailPage();
            // self.$weui.confirm('请先登录再来领取优惠！', {
            //   title: '提示',
            //   buttons: [{
            //     label: '取消',
            //     type: 'default',
            //     onClick: function () { console.log('no') }
            //   }, {
            //     label: '去登录',
            //     type: 'primary',
            //     onClick: function () {
            //       const wappLoginType = emkt.getFullUrlParam('LoginType')
            //       const pages = wappLoginType === emkt.WAPP_LOGIN_TYPE_CODE ? emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_CODE] : emkt.WAPP_LOGIN_TYPE_DICTIONARY[emkt.WAPP_LOGIN_TYPE_WX]
            //       wx.miniProgram.navigateTo({
            //         url: pages
            //       })
            //     }
            //   }]
            // })
          } else {
            self.$weui.alert('请您先登录~');
            this.$router.push({ name: 'login' });
          }
        } else {
          this.goToActivityDetailPage();
        }
      }
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finder_components_NewMerchandiseListA__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finder_components_NewMerchandiseListA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__finder_components_NewMerchandiseListA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Countdown__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Countdown__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SecPromotion',
  components: { newMerchandiseListA: __WEBPACK_IMPORTED_MODULE_5__finder_components_NewMerchandiseListA___default.a, Countdown: __WEBPACK_IMPORTED_MODULE_6__components_Countdown___default.a },
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/promotion/',
      merchandise: [],
      total: 0,
      startDT: '',
      endDT: '',
      secPromotion: __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktSecPromotion'),
      isWapp: __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isWapp
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['secInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['secFlag'])),
  mounted: function mounted() {
    this.fetchData();
    this.getSecPromotionInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['SET_SECPROMOTION_INFO']), {
    fetchData: function fetchData() {
      var _this = this;

      // get merchandise list
      if (this.$route.query.id === '') {
        if (__WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations') && __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations').length > 0) {
          this.merchandise = __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktRecommendations');
        } else {
          this.merchandise = __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktAllRecommends');
        }
      } else {
        this.gcapi('queryMerchandise', { promotionGuid: this.$route.query.id, fromIndex: 0 }).then(function (response) {
          _this.merchandise = response.body.result.merchandiseList;
          _this.total = response.body.result.total;
          console.log('merchandise', _this.merchandise, _this.total);
        });
      }
    },
    loadmore: function loadmore() {
      var _this2 = this;

      var fromindex = this.merchandise.length;
      if (fromindex >= this.total) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.button').remove();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#over').append('已经到底啦！');
        return;
      } else {
        var addlist = [];
        this.gcapi('queryMerchandise', { promotionGuid: this.$route.query.id, fromIndex: fromindex }).then(function (response) {
          addlist = response.body.result.merchandiseList;
          for (var i = 0; i < addlist.length; i++) {
            _this2.merchandise.push(addlist[i]);
          }
        });
      }
    },
    tolast: function tolast() {
      return this.$router.go(-1);
    },
    getSecPromotionInfo: function getSecPromotionInfo() {
      var _this3 = this;

      var info = {};
      if (this.secPromotion === '' || this.secPromotion === undefined) {
        return;
      }
      info.startDT = this.secPromotion.startDT;
      info.endDT = this.secPromotion.endDT;
      info.promotionGuid = this.secPromotion.promotionGuid;
      info.now = Date.parse(new Date());
      this.gcapi('getSeckillPromotion', info.promotionGuid).then(function (response) {
        var result = response.body.result;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(info, result);
        _this3.SET_SECPROMOTION_INFO(info);
        console.log('secinfo', _this3.secInfo);
        console.log('secflag', _this3.secFlag);
      });
    },
    openLink: function openLink() {
      var promotionId = this.$route.query.id;
      var type = this.$route.query.type;
      if (promotionId.endsWith('161') && type === 6) {
        return true;
      }
      return false;
    }
  })
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.goWapp();
  },

  methods: {
    goWapp: function goWapp() {
      if (this.$route.query && this.$route.query.link) {
        location.href = this.$route.query.link;
      } else {
        this.$router.replace('home');
      }
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchCoupons();
  },

  watch: {
    'researchGroupDetailList': {
      handler: 'fetchTotalWaitApproveOrder',
      immediate: true
    }
  },
  mounted: function mounted() {
    this.hasLogin();
  },
  data: function data() {
    return {
      myCoupons: [],
      baseUrl: '/emktResources/resocurces/img/pay/',
      attrurl: '/emktResources/resocurces/img/promotion/',
      totalWaitApproveOrder: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['LOGIN_STATE_UPDATE', 'CLIENT_INFO_UPDATE', 'MYORDER_UPDATE', 'CLIENT_INFO', 'INIT_MESSAGE', 'UPDATE_SHOWBILLINFO', 'REMOVE_ALL_FROM_CART_LIST']), {
    toOrderDetail: function toOrderDetail(selectId) {
      // if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 0) {
      //   this.$router.push({name: 'WeappMyOrders'})
      // } else {
      //   this.$router.push({name: 'myOrders', query: {id: selectId}})
      // }
      this.$router.push({ name: 'myOrders', query: { id: selectId } });
    },
    toEvaluationOrder: function toEvaluationOrder() {
      this.$router.push({ name: 'evaluation' });
    },
    logout: function logout() {
      var _this = this;
      _this.gcapi('getRecommendation', 'GUEST').then(function (res) {
        //                EMKT.setStoreItem('EmktPlain', merchList)
        var i = 0;
        var list = [];
        var newlist = res.body.result;
        if (newlist.length > 15) {
          for (i = 0; i < 15; i++) {
            list.push(newlist[i]);
          }
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setStoreItem('EmktRecommendations', list);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setStoreItem('EmktRecommendations', newlist);
        }
      });
      _this.gcapi('gcwwwifc/userLogout').then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.sign.shareUrl = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].wxShareUrl;
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].wxShare();
          //              _this.CLIENT_INFO_UPDATE('')
          //              _this.MYORDER_UPDATE('')
          //              _this.LOGIN_STATE_UPDATE(false)
          //              window.location = window.location.origin
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('注销成功');
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.sign.shareUrl = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].wxShareUrl;
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].wxShare();
          _this.CLIENT_INFO_UPDATE('');
          _this.MYORDER_UPDATE('');
          _this.LOGIN_STATE_UPDATE(false);
          _this.gcapi('@gcwwwifc/login', {
            'LoginId': 'guest',
            'Password': 'guest'
          }).then(function (response) {
            if (response !== undefined) {
              var res = response.body.result;
              _this.CLIENT_INFO(res);
            }
          });
          // 客户注销登录 清空cartList
          _this.REMOVE_ALL_FROM_CART_LIST();
          _this.$router.push('/category');
        }
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('失败');
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('失败，请重试');
      });
    },
    hasLogin: function hasLogin() {
      var _this = this;
      var guest = _this.sessionInfo;
      var customerInfo = _this.sessionInfo.customerInfo;
      // console.log(customerInfo)
      //        console.log('login state: ' + _this.hasLogin)
      if (guest.customerNo === 'GUEST' || customerInfo === '') {
        _this.$router.push('/login');
      }
    },
    fetchCoupons: function fetchCoupons() {
      var _this = this;
      var customerInfo = _this.sessionInfo.customerInfo;
      var customerNo = '';
      if (customerInfo) {
        customerNo = customerInfo.customerNo;
        var BillInfoBlacklis = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('EmktBillInfoBlacklist');
        if (BillInfoBlacklis !== undefined && BillInfoBlacklis !== null) {
          if (BillInfoBlacklis.indexOf(customerNo) !== -1) {
            _this.UPDATE_SHOWBILLINFO(false);
          } else {
            _this.UPDATE_SHOWBILLINFO(true);
          }
        }
        _this.gcapi('getMyCoupons', customerNo).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('allCoupons', res.body.result);
          // const coupons = []
          // for (let coupon of res.body.result) {
          //   coupon.startDT = coupon.startDT.replace(/-/g, '/')
          //   coupon.endDT = coupon.endDT.replace(/-/g, '/')
          //   if (new Date().getTime() <= new Date(coupon.endDT).getTime()) {
          //     coupons.push(coupon)
          //   }
          // }
          // var specialcouponpromotions = EMKT.getLocalStorage('EmktSpecialcouponpromotions')
          // for (let pro of specialcouponpromotions) {
          //   let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
          //   let now = new Date()
          //   console.log(endDT, now)
          //   if (now < endDT && pro.promotionCustomer.customerNos.indexOf(customerNo) !== -1) {
          //     var MySpecialPromotionCoupon = {}
          //     _this.gcapi('getMySpecialPromotionCoupon', pro.promotionGuid).then((res) => {
          //       if (res.body.result != null) {
          //         MySpecialPromotionCoupon = res.body.result
          //         var newcoupon = {
          //           'promotionGuid': pro.promotionGuid,
          //           'code': customerNo + MySpecialPromotionCoupon.guid,
          //           'customerNo': customerNo,
          //           'type': 5,
          //           'label': pro.name,
          //           'startDT': pro.startDT,
          //           'endDT': pro.endDT,
          //           'description': pro.description
          //         }
          //         MySpecialPromotionCoupon.quantity < pro.promotionCustomer.quantity ? newcoupon.applied = 0 : newcoupon.applied = 1
          //         if (newcoupon.applied === 0) {
          //           for (var i = 0; i < pro.promotionCustomer.quantity - MySpecialPromotionCoupon.quantity; i++) {
          //             coupons.push(newcoupon)
          //           }
          //         }
          //       } else if (res.body.code === 0) {
          //         var newcoupon1 = {
          //           'promotionGuid': pro.promotionGuid,
          //           'code': customerNo + pro.promotionGuid + customerNo,
          //           'customerNo': customerNo,
          //           'type': 0,
          //           'label': pro.name,
          //           'startDT': pro.startDT,
          //           'endDT': pro.endDT,
          //           'description': pro.description
          //         }
          //         newcoupon1.applied = 0
          //         coupons.push(newcoupon1)
          //       }
          //     })
          //   }
          // }
          _this.myCoupons = res.body.result && res.body.result.filter(function (coupon) {
            return coupon.applied === 0;
          });
          //            if (_this.myCoupons.length > 0) {
          //              var isread = true
          //              for (var i in _this.myCoupons) {
          //                if (_this.myCoupons[i].acknowledge === 0) {
          //                  isread = false
          //                }
          //              }
          //              if (!isread) {
          //                $.modal({
          //                  text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
          //                  buttons: [{
          //                    text: '查看全部优惠券',
          //                    onClick: function () {
          //                      _this.gcapi('acknowledge', customerNo)
          //                        .then((response) => {
          //                        })
          //                      _this.$router.push({name: 'myCoupons'})
          //                    }
          //                  }, {
          //                    text: '我知道了',
          //                    onClick: function () {
          //                      _this.gcapi('acknowledge', customerNo)
          //                        .then((response) => {
          //                        })
          //                    }
          //                  }]
          //                })
          //              }
          //            }
        });
      }
      _this.INIT_MESSAGE('INIT_MESSAGE');
    },
    gotoMymessage: function gotoMymessage() {
      __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].openCustomerService();
      //        var _this = this
      //        _this.gcapi('retrieveMyLeaveMessages').then((response) => {
      //          let data = response.body.result.merchantMessages
      //          if (data) {
      //            _this.messageSessions[0].merchantMessages = data
      //          }
      //        })
      //         window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    },
    getPointsDetail: function getPointsDetail() {
      this.$router.push('/PointsDetails');
    },
    getMyAccountChecked: function getMyAccountChecked() {
      this.$router.push('/user/OldAccountChecked');
    },
    fetchTotalWaitApproveOrder: function fetchTotalWaitApproveOrder() {
      var _this2 = this;

      if (!this.hasLogin) return;
      this.gcapi('getWaitingApprovedOrderCount').then(function (res) {
        if (res && res.body.result) {
          _this2.totalWaitApproveOrder = res.body.result;
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo', 'myOrder', 'showBillInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['curMessageSession', 'isSFFlag', 'researchGroupDetailList'
  // ...
  ]), {
    creditPay: function creditPay() {
      var cusInfo = this.sessionInfo.customerInfo;
      var isCreditPay = false;
      if (cusInfo) {
        var banlance = cusInfo.emktCreditBalance;
        var status = cusInfo.payTypeApplyStatusID;
        if (banlance && status === 0) {
          isCreditPay = true;
        }
      }
      return isCreditPay;
    },
    moneyRemain: function moneyRemain() {
      var cusInfo = this.sessionInfo.customerInfo;
      var isMoneyRemain = false;
      if (cusInfo) {
        var prepayMoney = cusInfo.prepayMoneyRemain;
        if (prepayMoney) {
          isMoneyRemain = true;
        }
      }
      return isMoneyRemain;
    },
    creditStatus: function creditStatus() {
      var cusInfo = this.sessionInfo.customerInfo;
      var status = 0;
      if (cusInfo) {
        var id = cusInfo.payTypeApplyStatusID;
        if (id) {
          status = id;
        }
      }
      return status;
    },
    payTypeApplyStatus: function payTypeApplyStatus() {
      var cusInfo = this.sessionInfo.customerInfo;
      var type = '';
      if (cusInfo) {
        var id = cusInfo.payTypeApplyStatusID;
        if (id === 1 || id === 3) {
          type = '信用付申请中';
        }
      }
      return type;
    },
    expireInOneDay: function expireInOneDay() {
      var coupons = this.myCoupons;
      if (coupons.length === 0) {
        return false;
      }
      return coupons.some(function (coupon) {
        var endDT = Date.parse(coupon.endDT);
        var now = Date.parse(new Date());
        return endDT - now < 24 * 3600 * 1000;
      });
    }
  }),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return val + '元';
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').cityPicker({ toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
    });
  },
  created: function created() {},
  data: function data() {
    return {
      expressInfo: {
        consignee: '',
        expressMobile: '',
        expressAddress: '',
        isDefaultString: true,
        province: '',
        city: '',
        district: ''
      },
      error: '',
      href: 'javascript:;'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE']), {
    checkInfo: function checkInfo() {
      var _this = this;
      var express = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val();
      if (express === '') {
        _this.error = '地址为空';
        return false;
      } else {
        var preexpress = [];
        preexpress = express.split(' ');
        if (preexpress[2] && preexpress[2] !== '') {
          _this.expressInfo.province = preexpress[0];
          _this.expressInfo.city = preexpress[1];
          _this.expressInfo.district = preexpress[2];
        } else {
          _this.expressInfo.city = preexpress[0];
          _this.expressInfo.district = preexpress[1];
        }
      }
      if (_this.expressInfo.consignee === '') {
        _this.error = '收货人姓名为空';
        return false;
      }
      if (_this.expressInfo.expressMobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.expressInfo.expressMobile)) {
        _this.error = '手机号码有误';
        return false;
      }
      if (_this.expressInfo.expressAddress === '') {
        _this.error = '地址为空';
        return false;
      }
      return true;
    },
    submit: function submit() {
      var _this = this;
      if (_this.checkInfo()) {
        _this.href = 'javascript:window.history.back()';
        //          _this.$router.replace('/me/userInfo/address')
        var address = _this.expressInfo.expressAddress;
        address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
        var params = {};
        params.customerNo = this.sessionInfo.customerInfo.customerNo;
        params.creator = this.sessionInfo.customerInfo.customerName;
        params.isDefault = _this.expressInfo.isDefaultString === true ? 1 : 0;
        params.consignee = _this.expressInfo.consignee.replace(/\s/g, '');
        params.expressMobile = _this.expressInfo.expressMobile;
        params.expressAddress = address;
        params.province = _this.expressInfo.province;
        params.city = _this.expressInfo.city;
        params.district = _this.expressInfo.district;
        params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
        _this.gcapi('createOrUpdateAddress', params).then(function (response) {
          if (response.body.code === 0) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('添加成功');
            _this.gotolast();
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(_this.error);
      }
    },
    gotolast: function gotolast() {
      this.$router.push({ name: 'address', query: { from: this.$route.query.from }, params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      addressInfo: [],
      from: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'count': function count() {
      return this.sessionInfo.expressAddress.length;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
      vm.from = from.query.from ? from.query.from : from.name;
    });
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE']), {
    getData: function getData() {
      var _this = this;
      _this.gcapi('gcwwwifc/getAddressInfoByCustomerNo?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(function (response) {
        var result = response.body.result.filter(function (r) {
          return r.addressStatus !== __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ADDRESS_STATUS.ADDRESS_STATUS_INVALID;
        });
        _this.addressInfo = result;
        _this.EXPRESSADDRESS_UPDATE(result);
      });
    },
    goBack: function goBack() {
      // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
      if (this.from === 'orderContentConfirm') {
        this.$router.replace({ name: 'orderContentConfirm' });
      } else if (this.from === 'orderContent') {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else {
        this.$router.push({ name: 'me' });
      }
    }
  })
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + this.expressInfo.district;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val(express);
  },
  data: function data() {
    return {
      href: 'javascript:;'
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').cityPicker({ toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
    });
    var express = this.expressInfo.province + ' ' + this.expressInfo.city;
    console.log(express);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val(express);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo']), {
    'expressInfo': {
      set: function set() {
        return this.sessionInfo.expressAddress[this.$route.query.num];
      },
      get: function get() {
        return this.sessionInfo.expressAddress[this.$route.query.num];
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE']), {
    submit: function submit() {
      var _this = this;
      var express = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val();
      var preexpress = [];
      preexpress = express.split(' ');
      if (preexpress[2] && preexpress[2] !== '') {
        _this.expressInfo.province = preexpress[0];
        _this.expressInfo.city = preexpress[1];
        _this.expressInfo.district = preexpress[2];
      } else {
        _this.expressInfo.city = preexpress[0];
        _this.expressInfo.district = preexpress[1];
      }
      _this.href = 'javascript:window.history.back()';
      var address = _this.expressInfo.expressAddress;
      address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
      var isDefault = _this.expressInfo.isDefault;
      if (isDefault === false) {
        isDefault = 0;
      } else if (isDefault === true) {
        isDefault = 1;
      }
      var params = {};
      params.customerNo = this.sessionInfo.customerInfo.customerNo;
      params.creator = this.sessionInfo.customerInfo.customerName;
      params.operator = this.sessionInfo.customerInfo.customerName;
      params.expressAddressGuid = _this.expressInfo.expressAddressGuid;
      params.isDefault = isDefault;
      params.consignee = _this.expressInfo.consignee.replace(/\s/g, '');
      params.expressMobile = _this.expressInfo.expressMobile;
      params.expressAddress = address;
      params.province = _this.expressInfo.province;
      params.city = _this.expressInfo.city;
      params.district = _this.expressInfo.district;
      params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
      _this.gcapi('createOrUpdateAddress', params).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('修改成功');
          _this.gotolast();
        }
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
        }
      });
    },
    delAddress: function delAddress() {
      var _this = this;
      _this.href = 'javascript:window.history.back()';
      _this.gcapi('gcwwwifc/updateAddressStatus', {
        'expressAddressGuid': _this.expressInfo.expressAddressGuid
      }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('删除成功');
          _this.gotolast();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('请求错误');
      });
    },
    gotolast: function gotolast() {
      this.$router.push({ name: 'address', query: { from: this.$route.query.from }, params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalRegisterAgreement_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalRegisterAgreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModalRegisterAgreement_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      showModal: true
    };
  },

  computed: {},
  watch: {},
  methods: {},
  components: {
    modalRegisterAgreement: __WEBPACK_IMPORTED_MODULE_0__components_ModalRegisterAgreement_vue___default.a
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_fc_multiplex_Bar__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_fc_multiplex_Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_fc_multiplex_Bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_Order_CouponSelection__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_Order_CouponSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_v_2_6_Order_CouponSelection__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import wx from 'wx'
// import EMKT from '../../../emkt'
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CouponSelection: __WEBPACK_IMPORTED_MODULE_3__views_v_2_6_Order_CouponSelection___default.a, Bar: __WEBPACK_IMPORTED_MODULE_2__views_fc_multiplex_Bar___default.a },
  props: {
    // 该变量区分是否是订单页面，订单页面需要使用优惠券，因此为true，
    // 默认为false，只作为展示，没有使用功能
  },
  created: function created() {
    this.fetchData();
    this.overdue();
  },
  data: function data() {
    return {
      myCoupons: [],
      overdueCoupons: [],
      serviceCoupons: [],
      toolsCoupons: [],
      fromOrderPage: this.$route.query.fromOrderPage,
      titleBar: [{
        label: '科研工具',
        value: '',
        length: 0
      }, {
        label: '科研服务',
        value: '3',
        length: 0
      }, {
        label: '已过期',
        value: '-',
        length: 0
      }],
      chooseLength: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'count': function count() {
      return this.sessionInfo.expressAddress.length;
    }
  }),
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$weui.loading('正在获取优惠券');
      var customerNo = this.sessionInfo.customerInfo.customerNo;
      var coupons = [];
      this.gcapi('getMyCoupons', customerNo).then(function (res) {
        _this.$weui.loading().hide();
        res.body.result.forEach(function (item) {
          item.open = true;
          item.desc = item.description.split('|');
          item.available = true;
          if (item.applied === 0) {
            coupons.push(item);
          }
        });
        coupons.sort(function (a, b) {
          return b.enableFlag - a.enableFlag;
        });
        coupons.forEach(function (item) {
          if (item.promotionUseType === 3) {
            _this.serviceCoupons.push(item);
          } else {
            _this.toolsCoupons.push(item);
          }
        });
        _this.titleBar[0].length = _this.toolsCoupons.length;
        _this.titleBar[1].length = _this.serviceCoupons.length;
      });
      if (this.$route.params.isService === true || this.$route.params.isService === false) {
        this.myCoupons = coupons;
      } else {
        this.myCoupons = this.toolsCoupons;
      }
      console.log(this.myCoupons, 'muc');
    },
    overdue: function overdue() {
      var _this2 = this;

      var customerNo = this.sessionInfo.customerInfo.customerNo;
      this.gcapi('getMyOverdueCoupons', customerNo).then(function (res) {
        res.body.result.forEach(function (item) {
          item.open = true;
          item.desc = item.description.split('|');
          item.available = false;
          console.log(item);
        });
        _this2.overdueCoupons = res.body.result;
        _this2.titleBar[2].length = _this2.overdueCoupons.length;
      });
    },
    changeType: function changeType(type) {
      if (type === '-') {
        this.myCoupons = this.overdueCoupons;
      } else {
        this.classify(type);
      }
    },
    classify: function classify(type) {
      console.log(type === '3');
      if (type === '3') {
        console.log(this.serviceCoupons);
        this.myCoupons = this.serviceCoupons;
      } else {
        console.log(this.toolsCoupons);
        this.myCoupons = this.toolsCoupons;
      }
    },

    // confirmCoupon () {
    //   this.$refs.coupons.confirmCoupon()
    // },
    // changeNumber () {
    //   this.chooseLength = this.$refs.coupons.chosenCoupons.length
    // },
    FormatterTime: function FormatterTime(date) {
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds;
      return newTime;
    }
  },
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {},
  data: function data() {
    return {
      avatarPositive: '',
      avatarNegative: '',
      disable: false,
      href: 'javascript:;'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['CLIENT_INFO']), {
    changeImagePositive: function changeImagePositive(e) {
      var file = e.target.files[0];
      var isAllowedUpdate = this.checkImage(file);
      if (!isAllowedUpdate) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('上传图片过大');
        return;
      }
      var reader = new FileReader();
      var _this = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        _this.avatarPositive = this.result;
      };
    },
    changeImageNegative: function changeImageNegative(e) {
      var file = e.target.files[0];
      var isAllowedUpdate = this.checkImage(file);
      if (!isAllowedUpdate) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('上传图片过大');
        return;
      }
      var reader = new FileReader();
      var _this = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        _this.avatarNegative = this.result;
      };
    },
    checkImage: function checkImage(file) {
      var maxSize = 5000; // 5mb
      var size = file.size;
      var isAllow = false;
      maxSize = maxSize * 1024; // 转化为字节数
      isAllow = size <= maxSize;
      return isAllow;
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      if (this.disable === true) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请勿重复提交');
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.showPreloader('上传中');
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.hidePreloader();
        }, 5000);
      }
      var posiImage = this.$refs.avatarInputPosi.files;
      var negaImage = this.$refs.avatarInputNega.files;
      if (posiImage.length !== 0 || negaImage.length !== 0) {
        this.disable = true;
        var image = new FormData();
        image.append('positive', posiImage[0]);
        image.append('negative', negaImage[0]);
        var config = {
          'Content-Type': 'multipart/form-data'
        };
        var _this = this;
        this.$http.post('/gcapi/gcwwwifc/applyCreditPay', image, config).then(function (res) {
          if (res.body.code === 0) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('上传成功');
            _this.href = 'javascript:window.history.back()';
            _this.gcapi('gcwwwifc/getCustomerInfo').then(function (response) {
              _this.CLIENT_INFO(response.body.result);
            });
          } else {
            _this2.disable = false;
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(res.message);
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请上传清晰的名片正面或身份证正面及反面');
      }
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }),
  filters: {
    currencyStyle: function currencyStyle(val) {
      return ' ¥ ' + val;
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on('close', function () {
      if (_this.enterpriseInfo.enterpriseName !== undefined && _this.enterpriseInfo.enterpriseName !== null) {
        _this.sessionInfo.customerInfo.enterpriseName = _this.enterpriseInfo.enterpriseName;
      }
    });
  },
  data: function data() {
    return {
      isWapp: __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isWapp
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo', 'enterpriseInfo'])),
  // watch: {
  //   'enterpriseInfo': function (val) {
  //     this.gcapi('gcwwwifc/updateCustomerEnterprise', {'EnterpriseNo': val.enterpriseNo}).then((response) => {
  //       if (response.body.code === 0) {
  //         alert('单位修改成功！')
  //       } else {
  //         alert('单位修改失败，请您联系客服')
  //       }
  //     })
  //   }
  // },
  methods: {}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').cityPicker({ toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
    });
  },
  created: function created() {},
  data: function data() {
    return {
      expressInfo: {
        consignee: '',
        expressMobile: '',
        expressAddress: '',
        isDefaultString: true,
        province: '',
        city: '',
        district: ''
      },
      error: '',
      href: 'javascript:;'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['INVOICE_ADDRESS']), {
    checkInfo: function checkInfo() {
      var _this = this;
      var express = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val();
      if (express === '') {
        _this.error = '地址为空';
        return false;
      } else {
        var preexpress = [];
        alert(express);
        preexpress = express.split(' ');
        if (preexpress[2] && preexpress[2] !== '') {
          _this.expressInfo.province = preexpress[0];
          _this.expressInfo.city = preexpress[1];
          _this.expressInfo.district = preexpress[2];
        } else {
          _this.expressInfo.city = preexpress[0];
          _this.expressInfo.district = preexpress[1];
        }
      }
      if (_this.expressInfo.consignee === '') {
        _this.error = '收货人姓名为空';
        return false;
      }
      if (_this.expressInfo.expressMobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.expressInfo.expressMobile)) {
        _this.error = '手机号码有误';
        return false;
      }
      if (_this.expressInfo.expressAddress === '') {
        _this.error = '地址为空';
        return false;
      }
      return true;
    },
    submit: function submit() {
      var _this = this;
      if (_this.checkInfo()) {
        _this.href = 'javascript:window.history.back()';
        var address = _this.expressInfo.expressAddress;
        address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
        var params = {};
        params.customerNo = this.sessionInfo.customerInfo.customerNo;
        params.creator = this.sessionInfo.customerInfo.customerName;
        params.isDefault = _this.expressInfo.isDefaultString === true ? 1 : 0;
        params.consignee = _this.expressInfo.consignee.replace(/\s/g, '');
        params.expressMobile = _this.expressInfo.expressMobile;
        params.expressAddress = address;
        params.province = _this.expressInfo.province;
        params.city = _this.expressInfo.city;
        params.district = _this.expressInfo.district;
        params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
        _this.gcapi('createOrUpdateAddress', params).then(function (response) {
          if (response.body.code === 0) {
            //              _this.gcapi('gcwwwifc/getUserProfile?ProfileType=4').then((response) => {
            //                _this.INVOICE_ADDRESS(response.body.result)
            //              })
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('添加成功');
            _this.goBack();
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(_this.error);
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'myInvoiceAddress', query: { from: this.$route.query.from }, params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('close', function () {
      _this.addEnterprise = _this.enterpriseInfo.enterpriseName;
    });
  },
  data: function data() {
    return {
      addEnterprise: '',
      isDefaultString: true,
      href: 'javascript:;'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo', 'enterpriseInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['INVOICE_TITLE']), {
    checkInfo: function checkInfo() {
      var _this = this;
      if (_this.addEnterprise === '') {
        _this.error = '请填写单位名称';
        return false;
      }
      //        if (_this.isDefaultString === '') {
      //          _this.error = '请选择是否设置为默认'
      //          return false
      //        }
      return true;
    },
    submit: function submit() {
      var _this = this;
      if (_this.checkInfo()) {
        _this.href = 'javascript:window.history.back()';
        _this.gcapi('gcwwwifc/createOrUpdateInvoiceTitle', {
          'IsDefault': _this.isDefaultString === true ? 1 : 0,
          'EnterpriseNo': _this.enterpriseInfo.enterpriseNo
        }).then(function (response) {
          if (response.body.code === 0) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('添加成功');
            _this.goBack();
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(_this.error);
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'invoiceTitle', query: { from: this.$route.query.from }, params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      invoiceInfo: [],
      from: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'count': function count() {
      return this.sessionInfo.invoiceAddress.length;
    }
  }),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
      vm.from = from.query.from ? from.query.from : from.name;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['INVOICE_ADDRESS']), {
    getData: function getData() {
      var _this = this;
      _this.gcapi('gcwwwifc/getAddressInfoByCustomerNo?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(function (response) {
        var result = response.body.result.filter(function (r) {
          return r.addressStatus !== __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ADDRESS_STATUS.ADDRESS_STATUS_INVALID;
        });
        _this.invoiceInfo = result;
        _this.INVOICE_ADDRESS(result);
      });
    },
    goBack: function goBack() {
      // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
      if (this.from === 'orderContentConfirm') {
        this.$router.replace({ name: 'orderContentConfirm' });
      } else if (this.from === 'orderContent') {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else {
        this.$router.push({ name: 'me' });
      }
    }
  })
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  data: function data() {
    return {
      href: 'javascript:;'
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').cityPicker({ toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
    });
    var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + this.expressInfo.district;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val(express);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo']), {
    'expressInfo': {
      set: function set() {
        return this.sessionInfo.invoiceAddress[this.$route.query.num];
      },
      get: function get() {
        return this.sessionInfo.invoiceAddress[this.$route.query.num];
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['INVOICE_ADDRESS']), {
    submit: function submit() {
      var _this = this;
      var express = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#city-picker').val();
      var preexpress = [];
      preexpress = express.split(' ');
      if (preexpress[2] && preexpress[2] !== '') {
        _this.expressInfo.province = preexpress[0];
        _this.expressInfo.city = preexpress[1];
        _this.expressInfo.district = preexpress[2];
      } else {
        _this.expressInfo.city = preexpress[0];
        _this.expressInfo.district = preexpress[1];
      }
      _this.href = 'javascript:window.history.back()';
      var address = _this.expressInfo.expressAddress;
      address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
      var isDefault = _this.expressInfo.isDefault;
      if (isDefault === false) {
        isDefault = 0;
      } else if (isDefault === true) {
        isDefault = 1;
      }
      var params = {};
      params.customerNo = this.sessionInfo.customerInfo.customerNo;
      params.creator = this.sessionInfo.customerInfo.customerName;
      params.operator = this.sessionInfo.customerInfo.customerName;
      params.isDefault = isDefault;
      params.expressAddressGuid = _this.expressInfo.expressAddressGuid;
      params.consignee = _this.expressInfo.consignee.replace(/\s/g, '');
      params.expressMobile = _this.expressInfo.expressMobile;
      params.expressAddress = address;
      params.province = _this.expressInfo.province;
      params.city = _this.expressInfo.city;
      params.district = _this.expressInfo.district;
      params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
      _this.gcapi('createOrUpdateAddress', params).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('修改成功');
          _this.goBack();
        }
        if (response.body.code === 1) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
        }
      });
    },
    delAddress: function delAddress() {
      var _this = this;
      _this.href = 'javascript:window.history.back()';
      _this.gcapi('gcwwwifc/updateAddressStatus', {
        'expressAddressGuid': _this.expressInfo.expressAddressGuid
      }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('删除成功');
          _this.goBack();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('出错');
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('请求错误');
      });
    },
    goBack: function goBack() {
      this.$router.push({ name: 'myInvoiceAddress', query: { from: this.$route.query.from }, params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      invoiceInfo: [],
      from: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
      vm.from = from.query.from ? from.query.from : from.name;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'count': function count() {
      return this.sessionInfo.invoiceTitle.length;
    }
  }),
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['INVOICE_TITLE']), {
    submit: function submit(inv, e) {
      console.log(inv.isDefault);
      var _this = this;
      var isDefault = e.target.checked;
      _this.gcapi('gcwwwifc/createOrUpdateInvoiceTitle', {
        'IsDefault': isDefault === false ? 0 : 1,
        'EnterpriseNo': inv.enterpriseNo
      }).then(function (response) {
        if (response.body.code === 0) {
          _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then(function (res) {
            _this.INVOICE_TITLE(res.body.result);
            _this.invoiceInfo = res.body.result;
          });
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('修改成功');
        } else if (response.body.code === 1) {}
      });
    },
    delInvoice: function delInvoice(inv) {
      var _this = this;
      _this.gcapi('gcwwwifc/deleteInvoiceTitle', {
        'EnterpriseNo': inv.enterpriseNo
      }).then(function (response) {
        if (response.body.code === 0) {
          _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then(function (res) {
            _this.INVOICE_TITLE(res.body.result);
            _this.invoiceInfo = res.body.result;
          });
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('删除成功');
        } else {}
      });
    },
    getData: function getData() {
      var _this = this;
      _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then(function (response) {
        _this.INVOICE_TITLE(response.body.result);
        _this.invoiceInfo = response.body.result;
      });
    },
    goBack: function goBack() {
      // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
      if (this.from === 'orderContentConfirm') {
        this.$router.replace({ name: 'orderContentConfirm' });
      } else if (this.from === 'orderContent') {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else {
        this.$router.push({ name: 'me' });
      }
    }
  })
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      account: '',
      type: 'phone',
      veriCode: '',
      coolDown: false
    };
  },

  watch: {
    'account': function account(val) {
      var _this = this;
      if (val.indexOf('@') !== -1) {
        _this.type = 'email';
      } else {
        _this.type = 'phone';
      }
    }
  },
  methods: {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (!_this.coolDown) {
        _this.gcapi('gcwwwifc/requestActivation', { 'LoginId': _this.account }).then(function (response) {
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    sendEmail: function sendEmail() {
      var _this = this;
      _this.gcapi('gcwwwifc/requestActivation', { 'LoginId': _this.account }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
          _this.$router.push('/me/login');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
      });
    },
    submit: function submit() {
      var _this = this;
      _this.gcapi('gcwwwifc/activateCustomer', { 'LoginId': _this.account, 'VerifyCode': _this.veriCode }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
          _this.$router.push('/login');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
      });
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_md5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      account: '',
      password: '',
      veriCode: '',
      coolDown: false,
      newLoginId: '',
      newLoginIdRe: '',
      error: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['LOGIN_STATE_UPDATE']), {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (!_this.coolDown) {
        _this.gcapi('gcwwwifc/requestChangeLoginID', {
          'ExLoginId': _this.account,
          'NewLoginId': _this.newLoginId,
          'Password': __WEBPACK_IMPORTED_MODULE_2_js_md5___default()(_this.password).toUpperCase()
        }).then(function (response) {
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    checkNewLoginId: function checkNewLoginId() {
      var _this = this;
      if (_this.veriCode === '') {
        _this.error = '请输入验证码';
        return false;
      }
      if (!_this.newLoginId === _this.newLoginId) {
        _this.error = '两次输入不相同';
        return false;
      }
      if (_this.newLoginId === _this.account) {
        _this.error = '新ID与原ID相同';
        return false;
      }
      return true;
    },
    submit: function submit() {
      var _this = this;
      if (_this.checkNewLoginId()) {
        _this.gcapi('gcwwwifc/changeLoginID', {
          'LoginId': _this.newLoginId,
          'VerifyCode': _this.veriCode
        }).then(function (response) {
          if (response.body.code === 0) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
            _this.gcapi('gcwwwifc/userLogout');
            _this.LOGIN_STATE_UPDATE(false);
            _this.$router.push('/login');
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(_this.error);
      }
    }
  })
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      account: '',
      type: 'phone',
      veriCode: '',
      coolDown: false,
      newPassword: '',
      confirmPassword: ''
    };
  },

  watch: {
    'account': function account(val) {
      var _this = this;
      if (val.indexOf('@') !== -1) {
        _this.type = 'email';
      } else {
        _this.type = 'phone';
      }
    }
  },
  methods: {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (!_this.coolDown) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.showPreloader('请稍候');
        _this.gcapi('gcwwwifc/requestResetPassword', { 'LoginId': _this.account }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.hidePreloader();
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    sendEmail: function sendEmail() {
      var _this = this;
      _this.gcapi('gcwwwifc/requestResetPassword', { 'LoginId': _this.account }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
          _this.$router.push('/me/login');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body.message);
      });
    },
    submit: function submit() {
      var _this = this;
      if (_this.newPassword !== _this.confirmPassword) {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast('两次输入的密码不一致');
      }
      _this.gcapi('gcwwwifc/submitResetPassword', { 'LoginId': _this.account, 'NewPassword': __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(_this.newPassword).toUpperCase(), 'VerifyCode': _this.veriCode }).then(function (response) {
        if (response.body.code === 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
          _this.$router.push('/login');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
      });
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id).focus();
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wx__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// client authentication here
// import md5 from 'js-md5'




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.hasLogin();
    this.isSales();
  },

  watch: {
    'customerNo': function customerNo(val) {
      var reg = /^\d{8}$/;
      if (!reg.test(val)) {
        this.error = 'red';
        this.errorFlag = true;
      } else {
        this.error = 'black';
        this.errorFlag = false;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 若从活动页面跳转到登录页面，登录成功后返回活动页面
    console.log('to from ', to, from);
    next(function (vm) {
      if (from.fullPath && (from.fullPath.includes('ResearchGroup') || from.fullPath.includes('activity'))) {
        vm.fromFullPath = from.fullPath;
      }
    });
  },
  data: function data() {
    return {
      account: '',
      password: '',
      customerNo: '',
      isSalesFlag: false,
      error: '',
      errorFlag: false,
      showPassword: false,
      fromFullPath: '/me',
      isWapp: __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].isWapp
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'EXPRESSADDRESS_UPDATE', 'INVOICE_TITLE', 'MYORDER_UPDATE', 'INVOICE_ADDRESS', 'INIT_MESSAGE']), {
    isSales: function isSales() {
      var sales = this.getUrlParam('sales');
      if (sales === '1') {
        this.isSalesFlag = true;
      }
    },
    getUrlParam: function getUrlParam(val) {
      var uri = window.location.href;
      var re = new RegExp('' + val + '=([^&?]*)', 'ig');
      return uri.match(re) ? uri.match(re)[0].substr(val.length + 1).substring(0, 1) : null;
    },
    hasLogin: function hasLogin() {
      var _this = this;
      var guest = _this.sessionInfo;
      var customerInfo = _this.sessionInfo.customerInfo;
      if (!(guest.customerNo === 'GUEST' || customerInfo === '')) {
        _this.goHome();
      }
    },
    goHome: function goHome() {
      // todo return to home
      if (this.isWapp) {
        __WEBPACK_IMPORTED_MODULE_4_wx___default.a.miniProgram.switchTab({
          url: '/pages/my/my'
        });
      } else {
        this.$router.replace({ name: 'me' });
      }
    },
    getResearchGroupInfo: function getResearchGroupInfo(customerNo) {
      var _this2 = this;

      // customerNo = EMKT.testCustomerNo
      // 获取所有的课题组信息
      this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(function (res) {
        if (res.body.result) {
          var researchGroupMemberMap = res.body.result.bResearchGroupMemberMap;
          var researchGroupSet = res.body.result.bResearchGroupList;
          _this2.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap);
          _this2.UPDATE_RESEARCHGROUP_SET(researchGroupSet);
          console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet);
        }
      });
      // 过滤掉无效的任职关系
      this.gcapi('getWorkExperienceList', customerNo).then(function (res) {
        if (res && res.body.result) {
          var workList = res.body.result.filter(function (work) {
            return work.enable === true;
          });
          __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', workList);
        } else {
          __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', []);
        }
        console.log('EmktWorkExperienceList', __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getLocalStorage('EmktWorkExperienceList'));
      });
    },
    login: function login() {
      //       var _this = this
      //       if (_this.account && _this.password) {
      //         let param
      //         if (_this.isSalesFlag) {
      //           let cNo = _this.customerNo
      //           if (!cNo) {
      //             return
      //           }
      //           if (_this.errorFlag) {
      //             return
      //           }
      //           param = {
      //             'LoginId': _this.account,
      //             'Password': md5(_this.password).toUpperCase(),
      //             'CustomerNo': cNo
      //           }
      //         } else {
      //           param = {
      //             'LoginId': _this.account,
      //             'Password': md5(_this.password).toUpperCase()
      //           }
      //         }
      //         _this.gcapi('gcwwwifc/login', param).then((response) => {
      //           if (response.body['code'] === 0) {
      //             $.toast('登录成功')
      //             _this.LOGIN_STATE_UPDATE(true)
      //             _this.gcapi('gcwwwifc/getCustomerInfo').then(res => {
      //               _this.CLIENT_INFO(res.body.result)
      //               let customerNo = res.body.result.customerInfo.customerNo
      //               let shareUrl = EMKT.wxShareUrl + '?introducer=' + customerNo
      //               $.sign.shareUrl = shareUrl
      //               _this.getResearchGroupInfo(customerNo)
      //               var ShowPromotions = EMKT.getLocalStorage('EmktShowPromotions')
      //               if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
      //                 var showPromotionParam = {}
      //                 showPromotionParam.bPromotions = ShowPromotions
      //                 showPromotionParam.customerNo = customerNo
      //                 _this.gcapi('ShowPromotions', showPromotionParam).then((res) => {
      //                   if (res.body.result === true) {
      //                     var isshowPromotion = {}
      //                     isshowPromotion.showPromotionParam = showPromotionParam
      //                     isshowPromotion.show = true
      //                     EMKT.setLocalStorage('isshowPromotion', isshowPromotion)
      //                   }
      //                 })
      //               }
      //               _this.gcapi('retrieveMyOrder').then((response) => {
      //                 _this.MYORDER_UPDATE(response.body.result)
      //                 // _this.$router.push('/me')
      //               })
      //               // EMKT.setLocalStorage('VipPlanList', null)
      //               // if (_this.sessionInfo.customerInfo) {
      //               //   var CustomerPlanParams = {
      //               //     'CustomerNo': _this.sessionInfo.customerInfo.customerNo
      //               //   }
      //               //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
      //               //     var VipPlanList = response.body.result
      //               //     EMKT.setLocalStorage('VipPlanList', VipPlanList)
      //               //   })
      //               // }
      //               _this.gcapi('getRecommendation', customerNo).then((res) => {
      //                 // EMKT.setStoreItem('EmktPlain', merchList)
      //                 if (res.body.result.length > 0) {
      //                   var i = 0
      //                   var list = []
      //                   var newlist = res.body.result
      //                   console.log(res.body.result)
      //                   if (newlist.length > 15) {
      //                     for (i = 0; i < 15; i++) {
      //                       list.push(newlist[i])
      //                     }
      //                     EMKT.setStoreItem('EmktRecommendations', list)
      //                   } else {
      //                     EMKT.setStoreItem('EmktRecommendations', newlist)
      //                   }
      //                 }
      //               })
      //               EMKT.wxShare()
      //               _this.$router.push(_this.fromFullPath)
      //             })
      // //            this.gcapi('searchContractNo').then(function (response) {
      // //              EMKT.setLocalStorage('contractNO', null)
      // //              console.log(response.body.result)
      // //              EMKT.setLocalStorage('contractNO', response.body.result)
      // //            })
      //           } else {
      //             $.toast(response.body['message'])
      //           }
      //         }, (response) => {
      //           $.toast(response.body)
      //         })
      //       } else {
      //         $.toast('请输入登录信息')
      //       }
    },
    focus: function focus(id) {
      document.getElementById(id).focus();
    },
    deletePassword: function deletePassword() {
      this.password = '';
    },
    toggleShowPassword: function toggleShowPassword() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password').attr('type', 'text');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#password').attr('type', 'password');
      }
    }
  })
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import md5 from 'js-md5'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      mobile: '',
      veriCode: '',
      coolDown: false,
      error: ''
    };
  },

  methods: {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (!_this.coolDown) {
        _this.gcapi().then(function (response) {
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    submit: function submit() {}
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      mobile: '',
      veriCode: '',
      coolDown: false,
      oldPassword: '',
      newPassword: '',
      newPasswordRe: '',
      error: ''
    };
  },

  methods: {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (!_this.coolDown) {
        _this.gcapi('gcwwwifc/requestPasswordChange', { 'LoginId': _this.mobile.replace(/\s+/g, '') }).then(function (response) {
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    checkNewPassword: function checkNewPassword() {
      var _this = this;
      if (_this.veriCode === '') {
        _this.error = '请输入验证码';
        return false;
      }
      if (!_this.newPassword === _this.newPasswordRe) {
        _this.error = '两次输入不相同';
        return false;
      }
      return true;
    },
    submit: function submit() {
      var _this = this;
      if (_this.checkNewPassword()) {
        _this.gcapi('gcwwwifc/submitPasswordChange', {
          'LoginId': _this.mobile.replace(/\s+/g, ''),
          'ExPassword': __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(_this.oldPassword).toUpperCase(),
          'NewPassword': __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(_this.newPassword).toUpperCase(),
          'VerifyCode': _this.veriCode
        }).then(function (response) {
          if (response.body.code === 1) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
          } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
            _this.$store.state.hasLogin = false;
            _this.$router.push('/login');
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(response.body['message']);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toast(_this.error);
      }
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import md5 from 'js-md5'
/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {},
  data: function data() {
    return {
      account: '',
      type: 'phone',
      veriCode: '',
      coolDown: false,
      fromFullPath: this.$route.query.fromFullPath || '/me'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo'])),
  watch: {
    'account': function account(val) {
      var _this = this;
      if (val.indexOf('@') !== -1) {
        _this.type = 'email';
      } else {
        _this.type = 'phone';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'EXPRESSADDRESS_UPDATE', 'INVOICE_TITLE', 'MYORDER_UPDATE', 'INVOICE_ADDRESS', 'INIT_MESSAGE']), {
    getResearchGroupInfo: function getResearchGroupInfo(customerNo) {
      var _this2 = this;

      // customerNo = EMKT.testCustomerNo
      // 获取所有的课题组信息
      this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(function (res) {
        if (res.body.result) {
          var researchGroupMemberMap = res.body.result.bResearchGroupMemberMap;
          var researchGroupSet = res.body.result.bResearchGroupList;
          _this2.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap);
          _this2.UPDATE_RESEARCHGROUP_SET(researchGroupSet);
          console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet);
        }
      });
      // 过滤掉无效的任职关系
      this.gcapi('getWorkExperienceList', customerNo).then(function (res) {
        if (res && res.body.result) {
          var workList = res.body.result.filter(function (work) {
            return work.enable === true;
          });
          __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', workList);
        } else {
          __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', []);
        }
        console.log('EmktWorkExperienceList', __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getLocalStorage('EmktWorkExperienceList'));
      });
    },
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      if (_this.account === '' || _this.account === undefined || _this.account === '' || _this.account === null) {
        alert('请填写手机号');
        return;
      }
      if (!/^1[3-9]{1}[0-9]{9}$/.test(_this.account.replace(/\s+/g, ''))) {
        alert('请填写正确手机号格式');
        return;
      }
      if (!_this.coolDown) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showPreloader('请稍候');
        _this.gcapi('gcwwwifc/requestLoginSmsCode?LoginId=' + _this.account, null).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hidePreloader();
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    login: function login() {
      var _this3 = this;

      var _this = this;
      if (!_this.account || !_this.veriCode) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('请填写完整登陆信息');
        return;
      }
      _this.gcapi('gcwwwifc/loginBySmsCode?LoginId=' + _this.account + '&Password=' + _this.veriCode + '&Code=').then(function (res) {
        console.log(res);
        var data = res;
        if (data) {
          if (data.body.result.customerName === 'GUEST') {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('啊哦～登陆失败了，稍后再试试吧');
          } else {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('登录成功');
            _this.LOGIN_STATE_UPDATE(true);
            _this.gcapi('gcwwwifc/getCustomerInfo').then(function (res) {
              _this.CLIENT_INFO(res.body.result);
              var customerNo = res.body.result.customerInfo.customerNo;
              var shareUrl = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].wxShareUrl + '?introducer=' + customerNo;
              __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.sign.shareUrl = shareUrl;
              _this.getResearchGroupInfo(customerNo);
              var ShowPromotions = __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].getLocalStorage('EmktShowPromotions');
              if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
                var showPromotionParam = {};
                showPromotionParam.bPromotions = ShowPromotions;
                showPromotionParam.customerNo = customerNo;
                _this.gcapi('ShowPromotions', showPromotionParam).then(function (res) {
                  if (res.body.result === true) {
                    var isshowPromotion = {};
                    isshowPromotion.showPromotionParam = showPromotionParam;
                    isshowPromotion.show = true;
                    __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setLocalStorage('isshowPromotion', isshowPromotion);
                  }
                });
              }
              // EMKT.setLocalStorage('VipPlanList', null)
              // if (_this.sessionInfo.customerInfo) {
              //   var CustomerPlanParams = {
              //     'CustomerNo': _this.sessionInfo.customerInfo.customerNo
              //   }
              //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
              //     var VipPlanList = response.body.result
              //     EMKT.setLocalStorage('VipPlanList', VipPlanList)
              //   })
              // }
              _this.gcapi('retrieveMyOrder').then(function (response) {
                _this.MYORDER_UPDATE(response.body.result);
                //                _this.$router.push('/me')
              });
              _this.gcapi('getRecommendation', customerNo).then(function (res) {
                //               EMKT.setStoreItem('EmktPlain', merchList)
                if (res.body.result.length > 0) {
                  var i = 0;
                  var list = [];
                  var newlist = res.body.result;
                  console.log(res.body.result);
                  if (newlist.length > 15) {
                    for (i = 0; i < 15; i++) {
                      list.push(newlist[i]);
                    }
                    __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktRecommendations', list);
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].setStoreItem('EmktRecommendations', newlist);
                  }
                }
              });
              __WEBPACK_IMPORTED_MODULE_2__emkt_js__["a" /* default */].wxShare();
              _this.$router.push(_this3.fromFullPath);
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('啊哦～登陆失败了，稍后再试试吧');
        }
      });
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).focus();
    }
  })
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  data: function data() {
    return {
      pointsList: [],
      totalPoints: 0,
      totalRemainPoints: 0
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var param = {
        'customerNo': this.sessionInfo.customerInfo.customerNo
      };
      this.gcapi('gcwwwifc/pointsDetails', param).then(function (response) {
        _this.pointsList = response.body.result;
        var points = 0;
        var points1 = 0;
        _this.pointsList.forEach(function (item) {
          if (new Date() < new Date(Date.parse(item.validUntil))) {
            console.log(item.remainedPoint);
            points = points + item.remainedPoint;
            points1 = points1 + item.accruedPoint;
          }
        });
        _this.totalPoints = points1;
        _this.totalRemainPoints = points;
      });
    },
    tolast: function tolast() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ModalRegisterAgreement_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ModalRegisterAgreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ModalRegisterAgreement_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on('close', function () {
      _this.addEnterprise = _this.enterpriseInfo.enterpriseName;
    });
  },
  created: function created() {},
  data: function data() {
    return {
      customerName: '',
      Mobile: '',
      Email: '',
      Password: '',
      rePassword: '',
      Address: '',
      addEnterprise: '',
      isReceivePromotion: true,
      error: '出错了',
      showModal: true,
      veriCode: '',
      coolDown: false,
      disableSubmit: false,
      sendVeriCodeSuccess: false,
      secondLevelEnterpriseList: [],
      showSecondLevelEnterprise: false,
      secondLevelEnterpriseNo: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['enterpriseInfo'])),
  watch: {
    'rePassword': function rePassword(val) {
      var _this = this;
      if (val !== _this.Password) {
        document.getElementById('password').className = 'error item-input';
      } else {
        document.getElementById('password').className = 'item-input';
      }
    },
    'veriCode': function veriCode(val) {
      var reg = new RegExp(/^\d{6}$/);
      if (this.sendVeriCodeSuccess && reg.test(val)) {
        this.disableSubmit = true;
      } else {
        this.disableSubmit = false;
      }
    },
    'enterpriseInfo': function enterpriseInfo(val) {
      var _this = this;
      _this.gcapi('getSecondEnterpriseInfoByFirstEnterpriseNo', _this.enterpriseInfo.enterpriseNo).then(function (response) {
        _this.secondLevelEnterpriseList = response.body.result;
        _this.showSecondLevelEnterprise = true;
        if (_this.addEnterprise.endsWith('医院')) {
          if (_this.secondLevelEnterpriseList.length < 1) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('该单位二级单位不可为空，请您联系客服处理！');
            return;
          }
        } else {
          _this.showSecondLevelEnterprise = false;
        }
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'MYORDER_UPDATE']), {
    sendVeriCode: function sendVeriCode() {
      var _this = this;
      var mobile = _this.Mobile.replace(/\s+/g, '');
      if (!_this.coolDown) {
        _this.gcapi('gcwwwifc/requestActivation', { 'LoginId': mobile }).then(function (response) {
          _this.coolDown = true;
          time(document.getElementById('btn'));
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
          _this.sendVeriCodeSuccess = true;
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
        });
      }
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          _this.coolDown = false;
          o.innerHTML = '发送';
          o.style.color = '';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
    },
    checkInfo: function checkInfo() {
      var _this = this;
      if (!_this.customerName) {
        _this.error = '请填写姓名';
        return false;
      }
      var mobile = _this.Mobile.replace(/\s+/g, '');
      if (!mobile) {
        _this.error = '请填写手机号';
        return false;
      }
      if (!/^1[3-9]{1}[0-9]{9}$/.test(mobile)) {
        _this.error = '手机号有误';
        return false;
      }
      var email = _this.Email;
      if (!email) {
        _this.error = '请填写邮箱';
        return false;
      }
      if (email) {
        if (!/^\w+([._-]\w+)*@(\w+\.)+\w+$/.test(email)) {
          _this.error = '邮箱有误';
          return false;
        }
      }
      var pass = _this.Password;
      var rePass = _this.rePassword;
      if (!pass || !rePass) {
        _this.error = '请填写密码并确认密码';
        return false;
      }
      if (rePass !== pass) {
        _this.error = '两次密码不同';
        return false;
      }
      if (!_this.addEnterprise) {
        _this.error = '请填写单位';
        return false;
      }
      if (_this.secondLevelEnterpriseNo === null && _this.showSecondLevelEnterprise) {
        _this.error = '请选择二级单位';
        return false;
      }
      return true;
    },
    register: function register() {
      var _this = this;
      if (_this.checkInfo()) {
        var address = _this.Address;
        address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
        _this.gcapi('gcwwwifc/addCustomer', {
          'CustomerName': _this.customerName.replace(/\s/g, ''),
          'Mobile': _this.Mobile.replace(/\s+/g, ''),
          'Password': __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(_this.Password).toUpperCase(),
          'EnterpriseNo': _this.enterpriseInfo.enterpriseNo,
          'SecondEnterpriseNo': _this.secondLevelEnterpriseNo,
          'Email': _this.Email,
          'Address': address,
          'AddEnterprise': _this.enterpriseInfo.enterpriseName,
          'ReceivePromotion': _this.isReceivePromotion === true ? 1 : 0
        }).then(function (response) {
          if (response.body.code === 0) {
            // register successful， then send validate code
            //              _this.getLotteryChance()
            _this.sendVeriCode();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(_this.error);
      }
    },
    submit: function submit() {
      var _this = this;
      _this.gcapi('gcwwwifc/activateCustomer', { 'LoginId': _this.Mobile.replace(/\s+/g, ''), 'VerifyCode': _this.veriCode }).then(function (response) {
        if (response.body.code === 0) {
          // activate customer successful ,then login
          _this.login();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
      });
    },
    saveWorkExperience: function saveWorkExperience(customerNo) {
      var _this2 = this;

      if (!customerNo) return;
      // 保存任职关系
      var workExperience = {};
      workExperience.firstLevelEnterpriseNo = this.enterpriseInfo.enterpriseNo;
      workExperience.customerNo = customerNo;
      workExperience.startDT = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate();
      workExperience.createDT = workExperience.startDT;
      this.gcapi('saveWorkExperience', workExperience).then(function (res) {
        if (res && res.body.code === 0) {
          _this2.getResearchGroupInfo(customerNo);
        }
      });
    },
    login: function login() {
      var _this = this;
      if (_this.Mobile && _this.Password) {
        _this.gcapi('gcwwwifc/login', {
          'LoginId': _this.Mobile.replace(/\s+/g, ''),
          'Password': __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(_this.Password).toUpperCase()
        }).then(function (response) {
          if (response.body['code'] === 0) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('登录成功');
            _this.LOGIN_STATE_UPDATE(true);
            if (!__WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].isResearchGroup) {
              _this.gcapi('retrieveMyOrder').then(function (response) {
                _this.MYORDER_UPDATE(response.body.result);
                _this.$router.push('/me');
                _this.getLotteryChance();
              });
            }
            _this.gcapi('gcwwwifc/getCustomerInfo').then(function (res) {
              _this.CLIENT_INFO(res.body.result);
              var customerNo = res.body.result.customerInfo.customerNo;
              var shareUrl = __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].wxShareUrl + '?introducer=' + customerNo;
              __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.sign.shareUrl = shareUrl;
              // _this.saveWorkExperience(customerNo)
              __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].wxShare();
              _this.$router.push('/me');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body['message']);
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast(response.body);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.toast('请输入登录信息');
      }
    },
    getResearchGroupInfo: function getResearchGroupInfo(customerNo) {
      var _this3 = this;

      // customerNo = EMKT.testCustomerNo
      // 获取所有的课题组信息
      this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(function (res) {
        if (res.body.result) {
          var researchGroupMemberMap = res.body.result.bResearchGroupMemberMap;
          var researchGroupSet = res.body.result.bResearchGroupList;
          _this3.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap);
          _this3.UPDATE_RESEARCHGROUP_SET(researchGroupSet);
          console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet);
        }
      });
      // 过滤掉无效的任职关系
      this.gcapi('getWorkExperienceList', customerNo).then(function (res) {
        if (res && res.body.result) {
          var workList = res.body.result.filter(function (work) {
            return work.enable === true;
          });
          __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', workList);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].setStoreItem('EmktWorkExperienceList', []);
        }
        console.log('EmktWorkExperienceList', __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].getLocalStorage('EmktWorkExperienceList'));
      });
    },
    getLotteryChance: function getLotteryChance() {
      var _this = this;
      this.gcapi('getAvailableLotteryChance', 'CustomerRegister').then(function (res) {
        if (res.body.result.length > 0) {
          var url = res.body.result[0].url;
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
            text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/lottery_register.jpg"></div>',
            buttons: [{
              text: '关闭'
            }],
            onClick: function onClick() {
              __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
                text: '亲，您确定放弃本次活动嘛～～～',
                buttons: [{
                  text: '确定放弃'
                }, {
                  text: '返回活动',
                  onClick: function onClick() {
                    _this.getLotteryChance();
                  }
                }]
              });
            }
          });
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#lottery').click(function () {
            //              window.open('https://jinshuju.net/f/4p9nKB')
            window.open(url);
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.closeModal();
          });
        }
      });
    }
  }),
  components: {
    modalRegisterAgreement: __WEBPACK_IMPORTED_MODULE_5__components_ModalRegisterAgreement_vue___default.a
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log('mounted')
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  data: function data() {
    return {
      products: []
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {}
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    resource: function resource() {
      var customerNo = this.sessionInfo.customerInfo.customerNo;
      var src = 'wxQr/' + customerNo + '.jpg?introducer=' + customerNo + '';
      return src;
    }
  }),
  methods: {}
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  data: function data() {
    return {
      VipPlanList: []
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      //        var param = {
      //          'CustomerNo': this.sessionInfo.customerInfo.customerNo
      //        }
      var param = {
        'CustomerNo': this.sessionInfo.customerInfo.customerNo
      };
      this.VipPlanList = [];
      this.gcapi('retrieveCustomerPlan', param).then(function (response) {
        _this.VipPlanList = response.body.result;
        console.log(_this.VipPlanList);
      });
    },
    tolast: function tolast() {
      this.$router.push({ name: 'me' });
    },
    gotovipdetails: function gotovipdetails(plan) {
      this.$router.push({ path: 'VipPlanMemberDetails', query: { plan: plan, VipPlanList: this.VipPlanList } });
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  data: function data() {
    return {
      plan: {},
      memberDetails: {}
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.plan = this.$route.query.plan;
      this.gcapi('retrieveCustomerPlanMemberInformation', this.plan.GUID).then(function (response) {
        _this.memberDetails = response.body.result;
        console.log(_this.memberDetails);
      });
    },
    tolast: function tolast() {
      this.$router.push({ name: 'VipPlanDetails' });
    },
    gotovipdetails: function gotovipdetails() {
      console.log(1);
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  data: function data() {
    return {
      member: {}
    };
  },

  methods: {
    fetchData: function fetchData() {
      this.member = this.$route.query.member;
      console.log(this.member);
    },
    tolast: function tolast() {
      this.$router.push({ path: 'VipPlanMemberDetails', query: { plan: this.$route.query.plan } });
    },
    gotovipdetails: function gotovipdetails() {
      console.log(1);
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.$router.replace('home');
    }, 0);
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinderFilter_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinderFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FinderFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewMerchandiseListA__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewMerchandiseListA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NewMerchandiseListA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NewMerchandiseListB__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NewMerchandiseListB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NewMerchandiseListB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewMerchandiseListC__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewMerchandiseListC___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NewMerchandiseListC__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// eslint-disable-next-line






/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (this.emkt.getLocalStorage('EmktFinderHistory')) {
      this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory');
    }
    //      var self = this
    //      $(function () {
    //        $('.popup .searchTr .searchBox').click(function () {
    //          $(this).toggleClass('selected')
    //
    //          self.selectedTags = []
    //          let selectTags = $('.popup .searchTr')[0].getElementsByClassName('selected')
    //          for (let i = 0; i < selectTags.length; i++) {
    //            self.selectedTags.push(selectTags[i].innerHTML)
    //          }
    //          if (this.searchWords !== '') {
    //            self.response()
    //          }
    //        })
    //        $('.close-popup').click(function () {
    //          self.searchWords = ''
    //        })
    //      })
    //      this.fetchData()
    window.addEventListener('scroll', this.handleScrollsss, true);
  },
  created: function created() {
    this.fetchData();
  },
  activated: function activated() {
    var _this2 = this;

    var content = '<div id="lottery"><img style="width: 12rem;" src="' + this.attrurl + 'finder_intro.png"></div>';
    if (this.showProductImage === false) {
      return;
    }
    this.$weui.dialog({
      title: '产品简介',
      content: content,
      buttons: [{
        type: 'primary',
        label: '我知道了',
        onClick: function onClick() {
          _this2.SET_SHOW_PRODUCT_IMAGE(false);
        }
      }]
    });
    // $.modal({
    //   title: '产品简介',
    //   text: content,
    //   buttons: [ {
    //     text: '我知道了',
    //     onClick: () => {
    //       this.SET_SHOW_PRODUCT_IMAGE(false)
    //     }
    //   }]
    // })
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScrollsss, true);
  },
  ready: function ready() {},
  data: function data() {
    return {
      uiOptions: {
        searchActive: false
      },
      searchWords: '',
      matchData: [],
      finderResultData: [],
      oldSearchWords: '',
      statusMsg: ' ',
      //        showFilterBar: false,
      showfinderContent: true,
      showMatchData: false,
      showFilter: true,
      searchHistory: [],
      hotWords: [],
      data: [],
      c: [],
      searchValue: '',
      tags: [],
      selectedTags: [],
      keywordMeanings: [],
      param: {},
      lastIndex: 20,
      maxitem: 0,
      showFilterBarValue: false,
      isRemoveSH: false,
      finderEnd: false,
      loading: false,
      flag: false,
      isCorrections: false,
      attrurl: '/emktResources/resocurces/img/promotion/',
      isWapp: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp
    };
  },

  watch: {
    searchWords: function searchWords(words) {
      this.searchAssociate();
    },
    $route: function $route() {
      var param = {};
      var _this = this;
      if (_this.$route.params.ishome) {
        param.text = '';
        param.fromIndex = 0;
        param.findFilters = [];
        if (_this.ÏisSFFlag === true) {
          param.findSource = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
        }
        _this.FINDER_FLAG(false);
        _this.showFilter = true;
        _this.loading = false;
        _this.showFilterBarValue = false;
        _this.finderEnd = false;
        window.addEventListener('scroll', this.handleScrollsss, true);
        _this.gcapi('find', param).then(function (response) {
          _this.FINDER_RESULT_TOTAL(response.body.result.total);
          _this.FIND_FILTERS(response.body.result.findFilters);
          _this.finderResultData = response.body.result.merchandiseList;
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated;
          });
          console.log(response.body.result);
        });
      }
    },

    'finderFlag': function finderFlag() {
      var _this = this;
      if (_this.finderFlag) {
        //          if (_this.$route.params.ishome) {
        //            _this.$route.params.ishome = false
        //          }
        var param = {};
        param.text = _this.searchWords;
        param.fromIndex = 0;
        param.findFilters = this.findFilters;
        if (_this.isSFFlag === true) {
          param.findSource = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
        }
        _this.gcapi('find', param).then(function (response) {
          _this.FIND_FILTERS(response.body.result.findFilters);
          //            _this.findFilters = response.body.result.findFilters
          _this.FINDER_RESULT_TOTAL(response.body.result.total);
          _this.finderResultData = response.body.result.merchandiseList;
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated;
          });
          if (_this.finderResultData.length >= 20) {
            _this.finderEnd = false;
          } else {
            _this.finderEnd = true;
          }
          //            _this.returntop()
          _this.say('为您找到' + _this.finderResultTotal + '条结果');
        });
      }
      this.FINDER_FLAG(false);
    }
  },
  //    components: {
  //      finderContent
  //    },
  components: {
    finderFilter: __WEBPACK_IMPORTED_MODULE_3__FinderFilter_vue___default.a, newMerchandiseListA: __WEBPACK_IMPORTED_MODULE_4__components_NewMerchandiseListA___default.a, newMerchandiseListB: __WEBPACK_IMPORTED_MODULE_5__components_NewMerchandiseListB___default.a, newMerchandiseListC: __WEBPACK_IMPORTED_MODULE_6__components_NewMerchandiseListC___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['hasLogin', 'isSFFlag'
  // ...
  ]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['showProductImage']), {
    showSearchIcon: function showSearchIcon() {
      // 如果查询输入框处于激活状态，不要显示搜索ICON
      if (this.uiOptions.searchActive) {
        this.showfinderContent = false;
        return false;
      }
      // 如果查询输入框有查询内容，也不要显示搜索ICON
      if (this.searchWords !== '') {
        return false;
      }

      return true;
    },
    selectedItems: function selectedItems() {
      var items = [];
      this.findFilters.forEach(function (item) {
        item.filterItems.forEach(function (data) {
          if (data.selected) {
            items.push(data);
          }
        });
      });
      return items;
    },
    showFilterBar: function showFilterBar() {
      return this.showFilterBarValue;
    },
    showStatusBar: function showStatusBar() {
      return this.statusMsg !== '';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['findFilters', 'finderResultTotal', 'finderFlag'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapMutations */])(['FIND_FILTERS', 'FINDER_RESULT_TOTAL', 'FINDER_FLAG', 'SET_SHOW_PRODUCT_IMAGE']), {
    fetchData: function fetchData() {
      var _this = this;
      var param = {};
      if (_this.$route.query.ishome) {
        param.text = '';
        param.fromIndex = 0;
        param.findFilters = [];
        if (_this.isSFFlag === true) {
          param.findSource = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
        }
        _this.FINDER_FLAG(false);
        _this.gcapi('find', param).then(function (response) {
          _this.FIND_FILTERS(response.body.result.findFilters);
          _this.finderResultData = response.body.result.merchandiseList;
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated;
          });
          console.log(response.body.result);
        });
        return;
      }
      param.text = _this.searchWords;
      param.fromIndex = _this.finderResultData.length;
      param.findFilters = [];
      if (_this.isSFFlag === true) {
        param.findSource = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
      }
      _this.FINDER_FLAG(false);
      _this.gcapi('find', param).then(function (response) {
        _this.FIND_FILTERS(response.body.result.findFilters);
        _this.finderResultData = response.body.result.merchandiseList;
        _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
          return o1.selfOperated - o2.selfOperated;
        });
        console.log('find', response.body.result);
      });
      _this.say('');
    },
    gotoCategry: function gotoCategry(id, label) {
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.category.goToCategoryDetail = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.click };
      this.$router.push({ path: '/categoryDetail', query: { id: id, label: label } });
    },
    goback: function goback() {
      if (this.showMatchData) {
        this.cancelSearch();
      } else {
        this.cancelSearch();
        window.removeEventListener('scroll', this.handleScrollsss, true);
        this.$router.go(-1);
      }
      //        this.$router.push({name: 'home'})
    },
    contactUs: function contactUs() {
      this.$router.push({ name: 'contactUs' });
    },
    finderFilterSearch: function finderFilterSearch() {
      this.FINDER_FLAG(true);
    },
    toMessage: function toMessage() {
      if (this.hasLogin) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].openCustomerService();
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      } else {
        alert('请您先去登录！');
      }
      //        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
    },
    returntop: function returntop() {
      var _this = this;
      _this.finderEnd = false;
      //        var btnTop = document.getElementById('btnTop')
      //        btnTop.style.display = 'none'
      var timer = setInterval(function () {
        var sTop;
        if (document.compatMode === 'BackCompat') {
          sTop = document.body.scrollTop;
        } else {
          sTop = document.getElementById('contentscroll').scrollTop || document.body.scrollTop || window.pageYOffset;
        }
        var backTop = sTop;
        var speedTop = backTop / 10;
        _this.setScrollTop(backTop - speedTop);
        if (backTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    setScrollTop: function setScrollTop(top) {
      if (document.compatMode === 'BackCompat') {
        document.body.scrollTop = top;
      } else {
        if (document.getElementById('contentscroll').scrollTop.scrollTop === 0) {
          document.body.scrollTop = top;
        } else {
          document.getElementById('contentscroll').scrollTop = top;
        }
      }
    },
    handleScrollsss: function handleScrollsss() {
      if (this.$route.name === 'finder') {
        var _this = this;
        var btnTop = document.getElementById('btnTop');
        var visibleBottom = window.scrollY + document.documentElement.clientHeight;
        //          console.log('visibleBottom:' + visibleBottom)
        //          console.log(' scrollTop:' + document.getElementById('contentscroll').scrollTop)
        if (document.getElementById('contentscroll').scrollTop > 1200) {
          if (_this.showFilter) {
            _this.showFilter = false;
            _this.showFilterBarValue = true;
          }
        }
        if (document.getElementById('contentscroll').scrollTop > 1200) {
          btnTop.style.display = 'block';
        } else {
          btnTop.style.display = 'none';
        }
        if (!_this.loading) {
          if (document.getElementById('preloader')) {
            var centerY = document.getElementById('preloader').offsetTop + document.getElementById('preloader').offsetHeight / 2;
            if (centerY <= document.getElementById('contentscroll').scrollTop + visibleBottom) {
              //              $.detachInfiniteScroll($('.infinite-scroll'))
              //              $('.infinite-scroll-preloader').remove()
              var length = _this.finderResultData.length;
              if (_this.finderResultData.length >= length) {
                _this.loading = true;
                _this.finderEnd = false;
                var param = {};
                if (_this.isSFFlag === true) {
                  param.findSource = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
                }
                param.text = _this.searchWords;
                param.fromIndex = _this.finderResultData.length;
                param.findFilters = _this.findFilters;
                this.gcapi('find', param).then(function (response) {
                  var addlist = response.body.result.merchandiseList;
                  length = length + addlist.length;
                  if (addlist.length >= 20) {
                    for (var i = 0; i < addlist.length; i++) {
                      _this.finderResultData.push(addlist[i]);
                    }
                  } else {
                    _this.finderEnd = true;
                  }
                  _this.loading = false;
                });
              }
            }
          }
        }
        //          if (_this.loading) return
      }
    },
    openpanel: function openpanel() {
      __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.openPanel('#panel-right-finder');
    },
    handleScroll: function handleScroll() {
      this.scroll = document.body.scrollTop;
      console.log(this.scroll);
    },
    onSearchActive: function onSearchActive(active) {
      this.uiOptions.searchActive = active;

      if (this.uiOptions.searchActive) {
        this.oldSearchWords = this.searchWords;
      } else {
        // search input 失去焦点
        if (this.oldSearchWords !== this.searchWords) {
          // 恢复原来的searchWords
          // this.searchWords = this.oldSearchWords
          this.oldSearchWords = this.searchWords;
        }
      }
    },
    onSearch: function onSearch() {
      var _this3 = this;

      this.oldSearchWords = this.searchWords;
      window.$('input[type=search]').blur();
      //        this.showfinderContent = false
      //        this.showMatchData = true
      var _this = this;
      if (!_this.matchData || _this.matchData.length < 1) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.showPreloader('正在查询结果,请稍等');
      _this.loading = true;
      _this.finderEnd = false;
      var param = {};
      if (_this.isSFFlag === true) {
        param.source = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].FindSourceCrm;
      }
      param.text = _this.searchWords;
      param.fromIndex = 0;
      param.findFilters = [];
      _this.gcapi('find', param).then(function (response) {
        console.log('onSearch', _this3.searchWords, response);
        var merchList = response.body.result.merchandiseList;
        if (merchList) {
          _this.addSearchWordIntoAbstractList(merchList);
        }
        _this.finderResultData = merchList;
        _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
          return o1.selfOperated - o2.selfOperated;
        });
        _this.FIND_FILTERS(response.body.result.findFilters);
        _this.FINDER_RESULT_TOTAL(response.body.result.total);
        _this.lastIndex = _this.finderResultData.length;
        if (_this.finderResultData.length > 0) {
          _this.showfinderContent = true;
          _this.showMatchData = false;
          console.log(response.body.result.total);
          _this.say('为您找到' + _this.finderResultTotal + '条结果');
        } else {
          _this.say('查询无结果');
        }
        // console.log('onSearch', response.body.result)
        //          this.finderResultData = response.body.result.merchandiseList
        //          if (this.finderResultData.length > 0) {
        //            this.showfinderContent = true
        //          }
      }).then(__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.hidePreloader());
      console.log('search1 ' + this.searchWords);
    },
    cancelSearch: function cancelSearch() {
      var _this4 = this;

      var param = {};
      param.text = '';
      param.fromIndex = 0;
      param.findFilters = [];
      this.FINDER_FLAG(false);
      this.gcapi('find', param).then(function (response) {
        _this4.FIND_FILTERS(response.body.result.findFilters);
        _this4.finderResultData = response.body.result.merchandiseList;
        _this4.finderResultData && _this4.finderResultData.sort(function (o1, o2) {
          return o1.selfOperated - o2.selfOperated;
        });
      });
      this.say('');
      window.$('input[type=search]').blur();
      this.showfinderContent = true;
      this.showMatchData = false;
      this.searchWords = '';
      console.log('search2 ' + this.searchWords);
    },

    // 搜索联想
    searchAssociate: function searchAssociate() {
      // 截流
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].throttle(this.doSearchAssociate, 500, this);
    },
    doSearchAssociate: function doSearchAssociate() {
      var _this = this;
      if (_this.searchWords === _this.oldSearchWords) {
        return;
      }
      _this.gcapi('findSuggestion', _this.searchWords).then(function (res) {
        _this.matchData = res.body.result;
        if (_this.matchData && _this.matchData.length > 0 && _this.matchData[0].isCorrections === true) {
          _this.isCorrections = _this.matchData[0].isCorrections;
        } else {
          _this.isCorrections = false;
        }
        _this.showMatchData = true;
      });
      console.log('search3 associate ' + _this.searchWords);
      this.say('');
    },
    removeSearchHistory: function removeSearchHistory() {
      window.localStorage.removeItem('EmktFinderHistory');
      this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory');
      this.emkt.removeStoreItem('EmktFinderHistory');
      this.isRemoveSH = true;
    },
    getHistoryData: function getHistoryData(selectedItem) {
      /**
       * 点击搜索结果进入下一页面时进行判断是否已经有一样的历史记录
       * 如果没有则新增，如果有则不做重复储存，判断完成后进入下一页
       */
      var searchHistory = this.emkt.getLocalStorage('EmktFinderHistory') === undefined ? [] : this.emkt.getLocalStorage('EmktFinderHistory');
      if (searchHistory) {
        var checkrepeat = false;
        searchHistory.forEach(function (item) {
          if (item.text === selectedItem.text) {
            checkrepeat = true;
          }
        });
        if (!checkrepeat) {
          if (searchHistory.length >= 5) {
            searchHistory.splice(0, 1);
          }
          searchHistory.push(selectedItem);
        }
      } else if (selectedItem && selectedItem.text !== '') {
        if (searchHistory.length >= 5) {
          searchHistory.splice(0, 1);
        }
        searchHistory.push(selectedItem);
      }
      this.emkt.setLocalStorage('EmktFinderHistory', searchHistory);
      this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory');
      this.isRemoveSH = false;
    },
    searchTarget: function searchTarget(selectedItem, needCondition, fromHistory) {
      var _this = this;
      _this.searchValue = selectedItem.text;
      _this.searchWords = selectedItem.text;
      __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.showPreloader('正在查询结果,请稍等');
      var param = {};
      param.text = _this.searchWords;
      param.fromIndex = 0;
      param.findFilters = [];
      this.getHistoryData(selectedItem);

      if (fromHistory) {
        // do nothing
      } else {
        param.queryNos = selectedItem.queryNos;
      }

      _this.gcapi('find', param).then(function (response) {
        _this.finderResultData = response.body.result.merchandiseList;
        _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
          return o1.selfOperated - o2.selfOperated;
        });
        _this.FIND_FILTERS(response.body.result.findFilters);
        _this.FINDER_RESULT_TOTAL(response.body.result.total);
        _this.lastIndex = _this.finderResultData.length;
        if (_this.finderResultData.length > 0) {
          _this.showfinderContent = true;
          _this.showMatchData = false;
          _this.showFilter = true;
          _this.showFilterBarValue = false;
          _this.say('为您找到' + _this.finderResultTotal + '条结果');
        } else {
          __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.toast('查询无结果');
        }
        console.log(response.body.result);
        //          this.finderResultData = response.body.result.merchandiseList
        //          if (this.finderResultData.length > 0) {
        //            this.showfinderContent = true
        //          }
      }).then(__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.hidePreloader());
    },
    controlForm: function controlForm(attribute, index) {
      console.log(attribute);
      console.log(index);
    },
    say: function say(msg) {
      this.statusMsg = msg;
    },
    addSearchWordIntoAbstractList: function addSearchWordIntoAbstractList(merchList) {
      if (!merchList || merchList.length === 0) {
        return;
      }
      // 若首个商品的_abstractList已包含搜索关键字，直接返回
      var searchWordIncluded = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(merchList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var merchandise = _step.value;

          searchWordIncluded = false;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(merchandise._abstractList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var attr = _step2.value;

              if (attr.valueText && attr.valueText.toLowerCase() === this.searchWords.toLowerCase()) {
                console.log('已包含关键字');
                searchWordIncluded = true;
                break;
              }
            }
            // 若商品的_abstractList不包含搜索关键字，手动添加
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (!searchWordIncluded) {
            console.log('手动添加');
            merchandise._abstractList.push({
              'label': 'searchWord',
              'valueText': this.searchWords
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return;
    }
  })
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-enum-box',
  data: function data() {
    return {
      checkedData: '',
      questionUrl: '/emktResources/resocurces/img/question.png',
      attrurl: '../../../static/filters/'
    };
  },

  props: ['attribute', 'index', 'attributesList', 'merchandises', 'type', 'param'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: {
    options: function options() {
      var opt = this.attribute.options;
      var resArr = [];
      if (opt) {
        for (var data in opt) {
          console.log(data);
        }
        return resArr;
      }
      return resArr;
    }
  },
  methods: {
    fetchData: function fetchData() {
      if (this.type) {
        return;
      }
      var opt = this.attribute.options;
      if (opt && this.attribute.groupId === 3 && this.attribute.sectionId === 2) {
        var obj = {};
        if (this.merchandises.specAttributes && this.merchandises.specAttributes[this.attribute.columnName]) {
          for (var data in this.merchandises.specAttributes[this.attribute.columnName]) {
            if (this.attribute.columnName === 'AAVBloodType') {
              obj = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('SpecialBloodOptions');
            } else {
              for (var data2 in this.attribute.options) {
                if (this.merchandises.specAttributes[this.attribute.columnName][data].toString() === data2) {
                  obj[data2] = this.attribute.options[data2];
                }
              }
            }
          }
        }
        this.attribute.options = obj;
        //          if (this.attribute.columnName === 'LVAmount' && this.merchandises._attributes.NC_LV_Amount) {
        //            this.merchandises._attributes.NC_LV_Amount.options = obj
        //          }
        //          if (this.attribute.columnName !== 'NC_LV_Amount') {
        //            this.attribute.options = obj
        //          } else {
        //            this.attribute.options = this.merchandises._attributes.LVAmount.options
        //          }
      }
      //        if (this.merchandises.categoryId === 20 && this.attribute.groupId === 3 && this.param === undefined) {
      //          this.attribute.value = ''
      //        }
    },
    showMessage: function showMessage(attribute) {
      var name = '';
      if (attribute.columnName === 'ExpressionTest') {
        name = 'ExpressionTest.jpg';
      } else if (attribute.columnName === 'InducingTest') {
        name = 'InducingTest.jpg';
      } else if (attribute.columnName === 'LVAmount' || attribute.columnName === 'NC_LV_Amount') {
        name = 'LVAmount.jpg';
      }
      var content = '<div id="lottery"><img style="width: 100%;height: 100%;"' + 'src=' + this.attrurl + name + '></div>';
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        text: content,
        buttons: [{
          text: '确定',
          onClick: function onClick() {}
        }]
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal').css({ 'width': '17rem', 'height': '100%', 'margin-left': '-8.7rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-buttons').css({ 'height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-button').css({ 'line-height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-inner').css({ 'padding': '0rem' });
    },
    getAfterText: function getAfterText(attribute) {
      var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' + '<input type="radio"  class="radio-input-attr" name="attr" value="';
      var ret2 = '';
      var ret3 = '"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">';
      var attr = this.attribute.options;
      var height = '';
      var length = 0;
      for (var key in attr) {
        if (attribute.valueText === attr[key]) {
          ret2 += ret1 + key + ret4 + attr[key] + '</div></div></label></li>';
        } else {
          ret2 += ret1 + key + ret3 + attr[key] + '</div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      return ret;
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert(val);
    },
    getTitle: function getTitle(attribute) {
      var data = '<div class="modal-title" style="font-size: .7rem">' + attribute.label + '</div>';
      return data;
    },
    showOptionList: function showOptionList(attribute) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.checkedData) {
              _this.attribute.value = _this.checkedData;
            }
          }
        }]
      });
      var obj1 = document.getElementById('modal-title');
      if (obj1 !== null) {
        obj1.style.cssText = 'font-size: .6rem;';
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr').on('click', function () {
        var val = void 0;
        var radio = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.radio-input-attr');
        for (var i = 0; i < radio.length; i++) {
          if (radio[i].checked) {
            val = radio[i].value;
          }
        }
        if (_this.attribute.value !== val) {
          _this.attribute.value = val;
          _this.checkedData = val;
          _this.valueChanged(attribute);
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.closeModal();
      });
    },
    valueChanged: function valueChanged(attribute) {
      this.$emit('controlForm', this.index, attribute);
      //        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
    }
    //      ,
    //      getKeyByValue (value) {
    //        let obj = this.attribute.options
    //        for (var prop in obj) {
    //          if (obj.hasOwnProperty(prop)) {
    //            if (obj[prop] === value) {
    //              return prop
    //            }
    //          }
    //        }
    //      }

  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = this.attribute.options[val];
      this.$emit('controlForm', this.index, this.attribute);
      //        this.merchandises._attributesList = this.attributesList
      //        this.$emit('controlForm', this.index, this.merchandises)
      //        if (!this.$route.query.cust) {
      //          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
      //        }
    }
    //      ,
    //      attribute: {
    //        handler: function (val) {
    //          this.attribute.value = this.getKeyByValue(val)
    //        },
    //        deep: true
    //      }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var REGUTECH_OVEREXPRESSION = 1;
var TOOLTYPE_LENTIVIRUS = 1;
var TOOLTYPE_PLASMID = 2;
var TOOLTYPE_ADENOVIRUS = 3;
var TOOLTYPE_RETROVIRUS = 5;
var TOOLTYPE_FLOATVIRUS = 6;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-gene-box',
  data: function data() {
    return {
      attributevalueText: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'customAttrs', 'merchandises'],
  mounted: function mounted() {},
  created: function created() {
    this.fetchData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    options: function options() {
      if (this.attribute.options) {
        return this.attribute.options;
      }
      return {};
    },
    attrOptions: function attrOptions() {
      var attr = this.curAttrsInGroup;
      var resList = [];
      for (var i in attr) {
        if (attr[i].customizable === 0 && attr[i].columnName.indexOf('TVInfo.') < 0) {
          resList.push(attr[i]);
        }
      }

      return resList;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['geneSearchResult', 'hardGeneInfo'])),
  methods: {
    fetchData: function fetchData() {
      console.log(1111);
      console.log(this.merchandises);
      if (typeof this.attribute.value === 'string' && this.attribute.value !== 'null' && this.attribute.value !== undefined) {
        if (this.attribute.value !== '' && JSON.parse(this.attribute.value) !== null) {
          var data1 = JSON.parse(this.attribute.value);
          var dictionary = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
          data1['taxName'] = dictionary[61033][data1.taxId].dictValue;
          this.attribute.value = data1;
          this.attribute.valueText = data1;
        }
      }
      if (this.merchandises._attributes['GeneInfo.symbol'] && this.merchandises._attributes['GeneInfo.symbol'].value !== '') {
        if (this.attribute.value === '') {
          this.attribute.value = {};
          this.attribute.value.symbol = this.merchandises._attributes['GeneInfo.symbol'].value;
        }
      }
      console.log(this.attribute);
      /*
      if (this.geneSearchResult['/custOrder']) {
        this.attributevalueText = this.geneSearchResult['/custOrder'].data.symbol
      } else {
        this.attributevalueText = this.attribute.value.symbol
      }
      */
    }
  },
  watch: {
    'geneSearchResult': function geneSearchResult(val) {
      var _this = this;
      var data = val['/finder/finderMerchandises'].data;
      var dictionary = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      data['taxName'] = dictionary[61033][data.taxId].dictValue;
      var scpoe = dictionary[55006][_this.merchandises._attributes.GeneInfo_Category_Scope.value].dictValue;
      console.log(data);
      console.log(dictionary[61064][data.category].dictValue);
      if (scpoe.indexOf(dictionary[61064][data.category].dictValue) !== -1) {
        //          if (data.category === 4 && data.ttttflag === ) {
        //
        //          }
        if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0) {
          var hardHeneGo = true;
          console.log('hardGeneInfo', _this.hardGeneInfo);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.hardGeneInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var hardGene = _step.value;

              if (hardGene.productGuid !== undefined && hardGene.productGuid) {
                // 合同小类拦截
                console.log(_this.merchandises);
                if (_this.merchandises.attributes.ProductGuid === hardGene.productGuid) {
                  if (hardGene.level === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].HardGeneLevelNo1) {
                    hardHeneGo = false;
                    break;
                  } else {
                    if (hardGene.removeTLNo !== undefined && hardGene.removeTLNo) {
                      // 有排除基因
                      if (_this.merchandises.attributes.TVInfo && !hardGene.removeTLNo.includes(_this.merchandises.attributes.TVInfo.TLNo)) {
                        hardHeneGo = false;
                        break;
                      }
                    } else {
                      hardHeneGo = false;
                      break;
                    }
                  }
                }
              } else {
                // 合同大类检查调控技术 和靶点设计方案
                if (_this.merchandises.attributes.Tech && hardGene.tech.includes(_this.merchandises.attributes.Tech)) {
                  if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                    if (_this.merchandises.attributes.TargetSupplier !== undefined && _this.merchandises.attributes.TargetSupplier && hardGene.targetSupplier.includes(_this.merchandises.attributes.TargetSupplier)) {
                      if (hardGene.level === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].HardGeneLevelNo1) {
                        hardHeneGo = false;
                        break;
                      } else {
                        if (hardGene.removeTLNo) {
                          // 有排除基因
                          if (_this.merchandises.attributes.TVInfo && !hardGene.removeTLNo.includes(_this.merchandises.attributes.TVInfo.TLNo)) {
                            hardHeneGo = false;
                            break;
                          }
                        } else {
                          hardHeneGo = false;
                          break;
                        }
                      }
                    }
                  } else {
                    hardHeneGo = false;
                    break;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (!hardHeneGo) {
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302');
            return;
          }
        } else {
          if (data.riskWarning) {
            _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302');
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            return;
            // this.$weui.confirm(val.hardGeneDescription, function () {
            //   setTimeout(function () {
            //   }, 300)
            // }, function () {
            //   setTimeout(function () {
            //       // 逻辑行1
            //     _this.attribute.value = ''
            //     _this.attribute.valueText = ''
            //     // 逻辑行2
            //   }, 300)
            // })
          }
        }
        console.log(_this.merchandises._attributes);
        // 质粒>10k 或 腺病毒>6.5k 或 慢病毒>6k 或 逆转录>4k 或 悬浮慢病毒>6k
        if (_this.merchandises._attributes.ReguTech.value === REGUTECH_OVEREXPRESSION) {
          if (_this.merchandises._attributes.ToolType.value === TOOLTYPE_LENTIVIRUS && data.CDSSize > 6000 || _this.merchandises._attributes.ToolType.value === TOOLTYPE_PLASMID && data.CDSSize > 10000 || _this.merchandises._attributes.ToolType.value === TOOLTYPE_ADENOVIRUS && data.CDSSize > 6500 || _this.merchandises._attributes.ToolType.value === TOOLTYPE_RETROVIRUS && data.CDSSize > 4000 || _this.merchandises._attributes.ToolType.value === TOOLTYPE_FLOATVIRUS && data.CDSSize > 6000) {
            console.log('基因太大不可构建！');
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302');
            return;
          }
        }
        if (_this.merchandises._attributes.ReguTech.value === 1 && (_this.merchandises._attributes.ToolType.value === 1 || _this.merchandises._attributes.ToolType.value === 6 || _this.merchandises._attributes.ToolType.value === 7)) {
          if (data.CDSSize > 4000 && data.CDSSize < 6000) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
              title: '请您核对',
              afterText: '<div>老师您选择的基因信息超过4K，公司不承诺滴度和总量，我司会尝试包装两次，按照实际滴度和总量发货,点击【确定】表示您认可我司的方案。您可以点击【返回修改】或者咨询在线客服。</div>',
              buttons: [{
                text: '返回修改',
                bold: true,
                onClick: function onClick() {
                  _this.attribute.value = '';
                  _this.attribute.valueText = '';
                }
              }, {
                text: '确定',
                bold: true,
                onClick: function onClick() {
                  _this.attribute.value = data;
                  _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
                  _this.$emit('controlForm', _this.index, _this.attribute);
                }
              }]
            });
          } else if (data.CDSSize > 6000) {
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            alert('您选择的基因大小超过6K，暂时不支持在线订购。详细您可以咨询电话400-621-0302或者咨询在线客服。');
          } else {
            console.log(data);
            _this.attribute.value = data;
            _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
            _this.$emit('controlForm', _this.index, _this.attribute);
          }
        } else if (_this.merchandises._attributes.ReguTech.value === 1 && _this.merchandises._attributes.ToolType.value === 4) {
          if (data.CDSSize > _this.merchandises._attributes.GeneSizeLimit.value) {
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            _this.$weui.alert('您选择的基因大小超过对应载体的包装容量，您可以返回上一步重新选择适用更大CDS基因的载体。同时您也可以电话400-621-0302或者咨询在线客服。');
          } else {
            _this.attribute.value = data;
            _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
            _this.$emit('controlForm', _this.index, _this.attribute);
          }
        } else if (_this.merchandises._attributes.ReguTech.value === 1 && (_this.merchandises._attributes.ToolType.value === 3 || _this.merchandises._attributes.ToolType.value === 2)) {
          if (data.CDSSize > 6000) {
            _this.attribute.value = '';
            _this.attribute.valueText = '';
            _this.$weui.alert('您选择的基因大小超过6K，暂时不支持在线订购。详细您可以咨询电话400-621-0302或者咨询在线客服。');
          } else {
            _this.attribute.value = data;
            _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
            _this.$emit('controlForm', _this.index, _this.attribute);
          }
        } else if (_this.merchandises._attributes.ReguTech.value === 2 && _this.merchandises._attributes.TargetSupplier.value === 2) {
          if (data.CDSSize > 4000) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.modal({
              title: '请您核对',
              afterText: '<div>您选择的基因大小超过4K，我司对于基因大小超过4k的基因不承诺敲减效率。点击【确定】表示您接受认可此承诺条款，此承诺条款如和其他地方描述冲突，以该处承诺条款为准。您可以点击【返回修改】或者咨询在线客服。</div>',
              buttons: [{
                text: '返回修改',
                bold: true,
                onClick: function onClick() {
                  _this.attribute.value = '';
                  _this.attribute.valueText = '';
                }
              }, {
                text: '确定',
                bold: true,
                onClick: function onClick() {
                  _this.attribute.value = data;
                  _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
                  _this.$emit('controlForm', _this.index, _this.attribute);
                }
              }]
            });
          } else {
            _this.attribute.value = data;
            _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
            _this.$emit('controlForm', _this.index, _this.attribute);
          }
        } else if ((data.category === 2 || data.category === 3) && data.ttttflag === 1 && _this.merchandises._attributes.TVInfo.value.TTTTFlag === 0) {
          _this.attribute.value = '';
          _this.attribute.valueText = '';
          _this.$weui.alert('您选择的miRNA存在4个连续的T，使用U6启动子构建有提前转录终止的可能，建议您返回上一步重新选择启动子为Ubi，CMV等二型启动子的载体');
        } else {
          _this.attribute.value = data;
          _this.attribute.valueText = data.symbol === undefined ? data.microNo : data.symbol;
          _this.$emit('controlForm', _this.index, _this.attribute);
        }
      } else {
        _this.attribute.value = '';
        _this.attribute.valueText = '';
        var message = '';
        if (scpoe.indexOf('MicroUp') !== -1) {
          message = '您需要选择的基因类型为pre-miRNA，请重新选择。pre-miRNA的名称中不包含-3p或者-5p，同时编号由MI+数字组成。';
        } else if (scpoe.indexOf('MicroDown') !== -1) {
          message = '您需要选择的基因类型为mature miRNA，请重新选择。mature miRNA的名称通常包含-3p或者-5p，同时编号由MIMAT+数字组成。';
        } else {
          message = '您需要选择的基因类型为' + scpoe + '，请您重新选择！';
        }
        _this.$weui.alert(message);
      }
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-number-box',
  data: function data() {
    return {};
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {},
  watch: {
    'attribute.value': function attributeValue(val) {
      if (val !== '') {
        if (val.replace(/[^\d]/g, '') === '') {
          alert('请您填写数字');
        }
      }
      if (this.attribute.columnName === 'PlasmidNumber' && val > 1) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          title: '请核对',
          afterText: '<div>请确认客户所提供的质粒抗性都相同，否则不同抗性的质粒请单独录入订单合同。</div>',
          buttons: [{
            text: '不确定',
            bold: true,
            onClick: function onClick() {
              alert('请您重新选择！');
            }
          }, {
            text: '确定',
            bold: true,
            onClick: function onClick() {
              _this.attribute.valueText = val;
              _this.$emit('controlForm', _this.index, _this.curAttrsInGroup, _this.attribute);
            }
          }]
        });
      } else {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute);
      }
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-text-box',
  data: function data() {
    return {
      questionUrl: '/emktResources/resocurces/img/question.png',
      attrurl: '/emktResources/resocurces/img/promotion/SKUIMG/'
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {
    control: function control() {},

    close: function close() {
      this.$emit('close');
    },
    gototlno: function gototlno() {
      //        var url = this.attrurl + this.attribute.valueText.TLNo + '.jpg'
      //        var myPhotoBrowserStandalone = $.photoBrowser({
      //          photos: [url]
      //        })
      //        $(document).on('click', '.pb-standalone', function () {
      //          myPhotoBrowserStandalone.open()
      //        })
      var tlno = '';
      if (this.attribute.valueText.TLNo) {
        tlno = this.attribute.valueText.TLNo;
      } else {
        tlno = this.attribute.value;
      }
      var content = '<div id="lottery"><img style="width: 13.5rem;height: 14rem;"' + 'src=' + this.attrurl + tlno + '.jpg' + '></div>';
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        text: content,
        buttons: [{
          text: '确定',
          onClick: function onClick() {}
        }]
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal').css({ 'width': '15rem', 'height': '18rem', 'margin-left': '-7.7rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-buttons').css({ 'height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-button').css({ 'line-height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-inner').css({ 'padding': '.55rem' });
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-text-box',
  data: function data() {
    return {
      textareaData: ''
    };
  },

  props: ['attribute', 'index', 'curAttrsInGroup'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {
    getAfterText: function getAfterText(attribute) {
      var ret = '<div class="modal-class" style="overflow-y: scroll; display: flex">' + ' <div style="margin: auto;">' + ' <textarea placeholder="请输入..." id="textarea-input-attr" style="height: 8rem;width: 12rem;background-color: #FFFFFF;border: 1px solid #E9E9E9;"></textarea>' + ' </div>' + ' </div>';
      return ret;
    },
    getTitle: function getTitle(attribute) {
      return attribute.label;
    },
    control: function control(attribute) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        title: _this.getTitle(attribute),
        afterText: _this.getAfterText(attribute),
        buttons: [{
          text: '取消',
          bold: true,
          onClick: function onClick() {
            if (_this.textareaData) {
              _this.attribute.value = _this.textareaData;
              //                  _this.attribute.valuetext = _this.textareaData
            }
          }
        }, {
          text: '确定',
          bold: true,
          onClick: function onClick() {
            var textarea = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#textarea-input-attr');
            var val = textarea.val();
            _this.attribute.value = val;
            //                _this.attribute.valuetext = val
            _this.textareaData = val;
          }
        }]
      });
      if (attribute.value) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#textarea-input-attr').val(attribute.value);
      }
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finder-attr-text-box',
  data: function data() {
    return {};
  },

  props: ['attribute', 'index', 'curAttrsInGroup', 'merchandises'],
  mounted: function mounted() {},
  created: function created() {},

  computed: {},
  methods: {
    control: function control() {
      this.$emit('controlForm', this.index, this.curAttrsInGroup);
    }
  },
  watch: {
    'attribute.value': function attributeValue(val) {
      this.attribute.valueText = val;
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import emkt from '../../emkt'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['findFilters', 'finderyemian'],
  data: function data() {
    return {
      questionUrl: '../../../static/img/question.png',
      attrurl: '../../../static/filters/',
      expend: false
    };
  },
  created: function created() {
    this.fetchData();
  },

  warch: {
    'finderyemian': function finderyemian(val) {
      console.log(val);
    }
  },
  methods: {
    queryHandler: function queryHandler() {
      this.$emit('finderFilterSearch', this.findFilters);
    },
    fetchData: function fetchData() {},
    displayMessage: function displayMessage(filter) {
      var content = '<div id="lottery"><img style="width: 14rem;height: 14rem;"' + 'src=' + this.attrurl + filter.tips + '></div>';
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        text: content,
        buttons: [{
          text: '确定',
          onClick: function onClick() {}
        }]
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal').css({ 'width': '15rem', 'height': '18rem', 'margin-left': '-7.7rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-buttons').css({ 'height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-button').css({ 'line-height': '1.5rem' });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-inner').css({ 'padding': '.55rem' });
    },
    filterItems: function filterItems(filter) {
      if (filter.expanded) {
        return filter.filterItems;
      }
      if (!this.finderyemian) {
        return filter.filterItems;
      }
      return filter.filterItems.slice(0, 8);
    },
    findFiltersItems: function findFiltersItems(findFilters) {
      if (this.expend || !this.finderyemian) {
        return findFilters;
      }
      return findFilters.slice(0, 3);
    },
    addmore: function addmore() {
      this.expend = true;
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      total: 0,
      inventoryStockRemark: '下单7天未确认订单，订单会被自动取消'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE']), {
    addCartListForRecom: function addCartListForRecom(pro) {
      this.ADD_CART_LIST(pro);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('加入购物车成功！');
    },
    setdatas: function setdatas(pro) {
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      var _self = this;
      _self.MERCHDISEGROUP_UPDATE(pro.compositions);
      this.$router.push({ path: '/promotion/Compositions' });
    },
    openshaxuan: function openshaxuan() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.openPanel('#panel-right-demo');
    },
    getbpromotions: function getbpromotions(merchdise) {
      if (merchdise.bpromotions) {
        var bpromotions = merchdise.bpromotions;
        var r = [];
        var t = [];
        for (var m = 0; m < bpromotions.length; m++) {
          if (t.indexOf(bpromotions[m].type) === -1) {
            r.push(bpromotions[m]);
            t.push(bpromotions[m].type);
            // console.log(m + ' ' + bpromotions[m].type)
          }
        }
        return r;
      }
    },
    clickMerchandise: function clickMerchandise(pro) {
      var id = '';
      var cid = 0;
      if (pro.categoryId === 20 && pro.findId) {
        id = pro.findId;
      } else if (pro.categoryId === 20 && !pro.findId) {
        cid = 20;
        id = pro.merchandiseId;
      } else {
        id = pro.merchandiseId;
      }
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      if (this.proo) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { pro: this.proo } });
      } else if (this.channel) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { channel: this.channel } });
      } else {
        if (cid === 20) {
          this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId, cid: 20 } });
        } else {
          this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId } });
        }
      }
    },
    filteredShowPromotions: function filteredShowPromotions(merchandise) {
      if (merchandise.promotions && merchandise.promotions.length > 0) {
        return merchandise.promotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && pro.type !== 0;
        });
      }
      if (merchandise.bpromotions && merchandise.bpromotions.length > 0) {
        return merchandise.bpromotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && pro.type !== 0;
        });
      }
      return [];
    },
    showInventoryStockRemark: function showInventoryStockRemark(merchandise) {
      return merchandise && merchandise.merchandiseLabel && merchandise.merchandiseLabel.indexOf('极速现货') !== -1;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['queryTotal', 'sessionInfo', 'secInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['secFlag']), {
    merchs: function merchs() {
      var newmerchList = [];
      if (!this.merchList) {
        return newmerchList;
      }
      newmerchList = this.merchList;
      //        for (var i = 0; i < newmerchList.length; i++) {
      //          var tags = []
      //          var merchandiseMeta = emkt.getEmktMetaData()
      //          var tagsmap = merchandiseMeta.tagsMap
      //          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
      //            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
      //          }
      //          newmerchList.tags = tags
      //          var bpromotions = newmerchList[i].bpromotions
      //          var r = []
      //          var t = []
      //          for (var m = 0; m < bpromotions.length; m++) {
      //            if (t.indexOf(bpromotions[m].type) === -1) {
      //              r.push(bpromotions[m])
      //              t.push(bpromotions[m].type)
      //              console.log(m + ' ' + bpromotions[m].type)
      //            }
      //          }
      //          newmerchList[i].bpromotions = r
      //        }
      this.total = newmerchList.length;
      return newmerchList;
    },
    showFilterBarFlag: function showFilterBarFlag() {
      var flag = true;
      var src = this.$route.name;
      if (src === 'home') {
        flag = false;
      }
      if (!this.showFilterBar) {
        flag = false;
      }
      return flag;
    },
    secPromotionRatio: function secPromotionRatio() {
      var ratio = String(100 - this.secInfo.seckilltRatio * 100);
      ratio = ratio[1] === '0' ? ratio[0] : ratio;
      return ratio;
    },
    merchListWithoutCustomized10: function merchListWithoutCustomized10() {
      if (this.merchList && this.merchList.length > 0) {
        return this.merchList.filter(function (product) {
          return product.categoryId !== 10;
        });
      }
      return [];
    }
  })
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      total: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE']), {
    addCartListForRecom: function addCartListForRecom(pro) {
      this.ADD_CART_LIST(pro);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('加入购物车成功！');
    },
    setdatas: function setdatas(pro) {
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      var _self = this;
      _self.MERCHDISEGROUP_UPDATE(pro.compositions);
      this.$router.push({ path: '/promotion/Compositions' });
    },
    openshaxuan: function openshaxuan() {
      // $.openPanel('#panel-right-demo')
    },
    getbpromotions: function getbpromotions(merchdise) {
      if (merchdise.bpromotions) {
        var bpromotions = merchdise.bpromotions;
        var r = [];
        var t = [];
        for (var m = 0; m < bpromotions.length; m++) {
          if (t.indexOf(bpromotions[m].type) === -1) {
            r.push(bpromotions[m]);
            t.push(bpromotions[m].type);
            // console.log(m + ' ' + bpromotions[m].type)
          }
        }
        return r;
      }
    },
    clickMerchandise: function clickMerchandise(pro) {
      var id = '';
      if (pro.categoryId === 20) {
        id = pro.findId;
      } else {
        id = pro.merchandiseId;
      }
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      if (this.proo) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { pro: this.proo } });
      } else if (this.channel) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { channel: this.channel } });
      } else {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId } });
      }
    },
    filteredShowPromotions: function filteredShowPromotions(merchandise) {
      if (merchandise.promotions && merchandise.promotions.length > 0) {
        return merchandise.promotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && pro.type !== 0;
        });
      }
      if (merchandise.bpromotions && merchandise.bpromotions.length > 0) {
        return merchandise.bpromotions.filter(function (pro) {
          return pro.requiredCustomers === 0 && pro.description && pro.type !== 0;
        });
      }
      return [];
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['queryTotal', 'sessionInfo', 'secInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['secFlag']), {
    merchs: function merchs() {
      var newmerchList = [];
      if (!this.merchList) {
        return newmerchList;
      }
      newmerchList = this.merchList;
      //        for (var i = 0; i < newmerchList.length; i++) {
      //          var tags = []
      //          var merchandiseMeta = emkt.getEmktMetaData()
      //          var tagsmap = merchandiseMeta.tagsMap
      //          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
      //            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
      //          }
      //          newmerchList.tags = tags
      //          var bpromotions = newmerchList[i].bpromotions
      //          var r = []
      //          var t = []
      //          for (var m = 0; m < bpromotions.length; m++) {
      //            if (t.indexOf(bpromotions[m].type) === -1) {
      //              r.push(bpromotions[m])
      //              t.push(bpromotions[m].type)
      //              console.log(m + ' ' + bpromotions[m].type)
      //            }
      //          }
      //          newmerchList[i].bpromotions = r
      //        }
      this.total = newmerchList.length;
      return newmerchList;
    },
    showFilterBarFlag: function showFilterBarFlag() {
      var flag = true;
      var src = this.$route.name;
      if (src === 'home') {
        flag = false;
      }
      if (!this.showFilterBar) {
        flag = false;
      }
      return flag;
    },
    secPromotionRatio: function secPromotionRatio() {
      var ratio = String(100 - this.secInfo.seckilltRatio * 100);
      ratio = ratio[1] === '0' ? ratio[0] : ratio;
      return ratio;
    },
    merchListWithoutCustomized10: function merchListWithoutCustomized10() {
      if (this.merchList && this.merchList.length > 0) {
        return this.merchList.filter(function (product) {
          return product.categoryId !== 10;
        });
      }
      return [];
    }
  })
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  // 在 props 中声明获取父组件的数据通过 message 传过来
  props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/',
      total: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE']), {
    addCartListForRecom: function addCartListForRecom(pro) {
      this.ADD_CART_LIST(pro);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.toast('加入购物车成功！');
    },
    setdatas: function setdatas(pro) {
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      var _self = this;
      _self.MERCHDISEGROUP_UPDATE(pro.compositions);
      this.$router.push({ path: '/promotion/Compositions' });
    },
    openshaxuan: function openshaxuan() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.openPanel('#panel-right-demo');
    },
    getbpromotions: function getbpromotions(merchdise) {
      if (merchdise.bpromotions) {
        var bpromotions = merchdise.bpromotions;
        var r = [];
        var t = [];
        for (var m = 0; m < bpromotions.length; m++) {
          if (t.indexOf(bpromotions[m].type) === -1) {
            r.push(bpromotions[m]);
            t.push(bpromotions[m].type);
            // console.log(m + ' ' + bpromotions[m].type)
          }
        }
        return r;
      }
    },
    clickMerchandise: function clickMerchandise(pro) {
      var id = '';
      if (pro.categoryId === 20) {
        id = pro.findId;
      } else {
        id = pro.merchandiseId;
      }
      if (this.isFromSearch) {
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviours.searchresults.click = { 'time': Date.parse(new Date()), 'target': id, 'type': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].customerBehaviourType.clickMer };
      }
      if (this.proo) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { pro: this.proo } });
      } else if (this.channel) {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId }, params: { channel: this.channel } });
      } else {
        this.$router.push({ name: 'finderMerchandises', query: { id: id, categoryId: pro.categoryId } });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['queryTotal', 'sessionInfo']), {
    merchs: function merchs() {
      var newmerchList = [];
      if (!this.merchList) {
        return newmerchList;
      }
      newmerchList = this.merchList;
      //        for (var i = 0; i < newmerchList.length; i++) {
      //          var tags = []
      //          var merchandiseMeta = emkt.getEmktMetaData()
      //          var tagsmap = merchandiseMeta.tagsMap
      //          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
      //            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
      //          }
      //          newmerchList.tags = tags
      //          var bpromotions = newmerchList[i].bpromotions
      //          var r = []
      //          var t = []
      //          for (var m = 0; m < bpromotions.length; m++) {
      //            if (t.indexOf(bpromotions[m].type) === -1) {
      //              r.push(bpromotions[m])
      //              t.push(bpromotions[m].type)
      //              console.log(m + ' ' + bpromotions[m].type)
      //            }
      //          }
      //          newmerchList[i].bpromotions = r
      //        }
      this.total = newmerchList.length;
      return newmerchList;
    },
    showFilterBarFlag: function showFilterBarFlag() {
      var flag = true;
      var src = this.$route.name;
      if (src === 'home') {
        flag = false;
      }
      if (!this.showFilterBar) {
        flag = false;
      }
      return flag;
    }
  })
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import $ from 'jquery'
//  import emkt from '../../emkt'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    //      this.fetchdata()
  },
  created: function created() {
    //      this.fetchdata()
  },
  data: function data() {
    return {
      radioChecked: '', // default
      popupTrue: true,
      data: ''
    };
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['POPUP_TEXT_RESULT', 'UPDATE_CUST_REMARK', 'UPDATE_CUST_REMARK1']), {
    fetchdata: function fetchdata() {
      console.log(this.custRemark);
    },
    checkData: function checkData() {
      var _this = this;
      var router = _this.$router.history.current.path;
      var gData = _this.data;
      var geneInfo = {};
      var gene = {};
      gene = { 'data': gData };
      geneInfo[router] = gene;
      _this.POPUP_TEXT_RESULT(geneInfo);
      _this.popupTrue = true;
      console.log(geneInfo);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['remarkData', 'custRemark', 'custRemark1']))
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (this.emkt.getLocalStorage('EmktSearchHistory')) {
      this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory');
    }
    var self = this;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.popup .searchTr .searchBox').click(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).toggleClass('selected');

        self.selectedTags = [];
        var selectTags = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.popup .searchTr')[0].getElementsByClassName('selected');
        for (var i = 0; i < selectTags.length; i++) {
          self.selectedTags.push(selectTags[i].innerHTML);
        }
        if (this.queryName !== '') {
          self.response();
        }
      });
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.close-popup').click(function () {
        self.queryName = '';
      });
    });
    this.fetchData();
  },
  created: function created() {},
  data: function data() {
    return {
      showMatchData: false,
      searchHistory: [],
      hotWords: [],
      data: [],
      matchData: [],
      searchValue: '',
      queryName: '',
      tags: [],
      selectedTags: [],
      keywordMeanings: [],
      param: {},
      isRemoveSH: false
    };
  },

  watch: {
    'queryName': 'response'
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['ROUTER_STORE']), {
    fetchData: function fetchData() {
      var self = this;
      if (!this.emkt.getEmktMetaData()) {
        if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isDebug) {
          window.alert('EmktMetaData=' + this.emkt.getEmktMetaData());
        }
      }
      this.tags = this.emkt.getEmktMetaData().tags;
      this.keywordMeanings = this.emkt.getEmktMetaData().keywordMeanings;
      self.gcapi('getCustomerHotWords').then(function (response) {
        self.hotWords = response.body.result;
      });
      // console.log(`response: ${this.products}`)
      //        this.data = JSON.parse(window.localStorage.getItem('enterpriseList'))
    },
    searchTarget: function searchTarget(selectedItem, needCondition) {
      this.emkt.setStoreItem('isPopUpOpen', false);
      this.queryName = '';
      this.searchValue = selectedItem;
      var allSelectedTagIds = [];
      for (var h = 0; h < this.selectedTags.length; h++) {
        var item = this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]];
        item && allSelectedTagIds.push(item);
      }
      selectedItem.tagIds = allSelectedTagIds;
      this.getHistoryData();
      if (this.$route.query && needCondition) {
        if (this.$route.query.des) {
          selectedItem.promotionGuid = this.$route.query.id;
        } else {
          selectedItem.categoryId = this.$route.query.id;
        }
      }
      if (!needCondition) {
        selectedItem.promotionGuid = undefined;
        selectedItem.categoryId = undefined;
      }
      if (this.$route.query.filterName && this.$route.query.filterName === 'promotionGuid') {
        selectedItem.promotionGuid = this.$route.query.filterValue;
      }
      this.ROUTER_STORE(this.$route);
      if (this.$route.name === 'searchresults') {
        this.$router.replace({
          name: 'searchresults',
          query: { search: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedItem) }
        });
      } else {
        this.$router.push({
          name: 'searchresults',
          query: { search: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedItem) }
        });
      }
    },
    getHistoryData: function getHistoryData() {
      var _this = this;

      /**
       * 点击搜索结果进入下一页面时进行判断是否已经有一样的历史记录
       * 如果没有则新增，如果有则不做重复储存，判断完成后进入下一页
       */
      var searchHistory = this.emkt.getLocalStorage('EmktSearchHistory') === undefined ? [] : this.emkt.getLocalStorage('EmktSearchHistory');
      if (searchHistory) {
        var checkrepeat = false;
        searchHistory.forEach(function (item) {
          if (item.data.word === _this.searchValue.data.word) {
            checkrepeat = true;
          }
        });
        if (!checkrepeat) {
          if (searchHistory.length >= 5) {
            searchHistory.splice(0, 1);
          }
          searchHistory.push(this.searchValue);
        }
      } else if (this.searchValue && this.searchValue.data.word !== '') {
        if (searchHistory.length >= 5) {
          searchHistory.splice(0, 1);
        }
        searchHistory.push(this.searchValue);
      }
      this.emkt.setLocalStorage('EmktSearchHistory', searchHistory);
      this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory');
      this.isRemoveSH = false;
    },
    response: function response() {
      //        if (this.data === undefined) {
      //          return
      //        }
      //        var allKeyWords = this.data.keywords
      //        var meanings = this.data.meanings
      //
      //        this.matchData = []
      //        let promotionId
      //        let categoryId
      //        if (this.$route.query) {
      //          if (this.$route.query.des) {
      //            promotionId = this.$route.query.id
      //          } else {
      //            categoryId = this.$route.query.id
      //          }
      //        }
      //        let allSelectedTagIds = []
      //        for (let h = 0; h < this.selectedTags.length; h++) {
      //          allSelectedTagIds.push(this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]])
      //        }
      //
      //        let match = this.data.wordsToKeyWords[this.queryName.toLocaleLowerCase()]
      //        if (match) {
      //          let containsSameTag = true
      //          if (promotionId !== undefined && (match.promotionIds === undefined || $.inArray(promotionId, match.promotionIds) < 0)) {
      //            containsSameTag = false
      //          }
      //          if (categoryId !== undefined && (match.categoryIds === undefined || $.inArray(+categoryId, match.categoryIds) < 0)) {
      //            containsSameTag = false
      //          }
      //          for (let j = 0; j < allSelectedTagIds.length; j++) {
      //            if ($.inArray(allSelectedTagIds[j], match.tagIds) < 0) {
      //              containsSameTag = false
      //              break
      //            }
      //          }
      //          if (containsSameTag === true) {
      //            let tagNames = []
      //            for (let k = 0; k < match.meaningIds.length; k++) {
      //              tagNames.push(meanings[match.meaningIds[k]])
      //            }
      //            let item = {'data': match, 'tags': tagNames}
      //            this.matchData.push(item)
      //          }
      //        }
      //        for (let w = 0; w < allKeyWords.length; w++) {
      //          let word = allKeyWords[w].word
      //          let tagIds = allKeyWords[w].tagIds
      //          let meaningIds = allKeyWords[w].meaningIds
      //          let promotionIds = allKeyWords[w].promotionIds
      //          let categoryIds = allKeyWords[w].categoryIds
      //
      //          if (match && word.toLocaleLowerCase() === match.word.toLocaleLowerCase()) {
      //            continue
      //          }
      //          let containsSameTagId = true
      //          if (promotionId !== undefined && (promotionIds === undefined || $.inArray(promotionId, promotionIds) < 0)) {
      //            containsSameTagId = false
      //          }
      //          if (categoryId !== undefined && (categoryIds === undefined || $.inArray(+categoryId, categoryIds) < 0)) {
      //            containsSameTagId = false
      //          }
      //          for (let j = 0; j < allSelectedTagIds.length; j++) {
      //            if ($.inArray(allSelectedTagIds[j], tagIds) < 0) {
      //              containsSameTagId = false
      //              break
      //            }
      //          }
      //          if (containsSameTagId === true && word.toLowerCase().match(this.queryName.toLocaleLowerCase())) {
      //            let tagNames = []
      //            for (let k = 0; k < meaningIds.length; k++) {
      //              tagNames.push(meanings[meaningIds[k]])
      //            }
      //            if (this.matchData.length > 100) {
      //              break
      //            } else {
      //              let item = {'data': allKeyWords[w], 'tags': tagNames}
      //              this.matchData.push(item)
      //            }
      //          }
      //        }
      if (this.queryName === undefined || this.queryName === '') {
        this.showMatchData = false;
      } else {
        var promotionId = void 0;
        var categoryId = void 0;
        if (this.$route.query) {
          if (this.$route.query.des) {
            promotionId = this.$route.query.id;
          } else {
            categoryId = this.$route.query.id;
          }
        }
        var allSelectedTagIds = [];
        for (var h = 0; h < this.selectedTags.length; h++) {
          var item = this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]];
          item && allSelectedTagIds.push(item);
        }

        if (this.queryName !== '') {
          var param = {};
          param.keywordChosen = this.queryName;
          param.categoryId = categoryId;
          param.promotionId = promotionId;
          param.tagIds = allSelectedTagIds;
          this.param = param;
          __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].throttle(this.getQueryResult, 500, this);
        }
        this.showMatchData = true;
      }
    },

    getQueryResult: function getQueryResult() {
      // let self = this
      // this.matchData = []
      // this.gcapi('queryKeywords', this.param).then((res) => {
      //   let result = res.body.result
      //   if (result) {
      //     let match = result.keywords
      //     let meanings = this.keywordMeanings
      //     for (let i = 0; i < match.length; i++) {
      //       let tagNames = []
      //       for (let k = 0; k < match[i].meaningIds.length; k++) {
      //         tagNames.push(meanings[match[i].meaningIds[k]])
      //       }
      //       let item = {'data': match[i], 'tags': tagNames}
      //       self.matchData.push(item)
      //     }
      //   }
      // })
    },
    removeSearchHistory: function removeSearchHistory() {
      window.localStorage.removeItem('EmktSearchHistory');
      this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory');
      this.emkt.removeStoreItem('EmktSearchHistory');
      this.isRemoveSH = true;
    }
  }),
  computed: {
    // a computed getter
    hotWordList: function hotWordList() {
      var hotWordList = [];

      var meanings = this.keywordMeanings;
      this.hotWords.forEach(function (hotWord) {
        var names = [];
        hotWord.meaningIds.forEach(function (meaningId) {
          names.push(meanings[meaningId]);
        });
        hotWordList.push({ data: hotWord, tags: names });
      });
      return hotWordList;
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finder_components_NewMerchandiseListA__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finder_components_NewMerchandiseListA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__finder_components_NewMerchandiseListA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      recommendGoods: this.emkt.getLocalStorage('EmktAllRecommends'),
      allQueryData: [],
      description: '为你推荐',
      search: {},
      total: 0,
      categoryId: this.emkt.getLocalStorage('EmktCategoryID'),
      categoryIdToCount: {},
      num: 1
    };
  },

  created: function created() {
    if (this.categoryId === '-1') {
      this.categoryId = undefined;
    }
  },
  components: {
    merchdata: __WEBPACK_IMPORTED_MODULE_2__finder_components_NewMerchandiseListA___default.a
  },
  watch: {
    '$route': 'showQueryContent',
    'merchandiseQueryParams': function merchandiseQueryParams() {
      var _this2 = this;

      var _this = this;
      var params = this.merchandiseQueryParams;
      if (__WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].getLocalStorage('panelFilterFlag')) {
        this.gcapi('queryMerchandise', params).then(function (res) {
          if (res.body.code === 0) {
            _this.allQueryData = res.body.result.merchandiseList;
            _this.total = res.body.result.total;
            _this.categoryIdToCount = res.body.result.categoryIdToCount;
            var data = {};
            data['total'] = _this2.total;
            data['category'] = res.body.result.categoryIdToCount;
            _this2.QUERY_TOTAL(data);
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['merchandiseQueryParams', 'routerSrc', 'queryTotal', 'sessionInfo']), {
    showBarForKit: function showBarForKit() {
      // 支原体暂不显示筛选bar
      var flag = true;
      console.log(this.categoryId);
      if (this.categoryIdToCount[7]) {
        flag = false;
      }
      if (this.categoryId !== 9 && this.categoryId !== 5 && this.categoryId !== 8) {
        flag = false;
      }
      return flag;
    }
  }),
  mounted: function mounted() {
    this.showQueryContent();
    //      var self = this
    //      setTimeout(() => {
    //        $(function () {
    //          $('.page1 .searchTr .searchBox').click(function () {
    //            $(this).toggleClass('selected')
    //
    //            self.selectedTags = []
    //            let selectTags = $('.page1 .searchTr')[0].getElementsByClassName('selected')
    //            for (let i = 0; i < selectTags.length; i++) {
    //              self.selectedTags.push(selectTags[i].innerHTML)
    //            }
    //
    //            self.searchResult()
    //          })
    //        })
    //      }, 3500)
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['QUERY_TOTAL']), {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    searchResult: function searchResult() {
      var _this3 = this;

      //        let tagNames = $('.page1 .searchTr')[0].getElementsByClassName('selected')
      //        let tagIds = []
      //        for (let i = 0; i < tagNames.length; i++) {
      //          tagIds.push(this.emkt.getEmktMetaData().tagNamesMap[tagNames[i].innerHTML])
      //        }

      var merchandiseQueryParam = {};
      merchandiseQueryParam.keywordChosen = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#searchGoods').val();
      merchandiseQueryParam.tagIds = this.search.tagIds;
      merchandiseQueryParam.fromIndex = 0;
      merchandiseQueryParam.promotionGuid = this.search.promotionGuid;
      if (this.categoryId) {
        merchandiseQueryParam.categoryId = this.categoryId;
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.showPreloader('正在查询结果,请稍等');
      this.gcapi('queryMerchandise', merchandiseQueryParam).then(function (response) {
        _this3.allQueryData = response.body.result.merchandiseList;
        _this3.total = response.body.result.total;
        _this3.categoryIdToCount = response.body.result.categoryIdToCount;
        var data = {};
        data['total'] = _this3.total;
        if (_this3.total === 0) {
          _this3.num = 0;
        }
        data['category'] = response.body.result.categoryIdToCount;
        _this3.QUERY_TOTAL(data);
      }).then(__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.hidePreloader());
    },
    showQueryContent: function showQueryContent() {
      //        var names = []
      this.search = JSON.parse(this.$route.query.search);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#searchGoods').val(this.search.data.word);
      //        var tagIds = this.search.data.tagIds
      //        for (let i = 0; i < tagIds.length; i++) {
      //          names.push(this.emkt.getEmktMetaData().tagIdsMap[tagIds[i]])
      //        }
      //
      //        var $box = $('.page1 .searchBox')
      //        for (let i = 0; i < $box.length; i++) {
      //          if (names.indexOf($box[i].innerHTML) >= 0) {
      //            $($box[i]).addClass('selected')
      //          }
      //        }
      this.searchResult();
    },
    toCust: function toCust() {
      this.$router.push({ name: 'custOrder' });
    },
    loadmore: function loadmore() {
      var _this4 = this;

      var fromIndex = this.allQueryData.length;
      if (fromIndex >= this.total) {
        //          $('#button').remove()
        //          $('#over').append('去定制')
        return;
      } else {
        var addlist = [];
        var merchandiseQueryParam = {};
        merchandiseQueryParam.keywordChosen = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#searchGoods').val();
        merchandiseQueryParam.tagIds = this.search.tagIds;
        merchandiseQueryParam.fromIndex = fromIndex;
        merchandiseQueryParam.promotionGuid = this.search.promotionGuid;
        merchandiseQueryParam.categoryId = this.categoryId;
        this.gcapi('queryMerchandise', merchandiseQueryParam).then(function (response) {
          addlist = response.body.result.merchandiseList;
          for (var i = 0; i < addlist.length; i++) {
            _this4.allQueryData.push(addlist[i]);
          }
          var data = {};
          data['total'] = _this4.total;
          data['category'] = response.body.result.categoryIdToCount;
          _this4.QUERY_TOTAL(data);
        });
      }
    }
  })
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    //      this.fetchdata()
  },
  created: function created() {
    //      this.fetchdata()
  },
  data: function data() {
    return {
      showMore: false,
      rat: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].Rat,
      mouse: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].Mouse,
      human: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].Human,
      others: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].others,
      Gallus_gallus: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].Gallusgallus,
      thale_cress: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].thalecress,
      rice: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].rice,
      zebrafish: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].zebrafish,
      fruit_fly: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].fruitfly,
      pig: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].pig,
      sheep: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].sheep,
      rabbit: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].rabbit,
      domestic_silkworm: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].domesticsilkworm,
      African_clawed_frog: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].Africanclawedfrog,
      yeast: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].yeast,
      radioChecked: '', // default
      queryRes: [],
      matchNMIDFirst: '',
      //        isClickMore: false,
      showMatchData: false,
      geneData: '',
      matchData: [],
      queryName: '',
      popupTrue: true,
      mateData: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getEmktMetaData().dictionariesMap[61031],
      close: true
    };
  },

  watch: {
    'queryName': 'getQueryResult',
    'finderSearchText': function finderSearchText(val) {
      this.queryName = val;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['GENE_SEARCH_RESULT', 'FINDER_SEARCH_TEXT', 'HARD_GENE_INFO']), {
    clickRadio: function clickRadio(tar) {
      if (tar.target.defaultValue !== '9606' && tar.target.defaultValue !== '10116' && tar.target.defaultValue !== '10090') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#allothers').css('background-color', '#0261b5');
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#allothers').css('background-color', '#DDDDDD');
      }
      this.radioChecked = tar.target.defaultValue;
      if (this.queryName !== '') {
        console.log(this);
        __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].throttle(this.getQueryResult, 250, this);
      }
    },
    fetchdata: function fetchdata() {
      console.log(this.geneSearchResult['/finder/finderMerchandises'].data);
    },
    openwuzhong: function openwuzhong() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.openPanel('#panel-left-demo');
    },
    getQueryResult: function getQueryResult() {
      // if (this.queryName === '' || this.queryName === undefined || this.radioChecked === '') {
      //   this.showMatchData = false
      //   return
      // }
      // let _this = this
      // let param = {
      //   'taxId': this.radioChecked,
      //   'entered': this.queryName
      // }
      // this.gcapi('queryGene', param).then((res) => {
      //   res.body.result.forEach(item => {
      //     item.open = false
      //   })
      //   this.queryRes = res.body.result
      //   this.showMatchData = true
      // })
    },
    searchTarget: function searchTarget(selectedItem, index) {
      console.log(selectedItem, index);
      var geneGuid = void 0;
      if (selectedItem.genes) {
        geneGuid = selectedItem.genes[0].geneGuid;
      } else {
        geneGuid = selectedItem.geneGuid;
      }
      this.close = true;
      var _this = this;
      this.gcapi('getGeneByGUID', geneGuid).then(function (res) {
        _this.geneData = res.body.result;
        var router = _this.$router.history.current.path;
        var gData = _this.geneData;
        var geneInfo = {};
        var gene = void 0;
        gene = { 'data': gData };
        geneInfo[router] = gene;
        var param = {
          geneID: gData.geneID, nM_ID: gData.NMID
        };
        console.log(param);
        _this.gcapi('getHardGeneDescriptions', param).then(function (res) {
          _this.FINDER_SEARCH_TEXT('');
          _this.FINDER_SEARCH_TEXT(gData.symbol);
          _this.GENE_SEARCH_RESULT(geneInfo);
          if (res.body.result) {
            _this.HARD_GENE_INFO(res.body.result);
          } else {
            _this.HARD_GENE_INFO([]);
          }
        });
      });
      //        this.searchValue = selectedItem
      //        this.getHistoryData()
      //        if (this.$route.query) {
      //          selectedItem.promotionGuid = this.$route.query.id
      //        }
      //        this.$router.push({
      //          name: 'searchresults',
      //          query: {search: JSON.stringify(selectedItem)}
      //        })
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['geneSearchResult', 'finderSearchText']))
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.removeChoose();
    var enterprise = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.popup-invoiceTitle');
    enterprise.on('open', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setStoreItem('invoiceTitlePopupFlag', true);
      console.log('popup is opening');
    });
    enterprise.on('closed', function () {
      __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].setStoreItem('invoiceTitlePopupFlag', false);
      console.log('popup closed');
    });
  },
  created: function created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  data: function data() {
    return {
      query: '',
      data: {},
      filteredData: {},
      showChoosePayEnterprise: false,
      enterpriseList: [],
      InvoiceTitleMap: null,
      payEnterpriseChooseList: []
    };
  },

  watch: {
    // listening to input
    'query': function query(_query) {
      console.log('in query');
      var _this = this;
      _this.initialize();
      var data = _this.data;
      var filteredData = _this.filteredData;
      for (var i = 0; i < data.length; i++) {
        if (data[i]['enterpriseInvoiceTitle'].match(_query.toLowerCase())) {
          var item = {
            'enterpriseInvoiceTitle': data[i].enterpriseInvoiceTitle
          };
          filteredData.push(item);
          // console.log(_this.filteredData)
          if (filteredData.length > 19) {
            break;
          }
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['INVOICETITLE_INFO_UPDATE']), {
    fetchData: function fetchData() {
      // fetching data from localstorage
      this.data = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktEnterpriseInvoiceTitleList');
      this.InvoiceTitleMap = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelInvoiceTitleMap');
      console.log('EMKT.getLocalStorage(\'EmktFirstLevelEnterpriseList\')', __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktEnterpriseInvoiceTitleList'));
    },
    initialize: function initialize() {
      this.filteredData = [];
    },
    removeChoose: function removeChoose() {
      this.INVOICETITLE_INFO_UPDATE('');
    },
    valueConvey: function valueConvey(company, index) {
      var _this = this;
      var enterprise = this.InvoiceTitleMap[company.enterpriseInvoiceTitle];
      _this.enterpriseList = this.InvoiceTitleMap[company.enterpriseInvoiceTitle].enterpriseList;
      if (_this.enterpriseList !== undefined && _this.enterpriseList.length > 1) {
        _this.showChoosePayEnterprise = true;
      } else {
        var choice = {
          'enterpriseInvoiceTitle': _this.filteredData[index].enterpriseInvoiceTitle,
          'enterpriseNo': enterprise.enterpriseList[0].enterpriseNo
        };
        _this.INVOICETITLE_INFO_UPDATE(choice);
        _this.query = '';
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal('.popup-invoice-title');
      }
    },
    valueConvey2: function valueConvey2() {
      var _this = this;
      var choice = {
        'enterpriseInvoiceTitle': _this.query,
        'enterpriseNo': ''
      };
      _this.INVOICETITLE_INFO_UPDATE(choice);
    },
    cancel: function cancel() {
      this.showChoosePayEnterprise = false;
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal('.popup-invoice-title');
    },
    choosePayEnterprise: function choosePayEnterprise(data) {
      var choice = {
        'enterpriseInvoiceTitle': data.enterpriseInvoiceTitle,
        'enterpriseNo': data.enterpriseNo
      };
      this.INVOICETITLE_INFO_UPDATE(choice);
      this.query = '';
      this.showChoosePayEnterprise = false;
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.closeModal('.popup-invoice-title');
    }
  })
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_v_2_6_PrivateMixins_ProgressMixin_js__ = __webpack_require__(255);
//
//
//
//
//
//
//
//
//

// import EMKT from '../../../emkt.js'

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__views_v_2_6_PrivateMixins_ProgressMixin_js__["a" /* serviceProgressMixIn */]],
  props: {
    contractNo: String,
    status: String
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_serviceProgressRefactor_components_ExperimentHeader_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_serviceProgressRefactor_components_ExperimentHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_serviceProgressRefactor_components_ExperimentHeader_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import BaseHeader from '@/views_v_2.6/components/BaseHeader'

// import emkt from '../../../emkt.js'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      headerName: '实验详情',
      contractNo: '',
      status: 1,
      taskModules: []
    };
  },

  components: {
    // BaseHeader,
    ExperimentHeader: __WEBPACK_IMPORTED_MODULE_2__views_serviceProgressRefactor_components_ExperimentHeader_vue___default.a
  },
  created: function created() {
    var _$route$params = this.$route.params,
        contractNo = _$route$params.contractNo,
        status = _$route$params.status,
        taskModules = _$route$params.taskModules;

    this.contractNo = contractNo;
    this.status = status;
    this.taskModules = taskModules;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isWapp'])),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_common_css__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_serviceProgressRefactor_components_ExperimentHeader_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_serviceProgressRefactor_components_ExperimentHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_serviceProgressRefactor_components_ExperimentHeader_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import BaseHeader from '@/views_v_2.6/components/BaseHeader'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      headerName: '历史详情',
      contractProgressInfo: null
    };
  },

  components: {
    // BaseHeader,
    ExperimentHeader: __WEBPACK_IMPORTED_MODULE_3__views_serviceProgressRefactor_components_ExperimentHeader_vue___default.a
  },
  created: function created() {
    this.contractProgressInfo = this.$route.params;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([
  // 'progressInfo'
  'isWapp'])),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_v_2_6_PrivateMixins_ProgressMixin_js__ = __webpack_require__(255);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__views_v_2_6_PrivateMixins_ProgressMixin_js__["a" /* serviceProgressMixIn */]],
  data: function data() {
    return {};
  },

  props: {
    contractProgressInfo: Object,
    aberrationType: Number
  },
  methods: {
    handleToExtension: function handleToExtension() {
      this.contractProgressInfo.show = !this.contractProgressInfo.show;
    },
    getFontStyle: function getFontStyle(_ref) {
      var experimentModules = _ref.experimentModules;

      var exceptionList = experimentModules.filter(function (item) {
        return item.isException;
      });
      if (exceptionList.length > 0) {
        return {
          color: 'red'
        };
      } else {
        return {};
      }
    },
    getExceptionName: function getExceptionName() {
      console.log(this.aberrationType);
      return this.aberrationType ? __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].ADBERRATION_STATUS[this.aberrationType] : '';
    },
    handleToHistoryProgress: function handleToHistoryProgress(contractProgressInfo) {
      this.$router.push({
        name: 'HistoryProgressDetail',
        params: contractProgressInfo
      });
    },
    handleToExperimentDetail: function handleToExperimentDetail(taskModules) {
      var _contractProgressInfo = this.contractProgressInfo,
          contractNo = _contractProgressInfo.contractNo,
          status = _contractProgressInfo.status;

      this.$router.push({
        name: 'ExperimentDetail',
        params: {
          contractNo: contractNo,
          status: status,
          taskModules: taskModules
        }
      });
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_serviceProgressRefactor_serviceProgress_ContractProgressInfo_vue__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_serviceProgressRefactor_serviceProgress_ContractProgressInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_serviceProgressRefactor_serviceProgress_ContractProgressInfo_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import {SFprogressInfos} from './data.js'

// import BaseHeader from '@/views_v_2.6/components/BaseHeader.vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      headerName: '进展详情',
      SCProgressInfo: null
    };
  },

  components: {
    ContractProgressInfo: __WEBPACK_IMPORTED_MODULE_4__views_serviceProgressRefactor_serviceProgress_ContractProgressInfo_vue___default.a
    // BaseHeader
  },
  created: function created() {
    var _this = this;

    var progressInfos = this.$route.query.SCProgressInfo;
    if (progressInfos) {
      progressInfos = JSON.parse(progressInfos);
      this.SCProgressInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, progressInfos, {
        contractProgressInfoList: progressInfos.contractProgressInfoList.map(function (contractProgressInfo) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contractProgressInfo, {
            show: true,
            experimentModules: contractProgressInfo.experimentModules.map(function (experiment) {
              var _getExperimentOtherIn = _this.getExperimentOtherInfo(experiment.taskModules),
                  isException = _getExperimentOtherIn.isException,
                  completedPercent = _getExperimentOtherIn.completedPercent;

              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, experiment, { isException: isException, completedPercent: completedPercent });
            })
          });
        })
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isWapp']), {
    showaberrationType: function showaberrationType() {
      return this.SCProgressInfo.aberrationType;
    }
  }),
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getaberration: function getaberration(aberrationType) {
      return !aberrationType ? '' : __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].ADBERRATION_MESSAGE[aberrationType];
    },
    handleCopy: function handleCopy() {
      var _this2 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#tag-copy');
      clipboard.on('success', function () {
        _this2.$weui.toast('复制成功', 1500);
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function () {
        _this2.$weui.topTips('该浏览器不支持自动复制');
        clipboard.destroy();
      });
    },
    getExperimentOtherInfo: function getExperimentOtherInfo(taskModules) {
      var isException = false;
      var completedTasks = [];
      taskModules.forEach(function (task) {
        if (task.publishComments.length > 0) {
          isException = true;
        }
        if (task.currentStatus === __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].EXPERIMENT_MODULES_STATUS_ENDING || task.currentStatus === __WEBPACK_IMPORTED_MODULE_3__emkt_js__["a" /* default */].EXPERIMENT_MODULES_STATUS_NAME__END_STOP) {
          completedTasks.push(task);
        }
      });
      var completedPercent = taskModules.length > 0 ? (completedTasks.length / taskModules.length * 100).toFixed(0) : 0;
      return { isException: isException, completedPercent: completedPercent };
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__multiplex_StaticDoc__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__multiplex_StaticDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__multiplex_StaticDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__ = __webpack_require__(136);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






var RETURN_MATERIAL_EU_NO = 'EU000273';
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StaticDoc: __WEBPACK_IMPORTED_MODULE_9__multiplex_StaticDoc___default.a },
  data: function data() {
    return {
      result: null,
      detail: false,
      comeForm: false,
      showErr: false,
      text: '',
      puIdInit: -100,
      DiaEuTemplateNo: ['EU000331', 'EU000269', 'EU000334'],
      serviceUrl: "/emktResources/resocurces/img/merchandise/service.png",
      oldCartContent: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}),
      shoppingCartProductNumber: null,
      stepNo: 0,
      currEu: '',
      currSku: {},
      // product理应从路由中取得产品名称。
      // TMT, 4D 可出现样本处理，其它不出现，sampleCategory.currSampleCategory不是‘体液样本’时，不出现样本处理
      // 只有DIA 2.0存在建库技术，若样本为体液类样本，DIA6级建库不可选， TODO 选择无需建库时，生信分析选项（4号位置）变为DeepDIA
      // shotgun时，step+2
      // 为PRM时，只有基因选择
      // 模拟样本处理（sampleProcessing），建库技术（databaseBuildings），生信分析（boSignalAnalysis）的选中值
      sampleProcessing: {},
      databaseBuildings: {},
      boSignalAnalysis: {},
      // 基因选择是一个数组类型
      geneSelectionGroup: [],
      // 实验组
      experimentalGroup: [{ label: '实验组1', number: 3 }, { label: '对照组2', number: 3 }],
      experimentalName: "",
      experimentalTotalNum: 0,
      // 对照组(control)和实验组(experimental)，数据结构： [{'experimental':{}, 'control':{}},{'experimental':{}, 'control':{}}...]
      controlGroup: [],
      controlName: "",
      sampleSpecItemChecked: [],
      sampleSpec: "" /* 样本物种 */
      , showOtherSampleSpecInput: false,
      otherSampleSpecName: "",
      infectionChecked: false,
      diseaseDirectionId: "",
      diseaseDirectionName: "",
      diseaseDirectionOpts: [],
      showDiseaseDirectionPicker: false,
      currSampleCategory: "",
      // 下面sampleCategory定义了三个属性，label为显示值（String），其它两个各自对应选择选项。
      sampleCategory: {},
      sampleType: "",
      showSampleCategory: false,
      sampleSpecOptArr: [{ engName: "Mouse", chnName: "小鼠" }, { engName: "Rat", chnName: "大鼠" }, { engName: "Human", chnName: "人类" }, { engName: "其他", chnName: "其他" }],
      sampleCategoryOptArr: [],
      sampleSubCategoryOptArr: [],
      sampleCategoryItemChecked: [],
      subCategoryChecked: [],
      showCal: false,
      deliveryTime: "",
      returnMaterialChecked: false,
      //   技术分类(TechCategory):71001
      //   产品分类(ProductCategory):71002
      //   TechCategory: [],
      //   ProductCategory: [],
      // 样本参数-是否返还(ParaReturnMaterial):71003
      // 参数选择-是否去高丰度蛋白(ParaRemoveHAProtein):71004
      // 参数选择-建库技术(ParaConstructionTech):71005
      // 参数选择-生信分析(ParaBioAnalysis):71006
      sampleProcessTech: {
        ParaReturnMaterial: [],
        ParaRemoveHAProtein: [],
        ParaConstructionTech: [],
        ParaBioAnalysis: []
      },
      showProcessTech: [],
      constructionTechEnable: [true, true, true], //建库技术选项启用标志
      validateFlag: false,
      bizValidateMsg: '',
      // 方案信息
      boSolution: {
        children: [{}]
      },
      priceSolution: {},
      serviceWorkDaysSolution: {},
      solutionId: '',
      currTaxId: '10090',
      formalQuotePrice: '',
      standardPrice: '',
      materialReceive: {
        receiveType: 2,
        isReceived: 0,
        notReceivedType: 1,
        returnType: 2,
        expectArrivalDT: '',
        quoteItemNos: []
      },
      euTemplates: [],
      puTemplates: [],
      proteomicsSku: [],
      specPuTemplates: [],
      eus: [],
      eu1: {},
      eu2: {},
      pus1: [],
      pus2: [],
      groups: [],
      productInfo: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}),
      promotion: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({})
    };
  },
  created: function created() {
    this.getMeteData();
    this.initNormalFormData();
    if (this.$route.query.detail) {
      this.stepNo = 2;
      this.detail = true;
    }
  },
  updated: function updated() {
    var number = 0;
    this.experimentalGroup.forEach(function (item) {
      number += item.number;
    });
    this.experimentalTotalNum = number;
    if (this.currEu === 'EU000048' && this.currEu === 'EU000046') {
      this.controlGroup = [];
    }
    this.shoppingCartProductNumber = this.getNumberFromCart();
  },

  /**
   * @author AnyaParry
   * @description 在watch中的代码监控选择的基因，这个对象存在于store中。
   * 如需修改请找AnyaParry
   *
   */
  watch: {
    geneSearchResult: function geneSearchResult(val) {
      var data = val["/Weapp/BoSolution"].data;
      var dictionary = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      data["taxName"] = dictionary[61033][data.taxId].dictValue;
      data["label"] = data["taxName"] + " / " + data["symbol"] + " / " + data["NMID"];
      this.geneSelectionGroup.push(data);
      console.log(data, '基因选择数据');
      this.handleChangeGene();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var comeFrom = this.$route.query.comeFrom;
    if (comeFrom === 'cart') {
      this.comeForm = true;
      this.text = "保存修改";
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["d" /* getSolutionInfoByCartItemId */])(this.customerNo, this.$route.query.itemId).then(function (res) {
        console.log(res, 'ressss');
        var result = res;
        _this.result = res;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(that, 'initOrderBasicData', [result]).then(function (res) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(that, 'fetchSkuList', [result]).then(function (res) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(that, 'initOrderGroupData', [result]).then(function (res) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(that, 'initSampleCategory', [result]).then(function (res) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_this, 'initOtherParamData', [result]);
              });
            });
          });
        });
        _this.shoppingCartProductNumber = _this.getNumberFromCart();
      });
    } else if (comeFrom === 'order') {
      this.comeForm = true;
      this.text = '加入购物车';
      var _that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["b" /* getSolutionInfoByOrderId */])(this.$route.query.orderId, this.$route.query.euId).then(function (res) {
        console.log(res, 'ressss');
        var result = res;
        _this.result = res;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_that, 'initOrderBasicData', [result]).then(function (res) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_that, 'fetchSkuList', [result]).then(function (res) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_that, 'initOrderGroupData', [result]).then(function (res) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_that, 'initSampleCategory', [result]).then(function (res) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["e" /* makeSureAsync */])(_this, 'initOtherParamData', [result]);
              });
            });
          });
        });
        _this.shoppingCartProductNumber = _this.getNumberFromCart();
      });
    } else {
      this.comeForm = false;
      this.text = '加入购物车';
      if (this.$route.query.templateNo) {
        this.currEu = this.$route.query.templateNo;
      }
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])().includes(this.currEu)) {
        this.controlGroup.push({ 'experimental': this.experimentalGroup[0], 'control': this.experimentalGroup[1] });
      }
      this.fetchSkuList();
      this.shoppingCartProductNumber = this.getNumberFromCart();
      this.setUserInputData();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    /**
     * 该方法还原用户上次输入的内容
     */
    setUserInputData: function setUserInputData() {
      this.pickSampleSpec(undefined, true);
      this.getSampleArrIndex();
      this.onConfirmDiseaseDirection();
      this.handleChangeSampleType(true);
      // this.onConfirmDeliveryTime(undefined, true)
    },
    validateControlGroup: function validateControlGroup() {
      var _this2 = this;

      var that = this;
      if (this.controlGroup.length > 0) {
        this.controlGroup.forEach(function (item) {
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.control) === '{}' || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.experimental) === '{}') {
            _this2.$weui.dialog({
              title: '生信分析对照组设置错误!',
              content: '请仔细检查生信分析对照组，确保您设置了所有的实验组和对照组！',
              buttons: [{
                label: '返回修改',
                type: 'primary',
                onClick: function onClick() {
                  if (that.stepNo === 1) {
                    that.stepNo = that.stepNo - 1;
                    that.$forceUpdate();
                  }
                }
              }]
            });
            _this2.validateFlag = false;
            return false;
          } else {
            return _this2.validateFlag = true;
          }
        });
      }
    },
    reSetPageScroll: function reSetPageScroll() {
      console.log('ssssssssssssssssssssss');
      this.$nextTick(function () {
        window.scrollTo(0, 0);
        document.body.scrollTo(0, 0);
      });
    },

    specialEuTemplateNo: __WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */],
    /**
     * 依据只能推荐的参数自动选择样本分类
     * @return indexArr[indexF, indexS] 选择的序号
     */
    getSampleArrIndex: function getSampleArrIndex() {
      if (localStorage.getItem('sample') !== null && localStorage.getItem('sample') !== undefined) {
        var object = JSON.parse(localStorage.getItem('sample'));
        var indexArr = [];
        this.sampleCategoryOptArr.forEach(function (item, index) {
          if (item.dictKey === object.currentCategory.dictKey) {
            indexArr.push(index);
          }
        });
        this.sampleSubCategoryOptArr.forEach(function (item, index) {
          if (item.dictKey === object.currentSubCategory.dictKey) {
            indexArr.push(index);
          }
        });
        this.pickSampleCategory(indexArr[0]);
        this.pickSubCategory(indexArr[1]);
        localStorage.removeItem('sample');
      }
    },

    /**
     * 获取购物车数量
     */
    getNumberFromCart: function getNumberFromCart() {
      var number = 0;
      for (var key in this.cartList.cartContent) {
        if (this.cartList.cartContent[key].productQuantity) {
          number = number + this.cartList.cartContent[key].productQuantity;
        } else {
          number = number + 1;
        }
      }
      return number;
    },

    /**
     * @description 验证疾病方向输入
     */
    validateDiseaseDirection: function validateDiseaseDirection() {
      if (this.diseaseDirectionName === '') {
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true; // 第一个验证的表单元素
        return true;
      }
    },
    validateOtherSampleSpecName: function validateOtherSampleSpecName() {
      if (this.currTaxId === '10117' && this.otherSampleSpecName === '') {
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true && this.validateFlag;
        return true;
      }
    },

    /**
     * @description 验证样本分类输入
     */
    validateSampleCategory: function validateSampleCategory() {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.sampleCategory) === '{}') {
        this.validateFlag = false;
        return false;
      } else {
        if (this.showErr) {
          this.validateFlag = false;
          this.bizValidateMsg = '注意：' + this.sampleCategory.label + '无法进行' + this.eu1.name + '实验';
          return false;
        } else {
          this.validateFlag = true && this.validateFlag;
          this.bizValidateMsg = '';
          return true;
        }
      }
    },

    /**
     * @description 验证样本类型输入
     */
    validateSampleType: function validateSampleType() {
      if (this.sampleType === '') {
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true && this.validateFlag;
        return true;
      }
    },

    /**
     * @description 验证到达时间
     */
    validateDeliveryTime: function validateDeliveryTime() {
      if (this.deliveryTime === '') {
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true && this.validateFlag;
        return true;
      }
    },

    /**
     * @description 验证物种是否输入
     */
    validateSampleSpec: function validateSampleSpec() {
      if (this.sampleSpec === '') {
        this.bizValidateMsg = '请选择物种';
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true && this.validateFlag;
        if (this.validateFlag) {
          this.bizValidateMsg = '';
        }
        return true;
      }
    },

    /**
     * @description 验证样本数量
     */
    validateSampleNum: function validateSampleNum() {
      var number = 0;

      this.experimentalGroup.forEach(function (item) {
        number += item.number;
      });
      if (number < this.currSku.minSampleQuantity) {
        this.$weui.dialog({
          title: '样本数量超低于实验下限!',
          content: '为了保证实验的有效性，' + this.eu1.name + '样本数量最低为' + this.currSku.minSampleQuantity + '个',
          buttons: [{
            label: '返回修改',
            type: 'primary'
          }]
        });
        this.validateFlag = false;
        return false;
      } else if (number > this.currSku.maxSampleQuantity) {
        this.$weui.dialog({
          title: '样本数量超过实验上限!',
          content: '为了保证实验的有效性，' + this.eu1.name + '样本数量最大为' + this.currSku.maxSampleQuantity + '个',
          buttons: [{
            label: '返回修改',
            type: 'primary'
          }]
        });
        this.validateFlag = false;
        return false;
      } else if (number < 3 && this.currEu !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])(0)) {
        this.$weui.dialog({
          title: '样本数量过小!',
          content: '建议重复数大于等于3，否则会造成数据定量准确 性受损，从而影响文章发表',
          buttons: [{
            label: '我再想想',
            type: 'default'
          }, {
            label: '立即更改',
            type: 'primary'
          }]
        });
        this.validateFlag = false;
        return false;
      } else if (number < 1 && this.currEu === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])(0)) {
        this.$weui.dialog({
          title: '样本数量过小!',
          content: '最少需要一个样本',
          buttons: [{
            label: '立即更改',
            type: 'primary'
          }]
        });
        this.validateFlag = false;
        return false;
      } else {
        this.validateFlag = true;
        return true;
      }
    },

    /**
     * 下一步操作
     */
    nextStep: function nextStep() {
      var _this3 = this;

      if (this.stepNo === 0) {
        new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          _this3.validateControlGroup();
          _this3.$refs.diseaseDirectionField.focus();
          _this3.$refs.diseaseDirectionField.blur();
          _this3.$refs.sampleCategoryField.focus();
          _this3.$refs.sampleCategoryField.blur();
          _this3.$refs.sampleTypeField.focus();
          _this3.$refs.sampleTypeField.blur();
          __WEBPACK_IMPORTED_MODULE_10_vant__["b" /* Toast */].loading();
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_10_vant__["b" /* Toast */].clear();
            resolve(_this3.validateFlag);
          }, 200);
        }).then(function (formValidate) {
          new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            if (formValidate) {
              resolve(_this3.validateSampleNum() && _this3.validateSampleSpec());
            } else {
              resolve(false);
            }
          }).then(function (bizValidate) {
            if (bizValidate) {
              if (_this3.stepNo < 2) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])(0).includes(_this3.currEu)) {
                  _this3.stepNo = _this3.stepNo + 2;
                  _this3.showProcessTech = [false, false, false];
                } else {
                  _this3.stepNo = _this3.stepNo + 1;
                }
              }
            }
          });
        });
      } else {
        this.stepNo = this.stepNo + 1;
      }
    },

    /**
     * 返回按钮操作
     */
    goBack: function goBack() {
      if (this.stepNo > 0) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])().includes(this.currEu)) {
          this.stepNo = this.stepNo - 2;
        } else {
          this.stepNo = this.stepNo - 1;
        }
      } else {
        if (this.comeFrom) {
          __WEBPACK_IMPORTED_MODULE_6_wx___default.a.miniProgram.switchTab({
            url: "/pages/cart/cart"
          });
        } else {
          this.$router.back();
        }
      }
    },

    /**
     * 初始化选择按钮
     */
    initRadioTag: function initRadioTag() {
      // 初始化样本物种选项的选择状态
      for (var i = 0; i < 4; i++) {
        this.$set(this.sampleSpecItemChecked, i, false);
      }
      // 初始化样本类型选项的选择状态
      for (var _i = 0; _i < this.sampleCategoryOptArr.length; _i++) {
        this.$set(this.sampleCategoryItemChecked, _i, false);
      }
      // 初始化样本子类型选项的选择状态
      for (var _i2 = 0; _i2 < this.sampleSubCategoryOptArr.length; _i2++) {
        this.$set(this.subCategoryChecked, _i2, false);
      }
    },

    /**
     * 获取SKU列表
     */
    fetchSkuList: function fetchSkuList() {
      var _this4 = this;

      console.log('数据已还原', this.currEu);
      console.log('vvvvvvvvvvvvvvvvvvvvvvvv');
      this.$weui.loading('加载中');
      var that = this;
      var returnValue = void 0;
      this.gcapi('getProteomicsBasicData', '').then(function (res) {
        if (res.data.code === 0) {
          that.euTemplates = JSON.parse(res.data.result.euTemplates);
          that.eus = [];
          console.log(that.currEu, _this4.currEu, 'sidjuo');
          _this4.currEu = _this4.currEu ? _this4.currEu : that.$route.query.templateNo;
          that.puTemplates = JSON.parse(res.data.result.puTemplates);
          that.proteomicsSku = res.data.result.proteomicsSku.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          });
          that.specPuTemplates = JSON.parse(res.data.result.specPuTemplates);
          var sku = void 0;
          sku = that.proteomicsSku.filter(function (v) {
            return v.eu1 === _this4.currEu;
          }).filter(function (v) {
            return v.valid === 1;
          }).filter(function (v) {
            return v.sampleCategory === -1;
          }).filter(function (v) {
            return v.paraReturnMaterial === _this4.returnMaterialChecked ? 1 : 0;
          })[0];
          console.log(sku, 'su', that.proteomicsSku, _this4.returnMaterialChecked ? 1 : 0);
          _this4.currSku = sku;
          console.log('Default Sku:', that.currSku);
          if (_this4.currEu === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["f" /* paraffinEuTemplateNo */])()) {
            _this4.pickSampleCategory(0);
            _this4.pickSubCategory(0);
          }
          returnValue = that.getBoSolutionBasicInfo();
        }
        _this4.$weui.loading('加载中').hide();
      });
      return returnValue;
    },

    /**
     * 样本物种选择
     * @param index
     */
    pickSampleSpec: function pickSampleSpec(index, enable) {
      if (localStorage.getItem('sampleSpec') && enable) {
        index = parseInt(localStorage.getItem('sampleSpec'));
      }
      localStorage.removeItem('sampleSpec');
      if (index !== null && index !== undefined) {
        localStorage.setItem('sampleSpec', index);
        for (var i = 0; i < 4; i++) {
          if (i === index) {
            this.sampleSpecItemChecked[index] = !this.sampleSpecItemChecked[index];
            if (this.sampleSpec === this.sampleSpecOptArr[index].chnName) {
              this.sampleSpec = '';
              this.eu1.taxId = '';
            } else {
              this.sampleSpec = this.sampleSpecOptArr[index].chnName;
              var taxMap = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getEmktMetaData().dictionariesMap[61033];
              for (var key in taxMap) {
                if (taxMap[key].dictValue === this.sampleSpecOptArr[index].engName) {
                  this.currTaxId = key;
                  this.eu1.taxId = this.currTaxId;
                  this.boSolution.children[0].taxId = this.currTaxId;
                  break;
                }
              }
            }
            this.bizValidateMsg = '';
          } else {
            this.$set(this.sampleSpecItemChecked, i, false);
          }
        }
        console.log(index === 3);
        console.log('执行4');
        this.showOtherSampleSpecInput = index === 3;
        if (this.showOtherSampleSpecInput) {
          this.handleOtherSpecNameChanged();
        }
        console.log(this.showOtherSampleSpecInput);
        this.databaseBuildingInit();
        this.getPreferPrice();
        this.$forceUpdate();
      }
    },

    /**
     * 样本其他物种的输入
     * @param index
     */
    handleOtherSpecNameChanged: function handleOtherSpecNameChanged() {
      if (localStorage.getItem('otherSpecName')) {
        this.otherSampleSpecName = localStorage.getItem('otherSpecName');
      }
      localStorage.setItem('otherSpecName', this.otherSampleSpecName);
      if (this.eu1.taxId === '10117') {
        this.eu1.otherTaxName = this.otherSampleSpecName;
        this.boSolution.children[0].otherTaxName = this.otherSampleSpecName;
        this.getPreferPrice();
      }
    },

    /**
     * 显示样本分类选择弹框
     */
    showSampleCategoryPopup: function showSampleCategoryPopup() {
      this.showSampleCategory = true;
    },

    /**
     * 关闭样本分类选择弹框
     */
    closeSampleCategoryPopup: function closeSampleCategoryPopup() {
      this.showSampleCategory = false;
      this.$refs.sampleCategoryField.focus();
      this.$refs.sampleCategoryField.blur();
      this.validateSampleCategory();
    },

    /**
     * 样本分类选择
     * @param index
     */
    pickSampleCategory: function pickSampleCategory(index) {
      for (var i = 0; i < this.sampleCategoryOptArr.length; i++) {
        if (i === index) {
          this.sampleCategoryItemChecked[index] = !this.sampleCategoryItemChecked[index];
          this.currSampleCategory = this.sampleCategoryOptArr[index].dictValue;
          this.databaseBuildingInit();
        } else {
          this.$set(this.sampleCategoryItemChecked, i, false);
        }
      }
    },

    /**
     * 选择子类型
     * @param index
     */
    pickSubCategory: function pickSubCategory(index) {
      for (var i = 0; i < this.sampleSubCategoryOptArr.length; i++) {
        if (i === index) {
          this.subCategoryChecked[index] = !this.subCategoryChecked[index];
          var object = {};
          object.loSampleTypeId = this.sampleSubCategoryOptArr[index].loSampleTypeId;
          object.label = this.sampleSubCategoryOptArr[index].dictValue;
          object.currSampleCategory = this.currSampleCategory;
          object.currSampleSubCategory = this.sampleSubCategoryOptArr[index];
          if (object.currSampleSubCategory.dictValue.search('穿刺') !== -1 || object.currSampleSubCategory.dictValue.search('<') !== -1) {
            if (this.currEu === 'EU000302') {
              //如果是 4D label free
              this.currEu = 'EU000333'; // 变成超微量4D label free
            }
            if (this.currEu === 'EU000331') {
              //如果是DIA2.0
              this.currEu = 'EU000334'; // 变成超微量DIA2.0
            }
          } else {
            if (this.currEu === 'EU000333') {
              //如果是超微量4D label free
              this.currEu = 'EU000302'; // 变成4D label free
            }
            if (this.currEu === 'EU000334') {
              //如果是超微量DIA2.0
              this.currEu = 'EU000331'; // 变成DIA2.0
            }
          }
          this.sampleCategory = object;
        } else {
          this.$set(this.subCategoryChecked, i, false);
        }
      }
      this.constructBoSolution('BASIC');
      this.getPreferPrice();
    },

    /**
     * 禁用建库技术, 可禁用DIA6
     */
    handleDatabaseBuildingChecked: function handleDatabaseBuildingChecked(index) {
      if (this.showProcessTech[1]) {
        this.showProcessTech[1].default = null;
      }
      this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[index];
      this.constructBoSolution('ADVANCE');
      this.getPreferPrice();
    },
    databaseBuildingInit: function databaseBuildingInit() {
      // 当样本分类选择为「组织样本」
      if (this.currSampleCategory === this.sampleCategoryOptArr[0].dictValue) {
        if (this.currTaxId === '9606') {
          this.constructionTechEnable[0] = true; // 物种=人 可选
        } else {
          this.constructionTechEnable[0] = false; // 其他物种不可选
        }
        this.constructionTechEnable[1] = false; // 6级不可选
        this.constructionTechEnable[2] = true; // 12级可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[2]
      }

      // 当样本分类选择为「细胞样本」
      if (this.currSampleCategory === this.sampleCategoryOptArr[1].dictValue) {
        if (this.currTaxId === '9606') {
          this.constructionTechEnable[0] = true; // 物种=人 可选
        } else {
          this.constructionTechEnable[0] = false; // 其他物种不可选
        }
        this.constructionTechEnable[1] = false; // 6级不可选
        this.constructionTechEnable[2] = true; // 12级可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[2]
      }

      // 当样本分类选择为「体液样本」大类
      if (this.currSampleCategory === this.sampleCategoryOptArr[2].dictValue) {
        this.constructionTechEnable[0] = false; // 无需建库不可选
        this.constructionTechEnable[1] = true; // 6级可选
        this.constructionTechEnable[2] = false; // 12级不可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[1]
      }
    },

    /**
     * 增加实验组
     */
    addExperimental: function addExperimental(name, number) {
      this.experimentalGroup.push({
        label: name ? name : "实验组名称" + (this.experimentalGroup.length + 1),
        number: number ? number : 3
      });
      this.updateGroupsAndParameters();
      this.getPreferPrice();
    },

    /**
     * 删除实验组
     * @param index 要删除的索引值
     */
    removeExperimental: function removeExperimental(index) {
      var minLength = this.productInfo.eu1 === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_templateToUserData__["c" /* specialEuTemplateNo */])(0) ? 1 : 2;
      if (this.experimentalGroup.length <= minLength) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant__["b" /* Toast */])(this.eu1.name + '最少需要' + minLength + '个分组');
      } else {
        this.experimentalGroup.splice(index, 1);
        this.updateGroupsAndParameters();
        this.getPreferPrice();
      }
    },

    /**
     * 修改实验组名称
     */
    handleChangeGroupName: function handleChangeGroupName(index) {
      this.groups[index].name = this.experimentalGroup[index].label;
      this.updateGroupsAndParameters();
      this.getPreferPrice();
    },

    /**
     * 修改实验组数量
     */
    handleChangeGroupNum: function handleChangeGroupNum(index, mini) {
      console.log(this.experimentalGroup[index].number, 'ssssssssss');
      if (this.experimentalGroup[index].number && this.experimentalGroup[index].number !== '') {
        this.groups[index].bioRepeatTimes = this.experimentalGroup[index].number;
        this.updateGroupsAndParameters();
        this.getPreferPrice();
      }
    },
    overLimit: function overLimit(number) {
      if (number !== 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant__["b" /* Toast */])(this.eu1.name + '每组至少需要' + number + '个样本');
      }
    },

    /**
     * 删除指定index基因
     * @param index
     */
    removeGeneSearchResult: function removeGeneSearchResult(index) {
      this.geneSelectionGroup.splice(index, 1);
    },

    /**
     * 确认日期选择
     */
    onConfirmDeliveryTime: function onConfirmDeliveryTime(date, enable) {
      if (enable && localStorage.getItem('date')) {
        date = new Date(parseInt(localStorage.getItem('date')));
      }
      if (date) {
        localStorage.setItem('date', date.getTime());
        this.deliveryTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        this.showCal = false;
      }
    },

    /**
     * 确认疾病方向选择
     */
    onConfirmDiseaseDirection: function onConfirmDiseaseDirection(value) {
      console.log(localStorage.getItem('diseaseDirection'), localStorage.getItem('diseaseDirection') !== 'undefined' && localStorage.getItem('diseaseDirection') !== 'null');
      if (localStorage.getItem('diseaseDirection') !== 'undefined' && localStorage.getItem('diseaseDirection') !== 'null') {
        value = JSON.parse(localStorage.getItem('diseaseDirection'));
      }
      localStorage.setItem('diseaseDirection', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(value));
      if (value) {
        this.diseaseDirectionId = value.diseaseKey;
        this.diseaseDirectionName = value.diseaseName;
        this.showDiseaseDirectionPicker = false;
      }
    },

    /**
     * 取消疾病方向选择
     */
    onCancelDiseaseDirection: function onCancelDiseaseDirection(value) {
      this.$refs.diseaseDirectionField.focus();
      this.$refs.diseaseDirectionField.blur();
      this.showDiseaseDirectionPicker = false;
    },

    /**
     *增加生信分析对照组
     */
    addControlGroup: function addControlGroup() {
      var object = {};
      object.experimental = {};
      object.control = {};
      this.controlGroup.push(object);
      // 增加无需重新计算，选择对照组第二个下拉列表再计算
    },

    /**
     * 需要移除的对照组
     * @param index
     */
    removeControlGroup: function removeControlGroup(index) {
      if (this.controlGroup.length <= 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant__["b" /* Toast */])(this.eu1.name + '至少需要一组生信分析对照组');
      } else {
        this.controlGroup.splice(index, 1);
        this.constructEuParameterValues();
        this.updateGroupsAndParameters();
        this.getPreferPrice();
      }
    },

    /**
     * @description 选择对照组触发
     */
    handleChangeExperimentalControl: function handleChangeExperimentalControl() {
      this.constructEuParameterValues();
      this.updateGroupsAndParameters();
      this.getPreferPrice();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'UPDATE_CART_CONTENT']), {
    gotoCart: function gotoCart() {
      var cartData = {};
      cartData['categoryId'] = 99;
      var itemId = this.$route.query.itemId;
      cartData['itemId'] = itemId ? itemId : new Date().getTime();
      cartData['workdays'] = this.serviceWorkDaysSolution.workdays;
      cartData['promotions'] = [this.promotion];
      cartData['diseaseDirectionName'] = this.diseaseDirectionName;
      cartData['diseaseDirectionId'] = this.diseaseDirectionId;
      cartData['boSignalAnalysis'] = this.boSignalAnalysis.dictValue;
      cartData['databaseBuildings'] = this.databaseBuildings.dictValue;
      cartData['sampleProcessing'] = this.sampleProcessing.dictValue;
      cartData['icon'] = 'service.png';
      cartData['product'] = this.eu1.name;
      cartData['userLabel'] = (this.sampleSpec ? this.sampleSpec + '/' : '') + (this.sampleType ? this.sampleType + '/' : '') + (this.experimentalTotalNum ? this.experimentalTotalNum + '个样本' : '');
      cartData['allData'] = {
        'otherSampleSpecName': this.otherSampleSpecName,
        'returnMaterialChecked': this.returnMaterialChecked,
        'deliveryTime': this.deliveryTime,
        'sampleType': this.sampleType.trim(),
        'loSampleTypeId': this.sampleCategory.loSampleTypeId, // 样本类型Id(与labonline对应)
        'boSolution': __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.boSolution),
        'currSkuId': this.currSku.id,
        'diseaseDirectionId': this.diseaseDirectionId,
        'diseaseDirectionName': this.diseaseDirectionName,
        'geneSelectionGroup': this.geneSelectionGroup,
        'experimentalGroup': this.experimentalGroup,
        'experimentalTotalNum': this.experimentalTotalNum,
        'controlGroup': this.controlGroup
      };

      if (itemId) {
        this.oldCartContent[itemId] = cartData;
        this.UPDATE_CART_CONTENT(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.oldCartContent));
        this.$weui.toast('商品更新成功！', 3000);
      } else {
        localStorage.setItem('saveToCart', true);
        this.ADD_CART_LIST(cartData);
      }
      this.shoppingCartProductNumber = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.cartList.cartContent).length;
      localStorage.removeItem('sampleSpec');
      localStorage.removeItem('sampleType');
      localStorage.removeItem('diseaseDirection');
      localStorage.removeItem('date');
      this.$forceUpdate();
    },
    getMeteData: function getMeteData() {
      var dictionary = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      for (var key in dictionary[100026]) {
        var opt = {};
        opt.diseaseKey = key;
        opt.diseaseName = dictionary[100026][key].dictValue;
        this.diseaseDirectionOpts.push(opt);
      }
      for (var key1 in dictionary[71003]) {
        this.sampleProcessTech.ParaReturnMaterial.push(dictionary[71003][key1].dictValue);
      }
      for (var key5 in dictionary[71007]) {
        this.sampleCategoryOptArr.push(dictionary[71007][key5]);
      }
      for (var key6 in dictionary[71008]) {
        var obj = dictionary[71008][key6];
        var extraValue = dictionary[71008][key6].extraValue;
        // 解析 parentId 和 loSampleTypeId
        // extraValue eg: {"parentId":1, loSampleTypeId:10}
        if (extraValue) {
          var extraValueMap = JSON.parse(extraValue);
          obj.parentId = extraValueMap.parentId;
          obj.loSampleTypeId = extraValueMap.loSampleTypeId;
        }
        this.sampleSubCategoryOptArr.push(obj);
      }

      console.log(dictionary[61033]);
      console.log(dictionary[100026]);
      console.log(dictionary[71002]);
      console.log(dictionary[71003]);
      console.log(dictionary[71004]);
      console.log(dictionary[71005]);
      console.log(dictionary[71006]);
      console.log(dictionary[71007]);
      console.log(dictionary[71008]);
    },
    handleChangeSampleType: function handleChangeSampleType(enable) {
      if (localStorage.getItem('sampleType') && enable) {
        this.sampleType = localStorage.getItem('sampleType');
      }
      localStorage.setItem('sampleType', this.sampleType);
      this.getPreferPrice();
    },

    /**
     * @description  是否返回状态改变触发
     */
    handleChangeReturnMaterial: function handleChangeReturnMaterial() {
      this.returnMaterialChecked = !this.returnMaterialChecked;
      // 剩余样本返还 无需添加实物返还EU
      // this.constructBoSolution('BASIC')
      // console.log(this.boSolution, 'vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv------------')
      // this.getPreferPrice()
    },

    /**
     * @description 样本处理选项选择后的逻辑
     */
    handleSampleProcessChecked: function handleSampleProcessChecked(index) {
      if (this.showProcessTech[0]) {
        this.showProcessTech[0].default = null;
      }
      this.sampleProcessing = this.sampleProcessTech.ParaRemoveHAProtein[index];
      this.constructBoSolution('ADVANCE');
      this.getPreferPrice();
    },

    /**
     * @description 生信分析参数选择后的逻辑
     */
    handleBoSignalAnalysisChecked: function handleBoSignalAnalysisChecked(index) {
      if (this.showProcessTech[2]) {
        this.showProcessTech[2].default = null;
      }
      this.boSignalAnalysis = this.sampleProcessTech.ParaBioAnalysis[index];
      this.constructBoSolution('ADVANCE');
      this.getPreferPrice();
    },

    /**
     * @description 处理基因选择
     */
    handleChangeGene: function handleChangeGene() {
      this.updateGroupsAndParameters();
      this.getPreferPrice();
    },

    /**
     * @description 获取服务类商品的预计交付周期以及质量承诺与服务说明和計算价格所需参数
     * @param euNo
     */
    getBoSolutionBasicInfo: function getBoSolutionBasicInfo() {
      var r = null;
      this.constructBoSolution('BASIC');
      var that = this;
      this.gcapi('loGetBoSolutionBasicInfo', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.boSolution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result);
          that.boSolution.children = that.serviceWorkDaysSolution.bExperimentUnitList;
          // console.log('get BoSolution basic info done', JSON.parse(response.body.result))
          that.constructGroups();
          that.constructEuParameterValues();
          that.getBasicPrice();
        } else {
          // $.showPreloader('保存失败！')
        }
        r = true;
      });
      return r;
    },

    /**
     * @description 获取服务类产品的最优价格
     * @param euNo
     */
    getPreferPrice: function getPreferPrice() {
      var that = this;
      this.gcapi('loGetBoSolutionBasicInfo', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.boSolution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result);
          that.boSolution.children = that.serviceWorkDaysSolution.bExperimentUnitList;
          // console.log('get BoSolution basic info done', response.body.result)
          that.constructGroups();
          that.constructEuParameterValues();
          var req = {};
          that.boSolution.id = -100;
          req.solutionJsons = [__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(that.boSolution)];
          that.gcapi('getServiceProductPreferPrice', req).then(function (response) {
            if (response.body.code === 0) {
              that.priceSolution = response.body.result;
              var solutionJson = JSON.parse(response.body.result.solutionJsons[0]);
              that.formalQuotePrice = solutionJson.formalQuotePrice;
              that.standardPrice = solutionJson.standardPrice;
            } else {
              // $.showPreloader('保存失败！')
            }
          });
        } else {
          // $.showPreloader('保存失败！')
        }
      });
    },

    /**
     * @description 获取服务类产品的最优价格
     * @param euNo
     */
    getBasicPrice: function getBasicPrice() {
      var req = {};
      req.solutionJsons = [__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.boSolution)];
      var that = this;
      this.gcapi('getServiceProductPreferPrice', req).then(function (response) {
        if (response.body.code === 0) {
          that.priceSolution = response.body.result;
          var solutionJson = JSON.parse(response.body.result.solutionJsons[0]);
          that.formalQuotePrice = solutionJson.formalQuotePrice;
          that.standardPrice = solutionJson.standardPrice;
          console.log('get prefer price done--------------------', response.body.result);
        } else {
          // $.showPreloader('保存失败！')
        }
      });
    },

    /**
     * 获取方案详情
     */
    getSolutionDetail: function getSolutionDetail(solutionId) {
      var that = this;
      this.gcapi('loLoadSolutionDetail', solutionId).then(function (res) {
        if (res.body.code === 0) {
          that.boSolution = res.body.result;
        }
      });
    },

    /**
     * @description 构造解决方案
     */
    constructBoSolution: function constructBoSolution(type) {
      if (type === 'BASIC') {
        console.log(type);
        this.querySkuBasic();
        var that = this;
      } else {
        this.querySkuAdvance();
      }
      console.log(this.currSku, 'currSku');
      this.createEu(this.currSku.eu1);
      this.createEu(this.currSku.eu2);
      this.constructEus();
      this.constructEuSubLines();
      this.boSolution.id = -100;
      this.boSolution.sortOrderManualModified = false;
      console.log('--------------------------------------------------------------------------=>>>>>>>>>>>>>>>>>>>>>>>');
      this.getPreferPrice();
    },

    /**
     * @description  创建 eu 数据
     * @param EU编号
     */
    createEu: function createEu(euNo) {
      console.log('Starting create Experimental Unit, euNo:', euNo);
      if (euNo === '' || euNo === undefined) {
        // this.eu2 = undefined
        return;
      }
      var euTemplate = this.euTemplates.filter(function (v) {
        return v.templateNo === euNo;
      })[0];
      var eu = {};
      eu.id = -1;
      eu.taxId = this.currTaxId;
      if (eu.taxId === '10117') {
        eu.otherTaxName = this.otherSampleSpecName;
      }
      eu.stageNo = 1;
      eu.sortOrder = 1;
      eu.name = euTemplate.externalName;
      var template = {};
      template.id = euTemplate.id;
      template.productGuid = euTemplate.productGuid;
      eu.template = template;
      if (euNo === RETURN_MATERIAL_EU_NO) {
        this.eu2 = eu;
        this.eu2.id = -2;
        this.eu2.sortOrder = 2;
      } else {
        this.eu1 = eu;
        this.eu2 = {};
      }
      console.log('Build Experimental Unit done:', eu);
    },

    /**
     * @description 构造 EU数据
     */
    constructEus: function constructEus() {
      this.eus = [];
      console.log(this.eu2, 'eu2,,,,,,,,,,,,,,,');
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.eu1) !== '{}') {
        this.eus.push(this.eu1);
      }
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.eu2) !== '{}') {
        this.eus.push(this.eu2);
      }
      this.boSolution.children = this.eus;
      this.constructPus();
    },

    /**
     * @description  创建 pu 数据
     * @param PU编号
     */
    createPu: function createPu(puNo) {
      console.log('Starting create Price Unit, puNo:', puNo);
      if (puNo === '' || puNo === undefined) {
        return;
      }
      if (puNo.indexOf('SPEC') !== -1) {
        this.createSpecPu();
        return;
      }
      var puTemplate = this.puTemplates.filter(function (v) {
        return v.templateNo === puNo;
      })[0];
      if (puTemplate === undefined) {
        console.log('Ops!  The puNo has not found', puNo);
        return;
      }
      var pu = {};

      pu.id = this.puIdInit;
      this.puIdInit -= 1;
      pu.workdays = puTemplate.workdays;
      var template = {};
      template.workdays = puTemplate.workdays;
      template.id = puTemplate.id;
      template.nodeId = parseInt(this.puIdInit); // 服务端没有要求，先填随机数
      this.puIdInit -= 1;
      template.type = puTemplate.type;
      template.templateNo = puNo;
      pu.template = template;
      pu.sortOrder = 1;

      if (puNo === 'PU000914') {
        this.pus2.push(pu);
      } else {
        this.pus1.push(pu);
      }
      console.log('Build Price Unit done:', pu);
    },

    /**
     * @description  创建 specpu ,仅适用于TMT蛋白组学和磷酸化TMT蛋白组学
     * @param PU编号
     */
    createSpecPu: function createSpecPu() {
      console.log('Starting create spec Price Unit');
      console.log('current EU is: ', this.currEu);
      if ('EU000040' !== this.currEu && 'EU000039' !== this.currEu) {
        return;
      }

      var n = this.experimentalTotalNum;
      var spec1 = this.specPuTemplates.SPEC1;
      var spec2 = this.specPuTemplates.SPEC2;

      var specPuTemplate = {};
      if ('EU000039' === this.currEu) {
        for (var i = 0; i < spec1.length; i++) {
          if (spec1[i].limitExpression === undefined) {
            specPuTemplate = this.specPuTemplates.SPEC1[i];
          }
          if (eval(spec1[i].limitExpression)) {
            console.log('spec1 limitExpression', spec1[i].limitExpression);
            specPuTemplate = this.specPuTemplates.SPEC1[i];
          }
        }
      }
      if ('EU000040' === this.currEu) {
        for (var _i3 = 0; _i3 < spec2.length; _i3++) {
          if (spec2[_i3].limitExpression === undefined) {
            specPuTemplate = this.specPuTemplates.SPEC2[_i3];
          }
          if (eval(spec2[_i3].limitExpression)) {
            console.log('spec2 limitExpression', spec2[_i3].limitExpression);
            specPuTemplate = this.specPuTemplates.SPEC2[_i3];
          }
        }
      }

      if (specPuTemplate === undefined) {
        console.log('Ops!  The spec puNo has not found', puNo);
        return;
      }
      var pu = {};
      pu.id = this.puIdInit;
      this.puIdInit -= 1;
      pu.workdays = specPuTemplate.workdays;
      var template = {};
      template.workdays = specPuTemplate.workdays;
      template.id = specPuTemplate.id;
      template.nodeId = this.puIdInit;
      this.puIdInit -= 1; // 服务端没有要求，先填随机数
      template.type = specPuTemplate.type;
      template.templateNo = specPuTemplate.templateNo;
      pu.template = template;
      pu.sortOrder = 1;
      this.pus1.push(pu);
      console.log('Build spec price unit done:', pu);
    },

    /**
     * @description 构造PU数据
     */
    constructPus: function constructPus() {
      this.pus1 = [];
      this.pus2 = [];

      for (var i = 0; i < this.currSku.eu1_Pus.length; i++) {
        this.createPu(this.currSku.eu1_Pus[i]);
      }
      for (var _i4 = 0; _i4 < this.currSku.eu2_Pus.length; _i4++) {
        this.createPu(this.currSku.eu2_Pus[_i4]);
      }

      this.boSolution.children[0].children = this.pus1;
      if (this.boSolution.children[1] !== undefined) {
        this.boSolution.children[1].children = this.pus2;
      }
      this.constructPuSubLines();
    },

    /**
     * @description 构造PU拓扑结构
     */
    constructPuSubLines: function constructPuSubLines() {
      var subLines = [];
      for (var i = 0; i < this.pus1.length; i++) {
        if (i < this.pus1.length - 1) {
          var subLine = {};
          subLine.northId = this.pus1[i].id;
          subLine.southId = this.pus1[i + 1].id;
          subLines.push(subLine);
        }
      }
      this.eu1.subLines = subLines;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.eu2) !== '{}') {
        this.eu2.subLines = [];
      }
    },

    /**
     * @description 根据用户选择查询对应SKU
     */
    querySkuBasic: function querySkuBasic() {
      var _this5 = this;

      var sku = this.proteomicsSku.filter(function (v) {
        return v.eu1 === _this5.currEu;
      }).filter(function (v) {
        return v.valid === 1;
      });
      if (this.returnMaterialChecked) {
        sku = sku.filter(function (v) {
          return v.paraReturnMaterial === 1;
        });
      } else {
        sku = sku.filter(function (v) {
          return v.paraReturnMaterial === 0;
        });
      }
      console.log(sku, 'ssssss');
      // let tmpSku = []
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.sampleCategory) !== '{}') {
        sku = sku.filter(function (v) {
          return v.sampleCategory === _this5.sampleCategory.currSampleSubCategory.dictKey;
        });
      }
      if (sku.length > 0) {
        // 如果没有查到继续用未过滤之前的列表
        this.showErr = false;
        this.currSku = sku[0]; // 设置样本处理选项是否需要显示。 当该处理方法全部是-1 的时候则不显示该处理方法
        this.showProcessTech = [{ show: false, elements: [], default: null }, { show: false, elements: [], default: null }, { show: false, elements: [], default: null }];
        // 收集所有参数值并利用set特性去除参数的重复值
        var setRemoveHAProtein = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        var setConstructionTech = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        var setBioAnalysis = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        //设定UI的显示为默认选中值sku[0]
        if (sku[0].paraRemoveHAProtein && !this.comeForm) {
          console.log(sku[0]);
          this.showProcessTech[0].default = sku[0].paraRemoveHAProtein;
        }
        if (sku[0].paraConstructionTech && !this.comeForm) {
          this.showProcessTech[1].default = sku[0].paraConstructionTech;
        }
        if (sku[0].paraBioAnalysis && !this.comeForm) {
          this.showProcessTech[2].default = sku[0].paraBioAnalysis;
        }
        for (var i = 0; i < sku.length; i++) {
          if (sku[i].paraRemoveHAProtein !== -1) {
            setRemoveHAProtein.add(sku[i].paraRemoveHAProtein);
            this.showProcessTech[0].show = true;
          }
          if (sku[i].paraConstructionTech !== -1) {
            setConstructionTech.add(sku[i].paraConstructionTech);
            this.showProcessTech[1].show = true;
          }
          if (sku[i].paraBioAnalysis !== -1) {
            setBioAnalysis.add(sku[i].paraBioAnalysis);
            this.showProcessTech[2].show = true;
          }
        }
        //将set集合值放入数组中
        setRemoveHAProtein.forEach(function (item) {
          _this5.showProcessTech[0].elements.push(item);
        });
        setConstructionTech.forEach(function (item) {
          _this5.showProcessTech[1].elements.push(item);
        });
        setBioAnalysis.forEach(function (item) {
          _this5.showProcessTech[2].elements.push(item);
        });
        // todo Use sortOrder
        this.showProcessTech[0].elements.sort();
        this.showProcessTech[1].elements.sort();
        this.showProcessTech[2].elements.sort();
        this.filterMeteData();
        if (this.comeForm) {
          this.querySkuAdvance();
        }
      } else {
        if (this.eu1.name) {
          this.showErr = true;
        }
        this.validateSampleCategory();
      }
    },

    /**
     * 根据sku过滤元数据中不应该存在的数据。
     */
    filterMeteData: function filterMeteData() {
      var _this6 = this;

      var dictionary = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      this.sampleProcessTech.ParaRemoveHAProtein = [];
      this.sampleProcessTech.ParaConstructionTech = [];
      this.sampleProcessTech.ParaBioAnalysis = [];

      var _loop = function _loop(key2) {
        _this6.showProcessTech[0].elements.forEach(function (item) {
          if (item === dictionary[71004][key2].dictKey) {
            console.log(_this6.showProcessTech[0].default, dictionary[71004][key2].dictKey, 'ijo9999999999999999999999999');
            if (_this6.showProcessTech[0].default === dictionary[71004][key2].dictKey) {
              _this6.sampleProcessing = dictionary[71004][key2];
            }
            _this6.sampleProcessTech.ParaRemoveHAProtein.push(dictionary[71004][key2]);
          }
        });
      };

      for (var key2 in dictionary[71004]) {
        _loop(key2);
      }

      var _loop2 = function _loop2(key3) {
        _this6.showProcessTech[1].elements.forEach(function (item) {
          if (item === dictionary[71005][key3].dictKey) {
            if (_this6.showProcessTech[1].default === dictionary[71005][key3].dictKey) {
              _this6.databaseBuildings = dictionary[71005][key3];
            }
            _this6.sampleProcessTech.ParaConstructionTech.push(dictionary[71005][key3]);
          }
        });
      };

      for (var key3 in dictionary[71005]) {
        _loop2(key3);
      }

      var _loop3 = function _loop3(key4) {
        _this6.showProcessTech[2].elements.forEach(function (item) {
          if (item === dictionary[71006][key4].dictKey) {
            if (_this6.showProcessTech[2].default === dictionary[71006][key4].dictKey) {
              _this6.boSignalAnalysis = dictionary[71006][key4];
            }
            _this6.sampleProcessTech.ParaBioAnalysis.push(dictionary[71006][key4]);
          }
        });
      };

      for (var key4 in dictionary[71006]) {
        _loop3(key4);
      }
      console.log(dictionary[71004], dictionary[71005], dictionary[71006], 'ss');
    },

    /**
     * @description 根据用户选择查询对应SKU
     */
    querySkuAdvance: function querySkuAdvance() {
      var _this7 = this;

      var sku = this.proteomicsSku.filter(function (v) {
        return v.eu1 === _this7.currEu;
      }).filter(function (v) {
        return v.valid === 1;
      });
      if (this.returnMaterialChecked) {
        sku = sku.filter(function (v) {
          return v.paraReturnMaterial === 1;
        });
      } else {
        sku = sku.filter(function (v) {
          return v.paraReturnMaterial === 0;
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.sampleCategory) !== '{}') {
        var tmpSku = [];
        tmpSku = sku.filter(function (v) {
          return v.sampleCategory === _this7.sampleCategory.currSampleSubCategory.dictKey;
        });
        if (tmpSku.length !== 0) {
          // 如果没有查到继续用未过滤之前的列表
          sku = tmpSku;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.boSignalAnalysis) !== '{}') {
        var _tmpSku = [];
        _tmpSku = sku.filter(function (v) {
          return v.paraBioAnalysis === _this7.boSignalAnalysis.dictKey;
        });
        if (_tmpSku.length !== 0) {
          // 如果没有查到继续用未过滤之前的列表
          sku = _tmpSku;
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.databaseBuildings) !== '{}') {
        var _tmpSku2 = [];
        _tmpSku2 = sku.filter(function (v) {
          return v.paraConstructionTech === _this7.databaseBuildings.dictKey;
        });
        if (_tmpSku2.length !== 0) {
          // 如果没有查到继续用未过滤之前的列表
          sku = _tmpSku2;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.sampleProcessing) !== '{}') {
        var _tmpSku3 = [];
        _tmpSku3 = sku.filter(function (v) {
          return v.paraRemoveHAProtein === _this7.sampleProcessing.dictKey;
        });
        if (_tmpSku3.length !== 0) {
          // 如果没有查到继续用未过滤之前的列表
          sku = _tmpSku3;
        }
      }
      if (sku.length > 0) {
        this.currSku = sku[0];
      }
    },

    /**
     * @description 构造EU拓扑结构
     */
    constructEuSubLines: function constructEuSubLines() {
      var subLines = [];
      if (this.eus.length > 1 && this.eus[0].id !== undefined && this.eus[1].id !== undefined) {
        var subLine = {};
        subLine.northId = this.eus[0].id;
        subLine.southId = this.eus[1].id;
        subLines.push(subLine);
      }
      this.boSolution.subLines = subLines;
    },

    /**
     * @description 创建实验组数据
     */
    createGroups: function createGroups() {
      for (var i = 0; i < this.experimentalGroup.length; i++) {
        var group = {};
        group.name = this.experimentalGroup[i].label;
        group.techRepeatTimes = 1;
        group.bioRepeatTimes = this.experimentalGroup[i].number;
        group.groupType = true;
        group.parameterValues = [];
        group.steps = [];
        //样本类型参数
        var parameterValue = {};
        if (this.sampleCategory.currSampleSubCategory !== undefined) {
          parameterValue.value = this.sampleCategory.currSampleSubCategory.dictValue + ':' + this.sampleType;
        } else {
          parameterValue.value = '-:' + this.sampleType;
        }
        parameterValue.duplicateDataType = 2;
        if (this.boSolution.children.length !== 0 && this.boSolution.children[0].parameters !== undefined && this.boSolution.children[0].parameters.length !== 0) {
          parameterValue.value = this.sampleCategory.label;
          parameterValue.duplicateDataType = this.boSolution.children[0].parameters[0].dataType;
          parameterValue.parameterId = this.boSolution.children[0].parameters[0].id;
          parameterValue.relationId = this.boSolution.children[0].parameters[0].relationId;
          parameterValue.dataType = this.boSolution.children[0].parameters[0].dataType;
          parameterValue.name = this.boSolution.children[0].parameters[0].name;
        }
        group.parameterValues.push(parameterValue);

        // 基因参数
        if (this.currEu === 'EU000046') {
          var parameterValueGen = {};
          var values = [];
          for (var j = 0; j < this.geneSelectionGroup.length; j++) {
            var value = {};
            value.providedType = null;
            value.nativeId = this.geneSelectionGroup[j].geneGUID;
            value.outlineInfo = this.geneSelectionGroup[j].label;
            value.paramDesc = '';
            values.push(value);
          }
          parameterValueGen.values = values;
          parameterValueGen.duplicateDataType = 2;
          if (this.boSolution.children.length !== 0 && this.boSolution.children[0].parameters !== undefined && this.boSolution.children[0].parameters.length !== 0) {
            parameterValueGen.parameterId = this.boSolution.children[0].parameters[1].id;
            parameterValueGen.relationId = this.boSolution.children[0].parameters[1].relationId;
            parameterValueGen.dataType = this.boSolution.children[0].parameters[1].dataType;
            parameterValueGen.name = this.boSolution.children[0].parameters[1].name;
            parameterValueGen.duplicateDataType = this.boSolution.children[0].parameters[1].dataType;
          }

          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(parameterValueGen) !== '{}') {
            group.parameterValues.push(parameterValueGen);
          }
        }
        this.groups.push(group);
      }
    },

    /**
     * @description 构造实验组
     */
    constructGroups: function constructGroups() {
      this.groups = [];
      this.createGroups();
      this.boSolution.children[0].groups = this.groups;
      if (this.boSolution.children[1] !== undefined) {
        // EU2 groups 不需要 parameterValues
        var groupsClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.groups));
        for (var i = 0; i < groupsClone.length; i++) {
          groupsClone[i].parameterValues = [];
        }
        this.boSolution.children[1].groups = groupsClone;
      }
    },

    /**
     * @description 补充解决方案信息
     */
    updateGroupsAndParameters: function updateGroupsAndParameters() {
      this.constructGroups();
      this.constructEuParameterValues();
    },

    /**
     * @description 构造对照组信息
     */
    constructEuParameterValues: function constructEuParameterValues() {
      var firstValue = '';
      for (var j = 0; j < this.controlGroup.length; j++) {
        firstValue += this.controlGroup[j].experimental.label + ' VS ' + this.controlGroup[j].control.label;
        if (j < this.controlGroup.length - 1) {
          firstValue += '\n';
        }
      }

      var paramVal1 = {};
      paramVal1.value = firstValue; // Index[0] 为 组名1 VS 组名2， 以\n 分割
      if (this.boSolution.children[0].euParameters !== undefined && this.boSolution.children[0].euParameters.length > 0) {
        paramVal1.parameterId = this.boSolution.children[0].euParameters[0].id;
        paramVal1.duplicateDataType = this.boSolution.children[0].euParameters[0].dataType;
        paramVal1.relationId = this.boSolution.children[0].euParameters[0].relationId;
        paramVal1.dataType = this.boSolution.children[0].euParameters[0].dataType;
        paramVal1.entityType = this.boSolution.children[0].euParameters[0].entityType;
        paramVal1.entityId = this.boSolution.children[0].euParameters[0].entityId;
        paramVal1.name = this.boSolution.children[0].euParameters[0].name;
      }

      var paramVal2 = {};
      paramVal2.value = 1; // Index[1] 固定为1（指分析次数）

      if (this.boSolution.children[0].euParameters !== undefined && this.boSolution.children[0].euParameters.length > 0) {
        var index = this.boSolution.children[0].euParameters.length === 1 ? 0 : 1;
        paramVal2.parameterId = this.boSolution.children[0].euParameters[index].id;
        paramVal2.relationId = this.boSolution.children[0].euParameters[index].relationId;
        paramVal2.dataType = this.boSolution.children[0].euParameters[index].dataType;
        paramVal2.duplicateDataType = this.boSolution.children[0].euParameters[index].dataType;
        paramVal2.entityType = this.boSolution.children[0].euParameters[index].entityType;
        paramVal2.entityId = this.boSolution.children[0].euParameters[index].entityId;
        paramVal2.name = this.boSolution.children[0].euParameters[index].name;
      }

      this.boSolution.children[0].parameterValues = [];
      if (this.boSolution.children[0].euParameters.length === 2) {
        this.boSolution.children[0].parameterValues.push(paramVal1);
      }
      this.boSolution.children[0].parameterValues.push(paramVal2);

      // 如果是shortgun 和PRM 则无需prameterValues
      if (this.currEu === 'EU000048' || this.currEu === 'EU000046') {
        this.boSolution.children[0].parameterValues = [];
      }
    },
    openPdfList: function openPdfList() {
      __WEBPACK_IMPORTED_MODULE_6_wx___default.a.miniProgram.navigateTo({
        url: "/pages/pdf/pdfList?comeFrom=2"
      });
    },

    /**
     * 初始化正常购买基因数据结构
     */
    initNormalFormData: function initNormalFormData() {
      this.initRadioTag();
      this.promotion = JSON.parse(localStorage.getItem('promotion'));
      this.productInfo = JSON.parse(localStorage.getItem('product'));
    },
    initOrderBasicData: function initOrderBasicData(data) {
      var _this8 = this;

      console.log(data, '解析后的数据');
      this.boSolution = data.boSolution;
      this.productInfo = data.productInfo;
      this.euTemplates = data.euTemplates;
      this.puTemplates = data.puTemplates;
      this.specPuTemplates = data.specPuTemplates;
      this.deliveryTime = data.deliveryTime;
      this.currEu = data.currEu;
      this.currSku = data.currSku;
      this.returnMaterialChecked = data.returnMaterialChecked;
      if (data.oldCartContent) {
        this.oldCartContent = data.oldCartContent;
      }
      this.promotion = data.promotion;
      if (data.sampleType) {
        this.sampleType = data.sampleType.trim();
      }
      this.sampleSpecOptArr.some(function (item, index) {
        if (item.engName === data.tax.dictValue) {
          _this8.sampleSpec = item.chnName;
          _this8.sampleSpecItemChecked[index] = true;
          // this.pickSampleSpec(index)
          return true;
        }
      });
      this.diseaseDirectionName = data.diseaseDirection.name;
      this.diseaseDirectionId = data.diseaseDirection.id;
      this.otherSampleSpecName = data.otherTaxName;
      if (this.otherSampleSpecName) {
        this.showOtherSampleSpecInput = true;
      }
    },
    initOrderGroupData: function initOrderGroupData(data) {
      var _this9 = this;

      this.experimentalGroup = [];
      data.groups.forEach(function (item) {
        _this9.addExperimental(item.name, item.bioRepeatTimes);
      });
      console.log(data.controlGroups);
      data.controlGroups.forEach(function (item) {
        _this9.controlGroup.push({ experimental: _this9.experimentalGroup.filter(function (v) {
            return v.label === item[0].trim();
          })[0],
          control: _this9.experimentalGroup.filter(function (v) {
            return v.label === item[1].trim();
          })[0] });
      });
    },
    initSampleCategory: function initSampleCategory(data) {
      this.pickSampleCategory(data.singleMeteData.specCategorySuperIndex);
      this.pickSubCategory(data.singleMeteData.sampleCategoryIndex);
    },
    initOtherParamData: function initOtherParamData(data) {
      this.geneSelectionGroup = data.geneSelectionGroup;
      this.boSignalAnalysis = data.singleMeteData.paraBioAnalysis;
      this.databaseBuildings = data.singleMeteData.paraConstructionTech;
      this.sampleProcessing = data.singleMeteData.paraRemoveHAProtein;
      this.getPreferPrice();
    },
    jumpToCart: function jumpToCart() {
      __WEBPACK_IMPORTED_MODULE_6_wx___default.a.miniProgram.reLaunch({ url: '/pages/cart/cart?type=99' });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(["geneSearchResult", "sessionInfo"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])([
  // 映射 this.navTopLevel 为 store.state.navTopLevel
  'cartList', 'customerNo']))
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multiplex_StaticDoc__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multiplex_StaticDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multiplex_StaticDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_templateToUserData__ = __webpack_require__(136);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StaticDoc: __WEBPACK_IMPORTED_MODULE_3__multiplex_StaticDoc___default.a },
  data: function data() {
    return {
      serviceWorkDaysSolution: null,
      sampleSpecOptArr: [{ engName: "Mouse", chnName: "小鼠" }, { engName: "Rat", chnName: "大鼠" }, { engName: "Human", chnName: "人类" }, { engName: "其他", chnName: "其他" }],
      show: false,
      serviceUrl: "/emktResources/resocurces/img/merchandise/service.png",
      information: {}
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.orderInfo) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_templateToUserData__["a" /* getSolutionInfoByCartItemData */])(this.$route.params.orderInfo).then(function (res) {
        console.log(res, 'ressssssssssssss');
        _this.information = res;
        _this.setTaxName();
        _this.getBoSolutionBasicInfo(res.boSolution);
      });
      console.log(this.$route.params.orderInfo, '未提交');
    } else if (this.$route.params.orderId && this.$route.params.euId) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_templateToUserData__["b" /* getSolutionInfoByOrderId */])(this.$route.params.orderId, this.$route.params.euId).then(function (res) {
        console.log(res, 'ressssssssssssss');
        _this.information = res;
        _this.setTaxName();
        _this.getBoSolutionBasicInfo(res.boSolution);
      });
      console.log(this.$route.params.orderSolution, '已提交');
    } else {
      alert('警告，数据存在错误，请返回后刷新重试或者联系客服！');
    }
    // this.getMeteData()
  },

  methods: {
    specialEuTemplateNo: __WEBPACK_IMPORTED_MODULE_4__util_templateToUserData__["c" /* specialEuTemplateNo */],
    /**
     * @description 获取服务类商品质量承诺与服务说明
     * @param euNo
     */
    getBoSolutionBasicInfo: function getBoSolutionBasicInfo(solution) {
      var that = this;
      this.gcapi('loGetBoSolutionBasicInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result);
        } else {
          // $.showPreloader('保存失败！')
        }
        that.show = true;
      });
    },
    setTaxName: function setTaxName() {
      var _this2 = this;

      this.sampleSpecOptArr.some(function (item) {
        if (item.engName === _this2.information.tax.dictValue) {
          _this2.information.sampleSpec = item.chnName;
          return true;
        }
      });
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "pdfList",
  data: function data() {
    return {
      pdfList: "",
      pdfName: "",
      pdfSize: "",
      pdfType: ""
    };
  },

  methods: {
    pdfRouter: function pdfRouter(item) {
      __WEBPACK_IMPORTED_MODULE_0_wx___default.a.miniProgram.navigateTo({
        url: "/pages/pdf/pdfPage?pdfName=" + item.fileName + "&pdfSize=" + item.fileSize + "&pdfType=" + item.type
      });
      console.log("/pages/pdf/pdfPage?pdfName=" + item.fileName + "&pdfSize=" + item.fileSize + "&pdfType=" + item.type);
    }
  },
  props: ['type'],
  components: {},
  computed: {
    boxheight: function boxheight() {
      return window.innerHeight + "px";
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this = this;

    if (this.type) {
      this.gcapi("getExampleReports", 1).then(function (res) {
        if (res.body.code == 0) {
          _this.pdfList = res.body.result;
        }
      });
    } else {
      this.gcapi("getExampleReports", 2).then(function (res) {
        if (res.body.code == 0) {
          _this.pdfList = res.body.result;
        }
      });
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  data: function data() {
    return {
      fileInfo: {},
      fileName: "",
      fileSize: "",
      type: "",
      pdfUrl: ""
    };
  },

  methods: {
    download: function download() {
      window.open(this.pdfUrl, "_blank");
    },
    send: function send() {
      var _this = this;

      this.$weui.loading("邮件发送中");
      this.gcapi("sendExampleReportToCustomerByEmail", {
        fileName: this.fileName,
        type: this.type
      }).then(function (res) {
        _this.$weui.loading().hide();
        console.log(">>>>>>>>>>>>>>", res);
        if (res.body.code == 0) {
          _this.$weui.dialog({
            title: "发送成功",
            buttons: [{
              label: "我知道了"
            }]
          });
        } else {
          _this.$weui.dialog({
            title: "发送失败",
            buttons: [{
              label: "我知道了"
            }]
          });
        }
      });
    }
  },
  props: {},
  components: {},
  computed: {},
  mounted: function mounted() {
    console.log("comeFrom>>>>>>>>>>", this.$route.query.comeFrom);
    var comeFrom = this.$route.query.comeFrom;
    console.log("pdfName>>>>>>>>>>", this.$route.query.pdfName);
    console.log("pdfSize>>>>>>>>>>", this.$route.query.pdfSize);

    this.fileSize = this.$route.query.pdfSize;
    this.fileName = this.$route.query.pdfName;
    if (comeFrom === "order") {
      this.pdfUrl = "https://www.genechemat.com:8444/previewPdf/3?fileName=" + this.fileName;
      console.log("this.pdfUrl>>>>>>>>>>>", this.pdfUrl);
    } else if (comeFrom === "cart") {} else {
      this.fileInfo = JSON.parse(this.$route.params.pdfInfo);
      this.fileName = this.fileInfo.fileName;
      this.fileSize = this.fileInfo.fileSize;
      this.type = this.fileInfo.type;
      this.pdfUrl = "https://www.genechemat.com:8444/previewPdf/" + this.type + "?fileName=" + this.fileName, console.log(this.pdfUrl);
    }
  },
  created: function created() {}
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PromotionSuccess',
  methods: {
    gotoOrderList: function gotoOrderList() {
      this.$router.replace({ name: 'WeappMyOrders' });
    },
    revert: function revert() {
      if (__WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_img_serviceMark_png__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_img_serviceMark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_img_serviceMark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_templateToUserData__ = __webpack_require__(136);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['order', 'service', 'needSlove'],
  data: function data() {
    return {
      solution: {},
      orderCouponsValue: null,
      baseurl: '/emktResources/resocurces/img/merchandise/service.png',
      markImg: __WEBPACK_IMPORTED_MODULE_1__static_img_serviceMark_png___default.a,
      euNumber: [],
      couponsService: [],
      solutionPrice: {},
      productPrice: [],
      puCouponsGuid: [],
      disconnect: 0,
      puGroup: []
    };
  },
  mounted: function mounted() {
    console.log(this.order, 'orders');
    if (this.needSlove) {
      this.sloveProductData();
    } else {
      this.getSolutionPrice();
    }
  },

  methods: {
    sloveProductData: function sloveProductData() {
      var _this = this;

      this.solution = this.order.solution;
      this.order.coupons.forEach(function (item) {
        _this.orderCouponsValue += item.value;
      });
      this.$weui.loading('正在加载数据~').hide();
    },
    getRightPu: function getRightPu(puArr) {
      if (puArr) {
        var arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_templateToUserData__["i" /* boSignalAnalysisTemplateNo */])();
        var pu = {};
        puArr.some(function (it) {
          if (arr.includes(it.template.templateNo)) {
            pu = it;
            return true;
          }
        });
        return pu;
      } else {
        return null;
      }
    },
    getSolutionPrice: function getSolutionPrice() {
      var _this2 = this;

      console.log('获取价格组件', '已调用');
      // 订单详情，数据源自于父组件传递，父组件值源于购物车isChecked为true的值，中间无任何处理
      console.log(this.order);
      // 设定EU的存放数组
      var children = [];
      // 遍历循环order，将所有allData.boSolution.children的所有元素提取出来存放到数组中，并记录每个children的长度到euNumber中
      this.order.forEach(function (item) {
        _this2.euNumber.push(item.allData.boSolution.children.length);
        item.allData.boSolution.children.forEach(function (items) {
          children.push(items);
        });
      });
      console.log('各商品EU数量', 'EU组合后');
      console.log(this.euNumber, children);
      // 拼凑方案
      this.solution = {
        'id': -100,
        'children': children
      };
      console.log(this.solution, '方案');
      this.gcapi('getServiceProductPriceAndCoupons', { 'solutionJsons': [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.solution)] }).then(function (res) {
        console.log(res.body, '价格接口返回');
        _this2.couponsService = res.body.result.coupons;
        console.log('该商品可用的优惠券', _this2.couponsService);
        _this2.solutionPrice = JSON.parse(res.body.result.solutionJson);
        console.log('该商品返回的价格', _this2.solutionPrice);
        _this2.solution.children.forEach(function (item, index) {
          item.formalQuotePrice = _this2.solutionPrice.children[index].formalQuotePrice;
          item.standardPrice = _this2.solutionPrice.children[index].standardPrice;
        });
        var from = 0; // 这个确定从this.solutionPrice.children的第几个开始获取。
        _this2.order.forEach(function (item, index) {
          for (var i = 0; i < _this2.euNumber[index]; i++) {
            item.allData.boSolution.children[i] = _this2.solution.children[from];
            from = from + 1;
          }
        });
        _this2.$emit('SE', [_this2.solutionPrice.formalQuotePrice]);
        _this2.solutionPrice.children.forEach(function (i) {
          i.children.forEach(function (it) {
            // console.log(it, 'sssssssssssssit s')
            if (it.promotionGuid) {
              _this2.puGroup.push(it);
              _this2.puCouponsGuid.push(it.promotionGuid);
            }
          });
        });
        _this2.$weui.loading('正在加载数据~').hide();
        _this2.$parent.$parent.getAvailableCoupons(_this2.couponsService, _this2.solutionPrice);
        _this2.$parent.$parent.setDefaultSelectedCoupons();
        if (_this2.$parent.$parent.useDiscountCouponOnly) {
          var special = 0;
          _this2.puGroup.forEach(function (i) {
            if (i.promotionGuid === _this2.$parent.$parent.specialGuid) {
              special = special + -i.discountPrice;
            }
          });
          _this2.$parent.$parent.specialDiscountPrice = special;
        }
      });
    },
    getSolutionPriceAgain: function getSolutionPriceAgain() {
      var _this3 = this;

      // 订单详情，数据源自于父组件传递，父组件值源于购物车isChecked为true的值，中间无任何处理
      // 设定EU的存放数组
      var children = [];
      // 遍历循环order，将所有allData.boSolution.children的所有元素提取出来存放到数组中，并记录每个children的长度到euNumber中
      this.order.forEach(function (item) {
        _this3.euNumber.push(item.allData.boSolution.children.length);
        item.allData.boSolution.children.forEach(function (items) {
          children.push(items);
        });
      });
      // 拼凑方案
      this.solution = {
        'id': -100,
        'children': children
      };
      this.gcapi('getServiceProductPriceAndCoupons', { 'solutionJsons': [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.solution)], 'coupons': this.$parent.$parent.selectedCoupons }).then(function (res) {
        console.log(res.body, '价格接口返回');
        console.log('该商品可用的优惠券', _this3.couponsService);
        _this3.solutionPrice = JSON.parse(res.body.result.solutionJson);
        console.log('该商品返回的价格', _this3.solutionPrice);
        _this3.solution.children.forEach(function (item, index) {
          item.formalQuotePrice = _this3.solutionPrice.children[index].formalQuotePrice;
          item.standardPrice = _this3.solutionPrice.children[index].standardPrice;
        });
        var from = 0; // 这个确定从this.solutionPrice.children的第几个开始获取。
        _this3.order.forEach(function (item, index) {
          for (var i = 0; i < _this3.euNumber[index]; i++) {
            item.allData.boSolution.children[i] = _this3.solution.children[from];
            from = from + 1;
          }
        });
        _this3.$emit('SE', [_this3.solutionPrice.formalQuotePrice]);
        _this3.solutionPrice.children.forEach(function (i) {
          i.children.forEach(function (it) {
            if (it.promotionGuid) {
              _this3.puGroup.push(it);
              _this3.puCouponsGuid.push(it.promotionGuid);
            }
          });
        });
        _this3.$parent.$parent.getAvailableCoupons(_this3.couponsService, _this3.solutionPrice);
        if (_this3.$parent.$parent.useDiscountCouponOnly) {
          var special = 0;
          _this3.puGroup.forEach(function (i) {
            if (i.promotionGuid === _this3.$parent.$parent.specialGuid) {
              special = special + -i.discountPrice;
            }
          });
          _this3.$parent.$parent.specialDiscountPrice = special;
        }
      });
    },
    gotoDetail: function gotoDetail(orderSolution, euId) {
      if (this.needSlove) {
        console.log(euId, orderSolution, this.order);
        this.$router.push({ name: 'boSolutionDetail', params: { orderId: this.order.id, euId: euId } });
      } else {
        this.$router.push({ name: 'boSolutionDetail', params: { orderInfo: orderSolution } });
      }
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubmitChecked',
  data: function data() {
    return {
      orderStatus: this.$route.query.orderStatus
    };
  },

  methods: {
    gotoOrderList: function gotoOrderList() {
      this.$router.replace({ name: 'WeappMyOrders' });
    },
    revert: function revert() {
      if (__WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyPromotion',
  data: function data() {
    return {
      promotion: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.gcapi('getPurchaseAgreement').then(function (res) {
      console.log(res);
      if (res.body.code === 0) {
        _this.promotion = res.body.result;
      }
    });
  },

  methods: {}
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_QualitativeTeach_vue__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_QualitativeTeach_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_QualitativeTeach_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuantitativeTech_vue__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuantitativeTech_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_QuantitativeTech_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ModificationTech_vue__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ModificationTech_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ModificationTech_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProteomicsDesc_vue__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProteomicsDesc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProteomicsDesc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__ = __webpack_require__(136);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    QualitativeTech: __WEBPACK_IMPORTED_MODULE_3__components_QualitativeTeach_vue___default.a,
    QuantitativeTech: __WEBPACK_IMPORTED_MODULE_4__components_QuantitativeTech_vue___default.a,
    ModificationTech: __WEBPACK_IMPORTED_MODULE_5__components_ModificationTech_vue___default.a,
    ProteomicsDesc: __WEBPACK_IMPORTED_MODULE_6__components_ProteomicsDesc_vue___default.a
  },
  data: function data() {
    ;
    return {
      plain: [false, true, false],
      filterProduct: {},
      isQualitativeTech: false,
      isQuantitativeTech: true,
      isModificationTech: false,
      showPromotion: false,
      promotion: {},
      categoryList: [],
      serviceItems: [{
        serviceTxt: '强大生信团队',
        serviceSubTxt: '个性化一对一',
        serviceSvgUrl: '/static/img/svg/强大生信团队.svg'
      }, {
        serviceTxt: '软硬件先进',
        serviceSubTxt: '设备一流',
        serviceSvgUrl: '/static/img/svg/软硬件先进.svg'
      }, {
        serviceTxt: '质控严格',
        serviceSubTxt: '明确质控结果',
        serviceSvgUrl: '/static/img/svg/质控严格.svg'
      }, {
        serviceTxt: '交付周期短',
        serviceSubTxt: '最短30个工作日',
        serviceSvgUrl: '/static/img/svg/交付周期短.svg'
      }],
      productList: [],
      proteomicsSkus: [],
      targetSku: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({})
    };
  },
  created: function created() {
    localStorage.removeItem('sample');
    this.$weui.loading('正在加载~');
    this.fetchData();
  },

  methods: {
    fetchProductPromotions: function fetchProductPromotions(data) {
      var _this = this;

      this.showPromotion = false;
      this.gcapi('getServiceProductPromotions', data).then(function (res) {
        if (res.data.code === 0) {
          if (res.data.result.length > 0) {
            _this.showPromotion = true;
            _this.promotion = res.data.result[0];
          }
        }
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;

      this.gcapi('getProteomicsBasicData', '').then(function (res) {
        if (res.data.code === 0) {
          _this2.proteomicsSkus = res.data.result.proteomicsSku.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          });
          console.log(_this2.proteomicsSkus);
          _this2.categoryList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["g" /* filterMeteData */])(undefined, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["h" /* deDuplication */])(_this2.proteomicsSkus, 'techCategory'), 71001);
          var filterSkus = {};
          var filterProduct = {};
          //得到技术分类,并依据技术分类将sku分类
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["h" /* deDuplication */])(_this2.proteomicsSkus, 'techCategory').forEach(function (item) {
            filterSkus[item] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["g" /* filterMeteData */])(_this2.proteomicsSkus, item, undefined, 'techCategory');
          });
          for (var key in filterSkus) {
            filterProduct[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["h" /* deDuplication */])(filterSkus[key], 'productCategory');
          }
          for (var _key in filterProduct) {
            _this2.filterProduct[_key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_templateToUserData__["g" /* filterMeteData */])(undefined, filterProduct[_key], 71002);
          }
          _this2.onChange(1, 2);
          _this2.$weui.loading().hide();
        }
      });
    },
    setProductList: function setProductList(techCategory) {
      var _this3 = this;

      if (techCategory.dictKey) {
        this.productList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.filterProduct[techCategory.dictKey]);
        this.$nextTick(function () {
          _this3.handleProduct(_this3.productList[0]);
        });
      } else {
        this.productList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.filterProduct[techCategory]);
      }
      this.$nextTick(function () {
        _this3.handleProduct(_this3.productList[0]);
        new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          if (_this3.plain[1]) {
            _this3.$refs.send.handleSearchRecommend();
          }
          __WEBPACK_IMPORTED_MODULE_8_vant__["b" /* Toast */].loading();
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_8_vant__["b" /* Toast */].clear();
            resolve(_this3.validateFlag);
          }, 200);
        }).then(function (go) {
          if (_this3.plain[1]) {
            _this3.$refs.send.handleSearchRecommend();
          }
        });
      });
    },
    onChange: function onChange(index, dictKey) {
      var _this4 = this;

      console.log(index, dictKey);
      this.plain.forEach(function (item, i) {
        _this4.plain[i] = i === index;
      });
      this.$forceUpdate();
      this.setProductList(dictKey);
    },
    onClickNextStep: function onClickNextStep() {
      console.log(this.targetSku, 'sssssssssssssssssssssssssssss');
      if (this.targetSku) {
        if (this.targetSku.eu1) {
          localStorage.setItem('product', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.targetSku));
          localStorage.setItem('promotion', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.promotion));
          console.log(this.targetSku);
          if (this.plain[1]) {
            this.$refs.send.sendInfo();
          }
          this.$router.push({
            name: 'boSolution',
            query: { 'templateNo': this.targetSku.eu1, 'product': this.targetSku.productName } });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vant__["b" /* Toast */])('请选择产品');
        }
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vant__["b" /* Toast */])('请选择产品');
      }
    },
    handleProduct: function handleProduct(obj) {
      if (obj !== null) {
        var dictKey = obj.dictKey;
        var targetSkus = this.proteomicsSkus.filter(function (v) {
          return v.productCategory === dictKey;
        });
        if (targetSkus.length > 0) {
          this.targetSku = targetSkus[0];
          this.targetSku.productName = obj.dictValue;
          this.targetSku.productDesc = obj.extraValue;
          console.log(this.targetSku);
          var data = this.targetSku.eu1_Pus.filter(function (v) {
            return v.includes('SPEC') === false;
          });
          this.fetchProductPromotions(data);
        }
      } else {
        this.targetSku = obj;
      }
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectIndex: 0
    };
  },

  props: {
    dataList: {
      type: [Object, Array],
      default: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({})
    }
  },
  created: function created() {},

  methods: {
    onSelectTech: function onSelectTech(currentItem, targetIndex) {
      this.selectIndex = targetIndex;
      localStorage.setItem('selectProductIndex', this.selectIndex);
      this.$emit('callback', currentItem);
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiplex_StaticDoc__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiplex_StaticDoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__multiplex_StaticDoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoSolution_PdfList__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoSolution_PdfList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BoSolution_PdfList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PdfList: __WEBPACK_IMPORTED_MODULE_1__BoSolution_PdfList___default.a, StaticDoc: __WEBPACK_IMPORTED_MODULE_0__multiplex_StaticDoc___default.a },
  data: function data() {
    return {
      src: [],
      imgLength: 25
    };
  },
  mounted: function mounted() {
    this.setSrc();
  },

  methods: {
    setSrc: function setSrc() {
      for (var i = 1; i < this.imgLength + 1; i++) {
        var url = '/emktResources/resocurces/img/proteomicsDetail/产品详情';
        url = url + i + '.png';
        this.src.push(url);
      }
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectIndex: 0,
      selectItem: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({})
    };
  },

  props: {
    dataList: {
      type: [Object, Array],
      default: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({})
    }
  },
  created: function created() {},

  methods: {
    onSelectTech: function onSelectTech(currentItem, targetIndex) {
      this.selectIndex = targetIndex;
      localStorage.setItem('selectProductIndex', this.selectIndex);
      this.selectItem = currentItem;
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isLoading: true,
      isRecommend: false,
      showPicker: false,
      templateCount: -1,
      selectIndex: 0,
      allRecommendations: [],
      recommendations: [],
      sampleCategories: [],
      sampleSubCategories: [],
      currentCategory: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}),
      currentSubCategory: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({})
    };
  },

  props: {
    dataList: {
      type: [Object, Array],
      default: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({})
    }
  },
  created: function created() {
    this.getMeteData();
    this.fetchRecommendList();
  },

  methods: {
    clear: function clear() {
      if (this.isRecommend) {
        this.selectIndex = null;
        this.$parent.handleProduct(null);
      } else {
        this.selectIndex = 0;
        this.$parent.handleProduct(this.dataList[0]);
        this.currentCategory = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({});
        this.currentSubCategory = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({});
        localStorage.removeItem('sample');
        this.templateCount = -1;
      }
    },
    sendInfo: function sendInfo() {
      if (this.isRecommend) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentCategory) !== '{}') {
          var sample = {
            currentCategory: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.currentCategory),
            currentSubCategory: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.currentSubCategory)
          };
          localStorage.setItem('sample', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sample));
        } else {
          localStorage.removeItem('sample');
        }
      } else {
        localStorage.removeItem('sample');
      }
    },
    getMeteData: function getMeteData() {
      var dictionary = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getEmktMetaData().dictionariesMap;
      for (var key1 in dictionary[71007]) {
        if (dictionary[71007][key1].dictValue !== '-') {
          this.sampleCategories.push(dictionary[71007][key1]);
        }
      }
      for (var key2 in dictionary[71008]) {
        var obj = dictionary[71008][key2];
        var extraValue = obj.extraValue;
        // 解析 parentId 和 loSampleTypeId
        // extraValue eg: {"parentId":1, loSampleTypeId:10}
        if (extraValue) {
          var extraValueMap = JSON.parse(extraValue);
          obj.parentId = extraValueMap.parentId;
          obj.loSampleTypeId = extraValueMap.loSampleTypeId;
        }
        this.sampleSubCategories.push(obj);
      }
      console.log('sampleSubCategories', this.sampleSubCategories);
    },
    fetchRecommendList: function fetchRecommendList() {
      var that = this;
      this.gcapi('getProteomicsBasicData', '').then(function (res) {
        if (res.data.code === 0) {
          that.allRecommendations = res.data.result.proteomicsRecommendation;
        }
      });
    },
    onSelectTech: function onSelectTech(currentItem, targetIndex) {
      if (this.isRecommend) {
        var result = this.recommendations.some(function (res) {
          return res.productCategory === parseInt(currentItem.dictKey);
        });
        if (!result) {
          return;
        }
      }
      this.selectIndex = targetIndex;
      localStorage.setItem('selectProductIndex', this.selectIndex);
      this.$emit('callback', currentItem);
    },
    handleCheckIsRecommend: function handleCheckIsRecommend(prod) {
      return this.isRecommend && this.recommendations.some(function (v) {
        return v.productCategory === prod.dictKey && v.recommendFlag === 1;
      });
    },
    handleSelectCategory: function handleSelectCategory(currentCategory) {
      this.currentCategory = currentCategory;
    },
    handleSubSelectCategory: function handleSubSelectCategory(currentSubCategory) {
      this.currentSubCategory = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({});
      this.currentSubCategory = currentSubCategory;
    },
    handleSearchRecommend: function handleSearchRecommend() {
      var _this = this;

      this.isLoading = false;
      if (this.isRecommend) {
        this.selectIndex = null;
      }
      this.recommendations = this.allRecommendations;
      this.recommendations = this.recommendations.filter(function (v) {
        return v.sampleQuantity === _this.templateCount;
      });
      if (this.currentSubCategory.dictKey !== undefined) {
        this.recommendations = this.recommendations.filter(function (v) {
          return v.sampleCategory === _this.currentSubCategory.dictKey;
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentSubCategory) === '{}') {
        this.recommendations = this.recommendations.filter(function (v) {
          return v.sampleCategory !== 1;
        });
      }
      this.showPicker = false;
      this.isLoading = true;
      this.$forceUpdate();
    },
    checkItemCanSelect: function checkItemCanSelect(prod) {
      if (!this.isRecommend) {
        return true;
      }
      return this.recommendations.some(function (v) {
        return v.productCategory === prod.dictKey && v.selectable === 1;
      });
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);

//
//
//
//
//

// import emkt from '../emkt'



/**
 * 电签规则：
 * @author Anya
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'centerController',
  mounted: function mounted() {
    this.init();
  },
  data: function data() {
    return {
      solutionId: null,
      bOrders: {}
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      this.$weui.loading('正在提交数据！');
      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
        this.bOrders = JSON.parse(this.$route.query.bOrders);
        this.solutionId = JSON.parse(this.$route.query.solution)[0];
      } else {
        this.bOrders = this.$route.params.bOrders;
        this.solutionId = this.$route.params.solution;
      }
      if (this.bOrders[0].orderType === 3) {
        this.gcapi('loLoadSolutionDetail', this.solutionId).then(function (res) {
          if (res.body.code === 0) {
            var solution = JSON.parse(res.body.result);
            solution.operationType = 30;
            solution.children.forEach(function (i) {
              i.groups.forEach(function (it) {
                if (it.parameterValues && it.parameterValues.length > 0) {
                  it.parameterValues.forEach(function (ite) {
                    if (ite.dataType) {
                      ite.duplicateDataType = ite.dataType;
                    }
                  });
                }
              });
              if (i.parameterValues && i.parameterValues.length > 0) {
                i.parameterValues.forEach(function (item) {
                  item.duplicateDataType = item.dataType;
                });
              }
            });
            _this.gcapi('loUpdateSolutionInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solution)).then(function (res) {
              console.log(res.body, '请求审核请求返回');
              if (res.body.code === 0) {
                console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.bOrders));
                _this.gcapi('orderPay', _this.bOrders).then(function (response) {
                  _this.$weui.loading().hide();
                  var order = response.body.result[0];
                  if (response.body.code === 0) {
                    if (order.status === 12) {
                      alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单');
                      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
                        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({ url: '/pages/cart/cart' });
                      } else {
                        _this.$router.replace({ name: 'cart' });
                      }
                      // todo 常量
                    } else if (order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_SUBMITTED) {
                      _this.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } });
                    } else if (order.status === 15) {
                      _this.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } });
                    } else if (order.status === 3) {
                      _this.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } });
                    }
                  }
                });
              }
            });
          } else {
            _this.$weui.topTips('获取详情失败，请联系客服解决，方案ID：' + _this.solutionId);
          }
          console.log(res.body.result);
        });
      } else {
        this.gcapi('orderPay', this.bOrders).then(function (response) {
          _this.$weui.loading().hide();
          var order = response.body.result[0];
          if (response.body.code === 0) {
            if (order.status === 12) {
              alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单');
              if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
                __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({ url: '/pages/cart/cart' });
              } else {
                _this.$router.replace({ name: 'cart' });
              }
            } else if (order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_SUBMITTED) {
              _this.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } });
            } else if (order.status === 15) {
              _this.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } });
            } else if (order.status === 3) {
              _this.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } });
            } else if (order.status === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
              _this.$weui.topTips('提交订单失败，请联系客服或重新提交订单');
              _this.$router.replace({ name: 'WeappMyOrders' });
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bar',
  props: {
    titleBar: {
      type: Array,
      default: [{
        label: 'label',
        value: 'value'
      }]
    }
  },
  data: function data() {
    return {
      selected: 0
    };
  },

  methods: {
    changed: function changed(index, value) {
      this.selected = index;
      this.$emit('change', value);
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaticDoc'
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DisplayIconAndStatus__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DisplayIconAndStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DisplayIconAndStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddSampleDeliverySheet',
  components: { DisplayIconAndStatus: __WEBPACK_IMPORTED_MODULE_6__DisplayIconAndStatus___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['getOrderMaterialInfo', 'getReassembleOrderMaterialInfo']), {
    customerNo: function customerNo() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo;
    },
    customerName: function customerName() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerName;
    },
    currentOrderMaterialExpressId: function currentOrderMaterialExpressId() {
      if (this.orderMaterialInfo.expressInfo) {
        return this.orderMaterialInfo.expressInfo.orderMaterialExpressId;
      } else if (this.uploadAfterOrderMaterialExpressId !== null) {
        return this.uploadAfterOrderMaterialExpressId;
      }
    }
  }),
  created: function created() {
    this.fetchData();
  },
  activated: function activated() {
    this.fetchData();
  },
  data: function data() {
    return {
      orderMaterialInfo: {},
      plain: [true, false],
      expressNo: null,
      expressCategoryList: ['快递寄送', '非快递寄送'],
      expressIndex: 0, // 初始化第一个快递高亮
      expressName: '顺丰快递',
      expressList: ['顺丰快递', '京东快递', '中通快递', '申通快递', '百世快递', '邮政EMS', '德邦快递', '圆通快递', '韵达快递', '其他快递'],
      sampleInfoFiles: [],
      fromType: null,
      uploadAfterOrderMaterialExpressId: null
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;
      _this.orderMaterialInfo = this.getReassembleOrderMaterialInfo;
      _this.fromType = this.$route.params.fromType;
      // 默认勾选有orderMaterialDetailId的数据，绑定快递信息
      _this.setIsCheckedOrderMaterial(_this.orderMaterialInfo);
      // 绑定快递信息
      _this.setExpressInfo(_this.orderMaterialInfo);
    },
    setIsCheckedOrderMaterial: function setIsCheckedOrderMaterial(orderMaterialInfo) {
      orderMaterialInfo.orderMaterial.forEach(function (material) {
        if (material.orderMaterialDetail !== undefined) {
          if (material.orderMaterialDetail.orderMaterialDetailId !== undefined) {
            material.orderMaterial.isChecked = true;
          }
        }
      });
    },
    setExpressInfo: function setExpressInfo(orderMaterialInfo) {
      var _this2 = this;

      if (this.fromType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery) {
        this.expressNo = null;
        this.expressIndex = 0;
        this.plain = [true, false];
      } else if (this.fromType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery) {
        if (orderMaterialInfo.expressInfo) {
          this.expressNo = orderMaterialInfo.expressInfo.expressNo;
          if (this.orderMaterialInfo.expressInfo.expressName === '') this.expressIndex = 0;else if (this.orderMaterialInfo.expressInfo.expressName === '非快递寄送') {
            this.plain = [false, true];
            this.expressIndex = 0;
            this.expressNo = null;
          } else {
            this.plain = [true, false];
            this.expressList.forEach(function (express, index) {
              if (express === _this2.orderMaterialInfo.expressInfo.expressName) {
                _this2.expressIndex = index;
              }
            });
          }
        }
      }
    },
    downloadGoodsInfoSheet: function downloadGoodsInfoSheet() {
      var sampleInfoFiles = this.orderMaterialInfo.initFileList.filter(function (initFile) {
        return initFile.fileType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].MATERIAL_FILETYPE.SAMPLE_INFO_SHEET;
      });
      this.$router.push({
        name: 'DownloadArticleInfoSheet',
        params: { sampleInfoFiles: sampleInfoFiles }
      });
    },
    isDisabled: function isDisabled(value) {
      if (value.orderMaterialDetail !== undefined) return value.orderMaterialDetail.infoReceived === true || value.orderMaterialDetail.fileName !== undefined;else return false;
    },
    getChange: function getChange(value) {
      if (value !== undefined && value.fileName) return this.$weui.alert('请先删除文件');
    },
    uploadFile: function uploadFile(e, item) {
      var _this3 = this;

      if (this.disAllowUploadOrDelete(item)) return this.$weui.alert('实物反馈信息成功，不允许上传！');
      var file = e.target.files[0];
      if (!file) return;
      var orderMaterialDetailId = null;
      if (item.orderMaterialDetail) {
        orderMaterialDetailId = item.orderMaterialDetail.orderMaterialDetailId;
      }
      this.getBase64(file).then(function (resBase64) {
        var params = { orderMaterialId: item.orderMaterial.orderMaterialId, orderMaterialExpressId: _this3.currentOrderMaterialExpressId, orderMaterialDetailId: orderMaterialDetailId, fileName: file.name, creator: _this3.customerName, creatorNo: _this3.customerNo, base64FileContent: resBase64 };
        _this3.$weui.loading('上传中', 8000);
        _this3.gcapi('uploadOrderMaterialFile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params)).then(function (res) {
          var uploadFile = JSON.parse(res.body.result);
          _this3.$set(item.orderMaterial, 'isChecked', true);
          _this3.$set(item, 'orderMaterialDetail', uploadFile);
          if (!_this3.currentOrderMaterialExpressId) {
            _this3.uploadAfterOrderMaterialExpressId = uploadFile.orderMaterialExpressId;
          }
          _this3.$weui.loading('上传成功').hide();
        });
      });
    },
    getBase64: function getBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        var fileResult = '';
        reader.readAsDataURL(file);
        reader.onload = function () {
          fileResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    disAllowUploadOrDelete: function disAllowUploadOrDelete(item) {
      return item.orderMaterialDetail && item.orderMaterialDetail.infoReceived;
    },
    removeFile: function removeFile(value) {
      var _this4 = this;

      var params = { orderMaterialDetailId: value.orderMaterialDetail.orderMaterialDetailId, deletedBy: this.customerName, deleteNo: this.customerNo };
      this.gcapi('removeUploadedOrderMaterialFile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params)).then(function (res) {
        _this4.orderMaterialInfo.orderMaterial.forEach(function (material) {
          if (material.orderMaterial.orderMaterialId === value.orderMaterial.orderMaterialId) {
            _this4.$set(material.orderMaterialDetail, 'fileName', undefined);
            _this4.$set(material.orderMaterialDetail, 'fileSizeDisplay', undefined);
            _this4.$set(material.orderMaterialDetail, 'fileType', null);
            _this4.$set(material.orderMaterialDetail, 'filePath', null);
            _this4.$set(material.orderMaterialDetail, 'orderMaterialDetailId', null);
          }
        });
      });
    },
    onChange: function onChange(index) {
      var _this5 = this;

      this.plain.forEach(function (item, i) {
        _this5.plain[i] = i === index;
      });
      this.$forceUpdate();
    },
    chooseExpress: function chooseExpress(value, index) {
      this.expressIndex = index;
      this.expressName = value;
    },
    copy: function copy() {
      var _this6 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_3_clipboard___default.a('#tag-copy');
      clipboard.on('success', function (e) {
        _this6.$weui.toast('复制成功', 1500);
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this6.$weui.topTips('该浏览器不支持自动复制');
        clipboard.destroy();
      });
    },
    showMiniProgramInComputerUsage: function showMiniProgramInComputerUsage() {
      this.$router.push({
        name: 'ComputerSideUsage'
      });
    },
    openShunFengProgram: function openShunFengProgram() {
      __WEBPACK_IMPORTED_MODULE_5_wx___default.a.miniProgram.navigateTo({
        url: '/pages/toShunFeng/toShunFeng'
      });
    },
    saveSampleDelivery: function saveSampleDelivery() {
      var _this7 = this;

      if (this.plain[0] && !this.expressNo) return this.$weui.alert('请输入快递单号');
      var expressNo = '非快递寄送';
      var expressName = '非快递寄送';
      if (this.plain[0]) {
        expressNo = this.expressNo;
        expressName = this.expressName;
      }
      var checkedOrderMaterialIds = this.orderMaterialInfo.orderMaterial.filter(function (material) {
        return material.orderMaterial.isChecked === true;
      }).map(function (m) {
        return m.orderMaterial.orderMaterialId;
      });
      var params = { orderMaterialIds: checkedOrderMaterialIds, orderNo: this.getOrderMaterialInfo[0].orderMaterial.orderNo, orderMaterialExpressId: this.currentOrderMaterialExpressId, expressNo: expressNo, expressName: expressName, operator: this.customerName, operatorNo: this.customerNo };
      this.$weui.loading('保存中');
      this.gcapi('createOrUpdateOrderMaterialExpressInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params)).then(function (res) {
        _this7.$weui.loading().hide();
        _this7.orderMaterialInfo = JSON.parse(res.body.result);
        _this7.setIsCheckedOrderMaterial(_this7.orderMaterialInfo);
        _this7.$weui.toast('保存成功', 1500);
        if (_this7.fromType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery) {
          _this7.$router.go(-2);
        } else if (_this7.fromType === __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery) {
          _this7.$router.go(-1);
        }
      });
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComputerSideUsage'
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DisplayIconAndStatus',
  props: {
    displayStatusName: {
      type: String,
      default: ''
    },
    materialType: {
      type: Number
    },
    displayType: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownloadArticleInfoSheet',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo'])),
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      fileList: []
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;
      _this.fileList = this.$route.params.sampleInfoFiles;
    },
    downSampleInfoFile: function downSampleInfoFile(file) {
      __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.navigateTo({
        url: '/pages/file/downloadSampleInfoFile?customerNo=' + this.sessionInfo.customerInfo.customerNo + '&fileName=' + file.fileName.replace('&', '%26') + '&fileType=' + __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getFileSuffix(file.fileName) + '&fileSize=' + file.fileSizeDisplay + '&orderMaterialDetailId=' + file.orderMaterialDetailId
      });
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisplayIconAndStatus__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisplayIconAndStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DisplayIconAndStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MaterialDetail',
  components: { DisplayIconAndStatus: __WEBPACK_IMPORTED_MODULE_3__DisplayIconAndStatus___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getOrderMaterialInfo', 'getOrderMaterialId']), {
    'sampleDeliveryInfo': function sampleDeliveryInfo() {
      if (this.materialDetail.initFileList && this.materialDetail.initFileList.length > 0) {
        return this.materialDetail.initFileList.filter(function (i) {
          return i.fileType === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].MATERIAL_FILETYPE.SAMPLE_DELIVERY_GUIDE;
        });
      }
    },
    'sampleInfo': function sampleInfo() {
      if (this.materialDetail.initFileList && this.materialDetail.initFileList.length > 0) {
        return this.materialDetail.initFileList.filter(function (i) {
          return i.fileType === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].MATERIAL_FILETYPE.SAMPLE_INFO_SHEET;
        });
      }
    }
  }),
  created: function created() {
    this.fetchData();
  },
  activated: function activated() {
    this.fetchData();
  },
  data: function data() {
    return {
      materialDetail: {}
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.gcapi('loadOrderMaterialInfo', this.getOrderMaterialInfo[0].orderMaterial.orderNo).then(function (res) {
        if (res.body.result !== '[]') {
          _this.orderMaterialInfo = JSON.parse(res.body.result);
          _this.materialDetail = _this.orderMaterialInfo.find(function (material) {
            return material.orderMaterial.orderMaterialId === _this.getOrderMaterialId;
          });
        }
      });
    },
    getMaterialWarning: function getMaterialWarning() {
      if (this.materialDetail.orderMaterial && this.materialDetail.orderMaterial.materialWarning !== undefined) return this.materialDetail.orderMaterial.materialWarning;
    },
    downSampleInfoFile: function downSampleInfoFile(file) {
      __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.navigateTo({
        url: '/pages/file/downloadSampleInfoFile?customerNo=' + this.sessionInfo.customerInfo.customerNo + '&fileName=' + file.fileName.replace('&', '%26') + '&fileType=' + __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getFileSuffix(file.fileName) + '&fileSize=' + file.fileSizeDisplay + '&orderMaterialDetailId=' + file.orderMaterialDetailId
      });
    },
    showMiniProgramInComputerUsage: function showMiniProgramInComputerUsage() {
      this.$router.push({
        name: 'ComputerSideUsage'
      });
    },
    showMaterialSendProcess: function showMaterialSendProcess() {
      this.$router.push({
        name: 'MaterialSendProcess'
      });
    },
    showSampleDeliverySheet: function showSampleDeliverySheet() {
      var _this2 = this;

      this.$weui.loading('加载中');
      var params = { json: this.getOrderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress' };
      this.gcapi('invokeBsmMethod', params).then(function (res) {
        _this2.$router.push({
          name: 'MySampleDeliverySheet',
          params: { orderMaterialExpressList: JSON.parse(res.body.result) }
        });
        _this2.$weui.loading('加载中').hide();
      });
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MaterialInquire',
  created: function created() {
    this.getData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  data: function data() {
    return {
      customerMaterialInfo: []
    };
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      var _this = this;
      var customerNo = this.sessionInfo.customerInfo.customerNo;
      this.$weui.loading('加载中');
      _this.gcapi('loadCustomerMaterialInfoInStock', customerNo).then(function (response) {
        _this2.customerMaterialInfo = JSON.parse(response.body.result);
        _this2.$weui.loading('加载中').hide();
      });
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MaterialSendProcess',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getOrderMaterialInfo'])),
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['REASSEMBLE_ORDER_MATERIAL_INFO']), {
    createSampleDeliverySheet: function createSampleDeliverySheet() {
      this.REASSEMBLE_ORDER_MATERIAL_INFO(__WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].reassembleOrderMaterialInfo(this.getOrderMaterialInfo));
      this.$router.push({
        name: 'AddSampleDeliverySheet',
        params: { fromType: __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery }
      });
    }
  })
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MySampleDeliverySheet',
  components: { DisplayIconAndStatus: __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getOrderMaterialInfo'])),
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      orderMaterialExpressList: []
    };
  },
  activated: function activated() {
    // 来自修改界面的返回
    this.fetchData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['REASSEMBLE_ORDER_MATERIAL_INFO']), {
    fetchData: function fetchData() {
      var _this2 = this;

      var _this = this;
      _this.orderMaterialExpressList = this.$route.params.orderMaterialExpressList;
      var params = { json: this.getOrderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress' };
      this.gcapi('invokeBsmMethod', params).then(function (res) {
        if (res.body.result !== '[]') {
          _this2.orderMaterialExpressList = JSON.parse(res.body.result);
        }
      });
    },
    modifyInfo: function modifyInfo(materialExpress) {
      var _this3 = this;

      this.$weui.loading('加载中');
      var params = { json: materialExpress.orderMaterialExpressId, method: 'loadOrderMaterialExpressDetail' };
      this.gcapi('invokeBsmMethod', params).then(function (res) {
        _this3.REASSEMBLE_ORDER_MATERIAL_INFO(JSON.parse(res.body.result));
        _this3.$router.push({
          name: 'AddSampleDeliverySheet',
          params: { fromType: __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery }
        });
        _this3.$weui.loading('加载中').hide();
      });
    }
  })
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SampleDeliveryList',
  components: { DisplayIconAndStatus: __WEBPACK_IMPORTED_MODULE_2__DisplayIconAndStatus___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getOrderMaterialInfo']), {
    waitSendOutMaterialNumber: function waitSendOutMaterialNumber() {
      var _this = this;

      this.waitSendOutMaterial = 0;
      this.orderMaterialInfo.forEach(function (material) {
        if (material.displayStatusName === '待寄出') {
          _this.waitSendOutMaterial++;
        }
      });
      return this.waitSendOutMaterial;
    }
  }),
  created: function created() {
    this.fetchData();
  },
  data: function data() {
    return {
      waitSendOutMaterial: 0,
      from: '',
      orderMaterialInfo: []
    };
  },
  activated: function activated() {
    this.fetchData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['MATERIALDETAIL_ORDERMATERIALID']), {
    fetchData: function fetchData() {
      var _this2 = this;

      this.gcapi('loadOrderMaterialInfo', this.getOrderMaterialInfo[0].orderMaterial.orderNo).then(function (res) {
        if (res.body.result !== '[]') {
          _this2.orderMaterialInfo = JSON.parse(res.body.result);
        }
      });
    },
    queryMaterial: function queryMaterial(material) {
      this.MATERIALDETAIL_ORDERMATERIALID(material.orderMaterial.orderMaterialId);
      this.$router.push({
        name: 'MaterialDetail'
      });
    },
    createSampleDeliverySheet: function createSampleDeliverySheet() {
      this.$router.push({
        name: 'MaterialSendProcess'
      });
    },
    showSampleDeliverySheet: function showSampleDeliverySheet() {
      var _this3 = this;

      this.$weui.loading('加载中');
      var params = { json: this.orderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress' };
      this.gcapi('invokeBsmMethod', params).then(function (res) {
        _this3.$router.push({
          name: 'MySampleDeliverySheet',
          params: { orderMaterialExpressList: JSON.parse(res.body.result) }
        });
        _this3.$weui.loading('加载中').hide();
      });
    },
    downloadAllInformationSheets: function downloadAllInformationSheets() {
      __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.navigateTo({
        url: '/pages/file/downloadSampleInfoFile?customerNo=' + this.sessionInfo.customerInfo.customerNo + '&fileName=' + this.getOrderMaterialInfo[0].orderMaterial.orderNo + '-物品信息表.zip' + '&fileType=' + 'zip' + '&orderNo=' + this.getOrderMaterialInfo[0].orderMaterial.orderNo
      });
    }
  })
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder___default.a },
  mounted: function mounted() {
    var _this = this;
    _this.gcapi('getBProvices').then(function (response) {
      console.log(response);
      var data = response.body.result;
      for (var i in data) {
        _this.provinceOptions.push({ text: data[i].name, value: data[i].name });
        var city = [];
        for (var y in data[i].cities) {
          city.push({ text: data[i].cities[y].name, value: data[i].cities[y].name });
        }
        _this.cityOptionsMap[data[i].name] = city;
      }
      // this.cityOptions = _this.cityOptionsMap[_this.addressInfo.province]
      console.log(_this.provinceOptions, _this.cityOptionsMap);
    });
  },
  created: function created() {
    console.log('params', this.$route.params);
  },
  data: function data() {
    return {
      expressInfo: {
        consignee: '',
        expressMobile: '',
        expressAddress: '',
        isDefaultString: true,
        province: '',
        city: '',
        street: ''
        // district: '',
      },
      error: '',
      provinceOptions: [],
      cityOptionsMap: {},
      cityOptions: [],
      showPicker: false,
      showCityPicker: false,
      href: 'javascript:;'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE']), {
    onConfirm2: function onConfirm2(data) {
      this.expressInfo.city = data.value;
      this.showCityPicker = false;
    },
    onConfirm: function onConfirm(data) {
      this.expressInfo.province = data.value;
      this.cityOptions = this.cityOptionsMap[data.value];
      this.showPicker = false;
    },
    checkInfo: function checkInfo() {
      var _this = this;
      if (!_this.expressInfo.province || !_this.expressInfo.city || !_this.expressInfo.street) {
        _this.error = '地址为空';
        return false;
      }
      if (_this.expressInfo.consignee === '') {
        _this.error = '收货人姓名为空';
        return false;
      }
      if (_this.expressInfo.expressMobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.expressInfo.expressMobile)) {
        _this.error = '手机号码有误';
        return false;
      }
      // if (_this.expressInfo.expressAddress === '') {
      //   _this.error = '地址为空'
      //   return false
      // }
      return true;
    },
    submit: function submit() {
      var _this2 = this;

      var _this = this;
      if (_this.checkInfo()) {
        _this.href = 'javascript:window.history.back()';
        //          _this.$router.replace('/me/userInfo/address')
        var address = _this.expressInfo.expressAddress;
        address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '');
        var params = {};
        params.customerNo = this.sessionInfo.customerInfo.customerNo;
        params.creator = this.sessionInfo.customerInfo.customerName;
        params.isDefault = 0;
        params.consignee = _this.expressInfo.consignee.replace(/\s/g, '');
        params.expressMobile = _this.expressInfo.expressMobile;
        params.expressAddress = address;
        params.province = _this.expressInfo.province;
        params.city = _this.expressInfo.city;
        params.street = _this.expressInfo.street;
        params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
        _this.gcapi('createOrUpdateAddress', params).then(function (response) {
          if (response.body.code === 0) {
            _this2.$weui.toast('添加成功', 1500);
            // $.toast('添加成功')
            _this.gotolast();
          } else {
            _this2.$weui.topTips('出错');
            // $.toast('出错')
          }
        });
      } else {
        this.$weui.topTips(_this.error);
        // $.toast(_this.error)
      }
    },
    gotolast: function gotolast() {
      // window.history.go(-1)
      this.$router.replace({ name: 'WeappAddress', query: { from: this.$route.query.from }, params: { order: this.$route.params.order, addressType: this.$route.params.addressType } });
    }
  })
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder___default.a },
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      addressInfo: [],
      from: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo', 'weappMyOrders', 'chosenOrder']), {
    'count': function count() {
      return this.sessionInfo.expressAddress.length;
    },
    newAddressInfo: function newAddressInfo() {
      // let defaultAddress = this.addressInfo.filter(address => address.isDefault !== 0)
      // let restAddress = this.addressInfo.filter(address => address.isDefault === 0)
      // return defaultAddress ? [...defaultAddress, ...restAddress] : restAddress
      return this.addressInfo;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
      vm.from = from.query.from ? from.query.from : from.name;
    });
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE', 'UPDATE_WEAPP_MYORDERS']), {
    getData: function getData() {
      var _this = this;
      _this.gcapi('gcwwwifc/getAddressInfoByCustomerNo?customerNo=' + this.sessionInfo.customerInfo.customerNo).then(function (response) {
        var result = response.body.result.filter(function (r) {
          return r.addressStatus !== __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].ADDRESS_STATUS.ADDRESS_STATUS_INVALID;
        });
        _this.addressInfo = result;
        _this.EXPRESSADDRESS_UPDATE(result);
      });
    },
    goBack: function goBack() {
      console.log(this.$route.params.order);
      // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
      if (this.from === 'orderContentConfirm') {
        this.$router.replace({ name: 'orderContentConfirm' });
      } else if (this.from === 'orderContent') {
        this.$router.replace({ name: 'orderContent', params: { order: this.$route.params.order } });
      } else if (this.from === 'WeappOrderContentConfirmation') {
        this.$router.replace({ name: 'WeappOrderContentConfirmation' });
      } else if (this.from === 'WeappOrderConfirmation') {
        this.$router.replace({ name: 'WeappOrderConfirmation' });
      } else if (this.from === 'WeappMyOrderDetail') {
        this.$router.replace({ name: 'WeappMyOrderDetail', params: { orderNo: this.$route.params.order.orderNo } });
      } else if (this.from === 'updateInvoiceTitle') {
        this.$router.replace({ name: 'updateInvoiceTitle', params: { order: this.$route.params.order } });
      } else {
        this.$router.push({ name: 'me' });
      }
    },
    updateAddress: function updateAddress(address, index) {
      if (this.from === 'WeappOrderContentConfirmation' || this.from === 'WeappOrderConfirmation' || this.from === 'WeappMyOrderDetail' || this.from === 'updateInvoiceTitle') {
        this.changeColor(this.newAddressInfo);
        document.getElementById('updateAddress' + index).style.background = '#EFEEF3';
        var isDefault = 0;
        if (this.from === 'WeappOrderContentConfirmation' || this.$route.params.addressType === 1) {
          if (address.isDefault === 2 || address.isDefault === 3) {
            isDefault = 3;
          } else {
            isDefault = 1;
          }
        } else if (this.from === 'updateInvoiceTitle' || this.from === 'WeappOrderConfirmation' || this.$route.params.addressType === 4) {
          if (address.isDefault === 1 || address.isDefault === 3) {
            isDefault = 3;
          } else {
            isDefault = 2;
          }
        }
        var _this = this;
        _this.$weui.loading();
        var params = {};
        params.customerNo = this.sessionInfo.customerInfo.customerNo;
        params.creator = this.sessionInfo.customerInfo.customerName;
        params.operator = this.sessionInfo.customerInfo.customerName;
        params.expressAddressGuid = address.expressAddressGuid;
        params.isDefault = isDefault;
        params.consignee = address.consignee;
        params.expressMobile = address.expressMobile;
        params.expressAddress = address.expressAddress;
        params.province = address.province;
        params.city = address.city;
        params.district = address.district;
        params.addressSource = __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
        _this.gcapi('createOrUpdateAddress', params).then(function (response) {
          if (response.body.code === 0) {
            var addressType = _this.$route.params.addressType;
            if (addressType) {
              var jsonString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.$route.params.order);
              var orderBo = JSON.parse(jsonString);
              orderBo.addressType = addressType;
              if (addressType === 1) {
                orderBo.expressAddress = address.province + address.city + address.district + address.expressAddress;
                orderBo.expressMobile = address.expressMobile;
                orderBo.expressName = address.consignee;
              } else if (_this.$route.params.addressType === 4) {
                orderBo.invoiceAddress = address.province + address.city + address.district + address.expressAddress;
                orderBo.invoiceMobile = address.expressMobile;
                orderBo.invoiceName = address.consignee;
              }
              _this.updateOrderExpressAddressOrInvoiceAddress(orderBo);
            } else {
              _this.getData();
              _this.$weui.toast('修改成功', 1500);
              _this.$weui.loading().hide();
              _this.goBack();
              setTimeout(function () {}, 900);
            }
          }
          if (response.body.code === 1) {
            _this.$weui.topTips('出错');
            _this.$weui.loading().hide();
          }
        });
      }
    },
    updateOrderExpressAddressOrInvoiceAddress: function updateOrderExpressAddressOrInvoiceAddress(order) {
      var _this = this;
      _this.gcapi('updateOrderExpressAddressOrInvoiceAddress', order).then(function (response) {
        if (response.body.code === 0) {
          _this.$route.params.order = order;
          _this.getData();
          _this.$weui.toast('修改成功', 1500);
          _this.$weui.loading().hide();
          __WEBPACK_IMPORTED_MODULE_4__emkt__["a" /* default */].setLocalStorage('addressOrder', order);
          _this.goBack();
          setTimeout(function () {}, 900);
        }
      });
    },
    changeColor: function changeColor(addressInfoList) {
      for (var i = 0; i < addressInfoList.length; i++) {
        document.getElementById('updateAddress' + i).style.background = '#ffffff';
      }
    }
  })
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_2__components_FooterPlaceholder___default.a },
  created: function created() {
    // var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + (this.expressInfo.district === undefined ? '' : this.expressInfo.district)
    // $('#city-picker').val(express)
  },
  data: function data() {
    return {
      href: 'javascript:;',
      addressInfo: {},
      provinceOptions: [],
      cityOptionsMap: {},
      cityOptions: [],
      showPicker: false,
      showCityPicker: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    // $('#city-picker').cityPicker({toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
    // })
    // console.log('sss', this.expressInfo)
    // var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + (this.expressInfo.district === undefined ? '' : this.expressInfo.district)
    // $('#city-picker').val(express)
    var _this = this;
    _this.addressInfo = this.expressInfo;
    _this.gcapi('getBProvices').then(function (response) {
      console.log(response);
      var data = response.body.result;
      for (var i in data) {
        _this.provinceOptions.push({ text: data[i].name, value: data[i].name });
        var city = [];
        for (var y in data[i].cities) {
          city.push({ text: data[i].cities[y].name, value: data[i].cities[y].name });
        }
        _this.cityOptionsMap[data[i].name] = city;
      }
      _this2.cityOptions = _this.cityOptionsMap[_this.addressInfo.province];
      console.log(_this.provinceOptions, _this.cityOptionsMap);
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo']), {
    'expressInfo': function expressInfo() {
      return JSON.parse(this.$route.query.address);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['EXPRESSADDRESS_UPDATE']), {
    onConfirm2: function onConfirm2(data) {
      this.addressInfo.city = data.value;
      this.showCityPicker = false;
    },
    onConfirm: function onConfirm(data) {
      this.addressInfo.province = data.value;
      this.cityOptions = this.cityOptionsMap[data.value];
      this.showPicker = false;
    },
    submit: function submit() {
      var _this3 = this;

      var _this = this;
      var params = {};
      params.customerNo = this.sessionInfo.customerInfo.customerNo;
      params.creator = this.sessionInfo.customerInfo.customerName;
      params.operator = this.sessionInfo.customerInfo.customerName;
      params.expressAddressGuid = _this.addressInfo.expressAddressGuid;
      params.isDefault = _this.addressInfo.isDefault;
      params.consignee = _this.addressInfo.consignee.replace(/\s/g, '');
      params.expressMobile = _this.expressInfo.expressMobile;
      params.province = _this.addressInfo.province;
      params.city = _this.addressInfo.city;
      params.street = _this.addressInfo.street;
      // params.district = _this.addressInfo.district
      params.addressSource = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT;
      _this.gcapi('createOrUpdateAddress', params).then(function (response) {
        if (response.body.code === 0) {
          _this3.$weui.toast('修改成功', 1500);
          // $.toast('修改成功')
          _this.gotolast();
        }
        if (response.body.code === 1) {
          _this3.$weui.topTips('出错');
          // $.toast('出错')
        }
      });
    },
    delAddress: function delAddress() {
      var _this4 = this;

      var _this = this;
      _this.href = 'javascript:window.history.back()';
      _this.gcapi('gcwwwifc/updateAddressStatus', {
        'expressAddressGuid': _this.expressInfo.expressAddressGuid
      }).then(function (response) {
        if (response.body.code === 0) {
          _this4.$weui.toast('删除成功', 1500);
          // $.toast('删除成功')
          _this.gotolast();
        } else {
          _this4.$weui.topTips('出错');
          // $.toast('出错')
        }
      }, function (response) {
        _this4.$weui.topTips('请求错误');
        // $.toast('请求错误')
      });
    },
    gotolast: function gotolast() {
      // window.history.go(-1)
      this.$router.push({ name: 'WeappAddress', query: { from: this.$route.query.from }, params: { order: this.$route.params.order, addressType: this.$route.params.addressType } });
    }
  })
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {},

  watch: {
    'invoiceInfo': function invoiceInfo(val) {
      var _this = this;
      var samePayEnterprise = _this.payEnterpriseListData.find(function (mer) {
        return val.enterpriseNo === mer.enterpriseNo;
      });
      console.log(samePayEnterprise);
      if (samePayEnterprise) {
        _this.$weui.topTips('该开票抬头已经存在！不可重复添加！');
        return;
      }
      _this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val);
      console.log(val);
    },
    'ListPayEnterprise': function ListPayEnterprise(val) {
      console.log(val);
    }
  },
  data: function data() {
    return {
      payEnterpriseIndex: null,
      payEnterpriseListData: [],
      showPayEnterprise: true,
      ListPayEnterprise: []
    };
  },

  components: {
    FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_1__components_FooterPlaceholder___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['sessionInfo', 'invoiceInfo', 'chosenOrder']), {
    payEnterpriseList: function payEnterpriseList() {
      return this.payEnterpriseListData;
    },
    canAddPayEnterprise: function canAddPayEnterprise() {
      return this.chosenOrder.payType !== 1 && this.showPayEnterprise;
    },
    order: function order() {
      if (this.$route.params.order) {
        this.UPDATE_CHOSEN_ORDER(this.$route.params.order);
      }
      return this.chosenOrder;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_ORDER']), {
    getPayExperienceLabel: function getPayExperienceLabel(label) {
      if (label) {
        return label.length > 15 ? label.substring(0, 15) + '...' : label;
      } else {
        return null;
      }
    },
    getMainClass: function getMainClass(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main3';
    },
    getMainStyle: function getMainStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'float: right;' : 'float: right;';
    },
    getTextStyle: function getTextStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);';
    },
    addPayEnterprise: function addPayEnterprise() {
      var payEnterprise = {};
      this.payEnterpriseListData.push(payEnterprise);
      console.log('this.payEnterpriseList', this.payEnterpriseList);
    },
    removePayEnterprise: function removePayEnterprise(index) {
      var _this = this;
      if (_this.payEnterpriseListData[index].enterpriseInvoiceTitle) {
        if (_this.payEnterpriseListData.length <= 1) {
          _this.$weui.topTips('订单开票抬头不可为空', 2000);
        } else {
          // _this.$weui.confirm('确定要删除订单开票抬头?', {
          //   title: '提示',
          //   buttons: [{
          //     label: '取消',
          //     type: 'default',
          //     onClick: function () { console.log('no') }
          //   }, {
          //     label: '确定',
          //     type: 'primary',
          //     onClick: function () {
          //       _this.payEnterpriseListData.splice(index, 1)
          //       _this.updatepayEnterprise()
          //       console.log('this.payEnterpriseList', _this.payEnterpriseList)
          //     }
          //   }]
          // })
          _this.payEnterpriseListData.splice(index, 1);
        }
      } else {
        _this.payEnterpriseListData.splice(index, 1);
      }
    },
    openSerchPayEnterprise: function openSerchPayEnterprise(index, val) {
      this.payEnterpriseIndex = index;
      console.log(index);
    },
    fetchData: function fetchData() {
      var _this = this;
      console.log(this.$route.params.order);
      _this.gcapi('getOrderPayEnterpriseNos', _this.order.id).then(function (response) {
        var map = __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelEnterpriseNoMap');
        var rlist = response.body.result;
        if (rlist.length > 0) {
          rlist.forEach(function (data) {
            var d = map[data];
            if (d !== undefined) {
              var enterprise = {
                'enterpriseInvoiceTitle': d.enterpriseInvoiceTitle,
                'enterpriseNo': d.enterpriseNo
              };
              _this.payEnterpriseListData.push(enterprise);
            }
          });
          _this.ListPayEnterprise = _this.payEnterpriseListData;
        } else {
          _this.showPayEnterprise = false;
        }
      });
    },
    submitPayEnterprise: function submitPayEnterprise() {
      var _this = this;
      _this.$weui.confirm('确定要更新订单开票抬头?', {
        title: '提示',
        buttons: [{
          label: '取消',
          type: 'default',
          onClick: function onClick() {
            console.log('no');
          }
        }, {
          label: '确定',
          type: 'primary',
          onClick: function onClick() {
            _this.updatepayEnterprise();
          }
        }]
      });
    },
    updatepayEnterprise: function updatepayEnterprise() {
      var self = this;
      console.log(self.payEnterpriseList);
      var payEnterpriseNos = [];
      self.payEnterpriseList.forEach(function (payEnterpriseNo) {
        if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
          payEnterpriseNos.push(payEnterpriseNo.enterpriseNo);
        }
      });
      self.$weui.loading('正在更新订单开票抬头');
      var param = {
        payEnterpriseNoList: payEnterpriseNos,
        rootOrderId: self.order.id
      };
      self.gcapi('updateOnlineOrderPayEnterprise', param).then(function (response) {
        self.$weui.loading().hide();
        self.$weui.toast('更新成功！', 2500);
        self.toPayInvoice();
      });
    },
    toPayInvoice: function toPayInvoice() {
      this.$router.replace({ name: 'updateInvoiceTitle', params: { order: this.$route.params.order } });
    }
  })
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {},

  watch: {
    'invoiceInfo': function invoiceInfo(val) {
      var _this = this;
      var samePayEnterprise = _this.payEnterpriseListData.find(function (mer) {
        return val.enterpriseNo === mer.enterpriseNo;
      });
      console.log(samePayEnterprise);
      if (samePayEnterprise) {
        _this.$weui.topTips('该开票抬头已经存在！不可重复添加！');
        return;
      }
      _this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val);
      _this.$weui.confirm('确定要更新订单开票抬头?', {
        title: '提示',
        buttons: [{
          label: '取消',
          type: 'default',
          onClick: function onClick() {
            console.log('no');
          }
        }, {
          label: '确定',
          type: 'primary',
          onClick: function onClick() {
            _this.updatepayEnterprise();
          }
        }]
      });
      console.log(val);
    },
    '.popup-invoice-title': function popupInvoiceTitle(val) {
      alert(1111);
    }
  },
  data: function data() {
    return {
      payEnterpriseIndex: null,
      payEnterpriseListData: [],
      showPayEnterprise: true
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['sessionInfo', 'invoiceInfo', 'chosenOrder']), {
    payEnterpriseList: function payEnterpriseList() {
      console.log('this.payEnterpriseListData', this.payEnterpriseListData);
      return this.payEnterpriseListData;
    },
    canAddPayEnterprise: function canAddPayEnterprise() {
      return this.chosenOrder.payType !== __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY && this.showPayEnterprise;
    },
    order: function order() {
      if (this.$route.params.order) {
        this.UPDATE_CHOSEN_ORDER(this.$route.params.order);
      }
      return this.chosenOrder;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['UPDATE_CHOSEN_ORDER']), {
    // contactCustomerService () {
    //   this.$weui.alert('请联系客服')
    // },
    getPayExperienceLabel: function getPayExperienceLabel(label) {
      return label;
    },
    getMainClass: function getMainClass(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main4';
    },
    getMainStyle: function getMainStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'float: right;margin-top: 10px' : 'float: right;margin-top: -10px';
    },
    getTextStyle: function getTextStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);';
    },
    addPayEnterprise: function addPayEnterprise() {
      var payEnterprise = {};
      this.payEnterpriseListData.push(payEnterprise);
      console.log('this.payEnterpriseList', this.payEnterpriseList);
    },
    removePayEnterprise: function removePayEnterprise(index) {
      var _this = this;
      if (_this.payEnterpriseListData[index].enterpriseInvoiceTitle) {
        if (_this.payEnterpriseListData.length <= 1) {
          _this.$weui.topTips('订单开票抬头不可为空', 2000);
        } else {
          _this.$weui.confirm('确定要删除订单开票抬头?', {
            title: '提示',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: function onClick() {
                console.log('no');
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: function onClick() {
                _this.payEnterpriseListData.splice(index, 1);
                _this.updatepayEnterprise();
                console.log('this.payEnterpriseList', _this.payEnterpriseList);
              }
            }]
          });
        }
      } else {
        _this.payEnterpriseListData.splice(index, 1);
      }
    },
    openSerchPayEnterprise: function openSerchPayEnterprise(index, val) {
      this.payEnterpriseIndex = index;
    },
    fetchData: function fetchData() {
      var _this = this;
      console.log(this.$route.params.order);
      _this.gcapi('getOrderPayEnterpriseNos', _this.order.id).then(function (response) {
        var map = __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelEnterpriseNoMap');
        var rlist = response.body.result;
        console.log(map);
        if (rlist.length > 0) {
          rlist.forEach(function (data) {
            var d = map[data];
            if (d !== undefined) {
              var enterprise = {
                'enterpriseInvoiceTitle': d.enterpriseInvoiceTitle,
                'enterpriseNo': d.enterpriseNo
              };
              _this.payEnterpriseListData.push(enterprise);
            }
          });
        } else {
          _this.showPayEnterprise = false;
        }
      });
    },
    updatepayEnterprise: function updatepayEnterprise() {
      var self = this;
      console.log(self.payEnterpriseList);
      var payEnterpriseNos = [];
      self.payEnterpriseList.forEach(function (payEnterpriseNo) {
        if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
          payEnterpriseNos.push(payEnterpriseNo.enterpriseNo);
        }
      });
      self.$weui.loading('正在更新订单开票抬头');
      var param = {
        payEnterpriseNoList: payEnterpriseNos,
        rootOrderId: self.order.id
      };
      self.gcapi('updateOnlineOrderPayEnterprise', param).then(function (response) {
        self.$weui.loading().hide();
        self.$weui.toast('更新成功！', 2500);
      });
    }
  })
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_FooterPlaceholder__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import $ from 'jquery'


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    myAllCoupons: {
      type: Array,
      default: []
    },
    comeFrom: {
      type: Boolean,
      default: undefined
    }
  },
  components: { FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__components_FooterPlaceholder___default.a },
  data: function data() {
    return {
      // 选择的优惠券，可能为现金券或者为折扣券
      chosenCoupons: [],
      // 客户自己选择的现金券
      selectedCashCoupon: null,
      displayAllCoupons: [],
      couponShowRule: [],
      availableUniqueCoupons: this.$route.query.availableUniqueCoupons,
      useDiscountCouponOnly: this.$route.query.useDiscountCouponOnly,
      defaultSelectedCoupons: this.$route.query.defaultSelectedCoupons,
      fetchAllCouponsFinish: false,
      presentCoupon: null,
      showPresentCoupon: false,
      receiverCustomerName: null,
      receiverCustomerMobile: null
    };
  },

  watch: {
    'availableAndUnAvailableCoupons': {
      handler: 'setInitialDisplayCoupons',
      immediate: true
    }
  },
  methods: {
    jumpTo: function jumpTo() {
      __WEBPACK_IMPORTED_MODULE_4_wx___default.a.miniProgram.switchTab({
        url: '/pages/category/newCategory'
      });
    },
    setInitialDisplayCoupons: function setInitialDisplayCoupons() {
      var _this = this;

      if (!this.unAvailableCoupons) return;
      var displayCoupons = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.availableAndUnAvailableCoupons));
      // const defaultCheckedCouponGuids = (this.defaultSelectedCoupons && this.defaultSelectedCoupons.map(coupon => coupon.promotionGuid)) || []
      this.chosenCoupons = [];
      console.log(this.defaultSelectedCoupons);
      if (this.defaultSelectedCoupons) {
        this.defaultSelectedCoupons.forEach(function (item) {
          displayCoupons.forEach(function (coupon) {
            var chosenCouponPromotionGuids = _this.chosenCoupons.map(function (coupon) {
              return coupon.promotionGuid;
            });
            if (item.code === item.promotionGuid + 'zhe') {
              if (item.promotionGuid.includes(coupon.promotionGuid)) {
                if (!chosenCouponPromotionGuids.includes(coupon.promotionGuid)) {
                  _this.chosenCoupons.push(coupon);
                } else {
                  // 重复的未被选择的折扣券用repeat属性来区分
                  coupon.repeat = true;
                }
              }
            } else {
              if (item.promotionGuid.includes(coupon.promotionGuid) && item.code.includes(coupon.code)) {
                if (!chosenCouponPromotionGuids.includes(coupon.promotionGuid)) {
                  _this.chosenCoupons.push(coupon);
                } else {
                  // 重复的未被选择的折扣券用repeat属性来区分
                  coupon.repeat = true;
                }
              }
            }
          });
        });
      }
      var unchosedCoupons = displayCoupons.filter(function (coupon) {
        return !_this.chosenCoupons.includes(coupon);
      });
      this.displayAllCoupons = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.chosenCoupons), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(unchosedCoupons));
      this.couponShowRule = this.displayAllCoupons.map(function (coupon) {
        return false;
      });
    },
    checkBoxIsDisabled: function checkBoxIsDisabled(coupon) {
      if (this.useDiscountCouponOnly) return true;
      if (this.getCouponEnabled(coupon) === false) return true;
    },
    toggleShowRule: function toggleShowRule(index) {
      this.$set(this.couponShowRule, index, !this.couponShowRule[index]);
    },
    checkChosenCoupons: function checkChosenCoupons() {
      if (this.useDiscountCouponOnly === false) {
        if (this.chosenCoupons.length > 1) {
          this.$weui.topTips('只能选择一张现金券', 2000);
          // $.toast('只能选择一张现金券')
          return false;
        }
      } else {
        if (this.chosenCoupons.length !== this.defaultSelectedCoupons.length) {
          this.$weui.topTips('折扣券不支持选择', 2000);
          // $.toast('折扣券不支持选择')
          return false;
        }
      }
      return true;
    },
    confirmCoupon: function confirmCoupon() {
      if (!this.checkChosenCoupons()) {
        return;
      }
      console.log(this.$route.params, 'params');
      this.$router.replace({ name: 'WeappOrderContentConfirmation', query: { chosenCoupons: this.chosenCoupons, comeFrom: this.$route.params.comeFrom } });
    },
    getCouponStyle: function getCouponStyle(coupon) {
      return this.getCouponEnabled(coupon) ? {} : { background: '#fff' };
    },
    getUnavailableStyle: function getUnavailableStyle(coupon) {
      return this.getCouponEnabled(coupon) ? { color: '#998776' } : { color: '#979797' };
    },
    getCouponValueStyle: function getCouponValueStyle(coupon) {
      return this.getCouponEnabled(coupon) ? { 'font-size': '32px', 'color': '#361B00' } : { 'font-size': '32px', 'color': '#979797' };
    },
    getLeftCirclePath: function getLeftCirclePath(coupon) {
      return this.getCouponEnabled(coupon) ? '/static/img/svg/左半圆.svg' : '/static/img/svg/白左半圆.svg';
    },
    getRightCirclePath: function getRightCirclePath(coupon) {
      return this.getCouponEnabled(coupon) ? '/static/img/svg/右半圆.svg' : '/static/img/svg/白右半圆.svg';
    },
    currentExcluded: function currentExcluded(coupon) {
      // 优惠券互斥
      if (!this.getCouponEnabled(coupon) || this.chosenCoupons.length === 0) {
        return false;
      }
      if (this.useDiscountCouponOnly) {
        return !this.chosenCoupons.map(function (coupon) {
          return coupon.code;
        }).includes(coupon.code) || coupon.repeat === true;
      } else {
        return !this.chosenCoupons.map(function (coupon) {
          return coupon.code;
        }).includes(coupon.code);
      }
    },
    handleSelectionChange: function handleSelectionChange(coupon) {
      if (coupon.type === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].COUPON_TYPE_DISCOUNT) {
        this.$weui.topTips('折扣券不支持重新选择', 2000);
        return;
      }
      if (this.getCouponEnabled(coupon) === false) {
        this.$weui.topTips('此优惠券不可用', 2000);
        return;
      }
      var couponCodes = this.chosenCoupons.map(function (coupon) {
        return coupon.code;
      });
      this.chosenCoupons = couponCodes.includes(coupon.code) ? [coupon] : [];
      console.log('handleSelectionChange coupon selected', coupon, this.chosenCoupons, couponCodes);
    },
    getCouponDiscount: function getCouponDiscount(coupon) {
      if (!coupon || !coupon.value) {
        return '';
      }
      var discount = (1 - coupon.value) * 10;
      if (!discount) {
        return '';
      }
      var twoDigit = discount.toFixed(2);
      if (twoDigit && twoDigit.toString().endsWith('0')) {
        return discount.toFixed(1);
      } else {
        return discount.toFixed(2);
      }
    },
    showPresentCouponDialog: function showPresentCouponDialog(coupon) {
      console.log('-------------', coupon);
      this.showPresentCoupon = true;
      this.presentCoupon = coupon;
    },
    transferCoupon: function transferCoupon() {
      var _this2 = this;

      var self = this;
      if (!self.presentCoupon) {
        self.$weui.topTips('请选择一张优惠券', 2500);
        return;
      }
      if (!self.receiverCustomerName || !self.receiverCustomerMobile) {
        self.$weui.topTips('请输入姓名和手机号', 2500);
        return;
      }
      if (self.receiverCustomerName === this.sessionInfo.customerInfo.customerName && self.receiverCustomerMobile === this.sessionInfo.customerInfo.mobile) {
        self.$weui.topTips('您已有该优惠券，不能重复转赠', 2500);
        return;
      }
      this.$weui.loading('请稍等....');
      var transferCouponParam = {};
      transferCouponParam.customerNo = this.sessionInfo.customerInfo.customerNo;
      transferCouponParam.customerName = this.sessionInfo.customerInfo.customerName;
      transferCouponParam.receiveCustomerName = self.receiverCustomerName;
      transferCouponParam.receiveCustomerMobile = self.receiverCustomerMobile;
      transferCouponParam.promotionGuid = self.presentCoupon.promotionGuid;
      transferCouponParam.couponCode = self.presentCoupon.code;
      transferCouponParam.value = self.presentCoupon.value;
      transferCouponParam.type = self.presentCoupon.type;
      console.log('transferCoupon:', transferCouponParam);
      self.gcapi('transferCoupon', transferCouponParam).then(function (res) {
        _this2.$weui.loading('请稍等....').hide();
        if (res.message) {
          _this2.$weui.topTips(res.message, 3000);
        } else {
          self.myAllCoupons.forEach(function (item, index) {
            if (self.presentCoupon.code.includes(item.code)) {
              self.myAllCoupons.splice(index, 1);
            }
          });
          _this2.$weui.topTips('转赠成功', 3000);
        }
        self.showPresentCoupon = false;
        self.presentCoupon = null;
        _this2.receiverCustomerName = null;
        _this2.receiverCustomerMobile = null;
      });
    },
    close: function close() {
      this.showPresentCoupon = false;
      this.presentCoupon = null;
      this.receiverCustomerName = null;
      this.receiverCustomerMobile = null;
    },
    getCouponDisabledText: function getCouponDisabledText(coupon) {
      return coupon.enableFlag !== 1 ? '(未启用)' : '';
    },
    getCouponEnabled: function getCouponEnabled(coupon) {
      return coupon.available && coupon.enableFlag === 1 || false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['cartList', 'sessionInfo']), {
    unAvailableCoupons: function unAvailableCoupons() {
      if (this.comeFrom) {
        console.log(!this.myAllCoupons && !this.availableUniqueCoupons);
        if (!this.myAllCoupons && !this.availableUniqueCoupons) return [];
        var availableCouponCodes = void 0;
        if (this.availableUniqueCoupons) {
          availableCouponCodes = this.availableUniqueCoupons.map(function (coupon) {
            return coupon.promotionGuid;
          });
          var coupons = this.myAllCoupons.filter(function (coupon) {
            return !availableCouponCodes.includes(coupon.promotionGuid);
          });
          coupons.forEach(function (coupon) {
            coupon.available = false;
          });
          return coupons;
        } else {
          var _coupons = [];
          this.myAllCoupons.forEach(function (item) {
            item.available = false;
            _coupons.push(item);
          });
          return _coupons;
        }
      }
    },
    availableCoupons: function availableCoupons() {
      if (!this.myAllCoupons || !this.availableUniqueCoupons) return [];
      var availableCouponCodes = this.availableUniqueCoupons.map(function (coupon) {
        return coupon.promotionGuid;
      });
      var coupons = this.myAllCoupons.filter(function (coupon) {
        return availableCouponCodes.includes(coupon.promotionGuid);
      });
      coupons.forEach(function (coupon) {
        coupon.available = true;
      });
      return coupons;
    },
    availableAndUnAvailableCoupons: function availableAndUnAvailableCoupons() {
      if (!this.unAvailableCoupons) return [];
      return this.availableCoupons || this.availableCoupons.length > 0 ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.availableCoupons), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.unAvailableCoupons)) : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.unAvailableCoupons));
    }
  })
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderMerchandises__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderMerchandises___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrderMerchandises__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderContentFramework__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderContentFramework___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OrderContentFramework__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrivateMixins_OrderConfirmationMixin__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_fc_Order_ServiceProduct__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_fc_Order_ServiceProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_fc_Order_ServiceProduct__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isService: false,
      type: 'tools',
      fapiaoTitleSameAsEnterprise: false,
      showChooseBalanceAccount: false,
      showChoosePayMethod: false,
      showAccountVerifyBox: false,
      showMerchandises: false,
      verifyCode: '',
      nameQuery: '',
      mobileQuery: '',
      discountPrice: '',
      totalMoney: '',
      goodsMoney: '',
      expressPrice: '',
      orderList: [],
      showButton: false,
      order: null,
      selectedBalanceType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER,
      selectedPayType: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].PAY_TYPE_FAPIAO,
      yueyanzheng: false,
      restPayCustomerNo: '',
      selectCoupon: null,
      defaultTitle: '',
      taxpayerIdentificationNo: '',
      invoiceAddress: [],
      SettlementAccountNameList: [],
      chosenSettlementAccount: null,
      chosenSettlementAccountName: '',
      workExperienceList: [],
      workExperienceNameList: [],
      ifNeedChooseWorkExperience: false,
      chosenWorkExperienceName: '',
      chosenWorkExperience: null,
      payTypeOptionMapping: {
        '1': 2,
        '3': 0,
        '6': 3,
        '7': 4
      },
      // usePrePay: false,
      // 验证他人余额账户是否成功
      verifyFinish: false,
      settlementAccountList: [],
      defaultInvoiceAddress: true,
      payEnterpriseIndex: null,
      payEnterpriseListData: [],
      ListPayEnterprise: [],
      firstLevelEnterpriseNoMap: __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('EmktFirstLevelEnterpriseNoMap')
    };
  },

  components: {
    ServiceProduct: __WEBPACK_IMPORTED_MODULE_10__views_fc_Order_ServiceProduct___default.a,
    OrderMerchandises: __WEBPACK_IMPORTED_MODULE_5__OrderMerchandises___default.a,
    OrderContentFramework: __WEBPACK_IMPORTED_MODULE_6__OrderContentFramework___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__PrivateMixins_OrderConfirmationMixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['sessionInfo', 'currentWaitPayOrder', 'invoiceInfo']), {
    displayOrderNo: function displayOrderNo() {
      return this.order && this.order.orderNo || '';
    },
    availableRestMoney: function availableRestMoney() {
      if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
        return 0;
      } else {
        return this.sessionInfo.customerInfo.prepayMoneyRemain;
      }
    },
    balanceTypeName: function balanceTypeName() {
      return this.selectedBalanceType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER ? '请选择结算账户' : this.chosenSettlementAccount === null ? '请选择结算账户' : this.chosenSettlementAccount.settlementAccountName;
    },
    payTypeName: function payTypeName() {
      return this.selectedPayType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].PAY_TYPE_FAPIAO ? '发票支付' : '余额支付';
    },
    showBalanceTypeMethod: function showBalanceTypeMethod() {
      // if (!this.settlementAccountList || this.settlementAccountList.length === 0) {
      //   return false
      // }
      return true;
    },
    canUseOtherAccount: function canUseOtherAccount() {
      if (this.order && !this.order.specialFundCouponUsed && this.availableRestMoney === 0) return true;
      if (this.order && this.order.specialFundCouponUsed && this.order.specialFundCouponUsed === 1) return false;
    },
    displayInvoiceAddress: function displayInvoiceAddress() {
      if (this.defaultInvoiceAddress && this.invoiceAddress && this.invoiceAddress.length > 0) {
        return this.invoiceAddress[0];
      } else if (!this.defaultInvoiceAddress) {
        return this.sessionInfo.expressAddress.find(function (item) {
          return item.addressStatus !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ADDRESS_STATUS.ADDRESS_STATUS_INVALID && (item.isDefault === 2 || item.isDefault === 3);
        });
      } else {
        return {};
      }
    },
    payEnterpriseList: function payEnterpriseList() {
      return this.payEnterpriseListData;
    },
    canAddPayEnterprise: function canAddPayEnterprise() {
      return this.payTypeName === '发票支付';
    }
  }),
  watch: {
    'selectedPayType': {
      handler: 'handlePayTypeChange'
    },
    'selectedBalanceType': {
      handler: 'handleBalanceTypeChange'
    },
    'invoiceInfo': function invoiceInfo(val) {
      var samePayEnterprise = this.payEnterpriseListData.find(function (mer) {
        return val.enterpriseNo === mer.enterpriseNo;
      });
      console.log(samePayEnterprise);
      if (samePayEnterprise) {
        this.$weui.topTips('该开票抬头已经存在！不可重复添加！');
        return;
      }
      var ldata = this.payEnterpriseListData[this.payEnterpriseIndex];
      var lsamePayEnterprise = this.ListPayEnterprise.findIndex(function (mer) {
        return ldata.enterpriseNo === mer.enterpriseNo;
      });
      if (lsamePayEnterprise !== -1) {
        // 说明是修改
        this.ListPayEnterprise.splice(lsamePayEnterprise, 1, val);
      } else {
        this.ListPayEnterprise.push(val);
      }
      this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val);
      console.log(val);
    },
    'ListPayEnterprise': function ListPayEnterprise(val) {
      console.log('ListPayEnterprise', val);
    }
  },
  mounted: function mounted() {
    this.solveServiceProduct(this.currentWaitPayOrder);
    this.setInitialFapiaoInfo();
    this.fetchTotalMoney();
    this.getResearchGroupAndWorkExperience();
    console.log(this.order, 'this.order');
  },

  // beforeRouteEnter (to, from, next) { // 若从活动页面跳转到登录页面，登录成功后返回活动页面
  //   console.log('to from ', to, from)
  //   next(vm => {
  //     if (from.name && (from.name === 'WeappOrderConfirmation')) {
  //       vm.gotoWeappCart()
  //     }
  //   })
  // },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET']), {
    solveServiceProduct: function solveServiceProduct(waitPayOrder) {
      if (waitPayOrder) {
        if (waitPayOrder.orderType === 3) {
          this.isService = true;
          this.defaultInvoiceAddress = false;
          this.available();
          waitPayOrder.solution = JSON.parse(waitPayOrder.solutionJson);
          // // 此处不是补丁，不可删除 todo duplicateDataType验证
          // waitPayOrder.solution.children.forEach(i => {
          //   i.groups.forEach(it => {
          //     if (it.parameterValues && it.parameterValues.length > 0) {
          //       it.parameterValues.forEach(ite => {
          //         if (ite.dataType) {
          //           ite.duplicateDataType = ite.dataType
          //         }
          //       })
          //     }
          //   })
          //   if (i.parameterValues && i.parameterValues.length > 0) {
          //     i.parameterValues.forEach(item => {
          //       item.duplicateDataType = item.dataType
          //     })
          //   }
          // })
          // waitPayOrder.solution.operationType = 20
          // waitPayOrder.solution.orderSource = 1
          this.order = waitPayOrder;
          console.log(this.order.solution, '修补后的方案');
        } else {
          this.order = waitPayOrder;
        }
      }
    },
    getResearchGroupAndWorkExperience: function getResearchGroupAndWorkExperience(customerNo) {
      var _this2 = this;

      var _this = this;
      customerNo = _this.sessionInfo.customerInfo.customerNo;
      // 获取所有的课题组信息\
      _this.gcapi('getHistoricalPayEnterprises').then(function (res) {
        var list = res.body.result;
        _this.payEnterpriseListData = [];
        if (list && list.length > 0) {
          list.forEach(function (data) {
            var firstLevelEnterprise = _this2.firstLevelEnterpriseNoMap[data];
            if (firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
              var payEnterprisedata = { 'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
                'enterpriseNo': firstLevelEnterprise.enterpriseNo };
              if (firstLevelEnterprise !== undefined) {
                _this.payEnterpriseListData.push(payEnterprisedata);
              }
              _this2.$weui.loading('正在提交数据！').hide();
              // this.$weui.alert('开票抬头默认为' + firstLevelEnterprise.enterpriseInvoiceTitle)
            }
          });
        }
      }).then(function (response) {
        _this.gcapi('getSettlementAccountListInfo', customerNo).then(function (res) {
          if (res.body.result) {
            // const researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
            // const researchGroupSet = res.body.result.bResearchGroupList
            // this.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap)
            // this.UPDATE_RESEARCHGROUP_SET(researchGroupSet)
            // if (!this.researchGroupSet || this.researchGroupSet.length === 0) return
            // // 获取所有课题组列表,选择课题组初始默认值
            // this.researchGroupNameList = this.researchGroupSet.map((group) => {
            //   return group.researchGroupName
            // })
            // // 选择第一个正常的课题组为默认课题组
            // for (let i = 0; i < this.researchGroupSet.length; i++) {
            //   if (this.researchGroupSet[i].status === emkt.RESEARCH_GROUP_STATUS_NORMAL) {
            //     this.chosenResearchGroupName = this.researchGroupSet[i].researchGroupName
            //     this.chosenResearchGroup = this.researchGroupSet[i]
            //     break
            //   }
            // }
            // console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet)
            _this.settlementAccountList = res.body.result;
            if (!_this.settlementAccountList || _this.settlementAccountList.length === 0) {
              _this.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
              return;
            }
            // 获取所有课题组列表,选择课题组初始默认值
            _this.SettlementAccountNameList = _this.settlementAccountList.map(function (group) {
              return group.settlementAccountName;
            });
            // 选择第一个正常的课题组为默认课题组
            for (var i = 0; i < _this.settlementAccountList.length; i++) {
              if (_this.settlementAccountList[i].settlementAccountStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
                var _ret = function () {
                  _this.chosenSettlementAccountName = _this.settlementAccountList[i].researchGroupName;
                  var payEnterprisedata = { enterpriseInvoiceTitle: _this.settlementAccountList[i].firstLevelEnterpriseInvoiceTitle,
                    enterpriseNo: _this.settlementAccountList[i].firstLevelEnterpriseNo };
                  _this.ListPayEnterprise.push(payEnterprisedata);
                  var ent = _this.payEnterpriseListData.find(function (data) {
                    return data.enterpriseNo === payEnterprisedata.enterpriseNo;
                  });
                  var firstLevelEnterprise = _this2.firstLevelEnterpriseNoMap[_this.settlementAccountList[i].firstLevelEnterpriseNo];
                  if (!ent && firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
                    _this.payEnterpriseListData.push(payEnterprisedata);
                  }
                  _this.chosenSettlementAccount = _this.settlementAccountList[i];
                  _this.selectedBalanceType = _this.chosenSettlementAccount;
                  return 'break';
                }();

                if (_ret === 'break') break;
              }
            }
            if (_this.chosenSettlementAccount === null) {
              _this.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
              return;
            }
          }
          // if (this.isService) {
          // this.buildServiceOrderParams(_this.sessionInfo.customerInfo.customerNo)
          // } else {
          _this.calculatePriceByAccountDiscountRatio(_this.sessionInfo.customerInfo.customerNo);
          // }
        });
      });
      // // 过滤掉无效的任职关系
      // this.gcapi('getWorkExperienceList', customerNo).then(res => {
      //   if (res && res.body.result) {
      //     const workList = res.body.result.filter(work => {
      //       return work.enable === true
      //     })
      //     emkt.setStoreItem('EmktWorkExperienceList', workList)
      //   } else {
      //     emkt.setStoreItem('EmktWorkExperienceList', [])
      //   }
      //   // 获取所有有效的任职关系列表，选择任职关系初始默认值
      //   this.workExperienceList = emkt.getLocalStorage('EmktWorkExperienceList')
      //   if (this.workExperienceList && this.workExperienceList.length > 0) {
      //     this.workExperienceNameList = this.workExperienceList.map(work => {
      //       return work.firstLevelEnterpriseName + (work.secondLevelEnterpriseName ? work.secondLevelEnterpriseName : '')
      //     })
      //   } else {
      //     // 如果该客户无任职关系信息，取客户的个人信息中的单位信息
      //     const customerInfo = this.sessionInfo.customerInfo
      //     if (customerInfo && customerInfo.enterpriseNo) {
      //       const enterprise = {
      //         firstLevelEnterpriseNo: customerInfo.enterpriseNo,
      //         firstLevelEnterpriseName: customerInfo.enterpriseName
      //       }
      //       this.workExperienceList = [enterprise]
      //       this.workExperienceNameList = [customerInfo.enterpriseName]
      //     }
      //   }
      //   // if (this.workExperienceNameList.length > 1) {
      //   //   this.ifNeedChooseWorkExperience = true
      //   // } else {
      //   //   this.ifNeedChooseWorkExperience = false
      //   // }
      //   this.chosenWorkExperienceName = this.workExperienceNameList[0]
      //   this.chosenWorkExperience = this.workExperienceList[0]
      //   console.log('nameList', this.settlementAccountList, this.SettlementAccountNameList, this.workExperienceList, this.workExperienceNameList)
      //   if (this.ifNeedChooseWorkExperience) {
      //     this.showOptionList('workExperience', 0)
      //   }
      //   console.log('EmktWorkExperienceList', emkt.getLocalStorage('EmktWorkExperienceList'))
      // })
    },
    setInitialFapiaoInfo: function setInitialFapiaoInfo() {
      var self = this;
      var invoiceTitle = this.sessionInfo.invoiceTitle;
      if (invoiceTitle) {
        var defTitle = invoiceTitle.filter(function (item) {
          return item.isDefault === 1;
        });
        if (defTitle.length > 0) {
          this.defaultTitle = defTitle[0].enterpriseName;
          this.taxpayerIdentificationNo = defTitle[0].invoiceTaxRegNo;
        }
      }
      if (this.order) {
        var item = {};
        item.expressAddress = this.order.expressAddress;
        item.consignee = this.order.expressContactor;
        item.expressMobile = this.order.expressPhone;
        item.province = '';
        item.city = '';
        item.district = '';
        self.invoiceAddress.push(item);
        if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('defaultInvoiceAddress') === undefined || __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].getLocalStorage('defaultInvoiceAddress') === true) {
          self.defaultInvoiceAddress = true;
        } else {
          self.defaultInvoiceAddress = false;
        }
      }
      // this.sessionInfo.invoiceAddress.forEach(function (item) {
      //   if (item.isDefault) {
      //     self.invoiceAddress.push(item)
      //     self.defaultInvoiceAddress = false
      //   }
      // })
    },
    available: function available() {
      if (this.defaultInvoiceAddress) {
        __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('defaultInvoiceAddress', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].setLocalStorage('defaultInvoiceAddress', false);
      }
    },
    handleBalanceTypeChange: function handleBalanceTypeChange() {
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER) {
        var chosenName = this.selectedBalanceType.settlementAccountName;
        var chosenAccount = this.selectedBalanceType.settlementAccountNo;
        if (this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          var status = this.selectedBalanceType.settlementAccountStatus;
          if (status !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
            this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
            this.$weui.alert(chosenName + '已冻结，请联系业务员解锁');
            return;
            // return alert(chosenName + '未启用，请选择其他课题组')
          }
          var researchGroupStatus = this.selectedBalanceType.researchGroupStatus;
          if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_DISABLE) {
            this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
            this.$weui.alert(chosenName + '(' + chosenAccount + '):\u8BE5\u8BFE\u9898\u7EC4\u672A\u542F\u7528\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u7ED3\u7B97\u8D26\u6237');
            return;
            // return alert(chosenName + '未启用，请选择其他课题组')
          }
          if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_LOCKED) {
            this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
            this.$weui.alert(chosenName + '(' + chosenAccount + '):\u8BE5\u8BFE\u9898\u7EC4\u5DF2\u51BB\u7ED3\uFF0C\u8BF7\u8054\u7CFB\u4E1A\u52A1\u5458\u89E3\u9501');
            return;
            // return alert(chosenName + '未启用，请选择其他课题组')
          }
          if (researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_EXPIRED) {
            this.selectedBalanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
            this.$weui.alert(chosenName + '(' + chosenAccount + '):\u8BE5\u8BFE\u9898\u7EC4\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u7ED3\u7B97\u8D26\u6237');
            return;
            // return alert(chosenName + '未启用，请选择其他课题组')
          }
        }
        console.log('selectedPayType', this.selectedPayType);
        this.checkSettmentAccount();
        this.showButton = true;
        // this.$weui.topTips('您已选择' + chosenName + ',可用信用额度' + this.selectedBalanceType.availableCredit + '元', 2500, 'warning')
        // this.$weui.info('您已选择' + chosenName + ',可用信用额度' + this.selectedBalanceType.availableCredit + '元', 3000)
        this.chosenSettlementAccountName = chosenName;
        this.chosenSettlementAccount = this.selectedBalanceType;
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
        // this.updateChoice('research')
      } else {
        this.chosenSettlementAccountName = '';
        this.chosenSettlementAccount = null;
        this.payEnterpriseListData = [];
      }
    },
    checkSettmentAccount: function checkSettmentAccount() {
      console.log(this.selectedPayType);
      if (this.selectedPayType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        if (this.restPayCustomerNo !== this.selectedBalanceType.prepayCustomerNo) {
          this.chosenSettlementAccountName = '';
          this.chosenSettlementAccount = null;
          console.log(this.chosenSettlementAccount !== null);
          this.$weui.alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择结算账户！');
          return;
        } else {
          this.payEnterpriseListData = [];
          this.ListPayEnterprise = [];
          var firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.selectedBalanceType.firstLevelEnterpriseNo];
          if (firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
            var payEnterprisedata = { 'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
              'enterpriseNo': firstLevelEnterprise.enterpriseNo };
            if (firstLevelEnterprise !== undefined) {
              this.payEnterpriseListData.push(payEnterprisedata);
              this.ListPayEnterprise.push(payEnterprisedata);
            }
            // this.$weui.alert('开票抬头默认为' + firstLevelEnterprise.enterpriseInvoiceTitle)
          }
        }
      } else {
        if (this.selectedBalanceType.isBindPrepayCustomer && this.selectedBalanceType.prepayCustomerNo !== this.sessionInfo.customerInfo.customerNo) {
          this.chosenSettlementAccountName = '';
          this.chosenSettlementAccount = null;
          this.payEnterpriseListData = [];
          this.$weui.alert('该结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用，请选择其他结算账户');
          return;
        }
      }
    },
    updateBalanceAccount: function updateBalanceAccount() {
      this.showChooseBalanceAccount = false;
      this.choosevip(this.payTypeOptionMapping[this.payType]);
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#' + id).focus();
    },
    toggleShowMerchandises: function toggleShowMerchandises() {
      this.showMerchandises = !this.showMerchandises;
    },
    fetchTotalMoney: function fetchTotalMoney() {
      if (this.currentWaitPayOrder) {
        var result = this.currentWaitPayOrder;
        this.goodsMoney = result.price;
        this.expressPrice = result.expressPrice;
        this.totalMoney = result.totalPrice;
        this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : 0;
      }
    },
    getOptionListHtml: function getOptionListHtml(optionList, optionName) {
      var className = 'radio-input-attr';
      var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' + '<input type="radio"  class="' + className + '" name="attr" value="';
      var ret2 = '';
      var ret3 = '" ><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">';
      var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">';
      var height = '';
      var length = 0;
      var chosenValue = optionName === 'research' ? this.chosenSettlementAccountName : this.chosenWorkExperienceName;
      for (var i = 0; i < optionList.length; i++) {
        var name = optionList[i];
        if (chosenValue === name) {
          ret2 += ret1 + name + '" id="' + i + ret4 + name + '</div></div></label></li>';
        } else {
          ret2 += ret1 + name + '" id="' + i + ret3 + name + '</div></div></label></li>';
        }
        length++;
      }
      var ret;
      if (length <= 7) {
        height = 2.1 * length + 1;
        ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      } else {
        ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">';
      }
      ret = ret + ret2 + '</ul></div></div>';
      return ret;
    },
    showOptionList: function showOptionList(optionName, chooseIndex) {
      if (optionName !== 'research' && this.ifNeedChooseWorkExperience === false) {
        console.log('不需要选择任职关系');
        // if (chooseIndex === 2) {
        //   this.payByRestMoney(true)
        // }
        return;
      }
      var optionList = optionName === 'research' ? this.SettlementAccountNameList : this.workExperienceNameList;
      var title = optionName === 'research' ? '请选择结算账户' : '请选择您目前的任职信息';
      var error = optionName === 'research' ? '您尚未新建过结算账户' : '';
      if (optionList.length === 0) {
        if (error) {
          // this.$weui.alert(error)
          alert(error);
        }
        return;
      }
      // this.$weui.dialog({
      //   title: title,
      //   content: this.getOptionListHtml(optionList, optionName),
      //   buttons: [{
      //     label: '关闭',
      //     type: 'primary',
      //     onClick: () => {
      //     }
      //   }]
      // })
      __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.modal({
        title: title,
        afterText: this.getOptionListHtml(optionList, optionName),
        buttons: [{
          text: '关闭',
          bold: true,
          onClick: function onClick() {}
        }]
      });
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.radio-input-attr').on('click', function (e) {
        e.preventDefault();
        if (optionName === 'research') {
          // debugger
          var id = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).attr('id');
          var chosenName = self.SettlementAccountNameList[id];
          console.log('radio id', id);
          if (self.settlementAccountList[id].settlementAccountStatus !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
            return self.$weui.alert(chosenName + '已被冻结，请联系业务员解锁');
          }
          // if (self.settlementAccountList[id].status === emkt.RESEARCH_GROUP_STATUS_LOCKED) {
          //   return self.$weui.alert(chosenName + '已被冻结，请联系业务员解锁')
          // }
          // if (self.settlementAccountList[id].status === emkt.RESEARCH_GROUP_STATUS_EXPIRED) {
          //   return self.$weui.alert(chosenName + '已过期，请选择其他课题组')
          // }
          var val = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).val();
          console.log('click', val);
          __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.closeModal();
          this.$weui.toast('您已选择' + val, 1500);
          // $.toast('您已选择' + val)
          self.chosenSettlementAccountName = val;
          self.updateChoice(optionName);
          if (chooseIndex === 4) {
            var _val = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).val();
            // debugger
            console.log('click', _val);
            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.closeModal();
            // if (chooseIndex === 2 || chooseIndex === 4) {
            //   self.payByRestMoney(false)
            // }
          }
          self.calculatePriceByAccountDiscountRatio(self.customerNo);
        } else {
          var _val2 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).val();
          // debugger
          console.log('click', _val2);
          __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.closeModal();
          self.chosenWorkExperienceName = _val2;
          self.updateChoice(optionName);
          // if (chooseIndex === 2) {
          //   self.payByRestMoney(true)
          // }
        }
      });
    },
    updateChoice: function updateChoice(optionName) {
      if (optionName === 'research' && this.chosenSettlementAccountName) {
        var index = this.SettlementAccountNameList.indexOf(this.chosenSettlementAccountName);
        if (index !== -1) {
          console.log('chosenSettlementAccount', this.chosenSettlementAccountName, this.settlementAccountList[index]);
          this.chosenSettlementAccount = this.settlementAccountList[index];
        }
      }
      if (optionName !== 'research' && this.chosenWorkExperienceName) {
        var _index = this.workExperienceNameList.indexOf(this.chosenWorkExperienceName);
        if (_index !== -1) {
          console.log('chosenWorkExperience', this.workExperienceList[_index]);
          this.chosenWorkExperience = this.workExperienceList[_index];
        }
      }
    },
    selectAddress: function selectAddress() {
      if (!this.defaultInvoiceAddress) {
        this.$router.push({ name: 'myInvoiceAddress', params: { order: this.order } });
      }
    },
    choosevip: function choosevip(index) {
      switch (index) {
        case 0:
          // 发票付款
          this.showOptionList('workExperience', index);
          this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo);
          break;
        case 3:
          // 选择课题组结算发票支付
          this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo);
          break;
        case 4:
          // 选择课题组结算余额支付 优惠促销以课题组优惠为主，但是余额账户金额需大于此订单金额
          this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo);
          break;
        case 2:
          // 余额付款 更新选择的任职经历
          this.showOptionList('workExperience', index);
          this.calculatePriceByAccountDiscountRatio(this.restPayCustomerNo);
      }
    },
    goToGoodsDetail: function goToGoodsDetail() {
      this.$router.push({ name: 'orderContentDetail', query: { order: this.order } });
    },
    displayMessage: function displayMessage(val) {
      if (!val) {
        return;
      }
      var message = void 0;
      var title = '';
      switch (val) {
        case 1:
          title = '支付方式说明';
          message = '支持发票支付(先货后款)和余额支付（账户余额支付）两种方式。选择发票支付下单后，我们将会主动联系您开具发票并安排寄送；选择余额支付后，您将使用自己账户的余额进行消费。也支持使用他人账户余额，使用前需进行系统验证。';
          break;
        case 2:
          title = '结算账户说明';
          message = '结算方式分为个人结算账户与课题组账户结算两种方式。选择课题组结算，提交订单后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。';
          break;
        // case 4:
        //   message = '该订单包含【第三方】商品，此商品不支持余额付款。' +
        //     '请您使用线下付款或者将【第三方】商品与【自营】商品分开购买！'
        //   break
        // case 5:
        //   message = '订单提交后，将使用您的蓝V储值账户余额支付订单货款。余额不足时，' +
        //     '请选择其他支付方式。为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人蓝V储值账户余额，' +
        //     '请准确填写储值帐号的姓名和手机号码进行授权。'
        //   break
        // case 2:
        //   message = '订单提交后，将使用您的信用支付额度支付订单货款。信用支付额度不足时，请选择其他支付方式。' +
        //     '同时，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。货款到位后，您的账户将恢复相应信用支付额度。' +
        //     '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。'
        //   break
        // case 6:
        //   message = '订单提交后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。'
        //   break
        // case 7:
        //   message = '订单提交后，将计入您所在课题组的消费。同时订单货款将使用您的账户余额支付。余额不足时，请选择其他支付方式。' +
        //     '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。'
      }
      this.$weui.dialog({
        title: title,
        content: message,
        buttons: [{
          label: '我知道了'
        }]
      });
      // alert(message)
    },
    toMini: function toMini(bOrders) {
      var so = [];
      if (this.order.solution) {
        so.push(this.order.solution.id);
      } else {
        so.push({});
      }
      __WEBPACK_IMPORTED_MODULE_9_wx___default.a.miniProgram.navigateTo({
        url: '/pages/protocol/index?bOrders=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(bOrders) + '&solution=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(so)
      });
    },
    orderPay: function orderPay() {
      var _this3 = this;

      this.showButton = false;
      if (this.chosenSettlementAccount === null) {
        return;
      }
      if (this.ListPayEnterprise.length < 1) {
        this.$weui.topTips('请先填写订单开票抬头！', 3500);
        return;
      }
      var saveItemInOrderKey = 0;
      var convertedPayType = this.payType;
      // 其余结算方式需要保存任职关系
      if (this.payType !== '6' && this.payType !== '7') {
        saveItemInOrderKey = 0;
        console.log('this chosenwork', this.chosenWorkExperience);
      }
      // 课题组结算需要保存课题组信息
      if (this.payType === '6') {
        convertedPayType = '3'; // 课题组结算属于发票付款
        saveItemInOrderKey = 1;
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
      }
      if (this.payType === '7') {
        convertedPayType = '1'; // 课题组结算属于账户余额
        saveItemInOrderKey = 1;
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
        // if (!this.usePrePay) {
        //   alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
        //   // setTimeout(() => { this.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式') }, 3000)
        //   // return
        // }
      }
      if (convertedPayType === '1') {
        if (this.restPayCustomerNo !== this.chosenSettlementAccount.prepayCustomerNo) {
          var Account = this.settlementAccountList.filter(function (d) {
            return d.prepayCustomerNo === _this3.restPayCustomerNo;
          });
          var name = '';
          if (Account.length !== 0) {
            name = Account[0].settlementAccountName;
          }
          alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择[' + name + ']结算账户！');
          // setTimeout(() => {
          //   this.$weui.alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择结算账户！')
          // }, 300)
          return;
        }
      }
      if (convertedPayType === '1') {
        if (!this.verifyFinish && (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0)) {
          alert('使用余额付款必须先验证，请您先验证！');
          // setTimeout(() => {
          //   this.$weui.alert('使用余额付款必须先验证，请您先验证！')
          // }, 3000)
          return;
        } else {
          this.successPay(saveItemInOrderKey, convertedPayType);
        }
      } else {
        if (this.selectedBalanceType.isBindPrepayCustomer && this.selectedBalanceType.prepayCustomerNo !== this.sessionInfo.customerInfo.customerNo) {
          // setTimeout(() => {
          //   this.$weui.alert('您选择的结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用')
          // }, 3000)
          alert('您选择的结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用');
          return;
        }
        this.successPay(saveItemInOrderKey, convertedPayType);
      }
    },
    successPay: function successPay(saveItemInOrderKey, convertedPayType) {
      var _this4 = this;

      console.log('this.chosenSettlementAccount', this.chosenSettlementAccount);
      console.log('saveItemInOrderKey', convertedPayType, saveItemInOrderKey);
      var saveItem = {};
      saveItem.settlementAccountNo = this.chosenSettlementAccount.settlementAccountNo;
      if (this.chosenSettlementAccount === null) {
        this.$weui.alert('请选择结算账户或者联系业务员给您新建结算账户', 1500);
        return;
      }
      saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo;
      saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName;
      saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo;
      saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName;
      if (saveItemInOrderKey === 1 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chosenSettlementAccount) !== '{}') {
        // if (!this.chosenSettlementAccount.discountA || !this.chosenSettlementAccount.discountB || !this.chosenSettlementAccount.discountC) {
        //   return alert('您选择的课题组未设置折扣率，请联系客服')
        // }
        saveItem.balanceType = 1; // 课题组结算
        saveItem.researchGroupApproveResult = 0; // 审批状态 不需要审批
        saveItem.researchGroupNo = this.chosenSettlementAccount.researchGroupNo;
        saveItem.researchGroupName = this.chosenSettlementAccount.researchGroupName;
      } else if (saveItemInOrderKey === 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chosenSettlementAccount) !== '{}') {
        saveItem.balanceType = 0; // 个人结算
        saveItem.researchGroupApproveResult = 0; // 审批状态 不需要审批
      }
      console.log('saveItem', saveItem);
      var self = this;
      var bOrders = [];
      var invoiceExpressContactor = '';
      var invoiceExpressAddress = '';
      var invoiceExpressPhone = '';

      if (convertedPayType === '3' && !this.displayInvoiceAddress) {
        self.$weui.topTips('请先添加发票寄送地址', 3500);
        return;
      }
      if (convertedPayType === '3' && this.displayInvoiceAddress) {
        var invoice = this.displayInvoiceAddress;
        invoiceExpressContactor = invoice.consignee;
        invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress;
        invoiceExpressPhone = invoice.expressMobile;
      } else {
        invoiceExpressContactor = '';
        invoiceExpressAddress = '';
        invoiceExpressPhone = '';
      }
      var payEnterpriseNos = [];
      self.ListPayEnterprise.forEach(function (payEnterpriseNo) {
        if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
          payEnterpriseNos.push(payEnterpriseNo.enterpriseNo);
        }
      });
      if (payEnterpriseNos.length < 1) {
        self.$weui.topTips('请先填写订单开票抬头！', 3500);
        return;
      }
      var bOrder = {
        payType: convertedPayType,
        id: this.order.id,
        invoiceTitle: this.defaultTitle,
        taxpayerIdentificationNo: this.taxpayerIdentificationNo,
        invoiceExpressContactor: invoiceExpressContactor,
        invoiceExpressAddress: invoiceExpressAddress,
        invoiceExpressPhone: invoiceExpressPhone,
        prepayCustomerNo: this.restPayCustomerNo,
        customerStoredPlanNo: '',
        payEnterpriseNos: payEnterpriseNos
      };
      if (this.isService) {
        bOrder.orderType = 3;
        console.log(this.order, '修改审核状态的order对象');
      } else {
        bOrder.orderType = 1;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(bOrder, saveItem);
      console.log('border', bOrder);
      console.log('本订单选择的发票信息---》', this.ListPayEnterprise);
      bOrder.amplification = self.order.amplification;
      bOrders.push(bOrder);
      this.gcapi('checkBeforeOrderPay', bOrders).then(function (res) {
        console.log(res.body);
        if (bOrder.orderType === 3) {
          _this4.showButton = true;
          if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp) {
            _this4.toMini(bOrders);
          } else {
            _this4.$router.push({ name: 'centerController', params: { bOrders: bOrders, solution: _this4.order.solution.id } });
          }
        } else {
          _this4.$weui.loading().hide();
          _this4.showButton = true;
          if (__WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].isWapp) {
            _this4.toMini(bOrders);
          } else {
            _this4.$router.push({ name: 'centerController', params: { bOrders: bOrders } });
          }
        }
      });
    },
    checkInfo: function checkInfo() {
      if (this.defaultTitle === '') {
        // $.toast('请选择发票抬头')
        return false;
      } else {
        return true;
      }
    },

    // buildServiceOrderParams (customerNo) {
    //   let object = {
    //     'customerNo': customerNo,
    //     'researchGroupNo': this.chosenSettlementAccount.researchGroupNo,
    //     'settlementAccountNo': this.chosenSettlementAccount.settlementAccountNo,
    //     'bOrders': {}
    //   }
    //   let bOrders = {
    //     'id': this.order.id,
    //     'payType': this.order.payType,
    //     'balanceType': this.order.balanceType,
    //     'amplification': this.order.amplification
    //   }
    //   object.bOrders = bOrders
    //   console.log(object, '构建完的object')
    // },
    calculatePriceByAccountDiscountRatio: function calculatePriceByAccountDiscountRatio(customerNo) {
      var _this5 = this;

      this.$weui.loading('加载中....');
      var self = this;
      if (self.chosenSettlementAccount === null) {
        self.$weui.topTips('请您选择可结算的结算账户', 2500);
        self.$weui.loading('加载中....').hide();
        return;
      }
      if (Number(self.payType) === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY && !self.chosenSettlementAccount.prepayCustomerNo) {
        self.$weui.topTips('选择账户余额结算时，必须使用账户余额绑定的结算账户，请联系客服！', 2500);
        self.$weui.loading('加载中....').hide();
        return;
      }
      self.showButton = true;
      self.yueyanzheng = true;
      var bOrders = [];
      var invoiceExpressContactor = '';
      var invoiceExpressAddress = '';
      var invoiceExpressPhone = '';
      if (this.displayInvoiceAddress) {
        var invoice = this.displayInvoiceAddress;
        invoiceExpressContactor = invoice.consignee;
        invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress;
        invoiceExpressPhone = invoice.expressMobile;
      }
      var bOrder = {
        payType: self.payType,
        id: self.order.id,
        invoiceTitle: self.defaultTitle,
        taxpayerIdentificationNo: self.taxpayerIdentificationNo,
        invoiceExpressContactor: invoiceExpressContactor,
        invoiceExpressAddress: invoiceExpressAddress,
        invoiceExpressPhone: invoiceExpressPhone,
        prepayCustomerNo: customerNo,
        customerStoredPlanNo: ''
      };
      bOrder.amplification = self.order.amplification;
      bOrders.push(bOrder);
      var obj = {};
      obj.bOrders = bOrders;
      obj.customerNo = customerNo;
      obj.settlementAccountNo = self.chosenSettlementAccount.settlementAccountNo;
      // 计算折扣率时，传入结算方式和课题组编号
      if (self.payType === '6') {
        bOrder.payType = '3';
        if (self.chosenSettlementAccount.settlementAccountType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_RESEARCH_GROUP;
          obj.researchGroupNo = self.chosenSettlementAccount.researchGroupNo;
        } else {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        }
      } else if (self.payType === '7') {
        bOrder.payType = '1';
        this.payEnterpriseListData = [];
        this.ListPayEnterprise = [];
        var firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.chosenSettlementAccount.firstLevelEnterpriseNo];
        var payEnterprisedata = { 'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
          'enterpriseNo': firstLevelEnterprise.enterpriseNo };
        if (firstLevelEnterprise !== undefined && firstLevelEnterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
          this.payEnterpriseListData.push(payEnterprisedata);
          this.ListPayEnterprise.push(payEnterprisedata);
        }
        if (self.chosenSettlementAccount.settlementAccountType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_RESEARCH_GROUP;
        } else {
          bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
        }
      } else {
        if (self.payType === '1') {
          this.payEnterpriseListData = [];
          this.ListPayEnterprise = [];
          var _firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.chosenSettlementAccount.firstLevelEnterpriseNo];
          var _payEnterprisedata = { 'enterpriseInvoiceTitle': _firstLevelEnterprise.enterpriseInvoiceTitle,
            'enterpriseNo': _firstLevelEnterprise.enterpriseNo };
          if (_firstLevelEnterprise !== undefined && _firstLevelEnterprise.enterpriseType !== __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].ENTERPRISE_TYPE_COMPANY) {
            this.payEnterpriseListData.push(_payEnterprisedata);
            this.ListPayEnterprise.push(_payEnterprisedata);
          }
        }
        bOrder.balanceType = __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER;
      }
      console.log('calculatePriceByAccountDiscountRatio', obj);
      if (self.isService) {
        self.gcapi('getServiceProductPriceByAccountDiscount', obj).then(function (res) {
          _this5.$weui.loading('加载中....').hide();
          if (res.message) {
            _this5.$weui.topTips(res.message, 3000);
            _this5.showButton = false;
            return;
          }
          console.log(res, '服务类产品的调用新的接口的返回值');
          if (res.body.code === 0) {
            var result = res.body.result[0];
            // if (bOrder.payType === '1') {
            //   const obj = {'customerNo': self.restPayCustomerNo, 'price': result.price}
            //   self.gcapi('hasPrepayRemain', obj).then((response) => {
            //     if (!response.body.result) {
            //       self.usePrePay = false
            //       this.showButton = false
            //       self.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
            //     } else {
            //       self.usePrePay = true
            //     }
            //   })
            // }
            if (self.order) {
              self.order.price = result.price;
              self.order.price = result.price;
              self.order.initPrice = result.initPrice;
              self.order.totalPrice = result.totalPrice;
              self.order.discountPrice = result.discountPrice;
              self.totalMoney = result.totalPrice;
            }
          }
        });
      } else {
        self.gcapi('calculatePriceByAccountDiscountRatio', obj).then(function (response) {
          _this5.$weui.loading('加载中....').hide();
          if (response.message) {
            _this5.$weui.topTips(response.message, 3000);
            _this5.showButton = false;
            return;
          }
          if (response.body.result !== null && response.body.result.length > 0) {
            self.selectCoupon = response.body.result[0].coupons && response.body.result[0].coupons[0];
            // var total = response.body.result[0].price
            // if (bOrder.payType === '1') {
            //   const obj = {'customerNo': self.restPayCustomerNo, 'price': response.body.result[0].price}
            //   self.gcapi('hasPrepayRemain', obj).then((response) => {
            //     if (!response.body.result) {
            //       self.usePrePay = false
            //       this.showButton = false
            //       self.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
            //     } else {
            //       self.usePrePay = true
            //     }
            //   })
            // }
            // self.gcapi('getSAOccupiedAmountAndExpiredInvoiceNum', this.chosenSettlementAccount.settlementAccountNo).then((response) => {
            //   let result = response.body.result
            //   if (result.availableCredit - total < 0) {
            //     self.$weui.alert('您使用的结算账户可用信用额度为' + result.availableCredit + '元，余额不够，请使用其他结算账户')
            //   }
            //   if (result.expiredInvoiceNum && result.expiredInvoiceNum > 0) {
            //     self.$weui.alert('您使用的结算账户有' + result.expiredInvoiceNum + '张超过信用期的发票，不可下单，请使用其他结算账户')
            //   }
            // })
            if (self.order.merchandises.length === 1) {
              self.order.merchandises[0].price = response.body.result[0].price;
              self.order.merchandises[0].discountPrice = response.body.result[0].discountPrice;
              self.order.price = response.body.result[0].price;
              self.order.initPrice = response.body.result[0].initPrice;
              self.order.totalPrice = response.body.result[0].totalPrice;
              self.order.discountPrice = response.body.result[0].discountPrice;
              self.totalMoney = response.body.result[0].totalPrice;
            } else {
              var price = 0;
              var totalPrice = 0;
              var initPrice = 0;
              var discountPrice = 0;
              if (self.order.subOrders.length > 0) {
                for (var i = 0; i < response.body.result[0].subOrders.length; i++) {
                  for (var j = 0; j < self.order.subOrders.length; j++) {
                    if (response.body.result[0].subOrders[i].id === self.order.subOrders[j].id) {
                      price = price + response.body.result[0].subOrders[i].price;
                      initPrice = initPrice + response.body.result[0].subOrders[i].initPrice;
                      totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice;
                      discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice;
                      if (!self.order.subOrders[j].isStock) {
                        self.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price;
                        self.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice;
                        self.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice;
                      } else {
                        // 增加现货折扣后价格
                        for (var n = 0; n < self.order.merchandises.length; n++) {
                          for (var o = 0; o < response.body.result[0].subOrders[i].stocks.length; o++) {
                            if (response.body.result[0].subOrders[i].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                              self.order.merchandises[n].price = response.body.result[0].subOrders[i].stocks[o].price;
                              self.order.merchandises[n].initPrice = response.body.result[0].subOrders[i].stocks[o].initPrice;
                              self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[i].stocks[o].discountPrice;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else if (response.body.result[0].subOrders.length > 0) {
                for (var m = 0; m < response.body.result[0].subOrders.length; m++) {
                  for (var _n = 0; _n < self.order.merchandises.length; _n++) {
                    if (response.body.result[0].subOrders[m].id === self.order.merchandises[_n].orderGuid) {
                      if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                        for (var _o = 0; _o < response.body.result[0].subOrders[m].stocks.length; _o++) {
                          if (response.body.result[0].subOrders[m].stocks[_o].merchandiseGuid === self.order.merchandises[_n].merchandiseGuid && self.order.merchandises[_n].presentQuantity === 0) {
                            price = price + response.body.result[0].subOrders[m].stocks[_o].price;
                            initPrice = initPrice + response.body.result[0].subOrders[m].stocks[_o].initPrice;
                            totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[_o].totalPrice;
                            discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[_o].discountPrice;
                          }
                        }
                      } else {
                        if (self.order.merchandises[_n].presentQuantity === 0) {
                          price = price + response.body.result[0].subOrders[m].price;
                          initPrice = initPrice + response.body.result[0].subOrders[m].initPrice;
                          totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice;
                          discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice;
                        }
                      }
                      //                      if (self.order.merchandises[n].isStock) {
                      //                        discountPrice = discountPrice + self.order.merchandises[n].discountPrice
                      //                      } else {
                      //                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
                      //                      }
                      if (self.order.merchandises[_n].categoryId === 20) {
                        self.order.merchandises[_n].price = response.body.result[0].subOrders[m].price;
                        self.order.merchandises[_n].initPrice = response.body.result[0].subOrders[m].initPrice;
                        self.order.merchandises[_n].discountPrice = response.body.result[0].subOrders[m].discountPrice;
                      } else if (self.order.merchandises[_n].presentQuantity === 0) {
                        // 现货更新商品价格
                        for (var _o2 = 0; _o2 < response.body.result[0].subOrders[m].stocks.length; _o2++) {
                          if (response.body.result[0].subOrders[m].stocks[_o2].merchandiseGuid === self.order.merchandises[_n].merchandiseGuid && self.order.merchandises[_n].presentQuantity === 0) {
                            self.order.merchandises[_n].price = response.body.result[0].subOrders[m].stocks[_o2].price;
                            self.order.merchandises[_n].initPrice = response.body.result[0].subOrders[m].stocks[_o2].initPrice;
                            self.order.merchandises[_n].discountPrice = response.body.result[0].subOrders[m].stocks[_o2].discountPrice;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                // 更新现货折扣后价格
                if (response.body.result[0].isStock && response.body.result[0].stocks.length > 0) {
                  for (var _n2 = 0; _n2 < self.order.merchandises.length; _n2++) {
                    for (var _o3 = 0; _o3 < response.body.result[0].stocks.length; _o3++) {
                      if (response.body.result[0].stocks[_o3].merchandiseGuid === self.order.merchandises[_n2].merchandiseGuid && self.order.merchandises[_n2].presentQuantity === 0) {
                        price = price + response.body.result[0].stocks[_o3].price;
                        initPrice = initPrice + response.body.result[0].stocks[_o3].initPrice;
                        totalPrice = totalPrice + response.body.result[0].stocks[_o3].totalPrice;
                        discountPrice = discountPrice + response.body.result[0].stocks[_o3].discountPrice;

                        self.order.merchandises[_n2].price = response.body.result[0].stocks[_o3].price;
                        self.order.merchandises[_n2].initPrice = response.body.result[0].stocks[_o3].initPrice;
                        self.order.merchandises[_n2].discountPrice = response.body.result[0].stocks[_o3].discountPrice;
                      }
                    }
                  }
                }
              }
              self.order.price = price;
              self.order.totalPrice = totalPrice;
              self.order.initPrice = initPrice;
              self.order.discountPrice = discountPrice;
              self.totalMoney = totalPrice;
            }
          }
        });
      }
    },
    getSettmentType: function getSettmentType(settlementAccount) {
      if (settlementAccount.settlementAccountType === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
        return settlementAccount.researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_DISABLE ? '*未启用' : settlementAccount.researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_LOCKED ? '*已冻结' : settlementAccount.researchGroupStatus === __WEBPACK_IMPORTED_MODULE_3__emkt__["a" /* default */].RESEARCH_GROUP_STATUS_EXPIRED ? '*已过期' : '';
      } else {
        return '';
      }
    },
    getPayExperienceLabel: function getPayExperienceLabel(label) {
      if (label) {
        return label.length > 15 ? label.substring(0, 15) + '...' : label;
      } else {
        return null;
      }
    },
    getMainClass: function getMainClass(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main3';
    },
    getMainStyle: function getMainStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'float: right;' : 'float: right;';
    },
    getTextStyle: function getTextStyle(payEnterprise) {
      return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);';
    },
    addPayEnterprise: function addPayEnterprise() {
      var payEnterprise = {};
      this.payEnterpriseListData.push(payEnterprise);
      console.log('this.payEnterpriseList', this.payEnterpriseList);
    },
    removePayEnterprise: function removePayEnterprise(index) {
      var ldata = this.payEnterpriseListData[index];
      this.payEnterpriseListData.splice(index, 1);
      var lsamePayEnterprise = this.ListPayEnterprise.findIndex(function (mer) {
        return ldata.enterpriseNo === mer.enterpriseNo;
      });
      if (lsamePayEnterprise !== -1) {
        // 说明是修改
        this.ListPayEnterprise.splice(lsamePayEnterprise, 1);
      }
      console.log('this.payEnterpriseList', this.payEnterpriseList);
    },
    openSerchPayEnterprise: function openSerchPayEnterprise(index, val) {
      this.payEnterpriseIndex = index;
    }
  })
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderMerchandises__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderMerchandises___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrderMerchandises__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CouponSelection__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CouponSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__CouponSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderContentFramework__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderContentFramework___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__OrderContentFramework__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_fc_Order_ServiceProduct__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_fc_Order_ServiceProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_fc_Order_ServiceProduct__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      serviceProductCanUseCoupons: [],
      materialReceives: [],
      children: [],
      subLines: [],
      isService: false,
      solution: {},
      solutionId: null,
      isExpress: false,
      showCouponSelectionBox: false,
      address: null,
      orderList: [],
      discountPrice: '',
      totalMoney: '',
      goodsMoney: '',
      expressPrice: '',
      specialGuid: '',
      // 用户选择的所有优惠券
      selectedCoupons: [],
      // 用户选择的现金券
      selectCoupon: null,
      // 仅使用折扣券
      useDiscountCouponOnly: false,
      availableCoupons: null,
      // 折扣券优惠券金额
      specialDiscountPrice: 0,
      productInfo: {
        value: null
      },
      showButton: true,
      calculatedPriceMerchandises: [],
      // 购物车数据
      cartContent: null
    };
  },

  components: {
    ServiceProduct: __WEBPACK_IMPORTED_MODULE_13__views_fc_Order_ServiceProduct___default.a,
    OrderMerchandises: __WEBPACK_IMPORTED_MODULE_8__OrderMerchandises___default.a,
    CouponSelection: __WEBPACK_IMPORTED_MODULE_9__CouponSelection___default.a,
    OrderContentFramework: __WEBPACK_IMPORTED_MODULE_10__OrderContentFramework___default.a
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 若从活动页面跳转到登录页面，登录成功后返回活动页面
    next(function (vm) {
      if (from.name && from.name === 'WeappOrderConfirmation') {
        vm.gotoWeappCart();
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['cartList', 'sessionInfo', 'currentWaitPayOrder', 'secPromotionDetailObj']), {
    // 筑研服务券
    specialFundCoupon: function specialFundCoupon() {
      if (!this.selectedCoupons) return null;
      var fundCoupon = this.selectedCoupons.filter(function (cou) {
        return cou.type === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_SPECIAL_FUND;
      })[0] || null;
      return fundCoupon;
    },

    //  新折扣券
    newDiscountCoupon: function newDiscountCoupon() {
      if (!this.selectedCoupons) return null;
      return this.selectedCoupons.filter(function (cou) {
        return cou.type === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_NEW_DISCOUNT;
      })[0] || null;
    },
    displayNameOnlyCoupon: function displayNameOnlyCoupon() {
      return this.specialFundCoupon || this.newDiscountCoupon;
    },
    orderForMerchandises: function orderForMerchandises() {
      return {
        expressPrice: this.expressPrice,
        totalPrice: this.totalMoney,
        price: this.goodsMoney,
        coupons: this.selectCoupon ? [this.selectCoupon] : [],
        merchandises: this.calculatedPriceMerchandises
      };
    },
    deliverAddress: function deliverAddress() {
      if (!this.address || this.address.length === 0) {
        return null;
      }
      var defaultAddress = this.address.find(function (addre) {
        return addre.addressStatus !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].ADDRESS_STATUS.ADDRESS_STATUS_INVALID && (addre.isDefault === 1 || addre.isDefault === 3);
      });
      return defaultAddress || this.address[0];
    },
    couponDiscount: function couponDiscount() {
      if (!this.selectedCoupons || this.selectedCoupons.length === 0) {
        return 0;
      }
      return this.useDiscountCouponOnly ? Math.abs(this.specialDiscountPrice) : this.selectCoupon && this.selectCoupon.value;
    }
  }),
  watch: {
    selectCoupon: function selectCoupon(val) {
      // 选择现金券后，仅当可用现金券时，重新计算价格
      if (this.useDiscountCouponOnly) return;
      if (this.isService) {
        this.$refs.service.getSolutionPriceAgain();
      } else {
        this.fetchTotalMoney();
      }
    },

    'sessionInfo': {
      handler: function handler(val) {
        if (!val) return;
        this.address = this.sessionInfo.expressAddress;
        if (this.address === undefined) {
          this.$weui.topTips('请登录', 2000);
          // $.toast('请登录')
          return;
        } else {
          this.orderList && this.orderList.length > 0 && this.fetchTotalMoney();
        }
      },
      immediate: true
    },
    'cartList': {
      handler: 'getCartCheckedProducts',
      immediate: true
    },
    totalMoney: function totalMoney(val) {
      if (val && val > 0) {
        this.showButton = true;
      }
    }
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapMutations */])(['SET_CURRENT_WAITPAY_ORDER', 'ADD_CHECK_LIST', 'REMOVE_ALL_CHECKLIST_FROM_CART_LIST']), {
    getServiceTotalMoney: function getServiceTotalMoney(price) {
      console.log('价格传递');
      this.totalMoney = price[0];
    },
    newsubmitOrder: function newsubmitOrder() {
      var _this2 = this;

      this.gcapi('checkEnterpriseType').then(function (res) {
        _this2.submit();
      });
    },
    gotoWeappCart: function gotoWeappCart() {
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_12_wx___default.a.miniProgram.switchTab({
          url: '/pages/cart/cart'
        });
      } else {
        this.$router.replace({ name: 'cart' });
      }
    },
    goToSelectCoupons: function goToSelectCoupons() {
      // 若使用筑研服务抵用券，不支持修改
      if (this.specialFundCoupon) return;
      // console.log(this.selectedCoupons, 'bnsjdnvkcslobvucbhsc')
      // this.$router.push({name: 'WeappCouponSelection', query: {availableUniqueCoupons: this.availableCoupons, useDiscountCouponOnly: this.useDiscountCouponOnly, defaultSelectedCoupons: this.selectedCoupons, fromOrderPage: true}})
      this.$router.push({ name: 'myCoupons',
        query: {
          availableUniqueCoupons: this.availableCoupons,
          useDiscountCouponOnly: this.useDiscountCouponOnly,
          defaultSelectedCoupons: this.selectedCoupons,
          fromOrderPage: true },
        params: {
          isService: this.isService,
          comeFrom: this.$route.query.comeFrom
        } });
    },
    getCartCheckedProducts: function getCartCheckedProducts() {
      var _this3 = this;

      // this.$weui.loading('正在加载数据~')
      if (!this.cartList || !this.cartList.cartContent) return;
      var cartContent = this.filterCartData(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.cartList.cartContent));
      var products = [];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cartContent).forEach(function (item) {
        cartContent[item]['cartId'] = item;
        if (cartContent[item].smartAttributes) {
          products.push(__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].convertProduct(cartContent[item]));
        } else {
          products.push(cartContent[item]);
        }
      });
      this.orderList = products.filter(function (pro) {
        return pro.isChecked;
      });
      if (this.orderList.length === 0) {
        return;
      }
      if (this.orderList[0].categoryId) {
        console.log('ssssssssssssssss', this.orderList);
        if (this.orderList[0].categoryId === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT) {
          this.isService = true;
          this.solution = {
            'questionDesc': new Date().getTime() + '问题',
            'name': new Date().getTime() + '方案',
            'diseaseDirection': parseInt(this.orderList[0].allData.diseaseDirectionId),
            'diseaseName': this.orderList[0].allData.diseaseDirectionName,
            'templateId': 1
          };
          var arr = [];
          var number = -1;
          this.orderList.forEach(function (item) {
            var object = {
              'receiveType': 2,
              'isReceived': 0,
              'notReceivedType': 1,
              'sampleType': item.allData.loSampleTypeId, // 样本类型
              'receiveDesc': item.allData.sampleType, // 样本类型名称
              'returnType': item.allData.returnMaterialChecked ? 1 : 2,
              'relatedEuIdList': [] // 关联实验
            };
            _this3.materialReceives.push(object);
            var euIdGroup = [];
            item.allData.boSolution.children.forEach(function (items) {
              var puIdGroup = [];
              items.id = number - 1;
              number = number - 1;
              items.children.forEach(function (it) {
                it.id = number - 1;
                number = number - 1;
                puIdGroup.push(it.id);
              });
              items.groups.forEach(function (i) {
                if (i.parameterValues) {
                  if (i.parameterValues.length > 0) {
                    i.parameterValues.forEach(function (its) {
                      its.value = item.allData.sampleType;
                    });
                  }
                }
              });
              items.skuID = item.allData.currSkuId;
              items.otherTaxName = item.allData.otherSampleSpecName;
              console.log(item.allData, items.otherTaxName);
              items.subLines = [];
              if (puIdGroup.length > 1) {
                puIdGroup.forEach(function (iss, index) {
                  if (index < puIdGroup.length - 1) {
                    items.subLines.push({
                      'northId': puIdGroup[index],
                      'southId': puIdGroup[index + 1]
                    });
                  }
                });
              }
              arr.push(items);
              euIdGroup.push(items.id);
            });
            if (item.allData.boSolution.children.length === 2) {
              _this3.subLines.push({
                'northId': euIdGroup[0],
                'southId': euIdGroup[1]
              });
            }
          });
          this.children = arr;
        }
        var arrString = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
        this.children.forEach(function (item) {
          if (item.template.externalName !== undefined) {
            arrString.add(item.template.externalName);
          }
        });
        var string = '';
        arrString.forEach(function (item) {
          string = string + item + '、';
        });
        string = string.substr(0, string.length - 1);
        this.solution.questionDesc = string;
        this.solution.name = string;
        this.ADD_CHECK_LIST(this.orderList);
      }
      if (!this.isService) {
        var cangoNext = true;
        // for (var i in this.orderList) {
        //   if (this.orderList[i].newMerch === undefined && (this.orderList[i].manualFileName.indexOf('腺相关') !== -1 || this.orderList[i].manualFileName.indexOf('神经环路标记病毒') !== -1)) {
        //     this.$weui.alert('老师：您好！\n' +
        //         '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' +
        //         '感谢您的支持！')
        //     cangoNext = false
        //     return
        //   }
        // }
        if (cangoNext) {
          this.ADD_CHECK_LIST(this.orderList);
          this.orderList && this.address && this.fetchTotalMoney();
        }
      }
      this.$weui.loading('正在加载数据~').hide();
    },

    /**
         * 为了防止购物车工具类和服务类的isChecked都为true，特地添加此过滤方法来确保服务类和工具类产品数据分开
         * service 来源于服务类购物车的跳转,
         * tools来源于工具类购物车的跳转
         * orderService 购物清单中服务类的跳转
         * orderTools 购物清单中工具类的跳转
         * @param data
         * @return {*}
         */
    filterCartData: function filterCartData(data) {
      console.log(this.$route);
      if (this.$route.query.comeFrom) {
        if (this.$route.query.comeFrom.includes('ervice')) {
          for (var key in data) {
            if (data[key].categoryId !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT) {
              delete data[key];
            }
          }
        } else if (this.$route.query.comeFrom.includes('ools')) {
          for (var _key in data) {
            if (data[_key].categoryId === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].PRODUCT_TYPE_SERVICE_CONSTANT) {
              delete data[_key];
            }
          }
        }
        return data;
      } else {
        return data;
      }
    },
    changeExpressFree: function changeExpressFree() {
      var self = this;
      if (self.isExpress === false) {
        self.fetchTotalMoney();
      } else {
        this.$weui.dialog({
          content: '如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {
              self.isExpress = false;
            }
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              __WEBPACK_IMPORTED_MODULE_11_jquery___default.a.showIndicator();
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_11_jquery___default.a.hideIndicator();
              }, 300);
              self.fetchTotalMoney();
            }
          }]
        });
        // $.confirm('如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。',
        //   function () {
        //     $.showIndicator()
        //     setTimeout(function () {
        //       $.hideIndicator()
        //     }, 300)
        //     self.fetchTotalMoney()
        //   },
        //   function () {
        //     self.isExpress = false
        //   })
      }
    },
    autofocus: function autofocus(id) {
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#' + id).focus();
    },
    submit: function submit() {
      if (this.isService) {
        this.beforeSubmitServiceOrder();
      } else {
        this.submitOrder();
      }
    },
    beforeSubmitServiceOrder: function beforeSubmitServiceOrder() {
      var _this4 = this;

      this.$weui.loading('正在提交数据！');
      this.gcapi('loCreateSolution', this.solution).then(function (res) {
        if (res.body.code === 0) {
          var data = JSON.parse(res.body.result);
          _this4.solutionId = data.id;
          var object = {
            'id': _this4.solutionId,
            'children': _this4.children,
            'subLines': _this4.subLines,
            'sortOrderManualModified': false
          };
          _this4.gcapi('loUpdateSolutionTopology', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(object)).then(function (res) {
            if (res.body.code === 0) {
              _this4.gcapi('loLoadSolutionDetail', _this4.solutionId).then(function (res) {
                if (res.body.code === 0) {
                  var result = JSON.parse(res.body.result);
                  object.children.forEach(function (item, index) {
                    item.groups.forEach(function (item) {
                      if (item.parameterValues && item.parameterValues.length > 0) {
                        item.parameterValues.forEach(function (it) {
                          if (it.dataType) {
                            it.duplicateDataType = it.dataType;
                          }
                        });
                      }
                    });
                    result.children[index].groups = item.groups;
                    result.children[index].parameterValues = item.parameterValues;
                    result.children[index].taxId = item.taxId;
                    result.children[index].skuId = item.skuID;
                    console.log(result.children[index].skuId, 'sdsiuhi');
                    if (item.otherTaxName) {
                      result.children[index].otherTaxName = item.otherTaxName;
                    }
                    // 物料关联EU的Id
                    if (_this4.materialReceives[index]) {
                      _this4.materialReceives[index].relatedEuIdList = [].concat(result.children[index].id);
                    }
                    console.log(result.children[index].otherTaxName, 'sdsiuhi');
                  });
                  var materialObject = {
                    'materialReceives': _this4.materialReceives,
                    'solutionId': _this4.solutionId,
                    'pushMaterialNotification': true // 淘基因下单默认推送实物信息表和送样指南

                    // 先调用获取方案详情接口 获取每个EU的Id 绑定到实物上 再调用保存方物料信息接口
                  };_this4.gcapi('loSaveMaterialInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(materialObject)).then(function (res) {
                    if (res.body.code !== 0) {
                      _this4.$weui.toast('保存物料信息失败，请联系客服!', 2000);
                    } else {
                      result['id'] = _this4.solutionId;
                      result['orderSource'] = '1';
                      result['operationType'] = 20;
                      _this4.gcapi('loUpdateSolutionInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(result)).then(function (res) {
                        _this4.$weui.loading().hide();
                        _this4.gcapi('loLoadSolutionDetail', _this4.solutionId).then(function (res) {});
                        _this4.submitServiceOrder(res.body.result);
                      });
                    }
                  });
                }
                console.log(JSON.parse(res.body.result), '方案详情');
                console.log(object);
              });
            } else {
              _this4.$weui.toast('保存拓扑结构图失败，请联系客服!', 2000);
            }
          });
        } else {
          _this4.$weui.toast('保存方案失败，请联系客服!', 2000);
        }
      });
    },
    submitServiceOrder: function submitServiceOrder(solutionJson) {
      var _this5 = this;

      var object = {
        'solutionJsons': [solutionJson],
        'coupons': this.selectedCoupons
      };
      this.gcapi('submitServiceProductOrder', object).then(function (res) {
        console.log(res.body, '提交订单返回');
        if (res.body.code === 0) {
          var order = res.body.result;
          console.log('submit order', order);
          _this5.SET_CURRENT_WAITPAY_ORDER(order);
          //  clear cart content 如果是购物清单的数据，那么将不会清除
          if (_this5.$route.query.comeFrom !== 'orderService') {
            _this5.REMOVE_ALL_CHECKLIST_FROM_CART_LIST();
          }
          if (!__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp) {
            _this5.gcapi('retrieveMyOrder').then(function (response) {
              _this5.$router.replace({ name: 'WeappOrderConfirmation' });
            });
          } else {
            _this5.$router.replace({ name: 'WeappOrderConfirmation' });
          }
        }
      });
    },
    submitOrder: function submitOrder() {
      var _this6 = this;

      var bMerchandises = this.productInfo.value;
      if (!bMerchandises) {
        return;
      }
      var order = void 0;
      var _this = this;
      bMerchandises.orderType = '1';
      _this.$weui.loading('结算中');
      // $.showPreloader('正在进入结算方式页面，请稍等')
      _this.showButton = false;
      _this.gcapi('orderSubmit', bMerchandises).then(function (response) {
        if (response.body.code === 1) {
          _this.$weui.topTips(response.body.message, 6000);
          // $.toast(response.body.message)
          return;
        }
        order = response.body.result;
        order.expressFree = _this6.productInfo.value.expressFree;
        console.log('submit order', order);
        _this.SET_CURRENT_WAITPAY_ORDER(order);
        //  clear cart content 如果源自于购物清单，则不清除购物车中的数据
        if (_this6.$route.query.comeFrom !== 'orderTools') {
          _this6.REMOVE_ALL_CHECKLIST_FROM_CART_LIST();
        }
        // todo push-replace
        // this.$router.replace({name: 'WeappOrderConfirmation'})
      }).then(function () {
        _this.$weui.loading().hide();
        _this.$router.replace({ name: 'WeappOrderConfirmation' });
        // if (!emkt.isWapp) {
        //   _this.gcapi('retrieveMyOrder').then(response => {
        //     _this.$weui.loading().hide()
        //     _this.$router.replace({name: 'WeappOrderConfirmation'})
        //   })
        // } else {
        //   _this.$weui.loading().hide()
        //   _this.$router.replace({name: 'WeappOrderConfirmation'})
        // }
      });
    },
    getRemark: function getRemark(result) {
      for (var i = 0; i < result.merchandises.length; i++) {
        for (var j = 0; j < this.productInfo.value.merchandises.length; j++) {
          if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
            this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark;
          }
          // 定制产品判断cartID，目前不需要考虑
          // else {
          //   if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
          //     this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark
          //   }
          // }
        }
      }
    },
    getAvailableCoupons: function getAvailableCoupons(result, havePu) {
      var _this7 = this;

      this.$forceUpdate();
      var useSpecialCoupon = false;
      if (this.isService) {
        var os = [];
        var proId = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getLocalStorage('EmktPromotions');
        this.$refs.service.puCouponsGuid.forEach(function (item) {
          proId.forEach(function (it) {
            if (item) {
              if (item === it.promotionGuid) {
                os.push(it);
              }
            }
          });
        });
        os.forEach(function (osItem) {
          if (osItem.description) {
            if (osItem.description.includes('不同享')) {
              result = [];
            }
          }
        });
        os.some(function (osItem) {
          // console.log('os', osItem)
          if (osItem.requiredCustomers) {
            if (osItem.requiredCustomers === 1) {
              var pros = osItem;
              var endDT = new Date(pros.endDT.year, pros.endDT.month, pros.endDT.dayOfMonth, pros.endDT.hourOfDay, pros.endDT.minute, pros.endDT.second);
              var statrDT = new Date(pros.startDT.year, pros.startDT.month, pros.startDT.dayOfMonth, pros.startDT.hourOfDay, pros.startDT.minute, pros.startDT.second);
              var _startDT = _this7.FormatterTime(statrDT).replace(/-/g, '/');
              var _endDT = _this7.FormatterTime(endDT).replace(/-/g, '/');
              var newCoupon = {
                'promotionGuid': pros.promotionGuid,
                'code': _this7.sessionInfo.customerInfo.customerNo + pros.promotionGuid,
                'customerNo': _this7.sessionInfo.customerInfo.customerNo,
                'type': __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_DISCOUNT,
                'label': pros.name,
                'startDT': _startDT,
                'endDT': _endDT,
                'description': pros.description,
                'quantity': pros.quantity
              };
              useSpecialCoupon = true;
              result.push(newCoupon);
              _this7.specialGuid = newCoupon.promotionGuid;
              return true;
            }
          }
        });
        this.useDiscountCouponOnly = useSpecialCoupon;
        // 此订单可以使用的所有优惠券，包括折扣券和现金券
        var _couponlist = [];

        var _loop = function _loop(_j) {
          var flag = true;
          _couponlist.forEach(function (item) {
            if (result[_j].code === item.code) {
              flag = false;
            }
          });
          if (flag) {
            _couponlist.push(result[_j]);
          }
        };

        for (var _j = 0; _j < result.length; _j++) {
          _loop(_j);
        }
        this.availableCoupons = [].concat(_couponlist).sort(function (a, b) {
          return a.type - b.type;
        });
        this.availableCoupons.forEach(function (coupon) {
          coupon.available = true;
        });
      } else {
        for (var i = 0; i < result.merchandises.length; i++) {
          for (var j = 0; j < this.productInfo.value.merchandises.length; j++) {
            if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
              this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark;
            }
          }
          if (result.merchandises[i].perferPromotions) {
            for (var k = 0; k < result.merchandises[i].perferPromotions.length; k++) {
              if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                result.coupons = [];
              }
              if (result.merchandises[i].perferPromotions[k].requiredCustomers === 1) {
                var pro = result.merchandises[i].perferPromotions[k];
                var endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second);
                var statrDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second);
                var startDT1 = this.FormatterTime(statrDT).replace(/-/g, '/');
                var endDT1 = this.FormatterTime(endDT).replace(/-/g, '/');
                var newcoupon = {
                  'promotionGuid': pro.promotionGuid,
                  'code': pro.promotionGuid + 'zhe',
                  'customerNo': this.sessionInfo.customerInfo.customerNo,
                  'type': __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_DISCOUNT,
                  'label': pro.name,
                  'startDT': startDT1,
                  'endDT': endDT1,
                  'description': pro.description,
                  'quantity': pro.quantity
                };
                useSpecialCoupon = true;
                result.coupons.push(newcoupon);
                break;
              }
            }
          }
        }
        this.useDiscountCouponOnly = useSpecialCoupon;
        // 此订单可以使用的所有优惠券，包括折扣券和现金券
        var couponlist = [];

        var _loop2 = function _loop2(_j2) {
          flag = true;

          couponlist.forEach(function (item) {
            if (result.coupons[_j2].code === item.code) {
              flag = false;
            }
          });
          if (flag) {
            couponlist.push(result.coupons[_j2]);
          }
        };

        for (var _j2 = 0; _j2 < result.coupons.length; _j2++) {
          var flag;

          _loop2(_j2);
        }
        this.availableCoupons = [].concat(couponlist).sort(function (a, b) {
          return a.type - b.type;
        });
        this.availableCoupons.forEach(function (coupon) {
          coupon.available = true;
        });
      }
    },
    setDefaultSelectedCoupons: function setDefaultSelectedCoupons() {
      // console.log(this.$route.query.chosenCoupons, '选择的优惠券')
      if (!this.availableCoupons || this.availableCoupons.length === 0) return;
      // 若从选择优惠券界面返回，设置为用户选择的优惠券
      var chosenCoupons = this.$route.query.chosenCoupons;
      if (chosenCoupons && Array.isArray(chosenCoupons)) {
        return this.updateSelectCoupon(this.$route.query.chosenCoupons);
      }
      // 若存在折扣券，目前只支持选择折扣券
      if (this.useDiscountCouponOnly) {
        this.$weui.toast('已为您选择折扣券！', 1500);
        this.selectedCoupons = this.availableCoupons.filter(function (cou) {
          return cou.type === __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_DISCOUNT;
        });
      } else {
        // 选择金额最大的现金券
        this.availableCoupons.sort(function (a, b) {
          return b.value - a.value;
        });
        this.selectCoupon = this.availableCoupons[0];
        this.selectedCoupons = [this.selectCoupon];
        this.$refs.service.getSolutionPriceAgain();
      }
    },
    updateMerchandisesAttributes: function updateMerchandisesAttributes(merchandises) {
      // 更新计算价格后的商品属性，包括基因等信息，通过cartId与购物车商品关联
      if (!merchandises) return;
      var filteredMerchandises = merchandises.filter(function (mer) {
        return mer.presentQuantity === 0;
      });
      var combinedMerchandises = [];
      this.orderList.forEach(function (cartMer) {
        var updatedMerchandise = filteredMerchandises.find(function (mer) {
          return cartMer.cartId === mer.cartId;
        });
        if (!updatedMerchandise) {
          console.log('购物车中无此商品cartID=' + cartMer.cartId);
        } else {
          delete updatedMerchandise._attributesList;
          delete updatedMerchandise._titleList;
          delete updatedMerchandise._subTitleList;
          delete updatedMerchandise._abstractList;
          var combined = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, cartMer, updatedMerchandise);
          combinedMerchandises.push(combined);
        }
      });
      console.log('combinedMerchandises', combinedMerchandises);
      return combinedMerchandises;
    },
    fetchTotalMoney: function fetchTotalMoney() {
      var _this8 = this;

      var self = this;
      var bMerchandises = this.getProductInfo();
      if (!bMerchandises) {
        return;
      }
      this.gcapi('calculateOrderAmount', bMerchandises).then(function (data) {
        var result = data.body.result;
        if (!result) return;
        // 若当前未获取优惠券，获取可选择的优惠券并默认选择最优优惠券
        console.log('this.availableCoupons--->', _this8.availableCoupons);
        if (_this8.availableCoupons === null) {
          _this8.getAvailableCoupons(result);
          _this8.setDefaultSelectedCoupons();
        } else {
          _this8.getRemark(result);
        }
        // console.log(this.productInfo)
        _this8.totalMoney = 0;
        _this8.goodsMoney = 0;
        _this8.expressPrice = 0;
        _this8.goodsMoney = result.price;
        _this8.totalMoney = result.totalPrice;
        _this8.expressPrice = result.expressPrice;
        _this8.calculatedPriceMerchandises = _this8.updateMerchandisesAttributes(result.merchandises);
        // 计算特殊的打折券的折扣金额
        var specialcouponpromotions = __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getLocalStorage('EmktSpecialcouponpromotions');
        var specialDiscountPrice = 0;
        if (specialcouponpromotions && specialcouponpromotions.length > 0) {
          var specialCouponPromotionGuids = specialcouponpromotions.map(function (pro) {
            return pro.promotionGuid;
          });
          result.merchandises.forEach(function (merchandise) {
            var preferPromitionGuid = merchandise.perferPromotions && merchandise.perferPromotions.length > 0 && merchandise.perferPromotions[0].promotionGuid;
            specialDiscountPrice += preferPromitionGuid && specialCouponPromotionGuids.includes(preferPromitionGuid) ? merchandise.discountPrice : 0;
          });
        }
        _this8.specialDiscountPrice = specialDiscountPrice;
        console.log('specialDiscountPrice', specialDiscountPrice, specialcouponpromotions);
        _this8.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : specialDiscountPrice ? Math.abs(+specialDiscountPrice) : 0;
        if (+_this8.totalMoney < 0) {
          _this8.$weui.dialog({
            title: '订单出现异常，请联系客服',
            buttons: [{
              label: '确定',
              type: 'primary',
              onClick: function onClick() {
                self.$router.go(-1);
              }
            }]
          });
        }
      });
    },
    getProductInfo: function getProductInfo() {
      var _this9 = this;

      var self = this;
      var border = {};
      if (this.address === undefined) {
        this.$weui.topTips('请登录', 2000);
        // $.toast('请登录')
        return;
      } else {
        var addr = this.deliverAddress;
        if (!addr && this.sessionInfo.customerInfo.ssoFlag === 0) {
          this.$weui.dialog({
            title: '请先添加收货地址',
            buttons: [{
              label: '确定',
              type: 'primary',
              onClick: function onClick() {
                self.$router.push({ name: 'WeappAddress' });
              }
            }]
          });
          return;
        }
        var city = addr.city === undefined ? '' : addr.city;
        var district = addr.district === undefined ? '' : addr.district;
        border.expressAddress = city + district + addr.expressAddress;
        border.expressPhone = addr.expressMobile;
        border.expressContactor = addr.consignee;
        border.isSingleExpress = true;
      }
      var coupons = [];
      if (!this.useDiscountCouponOnly) {
        var coupon = this.selectCoupon;
        if (coupon) {
          if (this.selectCoupon.type !== 0) {
            coupons.push(coupon);
          }
        }
      }
      border.coupons = coupons;

      var bMerchandises = [];
      if (this.orderList === undefined) {
        this.$weui.topTips('读取数据失败', 2000);
        // $.toast('读取数据失败')
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].getUrlParamHref('fromSmart') === '1') {
        border.isSmartOrder = true;
        border.bsmartProducts = [];
        this.orderList.forEach(function (item) {
          var pro = {
            guid: item.guid,
            smartProductParameterSelection: item.smartProductParameterSelection
          };
          var bMerchandise = {};
          bMerchandise.price = item.price;
          bMerchandise.expressPrice = item.expressPrice;
          bMerchandise.merchandiseGuid = item.guid;
          bMerchandise.workdays = item.workdays;
          bMerchandise.priceMax = item.price;
          bMerchandise.priceMin = item.price;
          bMerchandise.unitPrice = item.price;
          bMerchandise.initPrice = item.price;
          bMerchandise.SKUID = item.SKUID;
          bMerchandise.cartId = item.cartId;
          bMerchandise.productName = item.productName;
          bMerchandise.productGuid = item.productGuid;
          bMerchandise.muGuid = item.muGuid;
          bMerchandise.isSmartMerchandise = true;
          bMerchandise.attributes = item.smartAttributes.map(function (attr) {
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, attr, { dataType: attr.dataType });
          });
          bMerchandises.push(bMerchandise);
          border.bsmartProducts.push(pro);
        });
      } else {
        var _loop3 = function _loop3(i) {
          console.log('this.orderList', _this9.orderList);
          var bMerchandise = {};
          var order = _this9.orderList[i];
          if (order.categoryId !== 10) {
            bMerchandise.merchandiseGuid = order.merchandiseId;
            // 记录商品的cartId
            bMerchandise.cartId = order.cartId;
          } else {
            if (order.merchandiseId.toString().indexOf('Customized01') === -1) {
              alert('提交商品中包含审核失败的报价，请您修改商品再提交审核');
              // todo return cart
              _this9.$router.push({ name: 'cart' });
              return {
                v: void 0
              };
            }
            bMerchandise.merchandiseGuid = order.goodsNo;
            bMerchandise.merchandiseId = order.goodsNo;
          }
          if (order.id) {
            bMerchandise.orderGuid = order.id;
          }
          bMerchandise.newMerch = order.newMerch;
          bMerchandise.unitPrice = order.priceMin;
          bMerchandise.selfOperated = order.selfOperated;
          bMerchandise.customerGuid = _this9.sessionInfo.customerInfo.customerGuid;
          bMerchandise.quantity = order.productQuantity;
          bMerchandise.merchantNo = order.MerchantNo;
          bMerchandise.amplification = order.amplification;
          bMerchandise.categoryId = order.categoryId;
          bMerchandise.priceMax = order.priceMax;
          bMerchandise.priceMin = order.priceMin;
          bMerchandise.initPrice = bMerchandise.quantity * bMerchandise.unitPrice;
          var productGuid = order.productGuid;
          if (productGuid) {
            bMerchandise.productGuid = productGuid;
          }
          var cusGuid = order.expressPrice;
          if (cusGuid) {
            bMerchandise.expressPrice = cusGuid;
          }
          var attributes = [];
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(order.attributes).forEach(function (key) {
            if (order.attributes[key] instanceof Object) {
              if (key === 'GeneInfo') {
                attributes.push({ key: key, value: order.attributes[key].geneGUID });
                //                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
              }
              if (key === 'TVInfo') {
                attributes.push({ key: key, value: order.attributes[key].TLNo });
              }
            } else {
              if (key === 'GeneInfo') {
                if (order.attributes[key] === -1) {
                  attributes.push({ key: 'GeneInfo.category', value: -1 });
                }
                //                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
              }
              attributes.push({ key: key, value: order.attributes[key] });
            }
          });
          bMerchandise.attributes = attributes;

          bMerchandises[i] = bMerchandise;
        };

        for (var i = 0; i < this.orderList.length; i++) {
          var _ret3 = _loop3(i);

          if ((typeof _ret3 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
        }
      }
      border.merchandises = bMerchandises;
      border.expressFree = this.isExpress;
      border.usedBonus = false;
      border.customerVipPlanNo = this.customerVipPlanNo;
      if (__WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].isWapp) {
        border.clientSource = '3';
      } else {
        border.clientSource = '1';
      }
      self.productInfo.value = border;
      return border;
    },
    FormatterTime: function FormatterTime(date) {
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds;
      return newTime;
    },
    updateSelectCoupon: function updateSelectCoupon(coupons) {
      this.selectedCoupons = coupons;
      this.selectCoupon = coupons && coupons.find(function (coupon) {
        return coupon.type !== __WEBPACK_IMPORTED_MODULE_6__emkt__["a" /* default */].COUPON_TYPE_DISCOUNT;
      });
      if (this.isService) {
        console.log(-this.$refs.service.solutionPrice.discountPrice);
        this.discountPrice = -this.$refs.service.solutionPrice.discountPrice;
      }
      console.log('updateSelectCoupon selectedCoupons selectCoupon', this.selectedCoupons, this.selectCoupon);
    }
  })
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FooterPlaceholder: __WEBPACK_IMPORTED_MODULE_3__components_FooterPlaceholder___default.a },
  data: function data() {
    return {
      message: '',
      agree: Boolean
    };
  },

  props: ['buttonName', 'totalMoney', 'showButton'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isNewCustomerWithoutHistoryOrders'])),
  methods: {
    isPreSaleOrder: function isPreSaleOrder() {
      var preSalePeriod = [];
      __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].christmasPreSalePeriod.forEach(function (timeString) {
        preSalePeriod.push(new Date(timeString));
      });
      console.log('presaleperiod', preSalePeriod);
      var now = new Date();
      var isPreSale = false;
      if (now > preSalePeriod[0] && now < preSalePeriod[1]) {
        isPreSale = true;
        console.log('first day, all orders are pre sale orders');
      } else if (now > preSalePeriod[2] && now < preSalePeriod[3] || now > preSalePeriod[4] && now < preSalePeriod[5]) {
        console.log('second/third day, new customers\' orders are pre sale orders');
        isPreSale = this.isNewCustomerWithoutHistoryOrders;
      }
      console.log('is pre sale', isPreSale);
      return isPreSale;
    },
    response: function response() {
      var _this = this;
      if (this.buttonName === '确认下单') {
        console.log('isNewCustomerWithoutHistoryOrders', this.isNewCustomerWithoutHistoryOrders);
        var preSaleText = '';
        if (this.isPreSaleOrder()) {
          preSaleText = '本产品为预售产品，3月初发货，请知悉! 如有疑问可联系在线客服或业务员！<br>';
        }
        var showText = '<div><span style="color: #ff0000">' + preSaleText + '</span> \u8BF7\u60A8\u4ED4\u7EC6\u6838\u5BF9\u8BA2\u5355\u4FE1\u606F\uFF08\u5305\u62EC\u7269\u54C1\uFF0C\u53D1\u7968\uFF0C\u53D1\u8D27\u5730\u5740\uFF0C\u53D1\u8D27\u65B9\u5F0F\u548C\u7ED3\u7B97\u65B9\u5F0F\uFF09\n           \u786E\u8BA4\u8BA2\u5355\u540E\u5409\u51EF\u5C06\u5C3D\u5FEB\u5BF9\u60A8\u7684\u8BA2\u5355\u8FDB\u884C\u5BA1\u6838\uFF0C\u5BA1\u6838\u901A\u8FC7\u4E4B\u524D\uFF0C\u60A8\u4ECD\u65E7\u53EF\u4EE5\u5728\u201C\u6211\u7684\u201D\u754C\u9762\u4E2D\u7684\u201C\u5F85\u6536\u8D27\u201D\u6A21\u5757\u4E0B\u627E\u5230\u60A8\u7684\u8BA2\u5355\u3002</div>';
        this.$weui.dialog({
          content: showText,
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this.$emit('response');
            }
          }]
        });
        // $.modal({
        //   text: showText,
        //   buttons: [
        //     {
        //       text: 'Cancel',
        //       onClick: function () {
        //       }
        //     },
        //     {
        //       text: 'OK',
        //       onClick: function () {
        //         $.showIndicator()
        //         setTimeout(function () {
        //           $.hideIndicator()
        //         }, 300)
        //         _this.$emit('response')
        //       }
        //     }
        //   ]
        // })
      } else {
        _this.$emit('response');
      }
    }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['order'],
  data: function data() {
    return {
      baseurl: '/emktResources/resocurces/img/merchandise/'
    };
  },

  computed: {
    expressFee: function expressFee() {
      return this.order && this.order.expressPrice;
    },
    totalPrice: function totalPrice() {
      return this.order && this.order.totalPrice;
    },
    goodsPrice: function goodsPrice() {
      return this.order && this.order.price;
    },
    showCashCoupon: function showCashCoupon() {
      return this.cashCoupon && ![__WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].COUPON_TYPE_SPECIAL_FUND, __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].COUPON_TYPE_NEW_DISCOUNT].includes(this.cashCoupon.type);
    },
    cashCoupon: function cashCoupon() {
      return this.order && this.order.coupons && this.order.coupons[0];
    },
    merchandises: function merchandises() {
      var merchandiseList = [];
      if (this.order.merchandises.length === 0) {
        for (var i in this.order.subOrders) {
          for (var j in this.order.subOrders[i].merchandises) {
            merchandiseList.push(this.order.subOrders[i].merchandises[j]);
          }
        }
      } else {
        merchandiseList = this.order.merchandises;
      }
      for (var _j = 0; _j < merchandiseList.length; _j++) {
        if (!merchandiseList[_j]._titleList) {
          (function () {
            var _subTitleList = [];
            var _abstractList = [];
            var _titleList = [];
            merchandiseList[_j].attributes.forEach(function (par) {
              if (par.key.indexOf('GeneInfo') !== -1 && par.displayable === 1 && par.value) {
                _subTitleList.push({
                  valueText: par.valueLabel
                });
              }
              if (par.key === 'TVInfo' && par.value) {
                _abstractList.push({
                  valueText: par.valueLabel
                });
              }
            });
            merchandiseList[_j]._subTitleList = _subTitleList;
            merchandiseList[_j]._abstractList = _abstractList;
            var name = {};
            name.valueText = merchandiseList[_j].merchandiseLabel || merchandiseList[_j].productName;
            _titleList.push(name);
            merchandiseList[_j]._titleList = _titleList;
          })();
        }
      }
      return merchandiseList.filter(function (mer) {
        return mer.presentQuantity === 0;
      });
    },
    catalogueTotalPrice: function catalogueTotalPrice() {
      var _this = this;

      if (!this.merchandises || this.merchandises.length === 0) return 0;
      return this.merchandises.reduce(function (pre, current) {
        if (current.presentQuantity === 0) {
          return pre + _this.getMerchandiseInitPrice(current);
        } else {
          return pre;
        }
      }, 0);
    },
    totalCount: function totalCount() {
      if (!this.merchandises || this.merchandises.length === 0) return 0;
      var count = 0;
      this.merchandises.forEach(function (merchandise) {
        count += merchandise.presentQuantity === 0 ? merchandise.quantity : 0;
      });
      return count;
    }
  },
  mounted: function mounted() {
    this.$weui.loading().hide();
  },

  methods: {
    goToDetail: function goToDetail(product) {
      this.$router.push({ name: 'FinderOrderDeail', params: { merchandises: product, id: 1, order: this.order }, query: { id: 1 } });
      // let id = product.categoryId
      // let cId
      // if (product.merchandiseDetailForClient) {
      //   cId = product.merchandiseDetailForClient.categoryId
      // }
      // if (id !== 10 && cId !== 10) {
      //   if (id === 20 || cId === 20) {
      //     this.$router.push({name: 'FinderOrderDeail', params: {merchandises: product, id: 1, order: this.order}, query: {id: 1}})
      //   } else {
      //     this.$router.push({name: 'finderMerchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId, showFooter: '0' }, params: {order: this.order}})
      //   }
      // }
    },
    getMerchandiseCategory: function getMerchandiseCategory(merchandise) {
      var categoryLabel = '';
      switch (merchandise.categoryId) {
        case 20:
          categoryLabel = '定制';
          break;
        case 12:
          categoryLabel = '细胞类';
          break;
        default:
          categoryLabel = '现货';
      }
      return categoryLabel;
    },
    getMerchandiseDiscount: function getMerchandiseDiscount(merchandise) {
      var discount = merchandise.priceMin / merchandise.cataloguePrice;
      return discount < 1 ? (discount * 10).toFixed(1) : 1;
    },
    getMerchandiseInitPrice: function getMerchandiseInitPrice(merchandise) {
      return merchandise.categoryId === 20 ? merchandise.priceMax : merchandise.initPrice;
    },
    showExpressMessage: function showExpressMessage() {
      this.$weui.dialog({
        title: '运费说明',
        content: '为确保您所购产品的稳定性和活性，我们将选择最合适的物料（干冰或冰袋）进行产品包装，并用顺丰物流进行发货，以保障物流高效安全。如您的订单含有多个不同周期的产品，且周期相差超过10个工作日，产品将分批进行发货，并根据批次收取相应的运费。',
        buttons: [{
          label: '我知道了'
        }]
      });
    },

    // 获取下单时商品类型显示标签
    getPayOrderMerchandiseLabelPath: function getPayOrderMerchandiseLabelPath(merchandise) {
      var route = '/static/img/';
      if (merchandise.categoryId === 20 || merchandise.categoryId === 10) {
        return merchandise.amplification === 1 ? route + '扩增标签.png' : route + '定制标签.png';
      } else {
        return route + '现货标签.png';
      }
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_wx__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getLottery();
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])(['sessionInfo', 'myOrder', 'showLotteryAlready']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName']), {
    mobile: function mobile() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile;
    },
    enterpriseName: function enterpriseName() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName;
    },
    customerNo: function customerNo() {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo;
    },
    isWaitApprove: function isWaitApprove() {
      if (!this.$route || !this.$route.query || !this.$route.query.BOrders) {
        return false;
      }
      return this.$route.query.BOrders[0] && this.$route.query.BOrders[0].researchGroupApproveResult === __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE;
    },
    displayResult: function displayResult() {
      return this.isWaitApprove ? '订单正在审批中' : '下单成功';
    }
  }),
  data: function data() {
    return {
      constants: {},
      text: '感谢您的购买！',
      lotteryUrl: '',
      ifShowLottery: true,
      ifShowInstruction: false,
      promotions618Used: [],
      ifIsMonthlyFirstOrder: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapMutations */])(['UPDATE_WEAPP_MYORDERS']), {
    goHome: function goHome() {
      if (__WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_8_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    getLottery: function getLottery() {
      var _this = this;

      this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then(function (res) {
        if (res.body.result && res.body.result.length > 0) {
          var lotteryInfo = res.body.result[0];
          _this.$nextTick(_this.showLottery(lotteryInfo));
        } else {
          return _this.$weui.topTips('暂无抽奖信息');
        }
      });
    },
    showLottery: function showLottery(lotteryInfo) {
      var _this2 = this;

      // 是否参与抽奖，刷新后不获取抽奖信息
      var paidOrderId = this.$route.params.orderId;
      if (!paidOrderId || paidOrderId === undefined) {
        return this.$weui.topTips('暂无抽奖信息');
        // return $.toast('暂无抽奖信息')
      }
      this.$weui.loading('正在查询活动信息');
      // 先判断是不是首单，此值需要传到优惠券领取页面
      // this.ifIsMonthlyFirstOrder = this.isdaysFirstOrder()
      // this.getPromotions618()
      var lotteryStartDT = new Date(lotteryInfo.startDT.year, lotteryInfo.startDT.month, lotteryInfo.startDT.dayOfMonth, lotteryInfo.startDT.hourOfDay, lotteryInfo.startDT.minute, lotteryInfo.startDT.second);
      var lotteryEndDT = new Date(lotteryInfo.endDT.year, lotteryInfo.endDT.month, lotteryInfo.endDT.dayOfMonth, lotteryInfo.endDT.hourOfDay, lotteryInfo.endDT.minute, lotteryInfo.endDT.second);
      var now = new Date();
      if (now >= lotteryStartDT && now <= lotteryEndDT) {
        if (!this.customerNo) return;
        var queryParam = {
          customerNo: this.customerNo
        };
        this.UPDATE_WEAPP_MYORDERS({});
        this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(function (res) {
          _this2.$weui.loading().hide();
          if (res && res.body.result) {
            _this2.orderObject = res.body.result;
            _this2.UPDATE_WEAPP_MYORDERS(_this2.orderObject);
            console.log('getAllOrdersByCustomerNoOrResearchGroupNo', _this2.orderObject, 'this.tabIndex=', _this2.tabIndex);
            var waitDeliverAndFinishedOrders = _this2.orderObject.executedOrderList;
            var orderSet = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
            var orders = waitDeliverAndFinishedOrders.filter(function (order) {
              return order.id === parseInt(paidOrderId);
            });
            // 判断当前订单金额是否满足抽奖最低金额
            if (lotteryInfo.requiredMoney !== null) {
              if (orders.length === 1) {
                _this2.ifIsMonthlyFirstOrder = orders[0].price >= lotteryInfo.requiredMoney;
              } else {
                _this2.ifIsMonthlyFirstOrder = false;
              }
            }
            waitDeliverAndFinishedOrders.filter(function (order) {
              if (lotteryInfo.requiredMoney !== null) {
                var orderTime = new Date(order.orderTime.replace(/-/g, '/'));
                if (orderTime >= lotteryStartDT && orderTime <= lotteryEndDT && order.price >= lotteryInfo.requiredMoney) {
                  orderSet.add(order);
                }
              } else {
                if (new Date(order.orderTime) >= lotteryStartDT && new Date(order.orderTime) <= lotteryEndDT) {
                  orderSet.add(order);
                }
              }
            });
            // 仅第一次满足抽奖条件才可跳出抽奖活动，后续不再可跳出活动
            if (orderSet.size === 1 && _this2.ifIsMonthlyFirstOrder) {
              _this2.$weui.loading().hide();
              // $.hidePreloader()
              var url = lotteryInfo.url;
              // 享受520促销，判断是否有抽奖记录
              // if (this.has520Promotion()) {
              //   const lotteryRecord = {
              //     guid: lotteryInfo.guid,
              //     customerNo: this.sessionInfo.customerInfo.customerNo
              //   }
              //   this.gcapi('checkedLotteryrecords', lotteryRecord).then(res => {
              //     if (!res.body.result) {
              //       $.toast('您已经抽过奖了')
              //       return
              //     }
              //     let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/a-178-show.png"></a></div>'
              //     const self = this
              //     $.modal({
              //       text: domText,
              //       buttons: [{
              //         text: '关闭'
              //       }],
              //       onClick: function () {
              //         $.modal({
              //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
              //           buttons: [{
              //             text: '确定放弃',
              //             onClick: function () {
              //             }
              //           }, {
              //             text: '<a href="' + url + '">返回抽奖</a>',
              //             onClick: () => {
              //               // 防止iphone手机报错，加@抑制报错信息
              //               self.gcapi('@submitLotteryrecords', lotteryRecord)
              //             }
              //           }]
              //         })
              //       }
              //     })
              //     $('#lottery').click(() => {
              //       self.gcapi('@submitLotteryrecords', lotteryRecord).then(res => {})
              //       $.closeModal()
              //     })
              //   })
              // } else {
              // 每个月首单抽奖，无需判断是否有抽奖记录
              var domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></a></div>';
              // const self = this
              // this.$weui.dialog({
              //   content: domText,
              //   buttons: [{
              //     label: '关闭',
              //     type: 'primary',
              //     onClick: () => {
              //       this.$weui.dialog({
              //         content: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
              //         buttons: [{
              //           type: 'default',
              //           label: '确定放弃',
              //           onClick: function () {
              //           }
              //         }, {
              //           type: 'primary',
              //           label: '<a href="' + url + '">返回抽奖</a>',
              //           onClick: () => {
              //           }
              //         }]
              //       })
              //     }
              //   }]
              // })
              __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
                text: domText,
                buttons: [{
                  text: '关闭'
                }],
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.modal({
                    text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                    buttons: [{
                      text: '确定放弃',
                      onClick: function onClick() {}
                    }, {
                      text: '<a href="' + url + '">返回抽奖</a>',
                      onClick: function onClick() {}
                    }]
                  });
                }
              });
            } else {
              _this2.$weui.topTips('暂无抽奖信息');
            }
          }
        });
      }
    },
    isMonthlyFirstOrder: function isMonthlyFirstOrder() {
      if (!this.myOrder) return true;
      var currentMonth = new Date().getMonth() + 1;
      var currentYear = 2020;
      if (![4, 5, 6].includes(currentMonth)) return true;
      var waitDeliverAndFinishedOrders = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.myOrder.waitDeliverOrders), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.myOrder.finishedOrders));
      var orderSet = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
      waitDeliverAndFinishedOrders.filter(function (order) {
        return new Date(order.payDT.replace(/-/g, '/')).getFullYear() === currentYear;
      }).forEach(function (order) {
        if (new Date(order.payDT.replace(/-/g, '/')).getMonth() + 1 === currentMonth) {
          orderSet.add(order.payDT.replace(/-/g, '/'));
        }
      });
      console.log('orderSet', orderSet);
      return orderSet.size === 1;
    },
    getPromotions618: function getPromotions618() {
      var paidOrder = this.$route.query.order;
      if (!paidOrder || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(paidOrder) === '{}' || !paidOrder.merchandises) {
        this.promotions618Used = [];
      }
      var promotionGuids618 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].promotions618);
      var promotionsSet = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
      paidOrder.merchandises.forEach(function (merchandise) {
        merchandise && merchandise.perferPromotions && merchandise.perferPromotions.forEach(function (promotion) {
          if (promotion && promotionGuids618.includes(promotion.promotionGuid)) {
            promotionsSet.add(promotion.promotionGuid);
          }
        });
      });
      this.promotions618Used = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(promotionsSet)).sort().map(function (guid) {
        return __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].promotions618[guid];
      });
      var guids = this.promotions618Used.map(function (pro) {
        return pro.guid;
      }).join(',');
      __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].setStoreItem('promotionGuids618Used', guids);
      console.log('promotions618Used', this.promotions618Used);
    },
    getCouponForSelf: function getCouponForSelf() {
      var _this3 = this;

      this.ifShowInstruction = false;
      if (!this.hasLogin) {
        return this.$weui.alert('请先登录');
        // return alert('请先登录')
      }
      if (!this.promotions618Used || this.promotions618Used.length === 0) {
        return this.$weui.alert('无可领优惠券');
        // return alert('无可领优惠券')
      }
      if (!this.customerNo || !this.mobile || !this.customerName || !this.enterpriseName) {
        return this.$weui.alert('个人信息不完整，请联系业务员');
        // return alert('个人信息不完整，请联系业务员')
      }
      var formCollectionActivity = {
        'customerNo': this.customerNo,
        'customerMobile': this.mobile,
        'customerName': this.customerName,
        'customerEnterpriseName': this.enterpriseName,
        'activityName': '618领取优惠券',
        'attachmentName': __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].getLocalStorage('promotionGuids618Used'),
        'additionalinfos': []
      };
      formCollectionActivity['additionalinfos'].push({
        'columnName': '券是否自用',
        'columnValue': '券自用'
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者电话号码',
        'columnValue': this.mobile
      });
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者姓名',
        'columnValue': this.customerName
      });
      var formCollectionActivityList = [];
      formCollectionActivityList.push(formCollectionActivity);
      this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then(function (response) {
        if (response.body.result === false) {
          return _this3.$weui.topTips('提交失败');
          // return $.toast('提交失败')
        } else {
          // 领取优惠券后，清空订单中使用的618促销guids
          __WEBPACK_IMPORTED_MODULE_7__emkt__["a" /* default */].setStoreItem('promotionGuids618Used', '');
          var result = void 0,
              text = void 0;
          result = '领取成功';
          text = '折扣券将在3-5个工作日发放完毕';
          _this3.$router.replace({ name: 'OperationResult', query: { result: result, text: text, 'showLottery': _this3.ifIsMonthlyFirstOrder } });
        }
      });
    },
    getCouponForFriend: function getCouponForFriend() {
      this.$router.replace({ name: 'SearchContactWithoutDetail', query: { 'showLottery': this.ifIsMonthlyFirstOrder } });
    }
  })
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      receive1: false,
      receive2: false,
      receive3: false,
      receive4: false,
      receive5: false,
      grey1: false,
      grey2: false,
      grey3: false,
      grey4: false,
      grey5: false,
      BCoupon: {},
      prizes: {
        1: {
          name: 'G客精美台历',
          type: __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        2: {
          name: 'G客U盘32G',
          type: __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        3: {
          name: '病毒300元优惠券',
          type: __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201214-001', code: '2021bingdu-300', startDT: this.getHours(0), endDT: this.getDay(30) }
        },
        4: {
          name: '蛋白组学1314元券',
          type: __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201231-001', code: '2021danbai', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
        },
        5: {
          name: 'm6A高级生信分析券',
          type: __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201231-002', code: '2021m6A', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
        }
      },
      PrizeDetailBO: {}
    };
  },

  methods: {
    goHome: function goHome() {
      var _this2 = this;

      if (this.receive1 === false && this.receive2 === false && this.receive3 === false && this.receive4 === false && this.receive5 === false) {
        this.$weui.dialog({
          title: '',
          content: '您确定放弃领取奖品吗',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this2.revert();
            }
          }]
        });
      } else {
        this.revert();
      }
    },
    revert: function revert() {
      if (__WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_1_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
        // this.$router.replace({name: 'home'})
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    getDay: function getDay(day) {
      var date = new Date();
      var milliseconds = date.getTime() + 1000 * 60 * 60 * 24 * day;
      date.setTime(milliseconds);

      var currentYear = date.getFullYear();
      var currentMonth = date.getMonth();
      var currentDate = date.getDate();
      var currentHours = date.getHours();
      var currentMinutes = date.getMinutes();
      var currentSeconds = date.getSeconds();
      currentMonth = this.doHandleMonth(currentMonth + 1);
      currentDate = this.doHandleMonth(currentDate);
      return currentYear + '-' + currentMonth + '-' + currentDate + ' ' + currentHours + ':' + currentMinutes + ':' + currentSeconds;
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;
      if (month.toString().length === 1) {
        m = '0' + month;
      }
      return m;
    },
    getHours: function getHours() {
      var timestamp = new Date().getTime();
      timestamp = timestamp + 12 * 60 * 60 * 1000;
      var dateAfter = new Date(timestamp);
      var tempTimeStr24 = dateAfter.toLocaleTimeString('chinese', { hour12: false });
      return dateAfter.getFullYear() + '-' + (dateAfter.getMonth() + 1) + '-' + dateAfter.getDate() + ' ' + tempTimeStr24;
    },
    receivePrize: function receivePrize(id) {
      var _this3 = this;

      if (id === 1) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'G客精美台历，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 2) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'G客U盘32G，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 3) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '病毒300元代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。<br> 限在淘基因商城下单，该代金券可叠加日常折扣使用。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 4) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'm6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      }
    },
    subLottery: function subLottery(id) {
      var _this4 = this;

      var _this = this;
      var objectPrizes = [];
      var couponPrizes = [];
      var selectedPrize = this.prizes[id];
      if (selectedPrize.type === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_OBJECT) {
        objectPrizes.push(selectedPrize.name);
        this.PrizeDetailBO = {
          'orderId': _this.$route.query.BOrders[0].id,
          'activityName': __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].activityName,
          'promotionGuid': __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].promotionGuid,
          'objectPrizes': objectPrizes
        };
      }
      if (selectedPrize.type === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PRIZE_TYPE_COUPON) {
        couponPrizes.push(selectedPrize.BCoupon);
        this.PrizeDetailBO = {
          'orderId': _this.$route.query.BOrders[0].id,
          'activityName': __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].activityName,
          'promotionGuid': __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].promotionGuid,
          'couponPrizes': couponPrizes
        };
      }
      this.gcapi('requestPrize', this.PrizeDetailBO).then(function (response) {
        if (response.body.result === true) {
          if (id === 1) {
            _this4.receive1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 2) {
            _this4.receive2 = true;
            _this4.grey1 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 3) {
            _this4.receive3 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 4) {
            _this4.receive4 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey5 = true;
          } else {
            _this4.receive5 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wx__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo', 'myOrder', 'showLotteryAlready']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName'])),
  data: function data() {
    return {
      receive1: false,
      receive2: false,
      receive3: false,
      receive4: false,
      receive5: false,
      grey1: false,
      grey2: false,
      grey3: false,
      grey4: false,
      grey5: false,
      BCoupon: {},
      prizes: {
        1: {
          name: '萌宠暖手宝&充电宝',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        2: {
          name: 'G客保温杯',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        3: {
          name: '病毒800元优惠券',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201214-001', code: '2021bingdu-800', startDT: this.getHours(0), endDT: this.getDay(30) }
        },
        4: {
          name: '蛋白组学1314元券',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201231-001', code: '2021danbai', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
        },
        5: {
          name: 'm6A高级生信分析券',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_COUPON,
          BCoupon: { promotionGuid: 'coupon-20201231-002', code: '2021m6A', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
        }
      },
      PrizeDetailBO: {}
    };
  },

  methods: {
    goHome: function goHome() {
      var _this2 = this;

      if (this.receive1 === false && this.receive2 === false && this.receive3 === false && this.receive4 === false && this.receive5 === false) {
        this.$weui.dialog({
          title: '',
          content: '您确定放弃领取奖品吗',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this2.revert();
            }
          }]
        });
      } else {
        this.revert();
      }
    },
    revert: function revert() {
      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_3_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    getDay: function getDay(day) {
      var date = new Date();
      var milliseconds = date.getTime() + 1000 * 60 * 60 * 24 * day;
      date.setTime(milliseconds);

      var currentYear = date.getFullYear();
      var currentMonth = date.getMonth();
      var currentDate = date.getDate();
      var currentHours = date.getHours();
      var currentMinutes = date.getMinutes();
      var currentSeconds = date.getSeconds();
      currentMonth = this.doHandleMonth(currentMonth + 1);
      currentDate = this.doHandleMonth(currentDate);
      return currentYear + '-' + currentMonth + '-' + currentDate + ' ' + currentHours + ':' + currentMinutes + ':' + currentSeconds;
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;
      if (month.toString().length === 1) {
        m = '0' + month;
      }
      return m;
    },
    getHours: function getHours() {
      var timestamp = new Date().getTime();
      timestamp = timestamp + 12 * 60 * 60 * 1000;
      var dateAfter = new Date(timestamp);
      var tempTimeStr24 = dateAfter.toLocaleTimeString('chinese', { hour12: false });
      return dateAfter.getFullYear() + '-' + (dateAfter.getMonth() + 1) + '-' + dateAfter.getDate() + ' ' + tempTimeStr24;
    },
    receivePrize: function receivePrize(id) {
      var _this3 = this;

      if (id === 1) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '萌宠暖手宝&充电宝，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 2) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'G客保温杯礼品，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 3) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '病毒800元代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。<br> 限在淘基因商城下单，该代金券可叠加日常折扣使用。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 4) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'm6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      }
    },
    subLottery: function subLottery(id) {
      var _this4 = this;

      var _this = this;
      var objectPrizes = [];
      var couponPrizes = [];
      var selectedPrize = this.prizes[id];
      if (selectedPrize.type === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT) {
        objectPrizes.push(selectedPrize.name);
        this.PrizeDetailBO = {
          'orderId': _this.$route.query.BOrders[0].id,
          'activityName': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].activityName,
          'promotionGuid': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].promotionGuid,
          'objectPrizes': objectPrizes
        };
      }
      if (selectedPrize.type === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_COUPON) {
        couponPrizes.push(selectedPrize.BCoupon);
        this.PrizeDetailBO = {
          'orderId': _this.$route.query.BOrders[0].id,
          'activityName': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].activityName,
          'promotionGuid': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].promotionGuid,
          'couponPrizes': couponPrizes
        };
      }
      this.gcapi('requestPrize', this.PrizeDetailBO).then(function (response) {
        if (response.body.result === true) {
          if (id === 1) {
            _this4.receive1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 2) {
            _this4.receive2 = true;
            _this4.grey1 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 3) {
            _this4.receive3 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey4 = true;
            _this4.grey5 = true;
          } else if (id === 4) {
            _this4.receive4 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey5 = true;
          } else {
            _this4.receive5 = true;
            _this4.grey1 = true;
            _this4.grey2 = true;
            _this4.grey3 = true;
            _this4.grey4 = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['sessionInfo', 'myOrder', 'showLotteryAlready']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasLogin', 'customerName'])),
  data: function data() {
    return {
      receive1: false,
      receive2: false,
      receive3: false,
      receive4: false,
      grey1: false,
      grey2: false,
      grey3: false,
      grey4: false,
      prizes: {
        1: {
          name: 'PGG颈椎按摩器',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        2: {
          name: '特美刻智能保温杯',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        3: {
          name: '华为智选智能台灯',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        },
        4: {
          name: '三只松鼠坚果礼盒',
          type: __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT
        }
      },
      PrizeDetailBO: {}
    };
  },

  methods: {
    goHome: function goHome() {
      var _this2 = this;

      if (this.receive1 === false && this.receive2 === false && this.receive3 === false && this.receive4 === false) {
        this.$weui.dialog({
          title: '',
          content: '您确定放弃领取奖品吗',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this2.revert();
            }
          }]
        });
      } else {
        this.revert();
      }
    },
    revert: function revert() {
      if (__WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_3_wx___default.a.miniProgram.switchTab({
          url: '/pages/index/index'
        });
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    receivePrize: function receivePrize(id) {
      var _this3 = this;

      if (id === 1) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: 'PGG颈椎按摩器，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 2) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '特美刻智能保温杯，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else if (id === 3) {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '华为智选智能台灯，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      } else {
        this.$weui.dialog({
          title: '「是否确认领取礼品？」',
          content: '三只松鼠坚果礼盒，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function onClick() {}
          }, {
            label: '确定',
            type: 'primary',
            onClick: function onClick() {
              _this3.subLottery(id);
            }
          }]
        });
      }
    },
    subLottery: function subLottery(id) {
      var _this4 = this;

      var _this = this;
      var objectPrizes = [];
      var selectedPrize = _this.prizes[id];
      if (selectedPrize.type === __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].PRIZE_TYPE_OBJECT) {
        objectPrizes.push(selectedPrize.name);
        _this.PrizeDetailBO = {
          'orderId': _this.$route.query.BOrders[0].id,
          'activityName': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].activityName,
          'promotionGuid': __WEBPACK_IMPORTED_MODULE_2__emkt__["a" /* default */].promotionGuid,
          'objectPrizes': objectPrizes
        };
      }
      _this.gcapi('checkCustomerAlreadyRequestPrize', this.PrizeDetailBO).then(function (response) {
        if (response.body.result === true) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.toast('守护礼活动每个账户限参与一次');
        } else {
          _this.gcapi('requestPrize', _this4.PrizeDetailBO).then(function (response) {
            if (response.body.result === true) {
              if (id === 1) {
                _this.receive1 = true;
                _this.grey2 = true;
                _this.grey3 = true;
                _this.grey4 = true;
              } else if (id === 2) {
                _this.receive2 = true;
                _this.grey1 = true;
                _this.grey3 = true;
                _this.grey4 = true;
              } else if (id === 3) {
                _this.receive3 = true;
                _this.grey1 = true;
                _this.grey2 = true;
                _this.grey4 = true;
              } else {
                _this.receive4 = true;
                _this.grey1 = true;
                _this.grey2 = true;
                _this.grey3 = true;
              }
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emktcommon_orders_order_GcOrderDetailWithActions_vue__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emktcommon_orders_order_GcOrderDetailWithActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__emktcommon_orders_order_GcOrderDetailWithActions_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import $ from 'jquery'






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      status: 2,
      orderList: {},
      baseurl: '/emktResources/resocurces/img/merchandise/',
      serviceUrl: '/emktResources/resocurces/img/merchandise/service.png',
      routeType: 1,
      fileName: '',
      fileSize: '',
      orderMaterialInfo: [],
      showProgress: true,
      SCProgressInfo: null
    };
  },
  created: function created() {},

  components: { GcOrderDetailWithActions: __WEBPACK_IMPORTED_MODULE_6__emktcommon_orders_order_GcOrderDetailWithActions_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['chosenOrder', 'hasLogin', 'researchGroupCharacter', 'customerNo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['cartList', 'weappMyOrders'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['ADD_CART_LIST', 'SET_CURRENT_WAITPAY_ORDER', 'ORDER_MATERIAL_INFO']), {
    toSendContract: function toSendContract(orderDetail) {
      __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].wxDownloadOrderText(orderDetail);
    },

    toSampleDeliveryList: function toSampleDeliveryList(orderMaterialInfo) {
      this.ORDER_MATERIAL_INFO(orderMaterialInfo);
      this.$router.push({
        name: 'SampleDeliveryList'
      });
    },
    stringSet: function stringSet(str) {
      if (str) {
        var temp = str.replace(/&nbsp;/gi, ' ');
        return temp;
      } else {
        return '';
      }
    },
    showContractBtn: function showContractBtn(orderDetail) {
      return __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].showDownloadOrderTextBtn(orderDetail);
    },
    showSampleDeliveryGuideBtn: function showSampleDeliveryGuideBtn(orderDetail) {
      var _this = this;

      if (!orderDetail || !orderDetail.orderNo) return false;
      this.gcapi('loadOrderMaterialInfo', orderDetail.orderNo).then(function (res) {
        if (res.body.result === '[]') return false;else {
          _this.orderMaterialInfo = JSON.parse(res.body.result);
          var statusText = _this.getOrderStatusText(orderDetail);
          return statusText === '已完成' || statusText === '执行中';
        }
      });
    },
    showInvoiceBtn: function showInvoiceBtn(orderDetail) {
      if (!orderDetail) return false;
      if (!orderDetail.fromEmkt) return false;
      return orderDetail.payType !== __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].PAY_TYPE_REMAIN_MONEY && orderDetail.status >= __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_PAIED;
    },
    copy: function copy() {
      var _this2 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('#tag-copy');
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', function (e) {
        _this2.$weui.toast('复制成功', 1500);
        // $.toast('复制成功')
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', function (e) {
        _this2.$weui.topTips('该浏览器不支持自动复制');
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy();
      });
    },

    // goMessage () {
    //   window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    // },
    getStatusStyle: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getStatusStyle,
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].getOrderStatusText,
    showCancelButton: function showCancelButton(order) {
      console.log('showCancelButton', order);
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以取消订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待提交' || statusText === '待审批' || statusText === '执行中' || statusText === '待签署' || statusText === '技术审核中' || statusText === '待重新提交';
    },
    showSubmitToCheckSignApproveButton: function showSubmitToCheckSignApproveButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待重新提交';
    },
    showSubmitOrderButton: function showSubmitOrderButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待提交';
    },
    showSignSubmitOrderButton: function showSignSubmitOrderButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待签署';
    },
    handleOrderToSign: function handleOrderToSign(order) {
      this.$router.push({ name: 'promotions', query: { orderId: order.id, cc: true } });
    },
    showAmplificationBtn: function showAmplificationBtn(item, orderDetail) {
      if (!item) return false;
      if (!orderDetail.fromEmkt) return false;
      // 仅下单人可以操作订单
      if (orderDetail.customerNo !== this.customerNo) {
        return false;
      }
      return orderDetail.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_FINISHED && item.categoryId === 20;
    },
    showBuyAgainBtn: function showBuyAgainBtn(item, orderDetail) {
      if (!item || item.orderType !== 1) return false;
      if (!orderDetail.fromEmkt) return false;
      // 仅下单人可以操作订单
      if (orderDetail.customerNo !== this.customerNo) {
        return false;
      }
      // return true
      return orderDetail.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_ABORT || orderDetail.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_FINISHED && item.categoryId !== 20 || orderDetail.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_CHECK_BAD || orderDetail.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL;
    },
    buyCustomizeProductAgain: function buyCustomizeProductAgain(order, ifAmplify) {
      if (ifAmplify === true) {
        order.merchandises[0].amplification = 1;
        order.merchandises[0].merchandiseDetailForClient.amplification = 1;
      }
      if (typeof order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value === 'string') {
        var obj = {};
        obj.TLNo = order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value;
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[0].columnName === 'TVInfo') {
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].value = obj;
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].valueText = obj;
        }
      }
      for (var i in order.merchandises[0].merchandiseDetailForClient._attributesList) {
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].value !== '214' && (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'AAVBloodType' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'LVAmount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Lentivirus_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_CultureRequired' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_CultureRequired')) {} else {
          if ((order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 2 || order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 3) && order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName !== 'GeneInfo') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].displayable = 0;
          }
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].sorteditAble = false;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'ContractType') {
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributes.ContractType.value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Type' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Tech') {
          order.merchandises[0].merchandiseDetailForClient._attributes.Type.value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributes.Tech.value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = '-1';
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = '-1';
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Source') {
          order.merchandises[0].merchandiseDetailForClient._attributes.Source.value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
          order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber') {
          if (order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === '2' || order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === 2) {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.value;
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.valueText;
          }
        }
        if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter') {
          if (order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'RNAi综合－腺相关病毒外筛') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3;
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3;
          }
        }
      }
      this.$router.push({
        name: 'finderMerchandises',
        query: {
          categoryId: order.merchandises[0].merchandiseDetailForClient.categoryId
        },
        params: {
          merchandises: order.merchandises[0].merchandiseDetailForClient
        }
      });
    },
    amplifyProduct: function amplifyProduct(item, orderDetail) {
      var _this3 = this;

      if (!item) return;
      if (item.orderId) {
        this.gcapi('assambleOrders', item.orderId).then(function (res) {
          console.log('我要扩增', res.body.result);
          var order = res.body.result;
          _this3.buyCustomizeProductAgain(order, true);
        });
      }
    },
    buyProductAgain: function buyProductAgain(item, orderDetail) {
      var _this4 = this;

      if (item.orderId) {
        if (item.categoryId === 6) {
          self.$weui.topTips('细胞相关产品已经下架！不可再次购买！', 2000);
          return;
        }
        if (item.categoryId === 20) {
          this.$router.push({ name: 'finder' });
          return;
        }
        this.$weui.loading('正在获取商品数据');
        // $.showPreloader('正在获取商品数据')
        this.gcapi('assambleOrders', item.orderId).then(function (res) {
          // $.hidePreloader()
          _this4.$weui.loading().hide();
          console.log('再次购买', res.body.result);
          // let order = res.body.result
          var merchandise = res.body.result.merchandises.find(function (mer) {
            return mer.categoryId !== 20 && mer.merchandiseGuid === item.merchandiseGuid && mer.presentQuantity === 0;
          });
          var merchandiseDetail = merchandise && merchandise.merchandiseDetailForClient;
          // if (merchandise.categoryId === 20) {
          //   merchandiseDetail.productGuid = order.productGuid
          //   this.buyCustomizeProductAgain(order, false)
          //   console.log('再次购买定制商品')
          //   return
          // }
          _this4.ADD_CART_LIST(merchandiseDetail);
          console.log('ADD_CART_LIST', _this4.cartList, merchandiseDetail);
          _this4.checkFromWeapp();
        });
      }
    },
    checkFromWeapp: function checkFromWeapp() {
      if (__WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].isWapp) {
        // 手动保存到数据库
        this.saveCartManually();
      } else {
        this.$router.push({ name: 'cart' });
      }
    },
    saveCartManually: function saveCartManually() {
      var _this5 = this;

      var cartJsonString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cartList.cartContent);
      this.$weui.loading('正在添加到购物车');
      // $.showPreloader('正在添加到购物车')
      this.gcapi('saveShoppingCart', cartJsonString).then(function (response) {
        // $.hidePreloader()
        _this5.$weui.loading().hide();
        if (response.body.code === 0) {
          console.log('再次购买：save Shopping cart successfully, 即将跳转购物车');
          if (__WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].isWapp) {
            __WEBPACK_IMPORTED_MODULE_5_wx___default.a.miniProgram.switchTab({
              url: '/pages/cart/cart'
            });
          }
        } else {
          _this5.$weui.topTips('保存失败', 1000);
        }
      });
    },
    cancelOrder: function cancelOrder(order) {
      var _this6 = this;

      if (!order) return;
      var orderId = order.id;
      if (!orderId) {
        return this.$weui.topTips('当前订单缺少订单编号');
        // return $.toast('当前订单缺少订单编号')
      }
      if (order.status > __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_PAIED && order.status < __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_FINISHED) {
        return alert('订单已开始生产，无法自行取消，如有疑问请联系客服人员', {
          buttons: [{
            label: '我知道了'
          }]
        });
      }
      this.$weui.loading('正在取消订单');
      // $.showPreloader('正在取消订单')
      this.gcapi('orderCancel', { id: orderId }).then(function (data) {
        // $.hidePreloader()
        _this6.$weui.loading().hide();
        __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].setStoreItem('cancelledOrder', order);
        _this6.$weui.toast('取消成功', 1500);
        // $.toast('取消成功')
        // 返回到orders页面更新weappMyOrders
        _this6.$router.go(-1);
      });
    },
    handleOrderCancel: function handleOrderCancel(order) {
      var _this7 = this;

      this.$weui.dialog({
        title: '当订单未提交或未开始生产时，您随时可以取消订单，是否确认取消？',
        buttons: [{
          label: '否',
          type: 'default',
          onClick: function onClick() {
            return;
          }
        }, {
          label: '是',
          type: 'primary',
          onClick: function onClick() {
            _this7.cancelOrder(order);
          }
        }]
      });
    },
    handleOrderSubmit: function handleOrderSubmit(order) {
      var _this8 = this;

      this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then(function (res) {
        if (res && res.body.result) {
          var waitPayOrder = res.body.result;
          _this8.SET_CURRENT_WAITPAY_ORDER(waitPayOrder);
          _this8.$router.replace({ name: 'WeappOrderConfirmation' });
        }
      });
    },
    handleOrderToCheckSignApprove: function handleOrderToCheckSignApprove(bOrder) {
      var _this9 = this;

      this.$weui.loading('加载中');
      this.gcapi('checkOrderSignAndApprove', [{ id: bOrder.id }]).then(function (response) {
        if (response && response.body.result && response.body.code === 0) {
          _this9.$weui.loading('加载中').hide();
          var order = response.body.result[0];
          if (order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_ABORT) {
            alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单');
            if (__WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].isWapp) {
              __WEBPACK_IMPORTED_MODULE_5_wx___default.a.miniProgram.switchTab({ url: '/pages/cart/cart' });
            } else {
              _this9.$router.replace({ name: 'cart' });
            }
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_SUBMITTED) {
            _this9.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_SIGN_NEED) {
            _this9.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_PAIED) {
            _this9.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_4__emkt_js__["a" /* default */].ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
            _this9.$weui.topTips('提交订单失败，请联系客服或重新提交订单');
          }
        }
      });
    },
    toPayInvoice: function toPayInvoice(orderDetail) {
      this.$router.push({
        name: 'updateInvoiceTitle',
        params: { order: orderDetail }
      });
    }
  })
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emktcommon_api_orderApi_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_express_GcOrderExpressWithData_vue__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_express_GcOrderExpressWithData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_express_GcOrderExpressWithData_vue__);
//
//
//
//
//
//
//




// import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { GcOrderExpressWithData: __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_express_GcOrderExpressWithData_vue___default.a },
  props: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    handleDownloadExpressFile: function handleDownloadExpressFile(contractNo) {
      console.log(contractNo, __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].isWapp);
      if (__WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].isWapp) {
        __WEBPACK_IMPORTED_MODULE_0__emkt_js__["a" /* default */].wxDownloadExpressSheet(contractNo);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__emktcommon_api_orderApi_js__["j" /* downloadExpressOutFile */])(contractNo);
      }
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_order_GcOrderListWithActions_vue__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_order_GcOrderListWithActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_order_GcOrderListWithActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import $ from 'jquery'
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { GcOrderListWithAcitons: __WEBPACK_IMPORTED_MODULE_2__emktcommon_orders_order_GcOrderListWithActions_vue___default.a },
  props: {
    orderList: Array
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['customerNo'])),
  methods: {
    getOrderStatusText: __WEBPACK_IMPORTED_MODULE_1__emkt_js__["a" /* default */].getOrderStatusText,
    handleDownloadOrderText: function handleDownloadOrderText(orderDetail) {
      __WEBPACK_IMPORTED_MODULE_1__emkt_js__["a" /* default */].wxDownloadOrderText(orderDetail);
    },

    toDetailInfo: function toDetailInfo(order) {
      __WEBPACK_IMPORTED_MODULE_1__emkt_js__["a" /* default */].setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      console.log('订单信息', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      this.$router.push({ name: 'WeappMyOrderDetail', params: { orderNo: order.orderNo } });
    },
    showButton: function showButton(order) {
      if (order.fromEmkt) {
        return this.showCancelButton(order) || this.showSubmitOrderButton(order);
      } else {
        return false;
      }
    },
    showCancelButton: function showCancelButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      // return false
      var statusText = this.getOrderStatusText(order);
      // alert(statusText !== '执行中' || statusText !== '已完成' || statusText !== '已取消' || statusText !== '审核不通过')
      return statusText !== '已完成' && statusText !== '已取消' && statusText !== '审核不通过';
    },
    showSubmitOrderButton: function showSubmitOrderButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待提交';
    },
    showSubmitToCheckSignApproveButton: function showSubmitToCheckSignApproveButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待重新提交';
    },
    showSubmitToSignOrderButton: function showSubmitToSignOrderButton(order) {
      if (!order) return false;
      if (!order.fromEmkt) {
        return false;
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false;
      }
      var statusText = this.getOrderStatusText(order);
      return statusText === '待签署';
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderListPage_vue__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderListPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderListPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emktcommon_api_orderApi_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__emktcommon_orders_order_components_GcOrderSearchBox_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__emktcommon_orders_order_components_GcOrderSearchBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__emktcommon_orders_order_components_GcOrderSearchBox_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import $ from 'jquery'






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrderList: __WEBPACK_IMPORTED_MODULE_4__OrderListPage_vue___default.a, GcOrderSearchBox: __WEBPACK_IMPORTED_MODULE_9__emktcommon_orders_order_components_GcOrderSearchBox_vue___default.a
  },
  watch: {
    'customerNo': {
      handler: 'fetchOrders',
      immediate: true
    },
    'tabIndex': {
      handler: 'setCurrentTabIndex'
    },
    '$route.query.afterSales': {
      handler: 'fetchOrders',
      immediate: true
    }
  },
  data: function data() {
    return {
      refresh: true,
      tabIndex: __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_EXECUTE,
      orderObject: {},
      displayWaitPayOrders: [],
      displayExecutedOrders: [],
      displayFinishedOrders: [],
      displayCancledOrders: [],
      countOfLoadingMoreOrders: 10,
      fetchOrdersCompleted: false,
      memberList: ['李红日', '白牡蛎', '大河二', '白牡蛎', '大河二'],
      searchMap: {},
      displayWaitAduitOrders: []
    };
  },
  mounted: function mounted() {
    // this.fetchOrders()
    // console.log('Orders mounted')
  },
  activated: function activated() {
    if (this.currentMyOrderTabIndex !== -1) {
      this.tabIndex = this.currentMyOrderTabIndex;
    } else if (__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getUrlParamHref('orderTabIndex')) {
      this.tabIndex = Number(__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getUrlParamHref('orderTabIndex')) > 5 ? __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITPAY : Number(__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getUrlParamHref('orderTabIndex'));
    } else {
      this.tabIndex = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITPAY;
    }
    // 若在订单详情页面取消订单，需要更新用来显示的待下单订单和已取消订单
    var cancelled = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getLocalStorage('cancelledOrder');
    console.log('cancelled order', cancelled);
    if (cancelled) {
      this.updateMyOrders(cancelled);
      __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].setStoreItem('cancelledOrder', null);
    }
    console.log('Orders activated, getUrlParamHref= ', Number(__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getUrlParamHref('orderTabIndex')), 'this.currentMyOrderTabIndex=', this.currentMyOrderTabIndex);
    // 修改订单地址
    // let addressOrder = EMKT.getLocalStorage('addressOrder')
    // if (addressOrder) {
    //   this.updateMyAllOrders(addressOrder)
    //   EMKT.setStoreItem('addressOrder', null)
    // }
    this.goToLeavePosition();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['currentMyOrderTabIndex', 'weappMyOrders', 'sessionInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['customerNo']), {
    myWaitPayOrders: function myWaitPayOrders() {
      return this.orderObject.waitPayOrderList || [];
    },
    myExecutedOrders: function myExecutedOrders() {
      return this.orderObject.executedOrderList || [];
    },
    myFinishedOrders: function myFinishedOrders() {
      return this.orderObject.finishedOrderList || [];
    },
    myCancledOrders: function myCancledOrders() {
      return this.orderObject.cancledOrderList || [];
    },
    myWaitAuditOrderList: function myWaitAuditOrderList() {
      return this.orderObject.waitAuditOrderList || [];
    },
    showLoadMore: function showLoadMore() {
      var ifShowBtn = false;
      if (this.keywordSearchOnGoing) return false;
      switch (this.tabIndex) {
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITPAY:
          ifShowBtn = this.displayWaitPayOrders.length < this.myWaitPayOrders.length;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_EXECUTE:
          ifShowBtn = this.displayExecutedOrders.length < this.myExecutedOrders.length;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITAUDIT:
          ifShowBtn = this.displayWaitAduitOrders.length < this.myWaitAuditOrderList.length;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_FINISHED:
          ifShowBtn = this.displayFinishedOrders.length < this.myFinishedOrders.length;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_CANCELLED:
          ifShowBtn = this.displayCancledOrders.length < this.myCancledOrders.length;
          break;
      }
      return ifShowBtn;
    },
    hasCurrentDisplayOrders: function hasCurrentDisplayOrders() {
      var hasOrders = false;
      switch (this.tabIndex) {
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITPAY:
          hasOrders = this.displayWaitPayOrders.length > 0;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_EXECUTE:
          hasOrders = this.displayExecutedOrders.length > 0;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_FINISHED:
          hasOrders = this.displayFinishedOrders.length > 0;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITAUDIT:
          hasOrders = this.displayWaitAduitOrders.length > 0;
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_CANCELLED:
          hasOrders = this.displayCancledOrders.length > 0;
          break;
      }
      return hasOrders;
    },
    keywordSearchOnGoing: function keywordSearchOnGoing() {
      return this.searchMap && this.searchMap.keyword;
    },
    isAfterSales: function isAfterSales() {
      return !!this.$route.query.afterSales;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapMutations */])(['SET_CURRENT_MYORDER_TABINDEX', 'UPDATE_WEAPP_MYORDERS', 'SET_CURRENT_WAITPAY_ORDER']), {
    updateDisplayOrderList: function updateDisplayOrderList(list) {
      this.displayExecutedOrders = list || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].filterOrderListBySearchMap(this.myExecutedOrders, this.searchMap);
      this.displayFinishedOrders = list || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].filterOrderListBySearchMap(this.myFinishedOrders, this.searchMap);
      this.displayCancledOrders = list || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].filterOrderListBySearchMap(this.myCancledOrders, this.searchMap);
      this.displayWaitPayOrders = list || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].filterOrderListBySearchMap(this.myWaitPayOrders, this.searchMap);
      this.displayWaitAduitOrders = list || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].filterOrderListBySearchMap(this.myWaitAuditOrderList, this.searchMap);
    },
    handleFilter: function handleFilter(map) {
      this.searchMap = map;
      if (this.keywordSearchOnGoing) {
        this.updateDisplayOrderList();
      } else {
        this.updateDisplayOrderList([]);
        this.loadMoreCurrentTabDisplayOrders();
      }
      console.log('updateSearchMap', map);
    },
    setCurrentTabIndex: function setCurrentTabIndex() {
      if (!this.tabIndex) return;
      this.returnToTopPosition();
      this.SET_CURRENT_MYORDER_TABINDEX(this.tabIndex);
      if (!this.keywordSearchOnGoing) {
        this.updateDisplayOrderList([]);
        this.loadMoreCurrentTabDisplayOrders();
      }
    },
    fetchOrders: function fetchOrders() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var paramType, paramNo;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.customerNo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this.$weui.loading('获取订单中');
                _this.UPDATE_WEAPP_MYORDERS({});
                // test: getCustomerOrders type=2 no=00018007，00377256，00398575，00224169，00243640
                // 1.研转通 参数：type=4 and settlementAccountNo, 是本人
                // 执行中、已完成：根据结算账户取订单
                // 待下单、已取消：根据客户编号取订单
                // 2. gcrmg type = 2 CUSTOMER
                paramType = _this.$route.query.type || __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].QUERY_ORDER_TYPE.CUSTOMER;
                paramNo = Number(paramType) === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].QUERY_ORDER_TYPE.CUSTOMER ? _this.customerNo : __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getUrlParam('settlementAccountNo');
                _context2.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__emktcommon_api_orderApi_js__["l" /* getOrdersByCustomerOrResearchNo */])({ type: paramType, no: paramNo, afterSales: _this.$route.query.afterSales }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.$weui.loading().hide();
                            if (res) {
                              _this.orderObject = res;
                              _this.UPDATE_WEAPP_MYORDERS(_this.orderObject);
                              // console.log('getAllOrdersByCustomerNoOrResearchGroupNo', this.orderObject, 'this.tabIndex=', this.tabIndex)
                              // this.goToLeavePosition()
                              // this.getServiceOrder()
                              // this.loadMoreCurrentTabDisplayOrders()
                              // this.fetchOrdersCompleted = true
                            }

                            if (!(Number(paramType) === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].QUERY_ORDER_TYPE.SETTLEMENT_ACCOUNT)) {
                              _context.next = 8;
                              break;
                            }

                            _this.$weui.loading('获取订单中');
                            _context.next = 6;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__emktcommon_api_orderApi_js__["l" /* getOrdersByCustomerOrResearchNo */])({
                              type: __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].QUERY_ORDER_TYPE.CUSTOMER,
                              no: _this.customerNo,
                              afterSales: _this.$route.query.afterSales
                            }).then(function (res) {
                              _this.$weui.loading().hide();
                              if (res) {
                                _this.orderObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.orderObject, {
                                  waitPayOrderList: res.waitPayOrderList,
                                  cancledOrderList: res.cancledOrderList
                                });
                                _this.UPDATE_WEAPP_MYORDERS(_this.orderObject);
                                _this.goToLeavePosition();
                                _this.getServiceOrder();
                                _this.loadMoreCurrentTabDisplayOrders();
                                _this.fetchOrdersCompleted = true;
                              }
                            });

                          case 6:
                            _context.next = 13;
                            break;

                          case 8:
                            console.log('getAllOrdersByCustomerNoOrResearchGroupNo', _this.orderObject, 'this.tabIndex=', _this.tabIndex);
                            _this.goToLeavePosition();
                            _this.getServiceOrder();
                            _this.loadMoreCurrentTabDisplayOrders();
                            _this.fetchOrdersCompleted = true;

                          case 13:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    loadMoreCurrentTabDisplayOrders: function loadMoreCurrentTabDisplayOrders() {
      var _displayWaitPayOrders, _displayExecutedOrder, _displayWaitAduitOrde, _displayFinishedOrder, _displayCancledOrders;

      var startIndex = 0;
      var endIndex = 0;
      var expectEndIndex = 0;
      switch (this.tabIndex) {
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITPAY:
          startIndex = this.displayWaitPayOrders.length;
          expectEndIndex = this.displayWaitPayOrders.length + this.countOfLoadingMoreOrders;
          endIndex = expectEndIndex > this.myWaitPayOrders.length ? this.myWaitPayOrders.length : expectEndIndex;
          (_displayWaitPayOrders = this.displayWaitPayOrders).push.apply(_displayWaitPayOrders, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myWaitPayOrders.slice(startIndex, endIndex)));
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_EXECUTE:
          startIndex = this.displayExecutedOrders.length;
          expectEndIndex = this.displayExecutedOrders.length + this.countOfLoadingMoreOrders;
          endIndex = expectEndIndex > this.myExecutedOrders.length ? this.myExecutedOrders.length : expectEndIndex;
          (_displayExecutedOrder = this.displayExecutedOrders).push.apply(_displayExecutedOrder, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myExecutedOrders.slice(startIndex, endIndex)));
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_WAITAUDIT:
          startIndex = this.displayWaitAduitOrders.length;
          expectEndIndex = this.displayWaitAduitOrders.length + this.countOfLoadingMoreOrders;
          endIndex = expectEndIndex > this.myWaitAuditOrderList.length ? this.myWaitAuditOrderList.length : expectEndIndex;
          (_displayWaitAduitOrde = this.displayWaitAduitOrders).push.apply(_displayWaitAduitOrde, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myWaitAuditOrderList.slice(startIndex, endIndex)));
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_FINISHED:
          startIndex = this.displayFinishedOrders.length;
          expectEndIndex = this.displayFinishedOrders.length + this.countOfLoadingMoreOrders;
          endIndex = expectEndIndex > this.myFinishedOrders.length ? this.myFinishedOrders.length : expectEndIndex;
          (_displayFinishedOrder = this.displayFinishedOrders).push.apply(_displayFinishedOrder, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myFinishedOrders.slice(startIndex, endIndex)));
          break;
        case __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].MYORDER_TAB_CANCELLED:
          startIndex = this.displayCancledOrders.length;
          expectEndIndex = this.displayCancledOrders.length + this.countOfLoadingMoreOrders;
          endIndex = expectEndIndex > this.myCancledOrders.length ? this.myCancledOrders.length : expectEndIndex;
          (_displayCancledOrders = this.displayCancledOrders).push.apply(_displayCancledOrders, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myCancledOrders.slice(startIndex, endIndex)));
          break;
      }
    },
    getServiceOrder: function getServiceOrder() {
      var excutedList = this.orderObject.waitPayOrderList;
      var findout = excutedList.find(function (order) {
        order.itemList.map(function (item) {
          return item.contractNo;
        }).includes('GSGC0201795');
      });
      console.log('GSGC0201795', findout);
    },
    goToLeavePosition: function goToLeavePosition() {
      // 从订单详情返回到离开订单列表时的位置
      this.$nextTick(function () {
        var position = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].getLocalStorage('leaveOrderListPosition');
        console.log('leaveOrderListPosition', position);
        if (position === null || position === undefined || !document.getElementById('myOrderList')) return;
        document.getElementById('myOrderList').scrollTo(0, position);
      });
    },
    returnToTopPosition: function returnToTopPosition() {
      this.$nextTick(function () {
        console.log('returnToTopPosition');
        if (!document.getElementById('myOrderList')) return;
        document.getElementById('myOrderList').scrollTo(0, 0);
      });
    },

    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    cancelOrder: function cancelOrder(order) {
      var _this2 = this;

      if (!order) return;
      var orderId = order.id;
      if (!orderId) {
        return this.$weui.topTips('当前订单缺少订单编号');
        // return $.toast('当前订单缺少订单编号')
      }
      if (order.status > __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_PAIED && order.status < __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_FINISHED) {
        return alert('订单已开始生产，无法自行取消，如有疑问请联系客服人员', {
          buttons: [{
            label: '我知道了'
          }]
        });
      }
      this.$weui.loading('正在取消订单');
      // $.showPreloader('正在取消订单')
      // this.updateMyOrders(order)
      this.gcapi('orderCancel', { id: orderId }).then(function (data) {
        // $.hidePreloader()
        _this2.$weui.loading().hide();
        _this2.updateMyOrders(order);
        _this2.$weui.toast('取消成功', 1500);
        // $.toast('取消成功')
      });
    },
    updateMyAllOrders: function updateMyAllOrders(order) {
      var myOrders = this.weappMyOrders;
      var index = void 0;
      var index1 = void 0;
      // 待提交订单
      if (order.status <= __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SUBMITTED || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SIGN_NEED) {
        for (var i = 0; i < myOrders.waitPayOrderList.length; i++) {
          if (myOrders.waitPayOrderList[i].orderNo === order.orderNo) {
            index = i;
            break;
          }
        }
        if (index >= 0) {
          myOrders.waitPayOrderList.splice(index, 1, order);
        }
        for (var _i = 0; _i < this.displayWaitPayOrders.length; _i++) {
          if (this.displayWaitPayOrders[_i].orderNo === order.orderNo) {
            index1 = _i;
            break;
          }
        }
        if (index1 >= 0) {
          this.displayWaitPayOrders.splice(index1, 1, order);
        }
      } else if (order.status >= __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_PAIED && order.status <= 8) {
        // 执行中订单
        for (var _i2 = 0; _i2 < myOrders.executedOrderList.length; _i2++) {
          if (myOrders.executedOrderList[_i2].orderNo === order.orderNo) {
            index = _i2;
            break;
          }
        }
        if (index >= 0) {
          myOrders.executedOrderList.splice(index, 1, order);
        }
        for (var _i3 = 0; _i3 < this.displayExecutedOrders.length; _i3++) {
          if (this.displayExecutedOrders[_i3].orderNo === order.orderNo) {
            index1 = _i3;
            break;
          }
        }
        if (index1 >= 0) {
          this.displayExecutedOrders.splice(index1, 1, order);
        }
      } else if (this.orderDetail.status >= 8 && this.orderDetail.status <= __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_FINISHED) {
        // 已完成订单
        for (var _i4 = 0; _i4 < myOrders.finishedOrderList.length; _i4++) {
          if (myOrders.finishedOrderList[_i4].orderNo === order.orderNo) {
            index = _i4;
            break;
          }
        }
        if (index >= 0) {
          myOrders.finishedOrderList.splice(index, 1, order);
        }
        for (var _i5 = 0; _i5 < this.displayFinishedOrders.length; _i5++) {
          if (this.displayFinishedOrders[_i5].orderNo === order.orderNo) {
            index1 = _i5;
            break;
          }
        }
        if (index1 >= 0) {
          this.displayFinishedOrders.splice(index1, 1, order);
        }
      }
      this.UPDATE_WEAPP_MYORDERS(myOrders);
      console.log('updateMyOrders weappMyOrders finish', this.weappMyOrders);
    },
    updateMyOrders: function updateMyOrders(order) {
      var myOrders = this.weappMyOrders;
      var index = void 0;
      var index2 = void 0;
      // 待提交订单
      if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SUBMITTED || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SIGN_NEED) {
        myOrders.waitPayOrderList.some(function (item, i) {
          if (item.id === order.id) {
            index = i;
            return true;
          }
        });
        if (index >= 0) {
          myOrders.waitPayOrderList.splice(index, 1);
        }
        this.displayWaitPayOrders.some(function (item, i) {
          if (item.id === order.id) {
            index2 = i;
            return true;
          }
        });
        if (index2 >= 0) {
          this.displayWaitPayOrders.splice(index, 1);
        }
        console.log(index, index2, myOrders, myOrders.waitPayOrderList, order, this.displayWaitPayOrders);
      } else if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_PAIED) {
        // 执行中订单
        myOrders.executedOrderList.some(function (item, i) {
          if (item.id === order.id) {
            index = i;
            return true;
          }
        });
        if (index >= 0) {
          myOrders.executedOrderList.splice(index, 1);
        }
        this.displayExecutedOrders.some(function (item, i) {
          if (item.id === order.id) {
            index2 = i;
            return true;
          }
        });
        index2 = this.displayExecutedOrders.indexOf(order);
        if (index2 >= 0) {
          this.displayExecutedOrders.splice(index, 1);
        }
      }
      order.status = __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_ABORT;
      myOrders.cancledOrderList.unshift(order);
      this.displayCancledOrders.unshift(order);
      this.UPDATE_WEAPP_MYORDERS(myOrders);
      console.log('updateMyOrders weappMyOrders finish', myOrders, this.weappMyOrders);
    },
    handleOrderCancel: function handleOrderCancel(order) {
      var _this3 = this;

      this.$weui.dialog({
        title: '当订单未提交或未开始生产时，您随时可以取消订单，是否确认取消？',
        buttons: [{
          label: '否',
          type: 'default',
          onClick: function onClick() {
            return;
          }
        }, {
          label: '是',
          type: 'primary',
          onClick: function onClick() {
            _this3.cancelOrder(order);
          }
        }]
      });
    },
    handleOrderToCheckSignApprove: function handleOrderToCheckSignApprove(bOrder) {
      var _this4 = this;

      this.$weui.loading('加载中');
      this.gcapi('checkOrderSignAndApprove', [{ id: bOrder.id }]).then(function (response) {
        if (response && response.body.result && response.body.code === 0) {
          _this4.$weui.loading('加载中').hide();
          var order = response.body.result[0];
          if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_ABORT) {
            alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单');
            if (__WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].isWapp) {
              __WEBPACK_IMPORTED_MODULE_5_wx___default.a.miniProgram.switchTab({ url: '/pages/cart/cart' });
            } else {
              _this4.$router.replace({ name: 'cart' });
            }
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_CHECK || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SUBMITTED) {
            _this4.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_SIGN_NEED) {
            _this4.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_PAIED) {
            _this4.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } });
          } else if (order.status === __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
            _this4.$weui.topTips('提交订单失败，请联系客服或重新提交订单');
          }
        }
      });
    },
    handleOrderSubmit: function handleOrderSubmit(order) {
      var _this5 = this;

      this.$weui.loading('加载中');
      console.log('handleOrderSubmit', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then(function (res) {
        if (res && res.body.result) {
          var waitPayOrder = res.body.result;
          _this5.SET_CURRENT_WAITPAY_ORDER(waitPayOrder);
          _this5.$weui.loading('加载中').hide();
          _this5.$router.push({ name: 'WeappOrderConfirmation' });
        }
      });
    },
    handleOrderToSign: function handleOrderToSign(order) {
      console.log('handleOrderSubmit', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      __WEBPACK_IMPORTED_MODULE_8__emkt__["a" /* default */].setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop);
      this.$router.push({ name: 'promotions', query: { orderId: order.id, cc: true } });
    }
  })
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      display: false,
      touchFlag: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["hasLogin"])),
  methods: {
    handleTouchStart: function handleTouchStart(e) {
      this.touchFlag = true;
      this.$emit("preventTouchMove");
    },
    handleTouchMove: function handleTouchMove(e) {
      if (this.touchFlag === false) return;
      var touch = e.touches[0];
      var screenHeight = window.innerHeight;
      var element = document.getElementById("service");
      if (touch.clientY + 45 > screenHeight) {
        element.style.top = screenHeight - 45 + "px";
      } else if (touch.clientY < 0) {
        element.style.top = 0 + "px";
      } else {
        element.style.top = touch.clientY + "px";
      }
    },
    handleTouchEnd: function handleTouchEnd() {
      this.touchFlag = false;
      this.$emit("activateTouchMove");
    },
    tokefuMessage: function tokefuMessage() {
      if (this.hasLogin) {
        if (__WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].isWapp) {
          __WEBPACK_IMPORTED_MODULE_2_wx___default.a.miniProgram.navigateTo({
            url: '/pages/consult/consult'
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__emkt__["a" /* default */].openCustomerService();
        }
      } else {
        alert("请您先去登录！");
      }
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FooterPlaceholder'
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emkt__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    payType: function payType() {
      // 个人发票支付
      if (this.selectedBalanceType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_FAPIAO) {
        return '3';
      }
      // 个人余额支付
      if (this.selectedBalanceType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        return '1';
      }
      // 课题组结算（发票报账）
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_FAPIAO) {
        return this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '6' : '3';
      }
      // 课题组结算（余额支付）
      if (this.selectedBalanceType !== __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].BALANCE_TYPE_CUSTOMER && this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        return this.selectedBalanceType.settlementAccountType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '7' : '1';
      }
    }
  },
  methods: {
    openPayMethodBox: function openPayMethodBox() {
      this.showChoosePayMethod = true;
      if (this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY && !this.verifyFinish) {
        this.showAccountVerifyBox = true;
      }
      if (!this.verifyFinish) {
        this.nameQuery = '';
        this.mobileQuery = '';
        this.verifyCode = '';
      }
    },
    handlePayTypeChange: function handlePayTypeChange() {
      if (this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY) {
        this.payByRestMoney();
      } else {
        this.showAccountVerifyBox = false;
      }
      this.checkSettmentAccount();
    },
    updatePayMethod: function updatePayMethod() {
      if (this.selectedPayType === __WEBPACK_IMPORTED_MODULE_0__emkt__["a" /* default */].PAY_TYPE_REMAIN_MONEY && !this.verifyFinish) {
        this.linkRestMoneyAccount();
      } else {
        this.closeChoosePayMethodBox();
        this.choosevip(this.payTypeOptionMapping[this.payType]);
      }
    },
    closeChoosePayMethodBox: function closeChoosePayMethodBox() {
      this.showChoosePayMethod = false;
    },
    sendVeriCode: function sendVeriCode() {
      this.gcapi('gcwwwifc/applyPrepayCustomer', {
        'Mobile': this.mobileQuery
      });
      var wait = 60;
      function time(o) {
        if (wait === 0) {
          o.innerHTML = '验证';
          o.style.color = '#5878fa';
          wait = 60;
        } else {
          o.innerHTML = wait + 's';
          o.style.color = '#C8C8C8';
          wait--;
          setTimeout(function () {
            time(o);
          }, 1000);
        }
      }
      time(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#enterBtn')[0]);
    },
    linkRestMoneyAccount: function linkRestMoneyAccount() {
      var _this = this;

      if (this.verifyFinish) {
        this.choosevip(this.payTypeOptionMapping[this.payType]);
        this.closeChoosePayMethodBox();
        return;
      }
      this.gcapi('gcwwwifc/confirmPrepayCustomer', {
        'Mobile': this.mobileQuery,
        'VerifyCode': this.verifyCode
      }).then(function (response) {
        if (response.body.code !== 0) {
          _this.$weui.topTips('请先验证余额账户', 2000);
          // $.toast('请先验证余额账户')
          return;
        }
        var customerNo = response.body.result;
        _this.restPayCustomerNo = customerNo;
        _this.verifyFinish = true;
        _this.$weui.toast('绑定成功', 1500);
        _this.getSettlementAccount();
        _this.choosevip(_this.payTypeOptionMapping[_this.payType]);
        _this.closeChoosePayMethodBox();
      });
    },
    getSettlementAccount: function getSettlementAccount() {
      var _this2 = this;

      var customerNo = this.sessionInfo.customerInfo.customerNo;
      this.gcapi('getSettlementAccountListInfo', customerNo).then(function (res) {
        if (res.body.result) {
          _this2.settlementAccountList = res.body.result;
          if (!_this2.settlementAccountList || _this2.settlementAccountList.length === 0) {
            _this2.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500);
            return;
          }
          // 获取所有课题组列表,选择课题组初始默认值
          _this2.SettlementAccountNameList = _this2.settlementAccountList.map(function (group) {
            return group.settlementAccountName;
          });
        }
      });
    },
    checkRestMoneyAccount: function checkRestMoneyAccount() {
      var _this3 = this;

      this.verifyCode = '';
      this.verifyFinish = false;
      var myreg = /^(1[3456789]\d{9})$/;
      if (!myreg.test(this.mobileQuery)) {
        this.$weui.topTips('请输入正确的手机号', 2000);
        return;
        // return $.toast('请输入正确的手机号')
      }
      this.$weui.loading('验证中');
      // $.showPreloader('验证中')
      this.gcapi('gcwwwifc/verifyPrepayCustomer', {
        'CustomerName': this.nameQuery,
        'Mobile': this.mobileQuery
      }).then(function (response) {
        _this3.$weui.loading().hide();
        var customerNo = response.body.result;
        if (customerNo) {
          _this3.verifyFinish = true;
          _this3.restPayCustomerNo = customerNo;
          _this3.verifyCode = '验证通过(再次使用无需验证码)';
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#search_code')[0].style.color = '#60D837';
        } else {
          _this3.sendVeriCode();
        }
      });
    },
    payByRestMoney: function payByRestMoney() {
      console.log('payByRestMoney');
      this.yueyanzheng = false;
      if (this.order.specialFundCouponUsed === 1) {
        console.log(this.chosenSettlementAccount);
        this.verifyFinish = true;
        this.showAccountVerifyBox = false;
        if (!this.chosenSettlementAccount.prepayCustomerNo) {
          this.$weui.toast('请使用优惠券拥有者的课题组结算账户', 1500);
        } else {
          this.restPayCustomerNo = this.chosenSettlementAccount.prepayCustomerNo;
        }
        return;
      }
      if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
        this.showAccountVerifyBox = true;
      } else {
        this.verifyFinish = true;
        this.showAccountVerifyBox = false;
        this.restPayCustomerNo = this.sessionInfo.customerInfo.customerNo;
      }
    }
  }
});

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAYAAADOMhxqAAABXElEQVQ4T5WULUzEQBCF36xCIsGCR+HgBBIsqDuSTmsu4UeAhnACNARIkLvbGnAEiSNBgTiPahUJDnm5doeUtOSAa683dvLlvdl9M6S1fhGR9+FwuNXtdoeYUGSMeRWRZQB3SZK0e72eq2MoiqL5NE2fASwQ0Q0z79QCedMYsygiOTQnImdBEBxVQVQ2rLVLzrknALNEdMjM5+OgH6BQWhGRRwAzROQzc/gX+gXkTa31BoB7ESGl1CYzP4xC/4ACagOIiGjgnFsPgiC3+l1jgcLerohcA/hUSq15ntevBQqlEwA9AB9KqZbneW+VCqUFrfUlgH0RSbIsW50I5MNba0MR2SaifiPAGBMB6DQCSksA4jRNW7UKWuvmQ1tr95xzV42eNQzDdpZlue+BiNR/3FTRMMY0D99ovAEc+L5/URnv0QUiolNmPq5coKlXtDwCRHQbx3Fn4hGY9sx8Aa/M109iETpaAAAAAElFTkSuQmCC"

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1006)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ef69dde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c525b70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-682eafec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1524),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04cfcb94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22d8b2ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3b41db0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-384caa39",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22d502ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-408f0bab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ec318ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1518),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-001c3d14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80195964",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fe5ec5d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bfbe420",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27670d3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7074a85a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-92a1c568",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70621cca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a2f97996",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-166e6249",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1562),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fef93ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18bde554",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1595),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34031b06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1556),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a8c0d09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1013)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5421dd64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bb80526",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bf5cc6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1776204a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1533),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0db06f2d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f5e45ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(986)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3da4d5e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1521),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01fcba10",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1701),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9b5fa670",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-526b6608",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1098)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c70f140e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dbcd38a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6111aab7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f16b532",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1e6d314",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1737),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4ae669e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1007)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f2e5d18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4dba01e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-163567e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1563),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1025)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(980)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1603),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1094)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1717),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c146e3cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-154f2b74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-407eaa28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-659e6253",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-856d4496",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1575),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28eaaa3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96425f96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b256b352",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1726),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e4a74ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1553),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19467000",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1083)
  __webpack_require__(1082)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7d77af4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1732),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dde62604",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b21d7e7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4eaf556d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d1ece11",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1122)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1744),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(964)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f89e6cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1114)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1736),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-573843f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-972b3f56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1565),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21af0417",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14d565ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58077088",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1554),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1994611a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b4c6501",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9032b80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(959)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ba166d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64fda064",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57ed26ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3836c7e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7af603d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-987fae74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1580),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b095bca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e7b91e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53230180",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-add23eac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1668),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a33df7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e65c008",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(962)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e46a633",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17b2f1f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0042c16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1690),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ba4c01a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1543),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13c04388",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(944)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-200e8843",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-183173d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(976)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-377156f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1018)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57b117b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1557),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1731),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddb7d168",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1622),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49bdbc22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1560),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d57e38c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38cb35a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d8fb65a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d7d88e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-557fa056",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06384b6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e6dcf1ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67735b86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-afed295c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1095)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c23cd822",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1102)
  __webpack_require__(1103)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf236dc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c0df518",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1119)
  __webpack_require__(1120)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1742),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7df061c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e5c3c78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8299c0b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1096ae26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1623),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bb8fb74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a8bb66a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6bbc412",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1117)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f69f9510",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f683660e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(974)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-350bd142",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(970)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-329b3bd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(940)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1558),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d1af86c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(996)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1619),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45666f84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1540),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11248523",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3912f064",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1004)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(1628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4da19f80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1090)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b389871c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8408af68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1037)
  __webpack_require__(1038)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(1661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6352c013",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(1728),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc15950e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(983)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(1606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b5c42ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(1687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83c6ab30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1704),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a395ee44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08323ab6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1124)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(1746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ff5c8ec6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1526),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06fcc2de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(1724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cdad1112",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1527),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-076231dd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(1730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddb2a200",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1559),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1621),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1745),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fea06f3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1747),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffe83e9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(955)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29b01106",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1620),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31800b8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1588),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1429d13a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60a1920d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(993)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42516894",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8de0aa08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(956)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29cccd02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-138e8f6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7af27be2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bee0424e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-552c9650",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1030)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c51a9b7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ced4c00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1520),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0113e806",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b0a07dd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-952cb7e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-958dfe2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-829f1ade",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af38ad08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1021)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-585e7458",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-613bf14b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29a9b998",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(969)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1592),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-321b713c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62f5de36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1675),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-710761d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c10d3ada",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a1d858c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1001)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cabd1ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3820d34e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a151956a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4187cf62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3332fec2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35070632",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73d98287",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-start/bg.png"
    }
  }, [_c('img', {
    staticClass: "main-title ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-start/shape-1-new.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-button ani",
    attrs: {
      "swiper-animate-effect": "animate__pulse",
      "src": "/static/img/anniversary/page-start/shape-02.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "brand-area ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-start/shape-3-new.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [(!_vm.isWapp) ? _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "box-sizing": "content-box",
      "font-size": "0.8rem",
      "color": "#0894ec",
      "margin-top": "-1rem"
    }
  }, [_vm._t("header", function() {
    return [_vm._v("\n          吉凯基因淘基因用户注册协议\n        ")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "box-sizing": "content-box",
      "font-size": "0.8rem",
      "color": "#0894ec",
      "margin-top": "-0.2rem"
    }
  }, [_vm._t("header", function() {
    return [_vm._v("\n          吉凯基因淘基因用户注册协议\n        ")]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isWapp) ? _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "height": "24rem",
      "margin-top": "-1rem"
    }
  }, [_vm._t("body", function() {
    return [_vm._m(0)]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('div', {
    staticClass: "modal-body-1",
    staticStyle: {
      "margin-top": "0.16rem"
    }
  }, [_vm._t("body", function() {
    return [_vm._m(1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "-6.2rem"
    }
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "content-block"
    }, [(_vm.currentPage === '/login/register') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-50",
      staticStyle: {
        "float": "left"
      }
    }, [_c('router-link', {
      staticClass: "button button-big button-fill button-danger button-font",
      attrs: {
        "to": {
          name: 'login'
        }
      }
    }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-50",
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticClass: "button button-big button-fill button-font",
      on: {
        "click": _vm.close
      }
    }, [_vm._v("同意并继续")])])]) : (_vm.currentPage.includes('/ResearchGroup/RegisterContact')) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-50",
      staticStyle: {
        "float": "left"
      }
    }, [_c('router-link', {
      staticClass: "button button-big button-fill button-danger button-font",
      attrs: {
        "to": {
          name: 'AddResearchMember',
          query: {
            defaultIndex: _vm.defaultIndex
          }
        }
      }
    }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-50",
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticClass: "button button-big button-fill button-font",
      on: {
        "click": _vm.close
      }
    }, [_vm._v("同意并继续")])])]) : _c('div', {
      staticClass: "row"
    }, [(!_vm.isWapp) ? _c('div', {
      staticClass: "col-100",
      staticStyle: {
        "float": "left"
      }
    }, [_c('router-link', {
      staticClass: "button button-big button-fill button-danger button-font",
      attrs: {
        "to": {
          name: 'login'
        }
      }
    }, [_vm._v("已读")])], 1) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('div', {
      staticClass: "col-100",
      staticStyle: {
        "float": "left"
      }
    }, [_c('router-link', {
      staticClass: "read-button read-button-big read-button-fill read-button-danger read-button-font",
      attrs: {
        "to": {
          name: 'login'
        }
      }
    }, [_vm._v("已读")])], 1) : _vm._e()])])]
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block height"
  }, [_c('ul', {
    staticClass: "height border-ul",
    staticStyle: {
      "height": "19rem"
    }
  }, [_c('li', {
    staticClass: "align-top height"
  }, [_c('div', {
    staticClass: "item-content height"
  }, [_c('div', {
    staticClass: "item-inner height"
  }, [_c('div', {
    staticClass: "item-input height"
  }, [_c('div', {
    staticClass: "textArea",
    staticStyle: {
      "height": "18rem"
    },
    attrs: {
      "readonly": "true"
    }
  }, [_vm._v("    本协议是用户（以下简称“您”）与吉凯基因淘基因线上平台（以下简称“淘基因”）及其关联公司之间就吉凯基因数字营销服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击\"同意\"按钮后，即视为您接受并同意遵守本协议的约定。\n                        "), _c('br'), _vm._v("第1条 本站服务条款的确认和接纳\n                        "), _c('br'), _c('strong', [_vm._v("1.1")]), _vm._v("本站的各项电子服务的所有权和运作权归淘基因所有。您同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。您确认：本协议条款是处理双方权利义务的依据，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定或约定。\n                        "), _c('br'), _c('strong', [_vm._v("1.2")]), _vm._v("您点击同意本协议的，即视为您确认自己具有享受本站服务相应的权利能力和行为能力，能够独立承担法律责任。\n                        "), _c('br'), _c('strong', [_vm._v("1.3")]), _vm._v("您确认，如果您在18周岁以下，您只能在父母或其他监护人的监护参与下才能使用本站。\n                        "), _c('br'), _c('strong', [_vm._v("1.4")]), _vm._v("淘基因保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n                        "), _c('br'), _c('strong', [_vm._v("1.5")]), _vm._v("您使用本站提供的服务时，应同时接受适用于本站特定服务、活动等的准则、条款和协议（以下统称为“其他条款”）；如果以下使用条件与“其他条款”有不一致之处，则以“其他条款”为准。\n                        "), _c('br'), _c('strong', [_vm._v("1.6")]), _vm._v("为表述便利，商品和各类技术服务简称为“商品”或“货物”。\n                        "), _c('br'), _vm._v("第2条 本站服务\n                        "), _c('br'), _c('strong', [_vm._v("2.1")]), _vm._v("吉凯基因淘基因通过互联网依法为您提供产品及技术支持等服务，您在完全同意本协议及本站相关规定的情况下，方有权使用本站的相关服务。\n                        "), _c('br'), _c('strong', [_vm._v("2.2")]), _vm._v("您必须自行准备如下设备和承担如下开支：\n                        "), _c('br'), _c('strong', [_vm._v("2.2.1")]), _vm._v("上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；\n                        "), _c('br'), _c('strong', [_vm._v("2.2.2")]), _vm._v("上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。\n                        "), _c('br'), _vm._v("第3条 用户信息收集及保护\n                        "), _c('br'), _c('strong', [_vm._v("3.1")]), _vm._v("您应自行诚信向本站提供注册资料，您保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且吉凯基因保留单方终止您使用淘基因各项服务的权利。\n                        "), _c('br'), _c('strong', [_vm._v("3.2")]), _vm._v("您在本站进行注册、浏览、下单购物、评价、参加活动等行为时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情、评价或反馈、投诉内容、cookies等信息的，本站有权从完成交易、提供配送、售后及客户服务、开展活动、完成良好的客户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密，除非得到您的授权、为履行强行性法律义务（如国家安全机关指令）或法律另有规定、本注册协议或其他条款另有约定外，本站不会向外界披露您的隐私信息。\n                        "), _c('br'), _c('strong', [_vm._v("3.3")]), _vm._v("您注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。您应谨慎合理的保存、使用您的账户信息。您若发现任何非法使用您的账户或其他存在安全漏洞的情况的，请立即通知本站并向公安机关报案。\n                        "), _c('br'), _c('strong', [_vm._v("3.4您同意，淘基因拥有通过邮件、短信、电话、网站通知或声明等形式，向在本站注册、购物的用户、收货人发送订单信息、促销活动、售后服务、客户服务等告知信息的权利。如您不希望接收上述信息，可退订。\n                        "), _c('br'), _c('strong', [_vm._v("3.5")]), _vm._v("您同意：您选择向本站的商品销售商或服务提供商（以下统称为“销售商”，含淘基因及其关联公司）提交订单购买商品或服务的，视为您向销售商披露个人相关信息，接受销售商向您提供商品销售、配送、售后服务、客户服务、处理信用卡付款、数据分析、市场营销帮助或其他必要事宜；如前述全部或部分事宜之一涉及由销售商外的第三方履行的，销售商有权将您的信息以必要方式向第三方披露，第三方有权以履行上述事宜为目的联系您。\n                        "), _c('br'), _c('strong', [_vm._v("3.6")]), _vm._v("您不得将在本站注册获得的账号、密码等账户信息提供给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。\n                        "), _c('br'), _c('strong', [_vm._v("3.7")]), _vm._v("您同意，淘基因有权使用您的注册信息、用户名、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。")]), _vm._v(" "), _c('br'), _vm._v("第4条 用户依法言行义务\n                        "), _c('br'), _vm._v("本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：\n                        "), _c('br'), _c('strong', [_vm._v("4.1")]), _vm._v("不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n                        "), _c('br'), _c('strong', [_vm._v("4.2")]), _vm._v("从中国大陆向境外传输资料信息时必须符合中国有关法律法规；\n                        "), _c('br'), _c('strong', [_vm._v("4.3")]), _vm._v("不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n                        "), _c('br'), _c('strong', [_vm._v("4.4")]), _vm._v("不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；\n                        "), _c('br'), _c('strong', [_vm._v("4.5")]), _vm._v("不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；\n                        "), _c('br'), _c('strong', [_vm._v("4.6")]), _vm._v("不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n                        "), _c('br'), _c('strong', [_vm._v("4.7")]), _vm._v("不得教唆他人从事本条所禁止的行为；\n                        "), _c('br'), _c('strong', [_vm._v("4.8")]), _vm._v("除本注册协议、其他条款或另有其他约定外，您不得利用在本站注册的账户进行经营活动、牟利行为及其他未经本站许可的行为，包括但不限于以下行为：\n                        "), _c('br'), _c('strong', [_vm._v("4.8.1")]), _vm._v("您账户内的任何淘基因优惠信息（包括但不限于优惠券、折扣券、产品赠送券及其他形式优惠或折扣等）由吉凯基因享有解释权和修改权，您仅享有在淘基因购物时的使用权，严禁转卖淘基因账户、优惠券、折扣券、产品赠送券或其他类型的优惠券、或利用淘基因账户进行其他经营性行为等；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.2")]), _vm._v("恶意利用技术手段或其他方式，为获取优惠、折扣或其他利益而注册账户、下单等行为，影响其他用户正常消费行为或相关合法权益、影响淘基因正常销售秩序的行为；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.3")]), _vm._v("发布广告、垃圾邮件；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.4")]), _vm._v("以再销售或商业使用为目的对本站商品或服务进行购买的（与吉凯基因另有合同约定的除外）；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.5")]), _vm._v("商品或服务的供应商、代理商对其所供商品进行回购的行为；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.6")]), _vm._v("任何对商品目录、说明、价格、数量、其他用户信息或其他内容的下载、转载、收集、衍生利用、复制、出售、转售或其他形式的使用，无论是否通过Robots、Spiders、自动仪器或手工操作；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.7")]), _vm._v("本站相关规则、政策、或网页活动规则中限制、禁止的行为；\n                        "), _c('br'), _c('strong', [_vm._v("4.8.8")]), _vm._v("其他影响淘基因对用户账户正常管理秩序的行为。\n                        "), _c('br'), _c('strong', [_vm._v("4.9")]), _vm._v("您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则淘基因有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案。\n                        "), _c('br'), _c('strong', [_vm._v("4.10")]), _vm._v("您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现您发布的信息涉嫌知识产权、或其他合法权益争议的，这些用户或权利人有权要求淘基因删除您发布的信息，或者采取其他必要措施予以制止，淘基因将会依法采取这些措施。\n                        "), _c('br'), _c('strong', [_vm._v("4.11")]), _vm._v("您应不时关注并遵守本站不时公布或修改的各类规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知您的权利。\n                        "), _c('br'), _c('strong', [_vm._v("4.12")]), _vm._v("若您未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭您的账号、冻结账号内金额、关闭相应交易订单、停止发货等措施。您须对自己在网上的言论和行为承担法律责任。\n                        "), _c('br'), _vm._v("第5条 商品信息\n                        "), _c('br'), _c('strong', [_vm._v("5.1")]), _vm._v("本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；淘基因欢迎纠错，并会视情况给予纠错者一定的奖励。\n                        "), _c('br'), _c('strong', [_vm._v("5.2")]), _vm._v("本站售后服务政策为本协议的组成部分，淘基因有权以声明、通知或其他形式变更售后服务政策。\n                        "), _c('br'), _vm._v("第6条 订单\n                        "), _c('br'), _c('strong', [_vm._v("6.1")]), _vm._v("在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、周期、产品性状、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。\n                        "), _c('br'), _c('strong', [_vm._v("6.2")]), _vm._v("除法律另有强制性规定外，双方约定如下：本站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售商发出的合同要约；当您确认订单信息，并且在线点击“确认下单”后，进入下单成功页面，即视为您与销售商之间就您采购的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售商只给您发出了部分商品时，您与销售商之间仅就实际直接向您发出的商品建立了合同关系；只有在销售商实际直接向您发出了订单中订购的其他商品时，您和销售商之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登陆您在本站注册的账户，查询您的订单状态。\n                        "), _c('br'), _c('strong', [_vm._v("6.3尽管销售商做出最大的努力，但商品目录里的一小部分商品可能会有定价错误。如果发现错误定价，将采取下列之一措施，且不视为违约行为：\n                        "), _c('br'), _vm._v("6.3.1如果某一商品的正确定价低于销售商的错误定价，销售商将按照较低的定价向您销售交付该商品。\n                        "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n                        "), _c('br'), _vm._v("由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您下单所购买的商品，发生缺货，您有权取消订单，销售商亦有权取消订单，并为已付款的用户办理退款。")]), _vm._v(" "), _c('br'), _vm._v("第7条 配送\n                        "), _c('br'), _c('strong', [_vm._v("7.1")]), _vm._v("销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。\n                        "), _c('br'), _c('strong', [_vm._v("7.2")]), _vm._v("因如下情况造成订单延迟或无法配送、交货等，销售商不承担延迟配送、交货的责任：\n                        "), _c('br'), _c('strong', [_vm._v("（1）")]), _vm._v("您提供的信息错误、地址不详细等原因导致的；\n                        "), _c('br'), _c('strong', [_vm._v("（2）")]), _vm._v("货物送达后无人签收，导致无法配送或延迟配送的；\n                        "), _c('br'), _c('strong', [_vm._v("（3）")]), _vm._v("情势变更因素导致的；\n                        "), _c('br'), _c('strong', [_vm._v("（4）")]), _vm._v("未能在本站所示的送货参考时间内送货的；\n                        "), _c('br'), _c('strong', [_vm._v("（5）")]), _vm._v("因节假日、大型促销活动、店庆、预购或抢购人数众多等原因导致的；\n                        "), _c('br'), _c('strong', [_vm._v("（6）")]), _vm._v("不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n                        "), _c('br'), _vm._v("第8条 所有权及知识产权条款\n                        "), _c('br'), _c('strong', [_vm._v("8.1您一旦接受本协议，即表明您主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给淘基因所有，您同意吉凯基因有权就任何主体侵权而单独提起诉讼。\n                        "), _c('br'), _vm._v("8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在淘基因上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。\n                        "), _c('br'), _vm._v("8.3您同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其他主体以任何方式使用（包括但限于在各类网站、媒体上使用）。\n                        "), _c('br'), _vm._v("8.4淘基因有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知您。在法律允许的最大限度范围内，淘基因对本协议及本站内容拥有解释权。\n                        "), _c('br'), _vm._v("8.5除法律另有强制性规定外，未经淘基因明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，淘基因有权追究其法律责任。")]), _vm._v(" "), _c('br'), _c('strong', [_vm._v("8.6")]), _vm._v("本站所刊登的资料信息（包括但不限于文字、图表、商标、logo、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件等），均是淘基因或其内容提供者的财产，受中国和国际相关版权法规、公约等的保护，未经淘基因书面许可，任何第三方无权将上述资料信息复制、出版、发行、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。本站上所有内容的汇编是淘基因的排他财产，受中国和国际版权法的保护。本站上所有软件都是淘基因或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分软件，或利用软件创设衍生产品。\n                        "), _c('br'), _vm._v("第9条 责任限制及不承诺担保\n                        "), _c('br'), _c('strong', [_vm._v("9.1")]), _vm._v("除非另有明确的书面说明,本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。\n                        "), _c('br'), _c('strong', [_vm._v("9.2")]), _vm._v("除非另有明确的书面说明, 淘基因不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。\n                        "), _c('br'), _c('strong', [_vm._v("9.3")]), _vm._v("淘基因不担保本站所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。\n                        "), _c('br'), _c('strong', [_vm._v("9.4")]), _vm._v("如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，淘基因会合理地尽力协助处理善后事宜。\n                        "), _c('br'), _c('strong', [_vm._v("9.5")]), _vm._v("您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，您应承担全部责任。同时，因网络环境存在众多不可预知因素，因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的淘基因账户或个人信息等被第三方窃取的，淘基因不承担赔偿责任。\n                        "), _c('br'), _c('strong', [_vm._v("9.6")]), _vm._v("您了解并同意，吉凯基因有权应国家有关机关的要求，向其提供您在淘基因的用户信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则吉凯基因有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。\n                        "), _c('br'), _vm._v("第10条 协议更新及用户关注义务\n                        "), _c('br'), _vm._v("根据国家法律法规变化及网站运营需要，吉凯基因有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议、其他条款及网站公告。如您不同意更新后的协议，可以且应立即停止接受淘基因依据本协议提供的服务；如您继续使用本站提供的服务的，即视为同意更新后的协议。淘基因建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n                        "), _c('br'), _vm._v("第11条 法律管辖和适用\n                        "), _c('br'), _vm._v("本协议的订立、执行和解释及争议的解决均适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的"), _c('span', {
    staticClass: "background"
  }, [_vm._v("上海市徐汇区人民法院")]), _vm._v("提起诉讼。\n                        "), _c('br'), _vm._v("第12条 其他\n                        "), _c('br'), _c('strong', [_vm._v("12.1")]), _vm._v("淘基因所有者是指在政府部门依法许可或备案的吉凯基因网站经营主体。\n                        "), _c('br'), _c('strong', [_vm._v("12.2")]), _vm._v("淘基因尊重您的合法权利，本协议及本站上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。本站欢迎您和社会各界提出意见和建议，淘基因将虚心接受并适时修改本协议及本站上的各类规则。\n                        "), _c('br'), _c('strong', [_vm._v("12.3")]), _vm._v("本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请您着重阅读。\n                        "), _c('br'), _c('strong', [_vm._v("12.4")]), _vm._v("您点击本协议下方的“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。\n                      ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block-1"
  }, [_c('ul', {
    staticClass: "border-ul-1"
  }, [_c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('div', {
    staticClass: "textArea",
    staticStyle: {
      "height": "18rem"
    },
    attrs: {
      "readonly": "readonly"
    }
  }, [_vm._v("    本协议是用户（以下简称“您”）与吉凯基因淘基因线上平台（以下简称“淘基因”）及其关联公司之间就吉凯基因数字营销服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击\"同意\"按钮后，即视为您接受并同意遵守本协议的约定。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第1条 本站服务条款的确认和接纳\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.1")]), _vm._v("本站的各项电子服务的所有权和运作权归淘基因所有。您同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。您确认：本协议条款是处理双方权利义务的依据，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定或约定。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.2")]), _vm._v("您点击同意本协议的，即视为您确认自己具有享受本站服务相应的权利能力和行为能力，能够独立承担法律责任。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.3")]), _vm._v("您确认，如果您在18周岁以下，您只能在父母或其他监护人的监护参与下才能使用本站。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.4")]), _vm._v("淘基因保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.5")]), _vm._v("您使用本站提供的服务时，应同时接受适用于本站特定服务、活动等的准则、条款和协议（以下统称为“其他条款”）；如果以下使用条件与“其他条款”有不一致之处，则以“其他条款”为准。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("1.6")]), _vm._v("为表述便利，商品和各类技术服务简称为“商品”或“货物”。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第2条 本站服务\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("2.1")]), _vm._v("吉凯基因淘基因通过互联网依法为您提供产品及技术支持等服务，您在完全同意本协议及本站相关规定的情况下，方有权使用本站的相关服务。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("2.2")]), _vm._v("您必须自行准备如下设备和承担如下开支：\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("2.2.1")]), _vm._v("上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("2.2.2")]), _vm._v("上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第3条 用户信息收集及保护\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.1")]), _vm._v("您应自行诚信向本站提供注册资料，您保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且吉凯基因保留单方终止您使用淘基因各项服务的权利。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.2")]), _vm._v("您在本站进行注册、浏览、下单购物、评价、参加活动等行为时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情、评价或反馈、投诉内容、cookies等信息的，本站有权从完成交易、提供配送、售后及客户服务、开展活动、完成良好的客户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密，除非得到您的授权、为履行强行性法律义务（如国家安全机关指令）或法律另有规定、本注册协议或其他条款另有约定外，本站不会向外界披露您的隐私信息。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.3")]), _vm._v("您注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。您应谨慎合理的保存、使用您的账户信息。您若发现任何非法使用您的账户或其他存在安全漏洞的情况的，请立即通知本站并向公安机关报案。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.4您同意，淘基因拥有通过邮件、短信、电话、网站通知或声明等形式，向在本站注册、购物的用户、收货人发送订单信息、促销活动、售后服务、客户服务等告知信息的权利。如您不希望接收上述信息，可退订。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.5")]), _vm._v("您同意：您选择向本站的商品销售商或服务提供商（以下统称为“销售商”，含淘基因及其关联公司）提交订单购买商品或服务的，视为您向销售商披露个人相关信息，接受销售商向您提供商品销售、配送、售后服务、客户服务、处理信用卡付款、数据分析、市场营销帮助或其他必要事宜；如前述全部或部分事宜之一涉及由销售商外的第三方履行的，销售商有权将您的信息以必要方式向第三方披露，第三方有权以履行上述事宜为目的联系您。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.6")]), _vm._v("您不得将在本站注册获得的账号、密码等账户信息提供给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("3.7")]), _vm._v("您同意，淘基因有权使用您的注册信息、用户名、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。")]), _vm._v(" "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第4条 用户依法言行义务\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.1")]), _vm._v("不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.2")]), _vm._v("从中国大陆向境外传输资料信息时必须符合中国有关法律法规；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.3")]), _vm._v("不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.4")]), _vm._v("不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.5")]), _vm._v("不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.6")]), _vm._v("不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.7")]), _vm._v("不得教唆他人从事本条所禁止的行为；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8")]), _vm._v("除本注册协议、其他条款或另有其他约定外，您不得利用在本站注册的账户进行经营活动、牟利行为及其他未经本站许可的行为，包括但不限于以下行为：\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.1")]), _vm._v("您账户内的任何淘基因优惠信息（包括但不限于优惠券、折扣券、产品赠送券及其他形式优惠或折扣等）由吉凯基因享有解释权和修改权，您仅享有在淘基因购物时的使用权，严禁转卖淘基因账户、优惠券、折扣券、产品赠送券或其他类型的优惠券、或利用淘基因账户进行其他经营性行为等；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.2")]), _vm._v("恶意利用技术手段或其他方式，为获取优惠、折扣或其他利益而注册账户、下单等行为，影响其他用户正常消费行为或相关合法权益、影响淘基因正常销售秩序的行为；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.3")]), _vm._v("发布广告、垃圾邮件；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.4")]), _vm._v("以再销售或商业使用为目的对本站商品或服务进行购买的（与吉凯基因另有合同约定的除外）；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.5")]), _vm._v("商品或服务的供应商、代理商对其所供商品进行回购的行为；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.6")]), _vm._v("任何对商品目录、说明、价格、数量、其他用户信息或其他内容的下载、转载、收集、衍生利用、复制、出售、转售或其他形式的使用，无论是否通过Robots、Spiders、自动仪器或手工操作；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.7")]), _vm._v("本站相关规则、政策、或网页活动规则中限制、禁止的行为；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.8.8")]), _vm._v("其他影响淘基因对用户账户正常管理秩序的行为。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.9")]), _vm._v("您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则淘基因有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.10")]), _vm._v("您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现您发布的信息涉嫌知识产权、或其他合法权益争议的，这些用户或权利人有权要求淘基因删除您发布的信息，或者采取其他必要措施予以制止，淘基因将会依法采取这些措施。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.11")]), _vm._v("您应不时关注并遵守本站不时公布或修改的各类规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知您的权利。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("4.12")]), _vm._v("若您未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭您的账号、冻结账号内金额、关闭相应交易订单、停止发货等措施。您须对自己在网上的言论和行为承担法律责任。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第5条 商品信息\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("5.1")]), _vm._v("本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；淘基因欢迎纠错，并会视情况给予纠错者一定的奖励。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("5.2")]), _vm._v("本站售后服务政策为本协议的组成部分，淘基因有权以声明、通知或其他形式变更售后服务政策。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第6条 订单\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("6.1")]), _vm._v("在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、周期、产品性状、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("6.2")]), _vm._v("除法律另有强制性规定外，双方约定如下：本站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售商发出的合同要约；当您确认订单信息，并且在线点击“确认下单”后，进入下单成功页面，即视为您与销售商之间就您采购的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售商只给您发出了部分商品时，您与销售商之间仅就实际直接向您发出的商品建立了合同关系；只有在销售商实际直接向您发出了订单中订购的其他商品时，您和销售商之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登陆您在本站注册的账户，查询您的订单状态。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("6.3尽管销售商做出最大的努力，但商品目录里的一小部分商品可能会有定价错误。如果发现错误定价，将采取下列之一措施，且不视为违约行为：\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("6.3.1如果某一商品的正确定价低于销售商的错误定价，销售商将按照较低的定价向您销售交付该商品。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您下单所购买的商品，发生缺货，您有权取消订单，销售商亦有权取消订单，并为已付款的用户办理退款。")]), _vm._v(" "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第7条 配送\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("7.1")]), _vm._v("销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("7.2")]), _vm._v("因如下情况造成订单延迟或无法配送、交货等，销售商不承担延迟配送、交货的责任：\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（1）")]), _vm._v("您提供的信息错误、地址不详细等原因导致的；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（2）")]), _vm._v("货物送达后无人签收，导致无法配送或延迟配送的；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（3）")]), _vm._v("情势变更因素导致的；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（4）")]), _vm._v("未能在本站所示的送货参考时间内送货的；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（5）")]), _vm._v("因节假日、大型促销活动、店庆、预购或抢购人数众多等原因导致的；\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("（6）")]), _vm._v("不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第8条 所有权及知识产权条款\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("8.1您一旦接受本协议，即表明您主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给淘基因所有，您同意吉凯基因有权就任何主体侵权而单独提起诉讼。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在淘基因上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("8.3您同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其他主体以任何方式使用（包括但限于在各类网站、媒体上使用）。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("8.4淘基因有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知您。在法律允许的最大限度范围内，淘基因对本协议及本站内容拥有解释权。\n                          "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("8.5除法律另有强制性规定外，未经淘基因明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，淘基因有权追究其法律责任。")]), _vm._v(" "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("8.6")]), _vm._v("本站所刊登的资料信息（包括但不限于文字、图表、商标、logo、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件等），均是淘基因或其内容提供者的财产，受中国和国际相关版权法规、公约等的保护，未经淘基因书面许可，任何第三方无权将上述资料信息复制、出版、发行、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。本站上所有内容的汇编是淘基因的排他财产，受中国和国际版权法的保护。本站上所有软件都是淘基因或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分软件，或利用软件创设衍生产品。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第9条 责任限制及不承诺担保\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.1")]), _vm._v("除非另有明确的书面说明,本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.2")]), _vm._v("除非另有明确的书面说明, 淘基因不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.3")]), _vm._v("淘基因不担保本站所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.4")]), _vm._v("如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，淘基因会合理地尽力协助处理善后事宜。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.5")]), _vm._v("您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，您应承担全部责任。同时，因网络环境存在众多不可预知因素，因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的淘基因账户或个人信息等被第三方窃取的，淘基因不承担赔偿责任。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("9.6")]), _vm._v("您了解并同意，吉凯基因有权应国家有关机关的要求，向其提供您在淘基因的用户信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则吉凯基因有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第10条 协议更新及用户关注义务\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("根据国家法律法规变化及网站运营需要，吉凯基因有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议、其他条款及网站公告。如您不同意更新后的协议，可以且应立即停止接受淘基因依据本协议提供的服务；如您继续使用本站提供的服务的，即视为同意更新后的协议。淘基因建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第11条 法律管辖和适用\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("本协议的订立、执行和解释及争议的解决均适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的"), _c('span', {
    staticClass: "background",
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("上海市徐汇区人民法院")]), _vm._v("提起诉讼。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _vm._v("第12条 其他\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("12.1")]), _vm._v("淘基因所有者是指在政府部门依法许可或备案的吉凯基因网站经营主体。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("12.2")]), _vm._v("淘基因尊重您的合法权利，本协议及本站上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。本站欢迎您和社会各界提出意见和建议，淘基因将虚心接受并适时修改本协议及本站上的各类规则。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("12.3")]), _vm._v("本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请您着重阅读。\n                        "), _c('br', {
    attrs: {
      "data-v-04124e51": ""
    }
  }), _c('strong', {
    attrs: {
      "data-v-04124e51": ""
    }
  }, [_vm._v("12.4")]), _vm._v("您点击本协议下方的“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。\n                      ")])])])])])])])
}]}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("单位搜索")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block_input"
  }, [_c('div', {
    staticClass: "wrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('label', {
    staticClass: "icon icon-search icon_2",
    attrs: {
      "for": "search-enterprise"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "icon_2",
    attrs: {
      "type": "search",
      "id": "search-enterprise",
      "placeholder": "请输入单位名称"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.filteredData), function(enterprise, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group",
      on: {
        "click": function($event) {
          return _vm.updateEnterprise(enterprise)
        }
      }
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(enterprise.enterpriseName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    })]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod",
    staticStyle: {
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/时间.svg",
      "data-src": "/static/img/时间.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    短信已发送，等待签署\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n    请点击短信链接，根据提示在支付宝中完成签署，如果未收到短信，可尝试点击按钮重新发送\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.resendTime !== 0 ? 'bd' : 'submain',
    on: {
      "click": _vm.counter
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("\n      重新发送短信\n      "), (_vm.resendTime !== 0) ? _c('span', [_vm._v("\n        （" + _vm._s(_vm.resendTime) + "）\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.checkOrderStatus
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("\n      我已完成签署\n    ")])]), _vm._v(" "), (this.$route.query.canShow) ? _c('div', {
    staticClass: "submain",
    staticStyle: {
      "background": "#FFFFFF",
      "border-radius": "44px",
      "border": "1px solid #5878FA"
    },
    on: {
      "click": _vm.returnAuthenticationHome
    }
  }, [_c('span', {
    staticClass: "tag",
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("\n      返回修改信息\n    ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.preventTouchMoveFlag) ? _c('div', {
    staticClass: "page page-current page-goods",
    style: ({
      'z-index': '1'
    }),
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isDeskFlag) ? _c('header', {
    staticClass: "bar bar-nav",
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [(!_vm.isHomepage) ? _c('a', {
    staticClass: "icon icon-left pull-left color-wt",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title color-wt"
  }, [_vm._v("吉凯淘基因")])]) : _vm._e(), _vm._v(" "), (_vm.navTopLevel && !_vm.isWapp) ? _c('nav', {
    staticClass: "bar bar-tab",
    staticStyle: {
      "background-color": "#F3F3F3",
      "height": "2.6rem",
      "position": "fixed"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'custOrder'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("定制")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'cart'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-me"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("我的")]), _vm._v(" "), (_vm.waitPaidAndDeliver > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.waitPaidAndDeliver) + "\n      ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isDeskFlag) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-1rem",
      "height": "94%"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isDeskFlag && !_vm.hideCustomerService) ? _c('customer-service', {
    on: {
      "preventTouchMove": _vm.handlePreventTouchMove,
      "activateTouchMove": _vm.handleActivateTouchMove
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "page page-current page-goods",
    style: ({
      'z-index': '1'
    })
  }, [(_vm.isDeskFlag) ? _c('header', {
    staticClass: "bar bar-nav",
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [(!_vm.isHomepage) ? _c('a', {
    staticClass: "icon icon-left pull-left color-wt",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title color-wt"
  }, [_vm._v("吉凯淘基因")])]) : _vm._e(), _vm._v(" "), (_vm.navTopLevel && !_vm.isWapp) ? _c('nav', {
    staticClass: "bar bar-tab",
    staticStyle: {
      "background-color": "#F3F3F3",
      "height": "2.6rem",
      "position": "fixed"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'custOrder'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("定制")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'cart'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    class: {
      'sales': _vm.isSalesFlag
    },
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-me"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("我的")]), _vm._v(" "), (_vm.waitPaidAndDeliver > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.waitPaidAndDeliver) + "\n      ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isDeskFlag) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-1rem",
      "height": "94%"
    }
  }, [(_vm.isWapp && !_vm.isPcUser && _vm.showBack) ? _c('div', {
    staticClass: "back-text",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.backUrl,
      "data-src": _vm.backUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _c('div', [(_vm.isWapp && !_vm.isPcUser && _vm.showBack) ? _c('div', {
    staticClass: "back-text",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.backUrl,
      "data-src": _vm.backUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "keep-alive": ""
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isDeskFlag && !_vm.hideCustomerService) ? _c('customer-service', {
    on: {
      "preventTouchMove": _vm.handlePreventTouchMove,
      "activateTouchMove": _vm.handleActivateTouchMove
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.comeFrom) ? _c('div', {
    staticClass: "coupons-container"
  }, [_c('div', {
    staticClass: "header-subtitle"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.availableCoupons ? _vm.availableCoupons.length : 0) + "张可用优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-content",
    style: ({
      'bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.displayAllCoupons.length > 0) ? _c('div', _vm._l((_vm.displayAllCoupons), function(coupon, index) {
    return _c('div', {
      staticClass: "select-coupon"
    }, [_c('div', {
      staticClass: "coupon",
      style: (_vm.getCouponStyle(coupon))
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.getCouponEnabled(coupon)),
        expression: "!getCouponEnabled(coupon)"
      }],
      staticClass: "coupon-unuse",
      attrs: {
        "src": "static/img/不可用.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-detail"
    }, [_c('div', {
      staticClass: "detail-content"
    }, [_c('span', {
      style: ({
        'font-size': '14px',
        'color': _vm.getCouponEnabled(coupon) ? '#68533D' : '#979797'
      })
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v(_vm._s(coupon.typeName) + " " + _vm._s(_vm.getCouponDisabledText(coupon)))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("有效期至" + _vm._s(coupon.endDT))])]), _vm._v(" "), (coupon.type === _vm.emkt.COUPON_TYPE_DISCOUNT) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(_vm.getCouponDiscount(coupon)))]), _vm._v("折")]) : (![_vm.emkt.COUPON_TYPE.prepaySpecialFundCoupon, _vm.emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(coupon.value))]), _vm._v("元")]) : _vm._e()]), _vm._v(" "), _c('object', {
      staticClass: "left-circle",
      attrs: {
        "data": _vm.getLeftCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('object', {
      staticClass: "right-circle",
      attrs: {
        "data": _vm.getRightCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "coupon-split",
      style: ({
        'border-color': _vm.getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-rule"
    }, [_c('div', {
      staticClass: "use-rule",
      on: {
        "click": function($event) {
          return _vm.toggleShowRule(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "10px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("使用规则")]), _vm._v(" "), (!_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentExcluded(coupon)),
        expression: "currentExcluded(coupon)"
      }],
      staticClass: "alert-text",
      staticStyle: {
        "margin-left": "10px",
        "z-index": "10"
      }
    }, [_vm._v("与已选择优惠券互斥")])]), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('div', {
      staticStyle: {
        "padding-bottom": "11px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, _vm._l((coupon.desc), function(items, indexs) {
      return _c('div', [_vm._v("\n                " + _vm._s(indexs + 1) + "、" + _vm._s(items) + "。\n                ")])
    }), 0) : _vm._e()])]), _vm._v(" "), _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.chosenCoupons),
        expression: "chosenCoupons"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.checkBoxIsDisabled(coupon),
        "name": "couponCheckbox"
      },
      domProps: {
        "value": coupon,
        "checked": Array.isArray(_vm.chosenCoupons) ? _vm._i(_vm.chosenCoupons, coupon) > -1 : (_vm.chosenCoupons)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.chosenCoupons,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = coupon,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.chosenCoupons = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.chosenCoupons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.chosenCoupons = $$c
          }
        }, function($event) {
          return _vm.handleSelectionChange(coupon)
        }]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media group"
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox i-style",
      style: ({
        'border-color': _vm.checkBoxIsDisabled(coupon) ? '#D9D9D9' : '#979797'
      })
    })])])])
  }), 0) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "src": "/static/img/优惠券空.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("已选择"), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v(_vm._s(_vm.chosenCoupons.length))]), _vm._v("张优惠券")]), _vm._v(" "), (_vm.availableCoupons.length > 0) ? _c('div', {
    staticClass: "pay-btn research-background-color",
    on: {
      "click": _vm.confirmCoupon
    }
  }, [_vm._v("确认使用")]) : _c('div', {
    staticClass: "pay-btn",
    staticStyle: {
      "background-color": "#979797"
    }
  }, [_vm._v("确认使用")])]), _vm._v(" "), _c('footer-placeholder')], 1)]) : _c('div', {
    staticClass: "coupons-container"
  }, [_c('div', {
    staticClass: "coupon-content",
    style: ({
      'bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.myAllCoupons.length > 0) ? _c('div', _vm._l((_vm.myAllCoupons), function(coupon, index) {
    return _c('div', {
      staticClass: "select-coupon"
    }, [_c('div', {
      staticClass: "coupon-full",
      style: (_vm.getCouponStyle(coupon))
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!coupon.available),
        expression: "!coupon.available"
      }],
      staticClass: "coupon-unuse-full",
      attrs: {
        "src": "static/img/已过期.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-detail"
    }, [_c('div', {
      staticClass: "detail-content"
    }, [_c('span', {
      style: ({
        'font-size': '14px',
        'color': _vm.getCouponEnabled(coupon) ? '#68533D' : '#979797'
      })
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v(_vm._s(coupon.typeName) + " " + _vm._s(_vm.getCouponDisabledText(coupon)))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("有效期至" + _vm._s(coupon.endDT))])]), _vm._v(" "), (coupon.type === _vm.emkt.COUPON_TYPE_DISCOUNT) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(_vm.getCouponDiscount(coupon)))]), _vm._v("折")]) : (![_vm.emkt.COUPON_TYPE.prepaySpecialFundCoupon, _vm.emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(coupon.value))]), _vm._v("元")]) : _vm._e()]), _vm._v(" "), _c('object', {
      staticClass: "left-circle",
      attrs: {
        "data": _vm.getLeftCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('object', {
      staticClass: "right-circle",
      attrs: {
        "data": _vm.getRightCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "coupon-split",
      style: ({
        'border-color': _vm.getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'
      })
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "float": "right"
      }
    }, [(_vm.getCouponEnabled(coupon) && coupon.isPresent === 1) ? _c('span', {
      staticClass: "small-font-set1",
      on: {
        "click": function($event) {
          return _vm.showPresentCouponDialog(coupon)
        }
      }
    }, [_vm._v("\n          转赠\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getCouponEnabled(coupon)) ? _c('span', {
      staticClass: "small-font-set",
      on: {
        "click": _vm.jumpTo
      }
    }, [_vm._v("\n          立即使用\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coupon-rule"
    }, [_c('div', {
      staticClass: "use-rule",
      on: {
        "click": function($event) {
          return _vm.toggleShowRule(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "10px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("使用规则")]), _vm._v(" "), (!_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentExcluded(coupon)),
        expression: "currentExcluded(coupon)"
      }],
      staticClass: "alert-text",
      staticStyle: {
        "margin-left": "10px",
        "z-index": "10"
      }
    }, [_vm._v("与已选择优惠券互斥")])]), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('div', {
      staticStyle: {
        "padding-bottom": "11px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, _vm._l((coupon.desc), function(items, indexs) {
      return _c('div', [_vm._v("\n                  " + _vm._s(indexs + 1) + "、" + _vm._s(items) + "。\n                ")])
    }), 0) : _vm._e()])])])
  }), 0) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "src": "/static/img/优惠券空.png"
    }
  })])])]), _vm._v(" "), (_vm.showPresentCoupon) ? _c('div', {
    staticClass: "background-modal",
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPresentCoupon),
      expression: "showPresentCoupon"
    }],
    staticClass: "choose-pay-method"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "32px",
      "width": "32px"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    staticClass: "icon4",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/关闭.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPresentCoupon),
      expression: "showPresentCoupon"
    }]
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiverCustomerName),
      expression: "receiverCustomerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "type": "text",
      "placeholder": "请输入被转赠人的姓名"
    },
    domProps: {
      "value": (_vm.receiverCustomerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiverCustomerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiverCustomerMobile),
      expression: "receiverCustomerMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "type": "text",
      "placeholder": "请输入被转赠人的手机号"
    },
    domProps: {
      "value": (_vm.receiverCustomerMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiverCustomerMobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "pay-btn research-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.transferCoupon
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("转赠优惠券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind-info light-text-color"
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("转赠优惠券之前，请先提醒被转赠人注册淘基因账户，否则无法使用转赠功能")])])
}]}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    22年间"), _c('br'), _vm._v("您一共购买过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.purchaseTimes))]), _vm._v("吉凯的产品或服务"), _c('br'), _vm._v("合同金额总计"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.amount))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n    双向奔赴的感觉真好！\n    "), _c('br'), _vm._v("\n    吉凯继续努力，提供定制化实验需求，\n    "), _c('br'), _vm._v("\n    让科研之路不再漫长\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-text-background ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape1.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image-2 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image-3 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape3.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "title-text",
    staticStyle: {
      "margin": "10px 0 0 25px"
    }
  }, [_vm._v("送样指南")]), _vm._v(" "), (_vm.sampleDeliveryInfo && _vm.sampleDeliveryInfo.length > 0) ? _c('div', [_vm._l((_vm.sampleDeliveryInfo), function(initFile, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-content",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(initFile)
        }
      }
    }, [_c('div', {
      staticClass: "layer1"
    }, [_c('img', {
      staticClass: "word-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(initFile.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(initFile.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font",
      staticStyle: {
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(initFile.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "word",
    staticStyle: {
      "margin": "5px 15px 0px 15px"
    }
  }, [_vm._v("请务必仔细阅读《物品寄送指南》并按照指南收集样本")])], 2) : _c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('span', {
    staticClass: "word",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v(_vm._s(_vm.getMaterialWarning()))])]), _vm._v(" "), _c('div', {
    staticClass: "sample-info-class"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "show-txt",
    on: {
      "click": _vm.showMaterialSendProcess
    }
  }, [_vm._v("查看实物寄送流程")])]), _vm._v(" "), _vm._l((_vm.sampleInfo), function(initFile, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-content",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(initFile)
        }
      }
    }, [_c('div', {
      staticClass: "layer1"
    }, [_c('img', {
      staticClass: "word-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(initFile.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(initFile.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font",
      staticStyle: {
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(initFile.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info-class"
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("请完整填写《实物信息表》全部相关信息，寄送实物，将文档直接上传，字迹清晰可辨。推荐在电脑端使用小程序完成上传操作。")]), _vm._v(" "), _c('span', {
    staticClass: "word8",
    on: {
      "click": _vm.showMiniProgramInComputerUsage
    }
  }, [_vm._v("查看小程序在电脑端的使用方法")])]), _vm._v(" "), _c('div', {
    staticClass: "sample-delivery-record"
  }, [_c('span', {
    staticClass: "info4"
  }, [_vm._v("寄送记录")]), _vm._v(" "), _c('span', {
    staticClass: "show-txt",
    on: {
      "click": _vm.showSampleDeliverySheet
    }
  }, [_vm._v("查看寄送记录")])]), _vm._v(" "), _vm._l((_vm.materialDetail.orderMaterialExpressList), function(materialExpress, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "group1 flex-col"
    }, [_c('div', {
      staticClass: "flex-col"
    }, [_c('div', {
      staticClass: "group2 flex-row"
    }, [(materialExpress.expressNo !== '') ? _c('span', {
      staticClass: "express"
    }, [_vm._v("快递单号：" + _vm._s(materialExpress.expressNo))]) : _c('span', {
      staticClass: "express"
    }, [_vm._v("快递单号：待填写")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "displayStatusName": materialExpress.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "layer3 flex-row"
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": _vm.materialDetail.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(_vm.materialDetail.orderMaterial.materialDesc))]), _vm._v(" "), _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(materialExpress.expressMaterialDetailList[0].displayStatusName))])], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "create-dt-class"
    }, [_c('span', {
      staticClass: "word",
      staticStyle: {
        "margin": "5px 0 0 15px"
      }
    }, [_vm._v("创建时间：" + _vm._s(materialExpress.createDT))])])])])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('span', {
    staticClass: "end-txt"
  }, [_vm._v("我是有底线的")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
}]}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, _vm._l((_vm.priceDetail), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [_c('div', [_c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(data.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.price))]), _vm._v(" "), _vm._m(1, true)])])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "2rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "color": "#00469A",
      "font-size": "1.2rem"
    }
  }, [_vm._v("价格明细")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
}]}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "height": "4rem"
    }
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("选择靶点")]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "54%"
    }
  }, [_vm._v("\n    选择靶点\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.attrValueDisplay) ? _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": "smaller",
      "margin-left": "0.1rem",
      "height": "1rem"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "item-input"
  }, _vm._l((_vm.attrValueDisplay), function(arr, index) {
    return _c('div', {
      staticStyle: {
        "font-size": "smaller",
        "margin-left": "0.5rem"
      },
      attrs: {
        "readonly": "readonly"
      },
      on: {
        "click": function($event) {
          return _vm.showOptionList(_vm.attribute)
        }
      }
    }, [_vm._v(_vm._s(arr))])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "check-step"
  }, [_c('ul', _vm._l((_vm.attrGroups), function(group, index) {
    return _c('li', {
      class: {
        'curStep': _vm.curStep >= index
      },
      staticStyle: {
        "list-style-type": "none"
      }
    }, [_vm._v("\n            " + _vm._s(index + 1) + "." + _vm._s(group.groupLabel) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "content data-block",
    staticStyle: {
      "top": "3.5rem",
      "height": "28.5rem"
    }
  }, [(_vm.error) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#FF0000"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    class: {
      'bottom': _vm.curStep === 0 || _vm.curStep === 1
    }
  }, [_c('ul', _vm._l((_vm.curAttrsInGroup), function(attribute, index) {
    return (attribute.customizable === 1 && attribute.isNA === false && attribute.value !== -1) ? _c('li', {
      staticClass: "item-content",
      class: _vm.getCss(attribute)
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "curAttrsInGroup": _vm.curAttrsInGroup,
        "customAttrs": _vm.merchandise._customizableAttributes
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.curStep === _vm.steps - 1) ? _c('div', {
    staticClass: "content-block top",
    class: {
      'bottom': _vm.curStep === _vm.steps - 1
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$route.query.cust) ? _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("请点击加入购物车按钮完成定制")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.modifyProduct
    }
  }, [_vm._v("完成修改")])]) : (_vm.QuoteStatus === false) ? _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("请点击加入购物车按钮完成定制")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_vm._v("加入购物车")])]) : _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("此报价不可再添加商品")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success gotopay_button_style",
    staticStyle: {
      "background-color": "gray"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("加入购物车")])])])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "bar bar-footer-secondary",
    staticStyle: {
      "height": "3.5rem",
      "margin": "auto",
      "position": "fixed"
    }
  }, [_c('div', {
    staticClass: "content-block buttons-row",
    staticStyle: {
      "position": "relative",
      "bottom": "1.25rem"
    }
  }, [_c('button', {
    staticClass: "button button button-round",
    on: {
      "click": _vm.pageUp
    }
  }, [_vm._v("上一步")]), _vm._v(" "), (_vm.curStep !== _vm.steps - 1) ? _c('button', {
    staticClass: "button button button-round",
    on: {
      "click": _vm.pageDown
    }
  }, [_vm._v("下一步")]) : _c('button', {
    staticClass: "button button button-round",
    staticStyle: {
      "color": "rgb(142, 142, 147)"
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("审批订单")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.waitApproveOrderList), function(order, index) {
    return _c('router-link', {
      key: index,
      staticClass: "bd",
      attrs: {
        "to": {
          name: 'ApproveOrderDetail',
          query: {
            researchGroupNo: _vm.researchGroupNo,
            orderNo: order.orderNo
          }
        }
      }
    }, [_c('div', {
      staticClass: "outer"
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "tagWrap"
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v("未审批")])])]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('span', {
      staticClass: "orderTime"
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "orderNumber"
    }, [_vm._v("订单编号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("订单总金额：¥" + _vm._s(_vm.splitMoney(order.price)))])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "7vw",
      "visibility": "hidden"
    }
  }, [_vm._v("white")])], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "address-detail-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.addressInfo === undefined || _vm.addressInfo.length === 0) ? _c('img', {
    staticClass: "default-empty",
    attrs: {
      "src": "static/img/收货地址空.png"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.newAddressInfo), function(address, index) {
    return _c('div', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "address-block"
    }, [_c('div', {
      staticClass: "content",
      attrs: {
        "id": 'updateAddress' + index
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('i', {
      staticClass: "icon-font emkt-icon-didian place"
    }), _vm._v(" "), _c('div', {
      staticClass: "mod",
      on: {
        "click": function($event) {
          return _vm.updateAddress(address, index)
        }
      }
    }, [_c('div', {
      staticClass: "address",
      staticStyle: {
        "width": "100%"
      }
    }, [(address.province !== '') ? _c('div', [_vm._v("\r\n                  " + _vm._s(address.expressAddress) + "\r\n                ")]) : _c('div', [_vm._v("\r\n                  " + _vm._s(address.expressAddress) + "\r\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_vm._v("\r\n                  " + _vm._s(address.consignee) + "  " + _vm._s(address.expressMobile) + "\r\n                ")])])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'WeappAddressModify',
          query: {
            address: JSON.stringify(address),
            from: _vm.from
          },
          params: {
            order: _vm.$route.params.order,
            addressType: _vm.$route.params.addressType
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-font emkt-icon-xiugai modify",
      staticStyle: {
        "color": "#424242"
      }
    })])], 1)]), _vm._v(" "), (address.addressSource === 2 && !address.operator) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "appendInfo-layout"
    }, [_c('div', {
      staticClass: "appendInfo-content"
    }, [_c('div', [_vm._v("创建业务员:" + _vm._s(address.creator))]), _c('div', [_vm._v(_vm._s(address.createDT))])])])]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'WeappAddAddress',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order,
          addressType: _vm.$route.params.addressType
        }
      }
    }
  }, [_c('div', {
    staticClass: "add-btn research-background-color"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("+添加地址")])])])], 1), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr', {
    staticStyle: {
      "border": "1px dashed",
      "color": "rgb(239, 239, 244)",
      "width": "100%",
      "float": "left",
      "position": "relative",
      "top": "0px"
    }
  })])
}]}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayInBrowser) ? _c('div', {
    staticClass: "weui-search-bar",
    staticStyle: {
      "padding": "0",
      "background-color": "#ededed"
    },
    attrs: {
      "id": "searchBar"
    }
  }, [_c('form', {
    staticClass: "weui-search-bar__form",
    staticStyle: {
      "padding": "0 10px"
    },
    on: {
      "submit": function () {
        return false;
      }
    }
  }, [_c('div', {
    staticClass: "weui-search-bar__box",
    staticStyle: {
      "background-color": "#F7F8FA"
    }
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "weui-search-bar__input",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "search",
      "placeholder": "搜索",
      "required": ""
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": _vm.handleChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": _vm.clearKeyword
    }
  }, [_vm._v("取消")])])])]) : _c('div', {
    staticClass: "bar",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "searchbar",
    staticStyle: {
      "background-color": "#F7F8FA",
      "height": "45px"
    }
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup",
    on: {
      "click": _vm.clearKeyword
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keyword),
      expression: "keyword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": _vm.handleChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("设置发票信息")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("发票类型")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "1px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50"
  }, [_vm._v("增值税发票(普通)")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50"
  }, [_vm._v("增值税发票")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("发票抬头")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li'), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写单位名称"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "phoneNumber",
      "placeholder": "请填写纳税人识别号"
    }
  })])])])]), _vm._v(" "), _c('li')])])])
}]}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box_1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_name')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nameQuery),
      expression: "nameQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请输入被转赠人姓名"
    },
    domProps: {
      "value": (_vm.nameQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_mobile')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobileQuery),
      expression: "mobileQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请输入被转赠人手机号"
    },
    domProps: {
      "value": (_vm.mobileQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-up",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回上一步")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.searchContact()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("搜索")])])])]), _vm._v(" "), (_vm.contactDetail && _vm.contactDetail.customerName) ? _c('div', {
    staticClass: "box_2"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.customerName))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.mobile))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.email))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.enterpriseName))])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.infoCollectionTransfer
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("转赠")])])])]) : _vm._e()]), _vm._v(" "), (_vm.showRemindBox) ? _c('RemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "confirm": _vm.infoCollectionTransfer,
      "toggleShow": _vm.toggleShowRemindBox
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])])]), _vm._v(" "), _c('div', [(_vm.channels) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "2.5rem"
    }
  }, [_c('div', {
    staticClass: "card demo-card-header-pic"
  }, [_c('div', {
    staticClass: "card-header color-white no-border no-padding",
    attrs: {
      "valign": "bottom"
    }
  }, [_c('img', {
    staticClass: "card-cover",
    attrs: {
      "src": _vm.baseurl + _vm.channels.descUrl
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, _vm._l((_vm.channels.promotionList), function(pro) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "1rem",
        "margin-bottom": "4rem",
        "background-color": "#F7E7D8"
      },
      on: {
        "click": function($event) {
          return _vm.gotoPro(pro)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "x-large",
        "margin-bottom": "0.5rem",
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n          " + _vm._s(pro.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n          " + _vm._s(pro.description) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right",
        "margin-bottom": "0.5rem"
      }
    }, [_vm._v("点击进入活动专场")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-inner"
  }, [_vm._v("信号通路研究，是做基础科研接触最多的一个方面，不管是设计课题写基金还是发表文章，都需要对信号通路有一定的了解。常在文章里面见到各种各样的信号通路，比如经典的P53信号通路、NF-κB信号、Wnt信号通路等等。\n         "), _c('br'), _vm._v("\n          现在吉凯基因将持续不断的推出各类经典通路的促销活动，免除您有做通路研究的决心而无经费支持的尴尬，为您的科研提供最有利的保障。赶紧点击详情了解一下！\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div')])
}]}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-roadmap/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('img', {
    staticClass: "main-roadmap ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-roadmap/历程.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-roadmap/shape02.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [(_vm.merchandises) ? _c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec"
    }
  }, [(_vm.merchandises.showpromotion && _vm.merchandises.showpromotion.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('span', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n            "), _vm._l((_vm.merchandises.showpromotion), function(proo, index) {
    return _c('span', [(proo.type === 1) ? _c('span', [_vm._v("\n               " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n              ")]) : _vm._e()])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block goods-card",
    staticStyle: {
      "font-size": "0.6rem",
      "margin-bottom": "1.5rem"
    }
  }, [_vm._l((_vm.merchandises._titleList), function(title) {
    return _c('span', {
      staticStyle: {
        "margin-left": "0.3rem"
      }
    }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('strong', {
    staticStyle: {
      "color": "#4479B4",
      "font-size": "0.9rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMax))]) : _c('strong', {
    staticStyle: {
      "color": "#4479B4",
      "font-size": "0.9rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMin))]), _vm._v(" "), (_vm.merchandises.cataloguePrice) ? _c('del', {
    staticStyle: {
      "font-size": "0.5rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.cataloguePrice))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link  button",
    attrs: {
      "href": "#tab-introduce"
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab-detail"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-qualityCommitment"
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-comments"
    }
  }, [_vm._v("评论(" + _vm._s(_vm.Comments.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.introduces === '') ? _c('p', [_vm._v(_vm._s(_vm.merchandises.description))]) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName != '') ? _c('p') : _vm._e(), (_vm.merchandises.manualFileName.split(';').length === 1) ? _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.manualurl + _vm.merchandises.manualFileName + _vm.attr
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('p', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.manualurl + manualFileName + _vm.attr
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))])]) : _vm._e()
  }), _vm._v(" "), _c('p')], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab active list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(merchandise) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [(merchandise.valueText) ? _c('div', [(merchandise.columnName === 'STRSite' && merchandise.valueText.indexOf('；') !== -1) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-top": "0px"
      }
    }, _vm._l((merchandise.valueText.split('；')), function(value) {
      return _c('span', [_vm._v("\n                       " + _vm._s(value) + "\n                        "), _c('br')])
    }), 0), _vm._v(" "), _vm._m(0, true)]) : (merchandise.columnName === 'AdditionalParameters' && merchandise.valueText.indexOf('；') !== -1) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-top": "0px"
      }
    }, _vm._l((merchandise.valueText.split('；')), function(value) {
      return _c('span', [_vm._v("\n                       " + _vm._s(value) + "\n                        "), _c('br')])
    }), 0), _vm._v(" "), _vm._m(1, true)]) : _c('div', [(merchandise.displayable && merchandise.valueText.length > 60) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名' && merchandise.valueText.length > 60 && merchandise.valueText.length < 80) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length >= 80 && merchandise.valueText.length < 100) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60, 80)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(80)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length >= 100) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60, 80)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(80, 100)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(100)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText) + "\n                        ")])]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('div', {
      staticStyle: {
        "margin-top": "7rem"
      }
    }, [_c('hr', {
      staticStyle: {
        "height": "0.06rem",
        "border": "0.06rem",
        "background-color": "#B4B4B4"
      }
    })]) : _c('div', {
      staticStyle: {
        "margin-top": "11rem"
      }
    }, [_c('hr', {
      staticStyle: {
        "height": "0.06rem",
        "border": "0.06rem",
        "background-color": "#B4B4B4"
      }
    })])]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 45 && merchandise.valueText.length <= 60) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 39)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(39, 58)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(58)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(2, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 30 && merchandise.valueText.length <= 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名' && merchandise.valueText.length <= 38) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length > 38) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 38)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(38)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "8rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(3, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 16 && merchandise.valueText.length <= 30) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "10rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(4, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length <= 16) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(5, true)]) : _vm._e()])]) : _vm._e()])
  }), _vm._v(" "), (_vm.merchandises._cycle) ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v(_vm._s(_vm.merchandises._cycle.label))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.merchandises._cycle.valueText))])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])])])])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '2.5rem'
    })
  }, [_c('div', {
    staticClass: "item-media"
  }, [(_vm.hasLogin) ? _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "float": "left",
      "margin-left": "2rem"
    }
  }, [_c('span', {
    staticClass: "icon icon-message",
    on: {
      "click": function($event) {
        return _vm.toMessage(_vm.merchandises.merchandiseLabel)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label",
    staticStyle: {
      "width": "1.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.toMessage(_vm.merchandises.merchandiseLabel)
      }
    }
  }, [_vm._v("客服")]), _vm._v(" "), (_vm.curMessageSession.leaveMessageStatus === 3) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "width": "10rem"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), (_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])])])]) : _c('div', {
    staticStyle: {
      "margin-top": "11rem",
      "text-align": "center",
      "font-size": "200%"
    }
  }, [_c('div', [_vm._v("\n   此商品已经下架！\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "11rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "layer1"
  }, [_c('div', {
    staticClass: "info1"
  }, [_vm._v("实验编号：" + _vm._s(_vm.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "box3",
    class: _vm.getStatusClass(_vm.status)
  }, [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), _c('div', {
    staticClass: "layer2"
  })])
},staticRenderFns: []}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('OrderContentFramework', {
    attrs: {
      "button-name": '确认下单',
      "totalMoney": _vm.totalMoney,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.orderPay
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    on: {
      "click": _vm.toggleShowMerchandises
    }
  }, [_c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("订单编号：")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.displayOrderNo))])]), _vm._v(" "), _c('div', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMerchandises),
      expression: "!showMerchandises"
    }],
    staticClass: "icon-font emkt-icon-zhankai research-font-color"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMerchandises),
      expression: "showMerchandises"
    }],
    staticClass: "icon-font emkt-icon-shouqi research-font-color"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMerchandises),
      expression: "showMerchandises"
    }],
    staticClass: "full-split-line"
  }), _vm._v(" "), (_vm.showMerchandises && _vm.isService) ? _c('service-product', {
    attrs: {
      "order": _vm.order,
      "needSlove": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMerchandises && !_vm.isService) ? _c('OrderMerchandises', {
    ref: "getPrice",
    attrs: {
      "order": _vm.order
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item"
  }, [_c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-gantanhao light-text-color",
    staticStyle: {
      "font-size": "13px"
    },
    on: {
      "click": function($event) {
        return _vm.displayMessage(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.openPayMethodBox
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-yue research-font-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.payTypeName))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing",
    staticStyle: {
      "font-size": "12px"
    }
  })])]), _vm._v(" "), (_vm.showBalanceTypeMethod) ? _c('div', {
    staticClass: "split-line"
  }) : _vm._e(), _vm._v(" "), (_vm.showBalanceTypeMethod) ? _c('div', {
    staticClass: "block-item"
  }, [_c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("结算账户")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-gantanhao light-text-color",
    staticStyle: {
      "font-size": "13px"
    },
    on: {
      "click": function($event) {
        return _vm.displayMessage(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showChooseBalanceAccount = true
      }
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-bianzumergebeifen research-font-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.balanceTypeName))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing",
    staticStyle: {
      "font-size": "12px"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedPayType === _vm.emkt.PAY_TYPE_FAPIAO),
      expression: "selectedPayType === emkt.PAY_TYPE_FAPIAO"
    }],
    staticClass: "order-detail-content"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "60px",
      "font-size": "14px",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#424242",
      "line-height": "20px"
    }
  }, [_vm._v("\n          开票抬头\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _vm._l((_vm.payEnterpriseList), function(payEnterprise, index) {
    return _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "border-bottom": ".5px solid #efeef3"
      }
    }, [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ListPayEnterprise),
        expression: "ListPayEnterprise"
      }],
      attrs: {
        "type": "checkbox",
        "name": "accountCheckbox"
      },
      domProps: {
        "value": payEnterprise,
        "checked": Array.isArray(_vm.ListPayEnterprise) ? _vm._i(_vm.ListPayEnterprise, payEnterprise) > -1 : (_vm.ListPayEnterprise)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ListPayEnterprise,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = payEnterprise,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ListPayEnterprise = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.ListPayEnterprise = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ListPayEnterprise = $$c
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media group"
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox i-style"
    })])]), _vm._v(" "), _c('div', {
      class: _vm.getMainClass(payEnterprise)
    }, [_c('div', {
      staticClass: "open-popup open-enterprise light-text-color",
      staticStyle: {
        "margin-top": "10px",
        "margin-left": "5px",
        "font-size": "14px"
      },
      attrs: {
        "data-popup": ".popup-invoice-title"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, false)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)) + "\n              "), (!payEnterprise.enterpriseInvoiceTitle) ? _c('span', {
      staticClass: "light-text-color",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                点击搜索单位\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      style: (_vm.getMainStyle(payEnterprise))
    }, [(_vm.canAddPayEnterprise) ? _c('span', {
      staticStyle: {
        "padding-right": "5px"
      }
    }, [_c('img', {
      staticClass: "icon6",
      staticStyle: {
        "width": "17px",
        "height": "12px"
      },
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/修 改.svg"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, true)
        }
      }
    })]) : _vm._e()])])]), _vm._v(" "), _c('span', [_c('div', [(_vm.canAddPayEnterprise) ? _c('img', {
      staticClass: "icon5",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/删减.svg"
      },
      on: {
        "click": function($event) {
          return _vm.removePayEnterprise(index)
        }
      }
    }) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAddPayEnterprise),
      expression: "canAddPayEnterprise"
    }],
    staticClass: "block-item",
    on: {
      "click": _vm.addPayEnterprise
    }
  }, [_c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("增加开票抬头")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "label7",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/增加备份.svg"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedPayType === _vm.emkt.PAY_TYPE_FAPIAO),
      expression: "selectedPayType === emkt.PAY_TYPE_FAPIAO"
    }],
    staticClass: "layer7"
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("\n            开票抬头默认设置为您所在单位，您可以勾选以上所有单位或者新增\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "word10"
  }, [_vm._v("\n            。下单成功后，吉凯工作人员会主动联系您为您开具发票。\n          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedPayType === _vm.emkt.PAY_TYPE_FAPIAO),
      expression: "selectedPayType === emkt.PAY_TYPE_FAPIAO"
    }],
    staticClass: "content-block"
  }, [_c('img', {
    staticClass: "default-flag",
    attrs: {
      "src": "static/img/默认flag.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("发票寄送地址")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isService),
      expression: "!isService"
    }]
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("与收货地址相同")]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultInvoiceAddress),
      expression: "defaultInvoiceAddress"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.defaultInvoiceAddress) ? _vm._i(_vm.defaultInvoiceAddress, null) > -1 : (_vm.defaultInvoiceAddress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.defaultInvoiceAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.defaultInvoiceAddress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.defaultInvoiceAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.defaultInvoiceAddress = $$c
        }
      }, _vm.available]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    style: ({
      'background-color': _vm.defaultInvoiceAddress ? '#5878fa' : '#e5e5e5'
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), (!_vm.defaultInvoiceAddress) ? _c('div', [(_vm.displayInvoiceAddress) ? _c('router-link', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress',
        params: {
          order: _vm.order
        }
      }
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.displayInvoiceAddress.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.displayInvoiceAddress.consignee) + " " + _vm._s(_vm.displayInvoiceAddress.expressMobile))])])]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })]) : _c('router-link', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress',
        params: {
          order: _vm.order
        }
      }
    }
  }, [_c('div', {
    staticClass: "block-address",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "item-detail",
    staticStyle: {
      "margin-left": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#54c6fa",
      "font-size": "12px",
      "margin-left": "205px"
    }
  }, [_vm._v("点击选择地址")])])]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })])], 1) : _c('div', [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.displayInvoiceAddress.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.displayInvoiceAddress.consignee) + " " + _vm._s(_vm.displayInvoiceAddress.expressMobile))])])])])])])]), _vm._v(" "), (_vm.showChooseBalanceAccount || _vm.showChoosePayMethod) ? _c('div', {
    staticClass: "background-modal"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChooseBalanceAccount),
      expression: "showChooseBalanceAccount"
    }],
    staticClass: "choose-balance-account"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _vm._l((_vm.settlementAccountList), function(settlementAccount, index) {
    return _c('div', [_c('div', {
      staticClass: "block-item"
    }, [_c('div', [_c('i', {
      staticClass: "icon-font emkt-icon-bianzumergebeifen research-font-color"
    }), _vm._v(" "), _c('span', {
      staticClass: "light-text-color",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(_vm.getSettmentType(settlementAccount)))]), _vm._v(" " + _vm._s(settlementAccount.settlementAccountName) + " "), (settlementAccount.prepayCustomerNo) ? _c('span', {
      staticStyle: {
        "color": "#0A7CE3"
      }
    }, [_vm._v(" (账户余额)")]) : _vm._e()])]), _vm._v(" "), _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedBalanceType),
        expression: "selectedBalanceType"
      }],
      attrs: {
        "type": "radio",
        "name": "accountCheckbox",
        "id": index
      },
      domProps: {
        "value": settlementAccount,
        "checked": _vm._q(_vm.selectedBalanceType, settlementAccount)
      },
      on: {
        "change": function($event) {
          _vm.selectedBalanceType = settlementAccount
        }
      }
    }), _vm._v(" "), _vm._m(1, true)])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.chosenSettlementAccount !== null) ? _c('div', {
    staticClass: "pay-btn research-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.updateBalanceAccount
    }
  }, [_vm._v("完成")]) : _c('div', {
    staticClass: "pay-btn ",
    staticStyle: {
      "width": "100%",
      "background-color": "#7b7b7b"
    }
  }, [_vm._v("完成")])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoosePayMethod),
      expression: "showChoosePayMethod"
    }],
    staticClass: "choose-pay-method"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPayType),
      expression: "selectedPayType"
    }],
    attrs: {
      "type": "radio",
      "name": "payMethodCheckbox"
    },
    domProps: {
      "value": _vm.emkt.PAY_TYPE_FAPIAO,
      "checked": _vm._q(_vm.selectedPayType, _vm.emkt.PAY_TYPE_FAPIAO)
    },
    on: {
      "change": function($event) {
        _vm.selectedPayType = _vm.emkt.PAY_TYPE_FAPIAO
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-yue research-font-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "5px"
    }
  }, [_vm._v("余额支付")]), _vm._v(" "), _c('span', {
    staticClass: "tiny-font alert-text",
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("可用余额：¥" + _vm._s(_vm.availableRestMoney))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.canUseOtherAccount) ? _c('span', {
    staticClass: "tiny-font",
    staticStyle: {
      "color": "#979797"
    }
  }, [_vm._v("使用他人余额账户")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPayType),
      expression: "selectedPayType"
    }],
    attrs: {
      "type": "radio",
      "name": "payMethodCheckbox"
    },
    domProps: {
      "value": _vm.emkt.PAY_TYPE_REMAIN_MONEY,
      "checked": _vm._q(_vm.selectedPayType, _vm.emkt.PAY_TYPE_REMAIN_MONEY)
    },
    on: {
      "change": function($event) {
        _vm.selectedPayType = _vm.emkt.PAY_TYPE_REMAIN_MONEY
      }
    }
  }), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAccountVerifyBox),
      expression: "showAccountVerifyBox"
    }]
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('search_name')
      }
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nameQuery),
      expression: "nameQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请填写余额支付客户姓名"
    },
    domProps: {
      "value": (_vm.nameQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('search_mobile')
      }
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobileQuery),
      expression: "mobileQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请填写余额支付客户手机号"
    },
    domProps: {
      "value": (_vm.mobileQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pay-btn",
    staticStyle: {
      "width": "20%",
      "color": "#5878fa",
      "border": "1px solid #5878fa",
      "line-height": "23px",
      "height": "23px",
      "font-size": "12px"
    },
    attrs: {
      "id": "enterBtn"
    },
    on: {
      "click": _vm.checkRestMoneyAccount
    }
  }, [_vm._v("验证")])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('search_code')
      }
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "id": "search_code",
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "pay-btn research-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.updatePayMethod
    }
  }, [_vm._v("完成")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("结算账户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("支付方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "icon-font emkt-icon-xingzhuangkaobei research-font-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("发票支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind-info light-text-color"
  }, [_vm._v("首次选择使用"), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v("余额支付")]), _vm._v("时，为保证账户安全，请准确填写余额账号的姓名和手机号码，发送"), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v("短信验证码")]), _vm._v("进行授权验证，请勿外泄账号密码等重要信息。\n            "), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v("首次验证通过以后，再次使用时无需发送验证码。")])])
}]}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : (_vm.attribute.sorteditAble === true && (_vm.attribute.columnName === 'TvNoName' || _vm.attribute.columnName === 'TvNoNumber')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "选填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "必填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "research-background-color service-container",
    staticStyle: {
      "right": "-195px"
    },
    attrs: {
      "id": "service"
    },
    on: {
      "touchmove": _vm.handleTouchMove,
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd,
      "click": _vm.tokefuMessage
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-kefu1 icon-size",
    staticStyle: {
      "margin-left": "6px"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-base', {
    attrs: {
      "show-place-holder": _vm.showPlaceHolder,
      "order-detail": _vm.orderDetail,
      "express-track": _vm.expressTrack,
      "show-product-contract-no": _vm.showProductContractNo
    },
    on: {
      "goToProgressInfo": _vm.handleGoToProgressInfo,
      "goToProductInfo": _vm.handleGoToProductInfo,
      "goToExpressInfo": _vm.handleGoToExpressInfo,
      "getExpressSheet": _vm.handleGetExpressSheet
    },
    scopedSlots: _vm._u([{
      key: "addressOperation",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_vm._t("addressOperation", null, null, {
          orderDetail: orderDetail
        })]
      }
    }, {
      key: "productOperations",
      fn: function(ref) {
        var item = ref.item;
        var orderDetail = ref.orderDetail;

        return [_vm._t("productOperations", null, null, {
          item: item,
          orderDetail: orderDetail
        })]
      }
    }, {
      key: "orderOperations",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_vm._t("orderOperations", null, null, {
          orderDetail: orderDetail
        }), _vm._v(" "), _c('gc-order-detail-buttons-with-actions', {
          attrs: {
            "order-detail": orderDetail
          }
        })]
      }
    }], null, true)
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd_fixed"
  }, [_c('div', {
    staticClass: "hd"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("G客中心")])]), _vm._v(" "), _c('svg', {
    staticClass: "actionBg",
    attrs: {
      "width": "100vw",
      "height": "27.73vw",
      "viewBox": "0 0 375 104",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状结合@3x")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "页面-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "G客中心",
      "transform": "translate(0.000000, -51.000000)",
      "fill": "#2C2C2C"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,51 L375,51 L375,138 L372.172635,138.511249 C310.911081,149.50375 249.520202,155 188,155 C125.533333,155 62.8666666,149.333333 0,138 L0,138 L0,51 Z",
      "id": "形状结合"
    }
  })])])]), _vm._v(" "), (_vm.displayChosenResearchGroup) ? _c('van-swipe', {
    on: {
      "change": _vm.changeVip
    }
  }, _vm._l((5), function(item) {
    return _c('van-swipe-item', {
      key: item
    }, [_c('div', {
      staticClass: "current_group"
    }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName))]), _vm._v(" "), (item === _vm.displayChosenResearchGroup.vipLevel) ? _c('svg', {
      staticClass: "current_status",
      attrs: {
        "width": "71px",
        "height": "18px",
        "viewBox": "0 0 71 18",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("课题组组长标签")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "100%",
        "y1": "50%",
        "x2": "0%",
        "y2": "50%",
        "id": "linearGradient-1"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "#F0CFA6",
        "offset": "0%"
      }
    }), _vm._v(" "), _c('stop', {
      attrs: {
        "stop-color": "#C1864A",
        "offset": "100%"
      }
    })], 1)], 1), _vm._v(" "), _c('g', {
      attrs: {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "G客中心",
        "transform": "translate(-254.000000, -104.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组",
        "transform": "translate(25.000000, 61.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "课题组组长标签",
        "transform": "translate(229.000000, 43.000000)"
      }
    }, [_c('rect', {
      attrs: {
        "id": "矩形",
        "fill": "url(#linearGradient-1)",
        "x": "0",
        "y": "0",
        "width": "71",
        "height": "18",
        "rx": "9"
      }
    }), _vm._v(" "), _c('text', {
      attrs: {
        "id": "当前等级",
        "font-family": "PingFangSC-Regular, PingFang SC",
        "font-size": "12",
        "font-weight": "normal",
        "fill": "#FFFFFF"
      }
    }, [_c('tspan', {
      attrs: {
        "x": "11",
        "y": "13"
      }
    }, [_vm._v("当前等级")])])])])])])]) : _vm._e(), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.vipImg(item)
      }
    })])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [_c('object', {
    staticClass: "benefit_svg",
    attrs: {
      "data": _vm.vipBenefitSvg,
      "type": "image/svg+xml"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/对勾.svg",
      "data-src": "/static/img/对勾.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    合同签署成功\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.gotoOrderList
    }
  }, [_c('span', [_vm._v("\n      查看订单\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "submain-c",
    on: {
      "click": _vm.revert
    }
  }, [_c('span', [_vm._v("\n      返回主页\n    ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('order-content', {
    attrs: {
      "buttonName": "确认下单",
      "order": _vm.order,
      "showpromotion": false,
      "productInfo": _vm.productInfo,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.orderPay
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0",
      "width": "95%",
      "padding": "0 0 0 5%",
      "margin-bottom": "5px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "0.5rem"
    }
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "0.5rem"
    }
  }, [_vm._v(_vm._s(_vm.order.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "0.5rem"
    }
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "0.5rem"
    }
  }, [_vm._v(_vm._s(_vm.order.createOrderDT))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "1px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "innviceContent"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    staticStyle: {
      "height": "2rem"
    }
  }, [_c('label', {
    staticClass: "label-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPayType),
      expression: "selectedPayType"
    }],
    attrs: {
      "type": "radio",
      "name": "my-radio",
      "checked": ""
    },
    domProps: {
      "value": _vm.emkt.PAY_TYPE_FAPIAO,
      "checked": _vm._q(_vm.selectedPayType, _vm.emkt.PAY_TYPE_FAPIAO)
    },
    on: {
      "change": function($event) {
        _vm.selectedPayType = _vm.emkt.PAY_TYPE_FAPIAO
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  }), _vm._v(" "), _c('span', {
    staticClass: "textContent"
  }, [_vm._v(" 发票报账")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(3)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    staticStyle: {
      "height": "2rem"
    }
  }, [_c('label', {
    staticClass: "label-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPayType),
      expression: "selectedPayType"
    }],
    attrs: {
      "type": "radio",
      "name": "my-radio"
    },
    domProps: {
      "value": _vm.emkt.PAY_TYPE_REMAIN_MONEY,
      "checked": _vm._q(_vm.selectedPayType, _vm.emkt.PAY_TYPE_REMAIN_MONEY)
    },
    on: {
      "change": function($event) {
        _vm.selectedPayType = _vm.emkt.PAY_TYPE_REMAIN_MONEY
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  }), _vm._v(" "), _c('span', {
    staticClass: "pay1 textContent"
  }, [_vm._v("账户余额支付")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "innviceContent"
  }, [_vm._v("结算账户")]), _vm._v(" "), _vm._l((_vm.settlementAccountList), function(settlementAccount, index) {
    return _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('label', {
      staticClass: "label-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedBalanceType),
        expression: "selectedBalanceType"
      }],
      attrs: {
        "type": "radio",
        "name": "my-radio2",
        "id": index
      },
      domProps: {
        "value": settlementAccount,
        "checked": _vm._q(_vm.selectedBalanceType, settlementAccount)
      },
      on: {
        "change": function($event) {
          _vm.selectedBalanceType = settlementAccount
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "textContent"
    }, [_vm._v(" " + _vm._s(settlementAccount.settlementAccountName))])])]), _vm._v(" "), _c('p', [_c('a', {
      staticClass: "alert-text",
      on: {
        "click": function($event) {
          return _vm.displayMessage(6)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": ".9rem"
      },
      attrs: {
        "src": _vm.questionUrl
      }
    })])])])
  }), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'invoiceTitle',
        params: {
          order: _vm.order
        }
      }
    }
  }, [_c('div', {
    staticClass: "innoviceTitle item-inner item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "font-size": ".9rem",
      "font-weight": "bolder"
    }
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.defaultTitle))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "innviceContent"
  }, [_vm._v("发票内容")]), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('label', {
    staticClass: "label-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "my-invoice",
      "checked": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  }), _c('span', {
    staticClass: "textContent"
  }, [_vm._v("明细")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-title-row payTitle"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-top": "0.4rem"
    }
  }, [_vm._v("发票寄送地址")]), _vm._v(" "), _c('div', {
    attrs: {
      "lass": "item-after"
    }
  }, [_c('div', [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultInvoiceAddress),
      expression: "defaultInvoiceAddress"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.defaultInvoiceAddress) ? _vm._i(_vm.defaultInvoiceAddress, null) > -1 : (_vm.defaultInvoiceAddress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.defaultInvoiceAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.defaultInvoiceAddress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.defaultInvoiceAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.defaultInvoiceAddress = $$c
        }
      }, _vm.selectAddress]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })]), _vm._v(" "), _c('span', [_vm._v("与收货地址相同")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.defaultInvoiceAddress),
      expression: "!defaultInvoiceAddress"
    }]
  }, _vm._l((_vm.invoiceAddress), function(address, index) {
    return _c('li', [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'myInvoiceAddress',
          params: {
            order: _vm.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding": "0 0 0 2rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))])]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressMobile))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressAddress))])])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "innviceContent",
    staticStyle: {
      "border-top": "1px gainsboro solid"
    }
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('label', {
    staticClass: "label-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "my",
      "checked": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  }), _c('span', {
    staticClass: "textContent"
  }, [_vm._v("顺丰快递")])])])])], 2)])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "linear-gradient(#3B7EFE, #33CEFC)"
    }
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "3.5rem"
    }
  }, [_c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('account')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "account",
      "placeholder": "手机/邮箱/帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), (_vm.isSalesFlag) ? _c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('sfaccount')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerNo),
      expression: "customerNo",
      modifiers: {
        "trim": true
      }
    }],
    style: ({
      color: _vm.error
    }),
    attrs: {
      "id": "sfaccount",
      "type": "text",
      "placeholder": "客户编号"
    },
    domProps: {
      "value": (_vm.customerNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerNo = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('password')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "delete-password",
    attrs: {
      "src": "/static/img/delete.png"
    },
    on: {
      "click": _vm.deletePassword
    }
  }), _vm._v(" "), (_vm.showPassword) ? _c('img', {
    staticClass: "show-password",
    attrs: {
      "src": "/static/img/display-password.png"
    },
    on: {
      "click": _vm.toggleShowPassword
    }
  }) : _c('img', {
    staticClass: "show-password",
    attrs: {
      "src": "/static/img/hide-password.png"
    },
    on: {
      "click": _vm.toggleShowPassword
    }
  })])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-settings"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-2.4rem",
      "margin-left": "0",
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "block3"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "onclick": "window.open('https://beian.miit.gov.cn/')",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备17040580号-1")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "icon2",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "static/img/ba.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info3"
  }, [_vm._v("沪公网安备 31011502400053号")])])])])
}]}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.BOrder.expressContactor))])]), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v(_vm._s(_vm.BOrder.expressAddress))]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.BOrder.expressPhone))])])])]), _vm._v(" "), (_vm.BOrder.merchandises.length > 0) ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.BOrder.merchandises), function(merchandise) {
    return _c('ul', {
      staticStyle: {
        "margin": "5px 5% 0 5%",
        "width": "90%"
      }
    }, [_c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.goToDetail(merchandise)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((merchandise._titleList), function(title) {
      return (title.valueText !== '-1') ? _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, _vm._l((merchandise._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [(abstract.valueText && abstract.valueText !== '-1') ? _c('span', {
        staticStyle: {
          "font-size": "xx-small",
          "margin": ".3rem .3rem .8rem 0"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "1.5rem"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(merchandise.selfOperated === 0) ? _c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#1482E7"
      }
    }, [_vm._v("【第三方】")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(merchandise.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(merchandise.workdays) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(merchandise.workdays) + "工作日")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(merchandise.categoryId === 20 || merchandise.categoryId === 10) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("定制")]) : _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")])])])]), _vm._v(" "), (merchandise.discountPrice && merchandise.discountPrice != 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v(" ￥"), _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('hr'), _vm._v(" "), _c('div', [_vm._v(_vm._s(merchandise.merchandiseLabel))]), _vm._v(" "), (merchandise.quantity) ? _c('div', {
      staticStyle: {
        "color": "#6e727b",
        "float": "left"
      }
    }, [_vm._v("合计" + _vm._s(merchandise.quantity) + "个产品")]) : _c('div', {
      staticStyle: {
        "color": "#6e727b",
        "float": "left"
      }
    }, [_vm._v("合计" + _vm._s(1) + "个产品")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem",
        "float": "right"
      }
    }, [_vm._v(" ￥\n                  "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")]) : (merchandise.price && merchandise.price !== 0) ? _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.price) + " ")]) : _c('span', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")])])])])])])])
  }), 0) : _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.BOrder.subOrders), function(suborder) {
    return _c('div', _vm._l((suborder.merchandises), function(merch) {
      return _c('div', {
        staticStyle: {
          "margin": "5px 5% 0 5%",
          "width": "90%"
        }
      }, [_c('ul', [_c('li', [_c('a', {
        staticClass: "item-link item-content",
        on: {
          "click": function($event) {
            return _vm.goToDetail(merch)
          }
        }
      }, [_c('div', {
        staticClass: "item-inner",
        staticStyle: {
          "padding-bottom": "0rem"
        }
      }, [_c('div', {
        staticClass: "item-title-row"
      }, [_c('div', {
        staticClass: "item-title"
      }, _vm._l((merch._titleList), function(title) {
        return (title.valueText !== '-1') ? _c('span', {
          staticStyle: {
            "margin-right": ".3rem"
          }
        }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('div', {
        staticClass: "item-subtitle",
        staticStyle: {
          "font-size": "xx-small"
        }
      }, _vm._l((merch._abstractList), function(abstract) {
        return _c('label', {
          staticClass: "label-checkbox checkbox-el "
        }, [(abstract.valueText && abstract.valueText !== '-1') ? _c('span', {
          staticStyle: {
            "font-size": "xx-small",
            "margin": ".3rem .3rem .8rem 0"
          }
        }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "item-text",
        staticStyle: {
          "height": "1.5rem"
        }
      }, [_c('div', {
        staticStyle: {
          "height": "1.6rem"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left"
        }
      }, [(merch.selfOperated === 0) ? _c('span', {
        staticStyle: {
          "font-size": "x-small",
          "color": "#1482E7"
        }
      }, [_vm._v("【第三方】")]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "font-size": ".5rem"
        }
      }, [(merch.categoryId === 20 || merch.categoryId === 10) ? _c('span', {
        staticClass: "sub-span"
      }, [_vm._v("定制")]) : _c('span', [_c('span', {
        staticClass: "sub-span"
      }, [_vm._v("现货")]), _vm._v(" "), _c('span', {
        staticClass: "sub-span"
      }, [_vm._v("减券")])])])])]), _vm._v(" "), (merch.discountPrice && merch.discountPrice != 0) ? _c('div', {
        staticClass: "item-title-row"
      }, [_c('div', {
        staticClass: "item-title",
        staticStyle: {
          "color": "#6e727b"
        }
      }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#00469A",
          "font-size": "0.1rem"
        },
        attrs: {
          "lass": "item-after"
        }
      }, [_vm._v(" ￥"), _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_c('hr'), _vm._v(" "), (merch.quantity) ? _c('div', {
        staticStyle: {
          "color": "#6e727b",
          "float": "left"
        }
      }, [_vm._v("合计" + _vm._s(merch.quantity) + "个产品")]) : _c('div', {
        staticStyle: {
          "color": "#6e727b",
          "float": "left"
        }
      }, [_vm._v("合计" + _vm._s(1) + "个产品")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#00469A",
          "font-size": "0.1rem",
          "float": "right"
        }
      }, [_vm._v(" ￥\n                      "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.priceMax) + " ")]) : (merch.price && merch.price !== 0) ? _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.price) + " ")]) : _c('span', {
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(_vm._s(merch.priceMax) + " ")])])])])])])])])
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.createOrderDT))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("结算方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.payTypeName))])])])]), _vm._v(" "), (_vm.BOrder.balanceType === _vm.balanceTypeResearch) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("课题组名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.researchGroupName))])])])]) : _vm._e(), _vm._v(" "), (_vm.BOrder.settlementAccountNo) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("结算账户编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.settlementAccountNo))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceTypeName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceTitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票内容")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.BOrder.invoiceContent))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.initPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("运费")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.expressPrice))])])])]), _vm._v(" "), (_vm.BOrder.discountPrice && _vm.BOrder.discountPrice != 0) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("-￥" + _vm._s(_vm.BOrder.discountPrice))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("实支付")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("￥" + _vm._s(_vm.BOrder.totalPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  })])])]), _vm._v(" "), _c('footer', {
    staticClass: "bar bar-tab"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "float": "right",
      "margin-top": "0"
    }
  }, [(_vm.BOrder.status === 11 && _vm.merchandises[0].categoryId === 20 && (_vm.merchandises[0]._attributes.ReguTech === undefined || _vm.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
    staticClass: "gotopay_button_style",
    on: {
      "click": function($event) {
        return _vm.buyAgain1(_vm.BOrder)
      }
    }
  }, [_vm._v("我要扩增")]) : _c('span', {
    staticClass: "gotopay_button_style",
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("再次购买")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("订单详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": ".3rem"
    }
  }, [_c('button', {
    staticClass: "button workdays"
  }, [_vm._v("周期20个工作日")])])
}]}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.6rem",
      "display": "none"
    },
    attrs: {
      "id": "prompt"
    }
  }, [_vm._v("您的消息已经收到啦， 客服人员会尽快回复的。")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "按 回车键(换行) 发送"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "keyup": _vm.onKeyup,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWaitApproveOrder),
      expression: "isWaitApproveOrder"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单已提交课题组审批人，请等待审批。\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderDetail && _vm.orderDetail.status === 14),
      expression: "orderDetail && orderDetail.status === 14"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单已提交技术审核，技术审核预计在"), (new Date().getHours() >= 17 && new Date().getMinutes() >= 30) ? _c('span', [_vm._v("明天")]) : _vm._e(), _vm._v("17:30完成\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderDetail && _vm.orderDetail.status === 16),
      expression: "orderDetail && orderDetail.status === 16"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单未通过技术审核，未通过原因：" + _vm._s(_vm.orderDetail && _vm.orderDetail.remark) + "\n    ")]), _vm._v(" "), (_vm.orderDetail) ? _c('div', {
    staticClass: "order-detail-container"
  }, [_c('div', {
    staticClass: "order-detail-content",
    style: ({
      'padding-bottom': _vm.showPlaceHolder ? '85px' : '50px',
    })
  }, [_c('div', {
    staticClass: "order-content-block",
    style: ({
      'margin-top': _vm.isWaitApproveOrder ? '25px' : '0'
    })
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.expressAddress || '无收货地址'))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.expressName) + "\n                  " + _vm._s(_vm.orderDetail.expressMobile))])])]), _vm._v(" "), _vm._t("addressOperation", null, null, {
    orderDetail: _vm.orderDetail
  })], 2), _vm._v(" "), (_vm.lastExpressInfo && _vm.expressTrack.length > 0) ? _c('div', {
    staticClass: "full-split-line"
  }) : _vm._e(), _vm._v(" "), (_vm.lastExpressInfo && _vm.expressTrack.length > 0) ? _c('div', {
    staticClass: "block-address"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1691040315076",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "6515",
      "width": "16",
      "height": "16",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M770.24115 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998 0 47.557749 38.531832 86.098778 86.080383 86.098778 47.546507 0 86.079361-38.54103 86.079361-86.098778C856.319489 722.740631 817.787657 684.199601 770.24115 684.200623z",
      "fill": "#5878fa",
      "p-id": "6516"
    }
  }), _c('path', {
    attrs: {
      "d": "M933.255409 476.888655 856.319489 339.800399c-15.735058-18.968527-26.360335-34.43992-51.647617-34.43992L684.159745 305.360479 684.159745 202.039697c0-18.968527-15.467305-34.438898-34.431745-34.438898L98.814978 167.600798C79.850539 167.600798 64.383234 183.07117 64.383234 202.039697l0 516.598802c0 18.970571 15.467305 34.440942 34.431745 34.440942l68.661142 0C175.919521 693.748758 226.558467 647.81081 288.191617 647.81081S400.464735 693.748758 408.907114 753.079441l240.617517-0.034747c8.47406-59.325573 59.113006-105.233884 120.716519-105.233884 61.634172 0 112.272096 45.93897 120.715497 105.268631l34.229397 0C944.149461 753.079441 959.616766 737.60907 959.616766 718.639521c0 0 0-139.573653 0-172.199601C959.615745 513.814994 933.255409 476.888655 933.255409 476.888655zM718.592511 546.43992 718.592511 374.240319l84.229621 0c5.547178 0 13.249661 8.138858 13.249661 8.138858l72.493477 134.801118c6.42095 9.450028 13.383537 20.650667 13.383537 29.259625L718.592511 546.43992z",
      "fill": "#5878fa",
      "p-id": "6517"
    }
  }), _c('path', {
    attrs: {
      "d": "M288.191617 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998C202.112255 817.858172 240.64511 856.399202 288.191617 856.399202s86.080383-38.54103 86.080383-86.098778C374.272 722.740631 335.738124 684.199601 288.191617 684.200623z",
      "fill": "#5878fa",
      "p-id": "6518"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    on: {
      "click": function($event) {
        return _vm.$emit('goToExpressInfo')
      }
    }
  }, [_c('span', {
    staticClass: "express-opcode-color"
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.opcode))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "express-text-color",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.remark))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing",
    staticStyle: {
      "font-size": "5px",
      "position": "absolute",
      "right": "30px"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "express-text-color"
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.acceptTime))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "35px"
    }
  }, [_c('span', {
    staticClass: "deep-text-color",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderDetail.orderNo))]), _vm._v(" "), _c('div', {
    staticClass: "copy-orderno light-text-color",
    attrs: {
      "data-clipboard-text": _vm.orderDetail.orderNo,
      "id": "tag-copy"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n              复制\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _vm._l((_vm.orderDetail.itemList), function(item, i) {
    return _c('div', [_c('gc-order-product', {
      attrs: {
        "item": item,
        "order": _vm.orderDetail,
        "show-product-contract-no": _vm.showProductContractNo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item light-text-color",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "flex-start"
      }
    }, [((item.contractNo && item.contractNo.indexOf('GVAP') < 0) || !item.contractNo) ? _c('div', {
      staticClass: "return-btn research-font-color",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goToProductInfo', item)
        }
      }
    }, [_vm._v("产品详情\n                ")]) : _vm._e(), _vm._v(" "), (item.contractNo && item.contractNo.indexOf('GVAP') < 0) ? _c('div', {
      staticClass: "return-btn research-font-color",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goToProgressInfo', item)
        }
      }
    }, [_vm._v("\n                  进展查询\n                ")]) : _vm._e(), _vm._v(" "), _vm._t("productOperations", null, null, {
      item: item,
      orderDetail: _vm.orderDetail
    })], 2), _vm._v(" "), _c('span', {
      staticClass: "research-font-color"
    }, [_vm._v("¥ " + _vm._s(_vm.emkt.formatPrice(item.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.initPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("优惠折扣")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.discountPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("运费")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.expressPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.itemListLength) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.price)))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("结算方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getBalanceTypeName()))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getPayTypeName()))])]), _vm._v(" "), (_vm.orderDetail.sfQuoteNo) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("报价编号")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.sfQuoteNo))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getDeliverMethod()))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.orderTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_vm._t("orderOperations", null, null, {
    orderDetail: _vm.orderDetail
  })], 2), _vm._v(" "), _c('gc-footer-placeholder', {
    attrs: {
      "show-place-holder": _vm.showPlaceHolder
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind_block"
  }, [(!_vm.remindParams.register) ? _c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.remindParams.firstline))])]), _vm._v(" "), _c('div', {
    staticClass: "infoWrap_2"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v(_vm._s(_vm.remindParams.secondline))])]), _vm._v(" "), (_vm.remindParams.singleOrDouble === 2) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag research-font-color"
  }, [_vm._v(_vm._s(_vm.remindParams.cancel || '取消'))])]), _vm._v(" "), _c('div', {
    staticClass: "col2 activity-background-color",
    on: {
      "click": _vm.confirm
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v(_vm._s(_vm.remindParams.confirm || '确认'))])])]) : _vm._e(), _vm._v(" "), (_vm.remindParams.singleOrDouble === 1) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col3 activity-background-color",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v(_vm._s(_vm.remindParams.confirm || '确认'))])])]) : _vm._e()])]) : _c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_register"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col3 research-background-color",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info_register"
  }, [_vm._v("吉凯基因淘基因平台用户注册协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap_register"
  }, [_c('div', {
    staticClass: "textArea",
    staticStyle: {
      "height": "18rem"
    },
    attrs: {
      "readonly": "true"
    }
  }, [_vm._v("本协议是用户（以下简称“您”）与吉凯基因淘基因线上平台（以下简称“淘基因”）及其关联公司之间就吉凯基因数字营销服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击\"同意\"按钮后，即视为您接受并同意遵守本协议的约定。\n          "), _c('br'), _vm._v("第1条 本站服务条款的确认和接纳\n          "), _c('br'), _c('strong', [_vm._v("1.1")]), _vm._v("本站的各项电子服务的所有权和运作权归淘基因所有。您同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。您确认：本协议条款是处理双方权利义务的依据，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定或约定。\n          "), _c('br'), _c('strong', [_vm._v("1.2")]), _vm._v("您点击同意本协议的，即视为您确认自己具有享受本站服务相应的权利能力和行为能力，能够独立承担法律责任。\n          "), _c('br'), _c('strong', [_vm._v("1.3")]), _vm._v("您确认，如果您在18周岁以下，您只能在父母或其他监护人的监护参与下才能使用本站。\n          "), _c('br'), _c('strong', [_vm._v("1.4")]), _vm._v("淘基因保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n          "), _c('br'), _c('strong', [_vm._v("1.5")]), _vm._v("您使用本站提供的服务时，应同时接受适用于本站特定服务、活动等的准则、条款和协议（以下统称为“其他条款”）；如果以下使用条件与“其他条款”有不一致之处，则以“其他条款”为准。\n          "), _c('br'), _c('strong', [_vm._v("1.6")]), _vm._v("为表述便利，商品和各类技术服务简称为“商品”或“货物”。\n          "), _c('br'), _vm._v("第2条 本站服务\n          "), _c('br'), _c('strong', [_vm._v("2.1")]), _vm._v("吉凯基因淘基因通过互联网依法为您提供产品及技术支持等服务，您在完全同意本协议及本站相关规定的情况下，方有权使用本站的相关服务。\n          "), _c('br'), _c('strong', [_vm._v("2.2")]), _vm._v("您必须自行准备如下设备和承担如下开支：\n          "), _c('br'), _c('strong', [_vm._v("2.2.1")]), _vm._v("上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；\n          "), _c('br'), _c('strong', [_vm._v("2.2.2")]), _vm._v("上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。\n          "), _c('br'), _vm._v("第3条 用户信息收集及保护\n          "), _c('br'), _c('strong', [_vm._v("3.1")]), _vm._v("您应自行诚信向本站提供注册资料，您保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且吉凯基因保留单方终止您使用淘基因各项服务的权利。\n          "), _c('br'), _c('strong', [_vm._v("3.2")]), _vm._v("您在本站进行注册、浏览、下单购物、评价、参加活动等行为时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情、评价或反馈、投诉内容、cookies等信息的，本站有权从完成交易、提供配送、售后及客户服务、开展活动、完成良好的客户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密，除非得到您的授权、为履行强行性法律义务（如国家安全机关指令）或法律另有规定、本注册协议或其他条款另有约定外，本站不会向外界披露您的隐私信息。\n          "), _c('br'), _c('strong', [_vm._v("3.3")]), _vm._v("您注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。您应谨慎合理的保存、使用您的账户信息。您若发现任何非法使用您的账户或其他存在安全漏洞的情况的，请立即通知本站并向公安机关报案。\n          "), _c('br'), _c('strong', [_vm._v("3.4您同意，淘基因拥有通过邮件、短信、电话、网站通知或声明等形式，向在本站注册、购物的用户、收货人发送订单信息、促销活动、售后服务、客户服务等告知信息的权利。如您不希望接收上述信息，可退订。\n            "), _c('br'), _c('strong', [_vm._v("3.5")]), _vm._v("您同意：您选择向本站的商品销售商或服务提供商（以下统称为“销售商”，含淘基因及其关联公司）提交订单购买商品或服务的，视为您向销售商披露个人相关信息，接受销售商向您提供商品销售、配送、售后服务、客户服务、处理信用卡付款、数据分析、市场营销帮助或其他必要事宜；如前述全部或部分事宜之一涉及由销售商外的第三方履行的，销售商有权将您的信息以必要方式向第三方披露，第三方有权以履行上述事宜为目的联系您。\n            "), _c('br'), _c('strong', [_vm._v("3.6")]), _vm._v("您不得将在本站注册获得的账号、密码等账户信息提供给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。\n            "), _c('br'), _c('strong', [_vm._v("3.7")]), _vm._v("您同意，淘基因有权使用您的注册信息、用户名、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。")]), _vm._v(" "), _c('br'), _vm._v("第4条 用户依法言行义务\n          "), _c('br'), _vm._v("本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：\n          "), _c('br'), _c('strong', [_vm._v("4.1")]), _vm._v("不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n          "), _c('br'), _c('strong', [_vm._v("4.2")]), _vm._v("从中国大陆向境外传输资料信息时必须符合中国有关法律法规；\n          "), _c('br'), _c('strong', [_vm._v("4.3")]), _vm._v("不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n          "), _c('br'), _c('strong', [_vm._v("4.4")]), _vm._v("不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；\n          "), _c('br'), _c('strong', [_vm._v("4.5")]), _vm._v("不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；\n          "), _c('br'), _c('strong', [_vm._v("4.6")]), _vm._v("不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n          "), _c('br'), _c('strong', [_vm._v("4.7")]), _vm._v("不得教唆他人从事本条所禁止的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8")]), _vm._v("除本注册协议、其他条款或另有其他约定外，您不得利用在本站注册的账户进行经营活动、牟利行为及其他未经本站许可的行为，包括但不限于以下行为：\n          "), _c('br'), _c('strong', [_vm._v("4.8.1")]), _vm._v("您账户内的任何淘基因优惠信息（包括但不限于优惠券、折扣券、产品赠送券及其他形式优惠或折扣等）由吉凯基因享有解释权和修改权，您仅享有在淘基因购物时的使用权，严禁转卖淘基因账户、优惠券、折扣券、产品赠送券或其他类型的优惠券、或利用淘基因账户进行其他经营性行为等；\n          "), _c('br'), _c('strong', [_vm._v("4.8.2")]), _vm._v("恶意利用技术手段或其他方式，为获取优惠、折扣或其他利益而注册账户、下单等行为，影响其他用户正常消费行为或相关合法权益、影响淘基因正常销售秩序的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.3")]), _vm._v("发布广告、垃圾邮件；\n          "), _c('br'), _c('strong', [_vm._v("4.8.4")]), _vm._v("以再销售或商业使用为目的对本站商品或服务进行购买的（与吉凯基因另有合同约定的除外）；\n          "), _c('br'), _c('strong', [_vm._v("4.8.5")]), _vm._v("商品或服务的供应商、代理商对其所供商品进行回购的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.6")]), _vm._v("任何对商品目录、说明、价格、数量、其他用户信息或其他内容的下载、转载、收集、衍生利用、复制、出售、转售或其他形式的使用，无论是否通过Robots、Spiders、自动仪器或手工操作；\n          "), _c('br'), _c('strong', [_vm._v("4.8.7")]), _vm._v("本站相关规则、政策、或网页活动规则中限制、禁止的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.8")]), _vm._v("其他影响淘基因对用户账户正常管理秩序的行为。\n          "), _c('br'), _c('strong', [_vm._v("4.9")]), _vm._v("您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则淘基因有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案。\n          "), _c('br'), _c('strong', [_vm._v("4.10")]), _vm._v("您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现您发布的信息涉嫌知识产权、或其他合法权益争议的，这些用户或权利人有权要求淘基因删除您发布的信息，或者采取其他必要措施予以制止，淘基因将会依法采取这些措施。\n          "), _c('br'), _c('strong', [_vm._v("4.11")]), _vm._v("您应不时关注并遵守本站不时公布或修改的各类规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知您的权利。\n          "), _c('br'), _c('strong', [_vm._v("4.12")]), _vm._v("您未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭您的账号、冻结账号内金额、关闭相应交易订单、停止发货等措施。您须对自己在网上的言论和行为承担法律责任。\n          "), _c('br'), _vm._v("第5条 商品信息\n          "), _c('br'), _c('strong', [_vm._v("5.1")]), _vm._v("本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；淘基因欢迎纠错，并会视情况给予纠错者一定的奖励。\n          "), _c('br'), _c('strong', [_vm._v("5.2")]), _vm._v("本站售后服务政策为本协议的组成部分，淘基因有权以声明、通知或其他形式变更售后服务政策。\n          "), _c('br'), _vm._v("第6条 订单\n          "), _c('br'), _c('strong', [_vm._v("6.1")]), _vm._v("在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、周期、产品性状、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。\n          "), _c('br'), _c('strong', [_vm._v("6.2")]), _vm._v("除法律另有强制性规定外，双方约定如下：本站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售商发出的合同要约；当您确认订单信息，并且在线点击“确认下单”后，进入下单成功页面，即视为您与销售商之间就您采购的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售商只给您发出了部分商品时，您与销售商之间仅就实际直接向您发出的商品建立了合同关系；只有在销售商实际直接向您发出了订单中订购的其他商品时，您和销售商之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登陆您在本站注册的账户，查询您的订单状态。\n          "), _c('br'), _c('strong', [_vm._v("6.3尽管销售商做出最大的努力，但商品目录里的一小部分商品可能会有定价错误。如果发现错误定价，将采取下列之一措施，且不视为违约行为：\n            "), _c('br'), _vm._v("6.3.1如果某一商品的正确定价低于销售商的错误定价，销售商将按照较低的定价向您销售交付该商品。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.4由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您下单所购买的商品，发生缺货，您有权取消订单，销售商亦有权取消订单，并为已付款的用户办理退款。")]), _vm._v(" "), _c('br'), _vm._v("第7条 配送\n          "), _c('br'), _c('strong', [_vm._v("7.1")]), _vm._v("销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。\n          "), _c('br'), _c('strong', [_vm._v("7.2")]), _vm._v("因如下情况造成订单延迟或无法配送、交货等，销售商不承担延迟配送、交货的责任：\n          "), _c('br'), _c('strong', [_vm._v("（1）")]), _vm._v("您提供的信息错误、地址不详细等原因导致的；\n          "), _c('br'), _c('strong', [_vm._v("（2）")]), _vm._v("货物送达后无人签收，导致无法配送或延迟配送的；\n          "), _c('br'), _c('strong', [_vm._v("（3）")]), _vm._v("情势变更因素导致的；\n          "), _c('br'), _c('strong', [_vm._v("（4）")]), _vm._v("未能在本站所示的送货参考时间内送货的；\n          "), _c('br'), _c('strong', [_vm._v("（5）")]), _vm._v("因节假日、大型促销活动、店庆、预购或抢购人数众多等原因导致的；\n          "), _c('br'), _c('strong', [_vm._v("（6）")]), _vm._v("不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n          "), _c('br'), _vm._v("第8条 所有权及知识产权条款\n          "), _c('br'), _c('strong', [_vm._v("8.1您一旦接受本协议，即表明您主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给淘基因所有，您同意吉凯基因有权就任何主体侵权而单独提起诉讼。\n            "), _c('br'), _vm._v("8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在淘基因上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。\n            "), _c('br'), _vm._v("8.3您同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其他主体以任何方式使用（包括但限于在各类网站、媒体上使用）。\n            "), _c('br'), _vm._v("8.4淘基因有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知您。在法律允许的最大限度范围内，淘基因对本协议及本站内容拥有解释权。\n            "), _c('br'), _vm._v("8.5除法律另有强制性规定外，未经淘基因明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，淘基因有权追究其法律责任。 ")]), _vm._v(" "), _c('br'), _c('strong', [_vm._v("8.6")]), _vm._v("站所刊登的资料信息（包括但不限于文字、图表、商标、logo、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件等），均是淘基因或其内容提供者的财产，受中国和国际相关版权法规、公约等的保护，未经淘基因书面许可，任何第三方无权将上述资料信息复制、出版、发行、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。本站上所有内容的汇编是淘基因的排他财产，受中国和国际版权法的保护。本站上所有软件都是淘基因或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分软件，或利用软件创设衍生产品。\n          "), _c('br'), _vm._v("第9条 责任限制及不承诺担保\n          "), _c('br'), _c('strong', [_vm._v("9.1")]), _vm._v("除非另有明确的书面说明,本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。\n          "), _c('br'), _c('strong', [_vm._v("9.2")]), _vm._v("除非另有明确的书面说明, 淘基因不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。\n          "), _c('br'), _c('strong', [_vm._v("9.3")]), _vm._v("淘基因不担保本站所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。\n          "), _c('br'), _c('strong', [_vm._v("9.4")]), _vm._v("如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，淘基因会合理地尽力协助处理善后事宜。\n          "), _c('br'), _c('strong', [_vm._v("9.5")]), _vm._v("您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，您应承担全部责任。同时，因网络环境存在众多不可预知因素，因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的淘基因账户或个人信息等被第三方窃取的，淘基因不承担赔偿责任。\n          "), _c('br'), _c('strong', [_vm._v("9.6")]), _vm._v("您了解并同意，吉凯基因有权应国家有关机关的要求，向其提供您在淘基因的用户信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则吉凯基因有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。\n          "), _c('br'), _vm._v("第10条 协议更新及用户关注义务\n          "), _c('br'), _vm._v("根据国家法律法规变化及网站运营需要，吉凯基因有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议、其他条款及网站公告。如您不同意更新后的协议，可以且应立即停止接受淘基因依据本协议提供的服务；如您继续使用本站提供的服务的，即视为同意更新后的协议。淘基因建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n          "), _c('br'), _vm._v("第11条 法律管辖和适用\n          "), _c('br'), _vm._v("本协议的订立、执行和解释及争议的解决均适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的"), _c('span', {
    staticClass: "background"
  }, [_vm._v("上海市徐汇区人民法院")]), _vm._v("提起诉讼。\n          "), _c('br'), _vm._v("第12条 其他\n          "), _c('br'), _c('strong', [_vm._v("12.1")]), _vm._v("淘基因所有者是指在政府部门依法许可或备案的吉凯基因网站经营主体。\n          "), _c('br'), _c('strong', [_vm._v("12.2")]), _vm._v("淘基因尊重您的合法权利，本协议及本站上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。本站欢迎您和社会各界提出意见和建议，淘基因将虚心接受并适时修改本协议及本站上的各类规则。\n          "), _c('br'), _c('strong', [_vm._v("12.3")]), _vm._v("本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请您着重阅读。\n          "), _c('br'), _c('strong', [_vm._v("12.4")]), _vm._v("您点击本协议下方的“同意并继续”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。\n        ")])])
}]}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pager",
    style: ({
      'height': _vm.detail ? '100vh' : '90vh'
    })
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "-webkit-sticky"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "flex-y-bottom"
  }, [_c('div', {
    staticClass: "bo-logo flex-grow-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.serviceUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bo-title flex-grow-1"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.eu1.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sampleSpec ? _vm.sampleSpec + ' / ' : '') + "\n                " + _vm._s(_vm.sampleType ? _vm.sampleType + ' / ' : '') + "\n                " + _vm._s(_vm.experimentalTotalNum ? _vm.experimentalTotalNum + '个样本' : '') + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('span', {
    staticClass: "real-price"
  }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.formalQuotePrice)))]), _vm._v(" "), (_vm.formalQuotePrice !== _vm.standardPrice) ? _c('span', {
    staticClass: "sale-price"
  }, [_c('s', [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.standardPrice)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 right"
  }, [_c('span', {
    staticClass: "deliver-text"
  }, [_vm._v("预计交付周期：")]), _vm._v(" "), _c('span', {
    staticClass: "deliver-value"
  }, [_vm._v(_vm._s(_vm.serviceWorkDaysSolution ? _vm.serviceWorkDaysSolution.workdays : 15) + "个工作日")])])])]), _vm._v(" "), (_vm.promotion && _vm.promotion.name) ? _c('div', {
    staticClass: "advertising-banner"
  }, [_vm._v(_vm._s(_vm.promotion.name))]) : _vm._e(), _vm._v(" "), (!_vm.detail) ? _c('div', {
    staticClass: "step-wrapper"
  }, [_c('van-steps', {
    attrs: {
      "active": _vm.stepNo,
      "active-color": "#5878FA",
      "inactive-color": "#979797",
      "finish-icon": "checked",
      "active-icon": "checked",
      "inactive-icon": "circle"
    }
  }, [_c('van-step', [_vm._v("样本类型")]), _vm._v(" "), _c('van-step', [_vm._v("其他参数")]), _vm._v(" "), _c('van-step', [_vm._v("确认方案")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('van-popup', {
    style: ({
      width: '98%',
      height: '40%'
    }),
    attrs: {
      "closeable": "",
      "round": "",
      "close-icon": "close"
    },
    on: {
      "close": _vm.closeSampleCategoryPopup
    },
    model: {
      value: (_vm.showSampleCategory),
      callback: function($$v) {
        _vm.showSampleCategory = $$v
      },
      expression: "showSampleCategory"
    }
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_c('span', [_vm._v("样本分类")])]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("样本类型")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row sample-wrapper"
  }, _vm._l((_vm.sampleCategoryOptArr), function(item, index) {
    return (item.dictValue !== '-') ? _c('div', {
      key: index,
      staticClass: "flex-grow-1"
    }, [_c('div', {
      class: _vm.sampleCategoryItemChecked[index] ? 'radioTagChecked' : 'radioTag',
      on: {
        "click": function($event) {
          return _vm.pickSampleCategory(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.dictValue) + "\n              ")])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.sampleCategoryOptArr), function(category, k) {
    return _c('div', {
      key: k
    }, [(_vm.sampleCategoryItemChecked[k]) ? _c('div', [_c('div', {
      staticClass: "item-title"
    }, [_c('span', [_vm._v(_vm._s(_vm.sampleCategoryOptArr[k].extraValue))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row sample-wrapper"
    }, _vm._l((_vm.sampleSubCategoryOptArr), function(item, index) {
      return (category.dictKey === item.parentId) ? _c('div', {
        key: index,
        staticClass: "flex-grow-1"
      }, [_c('div', {
        class: _vm.subCategoryChecked[index] ? 'radioTagChecked' : 'radioTag',
        on: {
          "click": function($event) {
            return _vm.pickSubCategory(index)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(item.dictValue) + "\n                  ")])]) : _vm._e()
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-button-wrap"
  }, [_c('div', {
    staticClass: "pop-button",
    on: {
      "click": _vm.closeSampleCategoryPopup
    }
  }, [_c('span', [_vm._v("确定")])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80vh",
      "overflow": "auto"
    }
  }, [(_vm.stepNo === 0) ? _c('div', [_c('van-form', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v(" 样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', {
    attrs: {
      "center": "",
      "title": "是否具有传染性",
      "title-class": "cell-title"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "24"
          },
          model: {
            value: (_vm.infectionChecked),
            callback: function($$v) {
              _vm.infectionChecked = $$v
            },
            expression: "infectionChecked"
          }
        })]
      },
      proxy: true
    }], null, false, 1607973655)
  }), _vm._v(" "), (_vm.infectionChecked) ? _c('div', {
    staticClass: "warning-info"
  }, [_c('span', [_vm._v("注意：根据相关法律规定，传染性生物样本需要严格管控，\n              吉凯目前不具备处理传染性样本的实验条件，请您务必保证提供的生物样本为非传染性样本；\n              若一旦发现您提供的生物样本具有传染性，吉凯将保留追究相应的刑事和民事责任的权利。\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-cell', [_c('van-row', {
    attrs: {
      "gutter": "2"
    }
  }, [_c('van-col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _vm._l((_vm.sampleSpecOptArr), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      class: _vm.sampleSpecItemChecked[index] ? 'radioTagChecked' : 'radioTag',
      on: {
        "click": function($event) {
          return _vm.pickSampleSpec(index)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.chnName) + "\n                    ")])])
  }), _vm._v(" "), _c('van-col', {
    attrs: {
      "span": "2"
    }
  })], 2), _vm._v(" "), (_vm.showOtherSampleSpecInput) ? _c('van-field', {
    ref: "otherSampleSpecNameField",
    attrs: {
      "placeholder": "请输入其他物种名称",
      "rules": [{
        validator: _vm.validateOtherSampleSpecName,
        message: '请输入其他物种名称',
        trigger: 'onBlur'
      }]
    },
    on: {
      "change": _vm.handleOtherSpecNameChanged
    },
    model: {
      value: (_vm.otherSampleSpecName),
      callback: function($$v) {
        _vm.otherSampleSpecName = $$v
      },
      expression: "otherSampleSpecName"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "diseaseDirectionField",
    attrs: {
      "label-class": "form-label",
      "is-link": "",
      "readonly": "",
      "label": "疾病方向",
      "placeholder": "请选择疾病方向",
      "rules": [{
        validator: _vm.validateDiseaseDirection,
        message: '请选择疾病方向',
        trigger: 'onBlur'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDiseaseDirectionPicker = true
      }
    },
    model: {
      value: (_vm.diseaseDirectionName),
      callback: function($$v) {
        _vm.diseaseDirectionName = $$v
      },
      expression: "diseaseDirectionName"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showDiseaseDirectionPicker),
      callback: function($$v) {
        _vm.showDiseaseDirectionPicker = $$v
      },
      expression: "showDiseaseDirectionPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.diseaseDirectionOpts,
      "value-key": "diseaseName"
    },
    on: {
      "cancel": _vm.onCancelDiseaseDirection,
      "confirm": _vm.onConfirmDiseaseDirection
    }
  })], 1), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "sampleCategoryField",
    attrs: {
      "label-class": "form-label",
      "is-link": "",
      "readonly": "",
      "label": "样本分类",
      "placeholder": "请选择样本分类",
      "rules": [{
        validator: _vm.validateSampleCategory,
        message: '请选择样本分类',
        trigger: 'onBlur'
      }]
    },
    on: {
      "click": _vm.showSampleCategoryPopup
    },
    model: {
      value: (_vm.sampleCategory.label),
      callback: function($$v) {
        _vm.$set(_vm.sampleCategory, "label", $$v)
      },
      expression: "sampleCategory.label"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "sampleTypeField",
    attrs: {
      "label-class": "form-label",
      "label": "样本类型",
      "placeholder": "填写示例：癌或癌旁样本",
      "rules": [{
        validator: _vm.validateSampleType,
        message: '请填写样本类型',
        trigger: 'onBlur'
      }]
    },
    on: {
      "change": _vm.handleChangeSampleType,
      "blur": _vm.reSetPageScroll,
      "focus": _vm.reSetPageScroll
    },
    model: {
      value: (_vm.sampleType),
      callback: function($$v) {
        _vm.sampleType = $$v
      },
      expression: "sampleType"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bizValidateMsg !== ''),
      expression: "bizValidateMsg !== ''"
    }],
    staticClass: "warning-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.bizValidateMsg) + "\n            ")])])], 1), _vm._v(" "), (!_vm.infectionChecked) ? _c('div', {
    staticStyle: {
      "height": "30px",
      "background-color": "#fafafa"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', {
    attrs: {
      "center": "",
      "title": "剩余样本返回"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "24"
          },
          on: {
            "click": _vm.handleChangeReturnMaterial
          },
          model: {
            value: (_vm.returnMaterialChecked),
            callback: function($$v) {
              _vm.returnMaterialChecked = $$v
            },
            expression: "returnMaterialChecked"
          }
        })]
      },
      proxy: true
    }], null, false, 3092763397)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(!_vm.infectionChecked) ? _c('van-cell-group', {
    attrs: {
      "title": "实验组及样本数"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.experimentalGroup), function(experimental, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('span', {
      staticClass: "cancel-default-style"
    }, [_c('van-field', {
      staticStyle: {
        "float": "left",
        "width": "100px"
      },
      attrs: {
        "placeholder": "未命名",
        "input-align": "right"
      },
      on: {
        "blur": function($event) {
          return _vm.handleChangeGroupName(index)
        }
      },
      model: {
        value: (experimental.label),
        callback: function($$v) {
          _vm.$set(experimental, "label", $$v)
        },
        expression: "experimental.label"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-font emkt-icon-xiugai",
      staticStyle: {
        "color": "#5878fa",
        "font-size": "16px"
      }
    })], 1), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.removeExperimental(index)
        }
      }
    })]), _vm._v(" "), _c('span', [_c('van-stepper', {
      staticClass: "stepper",
      staticStyle: {
        "float": "right",
        "margin-right": "10%"
      },
      attrs: {
        "min": _vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3
      },
      on: {
        "focus": _vm.reSetPageScroll,
        "blur": _vm.reSetPageScroll,
        "overlimit": function($event) {
          _vm.overLimit(_vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3)
        },
        "change": function($event) {
          _vm.handleChangeGroupNum(index, _vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3)
        }
      },
      model: {
        value: (experimental.number),
        callback: function($$v) {
          _vm.$set(experimental, "number", _vm._n($$v))
        },
        expression: "experimental.number"
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.addExperimental()
      }
    }
  }, [_c('span', [_vm._v("增加实验组")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addExperimental()
      }
    }
  })])])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked && !_vm.specialEuTemplateNo().includes(this.currEu)) ? _c('van-cell-group', {
    attrs: {
      "title": "生信分析对照组设置"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.controlGroup), function(controlObject, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0 0 0",
        "text-align": "left"
      }
    }, [_c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controlObject.experimental),
        expression: "controlObject.experimental"
      }],
      staticClass: "select-group",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controlObject, "experimental", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": "0"
      }
    }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.experimentalGroup), function(item, index) {
      return _c('option', {
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
    })], 2), _vm._v(" "), _c('span', [_vm._v("VS")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controlObject.control),
        expression: "controlObject.control"
      }],
      staticClass: "select-group",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controlObject, "control", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.handleChangeExperimentalControl]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": "0"
      }
    }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.experimentalGroup), function(item, index) {
      return _c('option', {
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
    })], 2)]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.removeControlGroup(index)
        }
      }
    })]), _vm._v(" "), _c('span')])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0 15px 0",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.addControlGroup()
      }
    }
  }, [_c('span', [_vm._v("增加分析对照组")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addControlGroup()
      }
    }
  })])])], 2)]) : _vm._e()], 1)])])], 1) : (_vm.stepNo === 1) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.showProcessTech[0].show) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "样本处理"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaRemoveHAProtein), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.sampleProcessing.dictKey === item.dictKey || _vm.sampleProcessTech.ParaRemoveHAProtein[index].dictKey === _vm.showProcessTech[0].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleSampleProcessChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 1) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                          " + _vm._s(item.dictValue) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[1].show) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "建库技术"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaConstructionTech), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.databaseBuildings.dictKey === item.dictKey || _vm.sampleProcessTech.ParaConstructionTech[index].dictKey === _vm.showProcessTech[1].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleDatabaseBuildingChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 6) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                          " + _vm._s(item.dictValue) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[2].show) ? _c('div', [_c('div', [_c('span', {
    staticStyle: {
      "position": "relative",
      "top": "15px",
      "float": "right",
      "right": "20px",
      "font-size": "14px",
      "color": "#5878fa"
    },
    on: {
      "click": _vm.openPdfList
    }
  }, [_vm._v("查看示例报告")]), _vm._v(" "), _c('van-cell-group', {
    attrs: {
      "title": "生信分析"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaBioAnalysis), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.boSignalAnalysis.dictKey === item.dictKey || _vm.sampleProcessTech.ParaBioAnalysis[index].dictKey === _vm.showProcessTech[2].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleBoSignalAnalysisChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 1) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("免费")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                            " + _vm._s(item.dictValue) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currEu === _vm.specialEuTemplateNo(1)) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "选择基因"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.geneSelectionGroup), function(item, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "5%"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.label),
        expression: "item.label"
      }],
      staticStyle: {
        "width": "70%"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (item.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px",
        "padding-top": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.removeGeneSearchResult(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "padding": "20px 0"
    },
    attrs: {
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    }
  }, [_c('span', [_vm._v("添加基因")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    }
  })])])], 2)])], 1) : _vm._e()])]) : (_vm.stepNo === 2) ? _c('div', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleSpec))])], 1)], 1), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("疾病方向")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.diseaseDirectionName))])], 1)], 1), _vm._v(" "), (_vm.productInfo.eu1 !== _vm.specialEuTemplateNo(0)) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本分类")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleCategory.label))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本类型")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleType))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("实验分组及样本数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_vm._l((_vm.experimentalGroup), function(experimental, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(experimental.label))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(experimental.number))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.controlGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("生信分析组" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.experimental.label) + " VS " + _vm._s(item.control.label))])], 1)], 1)
  })], 2)]), _vm._v(" "), ((_vm.currEu !== _vm.specialEuTemplateNo(0) && _vm.currEu !== _vm.specialEuTemplateNo(1))) ? _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("其他参数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(_vm.showProcessTech[0].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本处理")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleProcessing.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[1].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("建库技术")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.databaseBuildings.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[2].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("生信分析")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.boSignalAnalysis.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.geneSelectionGroup.length > 0) ? _c('div', _vm._l((_vm.geneSelectionGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.label))])], 1)], 1)
  }), 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("质量承诺")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.qualityCommitment), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("服务说明")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.serviceComments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.detail) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "90vh",
      "width": "100%",
      "height": "10vh",
      "background": "white"
    }
  }, [(_vm.stepNo < 2) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('van-button', {
    staticClass: "bottom-button",
    staticStyle: {
      "color": "#5878fa",
      "height": "35px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button",
    class: _vm.bizValidateMsg === '' ? 'next-button-active' : 'next-button-inactive',
    attrs: {
      "disabled": _vm.infectionChecked
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "padding": "10px 5px 0 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left",
      "width": "10%"
    },
    on: {
      "click": _vm.jumpToCart
    }
  }, [(_vm.shoppingCartProductNumber !== 0) ? _c('van-badge', {
    staticClass: "badgev",
    staticStyle: {
      "float": "right",
      "margin": "0 2px 0 0",
      "position": "relative",
      "top": "-8px"
    },
    attrs: {
      "content": _vm.shoppingCartProductNumber
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart",
    staticStyle: {
      "width": "28px",
      "height": "28px"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button-small",
    staticStyle: {
      "color": "#5878fa",
      "height": "35px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button-small",
    staticStyle: {
      "background": "#5878fa",
      "color": "white",
      "height": "35px"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px",
      "height": "100vh",
      "overflow": "auto"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.promotion)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.orderList), function(order, index) {
    return _c('div', {
      staticClass: "content-block"
    }, [_c('div', {
      attrs: {
        "id": order.id
      },
      on: {
        "click": function($event) {
          return _vm.goToOrderDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "deep-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("订单编号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      class: _vm.getStatusStyle(order)
    }, [_vm._v("\n        " + _vm._s(_vm.getOrderStatusText(order)))]), _vm._v(" "), _c('i', {
      staticClass: "icon-font emkt-icon-lujing",
      staticStyle: {
        "font-size": "12px"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), (order.balanceType === _vm.emkt.BALANCE_TYPE_RESEARCH_GROUP) ? _c('div', [_c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "deep-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(order.orderPerson))]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("结算账户：" + _vm._s(order.researchGroupName))])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    })]) : _vm._e(), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', [_c('gc-order-product', {
        attrs: {
          "item": item,
          "order": order,
          "show-product-contract-no": _vm.showProductContractNo
        }
      })], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "light-text-color"
    }, [_c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "research-font-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(order.price)))])])]), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px",
        "justify-content": "flex-end",
        "align-items": "flex-start",
        "flex-wrap": "wrap"
      }
    }, [_vm._t("itemButton", null, null, order)], 2)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('modal-register-agreement', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "update:show": function($event) {
        _vm.showModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册协议")])])
}]}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobile),
      expression: "mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "pattern": "[0-9]*",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("旧密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.oldPassword),
      expression: "oldPassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "旧密码"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPassword),
      expression: "newPassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认新密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPasswordRe),
      expression: "newPasswordRe",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "重复新密码"
    },
    domProps: {
      "value": (_vm.newPasswordRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPasswordRe = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("修改密码")])])
}]}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("注册联系人")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box_1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerName),
      expression: "registerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.registerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerMobile),
      expression: "registerMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.registerMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerMobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerEmail),
      expression: "registerEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_email",
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.enterprise.enterpriseName),
      expression: "enterprise.enterpriseName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "readonly": "readonly",
      "unselectable": "on",
      "id": "search_enterpriseName",
      "type": "text",
      "placeholder": "请选择单位"
    },
    domProps: {
      "value": (_vm.enterprise.enterpriseName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enterprise, "enterpriseName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "block_2"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_agree",
      "value": ""
    },
    domProps: {
      "checked": _vm.agreeStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    on: {
      "click": function($event) {
        _vm.agreeStatus = !_vm.agreeStatus
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), (_vm.agreeStatus) ? _c('span', {
    staticClass: "agreement research-font-color"
  }, [_vm._v("已阅读并同意")]) : _c('span', {
    staticClass: "desc"
  }, [_vm._v("已阅读并同意")])])]), _vm._v(" "), _c('u', {
    staticClass: "agreement research-font-color",
    on: {
      "click": _vm.toggleResearchGroupRemindBox
    }
  }, [_vm._v("《吉凯基因淘基因用户注册协议》")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    staticClass: "addMember"
  }, [_vm._v("注册")])])])]), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFirstLevelEnterpriseBox) ? _c('FirstLevelEnterpriseBox', {
    on: {
      "toggleShow": _vm.toggleShowFirstLevelEnterpriseBox,
      "update": _vm.updateFirstLevelEnterprise
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDepartmentBox) ? _c('DepartmentBox', {
    attrs: {
      "enterpriseNo": _vm.enterprise.enterpriseNo
    },
    on: {
      "toggleShow": _vm.toggleShowDepartmentBox,
      "update": _vm.updateDepartment
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity_container"
  }, [_c('div', {
    staticClass: "hd activity-background-color"
  }, [_c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("援鄂医生认证")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLogin),
      expression: "hasLogin"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-background"
  }, [_c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "0"
    }
  }), _vm._v(" "), (_vm.stage !== 1) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 || _vm.stage === 4) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "25vw"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50vw"
    }
  }, [_c('div', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-ball",
    staticStyle: {
      "left": "23.5vw"
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.stage === 1) ? _c('div', {
    staticClass: "personal-detail"
  }, [(_vm.hasLogin) ? _c('div', {
    staticClass: "main-upload-container",
    staticStyle: {
      "height": "156px",
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.customerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.mobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-cell"
  }, [_c('div', {
    staticClass: "cell-outer"
  }, [_c('span', {
    staticClass: "attr-key"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr-value"
  }, [_vm._v(_vm._s(_vm.enterpriseName))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.goToNextStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("下一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 2) ? _c('div', {
    staticClass: "upload-identification"
  }, [_c('div', {
    staticClass: "main-upload-container",
    style: ('height: 206px;background-image:url(' + _vm.url + ');background-repeat:no-repeat;background-size:100% 100%;')
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('iframe', {
    staticClass: "identity-icon",
    style: (_vm.ifShowIcon),
    attrs: {
      "src": "/static/img/identification.svg"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": ".5px",
      "opacity": "0"
    },
    attrs: {
      "type": "file",
      "id": "imgFile"
    },
    on: {
      "change": function($event) {
        return _vm.changeImagePositive($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "add-icon",
    attrs: {
      "for": "imgFile"
    }
  })]), _vm._v(" "), (!_vm.url) ? _c('span', {
    staticClass: "upload-identification-instruction"
  }, [_vm._v("请上传您的工作证/学生证/身份证")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "remind-info"
  }, [_vm._v("注：由于微信浏览器的限制，部分机型可能出现无法上传照片的情况，请尝试点击右上角按钮，在其他浏览器中打开完成认证（需要重新登录）")]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-up",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.goToLastStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回上一步")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "45%"
    },
    on: {
      "click": function($event) {
        return _vm.goToNextStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("下一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 && _vm.showSearchContact === false) ? _c('div', {
    staticClass: "choose-discount-owner"
  }, [_c('div', {
    staticClass: "choose-owner",
    on: {
      "click": function($event) {
        return _vm.uploadIdentification(_vm.customerName, _vm.mobile)
      }
    }
  }, [_c('span', {
    staticClass: "discount-for"
  }, [_vm._v("折扣券自用")]), _vm._v(" "), _c('svg', {
    staticClass: "choose-icon",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "data-v-c24bfab2": "",
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "choose-owner",
    on: {
      "click": function($event) {
        return _vm.toggleShowSearchContact()
      }
    }
  }, [_c('span', {
    staticClass: "discount-for",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v("折扣券转赠")]), _vm._v(" "), _c('svg', {
    staticClass: "choose-icon",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "data-v-c24bfab2": "",
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.goToLastStep()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回上一步")])])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('div', {
    staticClass: "finish-process"
  }, [_c('span', {
    staticClass: "first-line"
  }, [_vm._v("您已经成功完成认证")]), _vm._v(" "), _c('span', {
    staticClass: "second-line"
  }, [_vm._v("奖励将在3-5个工作日内发送完毕")]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap activity-background-color",
    staticStyle: {
      "width": "87%",
      "margin-top": "6.93vw"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("返回主页")])])]) : _vm._e(), _vm._v(" "), (_vm.stage === 3 && _vm.showSearchContact) ? _c('search-contact', {
    on: {
      "finish": _vm.uploadIdentification,
      "toggleShow": function($event) {
        return _vm.toggleShowSearchContact()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-stage"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("信息确认")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("上传工牌")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("自用或转赠")]), _vm._v(" "), _c('span', {
    staticClass: "progress-text"
  }, [_vm._v("完成认证")])])
}]}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabs', {
    attrs: {
      "color": "#fff",
      "border": true,
      "title-active-color": "#5878FA",
      "title-inactive-color": "#979797",
      "sticky": ""
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "产品介绍"
    }
  }, _vm._l((_vm.src), function(item, index) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item,
        "alt": "产品介绍"
      }
    })
  }), 0), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "质量承诺"
    }
  }, [_c('static-doc')], 1), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "产品手册"
    }
  }, [_c('pdf-list', {
    attrs: {
      "type": 1
    }
  })], 1), _vm._v(" "), _c('van-tab', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "用户评论"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("用户评论暂未开放")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-list-with-acitons', {
    attrs: {
      "orderList": _vm.orderList,
      "show-product-contract-no": false
    },
    on: {
      "goToOrderDetail": _vm.toDetailInfo,
      "downloadOrderText": _vm.handleDownloadOrderText
    },
    scopedSlots: _vm._u([{
      key: "itemButton",
      fn: function(order) {
        return [(_vm.showCancelButton(order)) ? _c('div', {
          staticClass: "return-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.$emit('cancelOrder', order)
            }
          }
        }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitOrderButton(order)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('submitOrder', order)
            }
          }
        }, [_vm._v("提交订单")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitToSignOrderButton(order)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('submitOrderToSign', order)
            }
          }
        }, [_vm._v("签署合同\n      ")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("编辑收货地址")])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "phoneNumber",
      "placeholder": "Phone Number"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "password",
      "placeholder": "area"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-gender"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('select', [_c('option', [_vm._v("Male")]), _vm._v(" "), _c('option', [_vm._v("Female")])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Birthday")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "date",
      "placeholder": "Birth day",
      "value": "2014-04-30"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-toggle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Switch")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Textarea")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Submit")])])])])])
}]}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "order-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "line-height": "34px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("总计:")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "18px",
      "margin-right": "5px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.totalMoney)))])]), _vm._v(" "), (_vm.showButton) ? _c('div', {
    staticClass: "pay-btn research-background-color",
    on: {
      "click": _vm.response
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _c('div', {
    staticClass: "pay-btn",
    staticStyle: {
      "background-color": "gainsboro"
    }
  }, [_vm._v(_vm._s(_vm.buttonName))])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [(_vm.showInvoiceBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToInvoice')
      }
    }
  }, [_vm._v("开票信息")]) : _vm._e(), _vm._v(" "), (_vm.showCustomerGoodsBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToCustomerGoods')
      }
    }
  }, [_vm._v("实物信息")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchList) ? _c('div', _vm._l((_vm.merchList), function(merch) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v(_vm._s(merch.merchandiseLabel))]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "list-block media-list"
    }, [_c('ul', [_c('li', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('img', {
      attrs: {
        "src": _vm.baseurl + merch.merchandiseIcon,
        "width": "44"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticStyle: {
        "border": "#2ac845",
        "padding-bottom": ".5rem"
      }
    }, [_vm._l((merch._subTitleList), function(subTitle) {
      return (merch._subTitleList && merch._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "white",
          "padding": "0.1rem"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": ".7rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((merch._abstractList), function(abstractTitle) {
      return (merch._abstractList && merch._abstractList.length > 0) ? _c('span', {
        staticStyle: {
          "font-size": ".7rem",
          "color": "black"
        }
      }, [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l((merch._titleList), function(title) {
      return (merch._titleList && merch._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "1rem",
          "color": "#3F3F3F",
          "padding": "0.2rem 0 0.2rem 0",
          "font-weight": "bold"
        }
      }, [(title.valueText !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()]) : _vm._e()
    })], 2)])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.response(merch)
        }
      }
    }, [_vm._v(_vm._s(_vm.buttonName2))]), _vm._v(" "), _c('span', {
      staticClass: "goToComment",
      staticStyle: {
        "color": "#0a8ddf"
      },
      on: {
        "click": function($event) {
          return _vm.goToComment(merch)
        }
      }
    }, [_vm._v(_vm._s(_vm.buttonName1))])])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/时间.svg",
      "data-src": "/static/img/时间.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    " + _vm._s((_vm.orderStatus === _vm.emkt.ORDER_STATUS_CHECK || _vm.orderStatus === _vm.emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT) ? '订单已提交技术审核' : '订单已提交课题组审批人审批') + "\n  ")]), _vm._v(" "), (_vm.orderStatus === _vm.emkt.ORDER_STATUS_CHECK || _vm.orderStatus === _vm.emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT) ? _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n    技术审核预计在"), (new Date().getHours() >= 17 && new Date().getMinutes() >= 30) ? _c('span', [_vm._v("明天")]) : _vm._e(), _vm._v("17:30完成\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.revert
    }
  }, [_c('span', [_vm._v("\n      返回主页\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "submain-c",
    on: {
      "click": _vm.gotoOrderList
    }
  }, [_c('span', [_vm._v("\n      查看订单\n    ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机或邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('account')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "account",
      "placeholder": "帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "veriCode",
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('veriCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('newPassword')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPassword),
      expression: "newPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "newPassword",
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('confirmPassword')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPassword),
      expression: "confirmPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "confirmPassword",
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.type === 'phone') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("发送邮件")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("忘记密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-right panel-cover panel",
    attrs: {
      "id": "panel-right-demo"
    }
  }, [_c('div', {
    staticClass: "content-block top",
    staticStyle: {
      "padding": "0.6rem"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.6rem",
      "border-bottom": "1px solid"
    }
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    }
  }, [_vm._v(_vm._s(_vm.queryTotal.total))]), _vm._v("条结果")]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "-0.3rem"
    }
  }, [_vm._v("产品类别")]), _vm._v(" "), _c('div', {
    staticClass: "list-block bottom"
  }, [_c('ul', {
    staticClass: "border-bottom"
  }, [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categorySelected),
      expression: "categorySelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categorySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "",
      "selected": ""
    }
  }, [_vm._v("请选择 ▼")]), _vm._v(" "), (_vm.currentCategory) ? _c('option', [_c('span', {
    staticStyle: {
      "font-size": "0.7rem"
    }
  }, [_vm._v(_vm._s(this.$route.query.label))])]) : _vm._e()])])])])])]), _vm._v(" "), _vm._l((_vm.selection), function(item) {
    return _c('div', [_c('div', {
      staticClass: "content-block-title top"
    }, [_vm._v(_vm._s(item.attributeName))]), _vm._v(" "), _c('div', {
      staticClass: "list-block bottom"
    }, [_c('ul', {
      staticClass: "border-bottom"
    }, [_c('li', {
      staticClass: "item-content list"
    }, _vm._l((item.filterItems), function(val, inx) {
      return (inx < 3) ? _c('label', {
        staticClass: "label-checkbox label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemSel),
          expression: "itemSel"
        }],
        attrs: {
          "type": "checkbox",
          "name": "my-checkbox"
        },
        domProps: {
          "value": val,
          "checked": Array.isArray(_vm.itemSel) ? _vm._i(_vm.itemSel, val) > -1 : (_vm.itemSel)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.itemSel,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = val,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.itemSel = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.itemSel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.itemSel = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media checkbox-text",
        class: {
          select: _vm.itemSel.includes(val)
        }
      }, [_c('div', {
        staticClass: "span-text"
      }, [_vm._v(_vm._s(val.dictValue))])])]) : _vm._e()
    }), 0), _vm._v(" "), (item.filterItems.length > 3) ? _c('li', {
      staticClass: "item-content list"
    }, _vm._l((item.filterItems.slice(3)), function(val, inx) {
      return (inx < 3) ? _c('label', {
        staticClass: "label-checkbox label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemSel),
          expression: "itemSel"
        }],
        attrs: {
          "type": "checkbox",
          "name": "my-checkbox"
        },
        domProps: {
          "value": val,
          "checked": Array.isArray(_vm.itemSel) ? _vm._i(_vm.itemSel, val) > -1 : (_vm.itemSel)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.itemSel,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = val,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.itemSel = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.itemSel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.itemSel = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media checkbox-text",
        class: {
          select: _vm.itemSel.includes(val)
        }
      }, [_c('div', {
        staticClass: "span-text"
      }, [_vm._v(_vm._s(val.dictValue))])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (item.filterItems.length > 6) ? _c('li', {
      staticClass: "item-content list"
    }, _vm._l((item.filterItems.slice(6)), function(val, inx) {
      return (inx < 3) ? _c('label', {
        staticClass: "label-checkbox label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemSel),
          expression: "itemSel"
        }],
        attrs: {
          "type": "checkbox",
          "name": "my-checkbox"
        },
        domProps: {
          "value": val,
          "checked": Array.isArray(_vm.itemSel) ? _vm._i(_vm.itemSel, val) > -1 : (_vm.itemSel)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.itemSel,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = val,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.itemSel = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.itemSel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.itemSel = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media checkbox-text",
        class: {
          select: _vm.itemSel.includes(val)
        }
      }, [_c('div', {
        staticClass: "span-text"
      }, [_vm._v(_vm._s(val.dictValue))])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (item.filterItems.length > 9) ? _c('li', {
      staticClass: "item-content list"
    }, _vm._l((item.filterItems.slice(9)), function(val, inx) {
      return (inx < 3) ? _c('label', {
        staticClass: "label-checkbox label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemSel),
          expression: "itemSel"
        }],
        attrs: {
          "type": "checkbox",
          "name": "my-checkbox"
        },
        domProps: {
          "value": val,
          "checked": Array.isArray(_vm.itemSel) ? _vm._i(_vm.itemSel, val) > -1 : (_vm.itemSel)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.itemSel,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = val,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.itemSel = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.itemSel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.itemSel = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media checkbox-text",
        class: {
          select: _vm.itemSel.includes(val)
        }
      }, [_c('div', {
        staticClass: "span-text"
      }, [_vm._v(_vm._s(val.dictValue))])])]) : _vm._e()
    }), 0) : _vm._e()])])])
  })], 2), _vm._v(" "), _c('nav', {
    staticClass: "bar bar-tab",
    staticStyle: {
      "bottom": "auto"
    }
  }, [_c('a', {
    staticClass: "tab-item active",
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "tab-label"
  }, [_vm._v("重置")])]), _vm._v(" "), _c('a', {
    staticClass: "tab-item close-panel",
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [_c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.clickConfirm
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-key-words/bg.png"
    }
  }, [_c('img', {
    staticClass: "main-title ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-key-words/5.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips-c"
  }, [_vm._v(" 点此生成您下半年的科研关键词")]), _vm._v(" "), _c('img', {
    staticClass: "brand-area ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-key-words/button.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-coupon/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [(_vm.data.registrationDateYear > 0) ? _c('span', [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.registrationDateYear) + "年")]), _vm._v("以来"), _c('br')]) : _vm._e(), _vm._v("\n    感谢您一路的支持"), _c('br'), _vm._v("\n    送您一张"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.discountMoney || 99) + "元")]), _vm._v("定制病毒无门槛优惠券"), _c('br'), _vm._v("\n    可叠加二十二周年活动折扣使用\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-coupon/shape1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-image-coupon ani",
    staticStyle: {
      "background": "url(/static/img/anniversary/page-coupon/coupon.png)",
      "background-size": "cover"
    },
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "main-image-coupon-inner"
  }, [_c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.data.discountMoney || 99))])])])])
},staticRenderFns: []}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [(_vm.description !== 'group') ? _c('h4', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), (_vm.showFilterBarFlag) ? _c('div', {
    staticClass: "nav-div"
  }, [_c('nav', {
    staticClass: "bar bar-nav merbar"
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.queryTotal.total))]), _vm._v("条结果")]), _vm._v(" "), (!_vm.showFilterBarForKit) ? _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    on: {
      "click": function($event) {
        return _vm.openshaxuan()
      }
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (this.$route.query.id === 5 || this.$route.query.id === 8 || this.$route.query.id === 7 || this.$route.query.id === 9 || this.$route.name === 'searchresults') ? _c('div', {
    staticStyle: {
      "height": "2.2rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.merchs), function(pro, index) {
    return _c('div', {
      staticClass: "merchsdiv"
    }, [(_vm.description === 'group') ? _c('div', [_c('div', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                ¥" + _vm._s(pro.priceMax) + "\n                "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]) : _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                ¥" + _vm._s(pro.priceMin) + "\n                "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v("\n                      " + _vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, _vm._l((pro._specificatList), function(specificat) {
      return (pro._specificatList && pro._specificatList.length > 0) ? _c('span', {
        staticStyle: {
          "margin-left": "3px",
          "font-size": "small",
          "color": "#4479B4"
        }
      }, [_vm._v(_vm._s(specificat.label) + ": " + _vm._s(specificat.valueText))]) : _vm._e()
    }), 0), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#003d8e"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _c('div', [(!pro.composite) ? _c('div', [_c('div', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMax) + "\n                  "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]) : _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMin) + "\n                  "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), (subTitle.valueText.length > 15) ? _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _vm._e(), _vm._v(" "), (subTitle.valueText.length <= 15) ? _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v("\n                      " + _vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#003d8e"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _vm._e(), _vm._v(" "), (pro.composite) ? _c('div', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.setdatas(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(pro.priceMin !== pro.priceMax) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMin) + " ~ ¥" + _vm._s(pro.priceMax) + "\n                ")]) : _c('div', {
      staticClass: "merchsprice"
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', [_vm._v("\n                      ¥" + _vm._s(pro.priceMax) + "\n                  ")]) : _c('span', [_vm._v("\n                      ¥" + _vm._s(pro.priceMin) + "\n                  ")])]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].type !== 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "result-gene"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "data-popup": ".popup-gene-only",
      "type": "search",
      "id": "result-gene",
      "placeholder": "查询基因...",
      "readonly": "",
      "unselectable": "on"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link button active",
    attrs: {
      "href": "#tab-detail"
    }
  }, [_vm._v("Detail")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-comments"
    }
  }, [_vm._v("Comments(123)")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('h3', [_vm._v("真正")]), _vm._v(" "), _c('p', [_vm._v("只有当你接触到床的那一刻，才会被前所未有的柔软打动。天丝般的爽滑质感，完美的设计，漂亮的色彩搭配。")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "//img.alicdn.com/imgextra/i4/238126515/TB25x8rdXXXXXaWXXXXXXXXXXXX_!!238126515.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("活性色彩，我的正能量")]), _vm._v(" "), _c('p', [_vm._v("活性印刷，生活不在一成不变，跟上时代的脚步。A版大花纹，古典大气，民族的就是最美。零压力的舒适感，让人完美享受美好的床上时光。")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "//img.alicdn.com/imgextra/i3/238126515/TB2ht8qdXXXXXbmXXXXXXXXXXXX_!!238126515.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "http://gqianniu.alicdn.com/bao/uploaded/i4//tfscom/i3/TB10LfcHFXXXXXKXpXXXXXXXXXX_!!0-item_pic.jpg_250x250q60.jpg",
      "width": "44"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("张**三")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("12/12 13:11")])]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v("聚划算买的，只要888，料子很舒服。")])])])])])])])])])])
}]}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.needSlove) ? _c('div', [_vm._l((_vm.solution.children), function(orderItem, indexs) {
    return _c('div', [_c('div', {
      staticClass: "product-detail",
      on: {
        "click": function($event) {
          return _vm.gotoDetail(orderItem, orderItem.id)
        }
      }
    }, [_c('img', {
      staticClass: "product-label",
      attrs: {
        "src": _vm.markImg
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [_c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl
      }
    }), _vm._v(" "), (orderItem.template.name) ? _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('span', [_vm._v("\n                   " + _vm._s(orderItem.template.externalName) + "\n                ")])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font"
    }, [_vm._v("\n                " + _vm._s(orderItem.briefInfoDetail) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font"
    }, [_vm._v("\n                " + _vm._s(_vm.getRightPu(orderItem.children) !== null ? _vm.getRightPu(orderItem.children).template ? _vm.getRightPu(orderItem.children).template.name : '' : '') + "\n              ")])]) : _c('div', {
      staticClass: "item-detail"
    }, [_vm._m(0, true)])])]), _vm._v(" "), _c('div', {
      staticClass: "price-info"
    }, [(orderItem.standardPrice !== orderItem.formalQuotePrice) ? _c('span', {
      staticClass: "light-text-color tiny-font",
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(orderItem.standardPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "research-font-color bold-text"
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(orderItem.formalQuotePrice)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])])
  }), _vm._v(" "), (this.solution.standardPrice !== this.solution.formalQuotePrice) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solution.standardPrice)))]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solution.formalQuotePrice)))])])]) : _vm._e(), _vm._v(" "), (!this.$parent.$parent.useDiscountCouponOnly && _vm.orderCouponsValue) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderCouponsValue)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.order.length) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.order.totalPrice)))])])])], 2) : _c('div', [_vm._l((_vm.order), function(orderItem, indexs) {
    return _c('div', _vm._l((orderItem.allData.boSolution.children), function(merchandise, index) {
      return _c('div', {
        staticClass: "product-detail",
        on: {
          "click": function($event) {
            return _vm.gotoDetail(orderItem)
          }
        }
      }, [_c('img', {
        staticClass: "product-label",
        attrs: {
          "src": _vm.markImg
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "padding-top": "10px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [_c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl
        }
      }), _vm._v(" "), (merchandise.template.name) ? _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('span', [_vm._v("\n                   " + _vm._s(merchandise.template.name) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font"
      }, [_vm._v("\n                " + _vm._s(orderItem.userLabel) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font"
      }, [_vm._v("\n                " + _vm._s(orderItem.boSignalAnalysis) + "\n              ")])]) : _c('div', {
        staticClass: "item-detail"
      }, [_vm._m(1, true)])])]), _vm._v(" "), _c('div', {
        staticClass: "price-info"
      }, [(merchandise.standardPrice !== merchandise.formalQuotePrice) ? _c('span', {
        staticClass: "light-text-color tiny-font",
        staticStyle: {
          "text-decoration": "line-through"
        }
      }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.standardPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "research-font-color bold-text"
      }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.formalQuotePrice)))])]), _vm._v(" "), _c('div', {
        staticClass: "split-line"
      })])
    }), 0)
  }), _vm._v(" "), (this.solutionPrice.standardPrice !== this.solutionPrice.formalQuotePrice) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.standardPrice)))]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.formalQuotePrice)))])])]) : _vm._e(), _vm._v(" "), (!this.$parent.$parent.useDiscountCouponOnly && _vm.$parent.$parent.couponDiscount) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.$parent.$parent.couponDiscount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.order.length) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.formalQuotePrice)))])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', [_vm._v("\n                   实物返还\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', [_vm._v("\n                   实物返还\n                ")])])
}]}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品详细")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px"
    }
  }, _vm._l((_vm.orderList), function(order) {
    return _c('div', {
      staticClass: "list-block media-list"
    }, [_c('ul', [_c('li', [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'goods'
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('img', {
      staticStyle: {
        "width": "4rem"
      },
      attrs: {
        "src": "/emktResources/resocurces/img/gene.jpg"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', [_vm._v(_vm._s(order.merchandiseLabel))])]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#d94b73"
      }
    }, [_vm._v("¥" + _vm._s(order.priceMax))]) : _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#d94b73"
      }
    }, [_vm._v("¥" + _vm._s(order.priceMin))]), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_vm._v("合计" + _vm._s(order.productQuantity) + "个产品")])])])], 1)])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-text-only",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2.5rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("\n   填写说明:\n   "), _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.custRemark))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".7rem",
      "margin-top": "20px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.custRemark1) + "\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data),
      expression: "data"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "必填"
    },
    domProps: {
      "value": (_vm.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "margin-top": "15px",
      "text-align": "center",
      "color": "white"
    }
  }, [_c('button', {
    class: {
      'close-popup': _vm.popupTrue
    },
    staticStyle: {
      "background-color": "#0a8ddf"
    },
    on: {
      "click": _vm.checkData
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('div', {
    staticClass: "button button-link button-nav pull-right close-popup"
  }, [_c('span', {
    staticClass: "icon icon-down close-popup"
  }, [_vm._v("取消")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('div', [_vm._v("备注填写")])])])
}]}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    class: [(_vm.m_column === -1) ? 'choose-col' : 'nochoose-col'],
    on: {
      "click": function($event) {
        return _vm.chooseMember(-1)
      }
    }
  }, [_c('span', {
    class: [(_vm.m_column === -1) ? 'tag' : 'tag_2'],
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("全部成员")])]), _vm._v(" "), _vm._l((_vm.memberList), function(member, i) {
    return _c('div', {
      staticClass: "col2",
      class: [(_vm.m_column === i) ? 'choose-col' : 'nochoose-col'],
      on: {
        "click": function($event) {
          return _vm.chooseMember(i)
        }
      }
    }, [_c('span', {
      class: [(_vm.m_column === i) ? 'tag' : 'tag_2'],
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(member))])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    staticStyle: {
      "height": "5rem",
      "display": "block",
      "margin-top": "45%",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/logo2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.goWapp
    }
  }, [_vm._v("进入小程序")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.7vw"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 2),
      expression: "orderStatus===1||orderStatus===2"
    }]
  }, _vm._l((_vm.orderList.waitApprovedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(1, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_red"
    }, [_vm._v("\n            未审批\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 3),
      expression: "orderStatus===1||orderStatus===3"
    }]
  }, _vm._l((_vm.orderList.executedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(2, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_orange"
    }, [_vm._v("\n            执行中\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderStatus === 1 || _vm.orderStatus === 4),
      expression: "orderStatus===1||orderStatus===4"
    }]
  }, _vm._l((_vm.orderList.finishedOrderList), function(order, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.chooseStatus === 1 || (_vm.chooseStatus === 2 && _vm.chooseMemberName === order.orderPerson)),
        expression: "chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"
      }],
      staticClass: "row1",
      on: {
        "click": function($event) {
          return _vm.toDetailInfo(2, order)
        }
      }
    }, [_c('div', {
      staticClass: "container_9"
    }, [_c('span', {
      staticClass: "info_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('div', {
      staticClass: "color_2 color_greeen"
    }, [_vm._v("\n            已完成\n          ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "data-v-c24bfab2": "",
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "15",
        "height": "15"
      }
    }, [_c('path', {
      attrs: {
        "data-v-c24bfab2": "",
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "div_4"
    }), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding": "0 15px"
        }
      }, [(order.fromEmkt) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.serviceUrl
        }
      }), _vm._v(" "), (item.categoryId) ? _c('div', {
        staticClass: "item-detail"
      }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, _vm._l((item._titleList), function(title) {
        return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._subTitleList), function(subTitle, index) {
        return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
      }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, _vm._l((item._abstractList), function(abstractTitle, index) {
        return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
      }), 0) : _vm._e()]) : _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color small-font"
      }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [(item.merchandiseIcon) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + item.merchandiseIcon
        }
      }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color text-overflow-hidden",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
        staticClass: "light-text-color tiny-font text-overflow-hidden"
      }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color"
      }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "height": "80px"
        }
      }, [_vm._m(2, true), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "empty_2"
    }), _vm._v(" "), _c('div', {
      staticClass: "container_6"
    }, [_c('span', {
      staticClass: "text_5",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "moneyWrap"
    }, [_c('span', {
      staticClass: "word_4",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "text_6",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "money",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(order.price)))])])])], 2)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
}]}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-block meta-list",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('ul', _vm._l((_vm.orderList), function(order, index) {
    return _c('li', [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("生成时间：" + _vm._s(order.OrderDate))]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner"
    }, [_vm._v(_vm._s(order.TotalAmount))]), _vm._v(" "), _c('div', {
      staticClass: "card-content-inner"
    }, [_vm._v(_vm._s(order.AddressName))]), _vm._v(" "), _c('div', {
      staticClass: "card-content-inner"
    }, [_vm._v(_vm._s(order.AddressName))]), _vm._v(" "), _c('div', {
      staticClass: "card-content-inner"
    }, [_vm._v(_vm._s(order.AddressName))]), _vm._v(" "), _c('div', {
      staticClass: "card-content-inner"
    }, [_vm._v(_vm._s(order.AddressName))])])])
  }), 0)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'orderPayConfirm'
      }
    }
  }, [_vm._v("确认下单")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-step"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_vm._v("地址确认")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_vm._v("产品信息")]), _vm._v(" "), _c('li', {
    staticClass: "cur"
  }, [_vm._v("支付方式")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("支付方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "15px"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content item-link"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("发票")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("电子发票")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "15px"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content item-link"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("优惠")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("无优惠")])])])])])
}]}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isResearchGroup && !_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组管理")])]), _vm._v(" "), (_vm.hasLogin && _vm.displayChosenResearchGroup && _vm.displayChosenResearchGroup.researchGroupName) ? _c('div', {
    staticClass: "box_2"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('object', {
    staticClass: "blue-layer",
    attrs: {
      "data": '/static/img/svg/首页蓝色背景.svg',
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avator",
    attrs: {
      "src": "/static/img/avator.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "luWei"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [(_vm.displayChosenResearchGroup.leaderNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("课题组组长")])]) : _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("课题组成员")])]), _vm._v(" "), (_vm.displayChosenResearchGroup.approverNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("审批人")])]) : _vm._e(), _vm._v(" "), (_vm.displayChosenResearchGroup.accountCustomerNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("对账人")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "outer2"
  }, [(_vm.displayChosenResearchGroup.approveType === _vm.approveTypeNone) ? _c('div', {
    staticClass: "tagWrap_none"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.displayChosenResearchGroup.approveType]))])]) : (_vm.displayChosenResearchGroup.approveType === _vm.approveTypeThreshold) ? _c('div', [(_vm.displayChosenResearchGroup.approveThreshold) ? _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("单笔订单限额￥" + _vm._s(_vm.displayChosenResearchGroup.approveThreshold))])]) : _vm._e(), _vm._v(" "), (_vm.displayChosenResearchGroup.monthlyLimit) ? _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("单月累积限额￥" + _vm._s(_vm.displayChosenResearchGroup.monthlyLimit))])]) : _vm._e()]) : _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.displayChosenResearchGroup.approveType]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "group_detail"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName))]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupNo))])]), _vm._v(" "), _c('div', {
    staticClass: "block_2",
    on: {
      "click": _vm.toggleShowChooseBox
    }
  }, [_c('svg', {
    staticClass: "icon iconzhuanrang",
    attrs: {
      "width": "4vw",
      "height": "4vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M99.119848 428.002088h828.014506a43.350032 43.350032 0 0 0 43.350032-43.350031 43.248882 43.248882 0 0 0-16.451337-33.957525 43.465632 43.465632 0 0 0-9.219107-8.756707L635.50424 124.869766a43.350032 43.350032 0 1 0-49.809186 70.964002l207.270952 145.461032H99.119848a43.350032 43.350032 0 0 0 0 86.707288zM927.134354 601.07709H99.119848a43.350032 43.350032 0 0 0-43.350032 43.350032 43.205532 43.205532 0 0 0 16.451337 33.9503c2.564877 3.272927 5.635504 6.242405 9.219107 8.756706l309.309701 217.075284a43.313907 43.313907 0 0 0 60.386594-10.584632 43.350032 43.350032 0 0 0-10.577407-60.386595L233.288196 687.777154h693.846158a43.350032 43.350032 0 0 0 0-86.700064z",
      "fill": "#929292"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "switchingResearchGroup"
  }, [_vm._v("切换课题组")])])]), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.firstLevelEnterpriseName))]), _vm._v(" "), _c('div', {
    staticClass: "group_2"
  }, [_c('span', {
    staticClass: "character"
  }, [_vm._v("组长："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.leaderName))])]), _vm._v(" "), _c('span', {
    staticClass: "character"
  }, [_vm._v("审批人："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.approverName))])]), _vm._v(" "), _c('span', {
    staticClass: "character"
  }, [_vm._v("对账人："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.accountCustomerName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [(_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "info_8",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("课题组订单")]), _vm._v(" "), _c('div', {
    staticClass: "block_7",
    on: {
      "click": function($event) {
        return _vm.toOrder(1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14px",
      "height": "15px",
      "viewBox": "0 0 14 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("订单备份 2")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-247.000000, -426.000000)",
      "fill": "#979797",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-3#group#",
      "transform": "translate(236.000000, 419.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "订单备份-2",
      "transform": "translate(11.000000, 7.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.27230273,15 L2.27230273,15 C1.01805605,14.9984262 0.00171999101,14.0668211 0,12.9171431 L0,2.08285318 L0,2.08291935 C0.00167718208,0.933241334 1.01798443,0.00160772079 2.27223452,0 L11.7276972,0 L11.7276973,0 C12.981944,0.00157386508 13.99828,0.933178898 14,2.08285691 L14,12.9157108 L14,12.9156447 C13.9983228,14.0653227 12.9820156,14.9969563 11.7277655,14.998564 L2.27230273,15 Z M2.27230273,0.917146346 L2.27230279,0.917146346 C1.56943517,0.917933451 0.999860992,1.44002085 0.999002708,2.0842892 L0.999002708,12.9171431 L0.999002708,12.9171131 C0.99984338,13.5613814 1.56940107,14.0834817 2.27227039,14.0842856 L11.7277331,14.0842856 L11.7277331,14.0842856 C12.4306007,14.0834985 13.0001748,13.5614111 13.0010659,12.9171427 L13.0010659,2.08285282 L13.0010659,2.08288286 C13.0002252,1.43861451 12.4306675,0.916514206 11.7277982,0.915710346 L2.27230273,0.917146346 Z",
      "id": "形状"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.59076309,6.9356706 L3.59076312,6.9356706 C3.30111122,6.94909507 3.05318119,6.76522655 3.03699665,6.52498819 C3.02081095,6.28474983 3.24249855,6.07911575 3.53215045,6.06569222 C3.55167311,6.06478741 3.57124135,6.06478741 3.59076401,6.06569222 L11.4454007,6.06569222 L11.4454007,6.06569222 C11.7350526,6.05226776 11.9829826,6.23613627 11.9991672,6.47637463 C12.0153529,6.71661299 11.7936653,6.92224708 11.5040134,6.9356706 C11.4844907,6.93657541 11.4649225,6.93657541 11.4453998,6.9356706 L3.59076309,6.9356706 Z M3.59076309,8.99321262 L3.59076313,8.99321262 C3.30291885,9.02318376 3.04028113,8.8539443 3.0041466,8.61520519 C2.96801083,8.37646607 3.17206038,8.15863337 3.45990466,8.12866326 C3.50335388,8.12413918 3.5473148,8.12413918 3.59076402,8.12866325 L8.94991953,8.12866325 L8.9499195,8.12866325 C9.24002196,8.12866324 9.47519852,8.32371808 9.47519852,8.56433163 C9.47519852,8.80494369 9.24002375,9 8.9499195,9 L3.59076309,8.99321262 Z M3.59076309,4.87133675 L3.59076307,4.87133675 C3.30066061,4.87133675 3.06548405,4.67628192 3.06548405,4.43566837 C3.06548405,4.19505631 3.30065882,4 3.59076307,4 L11.4453998,4 L11.4453998,4 C11.7355022,4 11.9706788,4.19505483 11.9706788,4.43566837 C11.9706788,4.67628043 11.735504,4.87133675 11.4453998,4.87133675 L3.59076309,4.87133675 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('span', {
    staticClass: "text_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("全部订单")])])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_8"
  }, [_c('div', {
    staticClass: "group_7",
    on: {
      "click": function($event) {
        return _vm.toOrder(2)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "35px",
      "height": "31px",
      "viewBox": "0 0 35 31",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("daifukuan备份 2#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-63.000000, -472.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "daifukuan备份-2#merge#",
      "transform": "translate(63.000000, 472.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.84192864,7.27272727 L28.0786574,6.28335089 L30.5319149,6.28335089 L28.5596029,2.16652355 C27.8814262,0.508238737 25.9899977,-0.364382716 24.1782083,0.14459579 L3.72340426,6.28335089 L5.84192864,7.27272727 L5.84192864,7.27272727 Z",
      "id": "路径",
      "fill": "#333333"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.853125,5.54545455 C32.695625,5.54545455 35,7.7369697 35,10.4406061 L35,14.029697 L27.75375,14.030303 C25.36375,14.030303 23.408125,15.8375758 23.335625,18.0878788 L23.333125,18.2345455 C23.333125,20.5072727 25.233125,22.3672727 27.6,22.4357576 L27.75375,22.4381818 L35,22.4381818 L35,26.1048485 C35,28.8078788 32.695625,31 29.853125,31 L5.146875,31 C2.304375,31 0,28.8084848 0,26.1048485 L0,10.4406061 C0,7.73757576 2.304375,5.54545455 5.146875,5.54545455 L29.853125,5.54545455 Z",
      "id": "路径",
      "fill": "#5878FA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.5744681,18.2727273 C24.5744681,19.678543 25.7413855,20.8181818 27.1808511,20.8181818 C28.6203166,20.8181818 29.787234,19.678543 29.787234,18.2727273 C29.787234,16.8669115 28.6203166,15.7272727 27.1808511,15.7272727 C25.7413855,15.7272727 24.5744681,16.8669115 24.5744681,18.2727273 Z",
      "id": "路径",
      "fill": "#333333"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "txt_7",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("待审批")])]), _vm._v(" "), (_vm.orderList.waitApprovedOrderList && _vm.orderList.waitApprovedOrderList.length > 0) ? _c('div', {
    staticClass: "colorDiv_4"
  }, [_vm._v("\n            " + _vm._s(_vm.orderList.waitApprovedOrderList.length) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_51",
    on: {
      "click": function($event) {
        return _vm.toOrder(3)
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "word_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("执行中")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_4",
    on: {
      "click": function($event) {
        return _vm.toOrder(4)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "33px",
      "height": "32px",
      "viewBox": "0 0 33 32",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("yiwancheng备份 2#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-280.000000, -471.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "yiwancheng备份-2#merge#",
      "transform": "translate(280.000000, 471.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.51392857,1.44680851 L8.71435714,1.44680851 C9.293625,1.44680851 9.73676786,1.98033362 9.68078571,2.58009362 L9.64601786,2.81708085 C9.63423214,2.9124834 9.62833929,3.00424 9.62775,3.09052766 C9.62775,4.16608511 10.3378393,5.12314894 11.0143393,5.12314894 L21.75525,5.12314894 C22.3710536,5.12314894 23.0746607,4.15575489 23.0740714,3.09052766 C23.0740714,3.00241702 23.0681786,2.91126809 23.0563929,2.81647319 L23.0222143,2.58009362 C22.9662321,1.98033362 23.409375,1.44680851 23.9886429,1.44680851 L28.1466429,1.44680851 C31.2109286,1.44680851 33,3.51832 33,6.70002553 L33,26.6221447 C33,30.1392783 31.2816429,31.8297872 27.9321429,31.8297872 L4.72783929,31.8297872 C1.53685714,31.8297872 0,29.997086 0,26.6209294 L0,6.70002553 C0,3.3153617 1.332375,1.44680851 4.51392857,1.44680851 Z",
      "id": "路径",
      "fill": "#5878FA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.226081,0 C11.2844749,0 10.5319149,0.807801418 10.5319149,1.80609929 C10.5319149,2.80680851 11.2862869,3.61702128 12.226081,3.61702128 L20.1176939,3.61702128 C21.0115854,3.61702128 21.7659574,2.80680851 21.7659574,1.80609929 C21.7659574,0.807801418 21.0133974,0 20.0699794,0 L12.226081,0 Z",
      "id": "路径",
      "fill": "#333333"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.6094306,22.4255319 C15.2653615,22.4257077 14.9354445,22.2902224 14.6928646,22.0491303 L9.50701454,16.9049774 C9.00120792,16.4014043 9.00120792,15.5889796 9.50701454,15.0854065 C9.74964249,14.8443648 10.0795137,14.7088382 10.4235806,14.7088382 C10.7676475,14.7088382 11.0975187,14.8443648 11.3401466,15.0854065 L15.6094306,19.3209632 L23.7664471,11.2286297 C24.0087567,10.9869985 24.3387472,10.8510638 24.6830132,10.8510638 C25.0272792,10.8510638 25.3572696,10.9869985 25.5995792,11.2286297 C26.1051048,11.7304983 26.1051048,12.5439535 25.5995792,13.0464167 L16.5259967,22.0491303 C16.2832654,22.2899995 15.9534466,22.4255319 15.6094306,22.4255319 L15.6094306,22.4255319 Z",
      "id": "路径",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "text_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("已完成")])])]), _vm._v(" "), (_vm.orderList.waitApprovedOrderList && _vm.orderList.waitApprovedOrderList.length > 0) ? _c('div', {
    staticClass: "group_8"
  }, [_c('svg', {
    staticClass: "anonymousIconfont",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 4.12672c280.49408 0 507.87328 227.3792 507.87328 507.87328 0 280.49408-227.3792 507.87328-507.87328 507.87328C231.50592 1019.87328 4.12672 792.49408 4.12672 512 4.12672 231.50592 231.50592 4.12672 512 4.12672zM512 685.96736c-42.47552 0-76.91264 34.42688-76.91264 76.91264 0 42.47552 34.43712 76.91264 76.91264 76.91264 42.47552 0 76.91264-34.43712 76.91264-76.91264C588.91264 720.39424 554.47552 685.96736 512 685.96736zM509.78816 625.83808c36.58752 0 66.24256-29.66528 66.24256-66.24256l0-309.1456c0-36.58752-29.65504-66.24256-66.24256-66.24256-36.58752 0-66.24256 29.66528-66.24256 66.24256l0 309.1456C443.5456 596.18304 473.20064 625.83808 509.78816 625.83808z",
      "fill": "#FE654D"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "desc",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("您有" + _vm._s(_vm.orderList.waitApprovedOrderList.length) + "个订单需要审批，请尽快审批")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberManagement'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1040 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M401.1 312.7m-193.8 0a193.8 193.8 0 1 0 387.6 0 193.8 193.8 0 1 0-387.6 0Z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M738.9 833.2c0 169.3-675.5 169.3-675.5 0S214.6 562 401.1 562s337.8 101.9 337.8 271.2zM644.7 63.5c-47.2 0-90.4 16.9-124 44.9 75.3 36.5 127.4 113.5 127.4 202.9 0 50.8-17 97.5-45.3 135.2 13.5 3 27.4 4.6 41.8 4.6 107 0 193.8-86.8 193.8-193.8S751.8 63.5 644.7 63.5z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M622.6 513.2c-20.4 0-83.1 6.1-104.2 16.1 131.8 26.8 275.1 129.3 275.1 293.1 0 25.6-10.4 48.2-28.7 67.9 110.1-18 195.5-58.2 195.5-120.6 0.1-175.4-151.2-256.5-337.7-256.5z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("成员管理")]), _vm._v(" "), (_vm.approvalMemberListLength > 0) ? _c('div', {
    staticClass: "colorDiv_Member"
  }, [_vm._v("\n              " + _vm._s(_vm.approvalMemberListLength) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'accountCustomer'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M219.232 287.872l571.84-26.032h63.088l-50.72-108.32c-17.44-43.632-66.08-66.592-112.672-53.2L164.752 261.84l54.48 26.032z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M828.24 256C901.008 256 960 313.856 960 385.232v94.752L774.496 480c-61.184 0-111.248 47.712-113.104 107.12l-0.064 3.872c0 60 48.64 109.104 109.232 110.912l3.936 0.064H960v96.8C960 870.128 901.008 928 828.24 928H195.76C122.992 928 64 870.144 64 798.768V385.232C64 313.872 122.992 256 195.76 256h632.48z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M768 592m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置对账人")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'approver'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置审批人")])]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'horMember'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置科研者之家会员")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]) : (_vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_51"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]) : _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1040 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw",
      "visibility": "hidden"
    }
  }, [_vm._v("hidden")])])]) : _c('div', {
    staticClass: "box_3"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.showChooseResearchGroup) ? _c('ChooseResearchGroup', {
    on: {
      "toggleShow": _vm.toggleShowChooseBox
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "src": "/static/img/无课题组提示.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remind-info"
  }, [_c('span', {
    staticClass: "remind-title"
  }, [_vm._v("您还未加入G客课题组~")]), _vm._v(" "), _c('div', {
    staticClass: "remind-text"
  }, [_c('span', [_vm._v("为您的科研课题组创建专属账户")]), _vm._v(" "), _c('span', [_vm._v("享受专属科研服务、更优的折扣")]), _vm._v(" "), _c('span', [_vm._v("账户月结、便捷跟踪管理")]), _vm._v(" "), _c('span', [_vm._v("联系业务人员或致电"), _c('a', {
    staticStyle: {
      "color": "#ff9400"
    },
    attrs: {
      "href": "tel:400-621-0302"
    }
  }, [_vm._v("400-621-0302")])])])])])
}]}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('myCommentOrder', {
    attrs: {
      "commentMerchandise": _vm.waitCommentMerchandise,
      "buttonName1": "评价晒单"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('myCommentOrder', {
    attrs: {
      "commentMerchandise": _vm.commentedMerchandise,
      "buttonName1": "追加评价",
      "buttonName2": "查看评价"
    },
    on: {
      "response": _vm.getMerchandiseComments
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("评价中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "active tab-link button",
    attrs: {
      "id": "t1",
      "href": "#tab1"
    }
  }, [_vm._v("待评价")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t2",
      "href": "#tab2"
    }
  }, [_vm._v("已评价")])])
}]}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.emkt.isWapp) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    staticStyle: {
      "height": "5rem",
      "display": "block",
      "margin-top": "45%",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/logo2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("努力加载中")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-enterprise"
  }, [_c('header', {
    staticClass: "bar bar-nav close-popup"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-right",
    attrs: {
      "to": {}
    }
  }, [_c('span', {
    staticClass: "icon icon-down"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("单位搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup",
    on: {
      "click": _vm.valueConvey2
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchEnterprise"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchEnterprise",
      "placeholder": "单位名称"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "68px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, [_c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.filteredData), function(company, index) {
    return _c('li', {
      staticClass: "item-content",
      on: {
        "click": function($event) {
          return _vm.valueConvey(index)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner close-popup"
    }, [_c('div', {
      staticClass: "item-title",
      attrs: {
        "id": "resultsEnterprise"
      }
    }, [_vm._v("\n            " + _vm._s(company.enterpriseName) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', {
      staticClass: "badge",
      model: {
        value: (_vm.enterpriseNo),
        callback: function($$v) {
          _vm.enterpriseNo = $$v
        },
        expression: "enterpriseNo"
      }
    }, [_vm._v(_vm._s(company.enterpriseNo))])])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerName),
      expression: "customerName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Mobile),
      expression: "Mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Email),
      expression: "Email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "邮箱地址"
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Password),
      expression: "Password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "登录密码"
    },
    domProps: {
      "value": (_vm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    attrs: {
      "id": "password"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rePassword),
      expression: "rePassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addEnterprise),
      expression: "addEnterprise",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "open-popup open-enterprise",
    attrs: {
      "data-popup": ".popup-enterprise",
      "type": "text",
      "placeholder": "单位名称",
      "id": "enterpriseName",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.addEnterprise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEnterprise = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [(_vm.showSecondLevelEnterprise) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("二级单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondLevelEnterpriseNo),
      expression: "secondLevelEnterpriseNo"
    }],
    attrs: {
      "name": "fruit",
      "placeholder": "请选择二级单位"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.secondLevelEnterpriseNo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.secondLevelEnterpriseList), function(va) {
    return _c('option', {
      domProps: {
        "value": va.enterpriseNo
      }
    }, [_vm._v(_vm._s(va.enterpriseName))])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址(可选)")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Address),
      expression: "Address",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Address = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("接收促销信息")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isReceivePromotion),
      expression: "isReceivePromotion"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isReceivePromotion) ? _vm._i(_vm.isReceivePromotion, null) > -1 : (_vm.isReceivePromotion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isReceivePromotion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isReceivePromotion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isReceivePromotion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isReceivePromotion = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "7.4rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("发送")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [(_vm.disableSubmit) ? _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]) : _c('span', {
    staticClass: "button button-big button-fill fill-grey"
  }, [_vm._v("提交")])])])])]), _vm._v(" "), _c('modal-register-agreement', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "update:show": function($event) {
        _vm.showModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册")])])
}]}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "operation_box"
  }, [_c('img', {
    staticClass: "bd",
    attrs: {
      "src": "/static/img/operationsuccess.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "main",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.result))]), _vm._v(" "), _c('span', {
    staticClass: "submain",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "return-button",
    on: {
      "click": _vm.goHome
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("返回主页")])]), _vm._v(" "), (_vm.ifShowLottery && _vm.lotteryUrl) ? _c('a', {
    attrs: {
      "href": _vm.lotteryUrl
    }
  }, [_c('img', {
    staticClass: "lottery-image",
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/首单抽奖.png"
    }
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("领取优惠券")])])
}]}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-invoice-title"
  }, [_c('div', {
    staticClass: "page flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('div', {
    staticClass: "layer2 flex-col",
    staticStyle: {
      "background": "#FFFFFF"
    }
  }, [_c('div', {
    staticClass: "outer1 flex-col",
    staticStyle: {
      "background-color": "rgba(250, 250, 250, 1)"
    }
  }, [_c('div', {
    staticClass: "layer3 flex-row"
  }, [_c('img', {
    staticClass: "icon2",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/svg/sousuo.svg"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "txt1",
    staticStyle: {
      "border": "none",
      "background-color": "rgba(250, 250, 250, 1)"
    },
    attrs: {
      "placeholder": "请输入单位名称                      "
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "28px",
      "height": "20px",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular",
      "color": "rgb(151, 151, 151)",
      "float": "right",
      "right": "5px",
      "margin-right": "10px",
      "position": "fixed"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "enterprise",
    staticStyle: {
      "margin-top": "45px"
    }
  }, _vm._l((_vm.filteredData), function(company, index) {
    return _c('span', {
      staticClass: "infoBox1",
      on: {
        "click": function($event) {
          return _vm.valueConvey(company, index)
        }
      }
    }, [_vm._v("\n           " + _vm._s(company.enterpriseInvoiceTitle) + "\n             "), _c('div', {
      staticClass: "full-split-line",
      staticStyle: {
        "margin-top": "10px"
      }
    })])
  }), 0)])]), _vm._v(" "), (_vm.showChoosePayEnterprise) ? _c('div', {
    staticClass: "background-modal"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoosePayEnterprise),
      expression: "showChoosePayEnterprise"
    }],
    staticClass: "choose-balance-account"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "word3"
  }, [_vm._v("该发票抬头对应多个单位")]), _vm._v(" "), _c('span', {
    staticClass: "info1"
  }, [_vm._v("请选择支付单位")]), _vm._v(" "), _vm._l((_vm.enterpriseList), function(data) {
    return _c('div', [_c('div', {
      staticClass: "group3 flex-col"
    }), _vm._v(" "), _c('span', {
      staticClass: "word4",
      on: {
        "click": function($event) {
          return _vm.choosePayEnterprise(data)
        }
      }
    }, [_vm._v(_vm._s(data.enterpriseName))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "group3 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center",
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticClass: "word3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div')])])])
},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "main1 flex-col"
  }, [_c('div', {
    staticClass: "group_progress flex-col",
    style: (!_vm.showaberrationType ? {
      height: '118px'
    } : {})
  }, [_c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('div', {
    staticClass: "main3 flex-row justify-between"
  }, [_c('span', {
    staticClass: "info1"
  }, [_vm._v("订单编号：" + _vm._s(_vm.SCProgressInfo.orderNo))]), _vm._v(" "), _c('button', {
    staticClass: "block1 flex-col",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.SCProgressInfo.orderNo
    },
    on: {
      "click": _vm.handleCopy
    }
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "main4 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "main5 flex-row"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "info3"
  }, [_vm._v(_vm._s(_vm.SCProgressInfo.solutionName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showaberrationType),
      expression: "showaberrationType"
    }],
    staticClass: "main6 flex-row justify-between"
  }, [_c('img', {
    staticClass: "label2",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/注意.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word2"
  }, [_vm._v(_vm._s(_vm.getaberration(_vm.SCProgressInfo.aberrationType)))])])])]), _vm._v(" "), _vm._l((_vm.SCProgressInfo.contractProgressInfoList), function(contractProgressInfo, index) {
    return _c('div', {
      key: index,
      staticClass: "group3 flex-col"
    }, [_c('contract-progress-info', {
      attrs: {
        "contractProgressInfo": contractProgressInfo,
        "aberrationType": _vm.SCProgressInfo.aberrationType
      }
    })], 1)
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer1 flex-col"
  }, [_c('img', {
    staticClass: "icon3",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/service_product.png"
    }
  })])
}]}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/对勾.svg",
      "data-src": "/static/img/对勾.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    合同签署成功\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "submain"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.returnCart
    }
  }, [_vm._v("\n      返回首页\n    ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n   您已完成实名认证，"), _c('span', {
    staticStyle: {
      "color": "#67C08C"
    }
  }, [_vm._v("获2张病毒折扣券")]), _vm._v("，快去下单使用吧\n  ")])
}]}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("修改收货信息")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "text"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("默认状态")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefault),
      expression: "expressInfo.isDefault"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefault) ? _vm._i(_vm.expressInfo.isDefault, null) > -1 : (_vm.expressInfo.isDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefault", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认修改")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.delAddress
    }
  }, [_vm._v("删除地址")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.sessionInfo.invoiceAddress && _vm.sessionInfo.invoiceAddress.length > 0) ? _c('ul', _vm._l((_vm.sessionInfo.invoiceAddress), function(address, index) {
    return _c('li', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-left": "2rem"
      },
      on: {
        "click": function($event) {
          return _vm.selectInvoicAddress(index)
        }
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))])]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressMobile))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressAddress))])])])
  }), 0) : _c('ul', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem 0 2rem 0",
      "color": "grey"
    }
  }, [_vm._v("\n        请在用户中心进行添加发票地址\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("发票寄送地址")])])
}]}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n    返回首页\n  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-inner"
  }, [_c('span', {
    staticClass: "icon icon-gift",
    staticStyle: {
      "color": "#c82829",
      "margin-left": "40%"
    }
  }, [_vm._v(" 下单成功")])])])])]), _vm._v(" "), _c('merchdata', {
    attrs: {
      "merchList": _vm.recomPproducts,
      "description": _vm.description
    }
  })], 1), _vm._v(" "), (_vm.ifShowInstruction) ? _c('div', {
    staticClass: "modal-overlay modal-overlay-visible"
  }, [_c('div', {
    staticClass: "lottery-background"
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "left": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-self.png"
    },
    on: {
      "click": _vm.getCouponForSelf
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "right": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-gift.png"
    },
    on: {
      "click": _vm.getCouponForFriend
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "28px",
      "left": "260px",
      "top": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/lottery-close.png"
    },
    on: {
      "click": function($event) {
        _vm.ifShowInstruction = false
      }
    }
  }), _vm._v(" "), (_vm.promotions618Used && _vm.promotions618Used.length > 0) ? _c('div', {
    staticClass: "lottery-discount"
  }, [_vm._l((_vm.promotions618Used), function(pro) {
    return _c('div', [(_vm.promotions618Used.length === 1) ? _c('div', {
      staticStyle: {
        "line-height": "10px",
        "opacity": "0"
      }
    }, [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (pro.categoryId === 20) ? _c('div', [_vm._v("定制产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")]) : _c('div', [_vm._v("现货及质粒产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "scale(0.8)",
      "color": "#424242"
    }
  }, [_vm._v("使用截止日期2020.7.18")])], 2) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(0)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("不设限额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("限额审批")]), _vm._v(" "), _c('div', {
    staticClass: "inputWrap"
  }, [(_vm.setApproveType === _vm.setSinglestrokeApproveType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approve.approveThreshold),
      expression: "approve.approveThreshold",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "threshold",
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.approve.approveThreshold)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "approveThreshold", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setApproveType === _vm.setmouthApproveType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approve.monthlyLimit),
      expression: "approve.monthlyLimit",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "threshold",
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.approve.monthlyLimit)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "monthlyLimit", $event.target.value.trim())
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_tagWrap"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateMemberApproveType()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择审批原则")])])
}]}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(0)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("无需审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(2)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("限额审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("全部审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_tagWrap"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateMemberApproveType()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择审批原则")])])
}]}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组订单")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "allOrders",
    class: [_vm.tabIndex === 1 ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_vm._v("全部订单")]), _vm._v(" "), _c('span', {
    staticClass: "pendingApproval",
    class: [_vm.tabIndex === 2 ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_vm._v("待审批")]), _vm._v(" "), _c('span', {
    staticClass: "execution",
    class: [_vm.tabIndex === 3 ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(3)
      }
    }
  }, [_vm._v("执行中")]), _vm._v(" "), _c('span', {
    staticClass: "completed",
    class: [_vm.tabIndex === 4 ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(4)
      }
    }
  }, [_vm._v("已完成")])]), _vm._v(" "), _c('div', {
    staticClass: "div",
    style: ({
      'margin-left': _vm.tabMarginLeft + 'vw'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "submain"
  }, [_c('div', {
    staticClass: "container_2",
    on: {
      "click": _vm.changeOpenAll
    }
  }, [_c('span', {
    staticClass: "filterItems",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("筛选项目")]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openAll),
      expression: "!openAll"
    }],
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-未筛选",
      "transform": "translate(-334.000000, -173.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-4",
      "transform": "translate(334.000000, 173.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状#merge#"
    }
  })])])])])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openAll),
      expression: "openAll"
    }],
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-筛选展开",
      "transform": "translate(-210.000000, -350.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-3",
      "transform": "translate(10.000000, 158.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-7",
      "transform": "translate(139.000000, 190.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-4",
      "transform": "translate(69.000000, 10.000000) scale(1, -1) translate(-69.000000, -10.000000) translate(61.000000, 2.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), (_vm.isDefaultStatus == 2) ? _c('div', {
    staticClass: "block_31"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.memberList[_vm.m_row][_vm.m_column].memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "container_31",
    on: {
      "click": _vm.toDefineStatus
    }
  }, [_c('span', {
    staticClass: "text_3",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("清除筛选")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "12px",
      "height": "12px",
      "viewBox": "0 0 12 12",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("清除")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-筛选收起",
      "transform": "translate(-338.000000, -220.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-6",
      "transform": "translate(10.000000, 158.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-3",
      "transform": "translate(278.000000, 59.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "清除",
      "transform": "translate(50.000000, 3.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.7067367,4.09942408 L9.53993109,3.04085548 L10.7536165,0.728290231 L10.7536165,0.728290217 C10.9207018,0.566034847 10.9246191,0.299050293 10.7623683,0.131961454 C10.76061,0.130150744 10.7588355,0.128355865 10.757045,0.126577031 L10.757045,0.126577026 C10.5812143,-0.0385082467 10.3086159,-0.0425930572 10.1279171,0.117148493 L8.78566331,2.67314166 L6.91713635,1.76457266 L6.91713643,1.7645727 C6.74439277,1.67484575 6.55370713,1.62505031 6.35914971,1.6188588 C6.05058563,1.6188588 5.84916185,1.77314411 5.76173536,1.92057228 L5.74630715,1.94971506 C4.37148273,4.85970728 0.408148492,6.46341728 0.367006614,6.47970295 L0.367006634,6.47970294 C0.203142231,6.54367737 0.0768666645,6.67814304 0.0233005287,6.84570196 C-0.0572689822,7.11227268 0.0944416927,7.35055776 0.126155224,7.39598621 L0.174154081,7.46627173 L7.41255323,11.7759745 C7.6671186,11.9259741 7.88397058,11.9996882 8.07596601,11.9996882 L8.07596599,11.9996882 C8.20082141,12.0039084 8.3233476,11.9651832 8.42310058,11.8899742 L8.44367152,11.8728314 C11.0604664,9.47626636 11.9038749,5.95256149 11.9861586,5.13999224 C12.0564427,4.44313696 11.8430192,4.19028049 11.7067367,4.09942359 L11.7067367,4.09942408 Z M11.1881776,5.06370721 C11.1881776,5.0697072 11.1067509,5.65684848 10.8247577,6.53970327 C9.5176459,5.92256206 6.53143126,4.26656649 5.5517403,3.7197108 L5.5517403,3.71971055 C5.88511828,3.31265584 6.17336857,2.87064452 6.41143299,2.4014297 C6.44400364,2.41000111 6.49285962,2.42542964 6.55800093,2.45714384 C6.97199108,2.65771473 10.0842027,4.17313925 11.0304659,4.63428087 L11.1864622,4.70970924 C11.1967477,4.7679948 11.2070331,4.8777088 11.1881764,5.0637083 L11.1881776,5.06370721 Z M7.54283576,8.989411 L7.54283576,8.989411 C7.71362009,8.83036053 7.72313415,8.56297285 7.56408704,8.39218492 C7.56050267,8.38833596 7.55684674,8.38455425 7.55312118,8.38084177 L7.55312118,8.38084177 C7.37729054,8.2157565 7.10469212,8.21167169 6.92399329,8.37141324 L5.53374067,9.67340976 L5.53374063,9.67340979 C5.51818533,9.68792078 5.50385143,9.70368828 5.49088464,9.72055239 L3.37464929,8.46055576 L4.79747257,7.52284398 L4.79747258,7.52284398 C4.99365987,7.39645297 5.05024335,7.13494769 4.92385515,6.93875625 C4.92095434,6.93425336 4.91796819,6.92980602 4.9148983,6.92541667 L4.91489829,6.92541665 C4.77097672,6.73123681 4.50121483,6.68177846 4.29777012,6.8122741 L2.69752249,7.86655699 L2.69752249,7.86655699 C2.64989528,7.89812227 2.60908995,7.93892845 2.57752535,7.98655667 L1.00984837,7.05227346 C1.80011528,6.6982744 3.58464424,5.79484825 5.02032435,4.31799505 C6.03087173,4.88285069 9.20993892,6.64941739 10.5659066,7.27855857 C10.1399168,8.37398421 9.35479262,9.92540863 8.00825324,11.2034052 L8.00825324,11.2034052 C7.94770263,11.1786987 7.88923094,11.1491757 7.83340026,11.11512 L6.26572329,10.1834082 L7.54283575,8.98941141 L7.54283576,8.989411 Z",
      "id": "形状"
    }
  })])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDefaultStatus == 1),
      expression: "isDefaultStatus==1"
    }],
    staticClass: "submain1"
  }, [_c('span', {
    staticClass: "info_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("课题组成员")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    class: [(_vm.m_row === 0 && _vm.m_column === -1) ? 'choose-col' : 'nochoose-col'],
    on: {
      "click": function($event) {
        return _vm.chooseMember(0, -1)
      }
    }
  }, [_c('span', {
    class: [(_vm.m_row === 0 && _vm.m_column === -1) ? 'tag' : 'tag_2'],
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("全部成员")])]), _vm._v(" "), _vm._l((_vm.memberList[0]), function(member, i) {
    return _c('div', {
      staticClass: "col2",
      class: [(_vm.m_row === 0 && _vm.m_column === i) ? 'choose-col' : 'nochoose-col'],
      on: {
        "click": function($event) {
          return _vm.chooseMember(0, i)
        }
      }
    }, [_c('span', {
      class: [(_vm.m_row === 0 && _vm.m_column === i) ? 'tag' : 'tag_2'],
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(member.memberName))])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticStyle: {
      "margin-left": "3.53vw"
    }
  }, _vm._l((_vm.memberList), function(innerList, index) {
    return (innerList.length > 0) ? _c('div', {
      staticClass: "grid"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index===0"
      }],
      staticClass: "col1",
      class: [(_vm.m_row === 0 && _vm.m_column === -1) ? 'choose-col' : 'nochoose-col'],
      on: {
        "click": function($event) {
          return _vm.chooseMember(0, -1)
        }
      }
    }, [_c('span', {
      class: [(_vm.m_row === 0 && _vm.m_column === -1) ? 'tag' : 'tag_2'],
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("全部成员")])]), _vm._v(" "), _vm._l((innerList), function(member, i) {
      return _c('div', {
        staticClass: "col1",
        class: [(_vm.m_row === index && _vm.m_column === i) ? 'choose-col' : 'nochoose-col'],
        on: {
          "click": function($event) {
            return _vm.chooseMember(index, i)
          }
        }
      }, [_c('span', {
        class: [(_vm.m_row === index && _vm.m_column === i) ? 'tag' : 'tag_2'],
        attrs: {
          "lines": undefined
        }
      }, [_vm._v(_vm._s(member.memberName))])])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "group_2",
    on: {
      "click": _vm.changeOpen
    }
  }, [_c('span', {
    staticClass: "clickExpand",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("点击展开")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-未筛选",
      "transform": "translate(-334.000000, -173.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-4",
      "transform": "translate(334.000000, 173.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状#merge#"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "group_2",
    on: {
      "click": _vm.changeOpen
    }
  }, [_c('span', {
    staticClass: "clickExpand",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("点击收起")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-筛选展开",
      "transform": "translate(-210.000000, -350.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-3",
      "transform": "translate(10.000000, 158.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-7",
      "transform": "translate(139.000000, 190.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-4",
      "transform": "translate(69.000000, 10.000000) scale(1, -1) translate(-69.000000, -10.000000) translate(61.000000, 2.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])])])])])])])]), _vm._v(" "), _c('order-info-list', {
    attrs: {
      "orderStatus": _vm.tabIndex,
      "orderListOrigin": _vm.orderList,
      "chooseMemberName": _vm.chooseMemberName,
      "chooseStatus": _vm.chooseStatus
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-express-with-data', {
    on: {
      "downloadExpressFile": _vm.handleDownloadExpressFile
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [_c('span', {
    staticClass: "icon icon-left goback",
    staticStyle: {
      "color": "gray"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "5.5rem",
      "color": "gray"
    }
  }, [_vm._v("\n        联系我们\n      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerName),
      expression: "customerName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Mobile),
      expression: "Mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addEnterprise),
      expression: "addEnterprise",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "open-popup open-enterprise",
    attrs: {
      "data-popup": ".popup-enterprise",
      "type": "text",
      "placeholder": "单位名称",
      "id": "enterpriseName",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.addEnterprise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEnterprise = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticStyle: {
      "margin-left": ".7rem",
      "margin-top": ".7rem"
    }
  }, [_vm._v("\n              在线留言\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "margin-left": ".5rem",
      "margin-top": ".5rem"
    },
    attrs: {
      "placeholder": "我们将会为您提供更多服务,如有问题，请致电400-621-0302"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    staticStyle: {
      "background-color": "#0A3584"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [(_vm.showProgressBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToProgress', _vm.orderDetail)
      }
    }
  }, [_vm._v("进展查询")]) : _vm._e(), _vm._v(" "), (_vm.showDownloadContractBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('downloadOrderText', _vm.orderDetail)
      }
    }
  }, [_vm._v("下载合同")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [_c('span', {
    staticClass: "icon icon-left goback",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "goback"
  }, _vm._l((_vm.merchandises._titleList), function(title, index) {
    return _c('span', {
      staticStyle: {
        "margin-left": ".5rem"
      }
    }, [(index <= 1) ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "searchbar title searchbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "margin-bottom": "3rem"
    }
  }, [_c('a', {
    staticClass: "tab-link active button",
    staticStyle: {
      "border-bottom": "1px solid",
      "color": "#0894ec",
      "background-color": "transparent"
    },
    attrs: {
      "id": "detail",
      "href": "#tab-detail"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(1)
      }
    }
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "introduce",
      "href": "#tab-introduce"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(2)
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "qualityCommitment",
      "href": "#tab-qualityCommitment"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(3)
      }
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "comments",
      "href": "#tab-comments"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(4)
      }
    }
  }, [_vm._v("评论(0)")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "tlnoImg",
      "href": "#tab-tlnoImg"
    },
    on: {
      "click": function($event) {
        return _vm.addcss(5)
      }
    }
  }, [_vm._v("载体图谱")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('header', [_c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "margin-bottom": "3rem"
    }
  }, [_c('a', {
    staticClass: "tab-link active button",
    staticStyle: {
      "border-bottom": "1px solid",
      "color": "#0894ec",
      "background-color": "transparent",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "detail",
      "href": "#tab-detail"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(1)
      }
    }
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "introduce",
      "href": "#tab-introduce"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(2)
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qualityCommitment",
      "href": "#tab-qualityCommitment"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(3)
      }
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "comments",
      "href": "#tab-comments"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(4)
      }
    }
  }, [_vm._v("评论(0)")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('a', {
    staticClass: "tab-link button",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "tlnoImg",
      "href": "#tab-tlnoImg"
    },
    on: {
      "click": function($event) {
        return _vm.wappaddcss(5)
      }
    }
  }, [_vm._v("载体图谱")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-top": "2rem"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [(_vm.merchandises.specialAnnouncement) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.soldOut) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：该产品已售罄，具体上线时间可咨询在线客服。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showExtraMessage) ? _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "margin-left": "1rem"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.filteredShowPromotions && _vm.filteredShowPromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.filteredShowPromotions), function(proo, index) {
    return _c('div', [_c('span', [_vm._v(_vm._s(index + 1) + ": " + _vm._s(proo.description))])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    style: ({
      'margin-top': '-.75rem',
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '35px'
    })
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('div', {
    staticClass: "list-block"
  }, [(_vm.merchandises.categoryId === 20) ? _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.value !== null && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "param:": _vm.$route.params.merchandises,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax !== undefined) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.price)))])])]), _vm._v(" "), (_vm.merchandises.priceMin !== undefined) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])])]) : _vm._e()], 2) : _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== '' && attribute.value !== '214' && attribute.columnName !== 'GeneInfo') ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.secPromotionDetail && _vm.secPromotionDetail.seckillType === 1) ? _c('span', [_vm._v("¥" + _vm._s(((1 - _vm.secPromotionDetail.seckilltRatio) * _vm.merchandises.priceMin).toFixed(2)))]) : _vm._e()])])]) : _vm._e()], 2), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [(_vm.merchandises.H5FileName && _vm.introduces) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.merchandises.H5FileName && _vm.merchandises.description) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "10.5pt",
      "line-height": "2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.merchandises.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.merchandises.manualFileName.split(';').length === 1) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "#0A7CE3"
    },
    on: {
      "click": function($event) {
        return _vm.gotomanual(_vm.merchandises.manualFileName)
      }
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#0A7CE3"
      },
      on: {
        "click": function($event) {
          return _vm.gotomanual(manualFileName)
        }
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))])]) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-tlnoImg"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.tlnoimgurl !== '') ? _c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.tlnoimgurl
    }
  })]) : _c('div', [_vm._v("\n                   无载体！\n                ")])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('span', {
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart",
    staticStyle: {
      "margin-right": "100px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "margin-left": "-47px"
    }
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()])]), _vm._v(" "), (_vm.isWapp) ? _c('span', [(_vm.QuoteStatus === false && _vm.merchandises.priceMin > 0) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])]) : _c('span', [(_vm.QuoteStatus === false && _vm.merchandises.priceMin > 0) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])])])])]) : _c('div', {
    staticStyle: {
      "margin-top": "11rem",
      "text-align": "center",
      "font-size": "200%"
    }
  }, [_c('div', [_vm._v("\n      此商品已经下架！\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title-row"
  }, [_c('span', {
    staticStyle: {
      "color": "#ff3f3f",
      "font-size": "0.6rem",
      "margin-left": "0.5rem"
    }
  }, [_vm._v("注：本产品需回款后才能发货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n                    不同产品分装规则说明\n                    "), _c('div', [_vm._v("\n                      1.菌液:200μL/tube*1\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      2.质粒:不分装\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      3.慢病毒:50μL/tube\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      4.腺病毒:200μL/tube\n                    ")]), _c('div', [_vm._v("\n                    5.逆转录病毒:50μL/tube\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      6.腺相关病毒:50μL/tube\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-with-actions', {
    attrs: {
      "show-place-holder": _vm.emkt.leaveSpaceForFullScreen,
      "show-product-contract-no": false
    },
    scopedSlots: _vm._u([{
      key: "addressOperation",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'WeappAddress',
              params: {
                order: orderDetail,
                addressType: 1
              },
            }
          }
        }, [_c('div', {
          staticClass: "update-address update-address-color"
        }, [_vm._v("修改")])])]
      }
    }, {
      key: "productOperations",
      fn: function(ref) {
        var item = ref.item;
        var orderDetail = ref.orderDetail;

        return [(_vm.showAmplificationBtn(item, orderDetail) && item.name !== '实物返还') ? _c('div', {
          staticClass: "pay-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.amplifyProduct(item, orderDetail)
            }
          }
        }, [_vm._v("\n        我要扩增\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showBuyAgainBtn(item, orderDetail)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.buyProductAgain(item, orderDetail)
            }
          }
        }, [_vm._v("\n        再次购买\n      ")]) : _vm._e()]
      }
    }, {
      key: "orderOperations",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [(_vm.showCancelButton(orderDetail)) ? _c('div', {
          staticClass: "cancel-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderCancel(orderDetail)
            }
          }
        }, [_vm._v("\n        取消订单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showInvoiceBtn(orderDetail)) ? _c('div', {
          staticClass: "cancel-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.toPayInvoice(orderDetail)
            }
          }
        }, [_vm._v("\n        查看发票\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showContractBtn(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.toSendContract(orderDetail)
            }
          }
        }, [_vm._v("\n        下载合同\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSampleDeliveryGuideBtn(orderDetail)) ? _c('div', {
          staticClass: "research-background-color",
          class: orderDetail.fromEmkt ? 'submit-btn' : 'sf-sampleGuid-btn',
          on: {
            "click": function($event) {
              return _vm.toSampleDeliveryList(_vm.orderMaterialInfo)
            }
          }
        }, [_vm._v("\n        寄送实物\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitOrderButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderSubmit(orderDetail)
            }
          }
        }, [_vm._v("\n        提交订单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitToCheckSignApproveButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderToCheckSignApprove(orderDetail)
            }
          }
        }, [_vm._v("\n        重新提交\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSignSubmitOrderButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderToSign(orderDetail)
            }
          }
        }, [_vm._v("\n        签署合同\n      ")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isWapp) ? _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.tolast
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的对账单")])]) : _vm._e(), _vm._v(" "), (_vm.asBillInfos && _vm.asBillInfos[0] && _vm.asBillInfos[0].summary) ? _c('footer', {
    staticClass: "bar bar-footer-secondary",
    staticStyle: {
      "color": "white",
      "height": "3.5rem",
      "margin-bottom": "-2rem"
    },
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '5rem' : '3.5rem'
    })
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "red",
      "font-size": ".8rem",
      "margin-top": ".1rem"
    }
  }, [_vm._v("请您核对账单")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "45%",
      "float": "left",
      "border": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10%",
      "float": "left",
      "border": "1px",
      "text-align": "center",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "45%",
      "float": "left",
      "border": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.senEmail()
      }
    }
  }, [_vm._m(1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "top": "30px"
    },
    style: ({
      'bottom': _vm.emkt.leaveSpaceForFullScreen ? '5rem' : '3.5rem'
    })
  }, [_c('div', {
    staticClass: "buttons-tab",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, _vm._l((_vm.asBillInfos), function(item, index) {
    return _c('a', {
      class: 'tab-link' + (index === 0 ? ' active' : '') + ' button',
      attrs: {
        "href": '#tab' + (index + 1)
      }
    }, [_vm._v(_vm._s(item.summary.settlementAccountName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.asBillInfos), function(item, index) {
    return _c('div', {
      class: 'tab' + (index === 0 ? ' active' : ''),
      attrs: {
        "id": 'tab' + (index + 1)
      }
    }, [(item.summary) ? _c('div', {
      staticStyle: {
        "margin-top": "1rem",
        "font-size": "14px",
        "background-color": "white",
        "height": "70px",
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticClass: "jine"
    }, [_c('div', [_vm._v("消费总金额")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "color": "#0f60c8"
      }
    }, [_vm._v(_vm._s(item.summary.consumedMoneySum) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "jine"
    }, [_c('div', [_vm._v("已发货总金额")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "color": "#0f60c8"
      }
    }, [_vm._v(_vm._s(item.summary.deliveryMoneySum) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "jine"
    }, [_c('div', [_vm._v("预付款余额")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "color": "#0f60c8"
      }
    }, [_vm._v(_vm._s(item.summary.prepayAccountRestMoneySum) + "元")])])]) : _vm._e(), _vm._v(" "), (item.summary) ? _c('div', {
      staticStyle: {
        "font-size": "16px",
        "margin-top": "20px",
        "margin-left": "10px"
      }
    }, [_vm._v("\n          发票信息\n        ")]) : _vm._e(), _vm._v(" "), (item.summary) ? _c('div', {
      staticStyle: {
        "margin-top": ".5rem",
        "font-size": "14px",
        "background-color": "white",
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('table', {
      staticClass: "account-item",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tbody', [_vm._m(2, true), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.summary.openedNotReceivedInvoiceMoneySum) + "元\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.summary.notOpenedInvoiceMoneySum) + "元\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.summary.receivedMoneySum) + "元\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.summary.depositMoneySum) + "元\n              ")])])])])]) : _vm._e(), _vm._v(" "), (item.invoiceList) ? _c('div', {
      staticStyle: {
        "font-size": "16px",
        "margin-top": "20px",
        "margin-left": "10px"
      }
    }, [_vm._v("\n          明细（已开票未回款）\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": ".5rem",
        "font-size": "14px",
        "background-color": "white",
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [(item.invoiceList) ? _c('table', {
      staticClass: "account-item",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tbody', [_vm._m(3, true), _vm._v(" "), _vm._l((item.invoiceList), function(invoice) {
      return _c('tr', [_c('td', {
        staticClass: "idxn"
      }, [_vm._v("\n                " + _vm._s(invoice.invoiceNo) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(invoice.invoiceMoney) + "元\n              ")]), _vm._v(" "), _c('td', {
        staticClass: "idxn"
      }, [_vm._v("\n                " + _vm._s(invoice.invoiceBillingDT) + "\n              ")])])
    })], 2)]) : _vm._e()]), _vm._v(" "), (item.consumeContractList) ? _c('div', {
      staticStyle: {
        "font-size": "16px",
        "margin-top": "20px",
        "margin-left": "10px",
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n          消费详情\n        ")]) : _vm._e(), _vm._v(" "), (item.consumeContractList) ? _c('div', {
      staticClass: "list-block",
      staticStyle: {
        "margin": "0rem"
      }
    }, [_c('contractInfoBox', {
      attrs: {
        "contractInfo": _vm.contractInfo,
        "selected": _vm.selected,
        "type": _vm.type
      }
    }), _vm._v(" "), (_vm.timeList.length > 1) ? _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin": "0rem"
      }
    }, _vm._l((_vm.timeList), function(showdata) {
      return _c('div', {
        staticStyle: {
          "margin-left": "10px",
          "margin-right": "10px"
        }
      }, [_c('ul', {
        staticStyle: {
          "margin-bottom": "10px"
        }
      }, [_c('li', [_c('a', {
        staticClass: "item-link item-content"
      }, [_c('div', {
        staticClass: "item-inner",
        on: {
          "click": function($event) {
            return _vm.showcontract(showdata)
          }
        }
      }, [_c('div', {
        staticClass: "item-title",
        staticStyle: {
          "text-align": "center"
        }
      }, [_vm._v(_vm._s(showdata.data) + "年")])])])])]), _vm._v(" "), _vm._l((item.consumeContractList), function(contract) {
        return (showdata.isshow && contract.contractStartDT.substring(0, 4) === showdata.data) ? _c('ul', {
          staticStyle: {
            "margin-bottom": "10px",
            "font-size": ".8rem"
          }
        }, [_c('li', {
          staticClass: "item-content item-link"
        }, [_c('div', {
          staticClass: "item-inner"
        }, [_c('div', {
          on: {
            "click": function($event) {
              return _vm.showcontractInfo(contract)
            }
          }
        }, [_c('div', {
          staticClass: "xfxq-i-1 clearfix"
        }, [_c('span', {
          staticClass: "fl sp1"
        }, [_vm._v(_vm._s(contract.contractName))])]), _vm._v(" "), _c('div', {
          staticClass: "xfxq-i-1 clearfix",
          staticStyle: {
            "font-size": ".7rem"
          }
        }, [_c('span', {
          staticClass: "fl"
        }, [_vm._v("基因名称：-")]), _vm._v(" "), _c('span', {
          staticClass: "fr money"
        }, [_vm._v(_vm._s(contract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
          staticClass: "xfxq-i-1 clearfix",
          staticStyle: {
            "font-size": ".7rem"
          }
        }, [_c('span', {
          staticClass: "fl"
        }, [_vm._v("合同编号：" + _vm._s(contract.contractNo))]), _vm._v(" "), _c('span', {
          staticClass: "fr",
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v(_vm._s(contract.contractSignDT) + " ")])])])])])]) : _vm._e()
      })], 2)
    }), 0) : _c('div', _vm._l((item.consumeContractList), function(contract) {
      return _c('ul', {
        staticStyle: {
          "margin-left": "10px",
          "margin-right": "10px",
          "margin-bottom": "10px",
          "font-size": ".8rem"
        }
      }, [_c('li', {
        staticClass: "item-content item-link"
      }, [_c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        on: {
          "click": function($event) {
            return _vm.showcontractInfo(contract)
          }
        }
      }, [_c('div', {
        staticClass: "xfxq-i-1 clearfix"
      }, [_c('span', {
        staticClass: "fl sp1"
      }, [_vm._v(_vm._s(contract.contractName))])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("基因名称：-")]), _vm._v(" "), _c('span', {
        staticClass: "fr money"
      }, [_vm._v(_vm._s(contract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("合同编号：" + _vm._s(contract.contractNo))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "margin-left": "20px"
        }
      }, [_vm._v(_vm._s(contract.contractSignDT) + " ")])])])])])])
    }), 0)], 1) : _vm._e()])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "white",
      "background-color": "grey"
    }
  }, [_c('a', {
    staticClass: "button button-round",
    staticStyle: {
      "height": "1.5rem",
      "color": "white",
      "background-color": "rgb(8, 148, 236)",
      "font-size": "18px"
    }
  }, [_vm._v(" 确认")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [_c('a', {
    staticClass: "button button-round",
    staticStyle: {
      "height": "1.5rem",
      "color": "white",
      "background-color": "rgb(8, 148, 236)",
      "font-size": "18px"
    }
  }, [_vm._v("有问题，请联系我")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("\n                已开票未回款金额\n              ")]), _vm._v(" "), _c('th', [_vm._v("\n                待开票总金额\n              ")]), _vm._v(" "), _c('th', [_vm._v("\n                已回款\n              ")]), _vm._v(" "), _c('th', [_vm._v("\n                押金\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("\n                发票编号\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("\n                金额\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%",
      "padding-right": "5px"
    }
  }, [_vm._v("\n                发票开具日期\n              ")])])
}]}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "90vh",
      "overflow": "auto",
      "background-color": "#FAFAFA"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.showPromotion) ? _c('div', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.promotion.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "service-wrapper"
  }, _vm._l((_vm.serviceItems), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', {
      staticClass: "service-icon"
    }, [_c('img', {
      attrs: {
        "src": item.serviceSvgUrl,
        "data-src": item.serviceSvgUrl
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "service-txt",
      domProps: {
        "textContent": _vm._s(item.serviceTxt)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "service-sub-txt",
      domProps: {
        "textContent": _vm._s(item.serviceSubTxt)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('van-row', _vm._l((_vm.categoryList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.categoryList.length
      }
    }, [_c('van-button', {
      attrs: {
        "round": "",
        "size": "small",
        "block": "",
        "plain": _vm.plain[index],
        "color": "#5878FA"
      },
      on: {
        "click": function($event) {
          return _vm.onChange(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.dictValue))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', [(_vm.plain[0]) ? _c('qualitative-tech', {
    ref: "qualitativeTech",
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.plain[1]) ? _c('quantitative-tech', {
    ref: "send",
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.plain[2]) ? _c('modification-tech', {
    attrs: {
      "dataList": _vm.productList
    },
    on: {
      "callback": _vm.handleProduct
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('proteomics-desc')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shopping-footer"
  }, [_c('van-button', {
    staticClass: "bottom-button-large",
    attrs: {
      "color": "#5878FA",
      "type": "danger",
      "text": "下一步"
    },
    on: {
      "click": _vm.onClickNextStep
    }
  })], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-name"
  }, [_c('span', {
    staticClass: "zh-name"
  }, [_vm._v("蛋白组学")]), _vm._v(" "), _c('span', {
    staticClass: "en-name"
  }, [_vm._v("Proteomics")]), _vm._v(" "), _c('span', {
    staticClass: "sub-name"
  }, [_vm._v("强大生信团队/软硬件先进/质控严格/交付周期短")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("成员信息")])]), _vm._v(" "), (_vm.memberDetail && _vm.memberDetail.memberName) ? _c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.memberName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.mobile))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.email))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.firstLevelEnterpriseName))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("加入日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.createDT.split(" ")[0]))])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [(_vm.memberDetail && _vm.memberDetail.memberName) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("审批原则")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }, [(_vm.approve.approveType === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批原则")]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeNone) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#60d837"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeAll) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单笔订单限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }, [(_vm.approve.approveThreshold === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.approveThreshold === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.approveThreshold))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单月累积限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }, [(_vm.approve.monthlyLimit === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.monthlyLimit === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.monthlyLimit))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(7)]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.type === _vm.emkt.RESEARCH_MEMBER_OP.add) ? _c('div', {
    staticClass: "ft",
    on: {
      "click": function($event) {
        return _vm.checkMember()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("删除成员")])]) : _vm._e(), _vm._v(" "), (_vm.type === _vm.emkt.RESEARCH_MEMBER_OP.approval) ? _c('div', {
    staticClass: "ft submitAddMember",
    on: {
      "click": function($event) {
        return _vm.submitAddMember()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认添加")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showChooseApproveType) ? _c('ChooseApproveType1', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setallApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglestrokeApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setSinglestrokeApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglemouthApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setmouthApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox,
      "confirm": _vm.deleteMember
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "button button-link button-nav pull-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [(_vm.VipPlanList.manageCustomerPlans && _vm.VipPlanList.manageCustomerPlans.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("我管理的大客户计划")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.VipPlanList.manageCustomerPlans), function(plan) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', {
      on: {
        "click": function($event) {
          return _vm.gotovipdetails(plan)
        }
      }
    }, [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("名称- " + _vm._s(plan.customerPlanName))]), _vm._v(" "), _c('span', [_vm._v("类型- "), (plan.type === 2) ? _c('span', [_vm._v("\n              储值账户\n            ")]) : _c('span', [_vm._v("\n              VIP账户\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                  等级-- VIP" + _vm._s(plan.VIPLevel) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n                  单位-- " + _vm._s(plan.enterpriseName) + "\n                ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              生效时间- " + _vm._s(plan.startDt) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             有效截止时间- " + _vm._s(plan.validDt) + "\n            ")])])])])])
  }), _vm._v(" "), (_vm.VipPlanList.ubietyCustomerPlans && _vm.VipPlanList.ubietyCustomerPlans.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("我所属的大客户计划\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.VipPlanList.ubietyCustomerPlans), function(plan) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("名称- " + _vm._s(plan.customerPlanName))]), _vm._v(" "), _c('span', [_vm._v("类型- "), (plan.type === 2) ? _c('span', [_vm._v("\n              储值账户\n            ")]) : _c('span', [_vm._v("\n              VIP账户\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                  等级-- VIP" + _vm._s(plan.VIPLevel) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n                  单位-- " + _vm._s(plan.enterpriseName) + "\n                ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              生效时间- " + _vm._s(plan.startDt) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             有效截止时间- " + _vm._s(plan.validDt) + "\n            ")])])])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/page-key-words-result/1113.png"
    }
  }, [_c('div', {
    staticClass: "top",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "area"
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v("\n        您下半年的科研关键词是:"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "key-word"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的订单")])]), _vm._v(" "), (_vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t",
      "href": "#tab"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'all_orders.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t1",
      "href": "#tab1"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'wait_to_pay_1.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t2",
      "href": "#tab2"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'wait_receive.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t3",
      "href": "#tab3"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'complete.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t4",
      "href": "#tab4"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'cancel.png'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitPaidOrders,
      "description": "待支付",
      "payFlag": "true",
      "button1Name": _vm.baseUrl + 'cancel_order.png',
      "button2Name": _vm.baseUrl + 'pay.png'
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.waitDeliverOrders,
      "description": "待收货",
      "button1Name": _vm.baseUrl + 'cancel_order.png'
    },
    on: {
      "response1": _vm.cancelOrderFromWaitPaid
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.finishedOrders,
      "description": "已完成"
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.canceledOrders,
      "description": "已取消"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab1"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitPaidOrders,
      "description": "待支付",
      "payFlag": "true",
      "button1Name": _vm.baseUrl + 'cancel_order.png',
      "button2Name": _vm.baseUrl + 'pay.png'
    },
    on: {
      "response2": _vm.orderPay,
      "response1": _vm.cancelOrderFromWaitPaid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitDeliverOrders,
      "description": "待收货",
      "button1Name": _vm.baseUrl + 'cancel_order.png'
    },
    on: {
      "response1": _vm.cancelOrderFromWaitPaid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.finishedOrders,
      "description": "已完成"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab4"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.canceledOrders,
      "description": "已取消"
    }
  })], 1)])])]) : _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab10"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.failAuditOrders,
      "description": "审核失败",
      "button4Name": "审核意见",
      "button5Name": "重新购买"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab6"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitAuditOrders,
      "description": "待审核",
      "button3Name": "价格明细"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab7"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.quoteCompletedOrders,
      "description": "报价完成",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab8"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.completeOrders,
      "description": "录入完成",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab9"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitSignOrders,
      "description": "待签署",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t10",
      "href": "#tab10"
    }
  }, [_vm._v("审核失败")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t6",
      "href": "#tab6"
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t7",
      "href": "#tab7"
    }
  }, [_vm._v("报价完成")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t8",
      "href": "#tab8"
    }
  }, [_vm._v("录入完成")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t9",
      "href": "#tab9"
    }
  }, [_vm._v("已签署")])])
}]}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar-background"
  }, _vm._l((_vm.titleBar), function(item, index) {
    return _c('div', {
      staticClass: "all-of-the-options",
      style: ({
        'width': 'calc(100% / ' + _vm.titleBar.length + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.changed(index, item.value)
        }
      }
    }, [_c('div', {
      staticClass: "single-option",
      class: index === _vm.selected ? 'single-option-selected' : ''
    }, [_vm._v(_vm._s(item.label) + " " + _vm._s(item.length > 0 ? '(' + item.length + ')' : ''))])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n    " + _vm._s(this.attribute.label) + "\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.valueText),
      expression: "attribute.valueText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.valueText)
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "valueText", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : (_vm.attribute.sorteditAble === true && (_vm.attribute.columnName === 'TvNoName' || _vm.attribute.columnName === 'TvNoNumber')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "选填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "必填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_name')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nameQuery),
      expression: "nameQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请输入被转赠人姓名"
    },
    domProps: {
      "value": (_vm.nameQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_mobile')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobileQuery),
      expression: "mobileQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请输入被转赠人手机号码"
    },
    domProps: {
      "value": (_vm.mobileQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "return-button",
    staticStyle: {
      "width": "47%",
      "background-color": "transparent"
    },
    on: {
      "click": function($event) {
        return _vm.changeMind()
      }
    }
  }, [_c('span', {
    staticClass: "button-name",
    staticStyle: {
      "color": "#013c8e"
    }
  }, [_vm._v("返回上一步")])]), _vm._v(" "), _c('div', {
    staticClass: "return-button",
    staticStyle: {
      "width": "47%"
    },
    on: {
      "click": function($event) {
        return _vm.searchContact()
      }
    }
  }, [_c('span', {
    staticClass: "button-name"
  }, [_vm._v("转赠优惠券")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("转赠好友")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract-first/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractDate))]), _c('br'), _vm._v("\n    是您第一个合同的签订日"), _c('br'), _vm._v("\n    您购买的产品为"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractProduct))]), _c('br'), _vm._v(" "), (_vm.data.firstContractTLNo) ? _c('div', [_vm._v("\n      当年共有"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractTLBuyers))]), _vm._v("\n      与您选择了相同的载体\n      "), _c('br'), _vm._v("\n      科研道路上您并不孤单\n    ")]) : _c('div', [_vm._v("\n      成交只是起点，服务没有终点\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#fafafa",
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "mod",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "color"
  }), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('div', {
    staticClass: "group_3"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "container_1"
  }, [_c('span', {
    staticClass: "txt_1",
    on: {
      "click": function($event) {
        return _vm.autofocus('customerName')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerName),
      expression: "customerName",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "id": "customerName",
      "placeholder": "请填写您的姓名"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        return _vm.autofocus('customerName')
      }
    }
  }, [_c('img', {
    staticClass: "icon_5",
    attrs: {
      "src": "/static/img/修 改.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "/static/img/authentication13.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "word_1"
  }, [_vm._v("手机")]), _vm._v(" "), _c('div', {
    staticClass: "outer_1"
  }, [_c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.mobile))]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("4. 手机号为登录时使用手机号，无法更改")]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "add-btn research-background-color",
    staticStyle: {
      "text-align": "center",
      "padding-top": "12px"
    },
    on: {
      "click": _vm.goShowConfirmedButton
    }
  }, [_c('span', [_vm._v("发起签署")])])])]), _vm._v(" "), _c('footer-placeholder')], 1)])]), _vm._v(" "), (_vm.showConfirmedButton) ? _c('div', {
    staticClass: "background-modal"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmedButton),
      expression: "showConfirmedButton"
    }],
    staticClass: "choose-balance-account",
    staticStyle: {
      "margin-bottom": "350px",
      "margin-left": "10%",
      "margin-right": "10%",
      "border-radius": "12px"
    }
  }, [_c('div', {
    staticClass: "content-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "message_customer"
  }, [_c('div', [_c('span', [_vm._v("姓名: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerName))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mobile))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('img', {
    staticClass: "bg_1",
    attrs: {
      "src": "/static/img/authentication13.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmedButton = false
      }
    }
  }, [_c('span', [_vm._v("\r\n           返回修改\r\n         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "50%"
    },
    on: {
      "click": _vm.sendAuthentication
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#576B95"
    }
  }, [_vm._v("确认发起")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_4"
  }, [_c('img', {
    staticClass: "icon_6",
    attrs: {
      "src": "/static/img/锁.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submain"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("1. 请确保您的姓名为")]), _vm._v(" "), _c('span', {
    staticClass: "word_2"
  }, [_vm._v("真实姓名，")]), _vm._v(" "), _c('span', {
    staticClass: "info_1"
  }, [_vm._v("否则会导致")]), _vm._v(" "), _c('span', {
    staticClass: "txt_2"
  }, [_vm._v("签署失败")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v("2. 请确保您的姓名与")]), _vm._v(" "), _c('span', {
    staticClass: "organizationPrev"
  }, [_vm._v("手机号码实名机主")]), _vm._v(" "), _c('span', {
    staticClass: "organization"
  }, [_vm._v("一致")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row1"
  }, [_c('span', {
    staticClass: "word_3"
  }, [_vm._v("3. 手机号已")]), _vm._v(" "), _c('span', {
    staticClass: "text_1"
  }, [_vm._v("开通支付宝")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "14px",
      "font-size": "10px",
      "font-weight": "300",
      "color": "#929292",
      "line-height": "14px",
      "margin-bottom": "10px",
      "text-align": "center"
    }
  }, [_vm._v("\r\n       点击发起签署，"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("e签宝")]), _vm._v("认证链接会以"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("短信")]), _vm._v("形式发送到您的手机上\r\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "justify-content": "center",
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "text-align": "center",
      "width": "272px",
      "height": "24px",
      "font-size": "17px",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#000000",
      "line-height": "24px"
    }
  }, [_vm._v("确认信息")])])
}]}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("修改收货信息")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "text"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("默认状态")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefault),
      expression: "expressInfo.isDefault"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefault) ? _vm._i(_vm.expressInfo.isDefault, null) > -1 : (_vm.expressInfo.isDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefault", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认修改")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.delAddress
    }
  }, [_vm._v("删除地址")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.svgClass,
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayType === _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON) ? _c('div', [(_vm.materialType === _vm.emkt.MATERIAL_TYPE.CELL) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/目的细胞.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.SAMPLE) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/样本.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.ANTIBODY) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/抗体.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.MEDICINE) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/药物.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.KIT) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/试剂盒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.VIRUS) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/病毒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.PLASMID) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/质粒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.PRIMER) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/引物.svg'
    }
  }) : _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/其它.svg'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displayType === _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE) ? _c('div', [(_vm.displayStatusName === '待寄出') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(255, 148, 0, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(255, 148, 0, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : (_vm.displayStatusName === '已寄出') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(254, 101, 77, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(254, 101, 77, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : (_vm.displayStatusName === '已到达' || _vm.displayStatusName === '已到齐') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "#EAF7F0"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "#67C08C"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(255, 148, 0, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(255, 148, 0, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.merchdiseGroup,
      "description": 'group'
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-meet/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [(_vm.dataInfo) ? _c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    Hi，"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.dataInfo.registrationDate))]), _vm._v("，您第一次与吉凯相遇"), _c('br'), _vm._v("\n    我们共同走过了"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.dataInfo.registrationDatetoToday))]), _c('br'), _vm._v(" "), (_vm.dataInfo.registrationDateYear > 0) ? _c('span', [_vm._v("科研路漫漫，过程中体会到了坚持的力量"), _c('br'), _vm._v("不忘初心，我们继续携手探索科研的奥秘")]) : _c('span', [_vm._v("希望我们来日方长"), _c('br'), _vm._v("我们携手并进，继续创造无限可能")])]) : _c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    Hi，"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerCreateDT))]), _vm._v("今天是您第一次与吉凯相遇"), _c('br'), _vm._v("\n    终于等到您了~"), _c('br'), _vm._v("\n    未来日子里吉凯陪您「研途可期」\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/shape01.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', [_c('canvas', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "the-canvas"
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.pdfDoc && _vm.pageNum <= 1) ? _c('div', {
    staticClass: "foot",
    staticStyle: {
      "margin-left": "40%"
    }
  }, [(_vm.pageNum < _vm.pdfDoc.numPages) ? _c('button', {
    staticClass: "right",
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("下一页")]) : _vm._e()]) : _c('div', {
    staticClass: "foot",
    staticStyle: {
      "margin-left": "30%"
    }
  }, [(_vm.pageNum > 1) ? _c('button', {
    staticClass: "left",
    on: {
      "click": _vm.onPrevPage
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), (_vm.pageNum < _vm.pdfDoc.numPages) ? _c('button', {
    staticClass: "right",
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("下一页")]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.tolast
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.groupName) + "对账单")])]), _vm._v(" "), (_vm.summary && _vm.statementGuid != '' && _vm.statementGuid != null) ? _c('footer', {
    staticClass: "bar bar-footer-secondary",
    staticStyle: {
      "color": "white",
      "height": "3.5rem",
      "margin-bottom": "-2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "red",
      "font-size": ".8rem",
      "margin-top": ".1rem"
    }
  }, [_vm._v("请您核对账单")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "45%",
      "float": "left",
      "border": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "10%",
      "float": "left",
      "border": "1px",
      "text-align": "center",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "45%",
      "float": "left",
      "border": "1px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.senEmail()
      }
    }
  }, [_vm._m(1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "1rem",
      "font-size": ".8rem"
    }
  }, [_vm._v(_vm._s(_vm.selected)), (_vm.selected !== '累计') ? _c('span', [_vm._v(":")]) : _vm._e(), _vm._v(_vm._s(_vm.chooseDate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1rem",
      "font-size": "14px",
      "background-color": "white",
      "height": "70px",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [(_vm.selected !== '累计') ? _c('div', [_c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v(_vm._s(_vm.selected) + "消费金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.consumedMoneySum) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v(_vm._s(_vm.selected) + "交付金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.deliveryMoneySum) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v("账单金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.billAmount) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v(_vm._s(_vm.selected) + "未清金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.balanceAmount) + "元")])])]) : _c('div', [_c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v("消费总金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.consumedMoneySum) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v("已发货总金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.deliveryMoneySum) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v("已开票总金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.invoiceMoneySum) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "jine"
  }, [_c('div', [_vm._v("回款总金额")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#0f60c8"
    }
  }, [_vm._v(_vm._s(_vm.summary.invoiceReceivedMoneySum) + "元")])])])]), _vm._v(" "), (_vm.selected == '累计') ? _c('div', [(_vm.invoiceList.length > 0) ? _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "20px",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              明细（已开票未回款）\n            ")]) : _vm._e(), _vm._v(" "), (_vm.invoiceList.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": ".5rem",
      "font-size": "14px",
      "background-color": "white",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('table', {
    staticClass: "account-item",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.invoiceList), function(invoice) {
    return _c('tr', [_c('td', {
      staticClass: "idxn"
    }, [_vm._v("\n                   " + _vm._s(invoice.invoiceNo) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(invoice.invoiceMoney) + "元\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "idxn"
    }, [_vm._v("\n                    " + _vm._s(invoice.invoiceBillingDT) + "\n                  ")])])
  })], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.consumeContractList.length > 0) ? _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "20px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n            消费明细\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selected !== '累计' && _vm.consumeContractList.length > 0) ? _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin": "0rem"
    }
  }, [_c('contractInfoBox', {
    attrs: {
      "contractInfo": _vm.contractInfo,
      "type": _vm.type,
      "selected": _vm.selected
    }
  }), _vm._v(" "), _vm._l((_vm.consumeContractList), function(consumeContract) {
    return _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin": "0rem"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('ul', {
      staticStyle: {
        "margin-bottom": "10px",
        "font-size": ".8rem"
      }
    }, [_c('li', {
      staticClass: "item-content item-link"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.showcontractInfo(consumeContract, '消费明细')
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "xfxq-i-1 clearfix"
    }, [_c('span', {
      staticClass: "fl sp1"
    }, [_vm._v(_vm._s(consumeContract.contractName))])]), _vm._v(" "), _c('div', {
      staticClass: "xfxq-i-1 clearfix",
      staticStyle: {
        "font-size": ".7rem"
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v("基因名称：\n                            "), (consumeContract.geneNames !== '') ? _c('span', [_vm._v(_vm._s(consumeContract.geneNames))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticClass: "fr money"
    }, [_vm._v(_vm._s(consumeContract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "xfxq-i-1 clearfix",
      staticStyle: {
        "font-size": ".7rem"
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v("合同编号：" + _vm._s(consumeContract.contractNo))]), _vm._v(" "), _c('span', {
      staticClass: "fr",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v(_vm._s(consumeContract.contractStartDT))])])])])])])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selected === '累计') ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0rem"
    }
  }, [_c('contractInfoBox', {
    attrs: {
      "contractInfo": _vm.contractInfo,
      "type": _vm.type,
      "selected": _vm.selected
    }
  }), _vm._v(" "), _vm._l((_vm.timeList1), function(showdata1) {
    return _c('div', {
      staticStyle: {
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('ul', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('li', [_c('a', {
      staticClass: "item-link item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.showcontract(showdata1)
        }
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(showdata1.data) + "年")])])])])]), _vm._v(" "), _vm._l((_vm.consumeContractList), function(consumeContract) {
      return (showdata1.isshow && consumeContract.contractStartDT.substring(0, 4) === showdata1.data) ? _c('ul', {
        staticStyle: {
          "margin-bottom": "10px",
          "font-size": ".8rem"
        }
      }, [_c('li', {
        staticClass: "item-content item-link"
      }, [_c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        on: {
          "click": function($event) {
            return _vm.showcontractInfo(consumeContract, '消费明细')
          }
        }
      }, [_c('div', [_c('div', {
        staticClass: "xfxq-i-1 clearfix"
      }, [_c('span', {
        staticClass: "fl sp1"
      }, [_vm._v(_vm._s(consumeContract.contractName))])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("基因名称：\n                            "), (consumeContract.geneNames !== '') ? _c('span', [_vm._v(_vm._s(consumeContract.geneNames))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('span', {
        staticClass: "fr money"
      }, [_vm._v(_vm._s(consumeContract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("合同编号：" + _vm._s(consumeContract.contractNo))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "margin-left": "20px"
        }
      }, [_vm._v(_vm._s(consumeContract.contractStartDT))])])])])])])]) : _vm._e()
    })], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.deliverContractList.length > 0) ? _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "20px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n            交付明细\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selected !== '累计' && _vm.deliverContractList.length > 0) ? _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin": "0rem"
    }
  }, [_c('contractInfoBox', {
    attrs: {
      "contractInfo": _vm.contractInfo,
      "type": _vm.type,
      "selected": _vm.selected
    }
  }), _vm._v(" "), _vm._l((_vm.deliverContractList), function(deliverContract) {
    return _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin": "0rem"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('ul', {
      staticStyle: {
        "margin-bottom": "10px",
        "font-size": ".8rem"
      }
    }, [_c('li', {
      staticClass: "item-content item-link"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.showcontractInfo(deliverContract, '交付明细')
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "xfxq-i-1 clearfix"
    }, [_c('span', {
      staticClass: "fl sp1"
    }, [_vm._v(_vm._s(deliverContract.contractName))])]), _vm._v(" "), _c('div', {
      staticClass: "xfxq-i-1 clearfix",
      staticStyle: {
        "font-size": ".7rem"
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v("基因名称：" + _vm._s(deliverContract.geneNames))]), _vm._v(" "), _c('span', {
      staticClass: "fr money"
    }, [_vm._v(_vm._s(deliverContract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "xfxq-i-1 clearfix",
      staticStyle: {
        "font-size": ".7rem"
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v("合同编号：" + _vm._s(deliverContract.contractNo))]), _vm._v(" "), _c('span', {
      staticClass: "fr",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v(_vm._s(deliverContract.deliveryDT))])])])])])])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selected === '累计') ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin": "0rem"
    }
  }, [_c('contractInfoBox', {
    attrs: {
      "contractInfo": _vm.contractInfo,
      "type": _vm.type,
      "selected": _vm.selected
    }
  }), _vm._v(" "), _vm._l((_vm.timeList2), function(showdata2) {
    return _c('div', {
      staticStyle: {
        "margin-left": "10px",
        "margin-right": "10px"
      }
    }, [_c('ul', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('li', [_c('a', {
      staticClass: "item-link item-content"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.showcontract(showdata2, '累计')
        }
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(showdata2.data) + "年")])])])])]), _vm._v(" "), _vm._l((_vm.deliverContractList), function(deliverContract) {
      return (showdata2.isshow && deliverContract.deliveryDT.substring(0, 4) === showdata2.data) ? _c('ul', {
        staticStyle: {
          "margin-bottom": "10px",
          "font-size": ".8rem"
        }
      }, [_c('li', {
        staticClass: "item-content item-link"
      }, [_c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        on: {
          "click": function($event) {
            return _vm.showcontractInfo(deliverContract, '交付明细')
          }
        }
      }, [_c('div', [_c('div', {
        staticClass: "xfxq-i-1 clearfix"
      }, [_c('span', {
        staticClass: "fl sp1"
      }, [_vm._v(_vm._s(deliverContract.contractName))])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("基因名称：" + _vm._s(deliverContract.geneNames))]), _vm._v(" "), _c('span', {
        staticClass: "fr money"
      }, [_vm._v(_vm._s(deliverContract.contractMoney) + "元")])]), _vm._v(" "), _c('div', {
        staticClass: "xfxq-i-1 clearfix",
        staticStyle: {
          "font-size": ".7rem"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v("合同编号：" + _vm._s(deliverContract.contractNo))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "margin-left": "20px"
        }
      }, [_vm._v(_vm._s(deliverContract.deliveryDT))])])])])])])]) : _vm._e()
    })], 2)
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "white",
      "background-color": "grey"
    }
  }, [_c('a', {
    staticClass: "button button-round",
    staticStyle: {
      "height": "1.5rem",
      "color": "white",
      "background-color": "rgb(8, 148, 236)",
      "font-size": "18px"
    }
  }, [_vm._v(" 确认")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "background-color": "#0894ec"
    }
  }, [_c('a', {
    staticClass: "button button-round",
    staticStyle: {
      "height": "1.5rem",
      "color": "white",
      "background-color": "rgb(8, 148, 236)",
      "font-size": "18px"
    }
  }, [_vm._v("有问题，请联系我")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("\n                    发票编号\n                  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("\n                    金额\n                  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%",
      "padding-right": "5px"
    }
  }, [_vm._v("\n                    发票开具日期\n                  ")])])
}]}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attribute.value.length >= 140) ? _c('div', {
    staticClass: "item-inner specal",
    staticStyle: {
      "margin-bottom": "7rem"
    }
  }, [_c('div', {
    staticClass: "item-title "
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) ? _c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right",
      "height": "7rem"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "placeholder": "请填写",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "type": "text",
      "rows": "",
      "cols": "",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }, _vm.control]
    }
  })])]) : (_vm.attribute.value.length >= 100 && _vm.attribute.value.length < 140) ? _c('div', {
    staticClass: "item-inner specal",
    staticStyle: {
      "margin-bottom": "5rem"
    }
  }, [_c('div', {
    staticClass: "item-title "
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) ? _c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right",
      "height": "7rem"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "placeholder": "请填写",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "type": "text",
      "rows": "",
      "cols": "",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }, _vm.control]
    }
  })])]) : (_vm.attribute.value.length > 40 && _vm.attribute.value.length < 100) ? _c('div', {
    staticClass: "item-inner specal",
    staticStyle: {
      "margin-bottom": "4rem"
    }
  }, [_c('div', {
    staticClass: "item-title "
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) ? _c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "placeholder": "请填写",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "type": "text",
      "rows": "",
      "cols": "",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }, _vm.control]
    }
  })])]) : _c('div', {
    staticClass: "item-inner specal",
    staticStyle: {
      "margin-bottom": ".5rem"
    }
  }, [_c('div', {
    staticClass: "item-title "
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) ? _c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "placeholder": "请填写",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "rows": "",
      "cols": "",
      "type": "text",
      "rows": "",
      "cols": "",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }, _vm.control]
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.billInfo) ? _c('div', {
    class: {
      'box_bill_list_0': _vm.top === 0, 'box_bill_list': _vm.top === undefined
    }
  }, [(_vm.deliverContractList.length > 0) ? _c('div', {
    staticClass: "bd_2"
  }, [_c('div', {
    staticClass: "submain",
    on: {
      "click": function($event) {
        _vm.deliverIsOpen = !_vm.deliverIsOpen
      }
    }
  }, [_c('span', {
    staticClass: "consumptionDetails"
  }, [_vm._v("交付明细")]), _vm._v(" "), _c('div', {
    staticClass: "CenRadioIconWrap_2"
  }, [(_vm.deliverIsOpen) ? _c('svg', {
    staticClass: "CenRadioIcon_2",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M981.333333 512c0-260.266667-209.066667-469.333333-469.333333-469.333333S42.666667 251.733333 42.666667 512s209.066667 469.333333 469.333333 469.333333 469.333333-209.066667 469.333333-469.333333z m-64 0c0 221.866667-179.2 405.333333-405.333333 405.333333S106.666667 733.866667 106.666667 512 285.866667 106.666667 512 106.666667s405.333333 183.466667 405.333333 405.333333z",
      "fill": "#929292"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 473.6L345.6 640 298.666667 597.333333l213.333333-213.333333 213.333333 213.333333-46.933333 42.666667z",
      "fill": "#929292"
    }
  })]) : _c('svg', {
    staticClass: "CenRadioIcon_2",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M42.666667 512c0 260.266667 209.066667 469.33333301 469.333333 469.333333S981.333333 772.266667 981.333333 512s-209.066667-469.33333301-469.333333-469.333333-469.33333301 209.066667-469.333333 469.333333z m63.99999999 0c0-221.86666699 179.19999999-405.333333 405.33333301-405.33333301S917.333333 290.133333 917.33333301 512 738.133333 917.333333 512 917.33333301s-405.333333-183.466667-405.33333301-405.33333301z",
      "fill": "#929292"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 550.4L678.4 384 725.333333 426.666667l-213.333333 213.333333-213.333333-213.333333 46.933333-42.666667z",
      "fill": "#929292"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.deliverContractList), function(deliverContract) {
    return (_vm.deliverIsOpen) ? _c('div', {
      staticClass: "subrow",
      on: {
        "click": function($event) {
          return _vm.showBillInfo(deliverContract, '交付')
        }
      }
    }, [_c('div', {
      staticClass: "empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "color"
    }), _vm._v(" "), _c('div', {
      staticClass: "colorDiv"
    }), _vm._v(" "), _c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(deliverContract.contractName))]), _vm._v(" "), _c('div', {
      staticClass: "block_3"
    }, [_c('div', {
      staticClass: "block_4"
    }, [_c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("合同编号：" + _vm._s(deliverContract.contractNo))]), _vm._v(" "), _c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("下单时间：" + _vm._s(deliverContract.deliveryDT))]), _vm._v(" "), _c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("合同金额：¥" + _vm._s(deliverContract.contractMoney && _vm.splitMoney(deliverContract.contractMoney.toFixed(2))))])]), _vm._v(" "), _c('svg', {
      staticClass: "arrow-right",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "money_3 research-font-color"
    }, [_vm._v("待付尾款：¥" + _vm._s(deliverContract.waitRetainage && _vm.splitMoney(deliverContract.waitRetainage.toFixed(2))))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.consumeContractList.length > 0) ? _c('div', {
    staticClass: "bd_2"
  }, [_c('div', {
    staticClass: "submain",
    on: {
      "click": function($event) {
        _vm.consumeIsOpen = !_vm.consumeIsOpen
      }
    }
  }, [_c('span', {
    staticClass: "consumptionDetails"
  }, [_vm._v("消费明细")]), _vm._v(" "), _c('div', {
    staticClass: "CenRadioIconWrap_2"
  }, [(_vm.consumeIsOpen) ? _c('svg', {
    staticClass: "CenRadioIcon_2",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M981.333333 512c0-260.266667-209.066667-469.333333-469.333333-469.333333S42.666667 251.733333 42.666667 512s209.066667 469.333333 469.333333 469.333333 469.333333-209.066667 469.333333-469.333333z m-64 0c0 221.866667-179.2 405.333333-405.333333 405.333333S106.666667 733.866667 106.666667 512 285.866667 106.666667 512 106.666667s405.333333 183.466667 405.333333 405.333333z",
      "fill": "#929292"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 473.6L345.6 640 298.666667 597.333333l213.333333-213.333333 213.333333 213.333333-46.933333 42.666667z",
      "fill": "#929292"
    }
  })]) : _c('svg', {
    staticClass: "CenRadioIcon_2",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M42.666667 512c0 260.266667 209.066667 469.33333301 469.333333 469.333333S981.333333 772.266667 981.333333 512s-209.066667-469.33333301-469.333333-469.333333-469.33333301 209.066667-469.333333 469.333333z m63.99999999 0c0-221.86666699 179.19999999-405.333333 405.33333301-405.33333301S917.333333 290.133333 917.33333301 512 738.133333 917.333333 512 917.33333301s-405.333333-183.466667-405.33333301-405.33333301z",
      "fill": "#929292"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 550.4L678.4 384 725.333333 426.666667l-213.333333 213.333333-213.333333-213.333333 46.933333-42.666667z",
      "fill": "#929292"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.consumeContractList), function(consumeContract) {
    return (_vm.consumeIsOpen) ? _c('div', {
      staticClass: "subrow",
      on: {
        "click": function($event) {
          return _vm.showBillInfo(consumeContract, '消费')
        }
      }
    }, [_c('div', {
      staticClass: "empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "color"
    }), _vm._v(" "), _c('div', {
      staticClass: "colorDiv"
    }), _vm._v(" "), _c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(consumeContract.contractName))]), _vm._v(" "), _c('div', {
      staticClass: "block_3"
    }, [_c('div', {
      staticClass: "block_4"
    }, [_c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("合同编号：" + _vm._s(consumeContract.contractNo))]), _vm._v(" "), _c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("下单时间：" + _vm._s(consumeContract.contractStartDT))]), _vm._v(" "), _c('span', {
      staticClass: "contractNumber"
    }, [_vm._v("合同金额：¥" + _vm._s(consumeContract.contractMoney && _vm.splitMoney(consumeContract.contractMoney.toFixed(2))))])]), _vm._v(" "), _c('svg', {
      staticClass: "arrow-right",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "money_3 research-font-color"
    }, [_vm._v("待付账户余额：¥" + _vm._s(consumeContract.waitPrepayAmount && _vm.splitMoney(consumeContract.waitPrepayAmount.toFixed(2))))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw",
      "visibility": "hidden"
    }
  }, [_vm._v("hidden")]), _vm._v(" "), (_vm.showBillDetail) ? _c('BillDetail', {
    attrs: {
      "selected": _vm.selected,
      "type": _vm.type,
      "contractInfo": _vm.contractInfo
    },
    on: {
      "toggleShow": function($event) {
        _vm.showBillDetail = !_vm.showBillDetail
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.refresh) ? _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('gc-order-search-box', {
    on: {
      "updateSearchMap": _vm.handleFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-group"
  }, [_c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_WAITAUDIT)
      }
    }
  }, [_vm._v("待审核")]), _vm._v(" "), (!_vm.isAfterSales) ? _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_WAITPAY)
      }
    }
  }, [_vm._v("待下单")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_EXECUTE)
      }
    }
  }, [_vm._v("执行中")]), _vm._v(" "), _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_FINISHED)
      }
    }
  }, [_vm._v("已完成")]), _vm._v(" "), (!_vm.isAfterSales) ? _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_CANCELLED)
      }
    }
  }, [_vm._v("已取消")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-line-group"
  }, [_c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), (!_vm.isAfterSales) ? _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY ? 'visible' : 'hidden'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), (!_vm.isAfterSales) ? _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED ? 'visible' : 'hidden'
    })
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "myOrderList"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasCurrentDisplayOrders),
      expression: "hasCurrentDisplayOrders"
    }],
    staticClass: "order-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT),
      expression: "tabIndex===emkt.MYORDER_TAB_WAITAUDIT"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayWaitAduitOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY),
      expression: "tabIndex===emkt.MYORDER_TAB_WAITPAY"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayWaitPayOrders
    },
    on: {
      "cancelOrder": _vm.handleOrderCancel,
      "submitOrderToSign": _vm.handleOrderToSign,
      "submitOrderToCheckSignApprove": _vm.handleOrderToCheckSignApprove,
      "submitOrder": _vm.handleOrderSubmit
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE),
      expression: "tabIndex===emkt.MYORDER_TAB_EXECUTE"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayExecutedOrders
    },
    on: {
      "cancelOrder": _vm.handleOrderCancel
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED),
      expression: "tabIndex===emkt.MYORDER_TAB_FINISHED"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayFinishedOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED),
      expression: "tabIndex===emkt.MYORDER_TAB_CANCELLED"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayCancledOrders
    }
  })], 1), _vm._v(" "), (_vm.fetchOrdersCompleted) ? _c('div', {
    staticClass: "research-font-color",
    staticStyle: {
      "text-align": "center",
      "height": "100px"
    }
  }, [(_vm.showLoadMore) ? _c('span', {
    on: {
      "click": _vm.loadMoreCurrentTabDisplayOrders
    }
  }, [_vm._v("加载更多...")]) : _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "30%"
    }
  }, [_vm._v("---我是有底线的---")])]) : _vm._e()]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchOrdersCompleted && !_vm.hasCurrentDisplayOrders),
      expression: "fetchOrdersCompleted && !hasCurrentDisplayOrders"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/订单空.png"
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("选择支付配送方式")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContent'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("结算方式")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "1px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50",
    attrs: {
      "data-payType": "1"
    }
  }, [_vm._v("预支付")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50",
    attrs: {
      "data-payType": "2"
    }
  }, [_vm._v("后支付")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50",
    attrs: {
      "data-payType": "3"
    }
  }, [_vm._v("先货后款")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50",
    attrs: {
      "data-payType": "4"
    }
  }, [_vm._v("在线支付")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("配送方式")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50"
  }, [_vm._v("顺丰快递")])])])])])])])
}]}

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      Back\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的优惠券")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "myCoupons"
    }
  }, [_c('ul', _vm._l((_vm.myCoupons), function(coupon, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [(coupon.applied == 0) ? _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type == 1) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v("优惠码：" + _vm._s(coupon.code))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("有效期：" + _vm._s(coupon.startDT) + " 至 " + _vm._s(coupon.endDT))])]) : _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC",
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type == 1) ? _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e(), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "margin-top": "-20px"
      }
    }, [_vm._v("优惠码：" + _vm._s(coupon.code))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("有效期：" + _vm._s(coupon.startDT) + " 至 " + _vm._s(coupon.endDT))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "70px",
      "width": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/used_img.jpg"
    }
  })])
}]}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-container"
  }, [_c('div', {
    staticClass: "recommend-container"
  }, [_c('van-cell', {
    attrs: {
      "title-class": "form-label",
      "is-link": "",
      "center": "",
      "title": "开启智能推荐"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "active-color": "#1677FF",
            "size": "24"
          },
          on: {
            "change": _vm.clear
          },
          model: {
            value: (_vm.isRecommend),
            callback: function($$v) {
              _vm.isRecommend = $$v
            },
            expression: "isRecommend"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.isRecommend) ? _c('div', {
    staticClass: "recommend-props-wrap"
  }, [_c('div', {
    staticClass: "van-cell",
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "van-cell__value template-category",
    staticStyle: {
      "flex": "2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentSubCategory.dictValue))])]), _vm._v(" "), _c('i', {
    staticClass: "van-icon van-icon-arrow van-cell__right-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "van-cell"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "van-cell__value template-count",
    staticStyle: {
      "flex": "2"
    }
  }, [_c('van-radio-group', {
    attrs: {
      "direction": "horizontal"
    },
    on: {
      "change": function($event) {
        return _vm.handleSearchRecommend()
      }
    },
    model: {
      value: (_vm.templateCount),
      callback: function($$v) {
        _vm.templateCount = $$v
      },
      expression: "templateCount"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": 1
    }
  }, [_vm._v("16以下")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": 2
    }
  }, [_vm._v("17-29")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": 3
    }
  }, [_vm._v("30以上")])], 1)], 1)])]) : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "info-box ",
      class: [_vm.selectIndex == index ? 'selected' : '', _vm.checkItemCanSelect(item) ? '' : 'no-select'],
      on: {
        "click": function($event) {
          return _vm.onSelectTech(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "top"
    }, [(_vm.handleCheckIsRecommend(item)) ? _c('div', {
      staticClass: "recommend_tip"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tech-title",
      domProps: {
        "textContent": _vm._s(item.dictValue)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "tech-desc",
      domProps: {
        "textContent": _vm._s(item.extraValue)
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      width: '98%',
      height: '40%'
    }),
    attrs: {
      "closeable": "",
      "close-icon": "close",
      "round": ""
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_c('span', [_vm._v("样本分类")])]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("样本类型")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row sample-wrapper"
  }, _vm._l((_vm.sampleCategories), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-grow-1"
    }, [_c('div', {
      class: ['radio-tag', _vm.currentCategory.dictKey == item.dictKey ? 'radio-tag__checked' : ''],
      on: {
        "click": function($event) {
          return _vm.handleSelectCategory(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.dictValue) + "\n        ")])])
  }), 0), _vm._v(" "), _vm._l((_vm.sampleCategories), function(category, k) {
    return _c('div', {
      key: k
    }, [(_vm.currentCategory && _vm.currentCategory.dictKey === category.dictKey) ? _c('div', [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.currentCategory.extraValue)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-row sample-wrapper"
    }, _vm._l((_vm.sampleSubCategories), function(item, index) {
      return (category.dictKey === item.parentId) ? _c('div', {
        key: index,
        staticClass: "flex-grow-1"
      }, [_c('div', {
        class: ['radio-tag', _vm.currentSubCategory.dictKey == item.dictKey ? 'radio-tag__checked' : ''],
        on: {
          "click": function($event) {
            return _vm.handleSubSelectCategory(item)
          }
        }
      }, [_vm._v("\n              " + _vm._s(item.dictValue) + "\n            ")])]) : _vm._e()
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-button-wrap"
  }, [_c('div', {
    staticClass: "pop-button",
    on: {
      "click": function($event) {
        return _vm.handleSearchRecommend()
      }
    }
  }, [_c('span', [_vm._v("确定")])])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "van-cell__title form-label form--required",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('span', [_vm._v("样本分类")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "van-cell__title form-label form--required",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('span', [_vm._v("样本数量")])])
}]}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('OrderContentFramework', {
    attrs: {
      "button-name": '提交订单',
      "totalMoney": _vm.totalMoney,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.newsubmitOrder
    }
  }, [(!_vm.isService) ? _c('div', {
    staticClass: "content-block"
  }, [_c('img', {
    staticClass: "default-flag",
    attrs: {
      "src": "static/img/默认flag.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#979797"
    }
  }, [_vm._v("将商品留在吉凯用于其他项目")]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExpress),
      expression: "isExpress"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExpress) ? _vm._i(_vm.isExpress, null) > -1 : (_vm.isExpress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isExpress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExpress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExpress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExpress = $$c
        }
      }, _vm.changeExpressFree]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    style: ({
      'background-color': _vm.isExpress ? '#5878fa' : '#e5e5e5'
    })
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExpress),
      expression: "!isExpress"
    }]
  }, [_c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), (_vm.deliverAddress) ? _c('router-link', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress'
      }
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.deliverAddress.province + _vm.deliverAddress.city + (_vm.deliverAddress.district === undefined ? '' : _vm.deliverAddress.district) + _vm.deliverAddress.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.deliverAddress.consignee) + " " + _vm._s(_vm.deliverAddress.expressMobile))])])]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('label', {
    staticClass: "label-checkbox item-content",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "deliverMethod",
      "checked": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("顺丰快递")])])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [(_vm.isService) ? _c('ServiceProduct', {
    ref: "service",
    attrs: {
      "order": _vm.orderList,
      "service": _vm.isService
    },
    on: {
      "SE": _vm.getServiceTotalMoney
    }
  }) : _c('OrderMerchandises', {
    attrs: {
      "order": _vm.orderForMerchandises
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    on: {
      "click": _vm.goToSelectCoupons
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("优惠券")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [(!_vm.availableCoupons || _vm.availableCoupons.length === 0) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("无可用")]) : (_vm.displayNameOnlyCoupon) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("使用1张" + _vm._s(_vm.displayNameOnlyCoupon.label))]) : (_vm.selectedCoupons.length > 0) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("已选择\n            "), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v(_vm._s(_vm.selectedCoupons.length))]), _vm._v("张优惠券，可抵扣\n            "), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.couponDiscount)) + "元")])]) : _c('span', [_vm._v("未选择")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-goods"
  }, [_c('header', {
    staticClass: "bar bar-nav close-popup"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [(_vm.$route.query.id) ? _c('div', {
    staticStyle: {
      "color": "#c82829"
    }
  }, [(_vm.$route.query.label) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.$route.query.label) + "查询\n        ")]) : _c('div', [_vm._v("促销查询")])]) : _c('div', [_vm._v("搜索查询")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel close-popup"
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryName),
      expression: "queryName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchGoods",
      "placeholder": "查询基因/病毒/功能..."
    },
    domProps: {
      "value": (_vm.queryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (_vm.showMatchData) ? _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "4.5rem"
    }
  }, [_c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.matchData), function(searchData) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup",
      attrs: {
        "id": "results-goods"
      }
    }, [_vm._v("\n            " + _vm._s(searchData.data.word) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((searchData.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])])
  }), 0)]) : _c('div', {
    staticClass: "content infinite-scroll-top",
    attrs: {
      "data-distance": "5"
    }
  }, [(_vm.searchHistory.length && _vm.searchHistory) ? _c('div', {
    staticClass: "search_history"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "-1.2rem",
      "margin-left": "86%",
      "color": "#f6383a"
    },
    on: {
      "click": _vm.removeSearchHistory
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._l((_vm.searchHistory), function(item, index) {
    return (!_vm.isRemoveSH) ? _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n               " + _vm._s(item.data.word) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.hotWordList && _vm.hotWordList.length > 0) ? _c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("热门搜索")]), _vm._v(" "), _vm._l((_vm.hotWordList), function(item) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n              " + _vm._s(item.data.word) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(tag))])
    }), 0)])])
  })], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button button-link button-nav pull-left close-popup"
  }, [_c('span', {
    staticClass: "icon icon-down"
  })])
}]}

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("设置" + _vm._s(_vm.characterToDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "currentReconciler"
  }, [_vm._v("当前" + _vm._s(_vm.characterToDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "avatorWrap"
  }, [_c('img', {
    staticClass: "avator",
    attrs: {
      "src": "/static/img/avator2.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "liuChengbiao"
  }, [_vm._v(_vm._s(_vm.characterNameToDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "research-background-color open-popup open-researchGroupMember",
    class: _vm.character === 'horMember' ? 'tagWrap2' : 'tagWrap',
    attrs: {
      "data-popup": ".popup-researchGroupMember"
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("更换" + _vm._s(_vm.characterToDisplay))])])])])]), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("新增发票抬头")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addEnterprise),
      expression: "addEnterprise",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "open-popup open-enterprise",
    attrs: {
      "data-popup": ".popup-enterprise",
      "type": "text",
      "placeholder": "单位名称",
      "id": "enterpriseName",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.addEnterprise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEnterprise = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDefaultString),
      expression: "isDefaultString"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDefaultString) ? _vm._i(_vm.isDefaultString, null) > -1 : (_vm.isDefaultString)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDefaultString,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDefaultString = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDefaultString = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDefaultString = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mod4 flex-row"
  }, [_c('span', {
    staticClass: "secondary-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("上传实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "txt",
    on: {
      "click": _vm.downloadGoodsInfoSheet
    }
  }, [_vm._v("下载实物信息表")])]), _vm._v(" "), _vm._l((_vm.orderMaterialInfo.orderMaterial), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "goods-info-sheet"
    }, [_c('div', {
      staticClass: "sheet-content"
    }, [_c('label', {
      staticClass: "label-checkbox item-content",
      on: {
        "click": function($event) {
          return _vm.getChange(item.orderMaterialDetail)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.orderMaterial.isChecked),
        expression: "item.orderMaterial.isChecked"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isDisabled(item)
      },
      domProps: {
        "value": item.orderMaterial.orderMaterialId,
        "checked": Array.isArray(item.orderMaterial.isChecked) ? _vm._i(item.orderMaterial.isChecked, item.orderMaterial.orderMaterialId) > -1 : (item.orderMaterial.isChecked)
      },
      on: {
        "change": function($event) {
          var $$a = item.orderMaterial.isChecked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.orderMaterial.orderMaterialId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item.orderMaterial, "isChecked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item.orderMaterial, "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item.orderMaterial, "isChecked", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px",
        "margin-left": "15px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": item.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "outer1 flex-col"
    }, [_c('span', {
      staticClass: "word2"
    }, [_vm._v(_vm._s(item.orderMaterial.materialDesc))]), _vm._v(" "), _c('span', {
      staticClass: "txt4"
    }, [_vm._v("用于" + _vm._s(item.orderMaterial.euName))])]), _vm._v(" "), (item.orderMaterialDetail && item.orderMaterialDetail.fileName) ? _c('div', [_c('img', {
      staticClass: "label2",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(item.orderMaterialDetail.fileName)
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.disAllowUploadOrDelete(item)),
        expression: "!disAllowUploadOrDelete(item)"
      }],
      staticClass: "icon5",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/删除.svg'
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(item)
        }
      }
    })]) : _c('div', {
      staticClass: "upload"
    }, [_c('img', {
      staticClass: "upload-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/上传.svg'
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "uplaod-input",
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile($event, item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "upload-word"
    }, [_vm._v("上传文档")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mod6"
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("\n      请勾选您本次寄出的物品，务必完整填写《实物信息表》全部相关信息，将文档直接上传。推荐在电脑端使用小程序完成上传操作。\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "txt",
    on: {
      "click": _vm.showMiniProgramInComputerUsage
    }
  }, [_vm._v("查看小程序在电脑端的使用方法")])]), _vm._v(" "), _c('span', {
    staticClass: "secondary-title"
  }, [_vm._v("寄出快递")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "wrap flex-col"
  }, [_c('div', {
    staticClass: "box7 flex-row"
  }, [_c('img', {
    staticClass: "icon9",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/地址.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "address-content"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.ADDRESS))]), _vm._v(" "), _c('button', {
    staticClass: "group2 flex-col",
    attrs: {
      "data-clipboard-text": '收件人姓名：' + _vm.emkt.DELIVERY_ADDRESS.RECEIVER + '\n电话：' + _vm.emkt.DELIVERY_ADDRESS.PHONE + '\n地址信息：' + _vm.emkt.DELIVERY_ADDRESS.ADDRESS,
      "id": "tag-copy"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "box8 flex-row"
  }, [_c('span', {
    staticClass: "info4"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.RECEIVER))]), _vm._v(" "), _c('span', {
    staticClass: "info4"
  }, [_vm._v(_vm._s(_vm.emkt.DELIVERY_ADDRESS.PHONE))])]), _vm._v(" "), _c('div', {
    staticClass: "line flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "box10 flex-row"
  }, [_c('img', {
    staticClass: "outer4",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/顺丰logo.svg'
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "delivery-icon flex-col"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.openShunFengProgram
    }
  }, [_vm._v("打开")])])])]), _vm._v(" "), _c('img', {
    staticClass: "delivery flex-col",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/express.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('van-row', _vm._l((_vm.expressCategoryList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": 24 / _vm.expressCategoryList.length
      }
    }, [_c('van-button', {
      staticClass: "express-category",
      attrs: {
        "round": "",
        "size": "small",
        "block": "",
        "plain": _vm.plain[index],
        "color": "#5878FA"
      },
      on: {
        "click": function($event) {
          return _vm.onChange(index)
        }
      }
    }, [_vm._v(_vm._s(item))])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.plain[0]) ? _c('div', [_c('span', {
    staticClass: "secondary-title"
  }, [_vm._v("填写快递单号")]), _vm._v(" "), _c('ul', {
    staticClass: "express-block"
  }, _vm._l((_vm.expressList), function(express, index) {
    return _c('li', {
      staticClass: "express-content",
      class: {
        'active': index === _vm.expressIndex
      },
      on: {
        "click": function($event) {
          return _vm.chooseExpress(express, index)
        }
      }
    }, [_c('img', {
      staticClass: "icon-express",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'express/' + express + '.png'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "express-font"
    }, [_vm._v(_vm._s(express))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block9 flex-col"
  }, [_c('div', {
    staticClass: "bd4 flex-col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressNo),
      expression: "expressNo",
      modifiers: {
        "trim": true
      }
    }],
    ref: "content",
    staticClass: "word19",
    attrs: {
      "type": "text",
      "placeholder": "请输入快递单号"
    },
    domProps: {
      "value": (_vm.expressNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expressNo = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "save-btn",
    on: {
      "click": _vm.saveSampleDelivery
    }
  }, [_c('span', {
    staticClass: "save-tag"
  }, [_vm._v("保存")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style",
    staticStyle: {
      "margin-top": "10px",
      "width": "20px",
      "height": "20px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "paragraph1"
  }, [_vm._v("\n          打开顺丰小程序\n          "), _c('br'), _vm._v("\n          选择货到付款，快捷寄件\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attribute.sorteditAble === false) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "选基因",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[10].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[8].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("物种")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[9].valueText
    }
  })])])]) : _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "text",
      "placeholder": "选基因",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[10].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[8].valueText
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("物种")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.curAttrsInGroup[9].valueText
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("新增发票寄送地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefaultString),
      expression: "expressInfo.isDefaultString"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefaultString) ? _vm._i(_vm.expressInfo.isDefaultString, null) > -1 : (_vm.expressInfo.isDefaultString)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefaultString,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefaultString", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-activities/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    近些年"), _c('br'), _vm._v("吉凯每个月都会定期举办丰富多彩的"), _c('br'), _vm._v("市场活动"), _c('br'), _vm._v("您一共参加过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.campaignTimes))]), _vm._v("活动\n  ")]), _vm._v(" "), (_vm.activities.length > 0) ? _c('div', {
    staticClass: "main-text-2 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    2024年之前 您参加了\n    "), _vm._l(([0, 1, 2]), function(i) {
    return _c('p', {
      key: i,
      staticClass: "activities-list"
    }, [_vm._v(_vm._s(_vm.activities[i]))])
  }), _vm._v(" "), _c('p', {
    staticClass: "activities-list"
  }, [_vm._v(_vm._s(_vm.activities.length > 3 ? '...' : ''))])], 2) : _vm._e(), _vm._v(" "), (_vm.activitiesThisYear.length > 0) ? _c('div', {
    staticClass: "main-text-3 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    今年您参加了\n    "), _vm._l(([0, 1, 2]), function(i) {
    return _c('p', {
      key: i,
      staticClass: "activities-list"
    }, [_vm._v(_vm._s(_vm.activitiesThisYear[i]))])
  }), _vm._v(" "), _c('p', {
    staticClass: "activities-list"
  }, [_vm._v(_vm._s(_vm.activitiesThisYear.length > 3 ? '...' : ''))])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "msgApp"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.toMessageManagement()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    staticStyle: {
      "align-content": "center",
      "font-size": "smaller"
    }
  }, [_vm._v(_vm._s(_vm.Messages.merchantName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('dialoguecontent', {
    attrs: {
      "messages": _vm.Messages.messages
    }
  }), _vm._v(" "), _c('textcontent', {
    attrs: {
      "merchantNo": _vm.Messages.merchantNo,
      "messages": _vm.Messages.messages
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind_block"
  }, [(!_vm.remindParams.register) ? _c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.remindParams.firstline))])]), _vm._v(" "), _c('div', {
    staticClass: "infoWrap_2"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v(_vm._s(_vm.remindParams.secondline))])]), _vm._v(" "), (_vm.remindParams.singleOrDouble === 2) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag research-font-color"
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": _vm.confirm
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])]) : _vm._e(), _vm._v(" "), (_vm.remindParams.singleOrDouble === 1) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col3 research-background-color",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])]) : _vm._e()])]) : _c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_register"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col3 research-background-color",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info_register"
  }, [_vm._v("吉凯基因淘基因线上平台用户注册协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap_register"
  }, [_c('div', {
    staticClass: "textArea",
    staticStyle: {
      "height": "18rem"
    },
    attrs: {
      "readonly": "true"
    }
  }, [_vm._v("本协议是用户（以下简称“您”）与吉凯基因淘基因线上平台（以下简称“淘基因”）及其关联公司之间就吉凯基因数字营销服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击\"同意\"按钮后，即视为您接受并同意遵守本协议的约定。\n          "), _c('br'), _vm._v("第1条 本站服务条款的确认和接纳\n          "), _c('br'), _c('strong', [_vm._v("1.1")]), _vm._v("本站的各项电子服务的所有权和运作权归淘基因所有。您同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。您确认：本协议条款是处理双方权利义务的依据，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定或约定。\n          "), _c('br'), _c('strong', [_vm._v("1.2")]), _vm._v("您点击同意本协议的，即视为您确认自己具有享受本站服务相应的权利能力和行为能力，能够独立承担法律责任。\n          "), _c('br'), _c('strong', [_vm._v("1.3")]), _vm._v("您确认，如果您在18周岁以下，您只能在父母或其他监护人的监护参与下才能使用本站。\n          "), _c('br'), _c('strong', [_vm._v("1.4")]), _vm._v("淘基因保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n          "), _c('br'), _c('strong', [_vm._v("1.5")]), _vm._v("您使用本站提供的服务时，应同时接受适用于本站特定服务、活动等的准则、条款和协议（以下统称为“其他条款”）；如果以下使用条件与“其他条款”有不一致之处，则以“其他条款”为准。\n          "), _c('br'), _c('strong', [_vm._v("1.6")]), _vm._v("为表述便利，商品和各类技术服务简称为“商品”或“货物”。\n          "), _c('br'), _vm._v("第2条 本站服务\n          "), _c('br'), _c('strong', [_vm._v("2.1")]), _vm._v("吉凯基因淘基因通过互联网依法为您提供产品及技术支持等服务，您在完全同意本协议及本站相关规定的情况下，方有权使用本站的相关服务。\n          "), _c('br'), _c('strong', [_vm._v("2.2")]), _vm._v("您必须自行准备如下设备和承担如下开支：\n          "), _c('br'), _c('strong', [_vm._v("2.2.1")]), _vm._v("上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；\n          "), _c('br'), _c('strong', [_vm._v("2.2.2")]), _vm._v("上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。\n          "), _c('br'), _vm._v("第3条 用户信息收集及保护\n          "), _c('br'), _c('strong', [_vm._v("3.1")]), _vm._v("您应自行诚信向本站提供注册资料，您保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且吉凯基因保留单方终止您使用淘基因各项服务的权利。\n          "), _c('br'), _c('strong', [_vm._v("3.2")]), _vm._v("您在本站进行注册、浏览、下单购物、评价、参加活动等行为时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情、评价或反馈、投诉内容、cookies等信息的，本站有权从完成交易、提供配送、售后及客户服务、开展活动、完成良好的客户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密，除非得到您的授权、为履行强行性法律义务（如国家安全机关指令）或法律另有规定、本注册协议或其他条款另有约定外，本站不会向外界披露您的隐私信息。\n          "), _c('br'), _c('strong', [_vm._v("3.3")]), _vm._v("您注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。您应谨慎合理的保存、使用您的账户信息。您若发现任何非法使用您的账户或其他存在安全漏洞的情况的，请立即通知本站并向公安机关报案。\n          "), _c('br'), _c('strong', [_vm._v("3.4您同意，淘基因拥有通过邮件、短信、电话、网站通知或声明等形式，向在本站注册、购物的用户、收货人发送订单信息、促销活动、售后服务、客户服务等告知信息的权利。如您不希望接收上述信息，可退订。\n            "), _c('br'), _c('strong', [_vm._v("3.5")]), _vm._v("您同意：您选择向本站的商品销售商或服务提供商（以下统称为“销售商”，含淘基因及其关联公司）提交订单购买商品或服务的，视为您向销售商披露个人相关信息，接受销售商向您提供商品销售、配送、售后服务、客户服务、处理信用卡付款、数据分析、市场营销帮助或其他必要事宜；如前述全部或部分事宜之一涉及由销售商外的第三方履行的，销售商有权将您的信息以必要方式向第三方披露，第三方有权以履行上述事宜为目的联系您。\n            "), _c('br'), _c('strong', [_vm._v("3.6")]), _vm._v("您不得将在本站注册获得的账号、密码等账户信息提供给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。\n            "), _c('br'), _c('strong', [_vm._v("3.7")]), _vm._v("您同意，淘基因有权使用您的注册信息、用户名、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。")]), _vm._v(" "), _c('br'), _vm._v("第4条 用户依法言行义务\n          "), _c('br'), _vm._v("本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：\n          "), _c('br'), _c('strong', [_vm._v("4.1")]), _vm._v("不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n          "), _c('br'), _c('strong', [_vm._v("4.2")]), _vm._v("从中国大陆向境外传输资料信息时必须符合中国有关法律法规；\n          "), _c('br'), _c('strong', [_vm._v("4.3")]), _vm._v("不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n          "), _c('br'), _c('strong', [_vm._v("4.4")]), _vm._v("不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；\n          "), _c('br'), _c('strong', [_vm._v("4.5")]), _vm._v("不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；\n          "), _c('br'), _c('strong', [_vm._v("4.6")]), _vm._v("不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n          "), _c('br'), _c('strong', [_vm._v("4.7")]), _vm._v("不得教唆他人从事本条所禁止的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8")]), _vm._v("除本注册协议、其他条款或另有其他约定外，您不得利用在本站注册的账户进行经营活动、牟利行为及其他未经本站许可的行为，包括但不限于以下行为：\n          "), _c('br'), _c('strong', [_vm._v("4.8.1")]), _vm._v("您账户内的任何淘基因优惠信息（包括但不限于优惠券、折扣券、产品赠送券及其他形式优惠或折扣等）由吉凯基因享有解释权和修改权，您仅享有在淘基因购物时的使用权，严禁转卖淘基因账户、优惠券、折扣券、产品赠送券或其他类型的优惠券、或利用淘基因账户进行其他经营性行为等；\n          "), _c('br'), _c('strong', [_vm._v("4.8.2")]), _vm._v("恶意利用技术手段或其他方式，为获取优惠、折扣或其他利益而注册账户、下单等行为，影响其他用户正常消费行为或相关合法权益、影响淘基因正常销售秩序的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.3")]), _vm._v("发布广告、垃圾邮件；\n          "), _c('br'), _c('strong', [_vm._v("4.8.4")]), _vm._v("以再销售或商业使用为目的对本站商品或服务进行购买的（与吉凯基因另有合同约定的除外）；\n          "), _c('br'), _c('strong', [_vm._v("4.8.5")]), _vm._v("商品或服务的供应商、代理商对其所供商品进行回购的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.6")]), _vm._v("任何对商品目录、说明、价格、数量、其他用户信息或其他内容的下载、转载、收集、衍生利用、复制、出售、转售或其他形式的使用，无论是否通过Robots、Spiders、自动仪器或手工操作；\n          "), _c('br'), _c('strong', [_vm._v("4.8.7")]), _vm._v("本站相关规则、政策、或网页活动规则中限制、禁止的行为；\n          "), _c('br'), _c('strong', [_vm._v("4.8.8")]), _vm._v("其他影响淘基因对用户账户正常管理秩序的行为。\n          "), _c('br'), _c('strong', [_vm._v("4.9")]), _vm._v("您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则淘基因有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案。\n          "), _c('br'), _c('strong', [_vm._v("4.10")]), _vm._v("您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现您发布的信息涉嫌知识产权、或其他合法权益争议的，这些用户或权利人有权要求淘基因删除您发布的信息，或者采取其他必要措施予以制止，淘基因将会依法采取这些措施。\n          "), _c('br'), _c('strong', [_vm._v("4.11")]), _vm._v("您应不时关注并遵守本站不时公布或修改的各类规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知您的权利。\n          "), _c('br'), _c('strong', [_vm._v("4.12")]), _vm._v("您未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭您的账号、冻结账号内金额、关闭相应交易订单、停止发货等措施。您须对自己在网上的言论和行为承担法律责任。\n          "), _c('br'), _vm._v("第5条 商品信息\n          "), _c('br'), _c('strong', [_vm._v("5.1")]), _vm._v("本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；淘基因欢迎纠错，并会视情况给予纠错者一定的奖励。\n          "), _c('br'), _c('strong', [_vm._v("5.2")]), _vm._v("本站售后服务政策为本协议的组成部分，淘基因有权以声明、通知或其他形式变更售后服务政策。\n          "), _c('br'), _vm._v("第6条 订单\n          "), _c('br'), _c('strong', [_vm._v("6.1")]), _vm._v("在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、周期、产品性状、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。\n          "), _c('br'), _c('strong', [_vm._v("6.2")]), _vm._v("除法律另有强制性规定外，双方约定如下：本站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售商发出的合同要约；当您确认订单信息，并且在线点击“确认下单”后，进入下单成功页面，即视为您与销售商之间就您采购的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售商只给您发出了部分商品时，您与销售商之间仅就实际直接向您发出的商品建立了合同关系；只有在销售商实际直接向您发出了订单中订购的其他商品时，您和销售商之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登陆您在本站注册的账户，查询您的订单状态。\n          "), _c('br'), _c('strong', [_vm._v("6.3尽管销售商做出最大的努力，但商品目录里的一小部分商品可能会有定价错误。如果发现错误定价，将采取下列之一措施，且不视为违约行为：\n            "), _c('br'), _vm._v("6.3.1如果某一商品的正确定价低于销售商的错误定价，销售商将按照较低的定价向您销售交付该商品。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.3.2如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。\n            "), _c('br'), _vm._v("6.4由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您下单所购买的商品，发生缺货，您有权取消订单，销售商亦有权取消订单，并为已付款的用户办理退款。")]), _vm._v(" "), _c('br'), _vm._v("第7条 配送\n          "), _c('br'), _c('strong', [_vm._v("7.1")]), _vm._v("销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。\n          "), _c('br'), _c('strong', [_vm._v("7.2")]), _vm._v("因如下情况造成订单延迟或无法配送、交货等，销售商不承担延迟配送、交货的责任：\n          "), _c('br'), _c('strong', [_vm._v("（1）")]), _vm._v("您提供的信息错误、地址不详细等原因导致的；\n          "), _c('br'), _c('strong', [_vm._v("（2）")]), _vm._v("货物送达后无人签收，导致无法配送或延迟配送的；\n          "), _c('br'), _c('strong', [_vm._v("（3）")]), _vm._v("情势变更因素导致的；\n          "), _c('br'), _c('strong', [_vm._v("（4）")]), _vm._v("未能在本站所示的送货参考时间内送货的；\n          "), _c('br'), _c('strong', [_vm._v("（5）")]), _vm._v("因节假日、大型促销活动、店庆、预购或抢购人数众多等原因导致的；\n          "), _c('br'), _c('strong', [_vm._v("（6）")]), _vm._v("不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n          "), _c('br'), _vm._v("第8条 所有权及知识产权条款\n          "), _c('br'), _c('strong', [_vm._v("8.1您一旦接受本协议，即表明您主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给淘基因所有，您同意吉凯基因有权就任何主体侵权而单独提起诉讼。\n            "), _c('br'), _vm._v("8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在淘基因上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。\n            "), _c('br'), _vm._v("8.3您同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其他主体以任何方式使用（包括但限于在各类网站、媒体上使用）。\n            "), _c('br'), _vm._v("8.4淘基因有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知您。在法律允许的最大限度范围内，淘基因对本协议及本站内容拥有解释权。\n            "), _c('br'), _vm._v("8.5除法律另有强制性规定外，未经淘基因明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，淘基因有权追究其法律责任。 ")]), _vm._v(" "), _c('br'), _c('strong', [_vm._v("8.6")]), _vm._v("站所刊登的资料信息（包括但不限于文字、图表、商标、logo、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件等），均是淘基因或其内容提供者的财产，受中国和国际相关版权法规、公约等的保护，未经淘基因书面许可，任何第三方无权将上述资料信息复制、出版、发行、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。本站上所有内容的汇编是淘基因的排他财产，受中国和国际版权法的保护。本站上所有软件都是淘基因或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分软件，或利用软件创设衍生产品。\n          "), _c('br'), _vm._v("第9条 责任限制及不承诺担保\n          "), _c('br'), _c('strong', [_vm._v("9.1")]), _vm._v("除非另有明确的书面说明,本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。\n          "), _c('br'), _c('strong', [_vm._v("9.2")]), _vm._v("除非另有明确的书面说明, 淘基因不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。\n          "), _c('br'), _c('strong', [_vm._v("9.3")]), _vm._v("淘基因不担保本站所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。\n          "), _c('br'), _c('strong', [_vm._v("9.4")]), _vm._v("如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，淘基因会合理地尽力协助处理善后事宜。\n          "), _c('br'), _c('strong', [_vm._v("9.5")]), _vm._v("您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，您应承担全部责任。同时，因网络环境存在众多不可预知因素，因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的淘基因账户或个人信息等被第三方窃取的，淘基因不承担赔偿责任。\n          "), _c('br'), _c('strong', [_vm._v("9.6")]), _vm._v("您了解并同意，吉凯基因有权应国家有关机关的要求，向其提供您在淘基因的用户信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则吉凯基因有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。\n          "), _c('br'), _vm._v("第10条 协议更新及用户关注义务\n          "), _c('br'), _vm._v("根据国家法律法规变化及网站运营需要，吉凯基因有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议、其他条款及网站公告。如您不同意更新后的协议，可以且应立即停止接受淘基因依据本协议提供的服务；如您继续使用本站提供的服务的，即视为同意更新后的协议。淘基因建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n          "), _c('br'), _vm._v("第11条 法律管辖和适用\n          "), _c('br'), _vm._v("本协议的订立、执行和解释及争议的解决均适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的"), _c('span', {
    staticClass: "background"
  }, [_vm._v("上海市徐汇区人民法院")]), _vm._v("提起诉讼。\n          "), _c('br'), _vm._v("第12条 其他\n          "), _c('br'), _c('strong', [_vm._v("12.1")]), _vm._v("淘基因所有者是指在政府部门依法许可或备案的吉凯基因网站经营主体。\n          "), _c('br'), _c('strong', [_vm._v("12.2")]), _vm._v("淘基因尊重您的合法权利，本协议及本站上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。本站欢迎您和社会各界提出意见和建议，淘基因将虚心接受并适时修改本协议及本站上的各类规则。\n          "), _c('br'), _c('strong', [_vm._v("12.3")]), _vm._v("本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请您着重阅读。\n          "), _c('br'), _c('strong', [_vm._v("12.4")]), _vm._v("您点击本协议下方的“同意并继续”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。\n        ")])])
}]}

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.merchandises), function(merchandise, index) {
    return _c('div', {
      staticClass: "product-detail"
    }, [_c('img', {
      staticClass: "product-label",
      attrs: {
        "src": _vm.getPayOrderMerchandiseLabelPath(merchandise)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(merchandise.merchandiseDetailForClient && merchandise.merchandiseDetailForClient.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [(merchandise._titleList && merchandise._titleList.length > 0) ? _c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, _vm._l((merchandise._titleList), function(title) {
      return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (merchandise._subTitleList && merchandise._subTitleList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font"
    }, _vm._l((merchandise._subTitleList), function(subTitle, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (merchandise._abstractList && merchandise._abstractList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font"
    }, _vm._l((merchandise._abstractList), function(abstractTitle, index) {
      return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(merchandise.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "price-info"
    }, [(_vm.getMerchandiseDiscount(merchandise) < 1) ? _c('span', {
      staticClass: "alert-text tiny-font bold-text"
    }, [_vm._v(_vm._s(_vm.getMerchandiseCategory(merchandise)) + _vm._s(_vm.getMerchandiseDiscount(merchandise)) + "折")]) : _vm._e(), _vm._v(" "), (_vm.getMerchandiseInitPrice(merchandise) > merchandise.price) ? _c('span', {
      staticClass: "light-text-color tiny-font",
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.getMerchandiseInitPrice(merchandise))))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "research-font-color bold-text"
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [(_vm.catalogueTotalPrice > _vm.goodsPrice) ? _c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.catalogueTotalPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.goodsPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("运费")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-gantanhao light-text-color",
    staticStyle: {
      "font-size": "13px"
    },
    on: {
      "click": _vm.showExpressMessage
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.expressFee)))])]), _vm._v(" "), (_vm.showCashCoupon) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.cashCoupon.value)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.totalCount) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.totalPrice)))])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: ({
      minHeight: _vm.boxheight
    })
  }, _vm._l((_vm.pdfList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pdfList-box",
      on: {
        "click": function($event) {
          return _vm.pdfRouter(item)
        }
      }
    }, [_c('div', {
      staticClass: "left-layout"
    }, [_c('img', {
      staticClass: "icon-pdf-style",
      attrs: {
        "src": __webpack_require__(312)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pdf-desc"
    }, [_c('div', {
      staticClass: "pdf-name"
    }, [_vm._v(_vm._s(item.fileName))]), _vm._v(" "), _c('div', {
      staticClass: "pdf-size"
    }, [_vm._v(_vm._s(Math.round(item.fileSize / 1024)) + "KB")])])]), _vm._v(" "), _c('img', {
      staticClass: "icon-right-arrow-style",
      attrs: {
        "src": __webpack_require__(1230)
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [(_vm.ssoFlag === 0) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder'
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1) : _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "查询基因/产品名称……",
      "readonly": "",
      "unselectable": "on"
    },
    on: {
      "click": _vm.onSearchClicked
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("过表达/干扰现货慢病毒")]), _vm._v(" "), _c('div', {
    staticClass: "newCategory-items"
  }, _vm._l((_vm.newList), function(o) {
    return _c('div', {
      staticClass: "newCategory-item",
      on: {
        "click": function($event) {
          return _vm.todCategoryDetailnew(o)
        }
      }
    }, [_c('div', {
      staticClass: "item-label"
    }, [_vm._v(_vm._s(o.label))]), _vm._v(" "), _c('img', {
      staticClass: "imgs",
      attrs: {
        "src": _vm.baseurl + o.srcImg
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("现货产品\n        ")]), _vm._v(" "), _vm._l((_vm.tabs1), function(tabs) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [(tabs[3]) ? _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[1].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[2].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[3]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[3].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[3].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel)
        }
      }
    })]) : _vm._e()]) : _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[0] && !tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "6.5%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[1].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[2].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div')]) : _vm._e(), _vm._v(" "), (!tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('div')]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.ssoFlag !== 1) ? _c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("更多产品\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tabs2), function(tabs) {
    return (_vm.ssoFlag !== 1) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [(tabs[3]) ? _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[3]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[3].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel)
        }
      }
    })]) : _vm._e()]) : _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[0] && !tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "6.5%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div')])
}]}

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_vm._l((_vm.findFiltersItems(_vm.findFilters)), function(filter) {
    return _c('div', [_c('div', {
      staticClass: "content-block-title filter-title"
    }, [_vm._v(_vm._s(filter.groupName) + "\n          "), (filter.tips) ? _c('a', {
      staticClass: "alert-text",
      on: {
        "click": function($event) {
          return _vm.displayMessage(filter)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": ".9rem"
      },
      attrs: {
        "src": _vm.questionUrl
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-block filter-block"
    }, [_c('ul', {
      staticClass: "filter-block-ul"
    }, [_c('li', {
      staticClass: "item-content filter-opts"
    }, [_vm._l((_vm.filterItems(filter)), function(item, inx) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el filter-el"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.selected),
          expression: "item.selected"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": item.disabled
        },
        domProps: {
          "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
        },
        on: {
          "change": [function($event) {
            var $$a = item.selected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(item, "selected", $$c)
            }
          }, function($event) {
            return _vm.queryHandler()
          }]
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media checkbox filter-checkbox",
        class: {
          selected: item.selected, disabled: item.disabled
        }
      }, [_c('div', {
        staticClass: "span-text"
      }, [_vm._v(_vm._s(item.word))])])])
    }), _vm._v(" "), (filter.filterItems.length > 8 & !filter.expanded) ? _c('label', {
      staticClass: "label-checkbox checkbox-el filter-el"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.expanded),
        expression: "filter.expanded"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(filter.expanded) ? _vm._i(filter.expanded, null) > -1 : (filter.expanded)
      },
      on: {
        "change": function($event) {
          var $$a = filter.expanded,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(filter, "expanded", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(filter, "expanded", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(filter, "expanded", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(0, true)]) : _vm._e()], 2)])])])
  }), _vm._v(" "), (_vm.findFilters.length > 3 & !_vm.expend & _vm.finderyemian) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#1e7be6",
      "font-size": ".7rem"
    },
    on: {
      "click": _vm.addmore
    }
  }, [_vm._v("更多筛选项..")])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media checkbox filter-checkbox more"
  }, [_c('div', {
    staticClass: "span-text"
  }, [_vm._v("更多...")])])
}]}

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anniversary-container swiper"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('van-loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "swiper-wrapper"
  }, [_c('page-start', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }), _vm._v(" "), _c('page-roadmap', {
    attrs: {
      "swiper": _vm.swiper
    }
  }), _vm._v(" "), _c('page-meet', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }), _vm._v(" "), (_vm.data && _vm.data.amount) ? _c('page-contract', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.amount && _vm.data.firstContractDate) ? _c('page-contract-first', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.amount && _vm.data.yearDiff) ? _c('page-contract-last', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.campaignTimes) ? _c('page-activities', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.registrationDate) ? _c('page-content', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('page-coupon', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('page-key-words', {
    attrs: {
      "swiper": _vm.swiper
    }
  }), _vm._v(" "), _c('page-key-words-reslut', {
    attrs: {
      "swiper": _vm.swiper
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("合同详情")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.contractInfo) ? _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同名称")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同编号")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractNo))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("线下合同编号")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractNoOffline))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同金额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.splitMoney(_vm.contractInfo.contractMoney)))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.payTypeString))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), (_vm.type === '交付' && _vm.selected === '累计') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同是否结清账款")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.isSettledString))])]), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.type === '交付' && _vm.selected === '累计') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("未结清账款金额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.notSettledMoneySum && _vm.splitMoney(_vm.contractInfo.notSettledMoneySum.toFixed(2))))])]), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("业务员")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.employeeName))])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("签署客户名称")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.signedCustomerName))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("签署客户单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.signedEnterpriseName))])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同启动日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractStartDT))])]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("生产状态")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.produceStatusString))])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("预计生产完结日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.expectedProduceEndDT))])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("发货状态")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.deliveryStatusString))])]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("发货日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.deliveryDT))])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), (_vm.type === '消费') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("待收账户余额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.waitPrepayAmount && _vm.splitMoney(_vm.contractInfo.waitPrepayAmount.toFixed(2))))])]), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.type === '交付') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("待收尾款")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.waitRetainage && _vm.splitMoney(_vm.contractInfo.waitRetainage.toFixed(2))))])]), _vm._v(" "), _vm._m(16)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box flex-col"
  }, _vm._l((_vm.fileList), function(file, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-block flex-col",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(file)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('img', {
      staticClass: "file-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(file.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(file.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(file.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "src": _vm.baseurl + _vm.merch.merchandiseIcon
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.commitComment
    }
  }, [_vm._v("提交评价")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("评价晒单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("评分")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "starts"
    }
  }, [_c('span', {
    staticClass: "icon icon-star",
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "rel": "1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-star",
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "rel": "2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-star",
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "rel": "3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-star",
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "rel": "4"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-star",
    staticStyle: {
      "background-color": "yellow"
    },
    attrs: {
      "rel": "5"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    attrs: {
      "id": "text",
      "placeholder": "请评价~"
    }
  })])])])])])
}]}

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机或邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.type === 'phone') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("激活")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("发送激活邮件")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("激活")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-container"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "info-box",
      class: _vm.selectIndex == index ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.onSelectTech(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tech-title",
      domProps: {
        "textContent": _vm._s(item.dictValue)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tech-desc",
      domProps: {
        "textContent": _vm._s(item.extraValue)
      }
    })])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("关注公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/publicnumber.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("关注吉凯基因公众号，参与更多精彩活动！")])])])])])])
}]}

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.veriCode),
      expression: "veriCode"
    }],
    staticStyle: {
      "width": "70%",
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("登录")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left goback",
    staticStyle: {
      "font-size": ".8rem"
    },
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (!_vm.isWapp) ? _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "4rem"
    }
  }, [_vm._v("\n           产品详情\n        ")]) : _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "7rem"
    }
  }, [_vm._v("\n           产品详情\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [(_vm.merchandises.specialAnnouncement) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.merchandises.showpromotion && _vm.merchandises.showpromotion.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [(_vm.merchandises.showpromotion[0].name !== '') ? _c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.merchandises.showpromotion), function(proo, index) {
    return _c('div', [(proo.type === 1 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : (proo.type === 6 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : _vm._e()])
  })], 2) : _vm._e()]) : _c('div', [(_vm.merchandises.bpromotions && _vm.merchandises.bpromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [(_vm.merchandises.bpromotions[0].name !== '') ? _c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.merchandises.bpromotions), function(proo, index) {
    return _c('div', [(proo.type === 1 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : (proo.type === 6 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    staticStyle: {
      "margin-top": "-.75rem"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('div', {
    staticClass: "list-block"
  }, [(_vm.merchandises.categoryId === 20) ? _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.valueText !== undefined && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.valueText !== undefined && attribute.value !== null && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.valueText !== undefined && attribute.value !== '214' && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "param:": _vm.$route.params.merchandises,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax !== undefined) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMax))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.price))])])]), _vm._v(" "), (_vm.merchandises.priceMin !== undefined) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMin))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])])]) : _vm._e()], 2) : _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== '' && attribute.value !== '214' && attribute.valueText !== undefined && attribute.columnName !== 'GeneInfo') ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.price))])])])], 2), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.introduces === '') ? _c('div', [_vm._v(_vm._s(_vm.merchandises.description))]) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName.split(';').length === 1) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "#0A7CE3"
    },
    on: {
      "click": function($event) {
        return _vm.gotomanual(_vm.merchandises.manualFileName)
      }
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#0A7CE3"
      },
      on: {
        "click": function($event) {
          return _vm.gotomanual(manualFileName)
        }
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))]), _vm._v(" "), (_vm.showmanul) ? _c('pdf-preview', {
      attrs: {
        "url": _vm.manualurl + manualFileName
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-tlnoImg"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.tlnoimgurl !== '') ? _c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.tlnoimgurl
    }
  })]) : _c('div', [_vm._v("\n                   无载体！\n                ")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n                    不同产品分装规则说明\n                    "), _c('div', [_vm._v("\n                      1.菌液:200μL/tube*1\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      2.质粒:不分装\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      3.慢病毒:50μL/tube\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      4.腺病毒:200μL/tube\n                    ")]), _c('div', [_vm._v("\n                    5.逆转录病毒:50μL/tube\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      6.腺相关病毒:50μL/tube\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result_container"
  }, [_c('div', {
    staticClass: "operation_box"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-duigou research-font-color",
    staticStyle: {
      "font-size": "60px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "main",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.displayResult))]), _vm._v(" "), _c('span', {
    staticClass: "submain",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "return-button research-background-color",
    on: {
      "click": _vm.goHome
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("返回主页")])]), _vm._v(" "), (_vm.ifShowLottery && _vm.lotteryUrl) ? _c('a', {
    attrs: {
      "href": _vm.lotteryUrl
    }
  }, [_c('img', {
    staticClass: "lottery-image",
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/首单抽奖.png"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.ifShowInstruction) ? _c('div', {
    staticClass: "modal-overlay modal-overlay-visible"
  }, [_c('div', {
    staticClass: "lottery-background"
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "left": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-self.png"
    },
    on: {
      "click": _vm.getCouponForSelf
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "right": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-gift.png"
    },
    on: {
      "click": _vm.getCouponForFriend
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "28px",
      "left": "260px",
      "top": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/lottery-close.png"
    },
    on: {
      "click": function($event) {
        _vm.ifShowInstruction = false
      }
    }
  }), _vm._v(" "), (_vm.promotions618Used && _vm.promotions618Used.length > 0) ? _c('div', {
    staticClass: "lottery-discount"
  }, [_vm._l((_vm.promotions618Used), function(pro) {
    return _c('div', [(_vm.promotions618Used.length === 1) ? _c('div', {
      staticStyle: {
        "line-height": "10px",
        "opacity": "0"
      }
    }, [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (pro.categoryId === 20) ? _c('div', [_vm._v("定制产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")]) : _c('div', [_vm._v("现货及质粒产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "scale(0.8)",
      "color": "#424242"
    }
  }, [_vm._v("使用截止日期2020.7.18")])], 2) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  })]) : _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right",
      "color": "rgb(8, 148, 236)"
    },
    attrs: {
      "type": "text",
      "value": "点我选基因/转录本",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("基因名")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.symbol
    }
  })]) : _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.symbol
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value === 4 || _vm.merchandises._attributes.ReguTech.value === 3 || _vm.merchandises._attributes.ReguTech.value === '4' || _vm.merchandises._attributes.ReguTech.value === '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("microName")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.microName
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value === 4 || _vm.merchandises._attributes.ReguTech.value === 3 || _vm.merchandises._attributes.ReguTech.value === '4' || _vm.merchandises._attributes.ReguTech.value === '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("microNo")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.microNo
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.CDSSize
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("物种")]), _vm._v(" "), (_vm.attribute.value.taxName) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.taxName
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal "
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.NMID
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('account')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "account",
      "placeholder": "帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "veriCode",
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('veriCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.type === 'phone') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("手机短信登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.BOrderComments), function(BOrderComment) {
    return _c('div', {
      staticClass: "card demo-card-header-pic"
    }, [_c('div', {
      staticClass: "card-header color-white no-border no-padding",
      attrs: {
        "valign": "bottom"
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + _vm.merch.merchandiseIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner"
    }, [_c('p', {
      staticClass: "color-gray"
    }, [_vm._v("发表于 " + _vm._s(BOrderComment.createDT))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(BOrderComment.comments))])])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "card-footer"
    }, [_c('span', [_vm._v("评价等级")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon icon-star",
      class: {
        star: BOrderComment.commentLevel >= 1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon icon-star",
      class: {
        star: BOrderComment.commentLevel >= 2
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon icon-star",
      class: {
        star: BOrderComment.commentLevel >= 3
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon icon-star",
      class: {
        star: BOrderComment.commentLevel >= 4
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "icon icon-star",
      class: {
        star: BOrderComment.commentLevel >= 5
      }
    })])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("评价详情")])])
}]}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [(_vm.showFilterBarFlag) ? _c('div', {
    staticClass: "nav-div"
  }, [_c('nav', {
    staticClass: "bar bar-nav merbar",
    staticStyle: {
      "padding-left": "0rem",
      "padding-right": "0rem"
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.queryTotal.total))]), _vm._v("条结果")]), _vm._v(" "), (!_vm.showFilterBarForKit) ? _c('div', {
    staticStyle: {
      "color": "#0a8ddf",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    on: {
      "click": function($event) {
        return _vm.openshaxuan()
      }
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (Number(this.$route.query.id) === 5 || Number(this.$route.query.id) === 8 || Number(this.$route.query.id) === 14 || Number(this.$route.query.id) === 7 || Number(this.$route.query.id) === 9 || this.$route.name === 'searchresults') ? _c('div', {
    staticStyle: {
      "height": "2.2rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0rem"
    }
  }, [_c('ul', {
    staticClass: "list-container",
    staticStyle: {
      "border-top": "0px solid #e7e7e7"
    }
  }, _vm._l((_vm.merchListWithoutCustomized10), function(pro) {
    return _c('li', [(_vm.description === 'group') ? _c('div', {
      staticStyle: {
        "padding-left": ".5rem"
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name) + "\n                     ")])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].type !== 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name) + "\n                       ")])]) : _vm._e(), _vm._v(" "), (pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [_c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    })]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type === '6') ? _c('div', {
      staticClass: "item-after"
    }, [_c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")]), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((pro._specificatList), function(specificat) {
      return (pro._specificatList && pro._specificatList.length > 0) ? _c('span', {
        staticStyle: {
          "margin-left": "3px",
          "font-size": "small",
          "color": "#4479B4"
        }
      }, [_vm._v(_vm._s(specificat.label) + ": " + _vm._s(specificat.valueText))]) : _vm._e()
    }), 0), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])]) : _c('div', {
      staticStyle: {
        "padding-left": ".5rem"
      }
    }, [(!pro.composite) ? _c('div', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")]), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "margin-bottom": ".5rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])]) : _c('div', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.setdatas(pro)
        }
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(pro.priceMin !== pro.priceMax) ? _c('span', [_vm._v("\n                       ¥" + _vm._s(pro.priceMin) + " ~ ¥" + _vm._s(pro.priceMax) + "\n                    ")]) : _c('span', [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")])]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('div', [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.merchListWithoutCustomized10), function(pro) {
    return _c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMin))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])]), _vm._v(" "), _vm._m(0, true)])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "margin-bottom": ".5rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": ".5rem"
    }
  }, [_c('span', {
    staticClass: "sub-span"
  }, [_vm._v("现货")])])
}]}

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPlaceHolder) ? _c('div', {
    staticStyle: {
      "height": "35px",
      "visibility": "hidden"
    }
  }, [_vm._v("占位")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('div', [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.merchList), function(pro) {
    return _c('li', [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "my-checkbox"
      }
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, _vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMin))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])]), _vm._v(" "), _vm._m(1, true)])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": ".5rem"
    }
  }, [_c('span', {
    staticClass: "sub-span"
  }, [_vm._v("现货")]), _vm._v(" "), _c('span', {
    staticClass: "sub-span"
  }, [_vm._v("减券")])])
}]}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_date"
  }, [_c('span', {
    staticClass: "year"
  }, [_vm._v("年份")]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.yearList), function(year) {
    return _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      staticClass: "radio-input-month",
      attrs: {
        "type": "radio",
        "name": "attr_month"
      },
      domProps: {
        "value": year
      }
    }), _vm._v(" "), _c('div', {
      class: {
        'col1': true, 'research-background-color': _vm.isSelectedYear[year]
      },
      on: {
        "click": function($event) {
          return _vm.updateYear(year)
        }
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(year) + "年")])])])
  }), 0), _vm._v(" "), (_vm.monthOrYear === 'month') ? _c('span', {
    staticClass: "month"
  }, [_vm._v("月份")]) : _vm._e(), _vm._v(" "), (_vm.monthOrYear === 'month') ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.monthList), function(month) {
    return _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      staticClass: "radio-input-month",
      attrs: {
        "type": "radio",
        "name": "attr_month"
      },
      domProps: {
        "value": month
      }
    }), _vm._v(" "), _c('div', {
      class: {
        'col1_month': true, 'research-background-color': _vm.isSelectedMonth[month]
      },
      on: {
        "click": function($event) {
          return _vm.updateMonth(month)
        }
      }
    }, [_c('span', {
      staticClass: "tag_month"
    }, [_vm._v(_vm._s(month) + "月")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_ok"
  }, [_c('div', {
    staticClass: "tagWrap_ok research-background-color",
    on: {
      "click": _vm.confirm
    }
  }, [_c('span', {
    staticClass: "tag_ok"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.researchGroupDetailList), function(researchGroup, index) {
    return _c('div', {
      key: index,
      staticClass: "block_researchgroup"
    }, [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      staticClass: "radio-input-attr",
      attrs: {
        "type": "radio",
        "name": "attr",
        "value": "researchGroup.researchGroupName"
      },
      domProps: {
        "checked": researchGroup.researchGroupNo === _vm.displayChosenResearchGroup.researchGroupNo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media group",
      on: {
        "click": function($event) {
          return _vm.updateResearchGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox i-style"
    }), _vm._v(" "), _c('span', {
      staticClass: "info_2"
    }, [_vm._v(_vm._s(researchGroup.researchGroupName))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateChosenResearchGroup()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("切换课题组")])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择课题组")])])
}]}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "60px",
      "font-size": "14px",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#424242",
      "line-height": "20px"
    }
  }, [_vm._v("\n           开票抬头\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _vm._l((_vm.payEnterpriseList), function(payEnterprise, index) {
    return _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "border-bottom": ".5px solid #efeef3"
      }
    }, [_c('div', {
      class: _vm.getMainClass(payEnterprise)
    }, [_c('div', {
      staticClass: "open-popup open-enterprise",
      staticStyle: {
        "margin-top": "10px",
        "margin-left": "5px"
      },
      attrs: {
        "data-popup": ".popup-invoice-title"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, false)
        }
      }
    }, [_vm._v("\n               " + _vm._s(_vm.getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)) + "\n               "), (!payEnterprise.enterpriseInvoiceTitle) ? _c('span', [_vm._v("\n                点击搜索单位\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      style: (_vm.getMainStyle(payEnterprise))
    }, [(_vm.canAddPayEnterprise) ? _c('span', {
      staticStyle: {
        "padding-right": "5px"
      }
    }, [_c('img', {
      staticClass: "icon6",
      staticStyle: {
        "width": "17px",
        "height": "12px"
      },
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/修 改.svg"
      },
      on: {
        "click": function($event) {
          return _vm.openSerchPayEnterprise(index, true)
        }
      }
    })]) : _vm._e()])])]), _vm._v(" "), _c('div', [(_vm.canAddPayEnterprise) ? _c('img', {
      staticClass: "icon5",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/删减.svg"
      },
      on: {
        "click": function($event) {
          return _vm.removePayEnterprise(index)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAddPayEnterprise),
      expression: "canAddPayEnterprise"
    }],
    staticClass: "block-item",
    on: {
      "click": _vm.addPayEnterprise
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "del-btn",
    on: {
      "click": function($event) {
        return _vm.toPayInvoice()
      }
    }
  }, [_c('span', {
    staticClass: "tag",
    staticStyle: {
      "color": "#5878fa"
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-btn",
    on: {
      "click": function($event) {
        return _vm.submitPayEnterprise()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确定修改")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("增加开票抬头")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "label7",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/增加备份.svg"
    }
  })])
}]}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSsoFlag) ? _c('order-content', {
    attrs: {
      "buttonName": "下一步",
      "coupons": _vm.coupons,
      "selectCoupon": _vm.selectCoupon,
      "productInfo": _vm.productInfo,
      "showpromotion": true,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.orderSubmit,
      "updateSelectCoupon": _vm.updateSelectCoupon
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "item-link item-content",
    on: {
      "click": _vm.goToMyCoupons
    }
  }, [_c('div', {
    staticClass: "item-inner item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("优　惠　券")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.coupons.value.length === 0) ? _c('span', [_vm._v("无")]) : (_vm.selectCoupon) ? _c('span', [(_vm.selectCoupon.label.indexOf('折券') !== -1) ? _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label) + "..")]) : _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label))]), _vm._v(" "), (_vm.selectCoupon.type !== 0 && _vm.selectCoupon.type !== 6) ? _c('span', [_vm._v(_vm._s(_vm._f("currencyStyle")(_vm.selectCoupon.value)))]) : _vm._e()]) : _c('span', [_vm._v("共" + _vm._s(_vm.coupons.value.length) + "张")])])])])])])])]) : _c('order-content', {
    attrs: {
      "buttonName": "提交审核",
      "coupons": _vm.coupons,
      "showpromotion": true,
      "selectCoupon": _vm.selectCoupon,
      "productInfo": _vm.productInfo,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.checkSubmit,
      "updateSelectCoupon": _vm.updateSelectCoupon
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "item-link item-content",
    on: {
      "click": _vm.goToMyCoupons
    }
  }, [_c('div', {
    staticClass: "item-inner item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("优　惠　券")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.coupons.value.length === 0) ? _c('span', [_vm._v("无")]) : (_vm.selectCoupon) ? _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label)), (_vm.selectCoupon.type !== 0 && _vm.selectCoupon.type !== 6) ? _c('span', [_vm._v(_vm._s(_vm._f("currencyStyle")(_vm.selectCoupon.value)))]) : _vm._e()]) : _c('span', [_vm._v("共" + _vm._s(_vm.coupons.value.length) + "张")])])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "2.5rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.pro.imageUrl
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('merchdata', {
    attrs: {
      "merchList": _vm.merchandise,
      "description": _vm.$route.query.des,
      "proo": _vm.$route.params.pro
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    staticStyle: {
      "margin-bottom": "5rem"
    },
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "输入商品...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])
}]}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    style: ({
      'height': _vm.boxHeight
    })
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("订单详情")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order),
      expression: "order"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 1),
      expression: "status===1"
    }],
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('span', {
    staticClass: "info",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("下单成员：" + _vm._s(_vm.order.orderPerson))]), _vm._v(" "), _c('span', {
    staticClass: "price",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("单笔订单限额：\n        "), (_vm.memberInfo.approveThreshold !== undefined) ? _c('span', [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.memberInfo.approveThreshold)))]) : _c('span', [_vm._v("无")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('div', {
    staticClass: "priceWrap"
  }, [_c('span', {
    staticClass: "info_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("本月累计消费 ：")]), _vm._v(" "), _c('span', {
    staticClass: "price_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("¥" + _vm._s(_vm.splitMoney(_vm.monthlyTotalApprovedAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "money",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("单月累计限额：\n        "), (_vm.memberInfo.monthlyLimit !== undefined) ? _c('span', [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.memberInfo.monthlyLimit)))]) : _c('span', [_vm._v("无")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    style: ({
      'margin-top': _vm.orderAddress
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.expressAddress !== '' && _vm.order.expressAddress !== undefined),
      expression: "order.expressAddress!==''&&order.expressAddress!==undefined"
    }],
    staticClass: "submain"
  }, [_c('div', {
    staticStyle: {
      "line-height": "15.2vw",
      "margin-left": "4vw"
    }
  }, [_c('svg', {
    attrs: {
      "width": "12px",
      "height": "17px",
      "viewBox": "0 0 12 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "执行中订单详情",
      "transform": "translate(-25.000000, -118.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "地点",
      "transform": "translate(25.000000, 118.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "address_area"
  }, [_c('span', {
    staticClass: "phonePrev",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "luWei",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.expressName) + "  " + _vm._s(_vm.order.expressMobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block_4"
  }, [_c('span', {
    staticClass: "orderNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.order.orderNo))]), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.order.orderNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "div"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "4vw",
      "padding-right": "4vw",
      "width": "100%"
    }
  }, _vm._l((_vm.order.itemList), function(item, i) {
    return _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [(_vm.order.fromEmkt) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "52px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(item.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + item.merchandiseIcon
      }
    }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
      }
    }) : _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.serviceUrl
      }
    }), _vm._v(" "), (item.categoryId) ? _c('div', {
      staticClass: "item-detail"
    }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
      staticClass: "deep-text-color text-overflow-hidden",
      staticStyle: {
        "font-size": "12px"
      }
    }, _vm._l((item._titleList), function(title) {
      return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, _vm._l((item._subTitleList), function(subTitle, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, _vm._l((item._abstractList), function(abstractTitle, index) {
      return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e()]) : _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color small-font"
    }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color small-font"
    }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "52px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(item.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + item.merchandiseIcon
      }
    }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color text-overflow-hidden",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "80px"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.name))])])]) : _vm._e(), _vm._v(" "), (item.productType === '服务类') ? _c('div', {
      staticClass: "priceWrap_2"
    }, [(_vm.showProductDetailBtn(item) && item.name !== '实物返还' && _vm.isService) ? _c('div', {
      staticClass: "tagWrap_2",
      on: {
        "click": function($event) {
          return _vm.toProductInfo(item.orderId, item.serviceItemDetail.euId)
        }
      }
    }, [_c('span', {
      staticClass: "tag_2",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("产品详情")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.status === 2),
        expression: "status===2"
      }],
      class: [item.orderId !== undefined ? 'tagWrap_3' : 'tagWrap_2'],
      on: {
        "click": function($event) {
          return _vm.toProgress(item)
        }
      }
    }, [_c('span', {
      class: [item.orderId !== undefined ? 'tag_3' : 'tag_2']
    }, [_vm._v("进展查询")])]), _vm._v(" "), _c('span', {
      staticClass: "price_3",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(item.price)))])]) : _vm._e(), _vm._v(" "), (item.productType === '产品类') ? _c('div', {
      staticClass: "priceWrap_2"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.orderId !== undefined),
        expression: "item.orderId!==undefined"
      }],
      staticClass: "tagWrap_2",
      on: {
        "click": function($event) {
          return _vm.toProductInfo(item.orderId)
        }
      }
    }, [_c('span', {
      staticClass: "tag_2",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("产品详情")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.status === 2),
        expression: "status===2"
      }],
      class: [item.orderId !== undefined ? 'tagWrap_3' : 'tagWrap_2'],
      on: {
        "click": function($event) {
          return _vm.toProgress(item)
        }
      }
    }, [_c('span', {
      class: [item.orderId !== undefined ? 'tag_3' : 'tag_2']
    }, [_vm._v("进展查询")])]), _vm._v(" "), _c('span', {
      staticClass: "price_3",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(item.price)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap_2"
  }, [_c('span', {
    staticClass: "totalMerchandise",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('span', {
    staticClass: "money_3",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.order.initPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "discount",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("优惠折扣")]), _vm._v(" "), _c('span', {
    staticClass: "price_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("-￥" + _vm._s(_vm.discountPrice))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.expressPrice),
      expression: "order.expressPrice"
    }],
    staticClass: "moneyWrap_3"
  }, [_c('span', {
    staticClass: "freight",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("运费")]), _vm._v(" "), _c('span', {
    staticClass: "money_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.order.expressPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_5"
  }, [_c('span', {
    staticClass: "totalGoods",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("共" + _vm._s(_vm.itemListLength) + "件商品")]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap_4"
  }, [_c('span', {
    staticClass: "total",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
    staticClass: "money_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.order.price)))])])])])]), _vm._v(" "), _c('div', {
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "row_area"
  }, [_c('div', {
    staticClass: "row0"
  }, [_c('span', {
    staticClass: "paymentMethod",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', {
    staticClass: "info_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName) + "结算")])]), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_c('span', {
    staticClass: "orderTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "word",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.orderTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 1),
      expression: "status===1"
    }],
    staticClass: "block_6"
  }, [(_vm.order.fromEmkt) ? _c('div', {
    staticClass: "tagWrap_5",
    on: {
      "click": function($event) {
        return _vm.toggleResearchGroupDisagreeBox()
      }
    }
  }, [_c('span', {
    staticClass: "tag_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("不同意")])]) : _vm._e(), _vm._v(" "), (_vm.order.fromEmkt) ? _c('div', {
    staticClass: "tagWrap_6",
    on: {
      "click": function($event) {
        return _vm.agree()
      }
    }
  }, [_c('span', {
    staticClass: "tag_6",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "customerService",
    attrs: {
      "lines": undefined
    },
    on: {
      "click": _vm.goMessage
    }
  }, [_vm._v("客服")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "7vw",
      "top": "0.67vh"
    },
    on: {
      "click": _vm.goMessage
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "23px",
      "viewBox": "0 0 20 23",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("服务评价-客服")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-订单详情",
      "transform": "translate(-26.000000, -862.000000)",
      "fill": "#4191EA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-6",
      "transform": "translate(0.000000, 849.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组",
      "transform": "translate(26.000000, 13.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "服务评价-客服",
      "transform": "translate(0.000000, 0.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.0783731,12.6660875 L19.0783731,12.0399707 C19.1274803,9.1794763 18.2877472,6.7732235 16.6328345,5.0667483 C15.8422086,4.25156878 14.8895289,3.63772878 13.7846169,3.21049614 C13.607831,1.66853006 11.9529184,0.450671497 9.93461243,0.450671497 C7.91630651,0.450671497 6.24666171,1.6660747 6.08460795,3.21049614 C4.97969595,3.63772878 4.02701627,4.25156878 3.23639035,5.0667483 C1.58147771,6.7732235 0.739289234,9.1671995 0.790851794,12.0276939 L0.790851794,12.7937662 C0.363619154,13.2332757 0.0247794743,13.8839461 0.277681554,14.8120721 C0.466744274,15.5020283 0.967637714,16.0029217 1.58147771,16.2288149 C1.89576379,16.4301544 2.25915707,16.5431009 2.65938075,16.5431009 C3.45000667,20.0051585 6.29576891,22.3623041 10.0230054,22.3623041 C13.7477865,22.3623041 16.5960041,20.0051585 17.38663,16.5308241 C17.4111836,16.5308241 17.4357372,16.5431009 17.4627462,16.5431009 C17.9513628,16.5431009 18.4031491,16.366315 18.7665424,16.0790379 C19.2306054,15.8163144 19.5939987,15.3645281 19.7437756,14.7997953 C20.0064992,13.7930977 19.5669897,13.1031416 19.0783731,12.6660875 Z M16.895558,14.5591701 C16.895558,15.0232331 16.8587276,15.4627425 16.7948883,15.8875198 C15.5794851,17.8444417 13.5710006,19.1236843 11.0763548,19.3986846 C10.8872921,19.1482379 10.511622,18.9837288 10.0721126,18.9837288 C9.44599579,18.9837288 8.94264699,19.3225685 8.94264699,19.7498011 C8.94264699,20.1647569 9.44354043,20.5158734 10.0721126,20.5158734 C10.6368454,20.5158734 11.0886316,20.2408731 11.1893014,19.8750245 C11.9922041,19.7866315 12.7582764,19.5877473 13.485063,19.2980149 C14.5138588,18.883059 15.4174313,18.269219 16.1810483,17.4908699 C16.3062716,17.3656465 16.4192182,17.2404232 16.5321648,17.102923 C15.6285923,19.8774798 13.2076073,21.6576158 10.0598358,21.6576158 L10.0352822,21.6576158 C5.98393819,21.6576158 3.16272955,18.7357374 3.16272955,14.5591701 L3.15045275,14.1589464 C3.15045275,13.9821605 3.17500635,13.5058206 3.19955995,13.0540344 C4.88148155,12.4401944 6.39889403,10.0928702 7.01273403,9.01496718 C7.57746683,9.7810395 8.86898619,11.2591662 10.8504617,12.0252385 C11.5895251,12.3125157 12.3433206,12.464748 13.082384,12.6268017 C14.5506892,12.9410878 15.9428784,13.2406417 16.8832812,14.4707771 L16.9201116,14.5076075 L16.895558,14.5591701 L16.895558,14.5591701 Z",
      "id": "形状"
    }
  })])])])])])])])]), _vm._v(" "), _c('footer-placeholder')], 1), _vm._v(" "), (_vm.showResearchGroupDisagreeBox) ? _c('ResearchGroupDisagreeBox', {
    on: {
      "toggleShow": _vm.toggleResearchGroupDisagreeBox,
      "confirm": _vm.disagree
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
}]}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("进展详情")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "firstStage",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.stage.stageName) + "：")]), _vm._v(" "), _c('span', {
    staticClass: "preExperiment",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.project.projectName))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '结束' || _vm.project.status === '终止'),
      expression: "project.status==='结束'||project.status==='终止'"
    }],
    staticClass: "colorDiv_2 color_greeen"
  }, [_vm._v("已完成")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '未开始'),
      expression: "project.status==='未开始'"
    }],
    staticClass: "colorDiv_2 color_red"
  }, [_vm._v("未开始")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.status === '进行中'),
      expression: "project.status==='进行中'"
    }],
    staticClass: "colorDiv_2 color_orange"
  }, [_vm._v("进行中")])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('task-progress', {
    attrs: {
      "type": _vm.type,
      "subType": _vm.subType,
      "taskModules": _vm.project.taskProgresses,
      "expressOutList": _vm.expressOutList
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tvInfo.length > 0) ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "searchbar row"
  }, [_c('div', {
    staticClass: "search-input col-80",
    staticStyle: {
      "margin-left": "1.5rem",
      "width": "73%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchdata),
      expression: "searchdata"
    }],
    attrs: {
      "id": "search",
      "placeholder": "载体"
    },
    domProps: {
      "value": (_vm.searchdata)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchdata = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "button button-fill button-primary col-15",
    on: {
      "click": function($event) {
        return _vm.filterTVOptions(_vm.TVInfoFilters)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title title-label"
  }, [_vm._v("筛选项")]), _vm._v(" "), _vm._l((_vm.filterOptionAttributes), function(filter, index) {
    return _c('div', {
      staticClass: "filter-option"
    }, [_c('van-dropdown-menu', {
      attrs: {
        "index": index
      }
    }, [_c('van-dropdown-item', {
      attrs: {
        "title": filter.name,
        "disabled": "",
        "title-class": "blue-title"
      }
    }), _vm._v(" "), _c('van-dropdown-item', {
      attrs: {
        "options": _vm.filterOptions[filter.attribute]
      },
      model: {
        value: (_vm.TVInfoFilters[filter.data]),
        callback: function($$v) {
          _vm.$set(_vm.TVInfoFilters, filter.data, $$v)
        },
        expression: "TVInfoFilters[filter.data]"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title title-label"
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.serarchOptions.length > 0 || _vm.onlyShowSearchOptions) ? _c('ul', {
    staticStyle: {
      "padding-left": "0rem"
    }
  }, _vm._l((_vm.serarchOptions), function(opt, idx) {
    return _c('li', [(_vm.showCustomMade(opt.WQFlag)) ? _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attribute.value),
        expression: "attribute.value"
      }],
      attrs: {
        "type": "radio",
        "name": "my-radio"
      },
      domProps: {
        "value": opt.TLNo,
        "checked": _vm._q(_vm.attribute.value, opt.TLNo)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.attribute, "value", opt.TLNo)
        }
      }
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      on: {
        "click": _vm.changePeriod
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.8rem"
      }
    }, [_vm._v("\n              " + _vm._s(opt.TLNo) + "\n             ")]), _vm._v(" "), (opt.promoterAAV !== undefined) ? _c('span', {
      staticStyle: {
        "margin-right": "0.8rem"
      }
    }, [_vm._v("\n               " + _vm._s(opt.promoterAAV) + "\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 1) ? _c('span', [_vm._v("\n                推荐\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 2) ? _c('span', [_vm._v("\n                可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 3) ? _c('span', [_vm._v("\n               不可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.tag5ID === 1) ? _c('span', [_vm._v("\n               特异性启动子\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("\n            " + _vm._s(opt.elementSeq) + "\n          ")]), _vm._v(" "), (opt.RNAiEffect) ? _c('span', [_vm._v("包装容量：" + _vm._s(opt.RNAiEffect))]) : _vm._e(), _vm._v(" "), (opt.recommendSerotype) ? _c('div', [_vm._v("小鼠参考血清型：" + _vm._s(opt.recommendSerotype))]) : _vm._e(), _vm._v(" "), (opt.toolVectorApply) ? _c('div', [_vm._v("载体适用：" + _vm._s(opt.toolVectorApply))]) : _vm._e()])]) : _vm._e()])
  }), 0) : _c('ul', {
    staticStyle: {
      "padding-left": "0rem"
    }
  }, _vm._l((_vm.tvInfo), function(opt, idx) {
    return _c('li', [(_vm.showCustomMade(opt.WQFlag)) ? _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attribute.value),
        expression: "attribute.value"
      }],
      attrs: {
        "type": "radio",
        "name": "my-radio"
      },
      domProps: {
        "value": opt.TLNo,
        "checked": _vm._q(_vm.attribute.value, opt.TLNo)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.attribute, "value", opt.TLNo)
        }
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      on: {
        "click": _vm.changePeriod
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.5rem"
      }
    }, [_vm._v("\n              " + _vm._s(opt.TLNo) + "\n             ")]), _vm._v(" "), (opt.promoterAAV !== undefined) ? _c('span', {
      staticStyle: {
        "margin-right": "0.5rem"
      }
    }, [_vm._v("\n               " + _vm._s(opt.promoterAAV) + "\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 1) ? _c('span', [_vm._v("\n                推荐\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 2) ? _c('span', [_vm._v("\n               可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 3) ? _c('span', [_vm._v("\n               不可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.tag5ID === 1) ? _c('span', [_vm._v("\n                     特异性启动子\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(" " + _vm._s(opt.elementSeq))]), _vm._v(" "), (opt.RNAiEffect && opt.RNAiEffect !== '0') ? _c('span', [_vm._v("包装容量：" + _vm._s(opt.RNAiEffect))]) : _vm._e(), _vm._v(" "), (opt.recommendSerotype) ? _c('div', [_vm._v("小鼠参考血清型：" + _vm._s(opt.recommendSerotype))]) : _vm._e(), _vm._v(" "), (opt.toolVectorApply) ? _c('div', [_vm._v("载体适用：" + _vm._s(opt.toolVectorApply))]) : _vm._e()])]) : _vm._e()])
  }), 0)], 2) : _c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', [_vm._v("没有可选择的载体编号，请选择下一步！")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
}]}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item.orderType === 1) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.item.iconTag) ? _c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.calTagName(_vm.item)
    }
  }) : _c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.emkt.getOrderMerchandiseLabel(_vm.item)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-address"
  }, [(_vm.item.iconUrl) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.item.iconUrl
    }
  }) : (_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.isStock === 0) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.item.name) + " ")]), _vm._v(" "), (_vm.showProductContractNo) ? _c('span', {
    staticClass: "research-font-color small-font"
  }, [_vm._v(_vm._s(_vm.item.contractNo))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "light-text-color small-font"
  }, [_vm._v(_vm._s(_vm.item.TLNo) + " " + _vm._s(_vm.item.tag1PUBID) + " " + _vm._s(_vm.item.eu_RID))]), _vm._v(" "), (_vm.item.tax) ? _c('span', {
    staticClass: "light-text-color small-font"
  }, [_vm._v(_vm._s(_vm.item.tax) + " "), (_vm.item.symbol) ? _c('span', [_vm._v(_vm._s(_vm.item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])]) : _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + 'service_product.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.showProductContractNo) ? _c('span', {
    staticClass: "research-font-color small-font"
  }, [_vm._v(_vm._s(_vm.item.contractNo))]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-block-title top"
  }, [_vm._v("方式一：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-block-title top"
  }, [_vm._v("方式二：")]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list bottom"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.resource
    }
  })]), _vm._v(" "), _vm._m(2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("推荐给好友")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block media-list bottom"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("点击右上角，发送给指定好友进行推荐分享！")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("长按二维码，选择发送给朋友，即可进行推荐分享！")])])
}]}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$route.query.cc) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPage),
      expression: "showPage"
    }],
    staticClass: "content",
    staticStyle: {
      "background-color": "#fafafa"
    }
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "add-btn research-background-color",
    staticStyle: {
      "padding-top": "10px"
    },
    on: {
      "click": _vm.go
    }
  }, [_vm._v("开始签署合同")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])])]) : _c('div', [(_vm.isSpecialPromotion) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + 'c276.png'
    },
    on: {
      "click": _vm.goToSpecialPromotion
    }
  })])]) : (_vm.$route.query.isadvertising) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [(_vm.openLink()) ? _c('a', {
    attrs: {
      "href": "https://genechem.jinshuju.net/f/S85ziR",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : (_vm.openLink2()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/ZV4SUF",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : (_vm.openLink3()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/nrxuBV",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : _c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    },
    on: {
      "click": function($event) {
        return _vm.goToActivity()
      }
    }
  })])]) : _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2.5rem"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.$route.query.detailImageUrl && _vm.openLink()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://genechem.jinshuju.net/f/S85ziR",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$route.query.detailImageUrl && !_vm.openLink()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.checkForCouponActivity()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.coupons), function(tabs) {
    return (_vm.coupons && !_vm.$route.query.activityId) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "100%",
        "width": "100%"
      },
      attrs: {
        "src": _vm.baseurl + tabs.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.getcoupon(tabs)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.bcoupons), function(ctabs) {
    return (_vm.bcoupons && !_vm.$route.query.activityId) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('img', {
      staticStyle: {
        "height": "100%",
        "clear": "both",
        "display": "block",
        "margin": "auto"
      },
      attrs: {
        "src": _vm.baseurl + ctabs.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.getcoupon(ctabs)
        }
      }
    })])])])]) : _vm._e()
  }), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.merchandise,
      "description": _vm.$route.query.des,
      "channel": _vm.$route.params.channel
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submain"
  }, [_c('img', {
    staticClass: "icon_12",
    attrs: {
      "src": "/static/img/authentication4.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/img/authentication11.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/authentication9.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon_13",
    attrs: {
      "src": "/static/img/authentication4.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "summary"
  }, [_vm._v("在支付宝中使用E签宝小程序，根据提示完成人脸识别，并签署合同")]), _vm._v(" "), _c('span', {
    staticClass: "desc_1"
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": "/static/img/authentication10.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word_1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }), _vm._v(" "), _c('span', {
    staticClass: "word_2"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_4"
  }, [_vm._v("打开短信中的链接，点击"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("「快捷签署」")]), _vm._v("，跳转支付宝"), _c('span', {
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("（未开通支付宝请咨询客服进行人工认证）")])]), _vm._v(" "), _c('span', {
    staticClass: "info_5"
  }, [_c('span', {
    staticStyle: {
      "color": "#5878fa"
    }
  }, [_vm._v("点击发起签署")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "400"
    }
  }, [_vm._v("，认证链接会以短信形式发送到您的手机上")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "30px",
      "margin-left": "70px"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "12px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "27px",
      "height": "2px",
      "margin-bottom": "3px",
      "color": "#D2D2D6"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "21px",
      "white-space": "nowrap",
      "color": "#424242",
      "font-size": "21px",
      "font-weight": "500"
    }
  }, [_vm._v("\n            合同签署流程\n            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "27px",
      "height": "2px",
      "margin-bottom": "3px",
      "color": "#D2D2D6"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "icon_14",
    staticStyle: {
      "background": "#d2d2d6",
      "width": "15px",
      "height": "1px"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info_7"
  }, [_vm._v("我是有底线的")]), _vm._v(" "), _c('img', {
    staticClass: "icon_15",
    staticStyle: {
      "background": "#d2d2d6",
      "width": "15px",
      "height": "1px"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "输入商品...",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content flex-col"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('img', {
    staticClass: "label2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/实物寄送流程.png'
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.createSampleDeliverySheet
    }
  }, [_c('span', {
    staticClass: "add-tag"
  }, [_vm._v("寄送实物")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('span', {
    staticClass: "paragraph1"
  }, [_vm._v("\n            查看送样指南和信息表、收集样本\n            "), _c('br'), _vm._v("\n            并填写实物信息表\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_vm._v("\n            寄送实物\n            "), _c('br'), _vm._v("\n            并上传实物信息表\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("\n            顺丰快捷下单\n            "), _c('br'), _vm._v("\n            货到付款\n            "), _c('br'), _vm._v("\n            填写快递单号\n          ")])])
}]}

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract-last/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    时隔"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.yearDiff))]), _vm._v("之后"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.lastContractDate))]), _c('br'), _vm._v("\n    您再次选择了吉凯基因的 "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.lastContractProduct))]), _c('br'), _c('br'), _vm._v("\n\n    您与吉凯的合作时长超过"), _c('span', {
    staticClass: "collaborationDurationProportion"
  }, [_vm._v(_vm._s(_vm.data.collaborationDurationProportion))]), _vm._v("用户"), _c('br'), _vm._v("被授予"), _c('span', {
    staticClass: "text-ke"
  }, [_vm._v("科研巨匠")]), _vm._v("称号"), _c('br')])])
},staticRenderFns: []}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.emkt.leaveSpaceForFullScreen) ? _c('div', {
    staticStyle: {
      "height": "35px",
      "visibility": "hidden"
    }
  }, [_vm._v("占位")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background-color": "rgba(250, 250, 250, 1)"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "flex-col justify-between"
  }, [_c('div', {
    staticClass: "mod4 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('experiment-header', {
    attrs: {
      "contractNo": _vm.contractNo,
      "status": _vm.status
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, _vm._l((_vm.taskModules), function(task, index) {
    return _c('div', {
      key: index,
      staticClass: "historyProgress",
      staticStyle: {
        "display": "flex"
      },
      style: (task.publishComments.length < 1 ? {
        height: '19.5vw'
      } : {})
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "margin-left": "15px",
        "flex-direction": "column"
      }
    }, [_c('div', {
      staticStyle: {
        "line-height": "14px"
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING
    ) ? _c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])]) : _vm._e(), _vm._v(" "), (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START
    ) ? _c('div', {
      staticClass: "colorDiv_2 left1",
      staticStyle: {
        "index < taskModules.length -1 ? {'margin'": "'0 auto'}"
      }
    }) : _vm._e(), _vm._v(" "), (task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING) ? _c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("编组#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -270.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组#merge#",
        "transform": "translate(28.000000, 270.000000)"
      }
    }, [_c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#5878FA",
        "cx": "7",
        "cy": "7",
        "r": "7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#FFFFFF",
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份",
        "fill": "#FFFFFF",
        "cx": "9.8",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份-2",
        "fill": "#FFFFFF",
        "cx": "4.2",
        "cy": "7",
        "r": "1"
      }
    })])])])]) : _vm._e(), _vm._v(" "), (task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP) ? _c('svg', {
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("关闭")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "进展查询",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-服务类-实验进展备份-2",
        "transform": "translate(-25.000000, -306.000000)",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "关闭",
        "transform": "translate(25.000000, 306.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0,7 L0,7 C0,10.8659961 3.13400391,14 7,14 C10.8659961,14 14,10.8659961 14,7 L14,7 C14,3.13400391 10.8659961,0 7,0 C3.13400391,0 0,3.13400391 0,7 L0,7 Z",
        "id": "路径",
        "fill": "#F55300"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M3.2329342,4.3118086 L9.70694355,10.7858173 L9.70694356,10.7858173 C10.0100447,11.0785629 10.4930724,11.0701669 10.7858179,10.7670657 C11.071394,10.4713874 11.071394,10.0026212 10.7858179,9.7069429 L4.31180858,3.23293416 L4.31180861,3.2329342 C4.01906457,2.92983312 3.53603532,2.9214372 3.23293422,3.21418241 C2.92983312,3.50692643 2.9214372,3.98995563 3.21418244,4.29305671 C3.22032389,4.29941542 3.22657539,4.30566692 3.23293407,4.31180834 L3.2329342,4.3118086 Z",
        "id": "路径",
        "fill": "#F9F9F9"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M3.23264301,9.6897523 L9.69864387,3.22344586 L9.69864381,3.22344592 C9.99619785,2.92566646 10.4787993,2.92549677 10.7765646,3.22306477 C11.07433,3.52063287 11.0744997,4.00325708 10.7769458,4.30103654 L4.31018584,10.767343 L4.31018588,10.7673429 C4.01780396,11.0700834 3.53537224,11.0784693 3.23264608,10.7860724 C2.92991991,10.4936767 2.92153438,10.0112221 3.21391749,9.70848168 C3.22005104,9.70213085 3.22629449,9.69588708 3.23264503,9.68975325 L3.23264301,9.6897523 Z",
        "id": "路径",
        "fill": "#F9F9F9"
      }
    })])])])]) : _vm._e()]), _vm._v(" "), (index < _vm.taskModules.length - 1) ? _c('div', {
      staticClass: "group22",
      class: {
        'div_2':
        task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START || task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
          task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
          task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress_history",
      style: ((task.publishComments.length < 1 || (task.publishComments.length > 0 && task.publishComments[0].length < 50)) ? {
        height: '91px'
      } : {})
    }, [_c('div', {
      staticClass: "box4_text",
      style: ((task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START) ? {
        'margin-top': '-3px'
      } : '')
    }, [_c('div', {
      staticClass: "plasmidExtraction",
      class: [
        task.publishComments.length > 0 ?
        'color_red' :
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP ?
        'color_black' :
        'color_gray' ]
    }, [_vm._v("\n                      " + _vm._s(task.taskName) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('span', {
      staticClass: "completionTime",
      attrs: {
        "lines": undefined
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP
    ) ? _c('span', [_vm._v("完成时间")]) : (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
    ) ? _c('span', {
      staticClass: "color_blue"
    }, [_vm._v("开始时间")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "text",
      attrs: {
        "lines": undefined
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP
    ) ? _c('span', [_vm._v(_vm._s(task.actualEnd))]) : (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
    ) ? _c('span', {
      staticClass: "color_blue"
    }, [_vm._v(_vm._s(task.actualStart))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "paragraph1",
      class: {
        'paragraph-font1': index !== 0,
          'paragraph-font2': index === 0,
      },
      style: ({
        'margin-left': index === _vm.taskModules.length - 1 ? '20px' : '10px',
      })
    }, _vm._l((task.publishComments), function(text, index) {
      return _c('span', {
        key: index,
        staticClass: "tasktext",
        staticStyle: {
          "margin-top": "5px",
          "display": "block"
        }
      }, [_vm._v("\n                      " + _vm._s(text) + "\n                      "), _c('br')])
    }), 0)])])
  }), 0)], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block2"
  }, [_c('div', {
    staticClass: "sectionWrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reason),
      expression: "reason",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "section",
    attrs: {
      "cols": "5",
      "autofocus": "autofocus",
      "wrap": "hard",
      "placeholder": "请输入您不同意的原因"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('span', {
    staticClass: "tag research-font-color"
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": function($event) {
        _vm.$emit('toggleShow') && _vm.$emit('confirm', _vm.reason)
      }
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("您不同意的原因是？")])])
}]}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(_vm.showGo) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "orderTitle"
  }, [_vm._v("填写订单")]), _c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('li', {
    staticClass: "orderInfo"
  }, [_vm._v("收货地址")]), _vm._v(" "), _vm._l((_vm.filterAddress), function(address, index) {
    return _c('li', [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'address',
          params: {
            order: _vm.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding": "0 0 0 2rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))])]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressAddress))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressMobile))])])])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "orderInfo"
  }, [_c('span', [_vm._v("订单信息")]), _vm._v(" "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage1()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])])], 2)]), _vm._v(" "), _vm._l((_vm.orderList), function(merchandise) {
    return _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin": "5px 5% 0 5%",
        "width": "90%"
      }
    }, [_c('ul', [_c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.goToDetail(merchandise)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "1rem",
        "border-bottom": "1px solid #1a1a1a",
        "padding-top": "0.5rem"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "#2ac845",
        "padding-bottom": ".5rem"
      }
    }, [_vm._l((merchandise._subTitleList), function(subTitle) {
      return (merchandise._subTitleList && merchandise._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "white",
          "padding": "0.1rem"
        }
      }), _vm._v(" "), (subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', {
        staticStyle: {
          "font-size": "0.7rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((merchandise._abstractList), function(abstractTitle) {
      return (merchandise._abstractList && merchandise._abstractList.length > 0) ? _c('span', {
        staticStyle: {
          "font-size": "0.9rem",
          "color": "black"
        }
      }, [(abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))])]) : _vm._e()]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l((merchandise._titleList), function(title) {
      return (merchandise._titleList && merchandise._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "1.2rem",
          "color": "#3F3F3F",
          "padding": "0.2rem 0 0.2rem 0",
          "font-weight": "bold"
        }
      }, [(title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (merchandise.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#1482E7"
      }
    }, [_vm._v("【代购】")])]) : _vm._e()], 2), _vm._v(" "), (merchandise.discountPrice && merchandise.discountPrice !== 0 && !_vm.isUseSpecialFundCoupon) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v(" ￥"), _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [(!merchandise.productQuantity && merchandise.quantity === 0) ? _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("合计1个产品")]) : _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("合计" + _vm._s(merchandise.productQuantity ? merchandise.productQuantity : merchandise.quantity) + "个产品")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v("\n                    ￥"), (_vm.isSFFlag) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")]) : (merchandise.price && merchandise.price !== 0) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.price) + " ")]) : (merchandise.priceMin) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMin) + " ")]) : _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")])])])])])])])])
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "10px",
      "font-size": "14PX"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    选择不发货\n                      "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": _vm.displayMessage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.4rem",
      "padding-left": ".3rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "1rem"
    },
    attrs: {
      "lass": "item-after"
    }
  }, [_c('div', [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExpress),
      expression: "isExpress"
    }],
    attrs: {
      "id": "express",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExpress) ? _vm._i(_vm.isExpress, null) > -1 : (_vm.isExpress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isExpress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExpress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExpress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExpress = $$c
        }
      }, _vm.changeExpressFree]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])]), _vm._v(" "), (_vm.isSFFlag && !_vm.isUseSpecialFundCoupon) ? _c('div', {
    staticClass: "item-title-row",
    staticStyle: {
      "margin-bottom": "8px",
      "margin-top": "8px"
    }
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    不使用优惠券\n                  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "1rem"
    },
    attrs: {
      "lass": "item-after"
    }
  }, [_c('div', [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponRefused),
      expression: "couponRefused"
    }],
    attrs: {
      "id": "coupon_refused",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.couponRefused) ? _vm._i(_vm.couponRefused, null) > -1 : (_vm.couponRefused)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.couponRefused,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.couponRefused = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.couponRefused = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.couponRefused = $$c
        }
      }, _vm.changeCouponRefused]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("商品金额")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.goodsMoney))])])]), _vm._v(" "), (_vm.discountPrice && !_vm.isUseSpecialFundCoupon) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("-￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.discountPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.expressPrice && _vm.expressPrice > 0) ? _c('div', {
    staticClass: "item-title-row",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    运费\n                    "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage2()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.4rem",
      "padding-left": ".3rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("+￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.expressPrice))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1.2rem"
    }
  })])])])])], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    staticStyle: {
      "height": "3rem"
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('span', {
    staticClass: "tab-label"
  }, [_vm._v("实支付")]), _vm._v(" "), _c('span', {
    staticClass: "expressPrice",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.totalMoney.toFixed(2)))]), _vm._v(" "), _c('section', [(_vm.showButton && _vm.showBtn) ? _c('span', {
    staticClass: "buttonStyle",
    on: {
      "click": _vm.response
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _c('span', {
    staticClass: "buttonStyle",
    staticStyle: {
      "background-color": "gainsboro"
    }
  }, [_vm._v(_vm._s(_vm.buttonName))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-search-input', {
    attrs: {
      "display-in-browser": _vm.displayInBrowser
    },
    on: {
      "updateSearchKeyword": _vm.handleFilter
    }
  }), _vm._v(" "), (_vm.memberList && _vm.memberList.length > 0) ? _c('div', [_c('gc-single-selection', {
    attrs: {
      "member-list": _vm.memberList
    },
    on: {
      "updateSelection": _vm.handleUpdateSelection
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-buttons-base', {
    attrs: {
      "order-detail": _vm.orderDetail,
      "show-customer-goods-btn": _vm.showCustomerGoodsBtn,
      "show-invoice-btn": _vm.showInvoiceBtn
    },
    on: {
      "goToCustomerGoods": _vm.goToCustomerGoods,
      "goToInvoice": _vm.goToInvoice
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-express-base', {
    attrs: {
      "express-detail": _vm.expressDetail
    },
    on: {
      "downloadExpressOutFile": _vm.downloadExpressOutFile1
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-researchGroupMember"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组成员搜索")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down close-popup",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block_input"
  }, [_c('div', {
    staticClass: "wrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('label', {
    staticClass: "icon icon-search icon_2",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "icon_2",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.filteredData), function(member, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group close-popup",
      on: {
        "click": function($event) {
          return _vm.updateChosenResearchMember(member)
        }
      }
    }, [_c('img', {
      staticClass: "avator",
      attrs: {
        "src": "/static/img/avator2.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    })]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.item) ? _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "contractNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("合同号：" + _vm._s(_vm.item.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.item.contractNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])])]), _vm._v(" "), (_vm.sfQuoteNo !== undefined && _vm.sfQuoteNo !== null) ? _c('div', {
    staticClass: "group"
  }, [(_vm.sfQuoteNo) ? _c('span', {
    staticClass: "contractNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("报价编号：" + _vm._s(_vm.sfQuoteNo))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy1",
      "data-clipboard-text": _vm.sfQuoteNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copysfQuoteNo
    }
  }, [_vm._v("复制")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), (_vm.item.fromEmkt) ? _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.emkt.getMerchandiseLabelPath(_vm.item)
    }
  }), _vm._v(" "), (_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.categoryId === 20 || _vm.item.categoryId === 10) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [(_vm.item._titleList && _vm.item._titleList.length > 0) ? _c('span', {
    staticClass: "lentivirus deep-text-color text-overflow-hidden",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._l((_vm.item._titleList), function(title) {
    return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
  }), _vm._v(" "), (_vm.item._subTitleList && _vm.item._subTitleList.length > 0) ? _c('span', {
    staticClass: "gfpPuromycin light-text-color tiny-font text-overflow-hidden"
  }, _vm._l((_vm.item._subTitleList), function(subTitle, index) {
    return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
  }), 0) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item._abstractList && _vm.item._abstractList.length > 0) ? _c('span', {
    staticClass: "humanatgnm light-text-color tiny-font text-overflow-hidden"
  }, _vm._l((_vm.item._abstractList), function(abstractTitle, index) {
    return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [(abstractTitle.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "word light-text-color"
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])]) : _c('div', {
    staticClass: "container_3"
  }, [(_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.categoryId === 20 || _vm.item.categoryId === 10) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "lentivirus text-overflow-hidden",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gfpPuromycin",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.TLNo) + " " + _vm._s(_vm.item.tag1PUBID) + " " + _vm._s(_vm.item.eu_RID))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.tax !== '' && _vm.item.tax !== undefined),
      expression: "item.tax!==''&&item.tax!==undefined"
    }],
    staticClass: "humanatgnm text-overflow-hidden",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.tax) + "/" + _vm._s(_vm.item.symbol) + "/" + _vm._s(_vm.item.nm_ID))])]), _vm._v(" "), _c('span', {
    staticClass: "word",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])])]) : _vm._e(), _vm._v(" "), (_vm.showDefaultImage) ? _c('div', {
    staticClass: "bd",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/进展空.png"
    }
  })]) : _c('task-progress', {
    attrs: {
      "type": _vm.type,
      "taskModules": _vm.taskModules,
      "expressOutList": _vm.expressOutList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [_c('span', {
    staticClass: "icon icon-left goback",
    staticStyle: {
      "font-size": ".8rem"
    },
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "4rem"
    }
  }, [_vm._v("\n         订单详情\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row",
    staticStyle: {
      "margin-top": "2.5rem",
      "font-size": ".6rem"
    }
  }, [_vm._v("\n     重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。\n\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isWapp) ? _c('header', [_c('div', {
    staticClass: " bar_1 buttons-row",
    staticStyle: {
      "margin-top": "8px",
      "font-size": ".6rem"
    }
  }, [_vm._v("\n     重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "1rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-top": "4rem"
    }
  }, [_c('div', {
    staticClass: "page-detail",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.merchandises.specialAnnouncement !== undefined) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filteredShowPromotions && _vm.filteredShowPromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n            "), _vm._l((_vm.filteredShowPromotions), function(proo, index) {
    return _c('div', [_c('span', [_vm._v(_vm._s(index + 1) + ": " + _vm._s(proo.description))])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    style: ({
      'margin-top': '.55rem',
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '35px'
    })
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== 'null' && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList,
        "type": 1
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMax)))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.price)))])])]), _vm._v(" "), (_vm.merchandises.priceMin) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.merchandises.priceMin)))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [(_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])]) : _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.secPromotionDetail && _vm.secPromotionDetail.seckillType === 1) ? _c('span', [_vm._v("¥" + _vm._s(((1 - _vm.secPromotionDetail.seckilltRatio) * _vm.merchandises.priceMin).toFixed(2)))]) : _vm._e()])])]) : _vm._e()], 2), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), (this.$route.query.id === undefined) ? _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'border-top': '0px solid #e7e7e7',
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "background-color": "#00469A",
      "color": "white",
      "width": "80px"
    },
    on: {
      "click": function($event) {
        return _vm.gotofindermerchdisesdetail()
      }
    }
  }, [_c('span', {
    staticClass: "tab-label"
  }, [_vm._v("返回修改")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "width": "10rem"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), (!_vm.isWapp) ? _c('span', [(_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem",
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("确认")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  })]) : _c('span', [(_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem",
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("确认")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n\n            不同产品分装规则说明\n            "), _c('div', [_vm._v("\n              1.菌液:200μL/tube*1\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              2.质粒:不分装\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              3.慢病毒:50μL/tube\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n              4.腺病毒:200μL/tube\n            ")]), _c('div', [_vm._v("\n            5.逆转录病毒:50μL/tube\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n              6.腺相关病毒:50μL/tube\n            ")])])
}]}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.taskList), function(task, index) {
    return (_vm.type === 'Tool') ? _c('div', {
      staticClass: "progress1"
    }, [(task.statusId === 4 || task.statusId === 5) ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])]), _vm._v(" "), (index < _vm.taskModules.length) ? _c('div', {
      staticClass: "div"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (task.statusId === 0) ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('div', {
      staticClass: "colorDiv_2 left1"
    }), _vm._v(" "), (index < _vm.taskModules.length) ? _c('div', {
      staticClass: "div div_2"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (task.statusId === 1) ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("编组#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -270.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组#merge#",
        "transform": "translate(28.000000, 270.000000)"
      }
    }, [_c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#5878FA",
        "cx": "7",
        "cy": "7",
        "r": "7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#FFFFFF",
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份",
        "fill": "#FFFFFF",
        "cx": "9.8",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份-2",
        "fill": "#FFFFFF",
        "cx": "4.2",
        "cy": "7",
        "r": "1"
      }
    })])])])]), _vm._v(" "), (index < _vm.taskModules.length) ? _c('div', {
      staticClass: "div"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "block_3"
    }, [_c('span', {
      staticClass: "plasmidExtraction",
      class: [task.statusId === 0 ? 'color_gray' : 'color_black']
    }, [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('span', {
      staticClass: "completionTime",
      attrs: {
        "lines": undefined
      }
    }, [(task.statusId !== 0 && task.statusId !== 1) ? _c('span', [_vm._v("完成时间")]) : _c('span', {
      class: [task.statusId === 0 ? 'color_gray' : 'color_blue']
    }, [_vm._v("预计完成时间")])]), _vm._v(" "), _c('span', {
      staticClass: "text",
      attrs: {
        "lines": undefined
      }
    }, [(task.statusId !== 0 && task.statusId !== 1) ? _c('span', [_vm._v(_vm._s(task.realEndDate.replace('.', '-')))]) : _c('span', {
      class: [task.statusId === 0 ? 'color_gray' : 'color_blue']
    }, [_vm._v(_vm._s(task.planEndDate.replace('.', '-')))])])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.taskList), function(task, index) {
    return (_vm.type === 'Service') ? _c('div', {
      staticClass: "progress1"
    }, [(task.taskStatus === '结束' || task.taskStatus === '终止') ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])]), _vm._v(" "), (index + 1 + _vm.expressOutListLength < _vm.taskModules.length) ? _c('div', {
      staticClass: "div"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (task.taskStatus === '无法开始' || task.taskStatus === '准备开始') ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('div', {
      staticClass: "colorDiv_2 left1"
    }), _vm._v(" "), (index + 1 + _vm.expressOutListLength < _vm.taskModules.length) ? _c('div', {
      staticClass: "div div_2"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (task.taskStatus === '进行中') ? _c('div', {
      staticClass: "leftDiv"
    }, [_c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("编组#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -270.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组#merge#",
        "transform": "translate(28.000000, 270.000000)"
      }
    }, [_c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#5878FA",
        "cx": "7",
        "cy": "7",
        "r": "7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#FFFFFF",
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份",
        "fill": "#FFFFFF",
        "cx": "9.8",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份-2",
        "fill": "#FFFFFF",
        "cx": "4.2",
        "cy": "7",
        "r": "1"
      }
    })])])])]), _vm._v(" "), (index + 1 + _vm.expressOutListLength < _vm.taskModules.length) ? _c('div', {
      staticClass: "div"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "block_3"
    }, [_c('span', {
      staticClass: "plasmidExtraction",
      class: [task.taskStatus !== '无法开始' && task.taskStatus !== '准备开始' ? 'color_black' : 'color_gray']
    }, [_vm._v(_vm._s(task.taskName))]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('span', {
      staticClass: "completionTime",
      attrs: {
        "lines": undefined
      }
    }, [(task.taskStatus === '结束' || task.taskStatus === '终止') ? _c('span', [_vm._v("完成时间")]) : _c('span', {
      class: [task.taskStatus === '进行中' ? 'color_blue' : 'color_gray']
    }, [_vm._v("预计完成时间")])]), _vm._v(" "), _c('span', {
      staticClass: "text",
      attrs: {
        "lines": undefined
      }
    }, [(task.taskStatus === '结束' || task.taskStatus === '终止') ? _c('span', [_vm._v(_vm._s(task.actualEnd))]) : _c('span', {
      class: [task.taskStatus === '进行中' ? 'color_blue' : 'color_gray']
    }, [_vm._v(_vm._s(task.expectedEnd))])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.expressOutListLength > 0) ? _c('div', {
    staticClass: "progress1"
  }, [_c('div', {
    staticClass: "leftDiv"
  }, [_c('svg', {
    staticClass: "left1",
    attrs: {
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 14 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展查询-病毒",
      "transform": "translate(-28.000000, -198.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "对勾#merge#",
      "transform": "translate(28.000000, 198.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('span', {
    staticClass: "plasmidExtraction",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("发货")]), _vm._v(" "), _c('div', {
    staticClass: "outer_2"
  }, [_c('span', {
    staticClass: "completionTime",
    attrs: {
      "lines": undefined
    }
  }, [(_vm.expressOutList[0].sendStatusID === 1) ? _c('span', [_vm._v("完成时间")]) : _c('span', [_vm._v("预计完成时间")])]), _vm._v(" "), (_vm.expressOutList[0].sendDTString != undefined) ? _c('span', {
    staticClass: "text",
    attrs: {
      "lines": undefined
    }
  }, [(_vm.expressOutList[0].sendStatusID === 1) ? _c('span', [_vm._v(_vm._s(_vm.expressOutList[0].sendDTString.split(' ')[0]))]) : _c('span', [_vm._v(_vm._s(_vm.expressOutList[0].sendDTString.split(' ')[0]))])]) : _vm._e(), _vm._v(" "), (_vm.expressOutList[0].sendDTString == undefined) ? _c('span', {
    staticClass: "text",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("\n              无\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expressOutList.length > 0),
      expression: "expressOutList.length>0"
    }],
    staticClass: "container_4",
    staticStyle: {
      "width": "18vw",
      "border-color": "#5878FA"
    },
    on: {
      "click": _vm.toExpress
    }
  }, [_c('span', {
    staticClass: "tag_2",
    staticStyle: {
      "color": "#5878FA"
    },
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("物流信息")])])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1) ? _c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : (_vm.attribute.sorteditAble === true && _vm.attribute.columnName === 'TargetNum') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "实际所得靶点数量"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : (_vm.attribute.sorteditAble === true && _vm.attribute.columnName === 'TvNoNumber') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "必填"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [(_vm.billInfo) ? _c('div', {
    staticClass: "hd research-background-color"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v(_vm._s(_vm.billInfo.year) + "年账单")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('BillList', {
    attrs: {
      "billInfo": _vm.billInfo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "content-block-title"
  }, [_vm._v(_vm._s(_vm.plan.customerPlanName) + "成员信息")]), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, _vm._l((_vm.memberDetails), function(member) {
    return _c('ul', [_c('li', {
      staticClass: "item-content item-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/MemberDetails',
          query: {
            member: member,
            plan: _vm.plan
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('i', {
      staticClass: "icon icon-me",
      staticStyle: {
        "margin-right": "20px"
      }
    }), _vm._v(" "), (member.role === 1) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("储值联系人")]) : (member.role === 2) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("积分联系人")]) : (member.role === 3) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("管理联系人")]) : (member.role === 4) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("对账联系人")]) : (member.role === 5) ? _c('div', {
      staticClass: "item-title"
    }, [_vm._v("普通成员")]) : _c('div', {
      staticClass: "item-title"
    }, [_vm._v("未知")]), _vm._v(" "), _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "margin-left": "15px",
        "font-size": "smaller"
      }
    }, [_vm._v("\n                " + _vm._s(member.customerPlanMemberName) + "-" + _vm._s(member.customerPlanMemberNo) + "\n              ")])])])], 1)])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [(_vm.showComp) ? _c('div', {
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('ChooseResearchGroup', {
    attrs: {
      "researchGroupList": _vm.researchGroupList,
      "defaultIndex": _vm.defaultIndex
    },
    on: {
      "updateDefaultIndex": _vm.updateDefaultIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin": "0px",
      "margin-bottom": "10px",
      "font-size": ".8rem"
    }
  }, [_vm._v("请选择时间")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("分类")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "月度"
    }
  }, [_vm._v("月度")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "年度"
    }
  }, [_vm._v("年度")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "累计"
    }
  }, [_vm._v("累计")])])])])])]), _vm._v(" "), (_vm.selected !== '累计') ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("日期")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('ul', {
    staticClass: "toleft",
    staticStyle: {
      "height": "60px",
      "padding-left": "0"
    }
  }, [_c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2017"
    }
  }, [_vm._v("2017")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2016"
    }
  }, [_vm._v("2016")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2015"
    }
  }, [_vm._v("2015")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2014"
    }
  }, [_vm._v("2014")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2013"
    }
  }, [_vm._v("2013")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2012"
    }
  }, [_vm._v("2012")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2011"
    }
  }, [_vm._v("2011")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2010"
    }
  }, [_vm._v("2010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2009"
    }
  }, [_vm._v("2009")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2008"
    }
  }, [_vm._v("2008")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2007"
    }
  }, [_vm._v("2007")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2006"
    }
  }, [_vm._v("2006")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2005"
    }
  }, [_vm._v("2005")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2004"
    }
  }, [_vm._v("2004")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2003"
    }
  }, [_vm._v("2003")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2002"
    }
  }, [_vm._v("2002")])])]), _vm._v(" "), _c('li', [_vm._v("年")]), _vm._v(" "), (_vm.selected === '月度') ? _c('li', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("01")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("03")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("04")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("05")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("06")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("07")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("08")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("09")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e(), _vm._v(" "), (_vm.selected === '月度') ? _c('li', [_vm._v("月")]) : _vm._e()])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('p', [_c('a', {
    staticClass: "button button-big button-fill",
    on: {
      "click": function($event) {
        return _vm.toBillChecked()
      }
    }
  }, [_vm._v("查看")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrap1 flex-col"
  }, [_c('div', {
    staticClass: "main7"
  }, [_c('div', {
    staticClass: "word5",
    style: (_vm.getFontStyle(_vm.contractProgressInfo))
  }, [_vm._v("\n          实验编号：" + _vm._s(_vm.contractProgressInfo.contractNo) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "15px",
      "display": "flex"
    },
    on: {
      "click": function($event) {
        return _vm.handleToExtension()
      }
    }
  }, [_c('span', {
    staticClass: "txt2 txt",
    class: _vm.getStatusClass(_vm.contractProgressInfo.status)
  }, [_vm._v("\n            " + _vm._s(_vm.contractProgressInfo.status) + "\n          ")]), _vm._v(" "), (_vm.contractProgressInfo.show) ? _c('svg', {
    staticClass: "label3",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4#merge#")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-334.000000, -261.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开",
      "transform": "translate(342.000000, 269.000000) scale(1, -1) translate(-342.000000, -269.000000) translate(334.000000, 261.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])]) : _c('svg', {
    staticClass: "label3",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4#merge# 2")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-334.000000, -261.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开",
      "transform": "translate(334.000000, 261.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])])])]), _vm._v(" "), (_vm.contractProgressInfo.progressNotes.length > 0) ? _c('div', {
    staticClass: "main8 flex-col",
    class: {
      mianb:
        _vm.contractProgressInfo.progressNotes.length > 0 &&
        _vm.contractProgressInfo.show,
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractProgressInfo.show) ? _c('div', [(_vm.contractProgressInfo.progressNotes.length > 0) ? [_c('div', {
    staticClass: "main9 flex-row justify-between"
  }, [_c('div', {
    staticClass: "outer2 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "outer3 flex-col"
  }, [_c('span', {
    staticClass: "txt3",
    on: {
      "click": function($event) {
        return _vm.handleToHistoryProgress(_vm.contractProgressInfo)
      }
    }
  }, [_vm._v("历史进展")])])]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1"
  }, [_c('span', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n              1.  " + _vm._s(_vm.contractProgressInfo.progressNotes[0].content) + "\n            ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main10 flex-col"
  }), _vm._v(" "), _vm._l((_vm.contractProgressInfo.experimentModules), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "main11",
      on: {
        "click": function($event) {
          return _vm.handleToExperimentDetail(item.taskModules)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(item.completedPercent !== '100') ? _c('div', {
      staticClass: "pie-simple layer4",
      class: {
        allcomplete: item.completedPercent === '100'
      },
      style: ({
        '--percent': item.completedPercent
      })
    }, [_c('div', {
      staticClass: "pie-left flex-col"
    }), _vm._v(" "), _c('div', {
      staticClass: "pie-right flex-col"
    })]) : _c('div', [_c('svg', {
      staticClass: "left1",
      staticStyle: {
        "display": "block",
        "margin": "auto",
        "margin-top": "3px"
      },
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])])]), _vm._v(" "), _c('span', {
      staticClass: "info5",
      style: ({
        color: item.isException ? 'red' : ''
      })
    }, [_vm._v(_vm._s(item.experimentName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      },
      style: (item.isException ? {
        'margin-top': '4px'
      } : '')
    }, [(item.isException) ? _c('span', {
      staticClass: "txt2 layer7",
      staticStyle: {
        "margin-right": "15px"
      }
    }, [_vm._v("\n               " + _vm._s(_vm.getExceptionName()) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "label4",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/SketchPngf5a755bb1e7cc63077d460c4e20c96f4462ddbe798b160a88a0eb60fb5e54057.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "main8 flex-col",
      class: {
        mianb: index < _vm.contractProgressInfo.experimentModules.length - 1,
      }
    })])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.contractProgressInfo.progressNotes.length > 0) ? _c('span', {
    staticClass: "txt4"
  }, [_vm._v(_vm._s(_vm.contractProgressInfo.progressNotes[0].createDT) + " 最新进展："), _c('svg', {
    attrs: {
      "width": "25px",
      "height": "11px",
      "viewBox": "0 0 25 11",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("最新")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-192.000000, -308.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "最新",
      "transform": "translate(192.000000, 308.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.71428418,0 L24.357126,0 L24.357126,6.28571582 L24.357126,6.28571582 C24.357126,8.88934277 22.2464688,11 19.6428418,11 L3.93262024e-15,11 L3.93262024e-15,4.71428418 L3.93262024e-15,4.71428489 C3.93262024e-15,2.11065794 2.11065723,0 4.71428418,0 L4.71428418,0 Z",
      "id": "路径",
      "fill": "#FE654D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.35777988,7.85716895 L5.35777988,2.62429492 L6.42556943,2.62429492 L7.94592197,5.41044238 L8.46920723,6.54187402 L8.50456438,6.54187402 C8.44799291,5.99737402 8.37020755,5.30437402 8.37020755,4.71037402 L8.37020755,2.62429492 L9.36020755,2.62429492 L9.36020755,7.85716895 L8.2994928,7.85716895 L6.78620862,5.05687402 L6.25585179,3.93252148 L6.22049463,3.93252148 C6.26999463,4.49823623 6.34777988,5.15587402 6.34777988,5.75695312 L6.34777988,7.85716895 L5.35777988,7.85716895 L5.35777988,7.85716895 Z M10.6542842,7.85715713 L10.6542842,2.62429492 L13.8647158,2.62429492 L13.8647158,3.49408018 L11.7008633,3.49408018 L11.7008633,4.703296 L13.5394316,4.703296 L13.5394316,5.58015283 L11.7008633,5.58015283 L11.7008633,6.98030029 L13.9425107,6.98030029 L13.9425107,7.85715713 L10.6542842,7.85715713 L10.6542842,7.85715713 Z M15.4982158,7.85714746 L14.4870011,2.62429492 L15.5547863,2.62429492 L15.9720011,5.1770791 C16.0497868,5.72865068 16.1346442,6.28729492 16.2124295,6.84593164 L16.2407152,6.84593164 C16.3467867,6.28728848 16.4599299,5.7215791 16.573072,5.1770791 L17.1812152,2.62429492 L18.0722152,2.62429492 L18.6803583,5.1770791 C18.7935015,5.71450752 18.8995731,6.28022656 19.0127152,6.84593164 L19.0480723,6.84593164 C19.125858,6.28021689 19.2036439,5.7215791 19.2814292,5.1770791 L19.6915723,2.62429492 L20.6886439,2.62429492 L19.7198587,7.85714746 L18.4187112,7.85714746 L17.8317828,5.269 L17.8317825,5.26899871 C17.7473926,4.86765555 17.6719452,4.46448514 17.6054973,4.05978289 L17.5772116,4.05978289 C17.5064973,4.45578289 17.4357832,4.85885447 17.3509263,5.26899871 L16.7781411,7.85714746 L15.4982094,7.85714746 L15.4982158,7.85714746 Z",
      "id": "形状",
      "fill": "#FFFFFF"
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left goback",
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "searchbar title searchbox"
  }, [_c('a', {
    staticClass: "searchbar-cancel cancel",
    staticStyle: {
      "color": "#808080"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [(_vm.showSearchIcon) ? _c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchWords),
      expression: "searchWords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "search",
      "results": "0",
      "autocomplete": "off",
      "placeholder": "输入基因名称..."
    },
    domProps: {
      "value": (_vm.searchWords)
    },
    on: {
      "focus": function($event) {
        return _vm.onSearchActive(true)
      },
      "blur": [function($event) {
        return _vm.onSearchActive(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWords = $event.target.value.trim()
      }
    }
  })])])])]), _vm._v(" "), (_vm.showFilterBar) ? _c('div', {
    staticClass: "bar bar-header-secondary filter-bar",
    staticStyle: {
      "height": "auto",
      "overflow-x": "hidden"
    }
  }, [_vm._l((_vm.selectedItems), function(item) {
    return _c('div', {
      staticClass: "checkbox-el"
    }, [(item.selected) ? _c('label', {
      staticClass: "checkbox selected"
    }, [_vm._v(" " + _vm._s(item.word))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-el pull-right"
  }, [(_vm.searchWords !== '') ? _c('a', {
    staticStyle: {
      "width": "2rem",
      "padding-right": "1rem"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("清除搜索词")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right open-panel",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "data-panel": "#panel-right-finder"
    },
    on: {
      "click": _vm.openpanel
    }
  }, [_vm._v("筛选")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.showFilterBar && _vm.searchWords !== '') ? _c('div', {
    staticClass: "bar bar-header-secondary filter-bar",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "width": "2rem"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("清除搜索词")])])]) : _vm._e(), _vm._v(" "), (_vm.showStatusBar) ? _c('div', {
    staticClass: "bar bar-footer status"
  }, [_vm._v("\n    " + _vm._s(_vm.statusMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.showMatchData) ? _c('div', {
    staticStyle: {
      "margin-left": ".8rem",
      "font-size": ".6rem"
    }
  }, [_c('div', [_vm._v("为了您更好的体验，建议您：")]), _vm._v(" "), _c('div', [_vm._v("1.NCBI Refseq数据库基因使用Official Symbol；")]), _vm._v(" "), _c('div', [_vm._v("2. microRNA请使用mirbase数据库名称,比如microRNA155,若物种为human可以转化为hsa-mir-155,hsa-mir-155-5p,hsa-mir-155-3p；")]), _vm._v(" "), _c('div', [_vm._v("3.若您使用过程中碰到任何问题,可以返回首页咨询在线客服。")])]) : _vm._e(), _vm._v(" "), (_vm.searchHistory && _vm.searchHistory.length && !_vm.showMatchData) ? _c('div', {
    staticClass: "search_history"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "-1.2rem",
      "margin-left": "86%",
      "color": "#f6383a"
    },
    on: {
      "click": _vm.removeSearchHistory
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._l((_vm.searchHistory), function(item, index) {
    return (!_vm.isRemoveSH) ? _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])])]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showMatchData) ? _c('div', {
    staticClass: "list-block"
  }, [(_vm.matchData !== undefined && !_vm.isCorrections) ? _c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.matchData), function(searchData) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup",
      attrs: {
        "id": "results-goods"
      }
    }, [_vm._v("\n              " + _vm._s(searchData.text) + "\n            ")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isCorrections && _vm.searchWords !== '') ? _c('ul', {
    staticStyle: {
      "background-color": "inherit",
      "border": "0 solid",
      "font-size": "0.6rem"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂时没有匹配到与\""), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    }
  }, [_vm._v(_vm._s(_vm.searchWords))]), _vm._v("\"相关的线上产品信息，")]), _vm._v(" "), (_vm.isCorrections) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("您也许可以试一下关键字\n\n          "), _vm._l((_vm.matchData), function(correctData) {
    return _c('span', {
      staticStyle: {
        "color": "#0894ec",
        "margin-left": ".2rem"
      },
      on: {
        "click": function($event) {
          return _vm.searchTarget(correctData, true)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(correctData.text))])])
  }), _vm._v(" \n\n        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": ".8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "color": "#e7e7e7"
    }
  }), _vm._v(" "), _c('div', [_vm._v("您也可以点击"), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    },
    on: {
      "click": _vm.contactUs
    }
  }, [_vm._v("联系方式")])]), _vm._v(" "), _c('div', [_vm._v("或者点击"), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    },
    on: {
      "click": _vm.toMessage
    }
  }, [_vm._v("在线客服")]), _vm._v("咨询")]), _vm._v(" "), _c('div', [_vm._v("我们将会为您提供更多的产品和服务信息")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showfinderContent) ? _c('div', {
    staticClass: "content finder-content infinite-scroll",
    attrs: {
      "id": "contentscroll"
    }
  }, [(_vm.showFilter) ? _c('finderFilter', {
    attrs: {
      "findFilters": _vm.findFilters,
      "finderyemian": true
    },
    on: {
      "finderFilterSearch": _vm.finderFilterSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('newMerchandiseListA', {
    ref: "”a”",
    staticClass: "list-container",
    attrs: {
      "merchList": _vm.finderResultData
    }
  }), _vm._v(" "), (_vm.finderEnd) ? _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("更多产品请联系"), _c('a', {
    on: {
      "click": _vm.toMessage
    }
  }, [_vm._v("在线客服")]), _vm._v("或者拨打400-621-0302")])]) : _c('div', {
    staticClass: "infinite-scroll-preloader",
    attrs: {
      "id": "preloader"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btnTop",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "btnTop",
      "href": "javascript:;",
      "title": "Back to top"
    },
    on: {
      "click": _vm.returntop
    }
  }, [_c('img', {
    staticClass: "imageTop",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": __webpack_require__(1233)
    }
  })])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "description"
  }, [(_vm.secFlag === 0) ? _c('span', [_vm._v("距活动开始：")]) : (_vm.secFlag === 1 && _vm.timeNotLimited) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("正在抢购中")]) : _c('span', [_vm._v("距活动结束：")])]), _vm._v(" "), _c('span', {
    staticClass: "countdown"
  }, [(_vm.secFlag === 0 && _vm.daysOnly) ? _c('span', {
    staticClass: "clock"
  }, [_c('s', {
    staticClass: "hand hand-h"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.day[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.day[1]))])]), _vm._v("天\n    ")]) : (_vm.secFlag === 1 && _vm.timeNotLimited) ? _c('span', {
    staticClass: "clock"
  }) : _c('span', {
    staticClass: "clock"
  }, [_c('s', {
    staticClass: "hand hand-h"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.hr[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.hr[1]))])]), _vm._v(":\n      "), _c('s', {
    staticClass: "hand hand-m"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.min[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.min[1]))])]), _vm._v(":\n      "), _c('s', {
    staticClass: "hand hand-s"
  }, [_c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.sec[0]))]), _vm._v(" "), _c('s', {
    staticClass: "digital"
  }, [_vm._v(_vm._s(_vm.sec[1]))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail-container"
  }, [(_vm.payEnterpriseList.length > 0) ? _c('div', {
    staticClass: "mod2 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('div', {
    staticClass: "bd2 flex-row"
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("开票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "group1 flex-col"
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "to": {
        name: 'invoiceTitleModify',
        params: {
          order: _vm.order,
          addressType: 4
        }
      }
    }
  }, [_c('span', {
    staticClass: "word4"
  }, [_vm._v("修改")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line",
    staticStyle: {
      "margin-top": "21px",
      "margin-left": "15px"
    }
  }), _vm._v(" "), _vm._l((_vm.payEnterpriseList), function(payEnterprise, index) {
    return _c('div', {
      staticStyle: {
        "height": "60px",
        "margin-left": "15px"
      }
    }, [_c('div', {
      staticClass: "bd6 flex-col"
    }, [_c('span', {
      staticClass: "word3"
    }, [_vm._v(_vm._s(payEnterprise.enterpriseInvoiceTitle))])]), _vm._v(" "), (index < _vm.payEnterpriseList.length - 1) ? _c('div', {
      staticClass: "bd5 flex-col"
    }, [_c('div', {
      staticClass: "full-split-line"
    })]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mod3 flex-col"
  }, [_c('div', {
    staticClass: "layer2 flex-col"
  }, [_c('div', {
    staticClass: "box2 flex-row"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("发票寄送地址")]), _vm._v(" "), _c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress',
        params: {
          order: _vm.order,
          addressType: 4
        }
      }
    }
  }, [_c('span', {
    staticClass: "info5"
  }, [_vm._v("修改")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line",
    staticStyle: {
      "margin-top": "21px",
      "margin-left": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress || '无发票寄送地址'))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.order.invoiceName) + " " + _vm._s(_vm.order.invoiceMobile))])])])])])]), _vm._v(" "), (_vm.canAddPayEnterprise) ? _c('span', {
    staticClass: "txt2"
  }, [_vm._v("\n          下单成功后，吉凯工作人员会主动联系您为您开具发票。发票未寄出之前，您可以修改发票抬头与寄送地址\n        ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("进展详情")])]), _vm._v(" "), (_vm.type === 'Tool') ? _c('tool-progress', {
    attrs: {
      "type": _vm.type,
      "progressInfo": _vm.progressInfo,
      "item": _vm.item,
      "sfQuoteNo": _vm.sfQuoteNo
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }, _vm.control]
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : (_vm.attribute.sorteditAble === true && _vm.attribute.columnName === 'TargetNum') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "实际所得靶点数量"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : (_vm.attribute.sorteditAble === true && _vm.attribute.columnName === 'TvNoNumber') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "必填"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.tolast
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("秒杀专场")])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary countdown-bar"
  }, [(_vm.secFlag === 0) ? _c('span', {
    staticClass: "link",
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [_vm._v("抢购即将开始，敬请期待")]) : (_vm.secFlag === 1) ? _c('span', {
    staticClass: "link",
    staticStyle: {
      "color": "red",
      "float": "left"
    }
  }, [(_vm.secInfo.limitNumber > 0) ? _c('span', [_vm._v("已售" + _vm._s(_vm.secInfo.usedNumber) + "单")]) : _c('span', [_vm._v("抢购中")])]) : _c('span', {
    staticStyle: {
      "color": "#FFFFFF",
      "background": "#666",
      "border-radius": "3px",
      "padding": "2px 3px"
    }
  }, [_vm._v("秒杀结束")]), _vm._v(" "), _c('span', {
    staticClass: "link countdown",
    staticStyle: {
      "float": "right"
    }
  }, [_c('Countdown', {
    attrs: {
      "startDT": _vm.secInfo.startDT,
      "endDT": _vm.secInfo.endDT
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card facebook-card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [(_vm.openLink()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/nrxuBV",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl,
      "width": "100%"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl,
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('newMerchandiseListA', {
    attrs: {
      "merch-list": _vm.merchandise,
      "description": _vm.$route.query.des,
      "channel": _vm.$route.params.channel
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "icon-pdf-style",
    attrs: {
      "src": __webpack_require__(312)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.fileName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(Math.round(this.fileSize / 1024)) + "KB")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_vm._v("\n    点击下载后，可点击右上角【•••】将文件保存到手机\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "down",
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('div', {
    staticClass: "send",
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v("发送至邮箱")])])
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("科室搜索")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block_input"
  }, [_c('div', {
    staticClass: "wrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('label', {
    staticClass: "icon icon-search icon_2",
    attrs: {
      "for": "search-department"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "icon_2",
    attrs: {
      "type": "search",
      "id": "search-department",
      "placeholder": "请输入科室名称"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.filteredData), function(enterprise, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group",
      on: {
        "click": function($event) {
          return _vm.updateEnterprise(enterprise)
        }
      }
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(enterprise.enterpriseName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    })]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content flex-col"
  }, [_c('span', {
    staticClass: "first-title",
    staticStyle: {
      "margin-left": "35px",
      "margin-right": "34px"
    }
  }, [_vm._v("电脑端微信使用小程序的方法（通用版）")]), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("方法一：使用「在电脑上打开」功能")]), _vm._v(" "), _c('span', {
    staticClass: "describe",
    staticStyle: {
      "margin": "5px 25px 11px 25px"
    }
  }, [_vm._v("\n      确保在电脑上已登录微信，点击小程序右上角【•••】，点击【在电脑上打开】（需要升级至最新版微信）\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "outer2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图4.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("方法二：打开手机正在浏览的小程序")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("\n      保证小程序在手机上是打开的状态，然后登录电脑版微信，点击左下角【手机】按钮，便可打开手机上正在浏览的小程序\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "outer3",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图3.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("Windows版微信使用小程序的方法")]), _vm._v(" "), _c('span', {
    staticClass: "word4"
  }, [_vm._v("通过小程序面板打开小程序（仅支持Windows版）")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("\n      登录Windows版微信，点击左下角【小程序】图标，打开小程序，即可打开已添加或者已使用过的小程序\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word4"
  }, [_vm._v("将淘基因添加至「我的小程序」，后续访问更快捷")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("点击小程序右上角【•••】，点击【添加的我的小程序】")]), _vm._v(" "), _c('img', {
    staticClass: "outer2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图1.png'
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.tolast
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的对账单")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('OldAccountChecked')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [(_vm.canWatch) ? _c('div', [_c('ChooseBillType', {
    attrs: {
      "showComp": _vm.showComp,
      "researchGroupList": _vm.researchGroupList
    }
  })], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab1"
    }
  }, [_vm._v("个人对账单")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab2"
    }
  }, [_vm._v("课题组对账单")])])
}]}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "overflow-y": "scroll",
      "padding": "5px 10px",
      "background-color": "#F7F8FA"
    }
  }, _vm._l((_vm.expressList), function(express) {
    return _c('div', {
      staticClass: "content-block"
    }, [_c('div', {
      staticClass: "block-item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [(express.company === 1) ? _c('span', [_vm._v("顺丰快递")]) : _c('span', [_vm._v("跨越快递")]), _vm._v(" "), _c('span', [_vm._v("：" + _vm._s(express.mailNo) + " ")]), _vm._v(" "), _c('svg', {
      staticClass: "icon copySvg",
      attrs: {
        "t": "1691638351275",
        "data-clipboard-text": ((express.mailNo) + ": " + (express.contractNoList.join(',')) + " "),
        "id": "tag-copy",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "5506",
        "width": "16",
        "height": "16",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      },
      on: {
        "click": _vm.copy
      }
    }, [_c('path', {
      attrs: {
        "d": "M857.373005 65.290005 469.604424 65.290005c-34.211173 0-62.044078 27.832905-62.044078 62.043055l0 10.340509-63.076594 0c-25.993001 0-48.228421 16.346293-57.001225 39.293935L166.626995 176.967504c-34.21015 0-62.043055 27.832905-62.043055 62.043055l0 657.655358c0 34.21015 27.832905 62.043055 62.043055 62.043055l550.115086 0c34.21015 0 62.043055-27.832905 62.043055-62.043055l0-49.634444 78.587869 0c34.21015 0 62.043055-27.832905 62.043055-62.043055L919.41606 127.33306C919.41606 93.122911 891.583155 65.290005 857.373005 65.290005zM344.483752 179.035606l194.402595 0c10.833743 0 19.646456 8.813736 19.646456 19.646456 0 10.833743-8.813736 19.646456-19.646456 19.646456L344.483752 218.328517c-10.833743 0-19.646456-8.813736-19.646456-19.646456C324.836273 187.849342 333.650009 179.035606 344.483752 179.035606zM737.423099 896.665917c0 11.402701-9.278317 20.681018-20.681018 20.681018L166.626995 917.346935c-11.403724 0-20.681018-9.278317-20.681018-20.681018L145.945977 239.010559c0-11.402701 9.277294-20.681018 20.681018-20.681018l120.111588 0c8.197706 24.02723 30.977525 41.362037 57.744145 41.362037l194.402595 0c26.767644 0 49.54644-17.334807 57.744145-41.362037l120.111588 0c11.402701 0 20.681018 9.278317 20.681018 20.681018L737.422076 896.665917zM878.054023 784.988418c0 11.402701-9.278317 20.681018-20.681018 20.681018l-78.587869 0L778.785136 239.010559c0-34.21015-27.832905-62.043055-62.043055-62.043055L595.886549 176.967504c-8.771781-22.947641-31.007201-39.293935-57.001225-39.293935l-89.963964 0L448.921359 127.33306c0-11.403724 9.278317-20.681018 20.683065-20.681018l387.768581 0c11.402701 0 20.681018 9.277294 20.681018 20.681018L878.054023 784.988418z",
        "fill": "#5878fa",
        "p-id": "5507"
      }
    }), _c('path', {
      attrs: {
        "d": "M620.597347 334.252737 260.748652 334.252737c-11.422144 0-20.681018 9.259898-20.681018 20.681018s9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018S632.018467 334.252737 620.597347 334.252737z",
        "fill": "#5878fa",
        "p-id": "5508"
      }
    }), _c('path', {
      attrs: {
        "d": "M620.597347 454.201619 260.748652 454.201619c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C641.278365 463.46254 632.018467 454.201619 620.597347 454.201619z",
        "fill": "#5878fa",
        "p-id": "5509"
      }
    }), _c('path', {
      attrs: {
        "d": "M440.673511 574.151525 260.748652 574.151525c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l179.924859 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C461.35453 583.411423 452.093609 574.151525 440.673511 574.151525z",
        "fill": "#5878fa",
        "p-id": "5510"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), _vm._l((express.contractNoList), function(contractNo) {
      return _c('div', {
        staticClass: "block-item"
      }, [_c('div', [_c('span', [_vm._v(" 实验编号：" + _vm._s(contractNo))])]), _vm._v(" "), _c('div', {
        staticClass: "update-address update-address-color",
        on: {
          "click": function($event) {
            return _vm.downloadExpressOutFile(contractNo)
          }
        }
      }, [_c('svg', {
        staticClass: "icon",
        attrs: {
          "t": "1691039522552",
          "viewBox": "0 0 1024 1024",
          "version": "1.1",
          "xmlns": "http://www.w3.org/2000/svg",
          "p-id": "5135",
          "width": "14",
          "height": "14",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }
      }, [_c('path', {
        attrs: {
          "d": "M511.689076 305.399622",
          "p-id": "5136",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M512.005585 576.67584h-0.633018",
          "p-id": "5137",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M97.745455 199.262953",
          "p-id": "5138",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M646.209164 556.182807h-0.633019",
          "p-id": "5139",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M657.901382 876.590545c10.882327 0 21.345745 8.823156 21.345745 19.705484s-10.46528 19.705484-21.347607 19.705484H221.938036c-25.918371 0-49.470371-10.591884-66.528349-27.649862-17.057978-17.057978-27.649862-40.609978-27.649862-66.528349V242.321222c0-25.918371 10.591884-49.470371 27.649862-66.528349 17.057978-17.057978 40.609978-27.649862 66.528349-27.649862h579.50208c25.914647 0 49.466647 10.593745 66.524626 27.651724 17.061702 17.061702 27.653585 40.613702 27.653585 66.526487v349.640145c0 10.882327-8.823156 22.401396-19.705483 22.401397s-19.705484-11.286342-19.705484-22.168669v-349.872873c0-15.034182-6.170065-28.725993-16.106589-38.662517-9.934662-9.934662-23.622749-16.104727-38.660655-16.104727H221.938036c-15.039767 0-28.729716 6.168204-38.664378 16.102866-9.934662 9.934662-16.102865 23.624611-16.102865 38.664378v579.50208c0 15.039767 6.168204 28.729716 16.102865 38.664378 9.934662 9.934662 23.624611 16.102865 38.664378 16.102865h435.963346z",
          "p-id": "5140",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M662.965527 506.455505h-0.633018",
          "p-id": "5141",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M351.250618 363.834647h391.635317v26.273978H351.250618zM351.250618 519.035811h391.635317v26.273978H351.250618zM351.250618 674.236975h160.121949v26.273978H351.250618z",
          "p-id": "5142",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M260.952436 355.221876h43.49952v43.49952H260.952436zM260.952436 510.42304h43.49952v43.49952H260.952436zM260.952436 665.624204h43.49952v43.49952H260.952436z",
          "p-id": "5143",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M638.30016 792.324655c-11.682909 0-21.153978-9.472931-21.153978-21.153979 0-11.682909 9.471069-21.153978 21.153978-21.153978h247.37792c11.682909 0 21.153978 9.471069 21.153978 21.153978 0 11.681047-9.471069 21.153978-21.153978 21.153979H638.30016z",
          "p-id": "5144",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M795.785775 890.969367c-8.21248 8.260887-21.569164 8.296262-29.830051 0.083782-8.259025-8.214342-8.2944-21.571025-0.08192-29.830051l90.108276-90.158545-89.903476-89.951884c-8.21248-8.260887-8.177105-21.617571 0.083781-29.830051 8.259025-8.214342 21.615709-8.178967 29.830051 0.08192l104.641629 104.703069c6.428858 6.464233 7.80288 16.048873 4.138822 23.848029-1.016553 2.303069-2.463185 4.460916-4.343622 6.352524l-104.64349 104.701207z",
          "p-id": "5145",
          "fill": "#5878fa"
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "padding-top": "3px"
        }
      }, [_vm._v("出货单")])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }), _vm._v(" "), (!express.routes) ? _c('div', {
      staticClass: "block-express-invalid"
    }, [_vm._v("由于时间过长,无法为您提供该快递的物流信息,具体咨询\n      "), (express.company === 1) ? _c('span', [_vm._v("顺丰快递")]) : _c('span', [_vm._v("跨越快递")])]) : (express.routes && express.routes[0] && !express.showAll) ? _c('div', {
      staticClass: "block-express leftDiv"
    }, [_c('svg', {
      staticClass: "currentIcon",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "width": "14px",
        "height": "14px",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "fill": "none",
        "version": "1.1",
        "viewBox": "0 0 17 17"
      }
    }, [_c('g', [_c('g', [_c('ellipse', {
      attrs: {
        "cx": "8.5",
        "cy": "8.5",
        "rx": "8.5",
        "ry": "8.5",
        "fill": "#5878FA"
      }
    })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
      attrs: {
        "d": "M12.31888,5.92376C11.45951,4.71511,10.05733,3.99747287,8.56299,4.00149319L8.56374,4.0000144239C6.61387,3.99515438,4.877516,5.21888,4.246297,7.04283C3.432642,9.39397,4.700883,11.95205,7.079000000000001,12.75648C9.45712,13.5609,12.04457,12.30706,12.85823,9.95593C12.85858,9.954979999999999,12.85892,9.954039999999999,12.85925,9.95309C12.92073,9.77952,12.82826,9.58954,12.6527,9.52876C12.47584,9.465910000000001,12.28078,9.55555,12.21537,9.72973C11.92629,10.52698,11.37464,11.20506,10.648959999999999,11.65512C8.86125,12.76387,6.50288,12.2299,5.3814,10.46247C4.259928,8.695039999999999,4.80003,6.363440000000001,6.58775,5.25469C8.37547,4.145935,10.733830000000001,4.679908,11.85531,6.4473400000000005L11.03392,6.4473400000000005C10.84749,6.4563500000000005,10.70375,6.6130700000000004,10.71286,6.79738C10.72198,6.98169,10.8805,7.1238,11.06692,7.11479L12.6917,7.11479C12.86571,7.099130000000001,12.99918,6.95529,13,6.7825500000000005L13,5.19327C12.9835,5.01981,12.83613,4.887289,12.6599,4.887437C12.47141,4.887595,12.31872,5.0388,12.31888,5.22516L12.31888,5.92376ZM8.90278,5.97201C8.885010000000001,5.7999,8.73795,5.6692800000000005,8.56297,5.67017C8.37646,5.6697500000000005,8.22447,5.81803,8.22241,6.002409999999999L8.22241,8.48534C8.23302,8.58031,8.284379999999999,8.66621,8.36344,8.72117L9.956710000000001,9.8336L9.98446,9.8514C10.14215,9.9409,10.34307,9.89343,10.442789999999999,9.743120000000001C10.54128,9.5932,10.50179,9.39307,10.35353,9.29074L8.90278,8.27843L8.90278,5.97201Z",
        "fill-rule": "evenodd",
        "fill": "#FFFFFF"
      }
    })])])])]), _vm._v(" "), (!express.showAll) ? _c('div', {
      staticClass: "div div_2"
    }) : _vm._e(), _vm._v(" "), (!express.showAll) ? _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "express-opcode-color"
    }, [_vm._v(_vm._s(express.routes[0].opcode))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "express-text-color",
      staticStyle: {
        "position": "relative"
      }
    }, [_vm._v(_vm._s(express.routes[0].remark))])]), _vm._v(" "), _c('span', {
      staticClass: "express-text-color"
    }, [_vm._v(_vm._s(express.routes[0].acceptTime))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((express.routes), function(route, i) {
      return (express.showAll) ? _c('div', {
        staticClass: "block-express leftDiv",
        staticStyle: {
          "display": "flex",
          "align-items": "start"
        }
      }, [(i !== 0) ? _c('div', {
        staticClass: "colorDiv_2 left1"
      }) : _vm._e(), _vm._v(" "), (i !== 0) ? _c('div', {
        staticClass: "div div_2",
        attrs: {
          "ali": ""
        }
      }) : _vm._e(), _vm._v(" "), (i === 0) ? _c('svg', {
        staticClass: "currentIcon",
        staticStyle: {
          "margin-top": "-10px"
        },
        attrs: {
          "width": "14px",
          "height": "14px",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "fill": "none",
          "version": "1.1",
          "viewBox": "0 0 17 17"
        }
      }, [_c('g', [_c('g', [_c('ellipse', {
        attrs: {
          "cx": "8.5",
          "cy": "8.5",
          "rx": "8.5",
          "ry": "8.5",
          "fill": "#5878FA"
        }
      })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
        attrs: {
          "d": "M12.31888,5.92376C11.45951,4.71511,10.05733,3.99747287,8.56299,4.00149319L8.56374,4.0000144239C6.61387,3.99515438,4.877516,5.21888,4.246297,7.04283C3.432642,9.39397,4.700883,11.95205,7.079000000000001,12.75648C9.45712,13.5609,12.04457,12.30706,12.85823,9.95593C12.85858,9.954979999999999,12.85892,9.954039999999999,12.85925,9.95309C12.92073,9.77952,12.82826,9.58954,12.6527,9.52876C12.47584,9.465910000000001,12.28078,9.55555,12.21537,9.72973C11.92629,10.52698,11.37464,11.20506,10.648959999999999,11.65512C8.86125,12.76387,6.50288,12.2299,5.3814,10.46247C4.259928,8.695039999999999,4.80003,6.363440000000001,6.58775,5.25469C8.37547,4.145935,10.733830000000001,4.679908,11.85531,6.4473400000000005L11.03392,6.4473400000000005C10.84749,6.4563500000000005,10.70375,6.6130700000000004,10.71286,6.79738C10.72198,6.98169,10.8805,7.1238,11.06692,7.11479L12.6917,7.11479C12.86571,7.099130000000001,12.99918,6.95529,13,6.7825500000000005L13,5.19327C12.9835,5.01981,12.83613,4.887289,12.6599,4.887437C12.47141,4.887595,12.31872,5.0388,12.31888,5.22516L12.31888,5.92376ZM8.90278,5.97201C8.885010000000001,5.7999,8.73795,5.6692800000000005,8.56297,5.67017C8.37646,5.6697500000000005,8.22447,5.81803,8.22241,6.002409999999999L8.22241,8.48534C8.23302,8.58031,8.284379999999999,8.66621,8.36344,8.72117L9.956710000000001,9.8336L9.98446,9.8514C10.14215,9.9409,10.34307,9.89343,10.442789999999999,9.743120000000001C10.54128,9.5932,10.50179,9.39307,10.35353,9.29074L8.90278,8.27843L8.90278,5.97201Z",
          "fill-rule": "evenodd",
          "fill": "#FFFFFF"
        }
      })])])])]) : _vm._e(), _vm._v(" "), (i === 0) ? _c('div', {
        staticClass: "div div_2"
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        class: i === 0 ? 'express-opcode-color' : 'over-express-opcode-color'
      }, [_vm._v(_vm._s(route.opcode))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center"
        }
      }, [_c('span', {
        class: i === 0 ? 'express-text-color' : 'over-express-text-color',
        staticStyle: {
          "position": "relative"
        }
      }, [_vm._v(_vm._s(route.remark))])]), _vm._v(" "), _c('span', {
        class: i === 0 ? 'express-text-color' : 'over-express-text-color'
      }, [_vm._v(_vm._s(route.acceptTime))])])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!express.showAll && express.routes),
        expression: "!express.showAll && express.routes"
      }],
      staticClass: "group_2",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.changeOpen(express)
        }
      }
    }, [_c('span', {
      staticClass: "clickExpand",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("展开")]), _vm._v(" "), _c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1691030298315",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1049",
        "width": "10",
        "height": "10",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('path', {
      attrs: {
        "d": "M832 325.504L512 637.504 192 325.504a28.8 28.8 0 0 0-41.984 0 28.8 28.8 0 0 0-8.96 20.992c0 8 2.624 14.72 7.936 20.032l340.992 331.968c6.016 6.016 13.376 8.96 22.016 8.96 8.704 0 16-2.944 22.016-8.96l341.056-331.008a31.232 31.232 0 0 0 7.936-21.504c0-8.32-2.944-15.36-8.96-20.992a29.76 29.76 0 0 0-41.984 0.512H832z",
        "p-id": "1050",
        "fill": "#bfbfbf"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (express.showAll && express.routes),
        expression: "express.showAll && express.routes"
      }],
      staticClass: "group_2",
      on: {
        "click": function($event) {
          return _vm.changeOpen(express)
        }
      }
    }, [_c('span', {
      staticClass: "clickExpand",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("收起")]), _vm._v(" "), _c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1691030493766",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1816",
        "width": "10",
        "height": "10",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('path', {
      attrs: {
        "d": "M488.96 311.04l-339.968 356.928a32.256 32.256 0 0 0-8.96 22.016c0 8 2.944 15.36 8.96 22.016v1.024c6.016 5.952 13.184 8.96 21.504 8.96 8.32 0 15.488-3.008 21.504-8.96l320-336 320 336c6.016 5.952 13.184 8.96 21.504 8.96 8.32 0 15.488-3.008 21.504-8.96v-1.024a32.256 32.256 0 0 0 8.96-22.016 32.256 32.256 0 0 0-8.96-22.016L534.976 311.04A31.168 31.168 0 0 0 512 302.08a31.168 31.168 0 0 0-23.04 8.96z",
        "p-id": "1817",
        "fill": "#bfbfbf"
      }
    })])])], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("审批订单详情")])]), _vm._v(" "), (_vm.hasDisplayData) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mouthNumber"
  }, [_vm._v("月度累积已消费金额：¥" + _vm._s(_vm.splitMoney(_vm.orderDetail.monthlyTotalApprovedAmount)))]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "orderNumber",
    staticStyle: {
      "margin-top": "0",
      "color": "#424242"
    }
  }, [_vm._v("订单信息")]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("下单成员：" + _vm._s(_vm.orderDetail.orderPerson))]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("下单时间：" + _vm._s(_vm.orderDetail.orderTime))]), _vm._v(" "), _c('span', {
    staticClass: "orderNumber"
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderDetail.orderNo))]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v("订单总金额：¥" + _vm._s(_vm.splitMoney(_vm.orderDetail.price)))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "orderNumber",
    staticStyle: {
      "margin-top": "0",
      "color": "#424242"
    }
  }, [_vm._v("产品列表")]), _vm._v(" "), _vm._l((_vm.orderDetail.itemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_3"
    }, [_c('div', {
      staticClass: "moneyWrap"
    }, [(item.TLNo) ? _c('span', {
      staticClass: "info_3"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.promoter3ID) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]) : _c('span', {
      staticClass: "info_3"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.tax) ? _c('div', {
      staticClass: "outer"
    }, [_c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.tax))])]), _vm._v(" "), _c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.symbol || item.microName))])]), _vm._v(" "), _c('span', {
      staticClass: "color_4"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v(_vm._s(item.nm_ID || item.microNo))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "periodWrap"
    }, [_c('div', {
      staticClass: "sectionWrap research-background-color"
    }, [_c('span', {
      staticClass: "section"
    }, [_vm._v("周期：" + _vm._s(item.workdays) + "个工作日")])]), _vm._v(" "), _c('span', {
      staticClass: "money research-font-color"
    }, [_vm._v("¥" + _vm._s(_vm.splitMoney(item.price)))])])]), _vm._v(" "), _vm._m(0, true)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [(_vm.orderDetail.fromEmkt) ? _c('div', {
    staticClass: "col1",
    on: {
      "click": function($event) {
        return _vm.toggleResearchGroupDisagreeBox()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("不同意")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.fromEmkt) ? _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": function($event) {
        return _vm.agree()
      }
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("同意")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw",
      "visibility": "hidden"
    }
  }, [_vm._v("hidden")])]) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupDisagreeBox) ? _c('ResearchGroupDisagreeBox', {
    on: {
      "toggleShow": _vm.toggleResearchGroupDisagreeBox,
      "confirm": _vm.disagree
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.researchGroupDetail) ? _c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.researchGroupDetail), function(info, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group"
    }, [_c('span', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(info.name))]), _vm._v(" "), _c('span', {
      staticClass: "attr"
    }, [_vm._v(_vm._s(info.value))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border",
    staticStyle: {
      "margin-left": "0rem"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list person-card",
    staticStyle: {
      "margin-top": "-2px",
      "margin-bottom": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [(_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerName))]) : _vm._e()]), _vm._v(" "), (_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerNo))]) : _vm._e(), _vm._v(" "), (_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-text",
    staticStyle: {
      "height": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.enterpriseName))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "height": "15%",
      "border": "1px solid #ccc",
      "background": "white",
      "margin-top": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(1)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_pay.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.waitPaidOrders && _vm.myOrder.waitPaidOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitPaidOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(2)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_receive.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.waitDeliverOrders && _vm.myOrder.waitDeliverOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitDeliverOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_estimate.png'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(3)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_complete.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.finishedOrders && _vm.myOrder.finishedOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.finishedOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(4)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_cancel.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.canceledOrders && _vm.myOrder.canceledOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.canceledOrders.length))]) : _vm._e()])]) : _c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "height": "15%",
      "border": "1px solid #ccc",
      "background": "white",
      "margin-top": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(10)
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("审核失败")]), _vm._v(" "), (_vm.myOrder.failAuditOrders && _vm.myOrder.failAuditOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.failAuditOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(6)
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("待审核")]), _vm._v(" "), (_vm.myOrder.waitAuditOrders && _vm.myOrder.waitAuditOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitAuditOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(7)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("报价完成")]), _vm._v(" "), (_vm.myOrder.quoteCompletedOrders && _vm.myOrder.quoteCompletedOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.quoteCompletedOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(8)
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("录入完成")]), _vm._v(" "), (_vm.myOrder.completeOrders && _vm.myOrder.completeOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.completeOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(9)
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("待签署")]), _vm._v(" "), (_vm.myOrder.waitSignOrders && _vm.myOrder.waitSignOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitSignOrders.length))]) : _vm._e()]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "0.2rem"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'userInfo'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("个人信息")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'VipPlanDetails'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的大客户计划")])])])], 1), _vm._v(" "), (!_vm.isSFFlag) ? _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'ResearchGroupHome'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的课题组")]), _vm._v(" "), (_vm.totalWaitApproveOrder) ? _c('div', {
    staticClass: "item-title-after wait-approve"
  }, [_vm._v(_vm._s(_vm.totalWaitApproveOrder))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.myCoupons.length != 0) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after font-size"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'myCoupons'
      }
    }
  }, [_vm._v("共" + _vm._s(_vm.myCoupons.length) + "张优惠券\n                    "), (_vm.expireInOneDay) ? _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": ".6rem"
    }
  }, [_vm._v("优惠券即将过期")]) : _vm._e()])], 1)])])]) : _c('li', [_vm._m(14)]), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'myRecommend'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-browser"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("推荐给好友")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'passwordChange'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("修改密码")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'WeappAddress'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("收货地址管理")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的信用")]), _vm._v(" "), (_vm.creditPay) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(_vm.sessionInfo.customerInfo.emktCreditBalance)) + "\n                ")]) : (_vm.creditStatus === 0) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'applyCreditPay'
      }
    }
  }, [_vm._v("申请信用支付")])], 1) : _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm.payTypeApplyStatus) + "\n                  ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的余额")]), _vm._v(" "), (_vm.moneyRemain) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(_vm.sessionInfo.customerInfo.prepayMoneyRemain)) + "\n                ")]) : _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(0)) + "\n                ")])])])]), _vm._v(" "), (_vm.showBillInfo) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的对账单")]), _vm._v(" "), _c('button', {
    staticClass: "item-title-after font-size",
    staticStyle: {
      "color": "#399FED"
    },
    on: {
      "click": function($event) {
        return _vm.getMyAccountChecked()
      }
    }
  }, [_vm._v("\n                            查看对账单\n                          ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'myAgreement'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-menu"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("注册协议")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("联系我们")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'publicNumber'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-code"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("关注公众号")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger external",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("注销登录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "width": "88%"
    }
  }, [_c('span', {
    staticStyle: {
      "text-align": "center",
      "display": "block",
      "margin-top": ".5rem"
    }
  }, [_vm._v("\n        个人中心\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": __webpack_require__(1231),
      "width": "80"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_receive.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_comment.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/complete.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/cancel.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_receive.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_comment.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/complete.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    }
  }, [_c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/cancel.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("报价作废")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-gift"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-gift"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("无")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-emoji"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-search"
  })])
}]}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "登录手机号或邮箱"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "登录密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("新登录ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLoginId),
      expression: "newLoginId",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "新ID"
    },
    domProps: {
      "value": (_vm.newLoginId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLoginId = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认新ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLoginIdRe),
      expression: "newLoginIdRe",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "确认新ID"
    },
    domProps: {
      "value": (_vm.newLoginIdRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLoginIdRe = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("修改手机/邮箱")])])
}]}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "content-block-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanName) + "成员信息")]), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  }, [_c('ul', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("身份")]), _vm._v(" "), (_vm.member.role === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("储值联系人")]) : (_vm.member.role === 2) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("积分联系人")]) : (_vm.member.role === 3) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("管理联系人")]) : (_vm.member.role === 4) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("对账联系人")]) : (_vm.member.role === 5) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("普通成员")]) : _c('div', {
    staticClass: "item-title"
  }, [_vm._v("未知")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanMemberName))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanMemberNo))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("大客户计划编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.customerPlanNo))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.enterpriseName))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.mobile))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("是否禁用")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v("否")]) : _c('div', {
    staticClass: "item-title"
  }, [_vm._v("否")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("加入时间")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.joinPlanDt))]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("有效截止时间")]), _vm._v(" "), (_vm.member.availableFlag === 1) ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.member.overdueDt))]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background-color": "rgba(250, 250, 250, 1)"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "flex-col justify-between"
  }, [_c('div', {
    staticClass: "mod4 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('experiment-header', {
    attrs: {
      "contractNo": _vm.contractProgressInfo.contractNo,
      "status": _vm.contractProgressInfo.status
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, _vm._l((_vm.contractProgressInfo.progressNotes), function(progress, index) {
    return _c('div', {
      key: index,
      staticClass: "historyProgress"
    }, [_c('div', {
      staticClass: "box4 flex-row justify-between"
    }, [(index === 0) ? _c('img', {
      staticClass: "label1",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/最新进展.svg"
      }
    }) : _c('div', {
      staticClass: "bd3 flex-col"
    }), _vm._v(" "), (index === 0) ? _c('span', {
      staticClass: "info4"
    }, [_vm._v(_vm._s(progress.createDT) + " 最新进展：")]) : _c('span', {
      staticClass: "txt4"
    }, [_vm._v(_vm._s(progress.createDT))]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "main1 flex-col",
      staticStyle: {
        "margin-left": "13px"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [(index !== _vm.contractProgressInfo.progressNotes.length - 1) ? _c('div', {
      staticClass: "group_history flex-col"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "paragraph1",
      class: {
        'paragraph-font1': index !== 0,
          'paragraph-font2': index === 0,
      },
      style: ({
        'margin-left': index === _vm.contractProgressInfo.progressNotes.length - 1 ? '20px' : '10px',
      })
    }, [_c('span', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_vm._v("\n                    1.  " + _vm._s(progress.content) + "\n                    "), _c('br')])])])])
  }), 0)], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [(_vm.hasSharePermission) ? _c('button', {
    staticClass: "share-link",
    attrs: {
      "disabled": !_vm.hasLogin || _vm.totalPrice <= 0
    },
    on: {
      "click": function($event) {
        return _vm.shareBuyCartContent()
      }
    }
  }, [_vm._v("生成分享链接")]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title",
    staticStyle: {
      "font-weight": "bold",
      "color": "#00469A"
    }
  }, [_vm._v("我的购物车(" + _vm._s(_vm.getTotalGoodsNum) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "content pull-to-refresh-content",
    attrs: {
      "data-ptr-distance": "55"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [(!_vm.hasLogin) ? _c('div', {
    staticClass: "content-block-title"
  }, [_c('span', {
    staticClass: "button button-round",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'login'
        })
      }
    }
  }, [_vm._v("点此登录以同步手机端和电脑端购物车")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "overflow-x": "hidden",
      "padding-bottom": "2rem"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-bottom": "6rem"
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('li', {
      staticStyle: {
        "margin-right": ".8rem"
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('label', {
      staticClass: "label-checkbox "
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.isChecked),
        expression: "product.isChecked"
      }],
      attrs: {
        "type": "checkbox",
        "name": "my-checkbox"
      },
      domProps: {
        "checked": Array.isArray(product.isChecked) ? _vm._i(product.isChecked, null) > -1 : (product.isChecked)
      },
      on: {
        "click": function($event) {
          return _vm.getChecked(product)
        },
        "change": function($event) {
          var $$a = product.isChecked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(product, "isChecked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(product, "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(product, "isChecked", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem",
        "border-bottom": "0px solid"
      },
      on: {
        "click": function($event) {
          return _vm.goToDetail(product)
        }
      }
    }, [(product.availableFlag === 0) ? _c('div', {
      staticClass: "color-danger"
    }, [_vm._v("商品已下架")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [(_vm.filteredShowPromotions(product) && _vm.filteredShowPromotions(product).length > 0) ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(product)[0].name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [(product.categoryId !== _vm.emkt.PRODUCT_TYPE_SERVICE_CONSTANT) ? _c('span', _vm._l((product._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0) : _c('span', [_c('span', [_vm._v(_vm._s(product.product))])])]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((product._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(abstract.valueText !== '-1') ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo' && abstract.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()])])
    }), _vm._v(" "), _vm._l((product._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(product.selfOperated === 0) ? _c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#1482E7"
      }
    }, [_vm._v("【代购】")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [_vm._v("周期" + _vm._s(product.cycle) + "个工作日")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(product.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (product.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("定制")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "margin-left": "13%",
        "height": "50px",
        "border-bottom": "1px solid #e7e7e7"
      }
    }, [_c('div', {
      staticClass: "item-media",
      staticStyle: {
        "width": "38%",
        "color": "#00469A"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small"
      }
    }, [_vm._v("￥")]), _vm._v(" "), (_vm.showSecPromotionInfo(product)) ? _c('span', [(_vm.secPromotionType(product) === 1) ? _c('span', {
      staticStyle: {
        "font-size": "larger",
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.secPromotionPrice(product)) + " ")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行",
        "width": "15px"
      }
    })]) : _c('span', [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "font-size": "larger"
      }
    }, [_vm._v(_vm._s(product.priceMax && product.priceMax.toFixed(2)))]) : (product.categoryId !== _vm.emkt.PRODUCT_TYPE_SERVICE_CONSTANT) ? _c('span', {
      staticStyle: {
        "font-size": "larger"
      }
    }, [_vm._v(_vm._s(product.priceMin && product.priceMin.toFixed(2)))]) : _c('span', {
      staticStyle: {
        "font-size": "larger"
      }
    }, [_vm._v(_vm._s(product.standardPrice && product.standardPrice.toFixed(2)))])])]), _vm._v(" "), (product.categoryId == 7) ? _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "width": "38%"
      }
    }, [_c('a', {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "href": "javascript:void 0"
      },
      on: {
        "click": function($event) {
          return _vm.changeQuantity(product, -1)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('input', {
      staticStyle: {
        "width": "25px",
        "height": "30px",
        "padding": "0",
        "text-align": "center",
        "border": "1px solid #e9e9e9",
        "color": "#00469A"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": product.productQuantity
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": "javascript:void 0"
      },
      on: {
        "click": function($event) {
          return _vm.changeQuantity(product, 1)
        }
      }
    }, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), (product.categoryId == 10 && _vm.QuoteStatus === false) ? _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "width": "38%"
      }
    }, [_c('router-link', {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "to": {
          name: 'custOrder',
          query: {
            cust: product
          }
        }
      }
    }, [_vm._v("修改")])], 1) : (product.categoryId == 10 && _vm.QuoteStatus === true) ? _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "width": "38%"
      }
    }, [_c('span', {
      staticClass: "gotopay_button_style",
      staticStyle: {
        "margin-right": "5px",
        "color": "gray"
      }
    }, [_vm._v("修改")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-media",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('div', {
      staticClass: "item-input"
    }, [_c('a', {
      staticClass: "item-media",
      on: {
        "click": function($event) {
          return _vm.removeProduct(product, product.merchandiseId)
        }
      }
    }, [_vm._m(2, true)])])])])])
  }), 0)])])]), _vm._v(" "), _c('footer', {
    staticClass: "bar bar-footer-secondary",
    staticStyle: {
      "height": "3rem",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "padding": "3%"
    }
  }, [_c('label', {
    staticClass: "label-checkbox item-content",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckedAll),
      expression: "isCheckedAll"
    }],
    attrs: {
      "type": "checkbox",
      "name": "my-checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckedAll) ? _vm._i(_vm.isCheckedAll, null) > -1 : (_vm.isCheckedAll)
    },
    on: {
      "click": _vm.checkedAll,
      "change": function($event) {
        var $$a = _vm.isCheckedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckedAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  }), _c('span', {
    staticStyle: {
      "margin-left": "0.3rem"
    }
  }, [_vm._v("合计:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "0.7rem"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("￥")]), _vm._v(" "), (_vm.secPromotionProductIncluded()) ? _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "bold",
      "font-size": "large"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.totalPrice) + "\n              "), _c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
      "alt": "秒杀进行",
      "height": "20px"
    }
  })]) : _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "large"
    }
  }, [_vm._v(_vm._s(_vm.totalPrice))])])])]), _vm._v(" "), (_vm.isSsoFlag === false) ? _c('section', {
    staticClass: "gotopay1 gotopay_background",
    class: {
      gotopay_acitvity: _vm.totalPrice <= 0
    },
    staticStyle: {
      "margin-left": "180px"
    }
  }, [(_vm.totalPrice <= 0) ? _c('span', {
    staticClass: "gotopay1_button_style"
  }, [_vm._v("保存")]) : _c('span', {
    staticClass: "gotopay1_button_style",
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.saveBuyCart()
      }
    }
  }, [_vm._v("保存")])]) : _vm._e(), _vm._v(" "), (_vm.isSsoFlag) ? _c('section', {
    staticClass: "gotopay"
  }, [(_vm.totalPrice <= 0) ? _c('span', {
    staticClass: "gotopay_button_style"
  }, [_c('img', {
    staticClass: "img-pay-btn",
    attrs: {
      "src": _vm.baseUrl + 'go_to_pay_cart_1.png'
    }
  })]) : _c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.gotoOrderContentConfirm()
      }
    }
  }, [_c('img', {
    staticClass: "img-pay-btn",
    attrs: {
      "src": _vm.baseUrl + 'go_to_pay_cart_2.png'
    }
  })])]) : _c('section', {
    staticClass: "gotopay gotopay_background",
    class: {
      gotopay_acitvity: _vm.totalPrice <= 0
    }
  }, [(_vm.totalPrice <= 0) ? _c('span', {
    staticClass: "gotopay_button_style"
  }, [_vm._v("去审核")]) : _c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.gotoOrderQuotedPriceConfirm()
      }
    }
  }, [_vm._v("去审核")])])])]), _vm._v(" "), (_vm.ifShowShareInstruction) ? _c('div', {
    staticClass: "modal-overlay modal-overlay-visible",
    on: {
      "click": function($event) {
        _vm.ifShowShareInstruction = false
      }
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "30px",
      "width": "35%"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/分享指引.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ifShowBox) ? _c('div', {
    staticClass: "emkt-modal-overlay emkt-modal-overlay-visible"
  }, [_c('div', {
    staticClass: "emkt-modal-in"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "emkt-modal-buttons "
  }, [_c('span', {
    staticClass: "emkt-modal-button",
    on: {
      "click": function($event) {
        _vm.ifShowBox = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "emkt-modal-button",
    on: {
      "click": _vm.getShareCartContent
    }
  }, [_vm._v("添加")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-to-refresh-layer"
  }, [_c('div', {
    staticClass: "preloader"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-to-refresh-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('span', {
    staticClass: "icon icon-remove"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emkt-modal-innner"
  }, [_c('div', [_vm._v("您的好友帮您挑选好了产品"), _c('br'), _vm._v("是否添加到购物车？")])])
}]}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs-box"
  }, [_c('div', {
    staticClass: "at-tabs__header"
  }, [_c('div', {
    class: ['at-tabs__item', _vm.tabType === 1 && 'at-tabs__item--active'],
    on: {
      "click": function () {
        this$1.tabType = 1
      }
    }
  }, [_vm._v("\n                       课题组成员\n                     ")]), _vm._v(" "), _c('div', {
    class: ['at-tabs__item', _vm.tabType === 2 && 'at-tabs__item--active'],
    on: {
      "click": function () {
        this$1.tabType = 2
      }
    }
  }, [_vm._v("\n                 申请列表\n               ")])])]), _vm._v(" "), (_vm.tabType === 1) ? _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.memberList), function(member, index) {
    return _c('router-link', {
      key: index,
      staticClass: "outer_attr",
      attrs: {
        "to": {
          name: 'ResearchMemberDetail',
          query: {
            memberIndex: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "group"
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [(member.approveType === _vm.approveTypeNone) ? _c('span', {
      staticClass: "approve_none"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]))]) : _vm._e(), _vm._v(" "), (member.approveType === _vm.approveTypeAll) ? _c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]))]) : _vm._e(), _vm._v(" "), (member.approveType === _vm.approveTypeThreshold) ? _c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]) + " ")]) : _vm._e(), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "empty"
    })])])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.addMember
    }
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "addMember"
  }, [_vm._v("添加成员")])])]) : _vm._e(), _vm._v(" "), (_vm.tabType === 2 && _vm.approvalMemberList.length > 0) ? _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.approvalMemberList), function(member, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr",
      on: {
        "click": function($event) {
          return _vm.goDetailOrApproval(member, index)
        }
      }
    }, [_c('div', {
      staticClass: "group"
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(member.status === 0 ? '待添加' : '已添加') + " ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-list-base', {
    attrs: {
      "orderList": _vm.orderList,
      "show-product-contract-no": _vm.showProductContractNo
    },
    on: {
      "goToOrderDetail": _vm.handleGoToOrderDetail
    },
    scopedSlots: _vm._u([{
      key: "itemButton",
      fn: function(order) {
        return [_vm._t("itemButton", null, null, order), _vm._v(" "), _c('gc-order-list-buttons-base', {
          attrs: {
            "order-detail": order
          },
          on: {
            "goToProgress": _vm.handleGoToOrderDetail,
            "downloadOrderText": _vm.handleDownloadOrderText
          }
        })]
      }
    }], null, true)
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("选择原合同")]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n    选择原合同\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value.split(':')[0]),
      expression: "attribute.value.split(':')[0]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value.split(':')[0])
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute.value.split(':'), 0, $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-final/bg.png",
      "swiper": _vm.swiper,
      "has-down-btn": true
    }
  }, [_c('div', {
    staticClass: "main-image-text-bg ani",
    staticStyle: {
      "background": "url(/static/img/anniversary/page-final/text-bg.png)",
      "background-size": "cover"
    },
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "main-image-text-inner"
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n        亲爱的"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.customerName || _vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.registrationDate || _vm.customerCreateDT))]), _c('br'), _vm._v("\n        第一次与吉凯相遇"), _c('br'), _vm._v(" "), (_vm.data.campaignTimes) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("参加过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.campaignTimes)))]), _vm._v("市场活动")]) : _vm._e(), _vm._v(" "), (_vm.data.firstContractDate) ? _c('p', {
    staticClass: "active-details"
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.firstContractDate)))]), _vm._v("签订第一个合同")]) : _vm._e(), _vm._v(" "), (_vm.data.purchaseTimes) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("一共购买过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.purchaseTimes)))]), _vm._v("产品或服务")]) : _vm._e(), _vm._v(" "), (_vm.data.amount) ? _c('p', {
    staticClass: "active-details"
  }, [_vm._v("合同总金额"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.getText(_vm.data.amount)))])]) : _vm._e()])])]), _vm._v(" "), _c('img', {
    staticClass: "pic-final ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/page-key-words-result/4.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "page-body"
  }, [(!_vm.fromOrderPage) ? _c('bar', {
    attrs: {
      "titleBar": _vm.titleBar
    },
    on: {
      "change": _vm.changeType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('coupon-selection', {
    attrs: {
      "myAllCoupons": _vm.myCoupons,
      "comeFrom": _vm.fromOrderPage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page1"
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.search.promotionGuid) ? _c('div', {
    staticStyle: {
      "color": "#c82829"
    }
  }, [_vm._v("\n        促销查询结果")]) : _c('div', [_vm._v("查询结果")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "content infinite-scroll-top",
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "id": "products",
      "data-distance": "5"
    }
  }, [(_vm.num === 0 && _vm.allQueryData.length == 0) ? _c('div', [_c('a', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "20px",
      "margin-left": "0.75rem",
      "color": "black"
    }
  }, [_vm._v("没有任何搜索结果!")]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('a', {
    staticStyle: {
      "margin-left": "0.75rem",
      "margin-right": "0.45rem"
    },
    on: {
      "click": _vm.toCust
    }
  }, [_vm._v("去定制!")]) : _c('router-link', {
    staticClass: "item-link item-content",
    staticStyle: {
      "margin-left": "0.75rem",
      "margin-right": "0.45rem"
    },
    attrs: {
      "to": {
        name: 'myMessage'
      }
    }
  }, [_vm._v("请找客服!")])], 1) : _vm._e(), _vm._v(" "), (_vm.num === 1 && _vm.allQueryData.length == 0) ? _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "20px",
      "margin-left": "0.75rem"
    }
  }, [_vm._v("正在查询中")]), _vm._v(" "), (_vm.showBarForKit) ? _c('div', {
    staticStyle: {
      "color": "#0a8ddf",
      "margin-bottom": "20px",
      "margin-right": "0.75rem"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    attrs: {
      "data-panel": "#panel-right-demo"
    }
  }, [_vm._v("筛选")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.num !== 0 && _vm.allQueryData.length !== 0) ? _c('div', [_c('div', {
    staticClass: "list-block bar-div"
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v("条结果")]), _vm._v(" "), (_vm.showBarForKit) ? _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    attrs: {
      "data-panel": "#panel-right-demo"
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])]), _vm._v(" "), _c('merchdata', {
    attrs: {
      "merchList": _vm.allQueryData,
      "showBarForKit": _vm.showBarForKit,
      "isFromSearch": true
    }
  }), _vm._v(" "), (_vm.allQueryData.length < _vm.total) ? _c('div', {
    staticClass: "button",
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), (_vm.allQueryData.length <= _vm.total && _vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('div', {
    staticClass: "button",
    staticStyle: {
      "text-align": "center",
      "background-color": "white",
      "padding-bottom": "2rem"
    },
    on: {
      "click": _vm.toCust
    }
  }, [_vm._v("我要定制")]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "searchGoods",
      "placeholder": "查询基因/病毒/功能...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "pb-standalone",
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center",
      "color": "rgb(8, 148, 236)"
    },
    attrs: {
      "type": "text",
      "value": "查看载体图谱",
      "readonly": "readonly"
    },
    on: {
      "click": _vm.gototlno
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("物流信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "4vw",
      "margin-top": "5vw"
    }
  }, [_c('svg', {
    attrs: {
      "width": "12px",
      "height": "17px",
      "viewBox": "0 0 12 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "执行中订单详情",
      "transform": "translate(-25.000000, -118.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "地点",
      "transform": "translate(25.000000, 118.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "3vw",
      "margin-top": "7vw"
    }
  }, [_c('span', {
    staticClass: "phone",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressMobile))]), _vm._v(" "), _c('span', {
    staticClass: "luWei",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressContactor))]), _vm._v(" "), _c('span', {
    staticClass: "summary",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('span', {
    staticClass: "expressInformation",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递信息")]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "expressCompany",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递公司")]), _vm._v(" "), _c('span', {
    staticClass: "zhongtongExpress",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressCompanyName))])]), _vm._v(" "), _c('div', {
    staticClass: "div"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "expressNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("快递单号")]), _vm._v(" "), _c('div', {
    staticClass: "group_2",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.expressInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "num",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.expressNo))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "empty_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('span', {
    staticClass: "sendStatus",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送状态")]), _vm._v(" "), _c('span', {
    staticClass: "sent",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.sendStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "div_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_c('span', {
    staticClass: "sender",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送人")]), _vm._v(" "), _c('span', {
    staticClass: "human",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiver))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_3"
  }, [_c('span', {
    staticClass: "sendingTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("寄/发送时间")]), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.sendDTString))])]), _vm._v(" "), _c('div', {
    staticClass: "div_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_4"
  }, [_c('span', {
    staticClass: "signReceiveStatus",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收状态")]), _vm._v(" "), _c('span', {
    staticClass: "signed",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "signingRecipient",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收人")]), _vm._v(" "), _c('span', {
    staticClass: "human_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "div_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "signReceiveTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("签/接收时间")]), _vm._v(" "), _c('span', {
    staticClass: "text_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.expressInfo.receiveDTString))])])]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("复制")])])
}]}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.orderMaterialExpressList), function(orderMaterialExpress, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "mod"
    }, [_c('div', {
      staticClass: "wrap1"
    }, [_c('div', {
      staticClass: "layer1"
    }, [(orderMaterialExpress.expressNo !== '') ? _c('span', {
      staticClass: "express-info"
    }, [_vm._v("快递单号：" + _vm._s(orderMaterialExpress.expressNo))]) : _c('span', {
      staticClass: "express-info"
    }, [_vm._v("快递单号：待填写")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "displayStatusName": orderMaterialExpress.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _vm._l((orderMaterialExpress.expressMaterialDetailList), function(expressMaterialDetail, index) {
      return _c('div', {
        attrs: {
          "id": index
        }
      }, [_c('div', {
        staticClass: "layer3 flex-row"
      }, [_c('display-icon-and-status', {
        attrs: {
          "materialType": expressMaterialDetail.orderMaterialInfo.materialType,
          "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "txt3"
      }, [_vm._v(_vm._s(expressMaterialDetail.orderMaterialInfo.materialDesc))]), _vm._v(" "), _c('span', {
        staticClass: "status"
      }, [_vm._v(_vm._s(expressMaterialDetail.displayStatusName))])], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "layer5 flex-row"
    }, [_c('span', {
      staticClass: "info2"
    }, [_vm._v("创建时间：" + _vm._s(orderMaterialExpress.createDT))]), _vm._v(" "), _c('span', {
      staticClass: "txt4"
    }, [_vm._v("共" + _vm._s(orderMaterialExpress.expressMaterialDetailList.length) + "类物品")])]), _vm._v(" "), _c('div', {
      staticClass: "layer6 flex-col",
      on: {
        "click": function($event) {
          return _vm.modifyInfo(orderMaterialExpress)
        }
      }
    }, [_c('span', {
      staticClass: "info3"
    }, [_vm._v("修改信息")])])], 2)])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isWapp) ? _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("个人信息")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerName))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("编号")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerNo))])])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("手机")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.mobile))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.email))])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.enterpriseName))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-code"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-message"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-code"
  })])
}]}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("新增收货地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefaultString),
      expression: "expressInfo.isDefaultString"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefaultString) ? _vm._i(_vm.expressInfo.isDefaultString, null) > -1 : (_vm.expressInfo.isDefaultString)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefaultString,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefaultString", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.gotolast
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader' || _vm.customerNo === _vm.displayChosenResearchGroup.accountCustomerNo) ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("对账单")])]), _vm._v(" "), (_vm.billInfo) ? _c('div', [(_vm.monthOrYear !== 'all') ? _c('div', {
    class: {
      'box': _vm.showBillConfirmButton, 'no-footer-box': !_vm.showBillConfirmButton
    }
  }, [_c('div', {
    staticClass: "bd_1"
  }, [_c('div', {
    staticClass: "outer_1"
  }, [_c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'month'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'month', 'chosenBill': _vm.monthOrYear === 'month'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('month')
      }
    }
  }, [_vm._v("月度账单")]), _vm._v(" "), (_vm.monthOrYear === 'month') ? _c('svg', {
    staticClass: "arrow-down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'year'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'year', 'chosenBill': _vm.monthOrYear === 'year'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('year')
      }
    }
  }, [_vm._v("年度账单")]), _vm._v(" "), (_vm.monthOrYear === 'year') ? _c('svg', {
    staticClass: "arrow-down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'all'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'all', 'chosenBill': _vm.monthOrYear === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('all')
      }
    }
  }, [_vm._v("累计账单")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block_2"
  }, [_c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "账单金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.billAmount && _vm.splitMoney(_vm.summary.billAmount.toFixed(2))))])]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "未清金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.balanceAmount && _vm.splitMoney(_vm.summary.balanceAmount.toFixed(2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "block_2",
    staticStyle: {
      "margin-bottom": "6vw"
    }
  }, [_c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "消费金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.consumedMoneySum && _vm.splitMoney(_vm.summary.consumedMoneySum.toFixed(2))))])]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "交付金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.deliveryMoneySum && _vm.splitMoney(_vm.summary.deliveryMoneySum.toFixed(2))))])])])])]), _vm._v(" "), _c('BillList', {
    attrs: {
      "billInfo": _vm.billInfo,
      "top": 0
    }
  })], 1) : _c('div', {
    class: {
      'box': _vm.showBillConfirmButton, 'no-footer-box': !_vm.showBillConfirmButton
    }
  }, [_c('div', {
    staticClass: "bd_1"
  }, [_c('div', {
    staticClass: "outer_1"
  }, [_c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'month'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'month', 'chosenBill': _vm.monthOrYear === 'month'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('month')
      }
    }
  }, [_vm._v("月度账单")]), _vm._v(" "), (_vm.monthOrYear === 'month') ? _c('svg', {
    staticClass: "arrow-down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'year'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'year', 'chosenBill': _vm.monthOrYear === 'year'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('year')
      }
    }
  }, [_vm._v("年度账单")]), _vm._v(" "), (_vm.monthOrYear === 'year') ? _c('svg', {
    staticClass: "arrow-down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'wrap': true, 'research-background-color': _vm.monthOrYear === 'all'
    }
  }, [_c('span', {
    class: {
      'notChosenBill': _vm.monthOrYear !== 'all', 'chosenBill': _vm.monthOrYear === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.chooseBillType('all')
      }
    }
  }, [_vm._v("累计账单")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block_2"
  }, [_c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "开票金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.invoiceMoneySum && _vm.splitMoney(_vm.summary.invoiceMoneySum.toFixed(2))))])]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "支付金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.invoiceReceivedMoneySum && _vm.splitMoney(_vm.summary.invoiceReceivedMoneySum.toFixed(2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "block_2",
    staticStyle: {
      "margin-bottom": "6vw"
    }
  }, [_c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "消费金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.consumedMoneySum && _vm.splitMoney(_vm.summary.consumedMoneySum.toFixed(2))))])]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap"
  }, [_c('span', {
    staticClass: "clock"
  }, [_vm._v(_vm._s(_vm.displayDate) + "交付金额")]), _vm._v(" "), _c('span', {
    staticClass: "money research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.summary.deliveryMoneySum && _vm.splitMoney(_vm.summary.deliveryMoneySum.toFixed(2))))])])])])]), _vm._v(" "), (_vm.yearList.length > 0) ? _c('div', {
    staticClass: "bd_2"
  }, _vm._l((_vm.yearList), function(year) {
    return _c('div', {
      staticClass: "submain",
      on: {
        "click": function($event) {
          return _vm.showAnnualBill(year)
        }
      }
    }, [_c('span', {
      staticClass: "consumptionDetails"
    }, [_vm._v(_vm._s(year) + "年账单")]), _vm._v(" "), _c('div', {
      staticClass: "CenRadioIconWrap_2"
    }, [_c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.showBillConfirmButton) ? _c('div', {
    staticClass: "ft"
  }, [_c('div', {
    staticClass: "col1",
    on: {
      "click": _vm.sendEmail
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("联系我们")])]), _vm._v(" "), (!_vm.billInfo.status) ? _c('div', {
    staticClass: "col2 research-background-color",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("确认账单")])]) : _c('div', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "tag_2"
  }, [_vm._v("已核对")])])]) : _vm._e()]) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "150px"
    },
    attrs: {
      "src": "/static/img/对账单空.png"
    }
  })]), _vm._v(" "), (_vm.showChooseBillPeriod) ? _c('ChooseBillPeriod', {
    attrs: {
      "defaultYear": _vm.year,
      "defaultMonth": _vm.month,
      "monthOrYear": _vm.monthOrYear
    },
    on: {
      "getBillInfo": _vm.getBillInfo,
      "toggleShow": function($event) {
        _vm.showChooseBillPeriod = !_vm.showChooseBillPeriod
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAnnualBillDetail) ? _c('AnnualBillDetail', {
    attrs: {
      "billInfo": _vm.annualBillInfo
    },
    on: {
      "toggleShow": function($event) {
        _vm.showAnnualBillDetail = !_vm.showAnnualBillDetail
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticStyle: {
      "height": "100vh",
      "width": "100vw",
      "background-color": "#fafafa",
      "flex": "auto",
      "-webkit-flex": "auto",
      "position": "fixed"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "-webkit-sticky"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "flex-y-bottom"
  }, [_c('div', {
    staticClass: "bo-logo flex-grow-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.serviceUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bo-title flex-grow-1"
  }, [_c('div', [_vm._v(_vm._s(_vm.information.boSolution.children[0].externalName ? _vm.information.boSolution.children[0].externalName : _vm.information.boSolution.children[0].name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.information.boSolution.children[0].briefInfoDetail) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('span', {
    staticClass: "real-price"
  }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.information.boSolution.children[0].formalQuotePrice)))]), _vm._v(" "), _c('span', {
    staticClass: "sale-price"
  }, [_c('s', [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.information.boSolution.children[0].standardPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 right"
  }, [_c('span', {
    staticClass: "deliver-text"
  }, [_vm._v("预计交付周期：")]), _vm._v(" "), _c('span', {
    staticClass: "deliver-value"
  }, [_vm._v(_vm._s(_vm.information.boSolution.children[0].workdays) + "个工作日")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80vh",
      "overflow": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.sampleSpec) + " " + _vm._s(_vm.information.otherTaxName))])], 1)], 1), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("疾病方向")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.diseaseDirection.name))])], 1)], 1), _vm._v(" "), (_vm.information.currEu !== _vm.specialEuTemplateNo(0)) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本分类")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.sampleCategory.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本类型")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.sampleType))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("实验分组及样本数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_vm._l((_vm.information.boSolution.children[0].groups), function(experimental, index) {
    return _c('van-cell', {
      key: experimental.name
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(experimental.name))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(experimental.bioRepeatTimes))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.information.controlGroups), function(it, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("生信分析组" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(it[0]) + " VS " + _vm._s(it[1]))])], 1)], 1)
  })], 2)]), _vm._v(" "), (_vm.information.currEu !== _vm.specialEuTemplateNo(0)) ? _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("其他参数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(_vm.information.singleMeteData.paraRemoveHAProtein.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本处理")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraRemoveHAProtein.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.singleMeteData.paraConstructionTech.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("建库技术")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraConstructionTech.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.singleMeteData.paraBioAnalysis.dictValue !== '-') ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("生信分析")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.information.singleMeteData.paraBioAnalysis.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.information.geneSelectionGroup.length > 0) ? _c('div', _vm._l((_vm.information.geneSelectionGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.outlineInfo))])], 1)], 1)
  }), 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("质量承诺")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.qualityCommitment), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("服务说明")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.serviceComments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2)]), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("添加成员")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(!_vm.newContact) ? _c('div', {
    staticClass: "box_1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_name')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nameQuery),
      expression: "nameQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.nameQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr",
    on: {
      "click": function($event) {
        return _vm.autofocus('search_mobile')
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobileQuery),
      expression: "mobileQuery",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobileQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.searchContact
    }
  }, [_c('span', {
    staticClass: "addMember"
  }, [_vm._v("搜索联系人")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [(_vm.contactDetail && _vm.contactDetail.customerName) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.customerName))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.mobile))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.email))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contactDetail.enterpriseName))])]), _vm._v(" "), _vm._m(5)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [(_vm.contactDetail && _vm.contactDetail.customerName) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("审批原则")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }, [(_vm.approve.approveType === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批原则")]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeNone) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#60d837"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeAll) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单笔订单限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }, [(_vm.approve.approveThreshold === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.approveThreshold === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.approveThreshold))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单月累积限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }, [(_vm.approve.monthlyLimit === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.monthlyLimit === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.monthlyLimit))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(8)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.contactDetail && _vm.contactDetail.customerName) ? _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.addMember
    }
  }, [_c('span', {
    staticClass: "addMember"
  }, [_vm._v("添加")])]) : _vm._e()])]), _vm._v(" "), (_vm.showChooseApproveType) ? _c('ChooseApproveType1', {
    attrs: {
      "setApproveType": _vm.setallApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglestrokeApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "setApproveType": _vm.setSinglestrokeApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglemouthApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "setApproveType": _vm.setmouthApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "confirm": _vm.registerContact,
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderList) ? _c('div', [_vm._l((_vm.orderList), function(order, index) {
    return (_vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin-bottom": "3rem"
      }
    }, [_c('ul', [(order.merchandises) ? _c('li', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "3px solid ghostwhite"
      }
    }, [(order.selfOperated === 0) ? _c('span', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "margin-left": "0.2rem"
      }
    }, [_vm._v("第三方")]) : _vm._e(), _vm._v(" "), (order.selfOperated === 1) ? _c('span', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "margin-left": "0.2rem"
      }
    }, [_vm._v("吉凯基因")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8rem",
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.status === 2 && order.researchGroupApproveResult === _vm.waitApproveStatus ? '待审批' : _vm.description))])]), _vm._v(" "), (order.subOrders.length === 0) ? _c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'myOrderDetail',
          query: {
            BOrder: JSON.stringify(order)
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "1px solid gray"
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, _vm._l((order.merchandises), function(merchandise) {
      return _c('div', [_c('img', {
        staticStyle: {
          "width": "4rem",
          "margin-left": "0.1rem"
        },
        attrs: {
          "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
        }
      }), _vm._v(" "), (merchandise.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "text-align": "center"
        }
      }, [(merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText) ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e(), _vm._v(" "), (merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "text-align": "center"
        }
      }, [(merchandise._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e()])])
    }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((order.subOrders), function(suborder) {
      return (order.subOrders.length > 0) ? _c('div', [_c('router-link', {
        staticClass: "item-link item-content",
        attrs: {
          "to": {
            name: 'myOrderDetail',
            query: {
              BOrder: JSON.stringify(order)
            }
          }
        }
      }, [_c('div', {
        staticClass: "item-inner",
        staticStyle: {
          "border-bottom": "1px solid gray"
        }
      }, [_c('div', {
        staticClass: "item-media"
      }, _vm._l((suborder.merchandises), function(merch) {
        return _c('div', [_c('img', {
          staticStyle: {
            "width": "4rem",
            "margin-left": "0.2rem"
          },
          attrs: {
            "src": _vm.baseurl + merch.merchandiseDetailForClient.merchandiseIcon
          }
        }), _vm._v(" "), (merch.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
          staticStyle: {
            "font-size": ".2rem",
            "text-align": "center"
          }
        }, [(merch._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merch._titleList[0].valueText) + "}")]) : _vm._e(), _vm._v(" "), (merch._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merch._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
          staticStyle: {
            "font-size": ".2rem",
            "text-align": "center"
          }
        }, [(merch._titleList[0].valueText !== '-1') ? _c('span', [_vm._v("\n                    " + _vm._s(merch._titleList[0].valueText) + "  ")]) : _vm._e()]), _vm._v(" "), (merch && merch.selfOperated === 0) ? _c('div', {
          staticStyle: {
            "margin-top": "10px"
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "x-small",
            "color": "#1482E7"
          }
        }, [_vm._v("【第三方】")])]) : _vm._e()])
      }), 0)])])], 1) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [(order.isStock) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e()]), _vm._v(" "), _c('div', [(order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "color": "white",
        "background": "rgb(0, 70, 154)"
      },
      on: {
        "click": function($event) {
          return _vm.buyAgain1(order)
        }
      }
    }, [_vm._v("我要扩增")]) : _vm._e(), _vm._v(" "), (order.status === 2 || 3) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response1(order)
        }
      }
    }, [_c('img', {
      staticClass: "position",
      attrs: {
        "src": _vm.button1Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.researchGroupApproveResult !== _vm.waitApproveStatus) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response2(order)
        }
      }
    }, [_c('img', {
      staticClass: "pay-btn",
      attrs: {
        "src": _vm.button2Name
      }
    })]) : _vm._e()])], 2) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.orderList), function(order, index) {
    return (_vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin-bottom": "3rem"
      }
    }, [_c('ul', [(order.merchandises) ? _c('li', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "border-bottom": "1px solid gray"
      }
    }, _vm._l((order.merchandises), function(merchandise) {
      return _c('div', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.response3(merchandise)
          }
        }
      }, [_c('div', [_c('img', {
        staticStyle: {
          "width": "4rem",
          "margin-left": "0.1rem"
        },
        attrs: {
          "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
        }
      }), _vm._v(" "), (merchandise.merchandiseDetailForClient.categoryId === 10) ? _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "margin-left": "0.1rem",
          "color": "black"
        }
      }, [(merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText) ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e(), _vm._v(" "), (merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[1].valueText))]) : _vm._e()]) : _c('div', {
        staticStyle: {
          "font-size": ".2rem",
          "margin-left": "1rem",
          "color": "black"
        }
      }, [(merchandise._titleList[0].valueText !== '-1') ? _c('span', [_vm._v(_vm._s(merchandise._titleList[0].valueText))]) : _vm._e()])])])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [(order.isStock) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice)))])]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('div', {
      staticStyle: {
        "color": "black",
        "font-size": "0.7rem",
        "text-align": "right"
      }
    }, [_vm._v("\n            共" + _vm._s(order.productNum) + "个商品 "), _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_vm._v(" 实支付：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(order.totalPrice - order.expressPrice)))])]) : _vm._e(), _vm._v(" "), (order.merchandises[0].categoryId === 10 && order.orderNo) ? _c('span', {
      staticStyle: {
        "font-size": "xx-small",
        "margin-left": "120px"
      }
    }, [_vm._v("订单编号： " + _vm._s(order.orderNo))]) : _vm._e()]), _vm._v(" "), _c('div', [(order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "color": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.buyAgain1(order)
        }
      }
    }, [_vm._v("我要扩增")]) : _vm._e(), _vm._v(" "), ((order.status === 2 || 3) && _vm.button1Name) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response1(order)
        }
      }
    }, [_c('img', {
      staticClass: "position",
      attrs: {
        "src": _vm.button1Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.researchGroupApproveResult !== _vm.waitApproveStatus && _vm.button2Name) ? _c('span', {
      staticClass: "orderBtn",
      on: {
        "click": function($event) {
          return _vm.response2(order)
        }
      }
    }, [_c('img', {
      staticClass: "pay-btn",
      attrs: {
        "src": _vm.button2Name
      }
    })]) : _vm._e(), _vm._v(" "), (order.isStock === false) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response4(order.priceDetails)
        }
      }
    }, [_vm._v(_vm._s(_vm.button3Name))]) : _vm._e(), _vm._v(" "), (order.audit.comments) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response5(order.audit.comments)
        }
      }
    }, [_vm._v(_vm._s(_vm.button4Name))]) : _vm._e(), _vm._v(" "), (order.sfQuoteStatus === 1) ? _c('span', {
      staticClass: "orderBtn",
      staticStyle: {
        "background": "#00469A"
      },
      on: {
        "click": function($event) {
          return _vm.response6(order.merchandises)
        }
      }
    }, [_vm._v(_vm._s(_vm.button5Name))]) : _vm._e()])]) : _vm._e()])]) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap1"
  }, [_c('div', {
    staticClass: "mod1"
  }, [_c('span', {
    staticClass: "word1"
  }, [_vm._v("实物清单")]), _vm._v(" "), _c('img', {
    staticClass: "material-list-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/编组 3.svg'
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("为了保证实验正常进行，请您尽快寄送实验所需物品")]), _vm._v(" "), _c('div', {
    staticClass: "mod2"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('img', {
    staticClass: "label3",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/提示语.svg'
    }
  }), _vm._v(" "), (_vm.waitSendOutMaterialNumber === 0) ? _c('span', {
    staticClass: "word3"
  }, [_vm._v("您已寄出所有实物")]) : _c('span', {
    staticClass: "word3"
  }, [_vm._v("有" + _vm._s(_vm.waitSendOutMaterialNumber) + "个实物待寄出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap2 flex-row"
  }, [_c('div', {
    staticClass: "sample-block",
    staticStyle: {
      "margin-right": "11px"
    }
  }, [_c('div', {
    staticClass: "wrap3 flex-row",
    on: {
      "click": _vm.createSampleDeliverySheet
    }
  }, [_c('img', {
    staticClass: "sample-delivery-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/新建送样单.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sample-delivery-text"
  }, [_vm._v("寄送实物")])])]), _vm._v(" "), _c('div', {
    staticClass: "sample-block"
  }, [_c('div', {
    staticClass: "wrap3 flex-row",
    on: {
      "click": _vm.showSampleDeliverySheet
    }
  }, [_c('img', {
    staticClass: "sample-delivery-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/查看送样单.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sample-delivery-text"
  }, [_vm._v("寄送记录")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap4 flex-row"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("实物清单")]), _vm._v(" "), _c('span', {
    staticClass: "word6",
    on: {
      "click": _vm.downloadAllInformationSheets
    }
  }, [_vm._v("下载全部物品信息表")])]), _vm._v(" "), _vm._l((_vm.orderMaterialInfo), function(material, index) {
    return _c('div', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "wrap5",
      on: {
        "click": function($event) {
          return _vm.queryMaterial(material)
        }
      }
    }, [_c('div', {
      staticClass: "bd4"
    }, [_c('div', {
      staticClass: "mod4"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": material.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "group3 flex-col"
    }, [_c('div', {
      staticClass: "group4 flex-row"
    }, [_c('span', {
      staticClass: "word7"
    }, [_vm._v(_vm._s(material.orderMaterial.materialDesc))]), _vm._v(" "), _c('display-icon-and-status', {
      attrs: {
        "displayStatusName": material.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "txt2"
    }, [_vm._v("用于" + _vm._s(material.orderMaterial.euName))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap6"
  }, [_c('span', {
    staticClass: "txt8"
  }, [_vm._v("点击可查看送样指南、")]), _vm._v(" "), _c('span', {
    staticClass: "txt8",
    staticStyle: {
      "color": "rgba(254, 101, 77, 1)"
    }
  }, [_vm._v("下载实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "txt8"
  }, [_vm._v("并查看送样记录")])])
}]}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-bottom",
      rawName: "v-scroll-bottom",
      value: (_vm.messages),
      expression: "messages"
    }],
    staticClass: "message"
  }, [(_vm.realmessages) ? _c('ul', _vm._l((_vm.realmessages), function(item) {
    return _c('li', [(item.createDT) ? _c('p', {
      staticClass: "time"
    }, [_c('span', [_vm._v(_vm._s(item.createDT))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main",
      class: {
        self: item.messageType === 1
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "30",
        "height": "30",
        "src": item.messageType === 1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.message) + " "), (item.merchandise) ? _c('a', {
      attrs: {
        "href": '#/detail/merchandises?id=' + item.merchandise.merchandiseId
      }
    }, [_vm._v(_vm._s(item.merchandise.merchandiseLabel))]) : _vm._e()])])])
  }), 0) : _c('ul', _vm._l((_vm.messages), function(item) {
    return _c('li', [(item.createDT) ? _c('p', {
      staticClass: "time"
    }, [_c('span', [_vm._v(_vm._s(item.createDT))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main",
      class: {
        self: item.messageType === 1
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "30",
        "height": "30",
        "src": item.messageType === 1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.message) + " "), (item.merchandise) ? _c('a', {
      attrs: {
        "href": '#/detail/merchandises?id=' + item.merchandise.merchandiseId
      }
    }, [_vm._v(_vm._s(item.merchandise.merchandiseLabel))]) : _vm._e()])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper swiper-slide",
    style: (("background-image: url(" + _vm.background + ");"))
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasDownBtn) ? _c('img', {
    staticClass: "down-btn ani animate__infinite",
    attrs: {
      "swiper-animate-effect": "animate__bounce",
      "src": "/static/img/anniversary/down.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [_c('div', {
    staticClass: "labeldiv top",
    staticStyle: {
      "margin-left": "0.5rem",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.query.label))]), _vm._v(" "), (_vm.id !== 20) ? _c('div', {
    staticClass: "top",
    staticStyle: {
      "float": "right",
      "margin-bottom": "0rem",
      "height": "0.8rem"
    }
  }, [(!_vm.showSearchBar) ? _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), (_vm.id === 3 || _vm.id === 2 || _vm.id === 12 || _vm.id === 1) ? _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  }) : (_vm.id === 6) ? _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入细胞名称...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  }) : _c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "background-color": "#F6F6F7"
    },
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "top",
    staticStyle: {
      "float": "right",
      "margin-bottom": "0rem",
      "height": "0.8rem"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder'
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content top"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "3rem",
      "overflow": "scroll",
      "height": "100%"
    },
    style: ({
      'margin-bottom': _vm.emkt.leaveSpaceForFullScreen ? '4rem' : '3rem'
    })
  }, [_c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.catagoryList,
      "showFilterBar": _vm.showSearchBar,
      "showFilterBarForKit": _vm.showFilterBarForKit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("消息管理 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, _vm._l((_vm.merchantMessages), function(merch, index) {
    return _c('ul', {
      staticStyle: {
        "border-bottom": "1px solid gainsboro",
        "padding-top": "5px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.goto(merch)
        }
      }
    }, [_c('li', {
      staticClass: "item-content",
      attrs: {
        "heigh": "20"
      }
    }, [_c('div', {
      staticClass: "item-media",
      style: ({
        'background-image': 'url(' + _vm.url + ') ',
        'padding': '5px',
        'background-size': '100% 100%',
        'width': '2rem',
        'height': '2rem',
        'position': 'relative'
      })
    }, [(merch.unreadMessagesAmount > 0) ? _c('div', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(merch.unreadMessagesAmount))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "font-size": "small"
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("\n                   " + _vm._s(merch.merchantName))]), _vm._v(" "), (merch.lastestMessage.createDT.substring(0, 10) === _vm.date1) ? _c('div', {
      staticStyle: {
        "font-size": "xx-small",
        "color": "gray",
        "float": "right",
        "margin-top": "3px"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.createDT.substring(11)))]) : _c('div', {
      staticStyle: {
        "font-size": "xx-small",
        "color": "gray",
        "float": "right",
        "margin-top": "3px"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.createDT.substring(0, 10)))])]), _vm._v(" "), (merch.lastestMessage.message.length > 20) ? _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "color": "gray",
        "font-size": "small"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.message.substring(0, 15) + '.....'))]) : _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "color": "gray",
        "font-size": "small"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.message))])])])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.tolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "larger"
    }
  }, [_vm._v("积分详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('i', {
    staticClass: "icon icon-star"
  }), _vm._v(" 总剩余积分-- " + _vm._s(_vm.totalRemainPoints) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px"
    }
  }, [_c('i', {
    staticClass: "icon icon-star"
  }), _vm._v(" 总积分-- " + _vm._s(_vm.totalPoints) + " ")]), _vm._v(" "), _vm._l((_vm.pointsList), function(points) {
    return _c('div', {
      staticClass: "list-block cards-list",
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('ul', [_c('li', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("合同号- " + _vm._s(points.contractNo))]), _vm._v(" "), (new Date() > new Date(Date.parse(points.validUntil))) ? _c('span', [_vm._m(1, true)]) : _c('span', [_vm._v("是否到期: 否")])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner",
      staticStyle: {
        "margin-bottom": "25px"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n               积分数量-- " + _vm._s(points.accruedPoint) + "\n             ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("\n             剩余积分-- " + _vm._s(points.remainedPoint) + "\n             ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', [_vm._v("\n              计入时间- " + _vm._s(points.activateDT.substring(0, 10)) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n             到期时间- " + _vm._s(points.validUntil) + "\n            ")])])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button button-link button-nav pull-right"
  }, [_c('a', {
    attrs: {
      "href": "http://genechem-customer.xinfuli.net/web/login"
    }
  }, [_vm._v("积分兑换 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "50px",
      "width": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/endused_img.jpg"
    }
  })])
}]}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n        返回首页\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Single select")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.options,
      "searchable": false,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "Pick a value"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('pre', {
    staticClass: "language-json"
  }, [_c('code', [_vm._v(_vm._s(_vm.value))])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "address-detail-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "txt_1",
    attrs: {
      "type": "text",
      "placeholder": "请填写姓名"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "type": "text",
      "placeholder": "请填写您的手机号"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "省",
      "placeholder": "点击选择省份"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    },
    model: {
      value: (_vm.expressInfo.province),
      callback: function($$v) {
        _vm.$set(_vm.expressInfo, "province", $$v)
      },
      expression: "expressInfo.province"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.provinceOptions
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": function($event) {
        _vm.showPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "市",
      "placeholder": "点击选择市"
    },
    on: {
      "click": function($event) {
        _vm.showCityPicker = true
      }
    },
    model: {
      value: (_vm.expressInfo.city),
      callback: function($$v) {
        _vm.$set(_vm.expressInfo, "city", $$v)
      },
      expression: "expressInfo.city"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCityPicker),
      callback: function($$v) {
        _vm.showCityPicker = $$v
      },
      expression: "showCityPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.cityOptions
    },
    on: {
      "confirm": _vm.onConfirm2,
      "cancel": function($event) {
        _vm.showCityPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("*街道(不包含省市)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.street),
      expression: "expressInfo.street",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "placeholder": "请填写街道信息"
    },
    domProps: {
      "value": (_vm.expressInfo.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "street", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "del-btn",
    on: {
      "click": _vm.gotolast
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("收货地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.addressInfo), function(address, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'addressModify',
          query: {
            num: index,
            from: _vm.from
          },
          params: {
            order: _vm.$route.params.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))]), _vm._v(" "), (address.isDefault == 1) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v("默认地址")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressMobile))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressAddress))])])])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100",
    attrs: {
      "id": "button-div"
    }
  }, [_c('router-link', {
    staticClass: "button button-big button-fill",
    class: {
      'disabled': _vm.count > 2
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'addAddress',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order
        }
      },
      "disabled": _vm.count > 2
    }
  }, [_vm._v("\n            新增收货地址\n          ")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [(_vm.ssoFlag === 0) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder',
        params: {
          ishome: true
        }
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search1",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search1",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1) : _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\r\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2.5rem",
      "background-color": "#FFFFFF"
    }
  }, [(_vm.promotions) ? _c('div', {
    staticClass: "swiper-container swiper-container-horizontal",
    staticStyle: {
      "margin-left": "0.2rem",
      "margin-right": "0.2rem"
    },
    attrs: {
      "id": "sw1",
      "data-space-between": "10"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.promotions), function(attr) {
    return (attr.imageUrl) ? _c('div', {
      staticClass: "swiper-slide"
    }, [(_vm.openLink(attr)) ? _c('a', {
      attrs: {
        "href": _vm.getOuterLink(attr)
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + attr.imageUrl,
        "id": attr.promotionGuid
      }
    })]) : _c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + attr.imageUrl,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.todiscount(attr)
        }
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }, _vm._l((_vm.promotions), function(index) {
    return _c('span', [(index === 0) ? _c('span', {
      staticClass: "swiper-pagination-bullet swiper-pagination-bullet-active "
    }) : _vm._l((_vm.promotions), function(index) {
      return _c('span', {
        staticClass: "swiper-pagination-bullet"
      })
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticStyle: {
      "color": "#8e8e93",
      "margin-bottom": "0.5rem",
      "font-size": "0.8rem",
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.todiscount(_vm.promotionGuid, _vm.description)
      }
    }
  }, [_vm._v("查看全部")]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.channels) ? _c('div', {
    staticClass: "swiper-container  ",
    staticStyle: {
      "width": "100%",
      "height": "24%",
      "padding-bottom": "0px"
    },
    attrs: {
      "id": "sw"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [(_vm.channels.length > 1) ? _c('tr', _vm._l((_vm.channels), function(channel) {
    return _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "0.2rem",
        "margin-left": "0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.gotochannel(channel)
        }
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + channel.imageUrl,
        "alt": ""
      }
    })])])
  }), 0) : _c('tr', [_vm._l((_vm.channels), function(channel) {
    return _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "0.2rem",
        "margin-left": "0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.gotochannel(channel)
        }
      }
    }, [_c('img', {
      staticClass: "card-cover",
      attrs: {
        "src": _vm.baseurl + channel.imageUrl,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8e8e93",
      "margin-bottom": "0.5rem",
      "font-size": "0.8rem",
      "margin-left": "0.5rem",
      "margin-right": "0.5rem"
    }
  }, [_c('span', [_vm._v("猜你喜欢")]), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.topromotion('', '猜你喜欢')
      }
    }
  }, [_vm._v("查看全部")]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })])]), _vm._v(" "), (_vm.recommendsList && _vm.recommendsList.length > 0) ? _c('div', [_c('newMerchandiseListB', {
    attrs: {
      "merchList": _vm.recommendsList
    }
  })], 1) : _c('div', [_c('newMerchandiseListB', {
    attrs: {
      "merchList": _vm.recommends
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "查询基因/产品名称……",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "text",
      "placeholder": "填写备注",
      "data-popup": ".popup-text-only",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap",
    staticStyle: {
      "font-size": "12px",
      "padding": "0 20px"
    }
  }, [_c('p', [_c('span', [_vm._v("1、蛋白组学去高丰度蛋白、TMT蛋白组学6标及以上、label free蛋白组学、PRM实验方法评估和建立、PRM蛋白组学检测、石蜡样本蛋白组学、DIA建库（12级）、大样本蛋白质组DIA分析、DIA蛋白组学检测、DIA建库（6级）、DIA 2.0蛋白组学检测、4D label free蛋白组学")]), _c('br'), _c('span', [_vm._v("•上述所有服务项目均为提供客观实验结果。")]), _c('br'), _c('span', [_vm._v("2、蛋白组学生信分析（A套系）")]), _c('br'), _c('span', [_vm._v("•数据质量评估后，如不符合继续分析标准，则中止后续分析，进入客户交流阶段，交流确认的周期不计入合同执行周期内；")]), _c('br'), _c('span', [_vm._v("•所示周期为一组分析的周期，如有多组分析则周期累加。")]), _c('br'), _c('span', [_vm._v("3、shotgun蛋白组学检测")]), _c('br'), _c('span', [_vm._v("•提供每个样本的定性质谱和蛋白质查库的客观实验结果（不包括样本间的比较分析）。")]), _c('br'), _c('span', [_vm._v("4、DeepDIA")]), _c('br'), _c('span', [_vm._v("•提供客观真实的实验结果。")]), _c('br'), _c('span', [_vm._v("5、微量样本蛋白提取（组织/细胞）")]), _c('br'), _c('span', [_vm._v("•按照SOP操作流程进行蛋白提取，提供蛋白定量结果，保证数据客观、真实。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("服务说明")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap",
    staticStyle: {
      "font-size": "12px",
      "padding": "0 20px"
    }
  }, [_c('p', [_c('span', [_vm._v("1、TMT蛋白组学6标及以上、label free蛋白组学")]), _c('br'), _c('span', [_vm._v("•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。 若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•根据 iTRAQ/TMT 的技术特性，乙方采用差异倍数FC≥1.2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("2、蛋白组学生信分析（A套系）")]), _c('br'), _c('span', [_vm._v("•数据质量评估后，如不符合继续分析标准，则中止后续分析，进入客户交流阶段，交流确认的周期不计入合同执行周期内；")]), _c('br'), _c('span', [_vm._v("•所示周期为一组分析的周期，如有多组分析则周期累加。")]), _c('br'), _c('span', [_vm._v("3、PRM实验方法评估和建立、PRM蛋白组学检测")]), _c('br'), _c('span', [_vm._v("•样本制备、方法评估以及正式实验先后进行，周期累计，若前期实验不成功，合同终止，收取已完成部分的费用。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("4、shotgun蛋白组学检测")]), _c('br'), _c('span', [_vm._v("•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。")]), _c('br'), _c('span', [_vm._v("•跟据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("5、DeepDIA")]), _c('br'), _c('span', [_vm._v("•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行")]), _c('span', [_vm._v("后续实验。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("6、石蜡样本蛋白组学")]), _c('br'), _c('span', [_vm._v("•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。")]), _c('br'), _c('span', [_vm._v("•根据label free的技术特性，乙方采用差异倍数FC≥2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。")]), _c('br'), _c('span', [_vm._v("7、DIA建库（12级）、DIA蛋白组学检测、DIA建库（6级）")]), _c('br'), _c('span', [_vm._v("•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传")]), _c('br'), _c('span', [_vm._v("染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("8、大样本蛋白质组DIA分析")]), _c('br'), _c('span', [_vm._v("•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常，会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方有权单方面直接解除合同，并立即通知相关部门处置该等样本，并要求甲方赔偿相应损失。")]), _c('br'), _c('span', [_vm._v("9、DIA 2.0蛋白组学检测")]), _c('br'), _c('span', [_vm._v("•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•血清/血浆、石蜡样本，甲方无特殊要求，默认选择用Exploris 480分析，其他类型样本，乙方根据实验条件自行选择timsTOF Pro或Exploris 480进行分析。若甲方有特殊要求，需提前与乙方沟通协商，达成一致；")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传")]), _c('br'), _c('span', [_vm._v("染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("10、4D label free蛋白组学")]), _c('br'), _c('span', [_vm._v("•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•根据 4D label free 的技术特性，乙方采用差异倍数FC≥2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("11、微量样本蛋白提取（组织/细胞）")]), _c('br'), _c('span', [_vm._v("•微量样本蛋白提取后进行蛋白定量，若在抽提过程发现异常情况，或因原始送样量太少导致蛋白抽提不足，与乙方交流确定后，按达成一致的办法进行处理。若无异常且蛋白量足够，则直接启动后续实验。")]), _c('br'), _c('span', [_vm._v("•若蛋白抽提异常或不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")]), _c('br'), _c('span', [_vm._v("•微量样本蛋白提取为预实验。预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。")]), _c('br'), _c('span', [_vm._v("•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传")]), _c('br'), _c('span', [_vm._v("染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。")])])])])])
}]}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("模版来源合同")]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n    模版来源合同\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value.split(':')[0]),
      expression: "attribute.value.split(':')[0]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value.split(':')[0])
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute.value.split(':'), 0, $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-container"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "info-box",
      class: _vm.selectIndex == index ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.onSelectTech(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tech-title",
      domProps: {
        "textContent": _vm._s(item.dictValue)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tech-desc",
      domProps: {
        "textContent": _vm._s(item.extraValue)
      }
    })])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('ul', [_c('li', [_c('div', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "padding-left": "0.75rem"
    }
  }, [_c('div', [_c('div', {
    staticClass: "item-title tip"
  }, [_vm._v("请上传名片正面或身份证正反面")]), _vm._v(" "), _c('div', {
    staticClass: "item id-card"
  }, [_c('div', {
    staticClass: "show-image"
  }, [(_vm.avatarPositive === '') ? _c('span', {
    staticClass: "add-card"
  }, [_vm._v("+添加正面")]) : _c('img', {
    staticStyle: {
      "height": "146px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.avatarPositive
    }
  })]), _vm._v(" "), _c('input', {
    ref: "avatarInputPosi",
    staticClass: "input",
    attrs: {
      "type": "file",
      "name": "positive",
      "accept": "image/jpg,image/jpeg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImagePositive($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item id-card"
  }, [_c('div', {
    staticClass: "show-image"
  }, [(_vm.avatarNegative === '') ? _c('span', {
    staticClass: "add-card"
  }, [_vm._v("+添加反面")]) : _c('img', {
    staticStyle: {
      "height": "146px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.avatarNegative
    }
  })]), _vm._v(" "), _c('input', {
    ref: "avatarInputNega",
    staticClass: "input",
    attrs: {
      "type": "file",
      "name": "negative",
      "accept": "image/jpg,image/jpeg,image.png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImageNegative($event)
      }
    }
  })])])])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger external",
    class: {
      'disabled': _vm.disable
    },
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disable
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("申请信用支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("注：")]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("1.请上传清晰的名片正面或身份证正面及反面。")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("2.照片大小不超过5MB，支持照片格式jpg，jpeg，png。")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("3.吉凯基因淘基因向您承诺：您的身份证信息仅用作申请信用付款验证，我们绝不外漏！")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-0.3rem"
    }
  }, [_vm._v("4.在您提交认证申请后，我们将在两个工作日内完成审核，审核成功后，根据具体情况，您可以获得\n                    "), _c('strong', {
    staticStyle: {
      "color": "#f6383a"
    }
  }, [_vm._v("10000元")]), _vm._v("或"), _c('strong', {
    staticStyle: {
      "color": "#f6383a"
    }
  }, [_vm._v("50000元")]), _vm._v("的信用额度。请您在\"个人中心-我的信用\"中查看您的信用额度。")])])])])])])])
}]}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContractInfoBox),
      expression: "showContractInfoBox"
    }],
    staticClass: "fade"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContractInfoBox),
      expression: "showContractInfoBox"
    }],
    staticClass: "succ-pop",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "mint-msgbox-wrapper",
    staticStyle: {
      "position": "absolute",
      "z-index": "100"
    }
  }, [_c('div', {
    staticClass: "mint-msgbox"
  }, [_c('div', {
    staticClass: "main-2_z"
  }, [_c('div', {
    staticClass: "main2-title layer-fixed clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "15px",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "float": "left",
      "text-align": "right",
      "color": "#0a8ddf"
    },
    on: {
      "click": function($event) {
        return _vm.actionHandler('cancel')
      }
    }
  }, [_c('span', [_vm._v("关闭")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "xinxi",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("\n                  合同名称： " + _vm._s(_vm.contractInfo.contractName) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同编号：    " + _vm._s(_vm.contractInfo.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("线下合同编号：" + _vm._s(_vm.contractInfo.contractNoOffline))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同金额：    " + _vm._s(_vm.contractInfo.contractMoney))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("付款方式： " + _vm._s(_vm.contractInfo.payTypeString))]), _vm._v(" "), ((_vm.type === '交付明细' && _vm.selected === '累计') || _vm.selected === '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  合同是否结清账款：   " + _vm._s(_vm.contractInfo.isSettledString) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.type === '交付明细' && _vm.selected === '累计') || _vm.selected === '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  未结清账款金额：   " + _vm._s(_vm.contractInfo.notSettledMoneySum) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("业务员：    " + _vm._s(_vm.contractInfo.employeeName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("签署客户名称：   " + _vm._s(_vm.contractInfo.signedCustomerName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("签署客户单位：   " + _vm._s(_vm.contractInfo.signedEnterpriseName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同启动日期：   " + _vm._s(_vm.contractInfo.contractStartDT))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("生产状态：   " + _vm._s(_vm.contractInfo.produceStatusString))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("预计生产完结日期：   " + _vm._s(_vm.contractInfo.expectedProduceEndDT))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("发货状态：    " + _vm._s(_vm.contractInfo.deliveryStatusString))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("发货日期：    " + _vm._s(_vm.contractInfo.deliveryDT))]), _vm._v(" "), (_vm.type === '消费明细' && _vm.selected !== '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  待收账户余额 ：    " + _vm._s(_vm.contractInfo.waitPrepayAmount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.type === '交付明细' && _vm.selected !== '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  待收尾款 ：    " + _vm._s(_vm.contractInfo.waitRetainage) + "\n                ")]) : _vm._e()])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.customerMaterialInfo), function(customerMaterial, index) {
    return _c('div', [_c('div', {
      staticClass: "main3 flex-col"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "mod3 flex-row"
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(customerMaterial.receiveWareName))]), _vm._v(" "), (customerMaterial.orderNo !== undefined) ? _c('span', {
      staticClass: "txt",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(customerMaterial.orderNo))]) : _c('span', {
      staticClass: "txt",
      staticStyle: {
        "white-space": "nowrap"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "txt middle-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.receiveDT))]), _vm._v(" "), _c('span', {
      staticClass: "txt samll-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.statusName))]), _vm._v(" "), _c('span', {
      staticClass: "txt samll-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.goodsQuantity))])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main2 flex-col"
  }, [_c('div', {
    staticClass: "section1 flex-row"
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("实物名称")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("到达时间")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("在库状态")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("剩余量")])])])
}]}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner specal"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [(_vm.attribute.columnName === 'TVInfo.usageID' || _vm.attribute.columnName === 'TVInfo2.usageID') ? _c('span', [_vm._v("载体用途说明")]) : _c('span', [_vm._v(_vm._s(this.attribute.label))])]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [(_vm.attribute.columnName === 'TVInfo.usageID' || _vm.attribute.columnName === 'TVInfo2.usageID') ? _c('span', [_vm._v("载体用途说明")]) : _c('span', [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.attribute.columnName === 'ExpressionTest' || _vm.attribute.columnName === 'InducingTest' || _vm.attribute.columnName === 'LVAmount' || _vm.attribute.columnName === 'NC_LV_Amount') ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.showMessage(_vm.attribute)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length >= 50) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "0px solid #e7e7e7",
      "margin-bottom": "3rem"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length >= 12 && _vm.attribute.valueText.length < 50) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "0px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : ((_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1 || _vm.merchandises.categoryId !== 20) && _vm.attribute.valueText.length < 12) ? _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  })])]) : _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      }
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.valueText),
      expression: "attribute.valueText"
    }],
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.attribute.valueText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "valueText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-down",
    staticStyle: {
      "margin-top": ".2rem",
      "margin-right": ".5rem",
      "color": "gray"
    },
    attrs: {
      "disabled": "disabled"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("发票抬头管理")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.invoiceInfo), function(invoice, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(invoice.enterpriseName))])]), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "height": "40px",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticClass: "col-50 ",
      staticStyle: {
        "float": "left",
        "width": "40%",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticClass: "item-title label",
      staticStyle: {
        "width": "100PX",
        "font-size": "0.7rem"
      }
    }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
      staticClass: "item-input",
      staticStyle: {
        "margin-top": "-38px",
        "margin-left": "46%",
        "line-height": "40px"
      }
    }, [_c('label', {
      staticClass: "label-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "my-radio"
      },
      domProps: {
        "checked": invoice.isDefault
      },
      on: {
        "change": function($event) {
          return _vm.submit(invoice, $event)
        }
      }
    }), _vm._v(" "), _vm._m(0, true)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-50",
      staticStyle: {
        "float": "right",
        "width": "20px"
      }
    }, [_c('a', {
      staticClass: "item-media",
      on: {
        "click": function($event) {
          return _vm.delInvoice(invoice)
        }
      }
    }, [_vm._m(1, true)])])])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill",
    class: {
      'disabled': _vm.count > 2
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'addInvoiceTitle',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order
        }
      },
      "disabled": _vm.count > 2
    }
  }, [_vm._v("\n        新增发票抬头\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media",
    staticStyle: {
      "margin-top": "0.6rem",
      "margin-left": "1%",
      "position": "relative"
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-input"
  }, [_c('span', {
    staticClass: "icon icon-remove"
  })])
}]}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2.4rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticClass: "labeldiv",
    staticStyle: {
      "margin-left": "2rem",
      "font-weight": "bold"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3rem",
      "margin-top": "2rem",
      "margin-left": "2rem",
      "margin-right": "2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "color": "#00469A"
    }
  }, [_vm._v("\n             吉凯基因淘基因致力于与您共享吉凯\" 工程化科研平台 \" 15年来积累的科研资源，为您提供优质的产品和服务\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "color": "#00469A"
    }
  }, [_vm._v("\n          如果您有任何建议或意见，可以通过以下方式联系我们：\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          电话："), _c('a', {
    attrs: {
      "href": "tel:400-621-0302"
    }
  }, [_vm._v("400-621-0302")])]), _vm._v(" "), _c('div', [_vm._v("\n          Email：service@genechem.com.cn\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          联系地址：上海市浦东新区爱迪生路332号\n        ")])])])])
}]}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "layer",
    attrs: {
      "src": "static/img/女神节.jpg",
      "data-src": "static/img/女神节.jpg",
      "alt": "layer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "static/img/按摩仪.png",
      "data-src": "static/img/按摩仪.png",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.receive1 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1 icon"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_c('img', {
    staticClass: "largeIcon_2",
    attrs: {
      "src": "static/img/保温杯.png",
      "data-src": "static/img/保温杯.png",
      "alt": "largeIcon_2"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.receive2 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row3"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.receive3 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.receive4 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(4)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "group_6"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n              返回首页\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("PGG")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("颈椎按摩器")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("特美刻")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("智能保温杯")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "largeIcon_3",
    attrs: {
      "src": "static/img/台灯.png",
      "data-src": "static/img/台灯.png",
      "alt": "largeIcon_3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("华为智选")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("智能台灯")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_6"
  }, [_c('img', {
    staticClass: "largeIcon_4",
    attrs: {
      "src": "static/img/三只松鼠.png",
      "data-src": "static/img/三只松鼠.png",
      "alt": "largeIcon_4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_4"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("三只松鼠")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("坚果礼包")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("活动说明")]), _vm._v(" "), _c('span', {
    staticClass: "article"
  }, [_vm._v("\n            1、下单成功后可进行礼品选择，每个账户限参与一次，礼品将在订单回款后5个工作日后安排寄送；"), _c('br'), _vm._v("\n            2、扩增合同，血清和冰盒产品不参与本次活动，其他产品都参加；"), _c('br'), _vm._v("\n            3、该折扣优惠与其他优惠券和会员折扣不同享。\n          ")])])
}]}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "layer",
    attrs: {
      "src": "static/img/7.png",
      "data-src": "static/img/7.png",
      "alt": "layer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "static/img/8.png",
      "data-src": "static/img/8.png",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.receive1 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1 icon"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_c('img', {
    staticClass: "largeIcon_2",
    attrs: {
      "src": "static/img/9.png",
      "data-src": "static/img/9.png",
      "alt": "largeIcon_2"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.receive2 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row3"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.receive3 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.receive4 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(4)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row5"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.receive5 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(5)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive5 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey5 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "group_6"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n              返回首页\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("萌宠")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("暖手宝&充电宝")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("G客")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("保温杯")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "largeIcon_3",
    attrs: {
      "src": "static/img/4.png",
      "data-src": "static/img/4.png",
      "alt": "largeIcon_3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("病毒")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("800元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("优惠券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("无门槛优惠券，有效期1个月")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_6"
  }, [_c('img', {
    staticClass: "largeIcon_4",
    attrs: {
      "src": "static/img/3.png",
      "data-src": "static/img/3.png",
      "alt": "largeIcon_4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_4"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("蛋白组学")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("1314元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("合同金额5万以上可使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_5"
  }, [_c('div', {
    staticClass: "outer_5"
  }, [_c('img', {
    staticClass: "news",
    attrs: {
      "src": "static/img/2.png",
      "data-src": "static/img/2.png",
      "alt": "news"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_6"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v("m6A高级生信分析券")]), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }, [_vm._v("满4个样本免费分析")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('span', {
    staticClass: "article"
  }, [_vm._v("\n            1、所选礼品在您该笔订单回款后5个工作日内安排发货。"), _c('br'), _vm._v("\n            2、m6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            3、蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            4、病毒代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。限在淘基因商城下单，该代金券可叠加日常折扣使用。"), _c('br'), _vm._v("\n            5、该折扣优惠与其他优惠券和会员折扣不同享。\n          ")])])
}]}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "layer",
    attrs: {
      "src": "static/img/7.png",
      "data-src": "static/img/7.png",
      "alt": "layer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.receive1 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.receive2 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.receive3 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.receive4 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(4)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row5"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.receive5 === false) ? _c('img', {
    staticClass: "largeIcon_10 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_10"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(5)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive5 === true) ? _c('img', {
    staticClass: "largeIcon_10 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_10"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey5 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "group_6"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n            返回首页\n           ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_2"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "static/img/6.png",
      "data-src": "static/img/6.png",
      "alt": "largeIcon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("G客")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("精美台历")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_4"
  }, [_c('img', {
    staticClass: "largeIcon_2",
    attrs: {
      "src": "static/img/5.png",
      "data-src": "static/img/5.png",
      "alt": "largeIcon_2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group_3"
  }, [_c('div', {
    staticClass: "block_5"
  }, [_c('span', {
    staticClass: "word_2"
  }, [_vm._v("G客")]), _vm._v(" "), _c('span', {
    staticClass: "text_3"
  }, [_vm._v("U盘32G")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "largeIcon_3",
    attrs: {
      "src": "static/img/4.png",
      "data-src": "static/img/4.png",
      "alt": "largeIcon_3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("病毒")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("300元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("优惠券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("无门槛优惠券，有效期1个月")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_6"
  }, [_c('img', {
    staticClass: "largeIcon_4",
    attrs: {
      "src": "static/img/3.png",
      "data-src": "static/img/3.png",
      "alt": "largeIcon_4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_4"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("蛋白组学")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("1314元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("合同金额5万以上可使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_5"
  }, [_c('div', {
    staticClass: "outer_5"
  }, [_c('img', {
    staticClass: "news",
    attrs: {
      "src": "static/img/2.png",
      "data-src": "static/img/2.png",
      "alt": "news"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_6"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v("m6A高级生信分析券")]), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }, [_vm._v("满4个样本免费分析")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('span', {
    staticClass: "article"
  }, [_vm._v("\n            1、所选礼品在您该笔订单回款后5个工作日内安排发货。"), _c('br'), _vm._v("\n            2、m6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            3、蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            4、病毒代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。限在淘基因商城下单，该代金券可叠加日常折扣使用。"), _c('br'), _vm._v("\n            5、该折扣优惠与其他优惠券和会员折扣不同享。\n          ")])])
}]}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card demo-card-header-pic"
    }, [_c('div', {
      staticClass: "card-header color-white no-border"
    }, [_vm._v("订单" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner"
    }, [_c('p', {
      staticClass: "color-gray"
    }, [_vm._v("@2015/01/15")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-80",
      staticStyle: {
        "height": "auto",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(product.ProductName))])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("再次购买")]), _vm._v(" "), _c('router-link', {
      staticClass: "item-link",
      attrs: {
        "to": {
          name: 'orderDetail'
        }
      }
    }, [_vm._v("订单详情")])], 1)])
  })], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("订单详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab2"
    }
  }, [_vm._v("待支付")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab3"
    }
  }, [_vm._v("待发货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 1 content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-20"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/gene.jpg",
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 2 content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 3 content")])])])
}]}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "address-detail-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addressInfo.consignee),
      expression: "addressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "txt_1",
    attrs: {
      "type": "text",
      "placeholder": "请填写姓名"
    },
    domProps: {
      "value": (_vm.addressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addressInfo.expressMobile),
      expression: "addressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "type": "text",
      "placeholder": "请填写您的手机号"
    },
    domProps: {
      "value": (_vm.addressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "省",
      "placeholder": "点击选择省份"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    },
    model: {
      value: (_vm.addressInfo.province),
      callback: function($$v) {
        _vm.$set(_vm.addressInfo, "province", $$v)
      },
      expression: "addressInfo.province"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.provinceOptions
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": function($event) {
        _vm.showPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "市",
      "placeholder": "点击选择市"
    },
    on: {
      "click": function($event) {
        _vm.showCityPicker = true
      }
    },
    model: {
      value: (_vm.addressInfo.city),
      callback: function($$v) {
        _vm.$set(_vm.addressInfo, "city", $$v)
      },
      expression: "addressInfo.city"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCityPicker),
      callback: function($$v) {
        _vm.showCityPicker = $$v
      },
      expression: "showCityPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.cityOptions
    },
    on: {
      "confirm": _vm.onConfirm2,
      "cancel": function($event) {
        _vm.showCityPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("*街道(不包含省市)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addressInfo.street),
      expression: "addressInfo.street",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "placeholder": "请填写街道信息"
    },
    domProps: {
      "value": (_vm.addressInfo.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addressInfo, "street", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "del-btn",
    on: {
      "click": _vm.delAddress
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-gene-only",
    staticStyle: {
      "overflow-x": "hidden",
      "padding": "3%"
    }
  }, [_c('div', {}, [_c('div', [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "width": "85%",
      "float": "left",
      "border-radius": "40px"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGene"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryName),
      expression: "queryName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchGene",
      "placeholder": "请输入查询基因ID、基因名称、转录本"
    },
    domProps: {
      "value": (_vm.queryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "searchTr",
    staticStyle: {
      "margin-top": "5vh"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "solid 1px #EFEEF3",
      "padding": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("选择物种")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.radioChecked === ''),
      expression: "this.radioChecked === ''"
    }],
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-gantanhao",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v("\n        查询基因前请先选择物种")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore),
      expression: "!showMore"
    }],
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "icon-font emkt-icon-shouqi",
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    },
    attrs: {
      "id": "taxName"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '9606'
    },
    attrs: {
      "for": "human"
    }
  }, [_vm._v("人类 " + _vm._s(_vm.human))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "human",
      "value": "9606"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10116'
    },
    attrs: {
      "for": "rat"
    }
  }, [_vm._v("大鼠 " + _vm._s(_vm.rat))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rat",
      "value": "10116"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10090'
    },
    attrs: {
      "for": "mouse"
    }
  }, [_vm._v("小鼠 " + _vm._s(_vm.mouse))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "mouse",
      "value": "10090"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10123'),
      expression: "showMore || radioChecked === '10123'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10123'
    },
    attrs: {
      "for": "pig"
    }
  }, [_vm._v("猪 " + _vm._s(_vm.pig))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "pig",
      "value": "10123"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10125'),
      expression: "showMore || radioChecked === '10125'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10125'
    },
    attrs: {
      "for": "rabbit"
    }
  }, [_vm._v("兔子 " + _vm._s(_vm.rabbit))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rabbit",
      "value": "10125"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10124'),
      expression: "showMore || radioChecked === '10124'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10124'
    },
    attrs: {
      "for": "sheep"
    }
  }, [_vm._v("绵羊 " + _vm._s(_vm.sheep))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "sheep",
      "value": "10124"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10120'),
      expression: "showMore || radioChecked === '10120'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10120'
    },
    attrs: {
      "for": "rice"
    }
  }, [_vm._v("水稻 " + _vm._s(_vm.rice))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rice",
      "value": "10120"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10121'),
      expression: "showMore || radioChecked === '10121'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10121'
    },
    attrs: {
      "for": "zebrafish"
    }
  }, [_vm._v("斑马鱼 " + _vm._s(_vm.zebrafish))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "zebrafish",
      "value": "10121"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10118'),
      expression: "showMore || radioChecked === '10118'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10118'
    },
    attrs: {
      "for": "Gallus_gallus"
    }
  }, [_vm._v("鸡 " + _vm._s(_vm.Gallus_gallus))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "Gallus_gallus",
      "value": "10118"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10119'),
      expression: "showMore || radioChecked === '10119'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10119'
    },
    attrs: {
      "for": "thale_cress"
    }
  }, [_vm._v("拟南芥 " + _vm._s(_vm.thale_cress))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "thale_cress",
      "value": "10119"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10128'),
      expression: "showMore || radioChecked === '10128'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "34%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10128'
    },
    attrs: {
      "for": "yeast"
    }
  }, [_vm._v("酵母 " + _vm._s(_vm.yeast))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "yeast",
      "value": "10128"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10127'),
      expression: "showMore || radioChecked === '10127'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10127'
    },
    attrs: {
      "for": "African_clawed_frog"
    }
  }, [_vm._v("非洲爪娃 " + _vm._s(_vm.African_clawed_frog))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "African_clawed_frog",
      "value": "10127"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10122'),
      expression: "showMore || radioChecked === '10122'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10122'
    },
    attrs: {
      "for": "fruit_fly"
    }
  }, [_vm._v("果蝇 " + _vm._s(_vm.fruit_fly))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "fruit_fly",
      "value": "10122"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10126'),
      expression: "showMore || radioChecked === '10126'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "52%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10126'
    },
    attrs: {
      "for": "domestic_silkworm"
    }
  }, [_vm._v("家蚕 " + _vm._s(_vm.domestic_silkworm))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "domestic_silkworm",
      "value": "10126"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10117'),
      expression: "showMore || radioChecked === '10117'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10117'
    },
    attrs: {
      "for": "others"
    }
  }, [_vm._v(_vm._s(_vm.others))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "others",
      "value": "10117"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore && (_vm.radioChecked !== '9606' &&
        _vm.radioChecked !== '10116' && _vm.radioChecked !== '10090' && _vm.radioChecked !== '')),
      expression: "!showMore &&(radioChecked !== '9606'\n      && radioChecked !== '10116' && radioChecked !== '10090' && radioChecked !== '')"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA",
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n        选择其它物种\n        "), _c('i', {
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "12px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore && (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "!showMore && (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' || radioChecked === '')"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n          更多物种\n          "), _c('i', {
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n          点击收起\n          "), _c('i', {
    staticClass: "icon-font emkt-icon-shouqi",
    staticStyle: {
      "font-size": "12px"
    }
  })])])])]), _vm._v(" "), (!_vm.showMatchData) ? _c('div', [_c('h6', [_vm._v("注意事项：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("1.数据来源为NCBI refseq数据库，mirBase数据库。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.showMatchData) ? _c('div', _vm._l((_vm.queryRes), function(searchData, index) {
    return _c('div', [_c('div', {
      staticClass: "searchTr"
    }, [_c('div', {
      class: _vm.close ? 'close-popup' : '',
      staticStyle: {
        "padding": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, index)
        }
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "60%"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold",
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(searchData.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#979797"
      }
    }, [_vm._v("codeSize:" + _vm._s(searchData.genes[0].cdsSize))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#979797",
        "font-size": "10px",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_c('span', [_vm._v(_vm._s(searchData.genes[0].matched))]), _vm._v(" "), (searchData.genes[0].ttttflag === 0) ? _c('span', [_vm._v("连续4T：否")]) : _vm._e(), _vm._v(" "), (searchData.genes[0].ttttflag === 1) ? _c('span', [_vm._v("连续4T：是")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "40%"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "41px",
        "height": "70px",
        "float": "right",
        "margin": "-10px -10px 0 0"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          searchData.open = !searchData.open
        }
      }
    }, [((searchData.genes.length > 1) && !searchData.open) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      staticStyle: {
        "position": "relative",
        "float": "right",
        "top": "22px",
        "right": "12px",
        "color": "#5878FA",
        "font-size": "16px",
        "z-index": "999"
      }
    }) : (searchData.open) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      staticStyle: {
        "position": "relative",
        "float": "right",
        "top": "22px",
        "right": "12px",
        "color": "#5878FA",
        "font-size": "16px",
        "z-index": "999"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "text-align": "end",
        "margin-top": "15px",
        "font-size": "12px",
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._v(_vm._s(searchData.genes[0].subtitle))]), _vm._v(" "), (searchData.genes[0].recommended) ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("推荐转录本")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (searchData.text !== '' && searchData.open) ? _c('div', _vm._l((searchData.genes), function(gens, indexs) {
      return _c('div', {
        class: _vm.close ? 'close-popup' : '',
        on: {
          "click": function($event) {
            return _vm.searchTarget(gens, indexs)
          }
        }
      }, [(indexs !== 0) ? _c('div', {
        staticStyle: {
          "border-top": "#EFEEF3 0.5px solid",
          "padding": "10px"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "16px",
          "font-weight": "bold",
          "margin-right": "5px",
          "float": "left"
        }
      }, [_vm._v(_vm._s(searchData.title))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "10px",
          "color": "#979797"
        }
      }, [_vm._v("codeSize:" + _vm._s(gens.cdsSize))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#979797",
          "font-size": "10px",
          "width": "60%",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "white-space": "nowrap"
        }
      }, [_c('span', [_vm._v(_vm._s(gens.matched))]), _vm._v(" "), (searchData.ttttflag === 0) ? _c('span', [_vm._v("连续4T：否")]) : _vm._e(), _vm._v(" "), (searchData.ttttflag === 1) ? _c('span', [_vm._v("连续4T：是")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "position": "relative",
          "top": "-35px",
          "font-size": "12px",
          "text-align": "end",
          "width": "40%"
        }
      }, [_c('div', {
        staticClass: "sub-title"
      }, [_vm._v(_vm._s(gens.subtitle))]), _vm._v(" "), (gens.recommended) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("推荐转录本")]) : _vm._e()])]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('div')])])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "right",
      "text-align": "center",
      "font-size": "14px",
      "color": "#979797",
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticClass: "close-popup"
  }, [_vm._v("取消")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1.1rem"
    }
  }, [_vm._v("2.NCBI中refseq数据库\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("NM、XM")]), _vm._v("开头的accession为\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("编码基因")]), _vm._v("；\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("NR、XR")]), _vm._v("开头的accession为\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("非编码基因")]), _vm._v("。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("3."), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("pre-miRNA为MicroUp")]), _vm._v("基因类型，\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("mature miRNA为MicroDown")]), _vm._v("基因类型；")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("5.如果您在基因选择上遇到任何疑问，请返回上一步点击左下角\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("“在线客服”")]), _vm._v("寻求帮助；")])
}]}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("发票寄送地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.invoiceInfo), function(address, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'invoiceAddressModify',
          query: {
            num: index,
            from: _vm.from
          },
          params: {
            order: _vm.$route.params.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))]), _vm._v(" "), (address.isDefault == 1) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v("默认地址")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressMobile))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressAddress))])])])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100",
    attrs: {
      "id": "button-div"
    }
  }, [_c('router-link', {
    staticClass: "button button-big button-fill",
    class: {
      'disabled': _vm.count > 2
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'addInvoiceAddress',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order
        }
      },
      "disabled": _vm.count > 2
    }
  }, [_vm._v("\n            新增寄送地址\n          ")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "myCoupons"
    }
  }, [_c('ul', _vm._l((_vm.myCoupons), function(coupon, index) {
    return _c('li', {
      attrs: {
        "id": index
      },
      on: {
        "click": function($event) {
          return _vm.getCoupon(index)
        }
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [(coupon.applied == 0) ? _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type != 0) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "1rem"
      }
    }, [_vm._v("有效期： 至 " + _vm._s(coupon.endDT))]), _vm._v(" "), _c('div', [_vm._v("描述：" + _vm._s(coupon.label))])]) : _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC",
        "margin-top": "0.2rem"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type != 0) ? _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "1rem"
      }
    }, [_vm._v("有效期： 至 " + _vm._s(coupon.endDT))]), _vm._v(" "), _c('div', [_vm._v("描述：" + _vm._s(coupon.label))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("可以使用的优惠券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "70px",
      "width": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/used_img.jpg"
    }
  })])
}]}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, [(_vm.productName !== '') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "WORD-BREAK": "break-all",
      "WORD-WRAP": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.productName))]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributeList), function(merchandise) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [(merchandise.valueText && merchandise.valueText !== '-1') ? _c('div', [(merchandise.valueText.length > 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(2, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length > 30 && merchandise.valueText.length <= 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(3, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length > 14 && merchandise.valueText.length <= 30) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(4, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length <= 14) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(5, true)]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("周期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.workdays))]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.templateSource !== '') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("模版来源")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.templateSource))]), _vm._v(" "), _vm._m(7)]) : _vm._e()], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "2rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "color": "#00469A",
      "font-size": "1.2rem"
    }
  }, [_vm._v("定制商品详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
}]}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContent',
        query: {
          order: _vm.order
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises), function(me) {
    return _c('div', {
      staticClass: "list-block",
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "15px"
      }
    }, [_c('ul', [_c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title label"
    }, [_vm._v("单价")]), _vm._v(" "), _c('div', {
      staticClass: "item-input"
    }, [_c('span', [_vm._v(_vm._s(me.unitPrice))])])])])]), _vm._v(" "), _vm._m(2, true)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("返回首页")])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("商品详细信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("最小价格")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('span', [_vm._v("最小")])])])])])
}]}

/***/ }),
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 1754;

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[405]);


// WEBPACK FOOTER //
// static/js/app.172902758c122b174d2e.js